/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 234);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(24);
var hide = __webpack_require__(15);
var redefine = __webpack_require__(16);
var ctx = __webpack_require__(25);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(241)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(58)('wks');
var uid = __webpack_require__(42);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(27);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(6)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var IE8_DOM_DEFINE = __webpack_require__(198);
var toPrimitive = __webpack_require__(29);
var dP = Object.defineProperty;

exports.f = __webpack_require__(10) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(114);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var createDesc = __webpack_require__(41);
module.exports = __webpack_require__(10) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(15);
var has = __webpack_require__(18);
var SRC = __webpack_require__(42)('src');
var $toString = __webpack_require__(491);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(24).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(6);
var defined = __webpack_require__(30);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(59);
var defined = __webpack_require__(30);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(60);
var createDesc = __webpack_require__(41);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(29);
var has = __webpack_require__(18);
var IE8_DOM_DEFINE = __webpack_require__(198);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(10) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(18);
var toObject = __webpack_require__(12);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogLevel; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// These values are designed to match the ASP.NET Log Levels since that's the pattern we're emulating here.
/** Indicates the severity of a log message.
 *
 * Log Levels are ordered in increasing severity. So `Debug` is more severe than `Trace`, etc.
 */
var LogLevel;
(function (LogLevel) {
    /** Log level for very low severity diagnostic messages. */
    LogLevel[LogLevel["Trace"] = 0] = "Trace";
    /** Log level for low severity diagnostic messages. */
    LogLevel[LogLevel["Debug"] = 1] = "Debug";
    /** Log level for informational diagnostic messages. */
    LogLevel[LogLevel["Information"] = 2] = "Information";
    /** Log level for diagnostic messages that indicate a non-fatal problem. */
    LogLevel[LogLevel["Warning"] = 3] = "Warning";
    /** Log level for diagnostic messages that indicate a failure in the current operation. */
    LogLevel[LogLevel["Error"] = 4] = "Error";
    /** Log level for diagnostic messages that indicate a failure that will terminate the entire application. */
    LogLevel[LogLevel["Critical"] = 5] = "Critical";
    /** The highest possible log level. Used when configuring logging to indicate that no log messages should be emitted. */
    LogLevel[LogLevel["None"] = 6] = "None";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=ILogger.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Arg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Platform; });
/* harmony export (immutable) */ __webpack_exports__["f"] = getDataDetail;
/* unused harmony export formatArrayBuffer */
/* harmony export (immutable) */ __webpack_exports__["h"] = isArrayBuffer;
/* harmony export (immutable) */ __webpack_exports__["i"] = sendMessage;
/* harmony export (immutable) */ __webpack_exports__["e"] = createLogger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SubjectSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ConsoleLogger; });
/* harmony export (immutable) */ __webpack_exports__["g"] = getUserAgentHeader;
/* unused harmony export constructUserAgent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loggers__ = __webpack_require__(64);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


// Version token that will be replaced by the prepack command
/** The version of the SignalR client. */
var VERSION = "5.0.5";
/** @private */
var Arg = /** @class */ (function () {
    function Arg() {
    }
    Arg.isRequired = function (val, name) {
        if (val === null || val === undefined) {
            throw new Error("The '" + name + "' argument is required.");
        }
    };
    Arg.isNotEmpty = function (val, name) {
        if (!val || val.match(/^\s*$/)) {
            throw new Error("The '" + name + "' argument should not be empty.");
        }
    };
    Arg.isIn = function (val, values, name) {
        // TypeScript enums have keys for **both** the name and the value of each enum member on the type itself.
        if (!(val in values)) {
            throw new Error("Unknown " + name + " value: " + val + ".");
        }
    };
    return Arg;
}());

/** @private */
var Platform = /** @class */ (function () {
    function Platform() {
    }
    Object.defineProperty(Platform, "isBrowser", {
        get: function () {
            return typeof window === "object";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isWebWorker", {
        get: function () {
            return typeof self === "object" && "importScripts" in self;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Platform, "isNode", {
        get: function () {
            return !this.isBrowser && !this.isWebWorker;
        },
        enumerable: true,
        configurable: true
    });
    return Platform;
}());

/** @private */
function getDataDetail(data, includeContent) {
    var detail = "";
    if (isArrayBuffer(data)) {
        detail = "Binary data of length " + data.byteLength;
        if (includeContent) {
            detail += ". Content: '" + formatArrayBuffer(data) + "'";
        }
    }
    else if (typeof data === "string") {
        detail = "String data of length " + data.length;
        if (includeContent) {
            detail += ". Content: '" + data + "'";
        }
    }
    return detail;
}
/** @private */
function formatArrayBuffer(data) {
    var view = new Uint8Array(data);
    // Uint8Array.map only supports returning another Uint8Array?
    var str = "";
    view.forEach(function (num) {
        var pad = num < 16 ? "0" : "";
        str += "0x" + pad + num.toString(16) + " ";
    });
    // Trim of trailing space.
    return str.substr(0, str.length - 1);
}
// Also in signalr-protocol-msgpack/Utils.ts
/** @private */
function isArrayBuffer(val) {
    return val && typeof ArrayBuffer !== "undefined" &&
        (val instanceof ArrayBuffer ||
            // Sometimes we get an ArrayBuffer that doesn't satisfy instanceof
            (val.constructor && val.constructor.name === "ArrayBuffer"));
}
/** @private */
function sendMessage(logger, transportName, httpClient, url, accessTokenFactory, content, logMessageContent, withCredentials, defaultHeaders) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, headers, token, _b, name, value, responseType, response;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    headers = {};
                    if (!accessTokenFactory) return [3 /*break*/, 2];
                    return [4 /*yield*/, accessTokenFactory()];
                case 1:
                    token = _c.sent();
                    if (token) {
                        headers = (_a = {},
                            _a["Authorization"] = "Bearer " + token,
                            _a);
                    }
                    _c.label = 2;
                case 2:
                    _b = getUserAgentHeader(), name = _b[0], value = _b[1];
                    headers[name] = value;
                    logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(" + transportName + " transport) sending data. " + getDataDetail(content, logMessageContent) + ".");
                    responseType = isArrayBuffer(content) ? "arraybuffer" : "text";
                    return [4 /*yield*/, httpClient.post(url, {
                            content: content,
                            headers: __assign({}, headers, defaultHeaders),
                            responseType: responseType,
                            withCredentials: withCredentials,
                        })];
                case 3:
                    response = _c.sent();
                    logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(" + transportName + " transport) request complete. Response status: " + response.statusCode + ".");
                    return [2 /*return*/];
            }
        });
    });
}
/** @private */
function createLogger(logger) {
    if (logger === undefined) {
        return new ConsoleLogger(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information);
    }
    if (logger === null) {
        return __WEBPACK_IMPORTED_MODULE_1__Loggers__["a" /* NullLogger */].instance;
    }
    if (logger.log) {
        return logger;
    }
    return new ConsoleLogger(logger);
}
/** @private */
var SubjectSubscription = /** @class */ (function () {
    function SubjectSubscription(subject, observer) {
        this.subject = subject;
        this.observer = observer;
    }
    SubjectSubscription.prototype.dispose = function () {
        var index = this.subject.observers.indexOf(this.observer);
        if (index > -1) {
            this.subject.observers.splice(index, 1);
        }
        if (this.subject.observers.length === 0 && this.subject.cancelCallback) {
            this.subject.cancelCallback().catch(function (_) { });
        }
    };
    return SubjectSubscription;
}());

/** @private */
var ConsoleLogger = /** @class */ (function () {
    function ConsoleLogger(minimumLogLevel) {
        this.minimumLogLevel = minimumLogLevel;
        this.outputConsole = console;
    }
    ConsoleLogger.prototype.log = function (logLevel, message) {
        if (logLevel >= this.minimumLogLevel) {
            switch (logLevel) {
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Critical:
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Error:
                    this.outputConsole.error("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Warning:
                    this.outputConsole.warn("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information:
                    this.outputConsole.info("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
                default:
                    // console.debug only goes to attached debuggers in Node, so we use console.log for Trace and Debug
                    this.outputConsole.log("[" + new Date().toISOString() + "] " + __WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */][logLevel] + ": " + message);
                    break;
            }
        }
    };
    return ConsoleLogger;
}());

/** @private */
function getUserAgentHeader() {
    var userAgentHeaderName = "X-SignalR-User-Agent";
    if (Platform.isNode) {
        userAgentHeaderName = "User-Agent";
    }
    return [userAgentHeaderName, constructUserAgent(VERSION, getOsName(), getRuntime(), getRuntimeVersion())];
}
/** @private */
function constructUserAgent(version, os, runtime, runtimeVersion) {
    // Microsoft SignalR/[Version] ([Detailed Version]; [Operating System]; [Runtime]; [Runtime Version])
    var userAgent = "Microsoft SignalR/";
    var majorAndMinor = version.split(".");
    userAgent += majorAndMinor[0] + "." + majorAndMinor[1];
    userAgent += " (" + version + "; ";
    if (os && os !== "") {
        userAgent += os + "; ";
    }
    else {
        userAgent += "Unknown OS; ";
    }
    userAgent += "" + runtime;
    if (runtimeVersion) {
        userAgent += "; " + runtimeVersion;
    }
    else {
        userAgent += "; Unknown Runtime Version";
    }
    userAgent += ")";
    return userAgent;
}
function getOsName() {
    if (Platform.isNode) {
        switch (process.platform) {
            case "win32":
                return "Windows NT";
            case "darwin":
                return "macOS";
            case "linux":
                return "Linux";
            default:
                return process.platform;
        }
    }
    else {
        return "";
    }
}
function getRuntimeVersion() {
    if (Platform.isNode) {
        return process.versions.node;
    }
    return undefined;
}
function getRuntime() {
    if (Platform.isNode) {
        return "NodeJS";
    }
    else {
        return "Browser";
    }
}
//# sourceMappingURL=Utils.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(79)))

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(13);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(6);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(7);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(24);
var fails = __webpack_require__(6);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(25);
var IObject = __webpack_require__(59);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var asc = __webpack_require__(102);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(10)) {
  var LIBRARY = __webpack_require__(37);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(6);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(75);
  var $buffer = __webpack_require__(110);
  var ctx = __webpack_require__(25);
  var anInstance = __webpack_require__(48);
  var propertyDesc = __webpack_require__(41);
  var hide = __webpack_require__(15);
  var redefineAll = __webpack_require__(50);
  var toInteger = __webpack_require__(27);
  var toLength = __webpack_require__(9);
  var toIndex = __webpack_require__(226);
  var toAbsoluteIndex = __webpack_require__(44);
  var toPrimitive = __webpack_require__(29);
  var has = __webpack_require__(18);
  var classof = __webpack_require__(54);
  var isObject = __webpack_require__(7);
  var toObject = __webpack_require__(12);
  var isArrayIter = __webpack_require__(99);
  var create = __webpack_require__(45);
  var getPrototypeOf = __webpack_require__(21);
  var gOPN = __webpack_require__(46).f;
  var getIterFn = __webpack_require__(101);
  var uid = __webpack_require__(42);
  var wks = __webpack_require__(8);
  var createArrayMethod = __webpack_require__(32);
  var createArrayIncludes = __webpack_require__(65);
  var speciesConstructor = __webpack_require__(62);
  var ArrayIterators = __webpack_require__(104);
  var Iterators = __webpack_require__(56);
  var $iterDetect = __webpack_require__(70);
  var setSpecies = __webpack_require__(47);
  var arrayFill = __webpack_require__(103);
  var arrayCopyWithin = __webpack_require__(215);
  var $DP = __webpack_require__(11);
  var $GOPD = __webpack_require__(20);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(221);
var $export = __webpack_require__(0);
var shared = __webpack_require__(58)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(224))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40), __webpack_require__(236).setImmediate))

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_upload_2_vue__ = __webpack_require__(139);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d6d1c2be_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_2_vue__ = __webpack_require__(307);
function injectStyle (ssrContext) {
  __webpack_require__(301)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_upload_2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d6d1c2be_hasScoped_false_buble_transforms_vue_loader_lib_selector_type_template_index_0_upload_2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(42)('meta');
var isObject = __webpack_require__(7);
var has = __webpack_require__(18);
var setDesc = __webpack_require__(11).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(6)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(8)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(15)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 42 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(200);
var enumBugKeys = __webpack_require__(87);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(27);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(2);
var dPs = __webpack_require__(201);
var enumBugKeys = __webpack_require__(87);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(84)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(88).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(200);
var hiddenKeys = __webpack_require__(87).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(11);
var DESCRIPTORS = __webpack_require__(10);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(25);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(99);
var anObject = __webpack_require__(2);
var toLength = __webpack_require__(9);
var getIterFn = __webpack_require__(101);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(16);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpTransportType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TransferFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// This will be treated as a bit flag in the future, so we keep it using power-of-two values.
/** Specifies a specific HTTP transport type. */
var HttpTransportType;
(function (HttpTransportType) {
    /** Specifies no transport preference. */
    HttpTransportType[HttpTransportType["None"] = 0] = "None";
    /** Specifies the WebSockets transport. */
    HttpTransportType[HttpTransportType["WebSockets"] = 1] = "WebSockets";
    /** Specifies the Server-Sent Events transport. */
    HttpTransportType[HttpTransportType["ServerSentEvents"] = 2] = "ServerSentEvents";
    /** Specifies the Long Polling transport. */
    HttpTransportType[HttpTransportType["LongPolling"] = 4] = "LongPolling";
})(HttpTransportType || (HttpTransportType = {}));
/** Specifies the transfer format for a connection. */
var TransferFormat;
(function (TransferFormat) {
    /** Specifies that only text data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Text"] = 1] = "Text";
    /** Specifies that binary data will be transmitted over the connection. */
    TransferFormat[TransferFormat["Binary"] = 2] = "Binary";
})(TransferFormat || (TransferFormat = {}));
//# sourceMappingURL=ITransport.js.map

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(11).f;
var has = __webpack_require__(18);
var TAG = __webpack_require__(8)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(26);
var TAG = __webpack_require__(8)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var fails = __webpack_require__(6);
var spaces = __webpack_require__(90);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HttpError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TimeoutError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbortError; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/** Error thrown when an HTTP request fails. */
var HttpError = /** @class */ (function (_super) {
    __extends(HttpError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.HttpError}.
     *
     * @param {string} errorMessage A descriptive error message.
     * @param {number} statusCode The HTTP status code represented by this error.
     */
    function HttpError(errorMessage, statusCode) {
        var _newTarget = this.constructor;
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        _this.statusCode = statusCode;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return HttpError;
}(Error));

/** Error thrown when a timeout elapses. */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    /** Constructs a new instance of {@link @microsoft/signalr.TimeoutError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function TimeoutError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "A timeout occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return TimeoutError;
}(Error));

/** Error thrown when an action is aborted. */
var AbortError = /** @class */ (function (_super) {
    __extends(AbortError, _super);
    /** Constructs a new instance of {@link AbortError}.
     *
     * @param {string} errorMessage A descriptive error message.
     */
    function AbortError(errorMessage) {
        var _newTarget = this.constructor;
        if (errorMessage === void 0) { errorMessage = "An abort occurred."; }
        var _this = this;
        var trueProto = _newTarget.prototype;
        _this = _super.call(this, errorMessage) || this;
        // Workaround issue in Typescript compiler
        // https://github.com/Microsoft/TypeScript/issues/13965#issuecomment-278570200
        _this.__proto__ = trueProto;
        return _this;
    }
    return AbortError;
}(Error));

//# sourceMappingURL=Errors.js.map

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(24);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(37) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(26);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(2);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(13);
var SPECIES = __webpack_require__(8)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpClient; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
/** Represents an HTTP response. */
var HttpResponse = /** @class */ (function () {
    function HttpResponse(statusCode, statusText, content) {
        this.statusCode = statusCode;
        this.statusText = statusText;
        this.content = content;
    }
    return HttpResponse;
}());

/** Abstraction over an HTTP client.
 *
 * This class provides an abstraction over an HTTP client so that a different implementation can be provided on different platforms.
 */
var HttpClient = /** @class */ (function () {
    function HttpClient() {
    }
    HttpClient.prototype.get = function (url, options) {
        return this.send(__assign({}, options, { method: "GET", url: url }));
    };
    HttpClient.prototype.post = function (url, options) {
        return this.send(__assign({}, options, { method: "POST", url: url }));
    };
    HttpClient.prototype.delete = function (url, options) {
        return this.send(__assign({}, options, { method: "DELETE", url: url }));
    };
    /** Gets all cookies that apply to the specified URL.
     *
     * @param url The URL that the cookies are valid for.
     * @returns {string} A string containing all the key-value cookie pairs for the specified URL.
     */
    // @ts-ignore
    HttpClient.prototype.getCookieString = function (url) {
        return "";
    };
    return HttpClient;
}());

//# sourceMappingURL=HttpClient.js.map

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NullLogger; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** A logger that does nothing when log messages are sent to it. */
var NullLogger = /** @class */ (function () {
    function NullLogger() {
    }
    /** @inheritDoc */
    // tslint:disable-next-line
    NullLogger.prototype.log = function (_logLevel, _message) {
    };
    /** The singleton instance of the {@link @microsoft/signalr.NullLogger}. */
    NullLogger.instance = new NullLogger();
    return NullLogger;
}());

//# sourceMappingURL=Loggers.js.map

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(19);
var toLength = __webpack_require__(9);
var toAbsoluteIndex = __webpack_require__(44);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 66 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(26);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(27);
var defined = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(7);
var cof = __webpack_require__(26);
var MATCH = __webpack_require__(8)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(8)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(54);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(217);
var redefine = __webpack_require__(16);
var hide = __webpack_require__(15);
var fails = __webpack_require__(6);
var defined = __webpack_require__(30);
var wks = __webpack_require__(8);
var regexpExec = __webpack_require__(105);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(16);
var redefineAll = __webpack_require__(50);
var meta = __webpack_require__(38);
var forOf = __webpack_require__(49);
var anInstance = __webpack_require__(48);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var $iterDetect = __webpack_require__(70);
var setToStringTag = __webpack_require__(53);
var inheritIfRequired = __webpack_require__(91);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(15);
var uid = __webpack_require__(42);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(37) || !__webpack_require__(6)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var ctx = __webpack_require__(25);
var forOf = __webpack_require__(49);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export store */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(261);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    baseURL: "https://mixa-api.tamdabuyazilim.com",
    companyUrl: "https://tamdabuguvenlik.com",
    companyName: "Mixa Enroll",
    version: "1.0.49",
    user: {
      id: 0,
      userName: "",
      mail: "",
      title: "",
      profileUrl: "",
      companyName: "",
      token: "",
      defaultVisitorCardGroup: 0,
      language: "",
      authType: 0
    },
    requiredFields: [],
    authMap: {
      canliIzleme: 2,
      kisiler: 2,
      gecisYetkileri: 2,
      raporlar: 2,
      ayarlar: 2,
      tanimlamalar: 2,
      ziyaretciTakip: 2,
      yemekhane: 2,
      dashboard: 2,
      creditSale: 2,
      bekciTur: 2,
      shiftYonetimi: 2,
      puantajYonetimi: 2,
      shiftYetkileri: {
        canPlan: false,
        canConfirmShift: false,
        canConfirmAllowence: false,
        canPlanAllowence: false,
        canSeeRealMovements: false,
        sendMailWhenUnconfirmedShifts: false,
        sendWarningMailOnSecondDay: false
      }
    },
    defaultFilters: {
      nameOrCardNumber: "",
      sicilOrTerminalNo: null,
      departments: [],
      accessGroup: [],
      identityNo: "",
      documentNoOrMail: "",
      foodGroup: [],
      workGroupId: [],
      title: "",
      stateId: [],
      statuId: [],
      plateNo: "",
      extraField1key: 0,
      extraField1value: "",
      extraField2key: 0,
      extraField2value: "",
      extraField3key: 0,
      extraField3value: "",
      extraField4key: 0,
      extraField4value: "",
      isVisitor: false,
      isActive: true
    },
    buildings: [{
      target: "bank.png",
      tags: "bank, banka, bina",
      name: "Bank"
    }, {
      target: "building.png",
      tags: "building, bina, ofis, office",
      name: "Building"
    }, {
      target: "building-2.png",
      tags: "building, bina, ofis, office",
      name: "Building-2"
    }, {
      target: "building-3.png",
      tags: "building, bina, ofis, office",
      name: "Building-3"
    }, {
      target: "building-4.png",
      tags: "building, bina, ofis, office",
      name: "Building-4"
    }, {
      target: "building-5.png",
      tags: "building, bina, ofis, office",
      name: "Building-5"
    }, {
      target: "building-6.png",
      tags: "building, bina, ofis, office",
      name: "Building-6"
    }, {
      target: "building-7.png",
      tags: "building, bina, ofis, office",
      name: "Building-7"
    }, {
      target: "building-8.png",
      tags: "building, bina, ofis, office",
      name: "Building-8"
    }, {
      target: "building-9.png",
      tags: "building, bina, ofis, office",
      name: "Building-9"
    }, {
      target: "building-10.png",
      tags: "building, bina, ofis, office",
      name: "Building-10"
    }, {
      target: "building-11.png",
      tags: "building, bina, ofis, office",
      name: "Building-11"
    }, {
      target: "building-12.png",
      tags: "building, bina, ofis, office",
      name: "Building-12"
    }, {
      target: "building-13.png",
      tags: "building, bina, ofis, office",
      name: "Building-13"
    }, {
      target: "building-14.png",
      tags: "building, bina, ofis, office",
      name: "Building-14"
    }, {
      target: "building-15.png",
      tags: "building, bina, ofis, office",
      name: "Building-15"
    }, {
      target: "building-16.png",
      tags: "building, bina, ofis, office",
      name: "Building-16"
    }, {
      target: "building-17.png",
      tags: "building, bina, ofis, office",
      name: "Building-17"
    }, {
      target: "building-18.png",
      tags: "building, bina, ofis, office",
      name: "Building-18"
    }, {
      target: "building-19.png",
      tags: "building, bina, ofis, office",
      name: "Building-19"
    }, {
      target: "building-20.png",
      tags: "building, bina, ofis, office",
      name: "Building-20"
    }, {
      target: "building-21.png",
      tags: "building, bina, ofis, office",
      name: "Building-21"
    }, {
      target: "building-22.png",
      tags: "building, bina, ofis, office",
      name: "Building-22"
    }, {
      target: "building-23.png",
      tags: "building, bina, ofis, office",
      name: "Building-23"
    }, {
      target: "building-24.png",
      tags: "building, bina, ofis, office",
      name: "Building-24"
    }, {
      target: "building-25.png",
      tags: "building, bina, ofis, office",
      name: "Building-25"
    }, {
      target: "building-26.png",
      tags: "building, bina, ofis, office",
      name: "Building-26"
    }, {
      target: "building-27.png",
      tags: "building, bina, ofis, office",
      name: "Building-27"
    }, {
      target: "building-28.png",
      tags: "building, bina, ofis, office",
      name: "Building-28"
    }, {
      target: "building-29.png",
      tags: "building, bina, ofis, office",
      name: "Building-29"
    }, {
      target: "building-30.png",
      tags: "building, bina, ofis, office",
      name: "Building-30"
    }, {
      target: "building-31.png",
      tags: "building, bina, ofis, office",
      name: "Building-31"
    }, {
      target: "building-32.png",
      tags: "building, bina, ofis, office",
      name: "Building-32"
    }, {
      target: "building-33.png",
      tags: "building, bina, ofis, office",
      name: "Building-33"
    }, {
      target: "building-34.png",
      tags: "building, bina, ofis, office",
      name: "Building-34"
    }, {
      target: "building-35.png",
      tags: "building, bina, ofis, office",
      name: "Building-35"
    }, {
      target: "building-36.png",
      tags: "building, bina, ofis, office",
      name: "Building-36"
    }, {
      target: "cafe.png",
      tags: "cafe, kafe, restoran, restaurant",
      name: "Cafe"
    }, {
      target: "education.png",
      tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
      name: "Education"
    }, {
      target: "education-2.png",
      tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
      name: "Education-2"
    }, {
      target: "education-3.png",
      tags: "school, education, high school, university, eğitim, okul, lise, üniversite",
      name: "Education-3"
    }, {
      target: "factory.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory"
    }, {
      target: "factory-2.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-2"
    }, {
      target: "factory-3.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-3"
    }, {
      target: "factory-4.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-4"
    }, {
      target: "factory-5.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-5"
    }, {
      target: "factory-6.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-6"
    }, {
      target: "factory-7.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-7"
    }, {
      target: "factory-8.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-8"
    }, {
      target: "factory-9.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-9"
    }, {
      target: "factory-10.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-10"
    }, {
      target: "factory-11.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-11"
    }, {
      target: "factory-12.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-12"
    }, {
      target: "factory-13.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-13"
    }, {
      target: "factory-14.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-14"
    }, {
      target: "factory-15.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-15"
    }, {
      target: "factory-16.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-16"
    }, {
      target: "factory-17.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-17"
    }, {
      target: "factory-18.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-18"
    }, {
      target: "factory-19.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-19"
    }, {
      target: "factory-20.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-20"
    }, {
      target: "factory-21.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-21"
    }, {
      target: "factory-22.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-22"
    }, {
      target: "factory-23.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-23"
    }, {
      target: "factory-24.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-24"
    }, {
      target: "factory-25.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-25"
    }, {
      target: "factory-26.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-26"
    }, {
      target: "factory-27.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-27"
    }, {
      target: "factory-28.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-28"
    }, {
      target: "factory-29.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-29"
    }, {
      target: "factory-30.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-30"
    }, {
      target: "factory-31.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-31"
    }, {
      target: "factory-32.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-32"
    }, {
      target: "factory-33.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-33"
    }, {
      target: "factory-34.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-34"
    }, {
      target: "factory-35.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-35"
    }, {
      target: "factory-36.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-36"
    }, {
      target: "factory-37.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-37"
    }, {
      target: "factory-38.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-38"
    }, {
      target: "factory-39.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-39"
    }, {
      target: "factory-40.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-40"
    }, {
      target: "factory-41.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-41"
    }, {
      target: "factory-42.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-42"
    }, {
      target: "factory-43.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-43"
    }, {
      target: "factory-44.png",
      tags: "factory, endustries, endüstri, fabrika, sanayi",
      name: "Factory-44"
    }, {
      target: "fire-station.png",
      tags: "fire, station, itfaiye, yangın",
      name: "Fire Station"
    }, {
      target: "gas-station.png",
      tags: "gas, station, benzinlik, oto",
      name: "Gas Station"
    }, {
      target: "hospital.png",
      tags: "hospital, hastane, yatakhane",
      name: "Hospital"
    }, {
      target: "hospital-2.png",
      tags: "hospital, hastane, yatakhane",
      name: "Hospital-2"
    }, {
      target: "hospital-3.png",
      tags: "hospital, hastane, yatakhane",
      name: "Hospital-3"
    }, {
      target: "hotel.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel"
    }, {
      target: "hotel-2.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-2"
    }, {
      target: "hotel-3.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-3"
    }, {
      target: "hotel-4.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-4"
    }, {
      target: "hotel-5.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-5"
    }, {
      target: "hotel-6.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-6"
    }, {
      target: "hotel-7.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-7"
    }, {
      target: "hotel-8.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-8"
    }, {
      target: "hotel-9.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-9"
    }, {
      target: "hotel-10.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-10"
    }, {
      target: "hotel-11.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-11"
    }, {
      target: "hotel-12.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-12"
    }, {
      target: "hotel-13.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-13"
    }, {
      target: "hotel-14.png",
      tags: "hotel, otel, pansiyon, inn",
      name: "Hotel-14"
    }, {
      target: "house.png",
      tags: "house, ev, home, müstakil",
      name: "House"
    }, {
      target: "house-2.png",
      tags: "house, ev, home, müstakil",
      name: "House-2"
    }, {
      target: "house-3.png",
      tags: "house, ev, home, müstakil",
      name: "House-3"
    }, {
      target: "house-4.png",
      tags: "house, ev, home, müstakil",
      name: "House-4"
    }, {
      target: "house-5.png",
      tags: "house, ev, home, müstakil",
      name: "House-5"
    }, {
      target: "house-6.png",
      tags: "house, ev, home, müstakil",
      name: "House-6"
    }, {
      target: "house-7.png",
      tags: "house, ev, home, müstakil",
      name: "House-7"
    }, {
      target: "house-8.png",
      tags: "house, ev, home, müstakil",
      name: "House-8"
    }, {
      target: "house-9.png",
      tags: "house, ev, home, müstakil",
      name: "House-9"
    }, {
      target: "house-10.png",
      tags: "house, ev, home, müstakil",
      name: "House-10"
    }, {
      target: "house-11.png",
      tags: "house, ev, home, müstakil",
      name: "House-11"
    }, {
      target: "house-12.png",
      tags: "house, ev, home, müstakil",
      name: "House-12"
    }, {
      target: "museum.png",
      tags: "museum, müze",
      name: "Museum"
    }, {
      target: "office-building.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building"
    }, {
      target: "office-building-2.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-2"
    }, {
      target: "office-building-3.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-3"
    }, {
      target: "office-building-4.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-4"
    }, {
      target: "office-building-5.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-5"
    }, {
      target: "office-building-6.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-6"
    }, {
      target: "office-building-7.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-7"
    }, {
      target: "office-building-8.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-8"
    }, {
      target: "office-building-9.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-9"
    }, {
      target: "office-building-10.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-10"
    }, {
      target: "office-building-11.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-11"
    }, {
      target: "office-building-12.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-12"
    }, {
      target: "office-building-13.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-13"
    }, {
      target: "office-building-14.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-14"
    }, {
      target: "office-building-15.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-15"
    }, {
      target: "office-building-16.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-16"
    }, {
      target: "office-building-17.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-17"
    }, {
      target: "office-building-18.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-18"
    }, {
      target: "office-building-19.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-19"
    }, {
      target: "office-building-20.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-20"
    }, {
      target: "office-building-21.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-21"
    }, {
      target: "office-building-22.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-22"
    }, {
      target: "office-building-23.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-23"
    }, {
      target: "office-building-24.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-24"
    }, {
      target: "office-building-25.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-25"
    }, {
      target: "office-building-26.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-26"
    }, {
      target: "office-building-27.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-27"
    }, {
      target: "office-building-28.png",
      tags: "office, ofis, bina, plaza, business, iş yeri, towers, tower block, gökdelen",
      name: "Office Building-28"
    }, {
      target: "police-department.png",
      tags: "polis, police, cop, karakol, station, police station, emniyet",
      name: "Police Department"
    }, {
      target: "police-department-2.png",
      tags: "polis, police, cop, karakol, station, police station, emniyet",
      name: "Police Department-2"
    }, {
      target: "pool.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool"
    }, {
      target: "pool-2.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-2"
    }, {
      target: "pool-3.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-3"
    }, {
      target: "pool-4.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-4"
    }, {
      target: "pool-5.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-5"
    }, {
      target: "pool-6.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-6"
    }, {
      target: "pool-7.png",
      tags: "pool, havuz, yüzme havuzu, swimming pool, otel, hotel",
      name: "Pool-7"
    }, {
      target: "ship.png",
      tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
      name: "Ship"
    }, {
      target: "ship-2.png",
      tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
      name: "Ship-2"
    }, {
      target: "ship-3.png",
      tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
      name: "Ship-3"
    }, {
      target: "ship-4.png",
      tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
      name: "Ship-4"
    }, {
      target: "ship-5.png",
      tags: "ship, tersane, shipyard, dockyard, yard, gemi, lojistik, logistics, konteyner, container",
      name: "Ship-5"
    }, {
      target: "sport.png",
      tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, basketball",
      name: "Sport"
    }, {
      target: "sport-2.png",
      tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, football, university, high school",
      name: "Sport-2"
    }, {
      target: "sport-3.png",
      tags: "sport, spor, spor salonu, sport saloon, astroturf pitch, spore, sporting, gym, halısaha, halı saha, football",
      name: "Sport-3"
    }, {
      target: "store.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store"
    }, {
      target: "store-2.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-2"
    }, {
      target: "store-3.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-3"
    }, {
      target: "store-4.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-4"
    }, {
      target: "store-5.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-5"
    }, {
      target: "store-6.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-6"
    }, {
      target: "store-7.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-7"
    }, {
      target: "store-8.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-8"
    }, {
      target: "store-9.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-9"
    }, {
      target: "store-10.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-10"
    }, {
      target: "store-11.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-11"
    }, {
      target: "store-12.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-12"
    }, {
      target: "store-13.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-13"
    }, {
      target: "store-14.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-14"
    }, {
      target: "store-15.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-15"
    }, {
      target: "store-16.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-16"
    }, {
      target: "store-17.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-17"
    }, {
      target: "store-18.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-18"
    }, {
      target: "store-19.png",
      tags: "store, shop, shopping center, alış veriş, alışveriş merkezi, dükkan, satış",
      name: "Store-19"
    }, {
      target: "tv-station.png",
      tags: "tv, television, televizyon, vizontele, tv station, tv kanalı, kanal",
      name: "TV Station"
    }],
    modules: {
      visitor: false, //ZİYARETÇİ
      visitorTemporaryCard: false, //ZİYARETÇİ GEÇİCİ KART
      visitorAccessGroups: false, //ZİYARETÇİ ERİŞİM GRUPLARI
      dormitory: false, //YURT
      diningHall: false, //YEMEKHANE
      foodMenuPopup: false, //YEMEK MENÜSÜ EKRANI
      retailSale: false, //HIZLI SATIŞ, BAKİYE DÜŞME EKRANI
      memberManagement: false, //ÜYE TAKİP
      licencePlateRecognition: false, //PLAKA TANIMA SİSTEMİ
      hgs: false, //HGS
      plate: false, //PLAKA
      annualPermit: false, //YILLIK İZİN
      saveMovementLog: false, //YENİ HAREKET OLUŞTURMA
      payroll: false, //PUANTAJ
      payrollManagement: false, //PUANTAJ YÖNETİMİ
      timezone: false, //TİMEZONE
      smsOrMail: false, //SMS VE MAİL SİSTEMİ
      student: false, //ÖĞRENCİ
      sms: false, //SMS AKTİF Mİ
      guardTour: false, //BEKÇİ TUR
      scenario: false, //ÖZEL SENARYO
      integration: false,
      shiftManagement: false, //Shift modülünü açar
      dashboardBirthdays: false, //Dashboard'ta doğum günü kutlama modülünü açar
      customFieldName: "Belge No",
      maxTerminalCount: 40,
      maxMobileUsers: 1000,
      mobileApp: false, //Mobil uygulama özelliğini açar
      allowenceRequests: false, //İzin talepleri özelliğini açar
      controlPanelStatistics: false, //Kontrol panelinde istatistikleri açar
      isDisabledTerminalNo: true //Kişilerdeki 'Terminal No' alanını elle girilemez hale getirir
    }
  },
  mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__,
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__,
  actions: __WEBPACK_IMPORTED_MODULE_4__actions__,
  modules: {}
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(57);
/* unused harmony reexport AbortError */
/* unused harmony reexport HttpError */
/* unused harmony reexport TimeoutError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(63);
/* unused harmony reexport HttpClient */
/* unused harmony reexport HttpResponse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DefaultHttpClient__ = __webpack_require__(129);
/* unused harmony reexport DefaultHttpClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HubConnection__ = __webpack_require__(130);
/* unused harmony reexport HubConnection */
/* unused harmony reexport HubConnectionState */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HubConnectionBuilder__ = __webpack_require__(276);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__HubConnectionBuilder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IHubProtocol__ = __webpack_require__(82);
/* unused harmony reexport MessageType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ILogger__ = __webpack_require__(22);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ITransport__ = __webpack_require__(52);
/* unused harmony reexport HttpTransportType */
/* unused harmony reexport TransferFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Loggers__ = __webpack_require__(64);
/* unused harmony reexport NullLogger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__JsonHubProtocol__ = __webpack_require__(133);
/* unused harmony reexport JsonHubProtocol */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Subject__ = __webpack_require__(132);
/* unused harmony reexport Subject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Utils__ = __webpack_require__(23);
/* unused harmony reexport VERSION */
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.












//# sourceMappingURL=index.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MessageType; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
/** Defines the type of a Hub Message. */
var MessageType;
(function (MessageType) {
    /** Indicates the message is an Invocation message and implements the {@link @microsoft/signalr.InvocationMessage} interface. */
    MessageType[MessageType["Invocation"] = 1] = "Invocation";
    /** Indicates the message is a StreamItem message and implements the {@link @microsoft/signalr.StreamItemMessage} interface. */
    MessageType[MessageType["StreamItem"] = 2] = "StreamItem";
    /** Indicates the message is a Completion message and implements the {@link @microsoft/signalr.CompletionMessage} interface. */
    MessageType[MessageType["Completion"] = 3] = "Completion";
    /** Indicates the message is a Stream Invocation message and implements the {@link @microsoft/signalr.StreamInvocationMessage} interface. */
    MessageType[MessageType["StreamInvocation"] = 4] = "StreamInvocation";
    /** Indicates the message is a Cancel Invocation message and implements the {@link @microsoft/signalr.CancelInvocationMessage} interface. */
    MessageType[MessageType["CancelInvocation"] = 5] = "CancelInvocation";
    /** Indicates the message is a Ping message and implements the {@link @microsoft/signalr.PingMessage} interface. */
    MessageType[MessageType["Ping"] = 6] = "Ping";
    /** Indicates the message is a Close message and implements the {@link @microsoft/signalr.CloseMessage} interface. */
    MessageType[MessageType["Close"] = 7] = "Close";
})(MessageType || (MessageType = {}));
//# sourceMappingURL=IHubProtocol.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * qrcode.vue v1.7.0
 * A Vue component to generate QRCode.
 * © 2017-2019 @scopewu(https://github.com/scopewu)
 * MIT License.
 */
var mode = {
  MODE_NUMBER: 1 << 0,
  MODE_ALPHA_NUM: 1 << 1,
  MODE_8BIT_BYTE: 1 << 2,
  MODE_KANJI: 1 << 3
};

function QR8bitByte(data) {
  this.mode = mode.MODE_8BIT_BYTE;
  this.data = data;
}

QR8bitByte.prototype = {
  getLength: function (buffer) {
    return this.data.length;
  },
  write: function (buffer) {
    for (var i = 0; i < this.data.length; i++) {
      // not JIS ...
      buffer.put(this.data.charCodeAt(i), 8);
    }
  }
};
var _8BitByte = QR8bitByte;

var ErrorCorrectLevel = {
  L: 1,
  M: 0,
  Q: 3,
  H: 2
};

function QRRSBlock(totalCount, dataCount) {
  this.totalCount = totalCount;
  this.dataCount = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [// L
// M
// Q
// H
// 1
[1, 26, 19], [1, 26, 16], [1, 26, 13], [1, 26, 9], // 2
[1, 44, 34], [1, 44, 28], [1, 44, 22], [1, 44, 16], // 3
[1, 70, 55], [1, 70, 44], [2, 35, 17], [2, 35, 13], // 4		
[1, 100, 80], [2, 50, 32], [2, 50, 24], [4, 25, 9], // 5
[1, 134, 108], [2, 67, 43], [2, 33, 15, 2, 34, 16], [2, 33, 11, 2, 34, 12], // 6
[2, 86, 68], [4, 43, 27], [4, 43, 19], [4, 43, 15], // 7		
[2, 98, 78], [4, 49, 31], [2, 32, 14, 4, 33, 15], [4, 39, 13, 1, 40, 14], // 8
[2, 121, 97], [2, 60, 38, 2, 61, 39], [4, 40, 18, 2, 41, 19], [4, 40, 14, 2, 41, 15], // 9
[2, 146, 116], [3, 58, 36, 2, 59, 37], [4, 36, 16, 4, 37, 17], [4, 36, 12, 4, 37, 13], // 10		
[2, 86, 68, 2, 87, 69], [4, 69, 43, 1, 70, 44], [6, 43, 19, 2, 44, 20], [6, 43, 15, 2, 44, 16], // 11
[4, 101, 81], [1, 80, 50, 4, 81, 51], [4, 50, 22, 4, 51, 23], [3, 36, 12, 8, 37, 13], // 12
[2, 116, 92, 2, 117, 93], [6, 58, 36, 2, 59, 37], [4, 46, 20, 6, 47, 21], [7, 42, 14, 4, 43, 15], // 13
[4, 133, 107], [8, 59, 37, 1, 60, 38], [8, 44, 20, 4, 45, 21], [12, 33, 11, 4, 34, 12], // 14
[3, 145, 115, 1, 146, 116], [4, 64, 40, 5, 65, 41], [11, 36, 16, 5, 37, 17], [11, 36, 12, 5, 37, 13], // 15
[5, 109, 87, 1, 110, 88], [5, 65, 41, 5, 66, 42], [5, 54, 24, 7, 55, 25], [11, 36, 12], // 16
[5, 122, 98, 1, 123, 99], [7, 73, 45, 3, 74, 46], [15, 43, 19, 2, 44, 20], [3, 45, 15, 13, 46, 16], // 17
[1, 135, 107, 5, 136, 108], [10, 74, 46, 1, 75, 47], [1, 50, 22, 15, 51, 23], [2, 42, 14, 17, 43, 15], // 18
[5, 150, 120, 1, 151, 121], [9, 69, 43, 4, 70, 44], [17, 50, 22, 1, 51, 23], [2, 42, 14, 19, 43, 15], // 19
[3, 141, 113, 4, 142, 114], [3, 70, 44, 11, 71, 45], [17, 47, 21, 4, 48, 22], [9, 39, 13, 16, 40, 14], // 20
[3, 135, 107, 5, 136, 108], [3, 67, 41, 13, 68, 42], [15, 54, 24, 5, 55, 25], [15, 43, 15, 10, 44, 16], // 21
[4, 144, 116, 4, 145, 117], [17, 68, 42], [17, 50, 22, 6, 51, 23], [19, 46, 16, 6, 47, 17], // 22
[2, 139, 111, 7, 140, 112], [17, 74, 46], [7, 54, 24, 16, 55, 25], [34, 37, 13], // 23
[4, 151, 121, 5, 152, 122], [4, 75, 47, 14, 76, 48], [11, 54, 24, 14, 55, 25], [16, 45, 15, 14, 46, 16], // 24
[6, 147, 117, 4, 148, 118], [6, 73, 45, 14, 74, 46], [11, 54, 24, 16, 55, 25], [30, 46, 16, 2, 47, 17], // 25
[8, 132, 106, 4, 133, 107], [8, 75, 47, 13, 76, 48], [7, 54, 24, 22, 55, 25], [22, 45, 15, 13, 46, 16], // 26
[10, 142, 114, 2, 143, 115], [19, 74, 46, 4, 75, 47], [28, 50, 22, 6, 51, 23], [33, 46, 16, 4, 47, 17], // 27
[8, 152, 122, 4, 153, 123], [22, 73, 45, 3, 74, 46], [8, 53, 23, 26, 54, 24], [12, 45, 15, 28, 46, 16], // 28
[3, 147, 117, 10, 148, 118], [3, 73, 45, 23, 74, 46], [4, 54, 24, 31, 55, 25], [11, 45, 15, 31, 46, 16], // 29
[7, 146, 116, 7, 147, 117], [21, 73, 45, 7, 74, 46], [1, 53, 23, 37, 54, 24], [19, 45, 15, 26, 46, 16], // 30
[5, 145, 115, 10, 146, 116], [19, 75, 47, 10, 76, 48], [15, 54, 24, 25, 55, 25], [23, 45, 15, 25, 46, 16], // 31
[13, 145, 115, 3, 146, 116], [2, 74, 46, 29, 75, 47], [42, 54, 24, 1, 55, 25], [23, 45, 15, 28, 46, 16], // 32
[17, 145, 115], [10, 74, 46, 23, 75, 47], [10, 54, 24, 35, 55, 25], [19, 45, 15, 35, 46, 16], // 33
[17, 145, 115, 1, 146, 116], [14, 74, 46, 21, 75, 47], [29, 54, 24, 19, 55, 25], [11, 45, 15, 46, 46, 16], // 34
[13, 145, 115, 6, 146, 116], [14, 74, 46, 23, 75, 47], [44, 54, 24, 7, 55, 25], [59, 46, 16, 1, 47, 17], // 35
[12, 151, 121, 7, 152, 122], [12, 75, 47, 26, 76, 48], [39, 54, 24, 14, 55, 25], [22, 45, 15, 41, 46, 16], // 36
[6, 151, 121, 14, 152, 122], [6, 75, 47, 34, 76, 48], [46, 54, 24, 10, 55, 25], [2, 45, 15, 64, 46, 16], // 37
[17, 152, 122, 4, 153, 123], [29, 74, 46, 14, 75, 47], [49, 54, 24, 10, 55, 25], [24, 45, 15, 46, 46, 16], // 38
[4, 152, 122, 18, 153, 123], [13, 74, 46, 32, 75, 47], [48, 54, 24, 14, 55, 25], [42, 45, 15, 32, 46, 16], // 39
[20, 147, 117, 4, 148, 118], [40, 75, 47, 7, 76, 48], [43, 54, 24, 22, 55, 25], [10, 45, 15, 67, 46, 16], // 40
[19, 148, 118, 6, 149, 119], [18, 75, 47, 31, 76, 48], [34, 54, 24, 34, 55, 25], [20, 45, 15, 61, 46, 16]];

QRRSBlock.getRSBlocks = function (typeNumber, errorCorrectLevel) {
  var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);

  if (rsBlock == undefined) {
    throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
  }

  var length = rsBlock.length / 3;
  var list = new Array();

  for (var i = 0; i < length; i++) {
    var count = rsBlock[i * 3 + 0];
    var totalCount = rsBlock[i * 3 + 1];
    var dataCount = rsBlock[i * 3 + 2];

    for (var j = 0; j < count; j++) {
      list.push(new QRRSBlock(totalCount, dataCount));
    }
  }

  return list;
};

QRRSBlock.getRsBlockTable = function (typeNumber, errorCorrectLevel) {
  switch (errorCorrectLevel) {
    case ErrorCorrectLevel.L:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];

    case ErrorCorrectLevel.M:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];

    case ErrorCorrectLevel.Q:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];

    case ErrorCorrectLevel.H:
      return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];

    default:
      return undefined;
  }
};

var RSBlock = QRRSBlock;

function QRBitBuffer() {
  this.buffer = new Array();
  this.length = 0;
}

QRBitBuffer.prototype = {
  get: function (index) {
    var bufIndex = Math.floor(index / 8);
    return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
  },
  put: function (num, length) {
    for (var i = 0; i < length; i++) {
      this.putBit((num >>> length - i - 1 & 1) == 1);
    }
  },
  getLengthInBits: function () {
    return this.length;
  },
  putBit: function (bit) {
    var bufIndex = Math.floor(this.length / 8);

    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0);
    }

    if (bit) {
      this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
    }

    this.length++;
  }
};
var BitBuffer = QRBitBuffer;

var QRMath = {
  glog: function (n) {
    if (n < 1) {
      throw new Error("glog(" + n + ")");
    }

    return QRMath.LOG_TABLE[n];
  },
  gexp: function (n) {
    while (n < 0) {
      n += 255;
    }

    while (n >= 256) {
      n -= 255;
    }

    return QRMath.EXP_TABLE[n];
  },
  EXP_TABLE: new Array(256),
  LOG_TABLE: new Array(256)
};

for (var i = 0; i < 8; i++) {
  QRMath.EXP_TABLE[i] = 1 << i;
}

for (var i = 8; i < 256; i++) {
  QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4] ^ QRMath.EXP_TABLE[i - 5] ^ QRMath.EXP_TABLE[i - 6] ^ QRMath.EXP_TABLE[i - 8];
}

for (var i = 0; i < 255; i++) {
  QRMath.LOG_TABLE[QRMath.EXP_TABLE[i]] = i;
}

var math = QRMath;

function QRPolynomial(num, shift) {
  if (num.length == undefined) {
    throw new Error(num.length + "/" + shift);
  }

  var offset = 0;

  while (offset < num.length && num[offset] == 0) {
    offset++;
  }

  this.num = new Array(num.length - offset + shift);

  for (var i = 0; i < num.length - offset; i++) {
    this.num[i] = num[i + offset];
  }
}

QRPolynomial.prototype = {
  get: function (index) {
    return this.num[index];
  },
  getLength: function () {
    return this.num.length;
  },
  multiply: function (e) {
    var num = new Array(this.getLength() + e.getLength() - 1);

    for (var i = 0; i < this.getLength(); i++) {
      for (var j = 0; j < e.getLength(); j++) {
        num[i + j] ^= math.gexp(math.glog(this.get(i)) + math.glog(e.get(j)));
      }
    }

    return new QRPolynomial(num, 0);
  },
  mod: function (e) {
    if (this.getLength() - e.getLength() < 0) {
      return this;
    }

    var ratio = math.glog(this.get(0)) - math.glog(e.get(0));
    var num = new Array(this.getLength());

    for (var i = 0; i < this.getLength(); i++) {
      num[i] = this.get(i);
    }

    for (var i = 0; i < e.getLength(); i++) {
      num[i] ^= math.gexp(math.glog(e.get(i)) + ratio);
    } // recursive call


    return new QRPolynomial(num, 0).mod(e);
  }
};
var Polynomial = QRPolynomial;

var QRMaskPattern = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
};
var QRUtil = {
  PATTERN_POSITION_TABLE: [[], [6, 18], [6, 22], [6, 26], [6, 30], [6, 34], [6, 22, 38], [6, 24, 42], [6, 26, 46], [6, 28, 50], [6, 30, 54], [6, 32, 58], [6, 34, 62], [6, 26, 46, 66], [6, 26, 48, 70], [6, 26, 50, 74], [6, 30, 54, 78], [6, 30, 56, 82], [6, 30, 58, 86], [6, 34, 62, 90], [6, 28, 50, 72, 94], [6, 26, 50, 74, 98], [6, 30, 54, 78, 102], [6, 28, 54, 80, 106], [6, 32, 58, 84, 110], [6, 30, 58, 86, 114], [6, 34, 62, 90, 118], [6, 26, 50, 74, 98, 122], [6, 30, 54, 78, 102, 126], [6, 26, 52, 78, 104, 130], [6, 30, 56, 82, 108, 134], [6, 34, 60, 86, 112, 138], [6, 30, 58, 86, 114, 142], [6, 34, 62, 90, 118, 146], [6, 30, 54, 78, 102, 126, 150], [6, 24, 50, 76, 102, 128, 154], [6, 28, 54, 80, 106, 132, 158], [6, 32, 58, 84, 110, 136, 162], [6, 26, 54, 82, 110, 138, 166], [6, 30, 58, 86, 114, 142, 170]],
  G15: 1 << 10 | 1 << 8 | 1 << 5 | 1 << 4 | 1 << 2 | 1 << 1 | 1 << 0,
  G18: 1 << 12 | 1 << 11 | 1 << 10 | 1 << 9 | 1 << 8 | 1 << 5 | 1 << 2 | 1 << 0,
  G15_MASK: 1 << 14 | 1 << 12 | 1 << 10 | 1 << 4 | 1 << 1,
  getBCHTypeInfo: function (data) {
    var d = data << 10;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
      d ^= QRUtil.G15 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15);
    }

    return (data << 10 | d) ^ QRUtil.G15_MASK;
  },
  getBCHTypeNumber: function (data) {
    var d = data << 12;

    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
      d ^= QRUtil.G18 << QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18);
    }

    return data << 12 | d;
  },
  getBCHDigit: function (data) {
    var digit = 0;

    while (data != 0) {
      digit++;
      data >>>= 1;
    }

    return digit;
  },
  getPatternPosition: function (typeNumber) {
    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
  },
  getMask: function (maskPattern, i, j) {
    switch (maskPattern) {
      case QRMaskPattern.PATTERN000:
        return (i + j) % 2 == 0;

      case QRMaskPattern.PATTERN001:
        return i % 2 == 0;

      case QRMaskPattern.PATTERN010:
        return j % 3 == 0;

      case QRMaskPattern.PATTERN011:
        return (i + j) % 3 == 0;

      case QRMaskPattern.PATTERN100:
        return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;

      case QRMaskPattern.PATTERN101:
        return i * j % 2 + i * j % 3 == 0;

      case QRMaskPattern.PATTERN110:
        return (i * j % 2 + i * j % 3) % 2 == 0;

      case QRMaskPattern.PATTERN111:
        return (i * j % 3 + (i + j) % 2) % 2 == 0;

      default:
        throw new Error("bad maskPattern:" + maskPattern);
    }
  },
  getErrorCorrectPolynomial: function (errorCorrectLength) {
    var a = new Polynomial([1], 0);

    for (var i = 0; i < errorCorrectLength; i++) {
      a = a.multiply(new Polynomial([1, math.gexp(i)], 0));
    }

    return a;
  },
  getLengthInBits: function (mode$1, type) {
    if (1 <= type && type < 10) {
      // 1 - 9
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 10;

        case mode.MODE_ALPHA_NUM:
          return 9;

        case mode.MODE_8BIT_BYTE:
          return 8;

        case mode.MODE_KANJI:
          return 8;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else if (type < 27) {
      // 10 - 26
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 12;

        case mode.MODE_ALPHA_NUM:
          return 11;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 10;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else if (type < 41) {
      // 27 - 40
      switch (mode$1) {
        case mode.MODE_NUMBER:
          return 14;

        case mode.MODE_ALPHA_NUM:
          return 13;

        case mode.MODE_8BIT_BYTE:
          return 16;

        case mode.MODE_KANJI:
          return 12;

        default:
          throw new Error("mode:" + mode$1);
      }
    } else {
      throw new Error("type:" + type);
    }
  },
  getLostPoint: function (qrCode) {
    var moduleCount = qrCode.getModuleCount();
    var lostPoint = 0; // LEVEL1

    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount; col++) {
        var sameCount = 0;
        var dark = qrCode.isDark(row, col);

        for (var r = -1; r <= 1; r++) {
          if (row + r < 0 || moduleCount <= row + r) {
            continue;
          }

          for (var c = -1; c <= 1; c++) {
            if (col + c < 0 || moduleCount <= col + c) {
              continue;
            }

            if (r == 0 && c == 0) {
              continue;
            }

            if (dark == qrCode.isDark(row + r, col + c)) {
              sameCount++;
            }
          }
        }

        if (sameCount > 5) {
          lostPoint += 3 + sameCount - 5;
        }
      }
    } // LEVEL2


    for (var row = 0; row < moduleCount - 1; row++) {
      for (var col = 0; col < moduleCount - 1; col++) {
        var count = 0;
        if (qrCode.isDark(row, col)) count++;
        if (qrCode.isDark(row + 1, col)) count++;
        if (qrCode.isDark(row, col + 1)) count++;
        if (qrCode.isDark(row + 1, col + 1)) count++;

        if (count == 0 || count == 4) {
          lostPoint += 3;
        }
      }
    } // LEVEL3


    for (var row = 0; row < moduleCount; row++) {
      for (var col = 0; col < moduleCount - 6; col++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) {
          lostPoint += 40;
        }
      }
    }

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount - 6; row++) {
        if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) {
          lostPoint += 40;
        }
      }
    } // LEVEL4


    var darkCount = 0;

    for (var col = 0; col < moduleCount; col++) {
      for (var row = 0; row < moduleCount; row++) {
        if (qrCode.isDark(row, col)) {
          darkCount++;
        }
      }
    }

    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
    lostPoint += ratio * 10;
    return lostPoint;
  }
};
var util = QRUtil;

function QRCode(typeNumber, errorCorrectLevel) {
  this.typeNumber = typeNumber;
  this.errorCorrectLevel = errorCorrectLevel;
  this.modules = null;
  this.moduleCount = 0;
  this.dataCache = null;
  this.dataList = [];
} // for client side minification


var proto = QRCode.prototype;

proto.addData = function (data) {
  var newData = new _8BitByte(data);
  this.dataList.push(newData);
  this.dataCache = null;
};

proto.isDark = function (row, col) {
  if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
    throw new Error(row + "," + col);
  }

  return this.modules[row][col];
};

proto.getModuleCount = function () {
  return this.moduleCount;
};

proto.make = function () {
  // Calculate automatically typeNumber if provided is < 1
  if (this.typeNumber < 1) {
    var typeNumber = 1;

    for (typeNumber = 1; typeNumber < 40; typeNumber++) {
      var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);
      var buffer = new BitBuffer();
      var totalDataCount = 0;

      for (var i = 0; i < rsBlocks.length; i++) {
        totalDataCount += rsBlocks[i].dataCount;
      }

      for (var i = 0; i < this.dataList.length; i++) {
        var data = this.dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
      }

      if (buffer.getLengthInBits() <= totalDataCount * 8) break;
    }

    this.typeNumber = typeNumber;
  }

  this.makeImpl(false, this.getBestMaskPattern());
};

proto.makeImpl = function (test, maskPattern) {
  this.moduleCount = this.typeNumber * 4 + 17;
  this.modules = new Array(this.moduleCount);

  for (var row = 0; row < this.moduleCount; row++) {
    this.modules[row] = new Array(this.moduleCount);

    for (var col = 0; col < this.moduleCount; col++) {
      this.modules[row][col] = null; //(col + row) % 3;
    }
  }

  this.setupPositionProbePattern(0, 0);
  this.setupPositionProbePattern(this.moduleCount - 7, 0);
  this.setupPositionProbePattern(0, this.moduleCount - 7);
  this.setupPositionAdjustPattern();
  this.setupTimingPattern();
  this.setupTypeInfo(test, maskPattern);

  if (this.typeNumber >= 7) {
    this.setupTypeNumber(test);
  }

  if (this.dataCache == null) {
    this.dataCache = QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
  }

  this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function (row, col) {
  for (var r = -1; r <= 7; r++) {
    if (row + r <= -1 || this.moduleCount <= row + r) continue;

    for (var c = -1; c <= 7; c++) {
      if (col + c <= -1 || this.moduleCount <= col + c) continue;

      if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) {
        this.modules[row + r][col + c] = true;
      } else {
        this.modules[row + r][col + c] = false;
      }
    }
  }
};

proto.getBestMaskPattern = function () {
  var minLostPoint = 0;
  var pattern = 0;

  for (var i = 0; i < 8; i++) {
    this.makeImpl(true, i);
    var lostPoint = util.getLostPoint(this);

    if (i == 0 || minLostPoint > lostPoint) {
      minLostPoint = lostPoint;
      pattern = i;
    }
  }

  return pattern;
};

proto.createMovieClip = function (target_mc, instance_name, depth) {
  var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
  var cs = 1;
  this.make();

  for (var row = 0; row < this.modules.length; row++) {
    var y = row * cs;

    for (var col = 0; col < this.modules[row].length; col++) {
      var x = col * cs;
      var dark = this.modules[row][col];

      if (dark) {
        qr_mc.beginFill(0, 100);
        qr_mc.moveTo(x, y);
        qr_mc.lineTo(x + cs, y);
        qr_mc.lineTo(x + cs, y + cs);
        qr_mc.lineTo(x, y + cs);
        qr_mc.endFill();
      }
    }
  }

  return qr_mc;
};

proto.setupTimingPattern = function () {
  for (var r = 8; r < this.moduleCount - 8; r++) {
    if (this.modules[r][6] != null) {
      continue;
    }

    this.modules[r][6] = r % 2 == 0;
  }

  for (var c = 8; c < this.moduleCount - 8; c++) {
    if (this.modules[6][c] != null) {
      continue;
    }

    this.modules[6][c] = c % 2 == 0;
  }
};

proto.setupPositionAdjustPattern = function () {
  var pos = util.getPatternPosition(this.typeNumber);

  for (var i = 0; i < pos.length; i++) {
    for (var j = 0; j < pos.length; j++) {
      var row = pos[i];
      var col = pos[j];

      if (this.modules[row][col] != null) {
        continue;
      }

      for (var r = -2; r <= 2; r++) {
        for (var c = -2; c <= 2; c++) {
          if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) {
            this.modules[row + r][col + c] = true;
          } else {
            this.modules[row + r][col + c] = false;
          }
        }
      }
    }
  }
};

proto.setupTypeNumber = function (test) {
  var bits = util.getBCHTypeNumber(this.typeNumber);

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
  }

  for (var i = 0; i < 18; i++) {
    var mod = !test && (bits >> i & 1) == 1;
    this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
  }
};

proto.setupTypeInfo = function (test, maskPattern) {
  var data = this.errorCorrectLevel << 3 | maskPattern;
  var bits = util.getBCHTypeInfo(data); // vertical		

  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 6) {
      this.modules[i][8] = mod;
    } else if (i < 8) {
      this.modules[i + 1][8] = mod;
    } else {
      this.modules[this.moduleCount - 15 + i][8] = mod;
    }
  } // horizontal


  for (var i = 0; i < 15; i++) {
    var mod = !test && (bits >> i & 1) == 1;

    if (i < 8) {
      this.modules[8][this.moduleCount - i - 1] = mod;
    } else if (i < 9) {
      this.modules[8][15 - i - 1 + 1] = mod;
    } else {
      this.modules[8][15 - i - 1] = mod;
    }
  } // fixed module


  this.modules[this.moduleCount - 8][8] = !test;
};

proto.mapData = function (data, maskPattern) {
  var inc = -1;
  var row = this.moduleCount - 1;
  var bitIndex = 7;
  var byteIndex = 0;

  for (var col = this.moduleCount - 1; col > 0; col -= 2) {
    if (col == 6) col--;

    while (true) {
      for (var c = 0; c < 2; c++) {
        if (this.modules[row][col - c] == null) {
          var dark = false;

          if (byteIndex < data.length) {
            dark = (data[byteIndex] >>> bitIndex & 1) == 1;
          }

          var mask = util.getMask(maskPattern, row, col - c);

          if (mask) {
            dark = !dark;
          }

          this.modules[row][col - c] = dark;
          bitIndex--;

          if (bitIndex == -1) {
            byteIndex++;
            bitIndex = 7;
          }
        }
      }

      row += inc;

      if (row < 0 || this.moduleCount <= row) {
        row -= inc;
        inc = -inc;
        break;
      }
    }
  }
};

QRCode.PAD0 = 0xEC;
QRCode.PAD1 = 0x11;

QRCode.createData = function (typeNumber, errorCorrectLevel, dataList) {
  var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
  var buffer = new BitBuffer();

  for (var i = 0; i < dataList.length; i++) {
    var data = dataList[i];
    buffer.put(data.mode, 4);
    buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber));
    data.write(buffer);
  } // calc num max data.


  var totalDataCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalDataCount += rsBlocks[i].dataCount;
  }

  if (buffer.getLengthInBits() > totalDataCount * 8) {
    throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
  } // end code


  if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
    buffer.put(0, 4);
  } // padding


  while (buffer.getLengthInBits() % 8 != 0) {
    buffer.putBit(false);
  } // padding


  while (true) {
    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD0, 8);

    if (buffer.getLengthInBits() >= totalDataCount * 8) {
      break;
    }

    buffer.put(QRCode.PAD1, 8);
  }

  return QRCode.createBytes(buffer, rsBlocks);
};

QRCode.createBytes = function (buffer, rsBlocks) {
  var offset = 0;
  var maxDcCount = 0;
  var maxEcCount = 0;
  var dcdata = new Array(rsBlocks.length);
  var ecdata = new Array(rsBlocks.length);

  for (var r = 0; r < rsBlocks.length; r++) {
    var dcCount = rsBlocks[r].dataCount;
    var ecCount = rsBlocks[r].totalCount - dcCount;
    maxDcCount = Math.max(maxDcCount, dcCount);
    maxEcCount = Math.max(maxEcCount, ecCount);
    dcdata[r] = new Array(dcCount);

    for (var i = 0; i < dcdata[r].length; i++) {
      dcdata[r][i] = 0xff & buffer.buffer[i + offset];
    }

    offset += dcCount;
    var rsPoly = util.getErrorCorrectPolynomial(ecCount);
    var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);
    var modPoly = rawPoly.mod(rsPoly);
    ecdata[r] = new Array(rsPoly.getLength() - 1);

    for (var i = 0; i < ecdata[r].length; i++) {
      var modIndex = i + modPoly.getLength() - ecdata[r].length;
      ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
    }
  }

  var totalCodeCount = 0;

  for (var i = 0; i < rsBlocks.length; i++) {
    totalCodeCount += rsBlocks[i].totalCount;
  }

  var data = new Array(totalCodeCount);
  var index = 0;

  for (var i = 0; i < maxDcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < dcdata[r].length) {
        data[index++] = dcdata[r][i];
      }
    }
  }

  for (var i = 0; i < maxEcCount; i++) {
    for (var r = 0; r < rsBlocks.length; r++) {
      if (i < ecdata[r].length) {
        data[index++] = ecdata[r][i];
      }
    }
  }

  return data;
};

var QRCode_1 = QRCode;

/**
 * Encode UTF16 to UTF8.
 * See: http://jonisalonen.com/2012/from-utf-16-to-utf-8-in-javascript/
 * @param str {string}
 * @returns {string}
 */

function toUTF8String(str) {
  var utf8Str = '';

  for (var i = 0; i < str.length; i++) {
    var charCode = str.charCodeAt(i);

    if (charCode < 0x0080) {
      utf8Str += String.fromCharCode(charCode);
    } else if (charCode < 0x0800) {
      utf8Str += String.fromCharCode(0xc0 | charCode >> 6);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    } else if (charCode < 0xd800 || charCode >= 0xe000) {
      utf8Str += String.fromCharCode(0xe0 | charCode >> 12);
      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    } else {
      // surrogate pair
      i++; // UTF-16 encodes 0x10000-0x10FFFF by
      // subtracting 0x10000 and splitting the
      // 20 bits of 0x0-0xFFFFF into two halves

      charCode = 0x10000 + ((charCode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff);
      utf8Str += String.fromCharCode(0xf0 | charCode >> 18);
      utf8Str += String.fromCharCode(0x80 | charCode >> 12 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode >> 6 & 0x3f);
      utf8Str += String.fromCharCode(0x80 | charCode & 0x3f);
    }
  }

  return utf8Str;
}

function generatePath(modules) {
  var margin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var ops = [];
  modules.forEach(function (row, y) {
    var start = null;
    row.forEach(function (cell, x) {
      if (!cell && start !== null) {
        // M0 0h7v1H0z injects the space with the move and drops the comma,
        // saving a char per operation
        ops.push("M".concat(start + margin, " ").concat(y + margin, "h").concat(x - start, "v1H").concat(start + margin, "z"));
        start = null;
        return;
      } // end of row, clean up or skip


      if (x === row.length - 1) {
        if (!cell) {
          // We would have closed the op above already so this can only mean
          // 2+ light modules in a row.
          return;
        }

        if (start === null) {
          // Just a single dark module.
          ops.push("M".concat(x + margin, ",").concat(y + margin, " h1v1H").concat(x + margin, "z"));
        } else {
          // Otherwise finish the current line.
          ops.push("M".concat(start + margin, ",").concat(y + margin, " h").concat(x + 1 - start, "v1H").concat(start + margin, "z"));
        }

        return;
      }

      if (cell && start === null) {
        start = x;
      }
    });
  });
  return ops.join('');
} // @vue/component


var QrcodeVue = {
  props: {
    value: {
      type: String,
      required: true,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: 100,
      validator: function validator(s) {
        return isNaN(Number(s)) !== true;
      }
    },
    level: {
      type: String,
      default: 'L',
      validator: function validator(l) {
        return ['L', 'Q', 'M', 'H'].indexOf(l) > -1;
      }
    },
    background: {
      type: String,
      default: '#fff'
    },
    foreground: {
      type: String,
      default: '#000'
    },
    renderAs: {
      type: String,
      required: false,
      default: 'canvas',
      validator: function validator(as) {
        return ['canvas', 'svg'].indexOf(as) > -1;
      }
    }
  },
  data: function data() {
    return {
      numCells: 0,
      fgPath: ''
    };
  },
  updated: function updated() {
    this.render();
  },
  mounted: function mounted() {
    this.render();
  },
  methods: {
    render: function render() {
      var value = this.value,
          size = this.size,
          level = this.level,
          background = this.background,
          foreground = this.foreground,
          renderAs = this.renderAs;

      var _size = size >>> 0; // size to number
      // We'll use type===-1 to force QRCode to automatically pick the best type


      var qrCode = new QRCode_1(-1, ErrorCorrectLevel[level]);
      qrCode.addData(toUTF8String(value));
      qrCode.make();
      var cells = qrCode.modules;
      var tileW = _size / cells.length;
      var tileH = _size / cells.length;
      var scale = window.devicePixelRatio || 1;

      if (renderAs === 'svg') {
        this.numCells = cells.length; // Drawing strategy: instead of a rect per module, we're going to create a
        // single path for the dark modules and layer that on top of a light rect,
        // for a total of 2 DOM nodes. We pay a bit more in string concat but that's
        // way faster than DOM ops.
        // For level 1, 441 nodes -> 2
        // For level 40, 31329 -> 2

        this.fgPath = generatePath(cells);
      } else {
        var canvas = this.$refs['qrcode-vue'];
        var ctx = canvas.getContext('2d');
        canvas.height = canvas.width = _size * scale;
        ctx.scale(scale, scale);
        cells.forEach(function (row, rdx) {
          row.forEach(function (cell, cdx) {
            ctx.fillStyle = cell ? foreground : background;
            var w = Math.ceil((cdx + 1) * tileW) - Math.floor(cdx * tileW);
            var h = Math.ceil((rdx + 1) * tileH) - Math.floor(rdx * tileH);
            ctx.fillRect(Math.round(cdx * tileW), Math.round(rdx * tileH), w, h);
          });
        });
      }
    }
  },
  render: function render(createElement) {
    var className = this.className,
        value = this.value,
        level = this.level,
        background = this.background,
        foreground = this.foreground,
        size = this.size,
        renderAs = this.renderAs,
        numCells = this.numCells,
        fgPath = this.fgPath;
    return createElement('div', {
      class: this.class || className,
      attrs: {
        value: value,
        level: level,
        background: background,
        foreground: foreground
      }
    }, [renderAs === 'svg' ? createElement('svg', {
      attrs: {
        height: size,
        width: size,
        shapeRendering: 'crispEdges',
        viewBox: "0 0 ".concat(numCells, " ").concat(numCells)
      },
      style: {
        width: size + 'px',
        height: size + 'px'
      }
    }, [createElement('path', {
      attrs: {
        fill: background,
        d: "M0,0 h".concat(numCells, "v").concat(numCells, "H0z")
      }
    }), createElement('path', {
      attrs: {
        fill: foreground,
        d: fgPath
      }
    })]) : createElement('canvas', {
      attrs: {
        height: size,
        width: size
      },
      style: {
        width: size + 'px',
        height: size + 'px'
      },
      ref: 'qrcode-vue'
    }, [])]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (QrcodeVue);


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(24);
var LIBRARY = __webpack_require__(37);
var wksExt = __webpack_require__(199);
var defineProperty = __webpack_require__(11).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(58)('keys');
var uid = __webpack_require__(42);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(2);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(25)(Function.call, __webpack_require__(20).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var setPrototypeOf = __webpack_require__(89).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(27);
var defined = __webpack_require__(30);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(37);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(16);
var hide = __webpack_require__(15);
var Iterators = __webpack_require__(56);
var $iterCreate = __webpack_require__(96);
var setToStringTag = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(21);
var ITERATOR = __webpack_require__(8)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(45);
var descriptor = __webpack_require__(41);
var setToStringTag = __webpack_require__(53);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(15)(IteratorPrototype, __webpack_require__(8)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(69);
var defined = __webpack_require__(30);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(8)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(56);
var ITERATOR = __webpack_require__(8)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(11);
var createDesc = __webpack_require__(41);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(54);
var ITERATOR = __webpack_require__(8)('iterator');
var Iterators = __webpack_require__(56);
module.exports = __webpack_require__(24).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(580);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(44);
var toLength = __webpack_require__(9);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(39);
var step = __webpack_require__(216);
var Iterators = __webpack_require__(56);
var toIObject = __webpack_require__(19);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(95)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(61);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(68)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(25);
var invoke = __webpack_require__(206);
var html = __webpack_require__(88);
var cel = __webpack_require__(84);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(26)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(107).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(26)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(13);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(10);
var LIBRARY = __webpack_require__(37);
var $typed = __webpack_require__(75);
var hide = __webpack_require__(15);
var redefineAll = __webpack_require__(50);
var fails = __webpack_require__(6);
var anInstance = __webpack_require__(48);
var toInteger = __webpack_require__(27);
var toLength = __webpack_require__(9);
var toIndex = __webpack_require__(226);
var gOPN = __webpack_require__(46).f;
var dP = __webpack_require__(11).f;
var arrayFill = __webpack_require__(103);
var setToStringTag = __webpack_require__(53);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch("initAuth");

            case 2:
              document.title = _this.$store.getters.getCompanyName;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
  * vue-router v3.4.5
  * (c) 2020 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function extend (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

var View = {
  name: 'RouterView',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    // used by devtools to display a router-view badge
    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      var vnodeData = parent.$vnode ? parent.$vnode.data : {};
      if (vnodeData.routerView) {
        depth++;
      }
      if (vnodeData.keepAlive && parent._directInactive && parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      var cachedData = cache[name];
      var cachedComponent = cachedData && cachedData.component;
      if (cachedComponent) {
        // #2301
        // pass props
        if (cachedData.configProps) {
          fillPropsinData(cachedComponent, data, cachedData.route, cachedData.configProps);
        }
        return h(cachedComponent, data, children)
      } else {
        // render previous empty view
        return h()
      }
    }

    var matched = route.matched[depth];
    var component = matched && matched.components[name];

    // render empty node if no matched route or no config component
    if (!matched || !component) {
      cache[name] = null;
      return h()
    }

    // cache component
    cache[name] = { component: component };

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // register instance in init hook
    // in case kept-alive component be actived when routes changed
    data.hook.init = function (vnode) {
      if (vnode.data.keepAlive &&
        vnode.componentInstance &&
        vnode.componentInstance !== matched.instances[name]
      ) {
        matched.instances[name] = vnode.componentInstance;
      }
    };

    var configProps = matched.props && matched.props[name];
    // save route and configProps in cache
    if (configProps) {
      extend(cache[name], {
        route: route,
        configProps: configProps
      });
      fillPropsinData(component, data, route, configProps);
    }

    return h(component, data, children)
  }
};

function fillPropsinData (component, data, route, configProps) {
  // resolve props
  var propsToPass = data.props = resolveProps(route, configProps);
  if (propsToPass) {
    // clone to prevent mutation
    propsToPass = data.props = extend({}, propsToPass);
    // pass non-declared props as attrs
    var attrs = data.attrs = data.attrs || {};
    for (var key in propsToPass) {
      if (!component.props || !(key in component.props)) {
        attrs[key] = propsToPass[key];
        delete propsToPass[key];
      }
    }
  }
}

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
    .replace(encodeReserveRE, encodeReserveReplacer)
    .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    var value = extraQuery[key];
    parsedQuery[key] = Array.isArray(value)
      ? value.map(castQueryParamValue)
      : castQueryParamValue(value);
  }
  return parsedQuery
}

var castQueryParamValue = function (value) { return (value == null || typeof value === 'object' ? value : String(value)); };

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0 ? decode(parts.join('=')) : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj
    ? Object.keys(obj)
      .map(function (key) {
        var val = obj[key];

        if (val === undefined) {
          return ''
        }

        if (val === null) {
          return encode(key)
        }

        if (Array.isArray(val)) {
          var result = [];
          val.forEach(function (val2) {
            if (val2 === undefined) {
              return
            }
            if (val2 === null) {
              result.push(encode(key));
            } else {
              result.push(encode(key) + '=' + encode(val2));
            }
          });
          return result.join('&')
        }

        return encode(key) + '=' + encode(val)
      })
      .filter(function (x) { return x.length > 0; })
      .join('&')
    : null;
  return res ? ("?" + res) : ''
}

/*  */

var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // query values can be null and undefined
    if (aVal == null || bVal == null) { return aVal === bVal }
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}
pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  params = params || {};
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));

    // Fix #2505 resolving asterisk routes { name: 'not-found', params: { pathMatch: '/not-found' }}
    // and fix #3106 so that you can work with location descriptor object having params.pathMatch equal to empty string
    if (typeof params.pathMatch === 'string') { params[0] = params.pathMatch; }

    return filler(params, { pretty: true })
  } catch (e) {
    if (false) {
      // Fix #3072 no warn if `pathMatch` is string
      warn(typeof params.pathMatch === 'string', ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  } finally {
    // delete the 0 if it was added
    delete params[0];
  }
}

/*  */

function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next._normalized) {
    return next
  } else if (next.name) {
    next = extend({}, raw);
    var params = next.params;
    if (params && typeof params === 'object') {
      next.params = extend({}, params);
    }
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = extend({}, next);
    next._normalized = true;
    var params$1 = extend(extend({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params$1;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params$1, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var noop = function () {};

var Link = {
  name: 'RouterLink',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(
      this.to,
      current,
      this.append
    );
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback =
      globalActiveClass == null ? 'router-link-active' : globalActiveClass;
    var exactActiveClassFallback =
      globalExactActiveClass == null
        ? 'router-link-exact-active'
        : globalExactActiveClass;
    var activeClass =
      this.activeClass == null ? activeClassFallback : this.activeClass;
    var exactActiveClass =
      this.exactActiveClass == null
        ? exactActiveClassFallback
        : this.exactActiveClass;

    var compareTarget = route.redirectedFrom
      ? createRoute(null, normalizeLocation(route.redirectedFrom), null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var ariaCurrentValue = classes[exactActiveClass] ? this.ariaCurrentValue : null;

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location, noop);
        } else {
          router.push(location, noop);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) {
        on[e] = handler;
      });
    } else {
      on[this.event] = handler;
    }

    var data = { class: classes };

    var scopedSlot =
      !this.$scopedSlots.$hasNormal &&
      this.$scopedSlots.default &&
      this.$scopedSlots.default({
        href: href,
        route: route,
        navigate: handler,
        isActive: classes[activeClass],
        isExactActive: classes[exactActiveClass]
      });

    if (scopedSlot) {
      if (scopedSlot.length === 1) {
        return scopedSlot[0]
      } else if (scopedSlot.length > 1 || !scopedSlot.length) {
        if (false) {
          warn(
            false,
            ("RouterLink with to=\"" + (this.to) + "\" is trying to use a scoped slot but it didn't provide exactly one child. Wrapping the content with a span element.")
          );
        }
        return scopedSlot.length === 0 ? h() : h('span', {}, scopedSlot)
      }
    }

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href, 'aria-current': ariaCurrentValue };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var aData = (a.data = extend({}, a.data));
        aData.on = aData.on || {};
        // transform existing events in both objects into arrays so we can push later
        for (var event in aData.on) {
          var handler$1 = aData.on[event];
          if (event in on) {
            aData.on[event] = Array.isArray(handler$1) ? handler$1 : [handler$1];
          }
        }
        // append new listeners for router-link
        for (var event$1 in on) {
          if (event$1 in aData.on) {
            // on[event] is always a function
            aData.on[event$1].push(on[event$1]);
          } else {
            aData.on[event$1] = handler;
          }
        }

        var aAttrs = (a.data.attrs = extend({}, a.data.attrs));
        aAttrs.href = href;
        aAttrs['aria-current'] = ariaCurrentValue;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('RouterView', View);
  Vue.component('RouterLink', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  if (false) {
    // warn if routes do not include leading slashes
    var found = pathList
    // check for missing leading slash
      .filter(function (path) { return path && path.charAt(0) !== '*' && path.charAt(0) !== '/'; });

    if (found.length > 0) {
      var pathNames = found.map(function (path) { return ("- " + path); }).join('\n');
      warn(false, ("Non-nested routes must include a leading slash character. Fix the following routes: \n" + pathNames));
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(
        path || name
      )) + " cannot be a " + "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions =
    route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(path, parent, pathToRegexpOptions.strict);

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props:
      route.props == null
        ? {}
        : route.components
          ? route.props
          : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (
        route.name &&
        !route.redirect &&
        route.children.some(function (child) { return /^\/?$/.test(child.path); })
      ) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
            "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
            "the default child route will not be rendered. Remove the name from " +
            "this route and use the name of the default child route for named " +
            "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias) ? route.alias : [route.alias];
    for (var i = 0; i < aliases.length; ++i) {
      var alias = aliases[i];
      if (false) {
        warn(
          false,
          ("Found an alias with the same value as the path: \"" + path + "\". You have to remove that alias. It will be ignored in development.")
        );
        // skip in dev to make it work
        continue
      }

      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    }
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
          "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (
  path,
  pathToRegexpOptions
) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(
        !keys[key.name],
        ("Duplicate param keys in route with path: \"" + path + "\"")
      );
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (
  path,
  parent,
  strict
) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */



function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
      return _createRoute(record, location, redirectedFrom)
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
      ? originalRedirect(createRoute(record, location, null, router))
      : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      // Fix #1994: using * with props: true generates a param named 0
      params[key.name || 'pathMatch'] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */

// use User Timing api (if present) for more accurate key precision
var Time =
  inBrowser && window.performance && window.performance.now
    ? window.performance
    : Date;

function genStateKey () {
  return Time.now().toFixed(3)
}

var _key = genStateKey();

function getStateKey () {
  return _key
}

function setStateKey (key) {
  return (_key = key)
}

/*  */

var positionStore = Object.create(null);

function setupScroll () {
  // Prevent browser scroll behavior on History popstate
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  // Fix for #1585 for Firefox
  // Fix for #2195 Add optional third attribute to workaround a bug in safari https://bugs.webkit.org/show_bug.cgi?id=182678
  // Fix for #2774 Support for apps loaded from Windows file shares not mapped to network drives: replaced location.origin with
  // window.location.protocol + '//' + window.location.host
  // location.host contains the port and location.hostname doesn't
  var protocolAndPath = window.location.protocol + '//' + window.location.host;
  var absolutePath = window.location.href.replace(protocolAndPath, '');
  // preserve existing history state as it could be overriden by the user
  var stateCopy = extend({}, window.history.state);
  stateCopy.key = getStateKey();
  window.history.replaceState(stateCopy, '', absolutePath);
  window.addEventListener('popstate', handlePopState);
  return function () {
    window.removeEventListener('popstate', handlePopState);
  }
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior.call(
      router,
      to,
      from,
      isPop ? position : null
    );

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll
        .then(function (shouldScroll) {
          scrollToPosition((shouldScroll), position);
        })
        .catch(function (err) {
          if (false) {
            assert(false, err.toString());
          }
        });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function handlePopState (e) {
  saveScrollPosition();
  if (e.state && e.state.key) {
    setStateKey(e.state.key);
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

var hashStartsWithNumberRE = /^#\d/;

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    // getElementById would still fail if the selector contains a more complicated query like #main[data-attr]
    // but at the same time, it doesn't make much sense to select an element with an id and an extra selector
    var el = hashStartsWithNumberRE.test(shouldScroll.selector) // $flow-disable-line
      ? document.getElementById(shouldScroll.selector.slice(1)) // $flow-disable-line
      : document.querySelector(shouldScroll.selector);

    if (el) {
      var offset =
        shouldScroll.offset && typeof shouldScroll.offset === 'object'
          ? shouldScroll.offset
          : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState =
  inBrowser &&
  (function () {
    var ua = window.navigator.userAgent;

    if (
      (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
      ua.indexOf('Mobile Safari') !== -1 &&
      ua.indexOf('Chrome') === -1 &&
      ua.indexOf('Windows Phone') === -1
    ) {
      return false
    }

    return window.history && typeof window.history.pushState === 'function'
  })();

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      // preserve existing history state as it could be overriden by the user
      var stateCopy = extend({}, history.state);
      stateCopy.key = getStateKey();
      history.replaceState(stateCopy, '', url);
    } else {
      history.pushState({ key: setStateKey(genStateKey()) }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

// When changing thing, also edit router.d.ts
var NavigationFailureType = {
  redirected: 2,
  aborted: 4,
  cancelled: 8,
  duplicated: 16
};

function createNavigationRedirectedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.redirected,
    ("Redirected when going from \"" + (from.fullPath) + "\" to \"" + (stringifyRoute(
      to
    )) + "\" via a navigation guard.")
  )
}

function createNavigationDuplicatedError (from, to) {
  var error = createRouterError(
    from,
    to,
    NavigationFailureType.duplicated,
    ("Avoided redundant navigation to current location: \"" + (from.fullPath) + "\".")
  );
  // backwards compatible with the first introduction of Errors
  error.name = 'NavigationDuplicated';
  return error
}

function createNavigationCancelledError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.cancelled,
    ("Navigation cancelled from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" with a new navigation.")
  )
}

function createNavigationAbortedError (from, to) {
  return createRouterError(
    from,
    to,
    NavigationFailureType.aborted,
    ("Navigation aborted from \"" + (from.fullPath) + "\" to \"" + (to.fullPath) + "\" via a navigation guard.")
  )
}

function createRouterError (from, to, type, message) {
  var error = new Error(message);
  error._isRouter = true;
  error.from = from;
  error.to = to;
  error.type = type;

  return error
}

var propertiesToLog = ['params', 'query', 'hash'];

function stringifyRoute (to) {
  if (typeof to === 'string') { return to }
  if ('path' in to) { return to.path }
  var location = {};
  propertiesToLog.forEach(function (key) {
    if (key in to) { location[key] = to[key]; }
  });
  return JSON.stringify(location, null, 2)
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

function isNavigationFailure (err, errorType) {
  return (
    isError(err) &&
    err._isRouter &&
    (errorType == null || err.type === errorType)
  )
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
  this.listeners = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (
  location,
  onComplete,
  onAbort
) {
    var this$1 = this;

  var route;
  // catch redirect option https://github.com/vuejs/vue-router/issues/3201
  try {
    route = this.router.match(location, this.current);
  } catch (e) {
    this.errorCbs.forEach(function (cb) {
      cb(e);
    });
    // Exception should still be thrown
    throw e
  }
  var prev = this.current;
  this.confirmTransition(
    route,
    function () {
      this$1.updateRoute(route);
      onComplete && onComplete(route);
      this$1.ensureURL();
      this$1.router.afterHooks.forEach(function (hook) {
        hook && hook(route, prev);
      });

      // fire ready cbs once
      if (!this$1.ready) {
        this$1.ready = true;
        this$1.readyCbs.forEach(function (cb) {
          cb(route);
        });
      }
    },
    function (err) {
      if (onAbort) {
        onAbort(err);
      }
      if (err && !this$1.ready) {
        // Initial redirection should not mark the history as ready yet
        // because it's triggered by the redirection instead
        // https://github.com/vuejs/vue-router/issues/3225
        // https://github.com/vuejs/vue-router/issues/3331
        if (!isNavigationFailure(err, NavigationFailureType.redirected) || prev !== START) {
          this$1.ready = true;
          this$1.readyErrorCbs.forEach(function (cb) {
            cb(err);
          });
        }
      }
    }
  );
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  this.pending = route;
  var abort = function (err) {
    // changed after adding errors with
    // https://github.com/vuejs/vue-router/pull/3047 before that change,
    // redirect and aborted navigation would produce an err == null
    if (!isNavigationFailure(err) && isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) {
          cb(err);
        });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  var lastRouteIndex = route.matched.length - 1;
  var lastCurrentIndex = current.matched.length - 1;
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    lastRouteIndex === lastCurrentIndex &&
    route.matched[lastRouteIndex] === current.matched[lastCurrentIndex]
  ) {
    this.ensureURL();
    return abort(createNavigationDuplicatedError(current, route))
  }

  var ref = resolveQueue(
    this.current.matched,
    route.matched
  );
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort(createNavigationCancelledError(current, route))
    }
    try {
      hook(route, current, function (to) {
        if (to === false) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(createNavigationAbortedError(current, route));
        } else if (isError(to)) {
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' &&
            (typeof to.path === 'string' || typeof to.name === 'string'))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort(createNavigationRedirectedError(current, route));
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort(createNavigationCancelledError(current, route))
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) {
            cb();
          });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  this.current = route;
  this.cb && this.cb(route);
};

History.prototype.setupListeners = function setupListeners () {
  // Default implementation is empty
};

History.prototype.teardown = function teardown () {
  // clean up event listeners
  // https://github.com/vuejs/vue-router/issues/2341
  this.listeners.forEach(function (cleanupListener) {
    cleanupListener();
  });
  this.listeners = [];

  // reset current history route
  // https://github.com/vuejs/vue-router/issues/3294
  this.current = START;
  this.pending = null;
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(
    activated,
    'beforeRouteEnter',
    function (guard, _, match, key) {
      return bindEnterGuard(guard, match, key, cbs, isValid)
    }
  )
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
      next(cb);
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (
    instances[key] &&
    !instances[key]._isBeingDestroyed // do not reuse being destroyed instance
  ) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */

var HTML5History = /*@__PURE__*/(function (History) {
  function HTML5History (router, base) {
    History.call(this, router, base);

    this._startLocation = getLocation(this.base);
  }

  if ( History ) HTML5History.__proto__ = History;
  HTML5History.prototype = Object.create( History && History.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === this$1._startLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (supportsScroll) {
          handleScroll(router, route, current, true);
        }
      });
    };
    window.addEventListener('popstate', handleRoutingEvent);
    this.listeners.push(function () {
      window.removeEventListener('popstate', handleRoutingEvent);
    });
  };

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = decodeURI(window.location.pathname);
  if (base && path.toLowerCase().indexOf(base.toLowerCase()) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */

var HashHistory = /*@__PURE__*/(function (History) {
  function HashHistory (router, base, fallback) {
    History.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History ) HashHistory.__proto__ = History;
  HashHistory.prototype = Object.create( History && History.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    if (this.listeners.length > 0) {
      return
    }

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      this.listeners.push(setupScroll());
    }

    var handleRoutingEvent = function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    };
    var eventType = supportsPushState ? 'popstate' : 'hashchange';
    window.addEventListener(
      eventType,
      handleRoutingEvent
    );
    this.listeners.push(function () {
      window.removeEventListener(eventType, handleRoutingEvent);
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        pushHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(
      location,
      function (route) {
        replaceHash(route.fullPath);
        handleScroll(this$1.router, route, fromRoute, false);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(cleanPath(base + '/#' + location));
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  // empty path
  if (index < 0) { return '' }

  href = href.slice(index + 1);
  // decode the hash but not the search or hash
  // as search(query) is already decoded
  // https://github.com/vuejs/vue-router/issues/2708
  var searchIndex = href.indexOf('?');
  if (searchIndex < 0) {
    var hashIndex = href.indexOf('#');
    if (hashIndex > -1) {
      href = decodeURI(href.slice(0, hashIndex)) + href.slice(hashIndex);
    } else { href = decodeURI(href); }
  } else {
    href = decodeURI(href.slice(0, searchIndex)) + href.slice(searchIndex);
  }

  return href
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */

var AbstractHistory = /*@__PURE__*/(function (History) {
  function AbstractHistory (router, base) {
    History.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History ) AbstractHistory.__proto__ = History;
  AbstractHistory.prototype = Object.create( History && History.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
        this$1.index++;
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(
      location,
      function (route) {
        this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
        onComplete && onComplete(route);
      },
      onAbort
    );
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(
      route,
      function () {
        var prev = this$1.current;
        this$1.index = targetIndex;
        this$1.updateRoute(route);
        this$1.router.afterHooks.forEach(function (hook) {
          hook && hook(route, prev);
        });
      },
      function (err) {
        if (isNavigationFailure(err, NavigationFailureType.duplicated)) {
          this$1.index = targetIndex;
        }
      }
    );
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback =
    mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (raw, current, redirectedFrom) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' &&
    assert(
      install.installed,
      "not installed. Make sure to call `Vue.use(VueRouter)` " +
        "before creating root instance."
    );

  this.apps.push(app);

  // set up app destroyed handler
  // https://github.com/vuejs/vue-router/issues/2639
  app.$once('hook:destroyed', function () {
    // clean out app from this.apps array once destroyed
    var index = this$1.apps.indexOf(app);
    if (index > -1) { this$1.apps.splice(index, 1); }
    // ensure we still have a main app or null if no apps
    // we do not release the router so it can be reused
    if (this$1.app === app) { this$1.app = this$1.apps[0] || null; }

    if (!this$1.app) { this$1.history.teardown(); }
  });

  // main app previously initialized
  // return as we don't need to set up new history listener
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History || history instanceof HashHistory) {
    var handleInitialScroll = function (routeOrError) {
      var from = history.current;
      var expectScroll = this$1.options.scrollBehavior;
      var supportsScroll = supportsPushState && expectScroll;

      if (supportsScroll && 'fullPath' in routeOrError) {
        handleScroll(this$1, routeOrError, from, false);
      }
    };
    var setupListeners = function (routeOrError) {
      history.setupListeners();
      handleInitialScroll(routeOrError);
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupListeners,
      setupListeners
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.push(location, resolve, reject);
    })
  } else {
    this.history.push(location, onComplete, onAbort);
  }
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

  // $flow-disable-line
  if (!onComplete && !onAbort && typeof Promise !== 'undefined') {
    return new Promise(function (resolve, reject) {
      this$1.history.replace(location, resolve, reject);
    })
  } else {
    this.history.replace(location, onComplete, onAbort);
  }
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply(
    [],
    route.matched.map(function (m) {
      return Object.keys(m.components).map(function (key) {
        return m.components[key]
      })
    })
  )
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  current = current || this.history.current;
  var location = normalizeLocation(to, current, append, this);
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '3.4.5';
VueRouter.isNavigationFailure = isNavigationFailure;
VueRouter.NavigationFailureType = NavigationFailureType;

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(243);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(14);
var normalizeHeaderName = __webpack_require__(248);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(118);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(118);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(79)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var settle = __webpack_require__(249);
var cookies = __webpack_require__(251);
var buildURL = __webpack_require__(115);
var buildFullPath = __webpack_require__(252);
var parseHeaders = __webpack_require__(255);
var isURLSameOrigin = __webpack_require__(256);
var createError = __webpack_require__(119);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    if (
      (utils.isBlob(requestData) || utils.isFile(requestData)) &&
      requestData.type
    ) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = unescape(encodeURIComponent(config.auth.password)) || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(250);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_dashboard_Dashboard__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_realTimeMonitor_RealTimeMonitor__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_employees_Employees__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_operations_Operations__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_reports_Reports__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_reports_ShiftReport__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_reports_VerticalFirstInLastOutReport__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_payrollManagement_PayrollManagement__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_payrollManagement_PayrollShiftManagement__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_shiftManagement_ShiftManagement__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_visitors_Visitors__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_visitorCards_VisitorCards__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_visitorReports_VisitorReports__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_licensePlateRecognition_licensePlateRecognition_vue__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_foodGroups_FoodGroups__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_foodGroupOperations_FoodGroupOperations__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_foodGroupReports_FoodGroupReports__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_retailSale_retailSale__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_buildings_BuildDefinitions__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_buildings_BuildDefinitionsTest_vue__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_guardTour_Guards__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_guardTour_Areas__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_guardTour_ControlPoints__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_guardTour_GuardTours__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_guardTour_GuardTourReports__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_guardTour_GuardIncidentReport_vue__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_inventoryManagement_InventoryCategories_vue__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_inventoryManagement_InventoryWarehouse_vue__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_inventoryManagement_InventoryFields_vue__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_inventoryManagement_Inventories_vue__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_cardDesign_CardDesign__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_extraFields_ExtraFields__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_documentDefinitions_documentDefinitions_vue__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__pages_departments_Departments__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__pages_accessGroups_AccessGroups__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__pages_shifts_Shifts__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__pages_overtimeSettings_OvertimeSettings__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__pages_allowences_Allowences__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__pages_annualPermits_AnnualPermits__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__pages_scenarios_ScenarioList__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__pages_scenarios_ScenarioDetails__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__pages_timeZones_TimeZone__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__pages_devices_Devices__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__pages_deviceOperations_DeviceOperations__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__pages_workPlaceDefinitions_workPlaceDefinitions__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__pages_companySettings_CompanySettings__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__pages_shiftManagement_ShiftSettings__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pages_users_Users__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__pages_users_MyProfile__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__pages_userAuthorityGroups_UserAuthorityGroups__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__pages_mailSmsSettings_MailSmsSettings__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__pages_userLogs_UserLogs__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__pages_payrollTypes_PayrollTypes__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__pages_monthlyPayrollTables_MonthlyPayrollTables__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__pages_integration_Integration__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__pages_AppSettings_AppSettings__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__pages_help_Help__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__pages_appAbout_AppAbout__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__auth_SignIn__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__auth_SignUp__ = __webpack_require__(484);









// Reports



// Payroll Management


// Shift Management

// Visitors



// License Plate Recognition

// Food Groups





// Student Dormitory



//Guard Tour







//Inventory Management





// Definitions















// Settings













// Login";



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({

    routes: [{
        path: '', component: __WEBPACK_IMPORTED_MODULE_3__pages_Home__["a" /* default */], children: [{ path: '', component: __WEBPACK_IMPORTED_MODULE_4__pages_dashboard_Dashboard__["a" /* default */] }, { path: 'dashboard', component: __WEBPACK_IMPORTED_MODULE_4__pages_dashboard_Dashboard__["a" /* default */] }, { path: 'real-time-monitor', component: __WEBPACK_IMPORTED_MODULE_5__pages_realTimeMonitor_RealTimeMonitor__["a" /* default */] }, { path: 'employees', component: __WEBPACK_IMPORTED_MODULE_6__pages_employees_Employees__["a" /* default */] }, { path: 'operations', component: __WEBPACK_IMPORTED_MODULE_7__pages_operations_Operations__["a" /* default */] }, { path: 'reports', component: __WEBPACK_IMPORTED_MODULE_8__pages_reports_Reports__["a" /* default */] }, { path: 'shift-report', component: __WEBPACK_IMPORTED_MODULE_9__pages_reports_ShiftReport__["a" /* default */] }, { path: 'vertical-first-in-last-out-report', component: __WEBPACK_IMPORTED_MODULE_10__pages_reports_VerticalFirstInLastOutReport__["a" /* default */] }, { path: 'payroll-management', component: __WEBPACK_IMPORTED_MODULE_12__pages_payrollManagement_PayrollShiftManagement__["a" /* default */] }, { path: 'shift-management', component: __WEBPACK_IMPORTED_MODULE_13__pages_shiftManagement_ShiftManagement__["a" /* default */] }, { path: 'visitors', component: __WEBPACK_IMPORTED_MODULE_14__pages_visitors_Visitors__["a" /* default */] }, { path: 'visitor-cards', component: __WEBPACK_IMPORTED_MODULE_15__pages_visitorCards_VisitorCards__["a" /* default */] }, { path: 'visitor-reports', component: __WEBPACK_IMPORTED_MODULE_16__pages_visitorReports_VisitorReports__["a" /* default */] }, { path: 'license-plate-recognition', component: __WEBPACK_IMPORTED_MODULE_17__pages_licensePlateRecognition_licensePlateRecognition_vue__["a" /* default */] }, { path: 'retail-sale', component: __WEBPACK_IMPORTED_MODULE_21__pages_retailSale_retailSale__["a" /* default */] }, { path: 'food-groups', component: __WEBPACK_IMPORTED_MODULE_18__pages_foodGroups_FoodGroups__["a" /* default */] }, { path: 'food-group-operations', component: __WEBPACK_IMPORTED_MODULE_19__pages_foodGroupOperations_FoodGroupOperations__["a" /* default */] }, { path: 'food-group-reports', component: __WEBPACK_IMPORTED_MODULE_20__pages_foodGroupReports_FoodGroupReports__["a" /* default */] }, { path: 'build-definitions', component: __WEBPACK_IMPORTED_MODULE_22__pages_buildings_BuildDefinitions__["a" /* default */] }, { path: 'build-definitions-test', component: __WEBPACK_IMPORTED_MODULE_23__pages_buildings_BuildDefinitionsTest_vue__["a" /* default */] }, { path: 'guards', component: __WEBPACK_IMPORTED_MODULE_24__pages_guardTour_Guards__["a" /* default */] }, { path: 'guard-tour-area', component: __WEBPACK_IMPORTED_MODULE_25__pages_guardTour_Areas__["a" /* default */] }, { path: 'control-points', component: __WEBPACK_IMPORTED_MODULE_26__pages_guardTour_ControlPoints__["a" /* default */] }, { path: 'guard-tours', component: __WEBPACK_IMPORTED_MODULE_27__pages_guardTour_GuardTours__["a" /* default */] }, { path: 'guard-tour-reports', component: __WEBPACK_IMPORTED_MODULE_28__pages_guardTour_GuardTourReports__["a" /* default */] }, { path: 'guard-tour-incident-reports', component: __WEBPACK_IMPORTED_MODULE_29__pages_guardTour_GuardIncidentReport_vue__["a" /* default */] }, { path: 'card-designs', component: __WEBPACK_IMPORTED_MODULE_34__pages_cardDesign_CardDesign__["a" /* default */] }, { path: 'extra-fields', component: __WEBPACK_IMPORTED_MODULE_35__pages_extraFields_ExtraFields__["a" /* default */] }, { path: 'departments', component: __WEBPACK_IMPORTED_MODULE_37__pages_departments_Departments__["a" /* default */] }, { path: 'access-groups', component: __WEBPACK_IMPORTED_MODULE_38__pages_accessGroups_AccessGroups__["a" /* default */] }, { path: 'shifts', component: __WEBPACK_IMPORTED_MODULE_39__pages_shifts_Shifts__["a" /* default */] }, { path: 'allowences', component: __WEBPACK_IMPORTED_MODULE_41__pages_allowences_Allowences__["a" /* default */] }, { path: 'work-place-definitions', component: __WEBPACK_IMPORTED_MODULE_48__pages_workPlaceDefinitions_workPlaceDefinitions__["a" /* default */] }, { path: 'inventory-categories', component: __WEBPACK_IMPORTED_MODULE_30__pages_inventoryManagement_InventoryCategories_vue__["a" /* default */] }, { path: 'inventory-warehouses', component: __WEBPACK_IMPORTED_MODULE_31__pages_inventoryManagement_InventoryWarehouse_vue__["a" /* default */] }, { path: 'inventory-fields', component: __WEBPACK_IMPORTED_MODULE_32__pages_inventoryManagement_InventoryFields_vue__["a" /* default */] }, { path: 'inventories', component: __WEBPACK_IMPORTED_MODULE_33__pages_inventoryManagement_Inventories_vue__["a" /* default */] }, { path: 'document-definitions', component: __WEBPACK_IMPORTED_MODULE_36__pages_documentDefinitions_documentDefinitions_vue__["a" /* default */] }, { path: 'annual-permits', component: __WEBPACK_IMPORTED_MODULE_42__pages_annualPermits_AnnualPermits__["a" /* default */] }, { path: 'overtime-settings', component: __WEBPACK_IMPORTED_MODULE_40__pages_overtimeSettings_OvertimeSettings__["a" /* default */] }, { path: 'scenario-list', component: __WEBPACK_IMPORTED_MODULE_43__pages_scenarios_ScenarioList__["a" /* default */] }, { path: 'new-scenario', component: __WEBPACK_IMPORTED_MODULE_44__pages_scenarios_ScenarioDetails__["a" /* default */] }, { name: 'scenario-details', path: '/scenario-details/:id', component: __WEBPACK_IMPORTED_MODULE_44__pages_scenarios_ScenarioDetails__["a" /* default */] }, { path: 'timezones', component: __WEBPACK_IMPORTED_MODULE_45__pages_timeZones_TimeZone__["a" /* default */] }, { path: 'devices', component: __WEBPACK_IMPORTED_MODULE_46__pages_devices_Devices__["a" /* default */] }, { path: 'device-operations', component: __WEBPACK_IMPORTED_MODULE_47__pages_deviceOperations_DeviceOperations__["a" /* default */] }, { path: 'company-settings', component: __WEBPACK_IMPORTED_MODULE_49__pages_companySettings_CompanySettings__["a" /* default */] }, { path: 'shift-settings', component: __WEBPACK_IMPORTED_MODULE_50__pages_shiftManagement_ShiftSettings__["a" /* default */] }, { path: 'users', component: __WEBPACK_IMPORTED_MODULE_51__pages_users_Users__["a" /* default */] }, { path: 'my-profile', component: __WEBPACK_IMPORTED_MODULE_52__pages_users_MyProfile__["a" /* default */] }, { path: 'user-authority-groups', component: __WEBPACK_IMPORTED_MODULE_53__pages_userAuthorityGroups_UserAuthorityGroups__["a" /* default */] }, { path: 'mail-sms-settings', component: __WEBPACK_IMPORTED_MODULE_54__pages_mailSmsSettings_MailSmsSettings__["a" /* default */] }, { path: 'user-logs', component: __WEBPACK_IMPORTED_MODULE_55__pages_userLogs_UserLogs__["a" /* default */] }, { path: 'payroll-types', component: __WEBPACK_IMPORTED_MODULE_56__pages_payrollTypes_PayrollTypes__["a" /* default */] }, { path: 'monthly-payroll-tables', component: __WEBPACK_IMPORTED_MODULE_57__pages_monthlyPayrollTables_MonthlyPayrollTables__["a" /* default */] }, { path: 'integration', component: __WEBPACK_IMPORTED_MODULE_58__pages_integration_Integration__["a" /* default */] }, { path: 'app-settings', component: __WEBPACK_IMPORTED_MODULE_59__pages_AppSettings_AppSettings__["a" /* default */] }, { path: 'help', component: __WEBPACK_IMPORTED_MODULE_60__pages_help_Help__["a" /* default */] }, { path: 'app-about', component: __WEBPACK_IMPORTED_MODULE_61__pages_appAbout_AppAbout__["a" /* default */] }]
    }, {
        path: '/auth', component: __WEBPACK_IMPORTED_MODULE_62__auth_SignIn__["a" /* default */], children: [{ path: '', component: __WEBPACK_IMPORTED_MODULE_62__auth_SignIn__["a" /* default */] }, { path: '/signup', component: __WEBPACK_IMPORTED_MODULE_63__auth_SignUp__["a" /* default */] }, { path: '/login', component: __WEBPACK_IMPORTED_MODULE_62__auth_SignIn__["a" /* default */] }]
    },
    //{
    //path: '/redirect',
    //redirect: (to) => {
    //  var currentUrl = window.location.pathname;
    //console.log(currentUrl);
    //window.location.href = currentUrl;
    //return '/dashboard' // not important since redirecting
    //}
    //},
    { path: "*", redirect: "/login" // Wildcard : tanımsız yönlendirmeler
    }],
    mode: 'history' //hash : Default
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
/*!
 * vuex v3.5.1
 * (c) 2020 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  return parent.hasChild(key)
};

function update (path, targetModule, newModule) {
  if ((false)) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept anthor params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.5.1',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(40)))

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__);
var _alerts, _employees, _batchOperations, _alerts2, _employees2, _batchOperations2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLInstaller"]);

/* unused harmony default export */ var _unused_webpack_default_export = (new __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLCreate"]({
  initial: 'Türkçe',
  save: "production" === 'production',
  languages: [new __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLanguage"]('Türkçe').create({
    title: 'Merhaba {0}!',
    general: {
      addNew: "Yeni Ekle",
      select2: "Seç",
      select: "Seçiniz",
      notSelected: "Seçilmedi",
      selected: "Seçildi",
      notChanged: "Değiştirilmedi",
      active: "Aktif",
      passive: "Pasif",
      isActive: "Kayıt Aktif mi?",
      exportToPdfOrPrint: "PDF Aktar / Yazdır",
      exportToExcel: "Excele Aktar",
      view: "Görüntüle",
      remove: "Kaldır",
      all: "Tümü",
      selectAll: "Tümünü Seç",
      removeAll: "Tümünü Kaldır",
      add: "Ekle",
      added: "Eklendi",
      close: "Kapat",
      done: "Tamam",
      doorOpen: "Kapı Açık",
      doorIsClosed: "Kapı Kapalı",
      connected: "Bağlı",
      notConnected: "Bağlı Değil",
      refreshScreen: "Ekranı Yenile",
      removed: "Çıkartıldı",
      cancel: "İptal",
      save: "Kaydet",
      update: "Güncelle",
      credit: "Kontör",
      balance: "Bakiye",
      delete: "Sil",
      confirm: "Onayla",
      apply: "Uygula",
      monday: "Pazartesi",
      tuesday: "Salı",
      wednesday: "Çarşamba",
      thursday: "Perşembe",
      friday: "Cuma",
      saturday: "Cumartesi",
      sunday: "Pazar",
      search: "Arama yapın...",
      viewQRCode: "QR Kodu Görüntüle",
      qRCodeBarcodePrint: "QR Kod & Barkod Yazdır",
      qrSettings: "QR Ayarları",
      qrSize: "Boyut",
      print: "Yazdır",
      upload: "Yükle",
      download: "İndir"
    },
    shared: {
      myProfile: "Profilim",
      company: "Şirket",
      languageOptions: "Dil Seçenekleri",
      changeLanguageInfo: "Değiştirmek istediğiniz dili seçin.",
      licenceErrorTitle: "Lisans Hatası",
      licenceError: "Lisans Anahtarı Geçersiz!",
      softwareKey: "Yazılım Anahtarı",
      softwareKeyDescription: "Bu kodu satın aldığınız yere iletin.",
      enterLicenceKey: "Lisans Anahtarı Girin",
      licenceKeyDescription: "Satın almış olduğunuz ürüne ait lisans numaranızı girin.",
      saveLicenceKey: "Lisans Anahtarını Kaydet",
      wrongLicenceKey: "Lütfen geçerli bir lisans numarası girin",
      saveLicenceKeySuccessfully: "Lisans anahtarı başarıyla kaydedildi!",
      licenceAddTerminalMaxCount: "Varolan lisansınıza maksimum eklenebilecek terminal sayısı",
      licenceTerminalDescription: "Yeni terminal ekleyebilmek için lisansınızı yükseltmeniz gerekmektedir. Lisansınızı yükseltmek için lütfen satıcınızla irtibata geçin.",
      theme: "Tema",
      themes: {
        blue: "Mavi",
        black: "Siyah",
        purple: "Mor",
        green: "Yeşil",
        red: "Kırmızı",
        yellow: "Turuncu",
        blueLight: "Mavi Beyaz",
        blackLight: "Siyah Beyaz",
        purpleLight: "Mor Beyaz",
        greenLight: "Yeşil Beyaz",
        redLight: "Kırmızı Beyaz",
        yellowLight: "Turuncu Beyaz"
      },
      manufacturerInformation: "Üretici Bilgileri",
      copyright: "Telif Hakkı",
      allRightsReserved: "Tüm hakları saklıdır.",
      version: "Versiyon",
      notifications: "Bildirimler",
      deviceCommunication: "Terminal İletişim",
      notificationNotFound: "Kullanıcıya ait bildirim bulunmamaktadır.",
      notificationView: "Toplam görüntülenen bildirim :",
      logOut: "Çıkış Yap",
      dashboard: "Kontrol Paneli",
      realTimeMonitor: "Canlı İzleme",
      employees: "Kişiler",
      visitors: "Ziyaretçi Takip",
      visitorCards: "Ziyaretçi Kartları",
      visitorReports: "Ziyaretçi Raporları",
      batchOperations: "Toplu İşlemler",
      reports: "Raporlar",
      payrollManagement: "Puantaj Yönetimi",
      shiftManagement: "Vardiya (Shift) Yönetimi",
      shiftSettings: "Vardiya (Shift) Ayarları",
      diningHall: "Yemekhane",
      retailSale: "Bakiyeli Satış",
      employeeOperations: "Kişi İşlemleri",
      studentTransactions: "Öğrenci İşlemleri",
      areas: "Bölgeler",
      foodGroups: "Yemek Grupları",
      diningHallReports: "Yemekhane Raporları",
      guardTourSystem: "Devriye Tur Kontrol",
      guards: "Görevliler",
      points: "Kontrol Noktaları",
      tours: "Turlar",
      guardTourReports: "Devriye Tur Raporları",
      definitions: "Tanımlamalar",
      cardDesignTemplates: "Kart Şablonları",
      extraFields: "Özel Alanlar",
      licensePlateRecognition: "Plaka Tanıma Sistemi",
      departments: "Departmanlar",
      accessGroups: "Geçiş Yetki Grupları",
      workPlans: "Çalışma Planları",
      overtimeDefinitions: "Fazla Mesai Tanımları",
      allowences: "İzinler",
      annualPermitGroups: "Yıllık İzin Grupları",
      scenarioList: "Senaryo Listesi",
      timeZones: "Geçiş Parametreleri",
      devices: "Terminaller",
      deviceOperations: "Terminal İşlemleri",
      settings: "Ayarlar",
      companySettings: "Şirket Ayarları",
      users: "Kullanıcılar",
      userAuthorityGroups: "Yetki Grupları",
      mailSmsSettings: "Mail & SMS Ayarları",
      userLogs: "İşlem Kayıtları ",
      payrollTypes: "Puantaj Tipleri",
      monthlyPayrollTables: "Aylık Puantaj Tablosu",
      integration: "Entegrasyon",
      support: "Destek",
      appAbout: "Yazılım Hakkında",
      workPlaceDefinitions: "Görev Yeri Tanımları",
      inventoryManagement: "Demirbaş Yönetimi",
      inventoryCategories: "Demirbaş Kategorileri",
      inventoryWarehouses: "Demirbaş Depoları",
      inventoryFields: "Demirbaş Özellikleri",
      inventories: "Demirbaşlar",
      documentDefinitions: "Belge Tanımları"
    },
    filters: {
      filterEmployees: "Kişileri Filtrele",
      filterNameSurnameOrCardNo: "Adı Soyadı / Kart No",
      filterCitizenshipNumber: "Vatandaşlık No",
      filterRegistrationOrDeviceNo: "Sicil No / Terminal No",
      filterDocumentNoOrEmail: "E-posta",
      filterWorkPlan: "Çalışma Grubu",
      filterTitle: "Ünvanı",
      filterState: "Durumu",
      filterStatus: "Statü",
      filterAccessGroup: "Geçiş Grubu",
      filterFoodGroup: "Yemek Grubu",
      filterDepartments: "Departmanlar",
      filterAllowence: "İzinler",
      filterDepartmentNotRecord: "Departman kaydı bulunamadı.",
      filterDeleted: "Silinenler",
      filterNotShow: "Gösterme",
      filterVisitorCards: "Ziyaretçi Kartları",
      filterShow: "Göster",
      filterSelectExtraFields: "Özel Alan Seçiniz",
      filterCancel: "İptal",
      filterClear: "Sıfırla",
      filterApply: "Filtrele",
      filterValue: "Değer",
      filterComplete: "Seçimi Tamamla",
      filterPlateNo: "Plaka veya Etiket No",
      searchEmployeeFromList: "Liste içinde kişi arayın...",
      employeeList: "Kişi Listesi",
      employeeNotRecord: "Kişi kaydı bulunamadı."
    },
    alerts: (_alerts = {
      fileSizeIsTooHigh: "Dosya boyutu çok yüksek...",
      pleaseCheckTheFileFormat: "Lütfen dosya formatını kontrol edin",
      pleaseSelectFile: "Lütfen dosya seçin...",
      pleaseSelectADocumentDefinition: "Lütfen belge tipi seçin",
      fileUploadSuccessfull: "Dosya başarıyla yüklendi!",
      departmentAndMainDepartmentOverlap: "Departman ve ana departman aynı olamaz...",
      wrongEmail: "Lütfen geçerli bir e-posta adresi girin",
      wrongEmailOrUsername: "Lütfen geçerli bir e-posta adresi veya kullanıcı adı girin",
      wrongPassword: "Lütfen parolanızı kontrol edin",
      undefinedUser: "Tanımsız kullanıcı",
      userNotFound: "Kullanıcı bulunamadı",
      salaryNameNotBlank: "Ödeme & kesinti adı boş bırakılamaz...",
      savedSuccessfully: "Başarıyla kaydedildi!",
      updatedSuccessfully: "Başarıyla güncellendi",
      deletedSuccessfully: "Başarıyla silindi!",
      visitorCardGroupNameNotBlank: "Kart grubu adı boş bırakılamaz...",
      statusNameNotBlank: "Statü adı boş bırakılamaz...",
      stateNameNotBlank: "Durum adı boş bırakılamaz...",
      selectedDayNotMissingHour: "Seçilen güne ait eksik saat yok",
      notSelectedReader: "Lütfen bir okuyucu seçin...",
      cannotCreateMovementInTheFuture: "İleri tarihte bir hareket oluşturamazsınız...",
      getReadersError: "Okuyucular çekilirken hata oluştu...",
      creditNotBlank: "Lütfen kredi girin...",
      commandSendToReaderSuccessfully: "Okuyucuya yetki komutu başarıyla gönderildi!",
      commandSentToDevicesSuccessfully: "Terminallere yetki komutları başarıyla gönderildi!",
      getUserInfoFromTerminalsSuccessfully: "Terminallerden kişi bilgileri başarıyla istendi!",
      getFaceTemplateFromSuccessfully: "Terminallerden kişiye ait yüz izi bilgisi başarıyla istendi!",
      getFingerprintFromUsbReader: "Parmak izi alma komutu başarıyla gönderildi!",
      getFingerprintsFromTerminalsSuccessfully: "Terminallerden kişiye ait parmak izi bilgileri başarıyla istendi!",
      confirmedOvertimeCannotBeGreaterThanCalculated: "Onaylanan fazla mesai, hesaplanandan daha büyük olamaz...",
      selectedEmployeeNotBlank: "Lütfen önce kişi seçin...",
      selectedReportNotBlank: "Lütfen önce rapor seçin...",
      invalidDate: "Lütfen geçerli bir tarih girin...",
      invalidPrice: "Lütfen tutarı kontrol edin...",
      invalidSalaryType: "Lütfen ödeme & kesinti tipi seçin...",
      employeeRegistrationNumberNotBlank: "Sicil no alanı boş bırakılamaz...",
      employeeNameNotBlank: "Ad soyad alanı boş bırakılamaz...",
      employeeDepartmentNotBlank: "Departman alanı boş bırakılamaz...",
      employeeDeviceNoNotBlank: "Terminal no alanı boş bırakılamaz...",
      employeeStartDateNotBlank: "Giriş tarihi boş bırakılamaz...",
      employeeTitleNotBlank: "Ünvan alanı boş bırakılamaz...",
      employeeIdentityNoNotBlank: "Vatandaşlık numarası boş geçilemez...",
      employeeEndDateNotBlank: "Çıkış tarihi boş bırakılamaz...",
      employeeWorkGroupIdNotBlank: "Çalışma grubu alanı boş bırakılamaz...",
      employeeStateIdNotBlank: "Durum alanı boş bırakılamaz...",
      employeeStateNoteNotBlank: "Durum notu alanı boş bırakılamaz...",
      employeeStatuIdNotBlank: "Statü alanı boş bırakılamaz...",
      employeeCardNoNotBlank: "Kart numarası alanı boş bırakılamaz...",
      employeeTerminalStatuNotBlank: "Terminal statü alanı boş bırakılamaz...",
      employeeTerminalPasswordNotBlank: "Terminal parolası alanı boş bırakılamaz...",
      employeeTzCodeNotBlank: "Geçiş parametreleri alanı boş bırakılamaz...",
      employeePlateNoNotBlank: "Plaka alanı boş bırakılamaz...",
      employeeHgsNoNotBlank: "HGS alanı boş bırakılamaz...",
      employeeDocumentNoNotBlank: "Belge numarası alanı boş bırakılamaz...",

      visitorCardRegistrationNumberNotBlank: "Sicil no alanı boş bırakılamaz...",
      visitorCardNameNotBlank: "Kart adı alanı boş bırakılamaz...",
      visitorCardDeviceNoNotBlank: "Terminal no alanı boş bırakılamaz...",
      visitorCardCreateDateNotBlank: "Kayıt tarihi boş bırakılamaz...",
      userIsNotAuthorizedToSeeData: "Kullanıcınızın veri görmeye yetkisi yok",
      payrollOfTheEmployeeWasRecalculated: "Kişiye ait puantaj yeniden hesaplandı",
      confirmedOvertimeDeleted: "Onaylanan fazla mesai silindi",
      youAreOnlyAuthorizedToViewThisPage: "Bu sayfayı sadece görüntüleyebilme yetkisine sahipsiniz...",
      attentionPersonIsInBlackList: "Dikkat! Kişi kara listede!",
      cardIsUsed: "Kart kullanımda!",
      unableToConnectPageRefreshing: "Bağlantı sağlanamadı... Sayfa yenileniyor...",
      attentionPersonIsInBlackListNotBeenUpdated: "Dikkat! Kişi güncellenemedi. Çünkü kara listede!",
      visitorSuccessfullyExit: "Başarıyla çıkış yapıldı.",
      visitorIdentityNumberNotBlank: "Vatandaşlık numarası boş geçilemez...",
      visitorNameNotBlank: "Ziyaretçi adı boş geçilemez...",
      payrollOfTheEmployeesWasRecalculated: "Kişilere ait puantaj yeniden hesaplandı",
      allowenceNotSelected: "Lütfen izin seçin...",
      checkConfirmedTimes: "Hesaplanan süreden fazla onaylanmış kayıtlar var. Lütfen onaylanan süreleri kontrol edin...",
      confirmationOvertimeSuccessfully: "Fazla mesai onaylama başarıyla tamamlandı!",
      selectedRecordNotFound: "Seçilen kayıt bulunamadı",
      recordNotFound: "Kayıt bulunamadı.",
      checkTheMealTime: "Girilen saatte tanımlı öğün bulunmamaktadır. Lütfen yemek saatini kontrol edin...",
      mealNameNotBlank: "Öğün adı boş bırakılamaz",
      selectedMealNotBlank: "Lütfen öğün seçimi yapın",
      invalidTimeRange: "Lütfen saat aralığını kontrol edin",
      foodGroupNameNotBlank: "Grup adı boş bırakılamaz",
      selectedDepartmentNotBlank: "Lütfen departman seçimi yapın",
      selectedAccessGroupNotBlank: "Lütfen geçiş grubu seçimi yapın",
      accessGroupNameNotBlank: "Geçiş grubu adı boş bırakılamaz",
      pleaseCheckTimes: "Lütfen girilen saatleri kontrol edin",
      pleaseSelect: "Lütfen bir seçim yapın",
      pleaseEnterPeriodStartDate: "Lütfen periyod başlangıç tarihi girin",
      pleaseEnterShortCodeAndName: "Lütfen kısa kod ve isim girin",
      pleaseEnterAName: "Lütfen bir isim girin",
      pleaseEnterAEmail: "Lütfen bir e-posta girin",
      pleaseCheckEnteredValue: "Lütfen girilen değerleri kontrol edin",
      pleaseEnterADeviceNo: "Lütfen terminal numarası girin",
      pleaseEnterADeviceName: "Lütfen terminal adı girin",
      pleaseEnterIpAddressAndPort: "Lütfen Ip adresi ve port girin",
      pleaseEnterAReaderName: "Lütfen okuyucu adı girin",
      pleaseReaderNoOrPressButtonNewReader: "Lütfen okuyucu numarası girin veya yeni okuyucu butonuna basın",
      pleaseSelectReader: "Lütfen okuyucu seçin",
      pleaseCheckFoodGroupAndDate: "Lütfen yemek grubunun seçili olduğundan ve tarihin doğru olduğundan emin olun...",
      insufficientBalance: "Yetersiz bakiye!",
      pleaseEnterAmount: "Lütfen bir tutar girin...",
      noContactInformation: "Kişi bilgisi mevcut değil...",
      pleaseEnterADate: "Lütfen tarih girin",
      pleaseEnterACompanyName: "Lütfen şirket adı girin...",
      pleaseEnterAUserName: "Lütfen kullanıcı adı girin...",
      pleaseEnterAPassword: "Lütfen parola girin...",
      passwordsDoNotMatch: "Parolalar eşleşmedi...",
      pleaseSelectAuthorityGroup: "Lütfen yetki grubu seçin...",
      pleaseCheckEmptyFields: "Lütfen boş alanları kontrol edin",
      transfersTriggeredSuccessfully: "Aktarımlar başarıyla tetiklendi!"
    }, _defineProperty(_alerts, 'pleaseSelectFile', "Lütfen dosya seçin..."), _defineProperty(_alerts, 'transactionSuccessfull', "İşlem başarılı!"), _defineProperty(_alerts, 'youAreNotAuthorizedForThisAction', "Bu işlem için yetkiniz yok..."), _alerts),
    errors: {
      connectionError: "Bağlantı Hatası : servise ulaşılamadı"
    },
    loginPage: {
      select: "Seçiniz",
      welcome: 'Giriş yapmak için kullanıcı bilgilerinizi girin.',
      fullScreenInfo: "Tam ekran kullanım için 'F11' tuşuna basın.",
      loginButton: "Giriş Yap",
      emailOrUsername: "E-posta adresi veya kullanıcı adı",
      password: "Şifre",
      title1: "Modern Arayüz",
      title2: "Esnek Platform",
      title3: "Kolay Kullanım",
      title4: "Hızlı Çözüm",
      infoTitle1: "Modern Arayüz",
      infoContent1: "Mobil uyumlu arayüz ile dilediğiniz yerden sınırsız erişim",
      infoTitle2: "Bağımsız Platform",
      infoContent2: "Windows, Linux, Mac, Pardus vb. işletim sistemleri desteği",
      infoTitle3: "Esnek Veritabanı",
      infoContent3: "MSSQL, PostgreSQL vb. ilişkisel tüm veritabanı çeşitleri ile çalışma",
      infoTitle4: "Sınırsız Kullanıcı",
      infoContent4: "Sınırsız kullanıcı ve kolaylaştırılmış arayüz",
      infoTitle5: "Sınırsız Alt Kırılım",
      infoContent5: "Sınırsız ve esnek alt yapı ile özel filtreleme",
      infoTitle6: "Esnek Çalışma Tipleri",
      infoContent6: "Her sektöre uygun çalışma tipi desteği",
      infoTitle7: "Ayrıntılı Raporlar",
      infoContent7: "Esnek rapor çeşitleri ve tek tıkla dışa aktarım",
      infoTitle8: "Otomatik Mail",
      infoContent8: "İstenilen kişilere otomatik rapor gönderimi",
      infoTitle9: "Canlı İzleme",
      infoContent9: "Geçişleri gerçek zamanlı görüntüleme",
      infoTitle10: "Dil Seçenekleri",
      infoContent10: "Her kullanıcı için özelleştirilebilir dil seçenekleri",
      infoTitle11: "Esnek Altyapı",
      infoContent11: "Geliştirme ve entegrasyonlara açık altyapı",
      infoTitle12: "Sınırsız Güncelleme",
      infoContent12: "Hızlı destek ve sınırsız güncelleme hizmeti"
    },
    dashboard: {
      startOfWorks: "İŞ BAŞI YAPANLAR",
      absentees: "GELMEYENLER",
      totalEmployee: "TOPLAM KİŞİ",
      lateComers: "GEÇ GELENLER",
      lastUpdate: "SON GÜNCELLEME",
      deviceStatus: "Terminal Durumları",
      device: "Terminal",
      lastConnection: "Son Bağlantı",
      status: "Durumu",
      deviceNotFound: "Terminal kaydı bulunamadı.",
      allowenceRequests: "İzin Talepleri",
      allowenceRequest: "İzin Talebi",
      allowenceRequestNotFound: "Bekleyen izin talebi bulunmuyor.",
      allowenceHeadNameAndDescription: "Kişi / Açıklama",
      allowenceHeadRequestedDates: "Talep Edilen Tarihler",
      viewDetails: "Detayları Görüntüle",
      upcomingBirthdays: "Yaklaşan Doğum Günleri",
      upcomingBirthdaysNotFound: "Yaklaşan doğum günü bulunmuyor.",
      insides: "İçeridekiler",
      outsides: "Dışarıdakiler",
      allowenceEmployees: "İzinliler",
      insideVisitors: "İçerideki Ziyaretçiler",
      totalCar: "Toplam Araç",
      insideCar: "İçerideki Araçlar",
      outsideCar: "Dışarıdaki Araçlar",
      registeredMobileAppUser: "Kayıtlı Mobil Kullanıcı",
      activeMobileAppUser: "Aktif Mobil Kullanıcı",
      activeStudentsInDormitory: "Toplam Aktif Öğrenci",
      insideStudentsInDormitory: "İçerideki Öğrenciler",
      outsideStudentsInDormitory: "Dışarıdaki Öğrenciler",
      allowencedStudentsInDormitory: "İzinli Öğrenciler",
      fastReportView: "Hızlı Raporda Görüntüle",
      fastReportTitleTodayStartOfWorks: "Bugün İş Başı Yapanlar",
      fastReportTitleTodayAbsentees: "Bugün Gelmeyenler",
      fastReportTitleTotalEmployees: "Toplam Kişiler",
      fastReportTitleTodayLateComers: "Bugün Geç Gelenler",
      fastReportTitleInsides: "İçerideki Kişiler",
      fastReportTitleOutsides: "Dışarıdaki Kişiler",
      fastReportTitleTodayAllowence: "Bugün İzinli Kişiler",
      fastReportTitleInsideVisitors: "İçerideki Ziyaretçiler",
      fastReportTitleTotalCars: "Toplam Araçlar",
      fastReportTitleInsideCars: "İçerideki Araçlar",
      fastReportTitleOutsideCars: "Dışarıdaki Araçlar",
      fastReportTitleActiveStudents: "Yurda Kayıtlı Aktif Öğrenciler",
      fastReportTitleInsideStudents: "Yurdun İçinde Bulunan Öğrenciler",
      fastReportTitleOutsideStudents: "Yurdun Dışında Bulunan Öğrenciler",
      fastReportTitleAllowencedStudents: "Yurda Kayıtlı İzinli Öğrenciler",
      fastReportTitleMobileAppUsers: "Mobil Uygulama Kullanıcıları",
      fastReportTitleActiveMobileAppUsers: "Aktif Mobil Uygulama Kullanıcıları",
      fastReportNotRecord: "Görüntülenecek sonuç bulunamadı.",
      fastReportHeaderItems: {
        registrationNumber: "Sicil No",
        name: "Ad Soyad",
        department: "Departman",
        datetime: "Zaman",
        status: "Statü",
        citizenshipNumber: "Vatandaşlık No",
        visitorName: "Ziyaretçi Adı",
        entryTime: "Giriş Zamanı",
        title: "Ünvan",
        mobilePhone: "Telefon",
        device: "Cihaz Modeli",
        readerName: "Okuyucu Adı"
      }
    },
    realTimeMonitor: {
      inputStatus: "Kapı Durumları",
      openDoor: "Tetik Gönder",
      relayDelay: "Tetik Süresi (sn)",
      pleaseEnterRelayDelay: "Lütfen tetik süresini saniye cinsinden girin...",
      openDoorCommandSentSuccessfully: "Kapı açma komutu başarıyla gönderildi!",
      foodMenuAndView: "Yemekhane Menüsü ve İzleme",
      entryExitList: "Geçiş Listesi",
      lastEntry: "Son Yapılan Giriş",
      lastExit: "Son Yapılan Çıkış",
      logNotFoundInfo: "Geçiş hareketi olduğunda bu alanda listelenecektir.",
      foodMenu: "Yemek Menüsü",
      todayTotalFood: "Bugün Yenilen Yemek Toplamı",
      entryOrExitLogInfo: "Geçiş Bilgisi",
      logTime: "Geçiş Zamanı",
      logDescription: "Geçiş Açıklaması",
      mealPay: "Yemek Ücreti",
      availableBalance: "Kalan Bakiye",
      movementLogDescription: {
        moveIn: "Geçiş yaptı",
        entryIn: "Giriş yaptı",
        exitOut: "Çıkış yaptı",
        unregisteredCard: "Tanımsız Kart",
        noAccess: "Onay yok",
        dailyMealRightExpired: "Günlük yemek hakkı doldu",
        mealClaimExpired: "Öğün hakkı doldu",
        insufficientBalance: "Yetersiz bakiye",
        foodGroupNotSelected: "Yemek grubu seçilmemiş",
        timeLimit: "Zaman sınırı",
        antipassback: "Antipassback ihlali"
      }
    },
    employees: (_employees = {
      searchEmployeeInList: "Liste içinde kişi arayın",
      employeeList: "Kişi Listesi",
      employeeSearchNotFound: "Kişi kaydı bulunamadı.",
      employeeInfo: "Kişi Bilgileri",
      newEmployee: "Yeni Kişi",
      updateEmployee: "Kişiyi Güncelle",
      saveEmployee: "Kişiyi Kaydet",
      deleteEmployee: "Kişiyi Sil",
      selectedDepartment: "Seçilen Departman",
      removePhoto: "Kaldır",
      selectPhoto: "Fotoğraf Seç",
      deletedRecord: "Silinmiş Kayıt",
      recordType: "Kayıt Tipi",
      employee: "Personel",
      student: "Öğrenci",
      doesStayInTheDormitory: "Yurtta kalıyor",
      doesNotStayInTheDormitory: "Yurtta kalmıyor",
      foodClaim: "Yemek Hakkı",
      registrationNumber: "Sicil No",
      dateOfStartWork: "Başlama Tarihi",
      dateOfStart: "Kayıt Tarihi",
      dateOfEnd: "Çıkış Tarihi",
      dateOfEndWork: "Çıkış Tarihi",
      roomInformation: "Oda - Daire Bilgisi",
      validityStartDate: "Geçerlilik Başlangıç Tarihi",
      validityEndDate: "Geçerlilik Bitiş Tarihi",
      createValidityDate: "Geçerlilik Tarihi Oluştur",
      removeValidityDate: "Geçerlilik Tarihini Kaldır",
      isContinueRemoveValidityDate: "Geçerlilik tarihi kaldırılacaktır. Devam edilsin mi?",
      createValidityDateDescription: "Oluşturmak istediğiniz geçerlilik tarihini girin...",
      passwordExist: "Şifre kaydı mevcut",
      passwordNotExist: "Şifre kaydı mevcut değil",
      cardNumberExist: "Kart numarası var",
      cardNumberNotExist: "Kart numarası mevcut değil",
      fingerprintExist: "Parmak izi kaydı var",
      fingerprintNotExist: "Parmak izi kaydı mevcut değil",
      faceTemplateExist: "Yüz izi kaydı var",
      faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
      fingerPrintInformation: "Parmak İzi Bilgileri",
      fingerPrintDescription: "Lütfen parmak izi almak veya silmek için bir seçim yapın.",
      isVisitorCard: "Ziyaretçi Kartı",
      visitorCardGroup: "Ziyaretçi Kart Grubu",
      visitorCardGroups: "Ziyaretçi Kart Grupları",
      cardGroupList: "Kart Grup Listesi",
      newCardGroup: "Yeni Kart Grubu",
      visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
      cardGroupName: "Kart Grubu Adı",
      readerNotFound: "Okuyucu kaydı bulunamadı.",
      setLeaveDate: "Çıkış Bildir",
      backToWork: "Kaydı Geri Al",
      reActivate: "Yeniden Aktif Et",
      generalInformation: "Genel Bilgiler",
      studentInformation: "Öğrenci Bilgileri",
      extraFields: "Özel Alanlar",
      mobileApp: "Mobil Geçiş",
      otherInformation: "Diğer Bilgileri",
      accessAuthorities: "Yetkiler",
      movements: "Hareketler",
      allowences: "İzinler",
      payroll: "Puantaj",
      annualPermit: "Yıllık İzin",
      payments: "Ödemeler",
      foodGroup: "Yemek Grubu",
      employeeLogs: "İşlem Geçmişi",
      cardPrinting: "Kart Baskı",
      selectTemplate: "Şablon Seçin",
      registrationNumberInfo: "Sicil No",
      citizenshipNumber: "Vatandaşlık No",
      nameSurname: "Ad Soyad",
      department: "Departman",
      title: "Ünvan",
      dateofBirth: "Doğum Tarihi",
      dateOfStartWorkInfo: "Başlama Tarihi",
      status: "Statü",
      state: "Durum",
      stateNote: "Durum Notu",
      deviceEmployeeNumber: "Terminal Numarası",
      deviceStatus: "Terminal Statü",
      deviceCardNo: "Kart Numarası",
      devicePassword: "Terminal Şifre",
      plateNo: "Araç Plaka No",
      hgsNo: "Araç Etiket No",
      workPlan: "Çalışma Grubu",
      documentNo: "Belge No",
      salary: "Maaş",
      overtimeStatus: "Fazla Mesai Durumu",
      takesOvertime: "Fazla Mesai Alır",
      motherName: "Anne Adı",
      motherPhone: "Anne Cep Telefon",
      fatherName: "Baba Adı",
      fatherPhone: "Baba Cep Telefon",
      activateSmsSystem: "SMS Gönderimi",
      smsSendPhone: "SMS Gönderilecek Telefon",
      createExtraField: "Yeni Oluştur",
      extraFieldNoteInfo: "Not : Açılan gruplama alanları tüm kişiler için geçerli olacaktır.",
      keyExtraField: "Adı",
      valueExtraField: "Değeri",
      saveExtraField: "Kaydet",
      extraFieldNotRecord: "Özel alan kaydı bulunamadı.",
      email: "E-posta",
      address: "Adres",
      mobileNumber: "Cep Tel",
      internal: "Dahili",
      mobileBrand: "Cihaz Modeli",
      notPaired: "Eşleştirilmemiş",
      resetPairing: "Eşleştirmeyi Sıfırla",
      unknown: "Bilinmeyen Cihaz",
      isMobileAppUser: "Mobil Uygulama Kullanıcısı Mı?",
      mobileAppPassword: "Mobil Uygulama Parolası",
      qrReaderMode: "QR Okuyucu Modu",
      qrReaderModeAll: "Tümü",
      qrReaderModeOnlyQRCreate: "QR Üreterek",
      qrReaderModeOnlyQRRead: "QR Okuyarak",
      qrReaderModeOnlyWithButton: "Buton ile",
      qrReaderModeQRCreateAndRead: "QR Üreterek & QR Okuyarak",
      qrReaderModeQRReadAndButton: "QR Okuyarak & Buton ile",
      qrReaderModeQRCreateAndButton: "QR Üreterek & Buton ile",
      homePhone: "Ev Tel",
      gender: "Cinsiyet",
      male: "Erkek",
      female: "Kadın",
      educationStatus: "Eğitim Durumu",
      primarySchool: "İlk Öğretim",
      highSchool: "Orta Öğretim",
      associateDegree: "Ön Lisans",
      bachelorDegree: "Lisans",
      postGraduate: "Yüksek Lisans",
      doctorate: "Doktora",
      militaryStatus: "Askerlik Durumu",
      done: "Yapıldı",
      exempt: "Muaf",
      smokingStatus: "Sigara Durumu",
      smoking: "Kullanıyor",
      notSmoking: "Kullanmıyor",
      maritalStatus: "Medeni Durumu",
      single: "Bekar",
      married: "Evli",
      widow: "Dul",
      drivingLicence: "Ehliyet",
      foreignLanguage: "Yabancı Dil",
      bloodType: "Kan Grubu",
      height: "Boy",
      weight: "Kilo",
      disabledPercent: "Engellilik Yüzdesi",
      authorizedPerson1: "1. Sorumlu Kişi",
      authorizedPerson2: "2. Sorumlu Kişi",
      note1: "Not-1",
      note2: "Not-2",
      accessAuthoritiesInfo: "Geçiş Grubu",
      sendPersontoDevices: "Kişiyi Yetkili Terminallere Gönder",
      deviceList: "Terminal Listesi",
      sendToReader: "Okuyucuya Gönder",
      getFingerprint: "Parmak izi al",
      getFaceTemplate: "Yüz izi al",
      getUserData: "Kişiye ait verileri çek",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      newMovement: "Yeni Hareket",
      allDoors: "Tüm Kapılar",
      pdks: "PDKS",
      access: "Access",
      diningHall: "Yemekhane",
      licencePlateRecognition: "Plaka Tanıma",
      dormitoryDevice: "Yurt Terminali",
      all: "Tümü",
      active: "Aktif",
      passive: "Pasif",
      startDateMovements: "Başlangıç",
      endDateMovements: "Bitiş",
      searchMovements: "Listele",
      location: "Konum",
      timeMovement: "Zaman",
      deviceMovement: "Geçiş Noktası",
      statusMovement: "Geçiş",
      manuelMovement: "Manuel Hareket",
      entryMovement: "Giriş",
      exitMovement: "Çıkış",
      movementNotRecord: "Hareket kaydı bulunamadı.",
      addMovement: "Hareket Ekle",
      editMovement: "Hareket Düzenle",
      typeMovement: "Hareket Tipi",
      readerMovement: "Okuyucu",
      includePassivesMovement: "Pasif olan hareketleri de dahil et",
      confirmedOvertimeNotDeleted: "Onaylanan fazla mesailer silinmesin",
      newAllowence: "Yeni İzin",
      removeAllowence: "İzin Sil",
      removeAllowenceInSelectedDates: "Seçilen Tarih Aralığındaki İzinleri Sil",
      startDateAllowences: "Başlangıç",
      endDateAllowences: "Bitiş",
      searchAllowences: "Listele",
      startAllowence: "Başlangıç",
      endAllowence: "Bitiş",
      codeAllowence: "Kodu",
      nameAllowence: "İzin Adı",
      allowenceNotRecord: "İzin kaydı bulunamadı.",
      addAllowence: "İzin Ekle",
      editAllowence: "İzin Düzenle",
      validDays: "Geçerli Günler",
      typeAllowence: "İzin Tipi",
      dailyAllowence: "Günlük İzin",
      hourlyAllowence: "Saatlik İzin",
      startTimeAllowence: "Başlangıç Zamanı",
      endTimeAllowence: "Bitiş Zamanı",
      allowence: "İzin",
      totalTimeAllowence: "Toplam Zaman",
      missingHourAllowence: "Eksik Saat",
      isEqualTheMissingTime: "Eksik saat süresiyle eşitlensin mi?",
      equalTheMissingTime: "Eksik saat süresiyle eşitle",
      doesApplyHolidays: "Tatil günleri içinde geçerli olsun mu?",
      applyHolidays: "Tatil günleri içinde geçerli olsun",
      descriptionAllowence: "Açıklama",
      recalculate: "Yeniden Hesapla",
      startDatePayrolls: "Başlangıç",
      endDatePayrolls: "Bitiş",
      searchPayrolls: "Listele",
      payrollNotRecord: "Puantaj kaydı bulunamadı.",
      datePayroll: "Tarih",
      workPlanPayroll: "Çalışma Planı",
      firstEntry: "İlk Giriş",
      lastExit: "Son Çıkış",
      calculatedOvertime: "Hesap. F.M.",
      confirmedOvertime: "Onaylanan F.M.",
      confirmTheCalculated: "Hesaplananı onayla",
      deleteTheConfirmed: "Onaylananı sil",
      annualPermitGroups: "Yıllık İzin Grubu",
      seniority: "Kıdem",
      transfer: "Devir",
      remaining: "Kalan",
      deservedAnnualPermits: "Hakedilen Yıllık İzinler",
      deservedDate: "Hakediş Tarihi",
      deservedDay: "Hakedilen Gün",
      annualPermitNotRecord: "Hakedilen yıllık izin kaydı bulunamadı.",
      usedAnnualPermits: "Kullanılan Yıllık İzinler",
      annualPermitDate: "İzin Tarihi",
      annualPermitName: "İzin Adı",
      annualPermitDescription: "Açıklama",
      usedAnnualPermitNotRecord: "Kullanılan yıllık izin kaydı bulunamadı."
    }, _defineProperty(_employees, 'payments', "Ödemeler"), _defineProperty(_employees, 'paymentDefinitions', "Ödeme Tanımları"), _defineProperty(_employees, 'newPayment', "Yeni"), _defineProperty(_employees, 'startDatePayments', "Başlangıç"), _defineProperty(_employees, 'endDatePayments', "Bitiş"), _defineProperty(_employees, 'searchPayments', "Listele"), _defineProperty(_employees, 'timePayment', "Zaman"), _defineProperty(_employees, 'namePayment', "Ödeme & Kesinti Adı"), _defineProperty(_employees, 'amountPayment', "Tutar"), _defineProperty(_employees, 'statusPayment', "Durum"), _defineProperty(_employees, 'addedSalary', "Maaşa Eklenir"), _defineProperty(_employees, 'decreaseFromSalary', "Maaştan Düşer"), _defineProperty(_employees, 'paymentNotRecord', "Ödeme & kesinti kaydı bulunamadı."), _defineProperty(_employees, 'addPayment', "Ödeme & Kesinti Ekle"), _defineProperty(_employees, 'editPayment', "Ödeme & Kesinti Düzenle"), _defineProperty(_employees, 'typePayment', "Ödeme & Kesinti Tipi"), _defineProperty(_employees, 'effectOnSalary', "Maaşa Etkisi"), _defineProperty(_employees, 'remainingCredits', "Kalan Kontör"), _defineProperty(_employees, 'availableBalance', "Kalan Bakiye"), _defineProperty(_employees, 'addCredit', "Kontör Yükle"), _defineProperty(_employees, 'addBalance', "Bakiye Yükle"), _defineProperty(_employees, 'amountOfCredit', "Kontör Miktarı"), _defineProperty(_employees, 'amountOfBalance', "Bakiye Miktarı"), _defineProperty(_employees, 'startDateLogs', "Başlangıç"), _defineProperty(_employees, 'endDateLogs', "Bitiş"), _defineProperty(_employees, 'searchLogs', "Listele"), _defineProperty(_employees, 'timeLog', "İşlem Zamanı"), _defineProperty(_employees, 'descriptionLog', "İşlem Açıklaması"), _defineProperty(_employees, 'logNotRecord', "İşlem kaydı bulunamadı."), _defineProperty(_employees, 'selectEmployee', "Kişi Seç"), _defineProperty(_employees, 'searchFromNameSurname', "Ad soyada göre arayın."), _defineProperty(_employees, 'isContinueUpdateEmployee', "Seçilen kişi güncellenecektir. Devam edilsin mi?"), _defineProperty(_employees, 'isContinueSaveEmployee', "Yeni kişi kaydedilecektir. Devam edilsin mi?"), _defineProperty(_employees, 'isContinueDeleteEmployee', "Seçilen kişi silinecektir. Devam edilsin mi?"), _defineProperty(_employees, 'setLeaveDateInfo', "Seçilen kişi için çıkış bildirimi yapılacaktır. Lütfen çıkartmak istediğiniz tarihi girin."), _defineProperty(_employees, 'updateWorkPlan', "Çalışma Planı Güncelle"), _defineProperty(_employees, 'updateAllowence', "İzin Güncelle"), _defineProperty(_employees, 'updateAllowenceNotRecord', "Kayıt bulunamadı."), _defineProperty(_employees, 'updateWorkPlanNotRecord', "Kayıt bulunamadı."), _defineProperty(_employees, 'states', "Durumlar"), _defineProperty(_employees, 'stateList', "Durum Listesi"), _defineProperty(_employees, 'newState', "Yeni Durum"), _defineProperty(_employees, 'stateNotRecord', "Durum kaydı bulunamadı."), _defineProperty(_employees, 'stateName', "Durum Adı"), _defineProperty(_employees, 'enableToLeaveDate', "Seçildiğinde ayrılma tarihi etkinleşsin"), _defineProperty(_employees, 'statusTitle', "Statüler"), _defineProperty(_employees, 'statusList', "Statü Listesi"), _defineProperty(_employees, 'newStatus', "Yeni Statü"), _defineProperty(_employees, 'statusNotRecord', "Statü kaydı bulunamadı."), _defineProperty(_employees, 'statusName', "Statü Adı"), _defineProperty(_employees, 'selectDepartment', "Departman Seçin"), _defineProperty(_employees, 'departmentNotRecord', "Departman kaydı bulunamadı."), _defineProperty(_employees, 'confirmSelectedOvertime', "Fazla Mesaiyi Onayla"), _defineProperty(_employees, 'overtimePlace', "Fazla Mesai Yeri"), _defineProperty(_employees, 'overtimeDescription', "Fazla Mesai Nedeni"), _defineProperty(_employees, 'dailyPayrollDetail', "Günlük Puantaj Detayı"), _defineProperty(_employees, 'payrollDetail', "Puantaj Detayı"), _defineProperty(_employees, 'movementsOT', "Hareketler"), _defineProperty(_employees, 'payrollTime', "Süre"), _defineProperty(_employees, 'movementOT', "Hareket"), _defineProperty(_employees, 'statusOT', "Durum"), _defineProperty(_employees, 'calculatedOvertimeLong', "Hesaplanan F.M."), _defineProperty(_employees, 'confirmedOvertimeLong', "Onaylanan F.M."), _defineProperty(_employees, 'workPlaceStartDate', "Başlangıç"), _defineProperty(_employees, 'workPlaceEndDate', "Bitiş"), _defineProperty(_employees, 'workPlace', "Görev Yeri"), _defineProperty(_employees, 'workPlaces', "Görev Yerleri"), _defineProperty(_employees, 'workPlaceDefinitions', "Görev Yeri Tanımları"), _defineProperty(_employees, 'newWorkPlace', "Yeni Görev Yeri"), _defineProperty(_employees, 'workPlaceDescription', "Görev Yeri Açıklaması"), _defineProperty(_employees, 'addWorkplace', "Görev Yeri Ekle"), _defineProperty(_employees, 'editWorkplace', "Görev Yeri Düzenle"), _defineProperty(_employees, 'descriptionWorkPlace', "Görev Yeri Açıklaması"), _defineProperty(_employees, 'salary', "Maaş"), _defineProperty(_employees, 'updateTime', "Güncelleme Zamanı"), _defineProperty(_employees, 'addSalary', "Maaş Ekle"), _defineProperty(_employees, 'editSalary', "Maaş Düzenle"), _defineProperty(_employees, 'newSalary', "Yeni Maaş"), _defineProperty(_employees, 'assignedInventory', "Zimmetler"), _defineProperty(_employees, 'inventoryName', "Adı"), _defineProperty(_employees, 'inventoryQuantity', "Adet"), _defineProperty(_employees, 'inventoryDescription', "Açıklama"), _defineProperty(_employees, 'deliveryDate', "Verildiği Tarih"), _defineProperty(_employees, 'takenDate', "Teslim Alındığı Tarih"), _defineProperty(_employees, 'addInventory', "Zimmet Ekle"), _defineProperty(_employees, 'selectedInventory', "Demirbaş"), _defineProperty(_employees, 'documents', "Belgeler"), _defineProperty(_employees, 'addDocument', "Belge Ekle"), _defineProperty(_employees, 'documentDescription', "Açıklama"), _defineProperty(_employees, 'documentType', "Belge Tipi"), _defineProperty(_employees, 'editDocument', "Döküman Bilgilerini Düzenle"), _defineProperty(_employees, 'documentFile', "Dosya"), _defineProperty(_employees, 'isgDocument', "İSG Belgesi"), _defineProperty(_employees, 'validityStartDate', "Geçerlilik Başlangıç Tarihi"), _defineProperty(_employees, 'validityEndDate', "Geçerlilik Bitiş Tarihi"), _defineProperty(_employees, 'isgDocumentValidity', "İSG belgelerinde geçerlilik başlangıç ve bitiş tarihleri boş geçilemez"), _employees),
    visitors: {
      waitingVisitors: "Beklenenler",
      blackList: "Kara Liste",
      reasonsForVisit: "Ziyaret Nedenleri",
      visitorName: "Ziyaretçi Adı",
      reasonForVisit: "Ziyaret Nedeni",
      appointmentTime: "Randevu Zamanı",
      waitingVisitorNotRecord: "Beklenen ziyaretçi kaydı bulunamadı.",
      citizenshipNumber: "Vatandaşlık No",
      blackListName: "Kişi Adı",
      blackListDescription: "Açıklama",
      blackListNotRecord: "Kara liste kaydı bulunamadı.",
      reasonForVisitNotRecord: "Ziyaret nedeni kaydı bulunamadı.",
      inUse: "Kullanımda",
      ready: "Hazır",
      givenTemporary: "Geçici Verildi",
      visitorCardNotRecord: "Ziyaretçi kartı kaydı bulunamadı.",
      employeeStatus: "Kişi Durumları",
      searchEmployeeFromList: "Listeden kişi arayın...",
      searchVisitorCardFromList: "Listeden ziyaretçi kartı arayın...",
      employeeNotRecord: "Kişi kaydı bulunamadı.",
      in: "İçeride",
      out: "Dışarıda",
      noLatestStatusInformation: "Son durum bilgisi yok",
      visitorInformation: "Ziyaretçi Bilgileri",
      previousSimilarRecords: "Önceki Benzer Kayıtlar",
      similarRecordNotFound: "Benzer kayıt bulunamadı.",
      employeeList: "Kişi Listesi",
      visitorCard: "Ziyaretçi kartı",
      temporaryCardForEmployee: "Çalışan için geçici kart",
      nameSurname: "Adı Soyadı",
      mobilePhone: "Cep Telefonu",
      where: "Nereye",
      person: "Kişi",
      company: "Kurum",
      other: "Diğer",
      description: "Açıklama",
      visitedEmployeeInformation: "Ziyaret edilen kişi bilgileri",
      employeeInformation: "Kişi bilgileri",
      selectEmployee: "Kişi Seç",
      waitingVisitorInformation: "Beklenen Kişi Bilgileri",
      employeeSearch: "Kişi arayın...",
      noContactInformation: "Kişi bilgisi yok",
      visitorCards: "Ziyaretçi Kartları",
      selectVisitorCardToGive: "Verilecek ziyaretçi kartını seçin",
      readyToUseVisitorCardNotRecord: "Kullanıma uygun ziyaretçi kartı yok.",
      selectVisitorCardGroup: "Grup Seçiniz",
      isContinueDeleteReason: "Seçilen geliş nedeni kaydı silinecektir. Devam edilsin mi?",
      isContinueDeleteBlackList: "Seçilen kara liste kaydı silinecektir. Devam edilsin mi?",
      isContinueDeleteWaitingVisitor: "Seçilen beklenen kişi kaydı silinecektir. Devam edilsin mi?"

    },
    visitorCards: {
      searchVisitorCardInList: "Listeden ziyaretçi kartı arayın",
      visitorCardList: "Ziyaretçi Kartı Listesi",
      visitorCardSearchNotFound: "Ziyaretçi kartı kaydı bulunamadı.",
      visitorCardInfo: "Ziyaretçi Kartı Bilgileri",
      newVisitorCard: "Yeni Ziyaretçi Kartı",
      updateVisitorCard: "Ziyaretçi Kartını Güncelle",
      saveVisitorCard: "Ziyaretçi Kartını Kaydet",
      deleteVisitorCard: "Ziyaretçi Kartını Sil",
      removePhoto: "Kaldır",
      selectPhoto: "Fotoğraf Seç",
      deletedRecord: "Silinmiş Kayıt!",
      registrationNumber: "Sicil No",
      dateOfCreate: "Kayıt Tarihi",
      passwordExist: "Şifre kaydı mevcut",
      passwordNotExist: "Şifre kaydı mevcut değil",
      cardNumberExist: "Kart numarası var",
      cardNumberNotExist: "Kart numarası mevcut değil",
      fingerprintExist: "Parmak izi kaydı var",
      fingerprintNotExist: "Parmak izi kaydı mevcut değil",
      faceTemplateExist: "Yüz izi kaydı var",
      faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
      visitorCardGroup: "Ziyaretçi Kart Grubu",
      visitorCardGroups: "Ziyaretçi Kart Grupları",
      cardGroupList: "Kart Grup Listesi",
      newCardGroup: "Yeni Kart Grubu",
      visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
      cardGroupName: "Kart Grubu Adı",
      readerNotFound: "Okuyucu kaydı bulunamadı.",
      generalInformation: "Genel Bilgiler",
      accessAuthorities: "Yetkiler",
      movements: "Hareketler",
      employeeLogs: "İşlem Kayıtları",
      cardPrinting: "Kart Baskı",
      selectTemplate: "Şablon Seçin",
      registrationNumberInfo: "Sicil No",
      cardName: "Kart Adı",
      department: "Departman",
      dateOfCreateInfo: "Kayıt Tarihi",
      status: "Statü",
      deviceEmployeeNumber: "Terminal No",
      deviceStatus: "Terminal Statü",
      deviceCardNo: "Terminal Kart Numarası",
      devicePassword: "Terminal Şifresi",
      accessAuthoritiesInfo: "Geçiş Yetki Grubu",
      sendPersontoDevices: "Kişiyi Yetkili Terminallere Gönder",
      deviceList: "Terminal Listesi",
      selectAll: "Tümünü Seç",
      removeAll: "Tümünü Kaldır",
      sendToReader: "Okuyucuya Gönder",
      getFingerprint: "Parmak izlerini Çek",
      getFaceTemplate: "Yüz izi çek",
      getUserData: "Kişi bilgilerini çek",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      allDoors: "Tümü",
      pdks: "PDKS",
      access: "Access",
      diningHall: "Yemekhane",
      all: "Tümü",
      active: "Aktif",
      passive: "Pasif",
      startDateMovements: "Başlangıç Tarihi",
      endDateMovements: "Bitiş Tarihi",
      searchMovements: "Listele",
      timeMovement: "Zaman",
      deviceMovement: "Geçiş Noktası",
      statusMovement: "Durum",
      manuelMovement: "Manuel Hareket",
      entryMovement: "Giriş",
      exitMovement: "Çıkış",
      movementNotRecord: "Hareket kaydı bulunamadı.",
      remainingCredits: "Kalan Kontör",
      availableBalance: "Kalan Bakiye",
      addCredit: "Kontör Yükle",
      addBalance: "Bakiye Yükle",
      amountOfCredit: "Kontör Miktarı",
      amountOfBalance: "Bakiye Miktarı",
      startDateLogs: "Başlangıç",
      endDateLogs: "Bitiş",
      searchLogs: "Listele",
      timeLog: "İşlem Zamanı",
      descriptionLog: "İşlem Açıklaması",
      logNotRecord: "İşlem kaydı bulunamadı.",
      isContinueUpdateVisitorCard: "Seçilen ziyaretçi kartı güncellenecektir. Devam edilsin mi?",
      isContinueSaveVisitorCard: "Yeni ziyaretçi kartı kaydedilecektir. Devam edilsin mi?",
      isContinueDeleteVisitorCard: "Seçilen ziyaretçi kartı silinecektir. Devam edilsin mi?",
      statusTitle: "Statüler",
      statusList: "Statü Listesi",
      newStatus: "Yeni Statü",
      statusNotRecord: "Statü kaydı bulunamadı.",
      statusName: "Statü Adı",
      selectDepartment: "Departman seç",
      departmentNotRecord: "Departman kaydı bulunamadı."
    },
    batchOperations: (_batchOperations = {
      filterTheEmployeesYouWantToSelect: "Seçmek istediğiniz kişileri filtreleyin",
      searchEmployeeFromList: "Liste içinde kişi arayın...",
      employeeList: "Kişi Listesi",
      employeeNotRecord: "Kişi kaydı bulunamadı.",
      chooseFromTheFollowingActions: "Aşağıdaki işlemlerden birini seçin",
      informationUpdate: "Bilgi Güncelle",
      informationUpdateOperations: "Bilgi Güncelleme İşlemleri",
      allowence: "İzin",
      allowenceOperations: "İzin İşlemleri",
      movement: "Hareket",
      movementOperations: "Hareket İşlemleri",
      overtime: "Fazla Mesai",
      overtimeOperations: "Fazla Mesai İşlemleri",
      payroll: "Puantaj",
      payrollOperations: "Puantaj İşlemleri",
      workPlan: "Çalışma Planı",
      workPlanOperations: "Çalışma Planı İşlemleri",
      accessGroup: "Geçiş Grubu",
      validityStartDate: "Geçerlilik Başlangıç Tarihi",
      validityEndDate: "Geçerlilik Bitiş Tarihi",
      department: "Departman",
      status: "Statü",
      state: "Durum",
      foodGroup: "Yemek Grubu",
      startDate: "Başlangıç Tarihi",
      endDate: "Bitiş Tarihi",
      startTime: "Başlangıç Zamanı",
      endTime: "Bitiş Zamanı",
      validDays: "Geçerli Günler"
    }, _defineProperty(_batchOperations, 'allowence', "İzin"), _defineProperty(_batchOperations, 'allowenceType', "İzin Tipi"), _defineProperty(_batchOperations, 'dailyAllowence', "Günlük İzin"), _defineProperty(_batchOperations, 'hourlyAllowence', "Saatlik İzin"), _defineProperty(_batchOperations, 'totalTimeAllowence', "Toplam Zaman"), _defineProperty(_batchOperations, 'missingHourAllowence', "Eksik Saat"), _defineProperty(_batchOperations, 'isEqualTheMissingTime', "Eksik saat süresiyle eşitlensin mi?"), _defineProperty(_batchOperations, 'equalTheMissingTime', "Eksik saat süresiyle eşitle"), _defineProperty(_batchOperations, 'doesApplyHolidays', "Tatil günleri içinde geçerli olsun mu?"), _defineProperty(_batchOperations, 'applyHolidays', "Tatil günleri içinde geçerli olsun"), _defineProperty(_batchOperations, 'descriptionAllowence', "Açıklama"), _defineProperty(_batchOperations, 'movementDetails', "Hareket Detayları"), _defineProperty(_batchOperations, 'movementTime', "Hareket Zamanı"), _defineProperty(_batchOperations, 'reader', "Okuyucu"), _defineProperty(_batchOperations, 'movementType', "Hareket Tipi"), _defineProperty(_batchOperations, 'entryMovement', "Giriş"), _defineProperty(_batchOperations, 'exitMovement', "Çıkış"), _defineProperty(_batchOperations, 'createExitMovement', "Çıkış hareketi de oluştur"), _defineProperty(_batchOperations, 'secondMovementTime', "2.Hareket Zamanı"), _defineProperty(_batchOperations, 'secondMovementReader', "2.Hareket Okuyucusu"), _defineProperty(_batchOperations, 'secondMovementType', "2.Hareket Tipi"), _defineProperty(_batchOperations, 'confirmOvertime', "Fazla Mesai Onaylama"), _defineProperty(_batchOperations, 'search', "Filtrele"), _defineProperty(_batchOperations, 'overtimeWorks', "Yapılan Fazla Mesailer"), _defineProperty(_batchOperations, 'nameSurname', "Ad Soyad"), _defineProperty(_batchOperations, 'date', "Tarih"), _defineProperty(_batchOperations, 'calculated', "Hesaplanan"), _defineProperty(_batchOperations, 'confirmed', "Onaylanan"), _defineProperty(_batchOperations, 'includePassivesMovement', "Pasif olan hareketleri de dahil et"), _defineProperty(_batchOperations, 'confirmedOvertimeNotDeleted', "Onaylanan fazla mesailer silinmesin"), _defineProperty(_batchOperations, 'descriptionWorkPlan', "Açıklama"), _defineProperty(_batchOperations, 'batchInformationUpdateSuccessfully', "Toplu bilgi güncelleme başarıyla tamamlandı!"), _defineProperty(_batchOperations, 'batchWorkPlanUpdateSuccessfully', "Toplu çalışma planı değişikliği başarıyla kaydedildi!"), _defineProperty(_batchOperations, 'batchMovementSuccessfully', "Toplu hareket oluşturma başarıyla kaydedildi!"), _defineProperty(_batchOperations, 'batchAllowencesSuccessfully', "Toplu izin işlemi başarıyla tamamlandı!"), _defineProperty(_batchOperations, 'diningHall', "Yemekhane"), _defineProperty(_batchOperations, 'diningHallOperations', "Yemekhane Toplu Bakiye Yükle"), _defineProperty(_batchOperations, 'downloadTemplate', "Excel Şablonu İndir"), _defineProperty(_batchOperations, 'uploadFile', "Dosya Yükle"), _defineProperty(_batchOperations, 'uploadDescription', "Düzenlediğiniz excel şablon dosyasını yükleyin."), _batchOperations),
    reports: {
      selectReport: "Rapor Seç",
      report: "Rapor",
      noResults: "Görüntülenecek sonuç bulunamadı.",
      reportDetails: "Rapor Detayları",
      displayInReportVisitorCardGroups: "Görüntülenecek ziyaretçi kart grupları",
      visitorCardGroupNotFound: "Ziyaretçi kart grubu kaydı bulunamadı.",
      displayInReportDevices: "Görüntülenecek Terminaller",
      devicesNotFound: "Terminal kaydı bulunamadı.",
      displayInReportAllowences: "Görüntülenecek izinler",
      allowenceNotFound: "İzin kaydı bulunamadı.",
      displayInReportDepartments: "Görüntülenecek departmanlar",
      departmentNotFound: "Departman kaydı bulunamadı.",
      checkThisDevices: "Bu Cihazları İşaretle",
      reportSettings: "Rapor Ayarları",
      startDate: "Başlangıç",
      endDate: "Bitiş",
      date: "Tarih",
      reportOptions: "Rapor Seçenekleri",
      showAllowences: "İzinlileri göster",
      showMissing: "Gelmeyenleri göster",
      showLatecomer: "Geç kalanları göster",
      fromTheClock: "saatten",
      lessEmployees: "Az çalışanlar",
      moreEmployees: "Fazla çalışanlar",
      viewReport: "Raporu Görüntüle",
      selectedReportIsUnavailable: "Seçilen rapor kullanım dışı...",
      reports: {
        LaterComersReport: "Gelmeyenler Raporu",
        LaterComersReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          date: "Tarih",
          status: "Durum",
          entry: "Giriş",
          difference: "Fark"
        },
        DetailedInOutReport: "Detaylı Giriş Çıkış Raporu",
        DetailedInOutReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          workPlace: "Görev Yeri",
          date: "Tarih",
          firstEntry: "İlk Giriş",
          lastExit: "Son Çıkış",
          total: "Toplam",
          status: "Durum",
          entry: "Giriş",
          exit: "Çıkış",
          difference: "Fark"
        },
        FoodReport: "Yemekhane Hareket Raporu",
        FoodReportHeader: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          documentNo: "Belge No",
          departmentName: "Departman",
          readerName: "Okuyucu",
          date: "Tarih",
          debit: "Ücret"
        },
        FoodDebtReport: "Yemekhane Ücret Raporu",
        FoodDebtReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          documentNo: "Belge No",
          debit: "Borç"
        },
        FoodSummaryReport: "Yemekhane İcmal Raporu",
        FoodSummaryReportHeaders: {
          departmentName: "Departman Adı",
          total: "Toplam",
          debit: "Ücret"
        },
        EmployeesReport: "Kişi Bilgileri Raporu",
        EmployeesReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          mobilePhone: "Cep Tel",
          citizenshipNumber: "Vatandaşlık No",
          status: "Statü",
          state: "Durumu",
          startDateWork: "Başlangıç Tarihi",
          leaveDate: "Çıkış Tarihi",
          validityStartDate: "Geçerlilik Başlangıç Tarihi",
          validityEndDate: "Geçerlilik Bitiş Tarihi"
        },
        InsidesReport: "İçeridekiler Raporu",
        InsidesReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          entryTime: "Giriş Zamanı",
          entryPoint: "Giriş Noktası",
          status: "Durumu"
        },
        OutsidesReport: "Dışarıdakiler Raporu",
        OutsidesReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          exitTime: "Çıkış Zamanı",
          exitPoint: "Çıkış Noktası",
          status: "Durumu"
        },
        VisitorsReport: "Ziyaretçiler Raporu",
        VisitorsReportHeaders: {
          citizenshipNumber: "Vatandaşlık No",
          nameSurname: "Ad Soyad",
          mobilePhone: "Cep Tel",
          where: "Kime",
          departmentName: "Departman",
          reasonForVisit: "Geliş Nedeni",
          visitedEmployeeInformation: "Ziyaret Edilen",
          cardIssueTime: "Kartın Verildiği Tarih",
          entryTime: "Giriş Zamanı",
          exitTime: "Çıkış Zamanı",
          cardName: "Kart Adı",
          description: "Açıklama"
        },
        InsideVisitorsReport: "İçerideki Ziyaretçiler Raporu",
        InsideVisitorsReportHeader: {
          citizenshipNumber: "Vatandaşlık No",
          nameSurname: "Ad Soyad",
          mobilePhone: "Cep Tel",
          where: "Kime",
          departmentName: "Departman",
          reasonForVisit: "Geliş Nedeni",
          visitedEmployeeInformation: "Ziyaret Edilen",
          cardIssueTime: "Kartın Verildiği Tarih",
          entryTime: "Giriş Zamanı",
          cardName: "Kart Adı",
          description: "Açıklama"
        },
        TimeBasedWorkReport: "Süre Bazlı Çalışma Raporu",
        TimeBasedWorkReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          startDate: "Başlangıç Tarihi",
          endDate: "Bitiş Tarihi",
          totalWorkedTime: "Çalışma Süresi",
          difference: "Fark"
        },
        FirstInLastOutReport: "İlk Giriş Son Çıkış Raporu",
        FirstInLastOutReportHeaders: {
          citizenshipNumber: "TC No",
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          department: "Departman",
          title: "Ünvan",
          status1: "Statü",
          workPlace: "Görev Yeri",
          workPlan: "Çalışma Grubu",
          date: "Tarih",
          firstEntry: "İlk Giriş",
          entryReader: "Giriş Okuyucu",
          lastExit: "Son Çıkış",
          exitReader: "Çıkış Okuyucu",
          status: "Durum",
          total: "Toplam Çalışma",
          missingHour: "Fark",
          earlyEntry: "Erken Gelme",
          lateEntry: "Geç Gelme",
          earlyExit: "Erken Çıkma",
          lateExit: "Geç Çıkma"
        },
        AllowenceReport: "İzinliler Raporu",
        AllowenceReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          startDate: "Başlangıç Tarihi",
          endDate: "Bitiş Tarihi",
          allowenceName: "İzin Adı"
        },
        WorkSummaryReport: "Çalışma Özeti Raporu",
        WorkSummaryReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          jobDays: "İş Günü",
          workDays: "Çalışma Günü",
          publicHoliday: "Resmi Tatil / İdari İzin",
          allowence: "İzin / Rapor",
          absentee: "Devamsızlık"
        },
        CompanyEmployeesStatusReport: "Birim Bazlı Sayı Raporu",
        CompanyEmployeesStatusReportHeaders: {
          unitName: "Birim Adı",
          employeeCount: "Personel Sayısı",
          continuedEmployeeCount: "Devam Eden Personel Sayısı",
          annualPermit: "Yıllık İzinliler",
          report: "Raporlular",
          administrativeLeave: "İdari İzinliler",
          freePermission: "Ücretsiz İzinliler",
          nonComers: "Gelmeyenler & Kart Okutmayanlar",
          missioned: "Geçici Görevlendirme",
          todayComers: "Kurumda Olanlar"
        },
        CustomCompanyEmployeesStatusReport: "Departman Bazlı Sayı Raporu",
        CustomCompanyEmployeesStatusReportHeaders: {
          unitName: "Birim Adı",
          employeeCount: "Personel Sayısı",
          continuedEmployeeCount: "Devam Eden Personel Sayısı",
          annualPermit: "Yıllık İzinliler",
          report: "Raporlular",
          administrativeLeave: "İdari İzinliler",
          freePermission: "Ücretsiz İzinliler",
          nonComers: "Gelmeyenler & Kart Okutmayanlar",
          missioned: "Geçici Görevlendirme",
          todayComers: "Kurumda Olanlar"
        },
        DepartmentSummaryReport: "İki Tarih Arası Departman Bazlı Sayı Raporu",
        DepartmentSummaryReportHeaders: {
          unitName: "Birim Adı",
          employeeCount: "Personel Sayısı",
          continuedEmployeeCount: "Devam Eden Personel Sayısı",
          annualPermit: "Yıllık İzinliler",
          report: "Raporlular",
          administrativeLeave: "İdari İzinliler",
          freePermission: "Ücretsiz İzinliler",
          nonComers: "Gelmeyenler & Kart Okutmayanlar",
          missioned: "Geçici Görevlendirme",
          todayComers: "Kurumda Olanlar"
        },
        PayrollReport: "Puantaj Raporu",
        DetailedPayrollReport: "Detaylı Puantaj Raporu",
        FoodCreditReport: "Yemekhane Yükleme Raporu",
        FoodCreditReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          date: "Tarih",
          debit: "Tutar",
          creditType: "Tipi",
          status: "Durum",
          userName: "Kullanıcı"
        },
        TemplatePayrollReport: "Puantaj Şablon-1 Raporu",
        TemplateMonthlyPayrollReport: "Aylık Puantaj Raporu",
        SalaryReport: "Maaş Raporu",
        InOutReport: "Giriş Çıkış Raporu",
        InOutReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          workPlace: "Görev Yeri",
          departmentName: "Departman",
          location: "Lokasyon",
          date: "Tarih",
          readerName: "Okuyucu"
        },
        DoorBasedLastMovementReport: "Kapı Bazlı Son Hareket Raporu",
        DoorBasedLastMovementReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          departmentName: "Departman",
          date: "Tarih",
          readerName: "Okuyucu",
          doorStatus: "Durum"
        },
        DoorsAuthorizationReport: "Kapı Bazlı Yetki Raporu",
        DoorsAuthorizationReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          departmentName: "Departman",
          accessGroup: "Yetki Grubu"
        },
        DormitoryInformationReport: "Yurtta Kalan Öğrenciler Raporu",
        DormitoryInformationReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          departmentName: "Departman",
          isSmsSend: "SMS Gönderimi",
          motherName: "Anne Adı",
          fatherName: "Baba Adı",
          smsPhone: "SMS Tel",
          validityDate: "Geçerlilik Tarihi",
          roomName: "Oda",
          floorName: "Kat",
          areaName: "Bölge"
        },
        DormitoryInsidesReport: "Yurt İçerideki Öğrenciler Raporu",
        DormitoryInsidesReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          departmentName: "Departman",
          lastMovementDate: "Son Hareket",
          lastMovementReader: "Okuyucu",
          status: "Durumu",
          isSmsSend: "SMS Gönderimi",
          motherName: "Anne Adı",
          fatherName: "Baba Adı",
          smsPhone: "SMS Tel",
          validityDate: "Geçerlilik Tarihi",
          roomName: "Oda",
          floorName: "Kat",
          areaName: "Bölge"
        },
        DormitoryOutsidesReport: "Yurt Dışarıdaki Öğrenciler Raporu",
        DormitoryOutsidesReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          departmentName: "Departman",
          lastMovementDate: "Son Hareket",
          lastMovementReader: "Okuyucu",
          status: "Durumu",
          isSmsSend: "SMS Gönderimi",
          motherName: "Anne Adı",
          fatherName: "Baba Adı",
          smsPhone: "SMS Tel",
          validityDate: "Geçerlilik Tarihi",
          roomName: "Oda",
          floorName: "Kat",
          areaName: "Bölge"
        },
        WeeklyPayrollReport: "Haftalık Puantaj Raporu",
        WeeklyPayrollReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Adı Soyadı",
          title: "Ünvan",
          departmentName: "Departman",
          workTime: "Çalışma Süresi",
          overTime: "Fazla Mesai",
          nightWorkTime: "Gece Zammı",
          status: "Ödenecek Mesai Saati"
        },
        EntryExitSnapshotReport: "Fotoğraflı Hareket Raporu",
        EntryExitSnapshotReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Adı Soyadı",
          title: "Ünvan",
          departmentName: "Departman",
          date: "Tarih",
          reader: "Okuyucu",
          photo: "Kişi Fotoğrafı",
          snapshot: "Olay Görüntüsü"
        },
        SaleReport: "Satış Raporu",
        SaleReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Adı Soyadı",
          price: "Ücret",
          date: "Tarih",
          user: "Kullanıcı",
          isRefund: "İade Durumu"
        },
        DetailedVisitorReport: "Detaylı Ziyaretçi Hareket Raporu",
        DetailedVisitorReportHeaders: {
          citizenshipNumber: "Vatandaşlık No",
          nameSurname: "Ad Soyad",
          mobilePhone: "Cep Tel",
          where: "Kime",
          departmentName: "Departman",
          reasonForVisit: "Geliş Nedeni",
          visitedEmployeeInformation: "Ziyaret Edilen",
          cardIssueTime: "Kartın Verildiği Tarih",
          entryTime: "Giriş Zamanı",
          exitTime: "Çıkış Zamanı",
          cardName: "Kart Adı",
          description: "Açıklama"
        },
        DepartmentBasedVisitorReport: "Departman Bazlı Ziyaretçi Raporu",
        DepartmentBasedVisitorReportHeaders: {
          departmentName: "Departman",
          total: "Toplam"
        },
        ShiftReport: "Vardiya Raporu",
        ShiftReportHeaders: {
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          title: "Ünvan",
          departmentName: "Departman",
          signature: "İmza",
          isSignatureColumnAdded: "İmza Kolonu Eklensin mi?"
        },
        VerticalFirstInLastOutReport: "Dikey İlk Giriş Son Çıkış",
        VerticalFirstInLastOutReportHeaders: {
          citizenshipNumber: "Vatandaşlık No",
          registrationNumber: "Sicil No",
          nameSurname: "Ad Soyad",
          status: "Statü",
          title: "Ünvan",
          departmentName: "Departman"
        }
      }
    },
    foodGroupOperations: {
      searchEmployeeInList: "Liste içinde kişi arayın",
      employeeList: "Kişi Listesi",
      employeeSearchNotFound: "Kişi kaydı bulunamadı.",
      employeeInfo: "Kişi Bilgileri",
      deletedRecord: "Silinmiş Kayıt",
      registrationNumber: "Sicil No",
      dateOfStartWork: "Başlama Tarihi",
      dateOfEndWork: "Çıkış Tarihi",
      passwordExist: "Şifre kaydı mevcut",
      passwordNotExist: "Şifre kaydı mevcut değil",
      cardNumberExist: "Kart numarası var",
      cardNumberNotExist: "Kart numarası mevcut değil",
      fingerprintExist: "Parmak izi kaydı var",
      fingerprintNotExist: "Parmak izi kaydı mevcut değil",
      faceTemplateExist: "Yüz izi kaydı var",
      faceTemplateNotExist: "Yüz izi kaydı mevcut değil",
      movements: "Yemekhane Hareketleri",
      foodGroup: "Yemek Grubu",
      retailSaleLogs: "Satış Hareketleri",
      newMovement: "Yemek Hareketi Ekle",
      newMovementWarningInfo: "Dikkat : Kişinin yemek grubu bilgisine göre yemek ücreti düşülür.",
      dateMovement: "Hareket Tarihi",
      readerMovement: "Okuyucu",
      diningHall: "Yemekhane",
      startDateMovements: "Başlangıç",
      endDateMovements: "Bitiş",
      searchMovements: "Listele",
      timeMovement: "Zaman",
      deviceMovement: "Geçiş Noktası",
      statusMovement: "Geçiş",
      price: "Ücreti",
      meal: "Öğün",
      manuelMovement: "Manuel Hareket",
      entryMovement: "Giriş",
      exitMovement: "Çıkış",
      passive: "Pasif",
      movementNotRecord: "Hareket kaydı bulunamadı.",
      remainingCredits: "Kalan Kontör",
      availableBalance: "Kalan Bakiye",
      addCredit: "Kontör Yükle",
      addBalance: "Bakiye Yükle",
      amountOfCredit: "Yüklenecek Kontör Miktarı",
      amountOfBalance: "Yüklenecek Bakiye Miktarı",
      foodBalanceLogs: "Yemek Bakiye Hareketleri",
      time: "Zaman",
      amount: "Miktar",
      type: "Tip",
      status: "Durum",
      foodBalanceLogNotRecord: "Bakiye hareket kaydı bulunamadı.",
      isContinueUpdateEmployeeFoodGroup: "Seçilen kişinin yemek grubu güncellenecektir. Devam edilsin mi?"
    },
    foodGroups: {
      foodGroupList: "Yemek Grubu Listesi",
      foodGroupNotRecord: "Yemek grubu kaydı bulunamadı.",
      foodGroupInformation: "Yemek Grubu Bilgisi",
      newFoodGroup: "Yeni Grup",
      groupName: "Grup Adı",
      groupType: "Grup Tipi",
      deserveType: "Hak Tipi",
      creditType: "Kontör Tipi",
      balanceType: "Bakiye Tipi",
      dailyMealEatingCount: "Günlük Yemek Yeme Adeti",
      meals: "Öğünler",
      mealDefinitions: "Öğün Tanımları",
      newMeal: "Yeni Öğün",
      mealNotFoundSelectedFoodGroups: "Seçilen yemek grubuna ait öğün bulunmuyor.",
      foodGroupUpdateIsContinue: "Seçilen yemek grubu güncellenecektir. Devam edilsin mi?",
      foodGroupSaveIsContinue: "Yeni yemek grubu kaydedilecektir. Devam edilsin mi?",
      foodGroupDeleteIsContinue: "Seçilen yemek grubu silinecektir. Devam edilsin mi?",
      addNewMeal: "Yeni Öğün Ekle",
      validDays: "Geçerli Günler",
      mealName: "Öğün Adı",
      startTime: "Başlangıç Zamanı",
      endTime: "Bitiş Zamanı",
      eatingCount: "Yemek Yeme Adeti",
      price: "Ücret",
      guestPrice: "Misafir Ücreti",
      mealNameDefinitions: "Öğün İsim Tanımları",
      mealNameList: "Öğün İsim Listesi",
      newMealName: "Yeni Öğün Adı",
      mealNameNotRecord: "Öğün adı kaydı bulunamadı."
    },
    extraFields: {
      extraFieldList: "Özel Alan Listesi",
      extraFieldNotRecord: "Özel alan kaydı bulunamadı.",
      extraFieldInfo: "Özel Alan Bilgisi",
      newGroup: "Yeni Özel Alan",
      groupName: "Özel Alan Adı",
      isContinueUpdate: "Seçilen özel alan güncellenecektir. Devam edilsin mi?",
      isContinueSave: "Yeni özel alan kaydedilecektir. Devam edilsin mi?",
      isContinueDelete: "Seçilen özel alan silinecektir. Devam edilsin mi?"
    },
    licensePlateRecognition: {
      searchLicensePlateInList: "Listeden plaka arayın",
      licensePlateList: "Plaka Listesi",
      licensePlateSearchNotFound: "Plaka kaydı bulunamadı.",
      licensePlateInfo: "Plaka Bilgileri",
      newLicensePlate: "Yeni Plaka",
      updateLicensePlate: "Plakayı Güncelle",
      saveLicensePlate: "Plakayı Kaydet",
      deleteLicensePlate: "Plakayı Sil",
      plateNumber: "Plaka Numarası",
      plateNumberExist: "Plaka numarası var",
      plateNumberNotExist: "Plaka numarası mevcut değil",
      employee: "Kişi",
      deviceList: "Terminal Listesi",
      selectAll: "Tümünü Seç",
      removeAll: "Tümünü Kaldır",
      sendToReader: "Okuyucuya Gönder",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      isContinueUpdateLicensePlate: "Seçilen plaka güncellenecektir. Devam edilsin mi?",
      isContinueSaveLicensePlate: "Yeni plaka kaydedilecektir. Devam edilsin mi?",
      isContinueDeleteLicensePlate: "Seçilen plaka silinecektir. Devam edilsin mi?"
    },
    departments: {
      departmentInfo: "Departman Bilgisi",
      newDepartment: "Yeni Departman",
      departmentName: "Departman Adı",
      mainDepartment: "Ana Departman",
      indexNumber: "Sıra Numarası",
      departmentList: "Departman Listesi",
      displayOnDashboard: "Kontrol Panelinde Göster",
      departmentNotRecord: "Departman kaydı bulunamadı.",
      isContinueDepartmentUpdate: "Seçilen departman güncellenecektir. Devam edilsin mi?",
      isContinueDepartmentSave: "Yeni departman kaydedilecektir. Devam edilsin mi?",
      isContinueDepartmentDelete: "Seçilen departman silinecektir. Devam edilsin mi?"
    },
    accessGroups: {
      accessGroupList: "Geçiş Grubu Listesi",
      accessGroupNotRecord: "Geçiş grubu kaydı bulunamadı.",
      accessGroupInfo: "Geçiş Grubu Bilgisi",
      newAccessGroup: "Yeni Geçiş Grubu",
      accessGroupName: "Geçiş Grubu Adı",
      addNewDevicesAutomatically: "Yeni Terminaller Otomatik Eklensin",
      authorizedDevices: "Yetkili Terminaller",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      applyTemplate: "Şablonu Uygula",
      isContinueAccessGroupUpdate: "Seçilen geçiş grubu güncellenecektir. Devam edilsin mi?",
      isContinueAccessGroupSave: "Yeni geçiş grubu kaydedilecektir. Devam edilsin mi?",
      isContinueAccessGroupDelete: "Seçilen geçiş grubu silinecektir. Devam edilsin mi?"
    },
    workPlans: {
      workPlanList: "Çalışma Plan Listesi",
      period: "Periyod",
      singlePlan: "Tekli Çalışma",
      workPlanNotRecord: "Çalışma planı kaydı bulunamadı.",
      workPlanInfo: "Çalışma Planı Bilgisi",
      workPlanModel: "Çalışma Planı Modeli",
      newWorkPlan: "Yeni Çalışma Planı",
      defaultWorkPlanModel: "Varsayılan Çalışma Planı Modeli",
      workGroupModel: "Çalışma Grubu Modeli",
      hourBasedPlanningModel: "Saat Bazlı Çalışma Modeli",
      freelanceModelWithHourlyInterval: "Saat Bazlı Serbest Çalışma Modeli",
      plan1Title: "Standart çalışmalar ve dönüşümlü vardiyalar",
      plan1Description: "Gün bazlı saat aralıkları girerek plan detaylarını oluşturun.",
      plan2Title: "Plansız dönüşümlü vardiya olan yerler",
      plan2Description: "Oluşturulan çalışma planlarını gruplandırarak otomatik olarak algılanmasını sağlar.",
      plan3Title: "Mağazacılık Sektörü",
      plan3Description: "Sadece giriş çıkış saatlerini ve uygulanacak toleransları planlayın.",
      plan4Title: "Saat sınırlaması olmayan yerler",
      plan4Description: "Toplam çalışılması gereken saati ve mola süresi girerek planlayın.",
      details: "Detaylar",
      settings: "Ayarlar",
      plan: "Plan",
      calculateBasedOnFirstEntryAndLastExit: "İlk giriş ve son çıkışı baz alarak hesapla (aradaki hesaplar baz alınmaz)",
      shortCode: "Kısa Kodu",
      workPlanName: "Çalışma Planı Adı",
      entryTime: "Giriş",
      exitTime: "Çıkış",
      tolerances: "Toleranslar",
      earlyEntryTolerance: "Erken Giriş Toleransı",
      earlyExitTolerance: "Erken Çıkış Toleransı",
      lateEntryTolerance: "Geç Giriş Toleransı",
      lateExitTolerance: "Geç Çıkış Toleransı",
      mealBreakTime: "Yemek Molası",
      mealStartTime: "Yemek Başlangıç",
      mealEndTime: "Yemek Bitiş",
      totalMealTime: "Toplam Yemek Zamanı",
      totalWorkTime: "Toplam Çalışma Zamanı",
      breakTolerances: "Mola Toleransları",
      createSettingsForDeservedBreaks: "Hakedilen molalar için ayar oluşturun.",
      forHourlyWork: "saatlik çalışma için",
      break: "mola",
      hourlyWork: "Saatlik İş",
      breakTolerance: "Mola Toleransı",
      notRecord: "Kayıt seçilmedi.",
      durationOfAbsence: "Devamsızlıkta Kesilecek Süre",
      skipTheDayTime: "Gün Atlatma Zamanı",
      solsticeTime: "Gün Dönüm Zamanı",
      maxLimit: "Üst Sınır",
      minLimit: "Alt Sınır",
      basedOnEntryDay: "Giriş yapılan günü esas al",
      checkTheDoors: "Kapı kontrolü yap",
      payrollDetails: "Puantaj Detayları",
      toleranceToReduceTheSameMovementsToOne: "Aynı Hareketleri Teke İndirme Toleransı",
      includeDifferentDoorsInDeleting: "Farklı kapıları silmeye dahil et",
      dontDeleteConfirmedOvertimes: "Onaylanan fazla mesaileri silme",
      selectThePlansYouWantToIncludeInTheGroup: "Gruba dahil etmek istediğiniz planları seçin.",
      currentDefinitionBetweenSelectedHours: "Seçilen saatler için geçerli puantaj",
      whenItDoesntComePerceiveItAsADeserved: "Gelmediğinde hakediş olarak algıla",
      start: "Başlangıç",
      end: "Bitiş",
      payrollType: "Puantaj Tipi",
      deserve: "Hakediş",
      planType: "Plan Tipi",
      periodDistribution: "Periyod Dağılımı",
      periodStartDate: "Periyod Başlangıç Tarihi",
      allowence: "İZİN",
      day: "Gün",
      name: "Adı",
      dayCount: "Gün Sayısı",
      isContinueWorkPlanUpdate: "Seçilen çalışma planı güncellenecektir. Devam edilsin mi?",
      isContinueWorkPlanSave: "Yeni çalışma planı kaydedilecektir. Devam edilsin mi?",
      isContinueWorkPlanDelete: "Seçilen çalışma planı silinecektir. Devam edilsin mi?"
    },
    overtimeDefinitions: {
      overtimePlaces: "Fazla Mesai Yerleri",
      overtimePlaceNotRecord: "Fazla mesai yeri kaydı bulunamadı.",
      overtimeDescriptions: "Fazla Mesai Nedenleri",
      overtimeDescriptionNotRecord: "Fazla mesai nedeni kaydı bulunamadı.",
      newOvertimePlaceDefinition: "Yeni Fazla Mesai Yeri Tanımı",
      overtimePlaceName: "Fazla Mesai Yeri Adı",
      overtimePlaceUpdate: "Fazla Mesai Yeri Güncelle",
      isContinueOvertimePlaceDelete: "Seçilen fazla mesai yeri kaydı silinecektir. Devam edilsin mi?",
      newOvertimeDescriptionDefinition: "Yeni Fazla Mesai Nedeni Tanımı",
      overtimeDescriptionName: "Fazla Mesai Neden Adı",
      overtimeDescriptionUpdate: "Fazla Mesai Nedeni Güncelle",
      isContinueOvertimeDescriptionDelete: "Seçilen fazla mesai nedeni silinecektir. Devam edilsin mi?"
    },
    allowences: {
      allowenceList: "İzin Listesi",
      allowenceNotRecord: "İzin kaydı bulunamadı.",
      allowenceInfo: "İzin Bilgisi",
      newAllowence: "Yeni İzin",
      shortCode: "Kısa Kodu",
      allowenceName: "İzin Adı",
      monthlyPayrollColumn: "Aylık Puantaj Kolonu",
      dailyPayrollColumn: "Günlük Puantaj Kolonu",
      fullWorkTimeInDay: "Tam Gün Süresi",
      color: "Renk",
      isContinueAllowenceUpdate: "Seçilen izin güncellenecektir. Devam edilsin mi?",
      isContinueAllowenceSave: "Yeni izin kaydedilecektir. Devam edilsin mi?",
      isContinueAllowenceDelete: "Seçilen izin silinecektir. Devam edilsin mi?"
    },
    inventoryManagement: {
      inventoryCategories: "Demirbaş Kategorileri",
      inventoryCategoryInfo: "Kategori Bilgisi",
      newInventoryCategory: "Yeni Kategori",
      inventoryCategoryName: "Kategori Adı",
      inventoryCategoryList: "Kategori Listesi",
      inventoryCategoryNotRecord: "Demirbaş kategori kaydı bulunamadı.",
      isContinueInventoryCategoryUpdate: "Seçilen demirbaş kategori güncellenecektir. Devam edilsin mi?",
      isContinueInventoryCategorySave: "Yeni demirbaş kategori kaydedilecektir. Devam edilsin mi?",
      isContinueInventoryCategoryDelete: "Seçilen demirbaş kategori silinecektir. Devam edilsin mi?",
      inventoryWarehouses: "Demirbaş Depoları",
      inventoryWarehouseInfo: "Depo Bilgisi",
      newInventoryWarehouse: "Yeni Depo",
      inventoryWarehouseName: "Depo Adı",
      inventoryWarehouseList: "Depo Listesi",
      inventoryWarehouseNotRecord: "Demirbaş depo kaydı bulunamadı.",
      isContinueInventoryWarehouseUpdate: "Seçilen demirbaş depo güncellenecektir. Devam edilsin mi?",
      isContinueInventoryWarehouseSave: "Yeni demirbaş depo kaydedilecektir. Devam edilsin mi?",
      isContinueInventoryWarehouseDelete: "Seçilen demirbaş depo silinecektir. Devam edilsin mi?",
      inventoryFieldList: "Özellik Listesi",
      inventoryFieldInfo: "Özellik Bilgisi",
      newInventoryField: "Yeni Özellik",
      inventoryFieldName: "Özellik Adı",
      inventoryFieldNotRecord: "Demirbaş özellik kaydı bulunamadı.",
      isContinueInventoryFieldUpdate: "Seçilen demirbaş özelliği güncellenecektir. Devam edilsin mi?",
      isContinueInventoryFieldSave: "Yeni demirbaş özelliği kaydedilecektir. Devam edilsin mi?",
      isContinueInventoryFieldDelete: "Seçilen demirbaş özelliği silinecektir. Devam edilsin mi?",
      inventoryList: "Demirbaş Listesi",
      inventoryInfo: "Demirbaş Bilgisi",
      newInventory: "Yeni Demirbaş",
      inventoryName: "Adı",
      inventoryCode: "Kodu",
      inventorySerialNo: "Seri No",
      inventoryCategory: "Kategori",
      inventoryDefaultWarehouse: "Depo",
      quantity: "Adet",
      documentType: "Belge Tipi",
      documentDescription: "Belge Açıklaması",
      newDocument: "Yeni Belge",
      editDocument: "Belgeyi Düzenle",
      deleteDocument: "Belgeyi Sil",
      addDocumentFile: "Belge Ekle",
      selectPhoto: "Fotoğraf Seç",
      removePhoto: "Fotoğrafı Kaldır",
      allCategories: "Tüm Kategoriler",
      inventoryNotRecord: "Demirbaş kaydı bulunamadı.",
      isContinueInventoryUpdate: "Seçilen demirbaş güncellenecektir. Devam edilsin mi?",
      isContinueInventorySave: "Yeni demirbaş kaydedilecektir. Devam edilsin mi?",
      isContinueInventoryDelete: "Seçilen demirbaş silinecektir. Devam edilsin mi?"
    },
    workPlaceDefinitions: {
      workPlaceList: "Görev Yeri Listesi",
      workPlaceNotRecord: "Görev yeri kaydı bulunamadı.",
      workPlaceInfo: "Görev Yeri Bilgisi",
      newWorkPlace: "Yeni Görev Yeri",
      workPlaceName: "Görev Yeri Adı",
      workPlaceUpdate: "Görev Yeri Güncelle",
      isContinueWorkPlaceUpdate: "Seçilen görev yeri güncellenecektir. Devam edilsin mi?",
      isContinueWorkPlaceSave: "Yeni görev yeri kaydedilecektir. Devam edilsin mi?",
      isContinueWorkPlaceDelete: "Seçilen görev yeri silinecektir. Devam edilsin mi?"
    },
    documentDefinitions: {
      documentDefinitionList: "Belge Tanımları Listesi",
      documentDefinitionNotRecord: "Belge tanımı kaydı bulunamadı.",
      documentDefinitionInfo: "Belge Tanımı Bilgisi",
      newDocumentDefinition: "Yeni Belge Tanımı",
      documentDefinitionName: "Belge Adı",
      isContinueDocumentDefinitionUpdate: "Seçilen belge tanımı güncellenecektir. Devam edilsin mi?",
      isContinueDocumentDefinitionSave: "Yeni belge tanımı kaydedilecektir. Devam edilsin mi?",
      isContinueDocumentDefinitionDelete: "Seçilen belge tanımı silinecektir. Devam edilsin mi?"
    },
    annualPermitGroups: {
      annualPermitGroupList: "Yıllık İzin Grup Listesi",
      annualPermitGroupNotRecord: "Yıllık izin grupları bulunamadı.",
      annualPermitGroupInfo: "Yılık İzin Grubu Bilgisi",
      newAnnualPermitGroup: "Yeni Yıllık İzin Grubu",
      groupName: "Grup Adı",
      start: "Başlangıç",
      end: "Bitiş",
      deservedDay: "Hakedilen Gün",
      annualPermitGroupDetailNotRecord: "Yıllık izin grubu detayı bulunamadı.",
      isContinueAnnualPermitGroupUpdate: "Seçilen yıllık izin güncellenecektir. Devam edilsin mi?",
      isContinueAnnualPermitGroupSave: "Yeni yıllık izin kaydedilecektir. Devam edilsin mi?",
      isContinueAnnualPermitGroupDelete: "Seçilen yıllık izin silinecektir. Devam edilsin mi?"
    },
    scenarios: {
      newScenario: "Yeni Senaryo",
      scenarioDetails: "Senaryo Detayları",
      backToScenarios: "Senaryolara Dön",
      scenarioRecordNotFound: "Senaryo kaydı bulunamadı."
    },
    devices: {
      searchDeviceInList: "Listeden terminal arayın...",
      deviceList: "Liste",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      deviceInfo: "Terminal Bilgisi",
      newDevice: "Yeni Terminal",
      deviceNumber: "Terminal No",
      serialNo: "Seri No",
      brand: "Markası",
      platform: "Platform",
      feature: "Özellik",
      card: "Kart",
      isPanel: "Panel",
      fingerprint: "Parmak İzi",
      faceRecognition: "Yüz Tanıma",
      hasAntipassback: "Antipassback",
      hasTimeZone: "Zaman Sınırlaması",
      isRealTime: "Canlı İzle",
      isOnlineDevice: "Online Kontrol",
      deviceName: "Terminal Adı",
      ipAddress: "Ip Adresi",
      port: "Port",
      adminPassword: "Admin Şifresi",
      deviceGroup: "Terminal Grubu",
      status: "Durumu",
      readerInformation: "Okuyucu Bilgileri",
      readerList: "Okuyucular",
      newReader: "Yeni Okuyucu",
      selectedDeviceReaderNotFound: "Seçilen terminale ait okuyucu bulunamadı.",
      readerNo: "No",
      readerName: "Okuyucu Adı",
      inputName: "Kapı Adı",
      isMainDoor: "Ana Kapı",
      typeOfUse: "Kullanım Tipi",
      access: "Access",
      pdks: "PDKS",
      diningHall: "Yemekhane",
      licencePlateRecognition: "Plaka Tanıma",
      dormitoryDevice: "Yurt Terminali",
      bellOrAlarm: "Zil & Alarm",
      readerStatus: "Durum",
      entry: "Giriş",
      exit: "Çıkış",
      readerInfo: "Okuyucu kaydetmek için önce terminal kaydedin veya listeden bir seçim yapın.",
      isContinueDeviceUpdate: "Seçilen terminal güncellenecektir. Devam edilsin mi?",
      isContinueDeviceSave: "Yeni terminal kaydedilecektir. Devam edilsin mi?",
      isContinueDeviceDelete: "Seçilen terminal silinecektir. Devam edilsin mi?",
      isContinueReaderUpdate: "Seçilen okuyucu güncellenecektir. Devam edilsin mi?",
      isContinueReaderSave: "Yeni okuyucu kaydedilecektir. Devam edilsin mi?",
      isContinueReaderDelete: "Seçilen okuyucu silinecektir. Devam edilsin mi?"
    },
    deviceOperations: {
      addTask: "Görev Ekle",
      deviceNotRecord: "Terminal kaydı bulunamadı.",
      startTime: "Başlangıç Zamanı",
      selectTask: "İşlem Seçiniz",
      getMovementLogs: "Bilgi topla",
      personSetAndDelete: "Kişi gönder / sil",
      getPersons: "Kişileri Al",
      sendBatchPersonData: "Kişileri toplu gönder",
      updateTime: "Zaman güncelle",
      restart: "Yeniden başlat",
      removeAdminAuthorizes: "Admin yetkilerini kaldır",
      removeAllPerson: "Tüm kişileri sil",
      sendAuthorityGroups: "Yetki gruplarını gönder",
      sendPlate: "Plaka gönder",
      sendBatchPlates: "Toplu plaka gönder",
      repeatDaily: "Günlük Tekrar",
      applyRepeatDaily: "Günlük tekrar etsin",
      repetitionInterval: "Tekrarlama Aralığı",
      oneTimePerDay: "günde 1 kez",
      sendCommand: "Komutu Gönder",
      activeTaskList: "Aktif Görev Listesi",
      person: "Geçerli Kişi",
      task: "İşlem",
      device: "Terminal",
      taskTime: "İşlem Zamanı",
      repeatDay: "Tekrar (Gün)",
      noRepeat: "Tekrar Yok",
      activeTaskNotRecord: "Aktif görev kaydı bulunamadı.",
      isContinueTaskDelete: "Seçilen görev silinecektir. Devam edilsin mi?"
    },
    companySettings: {
      companies: "Şirketler",
      newCompany: "Yeni Şirket",
      companyNotRecord: "Şirket kaydı bulunamadı.",
      companyLogo: "Şirket Logo",
      selectPhoto: "Fotoğraf Seç",
      visitorSettings: "Ziyaretçi Takip Ayarları",
      cardIsNotUsedAccessGroup: "Kart Kullanım Dışıyken Geçiş Grubu",
      cardIsUsedAccessGroup: "Kart Kullanımdayken Geçiş Grubu",
      companyInformation: "Şirket Bilgileri",
      companyName: "Şirket Adı",
      companyTitle: "Şirket Ünvanı",
      phone: "Telefon",
      webSite: "Web Site",
      address: "Adres",
      syncRegistrationNoToDeviceNo: "Sicil numarasını terminal numarasına eşitle",
      isContinueCompanyUpdate: "Seçilen şirket güncellenecektir. Devam edilsin mi?",
      isContinueCompanySave: "Yeni şirket kaydedilecektir. Devam edilsin mi?",
      isContinueCompanyDelete: "Seçilen şirket silinecektir. Devam edilsin mi?"
    },
    users: {
      users: "Kullanıcılar",
      newUser: "Yeni Kullanıcı",
      userNotRecord: "Kullanıcı kaydı bulunamadı.",
      userPhoto: "Kullanıcı Fotoğrafı",
      selectPhoto: "Fotoğraf Seç",
      companyAuthorities: "Yetkili Şirketler",
      companyNotRecord: "Şirket kaydı bulunamadı.",
      userInformation: "Kullanıcı Bilgileri",
      userName: "Kullanıcı Adı",
      userTitle: "Kullanıcı Ünvanı",
      email: "E-posta",
      authorityGroup: "Yetki Grubu",
      password: "Parola",
      repeatPassword: "Tekrar Parola",
      realTimeMonitorGroup: "Canlı İzleme Grubu",
      visitorCardGroup: "Varsayılan Ziyaretçi Kart Grubu",
      activateSmsSystem: "SMS Onayı",
      phoneNumber: "Telefon Numarası",
      departmentNotRecord: "Departman kaydı bulunamadı.",
      reportAuthorities: "Rapor Yetkileri",
      reportNotRecord: "Rapor kaydı bulunamadı.",
      isContinueUserUpdate: "Seçilen kullanıcı güncellenecektir. Devam edilsin mi?",
      isContinueUserSave: "Yeni kullanıcı kaydedilecektir. Devam edilsin mi?",
      isContinueUserDelete: "Seçilen kullanıcı silinecektir. Devam edilsin mi?",
      realTimeMonitorGroups: "Canlı İzleme Grupları",
      realTimeMonitorGroupList: "Canlı İzleme Grup Listesi",
      newRealTimeMonitorGroup: "Yeni Canlı İzleme Grubu",
      realTimeMonitorGroupNotRecord: "Canlı izleme grubu kaydı bulunamadı.",
      groupName: "Grup Adı",
      deviceNotRecord: "Terminal kaydı bulunamadı."
    },
    userAuthorityGroups: {
      userAuthorityGroupList: "Yetki Grupları",
      userAuthorityGroupNotRecord: "Kullanıcı yetki grubu bulunamadı.",
      userAuthorityGroupInformation: "Kullanıcı Yetki Grubu Bilgisi",
      newAuthorityGroup: "Yeni Yetki Grubu",
      authorityGroupName: "Yetki Grubu Adı",
      description: "Açıklama",
      admin: "Admin",
      user: "Kullanıcı",
      authorityInfo: "Seçim yapılmaz ise tam yetkiye sahip olur.",
      authorities: "İşlem Yetkileri",
      filterAuthorities: "Filtre Yetkileri",
      fullAuthority: "Tam Yetki",
      onlyView: "Sadece Görebilir",
      cantUse: "Kullanamaz",
      isContinueUserAuthGroupUpdate: "Seçilen yetki grubu güncellenecektir. Devam edilsin mi?",
      isContinueUserAuthGroupSave: "Yeni yetki grubu kaydedilecektir. Devam edilsin mi?",
      isContinueUserAuthGroupDelete: "Seçilen yetki grubu silinecektir. Devam edilsin mi?"
    },
    mailSmsSettings: {
      mailSettings: "Mail Ayarları",
      smsSettings: "SMS Ayarları",
      automaticMailList: "Otomatik Mail Listesi",
      mailDetails: "Mail Detayı",
      newMailDefinition: "Yeni Mail Tanımı",
      mailDefinitionName: "Tanım Adı",
      mailHeader: "Mail Konusu",
      mailContent: "Mail İçeriği",
      reportType: "Rapor Tipi",
      mailSendingTime: "Gönderim Zamanı",
      day: "Gün",
      time: "Saat",
      reportsToSubmit: "Gönderilecek Raporlar",
      byCustomFilter: "Özel Filtreye Göre",
      emailAddressesToSend: "Gönderilecek E-posta Adresleri",
      enterAEmail: "E-posta adresi girin",
      filterGroup: "Geçerli Filtre Grubu",
      byAuthorizedEmployees: "Sorumlu Kişilere Göre",
      authorizedEmployees: "Sorumlu Kişiler",

      smsAPIRecordInformation: "SMS API Kayıt Bilgileri",
      requestSentLink: "İstek Gönderilen Bağlantı",
      title: "Başlık",
      apiKey: "API Anahtarı",
      secretKey: "Gizli Anahtar",
      userName: "Kullanıcı Adı",
      password: "Parola",
      smsSystem: "SMS Sistemi",
      active: "Aktif",
      dormitorySMSSettings: "SMS Ayarları",
      smsType: "SMS Tipi",
      smsContentDescription1: "Öğrenci belirtilen saatte giriş yapmadığında gönderilecek içerik",
      smsContentDescription2: "Öğrenci geç giriş yaptığında gönderilecek içerik",
      smsContentDescription3: "Öğrenci izinsiz çıkış yaptığında gönderilecek içerik",
      smsContentDescription4: "Öğrenciye izin verildiğinde veliyi bilgilendiren içerik",
      parameters: "Parametreler",
      studentName: "Öğrenci Adı",
      todaysDate: "Bugünün Tarihi",
      movementDate: "Hareket Tarihi",
      movementTime: "Hareket Saati",
      allowenceStartDate: "İzin Başlangıç Tarihi",
      allowenceEndDate: "İzin Bitiş Tarihi",
      allowenceName: "İzin Adı",
      dormitorySMSTimePlan: "Saat Planı",
      lastEntryTime: "Son Giriş Zamanı",
      updateInformation: "Bilgileri Güncelle"
    },
    userLogs: {
      user: "Kullanıcı",
      userLogList: "Kullanıcı İşlem Listesi",
      userLogs: "Kullanıcı İşlem Kayıtları",
      userName: "Kullanıcı Adı",
      logTime: "İşlem Zamanı",
      logDescription: "İşlem Açıklaması",
      logNotRecord: "Kullanıcı işlem kaydı bulunamadı."
    },
    payrollTypes: {
      payrollTypeList: "Puantaj Tipi Listesi",
      payrollTypeNotRecord: "Puantaj tipi kaydı bulunamadı.",
      payrollTypeInfo: "Puantaj Tipi Bilgisi",
      newPayrollType: "Yeni Puantaj Tipi",
      shortCode: "Kısa Kodu",
      payrollName: "Puantaj Adı",
      payrollType: "Puantaj Tipi",
      payrolls: {
        normalWork: "Normal Çalışma",
        weekendHoliday: "Hafta Tatili",
        publicHoliday: "Resmi Tatil",
        annualPermit: "Yıllık İzin",
        absenteeism: "Devamsızlık",
        missingHour: "Eksik Saat",
        allowence: "İzin",
        overtime: "Fazla Mesai",
        break: "Ara Dinlenme",
        nightOvertime: "Gece Zammı"
      },
      otherPayrollType: "Diğer Puantaj Tipi",
      equalPayrollType: "Eşit Puantaj Tipi",
      monthlyPayrollColumn: "Aylık Puantaj Kolonu",
      maxLimit: "Max Limit",
      multiplier: "Çarpan",
      confirmation: "Onay",
      confirmationRequired: "Onay Gerekli",
      tolerances: "Yuvarlamalar",
      firstTolerance: "İlk",
      lastTolerance: "Son",
      totalTolerance: "Toplam",
      isContinuePayrollTypeUpdate: "Seçilen puantaj tipi güncellenecektir. Devam edilsin mi?",
      isContinuePayrollTypeSave: "Yeni puantaj tipi kaydedilecektir. Devam edilsin mi?",
      isContinuePayrollTypeDelete: "Seçilen puantaj tipi silinecektir. Devam edilsin mi?"
    },
    monthlyPayrollTables: {
      monthlyPayrolColumnlList: "Aylık Puantaj Listesi",
      monthlyPayrollTableRecordNotFound: "Aylık puantaj tablosu kaydı bulunamadı.",
      monthlyPayrollInfo: "Aylık Puantaj Bilgisi",
      newMonthlyPayroll: "Yeni Aylık Puantaj",
      shortCode: "Kısa Kodu",
      payrollColumnName: "Puantaj Kolonu Adı",
      ssk: "SSK",
      total: "Toplam",
      work: "Çalışma",
      isContinueMonthlyPayrollUpdate: "Seçilen aylık puantaj güncellenecektir. Devam edilsin mi?",
      isContinueMonthlyPayrollSave: "Yeni aylık puantaj kaydedilecektir. Devam edilsin mi?",
      isContinueMonthlyPayrollDelete: "Seçilen aylık puantaj silinecektir. Devam edilsin mi?"
    },
    integration: {
      triggerTransfers: "Aktarımları Tetikle"
    },
    support: {
      whatWouldYouLikeSupportOn: "Hangi konuda destek almak istersiniz?",
      subjectYouWantHelpWith: "Destek almak istediğiniz konu",
      searchResults: "Arama Sonuçları",
      noRecordFound: "Sonuç bulunamadı."
    },
    guardTour: {
      guards: "Görevliler",
      newGuard: "Yeni Görevli",
      guardInfo: "Görevli Bilgisi",
      nameSurname: "Ad Soyad",
      title: "Ünvan",
      updatePassword: "Parolayı Güncelle",
      responsibleUserForGuard: "Görevliden Sorumlu Kullanıcı",
      tourCalendar: "Tur Takvimi",
      newCalendar: "Yeni Takvim"
    }
  }), new __WEBPACK_IMPORTED_MODULE_1_vue_multilanguage__["MLanguage"]('English').create({
    title: 'Hello {0}!',
    general: {
      addNew: "Add New",
      select2: "Select",
      select: "Select",
      notSelected: "Not Selected",
      selected: "Selected",
      notChanged: "Not Changed",
      exportToPdfOrPrint: "Export PDF / Print",
      exportToExcel: "Export to Excel",
      active: "Active",
      passive: "Passive",
      isActive: "Record is Active?",
      view: "View",
      remove: "Remove",
      all: "All",
      selectAll: "Select All",
      removeAll: "Remove All",
      add: "Add",
      added: "Added",
      close: "Close",
      done: "Done",
      doorOpen: "Door Open",
      doorIsClosed: "Door is Closed",
      connected: "Connected",
      notConnected: "Not Connected",
      refreshScreen: "Refresh Screen",
      removed: "Removed",
      cancel: "Cancel",
      save: "Save",
      update: "Update",
      credit: "Credit",
      balance: "Balance",
      delete: "Delete",
      apply: "Apply",
      confirm: "Confirm",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
      search: "Search",
      viewQRCode: "View QR Code",
      qRCodeBarcodePrint: "Print QR Code & Barcode",
      qrSettings: "QR Settings",
      qrSize: "Size",
      print: "Print",
      upload: "Upload",
      download: "Download"
    },
    shared: {
      myProfile: "My Profile",
      company: "Company",
      languageOptions: "Language Options",
      changeLanguageInfo: "Select the language you want to change.",
      licenceErrorTitle: "Licence Error",
      licenceError: "Invalid Licence Key!",
      softwareKey: "Software Key",
      softwareKeyDescription: "Forward this code to your company of purchase.",
      enterLicenceKey: "Enter Licence Key",
      licenceKeyDescription: "Enter your license number for the product you have purchased.",
      saveLicenceKey: "Save Licence Key",
      wrongLicenceKey: "Please enter a valid licence key",
      saveLicenceKeySuccessfully: "Licence key save completed successfully!",
      licenceAddTerminalMaxCount: "Maximum number of terminals that can be added to your existing license",
      licenceTerminalDescription: "You need to upgrade your license to add a new terminal. Please contact your reseller to upgrade your license.",
      theme: "Theme",
      themes: {
        blue: "Blue",
        black: "Black",
        purple: "Purple",
        green: "Green",
        red: "Red",
        yellow: "Yellow",
        blueLight: "Blue Light",
        blackLight: "Black Light",
        purpleLight: "Purple Light",
        greenLight: "Green Light",
        redLight: "Red Light",
        yellowLight: "Yellow Light"
      },
      manufacturerInformation: "Manufacturer Information",
      copyright: "Copyright",
      allRightsReserved: "All rights reserved.",
      version: "Version",
      notifications: "Notifications",
      deviceCommunication: "Device Communication",
      notificationNotFound: "Notification not found for user.",
      notificationView: "Total notifications viewed :",
      logOut: "Logout",
      dashboard: "Dashboard",
      realTimeMonitor: "Real Time Monitor",
      employees: "Employees",
      visitors: "Visitors",
      visitorCards: "Visitor Cards",
      visitorReports: "Visitor Reports",
      batchOperations: "Batch Operations",
      reports: "Reports",
      payrollManagement: "Payroll Management",
      shiftManagement: "Shift Management",
      shiftSettings: "Shift Settings",
      studentTransactions: "Student Dormitories",
      areas: "Areas",
      diningHall: "Dining Hall",
      retailSale: "Retail Sale",
      employeeOperations: "Employee Operations",
      foodGroups: "Food Groups",
      diningHallReports: "Dining Hall Reports",
      guardTourSystem: "Guard Tour Control",
      guards: "Guards",
      points: "Points",
      tours: "Tours",
      guardTourReports: "Guard Tour Reports",
      definitions: "Definitions",
      cardDesignTemplates: "Card Templates",
      extraFields: "Custom Fields",
      licensePlateRecognition: "License Plate Recognition",
      departments: "Departments",
      accessGroups: "Access Groups",
      workPlans: "Work Plans",
      overtimeDefinitions: "Overtime Definitions",
      allowences: "Allowences",
      annualPermitGroups: "Annual Permit Groups",
      scenarioList: "Scenario List",
      timeZones: "Time Zones",
      devices: "Devices",
      deviceOperations: "Device Operations",
      settings: "Settings",
      companySettings: "Company Settings",
      users: "Users",
      userAuthorityGroups: "Authority Groups",
      mailSmsSettings: "Mail & SMS Settings",
      userLogs: "User Logs",
      payrollTypes: "Payroll Types",
      monthlyPayrollTables: "Monthly Payroll Tables",
      integration: "Integration",
      support: "Support",
      appAbout: "App About",
      workPlaceDefinitions: "Work Place Definitions",
      inventoryManagement: "Inventory Management",
      inventoryCategories: "Inventory Categories",
      inventoryWarehouses: "Inventory Warehouses",
      inventoryFields: "Inventory Fields",
      documentDefinitions: "Document Definitions"
    },
    filters: {
      filterEmployees: "Employees Filter",
      filterNameSurnameOrCardNo: "Name Surname / Card No",
      filterCitizenshipNumber: "Citizenship No",
      filterRegistrationOrDeviceNo: "Registration No / Device No",
      filterDocumentNoOrEmail: "Email",
      filterTitle: "Title",
      filterState: "State",
      filterStatus: "Status",
      filterAccessGroup: "Access Group",
      filterWorkPlan: "Work Plan",
      filterFoodGroup: "Food Group",
      filterAllowence: "Allowence",
      filterDepartments: "Departments",
      filterDepartmentNotRecord: "No department record found.",
      filterDeleted: "Deleted",
      filterNotShow: "Not Show",
      filterVisitorCards: "Visitor Cards",
      filterShow: "Show",
      filterSelectExtraFields: "Select Custom Field",
      filterCancel: "Cancel",
      filterClear: "Clear",
      filterApply: "Filter Apply",
      filterValue: "Value",
      filterComplete: "Complete",
      filterPlateNo: "Plate No",
      searchEmployeeFromList: "Search employee from list...",
      employeeList: "Employee List",
      employeeNotRecord: "No employee record found."
    },
    alerts: (_alerts2 = {
      fileSizeIsTooHigh: "File size is too high...",
      pleaseCheckTheFileFormat: "Please check the file format...",
      pleaseSelectFile: "Please select a file...",
      pleaseSelectADocumentDefinition: "Please select a document type",
      fileUploadSuccessfull: "File uploaded successfully!",
      departmentAndMainDepartmentOverlap: "Department and main department overlap...",
      wrongEmail: "Please enter a valid email",
      wrongEmailOrUsername: "Please enter a valid email or username",
      wrongPassword: "Please check your password",
      undefinedUser: "Undefined user",
      userNotFound: "User not found",
      salaryNameNotBlank: "Payment & deduction name cannot be blank...",
      savedSuccessfully: "Saved successfully!",
      updatedSuccessfully: "Updated successfully!",
      deletedSuccessfully: "Deleted successfully!",
      visitorCardGroupNameNotBlank: "Card group name cannot be blank...",
      statusNameNotBlank: "Status name cannot be blank...",
      stateNameNotBlank: "State name cannot be blank...",
      selectedDayNotMissingHour: "No missing hours for the selected day",
      invalidDate: "Please enter a valid date...",
      notSelectedReader: "Please select a reader...",
      cannotCreateMovementInTheFuture: "You cannot create a movement for the future movements...",
      getReadersError: "Error get readers...",
      creditNotBlank: "Please enter a credit...",
      commandSendToReaderSuccessfully: "Command send to reader successfully!",
      commandSentToDevicesSuccessfully: "Authorization commands sent to terminals successfully!",
      getUserInfoFromTerminalsSuccessfully: "Contact information from terminals successfully requested!",
      getFaceTemplateFromSuccessfully: "Face template information of the employee was successfully requested from the terminals!",
      getFingerprintFromUsbReader: "Fingerprint information of the employee was successfully requested from the usb reader!",
      getFingerprintsFromTerminalsSuccessfully: "Fingerprint information of the employee was successfully requested from the terminals!",
      confirmedOvertimeCannotBeGreaterThanCalculated: "Confirmed overtime cannot be greater than calculated...",
      selectedEmployeeNotBlank: "Please select employee...",
      selectedReportNotBlank: "Please select report...",
      invalidPrice: "Please check the amount...",
      invalidSalaryType: "Please select payment & deduction...",
      employeeRegistrationNumberNotBlank: "Registration number cannot be blank...",
      employeeNameNotBlank: "Name, surname cannot be blank...",
      employeeDepartmentNotBlank: "Department cannot be blank...",
      employeeDeviceNoNotBlank: "Device number cannot be blank...",
      employeeStartDateNotBlank: "Start date of work cannot be blank...",
      employeeTitleNotBlank: "Title cannot be blank...",
      employeeIdentityNoNotBlank: "Identity number cannot be blank...",
      employeeEndDateNotBlank: "End date cannot be blank...",
      employeeWorkGroupIdNotBlank: "Work group cannot be blank...",
      employeeStateIdNotBlank: "State cannot be blank...",
      employeeStateNoteNotBlank: "State note cannot be blank...",
      employeeStatuIdNotBlank: "Status cannot be blank...",
      employeeCardNoNotBlank: "Card number cannot be blank...",
      employeeTerminalStatuNotBlank: "Terminal status cannot be blank...",
      employeeTerminalPasswordNotBlank: "Terminal password cannot be blank...",
      employeeTzCodeNotBlank: "Tz code cannot be blank...",
      employeePlateNoNotBlank: "Plate number cannot be blank...",
      employeeHgsNoNotBlank: "Hgs number cannot be blank...",
      employeeDocumentNoNotBlank: "Document number cannot be blank...",
      visitorCardRegistrationNumberNotBlank: "Registration number cannot be blank...",
      visitorCardNameNotBlank: "Card name cannot be blank...",
      visitorCardDeviceNoNotBlank: "Device number cannot be blank...",
      visitorCardCreateDateNotBlank: "Create date cannot be blank...",
      userIsNotAuthorizedToSeeData: "User is not authorized to see data",
      payrollOfTheEmployeeWasRecalculated: "Payroll of the employee was recalculated",
      confirmedOvertimeDeleted: "Confirmed overtime was deleted",
      youAreOnlyAuthorizedToViewThisPage: "You are only authorized to view this page...",
      attentionPersonIsInBlackList: "Attention! Person is in black list!",
      cardIsUsed: "Card is being used now!",
      unableToConnectPageRefreshing: "Unable to connect... Page refreshing...",
      attentionPersonIsInBlackListNotBeenUpdated: "Attention! This person has not been updated. Because person is in black list!",
      visitorIdentityNumberNotBlank: "Identity number cannot be blank...",
      visitorNameNotBlank: "Visitor name cannot be blank...",
      visitorSuccessfullyExit: "Successfully logged out.",
      checkConfirmedTimes: "There are confirmed entries greater than the calculated time. Please check confirmed times...",
      confirmationOvertimeSuccessfully: "Overtime confirmation process completed successfully!",
      payrollOfTheEmployeesWasRecalculated: "Payroll of the employees was recalculated",
      allowenceNotSelected: "Please select allowence...",
      selectedRecordNotFound: "No selected record found.",
      recordNotFound: "No record found.",
      batchInformationUpdateSuccessfully: "Batch information update completed successfully!",
      batchWorkPlanUpdateSuccessfully: "Batch work plan update completed successfully!",
      batchMovementSuccessfully: "Batch movements save completed successfully!",
      checkTheMealTime: "There is no defined meal at the entered time. Please check the meal time...",
      mealNameNotBlank: "Meal name cannot be blank",
      selectedMealNotBlank: "Please select meal",
      invalidTimeRange: "Please check time range",
      foodGroupNameNotBlank: "Food group name cannot be blank",
      selectedDepartmentNotBlank: "Please select department...",
      selectedAccessGroupNotBlank: "Please select access group",
      accessGroupNameNotBlank: "Access group name cannot be blank",
      pleaseCheckTimes: "Please check the times entered",
      pleaseSelect: "Please select...",
      pleaseEnterShortCodeAndName: "Please enter short code and name",
      pleaseEnterAName: "Please enter a name",
      pleaseEnterAEmail: "Please enter a e-mail",
      pleaseCheckEnteredValue: "Please check entered value",
      pleaseEnterADeviceNo: "Please enter a device number",
      pleaseEnterADeviceName: "Please enter a device name",
      pleaseEnterIpAddressAndPort: "Please enter Ip address and port",
      pleaseEnterAReaderName: "Please enter a reader name",
      pleaseReaderNoOrPressButtonNewReader: "Please enter a reader no or press button on new reader",
      pleaseSelectReader: "Please select reader",
      pleaseCheckFoodGroupAndDate: "Please check that the food group is selected and the date is correct...",
      insufficientBalance: "Insufficient balance!",
      pleaseEnterAmount: "Please enter amount...",
      noContactInformation: "No contact information...",
      pleaseEnterADate: "Please enter a date",
      pleaseEnterACompanyName: "Please enter a company name",
      pleaseEnterAUserName: "Please enter a user name",
      pleaseEnterAPassword: "Please enter a password",
      passwordsDoNotMatch: "Passwords do not match",
      pleaseSelectAuthorityGroup: "Please select authority group",
      pleaseCheckEmptyFields: "Please check empty fields",
      transfersTriggeredSuccessfully: "Transfer triggered successfully!"
    }, _defineProperty(_alerts2, 'pleaseSelectFile', "Please select file"), _defineProperty(_alerts2, 'transactionSuccessfull', "Transaction successful!"), _defineProperty(_alerts2, 'youAreNotAuthorizedForThisAction', "You are not authorized for this action..."), _alerts2),
    errors: {
      connectionError: "Connection error: service could not be reached"
    },
    loginPage: {
      select: "Select",
      welcome: 'Please enter your user information to login.',
      fullScreenInfo: "Press the 'F11' key for full screen use.",
      loginButton: "Login",
      emailOrUsername: "Email or username",
      password: "Password",
      title1: "Modern Interface",
      title2: "Flexible Platform",
      title3: "Easy User Interface",
      title4: "Fast Support",
      infoTitle1: "Modern Interface",
      infoContent1: "Unlimited access from anywhere with mobile compatible interface",
      infoTitle2: "Cross Platform",
      infoContent2: "Windows, Linux, Mac, Pardus etc. operating systems support",
      infoTitle3: "Flexible Database",
      infoContent3: "MSSQL, PostgreSQL etc. working with all relational database types",
      infoTitle4: "Unlimited Users",
      infoContent4: "Unlimited users and easy UI",
      infoTitle5: "Unlimited Sub Groups",
      infoContent5: "Special filtering with unlimited and flexible infrastructure",
      infoTitle6: "Flexible Working Types",
      infoContent6: "Working type support suitable for every sector",
      infoTitle7: "Detailed Reports",
      infoContent7: "Flexible report types and one-click export",
      infoTitle8: "Automatic Mail",
      infoContent8: "Automatic report sending to the desired people",
      infoTitle9: "Real Time Monitoring",
      infoContent9: "Real-time viewing of transitions",
      infoTitle10: "Language options",
      infoContent10: "Customizable language options for each user",
      infoTitle11: "Flexible Infrastructure",
      infoContent11: "Infrastructure open to development and integration",
      infoTitle12: "Unlimited Updates",
      infoContent12: "Fast support and unlimited update service"
    },
    dashboard: {
      startOfWorks: "Start of works",
      absentees: "Absentees",
      totalEmployee: "Total Employees",
      lateComers: "Late Comers",
      lastUpdate: "Last Update",
      deviceStatus: "Device Status",
      device: "Device",
      lastConnection: "Last Connection",
      status: "Status",
      deviceNotFound: "Device not found",
      allowenceRequests: "Allowence Requests",
      allowenceRequest: "Allowence Request",
      allowenceRequestNotFound: "Allowence request not found",
      allowenceHeadNameAndDescription: "Name / Description",
      allowenceHeadRequestedDates: "Requested Dates",
      viewDetails: "View details",
      upcomingBirthdays: "Upcoming Birthdays",
      upcomingBirthdaysNotFound: "Upcoming birthdays not found",
      insides: "Insides",
      outsides: "Outsides",
      allowenceEmployees: "Persons on leave",
      insideVisitors: "Inside visitors",
      insideCar: "Inside cars",
      outsideCar: "Outside cars",
      registeredMobileAppUser: "Registered Mobile App Users",
      activeMobileAppUser: "Active Mobile App Users",
      activeStudentsInDormitory: "Active students",
      insideStudentsInDormitory: "Inside students",
      outsideStudentsInDormitory: "Outside students",
      allowencedStudentsInDormitory: "Allowenced students",
      fastReportView: "Fast Report View",
      fastReportTitleTodayStartOfWorks: "Today Start of Works",
      fastReportTitleTodayAbsentees: "Today Absentees",
      fastReportTitleTotalEmployees: "Total Employees",
      fastReportTitleTodayLateComers: "Today Late Comers",
      fastReportTitleInsides: "Inside Employees",
      fastReportTitleOutsides: "Outside Employees",
      fastReportTitleTodayAllowence: "Today Allowenced Employees",
      fastReportTitleInsideVisitors: "Inside Visitors",
      fastReportTitleInsideCars: "Inside Cars",
      fastReportTitleOutsideCars: "Outside Cars",
      fastReportTitleActiveStudents: "Active Students in Dormitory",
      fastReportTitleInsideStudents: "Inside Students in Dormitory",
      fastReportTitleOutsideStudents: "Outside Students in Dormitory",
      fastReportTitleAllowencedStudents: "Allowenced Students in Dormitory",
      fastReportTitleMobileAppUsers: "Mobile App Users",
      fastReportTitleActiveMobileAppUsers: "Active Mobile App Users",
      fastReportNotRecord: "No record found.",
      fastReportHeaderItems: {
        registrationNumber: "Registration Number",
        name: "Name",
        department: "Department",
        datetime: "Time",
        status: "Status",
        citizenshipNumber: "Citizenship Number",
        visitorName: "Visitor Name",
        entryTime: "Entry Time",
        title: "Title",
        mobilePhone: "Mobile Phone",
        device: "Device Model",
        readerName: "Reader Name"
      }
    },
    realTimeMonitor: {
      inputStatus: "Input Status",
      openDoor: "Open Door",
      relayDelay: "Relay Delay",
      pleaseEnterRelayDelay: "Please enter relay delay time in seconds",
      openDoorCommandSentSuccessfully: "Open door command sent successfully!",
      foodMenuAndView: "Food Menu and Live View",
      entryExitList: "Entry or Exit List",
      lastEntry: "Last Entry",
      lastExit: "Last Exit",
      logNotFoundInfo: "When there is a transition movement, it will be listed in this area.",
      foodMenu: "Meal Menu",
      todayTotalFood: "Total Meals Eaten Today",
      entryOrExitLogInfo: "Log Info",
      logTime: "Log Time",
      logDescription: "Log Description",
      mealPay: "Meal Pay",
      availableBalance: "Available Balance",
      movementLogDescription: {
        moveIn: "Move in",
        entryIn: "Entry in",
        exitOut: "Exit Out",
        unregisteredCard: "Unregistered Card",
        noAccess: "No access",
        dailyMealRightExpired: "Daily meal right expired",
        mealClaimExpired: "Meal claim expired",
        insufficientBalance: "Insufficient balance",
        foodGroupNotSelected: "Food group not selected",
        timeLimit: "Time limit",
        antipassback: "Antipassback"
      }
    },
    employees: (_employees2 = {
      searchEmployeeInList: "Search employee in list",
      employeeList: "Employee List",
      employeeSearchNotFound: "No employee record found.",
      employeeInfo: "Employee Information",
      newEmployee: "New Employee",
      updateEmployee: "Update Employee",
      saveEmployee: "Save Employee",
      deleteEmployee: "Delete Employee",
      selectedDepartment: "Selected Department",
      removePhoto: "Remove",
      selectPhoto: "Select Photo",
      deletedRecord: "Deleted Record",
      recordType: "Record Type",
      employee: "Employee",
      student: "Student",
      doesStayInTheDormitory: "Does stay in the dormitory",
      doesNotStayInTheDormitory: "Does not stay in the dormitory",
      foodClaim: "Food Claim",
      registrationNumber: "Registration No",
      dateOfStartWork: "Start of Work",
      dateOfEndWork: "End of Work",
      dateOfStart: "Start of Date",
      dateOfEnd: "End of Date",
      roomInformation: "Room - Apartment Information",
      validityStartDate: "Validity Start Date",
      validityEndDate: "Validity End Date",
      createValidityDate: "Create Validity Date",
      removeValidityDate: "Remove Validity Date",
      isContinueRemoveValidityDate: "The validity date will be removed. Is continue?",
      createValidityDateDescription: "Enter the validity date you want to create...",
      passwordExist: "Password registration is available",
      passwordNotExist: "No password registration",
      cardNumberExist: "Card number is available",
      cardNumberNotExist: "No card number",
      fingerprintExist: "Fingerprint is available",
      fingerprintNotExist: "No fingerprint",
      faceTemplateExist: "Face template is available",
      faceTemplateNotExist: "No face template",
      fingerPrintInformation: "Finger Print Information",
      fingerPrintDescription: "Please click to select finger for save or delete.",
      isVisitorCard: "Visitor Card",
      visitorCardGroup: "Visitor Card Group",
      visitorCardGroups: "Visitor Card Groups",
      cardGroupList: "Card Group List",
      newCardGroup: "New Card Group",
      visitorCardGroupNotFound: "No visitor card group record found.",
      cardGroupName: "Card Group Name",
      readerNotFound: "No device record found.",
      setLeaveDate: "Set Leave Date",
      backToWork: "Back to Work",
      reActivate: "Reactivate",
      generalInformation: "General Information",
      studentInformation: "Student Information",
      extraFields: "Custom Fields",
      mobileApp: "Mobile App Settings",
      otherInformation: "Other Information",
      accessAuthorities: "Access Authorities",
      movements: "Movements",
      allowences: "Allowences",
      payroll: "Payroll",
      annualPermit: "Annual Permit",
      payments: "Payments",
      foodGroup: "Food Group",
      employeeLogs: "Logs",
      cardPrinting: "Card Print",
      selectTemplate: "Select Template",
      registrationNumberInfo: "Registration No",
      citizenshipNumber: "Citizenship No",
      nameSurname: "Name Surname",
      department: "Department",
      title: "Title",
      dateofBirth: "Date of Birth",
      dateOfStartWorkInfo: "Date of Start Work",
      status: "Status",
      state: "State",
      stateNote: "State Note",
      deviceEmployeeNumber: "Device Number",
      deviceStatus: "Device Status",
      deviceCardNo: "Device Card No",
      devicePassword: "Device Password",
      plateNo: "Plate No",
      hgsNo: "Vehicle Tag No",
      workPlan: "Work Plan",
      documentNo: "Document No",
      salary: "Salary",
      overtimeStatus: "Overtime Status",
      takesOvertime: "Takes Overtime",
      motherName: "Mother Name",
      motherPhone: "Mother Phone",
      fatherName: "Father Name",
      fatherPhone: "Father Phone",
      activateSmsSystem: "Activate SMS System",
      smsSendPhone: "SMS Send Phone",
      createExtraField: "Create",
      extraFieldNoteInfo: "Note : The extra fields opened will be valid for all persons.",
      keyExtraField: "Key",
      valueExtraField: "Value",
      saveExtraField: "Save",
      extraFieldNotRecord: "No custom field record found.",
      email: "Email",
      address: "Address",
      mobileNumber: "Mobile Number",
      internal: "Internal Number",
      mobileBrand: "Device Model",
      notPaired: "Not Paired",
      resetPairing: "Reset Pairing",
      unknown: "Unknown Device",
      isMobileAppUser: "Is Mobile App User?",
      mobileAppPassword: "Mobile App Password",
      qrReaderMode: "QR Reader Mode",
      qrReaderModeAll: "All",
      qrReaderModeOnlyQRCreate: "Create QR Code",
      qrReaderModeOnlyQRRead: "Read QR Code",
      qrReaderModeOnlyWithButton: "With Button",
      qrReaderModeQRCreateAndRead: "Create & Read QR Code",
      qrReaderModeQRReadAndButton: "Read QR Code & With Button",
      qrReaderModeQRCreateAndButton: "Create QR Code & With Button",
      homePhone: "Home Phone",
      gender: "Gender",
      male: "Male",
      female: "Female",
      educationStatus: "EducationStatus",
      primarySchool: "Primary School",
      highSchool: "High School",
      associateDegree: "Associate Degree",
      bachelorDegree: "Bachelor Degree",
      postGraduate: "Post Graduate",
      doctorate: "Doctorate",
      militaryStatus: "Military Status",
      done: "Done",
      exempt: "Exempt",
      smokingStatus: "Smoking Status",
      smoking: "Smoking",
      notSmoking: "Not Smoking",
      maritalStatus: "Marital Status",
      single: "Single",
      married: "Married",
      widow: "Widow",
      drivingLicence: "Driving Licence",
      foreignLanguage: "Foreign Language",
      bloodType: "Blood Type",
      height: "Height",
      weight: "Weight",
      disabledPercent: "Disabled Percent",
      authorizedPerson1: "1. Authorized Person",
      authorizedPerson2: "2. Authorized Person",
      note1: "Note-1",
      note2: "Note-2",
      accessAuthoritiesInfo: "Access Group",
      sendPersontoDevices: "Send Person to Authorized Devices",
      deviceList: "Device List",
      selectAll: "Select All",
      removeAll: "Remove All",
      sendToReader: "Send to reader",
      getFingerprint: "Get fingerprints",
      getFaceTemplate: "Get face template",
      getUserData: "Get user data",
      deviceNotRecord: "No device record found.",
      newMovement: "New Movement",
      allDoors: "All Doors",
      pdks: "PDKS",
      access: "Access",
      diningHall: "Dining Hall",
      licencePlateRecognition: "Licence Plate Recognition",
      dormitoryDevice: "Dormitory Device",
      all: "All",
      active: "Active",
      passive: "Passive",
      startDateMovements: "Start Date",
      endDateMovements: "End Date",
      searchMovements: "Search",
      location: "Location",
      timeMovement: "Time",
      deviceMovement: "Movement Point",
      statusMovement: "Status",
      manuelMovement: "Manuel Movement",
      entryMovement: "Entry",
      exitMovement: "Exit",
      movementNotRecord: "No movement record found.",
      addMovement: "Add Movement",
      editMovement: "Edit Movement",
      typeMovement: "Movement Type",
      readerMovement: "Reader",
      includePassivesMovement: "Include passive movement",
      confirmedOvertimeNotDeleted: "Confirmed overtime not deleted",
      newAllowence: "New Allowence",
      removeAllowence: "Remove Allowence",
      removeAllowenceInSelectedDates: "Remove Allowence In Selected Dates",
      startDateAllowences: "Start Date",
      endDateAllowences: "End Date",
      searchAllowences: "Search",
      startAllowence: "Start",
      endAllowence: "End",
      codeAllowence: "Code",
      nameAllowence: "Name",
      allowenceNotRecord: "No allowence record found.",
      addAllowence: "Add Allowence",
      editAllowence: "Edit Allowence",
      validDays: "Valid Days",
      typeAllowence: "Allowence Type",
      dailyAllowence: "Daily Allowence",
      hourlyAllowence: "Hourly Allowence",
      startTimeAllowence: "Start Time",
      endTimeAllowence: "End Time",
      allowence: "Allowence",
      totalTimeAllowence: "Total Time",
      missingHourAllowence: "Missing Hour",
      isEqualTheMissingTime: "Is equal the missing time?",
      equalTheMissingTime: "Equal the missing time",
      doesApplyHolidays: "Does it also apply to holidays?",
      applyHolidays: "Apply to holidays",
      descriptionAllowence: "Description",
      recalculate: "Recalculate",
      startDatePayrolls: "Start Date",
      endDatePayrolls: "End Date",
      searchPayrolls: "Search",
      payrollNotRecord: "No payroll record found.",
      datePayroll: "Date",
      workPlanPayroll: "Work Plan",
      firstEntry: "First Entry",
      lastExit: "Last Exit",
      calculatedOvertime: "Calc. O.T.",
      confirmedOvertime: "Confirm O.T.",
      confirmTheCalculated: "Confirm the calculated",
      deleteTheConfirmed: "Delete the confirmed",
      annualPermitGroups: "Annual Permit Groups",
      seniority: "Seniority",
      transfer: "Transfer",
      remaining: "Remaining",
      deservedAnnualPermits: "Annual Permits",
      deservedDate: "Date",
      deservedDay: "Day",
      annualPermitNotRecord: "No annual permit record found.",
      usedAnnualPermits: "Used Annual Permits",
      annualPermitDate: "Date",
      annualPermitName: "Name",
      annualPermitDescription: "Description",
      usedAnnualPermitNotRecord: "No used annual permit record found."
    }, _defineProperty(_employees2, 'payments', "Payments"), _defineProperty(_employees2, 'paymentDefinitions', "Payment Definitions"), _defineProperty(_employees2, 'newPayment', "New"), _defineProperty(_employees2, 'startDatePayments', "Start Date"), _defineProperty(_employees2, 'endDatePayments', "End Date"), _defineProperty(_employees2, 'searchPayments', "Search"), _defineProperty(_employees2, 'timePayment', "Time"), _defineProperty(_employees2, 'namePayment', "Payment & Deduction Name"), _defineProperty(_employees2, 'amountPayment', "Amount"), _defineProperty(_employees2, 'statusPayment', "Status"), _defineProperty(_employees2, 'addPayment', "Add Payment & Deduction"), _defineProperty(_employees2, 'editPayment', "Edit Payment & Deduction"), _defineProperty(_employees2, 'typePayment', "Payment & Deduction Type"), _defineProperty(_employees2, 'addedSalary', "Increase to Salary"), _defineProperty(_employees2, 'decreaseFromSalary', "Decrease from Salary"), _defineProperty(_employees2, 'effectOnSalary', "Effect on Salary"), _defineProperty(_employees2, 'paymentNotRecord', "No payment & deduction record found."), _defineProperty(_employees2, 'remainingCredits', "Remaining Credits"), _defineProperty(_employees2, 'availableBalance', "Available Balance"), _defineProperty(_employees2, 'addCredit', "Add Credit"), _defineProperty(_employees2, 'addBalance', "Add Balance"), _defineProperty(_employees2, 'amountOfCredit', "Amount of Credit"), _defineProperty(_employees2, 'amountOfBalance', "Amount of Balance"), _defineProperty(_employees2, 'startDateLogs', "Start Date"), _defineProperty(_employees2, 'endDateLogs', "End Date"), _defineProperty(_employees2, 'searchLogs', "Search"), _defineProperty(_employees2, 'timeLog', "Time"), _defineProperty(_employees2, 'descriptionLog', "Description"), _defineProperty(_employees2, 'logNotRecord', "No log record found."), _defineProperty(_employees2, 'selectEmployee', "Select Employee"), _defineProperty(_employees2, 'searchFromNameSurname', "Search from name or surname."), _defineProperty(_employees2, 'isContinueUpdateEmployee', "The selected employee will be updated. Continue?"), _defineProperty(_employees2, 'isContinueSaveEmployee', "The new employee will be saved. Continue?"), _defineProperty(_employees2, 'isContinueDeleteEmployee', "The selected employee will be deleted. Continue?"), _defineProperty(_employees2, 'setLeaveDateInfo', "The selected employee will be dismiss. Please enter the date you wish to dismiss."), _defineProperty(_employees2, 'updateWorkPlan', "Update Work Plan"), _defineProperty(_employees2, 'updateAllowence', "Update Allowence"), _defineProperty(_employees2, 'updateAllowenceNotRecord', "No record found."), _defineProperty(_employees2, 'updateWorkPlanNotRecord', "No record found."), _defineProperty(_employees2, 'states', "States"), _defineProperty(_employees2, 'stateList', "State List"), _defineProperty(_employees2, 'newState', "New State"), _defineProperty(_employees2, 'stateNotRecord', "No state record found."), _defineProperty(_employees2, 'stateName', "State Name"), _defineProperty(_employees2, 'enableToLeaveDate', "Enable to leave date"), _defineProperty(_employees2, 'statusTitle', "Status"), _defineProperty(_employees2, 'statusList', "Status List"), _defineProperty(_employees2, 'newStatus', "New Status"), _defineProperty(_employees2, 'statusNotRecord', "No status record found."), _defineProperty(_employees2, 'statusName', "Status Name"), _defineProperty(_employees2, 'selectDepartment', "Select Department"), _defineProperty(_employees2, 'departmentNotRecord', "No department record found."), _defineProperty(_employees2, 'confirmSelectedOvertime', "Confirm Selected Overtime"), _defineProperty(_employees2, 'overtimePlace', "Overtime Place"), _defineProperty(_employees2, 'overtimeDescription', "Overtime Description"), _defineProperty(_employees2, 'dailyPayrollDetail', "Daily Payroll Detail"), _defineProperty(_employees2, 'payrollDetail', "Payroll Detail"), _defineProperty(_employees2, 'movementsOT', "Movements"), _defineProperty(_employees2, 'payrollTime', "Time"), _defineProperty(_employees2, 'movementOT', "Movement"), _defineProperty(_employees2, 'statusOT', "Status"), _defineProperty(_employees2, 'calculatedOvertimeLong', "Calculated O.T."), _defineProperty(_employees2, 'confirmedOvertimeLong', "Confirmed O.T."), _defineProperty(_employees2, 'workPlaceStartDate', "Start Date"), _defineProperty(_employees2, 'workPlaceEndDate', "End Date"), _defineProperty(_employees2, 'workPlace', "Work Place"), _defineProperty(_employees2, 'workPlaces', "Work Places"), _defineProperty(_employees2, 'workPlaceDefinitions', "Work Place Definitions"), _defineProperty(_employees2, 'newWorkPlace', "New Work Place"), _defineProperty(_employees2, 'workPlaceDescription', "Work Place Description"), _defineProperty(_employees2, 'addWorkplace', "Add Work Place"), _defineProperty(_employees2, 'editWorkplace', "Edit Work Place"), _defineProperty(_employees2, 'descriptionWorkPlace', "Work Place Description"), _defineProperty(_employees2, 'salary', "Salary"), _defineProperty(_employees2, 'updateTime', "Update Time"), _defineProperty(_employees2, 'addSalary', "Add Salary"), _defineProperty(_employees2, 'editSalary', "Edit Salary"), _defineProperty(_employees2, 'newSalary', "New Salary"), _defineProperty(_employees2, 'assignedInventory', "Assigned Inventory"), _employees2),
    visitors: {
      waitingVisitors: "Waiting Visitors",
      blackList: "Black List",
      reasonsForVisit: "Reasons for Visit",
      visitorName: "Visitor Name",
      reasonForVisit: "Reason for Visit",
      appointmentTime: "Appointment Time",
      waitingVisitorNotRecord: "No waiting visitor record found.",
      citizenshipNumber: "Citizenship Number",
      blackListName: "Name",
      blackListDescription: "Description",
      blackListNotRecord: "No black list record found.",
      reasonForVisitNotRecord: "No reason for visit record found.",
      inUse: "In use",
      ready: "Ready",
      givenTemporary: "Given Temporary",
      visitorCardNotRecord: "No visitor card record found.",
      employeeStatus: "Employee Status",
      searchEmployeeFromList: "Search employee from list...",
      searchVisitorCardFromList: "Search visitor card from list...",
      employeeNotRecord: "No employee record found.",
      in: "In",
      out: "Out",
      noLatestStatusInformation: "No latest status information",
      visitorInformation: "Visitor Information",
      previousSimilarRecords: "Previous Similar Records",
      similarRecordNotFound: "Similar record not found.",
      employeeList: "Employee List",
      visitorCard: "Visitor Card",
      temporaryCardForEmployee: "Temporary Card for Employee",
      nameSurname: "Name Surname",
      mobilePhone: "Mobile Phone",
      where: "Where",
      person: "Person",
      company: "Company",
      other: "Other",
      description: "Description",
      visitedEmployeeInformation: "Visited employee information",
      employeeInformation: "Employee information",
      selectEmployee: "Select Employee",
      waitingVisitorInformation: "Waiting Visitor Information",
      employeeSearch: "Employee search...",
      noContactInformation: "No Contact Information",
      visitorCards: "Visitor Cards",
      selectVisitorCardToGive: "Select visitor card to give",
      readyToUseVisitorCardNotRecord: "No ready to use visitor card found.",
      selectVisitorCardGroup: "Select Group",
      isContinueDeleteReason: "The selected reason record will be deleted. Continue?",
      isContinueDeleteBlackList: "The selected person record will be deleted. Continue?",
      isContinueDeleteWaitingVisitor: "The selected waiting visitor record will be deleted. Continue?"

    },
    visitorCards: {
      searchVisitorCardInList: "Search visitor card in list",
      visitorCardList: "Visitor Card List",
      visitorCardSearchNotFound: "No visitor card record found.",
      visitorCardInfo: "Visitor Card Information",
      newVisitorCard: "New Visitor Card",
      updateVisitorCard: "Update Visitor Card",
      saveVisitorCard: "Save Visitor Card",
      deleteVisitorCard: "Delete Visitor Card",
      removePhoto: "Remove",
      selectPhoto: "Select Photo",
      deletedRecord: "Deleted Record",
      registrationNumber: "Registration No",
      dateOfCreate: "Create Date",
      passwordExist: "Password registration is available",
      passwordNotExist: "No password registration",
      cardNumberExist: "Card number is available",
      cardNumberNotExist: "No card number",
      fingerprintExist: "Fingerprint is available",
      fingerprintNotExist: "No fingerprint",
      faceTemplateExist: "Face template is available",
      faceTemplateNotExist: "No face template",
      visitorCardGroup: "Visitor Card Group",
      visitorCardGroups: "Visitor Card Groups",
      cardGroupList: "Card Group List",
      newCardGroup: "New Card Group",
      visitorCardGroupNotFound: "No visitor card group record found.",
      cardGroupName: "Card Group Name",
      readerNotFound: "No device record found.",
      generalInformation: "General Information",
      accessAuthorities: "Access Authorities",
      movements: "Movements",
      employeeLogs: "Logs",
      cardPrinting: "Card Print",
      selectTemplate: "Select Template",
      registrationNumberInfo: "Registration No",
      cardName: "Card Name",
      department: "Department",
      dateOfCreateInfo: "Date of Create",
      status: "Status",
      deviceEmployeeNumber: "Device Number",
      deviceStatus: "Device Status",
      deviceCardNo: "Device Card No",
      devicePassword: "Device Password",
      accessAuthoritiesInfo: "Access Group",
      sendPersontoDevices: "Send Person to Authorized Devices",
      deviceList: "Device List",
      selectAll: "Select All",
      removeAll: "Remove All",
      getFingerprint: "Get fingerprints",
      getFaceTemplate: "Get face template",
      getUserData: "Get user data",
      sendToReader: "Send to reader",
      deviceNotRecord: "No device record found.",
      newMovement: "New Movement",
      allDoors: "All Doors",
      pdks: "PDKS",
      access: "Access",
      diningHall: "Dining Hall",
      all: "All",
      active: "Active",
      passive: "Passive",
      startDateMovements: "Start Date",
      endDateMovements: "End Date",
      searchMovements: "Search",
      timeMovement: "Time",
      deviceMovement: "Movement Point",
      statusMovement: "Status",
      manuelMovement: "Manuel Movement",
      entryMovement: "Entry",
      exitMovement: "Exit",
      movementNotRecord: "No movement record found.",
      remainingCredits: "Remaining Credits",
      availableBalance: "Available Balance",
      addCredit: "Add Credit",
      addBalance: "Add Balance",
      amountOfCredit: "Amount of Credit",
      amountOfBalance: "Amount of Balance",
      startDateLogs: "Start Date",
      endDateLogs: "End Date",
      searchLogs: "Search",
      timeLog: "Time",
      descriptionLog: "Description",
      logNotRecord: "No log record found.",
      isContinueUpdateVisitorCard: "The selected visitor card will be updated. Continue?",
      isContinueSaveVisitorCard: "The new visitor card will be saved. Continue?",
      isContinueDeleteVisitorCard: "The selected visitor card will be deleted. Continue?",
      statusTitle: "Status",
      statusList: "Status List",
      newStatus: "New Status",
      statusNotRecord: "No status record found.",
      statusName: "Status Name",
      selectDepartment: "Select Department",
      departmentNotRecord: "No department record found."
    },
    batchOperations: (_batchOperations2 = {
      filterTheEmployeesYouWantToSelect: "Filter the employees you want to select",
      searchEmployeeFromList: "Search employee from list...",
      employeeList: "Employee List",
      employeeNotRecord: "No employee record found.",
      chooseFromTheFollowingActions: "Choose from the following actions",
      informationUpdate: "Information Update",
      informationUpdateOperations: "Information Update Operations",
      allowence: "Allowence",
      allowenceOperations: "Allowence Operations",
      movement: "Movement",
      movementOperations: "Movement Operations",
      overtime: "Overtime",
      overtimeOperations: "Overtime Operations",
      payroll: "Payroll",
      payrollOperations: "Payroll Operations",
      workPlan: "Work Plan",
      workPlanOperations: "Work Plan Operations",
      accessGroup: "Access Group",
      validityStartDate: "Validity Start Date",
      validityEndDate: "Validity End Date",
      department: "Department",
      status: "Status",
      state: "State",
      foodGroup: "Food Group",
      startDate: "Start Date",
      endDate: "End Date",
      startTime: "Start Time",
      endTime: "End Time",
      validDays: "Valid Days"
    }, _defineProperty(_batchOperations2, 'allowence', "Allowence"), _defineProperty(_batchOperations2, 'allowenceType', "Allowence Type"), _defineProperty(_batchOperations2, 'dailyAllowence', "Daily Allowence"), _defineProperty(_batchOperations2, 'hourlyAllowence', "Hourly Allowence"), _defineProperty(_batchOperations2, 'totalTimeAllowence', "Total Time"), _defineProperty(_batchOperations2, 'missingHourAllowence', "Missing Hour"), _defineProperty(_batchOperations2, 'isEqualTheMissingTime', "Is equal the missing time?"), _defineProperty(_batchOperations2, 'equalTheMissingTime', "Equal the missing time"), _defineProperty(_batchOperations2, 'doesApplyHolidays', "Does it also apply to holidays?"), _defineProperty(_batchOperations2, 'applyHolidays', "Apply to holidays"), _defineProperty(_batchOperations2, 'descriptionAllowence', "Description"), _defineProperty(_batchOperations2, 'movementDetails', "Movement Details"), _defineProperty(_batchOperations2, 'movementTime', "Movement Time"), _defineProperty(_batchOperations2, 'reader', "Reader"), _defineProperty(_batchOperations2, 'movementType', "Movement Type"), _defineProperty(_batchOperations2, 'entryMovement', "Entry"), _defineProperty(_batchOperations2, 'exitMovement', "Exit"), _defineProperty(_batchOperations2, 'createExitMovement', "Create exit movement"), _defineProperty(_batchOperations2, 'secondMovementTime', "2.Movement Time"), _defineProperty(_batchOperations2, 'secondMovementReader', "2.Movement Reader"), _defineProperty(_batchOperations2, 'secondMovementType', "2.Movement Type"), _defineProperty(_batchOperations2, 'confirmOvertime', "Confirm Overtime"), _defineProperty(_batchOperations2, 'search', "Search"), _defineProperty(_batchOperations2, 'overtimeWorks', "Overtime Works"), _defineProperty(_batchOperations2, 'nameSurname', "Name Surnama"), _defineProperty(_batchOperations2, 'date', "Date"), _defineProperty(_batchOperations2, 'calculated', "Calculated"), _defineProperty(_batchOperations2, 'confirmed', "Confirmed"), _defineProperty(_batchOperations2, 'includePassivesMovement', "Include passive movement"), _defineProperty(_batchOperations2, 'confirmedOvertimeNotDeleted', "Confirmed overtime not deleted"), _defineProperty(_batchOperations2, 'descriptionWorkPlan', "Description"), _defineProperty(_batchOperations2, 'batchInformationUpdateSuccessfully', "Bulk information update completed successfully!"), _defineProperty(_batchOperations2, 'batchWorkPlanUpdateSuccessfully', "Batch work plan change saved successfully!"), _defineProperty(_batchOperations2, 'batchMovementSuccessfully', "Bulk transaction creation successfully saved!"), _defineProperty(_batchOperations2, 'batchAllowencesSuccessfully', "Batch permission process completed successfully!"), _batchOperations2),
    reports: {
      selectReport: "Select Report",
      report: "Report",
      noResults: "No results to display.",
      reportDetails: "Report Details",
      displayInReportVisitorCardGroups: "Visitor card groups to display in the report",
      visitorCardGroupNotFound: "No visitor card group record found.",
      displayInReportDevices: "Devices to display in the report",
      devicesNotFound: "No device record found.",
      displayInReportAllowences: "Allowences to display in the report",
      allowenceNotFound: "No allowence record found.",
      displayInReportDepartments: "Departments to display in the report",
      departmentNotFound: "No department record found.",
      checkThisDevices: "Check This Devices",
      reportSettings: "Report Settings",
      startDate: "Start Date",
      endDate: "End Date",
      date: "Date",
      reportOptions: "Report Options",
      showAllowences: "Show Allowences",
      showMissing: "Show Missing",
      showLatecomer: "Show Latecomer",
      fromTheClock: "from the clock",
      lessEmployees: "Less employees",
      moreEmployees: "More employees",
      viewReport: "View Report",
      selectedReportIsUnavailable: "The selected report is unavailable...",
      reports: {
        LaterComersReport: "Later Comers Report",
        LaterComersReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          title: "Title",
          date: "Date",
          status: "Status",
          entry: "Entry",
          difference: "Difference"
        },
        DetailedInOutReport: "Detailed Movement Report",
        DetailedInOutReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          workPlace: "Work Place",
          date: "Date",
          firstEntry: "First Entry",
          lastExit: "Last Exit",
          total: "Total",
          status: "Status",
          entry: "Entry",
          exit: "Exit",
          difference: "Dif."
        },
        FoodReport: "Food Doors Movement Report",
        FoodReportHeader: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          title: "Title",
          documentNo: "Document No",
          departmentName: "Department",
          readerName: "Reader",
          date: "Date",
          debit: "Debit"
        },
        FoodDebtReport: "Food Debt Report",
        FoodDebtReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          documentNo: "Document No",
          debit: "Debit"
        },
        FoodSummaryReport: "Food Summary Report",
        FoodSummaryReportHeaders: {
          departmentName: "Department Name",
          total: "Total",
          debit: "Price"
        },
        EmployeesReport: "Employee Information Report",
        EmployeesReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          title: "Title",
          mobilePhone: "Phone",
          citizenshipNumber: "C.N.",
          status: "Status",
          state: "State",
          startDateWork: "Start Date",
          leaveDate: "Leave Date",
          validityStartDate: "Validity Start Date",
          validityEndDate: "Validity End Date"
        },
        InsidesReport: "Insides Report",
        InsidesReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          entryTime: "Entry Time",
          entryPoint: "Entry Point",
          status: "Status"
        },
        OutsidesReport: "Outsides Report",
        OutsidesReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          exitTime: "Exit Time",
          exitPoint: "Exit Point",
          status: "Status"
        },
        VisitorsReport: "Visitors Report",
        VisitorsReportHeaders: {
          citizenshipNumber: "C.N.",
          nameSurname: "Name Surname",
          mobilePhone: "Phone",
          where: "Visited",
          departmentName: "Department",
          reasonForVisit: "Reason for Visit",
          visitedEmployeeInformation: "Visited",
          cardIssueTime: "Card Issue Time",
          entryTime: "Entry Time",
          exitTime: "Exit Time",
          cardName: "Card Name",
          description: "Description"
        },
        InsideVisitorsReport: "Inside Visitors Report",
        InsideVisitorsReportHeader: {
          citizenshipNumber: "C.N.",
          nameSurname: "Name Surname",
          mobilePhone: "Phone",
          where: "Visited",
          departmentName: "Department",
          reasonForVisit: "Reason for Visit",
          visitedEmployeeInformation: "Visited",
          cardIssueTime: "Card Issue Time",
          entryTime: "Entry Time",
          cardName: "Card Name",
          description: "Description"
        },
        TimeBasedWorkReport: "Time Based Work Report",
        TimeBasedWorkReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          startDate: "Start Date",
          endDate: "End Date",
          totalWorkedTime: "Total Worked Time",
          difference: "Difference"
        },
        FirstInLastOutReport: "First Entry Last Exit Report",
        FirstInLastOutReportHeaders: {
          citizenshipNumber: "Citizenship No",
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          department: "Department",
          title: "Title",
          status1: "Status",
          workPlace: "Work Place",
          workPlan: "Work Plan",
          date: "Date",
          firstEntry: "First Entry",
          entryReader: "Entry Reader",
          lastExit: "Last Exit",
          exitReader: "Exit Reader",
          status: "Status",
          total: "Total Work Time",
          missingHour: "Difference",
          earlyEntry: "Early Entry",
          lateEntry: "Late Entry",
          earlyExit: "Early Exit",
          lateExit: "Late Exit"
        },
        AllowenceReport: "Allowence Report",
        AllowenceReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          startTime: "Start Time",
          endTime: "End Time",
          allowenceName: "Allowence Name"
        },
        WorkSummaryReport: "Work Summary Report",
        WorkSummaryReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          jobDays: "Job Days",
          workDays: "Work Days",
          publicHoliday: "Public Holiday",
          allowence: "Allowence",
          absentee: "Absentee"
        },
        CompanyEmployeesStatusReport: "Unit Based Employee Number Report",
        CompanyEmployeesStatusReportHeaders: {
          unitName: "Unit Name",
          employeeCount: "Employee Count",
          continuedEmployeeCount: "Continued Employee Count",
          annualPermit: "Annual Permit",
          report: "Report",
          administrativeLeave: "Administrative Leave",
          freePermission: "Free Permission",
          missioned: "Missioned",
          nonComers: "Non Comers",
          todayComers: "Today Comers"
        },
        CustomCompanyEmployeesStatusReport: "Department Based Employee Number Report",
        CustomCompanyEmployeesStatusReportHeaders: {
          unitName: "Unit Name",
          employeeCount: "Employee Count",
          continuedEmployeeCount: "Continued Employee Count",
          annualPermit: "Annual Permit",
          report: "Report",
          administrativeLeave: "Administrative Leave",
          freePermission: "Free Permission",
          missioned: "Missioned",
          nonComers: "Non Comers",
          todayComers: "Today Comers"
        },
        DepartmentSummaryReport: "Department Based Employee Number Report With Dates",
        DepartmentSummaryReportHeaders: {
          unitName: "Unit Name",
          employeeCount: "Employee Count",
          continuedEmployeeCount: "Continued Employee Count",
          annualPermit: "Annual Permit",
          report: "Report",
          administrativeLeave: "Administrative Leave",
          freePermission: "Free Permission",
          missioned: "Missioned",
          nonComers: "Non Comers",
          todayComers: "Today Comers"
        },
        PayrollReport: "Payroll Report",
        DetailedPayrollReport: "Detailed Payroll Report",
        FoodCreditReport: "Food Credit Log Report",
        FoodCreditReportHeaders: {
          registrationNumber: "Registration No",
          nameSurname: "Name Surname",
          date: "Date",
          debit: "Debit",
          creditType: "Type",
          status: "Status",
          userName: "User"
        },
        TemplatePayrollReport: "Template Payroll Report",
        TemplateMonthlyPayrollReport: "Monthly Payroll Report",
        SalaryReport: "Salary Report",
        InOutReport: "In Out Report",
        InOutReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          workPlace: "Work Place",
          departmentName: "Department",
          location: "Location",
          date: "Date",
          readerName: "Reader"
        },
        DoorBasedLastMovementReport: "Door Based Last Movement Report",
        DoorBasedLastMovementReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          departmentName: "Department",
          date: "Date",
          readerName: "Reader",
          doorStatus: "Status"
        },
        DoorsAuthorizationReport: "Doors Authorization Report",
        DoorsAuthorizationReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          departmentName: "Department",
          accessGroup: "Access Group"
        },
        DormitoryInformationReport: "Dormitory Students Report",
        DormitoryInformationReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          departmentName: "Department",
          isSmsSend: "SMS Send",
          motherName: "Mother Name",
          fatherName: "Father Name",
          smsPhone: "SMS Phone",
          validityDate: "Validity Date",
          roomName: "Room",
          floorName: "Floor",
          areaName: "Area"
        },
        DormitoryInsidesReport: "Yurt İçerideki Öğrenciler Raporu",
        DormitoryInsidesReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          departmentName: "Department",
          lastMovementDate: "Last Movement",
          lastMovementReader: "Reader",
          status: "Status",
          isSmsSend: "SMS Send",
          motherName: "Mother Name",
          fatherName: "Father Name",
          smsPhone: "SMS Phone",
          validityDate: "Validity Date",
          roomName: "Room",
          floorName: "Floor",
          areaName: "Area"
        },
        DormitoryOutsidesReport: "Yurt Dışarıdaki Öğrenciler Raporu",
        DormitoryOutsidesReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          departmentName: "Department",
          lastMovementDate: "Last Movement",
          lastMovementReader: "Reader",
          status: "Status",
          isSmsSend: "SMS Send",
          motherName: "Mother Name",
          fatherName: "Father Name",
          smsPhone: "SMS Phone",
          validityDate: "Validity Date",
          roomName: "Room",
          floorName: "Floor",
          areaName: "Area"
        },
        WeeklyPayrollReport: "Weekly Payroll Report",
        WeeklyPayrollReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          departmentName: "Department",
          workTime: "Work Time",
          overTime: "Overtime",
          nightWorkTime: "Night Work Time",
          status: "Overtime to Pay"
        },
        EntryExitSnapshotReport: "Movement Snapshots Report",
        EntryExitSnapshotReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          departmentName: "Department",
          date: "Date",
          reader: "Reader",
          photo: "Profile Picture",
          snapshot: "Snapshot"
        },
        SaleReport: "Sale Report",
        SaleReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          price: "Price",
          date: "Date",
          user: "User",
          isRefund: "Is Refund?"
        },
        DetailedVisitorReport: "Detailed Visitor Report",
        DetailedVisitorReportHeaders: {
          citizenshipNumber: "C.N.",
          nameSurname: "Name Surname",
          mobilePhone: "Phone",
          where: "Visited",
          departmentName: "Department",
          reasonForVisit: "Reason for Visit",
          visitedEmployeeInformation: "Visited",
          cardIssueTime: "Card Issue Time",
          entryTime: "Entry Time",
          exitTime: "Exit Time",
          cardName: "Card Name",
          description: "Description"
        },
        DepartmentBasedVisitorReport: "Department Based Visitor Report",
        DepartmentBasedVisitorReportHeaders: {
          departmentName: "Department",
          total: "Total"
        },
        ShiftReport: "Shift Report",
        ShiftReportHeaders: {
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          title: "Title",
          departmentName: "Department",
          signature: "Signature",
          isSignatureColumnAdded: "Add Signature Column?"
        },
        VerticalFirstInLastOutReport: "Vertical First In Last Out Report",
        VerticalFirstInLastOutReportHeaders: {
          citizenshipNumber: "Citizenship Number",
          registrationNumber: "Registration Number",
          nameSurname: "Name Surname",
          status: "Status",
          title: "Title",
          departmentName: "Department"
        }
      }
    },
    foodGroupOperations: {
      searchEmployeeInList: "Search employee in list",
      employeeList: "Employee List",
      employeeSearchNotFound: "No employee record found.",
      employeeInfo: "Employee Information",
      deletedRecord: "Deleted Record",
      registrationNumber: "Registration No",
      dateOfStartWork: "Start of Work",
      dateOfEndWork: "End of Work",
      passwordExist: "Password registration is available",
      passwordNotExist: "No password registration",
      cardNumberExist: "Card number is available",
      cardNumberNotExist: "No card number",
      fingerprintExist: "Fingerprint is available",
      fingerprintNotExist: "No fingerprint",
      faceTemplateExist: "Face template is available",
      faceTemplateNotExist: "No face template",
      movements: "Dining Hall Movements",
      foodGroup: "Food Group",
      retailSaleLogs: "Sale Logs",
      newMovement: "New Movement",
      newMovementWarningInfo: "Warning : Meal fee is deducted according to the employee's meal group information.",
      dateMovement: "Movement Date",
      readerMovement: "Reader",
      diningHall: "Dining Hall",
      startDateMovements: "Start Date",
      endDateMovements: "End Date",
      searchMovements: "Search",
      timeMovement: "Time",
      deviceMovement: "Movement Point",
      statusMovement: "Status",
      price: "Price",
      meal: "Meal",
      manuelMovement: "Manuel Movement",
      entryMovement: "Entry",
      exitMovement: "Exit",
      passive: "Passive",
      movementNotRecord: "No movement record found.",
      remainingCredits: "Remaining Credits",
      availableBalance: "Available Balance",
      addCredit: "Add Credit",
      addBalance: "Add Balance",
      amountOfCredit: "Amount of Credit",
      amountOfBalance: "Amount of Balance",
      foodBalanceLogs: "Food Balance Logs",
      time: "Time",
      amount: "Amount",
      type: "Type",
      status: "Status",
      foodBalanceLogNotRecord: "No food balance log record found.",
      isContinueUpdateEmployeeFoodGroup: "The food group of the selected employee will be updated. Continue?"
    },
    foodGroups: {
      foodGroupList: "Food Group List",
      foodGroupNotRecord: "No food group record found.",
      foodGroupInformation: "Food Group Information",
      newFoodGroup: "New Food Group",
      groupName: "Group Name",
      groupType: "Group Type",
      deserveType: "Claim Type",
      creditType: "Credit Type",
      balanceType: "Balance Type",
      dailyMealEatingCount: "Daily Meal Eating Right",
      meals: "Meals",
      mealDefinitions: "Meal Definitions",
      newMeal: "New Meal",
      mealNotFoundSelectedFoodGroups: "No meal in food group record found.",
      foodGroupUpdateIsContinue: "Selected food group will be updated. Continue?",
      foodGroupSaveIsContinue: "New food group will be saved. Continue?",
      foodGroupDeleteIsContinue: "Selected food group will be deleted. Continue?",
      addNewMeal: "Add New Meal",
      validDays: "Valid Days",
      mealName: "Meal Name",
      startTime: "Start Time",
      endTime: "End Time",
      eatingCount: "Eating Count",
      price: "Price",
      guestPrice: "Guest Price",
      mealNameDefinitions: "Meal Name Definitions",
      mealNameList: "Meal Name List",
      newMealName: "New Meal Name",
      mealNameNotRecord: "No meal name record found."
    },
    extraFields: {
      extraFieldList: "Custom Field List",
      extraFieldNotRecord: "No custom field record found.",
      extraFieldInfo: "Custom Field Info",
      newGroup: "New Custom Field",
      groupName: "Custom Field Name",
      isContinueUpdate: "Selected custom field will be updated. Continue?",
      isContinueSave: "New custom field will be saved. Continue?",
      isContinueDelete: "Selected custom field will be deleted. Continue?"
    },
    licensePlateRecognition: {
      searchLicensePlateInList: "Search license plate in list",
      licensePlateList: "License Plate List",
      licensePlateSearchNotFound: "No license plate record found.",
      licensePlateInfo: "License Plate Info",
      newLicensePlate: "New License Plate",
      updateLicensePlate: "Update License Plate",
      saveLicensePlate: "Save License Plate",
      deleteLicensePlate: "Delete License Plate",
      plateNumber: "Plate Number",
      plateNumberExist: "License plate number exists",
      plateNumberNotExist: "License plate number does not exist",
      deviceList: "Terminal List",
      employee: "Employee",
      selectAll: "Select All",
      removeAll: "Remove All",
      sendToReader: "Send to Reader",
      deviceNotRecord: "No terminal record found.",
      isContinueUpdateLicensePlate: "Selected license plate will be updated. Continue?",
      isContinueSaveLicensePlate: "New license plate will be saved. Continue?",
      isContinueDeleteLicensePlate: "Selected license plate will be deleted. Continue?"
    },
    departments: {
      departmentInfo: "Department Info",
      newDepartment: "New Department",
      departmentName: "Department Name",
      mainDepartment: "Main Department",
      indexNumber: "Index Number",
      departmentList: "Department List",
      displayOnDashboard: "Display on Dashboard",
      departmentNotRecord: "No department record found.",
      isContinueDepartmentUpdate: "Selected department will be updated. Continue?",
      isContinueDepartmentSave: "New department will be saved. Continue?",
      isContinueDepartmentDelete: "Selected department will be deleted. Continue?"
    },
    accessGroups: {
      accessGroupList: "Access Group List",
      accessGroupNotRecord: "No access group record found.",
      accessGroupInfo: "Access Group Info",
      newAccessGroup: "New Access Group",
      accessGroupName: "Access Group Name",
      addNewDevicesAutomatically: "Add New Devices Automatically",
      authorizedDevices: "Authorized Devices",
      deviceNotRecord: "No device record found.",
      applyTemplate: "Apply Template",
      isContinueAccessGroupUpdate: "Selected access group will be updated. Continue?",
      isContinueAccessGroupSave: "New access group will be saved. Continue?",
      isContinueAccessGroupDelete: "Selected access group will be deleted. Continue?"
    },
    workPlans: {
      workPlanList: "Work Plan List",
      period: "Period",
      singlePlan: "Single Plan",
      workPlanNotRecord: "No work plan record found.",
      workPlanInfo: "Work Plan Info",
      workPlanModel: "Work Plan Model",
      newWorkPlan: "New Work Plan",
      defaultWorkPlanModel: "Default Work Plan Model",
      workGroupModel: "Work Group Model",
      hourBasedPlanningModel: "Hour Based Planning Model",
      freelanceModelWithHourlyInterval: "Freelance Model With Hourly Interval",
      plan1Title: "Standard work and rotating shifts",
      plan1Description: "Create plan details by entering day-based time intervals.",
      plan2Title: "Places with unscheduled alternating shifts",
      plan2Description: "Provides automatic detection by grouping the created work plans.",
      plan3Title: "Merchandising sector",
      plan3Description: "Just plan in and out times and tolerances to apply.",
      plan4Title: "Places with no time limit",
      plan4Description: "Plan by entering total hours of work and break time.",
      details: "Details",
      settings: "Settings",
      plan: "Plan",
      calculateBasedOnFirstEntryAndLastExit: "Calculate based on first entry and last exit (calculations in between are not based)",
      shortCode: "Short Code",
      workPlanName: "Work Plan Name",
      entryTime: "Entry Time",
      exitTime: "Exit Time",
      tolerances: "Tolerances",
      earlyEntryTolerance: "Early Entry Tolerance",
      earlyExitTolerance: "Early Exit Tolerance",
      lateEntryTolerance: "Late Entry Tolerance",
      lateExitTolerance: "Late Exit Tolerance",
      mealBreakTime: "Meal Break",
      mealStartTime: "Meal Start",
      mealEndTime: "Meal End",
      totalMealTime: "Total Meal Time",
      totalWorkTime: "Total Work Time",
      breakTolerances: "Break Tolerances",
      createSettingsForDeservedBreaks: "Create settings for deserved breaks.",
      forHourlyWork: "for hourly work",
      break: "break",
      hourlyWork: "Hourly Work",
      breakTolerance: "Break Tolerance",
      notRecord: "Not record.",
      durationOfAbsence: "Duration of Absence",
      skipTheDayTime: "Skip The Day Time",
      solsticeTime: "Solstice Time",
      maxLimit: "Max Limit",
      minLimit: "Min Limit",
      basedOnEntryDay: "Based on entry day",
      checkTheDoors: "Check the doors",
      payrollDetails: "Payroll Details",
      toleranceToReduceTheSameMovementsToOne: "Tolerance to reduce the same movements to one",
      includeDifferentDoorsInDeleting: "Include different doors in deleting",
      dontDeleteConfirmedOvertimes: "Don't delete confirmed overtimes",
      selectThePlansYouWantToIncludeInTheGroup: "Select the plans you want to include in the group.",
      currentDefinitionBetweenSelectedHours: "Current definition between selected hours",
      whenItDoesntComePerceiveItAsADeserved: "When it doesn't come perceive it as a deserved",
      start: "Start",
      end: "End",
      payrollType: "Payroll Type",
      deserve: "Deserve",
      planType: "Plan Type",
      periodDistribution: "Period Distribution",
      periodStartDate: "Period Start Date",
      allowence: "Allowence",
      day: "Day",
      name: "Name",
      dayCount: "Day Count",
      isContinueWorkPlanUpdate: "Selected work plan will be updated. Continue?",
      isContinueWorkPlanSave: "New work plan will be saved. Continue?",
      isContinueWorkPlanDelete: "Selected work plan will be deleted. Continue?"
    },
    overtimeDefinitions: {
      overtimePlaces: "Overtime Places",
      overtimePlaceNotRecord: "No overtime place record found.",
      overtimeDescriptions: "Overtime Descriptions",
      overtimeDescriptionNotRecord: "No overtime description record found.",
      newOvertimePlaceDefinition: "New Overtime Place Definition",
      overtimePlaceName: "Overtime Place Name",
      overtimePlaceUpdate: "Update Overtime Place",
      isContinueOvertimePlaceDelete: "Selected overtime place will be deleted. Continue?",
      newOvertimeDescriptionDefinition: "New Overtime Description Definition",
      overtimeDescriptionName: "Overtime Description Name",
      overtimeDescriptionUpdate: "Update Overtime Description",
      isContinueOvertimeDescriptionDelete: "Selected overtime description will be deleted. Continue?"
    },
    allowences: {
      allowenceList: "Allowence List",
      allowenceNotRecord: "No allowence record found.",
      allowenceInfo: "Allowence Info",
      newAllowence: "New Allowence",
      shortCode: "Short Code",
      allowenceName: "Allowence Name",
      monthlyPayrollColumn: "Monthly Payroll Column",
      dailyPayrollColumn: "Daily Payroll Column",
      fullWorkTimeInDay: "Full Work Time In Day",
      color: "Color",
      isContinueAllowenceUpdate: "Selected allowence will be updated. Continue?",
      isContinueAllowenceSave: "New allowence will be saved. Continue?",
      isContinueAllowenceDelete: "Selected allowence will be deleted. Continue?"
    },
    inventoryManagement: {
      inventoryCategories: "Inventory Categories",
      inventoryCategoryInfo: "Category Information",
      newInventoryCategory: "New Category",
      inventoryCategoryName: "Category Name",
      inventoryCategoryList: "Category List",
      inventoryCategoryNotRecord: "No inventory category record found.",
      isContinueInventoryCategoryUpdate: "Selected inventory category will be updated. Continue?",
      isContinueInventoryCategorySave: "New inventory category will be saved. Continue?",
      isContinueInventoryCategoryDelete: "Selected inventory category will be deleted. Continue?",
      inventoryWarehouses: "Inventory Warehouses",
      inventoryWarehouseInfo: "Warehouse Information",
      newInventoryWarehouse: "New Warehouse",
      inventoryWarehouseName: "Warehouse Name",
      inventoryWarehouseList: "Warehouse List",
      inventoryWarehouseNotRecord: "No inventory warehouse record found.",
      isContinueInventoryWarehouseUpdate: "Selected inventory warehouse will be updated. Continue?",
      isContinueInventoryWarehouseSave: "New inventory warehouse will be saved. Continue?",
      isContinueInventoryWarehouseDelete: "Selected inventory warehouse will be deleted. Continue?",
      inventoryFieldList: "Inventory Fields",
      inventoryFieldInfo: "Inventory Field Information",
      newInventoryField: "New Inventory Field",
      inventoryFieldName: "Inventory Field Name",
      inventoryFieldNotRecord: "No inventory field record found.",
      isContinueInventoryFieldUpdate: "Selected inventory field will be updated. Continue?",
      isContinueInventoryFieldSave: "New inventory field will be saved. Continue?",
      isContinueInventoryFieldDelete: "Selected inventory field will be deleted. Continue?",
      inventoryList: "Inventory List",
      inventoryInfo: "Inventory Information",
      newInventory: "New Inventory",
      inventoryName: "Name",
      inventoryCode: "Code",
      inventorySerialNo: "Serial No",
      inventoryCategory: "Category",
      inventoryDefaultWarehouse: "Warehouse",
      quantity: "Quantity",
      documentType: "Document Type",
      documentDescription: "Document Description",
      newDocument: "New Document",
      editDocument: "Edit Document",
      deleteDocument: "Delete Document",
      addDocumentFile: "Add Document File",
      selectPhoto: "Select Photo",
      removePhoto: "Remove Photo",
      allCategories: "All Categories",
      inventoryNotRecord: "No inventory record found.",
      isContinueInventoryUpdate: "Selected inventory will be updated. Continue?",
      isContinueInventorySave: "New inventory will be saved. Continue?",
      isContinueInventoryDelete: "Selected inventory will be deleted. Continue?"
    },
    workPlaceDefinitions: {
      workPlaceList: "Work Place List",
      workPlaceNotRecord: "No work place record found.",
      workPlaceInfo: "Work Place Information",
      newWorkPlace: "New Work Place",
      workPlaceName: "Work Place Name",
      workPlaceUpdate: "Update Work Place",
      isContinueWorkPlaceUpdate: "Selected work place will be updated. Continue?",
      isContinueWorkPlaceSave: "New work place will be saved. Continue?",
      isContinueWorkPlaceDelete: "Selected work place will be deleted. Continue?"
    },
    documentDefinitions: {
      documentDefinitionList: "Document List",
      documentDefinitionNotRecord: "No document record found.",
      documentDefinitionInfo: "Document Information",
      newDocument: "New Document",
      documentDefinitionName: "Document Name",
      documentDefinitionUpdate: "Update Document",
      isContinueDocumentDefinitionUpdate: "Selected document definition will be updated. Continue?",
      isContinueDocumentDefinitionSave: "New document definition will be saved. Continue?",
      isContinueDocumentDefinitionDelete: "Selected document definition will be deleted. Continue?"
    },
    annualPermitGroups: {
      annualPermitGroupList: "Annual Permit Group List",
      annualPermitGroupNotRecord: "No annual permit group record found.",
      annualPermitGroupInfo: "Annual Permit Group Info",
      newAnnualPermitGroup: "New Annual Permit Group",
      groupName: "Group Name",
      start: "Start",
      end: "End",
      deservedDay: "Deserved Day",
      annualPermitGroupDetailNotRecord: "No annual permit group detail record found.",
      isContinueAnnualPermitGroupUpdate: "Selected annual permit group will be updated. Continue?",
      isContinueAnnualPermitGroupSave: "New annual permit group will be saved. Continue?",
      isContinueAnnualPermitGroupDelete: "Selected annual permit group will be deleted. Continue?"
    },
    scenarios: {
      newScenario: "New Scenario",
      scenarioDetails: "Scenario Details",
      backToScenarios: "Back to Scenarios",
      scenarioRecordNotFound: "Scenario record not found."
    },
    devices: {
      searchDeviceInList: "Search device in list...",
      deviceList: "Device List",
      deviceNotRecord: "No device record found.",
      deviceInfo: "Device Info",
      newDevice: "New Device",
      deviceNumber: "Device No",
      serialNo: "Serial No",
      brand: "Brand",
      platform: "Platform",
      feature: "Feature",
      isPanel: "Panel",
      card: "Card",
      fingerprint: "Fingerprint",
      faceRecognition: "Face Recognition",
      hasAntipassback: "Antipassback",
      hasTimeZone: "Timezone",
      isRealTime: "Real Time Monitoring",
      isOnlineDevice: "Online Control",
      deviceName: "Device Name",
      ipAddress: "Ip Address",
      port: "Port",
      adminPassword: "Admin Password",
      deviceGroup: "Device Group",
      status: "Status",
      readerInformation: "Reader Informations",
      readerList: "Readers",
      newReader: "New Reader",
      selectedDeviceReaderNotFound: "No reader found for the selected device.",
      readerNo: "No",
      readerName: "Reader Name",
      inputName: "Input Name",
      isMainDoor: "Is Main Door",
      typeOfUse: "Type of use",
      access: "Access",
      pdks: "PDKS",
      diningHall: "Dining Hall",
      licencePlateRecognition: "Licence Plate Recognition",
      dormitoryDevice: "Dormitory Device",
      bellOrAlarm: "Bell or Alarm",
      readerStatus: "Status",
      entry: "Entry",
      exit: "Exit",
      readerInfo: "To save a reader, first save device or make a selection from the list.",
      isContinueDeviceUpdate: "Selected device will be updated. Continue?",
      isContinueDeviceSave: "New device will be saved. Continue?",
      isContinueDeviceDelete: "Selected device will be deleted. Continue?",
      isContinueReaderUpdate: "Selected reader will be updated. Continue?",
      isContinueReaderSave: "New reader will be saved. Continue?",
      isContinueReaderDelete: "Selected reader will be deleted. Continue?"
    },
    deviceOperations: {
      addTask: "Add Task",
      deviceNotRecord: "No device record found.",
      startTime: "Start Time",
      selectTask: "Select Task",
      getMovementLogs: "Get movement logs",
      personSetAndDelete: "Person set and delete",
      getPersons: "Get persons",
      sendBatchPersonData: "Send batch person data",
      updateTime: "Update time",
      restart: "Restart",
      removeAdminAuthorizes: "Remove admin authorizes",
      removeAllPerson: "Remove all person",
      sendAuthorityGroups: "Send authority groups",
      sendPlate: "Send plate",
      sendBatchPlates: "Send batch plates",
      repeatDaily: "Repeat Daily",
      applyRepeatDaily: "Apply repeat daily",
      repetitionInterval: "Repetition Interval",
      oneTimePerDay: "1 time per day",
      sendCommand: "Send Command",
      activeTaskList: "Active Task List",
      person: "Person",
      task: "Task",
      device: "Device",
      taskTime: "Task Time",
      repeatDay: "Repeat (daily)",
      noRepeat: "No Repeat",
      activeTaskNotRecord: "No active task record found.",
      isContinueTaskDelete: "Selected task will be deleted. Continue?"
    },
    companySettings: {
      companies: "Companies",
      newCompany: "New Company",
      companyNotRecord: "No company record found.",
      companyLogo: "Company Logo",
      selectPhoto: "Select Photo",
      visitorSettings: "Visitor Settings",
      cardIsNotUsedAccessGroup: "Card is Not Used, Access Group",
      cardIsUsedAccessGroup: "Card is Used, Access Group",
      companyInformation: "Company Information",
      companyName: "Company Name",
      companyTitle: "Company Title",
      phone: "Phone",
      webSite: "Web",
      address: "Address",
      syncRegistrationNoToDeviceNo: "Sync registration number to device number",
      isContinueCompanyUpdate: "Selected company will be updated. Continue?",
      isContinueCompanySave: "New company will be saved. Continue?",
      isContinueCompanyDelete: "Selected company will be deleted. Continue?"
    },
    users: {
      users: "Users",
      newUser: "New User",
      userNotRecord: "No user record found.",
      userPhoto: "User Photo",
      selectPhoto: "Select Photo",
      companyAuthorities: "Company Authorities",
      companyNotRecord: "No company record found.",
      userInformation: "User Information",
      userName: "Username",
      userTitle: "User Title",
      email: "Email",
      authorityGroup: "Authority Group",
      password: "Password",
      repeatPassword: "Repeat Password",
      realTimeMonitorGroup: "Real Time Monitor Group",
      activateSmsSystem: "Activate SMS System",
      phoneNumber: "Phone Number",
      visitorCardGroup: "Visitor Card Group",
      departmentNotRecord: "No department record found.",
      reportAuthorities: "Report Authorities",
      reportNotRecord: "No report record found.",
      isContinueUserUpdate: "Selected user will be updated. Continue?",
      isContinueUserSave: "New user will be saved. Continue?",
      isContinueUserDelete: "Selected user will be deleted. Continue?",
      realTimeMonitorGroups: "Real Time Monitor Groups",
      realTimeMonitorGroupList: "Real Time Monitor Group List",
      newRealTimeMonitorGroup: "New Real Time Monitor Group",
      realTimeMonitorGroupNotRecord: "No real time monitor group record found.",
      groupName: "Group Name",
      deviceNotRecord: "No device record found."
    },
    userAuthorityGroups: {
      userAuthorityGroupList: "User Authority Group List",
      userAuthorityGroupNotRecord: "No user authority group record found.",
      userAuthorityGroupInformation: "User Authority Group Information",
      newAuthorityGroup: "New Authority Group",
      authorityGroupName: "Authority Group Name",
      description: "Description",
      admin: "Admin",
      user: "User",
      authorityInfo: "If no selection is made, it will have full authority.",
      authorities: "Authorities",
      filterAuthorities: "Filter Authorities",
      fullAuthority: "Full Authority",
      onlyView: "Only View",
      cantUse: "Can't Use",
      isContinueUserAuthGroupUpdate: "Selected authority group will be updated. Continue?",
      isContinueUserAuthGroupSave: "New authority group will be saved. Continue?",
      isContinueUserAuthGroupDelete: "Selected authority group will be deleted. Continue?"
    },
    mailSmsSettings: {
      mailSettings: "Mail Settings",
      smsSettings: "SMS Settings",
      automaticMailList: "Automatic Mail List",
      mailDetails: "Mail Details",
      newMailDefinition: "New Mail Definition",
      mailDefinitionName: "Definition Name",
      mailHeader: "Mail Header",
      mailContent: "Mail Content",
      reportType: "Report Type",
      mailSendingTime: "Sending Time",
      day: "Day",
      time: "Time",
      reportsToSubmit: "Reports to Submit",
      byCustomFilter: "By Custom Filter",
      emailAddressesToSend: "Email Addresses to Send",
      enterAEmail: "Enter a email",
      filterGroup: "Current Filter Group",
      byAuthorizedEmployees: "By Authorized Employees",
      authorizedEmployees: "Authorized Employees",
      smsAPIRecordInformation: "SMS API Record Information",
      requestSentLink: "Request Sent Link",
      title: "Title",
      apiKey: "API Key",
      secretKey: "Secret Key",
      userName: "Username",
      password: "Password",
      smsSystem: "SMS System",
      active: "Active",
      dormitorySMSSettings: "SMS Settings",
      smsType: "SMS Type",
      smsContentDescription1: "The content to be sent when the student does not enter at the specified time",
      smsContentDescription2: "Content to be sent when a student checks in late",
      smsContentDescription3: "Content to be sent when student logs out without permission",
      smsContentDescription4: "Content that informs parents when student is allowed",
      parameters: "Parameters",
      studentName: "Student Name",
      todaysDate: "Today's Date",
      movementDate: "Movement Date",
      movementTime: "Movement Time",
      allowenceStartDate: "Allowence Start Date",
      allowenceEndDate: "Allowence End Date",
      allowenceName: "Allowence Name",
      dormitorySMSTimePlan: "SMS Time Plan",
      lastEntryTime: "Last Entry Time",
      updateInformation: "Update Information"
    },
    userLogs: {
      user: "User",
      userLogList: "User Log List",
      userLogs: "User Logs",
      userName: "Username",
      logTime: "Log Time",
      logDescription: "Log Description",
      logNotRecord: "No log record found."
    },
    payrollTypes: {
      payrollTypeList: "Payroll Type List",
      payrollTypeNotRecord: "No payroll type record found.",
      payrollTypeInfo: "Payroll Type Info",
      newPayrollType: "New Payroll Type",
      shortCode: "Short Code",
      payrollName: "Payroll Name",
      payrollType: "Payroll Type",
      payrolls: {
        normalWork: "Normal Work",
        weekendHoliday: "Weekend Holiday",
        publicHoliday: "Public Holiday",
        annualPermit: "Annual Permit",
        absenteeism: "Absenteeism",
        missingHour: "Missing Hour",
        allowence: "Allowence",
        overtime: "Overtime",
        break: "Break",
        nightOvertime: "Night Overtime"
      },
      otherPayrollType: "Other Payroll Type",
      equalPayrollType: "Equal Payroll Type",
      monthlyPayrollColumn: "Monthly Payroll Column",
      maxLimit: "Max Limit",
      multiplier: "Multiplier",
      confirmation: "Confirmation",
      confirmationRequired: "Confirmation Required",
      tolerances: "Tolerances",
      firstTolerance: "First",
      lastTolerance: "Last",
      totalTolerance: "Total",
      isContinuePayrollTypeUpdate: "Selected payroll type will be updated. Continue?",
      isContinuePayrollTypeSave: "New payroll type will be saved. Continue?",
      isContinuePayrollTypeDelete: "Selected payroll type will be deleted. Continue?"
    },
    monthlyPayrollTables: {
      monthlyPayrolColumnlList: "Monthly Payroll List",
      monthlyPayrollTableRecordNotFound: "No monthly payroll table record found.",
      monthlyPayrollInfo: "Monthly Payroll Info",
      newMonthlyPayroll: "New Monthly Payroll",
      shortCode: "Short Code",
      payrollColumnName: "Payroll Column Name",
      ssk: "SSK",
      total: "Total",
      work: "Work",
      isContinueMonthlyPayrollUpdate: "Selected monthly payroll will be updated. Continue?",
      isContinueMonthlyPayrollSave: "New monthly payroll will be saved. Continue?",
      isContinueMonthlyPayrollDelete: "Selected monthly payroll will be deleted. Continue?"
    },
    integration: {
      triggerTransfers: "Trigger Transfers"
    },
    support: {
      whatWouldYouLikeSupportOn: "What would you like support on?",
      subjectYouWantHelpWith: "Subject you want help with",
      searchResults: "Search Results",
      noRecordFound: "No record found."
    },
    guardTour: {
      guards: "Guards",
      newGuard: "New Guard",
      guardInfo: "Guard Info",
      nameSurname: "Name Surname",
      title: "Title",
      updatePassword: "Update Password",
      responsibleUserForGuard: "Responsible User for Guard",
      tourCalendar: "Tour Calendar",
      newCalendar: "New Calendar"
    }
  })]
}));

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MLBuilder = exports.MLanguage = exports.MLCreate = exports.MLInstaller = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _vue = __webpack_require__(35);

var _install2 = __webpack_require__(262);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable */
// @ts-check


/**
 * @typedef {Object} VueMultiLanguageParams
 * @property {String} initial
 * @property {Array} languages
 * @property {Boolean} [save]
 * @property {Function} [middleware]
 * @property {String} [gettingStrategy]
 */

/**  @type {VueMultiLanguageParams} */
var options = {
  initial: null,
  languages: [],
  save: false,
  middleware: null,
  gettingStrategy: ''

  /** @type {VueConstructor} */
};var Vue = void 0;

var MLInstaller =
/**
   * function for install plugin with Vue.use
   * @param {VueConstructor} _Vue Vue constructor
   */
exports.MLInstaller = function MLInstaller(_Vue) {
  Vue = _Vue;
};

var MLCreate =
/**
 * Constructor
 * @param {VueMultiLanguageParams} _options object of settings
 */
exports.MLCreate = function MLCreate(_options) {
  _classCallCheck(this, MLCreate);

  options = _options;
  (0, _install2._install)(Vue, options);
};

var MLanguage = exports.MLanguage = function () {
  /**
   * Create new language
   * @param {string} name language name
   */
  function MLanguage(name) {
    _classCallCheck(this, MLanguage);

    this.name = name;
  }

  /**
   * Create new language with pharses
   * @param {Object}  database object with all language pharses
   * @return {Object} object with language sentences
   */


  _createClass(MLanguage, [{
    key: 'create',
    value: function create(database) {
      var name = this.name;

      return { name: name, database: database };
    }
  }]);

  return MLanguage;
}();

var MLBuilder = exports.MLBuilder = function () {
  /**
   * Create new language builder
   * @param {string} path language path
   */
  function MLBuilder(path) {
    _classCallCheck(this, MLBuilder);

    this.path = path;
    this._with = null;
  }

  /**
   * Create new language with pharses
   * @param {String}  name name or value from message
   * @param {String|Boolean}  value value from message
   * @return {MLBuilder} builder
   */


  _createClass(MLBuilder, [{
    key: 'with',
    value: function _with(name) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (value !== false) {
        if (this._with === null) {
          this._with = [];
        }
        // @ts-ignore
        this._with.push({
          name: name,
          value: value
        });
      } else {
        this._with = [name];
      }
      return this;
    }
  }]);

  return MLBuilder;
}();

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GettingStrategy = exports.GettingStrategy = {
  DEFAULT: 'default',
  RETURN_PATH_BY_DEFAULT: 'return-path-by-default',
  RETURN_PATH_BY_DEFAULT_WITHOUT_ERROR: 'return-path-by-default-without-error'
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_Header__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_Footer__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_Sidebar__ = __webpack_require__(286);
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_0__shared_Header__["a" /* default */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__shared_Sidebar__["a" /* default */],
    Footer: __WEBPACK_IMPORTED_MODULE_1__shared_Footer__["a" /* default */]
  }
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__microsoft_signalr__ = __webpack_require__(81);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        userName: "",
        title: "",
        profileUrl: null
      },
      authMap: {
        canliIzleme: 2,
        kisiler: 2,
        gecisYetkileri: 2,
        raporlar: 2,
        ayarlar: 2,
        tanimlamalar: 2,
        ziyaretciTakip: 2,
        yemekhane: 2,
        creditSale: 2,
        dashboard: 2,
        shiftYonetimi: 2,
        puantajYonetimi: 2,
        shiftYetkileri: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: false,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        }
      },
      defaultLanguage: "",
      totalNotify: 0,
      notifications: [],
      isCompanies: false
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    notificationList: function notificationList() {
      return this.notifications;
    },
    baseURL: function baseURL() {
      return this.$store.getters.getBaseURL;
    },
    activeUser: function activeUser() {
      return this.$store.getters.getUser;
    }
  },
  mounted: function mounted() {
    var _this = this;

    var hubConnection = new __WEBPACK_IMPORTED_MODULE_1__microsoft_signalr__["a" /* HubConnectionBuilder */]().withUrl(this.baseURL + "/notifyhub").withAutomaticReconnect().build();
    // connecting to the hub
    hubConnection.start().then(function () {
      console.log("connection started");
      _this.connection = true;
    }).catch(function (err) {
      console.log("connecting hub failed err is : ", err);
      _this.connection = false;
    });

    hubConnection.on("serviceNotify", function (result) {
      if (result.userId == _this.activeUser.id) {
        alertify.success(result.message);
      }
    });

    hubConnection.onclose(function () {
      console.log("connection failed");
      _this.connection = false;
    });
  },

  methods: {
    authControl: function authControl(data) {
      if (data != null) {
        if (data == 2) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    changeLanguage: function changeLanguage(lang) {
      this.$ml.change(lang);
      this.defaultLanguage = lang;
      localStorage.setItem("lang", this.defaultLanguage);
    },
    getCompanySettings: function getCompanySettings() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var requiredFields, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoading = true;
                requiredFields = [];
                _context.next = 5;
                return _this2.$axios.get("/CompanySettings/1").then(function (response) {
                  if (response.status == 200) {
                    requiredFields = response.data.requiredFields;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;
                _context.next = 8;
                return _this2.$store.commit("setRequiredFields", requiredFields);

              case 8:
                _this2.isLoading = false;
                _context.next = 16;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error("Hata : " + _context.t0.message);
                _this2.isLoading = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 11]]);
      }))();
    },
    getAuthority: function getAuthority() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var authMap, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.isLoading = true;
                authMap = {};
                _context2.next = 5;
                return _this3.$axios.get("/User/GetAuthMap").then(function (response) {
                  if (response.status == 200) {
                    authMap.canliIzleme = response.data.canliIzleme;
                    authMap.kisiler = response.data.kisiler;
                    authMap.gecisYetkileri = response.data.gecisYetkileri;
                    authMap.raporlar = response.data.raporlar;
                    authMap.ayarlar = response.data.ayarlar;
                    authMap.tanimlamalar = response.data.tanimlamalar;
                    authMap.ziyaretciTakip = response.data.ziyaretciTakip;
                    authMap.yemekhane = response.data.yemekhane;
                    authMap.dashboard = response.data.dashboard;
                    authMap.creditSale = response.data.creditSale;
                    authMap.shiftYonetimi = response.data.shiftYonetimi;
                    authMap.puantajYonetimi = response.data.puantajYonetimi;
                    authMap.shiftYetkileri = response.data.shiftYetkileri;
                    authMap.bekciTur = response.data.bekciTur;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this3.authMap = authMap;
                _context2.next = 9;
                return _this3.$store.commit("setAuthority", authMap);

              case 9:
                _this3.isLoading = false;
                _context2.next = 17;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Hata : " + _context2.t0.message);
                _this3.isLoading = false;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    },
    getNotifications: function getNotifications() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var notifications2, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.isLoading = true;
                notifications2 = [];
                _context3.next = 5;
                return _this4.$axios.get("/Notifications").then(function (response) {
                  response.data.forEach(function (doc) {
                    notifications2.push({
                      id: doc.id,
                      type: doc.type,
                      time: doc.time,
                      description: doc.description
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this4.notifications = notifications2;
                _this4.totalNotify = notifications2.length;
                _this4.isLoading = false;
                _context3.next = 16;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);
                _this4.isLoading = false;

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 11]]);
      }))();
    },
    logOut: function logOut() {
      this.$store.dispatch("logout");
    },
    goToMyProfile: function goToMyProfile() {
      this.$router.replace("/my-profile");
    }
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.getAuthority();

            case 2:
              _context4.next = 4;
              return _this5.getCompanySettings();

            case 4:
              _this5.user = _this5.$store.getters.getUser;
              _context4.next = 7;
              return _this5.getNotifications();

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FetchHttpClient__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HttpClient__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__XhrHttpClient__ = __webpack_require__(270);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** Default implementation of {@link @microsoft/signalr.HttpClient}. */
var DefaultHttpClient = /** @class */ (function (_super) {
    __extends(DefaultHttpClient, _super);
    /** Creates a new instance of the {@link @microsoft/signalr.DefaultHttpClient}, using the provided {@link @microsoft/signalr.ILogger} to log messages. */
    function DefaultHttpClient(logger) {
        var _this = _super.call(this) || this;
        if (typeof fetch !== "undefined" || __WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* Platform */].isNode) {
            _this.httpClient = new __WEBPACK_IMPORTED_MODULE_1__FetchHttpClient__["a" /* FetchHttpClient */](logger);
        }
        else if (typeof XMLHttpRequest !== "undefined") {
            _this.httpClient = new __WEBPACK_IMPORTED_MODULE_4__XhrHttpClient__["a" /* XhrHttpClient */](logger);
        }
        else {
            throw new Error("No usable HttpClient found.");
        }
        return _this;
    }
    /** @inheritDoc */
    DefaultHttpClient.prototype.send = function (request) {
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return this.httpClient.send(request);
    };
    DefaultHttpClient.prototype.getCookieString = function (url) {
        return this.httpClient.getCookieString(url);
    };
    return DefaultHttpClient;
}(__WEBPACK_IMPORTED_MODULE_2__HttpClient__["a" /* HttpClient */]));

//# sourceMappingURL=DefaultHttpClient.js.map

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubConnectionState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubConnection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HandshakeProtocol__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Subject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





var DEFAULT_TIMEOUT_IN_MS = 30 * 1000;
var DEFAULT_PING_INTERVAL_IN_MS = 15 * 1000;
/** Describes the current state of the {@link HubConnection} to the server. */
var HubConnectionState;
(function (HubConnectionState) {
    /** The hub connection is disconnected. */
    HubConnectionState["Disconnected"] = "Disconnected";
    /** The hub connection is connecting. */
    HubConnectionState["Connecting"] = "Connecting";
    /** The hub connection is connected. */
    HubConnectionState["Connected"] = "Connected";
    /** The hub connection is disconnecting. */
    HubConnectionState["Disconnecting"] = "Disconnecting";
    /** The hub connection is reconnecting. */
    HubConnectionState["Reconnecting"] = "Reconnecting";
})(HubConnectionState || (HubConnectionState = {}));
/** Represents a connection to a SignalR Hub. */
var HubConnection = /** @class */ (function () {
    function HubConnection(connection, logger, protocol, reconnectPolicy) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(connection, "connection");
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(logger, "logger");
        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(protocol, "protocol");
        this.serverTimeoutInMilliseconds = DEFAULT_TIMEOUT_IN_MS;
        this.keepAliveIntervalInMilliseconds = DEFAULT_PING_INTERVAL_IN_MS;
        this.logger = logger;
        this.protocol = protocol;
        this.connection = connection;
        this.reconnectPolicy = reconnectPolicy;
        this.handshakeProtocol = new __WEBPACK_IMPORTED_MODULE_0__HandshakeProtocol__["a" /* HandshakeProtocol */]();
        this.connection.onreceive = function (data) { return _this.processIncomingData(data); };
        this.connection.onclose = function (error) { return _this.connectionClosed(error); };
        this.callbacks = {};
        this.methods = {};
        this.closedCallbacks = [];
        this.reconnectingCallbacks = [];
        this.reconnectedCallbacks = [];
        this.invocationId = 0;
        this.receivedHandshakeResponse = false;
        this.connectionState = HubConnectionState.Disconnected;
        this.connectionStarted = false;
        this.cachedPingMessage = this.protocol.writeMessage({ type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Ping });
    }
    /** @internal */
    // Using a public static factory method means we can have a private constructor and an _internal_
    // create method that can be used by HubConnectionBuilder. An "internal" constructor would just
    // be stripped away and the '.d.ts' file would have no constructor, which is interpreted as a
    // public parameter-less constructor.
    HubConnection.create = function (connection, logger, protocol, reconnectPolicy) {
        return new HubConnection(connection, logger, protocol, reconnectPolicy);
    };
    Object.defineProperty(HubConnection.prototype, "state", {
        /** Indicates the state of the {@link HubConnection} to the server. */
        get: function () {
            return this.connectionState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "connectionId", {
        /** Represents the connection id of the {@link HubConnection} on the server. The connection id will be null when the connection is either
         *  in the disconnected state or if the negotiation step was skipped.
         */
        get: function () {
            return this.connection ? (this.connection.connectionId || null) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HubConnection.prototype, "baseUrl", {
        /** Indicates the url of the {@link HubConnection} to the server. */
        get: function () {
            return this.connection.baseUrl || "";
        },
        /**
         * Sets a new url for the HubConnection. Note that the url can only be changed when the connection is in either the Disconnected or
         * Reconnecting states.
         * @param {string} url The url to connect to.
         */
        set: function (url) {
            if (this.connectionState !== HubConnectionState.Disconnected && this.connectionState !== HubConnectionState.Reconnecting) {
                throw new Error("The HubConnection must be in the Disconnected or Reconnecting state to change the url.");
            }
            if (!url) {
                throw new Error("The HubConnection url must be a valid url.");
            }
            this.connection.baseUrl = url;
        },
        enumerable: true,
        configurable: true
    });
    /** Starts the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully established, or rejects with an error.
     */
    HubConnection.prototype.start = function () {
        this.startPromise = this.startWithStateTransitions();
        return this.startPromise;
    };
    HubConnection.prototype.startWithStateTransitions = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState !== HubConnectionState.Disconnected) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start a HubConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = HubConnectionState.Connecting;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Starting HubConnection.");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternal()];
                    case 2:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.connectionStarted = true;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection connected successfully.");
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.connectionState = HubConnectionState.Disconnected;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection failed to start successfully because of error '" + e_1 + "'.");
                        return [2 /*return*/, Promise.reject(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.startInternal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var handshakePromise, handshakeRequest, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stopDuringStartError = undefined;
                        this.receivedHandshakeResponse = false;
                        handshakePromise = new Promise(function (resolve, reject) {
                            _this.handshakeResolver = resolve;
                            _this.handshakeRejecter = reject;
                        });
                        return [4 /*yield*/, this.connection.start(this.protocol.transferFormat)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 7]);
                        handshakeRequest = {
                            protocol: this.protocol.name,
                            version: this.protocol.version,
                        };
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Sending handshake request.");
                        return [4 /*yield*/, this.sendMessage(this.handshakeProtocol.writeHandshakeRequest(handshakeRequest))];
                    case 3:
                        _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Using HubProtocol '" + this.protocol.name + "'.");
                        // defensively cleanup timeout in case we receive a message from the server before we finish start
                        this.cleanupTimeout();
                        this.resetTimeoutPeriod();
                        this.resetKeepAliveInterval();
                        return [4 /*yield*/, handshakePromise];
                    case 4:
                        _a.sent();
                        // It's important to check the stopDuringStartError instead of just relying on the handshakePromise
                        // being rejected on close, because this continuation can run after both the handshake completed successfully
                        // and the connection was closed.
                        if (this.stopDuringStartError) {
                            // It's important to throw instead of returning a rejected promise, because we don't want to allow any state
                            // transitions to occur between now and the calling code observing the exceptions. Returning a rejected promise
                            // will cause the calling continuation to get scheduled to run later.
                            throw this.stopDuringStartError;
                        }
                        return [3 /*break*/, 7];
                    case 5:
                        e_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Hub handshake failed with error '" + e_2 + "' during start(). Stopping HubConnection.");
                        this.cleanupTimeout();
                        this.cleanupPingTimer();
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        return [4 /*yield*/, this.connection.stop(e_2)];
                    case 6:
                        // HttpConnection.stop() should not complete until after the onclose callback is invoked.
                        // This will transition the HubConnection to the disconnected state before HttpConnection.stop() completes.
                        _a.sent();
                        throw e_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    /** Stops the connection.
     *
     * @returns {Promise<void>} A Promise that resolves when the connection has been successfully terminated, or rejects with an error.
     */
    HubConnection.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var startPromise, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        startPromise = this.startPromise;
                        this.stopPromise = this.stopInternal();
                        return [4 /*yield*/, this.stopPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        // Awaiting undefined continues immediately
                        return [4 /*yield*/, startPromise];
                    case 3:
                        // Awaiting undefined continues immediately
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_3 = _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.stopInternal = function (error) {
        if (this.connectionState === HubConnectionState.Disconnected) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Call to HubConnection.stop(" + error + ") ignored because it is already in the disconnected state.");
            return Promise.resolve();
        }
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
            return this.stopPromise;
        }
        this.connectionState = HubConnectionState.Disconnecting;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Stopping HubConnection.");
        if (this.reconnectDelayHandle) {
            // We're in a reconnect delay which means the underlying connection is currently already stopped.
            // Just clear the handle to stop the reconnect loop (which no one is waiting on thankfully) and
            // fire the onclose callbacks.
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection stopped during reconnect delay. Done reconnecting.");
            clearTimeout(this.reconnectDelayHandle);
            this.reconnectDelayHandle = undefined;
            this.completeClose();
            return Promise.resolve();
        }
        this.cleanupTimeout();
        this.cleanupPingTimer();
        this.stopDuringStartError = error || new Error("The connection was stopped before the hub handshake could complete.");
        // HttpConnection.stop() should not complete until after either HttpConnection.start() fails
        // or the onclose callback is invoked. The onclose callback will transition the HubConnection
        // to the disconnected state if need be before HttpConnection.stop() completes.
        return this.connection.stop(error);
    };
    /** Invokes a streaming hub method on the server using the specified name and arguments.
     *
     * @typeparam T The type of the items returned by the server.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {IStreamResult<T>} An object that yields results from the server as they are received.
     */
    HubConnection.prototype.stream = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createStreamInvocation(methodName, args, streamIds);
        var promiseQueue;
        var subject = new __WEBPACK_IMPORTED_MODULE_3__Subject__["a" /* Subject */]();
        subject.cancelCallback = function () {
            var cancelInvocation = _this.createCancelInvocation(invocationDescriptor.invocationId);
            delete _this.callbacks[invocationDescriptor.invocationId];
            return promiseQueue.then(function () {
                return _this.sendWithProtocol(cancelInvocation);
            });
        };
        this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
            if (error) {
                subject.error(error);
                return;
            }
            else if (invocationEvent) {
                // invocationEvent will not be null when an error is not passed to the callback
                if (invocationEvent.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                    if (invocationEvent.error) {
                        subject.error(new Error(invocationEvent.error));
                    }
                    else {
                        subject.complete();
                    }
                }
                else {
                    subject.next((invocationEvent.item));
                }
            }
        };
        promiseQueue = this.sendWithProtocol(invocationDescriptor)
            .catch(function (e) {
            subject.error(e);
            delete _this.callbacks[invocationDescriptor.invocationId];
        });
        this.launchStreams(streams, promiseQueue);
        return subject;
    };
    HubConnection.prototype.sendMessage = function (message) {
        this.resetKeepAliveInterval();
        return this.connection.send(message);
    };
    /**
     * Sends a js object to the server.
     * @param message The js object to serialize and send.
     */
    HubConnection.prototype.sendWithProtocol = function (message) {
        return this.sendMessage(this.protocol.writeMessage(message));
    };
    /** Invokes a hub method on the server using the specified name and arguments. Does not wait for a response from the receiver.
     *
     * The Promise returned by this method resolves when the client has sent the invocation to the server. The server may still
     * be processing the invocation.
     *
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<void>} A Promise that resolves when the invocation has been successfully sent, or rejects with an error.
     */
    HubConnection.prototype.send = function (methodName) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var sendPromise = this.sendWithProtocol(this.createInvocation(methodName, args, true, streamIds));
        this.launchStreams(streams, sendPromise);
        return sendPromise;
    };
    /** Invokes a hub method on the server using the specified name and arguments.
     *
     * The Promise returned by this method resolves when the server indicates it has finished invoking the method. When the promise
     * resolves, the server has finished invoking the method. If the server method returns a result, it is produced as the result of
     * resolving the Promise.
     *
     * @typeparam T The expected return type.
     * @param {string} methodName The name of the server method to invoke.
     * @param {any[]} args The arguments used to invoke the server method.
     * @returns {Promise<T>} A Promise that resolves with the result of the server method (if any), or rejects with an error.
     */
    HubConnection.prototype.invoke = function (methodName) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a = this.replaceStreamingParams(args), streams = _a[0], streamIds = _a[1];
        var invocationDescriptor = this.createInvocation(methodName, args, false, streamIds);
        var p = new Promise(function (resolve, reject) {
            // invocationId will always have a value for a non-blocking invocation
            _this.callbacks[invocationDescriptor.invocationId] = function (invocationEvent, error) {
                if (error) {
                    reject(error);
                    return;
                }
                else if (invocationEvent) {
                    // invocationEvent will not be null when an error is not passed to the callback
                    if (invocationEvent.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                        if (invocationEvent.error) {
                            reject(new Error(invocationEvent.error));
                        }
                        else {
                            resolve(invocationEvent.result);
                        }
                    }
                    else {
                        reject(new Error("Unexpected message type: " + invocationEvent.type));
                    }
                }
            };
            var promiseQueue = _this.sendWithProtocol(invocationDescriptor)
                .catch(function (e) {
                reject(e);
                // invocationId will always have a value for a non-blocking invocation
                delete _this.callbacks[invocationDescriptor.invocationId];
            });
            _this.launchStreams(streams, promiseQueue);
        });
        return p;
    };
    /** Registers a handler that will be invoked when the hub method with the specified method name is invoked.
     *
     * @param {string} methodName The name of the hub method to define.
     * @param {Function} newMethod The handler that will be raised when the hub method is invoked.
     */
    HubConnection.prototype.on = function (methodName, newMethod) {
        if (!methodName || !newMethod) {
            return;
        }
        methodName = methodName.toLowerCase();
        if (!this.methods[methodName]) {
            this.methods[methodName] = [];
        }
        // Preventing adding the same handler multiple times.
        if (this.methods[methodName].indexOf(newMethod) !== -1) {
            return;
        }
        this.methods[methodName].push(newMethod);
    };
    HubConnection.prototype.off = function (methodName, method) {
        if (!methodName) {
            return;
        }
        methodName = methodName.toLowerCase();
        var handlers = this.methods[methodName];
        if (!handlers) {
            return;
        }
        if (method) {
            var removeIdx = handlers.indexOf(method);
            if (removeIdx !== -1) {
                handlers.splice(removeIdx, 1);
                if (handlers.length === 0) {
                    delete this.methods[methodName];
                }
            }
        }
        else {
            delete this.methods[methodName];
        }
    };
    /** Registers a handler that will be invoked when the connection is closed.
     *
     * @param {Function} callback The handler that will be invoked when the connection is closed. Optionally receives a single argument containing the error that caused the connection to close (if any).
     */
    HubConnection.prototype.onclose = function (callback) {
        if (callback) {
            this.closedCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection starts reconnecting.
     *
     * @param {Function} callback The handler that will be invoked when the connection starts reconnecting. Optionally receives a single argument containing the error that caused the connection to start reconnecting (if any).
     */
    HubConnection.prototype.onreconnecting = function (callback) {
        if (callback) {
            this.reconnectingCallbacks.push(callback);
        }
    };
    /** Registers a handler that will be invoked when the connection successfully reconnects.
     *
     * @param {Function} callback The handler that will be invoked when the connection successfully reconnects.
     */
    HubConnection.prototype.onreconnected = function (callback) {
        if (callback) {
            this.reconnectedCallbacks.push(callback);
        }
    };
    HubConnection.prototype.processIncomingData = function (data) {
        this.cleanupTimeout();
        if (!this.receivedHandshakeResponse) {
            data = this.processHandshakeResponse(data);
            this.receivedHandshakeResponse = true;
        }
        // Data may have all been read when processing handshake response
        if (data) {
            // Parse the messages
            var messages = this.protocol.parseMessages(data, this.logger);
            for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
                var message = messages_1[_i];
                switch (message.type) {
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation:
                        this.invokeClientMethod(message);
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamItem:
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion:
                        var callback = this.callbacks[message.invocationId];
                        if (callback) {
                            if (message.type === __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion) {
                                delete this.callbacks[message.invocationId];
                            }
                            callback(message);
                        }
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Ping:
                        // Don't care about pings
                        break;
                    case __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Close:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Close message received from server.");
                        var error = message.error ? new Error("Server returned an error on close: " + message.error) : undefined;
                        if (message.allowReconnect === true) {
                            // It feels wrong not to await connection.stop() here, but processIncomingData is called as part of an onreceive callback which is not async,
                            // this is already the behavior for serverTimeout(), and HttpConnection.Stop() should catch and log all possible exceptions.
                            // tslint:disable-next-line:no-floating-promises
                            this.connection.stop(error);
                        }
                        else {
                            // We cannot await stopInternal() here, but subsequent calls to stop() will await this if stopInternal() is still ongoing.
                            this.stopPromise = this.stopInternal(error);
                        }
                        break;
                    default:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Invalid message type: " + message.type + ".");
                        break;
                }
            }
        }
        this.resetTimeoutPeriod();
    };
    HubConnection.prototype.processHandshakeResponse = function (data) {
        var _a;
        var responseMessage;
        var remainingData;
        try {
            _a = this.handshakeProtocol.parseHandshakeResponse(data), remainingData = _a[0], responseMessage = _a[1];
        }
        catch (e) {
            var message = "Error parsing handshake response: " + e;
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        if (responseMessage.error) {
            var message = "Server returned handshake error: " + responseMessage.error;
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
            var error = new Error(message);
            this.handshakeRejecter(error);
            throw error;
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Server handshake complete.");
        }
        this.handshakeResolver();
        return remainingData;
    };
    HubConnection.prototype.resetKeepAliveInterval = function () {
        var _this = this;
        if (this.connection.features.inherentKeepAlive) {
            return;
        }
        this.cleanupPingTimer();
        this.pingServerHandle = setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.connectionState === HubConnectionState.Connected)) return [3 /*break*/, 4];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.sendMessage(this.cachedPingMessage)];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        _a = _b.sent();
                        // We don't care about the error. It should be seen elsewhere in the client.
                        // The connection is probably in a bad or closed state now, cleanup the timer so it stops triggering
                        this.cleanupPingTimer();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, this.keepAliveIntervalInMilliseconds);
    };
    HubConnection.prototype.resetTimeoutPeriod = function () {
        var _this = this;
        if (!this.connection.features || !this.connection.features.inherentKeepAlive) {
            // Set the timeout timer
            this.timeoutHandle = setTimeout(function () { return _this.serverTimeout(); }, this.serverTimeoutInMilliseconds);
        }
    };
    HubConnection.prototype.serverTimeout = function () {
        // The server hasn't talked to us in a while. It doesn't like us anymore ... :(
        // Terminate the connection, but we don't need to wait on the promise. This could trigger reconnecting.
        // tslint:disable-next-line:no-floating-promises
        this.connection.stop(new Error("Server timeout elapsed without receiving a message from the server."));
    };
    HubConnection.prototype.invokeClientMethod = function (invocationMessage) {
        var _this = this;
        var methods = this.methods[invocationMessage.target.toLowerCase()];
        if (methods) {
            try {
                methods.forEach(function (m) { return m.apply(_this, invocationMessage.arguments); });
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "A callback for the method " + invocationMessage.target.toLowerCase() + " threw error '" + e + "'.");
            }
            if (invocationMessage.invocationId) {
                // This is not supported in v1. So we return an error to avoid blocking the server waiting for the response.
                var message = "Server requested a response, which is not supported in this version of the client.";
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, message);
                // We don't want to wait on the stop itself.
                this.stopPromise = this.stopInternal(new Error(message));
            }
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "No client method with the name '" + invocationMessage.target + "' found.");
        }
    };
    HubConnection.prototype.connectionClosed = function (error) {
        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "HubConnection.connectionClosed(" + error + ") called while in state " + this.connectionState + ".");
        // Triggering this.handshakeRejecter is insufficient because it could already be resolved without the continuation having run yet.
        this.stopDuringStartError = this.stopDuringStartError || error || new Error("The underlying connection was closed before the hub handshake could complete.");
        // If the handshake is in progress, start will be waiting for the handshake promise, so we complete it.
        // If it has already completed, this should just noop.
        if (this.handshakeResolver) {
            this.handshakeResolver();
        }
        this.cancelCallbacksWithError(error || new Error("Invocation canceled due to the underlying connection being closed."));
        this.cleanupTimeout();
        this.cleanupPingTimer();
        if (this.connectionState === HubConnectionState.Disconnecting) {
            this.completeClose(error);
        }
        else if (this.connectionState === HubConnectionState.Connected && this.reconnectPolicy) {
            // tslint:disable-next-line:no-floating-promises
            this.reconnect(error);
        }
        else if (this.connectionState === HubConnectionState.Connected) {
            this.completeClose(error);
        }
        // If none of the above if conditions were true were called the HubConnection must be in either:
        // 1. The Connecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail it.
        // 2. The Reconnecting state in which case the handshakeResolver will complete it and stopDuringStartError will fail the current reconnect attempt
        //    and potentially continue the reconnect() loop.
        // 3. The Disconnected state in which case we're already done.
    };
    HubConnection.prototype.completeClose = function (error) {
        var _this = this;
        if (this.connectionStarted) {
            this.connectionState = HubConnectionState.Disconnected;
            this.connectionStarted = false;
            try {
                this.closedCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onclose callback called with error '" + error + "' threw error '" + e + "'.");
            }
        }
    };
    HubConnection.prototype.reconnect = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var reconnectStartTime, previousReconnectAttempts, retryError, nextRetryDelay, e_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        reconnectStartTime = Date.now();
                        previousReconnectAttempts = 0;
                        retryError = error !== undefined ? error : new Error("Attempting to reconnect due to a unknown error.");
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, 0, retryError);
                        if (nextRetryDelay === null) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection not reconnecting because the IRetryPolicy returned null on the first reconnect attempt.");
                            this.completeClose(error);
                            return [2 /*return*/];
                        }
                        this.connectionState = HubConnectionState.Reconnecting;
                        if (error) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Connection reconnecting because of error '" + error + "'.");
                        }
                        else {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Connection reconnecting.");
                        }
                        if (this.onreconnecting) {
                            try {
                                this.reconnectingCallbacks.forEach(function (c) { return c.apply(_this, [error]); });
                            }
                            catch (e) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onreconnecting callback called with error '" + error + "' threw error '" + e + "'.");
                            }
                            // Exit early if an onreconnecting callback called connection.stop().
                            if (this.connectionState !== HubConnectionState.Reconnecting) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection left the reconnecting state in onreconnecting callback. Done reconnecting.");
                                return [2 /*return*/];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        if (!(nextRetryDelay !== null)) return [3 /*break*/, 7];
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect attempt number " + previousReconnectAttempts + " will start in " + nextRetryDelay + " ms.");
                        return [4 /*yield*/, new Promise(function (resolve) {
                                _this.reconnectDelayHandle = setTimeout(resolve, nextRetryDelay);
                            })];
                    case 2:
                        _a.sent();
                        this.reconnectDelayHandle = undefined;
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection left the reconnecting state during reconnect delay. Done reconnecting.");
                            return [2 /*return*/];
                        }
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.startInternal()];
                    case 4:
                        _a.sent();
                        this.connectionState = HubConnectionState.Connected;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "HubConnection reconnected successfully.");
                        if (this.onreconnected) {
                            try {
                                this.reconnectedCallbacks.forEach(function (c) { return c.apply(_this, [_this.connection.connectionId]); });
                            }
                            catch (e) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "An onreconnected callback called with connectionId '" + this.connection.connectionId + "; threw error '" + e + "'.");
                            }
                        }
                        return [2 /*return*/];
                    case 5:
                        e_4 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect attempt failed because of error '" + e_4 + "'.");
                        if (this.connectionState !== HubConnectionState.Reconnecting) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Debug, "Connection left the reconnecting state during reconnect attempt. Done reconnecting.");
                            return [2 /*return*/];
                        }
                        retryError = e_4 instanceof Error ? e_4 : new Error(e_4.toString());
                        nextRetryDelay = this.getNextRetryDelay(previousReconnectAttempts++, Date.now() - reconnectStartTime, retryError);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "Reconnect retries have been exhausted after " + (Date.now() - reconnectStartTime) + " ms and " + previousReconnectAttempts + " failed attempts. Connection disconnecting.");
                        this.completeClose();
                        return [2 /*return*/];
                }
            });
        });
    };
    HubConnection.prototype.getNextRetryDelay = function (previousRetryCount, elapsedMilliseconds, retryReason) {
        try {
            return this.reconnectPolicy.nextRetryDelayInMilliseconds({
                elapsedMilliseconds: elapsedMilliseconds,
                previousRetryCount: previousRetryCount,
                retryReason: retryReason,
            });
        }
        catch (e) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "IRetryPolicy.nextRetryDelayInMilliseconds(" + previousRetryCount + ", " + elapsedMilliseconds + ") threw error '" + e + "'.");
            return null;
        }
    };
    HubConnection.prototype.cancelCallbacksWithError = function (error) {
        var callbacks = this.callbacks;
        this.callbacks = {};
        Object.keys(callbacks)
            .forEach(function (key) {
            var callback = callbacks[key];
            callback(null, error);
        });
    };
    HubConnection.prototype.cleanupPingTimer = function () {
        if (this.pingServerHandle) {
            clearTimeout(this.pingServerHandle);
        }
    };
    HubConnection.prototype.cleanupTimeout = function () {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }
    };
    HubConnection.prototype.createInvocation = function (methodName, args, nonblocking, streamIds) {
        if (nonblocking) {
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    streamIds: streamIds,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
        }
        else {
            var invocationId = this.invocationId;
            this.invocationId++;
            if (streamIds.length !== 0) {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    streamIds: streamIds,
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
            else {
                return {
                    arguments: args,
                    invocationId: invocationId.toString(),
                    target: methodName,
                    type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Invocation,
                };
            }
        }
    };
    HubConnection.prototype.launchStreams = function (streams, promiseQueue) {
        var _this = this;
        if (streams.length === 0) {
            return;
        }
        // Synchronize stream data so they arrive in-order on the server
        if (!promiseQueue) {
            promiseQueue = Promise.resolve();
        }
        var _loop_1 = function (streamId) {
            streams[streamId].subscribe({
                complete: function () {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId)); });
                },
                error: function (err) {
                    var message;
                    if (err instanceof Error) {
                        message = err.message;
                    }
                    else if (err && err.toString) {
                        message = err.toString();
                    }
                    else {
                        message = "Unknown error";
                    }
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createCompletionMessage(streamId, message)); });
                },
                next: function (item) {
                    promiseQueue = promiseQueue.then(function () { return _this.sendWithProtocol(_this.createStreamItemMessage(streamId, item)); });
                },
            });
        };
        // We want to iterate over the keys, since the keys are the stream ids
        // tslint:disable-next-line:forin
        for (var streamId in streams) {
            _loop_1(streamId);
        }
    };
    HubConnection.prototype.replaceStreamingParams = function (args) {
        var streams = [];
        var streamIds = [];
        for (var i = 0; i < args.length; i++) {
            var argument = args[i];
            if (this.isObservable(argument)) {
                var streamId = this.invocationId;
                this.invocationId++;
                // Store the stream for later use
                streams[streamId] = argument;
                streamIds.push(streamId.toString());
                // remove stream from args
                args.splice(i, 1);
            }
        }
        return [streams, streamIds];
    };
    HubConnection.prototype.isObservable = function (arg) {
        // This allows other stream implementations to just work (like rxjs)
        return arg && arg.subscribe && typeof arg.subscribe === "function";
    };
    HubConnection.prototype.createStreamInvocation = function (methodName, args, streamIds) {
        var invocationId = this.invocationId;
        this.invocationId++;
        if (streamIds.length !== 0) {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                streamIds: streamIds,
                target: methodName,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamInvocation,
            };
        }
        else {
            return {
                arguments: args,
                invocationId: invocationId.toString(),
                target: methodName,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamInvocation,
            };
        }
    };
    HubConnection.prototype.createCancelInvocation = function (id) {
        return {
            invocationId: id,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].CancelInvocation,
        };
    };
    HubConnection.prototype.createStreamItemMessage = function (id, item) {
        return {
            invocationId: id,
            item: item,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].StreamItem,
        };
    };
    HubConnection.prototype.createCompletionMessage = function (id, error, result) {
        if (error) {
            return {
                error: error,
                invocationId: id,
                type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion,
            };
        }
        return {
            invocationId: id,
            result: result,
            type: __WEBPACK_IMPORTED_MODULE_1__IHubProtocol__["a" /* MessageType */].Completion,
        };
    };
    return HubConnection;
}());

//# sourceMappingURL=HubConnection.js.map

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextMessageFormat; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Not exported from index
/** @private */
var TextMessageFormat = /** @class */ (function () {
    function TextMessageFormat() {
    }
    TextMessageFormat.write = function (output) {
        return "" + output + TextMessageFormat.RecordSeparator;
    };
    TextMessageFormat.parse = function (input) {
        if (input[input.length - 1] !== TextMessageFormat.RecordSeparator) {
            throw new Error("Message is incomplete.");
        }
        var messages = input.split(TextMessageFormat.RecordSeparator);
        messages.pop();
        return messages;
    };
    TextMessageFormat.RecordSeparatorCode = 0x1e;
    TextMessageFormat.RecordSeparator = String.fromCharCode(TextMessageFormat.RecordSeparatorCode);
    return TextMessageFormat;
}());

//# sourceMappingURL=TextMessageFormat.js.map

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

/** Stream implementation to stream items to the server. */
var Subject = /** @class */ (function () {
    function Subject() {
        this.observers = [];
    }
    Subject.prototype.next = function (item) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            observer.next(item);
        }
    };
    Subject.prototype.error = function (err) {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.error) {
                observer.error(err);
            }
        }
    };
    Subject.prototype.complete = function () {
        for (var _i = 0, _a = this.observers; _i < _a.length; _i++) {
            var observer = _a[_i];
            if (observer.complete) {
                observer.complete();
            }
        }
    };
    Subject.prototype.subscribe = function (observer) {
        this.observers.push(observer);
        return new __WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* SubjectSubscription */](this, observer);
    };
    return Subject;
}());

//# sourceMappingURL=Subject.js.map

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonHubProtocol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ITransport__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Loggers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__ = __webpack_require__(131);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.





var JSON_HUB_PROTOCOL_NAME = "json";
/** Implements the JSON Hub Protocol. */
var JsonHubProtocol = /** @class */ (function () {
    function JsonHubProtocol() {
        /** @inheritDoc */
        this.name = JSON_HUB_PROTOCOL_NAME;
        /** @inheritDoc */
        this.version = 1;
        /** @inheritDoc */
        this.transferFormat = __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */].Text;
    }
    /** Creates an array of {@link @microsoft/signalr.HubMessage} objects from the specified serialized representation.
     *
     * @param {string} input A string containing the serialized representation.
     * @param {ILogger} logger A logger that will be used to log messages that occur during parsing.
     */
    JsonHubProtocol.prototype.parseMessages = function (input, logger) {
        // The interface does allow "ArrayBuffer" to be passed in, but this implementation does not. So let's throw a useful error.
        if (typeof input !== "string") {
            throw new Error("Invalid input for JSON hub protocol. Expected a string.");
        }
        if (!input) {
            return [];
        }
        if (logger === null) {
            logger = __WEBPACK_IMPORTED_MODULE_3__Loggers__["a" /* NullLogger */].instance;
        }
        // Parse the messages
        var messages = __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__["a" /* TextMessageFormat */].parse(input);
        var hubMessages = [];
        for (var _i = 0, messages_1 = messages; _i < messages_1.length; _i++) {
            var message = messages_1[_i];
            var parsedMessage = JSON.parse(message);
            if (typeof parsedMessage.type !== "number") {
                throw new Error("Invalid payload.");
            }
            switch (parsedMessage.type) {
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Invocation:
                    this.isInvocationMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].StreamItem:
                    this.isStreamItemMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Completion:
                    this.isCompletionMessage(parsedMessage);
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Ping:
                    // Single value, no need to validate
                    break;
                case __WEBPACK_IMPORTED_MODULE_0__IHubProtocol__["a" /* MessageType */].Close:
                    // All optional values, no need to validate
                    break;
                default:
                    // Future protocol changes can add message types, old clients can ignore them
                    logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Unknown message type '" + parsedMessage.type + "' ignored.");
                    continue;
            }
            hubMessages.push(parsedMessage);
        }
        return hubMessages;
    };
    /** Writes the specified {@link @microsoft/signalr.HubMessage} to a string and returns it.
     *
     * @param {HubMessage} message The message to write.
     * @returns {string} A string containing the serialized representation of the message.
     */
    JsonHubProtocol.prototype.writeMessage = function (message) {
        return __WEBPACK_IMPORTED_MODULE_4__TextMessageFormat__["a" /* TextMessageFormat */].write(JSON.stringify(message));
    };
    JsonHubProtocol.prototype.isInvocationMessage = function (message) {
        this.assertNotEmptyString(message.target, "Invalid payload for Invocation message.");
        if (message.invocationId !== undefined) {
            this.assertNotEmptyString(message.invocationId, "Invalid payload for Invocation message.");
        }
    };
    JsonHubProtocol.prototype.isStreamItemMessage = function (message) {
        this.assertNotEmptyString(message.invocationId, "Invalid payload for StreamItem message.");
        if (message.item === undefined) {
            throw new Error("Invalid payload for StreamItem message.");
        }
    };
    JsonHubProtocol.prototype.isCompletionMessage = function (message) {
        if (message.result && message.error) {
            throw new Error("Invalid payload for Completion message.");
        }
        if (!message.result && message.error) {
            this.assertNotEmptyString(message.error, "Invalid payload for Completion message.");
        }
        this.assertNotEmptyString(message.invocationId, "Invalid payload for Completion message.");
    };
    JsonHubProtocol.prototype.assertNotEmptyString = function (value, errorMessage) {
        if (typeof value !== "string" || value === "") {
            throw new Error(errorMessage);
        }
    };
    return JsonHubProtocol;
}());

//# sourceMappingURL=JsonHubProtocol.js.map

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    version: function version() {
      return this.$store.getters.getVersion;
    },
    user: function user() {
      return this.$store.getters.getUser;
    }
  },
  created: function created() {
    var version = localStorage.getItem("tVersion");
    if (version != this.version) {
      localStorage.setItem("tVersion", this.version);
      window.location.reload();
    }
  }
});

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      defaultLanguage: "",
      flag: ""
    };
  },

  methods: {
    changeLanguage: function changeLanguage(event) {
      this.defaultLanguage = event.target.value;
      localStorage.setItem("lang", this.defaultLanguage);
      this.$ml.change(event.target.value);
      if (event.target.value == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
        this.defaultLanguage = "Türkçe";
      }
    }
  },
  created: function created() {
    var language = localStorage.getItem("lang");
    if (language) {
      if (language == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.defaultLanguage = language;
      this.$ml.change(language);
    } else {
      localStorage.setItem("lang", "Türkçe");
      this.defaultLanguage = "Türkçe";
      this.flag = "/src/assets/flags/TR.png";
    }
  }
});

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apexcharts__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_apexcharts__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingFoodData: false,
      isLoadingData: false,
      isLoadingVehicle: false,
      isLoadingVisitor: false,
      isLoadingDormitoryData: false,
      isLoadingReport: false,
      isLoadingAllowence: false,
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
      searchText: "",
      searchTextDevices: "",
      totalFoodCount: 0,
      startWorkEmployees: "0",
      lateComers: "0",
      discontinuity: "0",
      totalEmployees: "0",
      lastConnectionTime: null,
      insides: "0",
      outsides: "0",
      insideVisitors: "0",
      allowencedEmployees: "0",
      mobileUsers: "0",
      activeMobileUsers: "0",
      insideCars: "0",
      outsideCars: "0",
      totalCars: "0",
      dormitoryTotalStudent: "0",
      dormitoryInsideStudent: "0",
      dormitoryOutsideStudent: "0",
      dormitoryAllowencedStudent: "0",
      devices: [],
      connectedDevice: 0,
      disconnectedDevice: 0,
      otherDeviceStatus: 0,
      departments: [],
      birthDays: [],
      allowences: [],
      allowenceRequests: [],
      allowenceRequestDescription: "",
      allowenceRequest: {
        id: null,
        empID: null,
        name: "",
        description: "",
        startDate: null,
        endDate: null,
        image: null,
        sicilNo: "",
        title: "",
        department: "",
        createdDate: null
      },
      allowence: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        description: "",
        allowenceId: null,
        holidayPass: false,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: true
      },
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }],
      reportHeaders: [],
      reportDatas: [],
      reportTitle: "",
      authMap: {
        canliIzleme: 2,
        kisiler: 2,
        gecisYetkileri: 2,
        raporlar: 2,
        ayarlar: 2,
        tanimlamalar: 2,
        ziyaretciTakip: 2,
        yemekhane: 2,
        creditSale: 2,
        dashboard: 2,
        shiftYonetimi: 2,
        puantajYonetimi: 2,
        shiftYetkileri: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: false,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        }
      },
      chart: null,
      chart2: null,
      chart3: null,
      infoEmployees: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: ["#00A65A", "#DD4B39", "#F39C12", "#3C8DBC", "#364b98", "#d63384", "#fd7e14", "#6610f2", "#20c997", "#0dcaf0", "#6c757d", "#6f42c1"],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      },
      infoStudents: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: ["#00A65A", "#DD4B39", "#F39C12", "#3C8DBC", "#364b98", "#d63384", "#fd7e14", "#6610f2", "#20c997", "#0dcaf0", "#6c757d", "#6f42c1"],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      },
      infoDevices: {
        series: [],
        labels: [],
        dataLabels: {
          enabled: true
        },
        colors: ["#00A65A", "#DD4B39", "#F39C12", "#3C8DBC", "#364b98", "#d63384", "#fd7e14", "#6610f2", "#20c997", "#0dcaf0", "#6c757d", "#6f42c1"],
        chart: {
          fontFamily: "Nunito",
          type: "donut",
          width: "100%",
          height: "350px"
        },
        legend: {
          show: true,
          position: "bottom"
        },
        plotOptions: {
          pie: {
            donut: {
              size: "30%"
            }
          }
        }
      }
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    readMore: function readMore(str) {
      if (str.length > 40) {
        return str.slice(0, 40) + "...";
      } else {
        return str;
      }
    }
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    fastReportList: function fastReportList() {
      var _this = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.reportDatas.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.reportDatas;
      }
    },
    reportHeaderList: function reportHeaderList() {
      return this.reportHeaders;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    deviceList: function deviceList() {
      return this.devices;
    },
    filteredDeviceList: function filteredDeviceList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchTextDevices);
      if (search) {
        return this.devices.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v) || item.ip.includes(v);
          });
        });
      } else {
        return this.devices;
      }
    },
    birthdayList: function birthdayList() {
      return this.birthDays;
    },
    dayList: function dayList() {
      return this.days;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    allowenceRequestList: function allowenceRequestList() {
      return this.allowenceRequests;
    },
    allowenceRequestCount: function allowenceRequestCount() {
      if (this.allowenceRequests[0]) {
        return this.allowenceRequests.length;
      } else {
        return 0;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReportHeightSize: function windowReportHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    },
    windowWidth: function windowWidth(newWidth, oldWidth) {
      if (newWidth < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    exportToPDF2: function exportToPDF2() {
      this.$htmlToPaper("printReportDormitory");
    },
    exportToPDFDevices: function exportToPDFDevices() {
      this.$htmlToPaper("printReportDevices");
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToExcel2: function exportToExcel2() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcelDormitory").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToExcelDevices: function exportToExcelDevices() {
      var tarih = new Date();
      var filename = this.$ml.get('dashboard.deviceStatus') + " - " + tarih.toLocaleString();
      $("#printExcelDevices").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    doldur: function doldur() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var elem;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                elem = document.getElementById("infoEmployees");
                _context.next = 3;
                return new __WEBPACK_IMPORTED_MODULE_0_apexcharts___default.a(elem, _this4.infoEmployees);

              case 3:
                _this4.chart = _context.sent;

                _this4.chart.render();

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    doldurDormitory: function doldurDormitory() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var elem2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                elem2 = document.getElementById("infoStudents");
                _context2.next = 3;
                return new __WEBPACK_IMPORTED_MODULE_0_apexcharts___default.a(elem2, _this5.infoStudents);

              case 3:
                _this5.chart2 = _context2.sent;

                _this5.chart2.render();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    chartDevices: function chartDevices() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var elem3;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                elem3 = document.getElementById("infoDevices");
                _context3.next = 3;
                return new __WEBPACK_IMPORTED_MODULE_0_apexcharts___default.a(elem3, _this6.infoDevices);

              case 3:
                _this6.chart3 = _context3.sent;

                _this6.chart3.render();

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    authControl: function authControl(data) {
      if (data != null) {
        if (data == 2) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    changeAllowenceType: function changeAllowenceType(event) {
      this.allowence.allowenceType = event.target.value;
    },
    changeAllowence: function changeAllowence(event) {
      this.allowence.allowenceId = event.target.value;
    },
    changeEqualMissingTime: function changeEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeCheckEqualMissingTime: function changeCheckEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.equalTheMissingTime = false;
        this.allowence.allowenceTime = "00:00";
      } else {
        this.allowence.equalTheMissingTime = true;
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeAllowenceStartTime: function changeAllowenceStartTime() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var ed, sd, startDate, id, _response, mT, mTT;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this7.allowence.allowenceType == 1)) {
                  _context4.next = 11;
                  break;
                }

                ed = _this7.allowence.endDate.split("T");
                sd = _this7.allowence.startDate.split("T");

                _this7.allowence.endDate = sd[0] + "T" + ed[1];
                startDate = sd[0] + "T" + sd[1];

                if (!(startDate != null && sd[0] != null && sd[1] != null && startDate > "1900-01-01T00:00")) {
                  _context4.next = 11;
                  break;
                }

                id = _this7.allowenceRequest.empID;
                _context4.next = 9;
                return _this7.$axios.post("/EmployeeDetails/GetMissingHour", {
                  empID: id,
                  date: startDate
                });

              case 9:
                _response = _context4.sent;

                if (_response.status == 200) {
                  mT = _response.data;
                  mTT = mT.split("T");

                  _this7.allowence.missingTime = mTT[1];
                  if (_this7.allowence.equalTheMissingTime == true) {
                    _this7.allowence.allowenceTime = mTT[1];
                  }
                } else if (_response.status == 201) {
                  _this7.allowence.missingTime = "00:00";
                  _this7.allowence.allowenceTime = "00:00";
                  alertify.warning(_this7.$ml.get("alerts.selectedDayNotMissingHour"));
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    selectedDays: function selectedDays() {
      var selectedDays = [];
      var aList = this.days;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    newAllowence: function newAllowence() {
      this.isNewAllowence = true;
      this.allowence.id = null;
      if (this.allowenceList[0]) {
        this.allowence.allowenceId = this.allowenceList[0].id;
      }
      this.allowence.description = "";
      this.allowence.allowenceType = 0;
      this.allowence.holidayPass = false;
      this.allowence.allowenceTime = "00:00";
      this.allowence.missingTime = "00:00";
      this.allowence.equalTheMissingTime = true;
    },
    selectAllowencedRequest: function selectAllowencedRequest(request) {
      this.allowenceRequest.id = request.id;
      this.allowenceRequest.empID = request.empID;
      this.allowenceRequest.sicilNo = request.sicilNo;
      this.allowenceRequest.department = request.department;
      this.allowenceRequest.title = request.title;
      this.allowenceRequest.createdDate = request.createdDate;
      this.allowenceRequest.name = request.name;
      this.allowenceRequest.description = request.description;
      this.allowenceRequest.startDate = request.startDate;
      this.allowenceRequest.endDate = request.endDate;
      this.allowenceRequest.image = request.image;
    },
    rejectAllowenceRequestModal: function rejectAllowenceRequestModal() {
      $("#modal-allowenceRequest").modal("hide");
      $("#modal-allowenceRequest-reject").modal("show");
    },
    successAllowenceRequestModal: function successAllowenceRequestModal() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this8.newAllowence();

              case 2:
                $("#modal-allowenceRequest").modal("hide");
                _this8.allowence.startDate = _this8.allowenceRequest.startDate;
                _this8.allowence.endDate = _this8.allowenceRequest.endDate;
                $("#modal-allowenceRequest-success").modal("show");

              case 6:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    successAllowenceRequest: function successAllowenceRequest() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var days, empIds, allowence2, _response2, response2;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this9.allowence.startDate == "" | _this9.allowence.endDate)) {
                  _context6.next = 3;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.invalidDate"));
                return _context6.abrupt("return");

              case 3:
                if (_this9.allowence.allowenceId) {
                  _context6.next = 6;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.pleaseSelect"));
                return _context6.abrupt("return");

              case 6:
                _context6.prev = 6;

                _this9.isLoadingAllowence = true;
                _context6.next = 10;
                return _this9.selectedDays();

              case 10:
                days = _context6.sent;
                empIds = [_this9.allowenceRequest.empID];
                allowence2 = _this9.allowence;

                _this9.allowenceRequestDescription = _this9.allowence.description;
                _context6.next = 16;
                return _this9.$axios.post("/BatchOperations/BatchAllowence", {
                  empIds: empIds,
                  days: days,
                  allowenceId: allowence2.allowenceId,
                  description: allowence2.description,
                  holidayPass: allowence2.holidayPass,
                  startDate: allowence2.startDate,
                  endDate: allowence2.endDate,
                  allowenceType: allowence2.allowenceType,
                  allowenceTime: allowence2.allowenceTime,
                  equalTheMissingTime: allowence2.equalTheMissingTime,
                  missingTime: allowence2.missingTime
                });

              case 16:
                _response2 = _context6.sent;

                if (!(_response2.status == 200)) {
                  _context6.next = 31;
                  break;
                }

                _context6.next = 20;
                return _this9.$axios.post("/AllowenceRequest?id=" + _this9.allowenceRequest.id + "&status=1&description=" + _this9.allowenceRequestDescription);

              case 20:
                response2 = _context6.sent;

                if (!(response2.status == 200)) {
                  _context6.next = 28;
                  break;
                }

                alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                $("#modal-allowenceRequest-success").modal("hide");
                _context6.next = 26;
                return _this9.getAllowenceRequests();

              case 26:
                _context6.next = 29;
                break;

              case 28:
                alertify.error(_response2.message);

              case 29:
                _context6.next = 32;
                break;

              case 31:
                alertify.error(_response2.message);

              case 32:
                _this9.isLoadingAllowence = false;
                _context6.next = 40;
                break;

              case 35:
                _context6.prev = 35;
                _context6.t0 = _context6["catch"](6);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this9.isLoadingAllowence = false;

              case 40:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[6, 35]]);
      }))();
    },
    rejectAllowenceRequest: function rejectAllowenceRequest() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response2;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this10.$axios.post("/AllowenceRequest?id=" + _this10.allowenceRequest.id + "&status=2&description=" + _this10.allowenceRequestDescription);

              case 3:
                response2 = _context7.sent;

                if (!(response2.status == 200)) {
                  _context7.next = 11;
                  break;
                }

                alertify.success(_this10.$ml.get("alerts.savedSuccessfully"));
                $("#modal-allowenceRequest-reject").modal("hide");
                _context7.next = 9;
                return _this10.getAllowenceRequests();

              case 9:
                _context7.next = 12;
                break;

              case 11:
                alertify.error(response.message);

              case 12:
                _context7.next = 19;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this10.isLoadingAllowence = false;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 14]]);
      }))();
    },
    openDeviceReport: function openDeviceReport() {
      $("#modal-device-report").modal("show");
    },
    getFastReport: function getFastReport(title, number) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _response3;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this11.authControl(_this11.authMap.raporlar)) {
                  _context8.next = 20;
                  break;
                }

                $("#modal-fast-report").modal("show");
                _this11.reportTitle = title;
                _context8.prev = 3;

                _this11.isLoadingReport = true;
                _this11.searchText = "";
                _this11.reportDatas = [];
                _context8.next = 9;
                return _this11.$axios.get("/Dashboard/DailyInfo/" + number).then(function (response) {
                  _this11.reportDatas = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingReport = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingReport = false;
                      return;
                    }
                  }
                });

              case 9:
                _response3 = _context8.sent;

                _this11.reportHeaders = [];
                if (number == 0) {
                  _this11.startWorkEmployees = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.datetime"));
                } else if (number == 1) {
                  _this11.discontinuity = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                } else if (number == 2) {
                  _this11.totalEmployees = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                } else if (number == 3) {
                  _this11.insides = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.datetime"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.readerName"));
                } else if (number == 4) {
                  _this11.outsides = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.datetime"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.readerName"));
                } else if (number == 5) {
                  _this11.allowencedEmployees = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                } else if (number == 6) {
                  _this11.insideVisitors = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.citizenshipNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.visitorName"));
                  _this11.reportHeaders.push("");
                  _this11.reportHeaders.push("");
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.entryTime"));
                } else if (number == 10) {
                  _this11.mobileUsers = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                } else if (number == 11) {
                  _this11.lateComers = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.status"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.datetime"));
                } else if (number == 12) {
                  _this11.activeMobileUsers = _this11.reportDatas.length;
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.registrationNumber"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.name"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.department"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.title"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.mobilePhone"));
                  _this11.reportHeaders.push(_this11.$ml.get("dashboard.fastReportHeaderItems.device"));
                }
                _this11.isLoadingReport = false;
                _context8.next = 20;
                break;

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8["catch"](3);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);
                _this11.isLoadingReport = false;

              case 20:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[3, 15]]);
      }))();
    },
    getDormitoryFastReport: function getDormitoryFastReport(title, number) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _response4;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this12.authControl(_this12.authMap.raporlar)) {
                  _context9.next = 19;
                  break;
                }

                $("#modal-fast-report-dormitory").modal("show");
                _this12.reportTitle = title;
                _context9.prev = 3;

                _this12.isLoadingReport = true;
                _this12.searchText = "";
                _this12.reportDatas = [];
                _context9.next = 9;
                return _this12.$axios.get("/Dormitory/DailyInfo/" + number).then(function (response) {
                  _this12.reportDatas = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingReport = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingReport = false;
                      return;
                    }
                  }
                });

              case 9:
                _response4 = _context9.sent;

                if (number == 0) {
                  _this12.dormitoryInsideStudent = _this12.reportDatas.length;
                } else if (number == 1) {
                  _this12.dormitoryOutsideStudent = _this12.reportDatas.length;
                } else if (number == 2) {
                  _this12.dormitoryAllowencedStudent = _this12.reportDatas.length;
                } else if (number == 3) {
                  _this12.dormitoryTotalStudent = _this12.reportDatas.length;
                }
                _this12.isLoadingReport = false;
                _context9.next = 19;
                break;

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9["catch"](3);

                console.error(_context9.t0);
                alertify.error("Servis Hatası :" + _context9.t0.message);
                _this12.isLoadingReport = false;

              case 19:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[3, 14]]);
      }))();
    },
    getDevices: function getDevices() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _response5, connected, disconnected, other;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this13.isLoading = true;
                _context10.next = 4;
                return _this13.$axios.get("/Terminal").then(function (response) {
                  _this13.devices = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                _response5 = _context10.sent;
                connected = _this13.deviceList.filter(function (device) {
                  return device.lastConnectionStatus == 'Bağlı';
                });
                disconnected = _this13.deviceList.filter(function (device) {
                  return device.lastConnectionStatus == 'Bağlantı Sorunu';
                });
                other = _this13.deviceList.length - connected.length - disconnected.length;

                _this13.connectedDevice = connected.length;
                _this13.disconnectedDevice = disconnected.length;
                _this13.otherDeviceStatus = other;

                _this13.infoDevices.labels.push("Bağlı");
                _this13.infoDevices.labels.push("Bağlantı Sorunu");
                _this13.infoDevices.labels.push("Bilinmeyen");
                _this13.infoDevices.series.push(_this13.connectedDevice);
                _this13.infoDevices.series.push(_this13.disconnectedDevice);
                _this13.infoDevices.series.push(_this13.otherDeviceStatus);
                _context10.next = 19;
                return _this13.chartDevices();

              case 19:
                _this13.isLoading = false;
                _context10.next = 27;
                break;

              case 22:
                _context10.prev = 22;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error("Servis Hatası :" + _context10.t0.message);
                _this13.isLoading = false;

              case 27:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 22]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var _response6;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this14.isLoading = true;
                _context11.next = 4;
                return _this14.$axios.get("/Dashboard/Departments").then(function (response) {
                  _this14.departments = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                _response6 = _context11.sent;

                _this14.isLoading = false;
                _context11.next = 13;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);
                alertify.error("Servis Hatası :" + _context11.t0.message);
                _this14.isLoading = false;

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14, [[0, 8]]);
      }))();
    },
    getDatas: function getDatas() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var startWorkEmployees2, lateComers2, discontinuity2, totalEmployees2, lastConnectionTime2, insides2, outsides2, allowencedEmployees2, mobileUsers2, activeMobileUsers2, birthDays2, _response7;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this15.isLoadingData = true;
                startWorkEmployees2 = "0";
                lateComers2 = "0";
                discontinuity2 = "0";
                totalEmployees2 = "0";
                lastConnectionTime2 = null;
                insides2 = "0";
                outsides2 = "0";
                allowencedEmployees2 = "0";
                mobileUsers2 = "0";
                activeMobileUsers2 = "0";
                birthDays2 = [];
                _context12.next = 15;
                return _this15.$axios.get("/Dashboard").then(function (response) {
                  if (response.status == 200) {
                    startWorkEmployees2 = response.data.startWorkEmployees;
                    lateComers2 = response.data.lateComers;
                    discontinuity2 = response.data.discontinuity;
                    totalEmployees2 = response.data.totalEmployees;
                    lastConnectionTime2 = response.data.lastConnectionTime;
                    insides2 = response.data.insides;
                    outsides2 = response.data.outsides;
                    allowencedEmployees2 = response.data.allowencedEmployees;
                    birthDays2 = response.data.birthDays;
                    mobileUsers2 = response.data.mobileUsers;
                    activeMobileUsers2 = response.data.activeMobileUsers;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoadingData = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoadingData = false;
                      return;
                    }
                  }
                });

              case 15:
                _response7 = _context12.sent;

                _this15.startWorkEmployees = startWorkEmployees2;
                _this15.lateComers = lateComers2;
                _this15.discontinuity = discontinuity2;
                _this15.totalEmployees = totalEmployees2;
                _this15.lastConnectionTime = lastConnectionTime2;
                _this15.insides = insides2;
                _this15.outsides = outsides2;
                _this15.allowencedEmployees = allowencedEmployees2;
                _this15.birthDays = birthDays2;
                _this15.mobileUsers = mobileUsers2;
                _this15.activeMobileUsers = activeMobileUsers2;
                _this15.infoEmployees.labels.push(_this15.$ml.get("dashboard.insides"));
                _this15.infoEmployees.labels.push(_this15.$ml.get("dashboard.outsides"));
                if (_this15.modules.payroll) {
                  _this15.infoEmployees.labels.push(_this15.$ml.get("dashboard.allowenceEmployees"));
                }
                _this15.infoEmployees.series.push(insides2);
                _this15.infoEmployees.series.push(outsides2);
                if (_this15.modules.payroll) {
                  _this15.infoEmployees.series.push(allowencedEmployees2);
                }
                _context12.next = 35;
                return _this15.doldur();

              case 35:
                _this15.isLoadingData = false;
                _context12.next = 43;
                break;

              case 38:
                _context12.prev = 38;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);
                alertify.error("Servis Hatası : " + _context12.t0.message);
                _this15.isLoadingData = false;

              case 43:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15, [[0, 38]]);
      }))();
    },
    getVisitorDatas: function getVisitorDatas() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var insideVisitors2, _response8;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                _this16.isLoadingVisitor = true;
                insideVisitors2 = "0";
                _context13.next = 5;
                return _this16.$axios.get("/Dashboard/Visitors").then(function (response) {
                  if (response.status == 200) {
                    insideVisitors2 = response.data.insideVisitors;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 5:
                _response8 = _context13.sent;

                _this16.insideVisitors = insideVisitors2;
                _this16.isLoadingVisitor = false;
                _context13.next = 15;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](0);

                console.error(_context13.t0);
                alertify.error("Servis Hatası : " + _context13.t0.message);
                _this16.isLoadingVisitor = false;

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this16, [[0, 10]]);
      }))();
    },
    getVehicleData: function getVehicleData() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var insideCars2, outsideCars2, totalCars2, _response9;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this17.isLoadingVehicle = true;
                insideCars2 = "0";
                outsideCars2 = "0";
                totalCars2 = "0";
                _context14.next = 7;
                return _this17.$axios.get("/Dashboard/Vehicles").then(function (response) {
                  if (response.status == 200) {
                    insideCars2 = response.data.insideCars;
                    outsideCars2 = response.data.outsideCars;
                    totalCars2 = response.data.totalCars;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this17.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this17.$ml.get("errors.connectionError"));
                      _this17.isLoadingVehicle = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this17.isLoadingVehicle = false;
                      return;
                    }
                  }
                });

              case 7:
                _response9 = _context14.sent;

                _this17.insideCars = insideCars2;
                _this17.outsideCars = outsideCars2;
                _this17.totalCars = totalCars2;
                _this17.isLoadingVehicle = false;
                _context14.next = 19;
                break;

              case 14:
                _context14.prev = 14;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası : " + _context14.t0.message);
                _this17.isLoadingVehicle = false;

              case 19:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this17, [[0, 14]]);
      }))();
    },
    getDormitoryDatas: function getDormitoryDatas() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var dormitoryTotalStudent2, dormitoryInsideStudent2, dormitoryOutsideStudent2, dormitoryAllowencedStudent2, _response10;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                _this18.isLoadingDormitoryData = true;
                dormitoryTotalStudent2 = "0";
                dormitoryInsideStudent2 = "0";
                dormitoryOutsideStudent2 = "0";
                dormitoryAllowencedStudent2 = "0";
                _context15.next = 8;
                return _this18.$axios.get("/Dormitory").then(function (response) {
                  if (response.status == 200) {
                    dormitoryTotalStudent2 = response.data.total;
                    dormitoryInsideStudent2 = response.data.insides;
                    dormitoryOutsideStudent2 = response.data.outsides;
                    dormitoryAllowencedStudent2 = response.data.allowenced;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this18.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this18.$ml.get("errors.connectionError"));
                      _this18.isLoadingDormitoryData = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this18.isLoadingDormitoryData = false;
                      return;
                    }
                  }
                });

              case 8:
                _response10 = _context15.sent;

                _this18.dormitoryTotalStudent = dormitoryTotalStudent2;
                _this18.dormitoryInsideStudent = dormitoryInsideStudent2;
                _this18.dormitoryOutsideStudent = dormitoryOutsideStudent2;
                _this18.dormitoryAllowencedStudent = dormitoryAllowencedStudent2;
                _this18.infoStudents.labels.push(_this18.$ml.get("dashboard.insideStudentsInDormitory"));
                _this18.infoStudents.labels.push(_this18.$ml.get("dashboard.outsideStudentsInDormitory"));
                _this18.infoStudents.labels.push(_this18.$ml.get("dashboard.allowencedStudentsInDormitory"));
                _this18.infoStudents.series.push(dormitoryInsideStudent2);
                _this18.infoStudents.series.push(dormitoryOutsideStudent2);
                _this18.infoStudents.series.push(dormitoryAllowencedStudent2);
                _context15.next = 21;
                return _this18.doldurDormitory();

              case 21:
                _this18.isLoadingDormitoryData = false;
                _context15.next = 29;
                break;

              case 24:
                _context15.prev = 24;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası : " + _context15.t0.message);
                _this18.isLoadingDormitoryData = false;

              case 29:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this18, [[0, 24]]);
      }))();
    },
    getTotalFoodCount: function getTotalFoodCount() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this19.isLoadingFoodData = true;
                _context16.next = 4;
                return _this19.$axios.get("/FoodMenu/GetFoodCount").then(function (response) {
                  if (response.status == 200) {
                    _this19.totalFoodCount = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this19.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this19.$ml.get("errors.connectionError"));
                      _this19.isLoadingFoodData = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this19.isLoadingFoodData = false;
                      return;
                    }
                  }
                });

              case 4:
                _this19.isLoadingFoodData = false;
                _context16.next = 12;
                break;

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası : " + _context16.t0.message);
                _this19.isLoadingFoodData = false;

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this19, [[0, 7]]);
      }))();
    },
    getAllowenceRequests: function getAllowenceRequests() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var allowenceRequests;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this20.isLoadingAllowence = true;
                allowenceRequests = [];
                _context17.next = 5;
                return _this20.$axios.get("/AllowenceRequest").then(function (response) {
                  if (response.status == 200) {
                    allowenceRequests = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoadingAllowence = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoadingAllowence = false;
                      return;
                    }
                  }
                });

              case 5:
                _this20.allowenceRequests = allowenceRequests;
                _this20.isLoadingAllowence = false;
                _context17.next = 14;
                break;

              case 9:
                _context17.prev = 9;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası : " + _context17.t0.message);
                _this20.isLoadingAllowence = false;

              case 14:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this20, [[0, 9]]);
      }))();
    },
    getAuthority: function getAuthority() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var authMap, _response11;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this21.isLoading = true;
                authMap = {};
                _context18.next = 5;
                return _this21.$axios.get("/User/GetAuthMap").then(function (response) {
                  if (response.status == 200) {
                    authMap.canliIzleme = response.data.canliIzleme;
                    authMap.kisiler = response.data.kisiler;
                    authMap.gecisYetkileri = response.data.gecisYetkileri;
                    authMap.raporlar = response.data.raporlar;
                    authMap.ayarlar = response.data.ayarlar;
                    authMap.tanimlamalar = response.data.tanimlamalar;
                    authMap.ziyaretciTakip = response.data.ziyaretciTakip;
                    authMap.yemekhane = response.data.yemekhane;
                    authMap.dashboard = response.data.dashboard;
                    authMap.creditSale = response.data.creditSale;
                    authMap.shiftYonetimi = response.data.shiftYonetimi;
                    authMap.puantajYonetimi = response.data.puantajYonetimi;
                    authMap.shiftYetkileri = response.data.shiftYetkileri;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                _response11 = _context18.sent;

                _this21.authMap = authMap;
                _context18.next = 9;
                return _this21.$store.commit("setAuthority", authMap);

              case 9:
                _this21.isLoading = false;
                _context18.next = 17;
                break;

              case 12:
                _context18.prev = 12;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Hata : " + _context18.t0.message);
                _this21.isLoading = false;

              case 17:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this21, [[0, 12]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var allowences, _response12;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                allowences = [];
                _context19.next = 4;
                return _this22.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                _response12 = _context19.sent;

                _this22.allowences = allowences;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this22, [[0, 8]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    try {
      window.removeEventListener("resize", this.onResize);
      this.chart.destroy();
      this.chart2.destroy();
      this.chart3.destroy();
    } catch (e) {}
  },
  created: function created() {
    var _this23 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var language;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              language = localStorage.getItem("lang");

              if (language) {
                _this23.$ml.change(language);
              }
              _context20.next = 4;
              return _this23.getAuthority();

            case 4:
              if (!(_this23.authMap.dashboard == 2)) {
                _context20.next = 9;
                break;
              }

              if (_this23.authMap.creditSale != 2 && _this23.modules.retailSale) {
                _this23.$router.replace("/retail-sale");
              } else if (_this23.authMap.ziyaretciTakip != 2 && _this23.modules.visitor) {
                _this23.$router.replace("/visitors");
              } else {
                _this23.$router.replace("/real-time-monitor");
              }
              return _context20.abrupt("return");

            case 9:
              _this23.getTotalFoodCount();
              _this23.getDevices();
              _this23.getDatas();
              _this23.getDepartments();
              if (_this23.modules.licencePlateRecognition) {
                _this23.getVehicleData();
              }
              if (_this23.modules.dormitory) {
                _this23.getDormitoryDatas();
              }
              if (_this23.modules.visitor) {
                _this23.getVisitorDatas();
              }
              if (_this23.modules.allowenceRequests) {
                _this23.getAllowences();
                _this23.getAllowenceRequests();
              }

            case 17:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, _this23);
    }))();
  }
});

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_signalr__ = __webpack_require__(81);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      activeScreen: 0,
      lastDate: null,
      foodMenus: {
        yemek1: "",
        yemek2: "",
        yemek3: "",
        yemek4: "",
        yemek5: ""
      },
      connection: false,
      totalFoodCount: 0,
      devices: [],
      readers: [],
      authDevice: [],
      selectedDevice: {
        name: "",
        terminalId: 0
      },
      relay: 2,
      logs: [],
      foodLog: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      },
      lastEntryRecord: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      },
      lastExitRecord: {
        image: null,
        name: "",
        title: "",
        terminalGroup: "",
        readerName: "",
        terminalName: "",
        date: "",
        entryOrExit: 1,
        description: "",
        isErrorLog: false,
        isFoodDevice: false,
        readerId: 0,
        foodPrice: "0",
        foodRemainPrice: "0"
      }
    };
  },

  computed: {
    baseURL: function baseURL() {
      return this.$store.getters.getBaseURL;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowFoodHeightSize: function windowFoodHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "background-image:url('/src/assets/foodMenuBackground.jpg');background-size:cover;background-position:bottom;height:" + height + "px;overflow:auto;";
      } else {
        return "background-image:url('/src/assets/foodMenuBackground.jpg');background-size:cover;background-position:bottom;height:370px;overflow:auto;";
      }
    },
    logList: function logList() {
      return this.logs;
    },
    lastExit: function lastExit() {
      return this.logs;
    },
    activeScreenStatus: function activeScreenStatus() {
      return this.activeScreen;
    },
    lastEntry: function lastEntry() {
      return this.logs;
    },
    conStatus: function conStatus() {
      return this.connection;
    },
    readerList: function readerList() {
      var list = this.readers.filter(function (a) {
        return a.inputName != "" && a.inputName != null;
      });
      return list.sort(function (a, b) {
        return a.inputName.toUpperCase().localeCompare(b.inputName.toUpperCase());
      });
    },
    deviceList: function deviceList() {
      return this.devices.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
      });
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
    this.FoodMenuGetTime();
    var hubConnection = new __WEBPACK_IMPORTED_MODULE_0__microsoft_signalr__["a" /* HubConnectionBuilder */]().withUrl(this.baseURL + "/LiveMonitor").withAutomaticReconnect().build();
    // connecting to the hub
    hubConnection.start().then(function () {
      console.log("connection started");
      _this.connection = true;
    }).catch(function (err) {
      console.log("connecting hub failed err is : ", err);
      _this.connection = false;
    });

    hubConnection.on("NewMovement", function (result) {
      //console.log(result);
      var auth = _this.authDevice.filter(function (device) {
        return device == result.readerId;
      });
      if (auth != "" && auth != null) {
        if (auth[0]) {
          _this.logs.unshift(result);
          if (result.isFoodDevice == true && _this.activeScreenStatus == 1 && _this.foodLog.description != "002") {
            _this.getTotalFoodCount();
            _this.foodLog.image = null;
            _this.foodLog.title = "";
            _this.foodLog.name = "";
            _this.foodLog.terminalGroup = "";
            _this.foodLog.readerName = "";
            _this.foodLog.date = null;
            _this.foodLog.entryOrExit = 1;
            _this.foodLog.description = "";
            _this.foodLog.readerId = 0;
            _this.foodLog.foodPrice = "0";
            _this.foodLog.foodRemainPrice = "0";

            _this.foodLog.image = result.image;
            _this.foodLog.title = result.title;
            _this.foodLog.name = _this.getCardName(result);
            _this.foodLog.terminalGroup = result.terminalGroup;
            _this.foodLog.readerName = result.readerName;
            _this.foodLog.date = result.date;
            _this.foodLog.entryOrExit = result.entryOrExit;
            _this.foodLog.description = _this.logDescription(result.description);
            _this.foodLog.isErrorLog = result.isErrorLog;
            _this.foodLog.isFoodDevice = result.isFoodDevice;
            _this.foodLog.readerId = result.readerId;
            _this.foodLog.foodPrice = result.foodPrice;
            _this.foodLog.foodRemainPrice = result.foodRemainPrice;
            $("#modal-food-log").modal("hide");
            setTimeout(function () {
              $("#modal-food-log").modal();
            }, 500);
            setTimeout(function () {
              $("#modal-food-log").modal("hide");
            }, 7000);
            //alertify.success(result.name + " - Yemek Ücreti : " + result.foodPrice + " TL - Kalan Bakiye : " + result.foodRemainPrice);
          }
          if (result.entryOrExit == 2 && result.isErrorLog == false) {
            _this.lastExitRecord.image = result.image;
            _this.lastExitRecord.title = result.title;
            _this.lastExitRecord.name = _this.getCardName(result);
            _this.lastExitRecord.terminalGroup = result.terminalGroup;
            _this.lastExitRecord.readerName = result.readerName;
            _this.lastExitRecord.date = result.date;
            _this.lastExitRecord.entryOrExit = result.entryOrExit;
            _this.lastExitRecord.description = _this.logDescription(result.description);
            _this.lastExitRecord.isErrorLog = result.isErrorLog;
            _this.lastExitRecord.isFoodDevice = result.isFoodDevice;
            _this.lastExitRecord.readerId = result.readerId;
            _this.lastExitRecord.foodPrice = result.foodPrice;
            _this.lastExitRecord.foodRemainPrice = result.foodRemainPrice;
          } else if (result.entryOrExit == 1 && result.isErrorLog == false) {
            _this.lastEntryRecord.image = result.image;
            _this.lastEntryRecord.title = result.title;
            _this.lastEntryRecord.name = _this.getCardName(result);
            _this.lastEntryRecord.terminalGroup = result.terminalGroup;
            _this.lastEntryRecord.readerName = result.readerName;
            _this.lastEntryRecord.date = result.date;
            _this.lastEntryRecord.entryOrExit = result.entryOrExit;
            _this.lastEntryRecord.description = _this.logDescription(result.description);
            _this.lastEntryRecord.isErrorLog = result.isErrorLog;
            _this.lastEntryRecord.isFoodDevice = result.isFoodDevice;
            _this.lastEntryRecord.readerId = result.readerId;
            _this.lastEntryRecord.foodPrice = result.foodPrice;
            _this.lastEntryRecord.foodRemainPrice = result.foodRemainPrice;
          }
        }
      }
    });
    hubConnection.on("DoorStates", function (result) {
      result.forEach(function (item) {
        var auth = _this.authDevice.filter(function (device) {
          return device == item.readerId;
        });
        if (auth != "" && auth != null) {
          if (auth[0]) {
            var reader = _this.readerList.filter(function (a) {
              return item.readerId == a.readerId;
            });
            if (reader[0]) {
              reader[0].connectionStatus = item.connectionStatus;
              reader[0].doorStates = item.lockStatus;
            }
          }
        }
      });
    });

    hubConnection.onclose(function () {
      console.log("connection failed");
      _this.connection = false;
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    openDoorModal: function openDoorModal(reader) {
      this.selectedDevice = reader;
      this.relay = 2;
      $("#modal-open-door").modal();
    },
    onCloseBoxDevice: function onCloseBoxDevice() {
      $("#deviceControlList").boxWidget("toggle");
    },
    customColor: function customColor(reader) {
      if (reader) {
        if (reader.connectionStatus == 0 && reader.doorStates != 1) {
          return "bg-red box-w-70";
        } else if (reader.connectionStatus == 1 && reader.doorStates != 1) {
          return "bg-green box-w-70";
        } else {
          return "bg-yellow box-w-70";
        }
      } else {
        return "box-w-70";
      }
    },
    getDoorImage: function getDoorImage(status) {
      if (status == 1) {
        return "/src/assets/open-door-black.png";
      } else {
        return "/src/assets/close-door.png";
      }
    },
    getDoorStates: function getDoorStates(status) {
      if (status == 1) {
        return this.$ml.get("general.doorOpen");
      } else {
        return this.$ml.get("general.doorIsClosed");
      }
    },
    getReaderStates: function getReaderStates(connectionStatus) {
      if (connectionStatus == 0) {
        return this.$ml.get("general.notConnected");
      } else if (connectionStatus == 1) {
        return this.$ml.get("general.connected");
      } else {
        return " - ";
      }
    },
    getShortName: function getShortName(name, length) {
      return name.length > length ? name.substr(0, length) + "..." : name;
    },
    logDescription: function logDescription(desc) {
      if (desc == "0") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.moveIn");
      } else if (desc == "1") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.entryIn");
      } else if (desc == "2") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.exitOut");
      } else if (desc == "101" || desc == "105" || desc == "302" || desc == "308") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.noAccess") + " (" + desc + ")";
      } else if (desc == "102" || desc == "103" || desc == "304" || desc == "306") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.dailyMealRightExpired") + " (" + desc + ")";
      } else if (desc == "104" || desc == "307") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.mealClaimExpired") + " (" + desc + ")";
      } else if (desc == "301" || desc == "303" || desc == "305") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.insufficientBalance") + " (" + desc + ")";
      } else if (desc == "001") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.foodGroupNotSelected");
      } else if (desc == "002") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.timeLimit");
      } else if (desc == "401") {
        return this.$ml.get("realTimeMonitor.movementLogDescription.antipassback");
      } else {
        return desc;
      }
    },
    getCardName: function getCardName(log) {
      if (log.name == "" && log.isErrorLog == true) {
        return this.$ml.get("realTimeMonitor.movementLogDescription.unregisteredCard");
      } else {
        return log.name;
      }
    },
    changeScreen: function changeScreen() {
      if (this.activeScreen == 0) {
        this.activeScreen = 1;
      } else {
        this.activeScreen = 0;
      }
    },
    FoodMenuGetTime: function FoodMenuGetTime() {
      var v = this;
      setInterval(function () {
        v.getFoodMenu();
      }, 7200000);
    },
    getTotalFoodCount: function getTotalFoodCount() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.$axios.get("/FoodMenu/GetFoodCount").then(function (response) {
                  if (response.status == 200) {
                    _this2.totalFoodCount = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getAuthDevice: function getAuthDevice() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var authDevice;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                authDevice = [];
                _context2.next = 3;
                return _this3.$axios.get("/RealTimeMonitor/GetUserMonitorDevices").then(function (response) {
                  if (response.status == 200) {
                    authDevice = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                _this3.authDevice = authDevice;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    getFoodMenu: function getFoodMenu() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.foodMenus.yemek1 = "";
                _this4.foodMenus.yemek2 = "";
                _this4.foodMenus.yemek3 = "";
                _this4.foodMenus.yemek4 = "";
                _this4.foodMenus.yemek5 = "";
                _context3.next = 7;
                return _this4.$axios.get("/FoodMenu").then(function (response) {
                  if (response.status == 200) {
                    _this4.foodMenus.yemek1 = response.data.yemek1;
                    _this4.foodMenus.yemek2 = response.data.yemek2;
                    _this4.foodMenus.yemek3 = response.data.yemek3;
                    _this4.foodMenus.yemek4 = response.data.yemek4;
                    _this4.foodMenus.yemek5 = response.data.yemek5;
                    _this4.lastDate = new Date();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    bgAyar: function bgAyar(isErrorLog, entryOrExit) {
      if (isErrorLog == true) {
        return "bg-warning text-danger";
      } else {
        if (entryOrExit == 1) {
          return "bg-success";
        } else if (entryOrExit == 0) {
          return "";
        } else {
          return "bg-danger";
        }
      }
    },
    sendOpenDoorCommand: function sendOpenDoorCommand() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.relay < 1)) {
                  _context4.next = 3;
                  break;
                }

                alertify.error(_this5.$ml.get("realTimeMonitor.pleaseEnterRelayDelay"));
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                _context4.next = 6;
                return _this5.$axios.post("/Terminal/OpenDoor", {
                  terminalId: _this5.selectedDevice.terminalId,
                  relayTime: _this5.relay
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get("realTimeMonitor.openDoorCommandSentSuccessfully"));
                    $("#modal-open-door").modal("hide");
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 400) {
                      console.error(error);
                      alertify.error("Servis Hatası : " + error.message);
                      _this5.isLoadingDetail = false;
                    }
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      return;
                    }
                  }
                });

              case 6:
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](3);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 8]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this6.isLoadingDetail = true;
                readers = [];
                _context5.next = 5;
                return _this6.$axios.get("/Terminal/GetReaders").then(function (response) {
                  response.data.forEach(function (doc) {
                    if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                      var device = _this6.devices.filter(function (a) {
                        return doc.terminalId == a.id;
                      });
                      readers.push({
                        readerNo: doc.readerNo,
                        readerId: doc.readerId,
                        terminalId: doc.terminalId,
                        terminalNo: doc.terminalNo,
                        ipAddress: doc.ipAddress,
                        inputName: doc.inputName,
                        name: doc.name,
                        terminalName: device[0] ? device[0].name : "",
                        lastConnectionTime: device[0] ? device[0].lastConnectionTime : " - ",
                        connectionStatus: 0, //0 bağlantı yok 1 bağlı
                        doorStates: 0 //0 belirsiz, 1 kapalı, 2 açık
                      });
                    }
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this6.$ml.get("errors.connectionError"));
                    _this6.isLoadingDetail = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this6.isLoadingDetail = false;
                    return;
                  }
                });

              case 5:
                response = _context5.sent;

                _this6.readers = readers;
                _this6.isLoadingDetail = false;
                _context5.next = 15;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası :" + _context5.t0.message);
                _this6.isLoadingDetail = false;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 10]]);
      }))();
    },
    getDevices: function getDevices() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var devices, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this7.isLoading = true;
                devices = [];
                _context6.next = 5;
                return _this7.$axios.get("/Terminal").then(function (response) {
                  response.data.forEach(function (doc) {
                    devices.push({
                      id: doc.id,
                      no: doc.no,
                      name: doc.name,
                      ip: doc.ip,
                      lastConnectionTime: doc.lastConnectionTime,
                      lastConnectionStatus: doc.lastConnectionStatus
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this7.devices = devices;
                _this7.isLoading = false;
                _context6.next = 15;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);
                _this7.isLoading = false;

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.getAuthDevice();

            case 2:
              _context7.next = 4;
              return _this8.getDevices();

            case 4:
              _context7.next = 6;
              return _this8.getReaders();

            case 6:
              _context7.next = 8;
              return _this8.getTotalFoodCount();

            case 8:
              if (!_this8.modules.foodMenuPopup) {
                _context7.next = 11;
                break;
              }

              _context7.next = 11;
              return _this8.getFoodMenu();

            case 11:
              $("body").addClass("sidebar-collapse");

            case 12:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this8);
    }))();
  }
});

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingAllowence: false,
      isLoadingPayrolls: false,
      isLoadingLogs: false,
      isLoadingEmployee: false,
      isLoadingAllowenceModal: false,
      isLoadingSalary: false,
      isLoadingPayment: false,
      isLoadingWorkPlace: false,
      isLoadingInventory: false,
      windowHeight: window.innerHeight,
      requiredFields: [],
      orderEmpList: 1,
      fpScreen: 0,
      selectedFPIndex: 0,
      textSearchDepartment: "",
      selectedDailyPayrol: {
        date: "",
        workGroup: "",
        movements: [],
        payrolls: [],
        calculatedOverTime: "00:00",
        confirmedOverTime: "00:00",
        overTimeId: null
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        plateNo: "",
        hgsNo: "",
        tzCode: "",
        documentNo: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        validityStartDate: null,
        validityEndDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        payments: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: "",
        isMobileUser: false,
        mobilePassword: "",
        foodClaim: false
      },
      searchInventoryText: "",
      selectedInventoryCategory: 0,
      employeeInventory: {
        id: null,
        employeeId: null,
        inventoryId: null,
        quantity: 0,
        deliveryDate: null,
        takenDate: null,
        description: ""
      },
      employeeInventories: [],
      inventories: [],
      inventoryCategories: [],
      document: {
        id: null,
        documentDefinitionId: null,
        description: "",
        filePath: "",
        isISGDocument: false,
        starDate: null,
        endDate: null,
        isActive: true
      },
      documents: [],
      documentDefinitions: [],
      selectedDoorTypeMovement: 0,
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 4,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0",
        positionX: "",
        positionY: "",
        inOutStartDate: null,
        inOutEndDate: null
      },
      isActiveInOut2: false,
      inOut2: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 4,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0"
      },
      salaries: [],
      salary: {
        id: null,
        salary: 0,
        updateTime: null
      },
      payment: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        salaryId: null,
        salaryName: "",
        status: 1,
        price: 0,
        date: null
      },
      workPlaceDefinitions: [],
      workPlaceDefinition: {
        id: null,
        name: ""
      },
      workPlaces: [],
      workPlace: {
        id: null,
        employeeId: null,
        workplaceId: null,
        description: "",
        startDate: null,
        endDate: null
      },
      allowence: {
        id: null,
        searchStartDate: null,
        searchEndDate: null,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        description: "",
        allowenceId: null,
        holidayPass: false,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: true
      },
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }],
      selectedChangePayroll: {
        isAllowence: false,
        changeDate: "",
        newOperationId: null
      },
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      paymentDefinitions: [],
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      isNewPaymentDefinition: true,
      paymentDefinition: {
        id: null,
        name: "",
        status: 1
      },
      isNewState: true,
      selectedStateId: null,
      selectedStateName: "",
      selectedStateStatus: false,
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      searchPayrollStartDate: null,
      searchPayrollEndDate: null,
      selectAP: 1,
      logStartDate: null,
      logEndDate: null,
      allowences: [],
      startDateRemoveAllowence: null,
      endDateRemoveAllowence: null,
      extrafields: [],
      workGroups: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      annualPermits: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      overtimeDescriptions: [],
      overtimePlaces: [],
      selectedOTDescriptionId: null,
      selectedOTPlaceId: null,
      selectedOverTimeId: null,
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      extraFieldKey: "",
      extraFieldValue: "",
      isNewInOut: true,
      isNewInOut2: true,
      isNewExtraField: true,
      isNewEmployee: true,
      isNewAllowence: true,
      isNewPayment: true,
      isNewWorkPlace: true,
      isDoubleSidedPrint: false,
      cardDesigns: [],
      cardDesign: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      cardDesign2: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  filters: {
    toCurrency: function toCurrency(value) {
      if (typeof value !== "number") {
        return value;
      }
      var formatter = new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY'
      });
      return formatter.format(value);
    },
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthKisiler;
    },
    dayList: function dayList() {
      return this.days;
    },
    inventoryCategoryList: function inventoryCategoryList() {
      return this.inventoryCategories;
    },
    inventoryList: function inventoryList() {
      var _this = this;

      if (this.searchInventoryText) {
        return this.inventories.filter(function (item) {
          return _this.searchInventoryText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else if (this.selectedInventoryCategory && this.selectedInventoryCategory != 0) {
        return this.inventories.filter(function (item) {
          return item.categoryId == _this.selectedInventoryCategory;
        });
      } else {
        return this.inventories;
      }
    },
    employeeInventoryList: function employeeInventoryList() {
      return this.employeeInventories;
    },
    documentList: function documentList() {
      return this.documents;
    },
    documentDefinitionList: function documentDefinitionList() {
      return this.documentDefinitions;
    },
    overtimeDescriptionList: function overtimeDescriptionList() {
      return this.overtimeDescriptions;
    },
    overtimePlaceList: function overtimePlaceList() {
      return this.overtimePlaces;
    },
    logList: function logList() {
      return this.employee.logs;
    },
    dailyPayrollDetailList: function dailyPayrollDetailList() {
      return this.selectedDailyPayrol.payrolls;
    },
    dailyInOutDetailList: function dailyInOutDetailList() {
      return this.selectedDailyPayrol.movements;
    },
    readerList: function readerList() {
      return this.readers.sort(function (a, b) {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    salaryForEmployeeList: function salaryForEmployeeList() {
      return this.salaries;
    },
    paymentDefinitionList: function paymentDefinitionList() {
      return this.paymentDefinitions;
    },
    workPlaceDefinitionList: function workPlaceDefinitionList() {
      return this.workPlaceDefinitions;
    },
    workPlaceList: function workPlaceList() {
      return this.workPlaces;
    },
    activeReaderList: function activeReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true;
      });
    },
    activeMovementReaderList: function activeMovementReaderList() {
      if (this.selectedDoorTypeMovement == 0) {
        return this.readerList.filter(function (item) {
          return item.isActive == true && item.doorType != 2;
        });
      } else if (this.selectedDoorTypeMovement == 1) {
        return this.readerList.filter(function (item) {
          return item.isActive == true && item.doorType != 2 && (item.inOrOut == 1 || item.inOrOut == 0);
        });
      } else {
        return this.readerList.filter(function (item) {
          return item.isActive == true && item.doorType != 2 && (item.inOrOut == 2 || item.inOrOut == 0);
        });
      }
    },
    activePDKSReaderList: function activePDKSReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true && item.doorType == 1;
      });
    },
    visitorCardGroupList: function visitorCardGroupList() {
      return this.visitorCardGroups;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepTrees.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList: function employeeList() {
      var _this2 = this;

      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return _this2.turkishToUpper(a.sicilNo).localeCompare(_this2.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return _this2.turkishToUpper(b.sicilNo).localeCompare(_this2.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return _this2.turkishToUpper(a.name).localeCompare(_this2.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort(function (a, b) {
          return _this2.turkishToUpper(b.name).localeCompare(_this2.turkishToUpper(a.name));
        });
      }
    },
    allEmployeeList: function allEmployeeList() {
      return this.allEmployees;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    employeeExtraFieldList: function employeeExtraFieldList() {
      return this.employee.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    EmpPayrollList: function EmpPayrollList() {
      return this.employee.empPayrolls;
    },
    annualPermitList: function annualPermitList() {
      return this.annualPermits;
    },
    annualPermitDetailList: function annualPermitDetailList() {
      return this.employee.annualPermits;
    },
    annualPermitClaimsDateList: function annualPermitClaimsDateList() {
      return this.employee.annualPermitClaimsDates;
    },
    inOutList: function inOutList() {
      return this.employee.inOuts;
    },
    allowenceForEmployeeList: function allowenceForEmployeeList() {
      return this.employee.allowences;
    },
    paymentForEmployeeList: function paymentForEmployeeList() {
      return this.employee.payments;
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this3 = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this3.turkishToUpper(item.name).includes(v) || _this3.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered: function filtered() {
      var _this4 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this4.turkishToUpper(item.name).includes(v) || _this4.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered: function inOutFiltered() {
      var _this5 = this;

      if (this.inOut.inOutListType == 0) {
        if (this.inOut.inOutListDoorType == 4) {
          return this.inOutList;
        } else {
          return this.inOutList.filter(function (item) {
            return item.doorType == _this5.inOut.inOutListDoorType;
          });
        }
      }
      if (this.inOut.inOutListType == 1) {
        return this.inOutList.filter(function (item) {
          if (_this5.inOut.inOutListDoorType == 4) {
            return item.isActive == true;
          } else {
            return item.isActive == true && item.doorType == _this5.inOut.inOutListDoorType;
          }
        });
      } else if (this.inOut.inOutListType == 2) {
        return this.inOutList.filter(function (item) {
          if (_this5.inOut.inOutListDoorType == 4) {
            return item.isActive == false;
          } else {
            return item.isActive == false && item.doorType == _this5.inOut.inOutListDoorType;
          }
        });
      }
    },
    cardDesignList: function cardDesignList() {
      return this.cardDesigns;
    },
    cardLabelItems: function cardLabelItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 0;
      });
    },
    cardValueItems: function cardValueItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 1;
      });
    },
    cardImageItems: function cardImageItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 2;
      });
    },
    cardLabelItems2: function cardLabelItems2() {
      return this.cardDesign2.template.items.filter(function (a) {
        return a.type == 0;
      });
    },
    cardValueItems2: function cardValueItems2() {
      return this.cardDesign2.template.items.filter(function (a) {
        return a.type == 1;
      });
    },
    cardImageItems2: function cardImageItems2() {
      return this.cardDesign2.template.items.filter(function (a) {
        return a.type == 2;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowACHeightSize: function windowACHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 320;
        return "height:" + height + "px;overflow:auto;";
      } else {
        return "height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this6.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    itemStyle: function itemStyle(item) {
      return "position:absolute;width:" + item.width + "px;height:" + item.height + "px;top:" + item.top + "px;left:" + item.left + "px;font-size:" + item.fontSize + "px;text-align:" + item.fontAlign + ";" + item.fontWeight + item.fontItalic + ";color:" + item.fontColor + ";";
    },
    imageItemStyle: function imageItemStyle(item) {
      return "position:absolute;width:" + item.width + "px;height:" + item.height + "px;top:" + item.top + "px;left:" + item.left + "px;";
    },
    changeCardDesign: function changeCardDesign(event) {
      var a = this.cardDesignList.filter(function (b) {
        return b.id == event.target.value;
      });
      if (a[0]) {
        this.cardDesign = a[0];
      }
    },
    changeCardDesign2: function changeCardDesign2(event) {
      var a = this.cardDesignList.filter(function (b) {
        return b.id == event.target.value;
      });
      if (a[0]) {
        this.cardDesign2 = a[0];
      }
    },
    getValueTitle: function getValueTitle(value) {
      if (value == 0) {
        return this.employee.sicilNo;
      } else if (value == 1) {
        return this.employee.identityNo;
      } else if (value == 2) {
        return this.employee.name;
      } else if (value == 3) {
        return this.getDepartmentFromId(this.employee.departmentId);
      } else if (value == 4) {
        return this.employee.title;
      } else if (value == 5) {
        return this.employee.birthDayDate;
      } else if (value == 6) {
        return this.employee.startDate;
      } else if (value == 7) {
        return this.getStatusFromId(this.employee.statuId);
      } else if (value == 8) {
        return this.getStateFromId(this.employee.stateId);
      } else if (value == 9) {
        return this.employee.stateNote;
      } else if (value == 10) {
        return this.employee.terminalNo;
      } else if (value == 11) {
        if (this.employee.terminalStatu == 0) {
          return "User";
        } else {
          return "Admin";
        }
      } else if (value == 12) {
        return this.employee.cardNo;
      } else if (value == 13) {
        return this.employee.plateNo;
      } else if (value == 14) {
        return this.employee.hgsNo;
      } else if (value == 15) {
        return this.getWorkGroupFromId(this.employee.workGroupId);
      } else if (value == 16) {
        return this.employee.documentNo;
      } else if (value == 17) {
        return this.employee.mail;
      } else if (value == 18) {
        return this.employee.address;
      } else if (value == 19) {
        return this.employee.mobilePhone;
      } else if (value == 20) {
        return this.employee.internalPhone;
      } else if (value == 21) {
        return this.employee.homePhone;
      } else if (value == 22) {
        if (this.employee.gender) {
          if (this.employee.gender == 0) {
            return "-";
          } else if (this.employee.gender == 1) {
            return this.$ml.get("employees.male");
          } else if (this.employee.gender == 2) {
            return this.$ml.get("employees.female");
          }
        } else {
          return "-";
        }
      } else if (value == 23) {
        if (this.employee.educationStatus == 0) {
          return "-";
        } else if (this.employee.educationStatus == 1) {
          return this.$ml.get("employees.primarySchool");
        } else if (this.employee.educationStatus == 2) {
          return this.$ml.get("employees.highSchool");
        } else if (this.employee.educationStatus == 3) {
          return this.$ml.get("employees.associateDegree");
        } else if (this.employee.educationStatus == 4) {
          return this.$ml.get("employees.bachelorDegree");
        } else if (this.employee.educationStatus == 5) {
          return this.$ml.get("employees.postGraduate");
        } else if (this.employee.educationStatus == 6) {
          return this.$ml.get("employees.doctorate");
        }
      } else if (value == 24) {
        if (this.employee.militaryStatus == 0) {
          return "-";
        } else if (this.employee.militaryStatus == 1) {
          return this.$ml.get("employees.done");
        } else if (this.employee.militaryStatus == 2) {
          return this.$ml.get("employees.exempt");
        }
      } else if (value == 25) {
        if (this.employee.maritalStatus == 0) {
          return "-";
        } else if (this.employee.maritalStatus == 1) {
          return this.$ml.get("employees.single");
        } else if (this.employee.maritalStatus == 2) {
          return this.$ml.get("employees.married");
        } else if (this.employee.maritalStatus == 3) {
          return this.$ml.get("employees.widow");
        }
      } else if (value == 26) {
        return this.employee.drivingLicence;
      } else if (value == 27) {
        return this.employee.foreignLanguagFe;
      } else if (value == 28) {
        return this.employee.bloodType;
      }
    },
    getFingerClass: function getFingerClass(fingerIndex) {
      var result = this.employee.fingerIndexes.filter(function (a) {
        return a == fingerIndex;
      });
      if (result[0]) {
        return "fp-kutu-yesil";
      } else {
        return "fp-kutu-kirmizi";
      }
    },
    getHasFinger: function getHasFinger(fingerIndex) {
      var result = this.employee.fingerIndexes.filter(function (a) {
        return a == fingerIndex;
      });
      if (result[0]) {
        return true;
      } else {
        return false;
      }
    },
    changeExtraFieldKey: function changeExtraFieldKey(event) {
      this.extraFieldKey = event.target.value;
    },
    getExtraFieldName: function getExtraFieldName(id) {
      var grup = this.extraFieldList.filter(function (a) {
        return a.id == id;
      });
      if (grup[0]) {
        return grup[0].name;
      } else {
        return "";
      }
    },
    selectedDays: function selectedDays() {
      var selectedDays = [];
      var aList = this.days;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    exportToPDFCard: function exportToPDFCard() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this7.$htmlToPaper("printCards", {
                  name: "_blank",
                  specs: ["fullscreen=yes", "titlebar=yes", "scrollbars=yes"],
                  styles: ["./vendor/dist/css/cardDesign.css"]
                });
                _context.prev = 1;
                _context.next = 4;
                return _this7.$axios.post("/EmployeeDetails/EmployeeLog", {
                  employeeId: _this7.employee.id,
                  message: _this7.cardDesign.name + " şablonu ile kart baskısı gerçekleşti"
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context.sent;

                if (response.status == 200) {} else {
                  alertify.error(response.message);
                }
                _this7.isLoading = false;
                _context.next = 14;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](1);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this7.isLoading = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this7, [[1, 9]]);
      }))();
    },
    exportToPDFInventory: function exportToPDFInventory() {
      this.$htmlToPaper("printInventory");
    },
    exportToPDFLogs: function exportToPDFLogs() {
      this.$htmlToPaper("printLogs");
    },
    exportToPDFPuantaj: function exportToPDFPuantaj() {
      this.$htmlToPaper("printPuantaj");
    },
    exportToPDFHareketler: function exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    exportToPDFIzinler: function exportToPDFIzinler() {
      this.$htmlToPaper("printIzinler");
    },
    exportToPDFOdemeler: function exportToPDFOdemeler() {
      this.$htmlToPaper("printOdemeler");
    },
    toDateFormat: function toDateFormat(str, format) {
      if (!str || str == "") {
        return str;
      }
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "yyyy-aa-gg ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun + " " + str.getHours() + ":" + str.getMinutes();
      } else if (format == "yyyy-aa-gg") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    selectPaymentDefinition: function selectPaymentDefinition(id, name, status) {
      this.isNewPaymentDefinition = false;
      this.paymentDefinition.id = id;
      this.paymentDefinition.name = name;
      this.paymentDefinition.status = status;
    },
    newPaymentDefinition: function newPaymentDefinition() {
      this.isNewPaymentDefinition = true;
      this.paymentDefinition.id = null;
      this.paymentDefinition.name = "";
      this.paymentDefinition.status = 1;
    },
    savePaymentDefinition: function savePaymentDefinition() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, name, status, response, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this8.paymentDefinition.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this8.$ml.get("alerts.salaryNameNotBlank"));
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                id = _this8.paymentDefinition.id;
                name = _this8.paymentDefinition.name;
                status = _this8.paymentDefinition.status;

                if (!(_this8.isNewPaymentDefinition == true)) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 10;
                return _this8.$axios.post("/Salary", {
                  name: name,
                  status: status
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this8.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 10:
                response = _context2.sent;

                _this8.newPaymentDefinition();
                _this8.getPaymentDefinitions();
                _context2.next = 20;
                break;

              case 15:
                _context2.next = 17;
                return _this8.$axios.post("/Salary/" + id, {
                  id: id,
                  name: name,
                  status: status
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this8.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 17:
                _response = _context2.sent;

                _this8.newPaymentDefinition();
                _this8.getPaymentDefinitions();

              case 20:
                _context2.next = 26;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2["catch"](3);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[3, 22]]);
      }))();
    },
    deletePaymentDefinition: function deletePaymentDefinition() {
      var _this9 = this;

      try {
        var id = this.paymentDefinition.id;
        if (id != null) {
          var response = this.$axios.delete("/Salary/" + id).then(function (response) {
            _this9.getPaymentDefinitions();
            _this9.newPaymentDefinition();
            alertify.success(_this9.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this9.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this9.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectVisitorCardGroup: function selectVisitorCardGroup(id, name, devices) {
      var _this10 = this;

      this.isNewVisitorCardGroup = false;
      this.selectedVisitorCardGroupId = id;
      this.selectedVisitorCardGroupDevices = devices;
      this.readers.forEach(function (device) {
        device.VCGcheck = false;
      });
      if (devices) {
        devices.forEach(function (item) {
          _this10.readers.forEach(function (device) {
            if (item == device.readerId) {
              device.VCGcheck = true;
            }
          });
        });
      }
      this.selectedVisitorCardGroupName = name;
    },
    newVisitorCardGroup: function newVisitorCardGroup() {
      this.isNewVisitorCardGroup = true;
      this.readers.forEach(function (device) {
        device.VCGcheck = false;
      });
      this.selectedVisitorCardGroupId = null;
      this.selectedVisitorCardGroupDevices = [];
      this.selectedVisitorCardGroupName = "";
    },
    saveVisitorCardGroup: function saveVisitorCardGroup() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, name, devices, response, _response2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this11.selectedVisitorCardGroupName == "")) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this11.$ml.get("alerts.visitorCardGroupNameNotBlank"));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;
                id = _this11.selectedVisitorCardGroupId;
                _context3.next = 7;
                return _this11.getCheckReaders();

              case 7:
                name = _this11.selectedVisitorCardGroupName;
                devices = _this11.selectedVisitorCardGroupDevices;

                if (!(_this11.isNewVisitorCardGroup == true)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 12;
                return _this11.$axios.post("/VisitorGroups", {
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this11.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this11.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this11.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 12:
                response = _context3.sent;

                _this11.newVisitorCardGroup();
                _this11.getVisitorCardGroups();
                _context3.next = 22;
                break;

              case 17:
                _context3.next = 19;
                return _this11.$axios.post("/VisitorGroups/" + id, {
                  id: id,
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this11.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this11.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this11.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 19:
                _response2 = _context3.sent;

                _this11.newVisitorCardGroup();
                _this11.getVisitorCardGroups();

              case 22:
                _context3.next = 28;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this11, [[3, 24]]);
      }))();
    },
    deleteVisitorCardGroup: function deleteVisitorCardGroup() {
      var _this12 = this;

      try {
        var id = this.selectedVisitorCardGroupId;
        if (id != null) {
          var response = this.$axios.delete("/VisitorGroups/" + id).then(function (response) {
            _this12.getVisitorCardGroups();
            _this12.newVisitorCardGroup();
            alertify.success(_this12.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this12.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this12.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    removePhonePair: function removePhonePair() {
      var _this13 = this;

      try {
        var id = this.employee.id;
        if (id != null) {
          var response = this.$axios.delete("/Employees/RemovePhonePair/" + id).then(function (response) {
            _this13.getEmployee(id);
            alertify.success(_this13.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this13.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this13.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectStatu: function selectStatu(id, name) {
      this.isNewStatu = false;
      this.selectedStatuId = id;
      this.selectedStatuName = name;
    },
    newStatu: function newStatu() {
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
    },
    saveStatu: function saveStatu() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var id, name, response, _response3;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this14.selectedStatuName == "")) {
                  _context4.next = 3;
                  break;
                }

                alertify.warning(_this14.$ml.get("alerts.statusNameNotBlank"));
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;
                id = _this14.selectedStatuId;
                name = _this14.selectedStatuName;

                if (!(_this14.isNewStatu == true)) {
                  _context4.next = 14;
                  break;
                }

                _context4.next = 9;
                return _this14.$axios.post("/Employees/AddStatus", {
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this14.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this14.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this14.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
                response = _context4.sent;

                _this14.newStatu();
                _this14.getStatus();
                _context4.next = 19;
                break;

              case 14:
                _context4.next = 16;
                return _this14.$axios.post("/Employees/UpdateStatus/" + id, {
                  id: id,
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this14.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this14.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this14.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 16:
                _response3 = _context4.sent;

                _this14.newStatu();
                _this14.getStatus();

              case 19:
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](3);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this14, [[3, 21]]);
      }))();
    },
    deleteStatu: function deleteStatu() {
      var _this15 = this;

      try {
        var id = this.selectedStatuId;
        if (id != null) {
          var response = this.$axios.delete("/Employees/DeleteStatus/" + id).then(function (response) {
            _this15.getStatus();
            _this15.newStatu();
            alertify.success(_this15.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this15.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this15.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectState: function selectState(id, name, status) {
      this.isNewState = false;
      this.selectedStateId = id;
      this.selectedStateName = name;
      this.selectedStateStatus = status;
    },
    newState: function newState() {
      this.isNewState = true;
      this.selectedStateId = null;
      this.selectedStateName = "";
      this.selectedStateStatus = false;
    },
    saveState: function saveState() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var id, name, status, response, _response4;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this16.selectedStateName == "")) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning(_this16.$ml.get("alerts.stateNameNotBlank"));
                return _context5.abrupt("return");

              case 3:
                _context5.prev = 3;
                id = _this16.selectedStateId;
                name = _this16.selectedStateName;
                status = _this16.selectedStateStatus;

                if (!(_this16.isNewState == true)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 10;
                return _this16.$axios.post("/Employees/AddState", {
                  name: name,
                  status: status
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this16.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this16.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 10:
                response = _context5.sent;

                _this16.newState();
                _this16.getStates();
                _context5.next = 20;
                break;

              case 15:
                _context5.next = 17;
                return _this16.$axios.post("/Employees/UpdateState/" + id, {
                  id: id,
                  name: name,
                  status: status
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this16.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this16.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 17:
                _response4 = _context5.sent;

                _this16.newState();
                _this16.getStates();

              case 20:
                _context5.next = 26;
                break;

              case 22:
                _context5.prev = 22;
                _context5.t0 = _context5["catch"](3);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);

              case 26:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this16, [[3, 22]]);
      }))();
    },
    deleteState: function deleteState() {
      var _this17 = this;

      try {
        var id = this.selectedStateId;
        if (id != null) {
          var response = this.$axios.delete("/Employees/DeleteState/" + id).then(function (response) {
            _this17.getStates();
            _this17.newState();
            alertify.success(_this17.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this17.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this17.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    validityDateOpenModal: function validityDateOpenModal() {
      if (this.employee.id) {
        if (this.employee.validityEndDate) {
          //remove
          $("#modalRemoveValidity").modal("show");
        } else {
          //create
          $("#modalCreateValidity").modal("show");
        }
      } else {
        alertify.warning(this.$ml.get("alerts.selectedEmployeeNotBlank"));
        return;
      }
    },
    validityDateCreate: function validityDateCreate() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var today, tarih;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                //create
                today = new Date();
                tarih = new Date(_this18.employee.validityEndDate + " 00:00:00");

                if (!(tarih <= today)) {
                  _context6.next = 7;
                  break;
                }

                alertify.warning(_this18.$ml.get("alerts.invalidDate"));
                return _context6.abrupt("return");

              case 7:
                _context6.next = 9;
                return _this18.$axios.post("/Employees/SetValidityDate", {
                  employeeId: _this18.employee.id,
                  date: _this18.employee.validityEndDate
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this18.$ml.get("alerts.savedSuccessfully"));
                    $("#modalCreateValidity").modal("hide");
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this18.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this18.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this18);
      }))();
    },
    validityDateRemove: function validityDateRemove() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!_this19.employee.validityEndDate) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return _this19.$axios.post("/Employees/RemoveValidityDate", {
                  employeeId: _this19.employee.id,
                  date: null
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this19.$ml.get("alerts.savedSuccessfully"));
                    _this19.employee.validityEndDate = null;
                    $("#modalRemoveValidity").modal("hide");
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this19.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this19);
      }))();
    },
    selectAuthorizedEmployee: function selectAuthorizedEmployee(id) {
      if (this.selectAP == 1) {
        this.employee.authorizedPerson1 = id;
      } else {
        this.employee.authorizedPerson2 = id;
      }
    },
    changeOvertimePlace: function changeOvertimePlace(event) {
      this.selectedOTPlaceId = event.target.value;
    },
    changeOvertimeDescription: function changeOvertimeDescription(event) {
      this.selectedOTDescriptionId = event.target.value;
    },
    changePaymentForEmployee: function changePaymentForEmployee(event) {
      this.payment.salaryId = event.target.value;
    },
    changeAllowenceType: function changeAllowenceType(event) {
      this.allowence.allowenceType = event.target.value;
    },
    changeCheckEqualMissingTime: function changeCheckEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.equalTheMissingTime = false;
        this.allowence.allowenceTime = "00:00";
      } else {
        this.allowence.equalTheMissingTime = true;
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeEqualMissingTime: function changeEqualMissingTime() {
      if (this.allowence.equalTheMissingTime == true) {
        this.allowence.allowenceTime = this.allowence.missingTime;
      }
    },
    changeAllowenceStartTime: function changeAllowenceStartTime() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var ed, sd, startDate, id, response, mT, mTT;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this20.allowence.allowenceType == 1)) {
                  _context8.next = 13;
                  break;
                }

                ed = _this20.allowence.endDate.split("T");
                sd = _this20.allowence.startDate.split("T");

                _this20.allowence.endDate = sd[0] + "T" + ed[1];
                startDate = sd[0] + "T" + sd[1];

                if (!(startDate != null && sd[0] != null && sd[1] != null && startDate > "1900-01-01T00:00")) {
                  _context8.next = 13;
                  break;
                }

                _this20.isLoadingAllowenceModal = true;
                id = _this20.employee.id;
                _context8.next = 10;
                return _this20.$axios.post("/EmployeeDetails/GetMissingHour", {
                  empId: id,
                  date: startDate
                });

              case 10:
                response = _context8.sent;

                if (response.status == 200) {
                  mT = response.data;
                  mTT = mT.split("T");

                  _this20.allowence.missingTime = mTT[1];
                  if (_this20.allowence.equalTheMissingTime == true) {
                    _this20.allowence.allowenceTime = mTT[1];
                  }
                } else if (response.status == 201) {
                  _this20.allowence.missingTime = "00:00";
                  _this20.allowence.allowenceTime = "00:00";
                  alertify.warning(_this20.$ml.get("alerts.selectedDayNotMissingHour"));
                }
                _this20.isLoadingAllowenceModal = false;

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this20);
      }))();
    },
    changeInOutListType: function changeInOutListType(number) {
      this.inOut.inOutListType = number;
    },
    changeInOutListDoorType: function changeInOutListDoorType(event) {
      this.inOut.inOutListDoorType = event.target.value;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.employee.image = null;
    },
    getStatusFromId: function getStatusFromId(id) {
      var aList = this.status;
      var stat = aList.filter(function (statu) {
        return statu.id == id;
      });
      if (stat != "" && stat != null) {
        return stat[0].name;
      } else {
        return null;
      }
    },
    getStateFromId: function getStateFromId(id) {
      var aList = this.states;
      var stat = aList.filter(function (state) {
        return state.id == id;
      });
      if (stat != "" && stat != null) {
        return stat[0].name;
      } else {
        return null;
      }
    },
    getWorkGroupFromId: function getWorkGroupFromId(id) {
      var aList = this.workGroups;
      var wg = aList.filter(function (workGroup) {
        return workGroup.id == id;
      });
      if (wg != "" && wg != null) {
        return wg[0].name;
      } else {
        return null;
      }
    },
    getWorkPlaceFromId: function getWorkPlaceFromId(id) {
      var aList = this.workPlaceDefinitions;
      var wg = aList.filter(function (workPlace) {
        return workPlace.id == id;
      });
      if (wg != "" && wg != null) {
        return wg[0].name;
      } else {
        return "";
      }
    },
    getDepartmentFromId: function getDepartmentFromId(id) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    getEmpNameFromId: function getEmpNameFromId(id) {
      var aList = this.allEmployees;
      var emp = aList.filter(function (emp) {
        return emp.id == id;
      });
      if (emp != "" && emp != null) {
        var title = "";
        if (emp[0].title != "") {
          title = " - " + emp[0].title;
        }
        return emp[0].name + title;
      } else {
        return null;
      }
    },
    getExtraFieldNameFromKey: function getExtraFieldNameFromKey(key) {
      var extraField = this.extraFieldList.filter(function (a) {
        return a.id == key;
      });
      if (extraField[0]) {
        return extraField[0].name;
      } else {
        return "";
      }
    },
    getLogs: function getLogs() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var logs, startDate, endDate, id, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!(_this21.logStartDate == null | _this21.logEndDate == null)) {
                  _context9.next = 3;
                  break;
                }

                alertify.warning(_this21.$ml.get("alerts.invalidDate"));
                return _context9.abrupt("return");

              case 3:
                _context9.prev = 3;

                _this21.isLoadingLogs = true;
                logs = [];
                startDate = _this21.logStartDate;
                endDate = _this21.logEndDate;
                id = _this21.employee.id;
                _context9.next = 11;
                return _this21.$axios.post("/EmployeeDetails/GetOperationLogs", {
                  id: id,
                  startDate: startDate,
                  endDate: endDate
                });

              case 11:
                response = _context9.sent;

                response.data.forEach(function (doc) {
                  logs.push({
                    id: doc.id,
                    date: doc.date,
                    description: doc.description
                  });
                });
                _this21.employee.logs = logs;
                _this21.isLoadingLogs = false;
                _context9.next = 22;
                break;

              case 17:
                _context9.prev = 17;
                _context9.t0 = _context9["catch"](3);

                console.error(_context9.t0);
                alertify.error(_context9.t0.message);
                _this21.isLoadingLogs = false;

              case 22:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this21, [[3, 17]]);
      }))();
    },
    changePaymentDefinitionStatus: function changePaymentDefinitionStatus(event) {
      this.paymentDefinition.status = event.target.value;
    },
    changeAnnualPermit: function changeAnnualPermit(event) {
      this.employee.annualPermitId = event.target.value;
    },
    changeVisitorCardGroup: function changeVisitorCardGroup(event) {
      this.employee.visitorCardGroupId = event.target.value;
    },
    changeTerminalStatu: function changeTerminalStatu(event) {
      this.employee.terminalStatu = event.target.value;
    },
    changeFoodGroup: function changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
    },
    changeInOutDoor: function changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeInOutDoor2: function changeInOutDoor2(event) {
      this.inOut2.readerId = event.target.value;
    },
    changeInOutType: function changeInOutType(event) {
      this.inOut.inOutType = event.target.value;
      this.selectedDoorTypeMovement = event.target.value;
    },
    changeInOutType2: function changeInOutType2(event) {
      this.inOut2.inOutType = event.target.value;
      this.selectedDoorTypeMovement = event.target.value;
    },
    changeAllowence: function changeAllowence(event) {
      this.allowence.allowenceId = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    changeDepartments: function changeDepartments(event) {
      this.employee.departmentId = event.target.value;
    },
    changeWorkGroups: function changeWorkGroups(event) {
      this.employee.workGroupId = event.target.value;
    },
    changeStatus: function changeStatus(event) {
      this.employee.statuId = event.target.value;
    },
    changeStates: function changeStates(event) {
      this.employee.stateId = event.target.value;
      var state = this.stateList.filter(function (a) {
        return a.id == event.target.value;
      });
      if (state[0]) {
        if (state[0].status == true) {
          $("#modal-istencikis").modal("show");
        }
      }
    },
    changeAccessGroups: function changeAccessGroups(event) {
      if (event.target.value != null && event.target.value != 0) {
        this.checkListFromAccessGroup(event.target.value);
      }
      this.employee.accessGroupId = event.target.value;
    },
    changeGender: function changeGender(event) {
      this.employee.gender = event.target.value;
    },
    changeEducationStatus: function changeEducationStatus(event) {
      this.employee.educationStatus = event.target.value;
    },
    changeMilitaryStatus: function changeMilitaryStatus(event) {
      this.employee.militaryStatus = event.target.value;
    },
    changeSmokeStatus: function changeSmokeStatus(event) {
      this.employee.smokeStatus = event.target.value;
    },
    changeMaritalStatus: function changeMaritalStatus(event) {
      this.employee.maritalStatus = event.target.value;
    },
    changeRecordType: function changeRecordType(event) {
      if (this.modules.dormitory) {
        if (event.target.value == "2") {
          this.employee.isStudent = true;
        } else {
          this.employee.isStudent = false;
          this.employee.isStayInDormitory = false;
        }
      }
    },
    selectFoodType: function selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    checkReaders: function checkReaders() {
      var _this22 = this;

      this.isCheck = !this.isCheck;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this22.isCheck) {
          doc.check = _this22.isCheck;
        }
      });
    },
    getReaders: function getReaders() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                readers = [];
                _context10.next = 4;
                return _this23.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          inOrOut: doc.inOrOut,
                          check: false,
                          VCGcheck: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this23.$ml.get("alerts.getReadersError"));
                      _this23.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context10.sent;

                _this23.readers = readers;
                _context10.next = 12;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error("Servis Hatası : " + _context10.t0.message);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this23, [[0, 8]]);
      }))();
    },
    updateFoodCredit: function updateFoodCredit() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var employeeId, credit, creditType, response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(_this24.selectedFoodCount == null)) {
                  _context11.next = 3;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.creditNotBlank"));
                return _context11.abrupt("return");

              case 3:
                _context11.prev = 3;
                employeeId = _this24.employee.id;
                credit = _this24.selectedFoodCount.replace(",", ".");
                creditType = _this24.selectedFoodType;
                _context11.next = 9;
                return _this24.$axios.post("/EmployeeDetails/UpdateCredit", {
                  employeeId: employeeId,
                  creditType: creditType,
                  credit: credit
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this24.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this24.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this24.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
                response = _context11.sent;

                _this24.selectedFoodCount = 0;
                _this24.getEmployee(employeeId);
                _context11.next = 18;
                break;

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11["catch"](3);

                console.error(_context11.t0);
                alertify.error(_context11.t0.message);

              case 18:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this24, [[3, 14]]);
      }))();
    },
    getCheckReaders: function getCheckReaders() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this25.selectedVisitorCardGroupDevices = [];
                _context12.next = 3;
                return _this25.readers.forEach(function (doc) {
                  if (doc.VCGcheck == true) {
                    _this25.selectedVisitorCardGroupDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this25);
      }))();
    },
    sendUserToDevice: function sendUserToDevice(deviceId) {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var aList, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!deviceId) {
                  _context13.next = 15;
                  break;
                }

                _this26.isLoading = true;
                _context13.prev = 2;
                aList = [];

                aList.push(deviceId);
                _context13.next = 7;
                return _this26.$axios.post("/EmployeeDetails/SendUserToDevices", {
                  empId: _this26.employee.id,
                  devices: aList
                }).then(function (response) {
                  if (response.status == 200) {
                    _this26.isLoading = false;
                    alertify.success(_this26.$ml.get("alerts.commandSendToReaderSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this26.isLoading = false;
                    _this26.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this26.isLoading = false;
                    alertify.error(_this26.$ml.get("errors.connectionError"));
                  } else {
                    _this26.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 7:
                response = _context13.sent;
                _context13.next = 15;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](2);

                _this26.isLoading = false;
                console.error(_context13.t0);
                alertify.error(_context13.t0.message);

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this26, [[2, 10]]);
      }))();
    },
    sendUserToDevices: function sendUserToDevices() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var aList, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this27.isLoading = true;
                _context14.prev = 1;
                aList = [];
                _context14.next = 5;
                return _this27.readers.filter(function (doc) {
                  if (doc.check == true) {
                    aList.push(doc.readerId);
                  }
                });

              case 5:
                _context14.next = 7;
                return _this27.$axios.post("/EmployeeDetails/SendUserToDevices", {
                  empId: _this27.employee.id,
                  devices: aList
                }).then(function (response) {
                  if (response.status == 200) {
                    _this27.isLoading = false;
                    alertify.success(_this27.$ml.get("alerts.commandSentToDevicesSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this27.isLoading = false;
                    _this27.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this27.isLoading = false;
                    alertify.error(_this27.$ml.get("errors.connectionError"));
                  } else {
                    _this27.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 7:
                response = _context14.sent;
                _context14.next = 15;
                break;

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](1);

                _this27.isLoading = false;
                console.error(_context14.t0);
                alertify.error(_context14.t0.message);

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this27, [[1, 10]]);
      }))();
    },
    GetUserDataFromDevice: function GetUserDataFromDevice(readerId) {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this28.isLoading = true;
                _context15.prev = 1;
                empId = _this28.employee.id;
                _context15.next = 5;
                return _this28.$axios.post("/EmployeeDetails/GetUserDataFromDevice", {
                  empId: empId,
                  readerId: readerId
                }).then(function (response) {
                  if (response.status == 200) {
                    _this28.isLoading = false;
                    alertify.success(_this28.$ml.get("alerts.getUserInfoFromTerminalsSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this28.isLoading = false;
                    _this28.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this28.isLoading = false;
                    alertify.error(_this28.$ml.get("errors.connectionError"));
                  } else {
                    _this28.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context15.sent;
                _context15.next = 13;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](1);

                _this28.isLoading = false;
                console.error(_context15.t0);
                alertify.error(_context15.t0.message);

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this28, [[1, 8]]);
      }))();
    },
    SendGetFaceCommand: function SendGetFaceCommand(readerId) {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this29.isLoading = true;
                _context16.prev = 1;
                empId = _this29.employee.id;
                _context16.next = 5;
                return _this29.$axios.post("/EmployeeDetails/SendGetFaceCommand", {
                  empId: empId,
                  readerId: readerId
                }).then(function (response) {
                  if (response.status == 200) {
                    _this29.isLoading = false;
                    alertify.success(_this29.$ml.get("alerts.getFaceTemplateFromSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this29.isLoading = false;
                    _this29.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this29.isLoading = false;
                    alertify.error(_this29.$ml.get("errors.connectionError"));
                  } else {
                    _this29.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context16.sent;
                _context16.next = 13;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](1);

                _this29.isLoading = false;
                console.error(_context16.t0);
                alertify.error(_context16.t0.message);

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this29, [[1, 8]]);
      }))();
    },
    selectGetFingerFromUsb: function selectGetFingerFromUsb() {
      this.selectedTerminal = null;
      this.fpScreen = 0;
      $("#fingerPrintModal").modal("show");
    },
    selectGetFingerFromTerminal: function selectGetFingerFromTerminal(readerId) {
      this.selectedTerminal = readerId;
      this.fpScreen = 0;
      $("#fingerPrintModal").modal("show");
    },
    SendGetFingerCommand: function SendGetFingerCommand(readerId, fpIndex) {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this30.isLoading = true;
                _context17.prev = 1;
                empId = _this30.employee.id;
                _context17.next = 5;
                return _this30.$axios.post("/EmployeeDetails/SendGetFingerCommand", {
                  empId: empId,
                  readerId: readerId,
                  fpIndex: fpIndex
                }).then(function (response) {
                  if (response.status == 200) {
                    _this30.isLoading = false;
                    alertify.success(_this30.$ml.get("alerts.getFingerprintsFromTerminalsSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this30.isLoading = false;
                    _this30.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this30.isLoading = false;
                    alertify.error(_this30.$ml.get("errors.connectionError"));
                  } else {
                    _this30.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context17.sent;
                _context17.next = 13;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](1);

                _this30.isLoading = false;
                console.error(_context17.t0);
                alertify.error(_context17.t0.message);

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this30, [[1, 8]]);
      }))();
    },
    newInOut2: function newInOut2() {
      this.isNewInOut2 = true;
      this.isActiveInOut2 = true;
      var docc = this.selectedDailyPayrol.date.split(".");
      this.inOut2.inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
      this.inOut2.inOutType = 0;
      this.selectedDoorTypeMovement = 0;
      this.inOut2.readerId = "0";
      this.inOut2.inOutId = null;
    },
    selectInOut2: function selectInOut2(inOutDetail) {
      this.isNewInOut2 = false;
      this.isActiveInOut2 = true;
      this.inOut2.inOutId = inOutDetail.id;
      this.inOut2.inOutType = inOutDetail.inOrOut;
      this.selectedDoorTypeMovement = inOutDetail.inOrOut;
      this.inOut2.inOutAdd = inOutDetail.unFormattedDate;
      this.inOut2.readerId = inOutDetail.readerId;
    },
    confirmOverTime: function confirmOverTime() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var id, calculatedDate, confirmedDate, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this31.selectedDailyPayrol.confirmedOverTime = _this31.selectedDailyPayrol.calculatedOverTime;
                id = _this31.selectedDailyPayrol.overTimeId;
                calculatedDate = "1900-01-01T" + _this31.selectedDailyPayrol.calculatedOverTime + ":00";
                confirmedDate = "1900-01-01T" + _this31.selectedDailyPayrol.confirmedOverTime.replace("Z", "");

                if (!(confirmedDate > calculatedDate)) {
                  _context18.next = 8;
                  break;
                }

                alertify.warning(_this31.$ml.get("alerts.confirmedOvertimeCannotBeGreaterThanCalculated"));
                return _context18.abrupt("return");

              case 8:
                _this31.isLoadingPayrolls = true;
                _context18.next = 11;
                return _this31.$axios.post("/EmployeeDetails/CustomConfirmOvertime", {
                  id: id,
                  confirmedDate: confirmedDate,
                  overtimeDescriptionId: _this31.selectedOTDescriptionId,
                  overtimePlaceId: _this31.selectedOTPlaceId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this31.$ml.get("alerts.savedSuccessfully"));
                    _this31.isLoadingPayrolls = false;
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this31.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this31.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 11:
                response = _context18.sent;

                _this31.getEmpPayrolls();
                _context18.next = 19;
                break;

              case 15:
                _context18.prev = 15;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error(_context18.t0.message);

              case 19:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this31, [[0, 15]]);
      }))();
    },
    customConfirmOverTime: function customConfirmOverTime() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var id, calculatedDate, confirmedDate, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                id = _this32.selectedDailyPayrol.overTimeId;
                calculatedDate = "1900-01-01T" + _this32.selectedDailyPayrol.calculatedOverTime + ":00";
                confirmedDate = "1900-01-01T" + _this32.selectedDailyPayrol.confirmedOverTime.replace("Z", "");

                if (!(confirmedDate > calculatedDate)) {
                  _context19.next = 7;
                  break;
                }

                alertify.warning(_this32.$ml.get("alerts.confirmedOvertimeCannotBeGreaterThanCalculated"));
                return _context19.abrupt("return");

              case 7:
                _this32.isLoadingPayrolls = true;
                _context19.next = 10;
                return _this32.$axios.post("/EmployeeDetails/CustomConfirmOvertime", {
                  id: id,
                  confirmedDate: confirmedDate,
                  overtimeDescriptionId: _this32.selectedOTDescriptionId,
                  overtimePlaceId: _this32.selectedOTPlaceId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this32.$ml.get("alerts.savedSuccessfully"));
                    _this32.isLoadingPayrolls = false;
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this32.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this32.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 10:
                response = _context19.sent;

                _this32.getEmpPayrolls();
                _context19.next = 18;
                break;

              case 14:
                _context19.prev = 14;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error(_context19.t0.message);

              case 18:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this32, [[0, 14]]);
      }))();
    },
    getDailyPayrollDetails: function getDailyPayrollDetails(tarih, workGroup) {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var docc, empId, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;

                _this33.selectedDailyPayrol.date = "";
                _this33.selectedDailyPayrol.movements = [];
                _this33.selectedDailyPayrol.workGroup = "";
                _this33.selectedDailyPayrol.payrolls = [];
                _this33.selectedDailyPayrol.calculatedOverTime = "00:00";
                _this33.selectedDailyPayrol.confirmedOverTime = "00:00";
                _this33.selectedDailyPayrol.overTimeId = null;
                _this33.selectedDailyPayrol.date = tarih;
                _this33.selectedDailyPayrol.workGroup = workGroup;
                docc = tarih.split(".");

                _this33.inOut2.inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
                empId = _this33.employee.id;
                _context20.next = 15;
                return _this33.$axios.post("/EmployeeDetails/GetDailyPayrollDetails", {
                  date: tarih,
                  empId: empId
                }).then(function (response) {
                  if (response.status == 200) {
                    if (response.data.overtimes) {
                      _this33.selectedDailyPayrol.calculatedOverTime = response.data.overtimes.calculated;
                      _this33.selectedDailyPayrol.confirmedOverTime = response.data.overtimes.confirmed;
                      _this33.selectedDailyPayrol.confirmedOverTime = response.data.overtimes.confirmed ? _this33.toDateFormat(response.data.overtimes.confirmed, "ss:dd") : "";
                      _this33.selectedDailyPayrol.overTimeId = response.data.overtimes.overTimeId;
                    }
                    response.data.movements.forEach(function (doc) {
                      _this33.selectedDailyPayrol.movements.push({
                        id: doc.id,
                        unFormattedDate: doc.unFormattedDate,
                        readerId: doc.readerId,
                        inOrOut: doc.inOrOut,
                        date: doc.date,
                        status: doc.status
                      });
                    });
                    response.data.payrolls.forEach(function (doc) {
                      _this33.selectedDailyPayrol.payrolls.push({
                        time: doc.time,
                        payroll: doc.payroll
                      });
                    });
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this33.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this33.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 15:
                response = _context20.sent;
                _context20.next = 22;
                break;

              case 18:
                _context20.prev = 18;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error(_context20.t0.message);

              case 22:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this33, [[0, 18]]);
      }))();
    },
    selectNode: function selectNode() {
      this.isLoading = true;
      var node = document.getElementById("selectedNode").value;
      var depId = this.getDepartmentFromName(node);
      if (depId) {
        this.employee.departmentId = depId;
      }
      //$("#select-department").modal("hide");
      this.isLoading = false;
    },
    getDepartmentFromName: function getDepartmentFromName(name) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0].id;
      } else {
        return null;
      }
    },
    setTree: function setTree() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var activeUser, departments, root, tree;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return _this34.$store.getters.getUser;

              case 2:
                activeUser = _context21.sent;
                departments = _this34.departments;
                root = new TreeNode(activeUser.companyName + " (" + _this34.$ml.get("shared.company") + ")");
                _context21.next = 7;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == null) {
                    var node = new TreeNode(doc.name);
                    root.addChild(node);
                    _this34.addChildDep(node, doc.id);
                  }
                });

              case 7:
                tree = new TreeView(root, "#treeview", {
                  leaf_icon: "<i class='fa fa-star'></i>",
                  parent_icon: "<i class='fa fa-sitemap'></i>",
                  open_icon: "<i class='fa fa-chevron-down'></i>",
                  close_icon: "<i class='fa fa-chevron-right'></i>"
                });

              case 8:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this34);
      }))();
    },
    addChildDep: function addChildDep(Tnode, mainDep) {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var departments;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                departments = _this35.departments;
                _context22.next = 3;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == mainDep) {
                    var node = new TreeNode(doc.name);
                    Tnode.addChild(node);
                    _this35.addChildDep(node, doc.id);
                  }
                });

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this35);
      }))();
    },
    getChildDep: function getChildDep(dep) {
      var DepartmentList = this.departments;
      return DepartmentList.filter(function (department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind: function getMainFind(id) {
      var DepartmentList = this.departments;
      var department = DepartmentList.filter(function (department) {
        return department.id == id;
      });
    },
    getAccessGroupFromId: function getAccessGroupFromId(id) {
      var aList = this.accessGroups;
      var dep = aList.filter(function (accessGroups) {
        return accessGroups.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    checkListFromAccessGroup: function checkListFromAccessGroup(id) {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var accessGroup, aa;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                accessGroup = _this36.getAccessGroupFromId(id);
                aa = _this36.readers;
                _context23.next = 4;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 4:
                accessGroup.selectedReaders.forEach(function (secilenReader) {
                  _this36.readers.forEach(function (doc) {
                    if (doc.readerId == secilenReader.id) {
                      doc.check = true;
                    }
                  });
                });

              case 5:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this36);
      }))();
    },
    getCheckReaderList: function getCheckReaderList() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var aList;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                aList = _this37.readers;

                _this37.employee.readers = [];
                _context24.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this37.employee.readers.push(doc.readerId);
                  }
                });

              case 4:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this37);
      }))();
    },
    setCheckReaderList: function setCheckReaderList() {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var aa, aList;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                aa = _this38.readers;
                _context25.next = 3;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 3:
                aList = _this38.employee.readers;
                _context25.next = 6;
                return aList.forEach(function (secilenReader) {
                  _this38.readers.forEach(function (doc) {
                    if (doc.readerId == secilenReader) {
                      doc.check = true;
                    }
                  });
                });

              case 6:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this38);
      }))();
    },
    getVisitorCardGroups: function getVisitorCardGroups() {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var cardGroups, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                cardGroups = [];
                _context26.next = 4;
                return _this39.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      cardGroups.push({
                        id: doc.id,
                        name: doc.name,
                        devices: doc.devices
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this39.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this39.$ml.get("errors.connectionError"));
                      _this39.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this39.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this39.visitorCardGroups = cardGroups;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Hata :" + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this39, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;
                accessGroups = [];
                _context27.next = 4;
                return _this40.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this40.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this40.$ml.get("errors.connectionError"));
                      _this40.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this40.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context27.sent;

                _this40.accessGroups = accessGroups;
                _context27.next = 12;
                break;

              case 8:
                _context27.prev = 8;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error("Servis Hatası :" + _context27.t0.message);

              case 12:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this40, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this41 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                departments = [];
                _context28.prev = 1;
                _context28.next = 4;
                return _this41.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this41.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this41.$ml.get("errors.connectionError"));
                      _this41.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this41.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context28.sent;

                _this41.setTree();
                _this41.departments = departments;
                _this41.sortableTrees();
                _this41.isLoading = false;
                _context28.next = 15;
                break;

              case 11:
                _context28.prev = 11;
                _context28.t0 = _context28["catch"](1);

                console.error(_context28.t0);
                alertify.error(_context28.t0);

              case 15:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this41, [[1, 11]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this42 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this42.sortableDepTrees.push(dep);
          _this42.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this43 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this43.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this43.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this44 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;
                foodGroups = [];
                _context29.next = 4;
                return _this44.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this44.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this44.$ml.get("errors.connectionError"));
                      _this44.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this44.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context29.sent;

                _this44.foodGroups = foodGroups;
                _context29.next = 12;
                break;

              case 8:
                _context29.prev = 8;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error("Servis Hatası :" + _context29.t0.message);

              case 12:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this44, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this45 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                status = [];
                _context30.next = 4;
                return _this45.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this45.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this45.$ml.get("errors.connectionError"));
                      _this45.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this45.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this45.status = status;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Servis Hatası :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this45, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this46 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                titles = [];
                _context31.next = 4;
                return _this46.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this46.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this46.$ml.get("errors.connectionError"));
                      _this46.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this46.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context31.sent;

                _this46.titles = titles;
                _context31.next = 12;
                break;

              case 8:
                _context31.prev = 8;
                _context31.t0 = _context31["catch"](0);

                console.error(_context31.t0);
                alertify.error("Servis Hatası :" + _context31.t0.message);

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this46, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this47 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                states = [];
                _context32.next = 4;
                return _this47.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this47.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this47.$ml.get("errors.connectionError"));
                      _this47.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this47.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context32.sent;

                _this47.states = states;
                _context32.next = 12;
                break;

              case 8:
                _context32.prev = 8;
                _context32.t0 = _context32["catch"](0);

                console.error(_context32.t0);
                alertify.error("Servis Hatası :" + _context32.t0.message);

              case 12:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, _this47, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this48 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                workGroups = [];
                _context33.next = 4;
                return _this48.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      model: doc.model,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this48.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this48.$ml.get("errors.connectionError"));
                      _this48.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this48.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context33.sent;

                _this48.workGroups = workGroups;
                _context33.next = 12;
                break;

              case 8:
                _context33.prev = 8;
                _context33.t0 = _context33["catch"](0);

                console.error(_context33.t0);
                alertify.error("Servis Hatası :" + _context33.t0.message);

              case 12:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, _this48, [[0, 8]]);
      }))();
    },
    newExtraField: function newExtraField() {
      this.isNewExtraField = true;
      this.extraFieldId = null;
      this.extraFieldKey = "";
      this.extraFieldValue = "";
    },
    selectExtraField: function selectExtraField(id, value, key) {
      if (id == 0) {
        this.newExtraField();
        this.extraFieldKey = key;
      } else {
        this.extraFieldId = id;
        this.extraFieldValue = value;
        this.extraFieldKey = key;
        this.isNewExtraField = false;
      }
    },
    getExtraFields: function getExtraFields() {
      var _this49 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                _context34.prev = 0;
                extrafields = [];
                _context34.next = 4;
                return _this49.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this49.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this49.$ml.get("errors.connectionError"));
                      _this49.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this49.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context34.sent;

                _this49.extrafields = extrafields;
                _context34.next = 12;
                break;

              case 8:
                _context34.prev = 8;
                _context34.t0 = _context34["catch"](0);

                console.error(_context34.t0);
                alertify.error("Servis Hatası :" + _context34.t0.message);

              case 12:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, _this49, [[0, 8]]);
      }))();
    },
    getExtraFieldsForEmployee: function getExtraFieldsForEmployee() {
      var _this50 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
        var id, extrafields, response;
        return regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.prev = 0;
                id = _this50.employee.id;
                extrafields = [];
                _context35.next = 5;
                return _this50.$axios.get("/Employees/getExtraFields/" + id).then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      key: doc.key,
                      value: doc.value
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this50.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this50.$ml.get("errors.connectionError"));
                      _this50.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this50.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context35.sent;

                _this50.employee.extrafields = extrafields;
                _context35.next = 13;
                break;

              case 9:
                _context35.prev = 9;
                _context35.t0 = _context35["catch"](0);

                console.error(_context35.t0);
                alertify.error("Servis Hatası :" + _context35.t0.message);

              case 13:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, _this50, [[0, 9]]);
      }))();
    },
    deleteExtraField: function deleteExtraField(id) {
      var _this51 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee36() {
        var response;
        return regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                _context36.prev = 0;

                if (!(id != 0)) {
                  _context36.next = 5;
                  break;
                }

                _context36.next = 4;
                return _this51.$axios.delete("/Employees/DeleteExtraField/" + id).then(function (response) {
                  _this51.getExtraFieldsForEmployee();
                  _this51.newExtraField();
                  alertify.success(_this51.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this51.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this51.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 4:
                response = _context36.sent;

              case 5:
                _context36.next = 10;
                break;

              case 7:
                _context36.prev = 7;
                _context36.t0 = _context36["catch"](0);

                alertify.error("Hata Oluştu : " + _context36.t0);

              case 10:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, _this51, [[0, 7]]);
      }))();
    },
    saveExtraField: function saveExtraField() {
      var _this52 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee37() {
        var extraFieldValue2, extraFieldKey2, empId, response, _extraFieldValue, _extraFieldKey, extraFieldId2, _empId, _response5;

        return regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                if (!_this52.isNewExtraField) {
                  _context37.next = 16;
                  break;
                }

                _context37.prev = 1;
                extraFieldValue2 = _this52.extraFieldValue;
                extraFieldKey2 = _this52.extraFieldKey;
                empId = _this52.employee.id;
                _context37.next = 7;
                return _this52.$axios.post("/Employees/AddExtraField", {
                  key: extraFieldKey2,
                  value: extraFieldValue2,
                  empId: empId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this52.$ml.get("alerts.savedSuccessfully"));
                    _this52.getExtraFieldsForEmployee();
                    _this52.newExtraField();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this52.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this52.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 7:
                response = _context37.sent;
                _context37.next = 14;
                break;

              case 10:
                _context37.prev = 10;
                _context37.t0 = _context37["catch"](1);

                console.error(_context37.t0);
                alertify.error(_context37.t0.message);

              case 14:
                _context37.next = 30;
                break;

              case 16:
                _context37.prev = 16;
                _extraFieldValue = _this52.extraFieldValue;
                _extraFieldKey = _this52.extraFieldKey;
                extraFieldId2 = _this52.extraFieldId;
                _empId = _this52.employee.id;
                _context37.next = 23;
                return _this52.$axios.post("/Employees/UpdateExtraField/" + extraFieldId2, {
                  key: _extraFieldKey,
                  value: _extraFieldValue,
                  empId: _empId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this52.$ml.get("alerts.updatedSuccessfully"));
                    _this52.getExtraFieldsForEmployee();
                    _this52.newExtraField();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this52.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this52.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 23:
                _response5 = _context37.sent;
                _context37.next = 30;
                break;

              case 26:
                _context37.prev = 26;
                _context37.t1 = _context37["catch"](16);

                console.error(_context37.t1);
                alertify.error(_context37.t1);

              case 30:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, _this52, [[1, 10], [16, 26]]);
      }))();
    },
    getSalaryForEmployee: function getSalaryForEmployee() {
      var _this53 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee38() {
        var salaries, selectedUser, response;
        return regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                if (!_this53.isNewEmployee) {
                  _context38.next = 3;
                  break;
                }

                alertify.warning(_this53.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context38.abrupt("return");

              case 3:
                _context38.prev = 3;

                _this53.isLoadingSalary = true;
                salaries = [];
                selectedUser = _this53.employee.id;
                _context38.next = 9;
                return _this53.$axios.get("/Employees/SalariesByEmployeeId/" + selectedUser).then(function (response) {
                  salaries = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this53.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this53.$ml.get("errors.connectionError"));
                      _this53.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this53.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context38.sent;

                _this53.salaries = salaries;
                _this53.isLoadingSalary = false;
                _context38.next = 19;
                break;

              case 14:
                _context38.prev = 14;
                _context38.t0 = _context38["catch"](3);

                console.error(_context38.t0);
                alertify.error(_context38.t0.message);
                _this53.isLoadingSalary = false;

              case 19:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, _this53, [[3, 14]]);
      }))();
    },
    getWorkPlaceForEmployee: function getWorkPlaceForEmployee() {
      var _this54 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee39() {
        var workPlaces, selectedUser, response;
        return regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                if (!_this54.isNewEmployee) {
                  _context39.next = 3;
                  break;
                }

                alertify.warning(_this54.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context39.abrupt("return");

              case 3:
                _context39.prev = 3;

                _this54.isLoadingWorkPlace = true;
                workPlaces = [];
                selectedUser = _this54.employee.id;
                _context39.next = 9;
                return _this54.$axios.get("/EmployeeWorkPlace/GetByEmployeeId/" + selectedUser).then(function (response) {
                  workPlaces = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this54.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this54.$ml.get("errors.connectionError"));
                      _this54.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this54.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context39.sent;

                _this54.workPlaces = workPlaces;
                _this54.isLoadingWorkPlace = false;
                _context39.next = 19;
                break;

              case 14:
                _context39.prev = 14;
                _context39.t0 = _context39["catch"](3);

                console.error(_context39.t0);
                alertify.error(_context39.t0.message);
                _this54.isLoadingWorkPlace = false;

              case 19:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, _this54, [[3, 14]]);
      }))();
    },
    getPaymentForEmployee: function getPaymentForEmployee() {
      var _this55 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee40() {
        var payments, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!_this55.isNewEmployee) {
                  _context40.next = 3;
                  break;
                }

                alertify.warning(_this55.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context40.abrupt("return");

              case 3:
                if (!(_this55.payment.searchStartDate == null | _this55.payment.searchEndDate == null)) {
                  _context40.next = 6;
                  break;
                }

                alertify.warning(_this55.$ml.get("alerts.invalidDate"));
                return _context40.abrupt("return");

              case 6:
                _context40.prev = 6;

                _this55.isLoadingPayment = true;
                payments = [];
                selectedUser = _this55.employee.id;
                startDate = _this55.payment.searchStartDate;
                endDate = _this55.payment.searchEndDate;
                _context40.next = 14;
                return _this55.$axios.post("/EmployeeDetails/getSalaries", {
                  id: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    payments.push({
                      id: doc.id,
                      salaryId: doc.salaryId,
                      salaryName: doc.salaryName,
                      price: doc.price,
                      date: doc.date,
                      status: doc.status
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this55.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this55.$ml.get("errors.connectionError"));
                      _this55.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this55.isLoading = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context40.sent;

                _this55.employee.payments = payments;
                _this55.isLoadingPayment = false;
                _context40.next = 24;
                break;

              case 19:
                _context40.prev = 19;
                _context40.t0 = _context40["catch"](6);

                console.error(_context40.t0);
                alertify.error(_context40.t0.message);
                _this55.isLoadingPayment = false;

              case 24:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, _this55, [[6, 19]]);
      }))();
    },
    changeWorkPlaceForEmployee: function changeWorkPlaceForEmployee(event) {
      this.workPlace.workplaceId = event.target.value;
    },
    newWorkPlace: function newWorkPlace() {
      this.isNewWorkPlace = true;
      this.workPlace.id = null;
      this.workPlace.workplaceId = null;
      this.workPlace.description = "";
      this.workPlace.startDate = null;
      this.workPlace.endDate = null;
    },
    selectWorkPlace: function selectWorkPlace(workPlace) {
      var _this56 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee41() {
        return regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                _this56.isNewWorkPlace = false;
                _this56.workPlace.id = workPlace.id;
                _this56.workPlace.workplaceId = workPlace.workplaceId;
                _this56.workPlace.description = workPlace.description;
                _this56.workPlace.startDate = _this56.toDateFormat(workPlace.startDate, "gg.aa.yyyy");
                _this56.workPlace.endDate = _this56.toDateFormat(workPlace.endDate, "gg.aa.yyyy");

              case 6:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, _this56);
      }))();
    },
    deleteWorkPlace: function deleteWorkPlace(id) {
      var _this57 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee42() {
        var response;
        return regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                _context42.prev = 0;

                _this57.isLoadingWorkPlace = true;

                if (!(id != 0)) {
                  _context42.next = 10;
                  break;
                }

                _context42.next = 5;
                return _this57.$axios.delete("/EmployeeWorkPlace/" + id);

              case 5:
                response = _context42.sent;

                _this57.getWorkPlaceForEmployee();
                _this57.newWorkPlace();
                alertify.success(_this57.$ml.get("alerts.deletedSuccessfully"));
                _this57.isLoadingWorkPlace = false;

              case 10:
                _context42.next = 16;
                break;

              case 12:
                _context42.prev = 12;
                _context42.t0 = _context42["catch"](0);

                alertify.error("Hata Oluştu : " + _context42.t0);
                _this57.isLoadingWorkPlace = false;

              case 16:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, _this57, [[0, 12]]);
      }))();
    },
    addWorkPlace: function addWorkPlace() {
      var _this58 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee43() {
        var empId, workPlace, response;
        return regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if (!(_this58.workPlace.startDate == null || _this58.workPlace.endDate == null)) {
                  _context43.next = 3;
                  break;
                }

                alertify.warning(_this58.$ml.get("alerts.invalidDate"));
                return _context43.abrupt("return");

              case 3:
                _context43.prev = 3;

                _this58.isLoadingWorkPlace = true;
                empId = _this58.employee.id;
                workPlace = _this58.workPlace;
                _context43.next = 9;
                return _this58.$axios.post("/EmployeeWorkPlace", {
                  employeeId: empId,
                  workplaceId: workPlace.workplaceId,
                  description: workPlace.description,
                  startDate: workPlace.startDate + "T00:00",
                  endDate: workPlace.endDate + "T23:59"
                });

              case 9:
                response = _context43.sent;

                if (response.status == 200) {
                  $("#modal-work-place").modal("hide");
                  alertify.success(_this58.$ml.get("alerts.savedSuccessfully"));
                  _this58.isLoadingWorkPlace = false;
                } else {
                  alertify.error(response.message);
                  _this58.isLoadingWorkPlace = false;
                }
                _this58.getWorkPlaceForEmployee();
                _this58.isLoadingWorkPlace = false;
                _context43.next = 20;
                break;

              case 15:
                _context43.prev = 15;
                _context43.t0 = _context43["catch"](3);

                console.error(_context43.t0);
                alertify.error(_context43.t0.message);
                _this58.isLoadingWorkPlace = false;

              case 20:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, _this58, [[3, 15]]);
      }))();
    },
    updateWorkPlace: function updateWorkPlace() {
      var _this59 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee44() {
        var empId, workPlace, response;
        return regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (!(_this59.workPlace.startDate == null || _this59.workPlace.endDate == null)) {
                  _context44.next = 3;
                  break;
                }

                alertify.warning(_this59.$ml.get("alerts.invalidDate"));
                return _context44.abrupt("return");

              case 3:
                _context44.prev = 3;

                _this59.isLoadingWorkPlace = true;
                empId = _this59.employee.id;
                workPlace = _this59.workPlace;
                _context44.next = 9;
                return _this59.$axios.put("/EmployeeWorkPlace/" + workPlace.id, {
                  employeeId: empId,
                  workplaceId: workPlace.workplaceId,
                  description: workPlace.description,
                  startDate: workPlace.startDate + "T00:00",
                  endDate: workPlace.endDate + "T23:59"
                });

              case 9:
                response = _context44.sent;

                if (response.status == 200) {
                  $("#modal-work-place").modal("hide");
                  alertify.success(_this59.$ml.get("alerts.updatedSuccessfully"));
                  _this59.isLoadingWorkPlace = false;
                } else {
                  alertify.error(response.message);
                  _this59.isLoadingWorkPlace = false;
                }
                _context44.next = 13;
                return _this59.getWorkPlaceForEmployee();

              case 13:
                _this59.isLoadingWorkPlace = false;
                _context44.next = 21;
                break;

              case 16:
                _context44.prev = 16;
                _context44.t0 = _context44["catch"](3);

                console.error(_context44.t0);
                alertify.error(_context44.t0.message);
                _this59.isLoadingWorkPlace = false;

              case 21:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, _this59, [[3, 16]]);
      }))();
    },
    newSalary: function newSalary() {
      this.salary.id = null;
      this.salary.salary = 0;
      this.salary.updateTime = new Date();
    },
    selectSalary: function selectSalary(salary) {
      var _this60 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee45() {
        return regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _this60.salary.id = salary.id;
                _this60.salary.salary = salary.salary;
                _this60.salary.updateTime = salary.updateTime;

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45, _this60);
      }))();
    },
    deleteSalary: function deleteSalary(id) {
      var _this61 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee46() {
        var response;
        return regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                _context46.prev = 0;

                _this61.isLoadingSalary = true;

                if (!(id != 0)) {
                  _context46.next = 10;
                  break;
                }

                _context46.next = 5;
                return _this61.$axios.delete("/Employees/Salary/" + id);

              case 5:
                response = _context46.sent;

                _this61.getSalaryForEmployee();
                _this61.newSalary();
                alertify.success(_this61.$ml.get("alerts.deletedSuccessfully"));
                _this61.isLoadingSalary = false;

              case 10:
                _context46.next = 16;
                break;

              case 12:
                _context46.prev = 12;
                _context46.t0 = _context46["catch"](0);

                alertify.error("Hata Oluştu : " + _context46.t0);
                _this61.isLoadingSalary = false;

              case 16:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, _this61, [[0, 12]]);
      }))();
    },
    addSalary: function addSalary() {
      var _this62 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee47() {
        var empId, salary, response;
        return regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                if (!(_this62.salary.updateTime == null)) {
                  _context47.next = 3;
                  break;
                }

                alertify.warning(_this62.$ml.get("alerts.invalidDate"));
                return _context47.abrupt("return");

              case 3:
                if (!($.isNumeric(_this62.salary.salary) == false || _this62.salary.salary == 0)) {
                  _context47.next = 6;
                  break;
                }

                alertify.warning(_this62.$ml.get("alerts.invalidPrice"));
                return _context47.abrupt("return");

              case 6:
                _context47.prev = 6;

                _this62.isLoadingSalary = true;
                empId = _this62.employee.id;
                salary = _this62.salary;
                _context47.next = 12;
                return _this62.$axios.post("/Employees/Salary", {
                  employeeId: empId,
                  salary: salary.salary,
                  updateTime: salary.updateTime
                });

              case 12:
                response = _context47.sent;

                if (response.status == 200) {
                  $("#modal-salary").modal("hide");
                  alertify.success(_this62.$ml.get("alerts.savedSuccessfully"));
                  _this62.isLoadingSalary = false;
                } else {
                  alertify.error(response.message);
                  _this62.isLoadingSalary = false;
                }
                _this62.getSalaryForEmployee();
                _this62.isLoadingSalary = false;
                _context47.next = 23;
                break;

              case 18:
                _context47.prev = 18;
                _context47.t0 = _context47["catch"](6);

                console.error(_context47.t0);
                alertify.error(_context47.t0.message);
                _this62.isLoadingSalary = false;

              case 23:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, _this62, [[6, 18]]);
      }))();
    },
    updateSalary: function updateSalary() {
      var _this63 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee48() {
        var empId, salary2, response;
        return regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (!(_this63.salary.updateTime == null)) {
                  _context48.next = 3;
                  break;
                }

                alertify.warning(_this63.$ml.get("alerts.invalidDate"));
                return _context48.abrupt("return");

              case 3:
                if (!(!$.isNumeric(_this63.salary.salary) || _this63.salary.salary == 0)) {
                  _context48.next = 6;
                  break;
                }

                alertify.warning(_this63.$ml.get("alerts.invalidPrice"));
                return _context48.abrupt("return");

              case 6:
                _context48.prev = 6;

                _this63.isLoadingSalary = true;
                empId = _this63.employee.id;
                salary2 = _this63.salary;
                _context48.next = 12;
                return _this63.$axios.put("/Employees/Salary/" + salary2.id, {
                  employeeId: empId,
                  salary: salary2.salary,
                  updateTime: salary2.updateTime
                });

              case 12:
                response = _context48.sent;

                if (response.status == 200) {
                  $("#modal-salary").modal("hide");
                  alertify.success(_this63.$ml.get("alerts.updatedSuccessfully"));
                  _this63.isLoadingSalary = false;
                } else {
                  alertify.error(response.message);
                  _this63.isLoadingSalary = false;
                }
                _context48.next = 16;
                return _this63.getSalaryForEmployee();

              case 16:
                _this63.isLoadingSalary = false;
                _context48.next = 24;
                break;

              case 19:
                _context48.prev = 19;
                _context48.t0 = _context48["catch"](6);

                console.error(_context48.t0);
                alertify.error(_context48.t0.message);
                _this63.isLoadingSalary = false;

              case 24:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, _this63, [[6, 19]]);
      }))();
    },
    newPayment: function newPayment() {
      this.isNewPayment = true;
      this.payment.id = null;
      this.payment.salaryId = null;
      this.payment.salaryName = "";
      this.payment.status = 1;
      this.payment.price = 0;
      this.payment.date = null;
    },
    selectPayment: function selectPayment(id) {
      var _this64 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee49() {
        var aList, log;
        return regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                _this64.isNewPayment = false;
                aList = _this64.employee.payments;
                log = aList.filter(function (doc) {
                  return doc.id == id;
                });

                _this64.payment.id = id;
                _this64.payment.salaryId = log[0].salaryId;
                _this64.payment.salaryName = log[0].salaryName;
                _this64.payment.status = log[0].status;
                _this64.payment.price = log[0].price;
                _this64.payment.date = log[0].date;

              case 9:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, _this64);
      }))();
    },
    deletePayment: function deletePayment(id) {
      var _this65 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee50() {
        var response;
        return regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                _context50.prev = 0;

                _this65.isLoadingPayment = true;

                if (!(id != 0)) {
                  _context50.next = 10;
                  break;
                }

                _context50.next = 5;
                return _this65.$axios.delete("/EmployeeDetails/deletePayment/" + id);

              case 5:
                response = _context50.sent;

                _this65.getPaymentForEmployee();
                _this65.newPayment();
                alertify.success(_this65.$ml.get("alerts.deletedSuccessfully"));
                _this65.isLoadingPayment = false;

              case 10:
                _context50.next = 16;
                break;

              case 12:
                _context50.prev = 12;
                _context50.t0 = _context50["catch"](0);

                alertify.error("Hata Oluştu : " + _context50.t0);
                _this65.isLoadingPayment = false;

              case 16:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, _this65, [[0, 12]]);
      }))();
    },
    addPayment: function addPayment() {
      var _this66 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee51() {
        var empId, payment2, response;
        return regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                if (!(_this66.payment.date == null)) {
                  _context51.next = 3;
                  break;
                }

                alertify.warning(_this66.$ml.get("alerts.invalidDate"));
                return _context51.abrupt("return");

              case 3:
                if (!($.isNumeric(_this66.payment.price) == false || _this66.payment.price == 0)) {
                  _context51.next = 6;
                  break;
                }

                alertify.warning(_this66.$ml.get("alerts.invalidPrice"));
                return _context51.abrupt("return");

              case 6:
                if (!(_this66.payment.salaryId == 0 || _this66.payment.salaryId == null)) {
                  _context51.next = 9;
                  break;
                }

                alertify.warning(_this66.$ml.get("alerts.invalidSalaryType"));
                return _context51.abrupt("return");

              case 9:
                _context51.prev = 9;

                _this66.isLoadingPayment = true;
                empId = _this66.employee.id;
                payment2 = _this66.payment;
                _context51.next = 15;
                return _this66.$axios.post("/EmployeeDetails/AddSalary", {
                  empId: empId,
                  salaryId: payment2.salaryId,
                  price: payment2.price,
                  date: payment2.date
                });

              case 15:
                response = _context51.sent;

                if (response.status == 200) {
                  $("#modal-odeme-ekle").modal("hide");
                  alertify.success(_this66.$ml.get("alerts.savedSuccessfully"));
                  _this66.isLoadingPayment = false;
                } else {
                  alertify.error(response.message);
                  _this66.isLoadingPayment = false;
                }
                _this66.getPaymentForEmployee();
                _this66.isLoadingPayment = false;
                _context51.next = 26;
                break;

              case 21:
                _context51.prev = 21;
                _context51.t0 = _context51["catch"](9);

                console.error(_context51.t0);
                alertify.error(_context51.t0.message);
                _this66.isLoadingPayment = false;

              case 26:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, _this66, [[9, 21]]);
      }))();
    },
    updatePayment: function updatePayment() {
      var _this67 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee52() {
        var empId, payment2, response;
        return regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                if (!(_this67.payment.date == null)) {
                  _context52.next = 3;
                  break;
                }

                alertify.warning(_this67.$ml.get("alerts.invalidDate"));
                return _context52.abrupt("return");

              case 3:
                if (!(!$.isNumeric(_this67.payment.price) || _this67.payment.price == 0)) {
                  _context52.next = 6;
                  break;
                }

                alertify.warning(_this67.$ml.get("alerts.invalidPrice"));
                return _context52.abrupt("return");

              case 6:
                if (!(_this67.payment.salaryId == 0 || _this67.payment.salaryId == null)) {
                  _context52.next = 9;
                  break;
                }

                alertify.warning(_this67.$ml.get("alerts.invalidSalaryType"));
                return _context52.abrupt("return");

              case 9:
                _context52.prev = 9;

                _this67.isLoadingPayment = true;
                empId = _this67.employee.id;
                payment2 = _this67.payment;
                _context52.next = 15;
                return _this67.$axios.post("/EmployeeDetails/UpdateSalary/", {
                  id: payment2.id,
                  empId: empId,
                  salaryId: payment2.salaryId,
                  price: payment2.price,
                  date: payment2.date
                });

              case 15:
                response = _context52.sent;

                if (response.status == 200) {
                  $("#modal-odeme-ekle").modal("hide");
                  alertify.success(_this67.$ml.get("alerts.updatedSuccessfully"));
                  _this67.isLoadingPayment = false;
                } else {
                  alertify.error(response.message);
                  _this67.isLoadingPayment = false;
                }
                _context52.next = 19;
                return _this67.getPaymentForEmployee();

              case 19:
                _this67.isLoadingPayment = false;
                _context52.next = 27;
                break;

              case 22:
                _context52.prev = 22;
                _context52.t0 = _context52["catch"](9);

                console.error(_context52.t0);
                alertify.error(_context52.t0.message);
                _this67.isLoadingPayment = false;

              case 27:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, _this67, [[9, 22]]);
      }))();
    },
    batchDeleteAllowence: function batchDeleteAllowence() {
      var _this68 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee53() {
        var response;
        return regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                if (!(_this68.startDateRemoveAllowence == null && _this68.endDateRemoveAllowence == null && _this68.startDateRemoveAllowence >= _this68.endDateRemoveAllowence)) {
                  _context53.next = 3;
                  break;
                }

                alertify.warning(_this68.$ml.get("alerts.invalidDate"));
                return _context53.abrupt("return");

              case 3:
                _context53.prev = 3;

                _this68.isLoadingAllowence = true;
                _context53.next = 7;
                return _this68.$axios.post("EmployeeDetails/BatchAllowenceDelete", {
                  empId: _this68.employee.id,
                  startDate: _this68.startDateRemoveAllowence,
                  endDate: _this68.endDateRemoveAllowence
                });

              case 7:
                response = _context53.sent;

                _this68.getAllowenceForEmployee();
                _this68.newAllowence();
                alertify.success(_this68.$ml.get("alerts.deletedSuccessfully"));
                $("#modal-izin-sil").modal("hide");
                _this68.isLoadingAllowence = false;
                _context53.next = 20;
                break;

              case 15:
                _context53.prev = 15;
                _context53.t0 = _context53["catch"](3);

                $("#modal-izin-sil").modal("hide");
                alertify.error("Hata Oluştu : " + _context53.t0);
                _this68.isLoadingAllowence = false;

              case 20:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, _this68, [[3, 15]]);
      }))();
    },
    getAllowenceForEmployee: function getAllowenceForEmployee() {
      var _this69 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee54() {
        var allowences, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                if (!_this69.isNewEmployee) {
                  _context54.next = 3;
                  break;
                }

                alertify.warning(_this69.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context54.abrupt("return");

              case 3:
                if (!(_this69.allowence.searchStartDate == null | _this69.allowence.searchEndDate == null)) {
                  _context54.next = 6;
                  break;
                }

                alertify.warning(_this69.$ml.get("alerts.invalidDate"));
                return _context54.abrupt("return");

              case 6:
                _context54.prev = 6;

                _this69.isLoadingAllowence = true;
                allowences = [];
                selectedUser = _this69.employee.id;
                startDate = _this69.allowence.searchStartDate;
                endDate = _this69.allowence.searchEndDate;
                _context54.next = 14;
                return _this69.$axios.post("/EmployeeDetails/GetAllowences", {
                  id: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      startDate: doc.startDate,
                      endDate: doc.endDate,
                      allowenceId: doc.allowenceId,
                      description: doc.description,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this69.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this69.$ml.get("errors.connectionError"));
                      _this69.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this69.isLoading = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context54.sent;

                _this69.employee.allowences = allowences;
                _this69.isLoadingAllowence = false;
                _context54.next = 24;
                break;

              case 19:
                _context54.prev = 19;
                _context54.t0 = _context54["catch"](6);

                console.error(_context54.t0);
                alertify.error(_context54.t0.message);
                _this69.isLoadingAllowence = false;

              case 24:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, _this69, [[6, 19]]);
      }))();
    },
    newAllowence: function newAllowence() {
      this.isNewAllowence = true;
      this.allowence.id = null;
      if (this.allowenceList[0]) {
        this.allowence.allowenceId = this.allowenceList[0].id;
      }
      this.allowence.description = "";
      this.allowence.allowenceType = 0;
      this.allowence.holidayPass = false;
      this.allowence.allowenceTime = "00:00";
      this.allowence.missingTime = "00:00";
      this.allowence.equalTheMissingTime = true;
    },
    selectAllowence: function selectAllowence(id) {
      var _this70 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee55() {
        var aList, log;
        return regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                _this70.isNewAllowence = false;
                aList = _this70.employee.allowences;
                log = aList.filter(function (doc) {
                  return doc.id == id;
                });

                _this70.allowence.id = id;
                _this70.allowence.allowenceId = log[0].allowenceId;
                _this70.allowence.startDate = log[0].startDate;
                _this70.allowence.endDate = log[0].endDate;
                _this70.allowence.description = log[0].description;

              case 8:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, _this70);
      }))();
    },
    deleteAllowence: function deleteAllowence(id) {
      var _this71 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee56() {
        var response;
        return regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                _context56.prev = 0;

                _this71.isLoadingAllowence = true;

                if (!(id != 0)) {
                  _context56.next = 10;
                  break;
                }

                _context56.next = 5;
                return _this71.$axios.delete("/EmployeeDetails/DeleteAllowence/" + id);

              case 5:
                response = _context56.sent;

                _this71.getAllowenceForEmployee();
                _this71.newAllowence();
                alertify.success(_this71.$ml.get("alerts.deletedSuccessfully"));
                _this71.isLoadingAllowence = false;

              case 10:
                _context56.next = 16;
                break;

              case 12:
                _context56.prev = 12;
                _context56.t0 = _context56["catch"](0);

                alertify.error("Hata Oluştu : " + _context56.t0);
                _this71.isLoadingAllowence = false;

              case 16:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, _this71, [[0, 12]]);
      }))();
    },
    addAllowence: function addAllowence() {
      var _this72 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee57() {
        var days, empIds, allowence2, response;
        return regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                if (!(_this72.allowence.startDate == "" | _this72.allowence.endDate)) {
                  _context57.next = 3;
                  break;
                }

                alertify.warning(_this72.$ml.get("alerts.invalidDate"));
                return _context57.abrupt("return");

              case 3:
                if (_this72.allowence.allowenceId) {
                  _context57.next = 6;
                  break;
                }

                alertify.warning(_this72.$ml.get("alerts.pleaseSelect"));
                return _context57.abrupt("return");

              case 6:
                _context57.prev = 6;

                _this72.isLoadingAllowence = true;
                _context57.next = 10;
                return _this72.selectedDays();

              case 10:
                days = _context57.sent;
                empIds = [_this72.employee.id];
                allowence2 = _this72.allowence;
                _context57.next = 15;
                return _this72.$axios.post("/BatchOperations/BatchAllowence", {
                  empIds: empIds,
                  days: days,
                  allowenceId: allowence2.allowenceId,
                  description: allowence2.description,
                  holidayPass: allowence2.holidayPass,
                  startDate: allowence2.startDate,
                  endDate: allowence2.endDate,
                  allowenceType: allowence2.allowenceType,
                  allowenceTime: allowence2.allowenceTime,
                  equalTheMissingTime: allowence2.equalTheMissingTime,
                  missingTime: allowence2.missingTime
                });

              case 15:
                response = _context57.sent;

                if (response.status == 200) {
                  alertify.success(_this72.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this72.getAllowenceForEmployee();
                _this72.isLoadingAllowence = false;
                _context57.next = 26;
                break;

              case 21:
                _context57.prev = 21;
                _context57.t0 = _context57["catch"](6);

                console.error(_context57.t0);
                alertify.error(_context57.t0.message);
                _this72.isLoadingAllowence = false;

              case 26:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, _this72, [[6, 21]]);
      }))();
    },
    updateAllowence: function updateAllowence() {
      var _this73 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee58() {
        var empId, allowence2, response;
        return regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                if (!(_this73.allowence.startDate == "" | _this73.allowence.endDate == "")) {
                  _context58.next = 3;
                  break;
                }

                alertify.warning(_this73.$ml.get("alerts.invalidDate"));
                return _context58.abrupt("return");

              case 3:
                if (_this73.allowence.allowenceId) {
                  _context58.next = 6;
                  break;
                }

                alertify.warning(_this73.$ml.get("alerts.pleaseSelect"));
                return _context58.abrupt("return");

              case 6:
                _context58.prev = 6;

                _this73.isLoadingAllowence = true;
                empId = _this73.employee.id;
                allowence2 = _this73.allowence;
                _context58.next = 12;
                return _this73.$axios.post("/EmployeeDetails/UpdateAllowence/" + allowence2.id, {
                  isActive: true,
                  startDate: allowence2.startDate,
                  endDate: allowence2.endDate,
                  allowenceId: allowence2.allowenceId,
                  description: allowence2.description,
                  empId: empId
                });

              case 12:
                response = _context58.sent;

                if (response.status == 200) {
                  alertify.success(_this73.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _context58.next = 16;
                return _this73.getAllowenceForEmployee();

              case 16:
                _this73.isLoadingAllowence = false;
                _context58.next = 24;
                break;

              case 19:
                _context58.prev = 19;
                _context58.t0 = _context58["catch"](6);

                console.error(_context58.t0);
                alertify.error(_context58.t0.message);
                _this73.isLoadingAllowence = false;

              case 24:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, _this73, [[6, 19]]);
      }))();
    },
    getInOuts: function getInOuts() {
      var _this74 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee59() {
        var inOuts, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                if (!_this74.isNewEmployee) {
                  _context59.next = 3;
                  break;
                }

                alertify.warning(_this74.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context59.abrupt("return");

              case 3:
                if (!(_this74.inOut.inOutStartDate == null || _this74.inOut.inOutEndDate == null || _this74.inOut.inOutStartDate > _this74.inOut.inOutEndDate)) {
                  _context59.next = 6;
                  break;
                }

                alertify.warning(_this74.$ml.get("alerts.invalidDate"));
                return _context59.abrupt("return");

              case 6:
                _context59.prev = 6;

                _this74.isLoadingInOuts = true;
                inOuts = [];
                selectedUser = _this74.employee.id;
                startDate = _this74.inOut.inOutStartDate;
                endDate = _this74.inOut.inOutEndDate;
                _context59.next = 14;
                return _this74.$axios.post("/EmployeeDetails/GetEntryExit", {
                  id: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    inOuts.push({
                      id: doc.id,
                      date: doc.date,
                      readerName: doc.readerName,
                      readerId: doc.readerId,
                      doorType: doc.doorType,
                      inOrOut: doc.inOrOut,
                      positionX: doc.positionX,
                      positionY: doc.positionY,
                      isActive: doc.isActive
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this74.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this74.$ml.get("errors.connectionError"));
                    _this74.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this74.isLoadingInOuts = false;
                    return;
                  }
                });

              case 14:
                response = _context59.sent;

                _this74.employee.inOuts = inOuts;
                _this74.isLoadingInOuts = false;
                _context59.next = 24;
                break;

              case 19:
                _context59.prev = 19;
                _context59.t0 = _context59["catch"](6);

                console.error(_context59.t0);
                alertify.error(_context59.t0.message);
                _this74.isLoadingInOuts = false;

              case 24:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, _this74, [[6, 19]]);
      }))();
    },
    newInOut: function newInOut() {
      this.isNewInOut = true;
      this.inOut.inOutId = null;
      this.inOut.readerId = "";
      this.inOut.inOutType = 0;
      this.inOut.positionX = "";
      this.inOut.positionY = "";
      this.selectedDoorTypeMovement = 0;
      this.inOut.inOutAdd = "";
    },
    selectInOut: function selectInOut(id) {
      var _this75 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee60() {
        var aList, log;
        return regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _this75.isNewInOut = false;
                aList = _this75.employee.inOuts;
                log = aList.filter(function (doc) {
                  return doc.id == id;
                });

                _this75.inOut.inOutId = id;
                _this75.inOut.inOutType = log[0].inOrOut;
                _this75.selectedDoorTypeMovement = log[0].inOrOut;
                _this75.inOut.inOutAdd = log[0].date;
                _this75.inOut.positionX = log[0].positionX.replace(",", ".");
                _this75.inOut.positionY = log[0].positionY.replace(",", ".");
                _this75.inOut.readerId = log[0].readerId;

              case 10:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, _this75);
      }))();
    },
    deleteInOut: function deleteInOut(id) {
      var _this76 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee61() {
        var response;
        return regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;

                if (!(id != 0)) {
                  _context61.next = 5;
                  break;
                }

                _context61.next = 4;
                return _this76.$axios.delete("/EmployeeDetails/DeleteEntryExit/" + id).then(function (response) {
                  _this76.getInOuts();
                  _this76.newInOut();
                  alertify.success(_this76.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this76.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this76.$ml.get("errors.connectionError"));
                    _this76.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this76.isLoadingInOuts = false;
                    return;
                  }
                });

              case 4:
                response = _context61.sent;

              case 5:
                _context61.next = 10;
                break;

              case 7:
                _context61.prev = 7;
                _context61.t0 = _context61["catch"](0);

                alertify.error("Hata Oluştu : " + _context61.t0);

              case 10:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, _this76, [[0, 7]]);
      }))();
    },
    addInOut: function addInOut() {
      var _this77 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee62() {
        var date, today, empId, inOurOut, inOutAdd, readerId, response;
        return regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                if (!(_this77.inOut.inOutAdd == "")) {
                  _context62.next = 3;
                  break;
                }

                alertify.warning(_this77.$ml.get("alerts.invalidDate"));
                return _context62.abrupt("return");

              case 3:
                if (!(_this77.inOut.readerId == "" || _this77.inOut.readerId == 0)) {
                  _context62.next = 6;
                  break;
                }

                alertify.warning(_this77.$ml.get("alerts.notSelectedReader"));
                return _context62.abrupt("return");

              case 6:
                date = new Date(_this77.inOut.inOutAdd);
                today = new Date();

                if (!(date > today)) {
                  _context62.next = 11;
                  break;
                }

                alertify.warning(_this77.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context62.abrupt("return");

              case 11:
                _context62.prev = 11;
                empId = _this77.employee.id;
                inOurOut = _this77.inOut.inOutType;
                inOutAdd = _this77.inOut.inOutAdd;
                readerId = _this77.inOut.readerId;
                _context62.next = 18;
                return _this77.$axios.post("/EmployeeDetails/AddEntryExit", {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  readerId: readerId,
                  includePassiveMovements: _this77.includePassiveMovements,
                  doNotDeleteOvertimes: _this77.doNotDeleteOvertimes,
                  empId: empId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this77.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this77.$ml.get("errors.connectionError"));
                    _this77.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this77.isLoadingInOuts = false;
                    return;
                  }
                });

              case 18:
                response = _context62.sent;

                if (response.status == 200) {
                  alertify.success(_this77.$ml.get("alerts.savedSuccessfully"));
                } else if (response.status == 201) {
                  alertify.error(_this77.$ml.get("alerts.checkTheMealTime"));
                } else {
                  alertify.error(response.message);
                }
                _this77.getInOuts();
                _context62.next = 27;
                break;

              case 23:
                _context62.prev = 23;
                _context62.t0 = _context62["catch"](11);

                console.error(_context62.t0);
                alertify.error(_context62.t0.message);

              case 27:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, _this77, [[11, 23]]);
      }))();
    },
    updateInOut: function updateInOut() {
      var _this78 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee63() {
        var date, today, empId, inOurOut, inOutAdd, readerId, response;
        return regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                if (!(_this78.inOut.inOutAdd == "")) {
                  _context63.next = 3;
                  break;
                }

                alertify.warning(_this78.$ml.get("alerts.invalidDate"));
                return _context63.abrupt("return");

              case 3:
                if (!(_this78.inOut.readerId == "" || _this78.inOut.readerId == 0)) {
                  _context63.next = 6;
                  break;
                }

                alertify.warning(_this78.$ml.get("alerts.notSelectedReader"));
                return _context63.abrupt("return");

              case 6:
                date = new Date(_this78.inOut.inOutAdd);
                today = new Date();

                if (!(date > today)) {
                  _context63.next = 11;
                  break;
                }

                alertify.warning(_this78.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context63.abrupt("return");

              case 11:
                _context63.prev = 11;
                empId = _this78.employee.id;
                inOurOut = _this78.inOut.inOutType;
                inOutAdd = _this78.inOut.inOutAdd;
                readerId = _this78.inOut.readerId;
                _context63.next = 18;
                return _this78.$axios.post("/EmployeeDetails/UpdateEntryExit/" + _this78.inOut.inOutId, {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  empId: empId,
                  includePassiveMovements: _this78.includePassiveMovements,
                  doNotDeleteOvertimes: _this78.doNotDeleteOvertimes,
                  readerId: readerId
                });

              case 18:
                response = _context63.sent;

                if (response.status == 200) {
                  alertify.success(_this78.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this78.getInOuts();
                _context63.next = 27;
                break;

              case 23:
                _context63.prev = 23;
                _context63.t0 = _context63["catch"](11);

                console.error(_context63.t0);
                alertify.error(_context63.t0.message);

              case 27:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, _this78, [[11, 23]]);
      }))();
    },
    addInOut2: function addInOut2() {
      var _this79 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee64() {
        var date, today, empId, inOurOut, inOutAdd, readerId, response;
        return regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                if (!(_this79.inOut2.inOutAdd == "")) {
                  _context64.next = 3;
                  break;
                }

                alertify.warning(_this79.$ml.get("alerts.invalidDate"));
                return _context64.abrupt("return");

              case 3:
                if (!(_this79.inOut2.readerId == "" || _this79.inOut2.readerId == 0)) {
                  _context64.next = 6;
                  break;
                }

                alertify.warning(_this79.$ml.get("alerts.notSelectedReader"));
                return _context64.abrupt("return");

              case 6:
                date = new Date(_this79.inOut2.inOutAdd);
                today = new Date();

                if (!(date > today)) {
                  _context64.next = 11;
                  break;
                }

                alertify.warning(_this79.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context64.abrupt("return");

              case 11:
                _context64.prev = 11;
                empId = _this79.employee.id;
                inOurOut = _this79.inOut2.inOutType;
                inOutAdd = _this79.inOut2.inOutAdd;
                readerId = _this79.inOut2.readerId;
                _context64.next = 18;
                return _this79.$axios.post("/EmployeeDetails/AddEntryExit", {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  readerId: readerId,
                  includePassiveMovements: _this79.includePassiveMovements,
                  doNotDeleteOvertimes: _this79.doNotDeleteOvertimes,
                  empId: empId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this79.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this79.$ml.get("errors.connectionError"));
                    _this79.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this79.isLoadingInOuts = false;
                    return;
                  }
                });

              case 18:
                response = _context64.sent;

                if (response.status == 200) {
                  alertify.success(_this79.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this79.getDailyPayrollDetails(_this79.selectedDailyPayrol.date, _this79.selectedDailyPayrol.workGroup);
                _this79.getEmpPayrolls();
                _context64.next = 28;
                break;

              case 24:
                _context64.prev = 24;
                _context64.t0 = _context64["catch"](11);

                console.error(_context64.t0);
                alertify.error(_context64.t0.message);

              case 28:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, _this79, [[11, 24]]);
      }))();
    },
    updateInOut2: function updateInOut2() {
      var _this80 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee65() {
        var date, today, empId, inOurOut, inOutAdd, readerId, response;
        return regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                if (!(_this80.inOut2.inOutAdd == "")) {
                  _context65.next = 3;
                  break;
                }

                alertify.warning(_this80.$ml.get("alerts.invalidDate"));
                return _context65.abrupt("return");

              case 3:
                if (!(_this80.inOut2.readerId == "" || _this80.inOut2.readerId == 0)) {
                  _context65.next = 6;
                  break;
                }

                alertify.warning(_this80.$ml.get("alerts.notSelectedReader"));
                return _context65.abrupt("return");

              case 6:
                date = new Date(_this80.inOut2.inOutAdd);
                today = new Date();

                if (!(date > today)) {
                  _context65.next = 11;
                  break;
                }

                alertify.warning(_this80.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context65.abrupt("return");

              case 11:
                _context65.prev = 11;
                empId = _this80.employee.id;
                inOurOut = _this80.inOut2.inOutType;
                inOutAdd = _this80.inOut2.inOutAdd;
                readerId = _this80.inOut2.readerId;
                _context65.next = 18;
                return _this80.$axios.post("/EmployeeDetails/UpdateEntryExit/" + _this80.inOut2.inOutId, {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  empId: empId,
                  readerId: readerId
                });

              case 18:
                response = _context65.sent;

                if (response.status == 200) {
                  alertify.success(_this80.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this80.getDailyPayrollDetails(_this80.selectedDailyPayrol.date, _this80.selectedDailyPayrol.workGroup);
                _this80.getEmpPayrolls();
                _context65.next = 28;
                break;

              case 24:
                _context65.prev = 24;
                _context65.t0 = _context65["catch"](11);

                console.error(_context65.t0);
                alertify.error(_context65.t0.message);

              case 28:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, _this80, [[11, 24]]);
      }))();
    },
    deleteInOut2: function deleteInOut2(id) {
      var _this81 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee66() {
        var response;
        return regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.prev = 0;

                if (!(id != 0)) {
                  _context66.next = 7;
                  break;
                }

                _context66.next = 4;
                return _this81.$axios.delete("/EmployeeDetails/DeleteEntryExit/" + id).then(function (response) {
                  _this81.getInOuts();
                  _this81.newInOut();
                  alertify.success(_this81.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this81.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this81.$ml.get("errors.connectionError"));
                    _this81.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this81.isLoadingInOuts = false;
                    return;
                  }
                });

              case 4:
                response = _context66.sent;

                _this81.getDailyPayrollDetails(_this81.selectedDailyPayrol.date, _this81.selectedDailyPayrol.workGroup);
                _this81.getEmpPayrolls();

              case 7:
                _context66.next = 12;
                break;

              case 9:
                _context66.prev = 9;
                _context66.t0 = _context66["catch"](0);

                alertify.error("Hata Oluştu : " + _context66.t0);

              case 12:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, _this81, [[0, 9]]);
      }))();
    },
    newEmployee: function newEmployee() {
      var _this82 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee67() {
        var toDay, gun, ay, yil, aa;
        return regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _this82.isLoading = true;
                _this82.isNewEmployee = true;
                toDay = new Date();
                gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
                ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
                yil = toDay.getFullYear();

                _this82.employee.startDate = yil + "-" + ay + "-" + gun;
                _this82.employee.endDate = null;
                _this82.imageData = null;
                _this82.tempUrl = null;
                _this82.selectedFoodType = 1;
                _this82.selectedFoodCount = 0;
                _this82.isNewState = true;
                _this82.selectedStateId = null;
                _this82.selectedStateName = "";
                _this82.isNewStatu = true;
                _this82.selectedStatuId = null;
                _this82.selectedStatuName = "";
                _this82.searchPayrollStartDate = null;
                _this82.searchPayrollEndDate = null;
                _this82.selectAP = 1;
                _this82.employee.id = null;
                _this82.employee.sicilNo = "";
                _this82.employee.image = null;
                _this82.employee.name = "";
                _this82.employee.departmentId = null;
                _this82.employee.title = "";
                _this82.employee.identityNo = "";
                _this82.employee.stateId = 1;
                _this82.employee.stateNote = "";
                _this82.employee.terminalNo = null;
                _this82.employee.statuId = null;
                _this82.employee.cardNo = "";
                _this82.employee.terminalStatu = 0;
                _this82.employee.terminalPassword = "";
                _this82.employee.plateNo = "";
                _this82.employee.hgsNo = "";
                _this82.employee.tzCode = "";
                _this82.employee.workGroupId = null;
                _this82.employee.documentNo = "";
                _this82.employee.overWorkStatus = true;
                _this82.employee.mail = "";
                _this82.employee.mobilePhone = "";
                _this82.employee.birthDayDate = null;
                _this82.employee.validityStartDate = null;
                _this82.employee.validityEndDate = null;
                _this82.employee.address = "";
                _this82.employee.internalPhone = "";
                _this82.employee.homePhone = "";
                _this82.employee.gender = null;
                _this82.employee.educationStatus = null;
                _this82.employee.militaryStatus = null;
                _this82.employee.drivingLicence = "";
                _this82.employee.smokeStatus = null;
                _this82.employee.maritalStatus = null;
                _this82.employee.bloodType = "";
                _this82.employee.height = null;
                _this82.employee.weight = null;
                _this82.employee.disabledPercent = "";
                _this82.employee.authorizedPerson1 = null;
                _this82.employee.authorizedPerson2 = null;
                _this82.employee.note1 = "";
                _this82.employee.note2 = "";
                _this82.employee.foreignLanguage = "";
                _this82.employee.accessGroupId = null;
                _this82.employee.readers = [];
                _this82.employee.foodGroupId = null;
                _this82.employee.credit = 0;
                _this82.employee.remainder = "0";
                _this82.employee.isVisitor = false;
                _this82.employee.visitorCardGroupId = null;
                _this82.employee.isActive = true;
                _this82.employee.annualPermitId = 0;
                _this82.employee.annualPermitSeniority = 0;
                _this82.employee.annualPermitTransfer = 0;
                _this82.employee.annualPermitClaim = 0;
                _this82.employee.annualPermitUsed = 0;
                _this82.employee.annualPermitRemain = 0;
                _this82.employee.annualPermits = [];
                _this82.employee.annualPermitClaimsDates = [];
                _this82.employee.extrafields = [];
                _this82.employee.inOuts = [];
                _this82.employee.allowences = [];
                _this82.employee.logs = [];
                _this82.employee.hasCard = false;
                _this82.employee.hasFace = false;
                _this82.employee.hasFinger = false;
                _this82.employee.hasPassword = false;
                _this82.employee.roomId = 0;
                _this82.employee.roomName = "";
                _this82.employee.areaName = "";
                _this82.employee.floorName = "";
                _this82.employee.fingerIndexes = [];
                _this82.employee.isSmsSend = false;
                _this82.employee.parentPhone = null;
                _this82.employee.isStudent = false;
                _this82.employee.isStayInDormitory = false;
                _this82.employee.motherName = "";
                _this82.employee.motherPhone = "";
                _this82.employee.fatherName = "";
                _this82.employee.fatherPhone = "";
                _this82.employee.isMobileUser = false;
                _this82.employee.mobilePassword = "";
                _this82.employee.foodClaim = false;
                _context67.next = 106;
                return _this82.getNewSicilveTerminalNo();

              case 106:
                aa = _this82.readers;
                _context67.next = 109;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 109:
                _this82.isLoading = false;

              case 110:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, _this82);
      }))();
    },
    deleteEmployee: function deleteEmployee() {
      var _this83 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee68() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.prev = 0;

                _this83.isLoading = true;
                id = _this83.employee.id;
                _context68.next = 5;
                return _this83.$axios.delete("/Employees/" + id);

              case 5:
                response = _context68.sent;

                _this83.getEmployees();
                _this83.newEmployee();
                alertify.success(response.data.message);
                _this83.isLoading = false;
                _context68.next = 16;
                break;

              case 12:
                _context68.prev = 12;
                _context68.t0 = _context68["catch"](0);

                alertify.error(_context68.t0);
                _this83.isLoading = false;

              case 16:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, _this83, [[0, 12]]);
      }))();
    },
    saveEmployee: function saveEmployee() {
      var _this84 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee69() {
        var employee2, id, image, response, _employee, _id, _image, _response6;

        return regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                if (!(_this84.employee.sicilNo == "")) {
                  _context69.next = 3;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeRegistrationNumberNotBlank"));
                return _context69.abrupt("return");

              case 3:
                if (!(_this84.employee.name == "")) {
                  _context69.next = 6;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeNameNotBlank"));
                return _context69.abrupt("return");

              case 6:
                if (!(_this84.employee.terminalNo == "")) {
                  _context69.next = 9;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeDeviceNoNotBlank"));
                return _context69.abrupt("return");

              case 9:
                if (!(_this84.employee.departmentId == "" || _this84.employee.departmentId == null)) {
                  _context69.next = 12;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeDepartmentNotBlank"));
                return _context69.abrupt("return");

              case 12:
                if (!(_this84.employee.startDate == "" || _this84.employee.startDate == null)) {
                  _context69.next = 15;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeStartDateNotBlank"));
                return _context69.abrupt("return");

              case 15:
                if (!(_this84.requiredFields.includes("title") && (_this84.employee.title == "" || _this84.employee.title == null))) {
                  _context69.next = 18;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeTitleNotBlank"));
                return _context69.abrupt("return");

              case 18:
                if (!(_this84.requiredFields.includes("identityNo") && (_this84.employee.identityNo == "" || _this84.employee.identityNo == null))) {
                  _context69.next = 21;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeIdentityNoNotBlank"));
                return _context69.abrupt("return");

              case 21:
                if (!(_this84.requiredFields.includes("endDate") && (_this84.employee.endDate == "" || _this84.employee.endDate == null))) {
                  _context69.next = 24;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeEndDateNotBlank"));
                return _context69.abrupt("return");

              case 24:
                if (!(_this84.requiredFields.includes("workGroupId") && (_this84.employee.workGroupId == "" || _this84.employee.workGroupId == null))) {
                  _context69.next = 27;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeWorkGroupIdNotBlank"));
                return _context69.abrupt("return");

              case 27:
                if (!(_this84.requiredFields.includes("stateId") && (_this84.employee.stateId == "" || _this84.employee.stateId == null))) {
                  _context69.next = 30;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeStateIdNotBlank"));
                return _context69.abrupt("return");

              case 30:
                if (!(_this84.requiredFields.includes("stateNote") && (_this84.employee.stateNote == "" || _this84.employee.stateNote == null))) {
                  _context69.next = 33;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeStateNoteNotBlank"));
                return _context69.abrupt("return");

              case 33:
                if (!(_this84.requiredFields.includes("statuId") && (_this84.employee.statuId == "" || _this84.employee.statuId == null))) {
                  _context69.next = 36;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeStatuIdNotBlank"));
                return _context69.abrupt("return");

              case 36:
                if (!(_this84.requiredFields.includes("cardNo") && (_this84.employee.cardNo == "" || _this84.employee.cardNo == null))) {
                  _context69.next = 39;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeCardNoNotBlank"));
                return _context69.abrupt("return");

              case 39:
                if (!(_this84.requiredFields.includes("terminalStatu") && (_this84.employee.terminalStatu == "" || _this84.employee.terminalStatu == null))) {
                  _context69.next = 42;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeTerminalStatuNotBlank"));
                return _context69.abrupt("return");

              case 42:
                if (!(_this84.requiredFields.includes("terminalPassword") && (_this84.employee.terminalPassword == "" || _this84.employee.terminalPassword == null))) {
                  _context69.next = 45;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeTerminalPasswordNotBlank"));
                return _context69.abrupt("return");

              case 45:
                if (!(_this84.requiredFields.includes("tzCode") && (_this84.employee.tzCode == "" || _this84.employee.tzCode == null))) {
                  _context69.next = 48;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeTzCodeNotBlank"));
                return _context69.abrupt("return");

              case 48:
                if (!(_this84.requiredFields.includes("plateNo") && (_this84.employee.plateNo == "" || _this84.employee.plateNo == null))) {
                  _context69.next = 51;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeePlateNoNotBlank"));
                return _context69.abrupt("return");

              case 51:
                if (!(_this84.requiredFields.includes("hgsNo") && (_this84.employee.hgsNo == "" || _this84.employee.hgsNo == null))) {
                  _context69.next = 54;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeHgsNoNotBlank"));
                return _context69.abrupt("return");

              case 54:
                if (!(_this84.requiredFields.includes("documentNo") && (_this84.employee.documentNo == "" || _this84.employee.documentNo == null))) {
                  _context69.next = 57;
                  break;
                }

                alertify.warning(_this84.$ml.get("alerts.employeeDocumentNoNotBlank"));
                return _context69.abrupt("return");

              case 57:
                _this84.isLoading = true;
                _context69.next = 60;
                return _this84.getCheckReaderList();

              case 60:
                if (!_this84.isNewEmployee) {
                  _context69.next = 77;
                  break;
                }

                _context69.prev = 61;
                employee2 = _this84.employee;
                id = 0;
                image = _this84.imageData;
                _context69.next = 67;
                return _this84.$axios.post("/Employees", {
                  sicilNo: employee2.sicilNo,
                  name: employee2.name,
                  departmentId: employee2.departmentId,
                  title: employee2.title,
                  identityNo: employee2.identityNo,
                  startDate: employee2.startDate,
                  endDate: employee2.endDate,
                  stateId: employee2.stateId,
                  stateNote: employee2.stateNote,
                  terminalNo: employee2.terminalNo,
                  statuId: employee2.statuId,
                  cardNo: employee2.cardNo,
                  terminalStatu: employee2.terminalStatu,
                  terminalPassword: employee2.terminalPassword,
                  plateNo: employee2.plateNo,
                  hgsNo: employee2.hgsNo,
                  tzCode: employee2.tzCode,
                  workGroupId: employee2.workGroupId,
                  documentNo: employee2.documentNo,
                  overWorkStatus: employee2.overWorkStatus,
                  mail: employee2.mail,
                  address: employee2.address,
                  mobilePhone: employee2.mobilePhone,
                  birthDayDate: employee2.birthDayDate,
                  internalPhone: employee2.internalPhone,
                  homePhone: employee2.homePhone,
                  gender: employee2.gender,
                  educationStatus: employee2.educationStatus,
                  militaryStatus: employee2.militaryStatus,
                  drivingLicence: employee2.drivingLicence,
                  smokeStatus: employee2.smokeStatus,
                  maritalStatus: employee2.maritalStatus,
                  bloodType: employee2.bloodType,
                  height: employee2.height,
                  weight: employee2.weight,
                  disabledPercent: employee2.disabledPercent,
                  authorizedPerson1: employee2.authorizedPerson1,
                  authorizedPerson2: employee2.authorizedPerson2,
                  note1: employee2.note1,
                  note2: employee2.note2,
                  foreignLanguage: employee2.foreignLanguage,
                  accessGroupId: parseInt(employee2.accessGroupId),
                  readers: employee2.readers,
                  foodGroupId: employee2.foodGroupId,
                  credit: employee2.credit,
                  remainder: employee2.remainder,
                  isVisitor: employee2.isVisitor,
                  visitorCardGroupId: employee2.visitorCardGroupId,
                  annualPermitId: employee2.annualPermitId,
                  annualPermitSeniority: employee2.annualPermitSeniority,
                  annualPermitTransfer: employee2.annualPermitTransfer,
                  validityStartDate: employee2.validityStartDate,
                  validityEndDate: employee2.validityEndDate,
                  parentPhone: employee2.parentPhone,
                  isSmsSend: employee2.isSmsSend,
                  isStudent: employee2.isStudent,
                  isStayInDormitory: employee2.isStayInDormitory,
                  motherName: employee2.motherName,
                  motherPhone: employee2.motherPhone,
                  fatherName: employee2.fatherName,
                  fatherPhone: employee2.fatherPhone,
                  isMobileUser: employee2.isMobileUser,
                  mobilePassword: employee2.mobilePassword,
                  foodClaim: employee2.foodClaim
                }).then(function (result) {
                  if (result.data.id) {
                    id = result.data.id;
                    if (_this84.imageData) {
                      var formData = new FormData();
                      formData.append("file", image);
                      var responseImage = _this84.$axios.post("/Employees/AddEmployeePhoto/" + id, formData).then(function (result2) {
                        alertify.success(_this84.$ml.get("alerts.savedSuccessfully"));
                        _this84.getEmployees();
                        _this84.getEmployee(id);
                        _this84.isNewEmployee = false;
                        _this84.isLoading = false;
                      });
                    } else {
                      alertify.success(_this84.$ml.get("alerts.savedSuccessfully"));
                      _this84.getEmployees();
                      _this84.getEmployee(id);
                      _this84.isNewEmployee = false;
                      _this84.isLoading = false;
                    }
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this84.$store.dispatch("logout");
                      return;
                    } else if (error.response.status == 400) {
                      console.log(error.response.data.message);
                      alertify.error(error.response.data.message);
                      return;
                    }
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this84.$ml.get("errors.connectionError"));
                      _this84.isLoadingInOuts = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this84.isLoadingInOuts = false;
                      return;
                    }
                  }
                });

              case 67:
                response = _context69.sent;
                _context69.next = 75;
                break;

              case 70:
                _context69.prev = 70;
                _context69.t0 = _context69["catch"](61);

                _this84.isLoading = false;
                console.error(_context69.t0);
                alertify.error(_context69.t0);

              case 75:
                _context69.next = 90;
                break;

              case 77:
                _context69.prev = 77;
                _employee = _this84.employee;
                _id = _employee.id;
                _image = _this84.imageData;
                _context69.next = 83;
                return _this84.$axios.post("/Employees/" + _employee.id, {
                  sicilNo: _employee.sicilNo,
                  name: _employee.name,
                  departmentId: _employee.departmentId,
                  title: _employee.title,
                  identityNo: _employee.identityNo,
                  startDate: _employee.startDate,
                  endDate: _employee.endDate,
                  stateId: _employee.stateId,
                  stateNote: _employee.stateNote,
                  terminalNo: _employee.terminalNo,
                  statuId: _employee.statuId,
                  cardNo: _employee.cardNo,
                  terminalStatu: _employee.terminalStatu,
                  terminalPassword: _employee.terminalPassword,
                  plateNo: _employee.plateNo,
                  hgsNo: _employee.hgsNo,
                  tzCode: _employee.tzCode,
                  workGroupId: _employee.workGroupId,
                  documentNo: _employee.documentNo,
                  overWorkStatus: _employee.overWorkStatus,
                  mail: _employee.mail,
                  address: _employee.address,
                  mobilePhone: _employee.mobilePhone,
                  birthDayDate: _employee.birthDayDate,
                  internalPhone: _employee.internalPhone,
                  homePhone: _employee.homePhone,
                  gender: _employee.gender,
                  educationStatus: _employee.educationStatus,
                  militaryStatus: _employee.militaryStatus,
                  drivingLicence: _employee.drivingLicence,
                  smokeStatus: _employee.smokeStatus,
                  maritalStatus: _employee.maritalStatus,
                  bloodType: _employee.bloodType,
                  height: _employee.height,
                  weight: _employee.weight,
                  disabledPercent: _employee.disabledPercent,
                  authorizedPerson1: _employee.authorizedPerson1,
                  authorizedPerson2: _employee.authorizedPerson2,
                  note1: _employee.note1,
                  note2: _employee.note2,
                  foreignLanguage: _employee.foreignLanguage,
                  accessGroupId: parseInt(_employee.accessGroupId),
                  readers: _employee.readers,
                  foodGroupId: _employee.foodGroupId,
                  credit: _employee.credit,
                  remainder: _employee.remainder,
                  isVisitor: _employee.isVisitor,
                  visitorCardGroupId: _employee.visitorCardGroupId,
                  annualPermitId: _employee.annualPermitId,
                  annualPermitSeniority: _employee.annualPermitSeniority,
                  annualPermitTransfer: _employee.annualPermitTransfer,
                  validityStartDate: _employee.validityStartDate,
                  validityEndDate: _employee.validityEndDate,
                  parentPhone: _employee.parentPhone,
                  isSmsSend: _employee.isSmsSend,
                  isStudent: _employee.isStudent,
                  isStayInDormitory: _employee.isStayInDormitory,
                  motherName: _employee.motherName,
                  motherPhone: _employee.motherPhone,
                  fatherName: _employee.fatherName,
                  fatherPhone: _employee.fatherPhone,
                  isMobileUser: _employee.isMobileUser,
                  mobilePassword: _employee.mobilePassword,
                  foodClaim: _employee.foodClaim
                }).then(function (result) {
                  if (result.data.id) {
                    if (_this84.imageData) {
                      var formData = new FormData();
                      formData.append("file", _image);
                      var responseImage = _this84.$axios.post("/Employees/AddEmployeePhoto/" + _id, formData).then(function (result) {
                        alertify.success(_this84.$ml.get("alerts.updatedSuccessfully"));
                        _this84.getEmployees();
                        _this84.getEmployee(_id);
                        _this84.isLoading = false;
                      });
                    } else if (_this84.employee.image == null) {
                      var _responseImage = _this84.$axios.patch("/Employees/RemovePhoto/" + _id).then(function (result) {
                        alertify.success(_this84.$ml.get("alerts.updatedSuccessfully"));
                        _this84.getEmployees();
                        _this84.getEmployee(_id);
                        _this84.isLoading = false;
                      });
                    } else {
                      alertify.success(_this84.$ml.get("alerts.updatedSuccessfully"));
                      _this84.getEmployees();
                      _this84.getEmployee(_id);
                      _this84.isLoading = false;
                    }
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this84.$store.dispatch("logout");
                      return;
                    } else if (error.response.status == 400) {
                      console.log(error.response.data.message);
                      alertify.error(error.response.data.message);
                      return;
                    }
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this84.$ml.get("errors.connectionError"));
                      _this84.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this84.isLoading = false;
                      return;
                    }
                  }
                });

              case 83:
                _response6 = _context69.sent;
                _context69.next = 90;
                break;

              case 86:
                _context69.prev = 86;
                _context69.t1 = _context69["catch"](77);

                console.error(_context69.t1);
                alertify.error(_context69.t1);

              case 90:
                _this84.isLoading = false;

              case 91:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, _this84, [[61, 70], [77, 86]]);
      }))();
    },
    getNewSicilveTerminalNo: function getNewSicilveTerminalNo() {
      var _this85 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee70() {
        var response;
        return regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                _context70.next = 2;
                return _this85.$axios.get("/Employees/GetDeviceAndSicilNumbers").then(function (response) {
                  _this85.employee.sicilNo = response.data.sicilNo;
                  _this85.employee.terminalNo = response.data.terminalNo;
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this85.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this85.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 2:
                response = _context70.sent;

              case 3:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70, _this85);
      }))();
    },
    setLeaveEmployee: function setLeaveEmployee() {
      var _this86 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee71() {
        var employeeId, tarih, response;
        return regeneratorRuntime.wrap(function _callee71$(_context71) {
          while (1) {
            switch (_context71.prev = _context71.next) {
              case 0:
                _context71.prev = 0;
                employeeId = _this86.employee.id;
                tarih = new Date();

                if (_this86.employee.endDate == "") {
                  tarih = null;
                } else {
                  tarih = new Date(_this86.employee.endDate);
                }
                _context71.next = 6;
                return _this86.$axios.post("/Employees/SetLeaveDate", {
                  id: employeeId,
                  date: tarih,
                  state: _this86.employee.stateId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this86.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this86.getEmployees();
                  _this86.getEmployee(employeeId);
                  _this86.isNewEmployee = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this86.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this86.$ml.get("errors.connectionError"));
                      _this86.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this86.isLoading = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context71.sent;
                _context71.next = 13;
                break;

              case 9:
                _context71.prev = 9;
                _context71.t0 = _context71["catch"](0);

                console.error(_context71.t0);
                alertify.error(_context71.t0);

              case 13:
              case "end":
                return _context71.stop();
            }
          }
        }, _callee71, _this86, [[0, 9]]);
      }))();
    },
    removeLeaveEmployee: function removeLeaveEmployee() {
      var _this87 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee72() {
        var employeeId, tarih, response;
        return regeneratorRuntime.wrap(function _callee72$(_context72) {
          while (1) {
            switch (_context72.prev = _context72.next) {
              case 0:
                _context72.prev = 0;
                employeeId = _this87.employee.id;
                tarih = new Date();

                if (_this87.employee.endDate == "") {
                  tarih = null;
                } else {
                  tarih = new Date(_this87.employee.endDate);
                }
                _context72.next = 6;
                return _this87.$axios.post("/Employees/RemoveLeaveDate", {
                  id: employeeId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this87.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this87.getEmployees();
                  _this87.newEmployee();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this87.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this87.$ml.get("errors.connectionError"));
                      _this87.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this87.isLoading = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context72.sent;
                _context72.next = 13;
                break;

              case 9:
                _context72.prev = 9;
                _context72.t0 = _context72["catch"](0);

                console.error(_context72.t0);
                alertify.error(_context72.t0);

              case 13:
              case "end":
                return _context72.stop();
            }
          }
        }, _callee72, _this87, [[0, 9]]);
      }))();
    },
    getFP: function getFP() {
      var _this88 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee73() {
        return regeneratorRuntime.wrap(function _callee73$(_context73) {
          while (1) {
            switch (_context73.prev = _context73.next) {
              case 0:
                _context73.prev = 0;
                _context73.next = 3;
                return _this88.$axios.post("/USBFPDevice", {
                  employeeId: _this88.employee.id,
                  fpIndex: _this88.selectedFPIndex
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this88.$ml.get("alerts.getFingerprintFromUsbReader"));
                    _this88.getEmployee(_this88.employee.id);
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this88.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this88.$ml.get("errors.connectionError"));
                      _this88.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this88.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                _context73.next = 9;
                break;

              case 5:
                _context73.prev = 5;
                _context73.t0 = _context73["catch"](0);

                console.error(_context73.t0);
                alertify.error(_context73.t0);

              case 9:
              case "end":
                return _context73.stop();
            }
          }
        }, _callee73, _this88, [[0, 5]]);
      }))();
    },
    deleteFP: function deleteFP() {
      var _this89 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee74() {
        return regeneratorRuntime.wrap(function _callee74$(_context74) {
          while (1) {
            switch (_context74.prev = _context74.next) {
              case 0:
                _context74.prev = 0;
                _context74.next = 3;
                return _this89.$axios.post("/USBFPDevice/DeleteFp", {
                  employeeId: _this89.employee.id,
                  fpIndex: _this89.selectedFPIndex
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this89.$ml.get("alerts.deletedSuccessfully"));
                    _this89.getEmployee(_this89.employee.id);
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this89.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this89.$ml.get("errors.connectionError"));
                      _this89.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this89.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                _context74.next = 9;
                break;

              case 5:
                _context74.prev = 5;
                _context74.t0 = _context74["catch"](0);

                console.error(_context74.t0);
                alertify.error(_context74.t0);

              case 9:
              case "end":
                return _context74.stop();
            }
          }
        }, _callee74, _this89, [[0, 5]]);
      }))();
    },
    clearFP: function clearFP() {
      this.fpScreen = 0;
      this.selectedFPIndex = 0;
    },
    GetOrDeleteFP: function GetOrDeleteFP(fpIndex) {
      var _this90 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee75() {
        var durum;
        return regeneratorRuntime.wrap(function _callee75$(_context75) {
          while (1) {
            switch (_context75.prev = _context75.next) {
              case 0:
                _this90.selectedFPIndex = fpIndex;
                _context75.next = 3;
                return _this90.getHasFinger(fpIndex);

              case 3:
                durum = _context75.sent;

                if (durum) {
                  //parmak izi silinecek
                  _this90.fpScreen = 2;
                } else {
                  if (!_this90.selectedTerminal) {
                    _this90.fpScreen = 1;
                  } else {
                    _this90.fpScreen = 0;
                    _this90.SendGetFingerCommand(_this90.selectedTerminal, _this90.selectedFPIndex);
                    $("#fingerPrintModal").modal("hide");
                  }
                }

              case 5:
              case "end":
                return _context75.stop();
            }
          }
        }, _callee75, _this90);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.payment.searchStartDate == null) {
        this.payment.searchStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.payment.searchEndDate == null) {
        this.payment.searchEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.allowence.searchStartDate == null) {
        this.allowence.searchStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.allowence.searchEndDate == null) {
        this.allowence.searchEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.allowence.startDate == null || this.allowence.startDate == "") {
        this.allowence.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.allowence.endDate == null) {
        this.allowence.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.searchPayrollStartDate == null) {
        this.searchPayrollStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.searchPayrollEndDate == null) {
        this.searchPayrollEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.logStartDate == null) {
        this.logStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.logEndDate == null) {
        this.logEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.startDateRemoveAllowence == null) {
        this.startDateRemoveAllowence = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDateRemoveAllowence == null) {
        this.endDateRemoveAllowence = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    getEmployee: function getEmployee(id) {
      var _this91 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee76() {
        var response;
        return regeneratorRuntime.wrap(function _callee76$(_context76) {
          while (1) {
            switch (_context76.prev = _context76.next) {
              case 0:
                _context76.prev = 0;

                _this91.getDefaultDate();
                _this91.isLoading = true;
                _this91.tempUrl = null;
                _this91.imageData = null;
                _context76.next = 7;
                return _this91.$axios.get("/Employees/" + id).then(function (response) {
                  _this91.isNewEmployee = false;
                  _this91.employee.id = id;
                  _this91.employee.sicilNo = response.data.sicilNo;
                  _this91.employee.image = response.data.image;
                  _this91.employee.name = response.data.name;
                  _this91.employee.departmentId = response.data.departmentId;
                  _this91.employee.title = response.data.title;
                  _this91.employee.identityNo = response.data.identityNo;
                  _this91.employee.startDate = _this91.toDateFormat(response.data.startDate, "gg.aa.yyyy");
                  _this91.employee.endDate = response.data.endDate ? _this91.toDateFormat(response.data.endDate, "gg.aa.yyyy") : null;
                  _this91.employee.stateId = response.data.stateId;
                  _this91.employee.stateNote = response.data.stateNote;
                  _this91.employee.terminalNo = response.data.terminalNo;
                  _this91.employee.statuId = response.data.statuId;
                  _this91.employee.cardNo = response.data.cardNo;
                  _this91.employee.terminalStatu = response.data.terminalStatu;
                  _this91.employee.terminalPassword = response.data.terminalPassword;
                  _this91.employee.plateNo = response.data.plateNo;
                  _this91.employee.hgsNo = response.data.hgsNo;
                  _this91.employee.tzCode = response.data.tzCode;
                  _this91.employee.workGroupId = response.data.workGroupId;
                  _this91.employee.documentNo = response.data.documentNo;
                  _this91.employee.overWorkStatus = response.data.overWorkStatus;
                  _this91.employee.mail = response.data.mail;
                  _this91.employee.mobilePhone = response.data.mobilePhone;
                  _this91.employee.birthDayDate = response.data.birthDayDate ? _this91.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy") : null;
                  _this91.employee.validityStartDate = response.data.validityStartDate ? _this91.toDateFormat(response.data.validityStartDate, "gg.aa.yyyy") : null;
                  _this91.employee.validityEndDate = response.data.validityEndDate ? _this91.toDateFormat(response.data.validityEndDate, "gg.aa.yyyy") : null;
                  _this91.employee.address = response.data.address;
                  _this91.employee.internalPhone = response.data.internalPhone;
                  _this91.employee.homePhone = response.data.homePhone;
                  _this91.employee.gender = response.data.gender;
                  _this91.employee.educationStatus = response.data.educationStatus;
                  _this91.employee.militaryStatus = response.data.militaryStatus;
                  _this91.employee.drivingLicence = response.data.drivingLicence;
                  _this91.employee.smokeStatus = response.data.smokeStatus;
                  _this91.employee.maritalStatus = response.data.maritalStatus;
                  _this91.employee.bloodType = response.data.bloodType;
                  _this91.employee.height = response.data.height;
                  _this91.employee.weight = response.data.weight;
                  _this91.employee.disabledPercent = response.data.disabledPercent;
                  _this91.employee.authorizedPerson1 = response.data.authorizedPerson1;
                  _this91.employee.authorizedPerson2 = response.data.authorizedPerson2;
                  _this91.employee.note1 = response.data.note1;
                  _this91.employee.note2 = response.data.note2;
                  _this91.employee.foreignLanguage = response.data.foreignLanguage;
                  _this91.employee.accessGroupId = response.data.accessGroupId;
                  _this91.employee.readers = response.data.readers;
                  _this91.employee.foodGroupId = response.data.foodGroupId;
                  _this91.employee.credit = response.data.credit;
                  _this91.employee.remainder = response.data.remainder;
                  _this91.employee.isVisitor = response.data.isVisitor;
                  _this91.employee.visitorCardGroupId = response.data.visitorCardGroupId;
                  _this91.employee.isActive = response.data.isActive;
                  _this91.employee.inOuts = [];
                  _this91.employee.allowences = [];
                  _this91.employee.logs = [];
                  _this91.employee.extrafields = [];
                  _this91.employee.empPayrolls = [];
                  _this91.employee.annualPermitId = response.data.annualPermitId;
                  _this91.employee.annualPermitClaim = response.data.annualPermitClaim;
                  _this91.employee.annualPermitUsed = response.data.annualPermitUsed;
                  _this91.employee.annualPermitRemain = response.data.annualPermitRemain;
                  _this91.employee.annualPermits = response.data.annualPermits;
                  _this91.employee.annualPermitClaimsDates = response.data.annualPermitClaimsDates;
                  _this91.employee.annualPermitSeniority = response.data.annualPermitSeniority;
                  _this91.employee.annualPermitTransfer = response.data.annualPermitTransfer;
                  _this91.employee.hasCard = response.data.hasCard;
                  _this91.employee.hasFace = response.data.hasFace;
                  _this91.employee.hasFinger = response.data.hasFinger;
                  _this91.employee.hasPassword = response.data.hasPassword;
                  _this91.employee.isSmsSend = response.data.isSmsSend;
                  _this91.employee.parentPhone = response.data.parentPhone;
                  _this91.employee.isStudent = response.data.isStudent;
                  _this91.employee.isStayInDormitory = response.data.isStayInDormitory;
                  _this91.employee.motherName = response.data.motherName;
                  _this91.employee.motherPhone = response.data.motherPhone;
                  _this91.employee.fatherName = response.data.fatherName;
                  _this91.employee.fatherPhone = response.data.fatherPhone;
                  _this91.employee.roomId = response.data.roomId;
                  _this91.employee.roomName = response.data.roomName;
                  _this91.employee.areaName = response.data.areaName;
                  _this91.employee.floorName = response.data.floorName;
                  _this91.employee.fingerIndexes = response.data.fingerIndexes;
                  _this91.employee.isMobileUser = response.data.isMobileUser;
                  _this91.employee.mobilePassword = response.data.mobilePassword;
                  _this91.employee.mobileBrand = response.data.mobileBrand;
                  _this91.employee.mobileUuid = response.data.mobileUuid;
                  _this91.employee.foodClaim = response.data.foodClaim;
                  _this91.newAllowence();
                  _this91.newInOut();
                  _this91.newExtraField();
                  _this91.clearFP();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this91.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this91.$ml.get("errors.connectionError"));
                      _this91.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this91.isLoading = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context76.sent;
                _context76.next = 10;
                return _this91.getExtraFieldsForEmployee();

              case 10:
                _context76.next = 12;
                return _this91.getWorkPlaceForEmployee();

              case 12:
                _context76.next = 14;
                return _this91.getSalaryForEmployee();

              case 14:
                _context76.next = 16;
                return _this91.setCheckReaderList();

              case 16:
                _context76.next = 18;
                return _this91.getEmployeeInventories();

              case 18:
                _context76.next = 20;
                return _this91.getDocuments(0);

              case 20:
                _this91.isLoading = false;
                _context76.next = 28;
                break;

              case 23:
                _context76.prev = 23;
                _context76.t0 = _context76["catch"](0);

                console.error(_context76.t0);
                alertify.error(_context76.t0);
                _this91.isLoading = false;

              case 28:
              case "end":
                return _context76.stop();
            }
          }
        }, _callee76, _this91, [[0, 23]]);
      }))();
    },
    getAnnualPermits: function getAnnualPermits() {
      var _this92 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee77() {
        var annualPermits, response;
        return regeneratorRuntime.wrap(function _callee77$(_context77) {
          while (1) {
            switch (_context77.prev = _context77.next) {
              case 0:
                _context77.prev = 0;

                _this92.isLoading = true;
                annualPermits = [];
                _context77.next = 5;
                return _this92.$axios.get("/AnnualPermit").then(function (response) {
                  response.data.forEach(function (doc) {
                    annualPermits.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                  _this92.annualPermits = annualPermits;
                  _this92.isLoading = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this92.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this92.$ml.get("errors.connectionError"));
                      _this92.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this92.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context77.sent;
                _context77.next = 13;
                break;

              case 8:
                _context77.prev = 8;
                _context77.t0 = _context77["catch"](0);

                console.error(_context77.t0);
                alertify.error("Servis Hatası :" + _context77.t0.message);
                _this92.isLoading = false;

              case 13:
              case "end":
                return _context77.stop();
            }
          }
        }, _callee77, _this92, [[0, 8]]);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this93 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee78() {
        return regeneratorRuntime.wrap(function _callee78$(_context78) {
          while (1) {
            switch (_context78.prev = _context78.next) {
              case 0:
                dep.check = checkValue;
                _this93.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this93.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context78.stop();
            }
          }
        }, _callee78, _this93);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this94 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee79() {
        return regeneratorRuntime.wrap(function _callee79$(_context79) {
          while (1) {
            switch (_context79.prev = _context79.next) {
              case 0:
                _this94.filters.departments = [];
                _context79.next = 3;
                return _this94.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context79.stop();
            }
          }
        }, _callee79, _this94);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this95 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee80() {
        return regeneratorRuntime.wrap(function _callee80$(_context80) {
          while (1) {
            switch (_context80.prev = _context80.next) {
              case 0:
                _this95.filters.accessGroup = [];
                _context80.next = 3;
                return _this95.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context80.stop();
            }
          }
        }, _callee80, _this95);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this96 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee81() {
        return regeneratorRuntime.wrap(function _callee81$(_context81) {
          while (1) {
            switch (_context81.prev = _context81.next) {
              case 0:
                _this96.filters.stateId = [];
                _context81.next = 3;
                return _this96.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context81.stop();
            }
          }
        }, _callee81, _this96);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this97 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee82() {
        return regeneratorRuntime.wrap(function _callee82$(_context82) {
          while (1) {
            switch (_context82.prev = _context82.next) {
              case 0:
                _this97.filters.statuId = [];
                _context82.next = 3;
                return _this97.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context82.stop();
            }
          }
        }, _callee82, _this97);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this98 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee83() {
        return regeneratorRuntime.wrap(function _callee83$(_context83) {
          while (1) {
            switch (_context83.prev = _context83.next) {
              case 0:
                _this98.filters.workGroupId = [];
                _context83.next = 3;
                return _this98.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context83.stop();
            }
          }
        }, _callee83, _this98);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this99 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee84() {
        return regeneratorRuntime.wrap(function _callee84$(_context84) {
          while (1) {
            switch (_context84.prev = _context84.next) {
              case 0:
                _this99.filters.foodGroup = [];
                _context84.next = 3;
                return _this99.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context84.stop();
            }
          }
        }, _callee84, _this99);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this100 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee85() {
        return regeneratorRuntime.wrap(function _callee85$(_context85) {
          while (1) {
            switch (_context85.prev = _context85.next) {
              case 0:
                _this100.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this100.isCheckDeps = !_this100.isCheckDeps;

              case 2:
              case "end":
                return _context85.stop();
            }
          }
        }, _callee85, _this100);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this101 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee86() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee86$(_context86) {
          while (1) {
            switch (_context86.prev = _context86.next) {
              case 0:
                aList = _this101.sortableDepartmentList;

                _this101.filters.departments = [];
                _context86.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this101.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this101.accessGroupList;

                _this101.filters.accessGroup = [];
                _context86.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this101.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this101.workGroupList;

                _this101.filters.workGroupId = [];
                _context86.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this101.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this101.foodGroupList;

                _this101.filters.foodGroup = [];
                _context86.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this101.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this101.statuList;

                _this101.filters.statuId = [];
                _context86.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this101.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this101.stateList;

                _this101.filters.stateId = [];
                _context86.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this101.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context86.stop();
            }
          }
        }, _callee86, _this101);
      }))();
    },
    getEmployeesFromCardNoFast: function getEmployeesFromCardNoFast(data) {
      var _this102 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee87() {
        return regeneratorRuntime.wrap(function _callee87$(_context87) {
          while (1) {
            switch (_context87.prev = _context87.next) {
              case 0:
                if (!(data.length > 9 && $.isNumeric(data) == true)) {
                  _context87.next = 10;
                  break;
                }

                _context87.next = 3;
                return _this102.filtersClear();

              case 3:
                _this102.filters.nameOrCardNumber = data;
                _this102.filters.isActive = false;
                _context87.next = 7;
                return _this102.getEmployees();

              case 7:
                _this102.searchText = "";
                _context87.next = 16;
                break;

              case 10:
                _context87.next = 12;
                return _this102.filtersClear();

              case 12:
                _this102.filters.nameOrCardNumber = data;
                _this102.filters.isActive = false;
                _context87.next = 16;
                return _this102.getEmployees();

              case 16:
              case "end":
                return _context87.stop();
            }
          }
        }, _callee87, _this102);
      }))();
    },
    getEmployeesFromCardNo: function getEmployeesFromCardNo() {
      $("#modal-filtre").modal("hide");
      this.getEmployees();
    },
    getEmployees: function getEmployees() {
      var _this103 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee88() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee88$(_context88) {
          while (1) {
            switch (_context88.prev = _context88.next) {
              case 0:
                _context88.prev = 0;

                _this103.isLoadingEmployee = true;
                _context88.next = 4;
                return _this103.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this103.filters;
                _context88.next = 8;
                return _this103.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title
                    });
                  });
                  _this103.filtersClear();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this103.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this103.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this103.$ml.get("errors.connectionError"));
                      _this103.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this103.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context88.sent;

                _this103.employees = employees;
                _this103.isLoadingEmployee = false;
                _context88.next = 18;
                break;

              case 13:
                _context88.prev = 13;
                _context88.t0 = _context88["catch"](0);

                console.error(_context88.t0);
                alertify.error("Servis Hatası :" + _context88.t0.message);
                _this103.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context88.stop();
            }
          }
        }, _callee88, _this103, [[0, 13]]);
      }))();
    },
    changePayroll: function changePayroll(empPayroll) {
      this.selectedChangePayroll.changeDate = empPayroll.date;
    },
    setChangePayroll: function setChangePayroll(newOperationId, isAllowence) {
      var _this104 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee89() {
        var employeeId, selectedChangePayroll2, response;
        return regeneratorRuntime.wrap(function _callee89$(_context89) {
          while (1) {
            switch (_context89.prev = _context89.next) {
              case 0:
                if (!_this104.isNewEmployee) {
                  _context89.next = 3;
                  break;
                }

                alertify.warning(_this104.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context89.abrupt("return");

              case 3:
                _context89.prev = 3;

                _this104.isLoadingPayrolls = true;
                employeeId = _this104.employee.id;
                selectedChangePayroll2 = _this104.selectedChangePayroll;
                _context89.next = 9;
                return _this104.$axios.post("/EmployeeDetails/ChangePayroll", {
                  employeeId: employeeId,
                  newOperationId: newOperationId,
                  changeDate: selectedChangePayroll2.changeDate,
                  isAllowence: isAllowence
                }).then(function (response) {
                  alertify.success(_this104.$ml.get("alerts.updatedSuccessfully"));
                  _this104.isLoadingPayrolls = false;
                  _this104.getEmpPayrolls();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this104.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this104.$ml.get("errors.connectionError"));
                      _this104.isLoadingPayrolls = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this104.isLoadingPayrolls = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context89.sent;
                _context89.next = 17;
                break;

              case 12:
                _context89.prev = 12;
                _context89.t0 = _context89["catch"](3);

                console.error(_context89.t0);
                alertify.error("Servis Hatası :" + _context89.t0.message);
                _this104.isLoadingPayrolls = false;

              case 17:
              case "end":
                return _context89.stop();
            }
          }
        }, _callee89, _this104, [[3, 12]]);
      }))();
    },
    getEmpPayrolls: function getEmpPayrolls() {
      var _this105 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee90() {
        var empPayrolls, empId, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee90$(_context90) {
          while (1) {
            switch (_context90.prev = _context90.next) {
              case 0:
                if (!_this105.isNewEmployee) {
                  _context90.next = 3;
                  break;
                }

                alertify.warning(_this105.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context90.abrupt("return");

              case 3:
                if (!(_this105.searchPayrollStartDate == null || _this105.searchPayrollEndDate == null || _this105.searchPayrollStartDate > _this105.searchPayrollEndDate)) {
                  _context90.next = 6;
                  break;
                }

                alertify.warning(_this105.$ml.get("alerts.invalidDate"));
                return _context90.abrupt("return");

              case 6:
                _context90.prev = 6;

                _this105.isLoadingPayrolls = true;
                empPayrolls = [];
                empId = _this105.employee.id;
                startDate = _this105.searchPayrollStartDate;
                endDate = _this105.searchPayrollEndDate;
                _context90.next = 14;
                return _this105.$axios.post("/EmployeeDetails/GetPayroll", {
                  empId: empId,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    empPayrolls.push({
                      overTimeId: doc.overTimeId,
                      workPlan: doc.workPlan,
                      calculatedOverTime: doc.calculatedOverTime,
                      confirmedOverTime: doc.confirmedOverTime,
                      firstEntry: doc.firstEntry,
                      lastOut: doc.lastOut,
                      date: doc.date,
                      isAllowence: doc.isAllowence
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this105.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this105.$ml.get("errors.connectionError"));
                      _this105.isLoadingPayrolls = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this105.isLoadingPayrolls = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context90.sent;

                _this105.employee.empPayrolls = empPayrolls;
                _this105.isLoadingPayrolls = false;
                _context90.next = 24;
                break;

              case 19:
                _context90.prev = 19;
                _context90.t0 = _context90["catch"](6);

                console.error(_context90.t0);
                alertify.error("Servis Hatası :" + _context90.t0.message);
                _this105.isLoadingPayrolls = false;

              case 24:
              case "end":
                return _context90.stop();
            }
          }
        }, _callee90, _this105, [[6, 19]]);
      }))();
    },
    getCalculatePayrolls: function getCalculatePayrolls() {
      var _this106 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee91() {
        var empId, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee91$(_context91) {
          while (1) {
            switch (_context91.prev = _context91.next) {
              case 0:
                if (!(_this106.isNewEmployee && !_this106.employee.id)) {
                  _context91.next = 3;
                  break;
                }

                alertify.warning(_this106.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context91.abrupt("return");

              case 3:
                _context91.prev = 3;

                _this106.isLoadingPayrolls = true;
                empId = parseInt(_this106.employee.id);
                startDate = _this106.searchPayrollStartDate;
                endDate = _this106.searchPayrollEndDate;
                _context91.next = 10;
                return _this106.$axios.post("/EmployeeDetails/CalculatePayroll", {
                  empId: empId,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this106.$ml.get("alerts.payrollOfTheEmployeeWasRecalculated"));
                    _this106.isLoadingPayrolls = false;
                  } else {
                    response.statusText + " - " + response.data.message;
                    _this106.isLoadingPayrolls = false;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this106.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this106.$ml.get("errors.connectionError"));
                      _this106.isLoadingPayrolls = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this106.isLoadingPayrolls = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context91.sent;
                _context91.next = 13;
                return _this106.getEmpPayrolls();

              case 13:
                _context91.next = 19;
                break;

              case 15:
                _context91.prev = 15;
                _context91.t0 = _context91["catch"](3);

                console.error(_context91.t0);
                alertify.error("Servis Hatası :" + _context91.t0.message);

              case 19:
              case "end":
                return _context91.stop();
            }
          }
        }, _callee91, _this106, [[3, 15]]);
      }))();
    },
    getAllEmployees: function getAllEmployees() {
      var _this107 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee92() {
        var allEmployees, response;
        return regeneratorRuntime.wrap(function _callee92$(_context92) {
          while (1) {
            switch (_context92.prev = _context92.next) {
              case 0:
                _context92.prev = 0;
                allEmployees = [];
                _context92.next = 4;
                return _this107.$axios.get("/Employees").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      allEmployees.push({
                        id: doc.id,
                        name: doc.name,
                        title: doc.title,
                        isVisitor: doc.isVisitor
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this107.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this107.$ml.get("errors.connectionError"));
                      _this107.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this107.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context92.sent;

                _this107.allEmployees = allEmployees;
                _context92.next = 12;
                break;

              case 8:
                _context92.prev = 8;
                _context92.t0 = _context92["catch"](0);

                console.error(_context92.t0);
                alertify.error("Servis Hatası :" + _context92.t0.message);

              case 12:
              case "end":
                return _context92.stop();
            }
          }
        }, _callee92, _this107, [[0, 8]]);
      }))();
    },
    getPaymentDefinitions: function getPaymentDefinitions() {
      var _this108 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee93() {
        var paymentDefinitions, response;
        return regeneratorRuntime.wrap(function _callee93$(_context93) {
          while (1) {
            switch (_context93.prev = _context93.next) {
              case 0:
                _context93.prev = 0;
                paymentDefinitions = [];
                _context93.next = 4;
                return _this108.$axios.get("/Salary").then(function (response) {
                  response.data.forEach(function (doc) {
                    paymentDefinitions.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this108.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this108.$ml.get("errors.connectionError"));
                      _this108.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this108.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context93.sent;

                _this108.paymentDefinitions = paymentDefinitions;
                _context93.next = 12;
                break;

              case 8:
                _context93.prev = 8;
                _context93.t0 = _context93["catch"](0);

                console.error(_context93.t0);
                alertify.error("Servis Hatası :" + _context93.t0.message);

              case 12:
              case "end":
                return _context93.stop();
            }
          }
        }, _callee93, _this108, [[0, 8]]);
      }))();
    },
    getWorkPlaceDefinitions: function getWorkPlaceDefinitions() {
      var _this109 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee94() {
        var response;
        return regeneratorRuntime.wrap(function _callee94$(_context94) {
          while (1) {
            switch (_context94.prev = _context94.next) {
              case 0:
                _context94.prev = 0;
                _context94.next = 3;
                return _this109.$axios.get("/WorkPlaceDefinition/GetAll").then(function (response) {
                  _this109.workPlaceDefinitions = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this109.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this109.$ml.get("errors.connectionError"));
                      _this109.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this109.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context94.sent;
                _context94.next = 10;
                break;

              case 6:
                _context94.prev = 6;
                _context94.t0 = _context94["catch"](0);

                console.error(_context94.t0);
                alertify.error("Servis Hatası :" + _context94.t0.message);

              case 10:
              case "end":
                return _context94.stop();
            }
          }
        }, _callee94, _this109, [[0, 6]]);
      }))();
    },
    getOvertimeDescriptions: function getOvertimeDescriptions() {
      var _this110 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee95() {
        var overtimeDescriptions, response;
        return regeneratorRuntime.wrap(function _callee95$(_context95) {
          while (1) {
            switch (_context95.prev = _context95.next) {
              case 0:
                _context95.prev = 0;
                overtimeDescriptions = [];
                _context95.next = 4;
                return _this110.$axios.get("/OvertimeDescription").then(function (response) {
                  response.data.forEach(function (doc) {
                    overtimeDescriptions.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this110.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this110.$ml.get("errors.connectionError"));
                      _this110.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this110.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context95.sent;

                _this110.overtimeDescriptions = overtimeDescriptions;
                _context95.next = 12;
                break;

              case 8:
                _context95.prev = 8;
                _context95.t0 = _context95["catch"](0);

                console.error(_context95.t0);
                alertify.error("Servis Hatası :" + _context95.t0.message);

              case 12:
              case "end":
                return _context95.stop();
            }
          }
        }, _callee95, _this110, [[0, 8]]);
      }))();
    },
    getOvertimePlaces: function getOvertimePlaces() {
      var _this111 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee96() {
        var overtimePlaces, response;
        return regeneratorRuntime.wrap(function _callee96$(_context96) {
          while (1) {
            switch (_context96.prev = _context96.next) {
              case 0:
                _context96.prev = 0;
                overtimePlaces = [];
                _context96.next = 4;
                return _this111.$axios.get("/OvertimePlaces").then(function (response) {
                  response.data.forEach(function (doc) {
                    overtimePlaces.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this111.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this111.$ml.get("errors.connectionError"));
                      _this111.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this111.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context96.sent;

                _this111.overtimePlaces = overtimePlaces;
                _context96.next = 12;
                break;

              case 8:
                _context96.prev = 8;
                _context96.t0 = _context96["catch"](0);

                console.error(_context96.t0);
                alertify.error("Servis Hatası :" + _context96.t0.message);

              case 12:
              case "end":
                return _context96.stop();
            }
          }
        }, _callee96, _this111, [[0, 8]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this112 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee97() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee97$(_context97) {
          while (1) {
            switch (_context97.prev = _context97.next) {
              case 0:
                _context97.prev = 0;
                allowences = [];
                _context97.next = 4;
                return _this112.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this112.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this112.$ml.get("errors.connectionError"));
                      _this112.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this112.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context97.sent;

                _this112.allowences = allowences;
                _context97.next = 12;
                break;

              case 8:
                _context97.prev = 8;
                _context97.t0 = _context97["catch"](0);

                console.error(_context97.t0);
                alertify.error("Servis Hatası :" + _context97.t0.message);

              case 12:
              case "end":
                return _context97.stop();
            }
          }
        }, _callee97, _this112, [[0, 8]]);
      }))();
    },
    deleteOverTime: function deleteOverTime(id) {
      var _this113 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee98() {
        var response;
        return regeneratorRuntime.wrap(function _callee98$(_context98) {
          while (1) {
            switch (_context98.prev = _context98.next) {
              case 0:
                _context98.prev = 0;

                _this113.isLoadingPayrolls = true;
                _context98.next = 4;
                return _this113.$axios.delete("/EmployeeDetails/DeleteConfirmOvertime/" + id).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this113.$ml.get("alerts.confirmedOvertimeDeleted"));
                  } else {
                    response.statusText + " - " + response.data.message;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this113.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this113.$ml.get("errors.connectionError"));
                      _this113.isLoadingPayrolls = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this113.isLoadingPayrolls = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context98.sent;
                _context98.next = 7;
                return _this113.getEmpPayrolls();

              case 7:
                _this113.isLoadingPayrolls = false;
                _context98.next = 15;
                break;

              case 10:
                _context98.prev = 10;
                _context98.t0 = _context98["catch"](0);

                console.error(_context98.t0);
                alertify.error("Servis Hatası :" + _context98.t0.message);
                _this113.isLoadingPayrolls = false;

              case 15:
              case "end":
                return _context98.stop();
            }
          }
        }, _callee98, _this113, [[0, 10]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this114 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this114.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this114.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this114.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this114.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this114.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this114.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getCardDesigns: function getCardDesigns() {
      var _this115 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee99() {
        var cardDesigns, response;
        return regeneratorRuntime.wrap(function _callee99$(_context99) {
          while (1) {
            switch (_context99.prev = _context99.next) {
              case 0:
                _context99.prev = 0;
                cardDesigns = [];
                _context99.next = 4;
                return _this115.$axios.get("/CardDesign").then(function (response) {
                  response.data.forEach(function (doc) {
                    cardDesigns.push({
                      id: doc.id,
                      name: doc.name,
                      backgroundImage: doc.backgroundImage,
                      backgroundColor: doc.backgroundColor,
                      template: doc.template
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this115.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this115.$ml.get("errors.connectionError"));
                      _this115.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this115.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context99.sent;

                _this115.cardDesigns = cardDesigns;
                _context99.next = 12;
                break;

              case 8:
                _context99.prev = 8;
                _context99.t0 = _context99["catch"](0);

                console.error(_context99.t0);
                alertify.error("Servis Hatası :" + _context99.t0.message);

              case 12:
              case "end":
                return _context99.stop();
            }
          }
        }, _callee99, _this115, [[0, 8]]);
      }))();
    },
    getInventoryFromId: function getInventoryFromId(inventoryId) {
      var inventory = {
        name: "",
        categoryId: null,
        code: "",
        fields: [],
        id: null,
        photoUrl: null,
        serialNo: "",
        quantity: 0,
        assignedCount: 0
      };
      this.inventories.forEach(function (doc) {
        if (doc.id == inventoryId) {
          inventory = _extends({}, doc);
        }
      });
      return inventory;
    },
    getInventoryCategoryName: function getInventoryCategoryName(categoryId) {
      var category = this.inventoryCategories.find(function (c) {
        return c.id === categoryId;
      });
      return category ? category.name : "";
    },
    newInventory: function newInventory() {
      this.employeeInventory = {
        id: null,
        employeeId: this.employee.id,
        inventoryId: null,
        quantity: 1,
        deliveryDate: null,
        takenDate: null,
        description: ""
      };
      this.selectedInventoryCategory = 0;
      this.searchInventoryText = "";
    },
    selectInventory: function selectInventory(inventory) {
      this.employeeInventory.id = inventory.id;
      this.employeeInventory.inventoryId = inventory.inventoryId;
      this.employeeInventory.quantity = inventory.quantity;
      this.employeeInventory.deliveryDate = inventory.deliveryDate;
      this.employeeInventory.takenDate = inventory.takenDate;
      this.employeeInventory.description = inventory.description;
    },
    deleteEmployeeInventory: function deleteEmployeeInventory() {
      var _this116 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee100() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee100$(_context100) {
          while (1) {
            switch (_context100.prev = _context100.next) {
              case 0:
                _context100.prev = 0;

                _this116.isLoading = true;
                id = _this116.employeeInventory.id;
                _context100.next = 5;
                return _this116.$axios.delete("/EmployeeInventory/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 400) {
                      alertify.error("Silmek istenilen demirbaş kişi veya ziyaretçilere zimmet olarak tanımlı.");
                    }
                    if (error.response.status == 401) {
                      _this116.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this116.$ml.get('errors.connectionError'));
                      _this116.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this116.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context100.sent;

                $("#modal-inventory-details").modal("hide");
                _this116.getEmployeeInventories();
                alertify.success(_this116.$ml.get('alerts.deletedSuccessfully'));
                _this116.isLoading = false;
                _context100.next = 16;
                break;

              case 12:
                _context100.prev = 12;
                _context100.t0 = _context100["catch"](0);

                alertify.error("Hata Oluştu : " + _context100.t0);
                _this116.isLoading = false;

              case 16:
              case "end":
                return _context100.stop();
            }
          }
        }, _callee100, _this116, [[0, 12]]);
      }))();
    },
    saveEmployeeInventory: function saveEmployeeInventory() {
      var _this117 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee101() {
        var response;
        return regeneratorRuntime.wrap(function _callee101$(_context101) {
          while (1) {
            switch (_context101.prev = _context101.next) {
              case 0:
                if (!(_this117.employeeInventory.inventoryId == null || _this117.employeeInventory.inventoryId == 0)) {
                  _context101.next = 3;
                  break;
                }

                alertify.warning(_this117.$ml.get("alerts.pleaseSelect"));
                return _context101.abrupt("return");

              case 3:
                if (!(_this117.getInventoryFromId(_this117.employeeInventory.inventoryId).quantity <= _this117.getInventoryFromId(_this117.employeeInventory.inventoryId).assignedCount)) {
                  _context101.next = 6;
                  break;
                }

                alertify.warning("Yetersiz stok! Tüm ürün adetleri zaten kişilere atanmış. Lütfen başka bir ürün seçiniz.");
                return _context101.abrupt("return");

              case 6:
                if (!(_this117.employeeInventory.quantity == null || _this117.employeeInventory.quantity <= 0)) {
                  _context101.next = 9;
                  break;
                }

                alertify.warning(_this117.$ml.get("alerts.pleaseEnterValidQuantity"));
                return _context101.abrupt("return");

              case 9:
                if (!(_this117.employeeInventory.deliveryDate == null || _this117.employeeInventory.deliveryDate == "")) {
                  _context101.next = 12;
                  break;
                }

                alertify.warning(_this117.$ml.get("alerts.pleaseSelectDeliveryDate"));
                return _context101.abrupt("return");

              case 12:
                _context101.prev = 12;

                _this117.isLoading = true;
                _context101.next = 16;
                return _this117.$axios.post("/EmployeeInventory", _this117.employeeInventory).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this117.$ml.get("alerts.savedSuccessfully"));
                    $("#modal-inventory").modal("hide");
                    _this117.getEmployeeInventories();
                  } else {
                    response.statusText + " - " + response.data.message;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this117.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this117.$ml.get("errors.connectionError"));
                      _this117.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this117.isLoading = false;
                      return;
                    }
                  }
                });

              case 16:
                response = _context101.sent;

                _this117.isLoading = false;
                _context101.next = 25;
                break;

              case 20:
                _context101.prev = 20;
                _context101.t0 = _context101["catch"](12);

                console.error(_context101.t0);
                alertify.error("Servis Hatası :" + _context101.t0.message);
                _this117.isLoading = false;

              case 25:
              case "end":
                return _context101.stop();
            }
          }
        }, _callee101, _this117, [[12, 20]]);
      }))();
    },
    getInventoryCategories: function getInventoryCategories() {
      var _this118 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee102() {
        var response;
        return regeneratorRuntime.wrap(function _callee102$(_context102) {
          while (1) {
            switch (_context102.prev = _context102.next) {
              case 0:
                _context102.prev = 0;

                _this118.isLoading = true;
                _context102.next = 4;
                return _this118.$axios.get("/InventoryCategory/GetAll").then(function (response) {
                  _this118.inventoryCategories = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this118.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this118.$ml.get('errors.connectionError'));
                      _this118.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this118.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context102.sent;

                _this118.isLoading = false;
                _context102.next = 13;
                break;

              case 8:
                _context102.prev = 8;
                _context102.t0 = _context102["catch"](0);

                console.error(_context102.t0);
                alertify.error("Servis Hatası :" + _context102.t0.message);
                _this118.isLoading = false;

              case 13:
              case "end":
                return _context102.stop();
            }
          }
        }, _callee102, _this118, [[0, 8]]);
      }))();
    },
    getInventories: function getInventories() {
      var _this119 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee103() {
        var response;
        return regeneratorRuntime.wrap(function _callee103$(_context103) {
          while (1) {
            switch (_context103.prev = _context103.next) {
              case 0:
                _context103.prev = 0;

                _this119.isLoading = true;
                _context103.next = 4;
                return _this119.$axios.get("/Inventory/Inventories").then(function (response) {
                  _this119.inventories = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this119.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this119.$ml.get('errors.connectionError'));
                      _this119.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this119.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context103.sent;

                _this119.isLoading = false;
                _context103.next = 13;
                break;

              case 8:
                _context103.prev = 8;
                _context103.t0 = _context103["catch"](0);

                console.error(_context103.t0);
                alertify.error("Servis Hatası :" + _context103.t0.message);
                _this119.isLoading = false;

              case 13:
              case "end":
                return _context103.stop();
            }
          }
        }, _callee103, _this119, [[0, 8]]);
      }))();
    },
    getEmployeeInventories: function getEmployeeInventories() {
      var _this120 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee104() {
        var response;
        return regeneratorRuntime.wrap(function _callee104$(_context104) {
          while (1) {
            switch (_context104.prev = _context104.next) {
              case 0:
                _context104.prev = 0;

                _this120.isLoading = true;
                _context104.next = 4;
                return _this120.$axios.get("/EmployeeInventory/GetAll/" + _this120.employee.id).then(function (response) {
                  _this120.employeeInventories = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this120.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this120.$ml.get('errors.connectionError'));
                      _this120.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this120.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context104.sent;

                _this120.isLoading = false;
                _context104.next = 13;
                break;

              case 8:
                _context104.prev = 8;
                _context104.t0 = _context104["catch"](0);

                console.error(_context104.t0);
                alertify.error("Servis Hatası :" + _context104.t0.message);
                _this120.isLoading = false;

              case 13:
              case "end":
                return _context104.stop();
            }
          }
        }, _callee104, _this120, [[0, 8]]);
      }))();
    },
    newDocument: function newDocument() {
      this.document.id = null;
      this.document.documentDefinitionId = null;
      this.document.description = "";
      this.document.filePath = "";
      this.document.isISGDocument = false, this.document.starDate = null;
      this.document.endDate = null;
      this.document.isActive = true;
      $('#modal-document').modal('show');
    },
    getDocument: function getDocument(document) {
      this.document.id = document.id;
      this.document.documentDefinitionId = document.documentDefinitionId;
      this.document.description = document.description;
      this.document.filePath = document.filePath;
      this.document.isISGDocument = document.isISGDocument;
      this.document.starDate = this.toDateFormat(document.starDate, "yyyy-aa-gg");
      this.document.endDate = this.toDateFormat(document.endDate, "yyyy-aa-gg");
      this.document.isActive = document.isActive;
      $('#modal-document').modal('show');
    },
    getDocumentDefinitionName: function getDocumentDefinitionName(documentDefinitionId) {
      var definition = this.documentDefinitions.find(function (d) {
        return d.id === documentDefinitionId;
      });
      return definition ? definition.name : "";
    },
    deleteDocument: function deleteDocument(documentId) {
      var _this121 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee105() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee105$(_context105) {
          while (1) {
            switch (_context105.prev = _context105.next) {
              case 0:
                _context105.prev = 0;

                _this121.isLoadingDetail = true;
                id = documentId;
                _context105.next = 5;
                return _this121.$axios.delete("/EmployeeDocument/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this121.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this121.$ml.get('errors.connectionError'));
                      _this121.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this121.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context105.sent;

                _this121.getDocuments(0);
                alertify.success(_this121.$ml.get('alerts.deletedSuccessfully'));
                _this121.isLoadingDetail = false;
                _context105.next = 15;
                break;

              case 11:
                _context105.prev = 11;
                _context105.t0 = _context105["catch"](0);

                alertify.error("Hata Oluştu : " + _context105.t0);
                _this121.isLoadingDetail = false;

              case 15:
              case "end":
                return _context105.stop();
            }
          }
        }, _callee105, _this121, [[0, 11]]);
      }))();
    },
    saveDocument: function saveDocument() {
      var _this122 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee106() {
        var fileName, idxDot, extFile, formData, response, id, document2, _response7;

        return regeneratorRuntime.wrap(function _callee106$(_context106) {
          while (1) {
            switch (_context106.prev = _context106.next) {
              case 0:
                if (!(_this122.document.documentDefinitionId == null)) {
                  _context106.next = 3;
                  break;
                }

                alertify.warning(_this122.$ml.get('alerts.pleaseSelectADocumentDefinition'));
                return _context106.abrupt("return");

              case 3:
                if (!(_this122.document.isISGDocument == true && (_this122.document.starDate == null || _this122.document.endDate == null))) {
                  _context106.next = 6;
                  break;
                }

                alertify.warning(_this122.$ml.get('employees.isgDocumentValidity'));
                return _context106.abrupt("return");

              case 6:
                if (!(_this122.document.id == null)) {
                  _context106.next = 46;
                  break;
                }

                fileName = document.getElementById("fileName").value;
                idxDot = fileName.lastIndexOf(".") + 1;
                extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

                if (!(extFile == "zip" || extFile == "pdf" || extFile == "doc" || extFile == "docx" || extFile == "xls" || extFile == "xlsx" || extFile == "png" || extFile == "jpg" || extFile == "jpeg")) {
                  _context106.next = 42;
                  break;
                }

                if (!(_this122.$refs.file.files[0].size > 29000000)) {
                  _context106.next = 16;
                  break;
                }

                //29 MB
                alertify.warning(_this122.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
                _this122.fileId = null;
                _this122.$refs.file.value = "";
                return _context106.abrupt("return");

              case 16:
                _this122.isLoadingDetail = true;
                _context106.prev = 17;
                formData = new FormData();

                formData.append("file", _this122.$refs.file.files[0]);
                formData.append("employeeId", _this122.employee.id);
                formData.append("documentDefinitionId", _this122.document.documentDefinitionId);
                formData.append("description", _this122.document.description);
                formData.append("isISGDocument", _this122.document.isISGDocument);
                if (_this122.document.starDate) {
                  formData.append("starDate", _this122.document.starDate);
                }
                if (_this122.document.endDate) {
                  formData.append("endDate", _this122.document.endDate);
                }
                _context106.next = 28;
                return _this122.$axios.post("/EmployeeDocument", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this122.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this122.$ml.get('errors.connectionError'));
                      _this122.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this122.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                response = _context106.sent;
                id = response.data.id;

                if (response.status == 200) {
                  $("#modal-document").modal("hide");
                  alertify.success(_this122.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this122.getDocuments(0);
                _this122.isLoadingDetail = false;
                _context106.next = 40;
                break;

              case 35:
                _context106.prev = 35;
                _context106.t0 = _context106["catch"](17);

                console.error(_context106.t0);
                alertify.error(_context106.t0.message);
                _this122.isLoadingDetail = false;

              case 40:
                _context106.next = 44;
                break;

              case 42:
                alertify.warning(_this122.$ml.get("alerts.pleaseCheckTheFileFormat"));
                return _context106.abrupt("return");

              case 44:
                _context106.next = 61;
                break;

              case 46:
                _context106.prev = 46;
                document2 = _this122.document;
                _context106.next = 50;
                return _this122.$axios.put("/EmployeeDocument/" + document2.id, {
                  employeeId: _this122.employee.id,
                  documentDefinitionId: _this122.document.documentDefinitionId,
                  description: _this122.document.description,
                  isISGDocument: _this122.document.isISGDocument,
                  starDate: _this122.document.starDate,
                  endDate: _this122.document.endDate
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this122.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this122.$ml.get('errors.connectionError'));
                      _this122.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this122.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 50:
                _response7 = _context106.sent;

                if (_response7.status == 200) {
                  $("#modal-document").modal("hide");
                  alertify.success(_this122.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response7.message);
                }
                _this122.getDocuments(0);
                _this122.isLoadingDetail = false;
                _context106.next = 61;
                break;

              case 56:
                _context106.prev = 56;
                _context106.t1 = _context106["catch"](46);

                console.error(_context106.t1);
                alertify.error(_context106.t1);
                _this122.isLoadingDetail = false;

              case 61:
              case "end":
                return _context106.stop();
            }
          }
        }, _callee106, _this122, [[17, 35], [46, 56]]);
      }))();
    },
    getDocuments: function getDocuments(type) {
      var _this123 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee107() {
        var response;
        return regeneratorRuntime.wrap(function _callee107$(_context107) {
          while (1) {
            switch (_context107.prev = _context107.next) {
              case 0:
                _context107.prev = 0;

                _this123.isLoading = true;
                _this123.documents = [];
                _context107.next = 5;
                return _this123.$axios.get("/EmployeeDocument/GetByEmployeeId/" + _this123.employee.id + "?type=" + type).then(function (response) {
                  _this123.documents = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this123.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this123.$ml.get('errors.connectionError'));
                      _this123.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this123.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context107.sent;

                _this123.isLoading = false;
                _context107.next = 14;
                break;

              case 9:
                _context107.prev = 9;
                _context107.t0 = _context107["catch"](0);

                console.error(_context107.t0);
                alertify.error("Servis Hatası :" + _context107.t0.message);
                _this123.isLoading = false;

              case 14:
              case "end":
                return _context107.stop();
            }
          }
        }, _callee107, _this123, [[0, 9]]);
      }))();
    },
    getDocumentDefinitions: function getDocumentDefinitions() {
      var _this124 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee108() {
        var response;
        return regeneratorRuntime.wrap(function _callee108$(_context108) {
          while (1) {
            switch (_context108.prev = _context108.next) {
              case 0:
                _context108.prev = 0;

                _this124.isLoading = true;
                _context108.next = 4;
                return _this124.$axios.get("/DocumentDefinition/GetAll").then(function (response) {
                  _this124.documentDefinitions = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this124.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this124.$ml.get('errors.connectionError'));
                      _this124.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this124.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context108.sent;

                _this124.isLoading = false;
                _context108.next = 13;
                break;

              case 8:
                _context108.prev = 8;
                _context108.t0 = _context108["catch"](0);

                console.error(_context108.t0);
                alertify.error("Servis Hatası :" + _context108.t0.message);
                _this124.isLoading = false;

              case 13:
              case "end":
                return _context108.stop();
            }
          }
        }, _callee108, _this124, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this125 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee109() {
        return regeneratorRuntime.wrap(function _callee109$(_context109) {
          while (1) {
            switch (_context109.prev = _context109.next) {
              case 0:
                if (_this125.authControl == 1) {
                  alertify.warning(_this125.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context109.stop();
            }
          }
        }, _callee109, _this125);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this126 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee110() {
      var filter;
      return regeneratorRuntime.wrap(function _callee110$(_context110) {
        while (1) {
          switch (_context110.prev = _context110.next) {
            case 0:
              _context110.next = 2;
              return _this126.getAuthControl();

            case 2:
              _this126.getDefaultDate();
              if (_this126.defaultFilters) {
                filter = _this126.defaultFilters;

                _this126.setUserAuthorityFilter(filter);
                _this126.getEmployees();
              }
              _this126.getAllEmployees();
              _this126.getReaders();
              _this126.getDepartments();
              _this126.getAccessGroups();
              if (_this126.modules.diningHall) {
                _this126.getFoodGroups();
              }
              _this126.getStatus();
              _this126.getStates();
              _this126.getTitles();
              _this126.getWorkGroups();
              _this126.getExtraFields();
              if (_this126.modules.annualPermit) {
                _this126.getAnnualPermits();
              }
              if (_this126.modules.payroll) {
                _this126.getOvertimeDescriptions();
                _this126.getOvertimePlaces();
              }
              _this126.getAllowences();
              _this126.getPaymentDefinitions();
              _this126.getWorkPlaceDefinitions();
              _this126.getCardDesigns();
              _context110.next = 22;
              return _this126.getInventories();

            case 22:
              _context110.next = 24;
              return _this126.getInventoryCategories();

            case 24:
              _this126.getDocumentDefinitions();
              _this126.requiredFields = _this126.$store.getters.getRequiredFields;
              //await this.getVisitorCardGroups();

            case 26:
            case "end":
              return _context110.stop();
          }
        }
      }, _callee110, _this126);
    }))();
  }
});

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_language_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_mimes_js__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_data2blob_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_effectRipple_js__ = __webpack_require__(306);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };






/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		// 域，上传文件name，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		field: {
			type: String,
			'default': 'avatar'
		},
		// 原名key，类似于id，触发事件会带上（如果一个页面多个图片上传控件，可以做区分
		ki: {
			'default': 0
		},
		// 显示该控件与否
		value: {
			'default': true
		},
		// 上传地址
		url: {
			type: String,
			'default': ''
		},
		// 其他要上传文件附带的数据，对象格式
		params: {
			type: Object,
			'default': null
		},
		//Add custom headers
		headers: {
			type: Object,
			'default': null
		},
		// 剪裁图片的宽
		width: {
			type: Number,
			default: 200
		},
		// 剪裁图片的高
		height: {
			type: Number,
			default: 200
		},
		// 不显示旋转功能
		noRotate: {
			type: Boolean,
			default: true
		},
		// 不预览圆形图片
		noCircle: {
			type: Boolean,
			default: false
		},
		// 不预览方形图片
		noSquare: {
			type: Boolean,
			default: false
		},
		// 单文件大小限制
		maxSize: {
			type: Number,
			'default': 10240
		},
		// 语言类型
		langType: {
			type: String,
			'default': 'zh'
		},
		// 语言包
		langExt: {
			type: Object,
			'default': null
		},
		// 图片上传格式
		imgFormat: {
			type: String,
			'default': 'png'
		},
		// 图片背景 jpg情况下生效
		imgBgc: {
			type: String,
			'default': '#fff'
		},
		// 是否支持跨域
		withCredentials: {
			type: Boolean,
			'default': false
		},
		method: {
			type: String,
			'default': 'POST'
		}
	},
	data: function data() {
		var that = this,
		    imgFormat = that.imgFormat,
		    langType = that.langType,
		    langExt = that.langExt,
		    width = that.width,
		    height = that.height,
		    isSupported = true,
		    allowImgFormat = ['jpg', 'png'],
		    tempImgFormat = allowImgFormat.indexOf(imgFormat) === -1 ? 'jpg' : imgFormat,
		    lang = __WEBPACK_IMPORTED_MODULE_0__utils_language_js__["a" /* default */][langType] ? __WEBPACK_IMPORTED_MODULE_0__utils_language_js__["a" /* default */][langType] : __WEBPACK_IMPORTED_MODULE_0__utils_language_js__["a" /* default */]['en'],
		    mime = __WEBPACK_IMPORTED_MODULE_1__utils_mimes_js__["a" /* default */][tempImgFormat];
		// 规范图片格式
		that.imgFormat = tempImgFormat;

		if (langExt) {
			Object.assign(lang, langExt);
		}
		if (typeof FormData != 'function') {
			isSupported = false;
		}
		return {
			// 图片的mime
			mime: mime,

			// 语言包
			lang: lang,

			// 浏览器是否支持该控件
			isSupported: isSupported,
			// 浏览器是否支持触屏事件
			isSupportTouch: document.hasOwnProperty("ontouchstart"),

			// 步骤
			step: 1, //1选择文件 2剪裁 3上传

			// 上传状态及进度
			loading: 0, //0未开始 1正在 2成功 3错误
			progress: 0,

			// 是否有错误及错误信息
			hasError: false,
			errorMsg: '',

			// 需求图宽高比
			ratio: width / height,

			// 原图地址、生成图片地址
			sourceImg: null,
			sourceImgUrl: '',
			createImgUrl: '',

			// 原图片拖动事件初始值
			sourceImgMouseDown: {
				on: false,
				mX: 0, //鼠标按下的坐标
				mY: 0,
				x: 0, //scale原图坐标
				y: 0
			},

			// 生成图片预览的容器大小
			previewContainer: {
				width: 100,
				height: 100
			},

			// 原图容器宽高
			sourceImgContainer: { // sic
				width: 240,
				height: 184 // 如果生成图比例与此一致会出现bug，先改成特殊的格式吧，哈哈哈
			},

			// 原图展示属性
			scale: {
				zoomAddOn: false, //按钮缩放事件开启
				zoomSubOn: false, //按钮缩放事件开启
				range: 1, //最大100

				x: 0,
				y: 0,
				width: 0,
				height: 0,
				maxWidth: 0,
				maxHeight: 0,
				minWidth: 0, //最宽
				minHeight: 0,
				naturalWidth: 0, //原宽
				naturalHeight: 0
			}
		};
	},

	computed: {
		// 进度条样式
		progressStyle: function progressStyle() {
			var progress = this.progress;

			return {
				width: progress + '%'
			};
		},

		// 原图样式
		sourceImgStyle: function sourceImgStyle() {
			var scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    top = scale.y + sourceImgMasking.y + 'px',
			    left = scale.x + sourceImgMasking.x + 'px';

			return {
				top: top,
				left: left,
				width: scale.width + 'px',
				height: scale.height + 'px' // 兼容 Opera
			};
		},

		// 原图蒙版属性
		sourceImgMasking: function sourceImgMasking() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sicRatio = sic.width / sic.height,
			    x = 0,
			    y = 0,
			    w = sic.width,
			    h = sic.height,
			    scale = 1;

			if (ratio < sicRatio) {
				scale = sic.height / height;
				w = sic.height * ratio;
				x = (sic.width - w) / 2;
			}
			if (ratio > sicRatio) {
				scale = sic.width / width;
				h = sic.width / ratio;
				y = (sic.height - h) / 2;
			}
			return {
				scale: scale, // 蒙版相对需求宽高的缩放
				x: x,
				y: y,
				width: w,
				height: h
			};
		},

		// 原图遮罩样式
		sourceImgShadeStyle: function sourceImgShadeStyle() {
			var sourceImgMasking = this.sourceImgMasking,
			    sourceImgContainer = this.sourceImgContainer,
			    sic = sourceImgContainer,
			    sim = sourceImgMasking,
			    w = sim.width == sic.width ? sim.width : (sic.width - sim.width) / 2,
			    h = sim.height == sic.height ? sim.height : (sic.height - sim.height) / 2;

			return {
				width: w + 'px',
				height: h + 'px'
			};
		},
		previewStyle: function previewStyle() {
			var width = this.width,
			    height = this.height,
			    ratio = this.ratio,
			    previewContainer = this.previewContainer,
			    pc = previewContainer,
			    w = pc.width,
			    h = pc.height,
			    pcRatio = w / h;

			if (ratio < pcRatio) {
				w = pc.height * ratio;
			}
			if (ratio > pcRatio) {
				h = pc.width / ratio;
			}
			return {
				width: w + 'px',
				height: h + 'px'
			};
		}
	},
	watch: {
		value: function value(newValue) {
			if (newValue && this.loading != 1) {
				this.reset();
			}
		}
	},
	methods: {
		// 点击波纹效果
		ripple: function ripple(e) {
			Object(__WEBPACK_IMPORTED_MODULE_3__utils_effectRipple_js__["a" /* default */])(e);
		},

		// 关闭控件
		off: function off() {
			var _this = this;

			setTimeout(function () {
				_this.$emit('input', false);
				if (_this.step == 3 && _this.loading == 2) {
					_this.setStep(1);
				}
			}, 200);
		},

		// 设置步骤
		setStep: function setStep(no) {
			var _this2 = this;

			// 延时是为了显示动画效果呢，哈哈哈
			setTimeout(function () {
				_this2.step = no;
			}, 200);
		},


		/* 图片选择区域函数绑定
   ---------------------------------------------------------------*/
		preventDefault: function preventDefault(e) {
			e.preventDefault();
			return false;
		},
		handleClick: function handleClick(e) {
			if (this.loading !== 1) {
				if (e.target !== this.$refs.fileinput) {
					e.preventDefault();
					if (document.activeElement !== this.$refs) {
						this.$refs.fileinput.click();
					}
				}
			}
		},
		handleChange: function handleChange(e) {
			e.preventDefault();
			if (this.loading !== 1) {
				var files = e.target.files || e.dataTransfer.files;
				this.reset();
				if (this.checkFile(files[0])) {
					this.setSourceImg(files[0]);
				}
			}
		},

		/* ---------------------------------------------------------------*/

		// 检测选择的文件是否合适
		checkFile: function checkFile(file) {
			var that = this,
			    lang = that.lang,
			    maxSize = that.maxSize;
			// 仅限图片
			if (file.type.indexOf('image') === -1) {
				that.hasError = true;
				that.errorMsg = lang.error.onlyImg;
				return false;
			}

			// 超出大小
			if (file.size / 1024 > maxSize) {
				that.hasError = true;
				that.errorMsg = lang.error.outOfSize + maxSize + 'kb';
				return false;
			}
			return true;
		},

		// 重置控件
		reset: function reset() {
			var that = this;
			that.loading = 0;
			that.hasError = false;
			that.errorMsg = '';
			that.progress = 0;
		},

		// 设置图片源
		setSourceImg: function setSourceImg(file) {
			this.$emit('src-file-set', file.name, file.type, file.size);
			var that = this,
			    fr = new FileReader();
			fr.onload = function (e) {
				that.sourceImgUrl = fr.result;
				that.startCrop();
			};
			fr.readAsDataURL(file);
		},

		// 剪裁前准备工作
		startCrop: function startCrop() {
			var that = this,
			    width = that.width,
			    height = that.height,
			    ratio = that.ratio,
			    scale = that.scale,
			    sourceImgUrl = that.sourceImgUrl,
			    sourceImgMasking = that.sourceImgMasking,
			    lang = that.lang,
			    sim = sourceImgMasking,
			    img = new Image();

			img.src = sourceImgUrl;
			img.onload = function () {
				var nWidth = img.naturalWidth,
				    nHeight = img.naturalHeight,
				    nRatio = nWidth / nHeight,
				    w = sim.width,
				    h = sim.height,
				    x = 0,
				    y = 0;
				// 图片像素不达标
				if (nWidth < width || nHeight < height) {
					that.hasError = true;
					that.errorMsg = lang.error.lowestPx + width + '*' + height;
					return false;
				}
				if (ratio > nRatio) {
					h = w / nRatio;
					y = (sim.height - h) / 2;
				}
				if (ratio < nRatio) {
					w = h * nRatio;
					x = (sim.width - w) / 2;
				}
				scale.range = 0;
				scale.x = x;
				scale.y = y;
				scale.width = w;
				scale.height = h;
				scale.minWidth = w;
				scale.minHeight = h;
				scale.maxWidth = nWidth * sim.scale;
				scale.maxHeight = nHeight * sim.scale;
				scale.naturalWidth = nWidth;
				scale.naturalHeight = nHeight;
				that.sourceImg = img;
				that.createImg();
				that.setStep(2);
			};
		},

		// 鼠标按下图片准备移动
		imgStartMove: function imgStartMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    simd = sourceImgMouseDown;

			simd.mX = et.screenX;
			simd.mY = et.screenY;
			simd.x = scale.x;
			simd.y = scale.y;
			simd.on = true;
		},

		// 鼠标按下状态下移动，图片移动
		imgMove: function imgMove(e) {
			e.preventDefault();
			// 支持触摸事件，则鼠标事件无效
			if (this.isSupportTouch && !e.targetTouches) {
				return false;
			}
			var et = e.targetTouches ? e.targetTouches[0] : e,
			    _sourceImgMouseDown = this.sourceImgMouseDown,
			    on = _sourceImgMouseDown.on,
			    mX = _sourceImgMouseDown.mX,
			    mY = _sourceImgMouseDown.mY,
			    x = _sourceImgMouseDown.x,
			    y = _sourceImgMouseDown.y,
			    scale = this.scale,
			    sourceImgMasking = this.sourceImgMasking,
			    sim = sourceImgMasking,
			    nX = et.screenX,
			    nY = et.screenY,
			    dX = nX - mX,
			    dY = nY - mY,
			    rX = x + dX,
			    rY = y + dY;

			if (!on) return;
			if (rX > 0) {
				rX = 0;
			}
			if (rY > 0) {
				rY = 0;
			}
			if (rX < sim.width - scale.width) {
				rX = sim.width - scale.width;
			}
			if (rY < sim.height - scale.height) {
				rY = sim.height - scale.height;
			}
			scale.x = rX;
			scale.y = rY;
		},

		// 顺时针旋转图片
		rotateImg: function rotateImg(e) {
			var sourceImg = this.sourceImg,
			    _scale = this.scale,
			    naturalWidth = _scale.naturalWidth,
			    naturalHeight = _scale.naturalHeight,
			    width = naturalHeight,
			    height = naturalWidth,
			    canvas = this.$refs.canvas,
			    ctx = canvas.getContext('2d');

			canvas.width = width;
			canvas.height = height;
			ctx.clearRect(0, 0, width, height);

			ctx.fillStyle = 'rgba(0,0,0,0)';
			ctx.fillRect(0, 0, width, height);

			ctx.translate(width, 0);
			ctx.rotate(Math.PI * 90 / 180);

			ctx.drawImage(sourceImg, 0, 0, naturalWidth, naturalHeight);
			var imgUrl = canvas.toDataURL(__WEBPACK_IMPORTED_MODULE_1__utils_mimes_js__["a" /* default */]['png']);

			this.sourceImgUrl = imgUrl;
			this.startCrop();
		},


		// 按钮按下开始放大
		startZoomAdd: function startZoomAdd(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomAddOn = true;

			function zoom() {
				if (scale.zoomAddOn) {
					var range = scale.range >= 100 ? 100 : ++scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消放大
		endZoomAdd: function endZoomAdd(e) {
			this.scale.zoomAddOn = false;
		},

		// 按钮按下开始缩小
		startZoomSub: function startZoomSub(e) {
			var that = this,
			    scale = that.scale;

			scale.zoomSubOn = true;

			function zoom() {
				if (scale.zoomSubOn) {
					var range = scale.range <= 0 ? 0 : --scale.range;
					that.zoomImg(range);
					setTimeout(function () {
						zoom();
					}, 60);
				}
			}
			zoom();
		},

		// 按钮松开或移开取消缩小
		endZoomSub: function endZoomSub(e) {
			var scale = this.scale;

			scale.zoomSubOn = false;
		},
		zoomChange: function zoomChange(e) {
			this.zoomImg(e.target.value);
		},

		// 缩放原图
		zoomImg: function zoomImg(newRange) {
			var that = this,
			    sourceImgMasking = this.sourceImgMasking,
			    sourceImgMouseDown = this.sourceImgMouseDown,
			    scale = this.scale,
			    maxWidth = scale.maxWidth,
			    maxHeight = scale.maxHeight,
			    minWidth = scale.minWidth,
			    minHeight = scale.minHeight,
			    width = scale.width,
			    height = scale.height,
			    x = scale.x,
			    y = scale.y,
			    range = scale.range,
			    sim = sourceImgMasking,
			    sWidth = sim.width,
			    sHeight = sim.height,
			    nWidth = minWidth + (maxWidth - minWidth) * newRange / 100,
			    nHeight = minHeight + (maxHeight - minHeight) * newRange / 100,
			    nX = sWidth / 2 - nWidth / width * (sWidth / 2 - x),
			    nY = sHeight / 2 - nHeight / height * (sHeight / 2 - y);

			// 判断新坐标是否超过蒙版限制
			if (nX > 0) {
				nX = 0;
			}
			if (nY > 0) {
				nY = 0;
			}
			if (nX < sWidth - nWidth) {
				nX = sWidth - nWidth;
			}
			if (nY < sHeight - nHeight) {
				nY = sHeight - nHeight;
			}

			// 赋值处理
			scale.x = nX;
			scale.y = nY;
			scale.width = nWidth;
			scale.height = nHeight;
			scale.range = newRange;
			setTimeout(function () {
				if (scale.range == newRange) {
					that.createImg();
				}
			}, 300);
		},

		// 生成需求图片
		createImg: function createImg(e) {
			var that = this,
			    imgFormat = that.imgFormat,
			    imgBgc = that.imgBgc,
			    mime = that.mime,
			    sourceImg = that.sourceImg,
			    _that$scale = that.scale,
			    x = _that$scale.x,
			    y = _that$scale.y,
			    width = _that$scale.width,
			    height = _that$scale.height,
			    scale = that.sourceImgMasking.scale,
			    canvas = that.$refs.canvas,
			    ctx = canvas.getContext('2d');

			if (e) {
				// 取消鼠标按下移动状态
				that.sourceImgMouseDown.on = false;
			}
			canvas.width = that.width;
			canvas.height = that.height;
			ctx.clearRect(0, 0, that.width, that.height);

			if (imgFormat == 'png') {
				ctx.fillStyle = 'rgba(0,0,0,0)';
			} else {
				// 如果jpg 为透明区域设置背景，默认白色
				ctx.fillStyle = imgBgc;
			}
			ctx.fillRect(0, 0, that.width, that.height);

			ctx.drawImage(sourceImg, x / scale, y / scale, width / scale, height / scale);
			that.createImgUrl = canvas.toDataURL(mime);
		},
		prepareUpload: function prepareUpload() {
			var url = this.url,
			    createImgUrl = this.createImgUrl,
			    data = this.data,
			    mime = this.mime,
			    field = this.field,
			    ki = this.ki;

			data = Object(__WEBPACK_IMPORTED_MODULE_2__utils_data2blob_js__["a" /* default */])(createImgUrl, mime);
			this.$emit('crop-success', createImgUrl, data, mime, field, ki);
			if (typeof url == 'string' && url) {
				//this.upload();
				this.off();
			} else {
				this.off();
			}
		},

		// 上传图片
		upload: function upload() {
			var that = this,
			    lang = this.lang,
			    imgFormat = this.imgFormat,
			    mime = this.mime,
			    url = this.url,
			    params = this.params,
			    headers = this.headers,
			    field = this.field,
			    ki = this.ki,
			    createImgUrl = this.createImgUrl,
			    withCredentials = this.withCredentials,
			    method = this.method,
			    fmData = new FormData();

			fmData.append(field, Object(__WEBPACK_IMPORTED_MODULE_2__utils_data2blob_js__["a" /* default */])(createImgUrl, mime), field + '.' + imgFormat);

			// 添加其他参数
			if ((typeof params === 'undefined' ? 'undefined' : _typeof(params)) == 'object' && params) {
				Object.keys(params).forEach(function (k) {
					fmData.append(k, params[k]);
				});
			}

			// 监听进度回调
			var uploadProgress = function uploadProgress(event) {
				if (event.lengthComputable) {
					that.progress = 100 * Math.round(event.loaded) / event.total;
				}
			};

			// 上传文件
			that.reset();
			that.loading = 1;
			that.setStep(3);
			new Promise(function (resolve, reject) {
				var client = new XMLHttpRequest();
				client.open(method, url, true);
				client.withCredentials = withCredentials;
				client.onreadystatechange = function () {
					if (this.readyState !== 4) {
						return;
					}
					if (this.status === 200 || this.status === 201) {
						resolve(JSON.parse(this.responseText));
					} else {
						reject(this.status);
					}
				};
				client.upload.addEventListener("progress", uploadProgress, false); //监听进度
				// 设置header
				if ((typeof headers === 'undefined' ? 'undefined' : _typeof(headers)) == 'object' && headers) {
					Object.keys(headers).forEach(function (k) {
						client.setRequestHeader(k, headers[k]);
					});
				}
				client.send(fmData);
			}).then(
			// 上传成功
			function (resData) {
				if (that.value) {
					that.loading = 2;
					that.$emit('crop-upload-success', resData, field, ki);
				}
			},
			// 上传失败
			function (sts) {
				if (that.value) {
					that.loading = 3;
					that.hasError = true;
					that.errorMsg = lang.fail;
					that.$emit('crop-upload-fail', sts, field, ki);
				}
			});
		}
	},
	created: function created() {
		var _this3 = this;

		// 绑定按键esc隐藏此插件事件
		document.addEventListener('keyup', function (e) {
			if (_this3.value && (e.key == 'Escape' || e.keyCode == 27)) {
				_this3.off();
			}
		});
	}
});

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      orderEmpList: 1,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isCheckDeps: false,
      sortableDepTrees: [],
      batchAllowence: {
        allowenceId: null,
        description: "",
        holidayPass: false,
        startDate: null,
        endDate: null,
        allowenceType: 0,
        allowenceTime: "00:00",
        missingTime: "00:00",
        equalTheMissingTime: false
      },
      batchWorkGroup: {
        startDate: null,
        endDate: null,
        workGroupId: 0,
        holidayPass: true,
        description: ""
      },
      batchMovement: {
        startDate: null,
        endDate: null,
        entryTime: "00:00",
        entryPointId: 0,
        entryPointStatus: 1,
        isTwoMovement: false,
        exitTime: "00:00",
        exitPointId: 0,
        exitPointStatus: 2
      },
      isCheckOvertime: false,
      batchOvertime: {
        startDate: null,
        endDate: null
      },
      batchOvertimes: [],
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }],
      batchPayrollStartDate: null,
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      batchInfo: {
        newDepartmentId: 0,
        newStatusId: 0,
        newStateId: 0,
        newFoodGroupId: 0,
        newValidityStartDate: null,
        newValidityEndDate: null
      },
      workPlaces: {
        workPlaceId: 0,
        description: "",
        startDate: null,
        endDate: null
      },
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      workPlaceDefinitions: [],
      allowences: [],
      readers: [],
      searchText: "",
      isLoading: false,
      isLoadingEmployee: false
    };
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    employeeFilteredList: function employeeFilteredList() {
      var _this = this;

      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.sicilNo).localeCompare(_this.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.sicilNo).localeCompare(_this.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.name).localeCompare(_this.turkishToUpper(a.name));
        });
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    batchOvertimeList: function batchOvertimeList() {
      return this.batchOvertimes;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    workPlaceDefinitionList: function workPlaceDefinitionList() {
      return this.workPlaceDefinitions;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    readerList: function readerList() {
      return this.readers;
    },
    dayList: function dayList() {
      return this.days;
    },
    filtered: function filtered() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeFilteredList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 340;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightConfirmOvertimeSize: function windowHeightConfirmOvertimeSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 340;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date(str);
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date(str);
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeEntryDevice: function changeEntryDevice(event) {
      this.batchMovement.entryPointId = event.target.value;
    },
    changeEntryStatus: function changeEntryStatus(event) {
      this.batchMovement.entryPointStatus = event.target.value;
    },
    changeExitDevice: function changeExitDevice(event) {
      this.batchMovement.exitPointId = event.target.value;
    },
    changeExitStatus: function changeExitStatus(event) {
      this.batchMovement.exitPointStatus = event.target.value;
    },
    changeAllowence: function changeAllowence(event) {
      this.batchAllowence.allowenceId = event.target.value;
    },
    changeAllowenceType: function changeAllowenceType(event) {
      this.batchAllowence.allowenceType = event.target.value;
    },
    changeWorkGroup: function changeWorkGroup(event) {
      this.batchWorkGroup.workGroupId = event.target.value;
    },
    changeDepartment: function changeDepartment(event) {
      this.batchInfo.newDepartmentId = event.target.value;
    },
    changeStatu: function changeStatu(event) {
      this.batchInfo.newStatusId = event.target.value;
    },
    changeWorkPlace: function changeWorkPlace(event) {
      this.workPlaces.workPlaceId = event.target.value;
    },
    changeState: function changeState(event) {
      this.batchInfo.newStateId = event.target.value;
    },
    changeFoodGroup: function changeFoodGroup(event) {
      this.batchInfo.newFoodGroupId = event.target.value;
    },
    changeAccessGroup: function changeAccessGroup(event) {
      this.batchInfo.newAccessGroupId = event.target.value;
    },
    checkEmployees: function checkEmployees() {
      var _this4 = this;

      this.isCheck = !this.isCheck;
      var aList = this.employees;
      aList.forEach(function (doc) {
        if (doc.check == !_this4.isCheck) {
          doc.check = _this4.isCheck;
        }
      });
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selectedEmployees, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this5.employees;
                selectedEmployees = aList.filter(function (employee) {
                  return employee.check == true;
                });
                selectedEmployeeList = [];
                _context.next = 5;
                return selectedEmployees.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 5:
                return _context.abrupt("return", selectedEmployeeList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeFilterDepartments: function changeFilterDepartments(event) {
      this.filters.departmentId = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterAccessGroups: function changeFilterAccessGroups(event) {
      this.filters.accessGroup = event.target.value;
    },
    changeFilterFoodGroups: function changeFilterFoodGroups(event) {
      this.filters.foodGroup = event.target.value;
    },
    changeFilterStatus: function changeFilterStatus(event) {
      this.filters.statuId = event.target.value;
    },
    changeFilterStates: function changeFilterStates(event) {
      this.filters.stateId = event.target.value;
    },
    changeFilterWorkGroups: function changeFilterWorkGroups(event) {
      this.filters.workGroupId = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dep.check = checkValue;
                _this6.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this6.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.filters.departments = [];
                _context3.next = 3;
                return _this7.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this8.filters.accessGroup = [];
                _context4.next = 3;
                return _this8.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this9.filters.stateId = [];
                _context5.next = 3;
                return _this9.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this10.filters.statuId = [];
                _context6.next = 3;
                return _this10.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this10);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this11.filters.workGroupId = [];
                _context7.next = 3;
                return _this11.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this11);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this12.filters.foodGroup = [];
                _context8.next = 3;
                return _this12.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this12);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this13.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this13.isCheckDeps = !_this13.isCheckDeps;

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this13);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                aList = _this14.sortableDepartmentList;

                _this14.filters.departments = [];
                _context10.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this14.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this14.accessGroupList;

                _this14.filters.accessGroup = [];
                _context10.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this14.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this14.workGroupList;

                _this14.filters.workGroupId = [];
                _context10.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this14.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this14.foodGroupList;

                _this14.filters.foodGroup = [];
                _context10.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this14.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this14.statuList;

                _this14.filters.statuId = [];
                _context10.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this14.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this14.stateList;

                _this14.filters.stateId = [];
                _context10.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this14.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this14);
      }))();
    },
    downloadExcelTemplate: function downloadExcelTemplate() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this15.isLoading = true;
                _context11.next = 4;
                return _this15.$axios.get("/Meal/Template", {
                  responseType: "blob"
                }).then(function (response) {
                  if (response.status == 200) {
                    var data = new Blob([response.data]);
                    var csvUrl = window.URL.createObjectURL(data);
                    var tempLink = document.createElement("a");
                    tempLink.href = csvUrl;
                    var today = new Date().toLocaleString("tr-TR");
                    tempLink.setAttribute("download", "yemekhane_bakiye_sablonu_" + today.replaceAll(".", "_").replaceAll(" ", "_").replaceAll(":", "_") + ".xlsx");
                    tempLink.click();
                  } else {
                    alertify.warning(_this15.$ml.get("alerts.youAreNotAuthorizedForThisAction"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.refreshToken();
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context11.sent;

                _this15.isLoading = false;
                _context11.next = 13;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);
                alertify.error(_context11.t0.message);
                _this15.isLoading = false;

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this15, [[0, 8]]);
      }))();
    },
    uploadExcelTemplate: function uploadExcelTemplate() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var formData, response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_this16.$refs.file.files[0]) {
                  _context12.next = 3;
                  break;
                }

                alertify.warning(_this16.$ml.get("alerts.pleaseSelectFile"));
                return _context12.abrupt("return");

              case 3:
                _context12.prev = 3;

                _this16.isLoading = true;
                formData = new FormData();

                formData.append("file", _this16.$refs.file.files[0]);
                _context12.next = 9;
                return _this16.$axios.post("/Meal/Import", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this16.$ml.get("alerts.transactionSuccessfull"));
                  } else {
                    alertify.warning(_this16.$ml.get("alerts.youAreNotAuthorizedForThisAction"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.refreshToken();
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context12.sent;

                _this16.isLoading = false;
                _context12.next = 18;
                break;

              case 13:
                _context12.prev = 13;
                _context12.t0 = _context12["catch"](3);

                console.error(_context12.t0);
                alertify.error(_context12.t0.message);
                _this16.isLoading = false;

              case 18:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this16, [[3, 13]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                accessGroups = [];
                _context13.next = 4;
                return _this17.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this17.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this17.$ml.get("errors.connectionError"));
                      _this17.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this17.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context13.sent;

                _this17.accessGroups = accessGroups;
                _context13.next = 12;
                break;

              case 8:
                _context13.prev = 8;
                _context13.t0 = _context13["catch"](0);

                console.error(_context13.t0);
                alertify.error("Servis Hatası :" + _context13.t0.message);

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this17, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                departments = [];
                _context14.prev = 1;
                _context14.next = 4;
                return _this18.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this18.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this18.$ml.get("errors.connectionError"));
                      _this18.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this18.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context14.sent;

                _this18.departments = departments;
                _this18.sortableTrees();
                _this18.isLoading = false;
                _context14.next = 14;
                break;

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](1);

                console.error(_context14.t0);
                alertify.error(_context14.t0);

              case 14:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this18, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this19 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this19.sortableDepTrees.push(dep);
          _this19.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this20 = this;

      var departments2 = this.departments;
      var subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          doc2.name = ekle + " " + doc2.name;
          _this20.sortableDepTrees.push(doc2);
          _this20.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                foodGroups = [];
                _context15.next = 4;
                return _this21.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this21.foodGroups = foodGroups;
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası :" + _context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this21, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                status = [];
                _context16.next = 4;
                return _this22.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context16.sent;

                _this22.status = status;
                _context16.next = 12;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası :" + _context16.t0.message);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this22, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                titles = [];
                _context17.next = 4;
                return _this23.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.this.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this23.titles = titles;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this23, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                states = [];
                _context18.next = 4;
                return _this24.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this24.states = states;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this24, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                workGroups = [];
                _context19.next = 4;
                return _this25.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this25.workGroups = workGroups;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this25, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                extrafields = [];
                _context20.next = 4;
                return _this26.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context20.sent;

                _this26.extrafields = extrafields;
                _context20.next = 12;
                break;

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error("Servis Hatası :" + _context20.t0.message);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this26, [[0, 8]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;

                _this27.isLoading = true;
                allowences = [];
                _context21.next = 5;
                return _this27.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context21.sent;

                _this27.allowences = allowences;
                _this27.isLoading = false;
                _context21.next = 15;
                break;

              case 10:
                _context21.prev = 10;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);
                _this27.isLoading = false;

              case 15:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this27, [[0, 10]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this28.isLoadingEmployee = true;
                _context22.next = 4;
                return _this28.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this28.filters;
                _context22.next = 8;
                return _this28.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context22.sent;

                _this28.employees = employees;
                _this28.isLoadingEmployee = false;
                _context22.next = 18;
                break;

              case 13:
                _context22.prev = 13;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);
                _this28.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this28, [[0, 13]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                readers = [];
                _context23.next = 4;
                return _this29.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          name: doc.name,
                          check: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this29.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this29.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context23.sent;

                _this29.readers = readers;
                _context23.next = 12;
                break;

              case 8:
                _context23.prev = 8;
                _context23.t0 = _context23["catch"](0);

                console.error(_context23.t0);
                alertify.error("Servis Hatası : " + _context23.t0.message);

              case 12:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this29, [[0, 8]]);
      }))();
    },
    setBatchAllowence: function setBatchAllowence() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var days, empIds, batchAllowence1, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (!(_this30.batchAllowence.allowenceId == null)) {
                  _context24.next = 3;
                  break;
                }

                alertify.warning(_this30.$ml.get("alerts.allowenceNotSelected"));
                return _context24.abrupt("return");

              case 3:
                _context24.prev = 3;

                _this30.isLoading = true;
                _context24.next = 7;
                return _this30.selectedDays();

              case 7:
                days = _context24.sent;
                _context24.next = 10;
                return _this30.getSelectedEmployeeList();

              case 10:
                empIds = _context24.sent;
                batchAllowence1 = _this30.batchAllowence;
                _context24.next = 14;
                return _this30.$axios.post("/BatchOperations/BatchAllowence", {
                  empIds: empIds,
                  days: days,
                  allowenceId: batchAllowence1.allowenceId,
                  description: batchAllowence1.description,
                  holidayPass: batchAllowence1.holidayPass,
                  startDate: batchAllowence1.startDate,
                  endDate: batchAllowence1.endDate,
                  allowenceType: batchAllowence1.allowenceType,
                  allowenceTime: batchAllowence1.allowenceTime,
                  equalTheMissingTime: batchAllowence1.equalTheMissingTime,
                  missingTime: batchAllowence1.missingTime
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this30.$ml.get("batchOperations.batchAllowencesSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context24.sent;

                _this30.isLoading = false;
                _context24.next = 23;
                break;

              case 18:
                _context24.prev = 18;
                _context24.t0 = _context24["catch"](3);

                console.error(_context24.t0);
                alertify.error("Hata :" + _context24.t0.message);
                _this30.isLoading = false;

              case 23:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this30, [[3, 18]]);
      }))();
    },
    selectedDays: function selectedDays() {
      var selectedDays = [];
      var aList = this.days;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    setBatchMovement: function setBatchMovement() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var days, empIds, exit, batchMovement, response;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(_this31.batchMovement.startDate == null || _this31.batchMovement.endDate == null || _this31.batchMovement.startDate > _this31.batchMovement.endDate)) {
                  _context25.next = 3;
                  break;
                }

                alertify.warning(_this31.$ml.get("alerts.invalidDate"));
                return _context25.abrupt("return");

              case 3:
                _context25.prev = 3;

                _this31.isLoading = true;
                _context25.next = 7;
                return _this31.selectedDays();

              case 7:
                days = _context25.sent;
                _context25.next = 10;
                return _this31.getSelectedEmployeeList();

              case 10:
                empIds = _context25.sent;
                exit = _this31.batchMovement.isTwoMovement == false ? null : _this31.batchMovement.exitTime;
                batchMovement = _this31.batchMovement;
                _context25.next = 15;
                return _this31.$axios.post("/BatchOperations/BatchMovement", {
                  empIds: empIds,
                  days: days,
                  entryTime: batchMovement.entryTime,
                  exitTime: exit,
                  startDate: batchMovement.startDate,
                  endDate: batchMovement.endDate,
                  entryPointId: batchMovement.entryPointId,
                  entryPointStatus: batchMovement.entryPointStatus,
                  exitPointId: batchMovement.exitPointId,
                  exitPointStatus: batchMovement.exitPointStatus
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this31.$ml.get("batchOperations.batchMovementSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoading = false;
                      return;
                    }
                  }
                });

              case 15:
                response = _context25.sent;

                _this31.isLoading = false;
                _context25.next = 24;
                break;

              case 19:
                _context25.prev = 19;
                _context25.t0 = _context25["catch"](3);

                console.error(_context25.t0);
                alertify.error("Hata :" + _context25.t0.message);
                _this31.isLoading = false;

              case 24:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this31, [[3, 19]]);
      }))();
    },
    setBatchWorkGroup: function setBatchWorkGroup() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var empIds, batchWorkGroup, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (!(_this32.batchWorkGroup.startDate == null || _this32.batchWorkGroup.endDate == null || _this32.batchWorkGroup.startDate > _this32.batchWorkGroup.endDate)) {
                  _context26.next = 3;
                  break;
                }

                alertify.warning(_this32.$ml.get("alerts.invalidDate"));
                return _context26.abrupt("return");

              case 3:
                _context26.prev = 3;

                _this32.isLoading = true;
                _context26.next = 7;
                return _this32.getSelectedEmployeeList();

              case 7:
                empIds = _context26.sent;
                batchWorkGroup = _this32.batchWorkGroup;
                _context26.next = 11;
                return _this32.$axios.post("/BatchOperations/BatchWorkGroupChange", {
                  empIds: empIds,
                  startDate: batchWorkGroup.startDate,
                  endDate: batchWorkGroup.endDate,
                  workGroupId: batchWorkGroup.workGroupId,
                  holidayPass: batchWorkGroup.holidayPass,
                  description: batchWorkGroup.description
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this32.$ml.get("batchOperations.batchWorkPlanUpdateSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoading = false;
                      return;
                    }
                  }
                });

              case 11:
                response = _context26.sent;

                _this32.isLoading = false;
                _context26.next = 20;
                break;

              case 15:
                _context26.prev = 15;
                _context26.t0 = _context26["catch"](3);

                console.error(_context26.t0);
                alertify.error("Hata :" + _context26.t0.message);
                _this32.isLoading = false;

              case 20:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this32, [[3, 15]]);
      }))();
    },
    setBatchWorkPlace: function setBatchWorkPlace() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var empIds, data, response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!(_this33.workPlaces.workPlaceId == null)) {
                  _context27.next = 3;
                  break;
                }

                alertify.warning(_this33.$ml.get("alerts.pleaseSelect"));
                return _context27.abrupt("return");

              case 3:
                if (!(_this33.workPlaces.startDate == null || _this33.workPlaces.endDate == null || _this33.workPlaces.startDate > _this33.workPlaces.endDate)) {
                  _context27.next = 6;
                  break;
                }

                alertify.warning(_this33.$ml.get("alerts.invalidDate"));
                return _context27.abrupt("return");

              case 6:
                _context27.prev = 6;

                _this33.isLoading = true;
                _context27.next = 10;
                return _this33.getSelectedEmployeeList();

              case 10:
                empIds = _context27.sent;
                data = [];

                empIds.forEach(function (emp) {
                  data.push({
                    employeeId: emp,
                    workPlaceId: _this33.workPlaces.workPlaceId,
                    startDate: _this33.workPlaces.startDate,
                    endDate: _this33.workPlaces.endDate,
                    description: _this33.workPlaces.description
                  });
                });
                _context27.next = 15;
                return _this33.$axios.post("/EmployeeWorkPlace/BulkAdd", data).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this33.$ml.get("batchOperations.batchInformationUpdateSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoading = false;
                      return;
                    }
                  }
                });

              case 15:
                response = _context27.sent;

                _this33.isLoading = false;
                _context27.next = 24;
                break;

              case 19:
                _context27.prev = 19;
                _context27.t0 = _context27["catch"](6);

                console.error(_context27.t0);
                alertify.error("Hata :" + _context27.t0.message);
                _this33.isLoading = false;

              case 24:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this33, [[6, 19]]);
      }))();
    },
    setBatchPayroll: function setBatchPayroll() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var empIds, batchPayrollStartDate, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                if (!(_this34.batchPayrollStartDate == null)) {
                  _context28.next = 3;
                  break;
                }

                alertify.warning(_this34.$ml.get("alerts.invalidDate"));
                return _context28.abrupt("return");

              case 3:
                _context28.prev = 3;

                _this34.isLoading = true;
                _context28.next = 7;
                return _this34.getSelectedEmployeeList();

              case 7:
                empIds = _context28.sent;
                batchPayrollStartDate = _this34.batchPayrollStartDate;
                _context28.next = 11;
                return _this34.$axios.post("/BatchOperations/BatchPayroll", {
                  empIds: empIds,
                  date: batchPayrollStartDate,
                  includePassiveMovements: _this34.includePassiveMovements,
                  doNotDeleteOvertimes: _this34.doNotDeleteOvertimes
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this34.$ml.get("alerts.payrollOfTheEmployeesWasRecalculated"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this34.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this34.isLoading = false;
                      return;
                    }
                  }
                });

              case 11:
                response = _context28.sent;

                _this34.isLoading = false;
                _context28.next = 20;
                break;

              case 15:
                _context28.prev = 15;
                _context28.t0 = _context28["catch"](3);

                console.error(_context28.t0);
                alertify.error("Hata :" + _context28.t0.message);
                _this34.isLoading = false;

              case 20:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this34, [[3, 15]]);
      }))();
    },
    setBatchInformation: function setBatchInformation() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var empIds, batchInfo, response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;

                _this35.isLoading = true;
                _context29.next = 4;
                return _this35.getSelectedEmployeeList();

              case 4:
                empIds = _context29.sent;
                batchInfo = _this35.batchInfo;
                _context29.next = 8;
                return _this35.$axios.post("/BatchOperations/BatchInformationChange", {
                  empIds: empIds,
                  newDepartmentId: batchInfo.newDepartmentId,
                  newStateId: batchInfo.newStateId,
                  newStatusId: batchInfo.newStatusId,
                  newFoodGroupId: batchInfo.newFoodGroupId,
                  newAccessGroupId: batchInfo.newAccessGroupId,
                  newValidityStartDate: batchInfo.newValidityStartDate,
                  newValidityEndDate: batchInfo.newValidityEndDate
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this35.$ml.get("batchOperations.batchInformationUpdateSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context29.sent;

                _this35.isLoading = false;
                _context29.next = 17;
                break;

              case 12:
                _context29.prev = 12;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error("Hata :" + _context29.t0.message);
                _this35.isLoading = false;

              case 17:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this35, [[0, 12]]);
      }))();
    },
    checkAllOvertime: function checkAllOvertime() {
      if (this.isCheckOvertime == true) {
        this.batchOvertimes.forEach(function (over) {
          over.check = false;
        });
      } else {
        this.batchOvertimes.forEach(function (over) {
          over.check = true;
        });
      }
      this.isCheckOvertime = !this.isCheckOvertime;
    },
    overtimeStyleControl: function overtimeStyleControl(calculated, confirmed) {
      if (calculated && confirmed) {
        var hesaplanan = new Date("1900-01-01T" + calculated);
        var onaylanan = new Date("1900-01-01T" + confirmed);
        if (onaylanan > hesaplanan) {
          return "border-color:#dd4b39;";
        } else {
          return "";
        }
      }
    },
    overtimeControl: function overtimeControl(calculated, confirmed, name, date) {
      if (calculated && confirmed) {
        var hesaplanan = new Date("1900-01-01T" + calculated);
        var onaylanan = new Date("1900-01-01T" + confirmed);
        if (onaylanan > hesaplanan) {
          var tarih = this.toDateFormat(date, "gg.aa.yyyy");
          alertify.error(this.$ml.get("alerts.confirmedOvertimeCannotBeGreaterThanCalculated") + " : " + name + " - " + tarih);
        } else {}
      }
    },
    prepareBatchOverTime: function prepareBatchOverTime() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var list, key;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                list = [];
                key = true;
                _context30.next = 4;
                return _this36.batchOvertimeList.forEach(function (overtime) {
                  if (overtime.check == true) {
                    var onaylanan = new Date("1900-01-01T" + overtime.confirmed);
                    var hesaplanan = new Date("1900-01-01T" + overtime.confirmed);
                    if (onaylanan > hesaplanan) {
                      alertify.error(_this36.$ml.get("alerts.checkConfirmedTimes"));
                      key = false;
                    } else {
                      list.push({
                        overTimeId: overtime.overTimeId,
                        confirmedTime: overtime.confirmed
                      });
                    }
                  }
                });

              case 4:
                return _context30.abrupt("return", { list: list, key: key });

              case 5:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this36);
      }))();
    },
    setBatchOvertime: function setBatchOvertime() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        var veri, response;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;

                _this37.isLoading = true;
                _context31.next = 4;
                return _this37.prepareBatchOverTime();

              case 4:
                veri = _context31.sent;

                if (!(veri.list.length > 0 && veri.key == true)) {
                  _context31.next = 12;
                  break;
                }

                console.log(veri.list);
                _context31.next = 9;
                return _this37.$axios.post("/BatchOperations/BatchConfirmOvertimes", veri.list).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this37.$ml.get("alerts.confirmationOvertimeSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this37.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this37.$ml.get("errors.connectionError"));
                      _this37.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this37.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context31.sent;
                _context31.next = 13;
                break;

              case 12:
                alertify.warning(_this37.$ml.get("alerts.selectedRecordNotFound"));

              case 13:
                _this37.isLoading = false;
                _context31.next = 21;
                break;

              case 16:
                _context31.prev = 16;
                _context31.t0 = _context31["catch"](0);

                console.error(_context31.t0);
                alertify.error("Servis Hatası :" + _context31.t0.message);
                _this37.isLoading = false;

              case 21:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this37, [[0, 16]]);
      }))();
    },
    getBatchOvertimes: function getBatchOvertimes() {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
        var empIds, batchOvertimes, response;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (!(_this38.batchOvertime.startDate == null || _this38.batchOvertime.endDate == null || _this38.batchOvertime.startDate > _this38.batchOvertime.endDate)) {
                  _context32.next = 3;
                  break;
                }

                alertify.warning(_this38.$ml.get("alerts.invalidDate"));
                return _context32.abrupt("return");

              case 3:
                _context32.prev = 3;

                _this38.isLoading = true;
                _context32.next = 7;
                return _this38.getSelectedEmployeeList();

              case 7:
                empIds = _context32.sent;
                batchOvertimes = [];
                _context32.next = 11;
                return _this38.$axios.post("/BatchOperations/GetBatchOvertimes", {
                  empIds: empIds,
                  startDate: _this38.batchOvertime.startDate,
                  endDate: _this38.batchOvertime.endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    var confirmed = _this38.toDateFormat(doc.confirmed, "ss:dd");
                    var calculated = _this38.toDateFormat(doc.calculated, "ss:dd");
                    batchOvertimes.push({
                      sicilNo: doc.sicilNo,
                      name: doc.name,
                      date: doc.date,
                      workGroupName: doc.workGroupName,
                      entry: doc.entry,
                      exit: doc.exit,
                      calculated: calculated,
                      confirmed: confirmed,
                      empId: doc.empId,
                      overTimeId: doc.overTimeId,
                      check: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this38.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this38.$ml.get("errors.connectionError"));
                      _this38.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this38.isLoading = false;
                      return;
                    }
                  }
                });

              case 11:
                response = _context32.sent;

                _this38.batchOvertimes = batchOvertimes;
                _this38.isLoading = false;
                _context32.next = 21;
                break;

              case 16:
                _context32.prev = 16;
                _context32.t0 = _context32["catch"](3);

                console.error(_context32.t0);
                alertify.error("Servis Hatası :" + _context32.t0.message);
                _this38.isLoading = false;

              case 21:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, _this38, [[3, 16]]);
      }))();
    },
    getWorkPlaceDefinitions: function getWorkPlaceDefinitions() {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
        var response;
        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                _context33.next = 3;
                return _this39.$axios.get("/WorkPlaceDefinition/GetAll").then(function (response) {
                  _this39.workPlaceDefinitions = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this39.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this39.$ml.get("errors.connectionError"));
                      _this39.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this39.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context33.sent;
                _context33.next = 10;
                break;

              case 6:
                _context33.prev = 6;
                _context33.t0 = _context33["catch"](0);

                console.error(_context33.t0);
                alertify.error("Servis Hatası :" + _context33.t0.message);

              case 10:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, _this39, [[0, 6]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.batchAllowence.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchWorkGroup.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchAllowence.entryTime = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchPayrollStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      this.batchMovement.startDate = yil + "-" + ay + "-" + gun;
      this.batchOvertime.startDate = yil + "-" + ay + "-" + gun;
      this.batchAllowence.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      this.batchWorkGroup.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      this.batchMovement.endDate = yil + "-" + ay + "-" + gun;
      this.batchOvertime.endDate = yil + "-" + ay + "-" + gun;
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        filter.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(function (doc) {
        filter.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        filter.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        filter.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        filter.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        filter.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getAuthControl: function getAuthControl() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
        return regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                if (_this40.authControl == 1) {
                  alertify.warning(_this40.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, _this40);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this41 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
      var filter;
      return regeneratorRuntime.wrap(function _callee35$(_context35) {
        while (1) {
          switch (_context35.prev = _context35.next) {
            case 0:
              _context35.next = 2;
              return _this41.getAuthControl();

            case 2:
              _context35.next = 4;
              return _this41.getDefaultDate();

            case 4:
              _context35.next = 6;
              return _this41.getDepartments();

            case 6:
              _context35.next = 8;
              return _this41.getAccessGroups();

            case 8:
              _context35.next = 10;
              return _this41.getFoodGroups();

            case 10:
              _context35.next = 12;
              return _this41.getStatus();

            case 12:
              _context35.next = 14;
              return _this41.getStates();

            case 14:
              _context35.next = 16;
              return _this41.getTitles();

            case 16:
              _context35.next = 18;
              return _this41.getWorkGroups();

            case 18:
              _context35.next = 20;
              return _this41.getExtraFields();

            case 20:
              _context35.next = 22;
              return _this41.getAllowences();

            case 22:
              _context35.next = 24;
              return _this41.getReaders();

            case 24:
              _context35.next = 26;
              return _this41.getWorkPlaceDefinitions();

            case 26:
              if (!_this41.defaultFilters) {
                _context35.next = 31;
                break;
              }

              filter = _this41.defaultFilters;

              _this41.setUserAuthorityFilter(filter);
              _context35.next = 31;
              return _this41.getEmployees();

            case 31:
            case "end":
              return _context35.stop();
          }
        }
      }, _callee35, _this41);
    }))();
  }
});

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      isCheckVG: true,
      visitorGroups: [],
      isCheckAllowences: true,
      allowences: [],
      isCheckReaders: true,
      readers: [],
      startDate: null,
      endDate: null,
      selectedReportId: 0,
      selectedReportEndPoint: "",
      selectedReportName: "",
      selectedDevices: [],
      selectedAllowences: [],
      selectedVisitorGroups: [],
      reportOptions: {
        showAllowed: true,
        showNonComers: true,
        showLateComers: false,
        isUpperFromTime: false,
        time: 45
      },
      reportDatas: null,
      reportHeaders: null,
      reportResult: [],
      reportName: "",
      searchText: "",
      activeReports: [],
      reports: [
      //max index:35, max id:36
      {
        id: 32,
        name: this.$ml.get("reports.reports.SaleReport"),
        endPoint: "SaleReport",
        isActive: false,
        index: 31,
        module: this.$store.getters.getModules.retailSale
      }, {
        id: 33,
        name: this.$ml.get("reports.reports.DetailedVisitorReport"),
        endPoint: "VisitorDetailedReport",
        isActive: false,
        index: 30,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 34,
        name: this.$ml.get("reports.reports.DepartmentBasedVisitorReport"),
        endPoint: "DepartmentBasedVisitorReport",
        isActive: false,
        index: 33,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 31,
        name: this.$ml.get("reports.reports.EntryExitSnapshotReport"),
        endPoint: "EntryExitSnapshotReport",
        isActive: false,
        index: 32,
        module: true
      }, {
        id: 1,
        name: this.$ml.get("reports.reports.LaterComersReport"),
        endPoint: "LaterComersReport",
        isActive: false,
        index: 2,
        module: true
      }, {
        id: 2,
        name: this.$ml.get("reports.reports.DetailedInOutReport"),
        endPoint: "DetailedInOutReport",
        isActive: false,
        index: 8,
        module: true
      }, {
        id: 3,
        name: this.$ml.get("reports.reports.FoodReport"),
        endPoint: "FoodReport",
        isActive: false,
        index: 22,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 4,
        name: this.$ml.get("reports.reports.FoodDebtReport"),
        endPoint: "FoodDebtReport",
        isActive: false,
        index: 23,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 5,
        name: this.$ml.get("reports.reports.EmployeesReport"),
        endPoint: "EmployeesReport",
        isActive: false,
        index: 0,
        module: true
      }, {
        id: 6,
        name: this.$ml.get("reports.reports.InsidesReport"),
        endPoint: "InsidesReport",
        isActive: false,
        index: 4,
        module: true
      }, {
        id: 7,
        name: this.$ml.get("reports.reports.OutsidesReport"),
        endPoint: "OutsidesReport",
        isActive: false,
        index: 5,
        module: true
      }, {
        id: 8,
        name: this.$ml.get("reports.reports.VisitorsReport"),
        endPoint: "VisitorsReport",
        isActive: false,
        index: 20,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 9,
        name: this.$ml.get("reports.reports.InsideVisitorsReport"),
        endPoint: "InsideVisitorsReport",
        isActive: false,
        index: 21,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 10,
        name: this.$ml.get("reports.reports.TimeBasedWorkReport"),
        endPoint: "TimeBasedWorkReport",
        isActive: false,
        index: 10,
        module: true
      }, {
        id: 11,
        name: this.$ml.get("reports.reports.FirstInLastOutReport"),
        endPoint: "FirstInLastOutReport",
        isActive: false,
        index: 9,
        module: true
      }, {
        id: 12,
        name: this.$ml.get("reports.reports.AllowenceReport"),
        endPoint: "AllowenceReport",
        isActive: false,
        index: 3,
        module: true
      }, {
        id: 13,
        name: this.$ml.get("reports.reports.WorkSummaryReport"),
        endPoint: "WorkSummaryReport",
        isActive: false,
        index: 11,
        module: true
      }, {
        id: 14,
        name: this.$ml.get("reports.reports.CompanyEmployeesStatusReport"),
        endPoint: "CompanyEmployeesStatusReport",
        isActive: false,
        index: 12,
        module: true
      }, {
        id: 15,
        name: this.$ml.get("reports.reports.CustomCompanyEmployeesStatusReport"),
        endPoint: "CustomCompanyEmployeesStatusReport",
        isActive: false,
        index: 13,
        module: true
      }, {
        id: 16,
        name: this.$ml.get("reports.reports.PayrollReport"),
        endPoint: "PayrollReport",
        isActive: false,
        index: 14,
        module: true
      }, {
        id: 17,
        name: this.$ml.get("reports.reports.DetailedPayrollReport"),
        endPoint: "DetailedPayrollReport",
        isActive: false,
        index: 15,
        module: true
      }, {
        id: 29,
        name: this.$ml.get("reports.reports.WeeklyPayrollReport"),
        endPoint: "WeeklyPayrollReport",
        isActive: false,
        index: 15,
        module: true
      }, {
        id: 26,
        name: this.$ml.get("reports.reports.TemplatePayrollReport"),
        endPoint: "TemplatePayrollReport",
        isActive: false,
        index: 16,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 27,
        name: this.$ml.get("reports.reports.TemplateMonthlyPayrollReport"),
        endPoint: "TemplateMonthlyPayrollReport",
        isActive: false,
        index: 17,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 28,
        name: this.$ml.get("reports.reports.SalaryReport"),
        endPoint: "SalaryReport",
        isActive: false,
        index: 18,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 30,
        name: this.$ml.get("reports.reports.DepartmentSummaryReport"),
        endPoint: "DepartmentSummaryReport",
        isActive: false,
        index: 19,
        module: true
      }, {
        id: 18,
        name: this.$ml.get("reports.reports.FoodCreditReport"),
        endPoint: "FoodCreditReport",
        isActive: false,
        index: 24,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 19,
        name: this.$ml.get("reports.reports.InOutReport"),
        endPoint: "InOutReport",
        isActive: false,
        index: 7,
        module: true
      }, {
        id: 20,
        name: this.$ml.get("reports.reports.DoorBasedLastMovementReport"),
        endPoint: "DoorBasedLastMovementReport",
        isActive: false,
        index: 6,
        module: true
      }, {
        id: 21,
        name: this.$ml.get("reports.reports.DoorsAuthorizationReport"),
        endPoint: "DoorsAuthorizationReport",
        isActive: false,
        index: 1,
        module: true
      }, {
        id: 22,
        name: this.$ml.get("reports.reports.DormitoryInformationReport"),
        endPoint: "DormitoryInformationReport",
        isActive: false,
        index: 26,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 23,
        name: this.$ml.get("reports.reports.DormitoryInsidesReport"),
        endPoint: "DormitoryInsidesReport",
        isActive: false,
        index: 27,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 24,
        name: this.$ml.get("reports.reports.DormitoryOutsidesReport"),
        endPoint: "DormitoryOutsidesReport",
        isActive: false,
        index: 28,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 25,
        name: this.$ml.get("reports.reports.FoodSummaryReport"),
        endPoint: "FoodSummaryReport",
        isActive: false,
        index: 29,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 35,
        name: this.$ml.get("reports.reports.ShiftReport"),
        endPoint: "ShiftReport",
        isActive: false,
        index: 34,
        module: true
      }, {
        id: 36,
        name: this.$ml.get("reports.reports.VerticalFirstInLastOutReport"),
        endPoint: "VerticalFirstInLastOutReport",
        isActive: false,
        index: 35,
        module: true
      }]
    };
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthRaporlar;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList: function employeeFilteredList() {
      var _this = this;

      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.sicilNo).localeCompare(_this.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.sicilNo).localeCompare(_this.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.name).localeCompare(_this.turkishToUpper(a.name));
        });
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    statuList: function statuList() {
      return this.status;
    },
    visitorGroupList: function visitorGroupList() {
      return this.visitorGroups;
    },
    readerList: function readerList() {
      return this.readers.sort(function (a, b) {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    reportList: function reportList() {
      var list = this.reports.filter(function (item) {
        return item.isActive == true && item.module == true;
      });
      if (list) {
        return list.sort(function (a, b) {
          if (a.index < b.index) return -1;
          if (a.index > b.index) return 0;
        });
      }
    },
    reportDataList: function reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList: function reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    filtered: function filtered() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeFilteredList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeInOutListDoorType: function changeInOutListDoorType(event) {
      var _this4 = this;

      this.selectedDoorType = event.target.value;
      this.readerList.forEach(function (a) {
        if (_this4.selectedDoorType == 4) {
          a.check = true;
        } else {
          if (a.doorType == _this4.selectedDoorType) {
            a.check = true;
          } else {
            a.check = false;
          }
        }
      });
      this.isCheckReaders = true;
    },
    customReportStyle: function customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (value == "Geç Kaldı" || value == "Hafta Tatili" || value == "Cumartesi Hakedişi") {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (key == "name" && value == "Toplam" || key == "date" && value == "Toplam") {
        return "text-bold h5";
      } else if (key == "unitName") {
        return "text-bold";
      } else if (key == "employeesInDepartments" || key == "continuedEmployee" || key == "annualPermit" || key == "report" || key == "missioned" || key == "administrativeLeave" || key == "nonComers" || key == "todayComers" || key == "freePermission") {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (key == "employeesInDepartments" || key == "annualPermit" || key == "report" || key == "administrativeLeave" || key == "freePermission" || key == "missioned" || key == "nonComers" || key == "todayComers" || key == "d1" || key == "d2" || key == "d3" || key == "d4" || key == "d5" || key == "d6" || key == "d7" || key == "d8" || key == "d9" || key == "d10" || key == "d11" || key == "d12" || key == "d13" || key == "d14" || key == "d15" || key == "d16" || key == "d17" || key == "d18" || key == "d19" || key == "d20" || key == "d21" || key == "d22" || key == "d23" || key == "d24" || key == "d25" || key == "d26" || key == "d27" || key == "d28" || key == "d29" || key == "d30" || key == "d31") {
        return "text-center";
      } else if (key == "shortCode1" || key == "shortCode2" || key == "shortCode3" || key == "shortCode4" || key == "shortCode5" || key == "shortCode6" || key == "shortCode7" || key == "shortCode8" || key == "shortCode9" || key == "shortCode10" || key == "shortCode11" || key == "shortCode12" || key == "shortCode13" || key == "shortCode14" || key == "shortCode15" || key == "shortCode16" || key == "shortCode17" || key == "shortCode18" || key == "shortCode19" || key == "shortCode20" || key == "shortCode21" || key == "shortCode22" || key == "shortCode23" || key == "shortCode24" || key == "shortCode25" || key == "shortCode26" || key == "shortCode27" || key == "shortCode28" || key == "shortCode29" || key == "shortCode30" || key == "shortCode31") {
        return "text-center";
      }
    },
    checkEmployees: function checkEmployees() {
      var _this5 = this;

      this.isCheck = !this.isCheck;
      var aList = this.employees;
      aList.forEach(function (doc) {
        if (doc.check == !_this5.isCheck) {
          doc.check = _this5.isCheck;
        }
      });
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selectedEmployees, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this6.employees;
                selectedEmployees = aList.filter(function (employee) {
                  return employee.check == true;
                });
                selectedEmployeeList = [];
                _context.next = 5;
                return selectedEmployees.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 5:
                return _context.abrupt("return", selectedEmployeeList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeSelectedReport: function changeSelectedReport(event) {
      this.selectedReportId = event.target.value;
      var report = this.reportList.filter(function (item) {
        return item.id == event.target.value;
      });
      if (report) {
        this.selectedReportEndPoint = report[0].endPoint;
        this.selectedReportName = report[0].name;
      }
    },
    changeIsUpperFromTime: function changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getAccessGroups: function getAccessGroups() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accessGroups = [];
                _context2.next = 4;
                return _this7.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this7.accessGroups = accessGroups;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                departments = [];
                _context3.prev = 1;
                _context3.next = 4;
                return _this8.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this8.departments = departments;
                _this8.sortableTrees();
                _this8.isLoading = false;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                alertify.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this9 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this9.sortableDepTrees.push(dep);
          _this9.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this10 = this;

      var departments2 = this.departments;
      var subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          doc2.name = ekle + " " + doc2.name;
          _this10.sortableDepTrees.push(doc2);
          _this10.subDepImport(doc2);
        });
      }
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dep.check = checkValue;
                _this11.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this11.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this11);
      }))();
    },
    changeFilterDep2: function changeFilterDep2(dep, checkValue) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dep.check = checkValue;
                _this12.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    //this.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this12);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this13.filters.departments = [];
                _context6.next = 3;
                return _this13.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this13);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this14.filters.accessGroup = [];
                _context7.next = 3;
                return _this14.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this14);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this15.filters.stateId = [];
                _context8.next = 3;
                return _this15.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this15);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this16.filters.statuId = [];
                _context9.next = 3;
                return _this16.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this16);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this17.filters.workGroupId = [];
                _context10.next = 3;
                return _this17.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this17);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this18.filters.foodGroup = [];
                _context11.next = 3;
                return _this18.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this18);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this19.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this19.isCheckDeps = !_this19.isCheckDeps;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this19);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                aList = _this20.sortableDepartmentList;

                _this20.filters.departments = [];
                _context13.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this20.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this20.accessGroupList;

                _this20.filters.accessGroup = [];
                _context13.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this20.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this20.workGroupList;

                _this20.filters.workGroupId = [];
                _context13.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this20.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this20.foodGroupList;

                _this20.filters.foodGroup = [];
                _context13.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this20.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this20.statuList;

                _this20.filters.statuId = [];
                _context13.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this20.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this20.stateList;

                _this20.filters.stateId = [];
                _context13.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this20.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this20);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                foodGroups = [];
                _context14.next = 4;
                return _this21.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context14.sent;

                _this21.foodGroups = foodGroups;
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this21, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                status = [];
                _context15.next = 4;
                return _this22.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this22.status = status;
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası :" + _context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this22, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                titles = [];
                _context16.next = 4;
                return _this23.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context16.sent;

                _this23.titles = titles;
                _context16.next = 12;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası :" + _context16.t0.message);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this23, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                states = [];
                _context17.next = 4;
                return _this24.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this24.states = states;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this24, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                workGroups = [];
                _context18.next = 4;
                return _this25.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this25.workGroups = workGroups;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this25, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                extrafields = [];
                _context19.next = 4;
                return _this26.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this26.extrafields = extrafields;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this26, [[0, 8]]);
      }))();
    },
    changeAuthReports: function changeAuthReports() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this27.activeReports.forEach(function (item) {
                  _this27.reports.forEach(function (report) {
                    if (report.id == item) {
                      report.isActive = true;
                    }
                  });
                });

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this27);
      }))();
    },
    getActiveReports: function getActiveReports() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return _this28.$axios.get("/Reports").then(function (response) {
                  _this28.activeReports = response.data;
                  _this28.changeAuthReports();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context21.sent;
                _context21.next = 10;
                break;

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this28, [[0, 6]]);
      }))();
    },
    reportSetting: function reportSetting() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var keys, movementsMaxLength;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (_this29.reportResult != [] && _this29.reportResult != null) {
                  if (_this29.selectedReportId == 1) {
                    //Gelmeyenler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.LaterComersReportHeaders.difference"));
                    keys = ["sicilNo", "adSoyad", "statu", "tarih", "durum", "girisS", "fark"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 2) {
                    //Detaylı Giriş Çıkış Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.workPlace"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.firstEntry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.lastExit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.total"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    keys = ["sicilNo", "adSoyad", "workPlace", "tarih", "ilkG", "sonC", "total", "durum", "g1", "c1", "f1", "g2", "c2", "f2", "g3", "c3", "f3", "g4", "c4", "f4", "g5", "c5", "f5", "g6", "c6", "f6", "g7", "c7", "f7", "g8", "c8", "f8"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 3) {
                    //Yemekhane Hareket Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.title"));
                    if (_this29.modules.customFieldName != "") {
                      _this29.reportHeaders.push(_this29.modules.customFieldName);
                    } else {
                      _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.documentNo"));
                    }
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.readerName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodReportHeader.debit"));
                    keys = ["sicilNo", "adSoyad", "title", "documentNo", "departmentName", "readerName", "tarih", "ucret"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 4) {
                    //Yemekhane Borç Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodDebtReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodDebtReportHeaders.nameSurname"));
                    if (_this29.modules.customFieldName != "") {
                      _this29.reportHeaders.push(_this29.modules.customFieldName);
                    } else {
                      _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodDebtReportHeaders.documentNo"));
                    }
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodDebtReportHeaders.debit"));
                    keys = ["sicilNo", "adSoyad", "iban", "ucret"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 5) {
                    //Kişi Bilgileri Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.mobilePhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.citizenshipNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.state"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.startDateWork"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.leaveDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.validityStartDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EmployeesReportHeaders.validityEndDate"));
                    keys = ["sicilNo", "name", "title", "mobilePhone", "identityNo", "statu", "state", "startDate", "leaveDate", "validityStartDate", "validityEndDate"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 6) {
                    //İçeridekiler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsidesReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsidesReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsidesReportHeaders.entryTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsidesReportHeaders.entryPoint"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "entryDate", "entryPoint", "status"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 7) {
                    //Dışarıdakiler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.OutsidesReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.OutsidesReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.OutsidesReportHeaders.exitTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.OutsidesReportHeaders.exitPoint"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.OutsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "exitDate", "exitPoint", "status"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 8) {
                    //Ziyaretçiler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.citizenshipNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.mobilePhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.where"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.reasonForVisit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.visitedEmployeeInformation"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.cardIssueTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.entryTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.exitTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.cardName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VisitorsReportHeaders.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "exitDate", "cardInfo", "description"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 9) {
                    //İçerideki Ziyaretçiler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.citizenshipNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.mobilePhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.where"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.reasonForVisit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.visitedEmployeeInformation"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.cardIssueTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.entryTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.cardName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InsideVisitorsReportHeader.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "cardInfo", "description"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 10) {
                    //Süre Bazlı Çalışma Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.startDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.endDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.totalWorkedTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.TimeBasedWorkReportHeaders.difference"));
                    keys = ["sicilNo", "adSoyad", "startDate", "endDate", "total", "difference"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 11) {
                    //İlk Giriş Son Çıkış Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.citizenshipNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.department"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.status1"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.workPlace"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.workPlan"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.firstEntry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.entryReader"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.lastExit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.exitReader"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.earlyEntry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.lateEntry"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.earlyExit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.lateExit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.total"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FirstInLastOutReportHeaders.missingHour"));
                    keys = ["tcNo", "sicilNo", "adSoyad", "departman", "unvan", "statu", "gorevYeri", "calismaGrubu", "tarih", "ilkG", "girisOkuyucu", "sonC", "cikisOkuyucu", "durum", "erkenG", "gecG", "erkenC", "gecC", "total", "fark"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 12) {
                    //İzinliler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.AllowenceReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.AllowenceReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.AllowenceReportHeaders.startDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.AllowenceReportHeaders.endDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.AllowenceReportHeaders.allowenceName"));
                    keys = ["sicilNo", "name", "startDate", "endDate", "allowenceName"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 13) {
                    //Çalışma Özeti Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.jobDays"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.workDays"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.publicHoliday"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.allowence"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WorkSummaryReportHeaders.absentee"));
                    keys = ["sicilNo", "name", "planWorkDay", "workDay", "publicHolidayOrAdministrativeLeave", "allowenceUsed", "absentee"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 14) {
                    //Departman Bazlı Sayı Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.unitName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.report"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.missioned"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "annualPermit", "report", "administrativeLeave", "freePermission", "missioned", "nonComers", "todayComers"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 15) {
                    //Müdürlük Bazlı Sayı Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.unitName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.report"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.missioned"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "annualPermit", "report", "administrativeLeave", "freePermission", "missioned", "nonComers", "todayComers"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 16) {
                    //Puantaj Raporu
                    keys = ["sicilNo", "name", "shortCode1", "shortCode2", "shortCode3", "shortCode4", "shortCode5", "shortCode6", "shortCode7", "shortCode8", "shortCode9", "shortCode10", "shortCode11", "shortCode12", "shortCode13", "shortCode14", "shortCode15", "shortCode16", "shortCode17", "shortCode18", "shortCode19", "shortCode20", "shortCode21", "shortCode22", "shortCode23", "shortCode24", "shortCode25", "shortCode26", "shortCode27", "shortCode28", "shortCode29", "shortCode30", "shortCode31"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 17) {
                    //Detaylı Puantaj Raporu
                    keys = ["sicilNo", "adSoyad", "realWorkDay", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10", "d11", "d12", "d13", "d14", "d15", "d16", "d17", "d18", "d19", "d20", "d21", "d22", "d23", "d24", "d25", "d26", "d27", "d28", "d29", "d30", "d31"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 18) {
                    //Yemekhane Yüklemeler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.debit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.creditType"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodCreditReportHeaders.userName"));
                    keys = ["sicilNo", "name", "date", "credit", "creditType", "userName"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        var veriler2 = [];
                        item.veriler.forEach(function (veri) {
                          var type = "";
                          if (veri.creditType == 2) {
                            type = _this29.$ml.get("general.balance");
                          } else if (veri.creditType == 1) {
                            type = _this29.$ml.get("general.credit");
                          }
                          veriler2.push({
                            sicilNo: veri.sicilNo,
                            name: veri.name,
                            date: veri.date,
                            credit: veri.credit,
                            creditType: type,
                            userName: veri.userName
                          });
                        });
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: veriler2
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 25) {
                    //Yemekhane İcmal Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodSummaryReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodSummaryReportHeaders.total"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.FoodSummaryReportHeaders.debit"));
                    keys = ["name", "count", "price"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 19) {
                    //Giriş Çıkış Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.workPlace"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.location"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.InOutReportHeaders.readerName"));
                    keys = ["sicilNo", "name", "title", "workPlace", "departmentName", "location", "date", "reader"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 20) {
                    //Kapı Bazlı Son Hareket Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.readerName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.doorStatus"));
                    keys = ["sicilNo", "name", "title", "departmentName", "date", "reader", "doorStatus"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 21) {
                    //Kapı Bazlı Yetki Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.accessGroup"));
                    keys = ["sicilNo", "name", "title", "departmentName", "accessGroup"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 22) {
                    //Yurtta Kalanlar Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.isSmsSend"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.motherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.fatherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.smsPhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.validityDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.areaName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.floorName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInformationReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 23) {
                    //Yurt İçerideki Öğrenciler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.lastMovementDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.lastMovementReader"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.isSmsSend"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.motherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.fatherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.smsPhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.validityDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.areaName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.floorName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryInsidesReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "exitDate", "exitPoint", "status", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 24) {
                    //Yurt Dışarıdaki Öğrenciler Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.lastMovementDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.lastMovementReader"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.status"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.isSmsSend"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.motherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.fatherName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.smsPhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.validityDate"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.areaName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.floorName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "exitDate", "exitPoint", "status", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 26) {
                    //Puantaj Şablon-1 Raporu
                    _this29.reportHeaders = _this29.reportResult[0].headers;
                    keys = ["sicilNo", "name", "title", "department", "date", "payrollName", "entry", "exit", "calculatedOvertime", "confirmedOvertime", "Item0", "Item1", "Item2", "Item3", "Item4", "Item5", "Item6", "Item7", "Item8", "Item9", "Item10", "Item11"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: item.keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 27) {
                    //Aylık Puantaj Raporu
                    _this29.reportHeaders = _this29.reportResult[0].headers;
                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: item.keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 28) {
                    //Aylık Maaş Raporu
                    _this29.reportHeaders = _this29.reportResult[0].headers;
                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: item.keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 29) {
                    // Haftalık Puantaj Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.workTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.overTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.nightWorkTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.WeeklyPayrollReportHeaders.status"));
                    keys = ["sicilNo", "name", "title", "departmentName", "workTime", "overTime", "nightWorkTime", "status"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 30) {
                    //İki Tarih Arası Departman Bazlı Sayı Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.unitName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.employeeCount"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.annualPermit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.report"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.administrativeLeave"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.freePermission"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.missioned"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.nonComers"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentSummaryReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "annualPermit", "report", "administrativeLeave", "freePermission", "missioned", "nonComers", "todayComers"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 31) {
                    //Fotoğraflı Hareket Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.title"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.reader"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.photo"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.EntryExitSnapshotReportHeaders.snapshot"));
                    keys = ["sicilNo", "name", "title", "departmentName", "date", "reader", "photo", "snapshot"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 32) {
                    //Satış Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.registrationNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.price"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.date"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.user"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.SaleReportHeaders.isRefund"));
                    keys = ["sicilNo", "name", "price", "date", "user", "isRefund"];

                    _this29.reportDatas = [];
                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 33) {
                    //Detaylı Ziyaretçi Hareket Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.citizenshipNumber"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.nameSurname"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.mobilePhone"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.where"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.reasonForVisit"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.visitedEmployeeInformation"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardIssueTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.entryTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.exitTime"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DetailedVisitorReportHeaders.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "exitDate", "cardInfo", "description"];

                    _this29.reportDatas = [];
                    movementsMaxLength = 0;

                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        item.veriler.forEach(function (iVeri) {
                          if (iVeri.movements.length > movementsMaxLength) {
                            movementsMaxLength = iVeri.movements.length;
                          }
                        });
                        for (var index = 0; index < movementsMaxLength; index++) {
                          _this29.reportHeaders.push(index + 1 + ". Hareket");
                        }
                        _this29.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 34) {
                    //Departman Bazlı Ziyaretçi Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentBasedVisitorReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.DepartmentBasedVisitorReportHeaders.total"));
                    keys = ["departmentName", "total"];

                    _this29.reportDatas = [];
                    movementsMaxLength = 0;

                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 35) {
                    //Vardiya Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.ShiftReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.ShiftReportHeaders.total"));
                    keys = ["departmentName", "total"];

                    _this29.reportDatas = [];
                    movementsMaxLength = 0;

                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this29.selectedReportId == 36) {
                    //Dikey İlk Giriş Son Çıkış Raporu
                    _this29.reportHeaders = [];
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.departmentName"));
                    _this29.reportHeaders.push(_this29.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.total"));
                    keys = ["departmentName", "total"];

                    _this29.reportDatas = [];
                    movementsMaxLength = 0;

                    _this29.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this29.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else {
                    alertify.warning(_this29.$ml.get("reports.selectedReportIsUnavailable"));
                  }
                } else {
                  _this29.reportHeaders = null;
                  _this29.reportDatas = null;
                }

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this29);
      }))();
    },
    getReportDetails: function getReportDetails() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var empIds, reportEndPoint, startDate, endDate, devices, allowenceIds, visitorGroupIds, reportOption, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!(_this30.selectedReportId == 0)) {
                  _context23.next = 3;
                  break;
                }

                alertify.warning(_this30.$ml.get("alerts.selectedReportNotBlank"));
                return _context23.abrupt("return");

              case 3:
                if (!(_this30.startDate == null || _this30.endDate == null || _this30.startDate > _this30.endDate)) {
                  _context23.next = 6;
                  break;
                }

                alertify.warning(_this30.$ml.get("alerts.invalidDate"));
                return _context23.abrupt("return");

              case 6:
                _context23.prev = 6;

                _this30.activeScreen = 3;
                _this30.isLoading = true;
                _context23.next = 11;
                return _this30.getSelectedEmployeeList();

              case 11:
                empIds = _context23.sent;
                reportEndPoint = _this30.selectedReportEndPoint;
                startDate = _this30.startDate;
                endDate = _this30.endDate;
                _context23.next = 17;
                return _this30.getCheckReaders();

              case 17:
                devices = _this30.selectedDevices;
                allowenceIds = [];
                visitorGroupIds = [];
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  deviceIds: devices
                };

                if (_this30.selectedReportId == 6 || _this30.selectedReportId == 7) {
                  reportOption = {
                    empIds: empIds,
                    deviceIds: devices,
                    startDate: startDate
                  };
                }

                if (!(_this30.selectedReportId == 8 || _this30.selectedReportId == 33)) {
                  _context23.next = 27;
                  break;
                }

                _context23.next = 25;
                return _this30.getCheckVisitorGroups();

              case 25:
                visitorGroupIds = _this30.selectedVisitorGroups;
                reportOption = {
                  startDate: startDate,
                  endDate: endDate,
                  visitorGroupIds: visitorGroupIds
                };

              case 27:
                if (_this30.selectedReportId == 9) {
                  reportOption = {
                    startDate: startDate,
                    endDate: endDate
                  };
                }
                if (_this30.selectedReportId == 10) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    time: _this30.reportOptions.time,
                    isUpperFromTime: _this30.reportOptions.isUpperFromTime,
                    showNonComers: _this30.reportOptions.showNonComers
                  };
                }
                if (_this30.selectedReportId == 11) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    showAllowed: _this30.reportOptions.showAllowed,
                    showNonComers: _this30.reportOptions.showNonComers,
                    deviceIds: devices
                  };
                }

                if (!(_this30.selectedReportId == 12)) {
                  _context23.next = 35;
                  break;
                }

                _context23.next = 33;
                return _this30.getCheckAllowences();

              case 33:
                allowenceIds = _this30.selectedAllowences;
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  allowenceIds: allowenceIds
                };

              case 35:
                if (_this30.selectedReportId == 13 || _this30.selectedReportId == 16 || _this30.selectedReportId == 17 || _this30.selectedReportId == 18 || _this30.selectedReportId == 26 || _this30.selectedReportId == 29 || _this30.selectedReportId == 32) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate
                  };
                }
                if (_this30.selectedReportId == 20 || _this30.selectedReportId == 21) {
                  reportOption = {
                    empIds: empIds,
                    deviceIds: devices
                  };
                }
                if (_this30.selectedReportId == 22 || _this30.selectedReportId == 23 || _this30.selectedReportId == 24) {
                  reportOption = {
                    empIds: empIds
                  };
                }

                if (!(_this30.selectedReportId == 14 || _this30.selectedReportId == 15)) {
                  _context23.next = 42;
                  break;
                }

                _context23.next = 41;
                return _this30.getCheckDepartmentList();

              case 41:
                reportOption = {
                  empIds: _this30.filters.departments,
                  startDate: startDate
                };

              case 42:
                if (!(_this30.selectedReportId == 25 || _this30.selectedReportId == 30)) {
                  _context23.next = 46;
                  break;
                }

                _context23.next = 45;
                return _this30.getCheckDepartmentList();

              case 45:
                reportOption = {
                  empIds: _this30.filters.departments,
                  startDate: startDate,
                  endDate: endDate
                };

              case 46:
                if (_this30.selectedReportId == 1) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    deviceIds: devices,
                    showAllowed: _this30.reportOptions.showAllowed,
                    showLateComers: _this30.reportOptions.showLateComers
                  };
                }
                _context23.next = 49;
                return _this30.$axios.post("/Reports/" + reportEndPoint, reportOption).then(function (response) {
                  _this30.reportResult = response.data.datas;
                  if (_this30.selectedReportId == 16 || _this30.selectedReportId == 17) {
                    _this30.reportHeaders = response.data.headers;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 49:
                response = _context23.sent;
                _context23.next = 52;
                return _this30.reportSetting();

              case 52:
                _this30.reportName = _this30.selectedReportName + " (" + _this30.toDateFormat(_this30.startDate, "gg.aa.yyyy ss:dd") + " - " + _this30.toDateFormat(_this30.endDate, "gg.aa.yyyy ss:dd") + ")";
                if (_this30.selectedReportId == 14) {
                  _this30.reportName = _this30.selectedReportName + " (" + _this30.toDateFormat(_this30.startDate, "gg.aa.yyyy") + ")";
                }
                _this30.isLoading = false;
                _context23.next = 62;
                break;

              case 57:
                _context23.prev = 57;
                _context23.t0 = _context23["catch"](6);

                console.error(_context23.t0);
                alertify.error("Servis Hatası :" + _context23.t0.message);
                _this30.isLoading = false;

              case 62:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this30, [[6, 57]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;

                _this31.isLoadingEmployee = true;
                _context24.next = 4;
                return _this31.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this31.filters;
                _context24.next = 8;
                return _this31.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context24.sent;

                _this31.employees = employees;
                _this31.isLoadingEmployee = false;
                _context24.next = 18;
                break;

              case 13:
                _context24.prev = 13;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error("Servis Hatası :" + _context24.t0.message);
                _this31.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this31, [[0, 13]]);
      }))();
    },
    checkAllReaders: function checkAllReaders() {
      var _this32 = this;

      this.isCheckReaders = !this.isCheckReaders;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this32.isCheckReaders) {
          doc.check = _this32.isCheckReaders;
        }
      });
    },
    getCheckReaders: function getCheckReaders() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this33.selectedDevices = [];
                _context25.next = 3;
                return _this33.readers.forEach(function (doc) {
                  if (doc.check == true) {
                    _this33.selectedDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this33);
      }))();
    },
    getReaders: function getReaders() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                readers = [];
                _context26.next = 4;
                return _this34.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      var isCheckNew = true;
                      if (doc.doorType != 1) {
                        isCheckNew == false;
                      }
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: isCheckNew
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this34.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this34.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this34.readers = readers;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Servis Hatası : " + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this34, [[0, 8]]);
      }))();
    },
    checkAllAllowence: function checkAllAllowence() {
      var _this35 = this;

      this.isCheckAllowences = !this.isCheckAllowences;
      var aList = this.allowences;
      aList.forEach(function (doc) {
        if (doc.check == !_this35.isCheckAllowences) {
          doc.check = _this35.isCheckAllowences;
        }
      });
    },
    getCheckAllowences: function getCheckAllowences() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this36.selectedAllowences = [];
                _context27.next = 3;
                return _this36.allowences.forEach(function (doc) {
                  if (doc.check == true) {
                    _this36.selectedAllowences.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this36);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;

                _this37.isLoading = true;
                allowences = [];
                _context28.next = 5;
                return _this37.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this37.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this37.$ml.get("errors.connectionError"));
                      _this37.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this37.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context28.sent;

                _this37.allowences = allowences;
                _this37.isLoading = false;
                _context28.next = 15;
                break;

              case 10:
                _context28.prev = 10;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);
                _this37.isLoading = false;

              case 15:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this37, [[0, 10]]);
      }))();
    },
    checkAllVisitorGroups: function checkAllVisitorGroups() {
      var _this38 = this;

      this.isCheckVG = !this.isCheckVG;
      var aList = this.visitorGroups;
      aList.forEach(function (doc) {
        if (doc.check == !_this38.isCheckVG) {
          doc.check = _this38.isCheckVG;
        }
      });
    },
    getCheckVisitorGroups: function getCheckVisitorGroups() {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _this39.selectedVisitorGroups = [];
                _context29.next = 3;
                return _this39.visitorGroups.forEach(function (doc) {
                  if (doc.check == true) {
                    _this39.selectedVisitorGroups.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this39);
      }))();
    },
    getVisitorCardGroups: function getVisitorCardGroups() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var visitorGroups, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                visitorGroups = [];
                _context30.next = 4;
                return _this40.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      visitorGroups.push({
                        id: doc.id,
                        name: doc.name,
                        devices: doc.devices,
                        check: true
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this40.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this40.$ml.get("errors.connectionError"));
                      _this40.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this40.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this40.visitorGroups = visitorGroups;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Hata :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this40, [[0, 8]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this41 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this41.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(function (doc) {
        _this41.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this41.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this41.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this41.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this41.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getAuthControl: function getAuthControl() {
      var _this42 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (_this42.authControl == 1) {
                  alertify.warning(_this42.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                }

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this42);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this43 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      var filter;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return _this43.getAuthControl();

            case 2:
              _context32.next = 4;
              return _this43.getDefaultDate();

            case 4:
              _context32.next = 6;
              return _this43.getDepartments();

            case 6:
              _context32.next = 8;
              return _this43.getAccessGroups();

            case 8:
              _context32.next = 10;
              return _this43.getActiveReports();

            case 10:
              _context32.next = 12;
              return _this43.getFoodGroups();

            case 12:
              _context32.next = 14;
              return _this43.getStatus();

            case 14:
              _context32.next = 16;
              return _this43.getStates();

            case 16:
              _context32.next = 18;
              return _this43.getTitles();

            case 18:
              _context32.next = 20;
              return _this43.getWorkGroups();

            case 20:
              _context32.next = 22;
              return _this43.getExtraFields();

            case 22:
              _context32.next = 24;
              return _this43.getReaders();

            case 24:
              _context32.next = 26;
              return _this43.getVisitorCardGroups();

            case 26:
              _context32.next = 28;
              return _this43.getAllowences();

            case 28:
              if (!_this43.defaultFilters) {
                _context32.next = 35;
                break;
              }

              filter = _this43.defaultFilters;

              _this43.setUserAuthorityFilter(filter);
              _context32.next = 33;
              return _this43.getEmployees();

            case 33:
              _context32.next = 37;
              break;

            case 35:
              _context32.next = 37;
              return _this43.getEmployees();

            case 37:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, _this43);
    }))();
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      startDate: null,
      endDate: null,
      selectedReportId: 35,
      selectedReportEndPoint: "ShiftReport",
      selectedReportName: "",
      selectedDevices: [],
      selectedAllowences: [],
      selectedVisitorGroups: [],
      reportOptions: {
        showAllowed: true,
        showNonComers: true,
        showLateComers: false,
        isUpperFromTime: false,
        time: 45
      },
      isSignatureColumnAdded: false,
      reportDatas: null,
      reportHeaders: null,
      reportResult: [],
      reportName: "",
      searchText: ""
    };
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthRaporlar;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList: function employeeFilteredList() {
      var _this = this;

      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.sicilNo).localeCompare(_this.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.sicilNo).localeCompare(_this.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.name).localeCompare(_this.turkishToUpper(a.name));
        });
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    statuList: function statuList() {
      return this.status;
    },
    reportDataList: function reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList: function reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    filtered: function filtered() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeFilteredList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "gg.aa.yyyy GG") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    customReportStyle: function customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (value == "Geç Kaldı" || value == "Hafta Tatili" || value == "Cumartesi Hakedişi") {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (key == "name" && value == "Toplam" || key == "date" && value == "Toplam") {
        return "text-bold h5";
      } else if (key == "unitName") {
        return "text-bold";
      } else if (key == "employeesInDepartments" || key == "continuedEmployee" || key == "annualPermit" || key == "report" || key == "missioned" || key == "administrativeLeave" || key == "nonComers" || key == "todayComers" || key == "freePermission") {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (key == "employeesInDepartments" || key == "annualPermit" || key == "report" || key == "administrativeLeave" || key == "freePermission" || key == "missioned" || key == "nonComers" || key == "todayComers" || key == "d1" || key == "d2" || key == "d3" || key == "d4" || key == "d5" || key == "d6" || key == "d7" || key == "d8" || key == "d9" || key == "d10" || key == "d11" || key == "d12" || key == "d13" || key == "d14" || key == "d15" || key == "d16" || key == "d17" || key == "d18" || key == "d19" || key == "d20" || key == "d21" || key == "d22" || key == "d23" || key == "d24" || key == "d25" || key == "d26" || key == "d27" || key == "d28" || key == "d29" || key == "d30" || key == "d31") {
        return "text-center";
      } else if (key == "shortCode1" || key == "shortCode2" || key == "shortCode3" || key == "shortCode4" || key == "shortCode5" || key == "shortCode6" || key == "shortCode7" || key == "shortCode8" || key == "shortCode9" || key == "shortCode10" || key == "shortCode11" || key == "shortCode12" || key == "shortCode13" || key == "shortCode14" || key == "shortCode15" || key == "shortCode16" || key == "shortCode17" || key == "shortCode18" || key == "shortCode19" || key == "shortCode20" || key == "shortCode21" || key == "shortCode22" || key == "shortCode23" || key == "shortCode24" || key == "shortCode25" || key == "shortCode26" || key == "shortCode27" || key == "shortCode28" || key == "shortCode29" || key == "shortCode30" || key == "shortCode31") {
        return "text-center";
      }
    },
    checkEmployees: function checkEmployees() {
      var _this4 = this;

      this.isCheck = !this.isCheck;
      var aList = this.employees;
      aList.forEach(function (doc) {
        if (doc.check == !_this4.isCheck) {
          doc.check = _this4.isCheck;
        }
      });
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selectedEmployees, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this5.employees;
                selectedEmployees = aList.filter(function (employee) {
                  return employee.check == true;
                });
                selectedEmployeeList = [];
                _context.next = 5;
                return selectedEmployees.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 5:
                return _context.abrupt("return", selectedEmployeeList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeIsUpperFromTime: function changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getAccessGroups: function getAccessGroups() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accessGroups = [];
                _context2.next = 4;
                return _this6.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this6.accessGroups = accessGroups;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                departments = [];
                _context3.prev = 1;
                _context3.next = 4;
                return _this7.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this7.departments = departments;
                _this7.sortableTrees();
                _this7.isLoading = false;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                alertify.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this8 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this8.sortableDepTrees.push(dep);
          _this8.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this9 = this;

      var departments2 = this.departments;
      var subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          doc2.name = ekle + " " + doc2.name;
          _this9.sortableDepTrees.push(doc2);
          _this9.subDepImport(doc2);
        });
      }
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dep.check = checkValue;
                _this10.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this10.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    changeFilterDep2: function changeFilterDep2(dep, checkValue) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dep.check = checkValue;
                _this11.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    //this.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this12.filters.departments = [];
                _context6.next = 3;
                return _this12.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this12);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this13.filters.accessGroup = [];
                _context7.next = 3;
                return _this13.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this13);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this14.filters.stateId = [];
                _context8.next = 3;
                return _this14.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this14);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this15.filters.statuId = [];
                _context9.next = 3;
                return _this15.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this15);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this16.filters.workGroupId = [];
                _context10.next = 3;
                return _this16.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this16);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this17.filters.foodGroup = [];
                _context11.next = 3;
                return _this17.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this17);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this18.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this18.isCheckDeps = !_this18.isCheckDeps;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this18);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                aList = _this19.sortableDepartmentList;

                _this19.filters.departments = [];
                _context13.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this19.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this19.accessGroupList;

                _this19.filters.accessGroup = [];
                _context13.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this19.workGroupList;

                _this19.filters.workGroupId = [];
                _context13.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this19.foodGroupList;

                _this19.filters.foodGroup = [];
                _context13.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this19.statuList;

                _this19.filters.statuId = [];
                _context13.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this19.stateList;

                _this19.filters.stateId = [];
                _context13.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this19);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                foodGroups = [];
                _context14.next = 4;
                return _this20.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context14.sent;

                _this20.foodGroups = foodGroups;
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this20, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                status = [];
                _context15.next = 4;
                return _this21.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this21.status = status;
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası :" + _context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this21, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                titles = [];
                _context16.next = 4;
                return _this22.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context16.sent;

                _this22.titles = titles;
                _context16.next = 12;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası :" + _context16.t0.message);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this22, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                states = [];
                _context17.next = 4;
                return _this23.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this23.states = states;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this23, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                workGroups = [];
                _context18.next = 4;
                return _this24.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this24.workGroups = workGroups;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this24, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                extrafields = [];
                _context19.next = 4;
                return _this25.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this25.extrafields = extrafields;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this25, [[0, 8]]);
      }))();
    },
    reportSetting: function reportSetting() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var keys, movementsMaxLength, tempDate, endDate, i;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (_this26.reportResult != [] && _this26.reportResult != null) {
                  //Vardiya Raporu
                  _this26.reportHeaders = [];
                  _this26.reportHeaders.push(_this26.$ml.get("reports.reports.ShiftReportHeaders.registrationNumber"));
                  _this26.reportHeaders.push(_this26.$ml.get("reports.reports.ShiftReportHeaders.nameSurname"));
                  _this26.reportHeaders.push(_this26.$ml.get("reports.reports.ShiftReportHeaders.title"));
                  keys = ["departmentName", "total"];

                  _this26.reportDatas = [];
                  movementsMaxLength = 0;

                  _this26.reportResult.forEach(function (item) {
                    if (item.veriler.length > 0) {
                      _this26.reportDatas.push({
                        departmanAdi: item.departmanAdi,
                        keys: keys,
                        veriler: item.veriler
                      });
                    }
                  });
                  tempDate = new Date(_this26.startDate);
                  endDate = new Date(_this26.endDate);

                  for (i = 0; tempDate <= endDate; i++) {
                    _this26.reportHeaders.push(tempDate.toLocaleDateString("tr-TR", { day: '2-digit', month: '2-digit', year: 'numeric' }));
                    tempDate.setDate(tempDate.getDate() + 1);
                  }
                  if (_this26.isSignatureColumnAdded) {
                    _this26.reportHeaders.push(_this26.$ml.get("reports.reports.ShiftReportHeaders.signature"));
                  }
                } else {
                  _this26.reportHeaders = null;
                  _this26.reportDatas = null;
                }

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this26);
      }))();
    },
    getReportDetails: function getReportDetails() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var empIds, reportEndPoint, startDate, endDate, reportOption, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(_this27.startDate == null || _this27.endDate == null || _this27.startDate > _this27.endDate)) {
                  _context21.next = 3;
                  break;
                }

                alertify.warning(_this27.$ml.get("alerts.invalidDate"));
                return _context21.abrupt("return");

              case 3:
                _context21.prev = 3;

                _this27.activeScreen = 3;
                _this27.isLoading = true;
                _context21.next = 8;
                return _this27.getSelectedEmployeeList();

              case 8:
                empIds = _context21.sent;
                reportEndPoint = _this27.selectedReportEndPoint;
                startDate = _this27.startDate;
                endDate = _this27.endDate;
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate
                };
                _context21.next = 15;
                return _this27.$axios.post("/Reports/" + reportEndPoint, reportOption).then(function (response) {
                  _this27.reportResult = response.data.datas;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 15:
                response = _context21.sent;
                _context21.next = 18;
                return _this27.reportSetting();

              case 18:
                _this27.reportName = _this27.selectedReportName + " (" + _this27.toDateFormat(_this27.startDate, "gg.aa.yyyy ss:dd") + " - " + _this27.toDateFormat(_this27.endDate, "gg.aa.yyyy ss:dd") + ")";
                _this27.isLoading = false;
                _context21.next = 27;
                break;

              case 22:
                _context21.prev = 22;
                _context21.t0 = _context21["catch"](3);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);
                _this27.isLoading = false;

              case 27:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this27, [[3, 22]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this28.isLoadingEmployee = true;
                _context22.next = 4;
                return _this28.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this28.filters;
                _context22.next = 8;
                return _this28.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context22.sent;

                _this28.employees = employees;
                _this28.isLoadingEmployee = false;
                _context22.next = 18;
                break;

              case 13:
                _context22.prev = 13;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);
                _this28.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this28, [[0, 13]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this29 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this29.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(function (doc) {
        _this29.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this29.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this29.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this29.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this29.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getAuthControl: function getAuthControl() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (_this30.authControl == 1) {
                  alertify.warning(_this30.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                }

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this30);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this31 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      var filter;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _this31.getAuthControl();

            case 2:
              _context24.next = 4;
              return _this31.getDefaultDate();

            case 4:
              _context24.next = 6;
              return _this31.getDepartments();

            case 6:
              _context24.next = 8;
              return _this31.getAccessGroups();

            case 8:
              _context24.next = 10;
              return _this31.getFoodGroups();

            case 10:
              _context24.next = 12;
              return _this31.getStatus();

            case 12:
              _context24.next = 14;
              return _this31.getStates();

            case 14:
              _context24.next = 16;
              return _this31.getTitles();

            case 16:
              _context24.next = 18;
              return _this31.getWorkGroups();

            case 18:
              _context24.next = 20;
              return _this31.getExtraFields();

            case 20:
              if (!_this31.defaultFilters) {
                _context24.next = 27;
                break;
              }

              filter = _this31.defaultFilters;

              _this31.setUserAuthorityFilter(filter);
              _context24.next = 25;
              return _this31.getEmployees();

            case 25:
              _context24.next = 29;
              break;

            case 27:
              _context24.next = 29;
              return _this31.getEmployees();

            case 29:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, _this31);
    }))();
  }
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            windowHeight: window.innerHeight,
            isLoading: false,
            isLoadingEmployee: false,
            activeScreen: 1,
            orderEmpList: 1,
            selectedDoorType: 4,
            filters: {
                nameOrCardNumber: "",
                sicilOrTerminalNo: null,
                departments: [],
                accessGroup: [],
                identityNo: "",
                documentNoOrMail: "",
                foodGroup: [],
                workGroupId: [],
                title: "",
                stateId: [],
                statuId: [],
                plateNo: "",
                extraField1key: 0,
                extraField1value: "",
                extraField2key: 0,
                extraField2value: "",
                extraField3key: 0,
                extraField3value: "",
                extraField4key: 0,
                extraField4value: "",
                isVisitor: false,
                isActive: true
            },
            sortableDepTrees: [],
            isCheckDeps: false,
            isCheck: true,
            employees: [],
            departments: [],
            foodGroups: [],
            titles: [],
            states: [],
            status: [],
            extrafields: [],
            workGroups: [],
            accessGroups: [],
            isCheckVG: true,
            visitorGroups: [],
            isCheckAllowences: true,
            allowences: [],
            isCheckReaders: true,
            readers: [],
            startDate: null,
            endDate: null,
            selectedReportId: 36,
            selectedReportEndPoint: "VerticalFirstInLastOutReport",
            selectedReportName: "",
            selectedDevices: [],
            selectedAllowences: [],
            selectedVisitorGroups: [],
            reportOptions: {
                showAllowed: true,
                showNonComers: true,
                showLateComers: false,
                isUpperFromTime: false,
                time: 45
            },
            reportDatas: null,
            reportHeaders: [],
            reportResult: [],
            reportName: "",
            searchText: "",
            activeReports: []
        };
    },

    computed: {
        defaultFilters: function defaultFilters() {
            return this.$store.getters.getDefaultFilters;
        },
        modules: function modules() {
            return this.$store.getters.getModules;
        },
        authControl: function authControl() {
            return this.$store.getters.getAuthRaporlar;
        },
        checkedDepartmentList: function checkedDepartmentList() {
            var checkedList = "";
            var list = this.sortableDepartmentList.forEach(function (a) {
                if (a.check == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        checkedStateList: function checkedStateList() {
            var checkedList = "";
            var list = this.stateList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        checkedStatusList: function checkedStatusList() {
            var checkedList = "";
            var list = this.statuList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        checkedWorkGroupList: function checkedWorkGroupList() {
            var checkedList = "";
            var list = this.workGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        checkedAccessGroupList: function checkedAccessGroupList() {
            var checkedList = "";
            var list = this.accessGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        checkedFoodGroupList: function checkedFoodGroupList() {
            var checkedList = "";
            var list = this.foodGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        employeeFilteredList: function employeeFilteredList() {
            var _this = this;

            if (this.orderEmpList == 1) {
                return this.employees.sort(function (a, b) {
                    return _this.turkishToUpper(a.sicilNo).localeCompare(_this.turkishToUpper(b.sicilNo));
                });
            } else if (this.orderEmpList == 2) {
                return this.employees.sort(function (a, b) {
                    return _this.turkishToUpper(b.sicilNo).localeCompare(_this.turkishToUpper(a.sicilNo));
                });
            } else if (this.orderEmpList == 3) {
                return this.employees.sort(function (a, b) {
                    return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
                });
            } else {
                return this.employees.sort(function (a, b) {
                    return _this.turkishToUpper(b.name).localeCompare(_this.turkishToUpper(a.name));
                });
            }
        },
        departmentList: function departmentList() {
            return this.departments;
        },
        sortableDepartmentList: function sortableDepartmentList() {
            return this.sortableDepTrees;
        },
        foodGroupList: function foodGroupList() {
            return this.foodGroups;
        },
        titleList: function titleList() {
            return this.titles;
        },
        stateList: function stateList() {
            return this.states;
        },
        statuList: function statuList() {
            return this.status;
        },
        visitorGroupList: function visitorGroupList() {
            return this.visitorGroups;
        },
        readerList: function readerList() {
            return this.readers.sort(function (a, b) {
                if (a.ipAddress < b.ipAddress) return -1;
                if (a.ipAddress > b.ipAddress) return 0;
            });
        },
        reportList: function reportList() {
            var list = this.reports.filter(function (item) {
                return item.isActive == true && item.module == true;
            });
            if (list) {
                return list.sort(function (a, b) {
                    if (a.index < b.index) return -1;
                    if (a.index > b.index) return 0;
                });
            }
        },
        reportDataList: function reportDataList() {
            return this.reportDatas;
        },
        reportHeaderList: function reportHeaderList() {
            return this.reportHeaders;
        },
        extraFieldList: function extraFieldList() {
            return this.extrafields;
        },
        workGroupList: function workGroupList() {
            return this.workGroups;
        },
        allowenceList: function allowenceList() {
            return this.allowences;
        },
        accessGroupList: function accessGroupList() {
            return this.accessGroups;
        },
        filtered: function filtered() {
            var _this2 = this;

            var search = this.turkishToUpper(this.searchText);
            if (search) {
                return this.employeeFilteredList.filter(function (item) {
                    return search.split(" ").every(function (v) {
                        return _this2.turkishToUpper(item.name).includes(v);
                    });
                });
            } else {
                return this.employeeFilteredList;
            }
        },
        windowHeightSize: function windowHeightSize() {
            if (this.windowHeight) {
                var height = this.windowHeight - 300;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        },
        windowHeightTableSize: function windowHeightTableSize() {
            if (this.windowHeight) {
                var height = this.windowHeight - 380;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    filters: {
        toDateFormatGet: function toDateFormatGet(str, format) {
            if (str == "" || str == null) {
                return "";
            }
            if (format == "gg.aa.yyyy ss:dd") {
                str = new Date(str);
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                str = new Date(str);
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                return gun + "." + ay + "." + yil;
            } else if (format == "ss:dd:ss") {
                if (str.length > 5) {
                    str = new Date(str);
                    var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                    var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                    return saat + ":" + dakika;
                } else {
                    str = new Date("1900-01-01 " + str.replace("Z", ""));
                    var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                    var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                    var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
                    return saat + ":" + dakika + ":" + saniye;
                }
            } else if (format == "ss:dd") {
                if (str.length > 5) {
                    str = new Date(str);
                    var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                    var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                    return saat + ":" + dakika;
                } else {
                    str = new Date("1900-01-01 " + str.replace("Z", ""));
                    var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                    var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                    return saat + ":" + dakika;
                }
            }
        }
    },
    watch: {
        windowHeight: function windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                    //WEB
                }
        }
    },
    methods: {
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
        },
        turkishToUpper: function turkishToUpper(text) {
            var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
            text = text.replace(/(([iışğüçö]))/g, function (letter) {
                return letters[letter];
            });
            return text.toUpperCase();
        },
        setOrderEmp: function setOrderEmp(number) {
            if (number == 1) {
                if (this.orderEmpList == 1) {
                    this.orderEmpList = 2;
                } else {
                    this.orderEmpList = 1;
                }
            } else {
                if (this.orderEmpList == 3) {
                    this.orderEmpList = 4;
                } else {
                    this.orderEmpList = 3;
                }
            }
        },
        toDateFormat: function toDateFormat(str, format) {
            if (str.length > 9) {
                str = new Date(str);
            } else {
                str = new Date("1900-01-01 " + str.replace("Z", ""));
            }
            if (format == "gg.aa.yyyy ss:dd") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                return yil + "-" + ay + "-" + gun;
            } else if (format == "ss:dd:ss") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return saat + ":" + dakika;
            }
        },
        changeInOutListDoorType: function changeInOutListDoorType(event) {
            var _this3 = this;

            this.selectedDoorType = event.target.value;
            this.readerList.forEach(function (a) {
                if (_this3.selectedDoorType == 4) {
                    a.check = true;
                } else {
                    if (a.doorType == _this3.selectedDoorType) {
                        a.check = true;
                    } else {
                        a.check = false;
                    }
                }
            });
            this.isCheckReaders = true;
        },
        customReportStyle: function customReportStyle(key, value) {
            if (key == "durum") {
                if (value == "Gelmedi") {
                    return "color-danger no-wrap";
                } else if (value == "Geç Kaldı" || value == "Hafta Tatili" || value == "Cumartesi Hakedişi") {
                    return "color-warning no-wrap";
                } else if (value == "Geldi") {
                    return "color-success no-wrap";
                } else {
                    return "color-primary no-wrap";
                }
            } else if (key == "name" && value == "Toplam" || key == "date" && value == "Toplam") {
                return "text-bold h5";
            } else if (key == "unitName") {
                return "text-bold";
            } else if (key == "employeesInDepartments" || key == "continuedEmployee" || key == "annualPermit" || key == "report" || key == "missioned" || key == "administrativeLeave" || key == "nonComers" || key == "todayComers" || key == "freePermission") {
                return "text-bold text-center";
            } else if (key == "adSoyad" || key == "name") {
                return "min-180";
            } else if (key == "total" || key == "ucret" || key == "allowenceName") {
                return "text-bold";
            } else if (key == "g1" && value != "") {
                return "color-success";
            } else if (key == "c1" && value != "") {
                return "color-danger";
            } else if (key == "g2" && value != "") {
                return "color-success";
            } else if (key == "c2" && value != "") {
                return "color-danger";
            } else if (key == "g3" && value != "") {
                return "color-success";
            } else if (key == "c3" && value != "") {
                return "color-danger";
            } else if (key == "g4" && value != "") {
                return "color-success";
            } else if (key == "c4" && value != "") {
                return "color-danger";
            } else if (key == "g5" && value != "") {
                return "color-success";
            } else if (key == "c5" && value != "") {
                return "color-danger";
            } else if (key == "g6" && value != "") {
                return "color-success";
            } else if (key == "c6" && value != "") {
                return "color-danger";
            } else if (key == "g7" && value != "") {
                return "color-success";
            } else if (key == "c7" && value != "") {
                return "color-danger";
            } else if (key == "g8" && value != "") {
                return "color-success";
            } else if (key == "c8" && value != "") {
                return "color-danger";
            } else if (key == "g9" && value != "") {
                return "color-success";
            } else if (key == "c9" && value != "") {
                return "color-danger";
            } else if (key == "g10" && value != "") {
                return "color-success";
            } else if (key == "c10" && value != "") {
                return "color-danger";
            } else if (key == "employeesInDepartments" || key == "annualPermit" || key == "report" || key == "administrativeLeave" || key == "freePermission" || key == "missioned" || key == "nonComers" || key == "todayComers" || key == "d1" || key == "d2" || key == "d3" || key == "d4" || key == "d5" || key == "d6" || key == "d7" || key == "d8" || key == "d9" || key == "d10" || key == "d11" || key == "d12" || key == "d13" || key == "d14" || key == "d15" || key == "d16" || key == "d17" || key == "d18" || key == "d19" || key == "d20" || key == "d21" || key == "d22" || key == "d23" || key == "d24" || key == "d25" || key == "d26" || key == "d27" || key == "d28" || key == "d29" || key == "d30" || key == "d31") {
                return "text-center";
            } else if (key == "shortCode1" || key == "shortCode2" || key == "shortCode3" || key == "shortCode4" || key == "shortCode5" || key == "shortCode6" || key == "shortCode7" || key == "shortCode8" || key == "shortCode9" || key == "shortCode10" || key == "shortCode11" || key == "shortCode12" || key == "shortCode13" || key == "shortCode14" || key == "shortCode15" || key == "shortCode16" || key == "shortCode17" || key == "shortCode18" || key == "shortCode19" || key == "shortCode20" || key == "shortCode21" || key == "shortCode22" || key == "shortCode23" || key == "shortCode24" || key == "shortCode25" || key == "shortCode26" || key == "shortCode27" || key == "shortCode28" || key == "shortCode29" || key == "shortCode30" || key == "shortCode31") {
                return "text-center";
            }
        },
        checkEmployees: function checkEmployees() {
            var _this4 = this;

            this.isCheck = !this.isCheck;
            var aList = this.employees;
            aList.forEach(function (doc) {
                if (doc.check == !_this4.isCheck) {
                    doc.check = _this4.isCheck;
                }
            });
        },
        getSelectedEmployeeList: function getSelectedEmployeeList() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var aList, selectedEmployees, selectedEmployeeList;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                aList = _this5.employees;
                                selectedEmployees = aList.filter(function (employee) {
                                    return employee.check == true;
                                });
                                selectedEmployeeList = [];
                                _context.next = 5;
                                return selectedEmployees.forEach(function (emp) {
                                    selectedEmployeeList.push(emp.id);
                                });

                            case 5:
                                return _context.abrupt("return", selectedEmployeeList);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this5);
            }))();
        },
        filtersClear: function filtersClear() {
            this.filters.nameOrCardNumber = "";
            this.filters.sicilOrTerminalNo = null;
            this.filters.departments = [];
            this.filters.accessGroup = [];
            this.filters.identityNo = "";
            this.filters.documentNoOrMail = "";
            this.filters.foodGroup = [];
            this.filters.workGroupId = [];
            this.filters.title = "";
            this.filters.stateId = [];
            this.filters.statuId = [];
            this.filters.plateNo = "";
            this.filters.extraField1key = 0;
            this.filters.extraField1value = "";
            this.filters.extraField2key = 0;
            this.filters.extraField2value = "";
            this.filters.extraField3key = 0;
            this.filters.extraField3value = "";
            this.filters.extraField4key = 0;
            this.filters.extraField4value = "";
            this.filters.isVisitor = false;
            this.filters.isActive = true;
            this.accessGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.sortableDepartmentList.forEach(function (a) {
                a.check = false;
            });
            this.foodGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.workGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.stateList.forEach(function (a) {
                a.isCheck = false;
            });
            this.statuList.forEach(function (a) {
                a.isCheck = false;
            });
        },
        changeSelectedReport: function changeSelectedReport(event) {
            this.selectedReportId = event.target.value;
            var report = this.reportList.filter(function (item) {
                return item.id == event.target.value;
            });
            if (report) {
                this.selectedReportEndPoint = report[0].endPoint;
                this.selectedReportName = report[0].name;
            }
        },
        changeIsUpperFromTime: function changeIsUpperFromTime(event) {
            this.reportOptions.isUpperFromTime = event.target.value;
        },
        changeFilterTitles: function changeFilterTitles(event) {
            this.filters.title = event.target.value;
        },
        changeFilterExtraField1: function changeFilterExtraField1(event) {
            this.filters.extraField1key = event.target.value;
        },
        changeFilterExtraField2: function changeFilterExtraField2(event) {
            this.filters.extraField2key = event.target.value;
        },
        changeFilterExtraField3: function changeFilterExtraField3(event) {
            this.filters.extraField3key = event.target.value;
        },
        changeFilterExtraField4: function changeFilterExtraField4(event) {
            this.filters.extraField4key = event.target.value;
        },
        exportToExcel: function exportToExcel() {
            var tarih = new Date();
            var filename = this.selectedReportName + " - " + tarih.toLocaleString();
            $("#printExcel").table2excel({
                filename: filename + ".xls",
                preserveColors: true
            });
        },
        exportToPDF: function exportToPDF() {
            this.$htmlToPaper("printReport");
        },
        getAccessGroups: function getAccessGroups() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var accessGroups, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                accessGroups = [];
                                _context2.next = 4;
                                return _this6.$axios.get("/AccessGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        accessGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isNewReaderAdd: doc.isNewReaderAdd,
                                            selectedReaders: doc.postReaders,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this6.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this6.$ml.get("errors.connectionError"));
                                            _this6.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this6.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context2.sent;

                                _this6.accessGroups = accessGroups;
                                _context2.next = 12;
                                break;

                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);

                                console.error(_context2.t0);
                                alertify.error("Servis Hatası :" + _context2.t0.message);

                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this6, [[0, 8]]);
            }))();
        },
        getDepartments: function getDepartments() {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var departments, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                departments = [];
                                _context3.prev = 1;
                                _context3.next = 4;
                                return _this7.$axios.get("/Department").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        departments.push({
                                            id: doc.id,
                                            name: doc.name,
                                            mainDepartmentId: doc.mainDepartmentId,
                                            isActive: doc.isActive,
                                            locationTree: doc.locationTree,
                                            userId: doc.userId,
                                            check: false
                                        });
                                    });
                                    departments.sort(function (a, b) {
                                        if (a.locationTree < b.locationTree) return -1;
                                        if (a.locationTree > b.locationTree) return 0;
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this7.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this7.$ml.get("errors.connectionError"));
                                            _this7.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this7.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context3.sent;

                                _this7.departments = departments;
                                _this7.sortableTrees();
                                _this7.isLoading = false;
                                _context3.next = 14;
                                break;

                            case 10:
                                _context3.prev = 10;
                                _context3.t0 = _context3["catch"](1);

                                console.error(_context3.t0);
                                alertify.error(_context3.t0);

                            case 14:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this7, [[1, 10]]);
            }))();
        },
        sortableTrees: function sortableTrees() {
            var _this8 = this;

            this.sortableDepTrees = [];
            this.departments.forEach(function (dep) {
                if (dep.mainDepartmentId == null) {
                    _this8.sortableDepTrees.push(dep);
                    _this8.subDepImport(dep);
                }
            });
        },
        subDepImport: function subDepImport(dep) {
            var _this9 = this;

            var departments2 = this.departments;
            var subDep = departments2.filter(function (doc) {
                return doc.mainDepartmentId == dep.id;
            });
            if (subDep.length > 0) {
                var ekle = "";
                var ek = subDep[0].locationTree.split("/");
                for (var index = 0; index < ek.length - 3; index++) {
                    ekle = "--/" + ekle;
                }
                subDep.forEach(function (doc2) {
                    doc2.name = ekle + " " + doc2.name;
                    _this9.sortableDepTrees.push(doc2);
                    _this9.subDepImport(doc2);
                });
            }
        },
        changeFilterDep: function changeFilterDep(dep, checkValue) {
            var _this10 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                dep.check = checkValue;
                                _this10.sortableDepartmentList.forEach(function (doc) {
                                    if (doc.mainDepartmentId == dep.id) {
                                        doc.check = checkValue;
                                        _this10.changeFilterDep(doc, checkValue);
                                    }
                                });

                            case 2:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this10);
            }))();
        },
        changeFilterDep2: function changeFilterDep2(dep, checkValue) {
            var _this11 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                dep.check = checkValue;
                                _this11.sortableDepartmentList.forEach(function (doc) {
                                    if (doc.mainDepartmentId == dep.id) {
                                        doc.check = checkValue;
                                        //this.changeFilterDep(doc, checkValue);
                                    }
                                });

                            case 2:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this11);
            }))();
        },
        clearFilterDepartments: function clearFilterDepartments() {
            var _this12 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _this12.filters.departments = [];
                                _context6.next = 3;
                                return _this12.sortableDepartmentList.forEach(function (doc) {
                                    if (doc.check == true) {
                                        doc.check = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this12);
            }))();
        },
        clearFilterAccessGroup: function clearFilterAccessGroup() {
            var _this13 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _this13.filters.accessGroup = [];
                                _context7.next = 3;
                                return _this13.accessGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this13);
            }))();
        },
        clearFilterStates: function clearFilterStates() {
            var _this14 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _this14.filters.stateId = [];
                                _context8.next = 3;
                                return _this14.stateList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this14);
            }))();
        },
        clearFilterStatus: function clearFilterStatus() {
            var _this15 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _this15.filters.statuId = [];
                                _context9.next = 3;
                                return _this15.statuList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this15);
            }))();
        },
        clearFilterWorkPlans: function clearFilterWorkPlans() {
            var _this16 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _this16.filters.workGroupId = [];
                                _context10.next = 3;
                                return _this16.workGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this16);
            }))();
        },
        clearFilterFoodGroups: function clearFilterFoodGroups() {
            var _this17 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _this17.filters.foodGroup = [];
                                _context11.next = 3;
                                return _this17.foodGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this17);
            }))();
        },
        getCheckDepartmentAll: function getCheckDepartmentAll(value) {
            var _this18 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _this18.sortableDepartmentList.forEach(function (dep) {
                                    dep.check = value;
                                });
                                _this18.isCheckDeps = !_this18.isCheckDeps;

                            case 2:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this18);
            }))();
        },
        getCheckDepartmentList: function getCheckDepartmentList() {
            var _this19 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var aList, aList2, aList3, aList4, aList5, aList6;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                aList = _this19.sortableDepartmentList;

                                _this19.filters.departments = [];
                                _context13.next = 4;
                                return aList.forEach(function (doc) {
                                    if (doc.check == true) {
                                        _this19.filters.departments.push(doc.id);
                                    }
                                });

                            case 4:
                                aList2 = _this19.accessGroupList;

                                _this19.filters.accessGroup = [];
                                _context13.next = 8;
                                return aList2.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this19.filters.accessGroup.push(doc.id);
                                    }
                                });

                            case 8:
                                aList3 = _this19.workGroupList;

                                _this19.filters.workGroupId = [];
                                _context13.next = 12;
                                return aList3.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this19.filters.workGroupId.push(doc.id);
                                    }
                                });

                            case 12:
                                aList4 = _this19.foodGroupList;

                                _this19.filters.foodGroup = [];
                                _context13.next = 16;
                                return aList4.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this19.filters.foodGroup.push(doc.id);
                                    }
                                });

                            case 16:
                                aList5 = _this19.statuList;

                                _this19.filters.statuId = [];
                                _context13.next = 20;
                                return aList5.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this19.filters.statuId.push(doc.id);
                                    }
                                });

                            case 20:
                                aList6 = _this19.stateList;

                                _this19.filters.stateId = [];
                                _context13.next = 24;
                                return aList6.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this19.filters.stateId.push(doc.id);
                                    }
                                });

                            case 24:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this19);
            }))();
        },
        getFoodGroups: function getFoodGroups() {
            var _this20 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var foodGroups, response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.prev = 0;
                                foodGroups = [];
                                _context14.next = 4;
                                return _this20.$axios.get("/FoodGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        foodGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            type: doc.type,
                                            singleFoodEachMeal: doc.singleFoodEachMeal,
                                            meals: doc.meals,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this20.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this20.$ml.get("errors.connectionError"));
                                            _this20.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this20.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context14.sent;

                                _this20.foodGroups = foodGroups;
                                _context14.next = 12;
                                break;

                            case 8:
                                _context14.prev = 8;
                                _context14.t0 = _context14["catch"](0);

                                console.error(_context14.t0);
                                alertify.error("Servis Hatası :" + _context14.t0.message);

                            case 12:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this20, [[0, 8]]);
            }))();
        },
        getStatus: function getStatus() {
            var _this21 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var status, response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.prev = 0;
                                status = [];
                                _context15.next = 4;
                                return _this21.$axios.get("/Employees/getStatus").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        status.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this21.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this21.$ml.get("errors.connectionError"));
                                            _this21.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this21.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context15.sent;

                                _this21.status = status;
                                _context15.next = 12;
                                break;

                            case 8:
                                _context15.prev = 8;
                                _context15.t0 = _context15["catch"](0);

                                console.error(_context15.t0);
                                alertify.error("Servis Hatası :" + _context15.t0.message);

                            case 12:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this21, [[0, 8]]);
            }))();
        },
        getTitles: function getTitles() {
            var _this22 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var titles, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.prev = 0;
                                titles = [];
                                _context16.next = 4;
                                return _this22.$axios.get("/Employees/getTitles").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        titles.push({
                                            name: doc
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this22.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this22.$ml.get("errors.connectionError"));
                                            _this22.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this22.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context16.sent;

                                _this22.titles = titles;
                                _context16.next = 12;
                                break;

                            case 8:
                                _context16.prev = 8;
                                _context16.t0 = _context16["catch"](0);

                                console.error(_context16.t0);
                                alertify.error("Servis Hatası :" + _context16.t0.message);

                            case 12:
                            case "end":
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this22, [[0, 8]]);
            }))();
        },
        getStates: function getStates() {
            var _this23 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
                var states, response;
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _context17.prev = 0;
                                states = [];
                                _context17.next = 4;
                                return _this23.$axios.get("/Employees/getStates").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        states.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this23.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this23.$ml.get("errors.connectionError"));
                                            _this23.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this23.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context17.sent;

                                _this23.states = states;
                                _context17.next = 12;
                                break;

                            case 8:
                                _context17.prev = 8;
                                _context17.t0 = _context17["catch"](0);

                                console.error(_context17.t0);
                                alertify.error("Servis Hatası :" + _context17.t0.message);

                            case 12:
                            case "end":
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this23, [[0, 8]]);
            }))();
        },
        getWorkGroups: function getWorkGroups() {
            var _this24 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                var workGroups, response;
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _context18.prev = 0;
                                workGroups = [];
                                _context18.next = 4;
                                return _this24.$axios.get("/WorkGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        workGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this24.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this24.$ml.get("errors.connectionError"));
                                            _this24.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this24.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context18.sent;

                                _this24.workGroups = workGroups;
                                _context18.next = 12;
                                break;

                            case 8:
                                _context18.prev = 8;
                                _context18.t0 = _context18["catch"](0);

                                console.error(_context18.t0);
                                alertify.error("Servis Hatası :" + _context18.t0.message);

                            case 12:
                            case "end":
                                return _context18.stop();
                        }
                    }
                }, _callee18, _this24, [[0, 8]]);
            }))();
        },
        getExtraFields: function getExtraFields() {
            var _this25 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
                var extrafields, response;
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _context19.prev = 0;
                                extrafields = [];
                                _context19.next = 4;
                                return _this25.$axios.get("/ExtraField").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        extrafields.push({
                                            id: doc.id,
                                            name: doc.definition
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this25.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this25.$ml.get("errors.connectionError"));
                                            _this25.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this25.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context19.sent;

                                _this25.extrafields = extrafields;
                                _context19.next = 12;
                                break;

                            case 8:
                                _context19.prev = 8;
                                _context19.t0 = _context19["catch"](0);

                                console.error(_context19.t0);
                                alertify.error("Servis Hatası :" + _context19.t0.message);

                            case 12:
                            case "end":
                                return _context19.stop();
                        }
                    }
                }, _callee19, _this25, [[0, 8]]);
            }))();
        },
        changeAuthReports: function changeAuthReports() {
            var _this26 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _this26.activeReports.forEach(function (item) {
                                    _this26.reports.forEach(function (report) {
                                        if (report.id == item) {
                                            report.isActive = true;
                                        }
                                    });
                                });

                            case 1:
                            case "end":
                                return _context20.stop();
                        }
                    }
                }, _callee20, _this26);
            }))();
        },
        getActiveReports: function getActiveReports() {
            var _this27 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
                var response;
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                _context21.prev = 0;
                                _context21.next = 3;
                                return _this27.$axios.get("/Reports").then(function (response) {
                                    _this27.activeReports = response.data;
                                    _this27.changeAuthReports();
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this27.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this27.$ml.get("errors.connectionError"));
                                            _this27.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this27.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 3:
                                response = _context21.sent;
                                _context21.next = 10;
                                break;

                            case 6:
                                _context21.prev = 6;
                                _context21.t0 = _context21["catch"](0);

                                console.error(_context21.t0);
                                alertify.error("Servis Hatası :" + _context21.t0.message);

                            case 10:
                            case "end":
                                return _context21.stop();
                        }
                    }
                }, _callee21, _this27, [[0, 6]]);
            }))();
        },
        reportSetting: function reportSetting() {
            var _this28 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                var tempDate, endDate, i;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                if (_this28.reportResult != [] && _this28.reportResult != null) {
                                    _this28.selectedReportName = _this28.$ml.get("reports.reports.VerticalFirstInLastOutReport");

                                    //Dikey İlk Giriş Son Çıkış Raporu
                                    _this28.reportHeaders = [];
                                    tempDate = new Date(_this28.startDate);
                                    endDate = new Date(_this28.endDate);

                                    for (i = 0; tempDate <= endDate; i++) {
                                        _this28.reportHeaders.push(tempDate.toLocaleDateString("tr-TR", { day: '2-digit', month: '2-digit', year: 'numeric' }));
                                        tempDate.setDate(tempDate.getDate() + 1);
                                    }
                                    _this28.reportDatas = [];
                                    _this28.reportResult.forEach(function (item) {
                                        if (item.veriler.length > 0) {
                                            _this28.reportDatas.push({
                                                departmanAdi: item.departmanAdi,
                                                veriler: item.veriler
                                            });
                                        }
                                    });
                                } else {
                                    _this28.reportHeaders = [];
                                    _this28.reportDatas = null;
                                }

                            case 1:
                            case "end":
                                return _context22.stop();
                        }
                    }
                }, _callee22, _this28);
            }))();
        },
        getReportDetails: function getReportDetails() {
            var _this29 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
                var empIds, reportEndPoint, startDate, endDate, devices, reportOption, response;
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                        switch (_context23.prev = _context23.next) {
                            case 0:
                                if (!(_this29.selectedReportId == 0)) {
                                    _context23.next = 3;
                                    break;
                                }

                                alertify.warning(_this29.$ml.get("alerts.selectedReportNotBlank"));
                                return _context23.abrupt("return");

                            case 3:
                                if (!(_this29.startDate == null || _this29.endDate == null || _this29.startDate > _this29.endDate)) {
                                    _context23.next = 6;
                                    break;
                                }

                                alertify.warning(_this29.$ml.get("alerts.invalidDate"));
                                return _context23.abrupt("return");

                            case 6:
                                _context23.prev = 6;

                                _this29.activeScreen = 3;
                                _this29.isLoading = true;
                                _context23.next = 11;
                                return _this29.getSelectedEmployeeList();

                            case 11:
                                empIds = _context23.sent;
                                reportEndPoint = _this29.selectedReportEndPoint;
                                startDate = _this29.startDate;
                                endDate = _this29.endDate;
                                _context23.next = 17;
                                return _this29.getCheckReaders();

                            case 17:
                                devices = _this29.selectedDevices;
                                reportOption = {
                                    empIds: empIds,
                                    startDate: startDate,
                                    endDate: endDate,
                                    deviceIds: devices
                                };
                                _context23.next = 21;
                                return _this29.$axios.post("/Reports/" + reportEndPoint, reportOption).then(function (response) {
                                    _this29.reportResult = response.data.datas;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this29.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this29.$ml.get("errors.connectionError"));
                                            _this29.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this29.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 21:
                                response = _context23.sent;
                                _context23.next = 24;
                                return _this29.reportSetting();

                            case 24:
                                _this29.reportName = _this29.selectedReportName + " (" + _this29.toDateFormat(_this29.startDate, "gg.aa.yyyy ss:dd") + " - " + _this29.toDateFormat(_this29.endDate, "gg.aa.yyyy ss:dd") + ")";
                                _this29.isLoading = false;
                                _context23.next = 33;
                                break;

                            case 28:
                                _context23.prev = 28;
                                _context23.t0 = _context23["catch"](6);

                                console.error(_context23.t0);
                                alertify.error("Servis Hatası :" + _context23.t0.message);
                                _this29.isLoading = false;

                            case 33:
                            case "end":
                                return _context23.stop();
                        }
                    }
                }, _callee23, _this29, [[6, 28]]);
            }))();
        },
        getEmployees: function getEmployees() {
            var _this30 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
                var employees, filters2, response;
                return regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                        switch (_context24.prev = _context24.next) {
                            case 0:
                                _context24.prev = 0;

                                _this30.isLoadingEmployee = true;
                                _context24.next = 4;
                                return _this30.getCheckDepartmentList();

                            case 4:
                                employees = [];
                                filters2 = _this30.filters;
                                _context24.next = 8;
                                return _this30.$axios.post("/Employees/getByFilter", {
                                    nameOrCardNumber: filters2.nameOrCardNumber,
                                    sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                                    departments: filters2.departments,
                                    accessGroup: filters2.accessGroup,
                                    identityNo: filters2.identityNo,
                                    documentNoOrMail: filters2.documentNoOrMail,
                                    foodGroup: filters2.foodGroup,
                                    workGroupId: filters2.workGroupId,
                                    title: filters2.title,
                                    stateId: filters2.stateId,
                                    statuId: filters2.statuId,
                                    plateNo: filters2.plateNo,
                                    extraField1key: filters2.extraField1key,
                                    extraField1value: filters2.extraField1value,
                                    extraField2key: filters2.extraField2key,
                                    extraField2value: filters2.extraField2value,
                                    extraField3key: filters2.extraField3key,
                                    extraField3value: filters2.extraField3value,
                                    extraField4key: filters2.extraField4key,
                                    extraField4value: filters2.extraField4value,
                                    isVisitor: filters2.isVisitor,
                                    isActive: filters2.isActive
                                }).then(function (response) {
                                    response.data.forEach(function (doc) {
                                        employees.push({
                                            id: doc.id,
                                            name: doc.name,
                                            sicilNo: doc.sicilNo,
                                            title: doc.title,
                                            check: true
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this30.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this30.$ml.get("errors.connectionError"));
                                            _this30.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this30.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 8:
                                response = _context24.sent;

                                _this30.employees = employees;
                                _this30.isLoadingEmployee = false;
                                _context24.next = 18;
                                break;

                            case 13:
                                _context24.prev = 13;
                                _context24.t0 = _context24["catch"](0);

                                console.error(_context24.t0);
                                alertify.error("Servis Hatası :" + _context24.t0.message);
                                _this30.isLoadingEmployee = false;

                            case 18:
                            case "end":
                                return _context24.stop();
                        }
                    }
                }, _callee24, _this30, [[0, 13]]);
            }))();
        },
        checkAllReaders: function checkAllReaders() {
            var _this31 = this;

            this.isCheckReaders = !this.isCheckReaders;
            var aList = this.readers;
            aList.forEach(function (doc) {
                if (doc.check == !_this31.isCheckReaders) {
                    doc.check = _this31.isCheckReaders;
                }
            });
        },
        getCheckReaders: function getCheckReaders() {
            var _this32 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                _this32.selectedDevices = [];
                                _context25.next = 3;
                                return _this32.readers.forEach(function (doc) {
                                    if (doc.check == true) {
                                        _this32.selectedDevices.push(doc.readerId);
                                    }
                                });

                            case 3:
                            case "end":
                                return _context25.stop();
                        }
                    }
                }, _callee25, _this32);
            }))();
        },
        getReaders: function getReaders() {
            var _this33 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
                var readers, response;
                return regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                _context26.prev = 0;
                                readers = [];
                                _context26.next = 4;
                                return _this33.$axios.get("/Terminal/GetReaders").then(function (response) {
                                    if (response.status == 200) {
                                        response.data.forEach(function (doc) {
                                            var isCheckNew = true;
                                            if (doc.doorType != 1) {
                                                isCheckNew == false;
                                            }
                                            if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                                                readers.push({
                                                    readerNo: doc.readerNo,
                                                    readerId: doc.readerId,
                                                    terminalId: doc.terminalId,
                                                    terminalNo: doc.terminalNo,
                                                    ipAddress: doc.ipAddress,
                                                    isActive: doc.isActive,
                                                    doorType: doc.doorType,
                                                    name: doc.name,
                                                    check: isCheckNew
                                                });
                                            }
                                        });
                                    }
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this33.$store.dispatch("logout");
                                        }
                                        if (error.response.status == 500) {
                                            alertify.error(_this33.$ml.get("errors.connectionError"));
                                            _this33.isLoading = false;
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this33.$ml.get("errors.connectionError"));
                                            _this33.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this33.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context26.sent;

                                _this33.readers = readers;
                                _context26.next = 12;
                                break;

                            case 8:
                                _context26.prev = 8;
                                _context26.t0 = _context26["catch"](0);

                                console.error(_context26.t0);
                                alertify.error("Servis Hatası : " + _context26.t0.message);

                            case 12:
                            case "end":
                                return _context26.stop();
                        }
                    }
                }, _callee26, _this33, [[0, 8]]);
            }))();
        },
        getDefaultDate: function getDefaultDate() {
            var toDay = new Date();
            var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
            var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
            var yil = toDay.getFullYear();
            if (this.startDate == null) {
                this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
            }
            if (this.endDate == null) {
                this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
            }
        },
        setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
            var _this34 = this;

            filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
            filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
            filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
            filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
            filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
            this.filters.departments = filter.departments;
            this.filters.nameOrCardNumber = filter.nameOrCardNumber;
            this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
            this.filters.isActive = filter.isActive;
            this.filters.documentNoOrMail = filter.documentNoOrMail;
            this.filters.identityNo = filter.identityNo;
            this.filters.title = filter.title;
            this.filters.extraField1key = filter.extraField1key;
            this.filters.extraField1value = filter.extraField1value;
            this.filters.extraField2key = filter.extraField2key;
            this.filters.extraField2value = filter.extraField2value;
            this.filters.extraField3key = filter.extraField3key;
            this.filters.extraField3value = filter.extraField3value;
            this.filters.extraField4key = filter.extraField4key;
            this.filters.extraField4value = filter.extraField4value;
            this.filters.isVisitor = filter.isVisitor;
            this.filters.plateNo = filter.plateNo;
            //this.filters = filter;
            this.sortableDepartmentList.forEach(function (doc) {
                _this34.filters.departments.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.check = true;
                    }
                });
            });
            this.workGroupList.forEach(function (doc) {
                _this34.filters.workGroupId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.accessGroupList.forEach(function (doc) {
                _this34.filters.accessGroup.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.foodGroupList.forEach(function (doc) {
                _this34.filters.foodGroup.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.stateList.forEach(function (doc) {
                _this34.filters.stateId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.statuList.forEach(function (doc) {
                _this34.filters.statuId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
        },
        getAuthControl: function getAuthControl() {
            var _this35 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
                return regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                if (_this35.authControl == 1) {
                                    alertify.warning(_this35.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                                }

                            case 1:
                            case "end":
                                return _context27.stop();
                        }
                    }
                }, _callee27, _this35);
            }))();
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    mounted: function mounted() {
        var _this36 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
            var filter;
            return regeneratorRuntime.wrap(function _callee28$(_context28) {
                while (1) {
                    switch (_context28.prev = _context28.next) {
                        case 0:
                            _this36.$nextTick(function () {
                                window.addEventListener("resize", _this36.onResize);
                            });
                            _context28.next = 3;
                            return _this36.getAuthControl();

                        case 3:
                            _context28.next = 5;
                            return _this36.getDefaultDate();

                        case 5:
                            _context28.next = 7;
                            return _this36.getDepartments();

                        case 7:
                            _context28.next = 9;
                            return _this36.getAccessGroups();

                        case 9:
                            _context28.next = 11;
                            return _this36.getFoodGroups();

                        case 11:
                            _context28.next = 13;
                            return _this36.getStatus();

                        case 13:
                            _context28.next = 15;
                            return _this36.getStates();

                        case 15:
                            _context28.next = 17;
                            return _this36.getTitles();

                        case 17:
                            _context28.next = 19;
                            return _this36.getWorkGroups();

                        case 19:
                            _context28.next = 21;
                            return _this36.getExtraFields();

                        case 21:
                            _context28.next = 23;
                            return _this36.getReaders();

                        case 23:
                            if (!_this36.defaultFilters) {
                                _context28.next = 30;
                                break;
                            }

                            filter = _this36.defaultFilters;

                            _this36.setUserAuthorityFilter(filter);
                            _context28.next = 28;
                            return _this36.getEmployees();

                        case 28:
                            _context28.next = 32;
                            break;

                        case 30:
                            _context28.next = 32;
                            return _this36.getEmployees();

                        case 32:
                        case "end":
                            return _context28.stop();
                    }
                }
            }, _callee28, _this36);
        }))();
    }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingEmployee: false,
      isLoadingInOuts: false,
      isLoadingPayrolls: false,
      windowHeight: window.innerHeight,
      searchText: "",
      orderEmpList: 1,
      startDate: null,
      endDate: null,
      selectedEmployeeId: null,
      payrollDatas: [],
      checkedRows: [],
      detailData: {
        calculatedOverTime: "00:00",
        confirmedOverTime: "00:00",
        date: "",
        firstEntry: "",
        firstEntryModified: true,
        firstEntryModifiedUserName: "",
        lastExit: "",
        lastExitModified: true,
        lastExitModifiedUserName: "",
        holidayDescription: null,
        missingHour: "",
        totalWorkTime: "",
        workPlan: "",
        check: true,
        name: "",
        registrationNumber: "",
        employeeId: 0
      },
      selectedDateDetails: [],
      isNewInOut: false,
      newInOut: {
        date: "00:00",
        inOrOut: 1,
        readerId: 1
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isCheckDeps: false,
      readers: [],
      extrafields: [],
      workGroups: [],
      allowences: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      sortableDepTrees: [],
      employees: [],
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        plateNo: "",
        hgsNo: "",
        tzCode: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        validityDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: ""
      }
    };
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    readerList: function readerList() {
      return this.readers;
    },
    isCheckedRowList: function isCheckedRowList() {
      return this.checkedRows;
    },
    selectedDateDetailList: function selectedDateDetailList() {
      return this.selectedDateDetails;
    },
    filtered: function filtered() {
      var _this = this;

      if (this.searchText) {
        return this.payrollDataList.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v) || item.registrationNumber.toUpperCase().includes(v);
          });
        });
      } else {
        return this.payrollDataList;
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepTrees.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList: function employeeList() {
      return this.employees;
    },
    payrollDataList: function payrollDataList() {
      if (this.orderEmpList == 1) {
        return this.payrollDatas.sort(function (a, b) {
          return a.registrationNumber.toUpperCase().localeCompare(b.registrationNumber.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.payrollDatas.sort(function (a, b) {
          return b.registrationNumber.toUpperCase().localeCompare(a.registrationNumber.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.payrollDatas.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.payrollDatas.sort(function (a, b) {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    toDateFormatGet: function toDateFormatGet(str) {
      if (!str || str == "-") {
        return "-";
      }
      var gun = str.substr(0, 2);
      var ay = str.substr(3, 2);
      var yil = str.substr(6, 4);
      var saat = str.substr(11, 2);
      var dakika = str.substr(14, 2);
      var saniye = str.substr(17, 2);
      return saat + ":" + dakika;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToExcel: function exportToExcel() {
      if (this.payrollDataList.length == 0) {
        alertify.warning("Lütfen önce verileri görüntüleyin...");
        return;
      }
      var tarih = new Date();
      var filename = "Puantaj Özeti - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    changeSelectedReader: function changeSelectedReader(event) {
      this.newInOut.readerId = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    getAccessGroups: function getAccessGroups() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                accessGroups = [];
                _context.next = 4;
                return _this3.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context.sent;

                _this3.accessGroups = accessGroups;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error("Servis Hatası :" + _context.t0.message);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                departments = [];
                _context2.prev = 1;
                _context2.next = 4;
                return _this4.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this4.departments = departments;
                _this4.sortableTrees();
                _this4.isLoading = false;
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](1);

                console.error(_context2.t0);
                alertify.error(_context2.t0);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this5 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this5.sortableDepTrees.push(dep);
          _this5.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this6 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this6.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this6.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                foodGroups = [];
                _context3.next = 4;
                return _this7.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this7.foodGroups = foodGroups;
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                status = [];
                _context4.next = 4;
                return _this8.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this8.status = status;
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                titles = [];
                _context5.next = 4;
                return _this9.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context5.sent;

                _this9.titles = titles;
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası :" + _context5.t0.message);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                states = [];
                _context6.next = 4;
                return _this10.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context6.sent;

                _this10.states = states;
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                workGroups = [];
                _context7.next = 4;
                return _this11.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      model: doc.model,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context7.sent;

                _this11.workGroups = workGroups;
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this11, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                extrafields = [];
                _context8.next = 4;
                return _this12.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context8.sent;

                _this12.extrafields = extrafields;
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this12, [[0, 8]]);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                dep.check = checkValue;
                _this13.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this13.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this13);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this14.filters.departments = [];
                _context10.next = 3;
                return _this14.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this14);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this15.filters.accessGroup = [];
                _context11.next = 3;
                return _this15.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this15);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this16.filters.stateId = [];
                _context12.next = 3;
                return _this16.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this16);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this17.filters.statuId = [];
                _context13.next = 3;
                return _this17.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this17);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this18.filters.workGroupId = [];
                _context14.next = 3;
                return _this18.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this18);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this19.filters.foodGroup = [];
                _context15.next = 3;
                return _this19.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this19);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this20.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this20.isCheckDeps = !_this20.isCheckDeps;

              case 2:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this20);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                aList = _this21.sortableDepartmentList;

                _this21.filters.departments = [];
                _context17.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this21.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this21.accessGroupList;

                _this21.filters.accessGroup = [];
                _context17.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this21.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this21.workGroupList;

                _this21.filters.workGroupId = [];
                _context17.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this21.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this21.foodGroupList;

                _this21.filters.foodGroup = [];
                _context17.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this21.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this21.statuList;

                _this21.filters.statuId = [];
                _context17.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this21.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this21.stateList;

                _this21.filters.stateId = [];
                _context17.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this21.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this21);
      }))();
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var aList, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                aList = _this22.employees;
                selectedEmployeeList = [];
                _context18.next = 4;
                return aList.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 4:
                return _context18.abrupt("return", selectedEmployeeList);

              case 5:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this22);
      }))();
    },
    deleteMovement: function deleteMovement(empId, empName, date, movement, registrationNumber) {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var response, i;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                if (!(movement.id != 0 && movement.id != null)) {
                  _context19.next = 9;
                  break;
                }

                _context19.next = 4;
                return _this23.$axios.delete("/EmployeeDetails/DeleteEntryExit/" + movement.id).then(function (response) {
                  alertify.success(_this23.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this23.$ml.get("errors.connectionError"));
                    _this23.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this23.isLoadingInOuts = false;
                    return;
                  }
                });

              case 4:
                response = _context19.sent;
                _context19.next = 7;
                return _this23.getPayrollDetail({
                  isOpen: false,
                  employeeId: empId,
                  name: empName,
                  registrationNumber: registrationNumber
                });

              case 7:
                for (i = 0; i < _this23.selectedDateDetails.length; i++) {
                  if (_this23.selectedDateDetails[i].employeeId == empId && _this23.selectedDateDetails[i].date == date) {
                    _this23.selectedDateDetails.splice(i, 1);
                  }
                }
                _this23.getDailyPayrollDetails(date, empId, empName, registrationNumber);

              case 9:
                _context19.next = 14;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](0);

                alertify.error("Hata Oluştu : " + _context19.t0);

              case 14:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this23, [[0, 11]]);
      }))();
    },
    clearInOut: function clearInOut() {
      this.isNewInOut = true;
      this.newInOut.date = "00:00";
      this.newInOut.inOrOut = 1;
      this.newInOut.readerId = 1;
    },
    saveMovement: function saveMovement(date, empId, empName, registrationNumber) {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var gun, ay, yil, date2, today, empId2, inOurOut, inOutAdd, readerId, response, i;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (!(_this24.newInOut.date == "")) {
                  _context20.next = 3;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.invalidDate"));
                return _context20.abrupt("return");

              case 3:
                if (!(_this24.newInOut.readerId == "" || _this24.newInOut.readerId == 0)) {
                  _context20.next = 6;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.notSelectedReader"));
                return _context20.abrupt("return");

              case 6:
                if (!(!date || date == "-")) {
                  _context20.next = 8;
                  break;
                }

                return _context20.abrupt("return", "-");

              case 8:
                gun = date.substr(0, 2);
                ay = date.substr(3, 2);
                yil = date.substr(6, 4);
                date2 = new Date(yil + "-" + ay + "-" + gun + "T" + _this24.newInOut.date + ":00.000Z");
                today = new Date();

                if (!(date2 > today)) {
                  _context20.next = 16;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context20.abrupt("return");

              case 16:
                _context20.prev = 16;
                empId2 = empId;
                inOurOut = _this24.newInOut.inOrOut;
                inOutAdd = date2.toISOString();
                readerId = _this24.newInOut.readerId;
                _context20.next = 23;
                return _this24.$axios.post("/EmployeeDetails/AddEntryExit", {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  readerId: readerId,
                  includePassiveMovements: false,
                  doNotDeleteOvertimes: false,
                  empId: empId2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this24.$ml.get("errors.connectionError"));
                    _this24.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this24.isLoadingInOuts = false;
                    return;
                  }
                });

              case 23:
                response = _context20.sent;

                if (response.status == 200) {
                  alertify.success(_this24.$ml.get("alerts.savedSuccessfully"));
                } else if (response.status == 201) {
                  alertify.error(_this24.$ml.get("alerts.checkTheMealTime"));
                } else {
                  alertify.error(response.message);
                }
                _context20.next = 27;
                return _this24.getPayrollDetail({
                  isOpen: false,
                  employeeId: empId2,
                  name: empName,
                  registrationNumber: ""
                });

              case 27:
                for (i = 0; i < _this24.selectedDateDetails.length; i++) {
                  if (_this24.selectedDateDetails[i].employeeId == empId2 && _this24.selectedDateDetails[i].date == date) {
                    _this24.selectedDateDetails.splice(i, 1);
                  }
                }
                _this24.getDailyPayrollDetails(date, empId2, empName, registrationNumber);
                _this24.clearInOut();
                _context20.next = 36;
                break;

              case 32:
                _context20.prev = 32;
                _context20.t0 = _context20["catch"](16);

                console.error(_context20.t0);
                alertify.error(_context20.t0.message);

              case 36:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this24, [[16, 32]]);
      }))();
    },
    updateMovement: function updateMovement(empId, empName, date, movement, registrationNumber) {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var date3, date2, today, empId2, inOurOut, inOutAdd, readerId, response, i;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(movement.date == "")) {
                  _context21.next = 3;
                  break;
                }

                alertify.warning(_this25.$ml.get("alerts.invalidDate"));
                return _context21.abrupt("return");

              case 3:
                if (!(movement.readerId == "" || movement.readerId == 0)) {
                  _context21.next = 6;
                  break;
                }

                alertify.warning(_this25.$ml.get("alerts.notSelectedReader"));
                return _context21.abrupt("return");

              case 6:
                date3 = _this25.toDateFormat(String(movement.unFormattedDate), "gg.aa.yyyy");
                date2 = new Date(date3 + "T" + movement.date + ":00.000Z");
                today = new Date();

                if (!(date2 > today)) {
                  _context21.next = 12;
                  break;
                }

                alertify.warning(_this25.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context21.abrupt("return");

              case 12:
                _context21.prev = 12;
                empId2 = empId;
                inOurOut = movement.inOrOut;
                inOutAdd = date2.toISOString();
                readerId = movement.readerId;
                _context21.next = 19;
                return _this25.$axios.post("/EmployeeDetails/UpdateEntryExit/" + movement.id, {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  empId: empId2,
                  readerId: readerId
                });

              case 19:
                response = _context21.sent;

                if (response.status == 200) {
                  alertify.success(_this25.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _context21.next = 23;
                return _this25.getPayrollDetail({
                  isOpen: false,
                  employeeId: empId2,
                  name: empName,
                  registrationNumber: registrationNumber
                });

              case 23:
                for (i = 0; i < _this25.selectedDateDetails.length; i++) {
                  if (_this25.selectedDateDetails[i].employeeId == empId2 && _this25.selectedDateDetails[i].date == date) {
                    _this25.selectedDateDetails.splice(i, 1);
                  }
                }
                _this25.getDailyPayrollDetails(date, empId2, empName, registrationNumber);
                _context21.next = 31;
                break;

              case 27:
                _context21.prev = 27;
                _context21.t0 = _context21["catch"](12);

                console.error(_context21.t0);
                alertify.error(_context21.t0.message);

              case 31:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this25, [[12, 27]]);
      }))();
    },
    deleteOverTime: function deleteOverTime(id, date, empId, empName, registrationNumber) {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var response, i;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this26.isLoadingPayrolls = true;
                _context22.next = 4;
                return _this26.$axios.delete("/EmployeeDetails/DeleteConfirmOvertime/" + id).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this26.$ml.get("alerts.confirmedOvertimeDeleted"));
                  } else {
                    response.statusText + " - " + response.data.message;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoadingPayrolls = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoadingPayrolls = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context22.sent;
                _context22.next = 7;
                return _this26.getPayrollDetail({
                  isOpen: false,
                  employeeId: empId,
                  name: empName,
                  registrationNumber: registrationNumber
                });

              case 7:
                for (i = 0; i < _this26.selectedDateDetails.length; i++) {
                  if (_this26.selectedDateDetails[i].employeeId == empId && _this26.selectedDateDetails[i].date == date) {
                    _this26.selectedDateDetails.splice(i, 1);
                  }
                }
                _this26.getDailyPayrollDetails(date, empId, empName, registrationNumber);
                _this26.isLoadingPayrolls = false;
                _context22.next = 17;
                break;

              case 12:
                _context22.prev = 12;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);
                _this26.isLoadingPayrolls = false;

              case 17:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this26, [[0, 12]]);
      }))();
    },
    confirmOverTime: function confirmOverTime(overTimeId, confirmed, calculated, date, empId, empName, registrationNumber) {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var id, calculatedDate, confirmedDate, response, i;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                id = overTimeId;
                calculatedDate = "1900-01-01T" + calculated + ":00";
                confirmedDate = "1900-01-01T" + calculated;

                if (!(confirmedDate > calculatedDate)) {
                  _context23.next = 7;
                  break;
                }

                alertify.warning(_this27.$ml.get("alerts.confirmedOvertimeCannotBeGreaterThanCalculated"));
                return _context23.abrupt("return");

              case 7:
                _this27.isLoadingPayrolls = true;
                _context23.next = 10;
                return _this27.$axios.post("/EmployeeDetails/CustomConfirmOvertime", {
                  id: id,
                  confirmedDate: confirmedDate,
                  overtimeDescriptionId: null,
                  overtimePlaceId: null
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this27.$ml.get("alerts.savedSuccessfully"));
                    _this27.isLoadingPayrolls = false;
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this27.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this27.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 10:
                response = _context23.sent;
                _context23.next = 13;
                return _this27.getPayrollDetail({
                  isOpen: false,
                  employeeId: empId,
                  name: empName,
                  registrationNumber: registrationNumber
                });

              case 13:
                for (i = 0; i < _this27.selectedDateDetails.length; i++) {
                  if (_this27.selectedDateDetails[i].employeeId == empId && _this27.selectedDateDetails[i].date == date) {
                    _this27.selectedDateDetails.splice(i, 1);
                  }
                }
                _this27.getDailyPayrollDetails(date, empId, empName, registrationNumber);
                _context23.next = 21;
                break;

              case 17:
                _context23.prev = 17;
                _context23.t0 = _context23["catch"](0);

                console.error(_context23.t0);
                alertify.error(_context23.t0.message);

              case 21:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this27, [[0, 17]]);
      }))();
    },
    getDailyPayrollDetails: function getDailyPayrollDetails(tarih, empId, empName, registrationNumber) {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var dateDetail, docc, inOutAdd, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                dateDetail = {
                  employeeId: empId,
                  employeeName: empName,
                  registrationNumber: registrationNumber,
                  date: tarih,
                  overtimes: {
                    calculated: "",
                    confirmed: "",
                    overTimeId: null
                  },
                  movements: [],
                  payrolls: []
                };
                docc = tarih.split(".");
                inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
                _context24.next = 6;
                return _this28.$axios.post("/EmployeeDetails/GetDailyPayrollDetails", {
                  date: tarih,
                  empId: empId
                }).then(function (response) {
                  if (response.status == 200) {
                    if (response.data.overtimes) {
                      dateDetail.overtimes = response.data.overtimes;
                    } else {
                      dateDetail.overtimes.calculated = "00:00";
                      dateDetail.overtimes.confirmed = "00:00";
                      dateDetail.overtimes.overTimeId = null;
                    }
                    response.data.movements.forEach(function (a) {
                      var ss = _this28.toDateFormat(a.unFormattedDate, "ss:dd");
                      dateDetail.movements.push({
                        date: ss,
                        id: a.id,
                        inOrOut: a.inOrOut,
                        readerId: a.readerId,
                        status: a.status,
                        unFormattedDate: a.unFormattedDate,
                        check: false
                      });
                    });
                    dateDetail.payrolls = response.data.payrolls;
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this28.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this28.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 6:
                response = _context24.sent;

                _this28.selectedDateDetails.push(dateDetail);
                _context24.next = 14;
                break;

              case 10:
                _context24.prev = 10;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error(_context24.t0.message);

              case 14:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this28, [[0, 10]]);
      }))();
    },
    changeWorkPlan: function changeWorkPlan(detail) {
      this.detailData = detail;
      $('#changePayroll').modal('show');
    },
    checkRow: function checkRow(detail) {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var i;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this29.detailData = detail;
                detail.check = !detail.check;
                if (detail.check == true) {
                  _this29.getDailyPayrollDetails(detail.date, detail.employeeId, detail.name, detail.registrationNumber);
                  _this29.checkedRows.push(detail);
                } else {
                  for (i = 0; i < _this29.checkedRows.length; i++) {
                    if (_this29.checkedRows[i].employeeId == detail.employeeId && _this29.checkedRows[i].date == detail.date) {
                      _this29.checkedRows.splice(i, 1);
                    }
                  }
                  for (i = 0; i < _this29.selectedDateDetails.length; i++) {
                    if (_this29.selectedDateDetails[i].employeeId == detail.employeeId && _this29.selectedDateDetails[i].date == detail.date) {
                      _this29.selectedDateDetails.splice(i, 1);
                    }
                  }
                }

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this29);
      }))();
    },
    setChangePayroll: function setChangePayroll(contextId, isAllowence) {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var data, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                if (!(_this30.detailData == null || _this30.detailData.employeeId == 0)) {
                  _context26.next = 3;
                  break;
                }

                alertify.warning("Lütfen seçim yapınız...");
                return _context26.abrupt("return");

              case 3:
                _context26.prev = 3;

                _this30.isLoadingEmployee = true;
                data = [];

                data.push({
                  empId: _this30.detailData.employeeId,
                  date: _this30.detailData.date,
                  contextId: contextId,
                  isAllowence: isAllowence
                });
                console.log(data);
                _context26.next = 10;
                return _this30.$axios.post("/Shift/ChangePayroll", data).then(function (response) {
                  _this30.getPayrollDetail(_this30.detailData);
                  alertify.success("İşlem Tamamlandı!");
                  _this30.isLoadingEmployee = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this30.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context26.sent;
                _context26.next = 18;
                break;

              case 13:
                _context26.prev = 13;
                _context26.t0 = _context26["catch"](3);

                console.error(_context26.t0);
                alertify.error("Servis Hatası :" + _context26.t0.message);
                _this30.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this30, [[3, 13]]);
      }))();
    },
    getPayrollDetail: function getPayrollDetail(emplo) {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;

                if (!(_this31.startDate == null || _this31.endDate == null)) {
                  _context27.next = 4;
                  break;
                }

                alertify.warning("Tarihleri kontrol edin...");
                return _context27.abrupt("return");

              case 4:
                /*if (emplo.isOpen == true) {
                  emplo.isOpen = false;
                }*/
                _this31.selectedEmployeeId = emplo.employeeId;
                _this31.isLoadingEmployee = true;
                _context27.next = 8;
                return _this31.$axios.post("/Shift/Details", {
                  employeeId: _this31.selectedEmployeeId,
                  startDate: _this31.startDate,
                  endDate: _this31.endDate
                }).then(function (response) {
                  var a = _this31.payrollDatas.filter(function (emp) {
                    return emp.employeeId == _this31.selectedEmployeeId;
                  });
                  if (a[0]) {
                    a[0].isOpen = true;
                    a[0].payrollDetails = [];
                    response.data.forEach(function (data) {
                      var checked = false;
                      var record = _this31.checkedRows.filter(function (b) {
                        return b.date == data.date && b.employeeId == _this31.selectedEmployeeId;
                      });
                      if (record[0]) {
                        checked = true;
                      }
                      a[0].payrollDetails.push({
                        calculatedOverTime: data.calculatedOverTime,
                        confirmedOverTime: data.confirmedOverTime,
                        date: data.date,
                        firstEntry: data.firstEntry,
                        firstEntryModified: data.firstEntryModified,
                        firstEntryModifiedUserName: data.firstEntryModifiedUserName,
                        lastExit: data.lastExit,
                        lastExitModified: data.lastExitModified,
                        lastExitModifiedUserName: data.lastExitModifiedUserName,
                        holidayDescription: data.holidayDescription,
                        missingHour: data.missingHour,
                        totalWorkTime: data.totalWorkTime,
                        workPlan: data.workPlan,
                        check: checked,
                        name: emplo.name,
                        registrationNumber: emplo.registrationNumber,
                        employeeId: _this31.selectedEmployeeId
                      });
                    });
                  }
                  _this31.isLoadingEmployee = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this31.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context27.sent;
                _context27.next = 16;
                break;

              case 11:
                _context27.prev = 11;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error("Servis Hatası :" + _context27.t0.message);
                _this31.isLoadingEmployee = false;

              case 16:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this31, [[0, 11]]);
      }))();
    },
    getData: function getData() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var payrollDatas, empIds, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _this32.selectedDateDetails = [];
                _this32.checkedRows = [];
                _context28.prev = 2;

                if (!(_this32.startDate == null || _this32.endDate == null)) {
                  _context28.next = 6;
                  break;
                }

                alertify.warning("Tarihleri kontrol edin...");
                return _context28.abrupt("return");

              case 6:
                _this32.isLoadingEmployee = true;
                payrollDatas = [];
                _context28.next = 10;
                return _this32.getSelectedEmployeeList();

              case 10:
                empIds = _context28.sent;
                _context28.next = 13;
                return _this32.$axios.post("/Shift", {
                  employeeIds: empIds,
                  startDate: _this32.startDate,
                  endDate: _this32.endDate
                }).then(function (response) {
                  response.data.forEach(function (a) {
                    payrollDatas.push({
                      employeeId: a.employeeId,
                      name: a.name,
                      registrationNumber: a.registrationNumber,
                      title: a.title,
                      totalCalculatedOvertime: a.totalCalculatedOvertime,
                      totalConfirmedOvertime: a.totalConfirmedOvertime,
                      totalHoliday: a.totalHoliday,
                      totalMissingHour: a.totalMissingHour,
                      totalWorkTime: a.totalWorkTime,
                      workPlan: a.workPlan,
                      payrollDetails: [],
                      isOpen: false,
                      allCheck: false
                    });
                  });
                  _this32.isLoadingEmployee = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this32.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 13:
                response = _context28.sent;

                _this32.payrollDatas = payrollDatas;
                _context28.next = 22;
                break;

              case 17:
                _context28.prev = 17;
                _context28.t0 = _context28["catch"](2);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);
                _this32.isLoadingEmployee = false;

              case 22:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this32, [[2, 17]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;

                _this33.isLoadingEmployee = true;
                _context29.next = 4;
                return _this33.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this33.filters;
                _context29.next = 8;
                return _this33.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: false
                    });
                  });
                  //this.filtersClear();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this33.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context29.sent;

                _this33.employees = employees;
                _this33.isLoadingEmployee = false;
                _context29.next = 18;
                break;

              case 13:
                _context29.prev = 13;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error("Servis Hatası :" + _context29.t0.message);
                _this33.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this33, [[0, 13]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                allowences = [];
                _context30.next = 4;
                return _this34.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this34.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this34.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this34.allowences = allowences;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Servis Hatası :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this34, [[0, 8]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this35 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this35.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this35.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this35.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this35.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this35.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this35.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getReaders: function getReaders() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                readers = [];
                _context31.next = 4;
                return _this36.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 1) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          inOrOut: doc.inOrOut,
                          check: false,
                          VCGcheck: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this36.$ml.get("alerts.getReadersError"));
                      _this36.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context31.sent;

                _this36.readers = readers;
                _context31.next = 12;
                break;

              case 8:
                _context31.prev = 8;
                _context31.t0 = _context31["catch"](0);

                console.error(_context31.t0);
                alertify.error("Servis Hatası : " + _context31.t0.message);

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this36, [[0, 8]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this37 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      var filter;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _this37.getDefaultDate();
              if (_this37.defaultFilters) {
                filter = _this37.defaultFilters;

                _this37.setUserAuthorityFilter(filter);
                _this37.getEmployees();
              }
              _this37.getDepartments();
              _this37.getAccessGroups();
              if (_this37.modules.diningHall) {
                _this37.getFoodGroups();
              }
              _this37.getReaders();
              _this37.getStatus();
              _this37.getStates();
              _this37.getTitles();
              _this37.getWorkGroups();
              _this37.getExtraFields();
              _this37.getAllowences();

            case 12:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, _this37);
    }))();
  }
});

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            isLoading: false,
            workGroupIsActive: false,
            allowenceIsActive: false,
            selectedAllowence: {
                id: null,
                name: ""
            },
            selectedWorkGroup: {
                id: null,
                name: ""
            },
            selectedBatchShiftList: [],
            windowHeight: window.innerHeight,
            searchText: "",
            orderEmpList: 1,
            isConfirm: true,
            isForbidden: false,
            startDateNow: null,
            endDateNow: null,
            year: 0,
            monthOrWeekNumber: 0,
            selectedEmployee: {
                empId: null,
                sicilNo: "",
                name: "",
                title: "",
                terminalNo: ""
            },
            selectedShift: {
                id: null,
                empId: null,
                date: null,
                entry: null,
                exit: null,
                toleranceEntry: null,
                toleranceExit: null,
                allowenceId: null,
                allowenceName: "",
                confirmedUserId: null,
                confirmStatus: 0,
                workGroupId: null,
                workGroupName: ""
            },
            readers: [],
            includePassiveMovements: false,
            doNotDeleteOvertimes: false,
            isNewInOut2: true,
            isActiveInOut2: false,
            inOut2: {
                inOutId: null,
                inOutListType: 0,
                inOutListDoorType: 4,
                inOutType: 0,
                inOutAdd: "",
                readerId: "0"
            },
            overtimeDescriptions: [],
            overtimePlaces: [],
            selectedOTPlaceId: null,
            selectedOTDescriptionId: null,
            selectedDailyPayrol: {
                date: "",
                workGroup: "",
                movements: [],
                payrolls: [],
                calculatedOverTime: "00:00",
                confirmedOverTime: "00:00",
                overTimeId: null
            },
            selectedWeek: null,
            selectedDays: [],
            filters: {
                nameOrCardNumber: "",
                sicilOrTerminalNo: null,
                departments: [],
                accessGroup: [],
                identityNo: "",
                documentNoOrMail: "",
                foodGroup: [],
                workGroupId: [],
                title: "",
                stateId: [],
                statuId: [],
                plateNo: "",
                extraField1key: 0,
                extraField1value: "",
                extraField2key: 0,
                extraField2value: "",
                extraField3key: 0,
                extraField3value: "",
                extraField4key: 0,
                extraField4value: "",
                isVisitor: false,
                isActive: true
            },
            isCheckDeps: false,
            extrafields: [],
            workGroups: [],
            status: [],
            states: [],
            foodGroups: [],
            titles: [],
            accessGroups: [],
            departments: [],
            sortableDepTrees: [],
            colorPalette: ["background-color:#ecf0f5;color:#333333;", "background-color:#758ead;color:#ffffff;", "background-color:#9d75ad;color:#ffffff;", "background-color:#dd9999;color:#333333;", "background-color:#d4dd99;color:#333333;", "background-color:#99cbdd;color:#333333;", "background-color:#d599dd;color:#333333;", "background-color:#f1ba98;color:#333333;", "background-color:#77b8bf;color:#333333;", "background-color:#7782bf;color:#ffffff;"],
            shifts: [],
            allowences: [],
            employeeAllCheck: false,
            employees: [],
            employee: {
                id: null,
                name: "",
                title: "",
                sicilNo: "",
                image: null,
                departmentId: null,
                identityNo: "",
                terminalNo: null
            }
        };
    },

    computed: {
        getAuthType: function getAuthType() {
            return this.$store.getters.getUser.authType;
        },
        getShiftAuthority: function getShiftAuthority() {
            return this.$store.getters.getAuthority.shiftYetkileri;
        },
        authControl: function authControl() {
            return this.$store.getters.getAuthTanimlamalar;
        },
        readerList: function readerList() {
            return this.readers.sort(function (a, b) {
                if (a.ipAddress < b.ipAddress) return -1;
                if (a.ipAddress > b.ipAddress) return 0;
            });
        },
        activePDKSReaderList: function activePDKSReaderList() {
            return this.readerList.filter(function (item) {
                return item.isActive == true && item.doorType == 1;
            });
        },
        dailyPayrollDetailList: function dailyPayrollDetailList() {
            return this.selectedDailyPayrol.payrolls;
        },
        dailyInOutDetailList: function dailyInOutDetailList() {
            return this.selectedDailyPayrol.movements;
        },
        overtimeDescriptionList: function overtimeDescriptionList() {
            return this.overtimeDescriptions;
        },
        overtimePlaceList: function overtimePlaceList() {
            return this.overtimePlaces;
        },
        isAdmin: function isAdmin() {
            if (this.getShiftAuthority.canPlan && this.getShiftAuthority.canConfirmShift || this.getShiftAuthority.canPlanAllowence && this.getShiftAuthority.canConfirmAllowence) {
                return true;
            } else {
                return false;
            }
        },
        shiftDateAuth: function shiftDateAuth() {
            var now = new Date();
            var start = this.dayList[0];
            var startDay = start.substring(0, 2);
            var startMonth = start.substring(3, 5);
            var startYear = start.substring(6, 10);
            var startDate = new Date(startYear + "-" + startMonth + "-" + startDay);
            var end = this.dayList[this.dayList.length - 1];
            var endDay = end.substring(0, 2);
            var endMonth = end.substring(3, 5);
            var endYear = end.substring(6, 10);
            var endDate = new Date(endYear + "-" + endMonth + "-" + endDay);
            if (startDate >= now && endDate <= now) {
                return true;
            } else if (startDate < now) {
                return false;
            } else {
                return true;
            }
            return true;
        },
        shiftAuthStatus: function shiftAuthStatus() {
            if (this.monthOrWeekNumber != 0 && this.year != 0 && this.dayList.length > 0) {
                if (this.isAdmin) {
                    return true; //Admin ise tam yetkiye sahip
                } else {
                    return !this.isForbidden;
                }
            } else {
                return false;
            }
        },
        defaultFilters: function defaultFilters() {
            return this.$store.getters.getDefaultFilters;
        },
        modules: function modules() {
            return this.$store.getters.getModules;
        },
        dayList: function dayList() {
            return this.selectedDays;
        },
        shiftList: function shiftList() {
            var _this = this;

            if (this.searchText) {
                return this.shifts.filter(function (item) {
                    return _this.searchText.toUpperCase().split(" ").every(function (v) {
                        return item.name.toUpperCase().includes(v) || item.sicilNo.toUpperCase().includes(v);
                    });
                });
            } else {
                return this.shifts;
            }
        },
        allowenceList: function allowenceList() {
            return this.allowences;
        },
        departmentList: function departmentList() {
            return this.departments;
        },
        sortableDepartmentList: function sortableDepartmentList() {
            return this.sortableDepTrees;
        },
        checkedDepartmentList: function checkedDepartmentList() {
            var checkedList = "";
            var list = this.sortableDepTrees.forEach(function (a) {
                if (a.check == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        employeeList: function employeeList() {
            if (this.orderEmpList == 1) {
                return this.employees.sort(function (a, b) {
                    return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
                });
            } else if (this.orderEmpList == 2) {
                return this.employees.sort(function (a, b) {
                    return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
                });
            } else if (this.orderEmpList == 3) {
                return this.employees.sort(function (a, b) {
                    return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                });
            } else {
                return this.employees.sort(function (a, b) {
                    return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
                });
            }
        },
        titleList: function titleList() {
            return this.titles;
        },
        stateList: function stateList() {
            return this.states;
        },
        checkedStateList: function checkedStateList() {
            var checkedList = "";
            var list = this.stateList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        statuList: function statuList() {
            return this.status;
        },
        checkedStatusList: function checkedStatusList() {
            var checkedList = "";
            var list = this.statuList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        extraFieldList: function extraFieldList() {
            return this.extrafields;
        },
        workGroupList: function workGroupList() {
            return this.workGroups;
        },
        periodWorkGroupList: function periodWorkGroupList() {
            return this.workGroups.filter(function (item) {
                return item.isPeriod == true || item.model == 4 || item.model == 3;
            });
        },
        checkedWorkGroupList: function checkedWorkGroupList() {
            var checkedList = "";
            var list = this.periodWorkGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        accessGroupList: function accessGroupList() {
            return this.accessGroups;
        },
        checkedAccessGroupList: function checkedAccessGroupList() {
            var checkedList = "";
            var list = this.accessGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        foodGroupList: function foodGroupList() {
            return this.foodGroups;
        },
        checkedFoodGroupList: function checkedFoodGroupList() {
            var checkedList = "";
            var list = this.foodGroupList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        windowHeightSize: function windowHeightSize() {
            if (this.windowHeight) {
                var height = this.windowHeight - 220;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    filters: {
        fixedFive: function fixedFive(str) {
            var str2 = "" + str;
            var pad = "00000";
            return pad.substring(0, pad.length - str2.length) + str2;
        },
        gunAdi: function gunAdi(tarihStr) {
            if (!tarihStr) return "";

            var tarih = void 0; // örn: "26.01.2026" veya "2026-02-03T00:00:00"

            // DD.MM.YYYY formatı
            if (tarihStr.includes(".")) {
                var _tarihStr$split = tarihStr.split("."),
                    _tarihStr$split2 = _slicedToArray(_tarihStr$split, 3),
                    gun = _tarihStr$split2[0],
                    ay = _tarihStr$split2[1],
                    yil = _tarihStr$split2[2];

                tarih = new Date(yil, ay - 1, gun);
            }
            // ISO format: YYYY-MM-DDTHH:mm:ss
            else {
                    tarih = new Date(tarihStr);
                }

            if (isNaN(tarih.getTime())) return "";

            var gunler = ["Pazar", "Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi"];

            return gunler[tarih.getDay()];
        },
        toDateFormatGet: function toDateFormatGet(str, format) {
            if (!str) {
                return "";
            }
            str = new Date(str);
            var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
            var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
            var yil = str.getFullYear();
            var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
            var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
            var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
            if (format == "gg.aa.yyyy ss:dd") {
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                return gun + "." + ay + "." + yil;
            } else if (format == "ss:dd:ss") {
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                return saat + ":" + dakika;
            }
        }
    },
    watch: {
        windowHeight: function windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                    //WEB
                }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            window.addEventListener("resize", _this2.onResize);
        });
    },

    methods: {
        toDateFormat: function toDateFormat(str, format) {
            if (!str) {
                return "";
            }
            str = new Date(str);
            var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
            var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
            var yil = str.getFullYear();
            var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
            var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
            var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
            if (format == "gg.aa.yyyy ss:dd") {
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                return gun + "." + ay + "." + yil;
            } else if (format == "yyyy-aa-ggTss:dd") {
                return yil + "-" + ay + "-" + gun + "T" + saat + ":" + dakika;
            } else if (format == "ss:dd:ss") {
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                return saat + ":" + dakika;
            }
        },
        getDateOfIsOWeek: function getDateOfIsOWeek(event) {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var inp;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this3.isLoading = true;
                                inp = _this3.selectedWeek;

                                _this3.year = parseInt(inp.slice(0, 4), 10);
                                _this3.monthOrWeekNumber = parseInt(inp.slice(6), 10);
                                _context.next = 6;
                                return _this3.getCalendar();

                            case 6:
                                _context.next = 8;
                                return _this3.getRealMovements();

                            case 8:
                                _this3.isLoading = false;

                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
        },
        exportToPDF: function exportToPDF() {
            this.$htmlToPaper("printShiftPlan");
        },
        bgColorShiftEntry: function bgColorShiftEntry(shift) {
            if (shift.toleranceEntry) {
                if (shift.entry > shift.toleranceEntry) {
                    return "badge label-danger";
                } else {
                    return "badge default-label";
                }
            } else {
                return "badge default-label";
            }
        },
        bgColorShiftExit: function bgColorShiftExit(shift) {
            if (shift.toleranceExit) {
                if (shift.exit < shift.toleranceExit) {
                    return "badge label-danger";
                } else {
                    return "badge default-label";
                }
            } else {
                return "badge default-label";
            }
        },
        bgColorAllowence: function bgColorAllowence(allowenceId) {
            if (allowenceId) {
                var list = this.allowenceList.filter(function (a) {
                    return a.id == allowenceId;
                });
                if (list[0]) {
                    return "background-color: rgb(" + list[0].r + "," + list[0].g + "," + list[0].b + ");color:#ffffff;";
                } else {
                    return "";
                }
            } else {
                return "";
            }
        },
        setOrderEmp: function setOrderEmp(number) {
            if (number == 1) {
                if (this.orderEmpList == 1) {
                    this.orderEmpList = 2;
                } else {
                    this.orderEmpList = 1;
                }
            } else {
                if (this.orderEmpList == 3) {
                    this.orderEmpList = 4;
                } else {
                    this.orderEmpList = 3;
                }
            }
        },
        getAllowenceNameFromId: function getAllowenceNameFromId(allowenceId) {
            var a = this.allowenceList.filter(function (allowence) {
                return allowence.id == allowenceId;
            });
            if (a[0]) {
                return a[0].name;
            } else {
                return "-";
            }
        },
        getWorkGroupNameFromId: function getWorkGroupNameFromId(workGroupId) {
            var a = this.workGroupList.filter(function (workGroup) {
                return workGroup.id == workGroupId;
            });
            if (a[0]) {
                return a[0].name;
            } else {
                return "-";
            }
        },
        changeAllowence: function changeAllowence(event) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (!(event.target.value == 0)) {
                                    _context2.next = 5;
                                    break;
                                }

                                _this4.selectedShift.allowenceId = null;
                                _this4.selectedShift.allowenceName = "";
                                _context2.next = 11;
                                break;

                            case 5:
                                _this4.selectedShift.allowenceId = event.target.value;
                                _context2.next = 8;
                                return _this4.getAllowenceNameFromId(event.target.value);

                            case 8:
                                _this4.selectedShift.allowenceName = _context2.sent;

                                _this4.selectedShift.workGroupId = null;
                                _this4.selectedShift.workGroupName = "";

                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        changeWorkGroup: function changeWorkGroup(event) {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(event.target.value == 0)) {
                                    _context3.next = 5;
                                    break;
                                }

                                _this5.selectedShift.workGroupId = null;
                                _this5.selectedShift.workGroupName = "";
                                _context3.next = 11;
                                break;

                            case 5:
                                _this5.selectedShift.workGroupId = event.target.value;
                                _context3.next = 8;
                                return _this5.getWorkGroupNameFromId(event.target.value);

                            case 8:
                                _this5.selectedShift.workGroupName = _context3.sent;

                                _this5.selectedShift.allowenceId = null;
                                _this5.selectedShift.allowenceName = "";

                            case 11:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5);
            }))();
        },
        changeFilterTitles: function changeFilterTitles(event) {
            this.filters.title = event.target.value;
        },
        changeFilterExtraField1: function changeFilterExtraField1(event) {
            this.filters.extraField1key = event.target.value;
            if (!this.filters.extraField1key) {
                this.filters.extraField1key = 0;
            }
        },
        changeFilterExtraField2: function changeFilterExtraField2(event) {
            this.filters.extraField2key = event.target.value;
            if (!this.filters.extraField2key) {
                this.filters.extraField2key = 0;
            }
        },
        changeFilterExtraField3: function changeFilterExtraField3(event) {
            this.filters.extraField3key = event.target.value;
            if (!this.filters.extraField3key) {
                this.filters.extraField3key = 0;
            }
        },
        changeFilterExtraField4: function changeFilterExtraField4(event) {
            this.filters.extraField4key = event.target.value;
            if (!this.filters.extraField4key) {
                this.filters.extraField4key = 0;
            }
        },
        filtersClear: function filtersClear() {
            this.filters.nameOrCardNumber = "";
            this.filters.sicilOrTerminalNo = null;
            this.filters.departments = [];
            this.filters.accessGroup = [];
            this.filters.identityNo = "";
            this.filters.documentNoOrMail = "";
            this.filters.foodGroup = [];
            this.filters.workGroupId = [];
            this.filters.title = "";
            this.filters.stateId = [];
            this.filters.statuId = [];
            this.filters.plateNo = "";
            this.filters.extraField1key = 0;
            this.filters.extraField1value = "";
            this.filters.extraField2key = 0;
            this.filters.extraField2value = "";
            this.filters.extraField3key = 0;
            this.filters.extraField3value = "";
            this.filters.extraField4key = 0;
            this.filters.extraField4value = "";
            this.filters.isVisitor = false;
            this.filters.isActive = true;
            this.accessGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.sortableDepartmentList.forEach(function (a) {
                a.check = false;
            });
            this.foodGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.workGroupList.forEach(function (a) {
                a.isCheck = false;
            });
            this.stateList.forEach(function (a) {
                a.isCheck = false;
            });
            this.statuList.forEach(function (a) {
                a.isCheck = false;
            });
        },
        checkListControl: function checkListControl(shift, empId) {
            var contextId = this.selectedWorkGroup.id;
            var isAllowence = false;
            if (this.selectedAllowence.id != null) {
                contextId = this.selectedAllowence.id;
                isAllowence = true;
            }
            var date = this.toDateFormat(shift.date, "gg.aa.yyyy");
            var result = this.selectedBatchShiftList.filter(function (item) {
                return item.contextId == contextId && item.empId == empId && item.date == date;
            });
            if (result.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        selectWorkGroup: function selectWorkGroup(workGroup) {
            if (this.selectedWorkGroup.id && this.selectedWorkGroup.id == workGroup.id) {
                this.selectedWorkGroup = { id: null, name: "" };
                this.selectedBatchShiftList = [];
            } else {
                this.selectedWorkGroup.id = workGroup.id;
                this.selectedWorkGroup.name = workGroup.name;
                this.selectedAllowence = { id: null, name: "" };
                alertify.message("Seçilen çalışma grubuna ait planlarda değişiklik yapabilirsiniz.");
            }
        },
        selectAllowence: function selectAllowence(allowence) {
            if (this.selectedAllowence && this.selectedAllowence.id == allowence.id) {
                this.selectedAllowence = { id: null, name: "" };
                this.selectedBatchShiftList = [];
            } else {
                this.selectedAllowence.id = allowence.id;
                this.selectedAllowence.name = allowence.name;
                this.selectedWorkGroup = { id: null, name: "" };
                alertify.message("Seçilen izin grubuna ait planlarda değişiklik yapabilirsiniz.");
            }
        },
        selectBatchShift: function selectBatchShift(shift) {
            console.log(shift);
            var contextId = this.selectedWorkGroup.id;
            var isAllowence = false;
            if (this.selectedAllowence.id != null) {
                contextId = this.selectedAllowence.id;
                isAllowence = true;
            }
            var date = this.toDateFormat(shift.date, "gg.aa.yyyy");
            var result = this.selectedBatchShiftList.filter(function (item) {
                if (isAllowence) {
                    return item.contextId == contextId && item.isAllowence == true && item.empId == shift.empId && item.date == date;
                } else {
                    return item.contextId == contextId && item.isAllowence == false && item.empId == shift.empId && item.date == date;
                }
            });
            if (result.length > 0) {
                //Eğer seçili ise selectedBatchShiftList içinden çıkar
                this.selectedBatchShiftList = this.selectedBatchShiftList.filter(function (item) {
                    if (isAllowence) {
                        return !(item.contextId == contextId && item.isAllowence == true && item.empId == shift.empId && item.date == date);
                    } else {
                        return !(item.contextId == contextId && item.isAllowence == false && item.empId == shift.empId && item.date == date);
                    }
                });
            } else {
                this.selectedBatchShiftList.push({
                    empId: shift.empId,
                    date: date,
                    contextId: parseInt(contextId),
                    isAllowence: isAllowence
                });
            }
            console.log(this.selectedBatchShiftList);
        },
        clearSelectedBatchShift: function clearSelectedBatchShift() {
            this.selectedBatchShiftList = [];
            this.selectedWorkGroup = { id: null, name: "" };
            this.selectedAllowence = { id: null, name: "" };
        },
        saveBatchShift: function saveBatchShift() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                _this6.isLoading = true;
                                _context4.next = 4;
                                return _this6.$axios.post("/Shift/ChangePayroll", _this6.selectedBatchShiftList).then(function (response) {
                                    _this6.getRealMovements();
                                    _this6.clearSelectedBatchShift();
                                    alertify.success("İşlem Tamamlandı!");
                                    _this6.isLoading = false;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this6.$store.dispatch("logout");
                                        } else if (error.response.status == 403) {
                                            alertify.message(_this6.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this6.$ml.get("errors.connectionError"));
                                            _this6.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this6.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context4.sent;
                                _context4.next = 12;
                                break;

                            case 7:
                                _context4.prev = 7;
                                _context4.t0 = _context4["catch"](0);

                                console.error(_context4.t0);
                                alertify.error("Servis Hatası :" + _context4.t0.message);
                                _this6.isLoading = false;

                            case 12:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6, [[0, 7]]);
            }))();
        },
        selectShift: function selectShift(shift, emp) {
            this.selectedShift.id = shift.id;
            this.selectedShift.empId = shift.empId;
            this.selectedShift.date = shift.date;
            this.selectedShift.entry = shift.entry;
            this.selectedShift.exit = shift.exit;
            this.selectedShift.toleranceEntry = shift.toleranceEntry;
            this.selectedShift.toleranceExit = shift.toleranceExit;
            this.selectedShift.allowenceId = shift.allowenceId;
            this.selectedShift.allowenceName = shift.allowenceName;
            this.selectedShift.workGroupId = shift.workGroupId;
            this.selectedShift.workGroupName = shift.workGroupName;
            this.selectedEmployee.empId = emp.empId;
            this.selectedEmployee.title = emp.title;
            this.selectedEmployee.sicilNo = emp.sicilNo;
            this.selectedEmployee.terminalNo = emp.terminalNo;
            this.selectedEmployee.name = emp.name;
            this.getDailyPayrollDetails(shift.date, shift.workGroupName, emp.empId);
            $("#modal-shift").modal("show");
        },
        getAccessGroups: function getAccessGroups() {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var accessGroups, response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;
                                accessGroups = [];
                                _context5.next = 4;
                                return _this7.$axios.get("/AccessGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        accessGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isNewReaderAdd: doc.isNewReaderAdd,
                                            selectedReaders: doc.postReaders,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this7.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this7.$ml.get("errors.connectionError"));
                                            _this7.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this7.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context5.sent;

                                _this7.accessGroups = accessGroups;
                                _context5.next = 12;
                                break;

                            case 8:
                                _context5.prev = 8;
                                _context5.t0 = _context5["catch"](0);

                                console.error(_context5.t0);
                                alertify.error("Servis Hatası :" + _context5.t0.message);

                            case 12:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7, [[0, 8]]);
            }))();
        },
        getDepartments: function getDepartments() {
            var _this8 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var departments, response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                departments = [];
                                _context6.prev = 1;
                                _context6.next = 4;
                                return _this8.$axios.get("/Department").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        departments.push({
                                            id: doc.id,
                                            name: doc.name,
                                            mainDepartmentId: doc.mainDepartmentId,
                                            isActive: doc.isActive,
                                            locationTree: doc.locationTree,
                                            check: false
                                        });
                                    });
                                    departments.sort(function (a, b) {
                                        if (a.locationTree < b.locationTree) return -1;
                                        if (a.locationTree > b.locationTree) return 0;
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this8.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this8.$ml.get("errors.connectionError"));
                                            _this8.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this8.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context6.sent;

                                _this8.departments = departments;
                                _this8.sortableTrees();
                                _this8.isLoading = false;
                                _context6.next = 14;
                                break;

                            case 10:
                                _context6.prev = 10;
                                _context6.t0 = _context6["catch"](1);

                                console.error(_context6.t0);
                                alertify.error(_context6.t0);

                            case 14:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8, [[1, 10]]);
            }))();
        },
        sortableTrees: function sortableTrees() {
            var _this9 = this;

            this.sortableDepTrees = [];
            this.departments.forEach(function (dep) {
                if (dep.mainDepartmentId == null) {
                    _this9.sortableDepTrees.push(dep);
                    _this9.subDepImport(dep);
                }
            });
        },
        subDepImport: function subDepImport(dep) {
            var _this10 = this;

            var subDep = this.departments.filter(function (doc) {
                return doc.mainDepartmentId == dep.id;
            });
            if (subDep.length > 0) {
                var ekle = "";
                var ek = subDep[0].locationTree.split("/");
                for (var index = 0; index < ek.length - 3; index++) {
                    ekle = "--/" + ekle;
                }
                subDep.forEach(function (doc2) {
                    _this10.sortableDepTrees.push({
                        id: doc2.id,
                        name: ekle + " " + doc2.name,
                        mainDepartmentId: doc2.mainDepartmentId,
                        isActive: doc2.isActive,
                        locationTree: doc2.locationTree,
                        userId: doc2.userId,
                        check: doc2.check
                    });
                    _this10.subDepImport(doc2);
                });
            }
        },
        getFoodGroups: function getFoodGroups() {
            var _this11 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var foodGroups, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.prev = 0;
                                foodGroups = [];
                                _context7.next = 4;
                                return _this11.$axios.get("/FoodGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        foodGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            type: doc.type,
                                            singleFoodEachMeal: doc.singleFoodEachMeal,
                                            meals: doc.meals,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this11.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this11.$ml.get("errors.connectionError"));
                                            _this11.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this11.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context7.sent;

                                _this11.foodGroups = foodGroups;
                                _context7.next = 12;
                                break;

                            case 8:
                                _context7.prev = 8;
                                _context7.t0 = _context7["catch"](0);

                                console.error(_context7.t0);
                                alertify.error("Servis Hatası :" + _context7.t0.message);

                            case 12:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this11, [[0, 8]]);
            }))();
        },
        getStatus: function getStatus() {
            var _this12 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var status, response;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                _context8.prev = 0;
                                status = [];
                                _context8.next = 4;
                                return _this12.$axios.get("/Employees/getStatus").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        status.push({
                                            id: doc.id,
                                            name: doc.name,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this12.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this12.$ml.get("errors.connectionError"));
                                            _this12.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this12.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context8.sent;

                                _this12.status = status;
                                _context8.next = 12;
                                break;

                            case 8:
                                _context8.prev = 8;
                                _context8.t0 = _context8["catch"](0);

                                console.error(_context8.t0);
                                alertify.error("Servis Hatası :" + _context8.t0.message);

                            case 12:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this12, [[0, 8]]);
            }))();
        },
        getTitles: function getTitles() {
            var _this13 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var titles, response;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.prev = 0;
                                titles = [];
                                _context9.next = 4;
                                return _this13.$axios.get("/Employees/getTitles").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        titles.push({
                                            name: doc
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this13.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this13.$ml.get("errors.connectionError"));
                                            _this13.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this13.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context9.sent;

                                _this13.titles = titles;
                                _context9.next = 12;
                                break;

                            case 8:
                                _context9.prev = 8;
                                _context9.t0 = _context9["catch"](0);

                                console.error(_context9.t0);
                                alertify.error("Servis Hatası :" + _context9.t0.message);

                            case 12:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this13, [[0, 8]]);
            }))();
        },
        getStates: function getStates() {
            var _this14 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var states, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.prev = 0;
                                states = [];
                                _context10.next = 4;
                                return _this14.$axios.get("/Employees/getStates").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        states.push({
                                            id: doc.id,
                                            name: doc.name,
                                            status: doc.status,
                                            isCheck: false
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this14.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this14.$ml.get("errors.connectionError"));
                                            _this14.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this14.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context10.sent;

                                _this14.states = states;
                                _context10.next = 12;
                                break;

                            case 8:
                                _context10.prev = 8;
                                _context10.t0 = _context10["catch"](0);

                                console.error(_context10.t0);
                                alertify.error("Servis Hatası :" + _context10.t0.message);

                            case 12:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this14, [[0, 8]]);
            }))();
        },
        getWorkGroups: function getWorkGroups() {
            var _this15 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var workGroups, response;
                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.prev = 0;
                                workGroups = [];
                                _context11.next = 4;
                                return _this15.$axios.get("/WorkGroups").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        workGroups.push({
                                            id: doc.id,
                                            name: doc.name,
                                            shortCode: doc.shortCode,
                                            isPeriod: doc.isPeriod,
                                            model: doc.model,
                                            isCheck: false
                                        });
                                        workGroups.sort(function (a, b) {
                                            if (a.name < b.name) return -1;
                                            if (a.name > b.name) return 0;
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this15.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this15.$ml.get("errors.connectionError"));
                                            _this15.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this15.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context11.sent;

                                _this15.workGroups = workGroups;
                                _context11.next = 12;
                                break;

                            case 8:
                                _context11.prev = 8;
                                _context11.t0 = _context11["catch"](0);

                                console.error(_context11.t0);
                                alertify.error("Servis Hatası :" + _context11.t0.message);

                            case 12:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this15, [[0, 8]]);
            }))();
        },
        getExtraFields: function getExtraFields() {
            var _this16 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var extrafields, response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.prev = 0;
                                extrafields = [];
                                _context12.next = 4;
                                return _this16.$axios.get("/ExtraField").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        extrafields.push({
                                            id: doc.id,
                                            name: doc.definition
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this16.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this16.$ml.get("errors.connectionError"));
                                            _this16.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this16.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context12.sent;

                                _this16.extrafields = extrafields;
                                _context12.next = 12;
                                break;

                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](0);

                                console.error(_context12.t0);
                                alertify.error("Servis Hatası :" + _context12.t0.message);

                            case 12:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this16, [[0, 8]]);
            }))();
        },
        changeFilterDep: function changeFilterDep(dep, checkValue) {
            var _this17 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                dep.check = checkValue;
                                _this17.sortableDepartmentList.forEach(function (doc) {
                                    if (doc.mainDepartmentId == dep.id) {
                                        doc.check = checkValue;
                                        _this17.changeFilterDep(doc, checkValue);
                                    }
                                });

                            case 2:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this17);
            }))();
        },
        clearFilterDepartments: function clearFilterDepartments() {
            var _this18 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _this18.filters.departments = [];
                                _context14.next = 3;
                                return _this18.sortableDepartmentList.forEach(function (doc) {
                                    if (doc.check == true) {
                                        doc.check = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this18);
            }))();
        },
        clearFilterAccessGroup: function clearFilterAccessGroup() {
            var _this19 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _this19.filters.accessGroup = [];
                                _context15.next = 3;
                                return _this19.accessGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this19);
            }))();
        },
        clearFilterStates: function clearFilterStates() {
            var _this20 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _this20.filters.stateId = [];
                                _context16.next = 3;
                                return _this20.stateList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this20);
            }))();
        },
        clearFilterStatus: function clearFilterStatus() {
            var _this21 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                _this21.filters.statuId = [];
                                _context17.next = 3;
                                return _this21.statuList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this21);
            }))();
        },
        clearFilterWorkPlans: function clearFilterWorkPlans() {
            var _this22 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
                return regeneratorRuntime.wrap(function _callee18$(_context18) {
                    while (1) {
                        switch (_context18.prev = _context18.next) {
                            case 0:
                                _this22.filters.workGroupId = [];
                                _context18.next = 3;
                                return _this22.workGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context18.stop();
                        }
                    }
                }, _callee18, _this22);
            }))();
        },
        clearFilterFoodGroups: function clearFilterFoodGroups() {
            var _this23 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
                return regeneratorRuntime.wrap(function _callee19$(_context19) {
                    while (1) {
                        switch (_context19.prev = _context19.next) {
                            case 0:
                                _this23.filters.foodGroup = [];
                                _context19.next = 3;
                                return _this23.foodGroupList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 3:
                            case "end":
                                return _context19.stop();
                        }
                    }
                }, _callee19, _this23);
            }))();
        },
        getCheckDepartmentAll: function getCheckDepartmentAll(value) {
            var _this24 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
                return regeneratorRuntime.wrap(function _callee20$(_context20) {
                    while (1) {
                        switch (_context20.prev = _context20.next) {
                            case 0:
                                _this24.sortableDepartmentList.forEach(function (dep) {
                                    dep.check = value;
                                });
                                _this24.isCheckDeps = !_this24.isCheckDeps;

                            case 2:
                            case "end":
                                return _context20.stop();
                        }
                    }
                }, _callee20, _this24);
            }))();
        },
        getCheckDepartmentList: function getCheckDepartmentList() {
            var _this25 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
                var aList, aList2, aList3, aList4, aList5, aList6;
                return regeneratorRuntime.wrap(function _callee21$(_context21) {
                    while (1) {
                        switch (_context21.prev = _context21.next) {
                            case 0:
                                aList = _this25.sortableDepartmentList;

                                _this25.filters.departments = [];
                                _context21.next = 4;
                                return aList.forEach(function (doc) {
                                    if (doc.check == true) {
                                        _this25.filters.departments.push(doc.id);
                                    }
                                });

                            case 4:
                                aList2 = _this25.accessGroupList;

                                _this25.filters.accessGroup = [];
                                _context21.next = 8;
                                return aList2.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this25.filters.accessGroup.push(doc.id);
                                    }
                                });

                            case 8:
                                aList3 = _this25.workGroupList;

                                _this25.filters.workGroupId = [];
                                _context21.next = 12;
                                return aList3.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this25.filters.workGroupId.push(doc.id);
                                    }
                                });

                            case 12:
                                aList4 = _this25.foodGroupList;

                                _this25.filters.foodGroup = [];
                                _context21.next = 16;
                                return aList4.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this25.filters.foodGroup.push(doc.id);
                                    }
                                });

                            case 16:
                                aList5 = _this25.statuList;

                                _this25.filters.statuId = [];
                                _context21.next = 20;
                                return aList5.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this25.filters.statuId.push(doc.id);
                                    }
                                });

                            case 20:
                                aList6 = _this25.stateList;

                                _this25.filters.stateId = [];
                                _context21.next = 24;
                                return aList6.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        _this25.filters.stateId.push(doc.id);
                                    }
                                });

                            case 24:
                            case "end":
                                return _context21.stop();
                        }
                    }
                }, _callee21, _this25);
            }))();
        },
        getEmployees: function getEmployees() {
            var _this26 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
                var employees, filters2, response;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                    while (1) {
                        switch (_context22.prev = _context22.next) {
                            case 0:
                                _context22.prev = 0;

                                _this26.isLoading = true;
                                _context22.next = 4;
                                return _this26.getCheckDepartmentList();

                            case 4:
                                employees = [];
                                filters2 = _this26.filters;
                                _context22.next = 8;
                                return _this26.$axios.post("/Employees/getByFilter", {
                                    nameOrCardNumber: filters2.nameOrCardNumber,
                                    sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                                    departments: filters2.departments,
                                    accessGroup: filters2.accessGroup,
                                    identityNo: filters2.identityNo,
                                    documentNoOrMail: filters2.documentNoOrMail,
                                    foodGroup: filters2.foodGroup,
                                    workGroupId: filters2.workGroupId,
                                    title: filters2.title,
                                    stateId: filters2.stateId,
                                    statuId: filters2.statuId,
                                    plateNo: filters2.plateNo,
                                    extraField1key: filters2.extraField1key,
                                    extraField1value: filters2.extraField1value,
                                    extraField2key: filters2.extraField2key,
                                    extraField2value: filters2.extraField2value,
                                    extraField3key: filters2.extraField3key,
                                    extraField3value: filters2.extraField3value,
                                    extraField4key: filters2.extraField4key,
                                    extraField4value: filters2.extraField4value,
                                    isVisitor: filters2.isVisitor,
                                    isActive: filters2.isActive
                                }).then(function (response) {
                                    response.data.forEach(function (doc) {
                                        employees.push({
                                            id: doc.id,
                                            name: doc.name,
                                            sicilNo: doc.sicilNo,
                                            title: doc.title,
                                            check: false
                                        });
                                    });
                                    //this.filtersClear();
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this26.$store.dispatch("logout");
                                        } else if (error.response.status == 403) {
                                            alertify.message(_this26.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this26.$ml.get("errors.connectionError"));
                                            _this26.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this26.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 8:
                                response = _context22.sent;

                                _this26.employees = employees;
                                _this26.isLoading = false;
                                _context22.next = 18;
                                break;

                            case 13:
                                _context22.prev = 13;
                                _context22.t0 = _context22["catch"](0);

                                console.error(_context22.t0);
                                alertify.error("Servis Hatası :" + _context22.t0.message);
                                _this26.isLoading = false;

                            case 18:
                            case "end":
                                return _context22.stop();
                        }
                    }
                }, _callee22, _this26, [[0, 13]]);
            }))();
        },
        getAllowences: function getAllowences() {
            var _this27 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
                var allowences, response;
                return regeneratorRuntime.wrap(function _callee23$(_context23) {
                    while (1) {
                        switch (_context23.prev = _context23.next) {
                            case 0:
                                _context23.prev = 0;
                                allowences = [];
                                _context23.next = 4;
                                return _this27.$axios.get("/Allowences").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        allowences.push({
                                            id: doc.id,
                                            shortCode: doc.shortCode,
                                            name: doc.name,
                                            monthlyPayrollId: doc.monthlyPayrollId,
                                            dailyPayrollId: doc.dailyPayrollId,
                                            dayTime: doc.dayTime,
                                            colorCode: doc.colorCode,
                                            r: doc.r,
                                            g: doc.g,
                                            b: doc.b
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this27.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this27.$ml.get("errors.connectionError"));
                                            _this27.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this27.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context23.sent;

                                _this27.allowences = allowences;
                                _context23.next = 12;
                                break;

                            case 8:
                                _context23.prev = 8;
                                _context23.t0 = _context23["catch"](0);

                                console.error(_context23.t0);
                                alertify.error("Servis Hatası :" + _context23.t0.message);

                            case 12:
                            case "end":
                                return _context23.stop();
                        }
                    }
                }, _callee23, _this27, [[0, 8]]);
            }))();
        },
        saveChangePayroll: function saveChangePayroll() {
            var _this28 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
                var contextId, isAllowence, date, data, response;
                return regeneratorRuntime.wrap(function _callee24$(_context24) {
                    while (1) {
                        switch (_context24.prev = _context24.next) {
                            case 0:
                                _context24.prev = 0;

                                _this28.isLoading = true;
                                contextId = _this28.selectedShift.workGroupId;
                                isAllowence = false;

                                if (_this28.selectedShift.allowenceId) {
                                    contextId = _this28.selectedShift.allowenceId;
                                    isAllowence = true;
                                }
                                date = _this28.toDateFormat(_this28.selectedShift.date, "gg.aa.yyyy");
                                data = [];

                                data.push({
                                    empId: _this28.selectedShift.empId,
                                    date: date,
                                    contextId: parseInt(contextId),
                                    isAllowence: isAllowence
                                });
                                _context24.next = 10;
                                return _this28.$axios.post("/Shift/ChangePayroll", data).then(function (response) {
                                    _this28.getRealMovements();
                                    $("#modal-shift").modal("hide");
                                    alertify.success("İşlem Tamamlandı!");
                                    _this28.isLoading = false;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this28.$store.dispatch("logout");
                                        } else if (error.response.status == 403) {
                                            alertify.message(_this28.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this28.$ml.get("errors.connectionError"));
                                            _this28.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this28.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 10:
                                response = _context24.sent;
                                _context24.next = 18;
                                break;

                            case 13:
                                _context24.prev = 13;
                                _context24.t0 = _context24["catch"](0);

                                console.error(_context24.t0);
                                alertify.error("Servis Hatası :" + _context24.t0.message);
                                _this28.isLoading = false;

                            case 18:
                            case "end":
                                return _context24.stop();
                        }
                    }
                }, _callee24, _this28, [[0, 13]]);
            }))();
        },
        getSelectedEmployeeList: function getSelectedEmployeeList() {
            var _this29 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
                var idList;
                return regeneratorRuntime.wrap(function _callee25$(_context25) {
                    while (1) {
                        switch (_context25.prev = _context25.next) {
                            case 0:
                                idList = [];
                                _context25.next = 3;
                                return _this29.employeeList.forEach(function (emp) {
                                    idList.push(emp.id);
                                });

                            case 3:
                                return _context25.abrupt("return", idList);

                            case 4:
                            case "end":
                                return _context25.stop();
                        }
                    }
                }, _callee25, _this29);
            }))();
        },
        getRealMovements: function getRealMovements() {
            var _this30 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
                var empIds, shifts, response;
                return regeneratorRuntime.wrap(function _callee26$(_context26) {
                    while (1) {
                        switch (_context26.prev = _context26.next) {
                            case 0:
                                _context26.prev = 0;

                                _this30.isLoading = true;
                                _context26.next = 4;
                                return _this30.getSelectedEmployeeList();

                            case 4:
                                empIds = _context26.sent;
                                shifts = [];
                                _context26.next = 8;
                                return _this30.$axios.post("/Webshift/RealMovements", {
                                    employeeIds: empIds,
                                    year: _this30.year,
                                    monthOrWeekNumber: _this30.monthOrWeekNumber,
                                    isMonth: false
                                }).then(function (response) {
                                    shifts = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this30.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this30.$ml.get("errors.connectionError"));
                                            _this30.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this30.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 8:
                                response = _context26.sent;

                                _this30.shifts = shifts;
                                _this30.isLoading = false;
                                _context26.next = 18;
                                break;

                            case 13:
                                _context26.prev = 13;
                                _context26.t0 = _context26["catch"](0);

                                console.error(_context26.t0);
                                alertify.error("Servis Hatası :" + _context26.t0.message);
                                _this30.isLoading = false;

                            case 18:
                            case "end":
                                return _context26.stop();
                        }
                    }
                }, _callee26, _this30, [[0, 13]]);
            }))();
        },
        getShifts: function getShifts() {
            var _this31 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
                var empIds, shifts, response;
                return regeneratorRuntime.wrap(function _callee27$(_context27) {
                    while (1) {
                        switch (_context27.prev = _context27.next) {
                            case 0:
                                _context27.prev = 0;

                                _this31.isLoading = true;
                                _context27.next = 4;
                                return _this31.getSelectedEmployeeList();

                            case 4:
                                empIds = _context27.sent;
                                shifts = [];
                                _context27.next = 8;
                                return _this31.$axios.post("/Webshift/GetShift", {
                                    employeeIds: empIds,
                                    year: _this31.year,
                                    monthOrWeekNumber: _this31.monthOrWeekNumber,
                                    isMonth: false
                                }).then(function (response) {
                                    shifts = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this31.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this31.$ml.get("errors.connectionError"));
                                            _this31.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this31.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 8:
                                response = _context27.sent;

                                _this31.shifts = shifts;
                                _this31.isLoading = false;
                                _context27.next = 18;
                                break;

                            case 13:
                                _context27.prev = 13;
                                _context27.t0 = _context27["catch"](0);

                                console.error(_context27.t0);
                                alertify.error("Servis Hatası :" + _context27.t0.message);
                                _this31.isLoading = false;

                            case 18:
                            case "end":
                                return _context27.stop();
                        }
                    }
                }, _callee27, _this31, [[0, 13]]);
            }))();
        },
        setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
            var _this32 = this;

            filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
            filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
            filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
            filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
            filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
            this.filters.departments = filter.departments;
            this.filters.nameOrCardNumber = filter.nameOrCardNumber;
            this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
            this.filters.isActive = filter.isActive;
            this.filters.documentNoOrMail = filter.documentNoOrMail;
            this.filters.identityNo = filter.identityNo;
            this.filters.title = filter.title;
            this.filters.extraField1key = filter.extraField1key;
            this.filters.extraField1value = filter.extraField1value;
            this.filters.extraField2key = filter.extraField2key;
            this.filters.extraField2value = filter.extraField2value;
            this.filters.extraField3key = filter.extraField3key;
            this.filters.extraField3value = filter.extraField3value;
            this.filters.extraField4key = filter.extraField4key;
            this.filters.extraField4value = filter.extraField4value;
            this.filters.isVisitor = filter.isVisitor;
            this.filters.plateNo = filter.plateNo;
            //this.filters = filter;
            this.sortableDepartmentList.forEach(function (doc) {
                _this32.filters.departments.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.check = true;
                    }
                });
            });
            this.periodWorkGroupList.forEach(function (doc) {
                _this32.filters.workGroupId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.accessGroupList.forEach(function (doc) {
                _this32.filters.accessGroup.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.foodGroupList.forEach(function (doc) {
                _this32.filters.foodGroup.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.stateList.forEach(function (doc) {
                _this32.filters.stateId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
            this.statuList.forEach(function (doc) {
                _this32.filters.statuId.forEach(function (doc2) {
                    if (doc.id == doc2) {
                        doc.isCheck = true;
                    }
                });
            });
        },
        getCalendar: function getCalendar() {
            var _this33 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
                var days, response;
                return regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                        switch (_context28.prev = _context28.next) {
                            case 0:
                                _context28.prev = 0;

                                _this33.isLoading = true;
                                days = [];
                                _context28.next = 5;
                                return _this33.$axios.get("/Webshift/Calendar?year=" + _this33.year + "&monthOrWeekNumber=" + _this33.monthOrWeekNumber + "&isMonth=false").then(function (response) {
                                    days = response.data.dates;
                                    _this33.isForbidden = response.data.isForbidden;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this33.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this33.$ml.get("errors.connectionError"));
                                            _this33.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this33.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context28.sent;

                                _this33.selectedDays = days;
                                _this33.isLoading = false;
                                _context28.next = 15;
                                break;

                            case 10:
                                _context28.prev = 10;
                                _context28.t0 = _context28["catch"](0);

                                console.error(_context28.t0);
                                alertify.error("Servis Hatası :" + _context28.t0.message);
                                _this33.isLoading = false;

                            case 15:
                            case "end":
                                return _context28.stop();
                        }
                    }
                }, _callee28, _this33, [[0, 10]]);
            }))();
        },
        changeInOutDoor2: function changeInOutDoor2(event) {
            this.inOut2.readerId = event.target.value;
            var filtered = this.readers.filter(function (doc) {
                return doc.readerId == event.target.value;
            });
            if (filtered.length > 0) {
                this.inOut2.inOutType = filtered[0].inOrOut;
                this.selectedDoorTypeMovement = filtered[0].inOrOut;
            }
        },
        changeInOutType2: function changeInOutType2(event) {
            this.inOut2.inOutType = event.target.value;
            this.selectedDoorTypeMovement = event.target.value;
        },
        newInOut2: function newInOut2() {
            this.isNewInOut2 = true;
            this.isActiveInOut2 = true;
            var date = this.toDateFormat(this.selectedDailyPayrol.date, "gg.aa.yyyy");
            var docc = date.split(".");
            this.inOut2.inOutAdd = docc[2] + "-" + docc[1] + "-" + docc[0] + "T00:00";
            this.inOut2.inOutType = 0;
            this.selectedDoorTypeMovement = 0;
            this.inOut2.readerId = "0";
            this.inOut2.inOutId = null;
            if (this.readers.length > 0) {
                this.inOut2.readerId = this.activePDKSReaderList[0].readerId;
                this.inOut2.inOutType = this.activePDKSReaderList[0].inOrOut;
            }
        },
        selectInOut2: function selectInOut2(inOutDetail) {
            this.isNewInOut2 = false;
            this.isActiveInOut2 = true;
            this.inOut2.inOutId = inOutDetail.id;
            this.inOut2.inOutType = inOutDetail.inOrOut;
            this.selectedDoorTypeMovement = inOutDetail.inOrOut;
            this.inOut2.inOutAdd = this.toDateFormat(inOutDetail.unFormattedDate, "yyyy-aa-ggTss:dd");
            this.inOut2.readerId = inOutDetail.readerId;
        },
        addInOut2: function addInOut2() {
            var _this34 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
                var date, today, empId, inOurOut, inOutAdd, readerId, response;
                return regeneratorRuntime.wrap(function _callee29$(_context29) {
                    while (1) {
                        switch (_context29.prev = _context29.next) {
                            case 0:
                                if (!(_this34.inOut2.inOutAdd == "")) {
                                    _context29.next = 3;
                                    break;
                                }

                                alertify.warning(_this34.$ml.get("alerts.invalidDate"));
                                return _context29.abrupt("return");

                            case 3:
                                if (!(_this34.inOut2.readerId == "" || _this34.inOut2.readerId == 0)) {
                                    _context29.next = 6;
                                    break;
                                }

                                alertify.warning(_this34.$ml.get("alerts.notSelectedReader"));
                                return _context29.abrupt("return");

                            case 6:
                                date = new Date(_this34.inOut2.inOutAdd);
                                today = new Date();

                                if (!(date > today)) {
                                    _context29.next = 11;
                                    break;
                                }

                                alertify.warning(_this34.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                                return _context29.abrupt("return");

                            case 11:
                                _context29.prev = 11;
                                empId = _this34.selectedEmployee.empId;
                                inOurOut = _this34.inOut2.inOutType;
                                inOutAdd = _this34.inOut2.inOutAdd;
                                readerId = _this34.inOut2.readerId;
                                _context29.next = 18;
                                return _this34.$axios.post("/EmployeeDetails/AddEntryExit", {
                                    isActive: true,
                                    inOrOut: inOurOut,
                                    date: inOutAdd,
                                    readerId: readerId,
                                    includePassiveMovements: _this34.includePassiveMovements,
                                    doNotDeleteOvertimes: _this34.doNotDeleteOvertimes,
                                    empId: empId
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this34.$store.dispatch("logout");
                                        }
                                    }
                                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                        alertify.error(_this34.$ml.get("errors.connectionError"));
                                        _this34.isLoadingInOuts = false;
                                        return;
                                    } else {
                                        console.error(error);
                                        alertify.error(error.message);
                                        _this34.isLoadingInOuts = false;
                                        return;
                                    }
                                });

                            case 18:
                                response = _context29.sent;

                                if (response.status == 200) {
                                    alertify.success(_this34.$ml.get("alerts.savedSuccessfully"));
                                } else {
                                    alertify.error(response.message);
                                }
                                _this34.newInOut2();
                                _this34.isActiveInOut2 = false;
                                _this34.getDailyPayrollDetails(_this34.selectedShift.date, _this34.selectedShift.workGroupName, _this34.selectedEmployee.empId);
                                _context29.next = 29;
                                break;

                            case 25:
                                _context29.prev = 25;
                                _context29.t0 = _context29["catch"](11);

                                console.error(_context29.t0);
                                alertify.error(_context29.t0.message);

                            case 29:
                            case "end":
                                return _context29.stop();
                        }
                    }
                }, _callee29, _this34, [[11, 25]]);
            }))();
        },
        updateInOut2: function updateInOut2() {
            var _this35 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
                var date, today, empId, inOurOut, inOutAdd, readerId, response;
                return regeneratorRuntime.wrap(function _callee30$(_context30) {
                    while (1) {
                        switch (_context30.prev = _context30.next) {
                            case 0:
                                if (!(_this35.inOut2.inOutAdd == "")) {
                                    _context30.next = 3;
                                    break;
                                }

                                alertify.warning(_this35.$ml.get("alerts.invalidDate"));
                                return _context30.abrupt("return");

                            case 3:
                                if (!(_this35.inOut2.readerId == "" || _this35.inOut2.readerId == 0)) {
                                    _context30.next = 6;
                                    break;
                                }

                                alertify.warning(_this35.$ml.get("alerts.notSelectedReader"));
                                return _context30.abrupt("return");

                            case 6:
                                date = new Date(_this35.inOut2.inOutAdd);
                                today = new Date();

                                if (!(date > today)) {
                                    _context30.next = 11;
                                    break;
                                }

                                alertify.warning(_this35.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                                return _context30.abrupt("return");

                            case 11:
                                _context30.prev = 11;
                                empId = _this35.selectedEmployee.empId;
                                inOurOut = _this35.inOut2.inOutType;
                                inOutAdd = _this35.inOut2.inOutAdd;
                                readerId = _this35.inOut2.readerId;
                                _context30.next = 18;
                                return _this35.$axios.post("/EmployeeDetails/UpdateEntryExit/" + _this35.inOut2.inOutId, {
                                    isActive: true,
                                    inOrOut: inOurOut,
                                    date: inOutAdd,
                                    empId: empId,
                                    readerId: readerId
                                });

                            case 18:
                                response = _context30.sent;

                                if (response.status == 200) {
                                    alertify.success(_this35.$ml.get("alerts.savedSuccessfully"));
                                } else {
                                    alertify.error(response.message);
                                }
                                _this35.newInOut2();
                                _this35.isActiveInOut2 = false;
                                _this35.getDailyPayrollDetails(_this35.selectedShift.date, _this35.selectedShift.workGroupName, _this35.selectedEmployee.empId);
                                _context30.next = 29;
                                break;

                            case 25:
                                _context30.prev = 25;
                                _context30.t0 = _context30["catch"](11);

                                console.error(_context30.t0);
                                alertify.error(_context30.t0.message);

                            case 29:
                            case "end":
                                return _context30.stop();
                        }
                    }
                }, _callee30, _this35, [[11, 25]]);
            }))();
        },
        deleteInOut2: function deleteInOut2(id) {
            var _this36 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
                var response;
                return regeneratorRuntime.wrap(function _callee31$(_context31) {
                    while (1) {
                        switch (_context31.prev = _context31.next) {
                            case 0:
                                _context31.prev = 0;

                                if (!(id != 0)) {
                                    _context31.next = 6;
                                    break;
                                }

                                _context31.next = 4;
                                return _this36.$axios.delete("/EmployeeDetails/DeleteEntryExit/" + id).then(function (response) {
                                    alertify.success(_this36.$ml.get("alerts.deletedSuccessfully"));
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this36.$store.dispatch("logout");
                                        }
                                    }
                                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                        alertify.error(_this36.$ml.get("errors.connectionError"));
                                        _this36.isLoadingInOuts = false;
                                        return;
                                    } else {
                                        console.error(error);
                                        alertify.error(error.message);
                                        _this36.isLoadingInOuts = false;
                                        return;
                                    }
                                });

                            case 4:
                                response = _context31.sent;

                                _this36.getDailyPayrollDetails(_this36.selectedShift.date, _this36.selectedShift.workGroupName, _this36.selectedEmployee.empId);

                            case 6:
                                _context31.next = 11;
                                break;

                            case 8:
                                _context31.prev = 8;
                                _context31.t0 = _context31["catch"](0);

                                alertify.error("Hata Oluştu : " + _context31.t0);

                            case 11:
                            case "end":
                                return _context31.stop();
                        }
                    }
                }, _callee31, _this36, [[0, 8]]);
            }))();
        },
        changeOvertimePlace: function changeOvertimePlace(event) {
            this.selectedOTPlaceId = event.target.value;
        },
        changeOvertimeDescription: function changeOvertimeDescription(event) {
            this.selectedOTDescriptionId = event.target.value;
        },
        customConfirmOverTime: function customConfirmOverTime() {
            var _this37 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
                var id, calculatedDate, confirmedDate, response;
                return regeneratorRuntime.wrap(function _callee32$(_context32) {
                    while (1) {
                        switch (_context32.prev = _context32.next) {
                            case 0:
                                _context32.prev = 0;
                                id = _this37.selectedDailyPayrol.overTimeId;
                                calculatedDate = "1900-01-01T" + _this37.selectedDailyPayrol.calculatedOverTime + ":00";
                                confirmedDate = "1900-01-01T" + _this37.selectedDailyPayrol.confirmedOverTime.replace("Z", "");

                                if (!(confirmedDate > calculatedDate)) {
                                    _context32.next = 7;
                                    break;
                                }

                                alertify.warning(_this37.$ml.get("alerts.confirmedOvertimeCannotBeGreaterThanCalculated"));
                                return _context32.abrupt("return");

                            case 7:
                                _this37.isLoading = true;
                                _context32.next = 10;
                                return _this37.$axios.post("/EmployeeDetails/CustomConfirmOvertime", {
                                    id: id,
                                    confirmedDate: confirmedDate,
                                    overtimeDescriptionId: _this37.selectedOTDescriptionId,
                                    overtimePlaceId: _this37.selectedOTPlaceId
                                }).then(function (response) {
                                    if (response.status == 200) {
                                        alertify.success(_this37.$ml.get("alerts.savedSuccessfully"));
                                        _this37.isLoading = false;
                                    }
                                }).catch(function (doc) {
                                    if (doc.status == 401) {
                                        _this37.$store.dispatch("logout");
                                    } else if (doc.message == "Network Error") {
                                        alertify.error(_this37.$ml.get("errors.connectionError"));
                                    } else {
                                        alertify.error(doc.message);
                                    }
                                });

                            case 10:
                                response = _context32.sent;

                                _this37.getDailyPayrollDetails(_this37.selectedShift.date, _this37.selectedShift.workGroupName, _this37.selectedEmployee.empId);
                                _context32.next = 18;
                                break;

                            case 14:
                                _context32.prev = 14;
                                _context32.t0 = _context32["catch"](0);

                                console.error(_context32.t0);
                                alertify.error(_context32.t0.message);

                            case 18:
                            case "end":
                                return _context32.stop();
                        }
                    }
                }, _callee32, _this37, [[0, 14]]);
            }))();
        },
        getDailyPayrollDetails: function getDailyPayrollDetails(tarih, workGroup, empId) {
            var _this38 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
                var date, response;
                return regeneratorRuntime.wrap(function _callee33$(_context33) {
                    while (1) {
                        switch (_context33.prev = _context33.next) {
                            case 0:
                                _context33.prev = 0;

                                _this38.selectedDailyPayrol.date = "";
                                _this38.selectedDailyPayrol.movements = [];
                                _this38.selectedDailyPayrol.workGroup = "";
                                _this38.selectedDailyPayrol.payrolls = [];
                                _this38.selectedDailyPayrol.calculatedOverTime = "00:00";
                                _this38.selectedDailyPayrol.confirmedOverTime = "00:00";
                                _this38.selectedDailyPayrol.overTimeId = null;
                                date = _this38.toDateFormat(tarih, "gg.aa.yyyy");

                                _this38.selectedDailyPayrol.date = tarih;
                                _this38.selectedDailyPayrol.workGroup = workGroup;
                                _context33.next = 13;
                                return _this38.$axios.post("/EmployeeDetails/GetDailyPayrollDetails", {
                                    date: date,
                                    empId: empId
                                }).then(function (response) {
                                    if (response.status == 200) {
                                        if (response.data.overtimes) {
                                            _this38.selectedDailyPayrol.calculatedOverTime = response.data.overtimes.calculated;
                                            _this38.selectedDailyPayrol.confirmedOverTime = response.data.overtimes.confirmed ? response.data.overtimes.confirmed : "";
                                            _this38.selectedDailyPayrol.overTimeId = response.data.overtimes.overTimeId;
                                        }
                                        response.data.movements.forEach(function (doc) {
                                            _this38.selectedDailyPayrol.movements.push({
                                                id: doc.id,
                                                unFormattedDate: doc.unFormattedDate,
                                                readerId: doc.readerId,
                                                inOrOut: doc.inOrOut,
                                                date: doc.date,
                                                status: doc.status
                                            });
                                        });
                                        response.data.payrolls.forEach(function (doc) {
                                            _this38.selectedDailyPayrol.payrolls.push({
                                                time: doc.time,
                                                payroll: doc.payroll
                                            });
                                        });
                                    }
                                }).catch(function (doc) {
                                    if (doc.status == 401) {
                                        _this38.$store.dispatch("logout");
                                    } else if (doc.message == "Network Error") {
                                        alertify.error(_this38.$ml.get("errors.connectionError"));
                                    } else {
                                        alertify.error(doc.message);
                                    }
                                });

                            case 13:
                                response = _context33.sent;
                                _context33.next = 20;
                                break;

                            case 16:
                                _context33.prev = 16;
                                _context33.t0 = _context33["catch"](0);

                                console.error(_context33.t0);
                                alertify.error(_context33.t0.message);

                            case 20:
                            case "end":
                                return _context33.stop();
                        }
                    }
                }, _callee33, _this38, [[0, 16]]);
            }))();
        },
        getReaders: function getReaders() {
            var _this39 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
                var readers, response;
                return regeneratorRuntime.wrap(function _callee34$(_context34) {
                    while (1) {
                        switch (_context34.prev = _context34.next) {
                            case 0:
                                _context34.prev = 0;
                                readers = [];
                                _context34.next = 4;
                                return _this39.$axios.get("/Terminal/GetReaders").then(function (response) {
                                    if (response.status == 200) {
                                        response.data.forEach(function (doc) {
                                            if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                                                readers.push({
                                                    readerNo: doc.readerNo,
                                                    readerId: doc.readerId,
                                                    terminalId: doc.terminalId,
                                                    terminalNo: doc.terminalNo,
                                                    ipAddress: doc.ipAddress,
                                                    isActive: doc.isActive,
                                                    doorType: doc.doorType,
                                                    name: doc.name,
                                                    inOrOut: doc.inOrOut,
                                                    check: false,
                                                    VCGcheck: false
                                                });
                                            }
                                        });
                                    }
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this39.$store.dispatch("logout");
                                        }
                                        if (error.response.status == 500) {
                                            alertify.error(_this39.$ml.get("alerts.getReadersError"));
                                            _this39.isLoading = false;
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this39.$ml.get("errors.connectionError"));
                                            _this39.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this39.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context34.sent;

                                _this39.readers = readers;
                                _context34.next = 12;
                                break;

                            case 8:
                                _context34.prev = 8;
                                _context34.t0 = _context34["catch"](0);

                                console.error(_context34.t0);
                                alertify.error("Servis Hatası : " + _context34.t0.message);

                            case 12:
                            case "end":
                                return _context34.stop();
                        }
                    }
                }, _callee34, _this39, [[0, 8]]);
            }))();
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    created: function created() {
        var _this40 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee35() {
            var curr, week, i, first, day, startDateOfYear, _i, a, days, weekNumber, weekNumber2, filter;

            return regeneratorRuntime.wrap(function _callee35$(_context35) {
                while (1) {
                    switch (_context35.prev = _context35.next) {
                        case 0:
                            _context35.next = 2;
                            return _this40.getDepartments();

                        case 2:
                            _context35.next = 4;
                            return _this40.getAccessGroups();

                        case 4:
                            if (!_this40.modules.diningHall) {
                                _context35.next = 7;
                                break;
                            }

                            _context35.next = 7;
                            return _this40.getFoodGroups();

                        case 7:
                            _context35.next = 9;
                            return _this40.getStatus();

                        case 9:
                            _context35.next = 11;
                            return _this40.getStates();

                        case 11:
                            _context35.next = 13;
                            return _this40.getTitles();

                        case 13:
                            _context35.next = 15;
                            return _this40.getWorkGroups();

                        case 15:
                            _context35.next = 17;
                            return _this40.getExtraFields();

                        case 17:
                            _context35.next = 19;
                            return _this40.getAllowences();

                        case 19:
                            _context35.next = 21;
                            return _this40.getReaders();

                        case 21:
                            $("body").addClass("sidebar-collapse"); //Sidebar kapatılarak tam ekrana geçiliyor
                            curr = new Date();
                            week = [];

                            for (i = 2; i <= 8; i++) {
                                //Bu haftanın günleri week adlı array içine diziliyor
                                first = curr.getDate() - curr.getDay() + i;
                                day = new Date(curr.setDate(first)).toISOString().slice(0, 10);

                                week.push(day);
                            }
                            _this40.startDateNow = new Date(week[0] + " 00:00");
                            _this40.endDateNow = new Date(week[6] + " 23:59");
                            _context35.next = 29;
                            return _this40.startDateNow.setDate(_this40.startDateNow.getDate() + 7);

                        case 29:
                            _context35.next = 31;
                            return _this40.endDateNow.setDate(_this40.endDateNow.getDate() + 7);

                        case 31:
                            // Shift düzenleme sonu bir hafta sonrası + pazartesi
                            startDateOfYear = null; //YILIN İLK PAZARTESİ GÜNÜ

                            for (_i = 0; _i < 7; _i++) {
                                a = new Date(_this40.startDateNow.getFullYear(), 0, _i);

                                if (a.toLocaleString("default", { weekday: "long" }) == "Pazartesi" || a.toLocaleString("default", { weekday: "long" }) == "Monday") {
                                    startDateOfYear = a;
                                    _i = 7;
                                }
                            }
                            _context35.next = 35;
                            return Math.floor((_this40.startDateNow - startDateOfYear) / (24 * 60 * 60 * 1000));

                        case 35:
                            days = _context35.sent;
                            _context35.next = 38;
                            return Math.ceil(days / 7);

                        case 38:
                            weekNumber = _context35.sent;

                            _this40.year = _this40.startDateNow.getFullYear();
                            _this40.monthOrWeekNumber = weekNumber;
                            weekNumber2 = "0";

                            if (weekNumber < 10) {
                                weekNumber2 = "0" + weekNumber;
                            } else {
                                weekNumber2 = weekNumber;
                            }
                            _this40.selectedWeek = _this40.startDateNow.getFullYear() + "-W" + weekNumber2;

                            if (!_this40.defaultFilters) {
                                _context35.next = 50;
                                break;
                            }

                            filter = _this40.defaultFilters;
                            _context35.next = 48;
                            return _this40.setUserAuthorityFilter(filter);

                        case 48:
                            _context35.next = 50;
                            return _this40.getEmployees();

                        case 50:
                        case "end":
                            return _context35.stop();
                    }
                }
            }, _callee35, _this40);
        }))();
    }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      isLoading: false
    }, _defineProperty(_ref, "isLoading", false), _defineProperty(_ref, "windowHeight", window.innerHeight), _defineProperty(_ref, "searchText", ""), _defineProperty(_ref, "orderEmpList", 1), _defineProperty(_ref, "activeScreen", 2), _defineProperty(_ref, "isConfirm", true), _defineProperty(_ref, "isForbidden", false), _defineProperty(_ref, "startDateNow", null), _defineProperty(_ref, "endDateNow", null), _defineProperty(_ref, "year", 0), _defineProperty(_ref, "monthOrWeekNumber", 0), _defineProperty(_ref, "selectedEmployee", {
      empId: null,
      sicilNo: "",
      name: "",
      title: "",
      terminalNo: ""
    }), _defineProperty(_ref, "selectedShift", {
      id: null,
      empId: null,
      date: null,
      entry: null,
      exit: null,
      allowenceId: null,
      allowenceName: "",
      confirmedUserId: null,
      confirmStatus: 0
    }), _defineProperty(_ref, "selectedWeek", null), _defineProperty(_ref, "selectedDays", []), _defineProperty(_ref, "filters", {
      nameOrCardNumber: "",
      sicilOrTerminalNo: null,
      departments: [],
      accessGroup: [],
      identityNo: "",
      documentNoOrMail: "",
      foodGroup: [],
      workGroupId: [],
      title: "",
      stateId: [],
      statuId: [],
      plateNo: "",
      extraField1key: 0,
      extraField1value: "",
      extraField2key: 0,
      extraField2value: "",
      extraField3key: 0,
      extraField3value: "",
      extraField4key: 0,
      extraField4value: "",
      isVisitor: false,
      isActive: true
    }), _defineProperty(_ref, "isCheckDeps", false), _defineProperty(_ref, "extrafields", []), _defineProperty(_ref, "workGroups", []), _defineProperty(_ref, "status", []), _defineProperty(_ref, "states", []), _defineProperty(_ref, "foodGroups", []), _defineProperty(_ref, "titles", []), _defineProperty(_ref, "accessGroups", []), _defineProperty(_ref, "departments", []), _defineProperty(_ref, "sortableDepTrees", []), _defineProperty(_ref, "colorPalette", ["background-color:#ecf0f5;color:#333333;", "background-color:#758ead;color:#ffffff;", "background-color:#9d75ad;color:#ffffff;", "background-color:#dd9999;color:#333333;", "background-color:#d4dd99;color:#333333;", "background-color:#99cbdd;color:#333333;", "background-color:#d599dd;color:#333333;", "background-color:#f1ba98;color:#333333;", "background-color:#77b8bf;color:#333333;", "background-color:#7782bf;color:#ffffff;"]), _defineProperty(_ref, "shifts", []), _defineProperty(_ref, "allowences", []), _defineProperty(_ref, "employeeAllCheck", false), _defineProperty(_ref, "employees", []), _defineProperty(_ref, "employee", {
      id: null,
      name: "",
      title: "",
      sicilNo: "",
      image: null,
      departmentId: null,
      identityNo: "",
      terminalNo: null
    }), _defineProperty(_ref, "webshiftSettings", {
      id: 0,
      shiftMode: 0, //Aylık - Haftalık
      allowenceLimitPerWeek: 0, //Aynı haftaya maksimum girilebilir izin sayısı
      changeShiftDayLimit: 0, //Geriye dönük planlama sınırı
      isConfirmActive: true, //Onay gerekli mi?
      mailToFirstAuthorizedPerson: true, //Uyarı maili aktif
      mailToSecondAuthorizedPerson: true, //Uyarı tekrarı maili (ertesi gün)
      shiftConfirmStartDay: 0 //Onay başlangıç günü
    }), _ref;
  },

  computed: {
    getAuthType: function getAuthType() {
      return this.$store.getters.getUser.authType;
    },
    getShiftAuthority: function getShiftAuthority() {
      return this.$store.getters.getAuthority.shiftYetkileri;
    },
    isAdmin: function isAdmin() {
      if (this.getShiftAuthority.canPlan && this.getShiftAuthority.canConfirmShift || this.getShiftAuthority.canPlanAllowence && this.getShiftAuthority.canConfirmAllowence) {
        return true;
      } else {
        return false;
      }
    },
    shiftDateAuth: function shiftDateAuth() {
      var now = new Date();
      var start = this.dayList[0];
      var startDay = start.substring(0, 2);
      var startMonth = start.substring(3, 5);
      var startYear = start.substring(6, 10);
      var startDate = new Date(startYear + "-" + startMonth + "-" + startDay);
      var end = this.dayList[this.dayList.length - 1];
      var endDay = end.substring(0, 2);
      var endMonth = end.substring(3, 5);
      var endYear = end.substring(6, 10);
      var endDate = new Date(endYear + "-" + endMonth + "-" + endDay);
      if (startDate >= now && endDate <= now) {
        return true;
      } else if (startDate < now) {
        return false;
      } else {
        return true;
      }
      return true;
    },
    shiftAuthStatus: function shiftAuthStatus() {
      if (this.monthOrWeekNumber != 0 && this.year != 0 && this.dayList.length > 0) {
        if (this.isAdmin) {
          return true; //Admin ise tam yetkiye sahip
        } else {
          return !this.isForbidden;
        }
      } else {
        return false;
      }
    },
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    dayList: function dayList() {
      return this.selectedDays;
    },
    shiftList: function shiftList() {
      var _this = this;

      if (this.searchText) {
        return this.shifts.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v) || item.sicilNo.toUpperCase().includes(v);
          });
        });
      } else {
        return this.shifts;
      }
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepTrees.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList: function employeeList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.employees.sort(function (a, b) {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    fixedFive: function fixedFive(str) {
      var str2 = "" + str;
      var pad = "00000";
      return pad.substring(0, pad.length - str2.length) + str2;
    },
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      if (format == "gg.aa.yyyy ss:dd") {
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        return saat + ":" + dakika;
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    getDateOfIsOWeek: function getDateOfIsOWeek(event) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var inp;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.isLoading = true;
                inp = _this3.selectedWeek;

                _this3.year = parseInt(inp.slice(0, 4), 10);
                _this3.monthOrWeekNumber = parseInt(inp.slice(6), 10);
                _context.next = 6;
                return _this3.getCalendar();

              case 6:
                if (!(_this3.activeScreen == 1)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return _this3.getRealMovements();

              case 9:
                _context.next = 15;
                break;

              case 11:
                if (!(_this3.activeScreen == 2)) {
                  _context.next = 15;
                  break;
                }

                if (!_this3.selectedWeek) {
                  _context.next = 15;
                  break;
                }

                _context.next = 15;
                return _this3.getShifts();

              case 15:
                _this3.isLoading = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printShiftPlan");
    },
    changeScreen: function changeScreen(event) {
      if (event.target.value == 1) {
        this.activeScreen = 1;
        this.getRealMovements();
      } else if (event.target.value == 2) {
        this.activeScreen = 2;
        if (this.monthOrWeekNumber != 0 && this.year != 0) {
          this.getDateOfIsOWeek();
        }
      }
    },
    bgColorShiftEntry: function bgColorShiftEntry(shift) {
      if (shift.toleranceEntry) {
        if (shift.entry > shift.toleranceEntry) {
          return "badge label-danger";
        } else {
          return "badge label-success";
        }
      } else {
        return "badge default-label";
      }
    },
    bgColorShiftExit: function bgColorShiftExit(shift) {
      if (shift.toleranceExit) {
        if (shift.exit < shift.toleranceExit) {
          return "badge label-danger";
        } else {
          return "badge label-success";
        }
      } else {
        return "badge default-label";
      }
    },
    bgColor: function bgColor(confirmStatus) {
      if (this.activeScreen == 2) {
        if (confirmStatus == 1) {
          return "text-center bg-success";
        } else {
          if (!this.shiftAuthStatus) {
            return "text-center bg-danger";
          } else {
            return "text-center";
          }
        }
      } else {
        return "text-center";
      }
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    getAllowenceNameFromId: function getAllowenceNameFromId(allowenceId) {
      var a = this.allowenceList.filter(function (allowence) {
        return allowence.id == allowenceId;
      });
      if (a[0]) {
        return a[0].name;
      } else {
        return "-";
      }
    },
    changeAllowence: function changeAllowence(event) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.selectedShift.allowenceId = event.target.value;
                _context2.next = 3;
                return _this4.getAllowenceNameFromId(event.target.value);

              case 3:
                _this4.selectedShift.allowenceName = _context2.sent;

                if (event.target.value == 0) {
                  _this4.selectedShift.entry = null;
                  _this4.selectedShift.exit = null;
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    changeAllEmployeeCheck: function changeAllEmployeeCheck() {
      var _this5 = this;

      this.employeeAllCheck = !this.employeeAllCheck;
      this.employeeList.forEach(function (employee) {
        employee.check = _this5.employeeAllCheck;
      });
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    shiftAuthControl: function shiftAuthControl() {
      if (this.monthOrWeekNumber != 0) {
        alertify.warning("Lütfen takvimden bir tarih seçimi yapın.");
        return;
      }
      if (!this.shiftAuthStatus) {
        alertify.error("Bu hafta kilitli. Değişiklik yapmaya yetkiniz yok.");
        return;
      }
    },
    allConfirmShift: function allConfirmShift() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var ids, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                ids = [];
                _context3.next = 4;
                return _this6.shiftList.forEach(function (emp) {
                  emp.shifts.forEach(function (shift) {
                    if (shift.id && shift.id != 0) {
                      ids.push(shift.id);
                    }
                  });
                });

              case 4:
                _context3.next = 6;
                return _this6.$axios.post("/Webshift/Confirm", ids).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context3.sent;

                if (response.status == 200) {
                  alertify.success(_this6.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this6.getShifts();
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 11]]);
      }))();
    },
    selectAllowence: function selectAllowence(shift, emp) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var shiftSend, response, a, b, limit, allowence;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this7.shiftAuthStatus) {
                  _context4.next = 3;
                  break;
                }

                alertify.error("Bu hafta kilitli. Değişiklik yapmaya yetkiniz yok.");
                return _context4.abrupt("return");

              case 3:
                if (!(!_this7.isAdmin && _this7.getShiftAuthority.canConfirmAllowence || _this7.isAdmin && _this7.isConfirm)) {
                  _context4.next = 25;
                  break;
                }

                if (shift.id) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return");

              case 8:
                _context4.prev = 8;
                shiftSend = [];
                _context4.next = 12;
                return shiftSend.push(shift.id);

              case 12:
                _context4.next = 14;
                return _this7.$axios.post("/Webshift/Confirm", shiftSend).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context4.sent;

                if (response.status == 200) {
                  alertify.success(_this7.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this7.getShifts();
                _context4.next = 23;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4["catch"](8);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);

              case 23:
                _context4.next = 59;
                break;

              case 25:
                if (!(!_this7.isAdmin && _this7.getShiftAuthority.canPlanAllowence || _this7.isAdmin && !_this7.isConfirm)) {
                  _context4.next = 59;
                  break;
                }

                if (shift.id) {
                  _context4.next = 57;
                  break;
                }

                _context4.next = 29;
                return _this7.shiftList.filter(function (shift) {
                  return shift.empId == emp.empId;
                });

              case 29:
                a = _context4.sent;
                _context4.next = 32;
                return a[0].shifts.filter(function (s) {
                  return s.allowenceId != null;
                });

              case 32:
                b = _context4.sent;
                limit = _this7.webshiftSettings.allowenceLimitPerWeek;

                if (!(b.length >= limit)) {
                  _context4.next = 39;
                  break;
                }

                alertify.warning("Seçilen kişiye aynı hafta içinde " + limit + " kere izin tanımlayabilirsiniz...");
                return _context4.abrupt("return");

              case 39:
                _this7.selectedShift.id = shift.id;
                _this7.selectedShift.empId = shift.empId;
                _this7.selectedShift.date = shift.date;
                _this7.selectedShift.entry = null;
                _this7.selectedShift.exit = null;
                _context4.next = 46;
                return _this7.allowenceList.filter(function (x) {
                  return x.shortCode == "HT" || x.shortCode == "OFF";
                });

              case 46:
                allowence = _context4.sent;

                if (allowence[0]) {
                  _this7.selectedShift.allowenceId = allowence[0].id;
                }
                _this7.selectedEmployee.empId = emp.empId;
                _this7.selectedEmployee.title = emp.title;
                _this7.selectedEmployee.sicilNo = emp.sicilNo;
                _this7.selectedEmployee.name = emp.name;
                _this7.selectedEmployee.terminalNo = emp.terminalNo;
                _context4.next = 55;
                return _this7.saveShift();

              case 55:
                _context4.next = 59;
                break;

              case 57:
                _context4.next = 59;
                return _this7.deleteShift(shift.id);

              case 59:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[8, 19]]);
      }))();
    },
    selectShift: function selectShift(shift, emp) {
      this.selectedShift.id = shift.id;
      this.selectedShift.empId = shift.empId;
      this.selectedShift.date = shift.date;
      this.selectedShift.entry = shift.entry;
      this.selectedShift.exit = shift.exit;
      this.selectedShift.allowenceId = shift.allowenceId;
      this.selectedShift.allowenceName = shift.allowenceName;
      this.selectedEmployee.empId = emp.empId;
      this.selectedEmployee.title = emp.title;
      this.selectedEmployee.sicilNo = emp.sicilNo;
      this.selectedEmployee.terminalNo = emp.terminalNo;
      this.selectedEmployee.name = emp.name;
      if (!this.selectedShift.id || this.selectedShift.id == 0) {
        var toDay = new Date(shift.date);
        var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
        var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
        var yil = toDay.getFullYear();
        this.selectedShift.entry = yil + "-" + ay + "-" + gun + "T00:00";
        this.selectedShift.exit = yil + "-" + ay + "-" + gun + "T00:00";
      }
      $("#modal-shift").modal("show");
    },
    getAccessGroups: function getAccessGroups() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                accessGroups = [];
                _context5.next = 4;
                return _this8.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context5.sent;

                _this8.accessGroups = accessGroups;
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası :" + _context5.t0.message);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                departments = [];
                _context6.prev = 1;
                _context6.next = 4;
                return _this9.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context6.sent;

                _this9.departments = departments;
                _this9.sortableTrees();
                _this9.isLoading = false;
                _context6.next = 14;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](1);

                console.error(_context6.t0);
                alertify.error(_context6.t0);

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this10 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this10.sortableDepTrees.push(dep);
          _this10.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this11 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this11.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this11.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                foodGroups = [];
                _context7.next = 4;
                return _this12.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context7.sent;

                _this12.foodGroups = foodGroups;
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this12, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                status = [];
                _context8.next = 4;
                return _this13.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context8.sent;

                _this13.status = status;
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this13, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                titles = [];
                _context9.next = 4;
                return _this14.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context9.sent;

                _this14.titles = titles;
                _context9.next = 12;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                alertify.error("Servis Hatası :" + _context9.t0.message);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this14, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                states = [];
                _context10.next = 4;
                return _this15.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context10.sent;

                _this15.states = states;
                _context10.next = 12;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error("Servis Hatası :" + _context10.t0.message);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this15, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                workGroups = [];
                _context11.next = 4;
                return _this16.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      model: doc.model,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context11.sent;

                _this16.workGroups = workGroups;
                _context11.next = 12;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);
                alertify.error("Servis Hatası :" + _context11.t0.message);

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this16, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                extrafields = [];
                _context12.next = 4;
                return _this17.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this17.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this17.$ml.get("errors.connectionError"));
                      _this17.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this17.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context12.sent;

                _this17.extrafields = extrafields;
                _context12.next = 12;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);
                alertify.error("Servis Hatası :" + _context12.t0.message);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this17, [[0, 8]]);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                dep.check = checkValue;
                _this18.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this18.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this18);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this19.filters.departments = [];
                _context14.next = 3;
                return _this19.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this19);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this20.filters.accessGroup = [];
                _context15.next = 3;
                return _this20.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this20);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _this21.filters.stateId = [];
                _context16.next = 3;
                return _this21.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this22.filters.statuId = [];
                _context17.next = 3;
                return _this22.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this22);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _this23.filters.workGroupId = [];
                _context18.next = 3;
                return _this23.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this23);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _this24.filters.foodGroup = [];
                _context19.next = 3;
                return _this24.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this24);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this25.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this25.isCheckDeps = !_this25.isCheckDeps;

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this25);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                aList = _this26.sortableDepartmentList;

                _this26.filters.departments = [];
                _context21.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this26.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this26.accessGroupList;

                _this26.filters.accessGroup = [];
                _context21.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this26.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this26.workGroupList;

                _this26.filters.workGroupId = [];
                _context21.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this26.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this26.foodGroupList;

                _this26.filters.foodGroup = [];
                _context21.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this26.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this26.statuList;

                _this26.filters.statuId = [];
                _context21.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this26.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this26.stateList;

                _this26.filters.stateId = [];
                _context21.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this26.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this26);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this27.isLoading = true;
                _context22.next = 4;
                return _this27.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this27.filters;
                _context22.next = 8;
                return _this27.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: false
                    });
                  });
                  //this.filtersClear();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this27.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context22.sent;

                _this27.employees = employees;

                if (!_this27.selectedWeek) {
                  _context22.next = 13;
                  break;
                }

                _context22.next = 13;
                return _this27.getDateOfIsOWeek();

              case 13:
                _this27.isLoading = false;
                _context22.next = 21;
                break;

              case 16:
                _context22.prev = 16;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);
                _this27.isLoading = false;

              case 21:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this27, [[0, 16]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                allowences = [];
                _context23.next = 4;
                return _this28.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context23.sent;

                _this28.allowences = allowences;
                _context23.next = 12;
                break;

              case 8:
                _context23.prev = 8;
                _context23.t0 = _context23["catch"](0);

                console.error(_context23.t0);
                alertify.error("Servis Hatası :" + _context23.t0.message);

              case 12:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this28, [[0, 8]]);
      }))();
    },
    deleteShift: function deleteShift(id) {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                if (id) {
                  _context24.next = 4;
                  break;
                }

                alertify.warning(_this29.$ml.get("alerts.pleaseSelect"));
                _context24.next = 19;
                break;

              case 4:
                _this29.isLoading = true;
                _context24.prev = 5;
                _context24.next = 8;
                return _this29.$axios.delete("/Webshift/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this29.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this29.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context24.sent;
                _context24.next = 11;
                return _this29.getShifts();

              case 11:
                alertify.success(_this29.$ml.get("alerts.deletedSuccessfully"));
                _this29.isLoading = false;
                _context24.next = 19;
                break;

              case 15:
                _context24.prev = 15;
                _context24.t0 = _context24["catch"](5);

                alertify.error("Hata Oluştu : " + _context24.t0);
                _this29.isLoading = false;

              case 19:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this29, [[5, 15]]);
      }))();
    },
    saveShift: function saveShift() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var response, _response;

        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(!_this30.selectedShift.allowenceId && (_this30.selectedShift.entry == null || _this30.selectedShift.exit == null))) {
                  _context25.next = 3;
                  break;
                }

                alertify.warning(_this30.$ml.get("alerts.invalidDate"));
                return _context25.abrupt("return");

              case 3:
                if (_this30.selectedShift.id) {
                  _context25.next = 29;
                  break;
                }

                if (_this30.selectedShift.allowenceId) {
                  _this30.selectedShift.entry = null;
                  _this30.selectedShift.exit = null;
                }
                _this30.isLoading = true;
                _context25.prev = 6;
                _context25.next = 9;
                return _this30.$axios.post("/Webshift", {
                  empId: _this30.selectedEmployee.empId,
                  date: _this30.selectedShift.date,
                  entry: _this30.selectedShift.entry,
                  exit: _this30.selectedShift.exit,
                  allowenceId: _this30.selectedShift.allowenceId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context25.sent;

                if (!(response.status == 200)) {
                  _context25.next = 18;
                  break;
                }

                _this30.selectedShift.id = response.data.id;
                _context25.next = 14;
                return _this30.getShifts();

              case 14:
                $("#modal-shift").modal("hide");
                alertify.success(_this30.$ml.get("alerts.savedSuccessfully"));
                _context25.next = 19;
                break;

              case 18:
                alertify.error(response.message);

              case 19:
                _this30.isLoading = false;
                _context25.next = 27;
                break;

              case 22:
                _context25.prev = 22;
                _context25.t0 = _context25["catch"](6);

                console.error(_context25.t0);
                alertify.error(_context25.t0.message);
                _this30.isLoading = false;

              case 27:
                _context25.next = 49;
                break;

              case 29:
                _context25.prev = 29;
                _context25.next = 32;
                return _this30.$axios.put("/Webshift", {
                  id: _this30.selectedShift.empId,
                  empId: _this30.selectedEmployee.id,
                  date: _this30.selectedShift.date,
                  entry: _this30.selectedShift.entry,
                  exit: _this30.selectedShift.exit,
                  allowenceId: _this30.selectedShift.allowenceId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context25.sent;

                if (!(_response.status == 200)) {
                  _context25.next = 40;
                  break;
                }

                _context25.next = 36;
                return _this30.getShifts();

              case 36:
                $("#modal-shift").modal("hide");
                alertify.success(_this30.$ml.get("alerts.updatedSuccessfully"));
                _context25.next = 41;
                break;

              case 40:
                alertify.error(_response.message);

              case 41:
                _this30.isLoading = false;
                _context25.next = 49;
                break;

              case 44:
                _context25.prev = 44;
                _context25.t1 = _context25["catch"](29);

                console.error(_context25.t1);
                alertify.error(_context25.t1.message);
                _this30.isLoading = false;

              case 49:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this30, [[6, 22], [29, 44]]);
      }))();
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var idList;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                idList = [];
                _context26.next = 3;
                return _this31.employeeList.forEach(function (emp) {
                  idList.push(emp.id);
                });

              case 3:
                return _context26.abrupt("return", idList);

              case 4:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this31);
      }))();
    },
    getRealMovements: function getRealMovements() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var empIds, shifts, response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;

                _this32.isLoading = true;
                _context27.next = 4;
                return _this32.getSelectedEmployeeList();

              case 4:
                empIds = _context27.sent;
                shifts = [];
                _context27.next = 8;
                return _this32.$axios.post("/Webshift/RealMovements", {
                  employeeIds: empIds,
                  year: _this32.year,
                  monthOrWeekNumber: _this32.monthOrWeekNumber,
                  isMonth: false
                }).then(function (response) {
                  shifts = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context27.sent;

                _this32.shifts = shifts;
                _this32.isLoading = false;
                _context27.next = 18;
                break;

              case 13:
                _context27.prev = 13;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error("Servis Hatası :" + _context27.t0.message);
                _this32.isLoading = false;

              case 18:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this32, [[0, 13]]);
      }))();
    },
    getShifts: function getShifts() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var empIds, shifts, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;

                _this33.isLoading = true;
                _context28.next = 4;
                return _this33.getSelectedEmployeeList();

              case 4:
                empIds = _context28.sent;
                shifts = [];
                _context28.next = 8;
                return _this33.$axios.post("/Webshift/GetShift", {
                  employeeIds: empIds,
                  year: _this33.year,
                  monthOrWeekNumber: _this33.monthOrWeekNumber,
                  isMonth: false
                }).then(function (response) {
                  shifts = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context28.sent;

                _this33.shifts = shifts;
                _this33.isLoading = false;
                _context28.next = 18;
                break;

              case 13:
                _context28.prev = 13;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);
                _this33.isLoading = false;

              case 18:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this33, [[0, 13]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this34 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this34.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this34.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this34.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this34.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this34.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this34.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getShiftSetting: function getShiftSetting() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;

                _this35.isLoading = true;
                _context29.next = 4;
                return _this35.$axios.get("WebshiftSettings").then(function (response) {
                  _this35.webshiftSettings = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context29.sent;

                _this35.isLoading = false;
                _context29.next = 13;
                break;

              case 8:
                _context29.prev = 8;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error(_context29.t0);
                _this35.isLoading = false;

              case 13:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this35, [[0, 8]]);
      }))();
    },
    getCalendar: function getCalendar() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var days, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;

                _this36.isLoading = true;
                days = [];
                _context30.next = 5;
                return _this36.$axios.get("/Webshift/Calendar?year=" + _this36.year + "&monthOrWeekNumber=" + _this36.monthOrWeekNumber + "&isMonth=false").then(function (response) {
                  days = response.data.dates;
                  _this36.isForbidden = response.data.isForbidden;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context30.sent;

                _this36.selectedDays = days;
                _this36.isLoading = false;
                _context30.next = 15;
                break;

              case 10:
                _context30.prev = 10;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Servis Hatası :" + _context30.t0.message);
                _this36.isLoading = false;

              case 15:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this36, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this37 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
      var curr, week, i, first, day, startDateOfYear, _i, a, days, weekNumber, weekNumber2, filter;

      return regeneratorRuntime.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return _this37.getDepartments();

            case 2:
              _context31.next = 4;
              return _this37.getAccessGroups();

            case 4:
              if (!_this37.modules.diningHall) {
                _context31.next = 7;
                break;
              }

              _context31.next = 7;
              return _this37.getFoodGroups();

            case 7:
              _context31.next = 9;
              return _this37.getStatus();

            case 9:
              _context31.next = 11;
              return _this37.getStates();

            case 11:
              _context31.next = 13;
              return _this37.getTitles();

            case 13:
              _context31.next = 15;
              return _this37.getWorkGroups();

            case 15:
              _context31.next = 17;
              return _this37.getExtraFields();

            case 17:
              _context31.next = 19;
              return _this37.getAllowences();

            case 19:
              _context31.next = 21;
              return _this37.getShiftSetting();

            case 21:
              $("body").addClass("sidebar-collapse"); //Sidebar kapatılarak tam ekrana geçiliyor
              curr = new Date();
              week = [];

              for (i = 2; i <= 8; i++) {
                //Bu haftanın günleri week adlı array içine diziliyor
                first = curr.getDate() - curr.getDay() + i;
                day = new Date(curr.setDate(first)).toISOString().slice(0, 10);

                week.push(day);
              }
              _this37.startDateNow = new Date(week[0] + " 00:00");
              _this37.endDateNow = new Date(week[6] + " 23:59");
              _context31.next = 29;
              return _this37.startDateNow.setDate(_this37.startDateNow.getDate() + 7);

            case 29:
              _context31.next = 31;
              return _this37.endDateNow.setDate(_this37.endDateNow.getDate() + 7);

            case 31:
              // Shift düzenleme sonu bir hafta sonrası + pazartesi
              startDateOfYear = null; //YILIN İLK PAZARTESİ GÜNÜ

              for (_i = 0; _i < 7; _i++) {
                a = new Date(_this37.startDateNow.getFullYear(), 0, _i);

                if (a.toLocaleString("default", { weekday: "long" }) == "Pazartesi" || a.toLocaleString("default", { weekday: "long" }) == "Monday") {
                  startDateOfYear = a;
                  _i = 7;
                }
              }
              _context31.next = 35;
              return Math.floor((_this37.startDateNow - startDateOfYear) / (24 * 60 * 60 * 1000));

            case 35:
              days = _context31.sent;
              _context31.next = 38;
              return Math.ceil(days / 7);

            case 38:
              _context31.t0 = _context31.sent;
              weekNumber = _context31.t0 + 1;

              _this37.year = _this37.startDateNow.getFullYear();
              _this37.monthOrWeekNumber = weekNumber;
              weekNumber2 = "0";

              if (weekNumber < 10) {
                weekNumber2 = "0" + weekNumber;
              } else {
                weekNumber2 = weekNumber;
              }
              _this37.selectedWeek = _this37.startDateNow.getFullYear() + "-W" + weekNumber2;

              if (!_this37.defaultFilters) {
                _context31.next = 51;
                break;
              }

              filter = _this37.defaultFilters;
              _context31.next = 49;
              return _this37.setUserAuthorityFilter(filter);

            case 49:
              _context31.next = 51;
              return _this37.getEmployees();

            case 51:
              _context31.next = 53;
              return _this37.getDateOfIsOWeek(_this37.selectedWeek);

            case 53:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31, _this37);
    }))();
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__microsoft_signalr__ = __webpack_require__(81);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      connection: false,
      waitingVisitor: {
        id: null,
        identityNo: "",
        name: "",
        visitTo: "",
        visitToSicil: "",
        reason: "",
        date: null,
        description: "",
        employeeId: null
      },
      blacklistVisitor: {
        id: null,
        identityNo: "",
        name: "",
        description: ""
      },
      gelisNedeni: {
        id: null,
        name: ""
      },
      visitor: {
        id: null,
        name: "",
        identityNo: "",
        employeeId: "",
        departmentId: null,
        visitTo: "",
        visitToSicil: "",
        reason: "",
        entryDate: "",
        toWho: "",
        description: "",
        mobilePhone: "",
        isTemporaryCard: false
      },
      visitorCard: {
        id: null,
        cardName: "",
        status: "",
        terminalNo: "",
        cardNo: "",
        accessDoor: "",
        lastPerson: ""
      },
      employee: {
        photo: null,
        name: "",
        lastStatus: null,
        lastMovementTime: null,
        lastMovementPoint: "",
        title: "",
        department: "",
        state: "",
        status: ""
      },
      employeeVisitor: {
        id: null,
        sicilNo: "",
        photo: null,
        name: "",
        lastStatus: null,
        lastMovementPoint: "",
        title: "",
        department: ""
      },
      selectedWaitingVisitorId: "",
      selectedWaitingVisitorName: "",
      selectedBlackListId: "",
      selectedBlackListName: "",
      selectedReasonId: "",
      selectedReasonName: "",
      type: 1,
      activeTab: 1,
      isNewVisitor: true,
      isNewBlacklist: true,
      isNewWaitingVisitor: true,
      isNewGelisNedeni: true,
      employeeSearchText: "",
      searchText: "",
      searchText2: "",
      oldRecords: [],
      cardGroups: [],
      employees: [],
      visitorCards: [],
      waitingVisitors: [],
      blacklistVisitors: [],
      gelisNedenleri: [],
      departments: [],
      selectedGroupName: this.$ml.get("visitors.selectVisitorCardGroup"),
      selectedGroupId: null,
      isLoading: false,
      isLoadingEmployee: false,
      isLoadingVisitor: false,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      }
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    conStatus: function conStatus() {
      return this.connection;
    },
    waitingVisitorList: function waitingVisitorList() {
      return this.waitingVisitors;
    },
    blacklistVisitorList: function blacklistVisitorList() {
      return this.blacklistVisitors;
    },
    gelisNedeniList: function gelisNedeniList() {
      return this.gelisNedenleri;
    },
    visitorCardList: function visitorCardList() {
      return this.visitorCards.sort(function (a, b) {
        if (a.cardName < b.cardName) return -1;
        if (a.cardName > b.cardName) return 0;
      });
    },
    employeeList: function employeeList() {
      return this.employees;
    },
    cardGroupList: function cardGroupList() {
      return this.cardGroups;
    },
    changeIsTemporaryCard: function changeIsTemporaryCard() {
      return this.visitor.isTemporaryCard;
    },
    oldRecordList: function oldRecordList() {
      return this.oldRecords;
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this = this;

      if (this.employeeSearchText != "") {
        if ($.isNumeric(this.employeeSearchText) == false) {
          return this.employeeList.filter(function (item) {
            return _this.employeeSearchText.toUpperCase().split(" ").every(function (v) {
              return item.name.toUpperCase().includes(v);
            });
          });
        } else {
          return this.employeeList.filter(function (item) {
            return _this.employeeSearchText.split(" ").every(function (v) {
              return item.name.includes(v);
            });
          });
        }
      } else {
        return this.employeeList.sort(function (a, b) {
          if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
          if (a.name.toUpperCase() > b.name.toUpperCase()) return 0;
        });
      }
    },
    employeeFilteredList: function employeeFilteredList() {
      var _this2 = this;

      if (this.searchText2 != "") {
        if ($.isNumeric(this.searchText2) == false) {
          return this.employeeList.filter(function (item) {
            return _this2.searchText2.toUpperCase().split(" ").every(function (v) {
              return item.name.toUpperCase().includes(v);
            });
          });
        } else {
          return this.employeeList.filter(function (item) {
            return _this2.searchText2.split(" ").every(function (v) {
              return item.name.includes(v);
            });
          });
        }
      } else {
        return this.employeeList;
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    departmentFilteredList: function departmentFilteredList() {
      var _this3 = this;

      if (this.searchText2 != "") {
        if ($.isNumeric(this.searchText2) == false) {
          return this.departmentList.filter(function (item) {
            return _this3.searchText2.toUpperCase().split(" ").every(function (v) {
              return item.name.toUpperCase().includes(v);
            });
          });
        } else {
          return this.departmentList.filter(function (item) {
            return _this3.searchText2.split(" ").every(function (v) {
              return item.name.includes(v);
            });
          });
        }
      } else {
        return this.departmentList;
      }
    },
    visitorCardFilteredList: function visitorCardFilteredList() {
      var _this4 = this;

      if (this.searchText) {
        if ($.isNumeric(this.searchText) == false) {
          return this.visitorCardList.filter(function (item) {
            return _this4.searchText.toUpperCase().split(" ").every(function (v) {
              return item.cardName.toUpperCase().includes(v) || item.lastPerson.toUpperCase().includes(v);
            });
          });
        } else {
          return this.visitorCardList.filter(function (item) {
            return _this4.searchText.split(" ").every(function (v) {
              return item.cardName.includes(v) || item.lastPerson.includes(v);
            });
          });
        }
      } else {
        return this.visitorCardList;
      }
    },
    hazirCardFilteredList: function hazirCardFilteredList() {
      var hazir = "Hazır";
      return this.visitorCardList.filter(function (item) {
        return hazir.toUpperCase().split(" ").every(function (v) {
          return item.status.toUpperCase().includes(v);
        });
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowVisitorsHeightSize: function windowVisitorsHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 310;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowEmployeesHeightSize: function windowEmployeesHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 520;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    baseURL: function baseURL() {
      return this.$store.getters.getBaseURL;
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this5.onResize);
    });
    var hubConnection = new __WEBPACK_IMPORTED_MODULE_0__microsoft_signalr__["a" /* HubConnectionBuilder */]().withUrl(this.baseURL + "/VisitorMonitor").withAutomaticReconnect().build();
    // connecting to the hub
    hubConnection.start().then(function () {
      console.log("connection started");
      _this5.connection = true;
    }).catch(function (err) {
      console.log("connecting hub failed err is : ", err);
      _this5.connection = false;
    });

    //at the hub there is a function named broadcastMessage, should return string that will be added to an array. should it be at sotr's getter
    hubConnection.on("VisitorUpdated", function (result) {
      if (result == true) {
        //Kartları Güncelle
        if (_this5.selectedGroupId != null) {
          _this5.getVisitorCards(_this5.selectedGroupId, _this5.selectedGroupName);
        } else {
          _this5.getVisitorCards(0, _this5.$ml.get("general.all"));
        }
      }
    });

    hubConnection.onclose(function () {
      console.log("connection failed");
      _this5.connection = false;
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeToWho: function changeToWho(event) {
      this.visitor.toWho = event.target.value;
    },
    changeNeden1: function changeNeden1(event) {
      this.visitor.reason = event.target.value;
    },
    changeNeden2: function changeNeden2(event) {
      this.waitingVisitor.reason = event.target.value;
    },
    getVisitorFromId: function getVisitorFromId(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, visitorCard;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this6.visitorCards;
                _context.next = 3;
                return aList.filter(function (item) {
                  return item.id == id;
                });

              case 3:
                visitorCard = _context.sent;

                if (!(visitorCard != "" && visitorCard != null)) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", visitorCard[0]);

              case 8:
                return _context.abrupt("return", null);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    getCardGroupNameFromId: function getCardGroupNameFromId(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var aList, visitorCardGroup;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                aList = _this7.cardGroups;
                _context2.next = 3;
                return aList.filter(function (item) {
                  return item.id == id;
                });

              case 3:
                visitorCardGroup = _context2.sent;

                if (!(visitorCardGroup != "" && visitorCardGroup != null)) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return", visitorCardGroup[0].name);

              case 8:
                return _context2.abrupt("return", null);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = null;
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = null;
      this.filters.workGroupId = null;
      this.filters.title = "";
      this.filters.stateId = null;
      this.filters.statuId = null;
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
    },
    getEmployees: function getEmployees() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this8.searchText2 != null && _this8.searchText2 != "") {
                  _this8.filters.nameOrCardNumber = _this8.searchText2;
                }

                if (!(_this8.filters.nameOrCardNumber == "")) {
                  _context3.next = 4;
                  break;
                }

                alertify.warning("Lütfen arama kısmını boş bırakmayın...");
                return _context3.abrupt("return");

              case 4:
                _context3.prev = 4;

                _this8.isLoadingEmployee = true;
                employees = [];
                filters2 = _this8.filters;
                _context3.next = 10;
                return _this8.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  employees = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this8.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context3.sent;

                _this8.employees = employees;
                _this8.isLoadingEmployee = false;
                _context3.next = 20;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](4);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);
                _this8.isLoadingEmployee = false;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[4, 15]]);
      }))();
    },
    newBlacklistVisitor: function newBlacklistVisitor() {
      this.isNewBlacklist = true;
      this.blacklistVisitor.id = null;
      this.blacklistVisitor.identityNo = "";
      this.blacklistVisitor.name = "";
      this.blacklistVisitor.description = "";
      this.selectedBlackListId = "";
      this.selectedBlackListName = "";
    },
    selectBlacklistVisitorDetail: function selectBlacklistVisitorDetail(id, name, identityNo, description) {
      this.isNewBlacklist = false;
      this.blacklistVisitor.id = id;
      this.blacklistVisitor.identityNo = identityNo;
      this.blacklistVisitor.name = name;
      this.blacklistVisitor.description = description;
    },
    editBlacklistVisitor: function editBlacklistVisitor(id, name) {
      this.selectedBlackListId = id;
      this.selectedBlackListName = name;
    },
    newWaitingVisitor: function newWaitingVisitor() {
      this.isNewWaitingVisitor = true;
      this.waitingVisitor.id = null;
      this.waitingVisitor.identityNo = "";
      this.waitingVisitor.name = "";
      this.waitingVisitor.employeeId = null;
      this.waitingVisitor.visitTo = "";
      this.waitingVisitor.visitToSicil = "";
      this.waitingVisitor.reason = "";
      this.waitingVisitor.date = "";
      this.waitingVisitor.description = "";
      this.searchText2 = "";
      this.employeeVisitor.id = null;
      this.employeeVisitor.photo = null;
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = null;
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
      this.selectedWaitingVisitorId = "", this.selectedWaitingVisitorName = "";
    },
    editWaitingVisitor: function editWaitingVisitor(id, name) {
      this.selectedWaitingVisitorId = id;
      this.selectedWaitingVisitorName = name;
    },
    selectWaitingVisitor: function selectWaitingVisitor(id, identityNo, name, visitTo, visitToSicil, reason, date, description, employeeId) {
      this.isNewWaitingVisitor = false;
      this.waitingVisitor.id = id;
      this.waitingVisitor.identityNo = identityNo;
      this.waitingVisitor.name = name;
      this.waitingVisitor.visitTo = visitTo;
      this.waitingVisitor.visitToSicil = visitToSicil;
      this.waitingVisitor.reason = reason;
      this.waitingVisitor.date = date;
      this.waitingVisitor.description = description;
      this.waitingVisitor.employeeId = employeeId;
      this.getEmployeeDetail(employeeId, 3);
    },
    deleteWaitingVisitor: function deleteWaitingVisitor(id) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this9.isLoading = true;

                if (!(id != null)) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 5;
                return _this9.$axios.delete("/Visitors/DeleteWaitingVisitor/" + id).then(function (response) {
                  _this9.getWaitingVisitors();
                  _this9.newWaitingVisitor();
                  alertify.success(_this9.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this9.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this9.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context4.sent;

              case 6:
                _this9.isLoading = false;
                _context4.next = 13;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);

                alertify.error("Hata Oluştu : " + _context4.t0);
                _this9.isLoading = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this9, [[0, 9]]);
      }))();
    },
    deleteBlacklistVisitor: function deleteBlacklistVisitor(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this10.isLoading = true;

                if (!(id != null)) {
                  _context5.next = 6;
                  break;
                }

                _context5.next = 5;
                return _this10.$axios.delete("/Visitors/DeleteBlackList/" + id).then(function (response) {
                  _this10.getBlacklistVisitors();
                  _this10.newBlacklistVisitor();
                  alertify.success(_this10.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this10.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this10.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context5.sent;

              case 6:
                _this10.isLoading = false;
                _context5.next = 13;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);

                alertify.error("Hata Oluştu : " + _context5.t0);
                _this10.isLoading = false;

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[0, 9]]);
      }))();
    },
    newGelisNedeni: function newGelisNedeni() {
      this.isNewGelisNedeni = true;
      this.gelisNedeni.id = null;
      this.gelisNedeni.name = "";
      this.selectedReasonId = "";
      this.selectedReasonName = "";
    },
    selectGelisNedeni: function selectGelisNedeni(id, name) {
      this.isNewGelisNedeni = false;
      this.gelisNedeni.id = id;
      this.gelisNedeni.name = name;
    },
    editGelisNedeni: function editGelisNedeni(id, name) {
      this.selectedReasonId = id;
      this.selectedReasonName = name;
    },
    deleteGelisNedeni: function deleteGelisNedeni(id) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this11.isLoading = true;

                if (!(id != null)) {
                  _context6.next = 6;
                  break;
                }

                _context6.next = 5;
                return _this11.$axios.delete("/Visitors/DeleteReason/" + id).then(function (response) {
                  _this11.getGelisNedenleri();
                  _this11.newGelisNedeni();
                  alertify.success(_this11.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this11.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this11.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context6.sent;

              case 6:
                _this11.isLoading = false;
                _context6.next = 13;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);

                alertify.error("Hata Oluştu : " + _context6.t0);
                _this11.isLoading = false;

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this11, [[0, 9]]);
      }))();
    },
    saveGelisNedeni: function saveGelisNedeni() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var gelisNedeni, response, _gelisNedeni, _response;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this12.isLoading = true;

                if (!_this12.isNewGelisNedeni) {
                  _context7.next = 17;
                  break;
                }

                _context7.prev = 2;
                gelisNedeni = _this12.gelisNedeni;
                _context7.next = 6;
                return _this12.$axios.post("/Visitors/AddReason", {
                  name: gelisNedeni.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this12.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  var id = response.data.id;
                  _this12.getGelisNedenleri();
                  _this12.newGelisNedeni();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this12.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this12.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 6:
                response = _context7.sent;

                _this12.isLoading = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](2);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this12.isLoading = false;

              case 15:
                _context7.next = 30;
                break;

              case 17:
                _context7.prev = 17;
                _gelisNedeni = _this12.gelisNedeni;
                _context7.next = 21;
                return _this12.$axios.post("/Visitors/UpdateReason/" + _gelisNedeni.id, {
                  id: _gelisNedeni.id,
                  name: _gelisNedeni.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this12.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this12.getGelisNedenleri();
                  _this12.newGelisNedeni();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this12.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this12.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 21:
                _response = _context7.sent;

                _this12.isLoading = false;
                _context7.next = 30;
                break;

              case 25:
                _context7.prev = 25;
                _context7.t1 = _context7["catch"](17);

                console.error(_context7.t1);
                alertify.error(_context7.t1);
                _this12.isLoading = false;

              case 30:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this12, [[2, 10], [17, 25]]);
      }))();
    },
    saveWaitingVisitorToCard: function saveWaitingVisitorToCard(cardId) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var waitingVisitor, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this13.isLoading = true;
                waitingVisitor = _this13.waitingVisitor;
                _context8.next = 5;
                return _this13.$axios.post("/Visitors/SaveWaitingVisitor?visitorId=" + waitingVisitor.id + "&cardId=" + cardId).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this13.$ml.get("alerts.savedSuccessfully"));
                    _this13.getWaitingVisitors();
                    _this13.getVisitorCards(_this13.selectedGroupId, _this13.selectedGroupName);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context8.sent;

                _this13.isLoading = false;
                _context8.next = 14;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Hata :" + _context8.t0.message);
                _this13.isLoading = false;

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this13, [[0, 9]]);
      }))();
    },
    saveBlacklist: function saveBlacklist() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var blacklist, response, _blacklist, _response2;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this14.isLoading = true;

                if (!_this14.isNewBlacklist) {
                  _context9.next = 17;
                  break;
                }

                _context9.prev = 2;
                blacklist = _this14.blacklistVisitor;
                _context9.next = 6;
                return _this14.$axios.post("/Visitors/AddBlackList", {
                  name: blacklist.name,
                  identityNo: blacklist.identityNo,
                  description: blacklist.description
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this14.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  var id = response.data.id;
                  _this14.getBlacklistVisitors();
                  _this14.newBlacklistVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this14.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this14.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 6:
                response = _context9.sent;

                _this14.isLoading = false;
                _context9.next = 15;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](2);

                console.error(_context9.t0);
                alertify.error(_context9.t0.message);
                _this14.isLoading = false;

              case 15:
                _context9.next = 30;
                break;

              case 17:
                _context9.prev = 17;
                _blacklist = _this14.blacklistVisitor;
                _context9.next = 21;
                return _this14.$axios.post("/Visitors/UpdateBlackList/" + _blacklist.id, {
                  id: _blacklist.id,
                  identityNo: _blacklist.identityNo,
                  name: _blacklist.name,
                  description: _blacklist.description
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this14.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this14.getBlacklistVisitors();
                  _this14.newBlacklistVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this14.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this14.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 21:
                _response2 = _context9.sent;

                _this14.isLoading = false;
                _context9.next = 30;
                break;

              case 25:
                _context9.prev = 25;
                _context9.t1 = _context9["catch"](17);

                console.error(_context9.t1);
                alertify.error(_context9.t1);
                _this14.isLoading = false;

              case 30:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this14, [[2, 10], [17, 25]]);
      }))();
    },
    saveWaitingVisitor: function saveWaitingVisitor() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var waitingVisitor, response, _waitingVisitor, _response3;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(_this15.waitingVisitor.identityNo == "")) {
                  _context10.next = 3;
                  break;
                }

                alertify.warning(_this15.$ml.get("alerts.visitorIdentityNumberNotBlank"));
                return _context10.abrupt("return");

              case 3:
                if (!(_this15.waitingVisitor.name == "")) {
                  _context10.next = 6;
                  break;
                }

                alertify.warning(_this15.$ml.get("alerts.visitorNameNotBlank"));
                return _context10.abrupt("return");

              case 6:
                _this15.isLoading = true;

                if (!_this15.isNewWaitingVisitor) {
                  _context10.next = 23;
                  break;
                }

                _context10.prev = 8;
                waitingVisitor = _this15.waitingVisitor;
                _context10.next = 12;
                return _this15.$axios.post("/Visitors/AddWaitingVisitor", {
                  identityNo: waitingVisitor.identityNo,
                  name: waitingVisitor.name,
                  visitTo: waitingVisitor.visitTo,
                  visitToSicil: waitingVisitor.visitToSicil,
                  reason: waitingVisitor.reason,
                  date: waitingVisitor.date,
                  description: waitingVisitor.description,
                  employeeId: waitingVisitor.employeeId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this15.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  var id = response.data.id;
                  _this15.getWaitingVisitors();
                  _this15.newWaitingVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this15.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this15.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 12:
                response = _context10.sent;

                _this15.isLoading = false;
                _context10.next = 21;
                break;

              case 16:
                _context10.prev = 16;
                _context10.t0 = _context10["catch"](8);

                console.error(_context10.t0);
                alertify.error(_context10.t0.message);
                _this15.isLoading = false;

              case 21:
                _context10.next = 36;
                break;

              case 23:
                _context10.prev = 23;
                _waitingVisitor = _this15.waitingVisitor;
                _context10.next = 27;
                return _this15.$axios.post("/Visitors/UpdateWaitingVisitor/" + _waitingVisitor.id, {
                  identityNo: _waitingVisitor.identityNo,
                  name: _waitingVisitor.name,
                  visitTo: _waitingVisitor.visitTo,
                  visitToSicil: _waitingVisitor.visitToSicil,
                  reason: _waitingVisitor.reason,
                  date: _waitingVisitor.date,
                  description: _waitingVisitor.description,
                  employeeId: _waitingVisitor.employeeId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this15.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this15.getWaitingVisitors();
                  _this15.newWaitingVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this15.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this15.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 27:
                _response3 = _context10.sent;

                _this15.isLoading = false;
                _context10.next = 36;
                break;

              case 31:
                _context10.prev = 31;
                _context10.t1 = _context10["catch"](23);

                console.error(_context10.t1);
                alertify.error(_context10.t1);
                _this15.isLoading = false;

              case 36:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this15, [[8, 16], [23, 31]]);
      }))();
    },
    saveVisitor: function saveVisitor() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var visitor, visitorCard, employeeVisitor, response, _visitor, _visitorCard, _employeeVisitor, _response4;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (!(_this16.visitor.isTemporaryCard == false)) {
                  _context11.next = 7;
                  break;
                }

                if (!(_this16.visitor.identityNo == "")) {
                  _context11.next = 4;
                  break;
                }

                alertify.warning(_this16.$ml.get("alerts.visitorIdentityNumberNotBlank"));
                return _context11.abrupt("return");

              case 4:
                if (!(_this16.visitor.name == "")) {
                  _context11.next = 7;
                  break;
                }

                alertify.warning(_this16.$ml.get("alerts.visitorNameNotBlank"));
                return _context11.abrupt("return");

              case 7:
                _this16.isLoadingVisitor = true;

                if (!_this16.isNewVisitor) {
                  _context11.next = 26;
                  break;
                }

                _context11.prev = 9;
                visitor = _this16.visitor;
                visitorCard = _this16.visitorCard;
                employeeVisitor = _this16.employeeVisitor;
                _context11.next = 15;
                return _this16.$axios.post("/Visitors/AddVisitor", {
                  name: visitor.name,
                  visitTo: employeeVisitor.name,
                  visitToSicil: employeeVisitor.sicilNo,
                  reason: visitor.reason,
                  description: visitor.description,
                  departmentId: visitor.departmentId,
                  identityNo: visitor.identityNo,
                  toWho: visitor.toWho,
                  cardId: visitorCard.id,
                  mobilePhone: visitor.mobilePhone,
                  isTemporaryCard: visitor.isTemporaryCard
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this16.$ml.get("alerts.savedSuccessfully"));
                    $("#modal-visitor").modal("hide");
                  } else if (response.status == 201) {
                    alertify.error(_this16.$ml.get("alerts.attentionPersonIsInBlackList"));
                  } else if (response.status == 202) {
                    alertify.error(_this16.$ml.get("alerts.cardIsUsed"));
                    if (_this16.connection == false) {
                      alertify.error(_this16.$ml.get("alerts.unableToConnectPageRefreshing"));
                      router.replace("/dashboard");
                    }
                  } else {
                    alertify.error(response.message);
                  }
                  var id = response.data.id;
                  _this16.getVisitorCards(_this16.selectedGroupId, _this16.selectedGroupName);
                  _this16.newVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this16.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 15:
                response = _context11.sent;

                _this16.isLoadingVisitor = false;
                _context11.next = 24;
                break;

              case 19:
                _context11.prev = 19;
                _context11.t0 = _context11["catch"](9);

                console.error(_context11.t0);
                alertify.error(_context11.t0.message);
                _this16.isLoadingVisitor = false;

              case 24:
                _context11.next = 41;
                break;

              case 26:
                _context11.prev = 26;
                _visitor = _this16.visitor;
                _visitorCard = _this16.visitorCard;
                _employeeVisitor = _this16.employeeVisitor;
                _context11.next = 32;
                return _this16.$axios.post("/Visitors/UpdateVisitor/" + _visitor.id, {
                  name: _visitor.name,
                  visitTo: _employeeVisitor.name,
                  visitToSicil: _employeeVisitor.sicilNo,
                  reason: _visitor.reason,
                  description: _visitor.description,
                  employeeId: _visitor.employeeId,
                  departmentId: _visitor.departmentId,
                  identityNo: _visitor.identityNo,
                  toWho: _visitor.toWho,
                  cardId: _visitorCard.id,
                  mobilePhone: _visitor.mobilePhone,
                  isTemporaryCard: _visitor.isTemporaryCard
                }).then(function (response) {
                  if (response.status == 200) {
                    $("#modal-visitor").modal("hide");
                    alertify.success(_this16.$ml.get("alerts.savedSuccessfully"));
                  } else if (response.status == 201) {
                    alertify.error(_this16.$ml.get("alerts.attentionPersonIsInBlackListNotBeenUpdated"));
                  } else {
                    alertify.error(response.message);
                  }
                  _this16.getVisitorCards(_this16.selectedGroupId, _this16.selectedGroupName);
                  _this16.newVisitor();
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this16.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 32:
                _response4 = _context11.sent;

                _this16.isLoadingVisitor = false;
                _context11.next = 41;
                break;

              case 36:
                _context11.prev = 36;
                _context11.t1 = _context11["catch"](26);

                console.error(_context11.t1);
                alertify.error(_context11.t1);
                _this16.isLoadingVisitor = false;

              case 41:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this16, [[9, 19], [26, 36]]);
      }))();
    },
    getOldRecordDetail: function getOldRecordDetail(name, identityNo, reason, toWho, description, mobilePhone, employeeId) {
      this.visitor.name = name;
      this.visitor.identityNo = identityNo;
      this.visitor.reason = reason;
      this.visitor.toWho = toWho;
      this.visitor.description = description;
      this.visitor.mobilePhone = mobilePhone;
      this.visitor.employeeId = employeeId;
      this.visitor.departmentId = departmentId;
      this.getEmployeeDetail(employeeId, 2);
    },
    isBlackList: function isBlackList(name, identityNo) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var data;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                data = null;

                if (!(name != "" && identityNo != "")) {
                  _context12.next = 5;
                  break;
                }

                _this17.blacklistVisitorList.filter(function (item) {
                  return item.name == name && item.name;
                });
                _context12.next = 13;
                break;

              case 5:
                if (!(name != "" && identityNo == "")) {
                  _context12.next = 8;
                  break;
                }

                _context12.next = 13;
                break;

              case 8:
                if (!(name == "" && identityNo != "")) {
                  _context12.next = 11;
                  break;
                }

                _context12.next = 13;
                break;

              case 11:
                return _context12.abrupt("return", false);

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this17);
      }))();
    },
    getOldRecords: function getOldRecords(name, identityNo) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var oldRecords, searchText5, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(name != "" || identityNo != "")) {
                  _context13.next = 20;
                  break;
                }

                _this18.isLoadingVisitor = true;
                _context13.prev = 2;
                oldRecords = [];
                searchText5 = "?";

                if (name.length > 4) {
                  searchText5 = searchText5 + "name=" + name;
                }
                if (identityNo.length > 4) {
                  if (searchText5 != "?") {
                    searchText5 = searchText5 + "&";
                  }
                  searchText5 = searchText5 + "identityNo=" + identityNo;
                }
                _context13.next = 9;
                return _this18.$axios.get("/Visitors/SearchOldRecords" + searchText5).then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      oldRecords.push({
                        name: doc.name,
                        identityNo: doc.identityNo,
                        visitTo: doc.visitTo,
                        visitToSicil: doc.visitToSicil,
                        reason: doc.reason,
                        toWho: doc.toWho,
                        description: doc.description,
                        mobilePhone: doc.mobilePhone,
                        employeeId: doc.employeeId
                      });
                    });
                  }
                  _this18.oldRecords = oldRecords;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this18.$store.dispatch("logout");
                    }
                    if (error.response.status == 204) {}
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this18.$ml.get("errors.connectionError"));
                      _this18.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this18.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context13.sent;

                _this18.isLoadingVisitor = false;
                _context13.next = 18;
                break;

              case 13:
                _context13.prev = 13;
                _context13.t0 = _context13["catch"](2);

                console.error(_context13.t0);
                alertify.error("Hata :" + _context13.t0.message);
                _this18.isLoadingVisitor = false;

              case 18:
                _context13.next = 21;
                break;

              case 20:
                _this18.oldRecords = [];

              case 21:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this18, [[2, 13]]);
      }))();
    },
    exitVisitor: function exitVisitor(id) {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this19.isLoadingVisitor = true;
                _this19.isNewVisitor = false;
                _context14.next = 5;
                return _this19.getVisitorFromId(id);

              case 5:
                _this19.visitorCard = _context14.sent;
                _context14.next = 8;
                return _this19.$axios.post("/Visitors/ExitVisitor?id=" + id).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this19.$ml.get("alerts.visitorSuccessfullyExit"));
                    _this19.newVisitor();
                    _this19.getVisitorCards(_this19.selectedGroupId, _this19.selectedGroupName);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this19.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this19.$ml.get("errors.connectionError"));
                      _this19.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this19.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context14.sent;

                _this19.isLoadingVisitor = false;
                _context14.next = 17;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Hata :" + _context14.t0.message);
                _this19.isLoadingVisitor = false;

              case 17:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this19, [[0, 12]]);
      }))();
    },
    cancelEmployee: function cancelEmployee() {
      this.visitor.employeeId = null;
      this.visitor.departmentId = null;
      this.visitor.visitTo = "";
      this.visitor.visitToSicil = "";
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = "";
      this.employeeVisitor.lastMovementTime = "";
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
      this.employeeVisitor.photo = "";
    },
    getDepartmentName: function getDepartmentName(departmentId) {
      var department = this.departmentList.filter(function (item) {
        return item.id == departmentId;
      });
      if (department[0]) {
        return department[0].name;
      } else {
        return "";
      }
    },
    getDepartmentDetail: function getDepartmentDetail(departmentId) {
      this.visitor.departmentId = departmentId;
    },
    getEmployeeDetail: function getEmployeeDetail(id, durum) {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                if (durum != 2) {
                  _this20.isLoadingEmployee = true;
                }
                _context15.next = 4;
                return _this20.$axios.get("/Visitors/GetEmployeesWithStatus?id=" + id).then(function (response) {
                  if (response.status == 200) {
                    if (durum == 1) {
                      _this20.employee.name = response.data.name;
                      _this20.employee.lastStatus = response.data.lastStatus;
                      _this20.employee.lastMovementTime = response.data.lastMovementTime;
                      _this20.employee.lastMovementPoint = response.data.lastMovementPoint;
                      _this20.employee.title = response.data.title;
                      _this20.employee.department = response.data.department;
                      _this20.employee.photo = response.data.photo;
                      _this20.employee.state = response.data.state;
                      _this20.employee.status = response.data.status;
                    } else if (durum == 2) {
                      _this20.visitor.employeeId = id;
                      _this20.visitor.visitTo = response.data.name;
                      _this20.visitor.visitToSicil = response.data.sicilNo;
                      _this20.employeeVisitor.sicilNo = response.data.sicilNo;
                      _this20.employeeVisitor.name = response.data.name;
                      _this20.employeeVisitor.lastStatus = response.data.lastStatus;
                      _this20.employeeVisitor.lastMovementTime = response.data.lastMovementTime;
                      _this20.employeeVisitor.lastMovementPoint = response.data.lastMovementPoint;
                      _this20.employeeVisitor.title = response.data.title;
                      _this20.employeeVisitor.department = response.data.department;
                      _this20.employeeVisitor.photo = response.data.photo;
                    } else {
                      _this20.waitingVisitor.employeeId = id;
                      _this20.waitingVisitor.visitTo = response.data.name;
                      _this20.waitingVisitor.visitToSicil = response.data.sicilNo;
                      _this20.employeeVisitor.sicilNo = response.data.sicilNo;
                      _this20.employeeVisitor.name = response.data.name;
                      _this20.employeeVisitor.lastStatus = response.data.lastStatus;
                      _this20.employeeVisitor.lastMovementTime = response.data.lastMovementTime;
                      _this20.employeeVisitor.lastMovementPoint = response.data.lastMovementPoint;
                      _this20.employeeVisitor.title = response.data.title;
                      _this20.employeeVisitor.department = response.data.department;
                      _this20.employeeVisitor.photo = response.data.photo;
                    }
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this20.isLoadingEmployee = false;
                _context15.next = 13;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Hata :" + _context15.t0.message);
                _this20.isLoadingEmployee = false;

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this20, [[0, 8]]);
      }))();
    },
    selectVisitor: function selectVisitor(id) {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return _this21.newVisitor();

              case 2:
                _context16.next = 4;
                return _this21.getVisitorFromId(id);

              case 4:
                _this21.visitorCard = _context16.sent;

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this21);
      }))();
    },
    newVisitor: function newVisitor() {
      this.isNewVisitor = true;
      this.visitor.id = null;
      this.visitor.name = "";
      this.visitor.identityNo = "";
      this.visitor.employeeId = null;
      this.visitor.departmentId = null;
      this.visitor.visitTo = "";
      this.visitor.visitToSicil = "";
      this.visitor.reason = "";
      this.visitor.entryDate = "";
      this.visitor.toWho = "";
      this.visitor.description = "";
      this.visitor.mobilePhone = "";
      this.visitor.isTemporaryCard = false;
      this.oldRecords = [];
      this.searchText2 = "";
      this.employeeVisitor.id = null;
      this.employeeVisitor.photo = null;
      this.employeeVisitor.sicilNo = "";
      this.employeeVisitor.name = "";
      this.employeeVisitor.lastStatus = null;
      this.employeeVisitor.lastMovementPoint = "";
      this.employeeVisitor.title = "";
      this.employeeVisitor.department = "";
    },
    getVisitorCardDetails: function getVisitorCardDetails(id) {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this22.isLoadingVisitor = true;
                _this22.isNewVisitor = false;
                _context17.next = 5;
                return _this22.getVisitorFromId(id);

              case 5:
                _this22.visitorCard = _context17.sent;
                _context17.next = 8;
                return _this22.$axios.get("/Visitors/getVisitorCardDetails?id=" + id).then(function (response) {
                  if (response.status == 200) {
                    _this22.visitor.id = response.data.id;
                    _this22.visitor.name = response.data.name;
                    _this22.visitor.identityNo = response.data.identityNo;
                    _this22.visitor.employeeId = response.data.employeeId;
                    _this22.visitor.departmentId = response.data.departmentId;
                    _this22.visitor.visitTo = response.data.visitTo;
                    _this22.visitor.visitToSicil = response.data.visitToSicil;
                    _this22.visitor.reason = response.data.reason;
                    _this22.visitor.entryDate = response.data.entryDate;
                    _this22.visitor.toWho = response.data.toWho;
                    _this22.visitor.description = response.data.description;
                    _this22.visitor.mobilePhone = response.data.mobilePhone;
                    _this22.getEmployeeDetail(response.data.employeeId, 2);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context17.sent;

                _this22.isLoadingVisitor = false;
                _context17.next = 17;
                break;

              case 12:
                _context17.prev = 12;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Hata :" + _context17.t0.message);
                _this22.isLoadingVisitor = false;

              case 17:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[0, 12]]);
      }))();
    },
    getWaitingVisitors: function getWaitingVisitors() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var waitingVisitors, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this23.isLoading = true;
                waitingVisitors = [];
                _context18.next = 5;
                return _this23.$axios.get("/Visitors/GetWaitingVisitors").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      waitingVisitors.push({
                        id: doc.id,
                        name: doc.name,
                        visitTo: doc.visitTo,
                        visitToSicil: doc.visitToSicil,
                        reason: doc.reason,
                        date: doc.date,
                        description: doc.description,
                        employeeId: doc.employeeId,
                        identityNo: doc.identityNo
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context18.sent;

                _this23.waitingVisitors = waitingVisitors;
                _this23.isLoading = false;
                _context18.next = 15;
                break;

              case 10:
                _context18.prev = 10;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Hata :" + _context18.t0.message);
                _this23.isLoading = false;

              case 15:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[0, 10]]);
      }))();
    },
    getBlacklistVisitors: function getBlacklistVisitors() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var blacklistVisitors, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this24.isLoading = true;
                blacklistVisitors = [];
                _context19.next = 5;
                return _this24.$axios.get("/Visitors/GetBlackList").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      blacklistVisitors.push({
                        id: doc.id,
                        identityNo: doc.identityNo,
                        name: doc.name,
                        description: doc.description
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context19.sent;

                _this24.blacklistVisitors = blacklistVisitors;
                _this24.isLoading = false;
                _context19.next = 15;
                break;

              case 10:
                _context19.prev = 10;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Hata :" + _context19.t0.message);
                _this24.isLoading = false;

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this24, [[0, 10]]);
      }))();
    },
    getGelisNedenleri: function getGelisNedenleri() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var gelisNedenleri, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;

                _this25.isLoading = true;
                gelisNedenleri = [];
                _context20.next = 5;
                return _this25.$axios.get("/Visitors/GetReasons").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      gelisNedenleri.push({
                        id: doc.id,
                        name: doc.name
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context20.sent;

                _this25.gelisNedenleri = gelisNedenleri;
                _this25.isLoading = false;
                _context20.next = 15;
                break;

              case 10:
                _context20.prev = 10;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error("Hata :" + _context20.t0.message);
                _this25.isLoading = false;

              case 15:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this25, [[0, 10]]);
      }))();
    },
    getCardGroups: function getCardGroups() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var cardGroups, response, activeUser, groupId, groupName;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;

                _this26.isLoadingVisitor = true;
                cardGroups = [];
                _context21.next = 5;
                return _this26.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      cardGroups.push({
                        id: doc.id,
                        name: doc.name
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context21.sent;

                _this26.cardGroups = cardGroups;
                activeUser = _this26.$store.getters.getUser;
                _context21.prev = 8;

                if (!activeUser.defaultVisitorCardGroup) {
                  _context21.next = 23;
                  break;
                }

                if (!(activeUser.defaultVisitorCardGroup != null && activeUser.defaultVisitorCardGroup != 0)) {
                  _context21.next = 19;
                  break;
                }

                groupId = activeUser.defaultVisitorCardGroup;
                _context21.next = 14;
                return _this26.getCardGroupNameFromId(groupId);

              case 14:
                groupName = _context21.sent;
                _context21.next = 17;
                return _this26.getVisitorCards(groupId, groupName);

              case 17:
                _context21.next = 21;
                break;

              case 19:
                _context21.next = 21;
                return _this26.getVisitorCards(0, _this26.$ml.get("general.all"));

              case 21:
                _context21.next = 25;
                break;

              case 23:
                _context21.next = 25;
                return _this26.getVisitorCards(0, _this26.$ml.get("general.all"));

              case 25:
                _context21.next = 30;
                break;

              case 27:
                _context21.prev = 27;
                _context21.t0 = _context21["catch"](8);

                console.error(_context21.t0);

              case 30:
                _this26.isLoadingVisitor = false;
                _context21.next = 38;
                break;

              case 33:
                _context21.prev = 33;
                _context21.t1 = _context21["catch"](0);

                console.error(_context21.t1);
                alertify.error("Hata :" + _context21.t1.message);
                _this26.isLoadingVisitor = false;

              case 38:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this26, [[0, 33], [8, 27]]);
      }))();
    },
    getVisitorCards: function getVisitorCards(cardGroupId, name) {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var visitorCards, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this27.isLoadingVisitor = true;
                _this27.selectedGroupName = name;
                _this27.selectedGroupId = cardGroupId;
                visitorCards = [];
                _context22.next = 7;
                return _this27.$axios.get("/Visitors/GetVisitorCards?groupId=" + cardGroupId).then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      visitorCards.push({
                        id: doc.id,
                        cardName: doc.cardName,
                        status: doc.status,
                        terminalNo: doc.terminalNo,
                        cardNo: doc.cardNo,
                        accessDoor: doc.accessDoor,
                        lastPerson: doc.lastPerson
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoadingVisitor = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoadingVisitor = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context22.sent;

                _this27.visitorCards = visitorCards;
                _this27.isLoadingVisitor = false;
                _context22.next = 17;
                break;

              case 12:
                _context22.prev = 12;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Hata :" + _context22.t0.message);
                _this27.isLoadingVisitor = false;

              case 17:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this27, [[0, 12]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                departments = [];
                _context23.prev = 1;
                _context23.next = 4;
                return _this28.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context23.sent;

                _this28.departments = departments;
                _this28.sortableTrees();
                _this28.isLoading = false;
                _context23.next = 14;
                break;

              case 10:
                _context23.prev = 10;
                _context23.t0 = _context23["catch"](1);

                console.error(_context23.t0);
                alertify.error(_context23.t0);

              case 14:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this28, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this29 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this29.sortableDepTrees.push(dep);
          _this29.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this30 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this30.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this30.subDepImport(doc2);
        });
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this31 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _this31.getCardGroups();
              _this31.getWaitingVisitors();
              _this31.getBlacklistVisitors();
              _this31.getGelisNedenleri();
              _this31.getDepartments();
              $("body").addClass("sidebar-collapse");

            case 6:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, _this31);
    }))();
  }
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingLogs: false,
      isLoadingEmployee: false,
      orderEmpList: 1,
      windowHeight: window.innerHeight,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: true,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: null,
        credit: 0,
        remainder: "0",
        isVisitor: true,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false,
        roomId: 0,
        roomName: "",
        areaName: "",
        floorName: "",
        fingerIndexes: [],
        isSmsSend: false,
        parentPhone: null,
        isStudent: false,
        isStayInDormitory: false,
        motherName: "",
        motherPhone: "",
        fatherName: "",
        fatherPhone: "",
        isMobileUser: false,
        mobilePassword: ""
      },
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 3,
        inOutType: 0,
        inOutAdd: "",
        readerId: "0",
        inOutStartDate: null,
        inOutEndDate: null
      },
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      logStartDate: null,
      logEndDate: null,
      status: [],
      foodGroups: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      isNewEmployee: true,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthKisiler;
    },
    logList: function logList() {
      return this.employee.logs;
    },
    readerList: function readerList() {
      return this.readers.sort(function (a, b) {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    activeReaderList: function activeReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true;
      });
    },
    activePDKSReaderList: function activePDKSReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true && item.doorType == 1;
      });
    },
    visitorCardGroupList: function visitorCardGroupList() {
      return this.visitorCardGroups;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    employeeList: function employeeList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.employees.sort(function (a, b) {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    allEmployeeList: function allEmployeeList() {
      return this.allEmployees;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    statuList: function statuList() {
      return this.status;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    inOutList: function inOutList() {
      return this.employee.inOuts;
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this.turkishToUpper(item.name).includes(v) || _this.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered: function filtered() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v) || _this2.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered: function inOutFiltered() {
      var _this3 = this;

      if (this.inOut.inOutListType == 0) {
        if (this.inOut.inOutListDoorType == 3) {
          return this.inOutList;
        } else {
          return this.inOutList.filter(function (item) {
            return item.doorType == _this3.inOut.inOutListDoorType;
          });
        }
      }
      if (this.inOut.inOutListType == 1) {
        return this.inOutList.filter(function (item) {
          if (_this3.inOut.inOutListDoorType == 3) {
            return item.isActive == true;
          } else {
            return item.isActive == true && item.doorType == _this3.inOut.inOutListDoorType;
          }
        });
      } else if (this.inOut.inOutListType == 2) {
        return this.inOutList.filter(function (item) {
          if (_this3.inOut.inOutListDoorType == 3) {
            return item.isActive == false;
          } else {
            return item.isActive == false && item.doorType == _this3.inOut.inOutListDoorType;
          }
        });
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this4.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    exportToPDFLogs: function exportToPDFLogs() {
      this.$htmlToPaper("printLogs");
    },
    exportToPDFHareketler: function exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    selectVisitorCardGroup: function selectVisitorCardGroup(id, name, devices) {
      var _this5 = this;

      this.isNewVisitorCardGroup = false;
      this.selectedVisitorCardGroupId = id;
      this.selectedVisitorCardGroupDevices = devices;
      this.readers.forEach(function (device) {
        device.VCGcheck = false;
      });
      if (devices) {
        devices.forEach(function (item) {
          _this5.readers.forEach(function (device) {
            if (item == device.readerId) {
              device.VCGcheck = true;
            }
          });
        });
      }
      this.selectedVisitorCardGroupName = name;
    },
    newVisitorCardGroup: function newVisitorCardGroup() {
      this.isNewVisitorCardGroup = true;
      this.readers.forEach(function (device) {
        device.VCGcheck = false;
      });
      this.selectedVisitorCardGroupId = null;
      this.selectedVisitorCardGroupDevices = [];
      this.selectedVisitorCardGroupName = "";
    },
    saveVisitorCardGroup: function saveVisitorCardGroup() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, name, devices, response, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this6.selectedVisitorCardGroupName == "")) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this6.$ml.get("alerts.visitorCardGroupNameNotBlank"));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                id = _this6.selectedVisitorCardGroupId;
                _context.next = 7;
                return _this6.getCheckReaders();

              case 7:
                name = _this6.selectedVisitorCardGroupName;
                devices = _this6.selectedVisitorCardGroupDevices;

                if (!(_this6.isNewVisitorCardGroup == true)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 12;
                return _this6.$axios.post("/VisitorGroups", {
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this6.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this6.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this6.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 12:
                response = _context.sent;

                _this6.newVisitorCardGroup();
                _this6.getVisitorCardGroups();
                _context.next = 22;
                break;

              case 17:
                _context.next = 19;
                return _this6.$axios.post("/VisitorGroups/" + id, {
                  id: id,
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this6.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this6.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this6.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 19:
                _response = _context.sent;

                _this6.newVisitorCardGroup();
                _this6.getVisitorCardGroups();

              case 22:
                _context.next = 28;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context["catch"](3);

                console.error(_context.t0);
                alertify.error(_context.t0.message);

              case 28:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[3, 24]]);
      }))();
    },
    deleteVisitorCardGroup: function deleteVisitorCardGroup() {
      var _this7 = this;

      try {
        var id = this.selectedVisitorCardGroupId;
        if (id != null) {
          var response = this.$axios.delete("/VisitorGroups/" + id).then(function (response) {
            _this7.getVisitorCardGroups();
            _this7.newVisitorCardGroup();
            alertify.success(_this7.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this7.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this7.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    selectStatu: function selectStatu(id, name) {
      this.isNewStatu = false;
      this.selectedStatuId = id;
      this.selectedStatuName = name;
    },
    newStatu: function newStatu() {
      this.isNewStatu = true;
      this.selectedStatuId = null;
      this.selectedStatuName = "";
    },
    saveStatu: function saveStatu() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, name, response, _response2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this8.selectedStatuName == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this8.$ml.get("alerts.statusNameNotBlank"));
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;
                id = _this8.selectedStatuId;
                name = _this8.selectedStatuName;

                if (!(_this8.isNewStatu == true)) {
                  _context2.next = 14;
                  break;
                }

                _context2.next = 9;
                return _this8.$axios.post("/Employees/AddStatus", {
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this8.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
                response = _context2.sent;

                _this8.newStatu();
                _this8.getStatus();
                _context2.next = 19;
                break;

              case 14:
                _context2.next = 16;
                return _this8.$axios.post("/Employees/UpdateStatus/" + id, {
                  id: id,
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this8.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 16:
                _response2 = _context2.sent;

                _this8.newStatu();
                _this8.getStatus();

              case 19:
                _context2.next = 25;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](3);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);

              case 25:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this8, [[3, 21]]);
      }))();
    },
    deleteStatu: function deleteStatu() {
      var _this9 = this;

      try {
        var id = this.selectedStatuId;
        if (id != null) {
          var response = this.$axios.delete("/Employees/DeleteStatus/" + id).then(function (response) {
            _this9.getStatus();
            _this9.newStatu();
            alertify.success(_this9.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this9.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this9.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    saveFoodCount: function saveFoodCount() {
      if (this.selectedFoodType == 1) {} else {}
    },
    changeInOutListType: function changeInOutListType(number) {
      this.inOut.inOutListType = number;
    },
    changeInOutListDoorType: function changeInOutListDoorType(number) {
      this.inOut.inOutListDoorType = number;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.employee.image = null;
    },
    getDepartmentFromId: function getDepartmentFromId(id) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    getLogs: function getLogs() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var logs, startDate, endDate, id, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this10.logStartDate == null | _this10.logEndDate == null)) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this10.$ml.get("alerts.invalidDate"));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                _this10.isLoadingLogs = true;
                logs = [];
                startDate = _this10.logStartDate;
                endDate = _this10.logEndDate;
                id = _this10.employee.id;
                _context3.next = 11;
                return _this10.$axios.post("/EmployeeDetails/GetOperationLogs", {
                  id: id,
                  startDate: startDate,
                  endDate: endDate
                });

              case 11:
                response = _context3.sent;

                response.data.forEach(function (doc) {
                  logs.push({
                    id: doc.id,
                    date: doc.date,
                    description: doc.description
                  });
                });
                _this10.employee.logs = logs;
                _this10.isLoadingLogs = false;
                _context3.next = 22;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this10.isLoadingLogs = false;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this10, [[3, 17]]);
      }))();
    },
    changeVisitorCardGroup: function changeVisitorCardGroup(event) {
      this.employee.visitorCardGroupId = event.target.value;
    },
    changeTerminalStatu: function changeTerminalStatu(event) {
      this.employee.terminalStatu = event.target.value;
    },
    changeFoodGroup: function changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
    },
    changeInOutDoor: function changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeInOutType: function changeInOutType(event) {
      this.inOut.inOutType = event.target.value;
    },
    changeDepartments: function changeDepartments(event) {
      this.employee.departmentId = event.target.value;
    },
    changeStatus: function changeStatus(event) {
      this.employee.statuId = event.target.value;
    },
    changeAccessGroups: function changeAccessGroups(event) {
      if (event.target.value != null && event.target.value != 0) {
        this.checkListFromAccessGroup(event.target.value);
      }
      this.employee.accessGroupId = event.target.value;
    },
    selectFoodType: function selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = true;
      this.filters.isActive = true;
    },
    checkReaders: function checkReaders() {
      var _this11 = this;

      this.isCheck = !this.isCheck;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this11.isCheck) {
          doc.check = _this11.isCheck;
        }
      });
    },
    getReaders: function getReaders() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                readers = [];
                _context4.next = 4;
                return _this12.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: false,
                          VCGcheck: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this12.$ml.get("alerts.getReadersError"));
                      _this12.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this12.readers = readers;
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası : " + _context4.t0.message);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this12, [[0, 8]]);
      }))();
    },
    updateFoodCredit: function updateFoodCredit() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var employeeId, credit, creditType, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this13.selectedFoodCount == null)) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning(_this13.$ml.get("alerts.creditNotBlank"));
                return _context5.abrupt("return");

              case 3:
                _context5.prev = 3;
                employeeId = _this13.employee.id;
                credit = _this13.selectedFoodCount.replace(",", ".");
                creditType = _this13.selectedFoodType;
                _context5.next = 9;
                return _this13.$axios.post("/EmployeeDetails/UpdateCredit", {
                  employeeId: employeeId,
                  creditType: creditType,
                  credit: credit
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this13.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this13.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this13.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
                response = _context5.sent;

                _this13.selectedFoodCount = 0;
                _this13.getEmployee(employeeId);
                _context5.next = 18;
                break;

              case 14:
                _context5.prev = 14;
                _context5.t0 = _context5["catch"](3);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);

              case 18:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this13, [[3, 14]]);
      }))();
    },
    getCheckReaders: function getCheckReaders() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this14.selectedVisitorCardGroupDevices = [];
                _context6.next = 3;
                return _this14.readers.forEach(function (doc) {
                  if (doc.VCGcheck == true) {
                    _this14.selectedVisitorCardGroupDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this14);
      }))();
    },
    sendUserToDevices: function sendUserToDevices() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var aList, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this15.isLoading = true;
                _context7.prev = 1;
                aList = [];
                _context7.next = 5;
                return _this15.readers.filter(function (doc) {
                  if (doc.check == true) {
                    aList.push(doc.readerId);
                  }
                });

              case 5:
                _context7.next = 7;
                return _this15.$axios.post("/EmployeeDetails/SendUserToDevices", {
                  empId: _this15.employee.id,
                  devices: aList
                }).then(function (response) {
                  if (response.status == 200) {
                    _this15.isLoading = false;
                    alertify.success(_this15.$ml.get("alerts.commandSentToDevicesSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this15.isLoading = false;
                    _this15.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this15.isLoading = false;
                    alertify.error(_this15.$ml.get("errors.connectionError"));
                  } else {
                    _this15.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 7:
                response = _context7.sent;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](1);

                _this15.isLoading = false;
                console.error(_context7.t0);
                alertify.error(_context7.t0.message);

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this15, [[1, 10]]);
      }))();
    },
    GetUserDataFromDevice: function GetUserDataFromDevice(readerId) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this16.isLoading = true;
                _context8.prev = 1;
                empId = _this16.employee.id;
                _context8.next = 5;
                return _this16.$axios.post("/EmployeeDetails/GetUserDataFromDevice", {
                  empId: empId,
                  readerId: readerId
                }).then(function (response) {
                  if (response.status == 200) {
                    _this16.isLoading = false;
                    alertify.success(_this16.$ml.get("alerts.getUserInfoFromTerminalsSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this16.isLoading = false;
                    _this16.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this16.isLoading = false;
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                  } else {
                    _this16.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context8.sent;
                _context8.next = 13;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](1);

                _this16.isLoading = false;
                console.error(_context8.t0);
                alertify.error(_context8.t0.message);

              case 13:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this16, [[1, 8]]);
      }))();
    },
    SendGetFaceCommand: function SendGetFaceCommand(readerId) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this17.isLoading = true;
                _context9.prev = 1;
                empId = _this17.employee.id;
                _context9.next = 5;
                return _this17.$axios.post("/EmployeeDetails/SendGetFaceCommand", {
                  empId: empId,
                  readerId: readerId
                }).then(function (response) {
                  if (response.status == 200) {
                    _this17.isLoading = false;
                    alertify.success(_this17.$ml.get("alerts.getFaceTemplateFromSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this17.isLoading = false;
                    _this17.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this17.isLoading = false;
                    alertify.error(_this17.$ml.get("errors.connectionError"));
                  } else {
                    _this17.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context9.sent;
                _context9.next = 13;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](1);

                _this17.isLoading = false;
                console.error(_context9.t0);
                alertify.error(_context9.t0.message);

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this17, [[1, 8]]);
      }))();
    },
    SendGetFingerCommand: function SendGetFingerCommand(readerId) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var empId, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this18.isLoading = true;
                _context10.prev = 1;
                empId = _this18.employee.id;
                _context10.next = 5;
                return _this18.$axios.post("/EmployeeDetails/SendGetFingerCommand", {
                  empId: empId,
                  readerId: readerId
                }).then(function (response) {
                  if (response.status == 200) {
                    _this18.isLoading = false;
                    alertify.success(_this18.$ml.get("alerts.getFingerprintsFromTerminalsSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this18.isLoading = false;
                    _this18.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    _this18.isLoading = false;
                    alertify.error(_this18.$ml.get("errors.connectionError"));
                  } else {
                    _this18.isLoading = false;
                    alertify.error(doc.message);
                  }
                });

              case 5:
                response = _context10.sent;
                _context10.next = 13;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](1);

                _this18.isLoading = false;
                console.error(_context10.t0);
                alertify.error(_context10.t0.message);

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this18, [[1, 8]]);
      }))();
    },
    selectNode: function selectNode() {
      this.isLoading = true;
      var node = document.getElementById("selectedNode").value;
      this.employee.departmentId = this.getDepartmentFromName(node);
      $("#select-department").modal("hide");
      this.isLoading = false;
    },
    getDepartmentFromName: function getDepartmentFromName(name) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0].id;
      } else {
        return null;
      }
    },
    setTree: function setTree() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var activeUser, departments, root, tree;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this19.$store.getters.getUser;

              case 2:
                activeUser = _context11.sent;
                departments = _this19.departments;
                root = new TreeNode(activeUser.companyName + " (" + _this19.$ml.get("shared.company") + ")");
                _context11.next = 7;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == null) {
                    var node = new TreeNode(doc.name);
                    root.addChild(node);
                    _this19.addChildDep(node, doc.id);
                  }
                });

              case 7:
                tree = new TreeView(root, "#treeview", {
                  leaf_icon: "<i class='fa fa-star'></i>",
                  parent_icon: "<i class='fa fa-sitemap'></i>",
                  open_icon: "<i class='fa fa-chevron-down'></i>",
                  close_icon: "<i class='fa fa-chevron-right'></i>"
                });

              case 8:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this19);
      }))();
    },
    addChildDep: function addChildDep(Tnode, mainDep) {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var departments;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                departments = _this20.departments;
                _context12.next = 3;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == mainDep) {
                    var node = new TreeNode(doc.name);
                    Tnode.addChild(node);
                    _this20.addChildDep(node, doc.id);
                  }
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this20);
      }))();
    },
    getChildDep: function getChildDep(dep) {
      var DepartmentList = this.departments;
      return DepartmentList.filter(function (department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind: function getMainFind(id) {
      var DepartmentList = this.departments;
      var department = DepartmentList.filter(function (department) {
        return department.id == id;
      });
    },
    getAccessGroupFromId: function getAccessGroupFromId(id) {
      var aList = this.accessGroups;
      var dep = aList.filter(function (accessGroups) {
        return accessGroups.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    checkListFromAccessGroup: function checkListFromAccessGroup(id) {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var accessGroup, aa;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                accessGroup = _this21.getAccessGroupFromId(id);
                aa = _this21.readers;
                _context13.next = 4;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 4:
                accessGroup.selectedReaders.forEach(function (secilenReader) {
                  _this21.readers.forEach(function (doc) {
                    if (doc.readerId == secilenReader.id) {
                      doc.check = true;
                    }
                  });
                });

              case 5:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this21);
      }))();
    },
    getCheckReaderList: function getCheckReaderList() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var aList;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                aList = _this22.readers;

                _this22.employee.readers = [];
                _context14.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this22.employee.readers.push(doc.readerId);
                  }
                });

              case 4:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this22);
      }))();
    },
    setCheckReaderList: function setCheckReaderList() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var aa, aList;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                aa = _this23.readers;
                _context15.next = 3;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 3:
                aList = _this23.employee.readers;
                _context15.next = 6;
                return aList.forEach(function (secilenReader) {
                  _this23.readers.forEach(function (doc) {
                    if (doc.readerId == secilenReader) {
                      doc.check = true;
                    }
                  });
                });

              case 6:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this23);
      }))();
    },
    getEmployeesFromCardNoFast: function getEmployeesFromCardNoFast(data) {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!(data.length > 9 && $.isNumeric(data) == true)) {
                  _context16.next = 10;
                  break;
                }

                _context16.next = 3;
                return _this24.filtersClear();

              case 3:
                _this24.filters.nameOrCardNumber = data;
                _this24.filters.isVisitor = true;
                _context16.next = 7;
                return _this24.getEmployees();

              case 7:
                _this24.searchText = "";
                _context16.next = 16;
                break;

              case 10:
                _context16.next = 12;
                return _this24.filtersClear();

              case 12:
                _this24.filters.nameOrCardNumber = data;
                _this24.filters.isVisitor = true;
                _context16.next = 16;
                return _this24.getEmployees();

              case 16:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this24);
      }))();
    },
    getVisitorCardGroups: function getVisitorCardGroups() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var cardGroups, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                cardGroups = [];
                _context17.next = 4;
                return _this25.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      cardGroups.push({
                        id: doc.id,
                        name: doc.name,
                        devices: doc.devices
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this25.visitorCardGroups = cardGroups;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Hata :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this25, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                accessGroups = [];
                _context18.next = 4;
                return _this26.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this26.accessGroups = accessGroups;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this26, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                departments = [];
                _context19.prev = 1;
                _context19.next = 4;
                return _this27.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this27.setTree();
                _this27.departments = departments;
                _this27.sortableTrees();
                _this27.isLoading = false;
                _context19.next = 15;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](1);

                console.error(_context19.t0);
                alertify.error(_context19.t0);

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this27, [[1, 11]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this28 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this28.sortableDepTrees.push(dep);
          _this28.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this29 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this29.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this29.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                foodGroups = [];
                _context20.next = 4;
                return _this30.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context20.sent;

                _this30.foodGroups = foodGroups;
                _context20.next = 12;
                break;

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error("Servis Hatası :" + _context20.t0.message);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this30, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                status = [];
                _context21.next = 4;
                return _this31.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context21.sent;

                _this31.status = status;
                _context21.next = 12;
                break;

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);

              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this31, [[0, 8]]);
      }))();
    },
    getInOuts: function getInOuts() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var inOuts, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (!_this32.isNewEmployee) {
                  _context22.next = 3;
                  break;
                }

                alertify.warning(_this32.$ml.get("alerts.selectedEmployeeNotBlank"));
                return _context22.abrupt("return");

              case 3:
                if (!(_this32.inOut.inOutStartDate == null || _this32.inOut.inOutEndDate == null || _this32.inOut.inOutStartDate > _this32.inOut.inOutEndDate)) {
                  _context22.next = 6;
                  break;
                }

                alertify.warning(_this32.$ml.get("alerts.invalidDate"));
                return _context22.abrupt("return");

              case 6:
                _context22.prev = 6;

                _this32.isLoadingInOuts = true;
                inOuts = [];
                selectedUser = _this32.employee.id;
                startDate = _this32.inOut.inOutStartDate;
                endDate = _this32.inOut.inOutEndDate;
                _context22.next = 14;
                return _this32.$axios.post("/EmployeeDetails/GetEntryExit", {
                  id: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    inOuts.push({
                      id: doc.id,
                      date: doc.date,
                      readerName: doc.readerName,
                      readerId: doc.readerId,
                      doorType: doc.doorType,
                      inOrOut: doc.inOrOut,
                      isActive: doc.isActive
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this32.$ml.get("errors.connectionError"));
                    _this32.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this32.isLoadingInOuts = false;
                    return;
                  }
                });

              case 14:
                response = _context22.sent;

                _this32.employee.inOuts = inOuts;
                _this32.isLoadingInOuts = false;
                _context22.next = 24;
                break;

              case 19:
                _context22.prev = 19;
                _context22.t0 = _context22["catch"](6);

                console.error(_context22.t0);
                alertify.error(_context22.t0.message);
                _this32.isLoadingInOuts = false;

              case 24:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this32, [[6, 19]]);
      }))();
    },
    newEmployee: function newEmployee() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var toDay, gun, ay, yil, aa;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this33.isLoading = true;
                _this33.isNewEmployee = true;
                _this33.imageData = null;
                _this33.tempUrl = null;
                _this33.selectedFoodType = 1;
                _this33.selectedFoodCount = 0;
                _this33.isNewState = true;
                _this33.selectedStateId = null;
                _this33.selectedStateName = "";
                _this33.isNewStatu = true;
                _this33.selectedStatuId = null;
                _this33.selectedStatuName = "";
                _this33.searchPayrollStartDate = null;
                _this33.searchPayrollEndDate = null;
                _this33.selectAP = 1;
                _this33.employee.id = null;
                _this33.employee.sicilNo = "";
                _this33.employee.image = null;
                _this33.employee.name = "";
                _this33.employee.departmentId = null;
                _this33.employee.title = "";
                _this33.employee.identityNo = "";
                toDay = new Date();
                gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
                ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
                yil = toDay.getFullYear();

                _this33.employee.startDate = yil + "-" + ay + "-" + gun;
                _this33.employee.endDate = null;
                _this33.employee.stateId = 1;
                _this33.employee.stateNote = "";
                _this33.employee.terminalNo = null;
                _this33.employee.statuId = null;
                _this33.employee.cardNo = "";
                _this33.employee.terminalStatu = 0;
                _this33.employee.terminalPassword = "";
                _this33.employee.workGroupId = null;
                _this33.employee.documentNo = "";
                _this33.employee.salary = null;
                _this33.employee.overWorkStatus = true;
                _this33.employee.mail = "";
                _this33.employee.mobilePhone = "";
                _this33.employee.birthDayDate = null;
                _this33.employee.address = "";
                _this33.employee.internalPhone = "";
                _this33.employee.homePhone = "";
                _this33.employee.gender = null;
                _this33.employee.educationStatus = null;
                _this33.employee.militaryStatus = null;
                _this33.employee.drivingLicence = "";
                _this33.employee.smokeStatus = null;
                _this33.employee.maritalStatus = null;
                _this33.employee.bloodType = "";
                _this33.employee.height = null;
                _this33.employee.weight = null;
                _this33.employee.disabledPercent = "";
                _this33.employee.authorizedPerson1 = null;
                _this33.employee.authorizedPerson2 = null;
                _this33.employee.note1 = "";
                _this33.employee.note2 = "";
                _this33.employee.foreignLanguage = "";
                _this33.employee.accessGroupId = null;
                _this33.employee.readers = [];
                _this33.employee.foodGroupId = null;
                _this33.employee.credit = 0;
                _this33.employee.remainder = "0";
                _this33.employee.isVisitor = true;
                _this33.employee.visitorCardGroupId = null;
                _this33.employee.isActive = true;
                _this33.employee.annualPermitId = 0;
                _this33.employee.annualPermitSeniority = 0;
                _this33.employee.annualPermitTransfer = 0;
                _this33.employee.annualPermitClaim = 0;
                _this33.employee.annualPermitUsed = 0;
                _this33.employee.annualPermitRemain = 0;
                _this33.employee.annualPermits = [];
                _this33.employee.annualPermitClaimsDates = [];
                _this33.employee.extrafields = [];
                _this33.employee.inOuts = [];
                _this33.employee.allowences = [];
                _this33.employee.logs = [];
                _this33.employee.hasCard = false;
                _this33.employee.hasFace = false;
                _this33.employee.hasFinger = false;
                _this33.employee.hasPassword = false;
                _context23.next = 86;
                return _this33.getNewSicilveTerminalNo();

              case 86:
                aa = _this33.readers;
                _context23.next = 89;
                return aa.forEach(function (dd) {
                  dd.check = false;
                });

              case 89:
                _this33.isLoading = false;

              case 90:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this33);
      }))();
    },
    deleteEmployee: function deleteEmployee() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;

                _this34.isLoading = true;
                id = _this34.employee.id;
                _context24.next = 5;
                return _this34.$axios.delete("/Employees/" + id);

              case 5:
                response = _context24.sent;

                _this34.getEmployees();
                _this34.newEmployee();
                alertify.success(response.data.message);
                _this34.isLoading = false;
                _context24.next = 16;
                break;

              case 12:
                _context24.prev = 12;
                _context24.t0 = _context24["catch"](0);

                alertify.error(_context24.t0);
                _this34.isLoading = false;

              case 16:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this34, [[0, 12]]);
      }))();
    },
    saveEmployee: function saveEmployee() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var employee2, id, image, response, formData, responseImage, _employee, _id, _image, _response3, _formData, _responseImage, _responseImage2;

        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                if (!(_this35.employee.sicilNo == "")) {
                  _context25.next = 3;
                  break;
                }

                alertify.warning(_this35.$ml.get("alerts.visitorCardRegistrationNumberNotBlank"));
                return _context25.abrupt("return");

              case 3:
                if (!(_this35.employee.name == "")) {
                  _context25.next = 6;
                  break;
                }

                alertify.warning(_this35.$ml.get("alerts.visitorCardNameNotBlank"));
                return _context25.abrupt("return");

              case 6:
                if (!(_this35.employee.terminalNo == "")) {
                  _context25.next = 9;
                  break;
                }

                alertify.warning(_this35.$ml.get("alerts.visitorCardDeviceNoNotBlank"));
                return _context25.abrupt("return");

              case 9:
                if (!(_this35.employee.startDate == "")) {
                  _context25.next = 12;
                  break;
                }

                alertify.warning(_this35.$ml.get("alerts.visitorCardCreateDateNotBlank"));
                return _context25.abrupt("return");

              case 12:
                _this35.isLoading = true;
                _context25.next = 15;
                return _this35.getCheckReaderList();

              case 15:
                if (!_this35.isNewEmployee) {
                  _context25.next = 50;
                  break;
                }

                _context25.prev = 16;
                employee2 = _this35.employee;
                id = 0;
                image = _this35.imageData;
                _context25.next = 22;
                return _this35.$axios.post("/Employees", {
                  sicilNo: employee2.sicilNo,
                  name: employee2.name,
                  departmentId: employee2.departmentId,
                  title: employee2.title,
                  identityNo: employee2.identityNo,
                  startDate: employee2.startDate,
                  endDate: employee2.endDate,
                  stateId: employee2.stateId,
                  stateNote: employee2.stateNote,
                  terminalNo: employee2.terminalNo,
                  statuId: employee2.statuId,
                  cardNo: employee2.cardNo,
                  terminalStatu: employee2.terminalStatu,
                  terminalPassword: employee2.terminalPassword,
                  workGroupId: employee2.workGroupId,
                  documentNo: employee2.documentNo,
                  salary: employee2.salary,
                  overWorkStatus: employee2.overWorkStatus,
                  mail: employee2.mail,
                  address: employee2.address,
                  mobilePhone: employee2.mobilePhone,
                  birthDayDate: employee2.birthDayDate,
                  internalPhone: employee2.internalPhone,
                  homePhone: employee2.homePhone,
                  gender: employee2.gender,
                  educationStatus: employee2.educationStatus,
                  militaryStatus: employee2.militaryStatus,
                  drivingLicence: employee2.drivingLicence,
                  smokeStatus: employee2.smokeStatus,
                  maritalStatus: employee2.maritalStatus,
                  bloodType: employee2.bloodType,
                  height: employee2.height,
                  weight: employee2.weight,
                  disabledPercent: employee2.disabledPercent,
                  authorizedPerson1: employee2.authorizedPerson1,
                  authorizedPerson2: employee2.authorizedPerson2,
                  note1: employee2.note1,
                  note2: employee2.note2,
                  foreignLanguage: employee2.foreignLanguage,
                  accessGroupId: parseInt(employee2.accessGroupId),
                  readers: employee2.readers,
                  foodGroupId: employee2.foodGroupId,
                  credit: employee2.credit,
                  remainder: employee2.remainder,
                  isVisitor: employee2.isVisitor,
                  visitorCardGroupId: employee2.visitorCardGroupId,
                  annualPermitId: employee2.annualPermitId,
                  annualPermitSeniority: employee2.annualPermitSeniority,
                  annualPermitTransfer: employee2.annualPermitTransfer,
                  validityDate: employee2.validityDate,
                  parentPhone: employee2.parentPhone,
                  isSmsSend: employee2.isSmsSend,
                  isStudent: employee2.isStudent,
                  isStayInDormitory: employee2.isStayInDormitory,
                  motherName: employee2.motherName,
                  motherPhone: employee2.motherPhone,
                  fatherName: employee2.fatherName,
                  fatherPhone: employee2.fatherPhone,
                  isMobileUser: employee2.isMobileUser,
                  mobilePassword: employee2.mobilePassword
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this35.$ml.get("errors.connectionError"));
                    _this35.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this35.isLoadingInOuts = false;
                    return;
                  }
                });

              case 22:
                response = _context25.sent;

                id = response.data.id;

                if (!(id != 0)) {
                  _context25.next = 39;
                  break;
                }

                if (!_this35.imageData) {
                  _context25.next = 32;
                  break;
                }

                formData = new FormData();

                formData.append("file", image);

                if (!(_this35.imageData != null)) {
                  _context25.next = 32;
                  break;
                }

                _context25.next = 31;
                return _this35.$axios.post("/Employees/AddEmployeePhoto/" + id, formData);

              case 31:
                responseImage = _context25.sent;

              case 32:
                alertify.success(_this35.$ml.get("alerts.savedSuccessfully"));
                _this35.getEmployees();
                _this35.getEmployee(id);
                _this35.isNewEmployee = false;
                _this35.isLoading = false;
                _context25.next = 41;
                break;

              case 39:
                alertify.error(response.message);
                _this35.isLoading = false;

              case 41:
                _context25.next = 48;
                break;

              case 43:
                _context25.prev = 43;
                _context25.t0 = _context25["catch"](16);

                _this35.isLoading = false;
                console.error(_context25.t0);
                alertify.error(_context25.t0);

              case 48:
                _context25.next = 81;
                break;

              case 50:
                _context25.prev = 50;
                _employee = _this35.employee;
                _id = _employee.id;
                _image = _this35.imageData;
                _context25.next = 56;
                return _this35.$axios.post("/Employees/" + _employee.id, {
                  sicilNo: _employee.sicilNo,
                  name: _employee.name,
                  departmentId: _employee.departmentId,
                  title: _employee.title,
                  identityNo: _employee.identityNo,
                  startDate: _employee.startDate,
                  endDate: _employee.endDate,
                  stateId: _employee.stateId,
                  stateNote: _employee.stateNote,
                  terminalNo: _employee.terminalNo,
                  statuId: _employee.statuId,
                  cardNo: _employee.cardNo,
                  terminalStatu: _employee.terminalStatu,
                  terminalPassword: _employee.terminalPassword,
                  workGroupId: _employee.workGroupId,
                  documentNo: _employee.documentNo,
                  salary: _employee.salary,
                  overWorkStatus: _employee.overWorkStatus,
                  mail: _employee.mail,
                  address: _employee.address,
                  mobilePhone: _employee.mobilePhone,
                  birthDayDate: _employee.birthDayDate,
                  internalPhone: _employee.internalPhone,
                  homePhone: _employee.homePhone,
                  gender: _employee.gender,
                  educationStatus: _employee.educationStatus,
                  militaryStatus: _employee.militaryStatus,
                  drivingLicence: _employee.drivingLicence,
                  smokeStatus: _employee.smokeStatus,
                  maritalStatus: _employee.maritalStatus,
                  bloodType: _employee.bloodType,
                  height: _employee.height,
                  weight: _employee.weight,
                  disabledPercent: _employee.disabledPercent,
                  authorizedPerson1: _employee.authorizedPerson1,
                  authorizedPerson2: _employee.authorizedPerson2,
                  note1: _employee.note1,
                  note2: _employee.note2,
                  foreignLanguage: _employee.foreignLanguage,
                  accessGroupId: parseInt(_employee.accessGroupId),
                  readers: _employee.readers,
                  foodGroupId: _employee.foodGroupId,
                  credit: _employee.credit,
                  remainder: _employee.remainder,
                  isVisitor: _employee.isVisitor,
                  visitorCardGroupId: _employee.visitorCardGroupId,
                  annualPermitId: _employee.annualPermitId,
                  annualPermitSeniority: _employee.annualPermitSeniority,
                  annualPermitTransfer: _employee.annualPermitTransfer,
                  validityDate: _employee.validityDate,
                  parentPhone: _employee.parentPhone,
                  isSmsSend: _employee.isSmsSend,
                  isStudent: _employee.isStudent,
                  isStayInDormitory: _employee.isStayInDormitory,
                  motherName: _employee.motherName,
                  motherPhone: _employee.motherPhone,
                  fatherName: _employee.fatherName,
                  fatherPhone: _employee.fatherPhone,
                  isMobileUser: _employee.isMobileUser,
                  mobilePassword: _employee.mobilePassword
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                      return;
                    } else if (error.response.status == 400) {
                      console.log(error.response.data.message);
                      alertify.error(error.response.data.message);
                      return;
                    }
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 56:
                _response3 = _context25.sent;

                if (!(_id != null)) {
                  _context25.next = 74;
                  break;
                }

                if (!_this35.imageData) {
                  _context25.next = 66;
                  break;
                }

                _formData = new FormData();

                _formData.append("file", _image);
                _context25.next = 63;
                return _this35.$axios.post("/Employees/AddEmployeePhoto/" + _id, _formData);

              case 63:
                _responseImage = _context25.sent;
                _context25.next = 70;
                break;

              case 66:
                if (!(_this35.employee.image == null)) {
                  _context25.next = 70;
                  break;
                }

                _context25.next = 69;
                return _this35.$axios.patch("/Employees/RemovePhoto/" + _id);

              case 69:
                _responseImage2 = _context25.sent;

              case 70:
                alertify.success(_this35.$ml.get("alerts.updatedSuccessfully"));
                _this35.getEmployees();
                _context25.next = 75;
                break;

              case 74:
                alertify.error(_response3.message);

              case 75:
                _context25.next = 81;
                break;

              case 77:
                _context25.prev = 77;
                _context25.t1 = _context25["catch"](50);

                console.error(_context25.t1);
                alertify.error(_context25.t1);

              case 81:
                _this35.isLoading = false;

              case 82:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this35, [[16, 43], [50, 77]]);
      }))();
    },
    getNewSicilveTerminalNo: function getNewSicilveTerminalNo() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return _this36.$axios.get("/Employees/GetDeviceAndSicilNumbers").then(function (response) {
                  _this36.employee.sicilNo = response.data.sicilNo;
                  _this36.employee.terminalNo = response.data.terminalNo;
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this36.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this36.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 2:
                response = _context26.sent;

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this36);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.logStartDate == null) {
        this.logStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.logEndDate == null) {
        this.logEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    getEmployee: function getEmployee(id) {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;

                _this37.getDefaultDate();
                _this37.isLoading = true;
                _this37.tempUrl = null;
                _this37.imageData = null;
                _context27.next = 7;
                return _this37.$axios.get("/Employees/" + id).then(function (response) {
                  _this37.isNewEmployee = false;
                  _this37.employee.id = id;
                  _this37.employee.sicilNo = response.data.sicilNo;
                  _this37.employee.image = response.data.image;
                  _this37.employee.name = response.data.name;
                  _this37.employee.departmentId = response.data.departmentId;
                  _this37.employee.title = response.data.title;
                  _this37.employee.identityNo = response.data.identityNo;
                  _this37.employee.startDate = _this37.toDateFormat(response.data.startDate, "gg.aa.yyyy");
                  _this37.employee.endDate = response.data.endDate ? _this37.toDateFormat(response.data.endDate, "gg.aa.yyyy") : null;
                  _this37.employee.stateId = response.data.stateId;
                  _this37.employee.stateNote = response.data.stateNote;
                  _this37.employee.terminalNo = response.data.terminalNo;
                  _this37.employee.statuId = response.data.statuId;
                  _this37.employee.cardNo = response.data.cardNo;
                  _this37.employee.terminalStatu = response.data.terminalStatu;
                  _this37.employee.terminalPassword = response.data.terminalPassword;
                  _this37.employee.workGroupId = response.data.workGroupId;
                  _this37.employee.documentNo = response.data.documentNo;
                  _this37.employee.salary = response.data.salary;
                  _this37.employee.overWorkStatus = response.data.overWorkStatus;
                  _this37.employee.mail = response.data.mail;
                  _this37.employee.mobilePhone = response.data.mobilePhone;
                  _this37.employee.birthDayDate = response.data.birthDayDate ? _this37.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy") : null;
                  _this37.employee.address = response.data.address;
                  _this37.employee.internalPhone = response.data.internalPhone;
                  _this37.employee.homePhone = response.data.homePhone;
                  _this37.employee.gender = response.data.gender;
                  _this37.employee.educationStatus = response.data.educationStatus;
                  _this37.employee.militaryStatus = response.data.militaryStatus;
                  _this37.employee.drivingLicence = response.data.drivingLicence;
                  _this37.employee.smokeStatus = response.data.smokeStatus;
                  _this37.employee.maritalStatus = response.data.maritalStatus;
                  _this37.employee.bloodType = response.data.bloodType;
                  _this37.employee.height = response.data.height;
                  _this37.employee.weight = response.data.weight;
                  _this37.employee.disabledPercent = response.data.disabledPercent;
                  _this37.employee.authorizedPerson1 = response.data.authorizedPerson1;
                  _this37.employee.authorizedPerson2 = response.data.authorizedPerson2;
                  _this37.employee.note1 = response.data.note1;
                  _this37.employee.note2 = response.data.note2;
                  _this37.employee.foreignLanguage = response.data.foreignLanguage;
                  _this37.employee.accessGroupId = response.data.accessGroupId;
                  _this37.employee.readers = response.data.readers;
                  _this37.employee.foodGroupId = response.data.foodGroupId;
                  _this37.employee.credit = response.data.credit;
                  _this37.employee.remainder = response.data.remainder;
                  _this37.employee.isVisitor = response.data.isVisitor;
                  _this37.employee.visitorCardGroupId = response.data.visitorCardGroupId;
                  _this37.employee.isActive = response.data.isActive;
                  _this37.employee.inOuts = [];
                  _this37.employee.allowences = [];
                  _this37.employee.logs = [];
                  _this37.employee.extrafields = [];
                  _this37.employee.empPayrolls = [];
                  _this37.employee.annualPermitId = response.data.annualPermitId;
                  _this37.employee.annualPermitClaim = response.data.annualPermitClaim;
                  _this37.employee.annualPermitUsed = response.data.annualPermitUsed;
                  _this37.employee.annualPermitRemain = response.data.annualPermitRemain;
                  _this37.employee.annualPermits = response.data.annualPermits;
                  _this37.employee.annualPermitClaimsDates = response.data.annualPermitClaimsDates;
                  _this37.employee.annualPermitSeniority = response.data.annualPermitSeniority;
                  _this37.employee.annualPermitTransfer = response.data.annualPermitTransfer;
                  _this37.employee.hasCard = response.data.hasCard;
                  _this37.employee.hasFace = response.data.hasFace;
                  _this37.employee.hasFinger = response.data.hasFinger;
                  _this37.employee.hasPassword = response.data.hasPassword;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this37.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this37.$ml.get("errors.connectionError"));
                      _this37.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this37.isLoading = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context27.sent;
                _context27.next = 10;
                return _this37.setCheckReaderList();

              case 10:
                _this37.isLoading = false;
                _context27.next = 18;
                break;

              case 13:
                _context27.prev = 13;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error(_context27.t0);
                _this37.isLoading = false;

              case 18:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this37, [[0, 13]]);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                dep.check = checkValue;
                _this38.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this38.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this38);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _this39.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this39.isCheckDeps = !_this39.isCheckDeps;

              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this39);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var aList;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                aList = _this40.sortableDepartmentList;

                _this40.filters.departments = [];
                _context30.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this40.filters.departments.push(doc.id);
                  }
                });

              case 4:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this40);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this41 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;

                _this41.isLoadingEmployee = true;
                _context31.next = 4;
                return _this41.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this41.filters;
                _context31.next = 8;
                return _this41.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this41.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this41.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this41.$ml.get("errors.connectionError"));
                      _this41.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this41.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context31.sent;

                _this41.employees = employees;
                _this41.isLoadingEmployee = false;
                _context31.next = 18;
                break;

              case 13:
                _context31.prev = 13;
                _context31.t0 = _context31["catch"](0);

                console.error(_context31.t0);
                alertify.error("Servis Hatası :" + _context31.t0.message);
                _this41.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this41, [[0, 13]]);
      }))();
    },
    getAllEmployees: function getAllEmployees() {
      var _this42 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
        var allEmployees, response;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                allEmployees = [];
                _context32.next = 4;
                return _this42.$axios.get("/Employees").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      allEmployees.push({
                        id: doc.id,
                        name: doc.name,
                        title: doc.title,
                        isVisitor: doc.isVisitor
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this42.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this42.$ml.get("errors.connectionError"));
                      _this42.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this42.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context32.sent;

                _this42.allEmployees = allEmployees;
                _context32.next = 12;
                break;

              case 8:
                _context32.prev = 8;
                _context32.t0 = _context32["catch"](0);

                console.error(_context32.t0);
                alertify.error("Servis Hatası :" + _context32.t0.message);

              case 12:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, _this42, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this43 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (_this43.authControl == 1) {
                  alertify.warning(_this43.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, _this43);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this44 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return _this44.getAuthControl();

            case 2:
              _context34.next = 4;
              return _this44.getDefaultDate();

            case 4:
              _context34.next = 6;
              return _this44.getAllEmployees();

            case 6:
              _context34.next = 8;
              return _this44.getReaders();

            case 8:
              _context34.next = 10;
              return _this44.getDepartments();

            case 10:
              _context34.next = 12;
              return _this44.getAccessGroups();

            case 12:
              _context34.next = 14;
              return _this44.getStatus();

            case 14:
              _context34.next = 16;
              return _this44.getVisitorCardGroups();

            case 16:
              _context34.next = 18;
              return _this44.getEmployees();

            case 18:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, _this44);
    }))();
  }
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      isCheckVG: true,
      visitorGroups: [],
      isCheckAllowences: true,
      allowences: [],
      isCheckReaders: false,
      readers: [],
      startDate: null,
      endDate: null
    }, _defineProperty(_ref, "selectedDoorType", 0), _defineProperty(_ref, "selectedReportIndex", 0), _defineProperty(_ref, "selectedReportEndPoint", ""), _defineProperty(_ref, "selectedReportName", ""), _defineProperty(_ref, "selectedDevices", []), _defineProperty(_ref, "selectedAllowences", []), _defineProperty(_ref, "selectedVisitorGroups", []), _defineProperty(_ref, "reportOptions", {
      showAllowed: true,
      showNonComers: true,
      showLateComers: false,
      isUpperFromTime: false,
      time: 45
    }), _defineProperty(_ref, "reportDatas", null), _defineProperty(_ref, "reportHeaders", null), _defineProperty(_ref, "reportResult", []), _defineProperty(_ref, "reportName", ""), _defineProperty(_ref, "searchText", ""), _defineProperty(_ref, "selectedReportId", 0), _defineProperty(_ref, "activeReports", []), _defineProperty(_ref, "reports", [{
      id: 6,
      name: this.$ml.get("reports.reports.InsidesReport"),
      endPoint: "InsidesReport",
      isActive: false
    }, {
      id: 7,
      name: this.$ml.get("reports.reports.OutsidesReport"),
      endPoint: "OutsidesReport",
      isActive: false
    }, {
      id: 8,
      name: this.$ml.get("reports.reports.VisitorsReport"),
      endPoint: "VisitorsReport",
      isActive: false
    }, {
      id: 9,
      name: this.$ml.get("reports.reports.InsideVisitorsReport"),
      endPoint: "InsideVisitorsReport",
      isActive: false
    }, {
      id: 33,
      name: this.$ml.get("reports.reports.DetailedVisitorReport"),
      endPoint: "VisitorDetailedReport",
      isActive: false
    }, {
      id: 34,
      name: this.$ml.get("reports.reports.DepartmentBasedVisitorReport"),
      endPoint: "DepartmentBasedVisitorReport",
      isActive: false
    }]), _ref;
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthority.ziyaretciTakip;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList: function employeeFilteredList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.employees.sort(function (a, b) {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    statuList: function statuList() {
      return this.status;
    },
    visitorGroupList: function visitorGroupList() {
      return this.visitorGroups;
    },
    readerList: function readerList() {
      return this.readers;
    },
    reportList: function reportList() {
      return this.reports.filter(function (item) {
        return item.isActive == true;
      });
    },
    reportDataList: function reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList: function reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    filtered: function filtered() {
      var _this = this;

      if (this.searchText) {
        return this.employeeFilteredList.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeInOutListDoorType: function changeInOutListDoorType(event) {
      this.selectedDoorType = event.target.value;
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    customReportStyle: function customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (value == "Geç Kaldı" || value == "Hafta Tatili" || value == "Cumartesi Hakedişi") {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (key == "unitName") {
        return "text-bold";
      } else if (key == "employeesInDepartments" || key == "continuedEmployee" || key == "annualPermit" || key == "report" || key == "administrativeLeave" || key == "nonComers" || key == "todayComers" || key == "freePermission") {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (key == "d1" || key == "d2" || key == "d3" || key == "d4" || key == "d5" || key == "d6" || key == "d7" || key == "d8" || key == "d9" || key == "d10" || key == "d11" || key == "d12" || key == "d13" || key == "d14" || key == "d15" || key == "d16" || key == "d17" || key == "d18" || key == "d19" || key == "d20" || key == "d21" || key == "d22" || key == "d23" || key == "d24" || key == "d25" || key == "d26" || key == "d27" || key == "d28" || key == "d29" || key == "d30" || key == "d31") {
        return "text-center";
      } else if (key == "shortCode1" || key == "shortCode2" || key == "shortCode3" || key == "shortCode4" || key == "shortCode5" || key == "shortCode6" || key == "shortCode7" || key == "shortCode8" || key == "shortCode9" || key == "shortCode10" || key == "shortCode11" || key == "shortCode12" || key == "shortCode13" || key == "shortCode14" || key == "shortCode15" || key == "shortCode16" || key == "shortCode17" || key == "shortCode18" || key == "shortCode19" || key == "shortCode20" || key == "shortCode21" || key == "shortCode22" || key == "shortCode23" || key == "shortCode24" || key == "shortCode25" || key == "shortCode26" || key == "shortCode27" || key == "shortCode28" || key == "shortCode29" || key == "shortCode30" || key == "shortCode31") {
        return "text-center";
      }
    },
    checkEmployees: function checkEmployees() {
      var _this3 = this;

      this.isCheck = !this.isCheck;
      var aList = this.employees;
      aList.forEach(function (doc) {
        if (doc.check == !_this3.isCheck) {
          doc.check = _this3.isCheck;
        }
      });
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selectedEmployees, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this4.employees;
                selectedEmployees = aList.filter(function (employee) {
                  return employee.check == true;
                });
                selectedEmployeeList = [];
                _context.next = 5;
                return selectedEmployees.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 5:
                return _context.abrupt("return", selectedEmployeeList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeSelectedReport: function changeSelectedReport(event) {
      this.selectedReportIndex = event.target.value;
      var report = this.reportList.filter(function (item) {
        return item.id == event.target.value;
      });
      if (report) {
        this.selectedReportEndPoint = report[0].endPoint;
        this.selectedReportName = report[0].name;
      }
    },
    changeIsUpperFromTime: function changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    eskiExcelExport: function eskiExcelExport() {
      if (this.selectedReportName != "" && this.selectedReportName != null) {
        var EXCEL_TYPE = "application/vdn.openxmlformats-officedocumant.spreadsheetml.sheet;charset=UTF-8";
        var EXCEL_EXTENSISON = ".xlsx";
        var worksheet = XLSX.utils.json_to_sheet(this.reportDatas[0]); //excelData değişkeni Oku-1 de var :)))
        var workbook = {
          Sheets: {
            data: worksheet
          },
          SheetNames: ["data"]
        };
        var tarih = new Date();
        var filename = this.selectedReportName + " - " + tarih.toLocaleString();
        var excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array"
        });
        var data = new Blob([excelBuffer], { type: EXCEL_TYPE });
        saveAs(data, filename + EXCEL_EXTENSISON);
      }
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getAccessGroups: function getAccessGroups() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accessGroups = [];
                _context2.next = 4;
                return _this5.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this5.accessGroups = accessGroups;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                departments = [];
                _context3.prev = 1;
                _context3.next = 4;
                return _this6.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this6.departments = departments;
                _this6.sortableTrees();
                _this6.isLoading = false;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                alertify.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this7 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this7.sortableDepTrees.push(dep);
          _this7.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this8 = this;

      var departments2 = this.departments;
      var subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          doc2.name = ekle + " " + doc2.name;
          _this8.sortableDepTrees.push(doc2);
          _this8.subDepImport(doc2);
        });
      }
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dep.check = checkValue;
                _this9.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this9.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this9);
      }))();
    },
    changeFilterDep2: function changeFilterDep2(dep, checkValue) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dep.check = checkValue;
                _this10.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    //this.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this10);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this11.filters.departments = [];
                _context6.next = 3;
                return _this11.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this11);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this12.filters.accessGroup = [];
                _context7.next = 3;
                return _this12.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this12);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this13.filters.stateId = [];
                _context8.next = 3;
                return _this13.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this13);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this14.filters.statuId = [];
                _context9.next = 3;
                return _this14.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this14);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this15.filters.workGroupId = [];
                _context10.next = 3;
                return _this15.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this15);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this16.filters.foodGroup = [];
                _context11.next = 3;
                return _this16.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this16);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this17.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this17.isCheckDeps = !_this17.isCheckDeps;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this17);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                aList = _this18.sortableDepartmentList;

                _this18.filters.departments = [];
                _context13.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this18.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this18.accessGroupList;

                _this18.filters.accessGroup = [];
                _context13.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this18.workGroupList;

                _this18.filters.workGroupId = [];
                _context13.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this18.foodGroupList;

                _this18.filters.foodGroup = [];
                _context13.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this18.statuList;

                _this18.filters.statuId = [];
                _context13.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this18.stateList;

                _this18.filters.stateId = [];
                _context13.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this18);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                foodGroups = [];
                _context14.next = 4;
                return _this19.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this19.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this19.$ml.get("errors.connectionError"));
                      _this19.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this19.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context14.sent;

                _this19.foodGroups = foodGroups;
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this19, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                status = [];
                _context15.next = 4;
                return _this20.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this20.status = status;
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası :" + _context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this20, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                titles = [];
                _context16.next = 4;
                return _this21.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context16.sent;

                _this21.titles = titles;
                _context16.next = 12;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası :" + _context16.t0.message);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this21, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                states = [];
                _context17.next = 4;
                return _this22.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this22.states = states;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                workGroups = [];
                _context18.next = 4;
                return _this23.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this23.workGroups = workGroups;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                extrafields = [];
                _context19.next = 4;
                return _this24.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this24.extrafields = extrafields;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this24, [[0, 8]]);
      }))();
    },
    changeAuthReports: function changeAuthReports() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this25.activeReports.forEach(function (item) {
                  _this25.reports.forEach(function (report) {
                    if (report.id == item) {
                      report.isActive = true;
                    }
                  });
                });

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this25);
      }))();
    },
    getActiveReports: function getActiveReports() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return _this26.$axios.get("/Reports").then(function (response) {
                  _this26.activeReports = response.data;
                  _this26.changeAuthReports();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context21.sent;
                _context21.next = 10;
                break;

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this26, [[0, 6]]);
      }))();
    },
    reportSetting: function reportSetting() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var keys, movementsMaxLength;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (_this27.reportResult != [] && _this27.reportResult != null) {
                  if (_this27.selectedReportIndex == 1) {
                    //Gelmeyenler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.date"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.status"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.LaterComersReportHeaders.difference"));
                    keys = ["sicilNo", "adSoyad", "tarih", "durum", "girisS", "fark"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 2) {
                    //Detaylı Giriş Çıkış Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.date"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.firstEntry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.lastExit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.total"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.status"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    //this.reportHeaders.push("Giriş");
                    //this.reportHeaders.push("Çıkış");
                    //this.reportHeaders.push("Fark");
                    //this.reportHeaders.push("Giriş");
                    //this.reportHeaders.push("Çıkış");
                    //this.reportHeaders.push("Fark");
                    keys = ["sicilNo", "adSoyad", "tarih", "ilkG", "sonC", "total", "durum", "g1", "c1", "f1", "g2", "c2", "f2", "g3", "c3", "f3", "g4", "c4", "f4", "g5", "c5", "f5", "g6", "c6", "f6", "g7", "c7", "f7", "g8", "c8", "f8"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 3) {
                    //Yemekhane Hareket Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodReportHeader.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodReportHeader.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodReportHeader.date"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodReportHeader.debit"));
                    keys = ["sicilNo", "adSoyad", "tarih", "ucret"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 4) {
                    //Yemekhane İcmal Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodSummaryReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodSummaryReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodSummaryReportHeaders.IBAN"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodSummaryReportHeaders.debit"));
                    keys = ["sicilNo", "adSoyad", "iban", "ucret"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 5) {
                    //Kişi Bilgileri Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.title"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.mobilePhone"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.citizenshipNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.status"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.state"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.startDateWork"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.EmployeesReportHeaders.leaveDate"));
                    keys = ["sicilNo", "name", "title", "mobilePhone", "identityNo", "statu", "state", "startDate", "leaveDate"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 6) {
                    //İçeridekiler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsidesReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsidesReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsidesReportHeaders.entryTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsidesReportHeaders.entryPoint"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "entryDate", "entryPoint", "status"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 7) {
                    //Dışarıdakiler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.OutsidesReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.OutsidesReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.OutsidesReportHeaders.exitTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.OutsidesReportHeaders.exitPoint"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.OutsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "exitDate", "exitPoint", "status"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 8) {
                    //Ziyaretçiler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.citizenshipNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.mobilePhone"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.where"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.departmentName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.reasonForVisit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.visitedEmployeeInformation"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.cardIssueTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.entryTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.exitTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.cardName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.VisitorsReportHeaders.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "exitDate", "cardInfo", "description"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 9) {
                    //İçerideki Ziyaretçiler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.citizenshipNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.mobilePhone"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.where"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.departmentName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.reasonForVisit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.visitedEmployeeInformation"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.cardIssueTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.entryTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.cardName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.InsideVisitorsReportHeader.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "cardInfo", "description"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 10) {
                    //Süre Bazlı Çalışma Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.TimeBasedWorkReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.TimeBasedWorkReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.TimeBasedWorkReportHeaders.startDate"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.TimeBasedWorkReportHeaders.endDate"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.TimeBasedWorkReportHeaders.totalWorkedTime"));
                    keys = ["sicilNo", "adSoyad", "startDate", "endDate", "total"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 11) {
                    //İlk Giriş Son Çıkış Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.date"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.firstEntry"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.lastExit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.total"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FirstInLastOutReportHeaders.status"));
                    keys = ["sicilNo", "adSoyad", "tarih", "ilkG", "sonC", "total", "durum"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 12) {
                    //İzinliler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.AllowenceReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.AllowenceReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.AllowenceReportHeaders.startDate"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.AllowenceReportHeaders.endDate"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.AllowenceReportHeaders.allowenceName"));
                    keys = ["sicilNo", "name", "startDate", "endDate", "allowenceName"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 13) {
                    //Çalışma Özeti Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.jobDays"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.workDays"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.publicHoliday"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.allowence"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.WorkSummaryReportHeaders.absentee"));
                    keys = ["sicilNo", "name", "planWorkDay", "workDay", "publicHolidayOrAdministrativeLeave", "allowenceUsed", "absentee"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 14) {
                    //Departman Bazlı Sayı Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.unitName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.continuedEmployeeCount"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.report"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "continuedEmployee", "annualPermit", "report", "administrativeLeave", "freePermission", "nonComers", "todayComers"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 15) {
                    //Müdürlük Bazlı Sayı Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.unitName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.continuedEmployeeCount"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.report"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.freePermission"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.nonComers"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.CustomCompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "continuedEmployee", "annualPermit", "report", "administrativeLeave", "freePermission", "nonComers", "todayComers"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 16) {
                    // Puantaj Raporu

                    keys = ["sicilNo", "name", "shortCode1", "shortCode2", "shortCode3", "shortCode4", "shortCode5", "shortCode6", "shortCode7", "shortCode8", "shortCode9", "shortCode10", "shortCode11", "shortCode12", "shortCode13", "shortCode14", "shortCode15", "shortCode16", "shortCode17", "shortCode18", "shortCode19", "shortCode20", "shortCode21", "shortCode22", "shortCode23", "shortCode24", "shortCode25", "shortCode26", "shortCode27", "shortCode28", "shortCode29", "shortCode30", "shortCode31"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 17) {
                    // Detaylı Puantaj Raporu

                    keys = ["sicilNo", "adSoyad", "realWorkDay", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10", "d11", "d12", "d13", "d14", "d15", "d16", "d17", "d18", "d19", "d20", "d21", "d22", "d23", "d24", "d25", "d26", "d27", "d28", "d29", "d30", "d31"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 18) {
                    // Yemekhane Yüklemeler Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.registrationNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.date"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.debit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.creditType"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.FoodCreditReportHeaders.status"));
                    keys = ["sicilNo", "name", "date", "credit", "creditType", "isAdded"];

                    _this27.reportDatas = [];
                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        var veriler2 = [];
                        item.veriler.forEach(function (veri) {
                          var type = _this27.$ml.get("general.credit");
                          if (veri.creditType == 2) {
                            type = _this27.$ml.get("general.balance");
                          }
                          var status = _this27.$ml.get("general.added");
                          if (veri.isAdded == false) {
                            status = _this27.$ml.get("general.removed");
                          }
                          veriler2.push({
                            sicilNo: veri.sicilNo,
                            name: veri.name,
                            date: veri.date,
                            credit: veri.credit,
                            creditType: type,
                            isAdded: status
                          });
                        });
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: veriler2
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 33) {
                    //Detaylı Ziyaretçi Hareket Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.citizenshipNumber"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.nameSurname"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.mobilePhone"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.where"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.departmentName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.reasonForVisit"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.visitedEmployeeInformation"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardIssueTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.entryTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.exitTime"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.cardName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DetailedVisitorReportHeaders.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "departmentName", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "exitDate", "cardInfo", "description"];

                    _this27.reportDatas = [];
                    movementsMaxLength = 0;

                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        item.veriler.forEach(function (iVeri) {
                          if (iVeri.movements.length > movementsMaxLength) {
                            movementsMaxLength = iVeri.movements.length;
                          }
                        });
                        for (var index = 0; index < movementsMaxLength; index++) {
                          _this27.reportHeaders.push(index + 1 + ". Hareket");
                        }
                        _this27.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this27.selectedReportIndex == 34) {
                    //Departman Bazlı Ziyaretçi Raporu
                    _this27.reportHeaders = [];
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DepartmentBasedVisitorReportHeaders.departmentName"));
                    _this27.reportHeaders.push(_this27.$ml.get("reports.reports.DepartmentBasedVisitorReportHeaders.total"));
                    keys = ["departmentName", "total"];

                    _this27.reportDatas = [];
                    movementsMaxLength = 0;

                    _this27.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this27.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else {
                    alertify.warning(_this27.$ml.get("reports.selectedReportIsUnavailable"));
                  }
                } else {
                  _this27.reportHeaders = null;
                  _this27.reportDatas = null;
                }

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this27);
      }))();
    },
    getReportDetails: function getReportDetails() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var empIds, reportEndPoint, startDate, endDate, devices, allowenceIds, visitorGroupIds, reportOption, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!(_this28.selectedReportIndex == 0)) {
                  _context23.next = 3;
                  break;
                }

                alertify.warning(_this28.$ml.get("alerts.selectedReportNotBlank"));
                return _context23.abrupt("return");

              case 3:
                if (!(_this28.startDate == null || _this28.endDate == null || _this28.startDate > _this28.endDate)) {
                  _context23.next = 6;
                  break;
                }

                alertify.warning(_this28.$ml.get("alerts.invalidDate"));
                return _context23.abrupt("return");

              case 6:
                _context23.prev = 6;

                _this28.activeScreen = 3;
                _this28.isLoading = true;
                _context23.next = 11;
                return _this28.getSelectedEmployeeList();

              case 11:
                empIds = _context23.sent;
                reportEndPoint = _this28.selectedReportEndPoint;
                startDate = _this28.startDate;
                endDate = _this28.endDate;
                _context23.next = 17;
                return _this28.getCheckReaders();

              case 17:
                devices = _this28.selectedDevices;
                allowenceIds = [];
                visitorGroupIds = [];
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  deviceIds: devices
                };

                if (_this28.selectedReportIndex == 6 || _this28.selectedReportIndex == 7) {
                  reportOption = {
                    empIds: empIds,
                    deviceIds: devices
                  };
                }

                if (!(_this28.selectedReportIndex == 8 || _this28.selectedReportIndex == 33)) {
                  _context23.next = 27;
                  break;
                }

                _context23.next = 25;
                return _this28.getCheckVisitorGroups();

              case 25:
                visitorGroupIds = _this28.selectedVisitorGroups;
                reportOption = {
                  startDate: startDate,
                  endDate: endDate,
                  visitorGroupIds: visitorGroupIds
                };

              case 27:
                if (_this28.selectedReportIndex == 9) {
                  reportOption = {
                    startDate: startDate,
                    endDate: endDate
                  };
                }
                if (_this28.selectedReportIndex == 10) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    time: _this28.reportOptions.time,
                    isUpperFromTime: _this28.reportOptions.isUpperFromTime,
                    showNonComers: _this28.reportOptions.showNonComers
                  };
                }
                if (_this28.selectedReportIndex == 11) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    showAllowed: _this28.reportOptions.showAllowed,
                    showNonComers: _this28.reportOptions.showNonComers
                  };
                }

                if (!(_this28.selectedReportIndex == 12)) {
                  _context23.next = 35;
                  break;
                }

                _context23.next = 33;
                return _this28.getCheckAllowences();

              case 33:
                allowenceIds = _this28.selectedAllowences;
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  allowenceIds: allowenceIds
                };

              case 35:
                if (_this28.selectedReportIndex == 13 || _this28.selectedReportIndex == 16 || _this28.selectedReportIndex == 17 || _this28.selectedReportIndex == 18) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate
                  };
                }

                if (!(_this28.selectedReportIndex == 14 || _this28.selectedReportIndex == 15)) {
                  _context23.next = 40;
                  break;
                }

                _context23.next = 39;
                return _this28.getCheckDepartmentList();

              case 39:
                reportOption = {
                  empIds: _this28.filters.departments,
                  startDate: startDate
                };

              case 40:
                if (_this28.selectedReportIndex == 1) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    deviceIds: devices,
                    showAllowed: _this28.reportOptions.showAllowed,
                    showLateComers: _this28.reportOptions.showLateComers
                  };
                }
                _context23.next = 43;
                return _this28.$axios.post("/Reports/" + reportEndPoint, reportOption).then(function (response) {
                  _this28.reportResult = response.data.datas;
                  if (_this28.selectedReportIndex == 16 || _this28.selectedReportIndex == 17) {
                    _this28.reportHeaders = response.data.headers;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoading = false;
                      return;
                    }
                  }
                });

              case 43:
                response = _context23.sent;
                _context23.next = 46;
                return _this28.reportSetting();

              case 46:
                _this28.reportName = _this28.selectedReportName + " (" + _this28.toDateFormat(_this28.startDate, "gg.aa.yyyy ss:dd") + " - " + _this28.toDateFormat(_this28.endDate, "gg.aa.yyyy ss:dd") + ")";
                if (_this28.selectedReportIndex == 14) {
                  _this28.reportName = _this28.selectedReportName + " (" + _this28.toDateFormat(_this28.startDate, "gg.aa.yyyy") + ")";
                }
                _this28.isLoading = false;
                _context23.next = 56;
                break;

              case 51:
                _context23.prev = 51;
                _context23.t0 = _context23["catch"](6);

                console.error(_context23.t0);
                alertify.error("Servis Hatası :" + _context23.t0.message);
                _this28.isLoading = false;

              case 56:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this28, [[6, 51]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;

                _this29.isLoadingEmployee = true;
                _context24.next = 4;
                return _this29.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this29.filters;
                _context24.next = 8;
                return _this29.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this29.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this29.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context24.sent;

                _this29.employees = employees;
                _this29.isLoadingEmployee = false;
                _context24.next = 18;
                break;

              case 13:
                _context24.prev = 13;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error("Servis Hatası :" + _context24.t0.message);
                _this29.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this29, [[0, 13]]);
      }))();
    },
    checkAllReaders: function checkAllReaders() {
      var _this30 = this;

      this.isCheckReaders = !this.isCheckReaders;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this30.isCheckReaders) {
          doc.check = _this30.isCheckReaders;
        }
      });
    },
    getCheckReaders: function getCheckReaders() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this31.selectedDevices = [];
                _context25.next = 3;
                return _this31.readers.forEach(function (doc) {
                  if (doc.check == true) {
                    _this31.selectedDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this31);
      }))();
    },
    getReaders: function getReaders() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                readers = [];
                _context26.next = 4;
                return _this32.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      var isCheckNew = true;
                      if (doc.doorType != 1) {
                        isCheckNew == false;
                      }
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: isCheckNew
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this32.readers = readers;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Servis Hatası : " + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this32, [[0, 8]]);
      }))();
    },
    checkAllAllowence: function checkAllAllowence() {
      var _this33 = this;

      this.isCheckAllowences = !this.isCheckAllowences;
      var aList = this.allowences;
      aList.forEach(function (doc) {
        if (doc.check == !_this33.isCheckAllowences) {
          doc.check = _this33.isCheckAllowences;
        }
      });
    },
    getCheckAllowences: function getCheckAllowences() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this34.selectedAllowences = [];
                _context27.next = 3;
                return _this34.allowences.forEach(function (doc) {
                  if (doc.check == true) {
                    _this34.selectedAllowences.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this34);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;

                _this35.isLoading = true;
                allowences = [];
                _context28.next = 5;
                return _this35.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context28.sent;

                _this35.allowences = allowences;
                _this35.isLoading = false;
                _context28.next = 15;
                break;

              case 10:
                _context28.prev = 10;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);
                _this35.isLoading = false;

              case 15:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this35, [[0, 10]]);
      }))();
    },
    checkAllVisitorGroups: function checkAllVisitorGroups() {
      var _this36 = this;

      this.isCheckVG = !this.isCheckVG;
      var aList = this.visitorGroups;
      aList.forEach(function (doc) {
        if (doc.check == !_this36.isCheckVG) {
          doc.check = _this36.isCheckVG;
        }
      });
    },
    getCheckVisitorGroups: function getCheckVisitorGroups() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _this37.selectedVisitorGroups = [];
                _context29.next = 3;
                return _this37.visitorGroups.forEach(function (doc) {
                  if (doc.check == true) {
                    _this37.selectedVisitorGroups.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this37);
      }))();
    },
    getVisitorCardGroups: function getVisitorCardGroups() {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var visitorGroups, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                visitorGroups = [];
                _context30.next = 4;
                return _this38.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      visitorGroups.push({
                        id: doc.id,
                        name: doc.name,
                        devices: doc.devices,
                        check: true
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this38.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this38.$ml.get("errors.connectionError"));
                      _this38.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this38.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this38.visitorGroups = visitorGroups;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Hata :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this38, [[0, 8]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this39 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this39.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(function (doc) {
        _this39.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this39.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this39.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this39.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this39.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getAuthControl: function getAuthControl() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (_this40.authControl == 1) {
                  alertify.warning(_this40.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                }

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this40);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this41 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      var filter;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return _this41.getAuthControl();

            case 2:
              _context32.next = 4;
              return _this41.getDepartments();

            case 4:
              _context32.next = 6;
              return _this41.getAccessGroups();

            case 6:
              _context32.next = 8;
              return _this41.getActiveReports();

            case 8:
              _context32.next = 10;
              return _this41.getFoodGroups();

            case 10:
              _context32.next = 12;
              return _this41.getStatus();

            case 12:
              _context32.next = 14;
              return _this41.getStates();

            case 14:
              _context32.next = 16;
              return _this41.getTitles();

            case 16:
              _context32.next = 18;
              return _this41.getWorkGroups();

            case 18:
              _context32.next = 20;
              return _this41.getExtraFields();

            case 20:
              _context32.next = 22;
              return _this41.getReaders();

            case 22:
              _context32.next = 24;
              return _this41.getVisitorCardGroups();

            case 24:
              _context32.next = 26;
              return _this41.getAllowences();

            case 26:
              _context32.next = 28;
              return _this41.getDefaultDate();

            case 28:
              if (!_this41.defaultFilters) {
                _context32.next = 35;
                break;
              }

              filter = _this41.defaultFilters;

              _this41.setUserAuthorityFilter(filter);
              _context32.next = 33;
              return _this41.getEmployees();

            case 33:
              _context32.next = 37;
              break;

            case 35:
              _context32.next = 37;
              return _this41.getEmployees();

            case 37:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, _this41);
    }))();
  }
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      searchText: "",
      searchText2: "",
      selectedPlate: {
        id: null,
        plate: "",
        accessPoints: [],
        employeeId: null
      },
      plates: [],
      employees: [],
      readers: [],
      isNewPlate: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    plateList: function plateList() {
      var _this = this;

      if (this.searchText) {
        return this.plates.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.plate.toUpperCase().includes(v);
          });
        }).sort(function (a, b) {
          return a.plate.localeCompare(b.plate);
        });
      } else {
        return this.plates.sort(function (a, b) {
          return a.plate.localeCompare(b.plate);
        });
      }
    },
    employeeList: function employeeList() {
      var _this2 = this;

      if (this.searchText2) {
        return this.employees.filter(function (item) {
          return _this2.searchText2.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.employees;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    getNameFromId: function getNameFromId(id) {
      var employee = this.employees.find(function (x) {
        return x.id == id;
      });
      if (employee) {
        return employee.name + (employee.title != "" ? " - " + employee.title : "");
      } else {
        return "";
      }
    },
    selectPlate: function selectPlate(plate) {
      this.isNewPlate = false;
      this.selectedPlate.id = plate.id;
      this.selectedPlate.plate = plate.plate;
      this.selectedPlate.accessPoints = plate.accessPoints;
      this.selectedPlate.employeeId = plate.employeeId;
      this.readers.forEach(function (reader) {
        if (reader.readerId == plate.accessPoints.find(function (x) {
          return x == reader.readerId;
        })) {
          reader.check = true;
        } else {
          reader.check = false;
        }
      });
    },
    newPlate: function newPlate() {
      this.isNewPlate = true;
      this.selectedPlate.id = null;
      this.selectedPlate.plate = "";
      this.selectedPlate.accessPoints = [];
      this.selectedPlate.employeeId = null;
      this.readers.forEach(function (reader) {
        reader.check = false;
      });
    },
    savePlate: function savePlate() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var accessPoints, selectedPlate2, _selectedPlate, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this4.selectedPlate.plate == "")) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.pleaseEnterAPlate"));
                return _context.abrupt("return");

              case 3:
                _this4.isLoading = true;
                accessPoints = [];

                _this4.readers.forEach(function (reader) {
                  if (reader.check == true) {
                    accessPoints.push(reader.readerId);
                  }
                });

                if (!(_this4.selectedPlate.id == null)) {
                  _context.next = 21;
                  break;
                }

                _context.prev = 7;
                selectedPlate2 = _this4.selectedPlate;
                _context.next = 11;
                return _this4.$axios.post("/Plate", {
                  plate: selectedPlate2.plate,
                  accessPoints: accessPoints,
                  employeeId: selectedPlate2.employeeId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get("alerts.savedSuccessfully"));
                    _this4.getPlates();
                    _this4.newPlate();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 11:
                _this4.isLoading = false;
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this4.isLoading = false;

              case 19:
                _context.next = 34;
                break;

              case 21:
                _context.prev = 21;
                _selectedPlate = _this4.selectedPlate;
                _context.next = 25;
                return _this4.$axios.put("/Plate/" + _selectedPlate.id, {
                  plate: _selectedPlate.plate,
                  accessPoints: accessPoints,
                  employeeId: _selectedPlate.employeeId
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get("alerts.updatedSuccessfully"));
                    _this4.getPlates();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 25:
                response = _context.sent;

                _this4.isLoading = false;
                _context.next = 34;
                break;

              case 29:
                _context.prev = 29;
                _context.t1 = _context["catch"](21);

                console.error(_context.t1);
                alertify.error(_context.t1.message);
                _this4.isLoading = false;

              case 34:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[7, 14], [21, 29]]);
      }))();
    },
    deletePlate: function deletePlate() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this5.isLoading = true;
                id = _this5.selectedPlate.id;
                _context2.next = 5;
                return _this5.$axios.delete("/Plate/" + id).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.deletedSuccessfully"));
                    _this5.getPlates();
                    _this5.newPlate();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this5.isLoading = false;
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this5.isLoading = false;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 9]]);
      }))();
    },
    getPlates: function getPlates() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var plates, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this6.isLoading = true;
                plates = [];
                _context3.next = 5;
                return _this6.$axios.get("/Plate").then(function (response) {
                  plates = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this6.plates = plates;
                _this6.isLoading = false;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 10]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                readers = [];
                _context4.next = 4;
                return _this7.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 3) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this7.readers = readers;
                _context4.next = 12;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası : " + _context4.t0.message);

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 8]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var employees, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                employees = [];
                _context5.next = 4;
                return _this8.$axios.get("/Employees?every=false").then(function (response) {
                  if (response.status == 200) {
                    employees = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context5.sent;

                _this8.employees = employees;
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası : " + _context5.t0.message);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this9.authControl == 1) {
                  alertify.warning(_this9.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this10.getAuthControl();

            case 2:
              _context7.next = 4;
              return _this10.getReaders();

            case 4:
              _context7.next = 6;
              return _this10.getEmployees();

            case 6:
              _context7.next = 8;
              return _this10.getPlates();

            case 8:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this10);
    }))();
  }
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingDetail: false,
      isLoadingMeals: false,
      windowHeight: window.innerHeight,
      searchText: "",
      foodGroup: {
        id: null,
        name: "",
        type: 1,
        singleFoodEachMeal: 1,
        meals: []
      },
      selectedMeal: {
        id: null,
        mealNameId: null,
        foodGroupId: null,
        day: 0,
        startDate: "00:00",
        endDate: "00:00",
        foodClaim: 0,
        price: 0,
        price2: 0
      },
      days: [{ value: 1, name: this.$ml.get('general.monday'), check: true }, { value: 2, name: this.$ml.get('general.tuesday'), check: true }, { value: 3, name: this.$ml.get('general.wednesday'), check: true }, { value: 4, name: this.$ml.get('general.thursday'), check: true }, { value: 5, name: this.$ml.get('general.friday'), check: true }, { value: 6, name: this.$ml.get('general.saturday'), check: true }, { value: 7, name: this.$ml.get('general.sunday'), check: true }],
      foodGroups: [],
      isNewFoodGroup: true,
      isNewMeal: true,
      isNewMealName: true,
      selectedMealName: "",
      selectedMealNameId: null,
      mealNames: []
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      if (format == "gg.aa.yyyy.ss:dd") {
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    foodGroupList: function foodGroupList() {
      var _this = this;

      if (this.searchText) {
        return this.foodGroups.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.foodGroups;
      }
    },
    mealList: function mealList() {
      return this.foodGroup.meals;
    },
    mealNameList: function mealNameList() {
      return this.mealNames;
    },
    dayList: function dayList() {
      return this.days;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowMealHeightSize: function windowMealHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeMealName: function changeMealName(event) {
      this.selectedMeal.mealNameId = event.target.value;
    },
    changeGroupType: function changeGroupType(event) {
      this.foodGroup.type = event.target.value;
    },
    checkFalseDays: function checkFalseDays() {
      var aList = this.days;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    selectedDays: function selectedDays() {
      var selectedDays = [];
      var aList = this.days;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          selectedDays.push(doc.value);
        }
      });
      return selectedDays;
    },
    getMealNameFromId: function getMealNameFromId(id) {
      var mealName = this.mealNameList.filter(function (a) {
        return a.id == id;
      });
      if (mealName.length > 0) {
        return mealName[0].name;
      } else {
        return "";
      }
    },
    selectMealName: function selectMealName(id, name) {
      this.isNewMealName = false;
      this.selectedMealNameId = id;
      this.selectedMealName = name;
    },
    newMealName: function newMealName() {
      this.isNewMealName = true;
      this.selectedMealNameId = null;
      this.selectedMealName = "";
    },
    saveMealName: function saveMealName() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, name, response, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.selectedMealName == "")) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get('alerts.mealNameNotBlank'));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;
                id = _this3.selectedMealNameId;
                name = _this3.selectedMealName;

                if (!(_this3.isNewMealName == true)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 9;
                return _this3.$axios.post("/FoodGroups/AddMealName", {
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this3.$ml.get('alerts.savedSuccessfully'));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this3.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this3.$ml.get('errors.connectionError'));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 9:
                response = _context.sent;

                _this3.newMealName();
                _this3.getMealNames();
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return _this3.$axios.post("/FoodGroups/UpdateMealName/", {
                  id: id,
                  name: name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this3.$ml.get('alerts.updatedSuccessfully'));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this3.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this3.$ml.get('errors.connectionError'));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 16:
                _response = _context.sent;

                _this3.newMealName();
                _this3.getMealNames();

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context["catch"](3);

                console.error(_context.t0);
                alertify.error(_context.t0.message);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 21]]);
      }))();
    },
    deleteMealName: function deleteMealName() {
      var _this4 = this;

      try {
        var id = this.selectedMealNameId;
        if (id != null) {
          var response = this.$axios.delete("/FoodGroups/DeleteMealName/" + id).then(function (response) {
            _this4.getMealNames();
            _this4.newMealName();
            alertify.success(_this4.$ml.get('alerts.deletedSuccessfully'));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this4.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this4.$ml.get('errors.connectionError'));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    getMealNames: function getMealNames() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var mealNames, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                mealNames = [];
                _context2.next = 4;
                return _this5.$axios.get("/FoodGroups/GetMealNames").then(function (response) {
                  response.data.forEach(function (doc) {
                    mealNames.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this5.mealNames = mealNames;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[0, 8]]);
      }))();
    },
    newFoodGroup: function newFoodGroup() {
      this.isLoadingDetail = true;
      this.isNewFoodGroup = true;
      this.foodGroup.id = null;
      this.foodGroup.name = "";
      this.foodGroup.type = 1;
      this.foodGroup.singleFoodEachMeal = 1;
      this.foodGroup.meals = [];
      this.isLoadingDetail = false;
    },
    newFoodMeal: function newFoodMeal() {
      this.isLoadingMeals = true;
      this.checkFalseDays();
      this.isNewMeal = true;
      this.selectedMeal.id = null;
      this.selectedMeal.mealNameId = null;
      this.selectedMeal.foodGroupId = null;
      this.selectedMeal.day = 0;
      this.selectedMeal.startDate = "00:00";
      this.selectedMeal.endDate = "00:00";
      this.selectedMeal.foodClaim = 0;
      this.selectedMeal.price = 0;
      this.selectedMeal.price2 = 0;
      this.isLoadingMeals = false;
    },
    deleteMeal: function deleteMeal(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this6.isNewMeal) {
                  _context3.next = 4;
                  break;
                }

                alertify.warning(_this6.$ml.get('alerts.selectedMealNotBlank'));
                _context3.next = 19;
                break;

              case 4:
                _context3.prev = 4;

                _this6.isLoadingDetail = true;
                _context3.next = 8;
                return _this6.$axios.delete("/FoodGroups/DeleteFoodMeal/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context3.sent;

                _this6.getFoodGroup(_this6.foodGroup.id);
                _this6.newFoodMeal();
                alertify.success(_this6.$ml.get('alerts.deletedSuccessfully'));
                _this6.isLoadingDetail = false;
                _context3.next = 19;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](4);

                alertify.error("Hata Oluştu : " + _context3.t0);
                _this6.isLoadingDetail = false;

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[4, 15]]);
      }))();
    },
    saveMeal: function saveMeal() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var selectedDays, meal2, response, _meal, _response2;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this7.selectedMeal.mealNameId == null || _this7.selectedMeal.mealNameId == 0)) {
                  _context4.next = 3;
                  break;
                }

                alertify.warning(_this7.$ml.get('alerts.mealNameNotBlank'));
                return _context4.abrupt("return");

              case 3:
                if (!(_this7.selectedMeal.startDate > _this7.selectedMeal.endDate)) {
                  _context4.next = 6;
                  break;
                }

                alertify.warning(_this7.$ml.get('alerts.invalidTimeRange'));
                return _context4.abrupt("return");

              case 6:
                if (!_this7.isNewMeal) {
                  _context4.next = 28;
                  break;
                }

                _this7.isLoadingMeals = true;
                selectedDays = _this7.selectedDays();
                _context4.prev = 9;

                _this7.selectedMeal.foodGroupId = _this7.foodGroup.id;
                meal2 = _this7.selectedMeal;
                _context4.next = 14;
                return _this7.$axios.post("/FoodGroups/AddFoodMeal", {
                  mealNameId: meal2.mealNameId,
                  foodGroupId: parseInt(meal2.foodGroupId),
                  startDate: meal2.startDate,
                  endDate: meal2.endDate,
                  foodClaim: parseInt(meal2.foodClaim),
                  price: meal2.price,
                  price2: meal2.price2,
                  days: selectedDays
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get('errors.connectionError'));
                      _this7.isLoadingMeals = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingMeals = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context4.sent;

                if (response.status == 200) {
                  alertify.success(_this7.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this7.getFoodGroup(meal2.foodGroupId);
                _this7.isNewMeal = false;
                _this7.isLoadingMeals = false;
                _context4.next = 26;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](9);

                console.error(_context4.t0);
                alertify.error(_context4.t0);
                _this7.isLoadingMeals = false;

              case 26:
                _context4.next = 44;
                break;

              case 28:
                _context4.prev = 28;

                _this7.selectedMeal.foodGroupId = _this7.foodGroup.id;
                _meal = _this7.selectedMeal;
                _context4.next = 33;
                return _this7.$axios.post("/FoodGroups/UpdateFoodMeal/" + _meal.id, {
                  mealNameId: _meal.mealNameId,
                  foodGroupId: parseInt(_meal.foodGroupId),
                  startDate: _meal.startDate,
                  endDate: _meal.endDate,
                  foodClaim: parseInt(_meal.foodClaim),
                  price: _meal.price,
                  price2: _meal.price2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get('errors.connectionError'));
                      _this7.isLoadingMeals = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingMeals = false;
                      return;
                    }
                  }
                });

              case 33:
                _response2 = _context4.sent;

                if (_response2.status == 200) {
                  alertify.success(_this7.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response2.message);
                }
                _this7.getFoodGroup(_meal.foodGroupId);
                _this7.isLoadingMeals = false;
                _context4.next = 44;
                break;

              case 39:
                _context4.prev = 39;
                _context4.t1 = _context4["catch"](28);

                console.error(_context4.t1);
                alertify.error(_context4.t1);
                _this7.isLoadingMeals = false;

              case 44:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[9, 21], [28, 39]]);
      }))();
    },
    deleteFoodGroup: function deleteFoodGroup() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this8.isLoadingDetail = true;
                id = _this8.foodGroup.id;
                _context5.next = 5;
                return _this8.$axios.delete("/FoodGroups/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get('errors.connectionError'));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;

                _this8.getFoodGroups();
                _this8.newFoodGroup();
                alertify.success(_this8.$ml.get('alerts.deletedSuccessfully'));
                _this8.isLoadingDetail = false;
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);

                alertify.error("Hata Oluştu : " + _context5.t0);
                _this8.isLoadingDetail = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 12]]);
      }))();
    },
    saveFoodGroup: function saveFoodGroup() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var foodGroup2, response, id, _foodGroup, _response3;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this9.isNewFoodGroup) {
                  _context6.next = 25;
                  break;
                }

                if (!(_this9.foodGroup.name == "")) {
                  _context6.next = 4;
                  break;
                }

                alertify.warning(_this9.$ml.get('alerts.foodGroupNameNotBlank'));
                return _context6.abrupt("return");

              case 4:
                _this9.isLoadingDetail = true;
                _context6.prev = 5;
                foodGroup2 = _this9.foodGroup;
                _context6.next = 9;
                return _this9.$axios.post("/FoodGroups", {
                  name: foodGroup2.name,
                  type: parseInt(foodGroup2.type),
                  singleFoodEachMeal: foodGroup2.singleFoodEachMeal,
                  meals: foodGroup2.meals
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get('errors.connectionError'));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context6.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this9.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this9.getFoodGroups();
                _this9.getFoodGroup(id);
                _this9.isNewFoodGroup = false;
                _this9.isLoadingDetail = false;
                _context6.next = 23;
                break;

              case 18:
                _context6.prev = 18;
                _context6.t0 = _context6["catch"](5);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this9.isLoadingDetail = false;

              case 23:
                _context6.next = 40;
                break;

              case 25:
                _context6.prev = 25;
                _foodGroup = _this9.foodGroup;
                _context6.next = 29;
                return _this9.$axios.post("/FoodGroups/" + _foodGroup.id, {
                  name: _foodGroup.name,
                  type: parseInt(_foodGroup.type),
                  singleFoodEachMeal: _foodGroup.singleFoodEachMeal,
                  meals: _foodGroup.meals
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get('errors.connectionError'));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 29:
                _response3 = _context6.sent;

                if (_response3.status == 200) {
                  alertify.success(_this9.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response3.message);
                }
                _this9.getFoodGroups();
                _this9.isLoadingDetail = false;
                _context6.next = 40;
                break;

              case 35:
                _context6.prev = 35;
                _context6.t1 = _context6["catch"](25);

                console.error(_context6.t1);
                alertify.error(_context6.t1);
                _this9.isLoadingDetail = false;

              case 40:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[5, 18], [25, 35]]);
      }))();
    },
    getFoodGroup: function getFoodGroup(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this10.isLoadingDetail = true;
                _context7.next = 4;
                return _this10.$axios.get("/FoodGroups/" + id).then(function (response) {
                  _this10.isNewFoodGroup = false;
                  _this10.foodGroup.id = id;
                  _this10.foodGroup.name = response.data.name;
                  _this10.foodGroup.type = response.data.type;
                  _this10.foodGroup.singleFoodEachMeal = response.data.singleFoodEachMeal;
                  _this10.foodGroup.meals = response.data.meals;
                  if (_this10.foodGroup.meals.length != 0) {
                    var dd = _this10.foodGroup.meals[0].id;
                    _this10.getFoodMeal(dd);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get('errors.connectionError'));
                      _this10.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context7.sent;

                _this10.isLoadingDetail = false;
                _context7.next = 13;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0);
                _this10.isLoadingDetail = false;

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 8]]);
      }))();
    },
    getFoodMeal: function getFoodMeal(id) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, aList;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this11.isLoadingMeals = true;
                _this11.checkFalseDays();
                _context8.next = 5;
                return _this11.$axios.get("/FoodGroups/GetFoodMeal/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get('errors.connectionError'));
                      _this11.isLoadingMeals = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingMeals = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context8.sent;

                _this11.isNewMeal = false;
                _this11.selectedMeal.id = id;
                _this11.selectedMeal.mealNameId = response.data.mealNameId;
                _this11.selectedMeal.foodGroupId = response.data.foodGroupId;
                _this11.selectedMeal.day = response.data.day;
                _this11.selectedMeal.endDate = response.data.endDate ? _this11.toDateFormat(response.data.endDate, "ss:dd") : "";
                _this11.selectedMeal.startDate = response.data.startDate ? _this11.toDateFormat(response.data.startDate, "ss:dd") : "";
                _this11.selectedMeal.foodClaim = response.data.foodClaim;
                _this11.selectedMeal.price = response.data.price;
                _this11.selectedMeal.price2 = response.data.price2;
                aList = _this11.days;
                _context8.next = 19;
                return aList.filter(function (day) {
                  if (day.value == response.data.day) {
                    day.check = true;
                  }
                });

              case 19:
                _this11.isLoadingMeals = false;
                _context8.next = 27;
                break;

              case 22:
                _context8.prev = 22;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error(_context8.t0);
                _this11.isLoadingMeals = false;

              case 27:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[0, 22]]);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this12.isLoading = true;
                foodGroups = [];
                _context9.next = 5;
                return _this12.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get('errors.connectionError'));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context9.sent;


                _this12.foodGroups = foodGroups;
                _this12.isLoading = false;
                _context9.next = 15;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                alertify.error("Servis Hatası :" + _context9.t0.message);
                _this12.isLoading = false;

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this13 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this13.getFoodGroups();

            case 2:
              _context10.next = 4;
              return _this13.getMealNames();

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this13);
    }))();
  }
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingInOuts: false,
      isLoadingEmployee: false,
      windowHeight: window.innerHeight,
      orderEmpList: 1,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      employee: {
        id: null,
        name: "",
        title: "",
        sicilNo: "",
        image: null,
        departmentId: null,
        identityNo: "",
        startDate: null,
        endDate: null,
        workGroupId: null,
        stateId: 1,
        stateNote: "",
        terminalNo: null,
        statuId: null,
        cardNo: "",
        terminalStatu: 0,
        terminalPassword: "",
        accessGroupId: null,
        readers: [],
        overWorkStatus: true,
        salary: null,
        mail: "",
        address: "",
        mobilePhone: "",
        birthDayDate: null,
        internalPhone: "",
        homePhone: "",
        gender: null,
        educationStatus: null,
        militaryStatus: null,
        drivingLicence: "",
        smokeStatus: null,
        maritalStatus: null,
        bloodType: "",
        height: "",
        weight: "",
        disabledPercent: "",
        authorizedPerson1: null,
        authorizedPerson2: null,
        note1: "",
        note2: "",
        foreignLanguage: "",
        foodGroupId: 0,
        credit: 0,
        remainder: "0",
        isVisitor: false,
        visitorCardGroupId: null,
        visitorArea: "",
        isActive: true,
        extrafields: [],
        inOuts: [],
        allowences: [],
        logs: [],
        empPayrolls: [],
        annualPermitId: 0,
        annualPermitSeniority: 0,
        annualPermitTransfer: 0,
        annualPermitClaim: 0,
        annualPermitUsed: 0,
        annualPermitRemain: 0,
        annualPermits: [],
        annualPermitClaimsDates: [],
        salaries: [],
        hasCard: false,
        hasFace: false,
        hasFinger: false,
        hasPassword: false
      },
      inOut: {
        inOutId: null,
        inOutListType: 0,
        inOutListDoorType: 2,
        inOutType: 1,
        inOutAdd: null,
        readerId: "0",
        inOutStartDate: null,
        inOutEndDate: null,
        price: 0
      },
      includePassiveMovements: false,
      doNotDeleteOvertimes: true,
      sortableDepTrees: [],
      selectedFoodType: 1,
      selectedFoodCount: "0",
      foodBalanceLogs: [],
      isNewSalary2: true,
      selectedSalaryId: null,
      selectedSalaryName: "",
      selectedSalaryStatus: 1,
      isNewState: true,
      selectedStateId: null,
      selectedStateName: "",
      selectedStateStatus: false,
      isNewStatu: true,
      selectedStatuId: null,
      selectedStatuName: "",
      searchPayrollStartDate: null,
      searchPayrollEndDate: null,
      selectAP: 1,
      logStartDate: null,
      logEndDate: null,
      allowences: [],
      extrafields: [],
      workGroups: [],
      status: [],
      states: [],
      foodGroups: [],
      titles: [],
      accessGroups: [],
      departments: [],
      employees: [],
      allEmployees: [],
      annualPermits: [],
      visitorCardGroups: [],
      isNewVisitorCardGroup: true,
      selectedVisitorCardGroupId: null,
      selectedVisitorCardGroupName: "",
      selectedVisitorCardGroupDevices: [],
      overtimeDescriptions: [],
      overtimePlaces: [],
      selectedOTDescriptionId: null,
      selectedOTPlaceId: null,
      selectedOverTimeId: null,
      searchText2: "",
      readers: [],
      isCheck: false,
      isCheckDeps: false,
      searchText: "",
      extraFieldKey: "",
      extraFieldValue: "",
      isNewInOut: true,
      isNewEmployee: true,
      isNewSalary: true,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      selectedFoodGroupType: 0,
      meals: [],
      selectedMealTime: "",
      isLoadingRetailSale: false,
      saleLogs: [],
      retailSaleLogs: {
        empIds: [],
        startDate: null,
        endDate: null
      }
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    retailSaleLogList: function retailSaleLogList() {
      return this.saleLogs;
    },
    retailSaleLogTotalPrice: function retailSaleLogTotalPrice() {
      var totalPrice = 0;
      if (this.retailSaleLogList.length > 0) {
        this.retailSaleLogList.forEach(function (item) {
          totalPrice += item.price;
        });
      }
      return totalPrice;
    },
    logList: function logList() {
      return this.employee.logs;
    },
    readerList: function readerList() {
      return this.readers.sort(function (a, b) {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    activeReaderList: function activeReaderList() {
      return this.readerList;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeList: function employeeList() {
      var _this = this;

      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.sicilNo).localeCompare(_this.turkishToUpper(b.sicilNo));
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.sicilNo).localeCompare(_this.turkishToUpper(a.sicilNo));
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
        });
      } else {
        return this.employees.sort(function (a, b) {
          return _this.turkishToUpper(b.name).localeCompare(_this.turkishToUpper(a.name));
        });
      }
    },
    allEmployeeList: function allEmployeeList() {
      return this.allEmployees;
    },
    mealList: function mealList() {
      return this.meals;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodBalanceLogList: function foodBalanceLogList() {
      return this.foodBalanceLogs;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    employeeExtraFieldList: function employeeExtraFieldList() {
      return this.employee.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    EmpPayrollList: function EmpPayrollList() {
      return this.employee.empPayrolls;
    },
    inOutList: function inOutList() {
      return this.employee.inOuts;
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.allEmployeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v) || _this2.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.allEmployeeList;
      }
    },
    filtered: function filtered() {
      var _this3 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.employeeList.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this3.turkishToUpper(item.name).includes(v) || _this3.turkishToUpper(item.sicilNo).includes(v);
          });
        });
      } else {
        return this.employeeList;
      }
    },
    inOutFiltered: function inOutFiltered() {
      return this.inOutList.filter(function (item) {
        return item.doorType == 2;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 220;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this4.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    exportToPDFSaleLogs: function exportToPDFSaleLogs() {
      this.$htmlToPaper("printSatisHareketleri");
    },
    exportToPDFHareketler: function exportToPDFHareketler() {
      this.$htmlToPaper("printHareketler");
    },
    exportToPDFBakiyeHareketleri: function exportToPDFBakiyeHareketleri() {
      this.$htmlToPaper("printBakiyeLoglari");
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getDepartmentFromId: function getDepartmentFromId(id) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0].name;
      } else {
        return null;
      }
    },
    getEmpNameFromId: function getEmpNameFromId(id) {
      var aList = this.allEmployees;
      var emp = aList.filter(function (emp) {
        return emp.id == id;
      });
      if (emp != "" && emp != null) {
        var title = "";
        if (emp[0].title != "") {
          title = " - " + emp[0].title;
        }
        return emp[0].name + title;
      } else {
        return null;
      }
    },
    changeFoodGroup: function changeFoodGroup(event) {
      this.employee.foodGroupId = event.target.value;
      this.changeFoodGroupType();
    },
    changeMeal: function changeMeal(event) {
      this.selectedMealTime = event.target.value;
    },
    changeInOutDoor: function changeInOutDoor(event) {
      this.inOut.readerId = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterAccessGroups: function changeFilterAccessGroups(event) {
      this.filters.accessGroup = event.target.value;
    },
    changeFilterFoodGroups: function changeFilterFoodGroups(event) {
      this.filters.foodGroup = event.target.value;
    },
    changeFilterStatus: function changeFilterStatus(event) {
      this.filters.statuId = event.target.value;
    },
    changeFilterStates: function changeFilterStates(event) {
      this.filters.stateId = event.target.value;
    },
    changeFilterWorkGroups: function changeFilterWorkGroups(event) {
      this.filters.workGroupId = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    selectFoodType: function selectFoodType(number, value) {
      this.selectedFoodType = number;
      //this.selectedFoodCount = value;
    },
    changeFoodGroupType: function changeFoodGroupType() {
      var _this5 = this;

      var secilen = this.foodGroupList.filter(function (item) {
        return _this5.employee.foodGroupId == item.id;
      });
      if (secilen[0]) {
        this.selectedFoodGroupType = secilen[0].type;
      } else {
        this.selectedFoodGroupType = 0;
      }
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    getMeals: function getMeals(id, date) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var meals, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                if (!(id == null || date == null)) {
                  _context.next = 4;
                  break;
                }

                alertify.error(_this6.$ml.get("alerts.pleaseCheckFoodGroupAndDate"));
                return _context.abrupt("return");

              case 4:
                meals = [];
                _context.next = 7;
                return _this6.$axios.post("/FoodGroups/GetMealsByFoodGroupId", {
                  foodGroupId: id,
                  selectedDate: date
                }).then(function (response) {
                  if (response.status == 200) {
                    meals = response.data;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context.sent;

                _this6.meals = meals;
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error("Servis Hatası : " + _context.t0.message);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[0, 11]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                readers = [];
                _context2.next = 4;
                return _this7.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 2) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this7.$ml.get("alerts.getReadersError"));
                      _this7.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this7.readers = readers;
                if (_this7.readers[0]) {
                  _this7.inOut.readerId = _this7.readers[0].readerId;
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası : " + _context2.t0.message);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this7, [[0, 9]]);
      }))();
    },
    getFoodBalanceLogs: function getFoodBalanceLogs() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var foodBalanceLogs, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                foodBalanceLogs = [];
                _context3.next = 4;
                return _this8.$axios.get("/FoodMenu/GetFoodBalanceLogs?empId=" + _this8.employee.id).then(function (response) {
                  if (response.status == 200) {
                    if (response.data) {
                      response.data.forEach(function (doc) {
                        foodBalanceLogs.push({
                          logId: doc.logId,
                          empId: doc.empId,
                          date: doc.date,
                          type: doc.type, //1 kontör 2 bakiye
                          amount: doc.amount,
                          isAdded: doc.isAdded
                        });
                      });
                    }
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this8.foodBalanceLogs = foodBalanceLogs;
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Servis Hatası : " + _context3.t0.message);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this8, [[0, 8]]);
      }))();
    },
    updateFoodCredit: function updateFoodCredit() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var credit, employeeId, creditType, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                credit = null;

                if (!(_this9.selectedFoodCount == null || _this9.selectedFoodCount == 0)) {
                  _context4.next = 6;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.creditNotBlank"));
                return _context4.abrupt("return");

              case 6:
                credit = parseFloat(_this9.selectedFoodCount.replace(".", ","));

              case 7:
                if (!($.isNumeric(credit) == false)) {
                  _context4.next = 10;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.creditNotBlank"));
                return _context4.abrupt("return");

              case 10:
                _context4.prev = 10;
                employeeId = _this9.employee.id;
                creditType = _this9.selectedFoodType;
                _context4.next = 15;
                return _this9.$axios.post("/EmployeeDetails/UpdateCredit", {
                  employeeId: employeeId,
                  creditType: creditType,
                  credit: credit
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this9.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this9.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 15:
                response = _context4.sent;

                _this9.selectedFoodCount = 0;
                _this9.getEmployee(employeeId);
                _this9.getFoodBalanceLogs();
                _context4.next = 25;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4["catch"](10);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);

              case 25:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this9, [[10, 21]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                departments = [];
                _context5.prev = 1;
                _context5.next = 4;
                return _this10.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context5.sent;

                _this10.departments = departments;
                _this10.sortableTrees();
                _this10.isLoading = false;
                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](1);

                console.error(_context5.t0);
                alertify.error(_context5.t0);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this10, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this11 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this11.sortableDepTrees.push(dep);
          _this11.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this12 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this12.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this12.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                foodGroups = [];
                _context6.next = 4;
                return _this13.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context6.sent;

                _this13.foodGroups = foodGroups;
                _context6.next = 12;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this13, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                status = [];
                _context7.next = 4;
                return _this14.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context7.sent;

                _this14.status = status;
                _context7.next = 12;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);

              case 12:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this14, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                titles = [];
                _context8.next = 4;
                return _this15.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context8.sent;

                _this15.titles = titles;
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this15, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                states = [];
                _context9.next = 4;
                return _this16.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context9.sent;

                _this16.states = states;
                _context9.next = 12;
                break;

              case 8:
                _context9.prev = 8;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                alertify.error("Servis Hatası :" + _context9.t0.message);

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this16, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                workGroups = [];
                _context10.next = 4;
                return _this17.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      model: doc.model,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this17.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this17.$ml.get("errors.connectionError"));
                      _this17.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this17.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context10.sent;

                _this17.workGroups = workGroups;
                _context10.next = 12;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error("Servis Hatası :" + _context10.t0.message);

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this17, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                extrafields = [];
                _context11.next = 4;
                return _this18.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this18.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this18.$ml.get("errors.connectionError"));
                      _this18.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this18.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context11.sent;

                _this18.extrafields = extrafields;
                _context11.next = 12;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);
                alertify.error("Servis Hatası :" + _context11.t0.message);

              case 12:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this18, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                accessGroups = [];
                _context12.next = 4;
                return _this19.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this19.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this19.$ml.get("errors.connectionError"));
                      _this19.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this19.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context12.sent;

                _this19.accessGroups = accessGroups;
                _context12.next = 12;
                break;

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);
                alertify.error("Servis Hatası :" + _context12.t0.message);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this19, [[0, 8]]);
      }))();
    },
    getRetailSaleLogs: function getRetailSaleLogs() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var saleLogs, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!_this20.isNewEmployee) {
                  _context13.next = 3;
                  break;
                }

                alertify.warning(_this20.$ml.get("alerts.selectedEmplyeeNotBlank"));
                return _context13.abrupt("return");

              case 3:
                if (!(_this20.retailSaleLogs.startDate == null || _this20.retailSaleLogs.endDate == null || _this20.retailSaleLogs.startDate > _this20.retailSaleLogs.endDate)) {
                  _context13.next = 6;
                  break;
                }

                alertify.warning(_this20.$ml.get("alerts.invalidDate"));
                return _context13.abrupt("return");

              case 6:
                _context13.prev = 6;

                _this20.isLoadingRetailSale = true;
                saleLogs = [];

                _this20.retailSaleLogs.empIds = [];
                _this20.retailSaleLogs.empIds.push(_this20.employee.id);
                _context13.next = 13;
                return _this20.$axios.post("/Reports/SaleReport", _this20.retailSaleLogs).then(function (response) {
                  response.data.datas[0].veriler.forEach(function (doc) {
                    saleLogs.push(doc);
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this20.$ml.get("errors.connectionError"));
                    _this20.isLoadingRetailSale = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this20.isLoadingRetailSale = false;
                    return;
                  }
                });

              case 13:
                response = _context13.sent;

                _this20.saleLogs = saleLogs;
                _this20.isLoadingRetailSale = false;
                _context13.next = 23;
                break;

              case 18:
                _context13.prev = 18;
                _context13.t0 = _context13["catch"](6);

                console.error(_context13.t0);
                alertify.error(_context13.t0.message);
                _this20.isLoadingRetailSale = false;

              case 23:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this20, [[6, 18]]);
      }))();
    },
    getInOuts: function getInOuts() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var inOuts, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (!_this21.isNewEmployee) {
                  _context14.next = 3;
                  break;
                }

                alertify.warning(_this21.$ml.get("alerts.selectedEmplyeeNotBlank"));
                return _context14.abrupt("return");

              case 3:
                if (!(_this21.inOut.inOutStartDate == null || _this21.inOut.inOutEndDate == null || _this21.inOut.inOutStartDate > _this21.inOut.inOutEndDate)) {
                  _context14.next = 6;
                  break;
                }

                alertify.warning(_this21.$ml.get("alerts.invalidDate"));
                return _context14.abrupt("return");

              case 6:
                _context14.prev = 6;

                _this21.isLoadingInOuts = true;
                inOuts = [];
                selectedUser = _this21.employee.id;
                startDate = _this21.inOut.inOutStartDate;
                endDate = _this21.inOut.inOutEndDate;
                _context14.next = 14;
                return _this21.$axios.post("/EmployeeDetails/GetEntryExit", {
                  id: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    inOuts.push({
                      id: doc.id,
                      date: doc.date,
                      readerName: doc.readerName,
                      readerId: doc.readerId,
                      doorType: doc.doorType,
                      inOrOut: doc.inOrOut,
                      price: doc.price,
                      isActive: doc.isActive
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this21.$ml.get("errors.connectionError"));
                    _this21.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this21.isLoadingInOuts = false;
                    return;
                  }
                });

              case 14:
                response = _context14.sent;

                _this21.employee.inOuts = inOuts;
                _this21.isLoadingInOuts = false;
                _context14.next = 24;
                break;

              case 19:
                _context14.prev = 19;
                _context14.t0 = _context14["catch"](6);

                console.error(_context14.t0);
                alertify.error(_context14.t0.message);
                _this21.isLoadingInOuts = false;

              case 24:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this21, [[6, 19]]);
      }))();
    },
    newInOut: function newInOut() {
      this.isNewInOut = true;
      this.inOut.inOutId = null;
      this.inOut.readerId = "";
      this.inOut.inOutType = 1;
      this.inOut.price = 0;
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      this.inOut.inOutAdd = yil + "-" + ay + "-" + gun + "T00:00";
    },
    selectInOut: function selectInOut(id) {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var aList, log;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _this22.isNewInOut = false;
                aList = _this22.employee.inOuts;
                log = aList.filter(function (doc) {
                  return doc.id == id;
                });

                _this22.inOut.inOutId = id;
                _this22.inOut.inOutType = log[0].inOrOut;
                _this22.inOut.inOutAdd = log[0].date;
                _this22.inOut.readerId = log[0].readerId;
                _this22.inOut.price = log[0].price;

              case 8:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this22);
      }))();
    },
    deleteInOut: function deleteInOut(id) {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                if (!(id != 0)) {
                  _context16.next = 5;
                  break;
                }

                _context16.next = 4;
                return _this23.$axios.delete("/EmployeeDetails/DeleteEntryExit/" + id).then(function (response) {
                  _this23.getInOuts();
                  _this23.newInOut();
                  _this23.getFoodBalanceLogs();
                  alertify.success(_this23.$ml.get("alerts.deletedSuccessfully"));
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this23.$ml.get("errors.connectionError"));
                    _this23.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this23.isLoadingInOuts = false;
                    return;
                  }
                });

              case 4:
                response = _context16.sent;

              case 5:
                _context16.next = 10;
                break;

              case 7:
                _context16.prev = 7;
                _context16.t0 = _context16["catch"](0);

                alertify.error("Hata Oluştu : " + _context16.t0);

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this23, [[0, 7]]);
      }))();
    },
    addInOut: function addInOut() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var selectedDate, date, today, empId, inOurOut, inOutAdd, readerId, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(_this24.selectedMealTime == "")) {
                  _context17.next = 3;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.selectedMealNotBlank"));
                return _context17.abrupt("return");

              case 3:
                if (!(_this24.inOut.inOutAdd == "")) {
                  _context17.next = 6;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.invalidDate"));
                return _context17.abrupt("return");

              case 6:
                if (!(_this24.inOut.readerId == "" || _this24.inOut.readerId == 0)) {
                  _context17.next = 9;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.notSelectedReader"));
                return _context17.abrupt("return");

              case 9:
                selectedDate = _this24.toDateFormat(_this24.inOut.inOutAdd, "gg.aa.yyyy") + "T" + _this24.selectedMealTime;
                date = new Date(selectedDate);
                today = new Date();

                if (!(date > today)) {
                  _context17.next = 15;
                  break;
                }

                alertify.warning(_this24.$ml.get("alerts.cannotCreateMovementInTheFuture"));
                return _context17.abrupt("return");

              case 15:
                _context17.prev = 15;
                empId = _this24.employee.id;
                inOurOut = _this24.inOut.inOutType;
                inOutAdd = selectedDate;
                readerId = _this24.inOut.readerId;
                _context17.next = 22;
                return _this24.$axios.post("/EmployeeDetails/AddEntryExit", {
                  isActive: true,
                  inOrOut: inOurOut,
                  date: inOutAdd,
                  readerId: readerId,
                  includePassiveMovements: _this24.includePassiveMovements,
                  doNotDeleteOvertimes: _this24.doNotDeleteOvertimes,
                  empId: empId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this24.$ml.get("errors.connectionError"));
                    _this24.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this24.isLoadingInOuts = false;
                    return;
                  }
                });

              case 22:
                response = _context17.sent;

                if (response.status == 200) {
                  alertify.success(_this24.$ml.get("alerts.savedSuccessfully"));
                } else if (response.status == 201) {
                  alertify.error(_this24.$ml.get("alerts.checkTheMealTime"));
                } else {
                  alertify.error(response.message);
                }
                _this24.getFoodBalanceLogs();
                _this24.getInOuts();
                _context17.next = 32;
                break;

              case 28:
                _context17.prev = 28;
                _context17.t0 = _context17["catch"](15);

                console.error(_context17.t0);
                alertify.error(_context17.t0.message);

              case 32:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this24, [[15, 28]]);
      }))();
    },
    saveEmployee: function saveEmployee() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var employee2, id, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _this25.isLoading = true;
                //GÜNCELLE

                if (!_this25.isNewEmployee) {
                  _context18.next = 4;
                  break;
                }

                alertify.warning(_this25.$ml.get("alerts.selectedEmplyeeNotBlank"));
                return _context18.abrupt("return");

              case 4:
                _context18.prev = 4;
                employee2 = _this25.employee;
                id = employee2.id;
                _context18.next = 9;
                return _this25.$axios.post("/FoodMenu/UpdateEmployeeFoodGroup", {
                  empId: employee2.id,
                  foodGroupId: employee2.foodGroupId
                }).then(function (response) {
                  alertify.success(_this25.$ml.get("alerts.updatedSuccessfully"));
                  _this25.getEmployees();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this25.$ml.get("errors.connectionError"));
                    _this25.isLoadingInOuts = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this25.isLoadingInOuts = false;
                    return;
                  }
                });

              case 9:
                response = _context18.sent;
                _context18.next = 16;
                break;

              case 12:
                _context18.prev = 12;
                _context18.t0 = _context18["catch"](4);

                console.error(_context18.t0);
                alertify.error(_context18.t0);

              case 16:
                _this25.isLoading = false;

              case 17:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this25, [[4, 12]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.retailSaleLogs.startDate == null) {
        this.retailSaleLogs.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.retailSaleLogs.endDate == null) {
        this.retailSaleLogs.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.inOut.inOutStartDate == null) {
        this.inOut.inOutStartDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.inOut.inOutEndDate == null) {
        this.inOut.inOutEndDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
      if (this.inOut.inOutAdd == null) {
        this.inOut.inOutAdd = yil + "-" + ay + "-" + gun + "T00:00";
      }
    },
    getEmployee: function getEmployee(id) {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this26.getDefaultDate();
                _this26.isLoading = true;
                _this26.tempUrl = null;
                _this26.imageData = null;
                _context19.next = 7;
                return _this26.$axios.get("/Employees/" + id).then(function (response) {
                  _this26.isNewEmployee = false;
                  _this26.employee.id = id;
                  _this26.employee.sicilNo = response.data.sicilNo;
                  _this26.employee.image = response.data.image;
                  _this26.employee.name = response.data.name;
                  _this26.employee.departmentId = response.data.departmentId;
                  _this26.employee.title = response.data.title;
                  _this26.employee.identityNo = response.data.identityNo;
                  _this26.employee.startDate = _this26.toDateFormat(response.data.startDate, "gg.aa.yyyy");
                  _this26.employee.endDate = response.data.endDate ? _this26.toDateFormat(response.data.endDate, "gg.aa.yyyy") : null;
                  _this26.employee.stateId = response.data.stateId;
                  _this26.employee.stateNote = response.data.stateNote;
                  _this26.employee.terminalNo = response.data.terminalNo;
                  _this26.employee.statuId = response.data.statuId;
                  _this26.employee.cardNo = response.data.cardNo;
                  _this26.employee.terminalStatu = response.data.terminalStatu;
                  _this26.employee.terminalPassword = response.data.terminalPassword;
                  _this26.employee.workGroupId = response.data.workGroupId;
                  _this26.employee.documentNo = response.data.documentNo;
                  _this26.employee.salary = response.data.salary;
                  _this26.employee.overWorkStatus = response.data.overWorkStatus;
                  _this26.employee.mail = response.data.mail;
                  _this26.employee.mobilePhone = response.data.mobilePhone;
                  _this26.employee.birthDayDate = response.data.birthDayDate ? _this26.toDateFormat(response.data.birthDayDate, "gg.aa.yyyy") : null;
                  _this26.employee.address = response.data.address;
                  _this26.employee.internalPhone = response.data.internalPhone;
                  _this26.employee.homePhone = response.data.homePhone;
                  _this26.employee.gender = response.data.gender;
                  _this26.employee.educationStatus = response.data.educationStatus;
                  _this26.employee.militaryStatus = response.data.militaryStatus;
                  _this26.employee.drivingLicence = response.data.drivingLicence;
                  _this26.employee.smokeStatus = response.data.smokeStatus;
                  _this26.employee.maritalStatus = response.data.maritalStatus;
                  _this26.employee.bloodType = response.data.bloodType;
                  _this26.employee.height = response.data.height;
                  _this26.employee.weight = response.data.weight;
                  _this26.employee.disabledPercent = response.data.disabledPercent;
                  _this26.employee.authorizedPerson1 = response.data.authorizedPerson1;
                  _this26.employee.authorizedPerson2 = response.data.authorizedPerson2;
                  _this26.employee.note1 = response.data.note1;
                  _this26.employee.note2 = response.data.note2;
                  _this26.employee.foreignLanguage = response.data.foreignLanguage;
                  _this26.employee.accessGroupId = response.data.accessGroupId;
                  _this26.employee.readers = response.data.readers;
                  _this26.employee.foodGroupId = response.data.foodGroupId;
                  _this26.employee.credit = response.data.credit;
                  _this26.employee.remainder = response.data.remainder;
                  _this26.employee.isVisitor = response.data.isVisitor;
                  _this26.employee.visitorCardGroupId = response.data.visitorCardGroupId;
                  _this26.employee.isActive = response.data.isActive;
                  _this26.employee.inOuts = [];
                  _this26.employee.allowences = [];
                  _this26.employee.logs = [];
                  _this26.employee.extrafields = [];
                  _this26.employee.empPayrolls = [];
                  _this26.employee.annualPermitId = response.data.annualPermitId;
                  _this26.employee.annualPermitClaim = response.data.annualPermitClaim;
                  _this26.employee.annualPermitUsed = response.data.annualPermitUsed;
                  _this26.employee.annualPermitRemain = response.data.annualPermitRemain;
                  _this26.employee.annualPermits = response.data.annualPermits;
                  _this26.employee.annualPermitClaimsDates = response.data.annualPermitClaimsDates;
                  _this26.employee.annualPermitSeniority = response.data.annualPermitSeniority;
                  _this26.employee.annualPermitTransfer = response.data.annualPermitTransfer;
                  _this26.employee.hasCard = response.data.hasCard;
                  _this26.employee.hasFace = response.data.hasFace;
                  _this26.employee.hasFinger = response.data.hasFinger;
                  _this26.employee.hasPassword = response.data.hasPassword;
                  _this26.newInOut();
                  _this26.changeFoodGroupType();
                  _this26.getFoodBalanceLogs();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context19.sent;

                _this26.isLoading = false;
                _context19.next = 16;
                break;

              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error(_context19.t0);
                _this26.isLoading = false;

              case 16:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this26, [[0, 11]]);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                dep.check = checkValue;
                _this27.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this27.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this27);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _this28.filters.departments = [];
                _context21.next = 3;
                return _this28.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this28);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _this29.filters.accessGroup = [];
                _context22.next = 3;
                return _this29.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this29);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _this30.filters.stateId = [];
                _context23.next = 3;
                return _this30.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this30);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _this31.filters.statuId = [];
                _context24.next = 3;
                return _this31.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this31);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this32.filters.workGroupId = [];
                _context25.next = 3;
                return _this32.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this32);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _this33.filters.foodGroup = [];
                _context26.next = 3;
                return _this33.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this33);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this34.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this34.isCheckDeps = !_this34.isCheckDeps;

              case 2:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this34);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                aList = _this35.sortableDepartmentList;

                _this35.filters.departments = [];
                _context28.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this35.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this35.accessGroupList;

                _this35.filters.accessGroup = [];
                _context28.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this35.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this35.workGroupList;

                _this35.filters.workGroupId = [];
                _context28.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this35.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this35.foodGroupList;

                _this35.filters.foodGroup = [];
                _context28.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this35.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this35.statuList;

                _this35.filters.statuId = [];
                _context28.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this35.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this35.stateList;

                _this35.filters.stateId = [];
                _context28.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this35.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this35);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;

                _this36.isLoadingEmployee = true;
                _context29.next = 4;
                return _this36.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this36.filters;
                _context29.next = 8;
                return _this36.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    } else if (error.response.status == 403) {
                      alertify.message(_this36.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoadingEmployee = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoadingEmployee = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context29.sent;

                _this36.employees = employees;
                _this36.isLoadingEmployee = false;
                _context29.next = 18;
                break;

              case 13:
                _context29.prev = 13;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error("Servis Hatası :" + _context29.t0.message);
                _this36.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this36, [[0, 13]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this37 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this37.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this37.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this37.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this37.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this37.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this37.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this38 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
      var filter;
      return regeneratorRuntime.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              _context30.next = 2;
              return _this38.getDepartments();

            case 2:
              _context30.next = 4;
              return _this38.getAccessGroups();

            case 4:
              _context30.next = 6;
              return _this38.getStatus();

            case 6:
              _context30.next = 8;
              return _this38.getStates();

            case 8:
              _context30.next = 10;
              return _this38.getTitles();

            case 10:
              _context30.next = 12;
              return _this38.getWorkGroups();

            case 12:
              _context30.next = 14;
              return _this38.getExtraFields();

            case 14:
              _context30.next = 16;
              return _this38.getReaders();

            case 16:
              _context30.next = 18;
              return _this38.getFoodGroups();

            case 18:
              _context30.next = 20;
              return _this38.getDefaultDate();

            case 20:
              if (!_this38.defaultFilters) {
                _context30.next = 25;
                break;
              }

              filter = _this38.defaultFilters;

              _this38.setUserAuthorityFilter(filter);
              _context30.next = 25;
              return _this38.getEmployees();

            case 25:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30, _this38);
    }))();
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingEmployee: false,
      activeScreen: 1,
      orderEmpList: 1,
      selectedDoorType: 4,
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      sortableDepTrees: [],
      isCheckDeps: false,
      isCheck: true,
      employees: [],
      departments: [],
      foodGroups: [],
      titles: [],
      states: [],
      status: [],
      extrafields: [],
      workGroups: [],
      accessGroups: [],
      isCheckVG: true,
      visitorGroups: [],
      isCheckAllowences: true,
      allowences: [],
      isCheckReaders: true,
      readers: [],
      startDate: null,
      endDate: null,
      selectedReportIndex: 0,
      selectedReportEndPoint: "",
      selectedReportName: "",
      selectedDevices: [],
      selectedAllowences: [],
      selectedVisitorGroups: [],
      reportOptions: {
        showAllowed: true,
        showNonComers: true,
        showLateComers: false,
        isUpperFromTime: false,
        time: 45
      },
      reportDatas: null,
      reportHeaders: null,
      reportResult: [],
      reportName: "",
      searchText: "",
      activeReports: [],
      reports: [{
        id: 3,
        name: this.$ml.get("reports.reports.FoodReport"),
        endPoint: "FoodReport",
        isActive: false,
        index: 18
      }, {
        id: 4,
        name: this.$ml.get("reports.reports.FoodDebtReport"),
        endPoint: "FoodDebtReport",
        isActive: false,
        index: 19
      }, {
        id: 18,
        name: this.$ml.get("reports.reports.FoodCreditReport"),
        endPoint: "FoodCreditReport",
        isActive: false,
        index: 20
      }, {
        id: 25,
        name: this.$ml.get("reports.reports.FoodSummaryReport"),
        endPoint: "FoodSummaryReport",
        isActive: false,
        index: 21
      }]
    };
  },

  computed: {
    defaultFilters: function defaultFilters() {
      return this.$store.getters.getDefaultFilters;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthRaporlar;
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.workGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    employeeFilteredList: function employeeFilteredList() {
      if (this.orderEmpList == 1) {
        return this.employees.sort(function (a, b) {
          return a.sicilNo.toUpperCase().localeCompare(b.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 2) {
        return this.employees.sort(function (a, b) {
          return b.sicilNo.toUpperCase().localeCompare(a.sicilNo.toUpperCase());
        });
      } else if (this.orderEmpList == 3) {
        return this.employees.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      } else {
        return this.employees.sort(function (a, b) {
          return b.name.toUpperCase().localeCompare(a.name.toUpperCase());
        });
      }
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      return this.sortableDepTrees;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    titleList: function titleList() {
      return this.titles;
    },
    stateList: function stateList() {
      return this.states;
    },
    statuList: function statuList() {
      return this.status;
    },
    visitorGroupList: function visitorGroupList() {
      return this.visitorGroups;
    },
    readerList: function readerList() {
      return this.readers.sort(function (a, b) {
        if (a.ipAddress < b.ipAddress) return -1;
        if (a.ipAddress > b.ipAddress) return 0;
      });
    },
    reportList: function reportList() {
      var list = this.reports.filter(function (item) {
        return item.isActive == true;
      });
      if (list) {
        return list.sort(function (a, b) {
          if (a.index < b.index) return -1;
          if (a.index > b.index) return 0;
        });
      }
    },
    reportDataList: function reportDataList() {
      return this.reportDatas;
    },
    reportHeaderList: function reportHeaderList() {
      return this.reportHeaders;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    workGroupList: function workGroupList() {
      return this.workGroups;
    },
    allowenceList: function allowenceList() {
      return this.allowences;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    filtered: function filtered() {
      var _this = this;

      if (this.searchText) {
        return this.employeeFilteredList.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.employeeFilteredList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 300;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 380;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    setOrderEmp: function setOrderEmp(number) {
      if (number == 1) {
        if (this.orderEmpList == 1) {
          this.orderEmpList = 2;
        } else {
          this.orderEmpList = 1;
        }
      } else {
        if (this.orderEmpList == 3) {
          this.orderEmpList = 4;
        } else {
          this.orderEmpList = 3;
        }
      }
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeInOutListDoorType: function changeInOutListDoorType(event) {
      var _this3 = this;

      this.selectedDoorType = event.target.value;
      this.readerList.forEach(function (a) {
        if (_this3.selectedDoorType == 4) {
          a.check = true;
        } else {
          if (a.doorType == _this3.selectedDoorType) {
            a.check = true;
          } else {
            a.check = false;
          }
        }
      });
      this.isCheckReaders = true;
    },
    customReportStyle: function customReportStyle(key, value) {
      if (key == "durum") {
        if (value == "Gelmedi") {
          return "color-danger no-wrap";
        } else if (value == "Geç Kaldı" || value == "Hafta Tatili" || value == "Cumartesi Hakedişi") {
          return "color-warning no-wrap";
        } else if (value == "Geldi") {
          return "color-success no-wrap";
        } else {
          return "color-primary no-wrap";
        }
      } else if (key == "name" && value == "Toplam" || key == "date" && value == "Toplam") {
        return "text-bold h5";
      } else if (key == "unitName") {
        return "text-bold";
      } else if (key == "employeesInDepartments" || key == "continuedEmployee" || key == "annualPermit" || key == "report" || key == "missioned" || key == "administrativeLeave" || key == "nonComers" || key == "todayComers" || key == "freePermission") {
        return "text-bold text-center";
      } else if (key == "adSoyad" || key == "name") {
        return "min-180";
      } else if (key == "total" || key == "ucret" || key == "allowenceName") {
        return "text-bold";
      } else if (key == "g1" && value != "") {
        return "color-success";
      } else if (key == "c1" && value != "") {
        return "color-danger";
      } else if (key == "g2" && value != "") {
        return "color-success";
      } else if (key == "c2" && value != "") {
        return "color-danger";
      } else if (key == "g3" && value != "") {
        return "color-success";
      } else if (key == "c3" && value != "") {
        return "color-danger";
      } else if (key == "g4" && value != "") {
        return "color-success";
      } else if (key == "c4" && value != "") {
        return "color-danger";
      } else if (key == "g5" && value != "") {
        return "color-success";
      } else if (key == "c5" && value != "") {
        return "color-danger";
      } else if (key == "g6" && value != "") {
        return "color-success";
      } else if (key == "c6" && value != "") {
        return "color-danger";
      } else if (key == "g7" && value != "") {
        return "color-success";
      } else if (key == "c7" && value != "") {
        return "color-danger";
      } else if (key == "g8" && value != "") {
        return "color-success";
      } else if (key == "c8" && value != "") {
        return "color-danger";
      } else if (key == "g9" && value != "") {
        return "color-success";
      } else if (key == "c9" && value != "") {
        return "color-danger";
      } else if (key == "g10" && value != "") {
        return "color-success";
      } else if (key == "c10" && value != "") {
        return "color-danger";
      } else if (key == "employeesInDepartments" || key == "annualPermit" || key == "report" || key == "administrativeLeave" || key == "freePermission" || key == "missioned" || key == "nonComers" || key == "todayComers" || key == "d1" || key == "d2" || key == "d3" || key == "d4" || key == "d5" || key == "d6" || key == "d7" || key == "d8" || key == "d9" || key == "d10" || key == "d11" || key == "d12" || key == "d13" || key == "d14" || key == "d15" || key == "d16" || key == "d17" || key == "d18" || key == "d19" || key == "d20" || key == "d21" || key == "d22" || key == "d23" || key == "d24" || key == "d25" || key == "d26" || key == "d27" || key == "d28" || key == "d29" || key == "d30" || key == "d31") {
        return "text-center";
      } else if (key == "shortCode1" || key == "shortCode2" || key == "shortCode3" || key == "shortCode4" || key == "shortCode5" || key == "shortCode6" || key == "shortCode7" || key == "shortCode8" || key == "shortCode9" || key == "shortCode10" || key == "shortCode11" || key == "shortCode12" || key == "shortCode13" || key == "shortCode14" || key == "shortCode15" || key == "shortCode16" || key == "shortCode17" || key == "shortCode18" || key == "shortCode19" || key == "shortCode20" || key == "shortCode21" || key == "shortCode22" || key == "shortCode23" || key == "shortCode24" || key == "shortCode25" || key == "shortCode26" || key == "shortCode27" || key == "shortCode28" || key == "shortCode29" || key == "shortCode30" || key == "shortCode31") {
        return "text-center";
      }
    },
    checkEmployees: function checkEmployees() {
      var _this4 = this;

      this.isCheck = !this.isCheck;
      var aList = this.employees;
      aList.forEach(function (doc) {
        if (doc.check == !_this4.isCheck) {
          doc.check = _this4.isCheck;
        }
      });
    },
    getSelectedEmployeeList: function getSelectedEmployeeList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selectedEmployees, selectedEmployeeList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this5.employees;
                selectedEmployees = aList.filter(function (employee) {
                  return employee.check == true;
                });
                selectedEmployeeList = [];
                _context.next = 5;
                return selectedEmployees.forEach(function (emp) {
                  selectedEmployeeList.push(emp.id);
                });

              case 5:
                return _context.abrupt("return", selectedEmployeeList);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.workGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeSelectedReport: function changeSelectedReport(event) {
      this.selectedReportIndex = event.target.value;
      var report = this.reportList.filter(function (item) {
        return item.id == event.target.value;
      });
      if (report) {
        this.selectedReportEndPoint = report[0].endPoint;
        this.selectedReportName = report[0].name;
      }
    },
    changeIsUpperFromTime: function changeIsUpperFromTime(event) {
      this.reportOptions.isUpperFromTime = event.target.value;
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.selectedReportName + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getAccessGroups: function getAccessGroups() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                accessGroups = [];
                _context2.next = 4;
                return _this6.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this6.accessGroups = accessGroups;
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 8]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                departments = [];
                _context3.prev = 1;
                _context3.next = 4;
                return _this7.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      userId: doc.userId,
                      check: false
                    });
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this7.departments = departments;
                _this7.sortableTrees();
                _this7.isLoading = false;
                _context3.next = 14;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](1);

                console.error(_context3.t0);
                alertify.error(_context3.t0);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[1, 10]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this8 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this8.sortableDepTrees.push(dep);
          _this8.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this9 = this;

      var departments2 = this.departments;
      var subDep = departments2.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          doc2.name = ekle + " " + doc2.name;
          _this9.sortableDepTrees.push(doc2);
          _this9.subDepImport(doc2);
        });
      }
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dep.check = checkValue;
                _this10.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this10.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this10);
      }))();
    },
    changeFilterDep2: function changeFilterDep2(dep, checkValue) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                dep.check = checkValue;
                _this11.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    //this.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this11);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this12.filters.departments = [];
                _context6.next = 3;
                return _this12.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this12);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this13.filters.accessGroup = [];
                _context7.next = 3;
                return _this13.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this13);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this14.filters.stateId = [];
                _context8.next = 3;
                return _this14.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this14);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this15.filters.statuId = [];
                _context9.next = 3;
                return _this15.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this15);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this16.filters.workGroupId = [];
                _context10.next = 3;
                return _this16.workGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this16);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this17.filters.foodGroup = [];
                _context11.next = 3;
                return _this17.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this17);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this18.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this18.isCheckDeps = !_this18.isCheckDeps;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this18);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                aList = _this19.sortableDepartmentList;

                _this19.filters.departments = [];
                _context13.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this19.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this19.accessGroupList;

                _this19.filters.accessGroup = [];
                _context13.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this19.workGroupList;

                _this19.filters.workGroupId = [];
                _context13.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this19.foodGroupList;

                _this19.filters.foodGroup = [];
                _context13.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this19.statuList;

                _this19.filters.statuId = [];
                _context13.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this19.stateList;

                _this19.filters.stateId = [];
                _context13.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this19.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this19);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                foodGroups = [];
                _context14.next = 4;
                return _this20.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context14.sent;

                _this20.foodGroups = foodGroups;
                _context14.next = 12;
                break;

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);

              case 12:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this20, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                status = [];
                _context15.next = 4;
                return _this21.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context15.sent;

                _this21.status = status;
                _context15.next = 12;
                break;

              case 8:
                _context15.prev = 8;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error("Servis Hatası :" + _context15.t0.message);

              case 12:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this21, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                titles = [];
                _context16.next = 4;
                return _this22.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context16.sent;

                _this22.titles = titles;
                _context16.next = 12;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error("Servis Hatası :" + _context16.t0.message);

              case 12:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this22, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                states = [];
                _context17.next = 4;
                return _this23.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this23.states = states;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this23, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                workGroups = [];
                _context18.next = 4;
                return _this24.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this24.workGroups = workGroups;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this24, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                extrafields = [];
                _context19.next = 4;
                return _this25.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this25.extrafields = extrafields;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this25, [[0, 8]]);
      }))();
    },
    changeAuthReports: function changeAuthReports() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _this26.activeReports.forEach(function (item) {
                  _this26.reports.forEach(function (report) {
                    if (report.id == item) {
                      report.isActive = true;
                    }
                  });
                });

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this26);
      }))();
    },
    getActiveReports: function getActiveReports() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                _context21.next = 3;
                return _this27.$axios.get("/Reports").then(function (response) {
                  _this27.activeReports = response.data;
                  _this27.changeAuthReports();
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context21.sent;
                _context21.next = 10;
                break;

              case 6:
                _context21.prev = 6;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);

              case 10:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this27, [[0, 6]]);
      }))();
    },
    reportSetting: function reportSetting() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var keys;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                if (_this28.reportResult != [] && _this28.reportResult != null) {
                  if (_this28.selectedReportIndex == 1) {
                    //Gelmeyenler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.status"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.LaterComersReportHeaders.difference"));
                    keys = ["sicilNo", "adSoyad", "statu", "tarih", "durum", "girisS", "fark"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 2) {
                    //Detaylı Giriş Çıkış Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.firstEntry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.lastExit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.total"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.status"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.entry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.exit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DetailedInOutReportHeaders.difference"));
                    //this.reportHeaders.push("Giriş");
                    //this.reportHeaders.push("Çıkış");
                    //this.reportHeaders.push("Fark");
                    //this.reportHeaders.push("Giriş");
                    //this.reportHeaders.push("Çıkış");
                    //this.reportHeaders.push("Fark");
                    keys = ["sicilNo", "adSoyad", "tarih", "ilkG", "sonC", "total", "durum", "g1", "c1", "f1", "g2", "c2", "f2", "g3", "c3", "f3", "g4", "c4", "f4", "g5", "c5", "f5", "g6", "c6", "f6", "g7", "c7", "f7", "g8", "c8", "f8"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 3) {
                    //Yemekhane Hareket Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.title"));
                    if (_this28.modules.customFieldName != "") {
                      _this28.reportHeaders.push(_this28.modules.customFieldName);
                    } else {
                      _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.documentNo"));
                    }
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.readerName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodReportHeader.debit"));
                    keys = ["sicilNo", "adSoyad", "title", "documentNo", "departmentName", "readerName", "tarih", "ucret"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 4) {
                    //Yemekhane Borç Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodDebtReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodDebtReportHeaders.nameSurname"));
                    if (_this28.modules.customFieldName != "") {
                      _this28.reportHeaders.push(_this28.modules.customFieldName);
                    } else {
                      _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodDebtReportHeaders.documentNo"));
                    }
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodDebtReportHeaders.debit"));
                    keys = ["sicilNo", "adSoyad", "iban", "ucret"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 5) {
                    //Kişi Bilgileri Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.mobilePhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.citizenshipNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.status"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.state"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.startDateWork"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.EmployeesReportHeaders.leaveDate"));
                    keys = ["sicilNo", "name", "title", "mobilePhone", "identityNo", "statu", "state", "startDate", "leaveDate"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 6) {
                    //İçeridekiler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsidesReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsidesReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsidesReportHeaders.entryTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsidesReportHeaders.entryPoint"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "entryDate", "entryPoint", "status"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 7) {
                    //Dışarıdakiler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.OutsidesReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.OutsidesReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.OutsidesReportHeaders.exitTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.OutsidesReportHeaders.exitPoint"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.OutsidesReportHeaders.status"));
                    keys = ["sicilNo", "name", "exitDate", "exitPoint", "status"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 8) {
                    //Ziyaretçiler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.citizenshipNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.mobilePhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.where"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.reasonForVisit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.visitedEmployeeInformation"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.cardIssueTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.entryTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.exitTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.cardName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.VisitorsReportHeaders.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "exitDate", "cardInfo", "description"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 9) {
                    //İçerideki Ziyaretçiler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.citizenshipNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.mobilePhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.where"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.reasonForVisit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.visitedEmployeeInformation"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.cardIssueTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.entryTime"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.cardName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InsideVisitorsReportHeader.description"));
                    keys = ["identityNo", "name", "mobilePhone", "toWho", "comingReason", "employeeInfo", "entryDate", "entryLogDate", "cardInfo", "description"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 10) {
                    //Süre Bazlı Çalışma Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.TimeBasedWorkReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.TimeBasedWorkReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.TimeBasedWorkReportHeaders.startDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.TimeBasedWorkReportHeaders.endDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.TimeBasedWorkReportHeaders.totalWorkedTime"));
                    keys = ["sicilNo", "adSoyad", "startDate", "endDate", "total"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 11) {
                    //İlk Giriş Son Çıkış Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.firstEntry"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.lastExit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.total"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.missingHour"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FirstInLastOutReportHeaders.status"));
                    keys = ["sicilNo", "adSoyad", "statu", "tarih", "ilkG", "sonC", "total", "fark", "durum"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 12) {
                    //İzinliler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.AllowenceReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.AllowenceReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.AllowenceReportHeaders.startDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.AllowenceReportHeaders.endDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.AllowenceReportHeaders.allowenceName"));
                    keys = ["sicilNo", "name", "startDate", "endDate", "allowenceName"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 13) {
                    //Çalışma Özeti Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.jobDays"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.workDays"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.publicHoliday"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.allowence"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.WorkSummaryReportHeaders.absentee"));
                    keys = ["sicilNo", "name", "planWorkDay", "workDay", "publicHolidayOrAdministrativeLeave", "allowenceUsed", "absentee"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 14) {
                    //Departman Bazlı Sayı Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.unitName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.report"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.missioned"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "annualPermit", "report", "administrativeLeave", "freePermission", "missioned", "nonComers", "todayComers"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                        _this28.reportDatas.sort(function (a, b) {
                          if (a.departmanAdi < b.departmanAdi) return -1;
                          if (a.departmanAdi > b.departmanAdi) return 0;
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 15) {
                    //Müdürlük Bazlı Sayı Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.unitName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.employeeCount"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.annualPermit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.report"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.administrativeLeave"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.freePermission"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.missioned"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.nonComers"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.CompanyEmployeesStatusReportHeaders.todayComers"));
                    keys = ["unitName", "employeesInDepartments", "annualPermit", "report", "administrativeLeave", "freePermission", "missioned", "nonComers", "todayComers"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 16) {
                    // Puantaj Raporu

                    keys = ["sicilNo", "name", "shortCode1", "shortCode2", "shortCode3", "shortCode4", "shortCode5", "shortCode6", "shortCode7", "shortCode8", "shortCode9", "shortCode10", "shortCode11", "shortCode12", "shortCode13", "shortCode14", "shortCode15", "shortCode16", "shortCode17", "shortCode18", "shortCode19", "shortCode20", "shortCode21", "shortCode22", "shortCode23", "shortCode24", "shortCode25", "shortCode26", "shortCode27", "shortCode28", "shortCode29", "shortCode30", "shortCode31"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 17) {
                    // Detaylı Puantaj Raporu

                    keys = ["sicilNo", "adSoyad", "realWorkDay", "d1", "d2", "d3", "d4", "d5", "d6", "d7", "d8", "d9", "d10", "d11", "d12", "d13", "d14", "d15", "d16", "d17", "d18", "d19", "d20", "d21", "d22", "d23", "d24", "d25", "d26", "d27", "d28", "d29", "d30", "d31"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 18) {
                    // Yemekhane Yüklemeler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.debit"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.creditType"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodCreditReportHeaders.userName"));
                    keys = ["sicilNo", "name", "date", "credit", "creditType", "userName"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        var veriler2 = [];
                        item.veriler.forEach(function (veri) {
                          var type = "";
                          if (veri.creditType == 2) {
                            type = _this28.$ml.get("general.balance");
                          } else if (veri.creditType == 1) {
                            type = _this28.$ml.get("general.credit");
                          }
                          veriler2.push({
                            sicilNo: veri.sicilNo,
                            name: veri.name,
                            date: veri.date,
                            credit: veri.credit,
                            creditType: type,
                            userName: veri.userName
                          });
                        });
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: veriler2
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 25) {
                    // Yemekhane İcmal Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodSummaryReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodSummaryReportHeaders.total"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.FoodSummaryReportHeaders.debit"));
                    keys = ["name", "count", "price"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 19) {
                    // Giriş Çıkış Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.InOutReportHeaders.readerName"));
                    keys = ["sicilNo", "name", "title", "departmentName", "date", "reader"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 20) {
                    // Kapı Bazlı Son Hareket Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.date"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.readerName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorBasedLastMovementReportHeaders.doorStatus"));
                    keys = ["sicilNo", "name", "title", "departmentName", "date", "reader", "doorStatus"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 21) {
                    // Kapı Bazlı Yetki Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.title"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DoorsAuthorizationReportHeaders.accessGroup"));
                    keys = ["sicilNo", "name", "title", "departmentName", "accessGroup"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 22) {
                    // Yurtta Kalanlar Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.isSmsSend"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.motherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.fatherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.smsPhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.validityDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.areaName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.floorName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInformationReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 23) {
                    // Yurt İçerideki Öğrenciler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.lastMovementDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.lastMovementReader"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.status"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.isSmsSend"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.motherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.fatherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.smsPhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.validityDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.areaName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.floorName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryInsidesReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "exitDate", "exitPoint", "status", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else if (_this28.selectedReportIndex == 24) {
                    // Yurt Dışarıdaki Öğrenciler Raporu
                    _this28.reportHeaders = [];
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.registrationNumber"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.nameSurname"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.departmentName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.lastMovementDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.lastMovementReader"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.status"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.isSmsSend"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.motherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.fatherName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.smsPhone"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.validityDate"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.areaName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.floorName"));
                    _this28.reportHeaders.push(_this28.$ml.get("reports.reports.DormitoryOutsidesReportHeaders.roomName"));
                    keys = ["sicilNo", "name", "departmentName", "exitDate", "exitPoint", "status", "isSmsSend", "motherName", "fatherName", "smsPhone", "validityDate", "areaName", "floorName", "roomName"];

                    _this28.reportDatas = [];
                    _this28.reportResult.forEach(function (item) {
                      if (item.veriler.length > 0) {
                        _this28.reportDatas.push({
                          departmanAdi: item.departmanAdi,
                          keys: keys,
                          veriler: item.veriler
                        });
                      }
                    });
                  } else {
                    alertify.warning(_this28.$ml.get("reports.selectedReportIsUnavailable"));
                  }
                } else {
                  _this28.reportHeaders = null;
                  _this28.reportDatas = null;
                }

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this28);
      }))();
    },
    getReportDetails: function getReportDetails() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var empIds, reportEndPoint, startDate, endDate, devices, allowenceIds, visitorGroupIds, reportOption, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (!(_this29.selectedReportIndex == 0)) {
                  _context23.next = 3;
                  break;
                }

                alertify.warning(_this29.$ml.get("alerts.selectedReportNotBlank"));
                return _context23.abrupt("return");

              case 3:
                if (!(_this29.startDate == null || _this29.endDate == null || _this29.startDate > _this29.endDate)) {
                  _context23.next = 6;
                  break;
                }

                alertify.warning(_this29.$ml.get("alerts.invalidDate"));
                return _context23.abrupt("return");

              case 6:
                _context23.prev = 6;

                _this29.activeScreen = 3;
                _this29.isLoading = true;
                _context23.next = 11;
                return _this29.getSelectedEmployeeList();

              case 11:
                empIds = _context23.sent;
                reportEndPoint = _this29.selectedReportEndPoint;
                startDate = _this29.startDate;
                endDate = _this29.endDate;
                _context23.next = 17;
                return _this29.getCheckReaders();

              case 17:
                devices = _this29.selectedDevices;
                allowenceIds = [];
                visitorGroupIds = [];
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  deviceIds: devices
                };

                if (_this29.selectedReportIndex == 6 || _this29.selectedReportIndex == 7) {
                  reportOption = {
                    empIds: empIds,
                    deviceIds: devices
                  };
                }

                if (!(_this29.selectedReportIndex == 8)) {
                  _context23.next = 27;
                  break;
                }

                _context23.next = 25;
                return _this29.getCheckVisitorGroups();

              case 25:
                visitorGroupIds = _this29.selectedVisitorGroups;
                reportOption = {
                  startDate: startDate,
                  endDate: endDate,
                  visitorGroupIds: visitorGroupIds
                };

              case 27:
                if (_this29.selectedReportIndex == 9) {
                  reportOption = {
                    startDate: startDate,
                    endDate: endDate
                  };
                }
                if (_this29.selectedReportIndex == 10) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    time: _this29.reportOptions.time,
                    isUpperFromTime: _this29.reportOptions.isUpperFromTime,
                    showNonComers: _this29.reportOptions.showNonComers
                  };
                }
                if (_this29.selectedReportIndex == 11) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    showAllowed: _this29.reportOptions.showAllowed,
                    showNonComers: _this29.reportOptions.showNonComers,
                    deviceIds: devices
                  };
                }

                if (!(_this29.selectedReportIndex == 12)) {
                  _context23.next = 35;
                  break;
                }

                _context23.next = 33;
                return _this29.getCheckAllowences();

              case 33:
                allowenceIds = _this29.selectedAllowences;
                reportOption = {
                  empIds: empIds,
                  startDate: startDate,
                  endDate: endDate,
                  allowenceIds: allowenceIds
                };

              case 35:
                if (_this29.selectedReportIndex == 13 || _this29.selectedReportIndex == 16 || _this29.selectedReportIndex == 17 || _this29.selectedReportIndex == 18) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate
                  };
                }
                if (_this29.selectedReportIndex == 20 || _this29.selectedReportIndex == 21) {
                  reportOption = {
                    empIds: empIds,
                    deviceIds: devices
                  };
                }
                if (_this29.selectedReportIndex == 22 || _this29.selectedReportIndex == 23 || _this29.selectedReportIndex == 24) {
                  reportOption = {
                    empIds: empIds
                  };
                }

                if (!(_this29.selectedReportIndex == 14 || _this29.selectedReportIndex == 15)) {
                  _context23.next = 42;
                  break;
                }

                _context23.next = 41;
                return _this29.getCheckDepartmentList();

              case 41:
                reportOption = {
                  empIds: _this29.filters.departments,
                  startDate: startDate
                };

              case 42:
                if (!(_this29.selectedReportIndex == 25)) {
                  _context23.next = 46;
                  break;
                }

                _context23.next = 45;
                return _this29.getCheckDepartmentList();

              case 45:
                reportOption = {
                  empIds: _this29.filters.departments,
                  startDate: startDate,
                  endDate: endDate
                };

              case 46:
                if (_this29.selectedReportIndex == 1) {
                  reportOption = {
                    empIds: empIds,
                    startDate: startDate,
                    endDate: endDate,
                    deviceIds: devices,
                    showAllowed: _this29.reportOptions.showAllowed,
                    showLateComers: _this29.reportOptions.showLateComers
                  };
                }
                _context23.next = 49;
                return _this29.$axios.post("/Reports/" + reportEndPoint, reportOption).then(function (response) {
                  _this29.reportResult = response.data.datas;
                  if (_this29.selectedReportIndex == 16 || _this29.selectedReportIndex == 17) {
                    _this29.reportHeaders = response.data.headers;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this29.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this29.isLoading = false;
                      return;
                    }
                  }
                });

              case 49:
                response = _context23.sent;
                _context23.next = 52;
                return _this29.reportSetting();

              case 52:
                _this29.reportName = _this29.selectedReportName + " (" + _this29.toDateFormat(_this29.startDate, "gg.aa.yyyy ss:dd") + " - " + _this29.toDateFormat(_this29.endDate, "gg.aa.yyyy ss:dd") + ")";
                if (_this29.selectedReportIndex == 14) {
                  _this29.reportName = _this29.selectedReportName + " (" + _this29.toDateFormat(_this29.startDate, "gg.aa.yyyy") + ")";
                }
                _this29.isLoading = false;
                _context23.next = 62;
                break;

              case 57:
                _context23.prev = 57;
                _context23.t0 = _context23["catch"](6);

                console.error(_context23.t0);
                alertify.error("Servis Hatası :" + _context23.t0.message);
                _this29.isLoading = false;

              case 62:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this29, [[6, 57]]);
      }))();
    },
    getEmployees: function getEmployees() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var employees, filters2, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;

                _this30.isLoadingEmployee = true;
                _context24.next = 4;
                return _this30.getCheckDepartmentList();

              case 4:
                employees = [];
                filters2 = _this30.filters;
                _context24.next = 8;
                return _this30.$axios.post("/Employees/getByFilter", {
                  nameOrCardNumber: filters2.nameOrCardNumber,
                  sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                  departments: filters2.departments,
                  accessGroup: filters2.accessGroup,
                  identityNo: filters2.identityNo,
                  documentNoOrMail: filters2.documentNoOrMail,
                  foodGroup: filters2.foodGroup,
                  workGroupId: filters2.workGroupId,
                  title: filters2.title,
                  stateId: filters2.stateId,
                  statuId: filters2.statuId,
                  plateNo: filters2.plateNo,
                  extraField1key: filters2.extraField1key,
                  extraField1value: filters2.extraField1value,
                  extraField2key: filters2.extraField2key,
                  extraField2value: filters2.extraField2value,
                  extraField3key: filters2.extraField3key,
                  extraField3value: filters2.extraField3value,
                  extraField4key: filters2.extraField4key,
                  extraField4value: filters2.extraField4value,
                  isVisitor: filters2.isVisitor,
                  isActive: filters2.isActive
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    employees.push({
                      id: doc.id,
                      name: doc.name,
                      sicilNo: doc.sicilNo,
                      title: doc.title,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context24.sent;

                _this30.employees = employees;
                _this30.isLoadingEmployee = false;
                _context24.next = 18;
                break;

              case 13:
                _context24.prev = 13;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error("Servis Hatası :" + _context24.t0.message);
                _this30.isLoadingEmployee = false;

              case 18:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this30, [[0, 13]]);
      }))();
    },
    checkAllReaders: function checkAllReaders() {
      var _this31 = this;

      this.isCheckReaders = !this.isCheckReaders;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this31.isCheckReaders) {
          doc.check = _this31.isCheckReaders;
        }
      });
    },
    getCheckReaders: function getCheckReaders() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _this32.selectedDevices = [];
                _context25.next = 3;
                return _this32.readers.forEach(function (doc) {
                  if (doc.check == true) {
                    _this32.selectedDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this32);
      }))();
    },
    getReaders: function getReaders() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                readers = [];
                _context26.next = 4;
                return _this33.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      var isCheckNew = true;
                      if (doc.doorType != 1) {
                        isCheckNew == false;
                      }
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: isCheckNew
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this33.readers = readers;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Servis Hatası : " + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this33, [[0, 8]]);
      }))();
    },
    checkAllAllowence: function checkAllAllowence() {
      var _this34 = this;

      this.isCheckAllowences = !this.isCheckAllowences;
      var aList = this.allowences;
      aList.forEach(function (doc) {
        if (doc.check == !_this34.isCheckAllowences) {
          doc.check = _this34.isCheckAllowences;
        }
      });
    },
    getCheckAllowences: function getCheckAllowences() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this35.selectedAllowences = [];
                _context27.next = 3;
                return _this35.allowences.forEach(function (doc) {
                  if (doc.check == true) {
                    _this35.selectedAllowences.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this35);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;

                _this36.isLoading = true;
                allowences = [];
                _context28.next = 5;
                return _this36.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b,
                      check: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context28.sent;

                _this36.allowences = allowences;
                _this36.isLoading = false;
                _context28.next = 15;
                break;

              case 10:
                _context28.prev = 10;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);
                _this36.isLoading = false;

              case 15:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this36, [[0, 10]]);
      }))();
    },
    checkAllVisitorGroups: function checkAllVisitorGroups() {
      var _this37 = this;

      this.isCheckVG = !this.isCheckVG;
      var aList = this.visitorGroups;
      aList.forEach(function (doc) {
        if (doc.check == !_this37.isCheckVG) {
          doc.check = _this37.isCheckVG;
        }
      });
    },
    getCheckVisitorGroups: function getCheckVisitorGroups() {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _this38.selectedVisitorGroups = [];
                _context29.next = 3;
                return _this38.visitorGroups.forEach(function (doc) {
                  if (doc.check == true) {
                    _this38.selectedVisitorGroups.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this38);
      }))();
    },
    getVisitorCardGroups: function getVisitorCardGroups() {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var visitorGroups, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                visitorGroups = [];
                _context30.next = 4;
                return _this39.$axios.get("/Visitors/GetVisitorsCardGroup").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      visitorGroups.push({
                        id: doc.id,
                        name: doc.name,
                        devices: doc.devices,
                        check: true
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this39.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this39.$ml.get("errors.connectionError"));
                      _this39.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this39.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this39.visitorGroups = visitorGroups;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Hata :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this39, [[0, 8]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this40 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this40.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.workGroupList.forEach(function (doc) {
        _this40.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this40.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this40.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this40.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this40.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getAuthControl: function getAuthControl() {
      var _this41 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                if (_this41.authControl == 1) {
                  alertify.warning(_this41.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                }

              case 1:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this41);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this42 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
      var filter;
      return regeneratorRuntime.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              _context32.next = 2;
              return _this42.getAuthControl();

            case 2:
              _context32.next = 4;
              return _this42.getDefaultDate();

            case 4:
              _context32.next = 6;
              return _this42.getDepartments();

            case 6:
              _context32.next = 8;
              return _this42.getAccessGroups();

            case 8:
              _context32.next = 10;
              return _this42.getActiveReports();

            case 10:
              _context32.next = 12;
              return _this42.getFoodGroups();

            case 12:
              _context32.next = 14;
              return _this42.getStatus();

            case 14:
              _context32.next = 16;
              return _this42.getStates();

            case 16:
              _context32.next = 18;
              return _this42.getTitles();

            case 18:
              _context32.next = 20;
              return _this42.getWorkGroups();

            case 20:
              _context32.next = 22;
              return _this42.getExtraFields();

            case 22:
              _context32.next = 24;
              return _this42.getReaders();

            case 24:
              _context32.next = 26;
              return _this42.getVisitorCardGroups();

            case 26:
              _context32.next = 28;
              return _this42.getAllowences();

            case 28:
              if (!_this42.defaultFilters) {
                _context32.next = 35;
                break;
              }

              filter = _this42.defaultFilters;

              _this42.setUserAuthorityFilter(filter);
              _context32.next = 33;
              return _this42.getEmployees();

            case 33:
              _context32.next = 37;
              break;

            case 35:
              _context32.next = 37;
              return _this42.getEmployees();

            case 37:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, _this42);
    }))();
  }
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingReport: false,
      windowHeight: window.innerHeight,
      activeScreen: 0,
      sales: [],
      selectedSale: {
        id: null,
        date: "",
        price: 0
      },
      employee: {
        id: null,
        sicilNo: "",
        name: "",
        title: "",
        department: "",
        image: null,
        credit: 0,
        cardNumber: ""
      },
      total: 0,
      cardNumber: "",
      startDate: null,
      endDate: null,
      reportName: "",
      /*reportData: {
        total,
        data: [{ date: 11, price: 0 }]
      },*/
      reportDatas: [],
      reportDataTotal: 0
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    activeUser: function activeUser() {
      return this.$store.getters.getUser;
    },
    saleList: function saleList() {
      return this.sales;
    },
    reportDataList: function reportDataList() {
      return this.reportDatas;
    },
    windowReportHeightSize: function windowReportHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 180;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    exportToExcel: function exportToExcel() {
      var tarih = new Date();
      var filename = this.reportTitle + " - " + tarih.toLocaleString();
      $("#printExcel").table2excel({
        filename: filename + ".xls",
        preserveColors: true
      });
    },
    clearEmployee: function clearEmployee() {
      this.employee.id = null;
      this.employee.sicilNo = "";
      this.employee.name = "";
      this.employee.title = "";
      this.employee.department = "";
      this.employee.image = null;
      this.employee.credit = 0;
      this.employee.cardNumber = "";
      this.cardNumber = "";
    },
    searchEmployee: function searchEmployee() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var cardNo, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.cardNumber.length == 10)) {
                  _context.next = 16;
                  break;
                }

                _context.prev = 1;

                _this2.isLoading = true;
                cardNo = _this2.cardNumber;
                _context.next = 6;
                return _this2.$axios.get("/Sale/GetEmployeeByCardNumber?cardNumber=" + _this2.cardNumber).then(function (response) {
                  _this2.employee = response.data;
                  _this2.employee.cardNumber = cardNo;
                  _this2.cardNumber = "";
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    } else if (error.response.status == 404) {
                      alertify.error("Kişi Bulunamadı");
                      _this2.clearEmployee();
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.clearEmployee();
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.clearEmployee();
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context.sent;
                _context.next = 9;
                return _this2.getSales();

              case 9:
                _this2.isLoading = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);

                console.error(_context.t0);
                alertify.error(_context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 12]]);
      }))();
    },
    question: function question() {
      if (this.employee.id == null) {
        alertify.warning(this.$ml.get("alerts.noContactInformation"));
        return;
      }
      if (this.total == null || this.total == 0) {
        alertify.warning(this.$ml.get("alerts.pleaseEnterAmount"));
        return;
      }
      var credit = parseFloat(this.employee.credit);
      var total = parseFloat(this.total);
      if (credit < total) {
        alertify.warning(this.$ml.get("alerts.insufficientBalance"));
        return;
      }
      $("#question").modal("show");
    },
    setCardFocus: function setCardFocus() {
      $("#searchCardNumber").focus();
    },
    setPayment: function setPayment() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var credit, total, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (!(_this3.employee.id == null)) {
                  _context2.next = 4;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.noContactInformation"));
                return _context2.abrupt("return");

              case 4:
                if (!(_this3.total == null || _this3.total == 0)) {
                  _context2.next = 7;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.pleaseEnterAmount"));
                return _context2.abrupt("return");

              case 7:
                credit = parseFloat(_this3.employee.credit);
                total = parseFloat(_this3.total);

                if (!(credit < total)) {
                  _context2.next = 12;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.insufficientBalance"));
                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return _this3.$axios.post("/Sale", {
                  employeeId: _this3.employee.id,
                  price: _this3.total
                }).then(function (response) {
                  if (response.status == 200) {
                    $("#question").modal("hide");
                    alertify.success("İşlem Başarılı!");
                    _this3.clearEmployee();
                    _this3.total = 0;
                    _this3.isLoading = false;
                    _this3.setCardFocus();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 14:
                response = _context2.sent;
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası : " + _context2.t0.message);

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 17]]);
      }))();
    },
    setPaymentReset: function setPaymentReset() {
      this.total = 0;
    },
    clearPaymentNumber: function clearPaymentNumber() {
      var num = String(this.total);
      var aa = num.slice(0, -1);
      if (aa == "") {
        this.total = 0;
      } else if (aa.substr(aa.length - 1, 1) == "," || aa.substr(aa.length - 1, 1) == ".") {
        this.total = aa.slice(0, -1);
      } else {
        this.total = aa;
      }
    },
    setPaymentNumber: function setPaymentNumber(number) {
      var index = String(this.total).indexOf(".0");
      var num = "";
      if (this.total == 0) {
        num = String(number);
      } else if (index != -1) {
        num = String(this.total).substr(0, this.total.length - 1) + String(number);
      } else {
        num = String(this.total) + String(number);
      }
      this.total = num;
      $("#totalPrice").focus();
    },
    getReport: function getReport() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.startDate == null || _this4.endDate == null || _this4.startDate > _this4.endDate)) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.invalidDate"));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                _this4.isLoadingReport = true;
                _this4.reportDatas = [];
                _context3.next = 8;
                return _this4.$axios.post("/Sale/Report", {
                  startDate: _this4.startDate,
                  endDate: _this4.endDate
                }).then(function (response) {
                  _this4.reportDatas = response.data.data;
                  _this4.reportDataTotal = response.data.total;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingReport = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingReport = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context3.sent;

                _this4.reportName = _this4.activeUser.userName + " - Bakiye İcmal Raporu" + " (" + _this4.toDateFormat(_this4.startDate, "gg.aa.yyyy ss:dd") + " - " + _this4.toDateFormat(_this4.endDate, "gg.aa.yyyy ss:dd") + ")";
                _this4.isLoadingReport = false;
                _context3.next = 18;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);
                _this4.isLoadingReport = false;

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 13]]);
      }))();
    },
    refund: function refund(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (id) {
                  _context4.next = 4;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseSelect"));
                _context4.next = 21;
                break;

              case 4:
                _this5.isLoadingReader = true;
                _context4.prev = 5;
                _context4.next = 8;
                return _this5.$axios.delete("/Sale/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context4.sent;

                $("#refund-confirm-modal").modal("hide");
                _this5.cardNumber = _this5.employee.cardNumber;
                _context4.next = 13;
                return _this5.searchEmployee();

              case 13:
                alertify.success(_this5.$ml.get("alerts.deletedSuccessfully"));
                _this5.isLoadingReader = false;
                _context4.next = 21;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4["catch"](5);

                alertify.error("Hata Oluştu : " + _context4.t0);
                _this5.isLoadingReader = false;

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[5, 17]]);
      }))();
    },
    selectSale: function selectSale(sale) {
      this.selectedSale = sale;
      $("#refund-confirm-modal").modal("show");
    },
    getSales: function getSales() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var sales, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this6.employee.id == null)) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning(_this6.$ml.get("alerts.noContactInformation"));
                return _context5.abrupt("return");

              case 3:
                _context5.prev = 3;

                _this6.isLoading = true;
                sales = [];
                _context5.next = 8;
                return _this6.$axios.get("/Sale/GetSalesByCardNumber?cardNumber=" + _this6.employee.cardNumber).then(function (response) {
                  sales = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    } else if (error.response.status == 404) {
                      alertify.error("Kişi Bulunamadı");
                      _this6.clearEmployee();
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.clearEmployee();
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.clearEmployee();
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context5.sent;

                _this6.sales = sales;
                _this6.isLoading = false;
                _context5.next = 17;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5["catch"](3);

                console.error(_context5.t0);
                alertify.error(_context5.t0);

              case 17:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 13]]);
      }))();
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.getDefaultDate();

            case 2:
              $("body").addClass("sidebar-collapse");

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: true,
      isLoadingDetail: true,
      isLoadingEmployee: false,
      isLoadingUsesEmployees: false,
      isNewArea: true,
      isNewFloor: true,
      isNewRoom: true,
      isNewRoomType: true,
      selectedArea: {
        id: null,
        name: "",
        floors: []
      },
      selectedFloor: {
        id: null,
        name: "",
        areaId: null,
        orderNo: 1,
        rooms: []
      },
      selectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      selectedRoomType: {
        id: null,
        name: ""
      },
      viewSelectedArea: {
        id: null,
        name: "",
        floors: []
      },
      viewSelectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      areas: [],
      floors: [],
      rooms: [],
      roomTypes: [],
      employees: [],
      selectedEmployees: [],
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      }
    };
  },

  computed: {
    areaList: function areaList() {
      return this.areas;
    },
    floorList: function floorList() {
      return this.floors;
    },
    roomTypeList: function roomTypeList() {
      return this.roomTypes;
    },
    selectedFloorList: function selectedFloorList() {
      return this.selectedArea.floors.sort(function (a, b) {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    selectedViewFloorList: function selectedViewFloorList() {
      return this.viewSelectedArea.floors.sort(function (a, b) {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    checkedEmployeeCount: function checkedEmployeeCount() {
      var employees = this.allEmployeeFilteredList.filter(function (a) {
        return a.isCheck == true;
      });
      if (employees[0]) {
        return employees.length;
      } else {
        return 0;
      }
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this = this;

      return this.employees.filter(function (item) {
        return item.roomId == null || item.roomId == _this.viewSelectedRoom.id;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 240;
        return "height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowEmployeesHeightSize: function windowEmployeesHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 280;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    customColor2: function customColor2() {
      if (this.viewSelectedRoom.capacity <= this.viewSelectedRoom.usesCount) {
        return "detail-box bg-red text-center";
      } else if (this.viewSelectedRoom.usesCount > 0 && this.viewSelectedRoom.usesCount < this.viewSelectedRoom.capacity) {
        return "detail-box bg-blue text-center";
      } else if (this.viewSelectedRoom.usesCount == 0) {
        return "detail-box bg-green text-center";
      } else {
        return "detail-box bg-warning text-center";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: (_methods = {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    roomDetail: function roomDetail(room) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.employees = [];
                _this3.viewSelectedRoom.id = room.id;
                _this3.viewSelectedRoom.name = room.name;
                _this3.viewSelectedRoom.capacity = room.capacity;
                _this3.viewSelectedRoom.orderNo = room.orderNo;
                _this3.viewSelectedRoom.usesEmployees = room.usesEmployees;
                _this3.viewSelectedRoom.floorId = room.floorId;
                _this3.viewSelectedRoom.areaId = room.areaId;
                _this3.viewSelectedRoom.roomTypeId = room.roomTypeId;
                _this3.viewSelectedRoom.usesCount = room.usesCount;
                $("#modal-room-detail").modal("show");
                _context.next = 13;
                return _this3.getUsesByRoomId(room.id);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    editRoom: function editRoom() {
      if (this.viewSelectedRoom.id) {
        this.selectRoom(this.viewSelectedRoom.id);
        $("#room-modal").modal("show");
      }
    },
    newRoomType: function newRoomType() {
      this.isNewRoomType = true;
      this.selectedRoomType.id = null;
      this.selectedRoomType.name = "";
    },
    selectRoomType: function selectRoomType(id, name) {
      this.isNewRoomType = false;
      this.selectedRoomType.id = id;
      this.selectedRoomType.name = name;
    },
    getRoomTypeName: function getRoomTypeName(id) {
      var roomType = this.roomTypeList.filter(function (a) {
        return a.id == id;
      });
      if (roomType[0]) {
        return roomType[0].name;
      } else {
        return "-";
      }
    },
    deleteRoomType: function deleteRoomType(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 4;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.selectedMealNotBlank"));
                _context2.next = 21;
                break;

              case 4:
                _context2.prev = 4;

                _this4.isLoadingDetail = true;
                _context2.next = 8;
                return _this4.$axios.delete("/RoomType/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context2.sent;
                _context2.next = 11;
                return _this4.newRoomType();

              case 11:
                _context2.next = 13;
                return _this4.getRoomTypes();

              case 13:
                alertify.success(_this4.$ml.get("alerts.deletedSuccessfully"));
                _this4.isLoadingDetail = false;
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](4);

                alertify.error("Hata Oluştu : " + _context2.t0);
                _this4.isLoadingDetail = false;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[4, 17]]);
      }))();
    },
    saveRoomType: function saveRoomType() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, id, _response;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this5.isNewRoomType) {
                  _context3.next = 29;
                  break;
                }

                if (!(_this5.selectedRoomType.name == "")) {
                  _context3.next = 4;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context3.abrupt("return");

              case 4:
                _this5.isLoadingDetail = true;
                _context3.prev = 5;
                _context3.next = 8;
                return _this5.$axios.post("/RoomType", {
                  name: _this5.selectedRoomType.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context3.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 13;
                return _this5.newRoomType();

              case 13:
                _context3.next = 15;
                return _this5.getRoomTypes();

              case 15:
                alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                _context3.next = 19;
                break;

              case 18:
                alertify.error(response.message);

              case 19:
                _this5.isLoadingDetail = false;
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](5);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this5.isLoadingDetail = false;

              case 27:
                _context3.next = 50;
                break;

              case 29:
                _context3.prev = 29;
                _context3.next = 32;
                return _this5.$axios.post("/RoomType/" + _this5.selectedRoomType.id, {
                  name: _this5.selectedRoomType.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context3.sent;

                if (!(_response.status == 200)) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 36;
                return _this5.newRoomType();

              case 36:
                _context3.next = 38;
                return _this5.getRoomTypes();

              case 38:
                alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                _context3.next = 42;
                break;

              case 41:
                alertify.error(_response.message);

              case 42:
                _this5.isLoadingDetail = false;
                _context3.next = 50;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t1 = _context3["catch"](29);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this5.isLoadingDetail = false;

              case 50:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 22], [29, 45]]);
      }))();
    },
    viewSelectArea: function viewSelectArea($event) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var id;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = event.target.value;

                if (!id) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return _this6.getFloorsByAreaId(id);

              case 4:
                _context4.next = 6;
                return _this6.viewRefreshArea(id);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _this6.viewSelectedArea.id = null;
                _this6.viewSelectedArea.name = "";
                _this6.viewSelectedArea.floors = [];

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    viewRefreshArea: function viewRefreshArea(id) {
      this.viewSelectedArea.id = id;
      var area = this.areaList.filter(function (a) {
        return a.id == id;
      });
      if (area[0]) {
        this.viewSelectedArea.name = area[0].name;
        this.viewSelectedArea.floors = [];
        this.viewSelectedArea.floors = this.floorList.filter(function (a) {
          return a.areaId == id;
        });
      } else {
        this.viewSelectedArea.id = null;
        this.viewSelectedArea.name = "";
        this.viewSelectedArea.floors = [];
      }
    },
    newEmployees: function newEmployees() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this7.viewSelectedRoom.capacity == _this7.viewSelectedRoom.usesCount)) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning("Odada yeterli boş alan mevcut değil...");
                return _context5.abrupt("return");

              case 3:
                _context5.next = 5;
                return _this7.allEmployeeFilteredList.forEach(function (a) {
                  if (a.isCheck == true) {
                    a.isCheck = false;
                    a.isAtRoom = false;
                  }
                  var result = _this7.viewSelectedRoom.usesEmployees.filter(function (b) {
                    return b.id == a.id;
                  });
                  if (result[0]) {
                    a.isCheck = true;
                    a.isAtRoom = true;
                  }
                });

              case 5:
                _context5.next = 7;
                return $("#employees-modal").modal("show");

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    addEmployee: function addEmployee() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var employees, ids, response, id, floor, room;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                employees = _this8.allEmployeeFilteredList.filter(function (a) {
                  return a.isCheck == true && a.isAtRoom == false;
                });
                ids = [];

                if (!employees[0]) {
                  _context6.next = 52;
                  break;
                }

                employees.forEach(function (b) {
                  ids.push(b.id);
                });
                _context6.prev = 4;
                _context6.next = 7;
                return _this8.$axios.post("/AreaDefinition/SetEmployeesToRoom", {
                  ids: ids,
                  roomId: _this8.viewSelectedRoom.id
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context6.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context6.next = 43;
                  break;
                }

                _context6.next = 12;
                return $("#employees-modal").modal("hide");

              case 12:
                _context6.next = 14;
                return _this8.getUsesByRoomId(_this8.viewSelectedRoom.id);

              case 14:
                _this8.viewSelectedRoom.usesCount = _this8.viewSelectedRoom.usesEmployees.length;
                floor = _this8.floorList.filter(function (a) {
                  return a.id == _this8.viewSelectedRoom.floorId;
                });

                if (!floor[0]) {
                  _context6.next = 32;
                  break;
                }

                room = floor[0].rooms.filter(function (b) {
                  return b.id == _this8.viewSelectedRoom.id;
                });

                if (!room[0]) {
                  _context6.next = 22;
                  break;
                }

                room[0].usesCount = _this8.viewSelectedRoom.usesEmployees.length;
                _context6.next = 30;
                break;

              case 22:
                _context6.next = 24;
                return $("#modal-room-detail").modal("hide");

              case 24:
                _context6.next = 26;
                return _this8.getFloorsByAreaId(_this8.viewSelectedArea.id);

              case 26:
                _context6.next = 28;
                return _this8.viewRefreshArea(_this8.viewSelectedArea.id);

              case 28:
                _context6.next = 30;
                return _this8.scrollToAnchor(_this8.viewSelectedRoom.id);

              case 30:
                _context6.next = 40;
                break;

              case 32:
                _context6.next = 34;
                return $("#modal-room-detail").modal("hide");

              case 34:
                _context6.next = 36;
                return _this8.getFloorsByAreaId(_this8.viewSelectedArea.id);

              case 36:
                _context6.next = 38;
                return _this8.viewRefreshArea(_this8.viewSelectedArea.id);

              case 38:
                _context6.next = 40;
                return _this8.scrollToAnchor(_this8.viewSelectedRoom.id);

              case 40:
                alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                _context6.next = 44;
                break;

              case 43:
                alertify.error(response.message);

              case 44:
                _this8.isLoadingDetail = false;
                _context6.next = 52;
                break;

              case 47:
                _context6.prev = 47;
                _context6.t0 = _context6["catch"](4);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this8.isLoadingDetail = false;

              case 52:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[4, 47]]);
      }))();
    },
    removeEmployee: function removeEmployee(emp, index) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, id, floor, room;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this9.$axios.post("/AreaDefinition/RemoveEmployeesToRoom?employeeId=" + emp.id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context7.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context7.next = 36;
                  break;
                }

                _this9.viewSelectedRoom.usesEmployees.splice(index, 1);
                _this9.viewSelectedRoom.usesCount = _this9.viewSelectedRoom.usesEmployees.length;
                floor = _this9.floorList.filter(function (a) {
                  return a.id == _this9.viewSelectedRoom.floorId;
                });

                if (!floor[0]) {
                  _context7.next = 25;
                  break;
                }

                room = floor[0].rooms.filter(function (b) {
                  return b.id == _this9.viewSelectedRoom.id;
                });

                if (!room[0]) {
                  _context7.next = 15;
                  break;
                }

                room[0].usesCount = _this9.viewSelectedRoom.usesEmployees.length;
                _context7.next = 23;
                break;

              case 15:
                _context7.next = 17;
                return $("#modal-room-detail").modal("hide");

              case 17:
                _context7.next = 19;
                return _this9.getFloorsByAreaId(_this9.viewSelectedArea.id);

              case 19:
                _context7.next = 21;
                return _this9.viewRefreshArea(_this9.viewSelectedArea.id);

              case 21:
                _context7.next = 23;
                return _this9.scrollToAnchor(_this9.viewSelectedRoom.id);

              case 23:
                _context7.next = 33;
                break;

              case 25:
                _context7.next = 27;
                return $("#modal-room-detail").modal("hide");

              case 27:
                _context7.next = 29;
                return _this9.getFloorsByAreaId(_this9.viewSelectedArea.id);

              case 29:
                _context7.next = 31;
                return _this9.viewRefreshArea(_this9.viewSelectedArea.id);

              case 31:
                _context7.next = 33;
                return _this9.scrollToAnchor(_this9.viewSelectedRoom.id);

              case 33:
                alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                _context7.next = 37;
                break;

              case 36:
                alertify.error(response.message);

              case 37:
                _this9.isLoadingDetail = false;
                _context7.next = 45;
                break;

              case 40:
                _context7.prev = 40;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this9.isLoadingDetail = false;

              case 45:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 40]]);
      }))();
    },
    customColor: function customColor(room) {
      if (room) {
        if (room.capacity <= room.usesCount) {
          return "info-box-icon bg-red box-w-70";
        } else if (room.usesCount > 0 && room.usesCount < room.capacity) {
          return "info-box-icon bg-blue box-w-70";
        } else if (room.usesCount == 0) {
          return "info-box-icon bg-green box-w-70";
        } else {
          return "info-box-icon bg-warning box-w-70";
        }
      } else {
        return "info-box-icon box-w-70";
      }
    },
    changeRoomType: function changeRoomType(event) {
      this.viewSelectedRoom.roomTypeId = event.target.value;
    },
    clearRoom: function clearRoom() {
      this.isNewRoom = true;
      this.viewSelectedRoom.id = null;
      this.viewSelectedRoom.name = "";
      this.viewSelectedRoom.capacity = 1;
      this.viewSelectedRoom.orderNo = 1;
      this.viewSelectedRoom.usesEmployees = [];
      this.viewSelectedRoom.floorId = null;
      this.viewSelectedRoom.areaId = null;
      this.viewSelectedRoom.roomTypeId = null;
      this.viewSelectedRoom.usesCount = 0;
    },
    newRoom: function newRoom(floorId, areaId) {
      this.clearRoom();
      this.viewSelectedRoom.floorId = floorId;
      this.viewSelectedRoom.areaId = areaId;
      $("#room-modal").modal("show");
    },
    selectRoom: function selectRoom(id) {
      this.isNewRoom = false;
      this.viewSelectedRoom.id = id;
      var room = this.rooms.filter(function (a) {
        return a.id == id;
      });
      if (room[0]) {
        this.viewSelectedRoom.name = room[0].name;
        this.viewSelectedRoom.capacity = room[0].capacity;
        this.viewSelectedRoom.orderNo = room[0].orderNo;
        this.viewSelectedRoom.usesEmployees = room[0].usesEmployees;
        this.viewSelectedRoom.floorId = room[0].floorId;
        this.viewSelectedRoom.areaId = room[0].areaId;
        this.viewSelectedRoom.roomTypeId = room[0].roomTypeId;
        this.viewSelectedRoom.usesCount = room[0].usesCount;
      }
    },
    saveRoom: function saveRoom() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, id, _response2;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this10.isNewRoom) {
                  _context8.next = 27;
                  break;
                }

                if (!(_this10.viewSelectedRoom.name == "")) {
                  _context8.next = 4;
                  break;
                }

                alertify.warning(_this10.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context8.abrupt("return");

              case 4:
                _this10.isLoadingDetail = true;
                _context8.prev = 5;
                _context8.next = 8;
                return _this10.$axios.post("/AreaDefinition", {
                  name: _this10.viewSelectedRoom.name,
                  type: 2,
                  floorId: _this10.viewSelectedRoom.floorId,
                  areaId: _this10.viewSelectedRoom.areaId,
                  capacity: _this10.viewSelectedRoom.capacity,
                  orderNo: _this10.viewSelectedRoom.orderNo,
                  roomTypeId: _this10.viewSelectedRoom.roomTypeId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context8.sent;
                id = response.data.id;

                if (response.status == 200) {
                  $("#room-modal").modal("hide");
                  alertify.success(_this10.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _context8.next = 13;
                return _this10.getFloorsByAreaId(_this10.viewSelectedArea.id);

              case 13:
                _context8.next = 15;
                return _this10.viewRefreshArea(_this10.viewSelectedArea.id);

              case 15:
                _context8.next = 17;
                return _this10.selectRoom(id);

              case 17:
                _this10.isLoadingDetail = false;
                _context8.next = 25;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8["catch"](5);

                console.error(_context8.t0);
                alertify.error(_context8.t0.message);
                _this10.isLoadingDetail = false;

              case 25:
                _context8.next = 46;
                break;

              case 27:
                _context8.prev = 27;
                _context8.next = 30;
                return _this10.$axios.post("/AreaDefinition/" + _this10.viewSelectedRoom.id, {
                  name: _this10.viewSelectedRoom.name,
                  type: 2,
                  floorId: _this10.viewSelectedRoom.floorId,
                  areaId: _this10.viewSelectedRoom.areaId,
                  capacity: _this10.viewSelectedRoom.capacity,
                  orderNo: _this10.viewSelectedRoom.orderNo,
                  roomTypeId: _this10.viewSelectedRoom.roomTypeId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 30:
                _response2 = _context8.sent;

                if (_response2.status == 200) {
                  $("#room-modal").modal("hide");
                  alertify.success(_this10.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response2.message);
                }
                _context8.next = 34;
                return _this10.getFloorsByAreaId(_this10.viewSelectedArea.id);

              case 34:
                _context8.next = 36;
                return _this10.viewRefreshArea(_this10.viewSelectedArea.id);

              case 36:
                _context8.next = 38;
                return _this10.selectRoom(_this10.viewSelectedRoom.id);

              case 38:
                _this10.isLoadingDetail = false;
                _context8.next = 46;
                break;

              case 41:
                _context8.prev = 41;
                _context8.t1 = _context8["catch"](27);

                console.error(_context8.t1);
                alertify.error(_context8.t1);
                _this10.isLoadingDetail = false;

              case 46:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[5, 20], [27, 41]]);
      }))();
    },
    newArea: function newArea() {
      this.isNewArea = true;
      this.selectedArea.id = null;
      this.selectedArea.name = "";
      this.selectedArea.floors = [];
      this.newFloor();
    },
    selectArea: function selectArea(id) {
      this.isNewArea = false;
      this.selectedArea.id = id;
      var area = this.areaList.filter(function (a) {
        return a.id == id;
      });
      if (area[0]) {
        this.selectedArea.name = area[0].name;
      }
      this.selectedArea.floors = [];
      this.selectedArea.floors = this.floorList.filter(function (a) {
        return a.areaId == id;
      });
      this.newFloor();
    },
    saveArea: function saveArea() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response, id, _response3;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this11.isNewArea) {
                  _context9.next = 23;
                  break;
                }

                if (!(_this11.selectedArea.name == "")) {
                  _context9.next = 4;
                  break;
                }

                alertify.warning(_this11.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context9.abrupt("return");

              case 4:
                _this11.isLoadingDetail = true;
                _context9.prev = 5;
                _context9.next = 8;
                return _this11.$axios.post("/AreaDefinition", {
                  name: _this11.selectedArea.name,
                  type: 0,
                  floorId: null,
                  areaId: null,
                  capacity: 0,
                  orderNo: 0,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context9.sent;
                id = response.data.id;

                if (response.status == 200) {
                  _this11.selectArea(id);
                  alertify.success(_this11.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this11.getAreas();
                _this11.isNewArea = false;
                _this11.isLoadingDetail = false;
                _context9.next = 21;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9["catch"](5);

                console.error(_context9.t0);
                alertify.error(_context9.t0.message);
                _this11.isLoadingDetail = false;

              case 21:
                _context9.next = 37;
                break;

              case 23:
                _context9.prev = 23;
                _context9.next = 26;
                return _this11.$axios.post("/AreaDefinition/" + _this11.selectedArea.id, {
                  name: _this11.selectedArea.name,
                  type: 0,
                  floorId: null,
                  areaId: null,
                  capacity: 0,
                  orderNo: 0,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 26:
                _response3 = _context9.sent;

                if (_response3.status == 200) {
                  _this11.selectArea(_this11.selectedArea.id);
                  alertify.success(_this11.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response3.message);
                }
                _this11.getAreas();
                _this11.isLoadingDetail = false;
                _context9.next = 37;
                break;

              case 32:
                _context9.prev = 32;
                _context9.t1 = _context9["catch"](23);

                console.error(_context9.t1);
                alertify.error(_context9.t1);
                _this11.isLoadingDetail = false;

              case 37:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[5, 16], [23, 32]]);
      }))();
    },
    newFloor: function newFloor() {
      this.isNewFloor = true;
      this.selectedFloor.id = null;
      this.selectedFloor.name = "";
      this.selectedFloor.orderNo = 1;
      this.selectedFloor.areaId = this.selectedArea.id;
    },
    selectFloor: function selectFloor(id) {
      this.isNewFloor = false;
      this.selectedFloor.id = id;
      var floor = this.floorList.filter(function (a) {
        return a.id == id;
      });
      if (floor[0]) {
        this.selectedFloor.name = floor[0].name;
        this.selectedFloor.orderNo = floor[0].orderNo;
        this.selectedFloor.areaId = floor[0].areaId;
      }
    },
    saveFloor: function saveFloor() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response, id, _response4;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this12.isNewFloor) {
                  _context10.next = 28;
                  break;
                }

                if (!(_this12.selectedFloor.name == "")) {
                  _context10.next = 4;
                  break;
                }

                alertify.warning(_this12.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context10.abrupt("return");

              case 4:
                _this12.isLoadingDetail = true;
                _context10.prev = 5;
                _context10.next = 8;
                return _this12.$axios.post("/AreaDefinition", {
                  name: _this12.selectedFloor.name,
                  type: 1,
                  floorId: null,
                  areaId: _this12.selectedArea.id,
                  capacity: 0,
                  orderNo: _this12.selectedFloor.orderNo,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context10.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context10.next = 16;
                  break;
                }

                _context10.next = 13;
                return _this12.getFloorsByAreaId(_this12.selectedArea.id);

              case 13:
                alertify.success(_this12.$ml.get("alerts.savedSuccessfully"));
                _context10.next = 17;
                break;

              case 16:
                alertify.error(response.message);

              case 17:
                _this12.isNewFloor = true;
                _this12.isLoadingDetail = false;
                _context10.next = 26;
                break;

              case 21:
                _context10.prev = 21;
                _context10.t0 = _context10["catch"](5);

                console.error(_context10.t0);
                alertify.error(_context10.t0.message);
                _this12.isLoadingDetail = false;

              case 26:
                _context10.next = 47;
                break;

              case 28:
                _context10.prev = 28;
                _context10.next = 31;
                return _this12.$axios.post("/AreaDefinition/" + _this12.selectedFloor.id, {
                  name: _this12.selectedFloor.name,
                  type: 1,
                  floorId: null,
                  areaId: _this12.selectedArea.id,
                  capacity: 0,
                  orderNo: _this12.selectedFloor.orderNo,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 31:
                _response4 = _context10.sent;

                if (!(_response4.status == 200)) {
                  _context10.next = 38;
                  break;
                }

                _context10.next = 35;
                return _this12.getFloorsByAreaId(_this12.selectedArea.id);

              case 35:
                alertify.success(_this12.$ml.get("alerts.updatedSuccessfully"));
                _context10.next = 39;
                break;

              case 38:
                alertify.error(_response4.message);

              case 39:
                _this12.isLoadingDetail = false;
                _context10.next = 47;
                break;

              case 42:
                _context10.prev = 42;
                _context10.t1 = _context10["catch"](28);

                console.error(_context10.t1);
                alertify.error(_context10.t1);
                _this12.isLoadingDetail = false;

              case 47:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[5, 21], [28, 42]]);
      }))();
    },
    deleteField: function deleteField(id, type) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (id) {
                  _context11.next = 4;
                  break;
                }

                alertify.warning(_this13.$ml.get("alerts.selectedMealNotBlank"));
                _context11.next = 39;
                break;

              case 4:
                _context11.prev = 4;

                _this13.isLoadingDetail = true;
                _context11.next = 8;
                return _this13.$axios.delete("/AreaDefinition/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context11.sent;

                if (!(type == 0)) {
                  _context11.next = 16;
                  break;
                }

                _context11.next = 12;
                return _this13.newArea();

              case 12:
                _context11.next = 14;
                return _this13.getAreas();

              case 14:
                _context11.next = 31;
                break;

              case 16:
                if (!(type == 1)) {
                  _context11.next = 23;
                  break;
                }

                _context11.next = 19;
                return _this13.newFloor();

              case 19:
                _context11.next = 21;
                return _this13.getFloorsByAreaId(_this13.selectedArea.id);

              case 21:
                _context11.next = 31;
                break;

              case 23:
                $("#room-modal").modal("hide");
                $("#modal-room-detail").modal("hide");
                _context11.next = 27;
                return _this13.clearRoom();

              case 27:
                _context11.next = 29;
                return _this13.getFloorsByAreaId(_this13.viewSelectedArea.id);

              case 29:
                _context11.next = 31;
                return _this13.viewRefreshArea(_this13.viewSelectedArea.id);

              case 31:
                alertify.success(_this13.$ml.get("alerts.deletedSuccessfully"));
                _this13.isLoadingDetail = false;
                _context11.next = 39;
                break;

              case 35:
                _context11.prev = 35;
                _context11.t0 = _context11["catch"](4);

                alertify.error("Hata Oluştu : " + _context11.t0);
                _this13.isLoadingDetail = false;

              case 39:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13, [[4, 35]]);
      }))();
    },
    getAreas: function getAreas() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var areas, response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this14.isLoading = true;
                areas = [];
                _context12.next = 5;
                return _this14.$axios.get("/AreaDefinition/Area").then(function (response) {
                  response.data.forEach(function (doc) {
                    //Bölge
                    areas.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context12.sent;

                _this14.areas = areas;
                _this14.isLoading = false;
                _context12.next = 15;
                break;

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);
                alertify.error("Servis Hatası :" + _context12.t0.message);
                _this14.isLoading = false;

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this14, [[0, 10]]);
      }))();
    },
    getFloorsByAreaId: function getFloorsByAreaId(areaId) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var floors, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                _this15.isLoading = true;
                floors = [];
                _context13.next = 5;
                return _this15.$axios.get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId).then(function (response) {
                  response.data.forEach(function (doc) {
                    //Katlar
                    var rooms1 = doc.rooms.sort(function (a, b) {
                      if (a.orderNo < b.orderNo) return -1;
                      if (a.orderNo > b.orderNo) return 0;
                    });
                    floors.push({
                      id: doc.id,
                      name: doc.name,
                      areaId: doc.areaId,
                      orderNo: doc.orderNo,
                      rooms: rooms1
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context13.sent;

                _this15.floors = floors;
                _this15.isLoading = false;
                _context13.next = 15;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](0);

                console.error(_context13.t0);
                alertify.error("Servis Hatası :" + _context13.t0.message);
                _this15.isLoading = false;

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this15, [[0, 10]]);
      }))();
    },
    getUsesByRoomId: function getUsesByRoomId(roomId) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var usesEmployees, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this16.isLoadingUsesEmployees = true;
                usesEmployees = [];
                _context14.next = 5;
                return _this16.$axios.get("/AreaDefinition/UsesByRoomId?roomId=" + roomId).then(function (response) {
                  response.data.forEach(function (doc) {
                    usesEmployees.push(doc);
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoadingUsesEmployees = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoadingUsesEmployees = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context14.sent;

                _this16.viewSelectedRoom.usesEmployees = usesEmployees;
                _this16.isLoadingUsesEmployees = false;
                _context14.next = 15;
                break;

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);
                _this16.isLoadingUsesEmployees = false;

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this16, [[0, 10]]);
      }))();
    }
  }, _defineProperty(_methods, "getFloorsByAreaId", function getFloorsByAreaId(areaId) {
    var _this17 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
      var floors, response;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;

              _this17.isLoading = true;
              floors = [];
              _context15.next = 5;
              return _this17.$axios.get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId).then(function (response) {
                response.data.forEach(function (doc) {
                  //Katlar
                  var rooms1 = doc.rooms.sort(function (a, b) {
                    if (a.orderNo < b.orderNo) return -1;
                    if (a.orderNo > b.orderNo) return 0;
                  });
                  floors.push({
                    id: doc.id,
                    name: doc.name,
                    areaId: doc.areaId,
                    orderNo: doc.orderNo,
                    rooms: rooms1
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this17.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this17.$ml.get("errors.connectionError"));
                    _this17.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this17.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context15.sent;

              _this17.floors = floors;
              _this17.isLoading = false;
              _context15.next = 15;
              break;

            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15["catch"](0);

              console.error(_context15.t0);
              alertify.error("Servis Hatası :" + _context15.t0.message);
              _this17.isLoading = false;

            case 15:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, _this17, [[0, 10]]);
    }))();
  }), _defineProperty(_methods, "getRoomTypes", function getRoomTypes() {
    var _this18 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      var roomTypes, response;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;

              _this18.isLoading = true;
              roomTypes = [];
              _context16.next = 5;
              return _this18.$axios.get("/RoomType").then(function (response) {
                response.data.forEach(function (doc) {
                  roomTypes.push({
                    id: doc.id,
                    name: doc.name
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this18.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this18.$ml.get("errors.connectionError"));
                    _this18.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this18.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context16.sent;

              _this18.roomTypes = roomTypes;
              _this18.isLoading = false;
              _context16.next = 15;
              break;

            case 10:
              _context16.prev = 10;
              _context16.t0 = _context16["catch"](0);

              console.error(_context16.t0);
              alertify.error("Servis Hatası :" + _context16.t0.message);
              _this18.isLoading = false;

            case 15:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, _this18, [[0, 10]]);
    }))();
  }), _defineProperty(_methods, "getAllEmployees", function getAllEmployees() {
    var _this19 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
      var allEmployees, response;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;

              _this19.isLoadingEmployee = true;
              allEmployees = [];
              _context17.next = 5;
              return _this19.$axios.get("/Employees").then(function (response) {
                if (response.status == 200) {
                  response.data.forEach(function (doc) {
                    if (doc.isVisitor == false) {
                      allEmployees.push({
                        id: doc.id,
                        name: doc.name,
                        title: doc.title,
                        registrationNo: doc.registrationNo,
                        roomId: doc.roomId,
                        isVisitor: doc.isVisitor,
                        isCheck: false,
                        isAtRoom: false
                      });
                    }
                  });
                }
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this19.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                    _this19.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this19.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context17.sent;

              _this19.employees = allEmployees;
              _context17.next = 13;
              break;

            case 9:
              _context17.prev = 9;
              _context17.t0 = _context17["catch"](0);

              console.error(_context17.t0);
              alertify.error("Hata :" + _context17.t0.message);

            case 13:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, _this19, [[0, 9]]);
    }))();
  }), _defineProperty(_methods, "getEmployees", function getEmployees() {
    var _this20 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
      var employees, filters2, response;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!(_this20.filters.nameOrCardNumber == "")) {
                _context18.next = 3;
                break;
              }

              alertify.warning("Lütfen arama kısmını boş bırakmayın...");
              return _context18.abrupt("return");

            case 3:
              _context18.prev = 3;

              _this20.isLoadingEmployee = true;
              employees = [];
              filters2 = _this20.filters;
              _context18.next = 9;
              return _this20.$axios.post("/Employees/getByFilter", {
                nameOrCardNumber: filters2.nameOrCardNumber,
                sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                departments: filters2.departments,
                accessGroup: filters2.accessGroup,
                identityNo: filters2.identityNo,
                documentNoOrMail: filters2.documentNoOrMail,
                foodGroup: filters2.foodGroup,
                workGroupId: filters2.workGroupId,
                title: filters2.title,
                stateId: filters2.stateId,
                statuId: filters2.statuId,
                plateNo: filters2.plateNo,
                extraField1key: filters2.extraField1key,
                extraField1value: filters2.extraField1value,
                extraField2key: filters2.extraField2key,
                extraField2value: filters2.extraField2value,
                extraField3key: filters2.extraField3key,
                extraField3value: filters2.extraField3value,
                extraField4key: filters2.extraField4key,
                extraField4value: filters2.extraField4value,
                isVisitor: filters2.isVisitor,
                isActive: filters2.isActive
              }).then(function (response) {
                response.data.forEach(function (doc) {
                  var a = doc;
                  a.isCheck = false;
                  a.isAtRoom = false;
                  employees.push(a);
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this20.$store.dispatch("logout");
                  } else if (error.response.status == 403) {
                    alertify.message(_this20.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this20.$ml.get("errors.connectionError"));
                    _this20.isLoadingEmployee = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this20.isLoadingEmployee = false;
                    return;
                  }
                }
              });

            case 9:
              response = _context18.sent;

              _this20.employees = employees;
              _this20.isLoadingEmployee = false;
              _context18.next = 19;
              break;

            case 14:
              _context18.prev = 14;
              _context18.t0 = _context18["catch"](3);

              console.error(_context18.t0);
              alertify.error("Servis Hatası :" + _context18.t0.message);
              _this20.isLoadingEmployee = false;

            case 19:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, _this20, [[3, 14]]);
    }))();
  }), _defineProperty(_methods, "setUserAuthorityFilter", function setUserAuthorityFilter(filter) {
    var _this21 = this;

    filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
    filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
    filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
    filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
    filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
    this.filters.departments = filter.departments;
    this.filters.nameOrCardNumber = filter.nameOrCardNumber;
    this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
    this.filters.isActive = filter.isActive;
    this.filters.documentNoOrMail = filter.documentNoOrMail;
    this.filters.identityNo = filter.identityNo;
    this.filters.title = filter.title;
    this.filters.extraField1key = filter.extraField1key;
    this.filters.extraField1value = filter.extraField1value;
    this.filters.extraField2key = filter.extraField2key;
    this.filters.extraField2value = filter.extraField2value;
    this.filters.extraField3key = filter.extraField3key;
    this.filters.extraField3value = filter.extraField3value;
    this.filters.extraField4key = filter.extraField4key;
    this.filters.extraField4value = filter.extraField4value;
    this.filters.isVisitor = filter.isVisitor;
    this.filters.plateNo = filter.plateNo;
    //this.filters = filter;
    this.sortableDepartmentList.forEach(function (doc) {
      _this21.filters.departments.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.check = true;
        }
      });
    });
    this.periodWorkGroupList.forEach(function (doc) {
      _this21.filters.workGroupId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.accessGroupList.forEach(function (doc) {
      _this21.filters.accessGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.foodGroupList.forEach(function (doc) {
      _this21.filters.foodGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.stateList.forEach(function (doc) {
      _this21.filters.stateId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.statuList.forEach(function (doc) {
      _this21.filters.statuId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
  }), _defineProperty(_methods, "scrollToAnchor", function scrollToAnchor(aid) {
    var aTag = $(".room[name='" + aid + "']");
    $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
  }), _methods),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this22 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
      var filter;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (_this22.defaultFilters) {
                filter = _this22.defaultFilters;

                _this22.setUserAuthorityFilter(filter);
                //this.getEmployees();
              }
              _context19.next = 3;
              return _this22.getRoomTypes();

            case 3:
              _context19.next = 5;
              return _this22.getAreas();

            case 5:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, _this22);
    }))();
  }
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: true,
      isLoadingDetail: true,
      isLoadingEmployee: false,
      isLoadingUsesEmployees: false,
      isNewArea: true,
      isNewFloor: true,
      isNewRoom: true,
      isNewRoomType: true,
      selectedArea: {
        id: null,
        name: "",
        floors: []
      },
      selectedFloor: {
        id: null,
        name: "",
        areaId: null,
        orderNo: 1,
        rooms: []
      },
      selectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      selectedRoomType: {
        id: null,
        name: ""
      },
      viewSelectedArea: {
        id: null,
        name: "",
        floors: []
      },
      viewSelectedRoom: {
        id: null,
        name: "",
        capacity: 0,
        usesEmployees: [],
        orderNo: 1,
        floorId: null,
        areaId: null,
        roomTypeId: null,
        usesCount: 0
      },
      areas: [],
      floors: [],
      rooms: [],
      roomTypes: [],
      employees: [],
      selectedEmployees: [],
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      }
    };
  },

  computed: {
    areaList: function areaList() {
      return this.areas;
    },
    floorList: function floorList() {
      return this.floors;
    },
    roomTypeList: function roomTypeList() {
      return this.roomTypes;
    },
    selectedFloorList: function selectedFloorList() {
      return this.selectedArea.floors.sort(function (a, b) {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    selectedViewFloorList: function selectedViewFloorList() {
      return this.viewSelectedArea.floors.sort(function (a, b) {
        if (a.orderNo < b.orderNo) return -1;
        if (a.orderNo > b.orderNo) return 0;
      });
    },
    checkedEmployeeCount: function checkedEmployeeCount() {
      var employees = this.allEmployeeFilteredList.filter(function (a) {
        return a.isCheck == true;
      });
      if (employees[0]) {
        return employees.length;
      } else {
        return 0;
      }
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this = this;

      return this.employees.filter(function (item) {
        return item.roomId == null || item.roomId == _this.viewSelectedRoom.id;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 240;
        return "height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowEmployeesHeightSize: function windowEmployeesHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 280;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    customColor2: function customColor2() {
      if (this.viewSelectedRoom.capacity <= this.viewSelectedRoom.usesCount) {
        return "detail-box bg-red text-center";
      } else if (this.viewSelectedRoom.usesCount > 0 && this.viewSelectedRoom.usesCount < this.viewSelectedRoom.capacity) {
        return "detail-box bg-blue text-center";
      } else if (this.viewSelectedRoom.usesCount == 0) {
        return "detail-box bg-green text-center";
      } else {
        return "detail-box bg-warning text-center";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: (_methods = {
    openDevice: function openDevice() {
      var width = 800;
      var height = 600;

      var left = window.screen.width / 2 - width / 2;
      var top = window.screen.height / 2 - height / 2;

      window.open("https://kamera-linkin.com", "cameraWindow", "width=" + width + ",height=" + height + ",top=" + top + ",left=" + left);
    },
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    roomDetail: function roomDetail(room) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.employees = [];
                _this3.viewSelectedRoom.id = room.id;
                _this3.viewSelectedRoom.name = room.name;
                _this3.viewSelectedRoom.capacity = room.capacity;
                _this3.viewSelectedRoom.orderNo = room.orderNo;
                _this3.viewSelectedRoom.usesEmployees = room.usesEmployees;
                _this3.viewSelectedRoom.floorId = room.floorId;
                _this3.viewSelectedRoom.areaId = room.areaId;
                _this3.viewSelectedRoom.roomTypeId = room.roomTypeId;
                _this3.viewSelectedRoom.usesCount = room.usesCount;
                $("#modal-room-detail").modal("show");
                _context.next = 13;
                return _this3.getUsesByRoomId(room.id);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    editRoom: function editRoom() {
      if (this.viewSelectedRoom.id) {
        this.selectRoom(this.viewSelectedRoom.id);
        $("#room-modal").modal("show");
      }
    },
    newRoomType: function newRoomType() {
      this.isNewRoomType = true;
      this.selectedRoomType.id = null;
      this.selectedRoomType.name = "";
    },
    selectRoomType: function selectRoomType(id, name) {
      this.isNewRoomType = false;
      this.selectedRoomType.id = id;
      this.selectedRoomType.name = name;
    },
    getRoomTypeName: function getRoomTypeName(id) {
      var roomType = this.roomTypeList.filter(function (a) {
        return a.id == id;
      });
      if (roomType[0]) {
        return roomType[0].name;
      } else {
        return "-";
      }
    },
    deleteRoomType: function deleteRoomType(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 4;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.selectedMealNotBlank"));
                _context2.next = 21;
                break;

              case 4:
                _context2.prev = 4;

                _this4.isLoadingDetail = true;
                _context2.next = 8;
                return _this4.$axios.delete("/RoomType/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context2.sent;
                _context2.next = 11;
                return _this4.newRoomType();

              case 11:
                _context2.next = 13;
                return _this4.getRoomTypes();

              case 13:
                alertify.success(_this4.$ml.get("alerts.deletedSuccessfully"));
                _this4.isLoadingDetail = false;
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](4);

                alertify.error("Hata Oluştu : " + _context2.t0);
                _this4.isLoadingDetail = false;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[4, 17]]);
      }))();
    },
    saveRoomType: function saveRoomType() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, id, _response;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this5.isNewRoomType) {
                  _context3.next = 29;
                  break;
                }

                if (!(_this5.selectedRoomType.name == "")) {
                  _context3.next = 4;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context3.abrupt("return");

              case 4:
                _this5.isLoadingDetail = true;
                _context3.prev = 5;
                _context3.next = 8;
                return _this5.$axios.post("/RoomType", {
                  name: _this5.selectedRoomType.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context3.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 13;
                return _this5.newRoomType();

              case 13:
                _context3.next = 15;
                return _this5.getRoomTypes();

              case 15:
                alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                _context3.next = 19;
                break;

              case 18:
                alertify.error(response.message);

              case 19:
                _this5.isLoadingDetail = false;
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](5);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this5.isLoadingDetail = false;

              case 27:
                _context3.next = 50;
                break;

              case 29:
                _context3.prev = 29;
                _context3.next = 32;
                return _this5.$axios.post("/RoomType/" + _this5.selectedRoomType.id, {
                  name: _this5.selectedRoomType.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context3.sent;

                if (!(_response.status == 200)) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 36;
                return _this5.newRoomType();

              case 36:
                _context3.next = 38;
                return _this5.getRoomTypes();

              case 38:
                alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                _context3.next = 42;
                break;

              case 41:
                alertify.error(_response.message);

              case 42:
                _this5.isLoadingDetail = false;
                _context3.next = 50;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t1 = _context3["catch"](29);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this5.isLoadingDetail = false;

              case 50:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 22], [29, 45]]);
      }))();
    },
    viewSelectArea: function viewSelectArea($event) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var id;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = event.target.value;

                if (!id) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 4;
                return _this6.getFloorsByAreaId(id);

              case 4:
                _context4.next = 6;
                return _this6.viewRefreshArea(id);

              case 6:
                _context4.next = 11;
                break;

              case 8:
                _this6.viewSelectedArea.id = null;
                _this6.viewSelectedArea.name = "";
                _this6.viewSelectedArea.floors = [];

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    viewRefreshArea: function viewRefreshArea(id) {
      this.viewSelectedArea.id = id;
      var area = this.areaList.filter(function (a) {
        return a.id == id;
      });
      if (area[0]) {
        this.viewSelectedArea.name = area[0].name;
        this.viewSelectedArea.floors = [];
        this.viewSelectedArea.floors = this.floorList.filter(function (a) {
          return a.areaId == id;
        });
      } else {
        this.viewSelectedArea.id = null;
        this.viewSelectedArea.name = "";
        this.viewSelectedArea.floors = [];
      }
    },
    newEmployees: function newEmployees() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this7.viewSelectedRoom.capacity == _this7.viewSelectedRoom.usesCount)) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning("Odada yeterli boş alan mevcut değil...");
                return _context5.abrupt("return");

              case 3:
                _context5.next = 5;
                return _this7.allEmployeeFilteredList.forEach(function (a) {
                  if (a.isCheck == true) {
                    a.isCheck = false;
                    a.isAtRoom = false;
                  }
                  var result = _this7.viewSelectedRoom.usesEmployees.filter(function (b) {
                    return b.id == a.id;
                  });
                  if (result[0]) {
                    a.isCheck = true;
                    a.isAtRoom = true;
                  }
                });

              case 5:
                _context5.next = 7;
                return $("#employees-modal").modal("show");

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    addEmployee: function addEmployee() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var employees, ids, response, id, floor, room;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                employees = _this8.allEmployeeFilteredList.filter(function (a) {
                  return a.isCheck == true && a.isAtRoom == false;
                });
                ids = [];

                if (!employees[0]) {
                  _context6.next = 52;
                  break;
                }

                employees.forEach(function (b) {
                  ids.push(b.id);
                });
                _context6.prev = 4;
                _context6.next = 7;
                return _this8.$axios.post("/AreaDefinition/SetEmployeesToRoom", {
                  ids: ids,
                  roomId: _this8.viewSelectedRoom.id
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context6.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context6.next = 43;
                  break;
                }

                _context6.next = 12;
                return $("#employees-modal").modal("hide");

              case 12:
                _context6.next = 14;
                return _this8.getUsesByRoomId(_this8.viewSelectedRoom.id);

              case 14:
                _this8.viewSelectedRoom.usesCount = _this8.viewSelectedRoom.usesEmployees.length;
                floor = _this8.floorList.filter(function (a) {
                  return a.id == _this8.viewSelectedRoom.floorId;
                });

                if (!floor[0]) {
                  _context6.next = 32;
                  break;
                }

                room = floor[0].rooms.filter(function (b) {
                  return b.id == _this8.viewSelectedRoom.id;
                });

                if (!room[0]) {
                  _context6.next = 22;
                  break;
                }

                room[0].usesCount = _this8.viewSelectedRoom.usesEmployees.length;
                _context6.next = 30;
                break;

              case 22:
                _context6.next = 24;
                return $("#modal-room-detail").modal("hide");

              case 24:
                _context6.next = 26;
                return _this8.getFloorsByAreaId(_this8.viewSelectedArea.id);

              case 26:
                _context6.next = 28;
                return _this8.viewRefreshArea(_this8.viewSelectedArea.id);

              case 28:
                _context6.next = 30;
                return _this8.scrollToAnchor(_this8.viewSelectedRoom.id);

              case 30:
                _context6.next = 40;
                break;

              case 32:
                _context6.next = 34;
                return $("#modal-room-detail").modal("hide");

              case 34:
                _context6.next = 36;
                return _this8.getFloorsByAreaId(_this8.viewSelectedArea.id);

              case 36:
                _context6.next = 38;
                return _this8.viewRefreshArea(_this8.viewSelectedArea.id);

              case 38:
                _context6.next = 40;
                return _this8.scrollToAnchor(_this8.viewSelectedRoom.id);

              case 40:
                alertify.success(_this8.$ml.get("alerts.savedSuccessfully"));
                _context6.next = 44;
                break;

              case 43:
                alertify.error(response.message);

              case 44:
                _this8.isLoadingDetail = false;
                _context6.next = 52;
                break;

              case 47:
                _context6.prev = 47;
                _context6.t0 = _context6["catch"](4);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this8.isLoadingDetail = false;

              case 52:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[4, 47]]);
      }))();
    },
    removeEmployee: function removeEmployee(emp, index) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, id, floor, room;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return _this9.$axios.post("/AreaDefinition/RemoveEmployeesToRoom?employeeId=" + emp.id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 3:
                response = _context7.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context7.next = 36;
                  break;
                }

                _this9.viewSelectedRoom.usesEmployees.splice(index, 1);
                _this9.viewSelectedRoom.usesCount = _this9.viewSelectedRoom.usesEmployees.length;
                floor = _this9.floorList.filter(function (a) {
                  return a.id == _this9.viewSelectedRoom.floorId;
                });

                if (!floor[0]) {
                  _context7.next = 25;
                  break;
                }

                room = floor[0].rooms.filter(function (b) {
                  return b.id == _this9.viewSelectedRoom.id;
                });

                if (!room[0]) {
                  _context7.next = 15;
                  break;
                }

                room[0].usesCount = _this9.viewSelectedRoom.usesEmployees.length;
                _context7.next = 23;
                break;

              case 15:
                _context7.next = 17;
                return $("#modal-room-detail").modal("hide");

              case 17:
                _context7.next = 19;
                return _this9.getFloorsByAreaId(_this9.viewSelectedArea.id);

              case 19:
                _context7.next = 21;
                return _this9.viewRefreshArea(_this9.viewSelectedArea.id);

              case 21:
                _context7.next = 23;
                return _this9.scrollToAnchor(_this9.viewSelectedRoom.id);

              case 23:
                _context7.next = 33;
                break;

              case 25:
                _context7.next = 27;
                return $("#modal-room-detail").modal("hide");

              case 27:
                _context7.next = 29;
                return _this9.getFloorsByAreaId(_this9.viewSelectedArea.id);

              case 29:
                _context7.next = 31;
                return _this9.viewRefreshArea(_this9.viewSelectedArea.id);

              case 31:
                _context7.next = 33;
                return _this9.scrollToAnchor(_this9.viewSelectedRoom.id);

              case 33:
                alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                _context7.next = 37;
                break;

              case 36:
                alertify.error(response.message);

              case 37:
                _this9.isLoadingDetail = false;
                _context7.next = 45;
                break;

              case 40:
                _context7.prev = 40;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this9.isLoadingDetail = false;

              case 45:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 40]]);
      }))();
    },
    customColor: function customColor(room) {
      if (room) {
        if (room.capacity <= room.usesCount) {
          return "info-box-icon bg-red box-w-70";
        } else if (room.usesCount > 0 && room.usesCount < room.capacity) {
          return "info-box-icon bg-blue box-w-70";
        } else if (room.usesCount == 0) {
          return "info-box-icon bg-green box-w-70";
        } else {
          return "info-box-icon bg-warning box-w-70";
        }
      } else {
        return "info-box-icon box-w-70";
      }
    },
    changeRoomType: function changeRoomType(event) {
      this.viewSelectedRoom.roomTypeId = event.target.value;
    },
    clearRoom: function clearRoom() {
      this.isNewRoom = true;
      this.viewSelectedRoom.id = null;
      this.viewSelectedRoom.name = "";
      this.viewSelectedRoom.capacity = 1;
      this.viewSelectedRoom.orderNo = 1;
      this.viewSelectedRoom.usesEmployees = [];
      this.viewSelectedRoom.floorId = null;
      this.viewSelectedRoom.areaId = null;
      this.viewSelectedRoom.roomTypeId = null;
      this.viewSelectedRoom.usesCount = 0;
    },
    newRoom: function newRoom(floorId, areaId) {
      this.clearRoom();
      this.viewSelectedRoom.floorId = floorId;
      this.viewSelectedRoom.areaId = areaId;
      $("#room-modal").modal("show");
    },
    selectRoom: function selectRoom(id) {
      this.isNewRoom = false;
      this.viewSelectedRoom.id = id;
      var room = this.rooms.filter(function (a) {
        return a.id == id;
      });
      if (room[0]) {
        this.viewSelectedRoom.name = room[0].name;
        this.viewSelectedRoom.capacity = room[0].capacity;
        this.viewSelectedRoom.orderNo = room[0].orderNo;
        this.viewSelectedRoom.usesEmployees = room[0].usesEmployees;
        this.viewSelectedRoom.floorId = room[0].floorId;
        this.viewSelectedRoom.areaId = room[0].areaId;
        this.viewSelectedRoom.roomTypeId = room[0].roomTypeId;
        this.viewSelectedRoom.usesCount = room[0].usesCount;
      }
    },
    saveRoom: function saveRoom() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response, id, _response2;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!_this10.isNewRoom) {
                  _context8.next = 27;
                  break;
                }

                if (!(_this10.viewSelectedRoom.name == "")) {
                  _context8.next = 4;
                  break;
                }

                alertify.warning(_this10.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context8.abrupt("return");

              case 4:
                _this10.isLoadingDetail = true;
                _context8.prev = 5;
                _context8.next = 8;
                return _this10.$axios.post("/AreaDefinition", {
                  name: _this10.viewSelectedRoom.name,
                  type: 2,
                  floorId: _this10.viewSelectedRoom.floorId,
                  areaId: _this10.viewSelectedRoom.areaId,
                  capacity: _this10.viewSelectedRoom.capacity,
                  orderNo: _this10.viewSelectedRoom.orderNo,
                  roomTypeId: _this10.viewSelectedRoom.roomTypeId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context8.sent;
                id = response.data.id;

                if (response.status == 200) {
                  $("#room-modal").modal("hide");
                  alertify.success(_this10.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _context8.next = 13;
                return _this10.getFloorsByAreaId(_this10.viewSelectedArea.id);

              case 13:
                _context8.next = 15;
                return _this10.viewRefreshArea(_this10.viewSelectedArea.id);

              case 15:
                _context8.next = 17;
                return _this10.selectRoom(id);

              case 17:
                _this10.isLoadingDetail = false;
                _context8.next = 25;
                break;

              case 20:
                _context8.prev = 20;
                _context8.t0 = _context8["catch"](5);

                console.error(_context8.t0);
                alertify.error(_context8.t0.message);
                _this10.isLoadingDetail = false;

              case 25:
                _context8.next = 46;
                break;

              case 27:
                _context8.prev = 27;
                _context8.next = 30;
                return _this10.$axios.post("/AreaDefinition/" + _this10.viewSelectedRoom.id, {
                  name: _this10.viewSelectedRoom.name,
                  type: 2,
                  floorId: _this10.viewSelectedRoom.floorId,
                  areaId: _this10.viewSelectedRoom.areaId,
                  capacity: _this10.viewSelectedRoom.capacity,
                  orderNo: _this10.viewSelectedRoom.orderNo,
                  roomTypeId: _this10.viewSelectedRoom.roomTypeId
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 30:
                _response2 = _context8.sent;

                if (_response2.status == 200) {
                  $("#room-modal").modal("hide");
                  alertify.success(_this10.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response2.message);
                }
                _context8.next = 34;
                return _this10.getFloorsByAreaId(_this10.viewSelectedArea.id);

              case 34:
                _context8.next = 36;
                return _this10.viewRefreshArea(_this10.viewSelectedArea.id);

              case 36:
                _context8.next = 38;
                return _this10.selectRoom(_this10.viewSelectedRoom.id);

              case 38:
                _this10.isLoadingDetail = false;
                _context8.next = 46;
                break;

              case 41:
                _context8.prev = 41;
                _context8.t1 = _context8["catch"](27);

                console.error(_context8.t1);
                alertify.error(_context8.t1);
                _this10.isLoadingDetail = false;

              case 46:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[5, 20], [27, 41]]);
      }))();
    },
    newArea: function newArea() {
      this.isNewArea = true;
      this.selectedArea.id = null;
      this.selectedArea.name = "";
      this.selectedArea.floors = [];
      this.newFloor();
    },
    selectArea: function selectArea(id) {
      this.isNewArea = false;
      this.selectedArea.id = id;
      var area = this.areaList.filter(function (a) {
        return a.id == id;
      });
      if (area[0]) {
        this.selectedArea.name = area[0].name;
      }
      this.selectedArea.floors = [];
      this.selectedArea.floors = this.floorList.filter(function (a) {
        return a.areaId == id;
      });
      this.newFloor();
    },
    saveArea: function saveArea() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var response, id, _response3;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!_this11.isNewArea) {
                  _context9.next = 23;
                  break;
                }

                if (!(_this11.selectedArea.name == "")) {
                  _context9.next = 4;
                  break;
                }

                alertify.warning(_this11.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context9.abrupt("return");

              case 4:
                _this11.isLoadingDetail = true;
                _context9.prev = 5;
                _context9.next = 8;
                return _this11.$axios.post("/AreaDefinition", {
                  name: _this11.selectedArea.name,
                  type: 0,
                  floorId: null,
                  areaId: null,
                  capacity: 0,
                  orderNo: 0,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context9.sent;
                id = response.data.id;

                if (response.status == 200) {
                  _this11.selectArea(id);
                  alertify.success(_this11.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this11.getAreas();
                _this11.isNewArea = false;
                _this11.isLoadingDetail = false;
                _context9.next = 21;
                break;

              case 16:
                _context9.prev = 16;
                _context9.t0 = _context9["catch"](5);

                console.error(_context9.t0);
                alertify.error(_context9.t0.message);
                _this11.isLoadingDetail = false;

              case 21:
                _context9.next = 37;
                break;

              case 23:
                _context9.prev = 23;
                _context9.next = 26;
                return _this11.$axios.post("/AreaDefinition/" + _this11.selectedArea.id, {
                  name: _this11.selectedArea.name,
                  type: 0,
                  floorId: null,
                  areaId: null,
                  capacity: 0,
                  orderNo: 0,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 26:
                _response3 = _context9.sent;

                if (_response3.status == 200) {
                  _this11.selectArea(_this11.selectedArea.id);
                  alertify.success(_this11.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response3.message);
                }
                _this11.getAreas();
                _this11.isLoadingDetail = false;
                _context9.next = 37;
                break;

              case 32:
                _context9.prev = 32;
                _context9.t1 = _context9["catch"](23);

                console.error(_context9.t1);
                alertify.error(_context9.t1);
                _this11.isLoadingDetail = false;

              case 37:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[5, 16], [23, 32]]);
      }))();
    },
    newFloor: function newFloor() {
      this.isNewFloor = true;
      this.selectedFloor.id = null;
      this.selectedFloor.name = "";
      this.selectedFloor.orderNo = 1;
      this.selectedFloor.areaId = this.selectedArea.id;
    },
    selectFloor: function selectFloor(id) {
      this.isNewFloor = false;
      this.selectedFloor.id = id;
      var floor = this.floorList.filter(function (a) {
        return a.id == id;
      });
      if (floor[0]) {
        this.selectedFloor.name = floor[0].name;
        this.selectedFloor.orderNo = floor[0].orderNo;
        this.selectedFloor.areaId = floor[0].areaId;
      }
    },
    saveFloor: function saveFloor() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response, id, _response4;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!_this12.isNewFloor) {
                  _context10.next = 28;
                  break;
                }

                if (!(_this12.selectedFloor.name == "")) {
                  _context10.next = 4;
                  break;
                }

                alertify.warning(_this12.$ml.get("alerts.foodGroupNameNotBlank"));
                return _context10.abrupt("return");

              case 4:
                _this12.isLoadingDetail = true;
                _context10.prev = 5;
                _context10.next = 8;
                return _this12.$axios.post("/AreaDefinition", {
                  name: _this12.selectedFloor.name,
                  type: 1,
                  floorId: null,
                  areaId: _this12.selectedArea.id,
                  capacity: 0,
                  orderNo: _this12.selectedFloor.orderNo,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context10.sent;
                id = response.data.id;

                if (!(response.status == 200)) {
                  _context10.next = 16;
                  break;
                }

                _context10.next = 13;
                return _this12.getFloorsByAreaId(_this12.selectedArea.id);

              case 13:
                alertify.success(_this12.$ml.get("alerts.savedSuccessfully"));
                _context10.next = 17;
                break;

              case 16:
                alertify.error(response.message);

              case 17:
                _this12.isNewFloor = true;
                _this12.isLoadingDetail = false;
                _context10.next = 26;
                break;

              case 21:
                _context10.prev = 21;
                _context10.t0 = _context10["catch"](5);

                console.error(_context10.t0);
                alertify.error(_context10.t0.message);
                _this12.isLoadingDetail = false;

              case 26:
                _context10.next = 47;
                break;

              case 28:
                _context10.prev = 28;
                _context10.next = 31;
                return _this12.$axios.post("/AreaDefinition/" + _this12.selectedFloor.id, {
                  name: _this12.selectedFloor.name,
                  type: 1,
                  floorId: null,
                  areaId: _this12.selectedArea.id,
                  capacity: 0,
                  orderNo: _this12.selectedFloor.orderNo,
                  roomTypeId: null
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 31:
                _response4 = _context10.sent;

                if (!(_response4.status == 200)) {
                  _context10.next = 38;
                  break;
                }

                _context10.next = 35;
                return _this12.getFloorsByAreaId(_this12.selectedArea.id);

              case 35:
                alertify.success(_this12.$ml.get("alerts.updatedSuccessfully"));
                _context10.next = 39;
                break;

              case 38:
                alertify.error(_response4.message);

              case 39:
                _this12.isLoadingDetail = false;
                _context10.next = 47;
                break;

              case 42:
                _context10.prev = 42;
                _context10.t1 = _context10["catch"](28);

                console.error(_context10.t1);
                alertify.error(_context10.t1);
                _this12.isLoadingDetail = false;

              case 47:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[5, 21], [28, 42]]);
      }))();
    },
    deleteField: function deleteField(id, type) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (id) {
                  _context11.next = 4;
                  break;
                }

                alertify.warning(_this13.$ml.get("alerts.selectedMealNotBlank"));
                _context11.next = 39;
                break;

              case 4:
                _context11.prev = 4;

                _this13.isLoadingDetail = true;
                _context11.next = 8;
                return _this13.$axios.delete("/AreaDefinition/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context11.sent;

                if (!(type == 0)) {
                  _context11.next = 16;
                  break;
                }

                _context11.next = 12;
                return _this13.newArea();

              case 12:
                _context11.next = 14;
                return _this13.getAreas();

              case 14:
                _context11.next = 31;
                break;

              case 16:
                if (!(type == 1)) {
                  _context11.next = 23;
                  break;
                }

                _context11.next = 19;
                return _this13.newFloor();

              case 19:
                _context11.next = 21;
                return _this13.getFloorsByAreaId(_this13.selectedArea.id);

              case 21:
                _context11.next = 31;
                break;

              case 23:
                $("#room-modal").modal("hide");
                $("#modal-room-detail").modal("hide");
                _context11.next = 27;
                return _this13.clearRoom();

              case 27:
                _context11.next = 29;
                return _this13.getFloorsByAreaId(_this13.viewSelectedArea.id);

              case 29:
                _context11.next = 31;
                return _this13.viewRefreshArea(_this13.viewSelectedArea.id);

              case 31:
                alertify.success(_this13.$ml.get("alerts.deletedSuccessfully"));
                _this13.isLoadingDetail = false;
                _context11.next = 39;
                break;

              case 35:
                _context11.prev = 35;
                _context11.t0 = _context11["catch"](4);

                alertify.error("Hata Oluştu : " + _context11.t0);
                _this13.isLoadingDetail = false;

              case 39:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13, [[4, 35]]);
      }))();
    },
    getAreas: function getAreas() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var areas, response;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;

                _this14.isLoading = true;
                areas = [];
                _context12.next = 5;
                return _this14.$axios.get("/AreaDefinition/Area").then(function (response) {
                  response.data.forEach(function (doc) {
                    //Bölge
                    areas.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context12.sent;

                _this14.areas = areas;
                _this14.isLoading = false;
                _context12.next = 15;
                break;

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);

                console.error(_context12.t0);
                alertify.error("Servis Hatası :" + _context12.t0.message);
                _this14.isLoading = false;

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this14, [[0, 10]]);
      }))();
    },
    getFloorsByAreaId: function getFloorsByAreaId(areaId) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var floors, response;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;

                _this15.isLoading = true;
                floors = [];
                _context13.next = 5;
                return _this15.$axios.get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId).then(function (response) {
                  response.data.forEach(function (doc) {
                    //Katlar
                    var rooms1 = doc.rooms.sort(function (a, b) {
                      if (a.orderNo < b.orderNo) return -1;
                      if (a.orderNo > b.orderNo) return 0;
                    });
                    floors.push({
                      id: doc.id,
                      name: doc.name,
                      areaId: doc.areaId,
                      orderNo: doc.orderNo,
                      rooms: rooms1
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this15.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this15.$ml.get("errors.connectionError"));
                      _this15.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this15.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context13.sent;

                _this15.floors = floors;
                _this15.isLoading = false;
                _context13.next = 15;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](0);

                console.error(_context13.t0);
                alertify.error("Servis Hatası :" + _context13.t0.message);
                _this15.isLoading = false;

              case 15:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this15, [[0, 10]]);
      }))();
    },
    getUsesByRoomId: function getUsesByRoomId(roomId) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var usesEmployees, response;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;

                _this16.isLoadingUsesEmployees = true;
                usesEmployees = [];
                _context14.next = 5;
                return _this16.$axios.get("/AreaDefinition/UsesByRoomId?roomId=" + roomId).then(function (response) {
                  response.data.forEach(function (doc) {
                    usesEmployees.push(doc);
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this16.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this16.$ml.get("errors.connectionError"));
                      _this16.isLoadingUsesEmployees = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this16.isLoadingUsesEmployees = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context14.sent;

                _this16.viewSelectedRoom.usesEmployees = usesEmployees;
                _this16.isLoadingUsesEmployees = false;
                _context14.next = 15;
                break;

              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](0);

                console.error(_context14.t0);
                alertify.error("Servis Hatası :" + _context14.t0.message);
                _this16.isLoadingUsesEmployees = false;

              case 15:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this16, [[0, 10]]);
      }))();
    }
  }, _defineProperty(_methods, "getFloorsByAreaId", function getFloorsByAreaId(areaId) {
    var _this17 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
      var floors, response;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;

              _this17.isLoading = true;
              floors = [];
              _context15.next = 5;
              return _this17.$axios.get("/AreaDefinition/FloorsByAreaId?areaId=" + areaId).then(function (response) {
                response.data.forEach(function (doc) {
                  //Katlar
                  var rooms1 = doc.rooms.sort(function (a, b) {
                    if (a.orderNo < b.orderNo) return -1;
                    if (a.orderNo > b.orderNo) return 0;
                  });
                  floors.push({
                    id: doc.id,
                    name: doc.name,
                    areaId: doc.areaId,
                    orderNo: doc.orderNo,
                    rooms: rooms1
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this17.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this17.$ml.get("errors.connectionError"));
                    _this17.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this17.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context15.sent;

              _this17.floors = floors;
              _this17.isLoading = false;
              _context15.next = 15;
              break;

            case 10:
              _context15.prev = 10;
              _context15.t0 = _context15["catch"](0);

              console.error(_context15.t0);
              alertify.error("Servis Hatası :" + _context15.t0.message);
              _this17.isLoading = false;

            case 15:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, _this17, [[0, 10]]);
    }))();
  }), _defineProperty(_methods, "getRoomTypes", function getRoomTypes() {
    var _this18 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      var roomTypes, response;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;

              _this18.isLoading = true;
              roomTypes = [];
              _context16.next = 5;
              return _this18.$axios.get("/RoomType").then(function (response) {
                response.data.forEach(function (doc) {
                  roomTypes.push({
                    id: doc.id,
                    name: doc.name
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this18.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this18.$ml.get("errors.connectionError"));
                    _this18.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this18.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context16.sent;

              _this18.roomTypes = roomTypes;
              _this18.isLoading = false;
              _context16.next = 15;
              break;

            case 10:
              _context16.prev = 10;
              _context16.t0 = _context16["catch"](0);

              console.error(_context16.t0);
              alertify.error("Servis Hatası :" + _context16.t0.message);
              _this18.isLoading = false;

            case 15:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, _this18, [[0, 10]]);
    }))();
  }), _defineProperty(_methods, "getAllEmployees", function getAllEmployees() {
    var _this19 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
      var allEmployees, response;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;

              _this19.isLoadingEmployee = true;
              allEmployees = [];
              _context17.next = 5;
              return _this19.$axios.get("/Employees").then(function (response) {
                if (response.status == 200) {
                  response.data.forEach(function (doc) {
                    if (doc.isVisitor == false) {
                      allEmployees.push({
                        id: doc.id,
                        name: doc.name,
                        title: doc.title,
                        registrationNo: doc.registrationNo,
                        roomId: doc.roomId,
                        isVisitor: doc.isVisitor,
                        isCheck: false,
                        isAtRoom: false
                      });
                    }
                  });
                }
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this19.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                    _this19.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this19.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context17.sent;

              _this19.employees = allEmployees;
              _context17.next = 13;
              break;

            case 9:
              _context17.prev = 9;
              _context17.t0 = _context17["catch"](0);

              console.error(_context17.t0);
              alertify.error("Hata :" + _context17.t0.message);

            case 13:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, _this19, [[0, 9]]);
    }))();
  }), _defineProperty(_methods, "getEmployees", function getEmployees() {
    var _this20 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
      var employees, filters2, response;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              if (!(_this20.filters.nameOrCardNumber == "")) {
                _context18.next = 3;
                break;
              }

              alertify.warning("Lütfen arama kısmını boş bırakmayın...");
              return _context18.abrupt("return");

            case 3:
              _context18.prev = 3;

              _this20.isLoadingEmployee = true;
              employees = [];
              filters2 = _this20.filters;
              _context18.next = 9;
              return _this20.$axios.post("/Employees/getByFilter", {
                nameOrCardNumber: filters2.nameOrCardNumber,
                sicilOrTerminalNo: filters2.sicilOrTerminalNo,
                departments: filters2.departments,
                accessGroup: filters2.accessGroup,
                identityNo: filters2.identityNo,
                documentNoOrMail: filters2.documentNoOrMail,
                foodGroup: filters2.foodGroup,
                workGroupId: filters2.workGroupId,
                title: filters2.title,
                stateId: filters2.stateId,
                statuId: filters2.statuId,
                plateNo: filters2.plateNo,
                extraField1key: filters2.extraField1key,
                extraField1value: filters2.extraField1value,
                extraField2key: filters2.extraField2key,
                extraField2value: filters2.extraField2value,
                extraField3key: filters2.extraField3key,
                extraField3value: filters2.extraField3value,
                extraField4key: filters2.extraField4key,
                extraField4value: filters2.extraField4value,
                isVisitor: filters2.isVisitor,
                isActive: filters2.isActive
              }).then(function (response) {
                response.data.forEach(function (doc) {
                  var a = doc;
                  a.isCheck = false;
                  a.isAtRoom = false;
                  employees.push(a);
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this20.$store.dispatch("logout");
                  } else if (error.response.status == 403) {
                    alertify.message(_this20.$ml.get("alerts.userIsNotAuthorizedToSeeData"));
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this20.$ml.get("errors.connectionError"));
                    _this20.isLoadingEmployee = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this20.isLoadingEmployee = false;
                    return;
                  }
                }
              });

            case 9:
              response = _context18.sent;

              _this20.employees = employees;
              _this20.isLoadingEmployee = false;
              _context18.next = 19;
              break;

            case 14:
              _context18.prev = 14;
              _context18.t0 = _context18["catch"](3);

              console.error(_context18.t0);
              alertify.error("Servis Hatası :" + _context18.t0.message);
              _this20.isLoadingEmployee = false;

            case 19:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, _this20, [[3, 14]]);
    }))();
  }), _defineProperty(_methods, "setUserAuthorityFilter", function setUserAuthorityFilter(filter) {
    var _this21 = this;

    filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
    filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
    filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
    filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
    filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
    this.filters.departments = filter.departments;
    this.filters.nameOrCardNumber = filter.nameOrCardNumber;
    this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
    this.filters.isActive = filter.isActive;
    this.filters.documentNoOrMail = filter.documentNoOrMail;
    this.filters.identityNo = filter.identityNo;
    this.filters.title = filter.title;
    this.filters.extraField1key = filter.extraField1key;
    this.filters.extraField1value = filter.extraField1value;
    this.filters.extraField2key = filter.extraField2key;
    this.filters.extraField2value = filter.extraField2value;
    this.filters.extraField3key = filter.extraField3key;
    this.filters.extraField3value = filter.extraField3value;
    this.filters.extraField4key = filter.extraField4key;
    this.filters.extraField4value = filter.extraField4value;
    this.filters.isVisitor = filter.isVisitor;
    this.filters.plateNo = filter.plateNo;
    //this.filters = filter;
    this.sortableDepartmentList.forEach(function (doc) {
      _this21.filters.departments.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.check = true;
        }
      });
    });
    this.periodWorkGroupList.forEach(function (doc) {
      _this21.filters.workGroupId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.accessGroupList.forEach(function (doc) {
      _this21.filters.accessGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.foodGroupList.forEach(function (doc) {
      _this21.filters.foodGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.stateList.forEach(function (doc) {
      _this21.filters.stateId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.statuList.forEach(function (doc) {
      _this21.filters.statuId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
  }), _defineProperty(_methods, "scrollToAnchor", function scrollToAnchor(aid) {
    var aTag = $(".room[name='" + aid + "']");
    $("html,body").animate({ scrollTop: aTag.offset().top }, "slow");
  }), _methods),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this22 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
      var filter;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              if (_this22.defaultFilters) {
                filter = _this22.defaultFilters;

                _this22.setUserAuthorityFilter(filter);
                //this.getEmployees();
              }
              _context19.next = 3;
              return _this22.getRoomTypes();

            case 3:
              _context19.next = 5;
              return _this22.getAreas();

            case 5:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, _this22);
    }))();
  }
});

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      users: [],
      guard: {
        id: 1,
        name: "",
        title: "",
        mail: "",
        password: "",
        password2: "",
        phone: "",
        image: null,
        authorizedUserIds: []
      },
      isNewGuard: true,
      guards: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }],
      isNewTour: true,
      calendar: {
        id: null,
        guardId: null,
        tourId: null,
        day: 1
      },
      calendars: [],
      guardTours: []
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    guardList: function guardList() {
      var _this = this;

      if (this.searchText) {
        return this.guards.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.guards;
      }
    },
    userList: function userList() {
      return this.users;
    },
    guardTourList: function guardTourList() {
      return this.guardTours;
    },
    dayList: function dayList() {
      return this.days;
    },
    calendarList: function calendarList() {
      return this.calendars;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.guard.image = null;
    },
    onCloseBoxDevice: function onCloseBoxDevice(day) {
      $("#" + day).boxWidget("toggle");
    },
    newGuard: function newGuard() {
      this.isLoadingDetail = true;
      this.isNewGuard = true;
      this.guard.id = null;
      this.guard.name = "";
      this.guard.title = "";
      this.guard.mail = "";
      this.guard.password = "";
      this.guard.password2 = "";
      this.guard.image = null;
      this.guard.phone = "";
      this.imageData = null;
      this.tempUrl = null;
      this.calendars = [];
      this.guard.authorizedUserIds = [];
      this.isLoadingDetail = false;
    },
    deleteGuard: function deleteGuard() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.guard.id == null)) {
                  _context.next = 3;
                  break;
                }

                alertify.warning("Lütfen önce görevli seçin...");
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                _this3.isLoadingDetail = true;
                id = _this3.guard.id;
                _context.next = 8;
                return _this3.$axios.delete("/GuardDefinition/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context.sent;

                _this3.getGuards();
                _this3.newGuard();
                alertify.success(_this3.$ml.get("alerts.deletedSuccessfully"));
                _this3.isLoadingDetail = false;
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this3.isLoadingDetail = false;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 15]]);
      }))();
    },
    updatePassword: function updatePassword() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.guard.id == null)) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning("Lütfen önce görevli seçin...");
                return _context2.abrupt("return");

              case 3:
                if (!(_this4.guard.password != _this4.guard.password2)) {
                  _context2.next = 6;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.passwordsDoNotMatch"));
                return _context2.abrupt("return");

              case 6:
                if (!(_this4.guard.password == "")) {
                  _context2.next = 9;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.pleaseEnterAPassword"));
                return _context2.abrupt("return");

              case 9:
                _context2.prev = 9;

                _this4.isLoadingDetail = true;
                _context2.next = 13;
                return _this4.$axios.post("/GuardDefinition/UpdatePassword/", {
                  guardId: _this4.guard.id,
                  password: _this4.guard.password
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get("alerts.updatedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this4.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this4.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 13:
                response = _context2.sent;

                _this4.isLoadingDetail = false;
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](9);

                console.error(error);
                alertify.error(error);
                _this4.isLoadingDetail = false;

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[9, 17]]);
      }))();
    },
    saveGuard: function saveGuard() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var guard2, image, response, id, formData, responseImage, _guard, _image, _response, _id, _formData, _responseImage, _responseImage2;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.guard.name == "")) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseEnterAUserName"));
                return _context3.abrupt("return");

              case 3:

                _this5.isLoadingDetail = true;

                if (!_this5.isNewGuard) {
                  _context3.next = 33;
                  break;
                }

                _context3.prev = 5;
                guard2 = _this5.guard;
                image = _this5.imageData;
                _context3.next = 10;
                return _this5.$axios.post("/GuardDefinition", {
                  name: guard2.name,
                  title: guard2.title,
                  mail: guard2.mail,
                  phone: guard2.phone,
                  authorizedUserIds: guard2.authorizedUserIds
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context3.sent;
                id = response.data.id;

                if (!_this5.imageData) {
                  _context3.next = 19;
                  break;
                }

                formData = new FormData();

                formData.append("file", image);

                if (!(_this5.imageData != null)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 18;
                return _this5.$axios.post("/GuardDefinition/AddGuardPhoto/" + id, formData);

              case 18:
                responseImage = _context3.sent;

              case 19:
                try {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                } catch (error) {}
                _this5.getGuards();
                _this5.getGuard(id);
                _this5.isNewGuard = false;
                _this5.isLoadingDetail = false;
                _context3.next = 31;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](5);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 31:
                _context3.next = 62;
                break;

              case 33:
                _context3.prev = 33;
                _guard = _this5.guard;
                _image = _this5.imageData;
                _context3.next = 38;
                return _this5.$axios.put("/GuardDefinition/" + _guard.id, {
                  name: _guard.name,
                  title: _guard.title,
                  mail: _guard.mail,
                  phone: _guard.phone,
                  authorizedUserIds: _guard.authorizedUserIds
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 38:
                _response = _context3.sent;
                _id = _guard.id;

                if (!_this5.imageData) {
                  _context3.next = 48;
                  break;
                }

                _formData = new FormData();

                _formData.append("file", _image);
                _context3.next = 45;
                return _this5.$axios.post("/GuardDefinition/AddGuardPhoto/" + _id, _formData);

              case 45:
                _responseImage = _context3.sent;
                _context3.next = 52;
                break;

              case 48:
                if (!(_this5.guard.image == null)) {
                  _context3.next = 52;
                  break;
                }

                _context3.next = 51;
                return _this5.$axios.patch("/GuardDefinition/RemovePhoto/" + _id);

              case 51:
                _responseImage2 = _context3.sent;

              case 52:
                try {
                  if (_response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response.message);
                  }
                } catch (error) {}
                _this5.getGuards();
                _this5.isLoadingDetail = false;
                _context3.next = 62;
                break;

              case 57:
                _context3.prev = 57;
                _context3.t1 = _context3["catch"](33);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this5.isLoadingDetail = false;

              case 62:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 26], [33, 57]]);
      }))();
    },
    removePhonePair: function removePhonePair() {
      var _this6 = this;

      try {
        var id = this.guard.id;
        if (id != null) {
          var response = this.$axios.delete("/GuardDefinition/ResetPair/" + id).then(function (response) {
            alertify.success("Başarıyla Sıfırlandı!");
            _this6.getGuard(id);
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this6.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this6.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    getGuard: function getGuard(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this7.isLoadingDetail = true;
                _this7.newGuard();
                _context4.next = 5;
                return _this7.$axios.get("/GuardDefinition/" + id).then(function (response) {
                  _this7.isNewGuard = false;
                  _this7.guard.id = id;
                  _this7.guard.name = response.data.name;
                  _this7.guard.title = response.data.title;
                  _this7.guard.mail = response.data.mail;
                  _this7.guard.phone = response.data.phone;
                  _this7.guard.image = response.data.image;
                  _this7.guard.authorizedUserIds = response.data.authorizedUserIds;
                  _this7.guard.mobilUID = response.data.mobilUID;
                  _this7.guard.mobileToken = response.data.mobileToken;
                  _this7.getGuardCalendar(id);
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this7.isLoadingDetail = false;
                _context4.next = 14;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this7.isLoadingDetail = false;

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 9]]);
      }))();
    },
    getCalendar: function getCalendar(day) {
      return this.calendarList.filter(function (item) {
        return item.day == day;
      });
    },
    getGuardTourFromId: function getGuardTourFromId(id) {
      var tour = this.guardTourList.filter(function (item) {
        return item.id == id;
      });
      if (tour[0]) {
        return tour[0];
      } else {
        return "";
      }
    },
    changeTour: function changeTour(event) {
      this.calendar.tourId = event.target.value;
    },
    newCalendar: function newCalendar(day) {
      this.isNewTour = true;
      this.calendar.id = null;
      this.calendar.guardId = this.guard.id;
      this.calendar.tourId = null;
      this.calendar.day = day;
    },
    selectCalendar: function selectCalendar(calendar) {
      this.isNewTour = false;
      this.calendar.id = calendar.id;
      this.calendar.guardId = calendar.guardId;
      this.calendar.tourId = calendar.tourId;
      this.calendar.day = calendar.day;
      $("#modal-tour").modal("show");
    },
    deleteCalendar: function deleteCalendar(tourId) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this8.isLoadingDetail = true;
                id = tourId;
                _context5.next = 5;
                return _this8.$axios.delete("/GuardCalendar/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;

                _this8.getGuardCalendar(_this8.guard.id);
                alertify.success(_this8.$ml.get("alerts.deletedSuccessfully"));
                _this8.isLoadingDetail = false;
                _context5.next = 16;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);
                _this8.isLoadingDetail = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 11]]);
      }))();
    },
    saveCalendar: function saveCalendar() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var calendar2, response, _calendar, image, _response2;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log(_this9.calendar);

                if (!(_this9.calendar.tourId == null || _this9.calendar.tourId == "")) {
                  _context6.next = 4;
                  break;
                }

                alertify.warning("Lütfen tur seçin...");
                return _context6.abrupt("return");

              case 4:
                _this9.isLoadingDetail = true;

                if (!_this9.isNewTour) {
                  _context6.next = 23;
                  break;
                }

                _context6.prev = 6;
                calendar2 = _this9.calendar;
                _context6.next = 10;
                return _this9.$axios.post("/GuardCalendar", {
                  guardId: calendar2.guardId,
                  tourId: calendar2.tourId,
                  day: calendar2.day
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context6.sent;

                if (response.status == 200) {
                  alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this9.getGuardCalendar(_this9.guard.id);
                _this9.isLoadingDetail = false;
                _context6.next = 21;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](6);

                console.error(_context6.t0);
                alertify.error(_context6.t0);
                _this9.isLoadingDetail = false;

              case 21:
                _context6.next = 39;
                break;

              case 23:
                _context6.prev = 23;
                _calendar = _this9.calendar;
                image = _this9.imageData;
                _context6.next = 28;
                return _this9.$axios.put("/GuardCalendar/" + _calendar.id, {
                  guardId: _calendar.guardId,
                  tourId: _calendar.tourId,
                  day: _calendar.day
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                _response2 = _context6.sent;

                try {
                  if (_response2.status == 200) {
                    alertify.success(_this9.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response2.message);
                  }
                } catch (error) {}
                _this9.getGuardCalendar(_this9.guard.id);
                _this9.isLoadingDetail = false;
                _context6.next = 39;
                break;

              case 34:
                _context6.prev = 34;
                _context6.t1 = _context6["catch"](23);

                console.error(_context6.t1);
                alertify.error(_context6.t1);
                _this9.isLoadingDetail = false;

              case 39:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[6, 16], [23, 34]]);
      }))();
    },
    getGuardCalendar: function getGuardCalendar(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var calendars, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this10.isLoadingDetail = true;
                calendars = [];
                _context7.next = 5;
                return _this10.$axios.get("/GuardCalendar?guardId=" + id).then(function (response) {
                  response.data.forEach(function (doc) {
                    calendars.push({
                      id: doc.id,
                      guardId: doc.guardId,
                      tourId: doc.tourId,
                      day: doc.day
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this10.calendars = calendars;
                _this10.isLoadingDetail = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this10.isLoadingDetail = false;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 10]]);
      }))();
    },
    getGuards: function getGuards() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var guards, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this11.isLoading = true;
                guards = [];
                _context8.next = 5;
                return _this11.$axios.get("/GuardDefinition").then(function (response) {
                  response.data.forEach(function (doc) {
                    guards.push({
                      id: doc.id,
                      name: doc.name,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context8.sent;

                _this11.guards = guards;
                _this11.isLoading = false;
                _context8.next = 15;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error(_context8.t0.message);
                _this11.isLoading = false;

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[0, 10]]);
      }))();
    },
    getGuardTours: function getGuardTours() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var guardTours, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this12.isLoading = true;
                guardTours = [];
                _context9.next = 5;
                return _this12.$axios.get("/GuardTour").then(function (response) {
                  response.data.forEach(function (doc) {
                    guardTours.push({
                      id: doc.id,
                      name: doc.name,
                      startDate: doc.startDate ? _this12.toDateFormat(doc.startDate, "ss:dd") : "",
                      endDate: doc.endDate ? _this12.toDateFormat(doc.endDate, "ss:dd") : ""
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context9.sent;

                _this12.guardTours = guardTours;
                _this12.isLoading = false;
                _context9.next = 15;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                alertify.error(_context9.t0.message);
                _this12.isLoading = false;

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 10]]);
      }))();
    },
    getUsers: function getUsers() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var users, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this13.isLoading = true;
                users = [];
                _context10.next = 5;
                return _this13.$axios.get("/User").then(function (response) {
                  response.data.forEach(function (doc) {
                    users.push({
                      id: doc.id,
                      name: doc.name,
                      title: doc.title,
                      isChecked: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context10.sent;

                _this13.users = users;
                _this13.isLoading = false;
                _context10.next = 15;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error(_context10.t0.message);
                _this13.isLoading = false;

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this14 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this14.getUsers();

            case 2:
              _context11.next = 4;
              return _this14.getGuards();

            case 4:
              _context11.next = 6;
              return _this14.getGuardTours();

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this14);
    }))();
  }
});

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      searchText: "",
      isNewArea: true,
      newImg: false,
      area: {
        id: null,
        areaName: "",
        imagePath: ""
      },
      areas: []
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    buildings: function buildings() {
      return this.$store.getters.getBuildings;
    },
    imgList: function imgList() {
      var _this2 = this;

      if (this.searchText != "") {
        return this.buildings.filter(function (a) {
          return _this2.searchText.toLowerCase().split(" ").every(function (v) {
            return a.tags.toLowerCase().includes(v);
          });
        });
      } else {
        return this.buildings;
      }
    },
    areaList: function areaList() {
      return this.areas;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    newArea: function newArea() {
      this.isNewArea = true;
      this.newImg = true;
      this.searchText = "";
      this.area.id = null;
      this.area.areaName = "";
      this.area.imagePath = "office-building-19.png";
    },
    selectArea: function selectArea(area) {
      this.isNewArea = false;
      this.newImg = false;
      this.searchText = "";
      this.area.id = area.id;
      this.area.areaName = area.areaName;
      this.area.imagePath = area.imagePath;
    },
    getAreas: function getAreas() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var areas, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoading = true;
                areas = [];
                _context.next = 5;
                return _this3.$axios.get("/GuardArea").then(function (response) {
                  response.data.forEach(function (doc) {
                    areas.push({
                      id: doc.id,
                      areaName: doc.areaName,
                      imagePath: doc.imagePath
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.areas = areas;
                _this3.isLoading = false;
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this3.isLoading = false;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 10]]);
      }))();
    },
    deleteArea: function deleteArea() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this4.isLoadingDetail = true;
                id = _this4.area.id;
                _context2.next = 5;
                return _this4.$axios.delete("/GuardArea/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this4.getAreas();
                _this4.newArea();
                alertify.success(_this4.$ml.get("alerts.deletedSuccessfully"));
                _this4.isLoadingDetail = false;
                _context2.next = 17;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 12]]);
      }))();
    },
    saveArea: function saveArea() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var area2, response, _area, _response;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.area.areaName == "")) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseEnterAUserName"));
                return _context3.abrupt("return");

              case 3:
                _this5.isLoadingDetail = true;

                if (!_this5.isNewArea) {
                  _context3.next = 23;
                  break;
                }

                _context3.prev = 5;
                area2 = _this5.area;
                _context3.next = 9;
                return _this5.$axios.post("/GuardArea", {
                  areaName: area2.areaName,
                  imagePath: area2.imagePath
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context3.sent;

                if (response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this5.getAreas();
                _this5.newArea();
                _this5.isLoadingDetail = false;
                _context3.next = 21;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](5);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 21:
                _context3.next = 39;
                break;

              case 23:
                _context3.prev = 23;
                _area = _this5.area;
                _context3.next = 27;
                return _this5.$axios.put("/GuardArea/" + _area.id, {
                  areaName: _area.areaName,
                  imagePath: _area.imagePath
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 27:
                _response = _context3.sent;

                try {
                  if (_response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response.message);
                  }
                } catch (error) {}
                _this5.getAreas();
                _this5.newArea();
                _this5.isLoadingDetail = false;
                _context3.next = 39;
                break;

              case 34:
                _context3.prev = 34;
                _context3.t1 = _context3["catch"](23);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this5.isLoadingDetail = false;

              case 39:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[5, 16], [23, 34]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this6.getAreas();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this6);
    }))();
  }
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qrcode_vue__ = __webpack_require__(83);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      qrValue: "",
      qrSize: 200,
      qrTextStyle: "text-align:center;",
      searchText: "",
      newImg: true,
      isNewControlPoint: true,
      controlPoint: {
        id: null,
        areaId: null,
        name: "",
        imagePath: "",
        positionX: "",
        positionY: ""
      },
      controlPoints: [],
      areas: []
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */],
    QrcodeVue: __WEBPACK_IMPORTED_MODULE_1_qrcode_vue__["a" /* default */]
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    buildings: function buildings() {
      return this.$store.getters.getBuildings;
    },
    imgList: function imgList() {
      var _this2 = this;

      if (this.searchText != "") {
        return this.buildings.filter(function (a) {
          return _this2.searchText.toLowerCase().split(" ").every(function (v) {
            return a.tags.toLowerCase().includes(v);
          });
        });
      } else {
        return this.buildings;
      }
    },
    areaList: function areaList() {
      return this.areas;
    },
    controlPointList: function controlPointList() {
      return this.controlPoints;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    print: function print() {
      this.$htmlToPaper("print");
    },
    changeArea: function changeArea(event) {
      this.controlPoint.areaId = event.target.value;
      var area = this.areaList.filter(function (a) {
        return a.id == event.target.value;
      });
      if (area[0]) {
        this.controlPoint.imagePath = area[0].imagePath;
      } else {
        this.controlPoint.imagePath = "";
      }
    },
    getAreaImageFromId: function getAreaImageFromId(areaId) {
      var area = this.areaList.filter(function (a) {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].imagePath;
      } else {
        return "office-building-19.png";
      }
    },
    getAreaNameFromId: function getAreaNameFromId(areaId) {
      var area = this.areaList.filter(function (a) {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    newControlPoint: function newControlPoint() {
      this.isNewControlPoint = true;
      this.controlPoint.id = null;
      this.controlPoint.areaId = null;
      this.controlPoint.name = "";
      this.controlPoint.imagePath = "office-building-19.png";
      this.controlPoint.positionX = "";
      this.controlPoint.positionY = "";
    },
    selectControlPoint: function selectControlPoint(controlPoint) {
      this.isNewControlPoint = false;
      this.controlPoint.id = controlPoint.id;
      this.controlPoint.areaId = controlPoint.areaId;
      this.controlPoint.name = controlPoint.name;
      this.controlPoint.imagePath = controlPoint.imagePath;
      this.controlPoint.positionX = controlPoint.positionX;
      this.controlPoint.positionY = controlPoint.positionY;
      this.qrValue = "TCCP-" + controlPoint.id;
    },
    deleteControlPoint: function deleteControlPoint() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.controlPoint.id;
                _context.next = 5;
                return _this3.$axios.delete("/GuardControlPoint/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getControlPoints();
                _this3.newControlPoint();
                alertify.success(_this3.$ml.get("alerts.deletedSuccessfully"));
                _this3.isLoadingDetail = false;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this3.isLoadingDetail = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveControlPoint: function saveControlPoint() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var controlPoint2, response, _controlPoint, image, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.controlPoint.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning("Lütfen kontrol noktası adı girin...");
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!_this4.isNewControlPoint) {
                  _context2.next = 23;
                  break;
                }

                _context2.prev = 5;
                controlPoint2 = _this4.controlPoint;
                _context2.next = 9;
                return _this4.$axios.post("/GuardControlPoint", {
                  name: controlPoint2.name,
                  areaId: controlPoint2.areaId,
                  imagePath: controlPoint2.imagePath,
                  positionX: controlPoint2.positionX,
                  positionY: controlPoint2.positionY
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this4.getControlPoints();
                _this4.newControlPoint();
                _this4.isLoadingDetail = false;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0);
                _this4.isLoadingDetail = false;

              case 21:
                _context2.next = 40;
                break;

              case 23:
                _context2.prev = 23;
                _controlPoint = _this4.controlPoint;
                image = _this4.imageData;
                _context2.next = 28;
                return _this4.$axios.put("/GuardControlPoint/" + _controlPoint.id, {
                  name: _controlPoint.name,
                  areaId: _controlPoint.areaId,
                  imagePath: _controlPoint.imagePath,
                  positionX: _controlPoint.positionX,
                  positionY: _controlPoint.positionY
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                _response = _context2.sent;

                try {
                  if (_response.status == 200) {
                    alertify.success(_this4.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response.message);
                  }
                } catch (error) {}
                _this4.getControlPoints();
                _this4.newControlPoint();
                _this4.isLoadingDetail = false;
                _context2.next = 40;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](23);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 16], [23, 35]]);
      }))();
    },
    getControlPoints: function getControlPoints() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var controlPoints, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoading = true;
                controlPoints = [];
                _context3.next = 5;
                return _this5.$axios.get("/GuardControlPoint").then(function (response) {
                  response.data.forEach(function (doc) {
                    controlPoints.push({
                      id: doc.id,
                      areaId: doc.areaId,
                      name: doc.name,
                      imagePath: doc.imagePath,
                      positionX: doc.positionX,
                      positionY: doc.positionY
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this5.controlPoints = controlPoints;
                _this5.isLoading = false;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 10]]);
      }))();
    },
    getAreas: function getAreas() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var areas, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                areas = [];
                _context4.next = 5;
                return _this6.$axios.get("/GuardArea").then(function (response) {
                  response.data.forEach(function (doc) {
                    areas.push({
                      id: doc.id,
                      areaName: doc.areaName,
                      imagePath: doc.imagePath
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this6.areas = areas;
                _this6.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.getAreas();

            case 2:
              _context5.next = 4;
              return _this7.getControlPoints();

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  }
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alertifyjs__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_alertifyjs__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      guardTour: {
        id: 1,
        name: "",
        startDate: "00:00",
        endDate: "00:00"
      },
      tourDetails: [],
      isNewGuardTour: true,
      guardTours: [],
      areas: [],
      controlPoints: [],
      isNewTourDetail: true,
      controlPointIds: [],
      tourDetail: {
        id: null,
        guardTourId: null,
        guardControlPointId: null,
        time: "00:00",
        controlPoint: {
          areaId: null,
          name: ""
        }
      }
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      if (format == "gg.aa.yyyy.ss:dd") {
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    guardTourList: function guardTourList() {
      var _this = this;

      if (this.searchText) {
        return this.guardTours.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.guardTours;
      }
    },
    areaList: function areaList() {
      return this.areas;
    },
    controlPointList: function controlPointList() {
      return this.controlPoints;
    },
    tourDetailList: function tourDetailList() {
      return this.tourDetails.sort(function (a, b) {
        if (a.time < b.time) return -1;
        if (a.time > b.time) return 0;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    getAreaById: function getAreaById(areaId) {
      var area = this.areaList.filter(function (a) {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    changeControlPoint: function changeControlPoint(event) {
      this.tourDetail.guardControlPointId = event.target.value;
      var controlPoint = this.controlPointList.filter(function (a) {
        return a.id == event.target.value;
      });
      if (controlPoint[0]) {
        this.tourDetail.controlPoint = controlPoint[0];
      } else {
        this.tourDetail.controlPoint = {
          areaId: null,
          name: ""
        };
      }
    },
    getAreaNameFromId: function getAreaNameFromId(areaId) {
      var area = this.areaList.filter(function (a) {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].areaName;
      } else {
        return "";
      }
    },
    getAreaImageFromId: function getAreaImageFromId(areaId) {
      var area = this.areaList.filter(function (a) {
        return a.id == areaId;
      });
      if (area[0]) {
        return area[0].imagePath;
      } else {
        return "office-building-19.png";
      }
    },
    newGuardTour: function newGuardTour() {
      this.isLoadingDetail = true;
      this.isNewGuardTour = true;
      this.guardTour.id = null;
      this.guardTour.name = "";
      this.guardTour.startDate = null;
      this.guardTour.endDate = null;
      this.tourDetails = [];
      this.isLoadingDetail = false;
    },
    deleteGuardTour: function deleteGuardTour() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.guardTour.id == null)) {
                  _context.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen önce tur seçin...");
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                _this3.isLoadingDetail = true;
                id = _this3.guardTour.id;
                _context.next = 8;
                return _this3.$axios.delete("/GuardTour/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context.sent;

                _this3.getGuardTours();
                _this3.newGuardTour();
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this3.$ml.get("alerts.deletedSuccessfully"));
                _this3.isLoadingDetail = false;
                _context.next = 20;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](3);

                console.error(_context.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context.t0.message);
                _this3.isLoadingDetail = false;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[3, 15]]);
      }))();
    },
    saveGuardTour: function saveGuardTour() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var guardTour2, response, id, _guardTour, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.guardTour.name == "")) {
                  _context2.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen tur adı girin...");
                return _context2.abrupt("return");

              case 3:
                if (!(_this4.guardTour.endDate <= _this4.guardTour.startDate)) {
                  _context2.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Başlangıç saati bitiş saatinden büyük olamaz");
                return _context2.abrupt("return");

              case 6:
                _this4.isLoadingDetail = true;

                if (!_this4.isNewGuardTour) {
                  _context2.next = 28;
                  break;
                }

                _context2.prev = 8;
                guardTour2 = _this4.guardTour;
                _context2.next = 12;
                return _this4.$axios.post("/GuardTour", {
                  name: guardTour2.name,
                  startDate: guardTour2.startDate,
                  endDate: guardTour2.endDate
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 12:
                response = _context2.sent;
                id = response.data.id;

                try {
                  if (response.status == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this4.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(response.message);
                  }
                } catch (error) {}
                _this4.getGuardTours();
                _this4.getGuardTour(id);
                _this4.isNewGuardTour = false;
                _this4.isLoadingDetail = false;
                _context2.next = 26;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2["catch"](8);

                console.error(_context2.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context2.t0);
                _this4.isLoadingDetail = false;

              case 26:
                _context2.next = 43;
                break;

              case 28:
                _context2.prev = 28;
                _guardTour = _this4.guardTour;
                _context2.next = 32;
                return _this4.$axios.put("/GuardTour/" + _guardTour.id, {
                  name: _guardTour.name,
                  startDate: _guardTour.startDate,
                  endDate: _guardTour.endDate
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context2.sent;

                try {
                  if (_response.status == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this4.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_response.message);
                  }
                } catch (error) {}
                _this4.getGuardTours();
                _this4.isLoadingDetail = false;
                _context2.next = 43;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t1 = _context2["catch"](28);

                console.error(_context2.t1);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 43:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[8, 21], [28, 38]]);
      }))();
    },
    getGuardTour: function getGuardTour(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _this5.newGuardTour();
                _context3.next = 5;
                return _this5.$axios.get("/GuardTour/" + id).then(function (response) {
                  _this5.isNewGuardTour = false;
                  _this5.guardTour.id = id;
                  _this5.guardTour.name = response.data.name;
                  _this5.guardTour.startDate = response.data.startDate ? _this5.toDateFormat(response.data.startDate, "ss:dd") : "";
                  _this5.guardTour.endDate = response.data.endDate ? _this5.toDateFormat(response.data.endDate, "ss:dd") : "";
                  _this5.getTourDetails(id);
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context3.t0.message);
                _this5.isLoadingDetail = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 9]]);
      }))();
    },
    newTourDetail: function newTourDetail() {
      this.isNewTourDetail = true;
      this.tourDetail.id = null;
      this.tourDetail.guardTourId = this.guardTour.id;
      this.tourDetail.guardControlPointId = null;
      this.tourDetail.time = this.guardTour.startDate;
      this.tourDetail.controlPoint = {
        areaId: null,
        name: ""
      };
      this.controlPointIds = [];
      this.controlPoints.forEach(function (a) {
        a.isCheck = false;
      });
      $("#modal-tour-detail").modal("show");
    },
    selectTourDetail: function selectTourDetail(tourDetail) {
      this.isNewTourDetail = false;
      this.tourDetail.id = tourDetail.id;
      this.tourDetail.guardTourId = tourDetail.guardTourId;
      this.tourDetail.guardControlPointId = tourDetail.guardControlPointId;
      this.tourDetail.time = tourDetail.time;
      this.tourDetail.controlPoint = tourDetail.controlPoint;
      $("#modal-tour-detail").modal("show");
    },
    deleteTourDetail: function deleteTourDetail() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this6.tourDetail.id == null)) {
                  _context4.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen önce tur geçiş noktası seçin...");
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;

                _this6.isLoadingDetail = true;
                id = _this6.tourDetail.id;
                _context4.next = 8;
                return _this6.$axios.delete("/GuardTour/TourDetails/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context4.sent;

                _this6.getTourDetails(_this6.guardTour.id);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this6.$ml.get("alerts.deletedSuccessfully"));
                _this6.isLoadingDetail = false;
                _context4.next = 19;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](3);

                console.error(_context4.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context4.t0.message);
                _this6.isLoadingDetail = false;

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[3, 14]]);
      }))();
    },
    isCheckSelectedControlPoints: function isCheckSelectedControlPoints() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this7.controlPointIds = [];
                _context5.next = 3;
                return _this7.controlPointList.forEach(function (element) {
                  if (element.isCheck == true) {
                    _this7.controlPointIds.push(element.id);
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    saveTourDetail: function saveTourDetail() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var tourDetail2, response, _tourDetail, _response2;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this8.guardTour.id == null)) {
                  _context6.next = 3;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen önce tur seçin...");
                return _context6.abrupt("return");

              case 3:
                if (!(_this8.tourDetail.time == "")) {
                  _context6.next = 6;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen zaman girin...");
                return _context6.abrupt("return");

              case 6:
                if (!(_this8.tourDetail.time < _this8.guardTour.startDate || _this8.tourDetail.time > _this8.guardTour.endDate)) {
                  _context6.next = 9;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen " + _this8.toDateFormat(_this8.guardTour.startDate, 'ss:dd') + "-" + _this8.toDateFormat(_this8.guardTour.endDate, 'ss:dd') + " tur saatleri içerisinde bir zaman seçin");
                return _context6.abrupt("return");

              case 9:
                _this8.isLoadingDetail = true;

                if (!_this8.isNewTourDetail) {
                  _context6.next = 34;
                  break;
                }

                _context6.prev = 11;
                _context6.next = 14;
                return _this8.isCheckSelectedControlPoints();

              case 14:
                if (!(_this8.controlPointIds.length == 0)) {
                  _context6.next = 17;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen kontrol noktası seçin...");
                return _context6.abrupt("return");

              case 17:
                tourDetail2 = _this8.tourDetail;
                _context6.next = 20;
                return _this8.$axios.post("/GuardTour/TourDetails", {
                  guardTourId: _this8.guardTour.id,
                  guardControlPointId: _this8.controlPointIds,
                  time: tourDetail2.time
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 20:
                response = _context6.sent;

                try {
                  if (response.status == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this8.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(response.message);
                  }
                } catch (error) {}
                _this8.getTourDetails(_this8.guardTour.id);
                _this8.isNewTourDetail = false;
                _this8.isLoadingDetail = false;
                _context6.next = 32;
                break;

              case 27:
                _context6.prev = 27;
                _context6.t0 = _context6["catch"](11);

                console.error(_context6.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context6.t0);
                _this8.isLoadingDetail = false;

              case 32:
                _context6.next = 52;
                break;

              case 34:
                if (!(_this8.tourDetail.guardControlPointId == null || _this8.tourDetail.guardControlPointId == "")) {
                  _context6.next = 37;
                  break;
                }

                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.warning("Lütfen kontrol noktası seçin...");
                return _context6.abrupt("return");

              case 37:
                _context6.prev = 37;
                _tourDetail = _this8.tourDetail;
                _context6.next = 41;
                return _this8.$axios.put("/GuardTour/TourDetails/" + _tourDetail.id, {
                  guardTourId: _this8.guardTour.id,
                  guardControlPointId: _tourDetail.guardControlPointId,
                  time: _tourDetail.time
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 41:
                _response2 = _context6.sent;

                try {
                  if (_response2.status == 200) {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.success(_this8.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_response2.message);
                  }
                } catch (error) {}
                _this8.getTourDetails(_this8.guardTour.id);
                _this8.isLoadingDetail = false;
                _context6.next = 52;
                break;

              case 47:
                _context6.prev = 47;
                _context6.t1 = _context6["catch"](37);

                console.error(_context6.t1);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context6.t1);
                _this8.isLoadingDetail = false;

              case 52:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[11, 27], [37, 47]]);
      }))();
    },
    getGuardTours: function getGuardTours() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var guardTours, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this9.isLoading = true;
                guardTours = [];
                _context7.next = 5;
                return _this9.$axios.get("/GuardTour").then(function (response) {
                  response.data.forEach(function (doc) {
                    guardTours.push({
                      id: doc.id,
                      name: doc.name,
                      startDate: doc.startDate ? _this9.toDateFormat(doc.startDate, "ss:dd") : "",
                      endDate: doc.endDate ? _this9.toDateFormat(doc.endDate, "ss:dd") : ""
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this9.guardTours = guardTours;
                _this9.isLoading = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context7.t0.message);
                _this9.isLoading = false;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 10]]);
      }))();
    },
    getTourDetails: function getTourDetails(tourId) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var tourDetails, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this10.isLoading = true;
                tourDetails = [];
                _context8.next = 5;
                return _this10.$axios.get("/GuardTour/TourDetails/" + tourId).then(function (response) {
                  response.data.forEach(function (doc) {
                    var cp = {
                      name: "",
                      areaId: null
                    };
                    if (doc.guardControlPointId) {
                      var cp2 = _this10.controlPointList.filter(function (a) {
                        return a.id == doc.guardControlPointId;
                      });
                    }
                    if (cp2[0]) {
                      cp = cp2[0];
                    }
                    tourDetails.push({
                      id: doc.id,
                      guardTourId: doc.guardTourId,
                      guardControlPointId: doc.guardControlPointId,
                      time: doc.time ? _this10.toDateFormat(doc.time, "ss:dd") : "",
                      controlPoint: cp
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context8.sent;

                _this10.tourDetails = tourDetails;
                _this10.isLoading = false;
                _context8.next = 15;
                break;

              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context8.t0.message);
                _this10.isLoading = false;

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 10]]);
      }))();
    },
    getAreas: function getAreas() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var areas, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this11.isLoading = true;
                areas = [];
                _context9.next = 5;
                return _this11.$axios.get("/GuardArea").then(function (response) {
                  response.data.forEach(function (doc) {
                    areas.push({
                      id: doc.id,
                      areaName: doc.areaName,
                      imagePath: doc.imagePath
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this11.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context9.sent;

                _this11.areas = areas;
                _this11.isLoading = false;
                _context9.next = 15;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context9.t0.message);
                _this11.isLoading = false;

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[0, 10]]);
      }))();
    },
    getControlPoints: function getControlPoints() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var controlPoints, response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this12.isLoading = true;
                controlPoints = [];
                _context10.next = 5;
                return _this12.$axios.get("/GuardControlPoint").then(function (response) {
                  response.data.forEach(function (doc) {
                    controlPoints.push({
                      id: doc.id,
                      areaId: doc.areaId,
                      name: doc.name,
                      imagePath: doc.imagePath,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(error.message);
                      _this12.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context10.sent;

                _this12.controlPoints = controlPoints;
                _this12.isLoading = false;
                _context10.next = 15;
                break;

              case 10:
                _context10.prev = 10;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                __WEBPACK_IMPORTED_MODULE_0_alertifyjs___default.a.error(_context10.t0.message);
                _this12.isLoading = false;

              case 15:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this13 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this13.getAreas();

            case 2:
              _context11.next = 4;
              return _this13.getControlPoints();

            case 4:
              _context11.next = 6;
              return _this13.getGuardTours();

            case 6:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11, _this13);
    }))();
  }
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      startDate: null,
      endDate: null,
      guards: [],
      logs: []
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthBekciTur;
    },
    guardList: function guardList() {
      return this.guards;
    },
    logList: function logList() {
      return this.logs;
    },
    checkedGuardCount: function checkedGuardCount() {
      var count = 0;
      this.guardList.forEach(function (a) {
        if (a.isCheck == true) {
          count += 1;
        }
      });
      return count;
    },
    checkedGuardList: function checkedGuardList() {
      var checkedList = "";
      var list = this.guardList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: _defineProperty({
    openWindow: function openWindow(log) {
      var url = 'http://maps.google.com/maps?f=q&hl=en&q=' + log.location.lat + '+N,+' + log.location.lon + '+E&ie=UTF8&t=k&om=0&ll=' + log.location.lat + ',' + log.location.lon + '&spn=0.003022,0.004989&t=k';
      window.open(url, '_blank', 'width=1200,height=800,resizable=yes,scrollbars=yes');
    },
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    clearCheckedGuards: function clearCheckedGuards() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.guards = [];
                _context.next = 3;
                return _this2.guardList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    getSelectedGuardList: function getSelectedGuardList() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var aList, selectedGuards, selectedGuardList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                aList = _this3.guards;
                selectedGuards = aList.filter(function (guard) {
                  return guard.isCheck == true;
                });
                selectedGuardList = [];
                _context2.next = 5;
                return selectedGuards.forEach(function (guard) {
                  selectedGuardList.push(guard.id);
                });

              case 5:
                return _context2.abrupt("return", selectedGuardList);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    send: function send() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var logs, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.startDate == null | _this4.endDate == null)) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.pleaseCheckEnteredValue"));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                _this4.isLoading = true;
                logs = [];
                _context3.next = 8;
                return _this4.getSelectedGuardList();

              case 8:
                selectedUser = _context3.sent;
                startDate = _this4.startDate;
                endDate = _this4.endDate;
                _context3.next = 13;
                return _this4.$axios.post("/Reports/GuardMovementReport", {
                  empIds: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.datas.forEach(function (doc) {
                    doc.veriler.forEach(function (satir) {
                      logs.push({
                        name: satir.name,
                        controlPoint: satir.controlPoint,
                        date: satir.date,
                        location: satir.location,
                        isOnlineRead: satir.isOnlineRead
                      });
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 13:
                response = _context3.sent;

                _this4.logs = logs;
                _this4.isLoading = false;
                _context3.next = 23;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this4.isLoading = false;

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 18]]);
      }))();
    },
    getGuards: function getGuards() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var guards, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoading = true;
                guards = [];
                _context4.next = 5;
                return _this5.$axios.get("/GuardDefinition").then(function (response) {
                  response.data.forEach(function (doc) {
                    guards.push({
                      id: doc.id,
                      name: doc.name,
                      title: doc.title,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this5.guards = guards;
                _this5.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    }
  }, "getDefaultDate", function getDefaultDate() {
    var toDay = new Date();
    var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
    var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
    var yil = toDay.getFullYear();
    if (this.startDate == null) {
      this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
    }
    if (this.endDate == null) {
      this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
    }
  }),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this6 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.getGuards();

            case 2:
              _context5.next = 4;
              return _this6.getDefaultDate();

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this6);
    }))();
  }
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            windowHeight: window.innerHeight,
            isLoading: false,
            tempImage: null,
            startDate: null,
            endDate: null,
            guards: [],
            logs: []
        };
    },

    filters: {
        toDateFormatGet: function toDateFormatGet(str) {
            if (!str) {
                return "";
            }
            str = new Date(str);
            var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
            var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
            var yil = str.getFullYear();
            var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
            var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
            return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
        }
    },
    computed: {
        authControl: function authControl() {
            return this.$store.getters.getAuthBekciTur;
        },
        guardList: function guardList() {
            return this.guards;
        },
        logList: function logList() {
            return this.logs;
        },
        checkedGuardList: function checkedGuardList() {
            var checkedList = "";
            var list = this.guardList.forEach(function (a) {
                if (a.isCheck == true) {
                    if (checkedList != "") {
                        checkedList += ", " + a.name;
                    } else {
                        checkedList += a.name;
                    }
                }
            });
            return checkedList;
        },
        windowHeightSize: function windowHeightSize() {
            if (this.windowHeight) {
                var height = this.windowHeight - 260;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    watch: {
        windowHeight: function windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                    //WEB
                }
        }
    },
    mounted: function mounted() {
        var _this = this;

        this.$nextTick(function () {
            window.addEventListener("resize", _this.onResize);
        });
    },

    methods: _defineProperty({
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
        },
        openImageModal: function openImageModal(photo) {
            this.tempImage = photo;
            $('#modal-image').modal('show');
        },
        exportToPDF: function exportToPDF() {
            this.$htmlToPaper("printReport");
        },
        getDefaultDate: function getDefaultDate() {
            var toDay = new Date();
            var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
            var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
            var yil = toDay.getFullYear();
            if (this.startDate == null) {
                this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
            }
            if (this.endDate == null) {
                this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
            }
        },
        clearCheckedGuards: function clearCheckedGuards() {
            var _this2 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this2.guardList.forEach(function (doc) {
                                    if (doc.isCheck == true) {
                                        doc.isCheck = false;
                                    }
                                });

                            case 2:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this2);
            }))();
        },
        getSelectedGuardList: function getSelectedGuardList() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var aList, selectedGuards, selectedGuardList;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                aList = _this3.guards;
                                selectedGuards = aList.filter(function (guard) {
                                    return guard.isCheck == true;
                                });
                                selectedGuardList = [];
                                _context2.next = 5;
                                return selectedGuards.forEach(function (guard) {
                                    selectedGuardList.push(guard.id);
                                });

                            case 5:
                                return _context2.abrupt("return", selectedGuardList);

                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this3);
            }))();
        },
        send: function send() {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var logs, selectedUser, startDate, endDate, response;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(_this4.startDate == null | _this4.endDate == null)) {
                                    _context3.next = 3;
                                    break;
                                }

                                alertify.warning(_this4.$ml.get("alerts.pleaseCheckEnteredValue"));
                                return _context3.abrupt("return");

                            case 3:
                                _context3.prev = 3;

                                _this4.isLoading = true;
                                logs = [];
                                _context3.next = 8;
                                return _this4.getSelectedGuardList();

                            case 8:
                                selectedUser = _context3.sent;
                                startDate = _this4.startDate;
                                endDate = _this4.endDate;
                                _context3.next = 13;
                                return _this4.$axios.post("/Reports/GuardIncidentReport", {
                                    empIds: selectedUser,
                                    startDate: startDate,
                                    endDate: endDate
                                }).then(function (response) {
                                    response.data.datas.forEach(function (doc) {
                                        doc.veriler.forEach(function (satir) {
                                            logs.push({
                                                name: satir.name,
                                                date: satir.date,
                                                description: satir.description,
                                                photos: satir.photos
                                            });
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this4.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this4.$ml.get("errors.connectionError"));
                                            _this4.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this4.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 13:
                                response = _context3.sent;

                                _this4.logs = logs;
                                _this4.isLoading = false;
                                _context3.next = 23;
                                break;

                            case 18:
                                _context3.prev = 18;
                                _context3.t0 = _context3["catch"](3);

                                console.error(_context3.t0);
                                alertify.error(_context3.t0.message);
                                _this4.isLoading = false;

                            case 23:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this4, [[3, 18]]);
            }))();
        },
        getGuards: function getGuards() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var guards, response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                _this5.isLoading = true;
                                guards = [];
                                _context4.next = 5;
                                return _this5.$axios.get("/GuardDefinition").then(function (response) {
                                    response.data.forEach(function (doc) {
                                        guards.push({
                                            id: doc.id,
                                            name: doc.name,
                                            title: doc.title,
                                            isCheck: true
                                        });
                                    });
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this5.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this5.$ml.get("errors.connectionError"));
                                            _this5.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this5.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context4.sent;

                                _this5.guards = guards;
                                _this5.isLoading = false;
                                _context4.next = 15;
                                break;

                            case 10:
                                _context4.prev = 10;
                                _context4.t0 = _context4["catch"](0);

                                console.error(_context4.t0);
                                alertify.error(_context4.t0.message);
                                _this5.isLoading = false;

                            case 15:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this5, [[0, 10]]);
            }))();
        }
    }, "getDefaultDate", function getDefaultDate() {
        var toDay = new Date();
        var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
        var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
        var yil = toDay.getFullYear();
        if (this.startDate == null) {
            this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
        }
        if (this.endDate == null) {
            this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
        }
    }),
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    created: function created() {
        var _this6 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                    switch (_context5.prev = _context5.next) {
                        case 0:
                            _context5.next = 2;
                            return _this6.getGuards();

                        case 2:
                            _context5.next = 4;
                            return _this6.getDefaultDate();

                        case 4:
                        case "end":
                            return _context5.stop();
                    }
                }
            }, _callee5, _this6);
        }))();
    }
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      inventoryCategory: {
        id: null,
        name: ""
      },
      inventoryCategories: [],
      isNewInventoryCategory: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    inventoryCategoryList: function inventoryCategoryList() {
      var _this = this;

      if (this.searchText) {
        return this.inventoryCategories.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.inventoryCategories;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newInventoryCategory: function newInventoryCategory() {
      this.isLoadingDetail = true;
      this.inventoryCategory.id = null;
      this.inventoryCategory.name = "";
      this.isLoadingDetail = false;
    },
    deleteInventoryCategory: function deleteInventoryCategory() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.inventoryCategory.id;
                _context.next = 5;
                return _this3.$axios.delete("/InventoryCategory/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getInventoryCategories();
                _this3.newInventoryCategory();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveInventoryCategory: function saveInventoryCategory() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var inventoryCategory2, response, id, _inventoryCategory, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.inventoryCategory.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!(_this4.inventoryCategory.id == null)) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 5;
                inventoryCategory2 = _this4.inventoryCategory;
                _context2.next = 9;
                return _this4.$axios.post("/InventoryCategory", {
                  name: inventoryCategory2.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getInventoryCategories();
                _this4.getInventoryCategory(id);
                _this4.isNewInventoryCategory = false;
                _this4.isLoadingDetail = false;
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 23:
                _context2.next = 40;
                break;

              case 25:
                _context2.prev = 25;
                _inventoryCategory = _this4.inventoryCategory;
                _context2.next = 29;
                return _this4.$axios.put("/InventoryCategory/" + _inventoryCategory.id, {
                  name: _inventoryCategory.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 29:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getInventoryCategories();
                _this4.isLoadingDetail = false;
                _context2.next = 40;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](25);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 18], [25, 35]]);
      }))();
    },
    getInventoryCategory: function getInventoryCategory(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/InventoryCategory/GetById/" + id).then(function (response) {
                  _this5.isNewInventoryCategory = false;
                  _this5.inventoryCategory.id = id;
                  _this5.inventoryCategory.name = response.data.name;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getInventoryCategories: function getInventoryCategories() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                _context4.next = 4;
                return _this6.$axios.get("/InventoryCategory/GetAll").then(function (response) {
                  _this6.inventoryCategories = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this6.isLoading = false;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this8.getInventoryCategories();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  }
});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      inventoryWarehouse: {
        id: null,
        name: ""
      },
      inventoryWarehouses: []
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    inventoryWarehouseList: function inventoryWarehouseList() {
      var _this = this;

      if (this.searchText) {
        return this.inventoryWarehouses.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.inventoryWarehouses;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newInventoryWarehouse: function newInventoryWarehouse() {
      this.isLoadingDetail = true;
      this.inventoryWarehouse.id = null;
      this.inventoryWarehouse.name = "";
      this.isLoadingDetail = false;
    },
    deleteInventoryWarehouse: function deleteInventoryWarehouse() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.inventoryWarehouse.id;
                _context.next = 5;
                return _this3.$axios.delete("/InventoryWarehouse/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getInventoryWarehouses();
                _this3.newInventoryWarehouse();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveInventoryWarehouse: function saveInventoryWarehouse() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var inventoryWarehouse2, response, id, _inventoryWarehouse, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.inventoryWarehouse.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!(_this4.inventoryWarehouse.id == null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.prev = 5;
                inventoryWarehouse2 = _this4.inventoryWarehouse;
                _context2.next = 9;
                return _this4.$axios.post("/InventoryWarehouse", {
                  name: inventoryWarehouse2.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getInventoryWarehouses();
                _this4.getInventoryWarehouse(id);
                _this4.isLoadingDetail = false;
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 22:
                _context2.next = 39;
                break;

              case 24:
                _context2.prev = 24;
                _inventoryWarehouse = _this4.inventoryWarehouse;
                _context2.next = 28;
                return _this4.$axios.put("/InventoryWarehouse/" + _inventoryWarehouse.id, {
                  name: _inventoryWarehouse.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getInventoryWarehouses();
                _this4.isLoadingDetail = false;
                _context2.next = 39;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](24);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 17], [24, 34]]);
      }))();
    },
    getInventoryWarehouse: function getInventoryWarehouse(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/InventoryWarehouse/GetById/" + id).then(function (response) {
                  _this5.inventoryWarehouse.id = id;
                  _this5.inventoryWarehouse.name = response.data.name;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getInventoryWarehouses: function getInventoryWarehouses() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                _context4.next = 4;
                return _this6.$axios.get("/InventoryWarehouse/GetAll").then(function (response) {
                  _this6.inventoryWarehouses = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this6.isLoading = false;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this8.getInventoryWarehouses();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  }
});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      inventoryField: {
        id: null,
        name: ""
      },
      inventoryFields: []
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    inventoryFieldList: function inventoryFieldList() {
      var _this = this;

      if (this.searchText) {
        return this.inventoryFields.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.inventoryFields;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newInventoryField: function newInventoryField() {
      this.isLoadingDetail = true;
      this.inventoryField.id = null;
      this.inventoryField.name = "";
      this.isLoadingDetail = false;
    },
    deleteInventoryField: function deleteInventoryField() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.inventoryField.id;
                _context.next = 5;
                return _this3.$axios.delete("/InventoryField/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getInventoryFields();
                _this3.newInventoryField();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveInventoryField: function saveInventoryField() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var inventoryField2, response, id, _inventoryField, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.inventoryField.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!(_this4.inventoryField.id == null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.prev = 5;
                inventoryField2 = _this4.inventoryField;
                _context2.next = 9;
                return _this4.$axios.post("/InventoryField", {
                  name: inventoryField2.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getInventoryFields();
                _this4.getInventoryField(id);
                _this4.isLoadingDetail = false;
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 22:
                _context2.next = 39;
                break;

              case 24:
                _context2.prev = 24;
                _inventoryField = _this4.inventoryField;
                _context2.next = 28;
                return _this4.$axios.put("/InventoryField/" + _inventoryField.id, {
                  name: _inventoryField.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getInventoryFields();
                _this4.isLoadingDetail = false;
                _context2.next = 39;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](24);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 17], [24, 34]]);
      }))();
    },
    getInventoryField: function getInventoryField(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/InventoryField/" + id).then(function (response) {
                  _this5.inventoryField.id = id;
                  _this5.inventoryField.name = response.data.name;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getInventoryFields: function getInventoryFields() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                _context4.next = 4;
                return _this6.$axios.get("/InventoryField/InventoryFields").then(function (response) {
                  _this6.inventoryFields = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this6.isLoading = false;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this8.getInventoryFields();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  }
});

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_vue__ = __webpack_require__(83);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            windowHeight: window.innerHeight,
            isLoading: false,
            isLoadingDetail: false,
            searchText: "",
            selectedCategory: 0,
            inventory: {
                id: null,
                name: "",
                code: "",
                serialNo: "",
                categoryId: 0,
                defaultWarehouseId: 0,
                quantity: 0,
                photoUrl: null,
                assignedCount: 0,
                assignedUsers: [],
                fields: []
            },
            document: {
                id: null,
                documentDefinitionId: null,
                description: "",
                filePath: null
            },
            selectedFile: null,
            newFieldId: null,
            newFieldValue: "",
            documentDefinitions: [],
            documents: [],
            inventories: [],
            inventoryFields: [],
            inventoryCategories: [],
            inventoryWarehouses: []
        };
    },

    computed: {
        authControl: function authControl() {
            return this.$store.getters.getAuthTanimlamalar;
        },
        documentList: function documentList() {
            return this.documents;
        },
        documentDefinitionList: function documentDefinitionList() {
            return this.documentDefinitions;
        },
        inventoryList: function inventoryList() {
            var _this = this;

            if (this.searchText) {
                return this.inventories.filter(function (item) {
                    return _this.searchText.toUpperCase().split(" ").every(function (v) {
                        return item.name.toUpperCase().includes(v);
                    });
                });
            } else if (this.selectedCategory && this.selectedCategory != 0) {
                return this.inventories.filter(function (item) {
                    return item.categoryId == _this.selectedCategory;
                });
            } else {
                return this.inventories;
            }
        },
        inventoryFieldList: function inventoryFieldList() {
            return this.inventoryFields;
        },
        inventoryCategoryList: function inventoryCategoryList() {
            return this.inventoryCategories;
        },
        inventoryWarehouseList: function inventoryWarehouseList() {
            return this.inventoryWarehouses;
        },
        windowHeightSize: function windowHeightSize() {
            if (this.windowHeight) {
                var height = this.windowHeight - 260;
                return "max-height:" + height + "px;overflow:auto;";
            } else {
                return "max-height:370px;overflow:auto;";
            }
        }
    },
    watch: {
        windowHeight: function windowHeight(newHeight, oldHeight) {
            if (newHeight < 576) {
                //MOBİL
            } else {
                    //WEB
                }
        }
    },
    mounted: function mounted() {
        var _this2 = this;

        this.$nextTick(function () {
            window.addEventListener("resize", _this2.onResize);
        });
    },

    methods: {
        onResize: function onResize() {
            this.windowHeight = window.innerHeight;
        },
        toDateFormat: function toDateFormat(str, format) {
            if (str.length > 9) {
                str = new Date(str);
            } else {
                str = new Date("1900-01-01 " + str.replace("Z", ""));
            }
            if (format == "gg.aa.yyyy ss:dd") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
            } else if (format == "gg.aa.yyyy") {
                var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
                var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
                var yil = str.getFullYear();
                return yil + "-" + ay + "-" + gun;
            } else if (format == "ss:dd:ss") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
                return saat + ":" + dakika + ":" + saniye;
            } else if (format == "ss:dd") {
                var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
                var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
                return saat + ":" + dakika;
            }
        },
        changeField: function changeField(event) {
            this.newFieldId = event.target.value;
        },
        changeCategory: function changeCategory(event) {
            this.inventory.categoryId = event.target.value;
        },
        changeDefaultWarehouse: function changeDefaultWarehouse(event) {
            this.inventory.defaultWarehouseId = event.target.value;
        },
        getDocumentDefinitionName: function getDocumentDefinitionName(documentDefinitionId) {
            var definition = this.documentDefinitions.find(function (d) {
                return d.id === documentDefinitionId;
            });
            return definition ? definition.name : "";
        },
        getInventoryCategoryName: function getInventoryCategoryName(categoryId) {
            var category = this.inventoryCategories.find(function (c) {
                return c.id === categoryId;
            });
            return category ? category.name : "";
        },
        newDocument: function newDocument() {
            this.document.id = null;
            this.document.documentDefinitionId = null;
            this.document.description = "";
            this.document.filePath = null;
            $('#modal-document').modal('show');
        },
        uploadDocumentDialog: function uploadDocumentDialog(document) {
            this.document.id = document.id;
            this.document.documentDefinitionId = document.documentDefinitionId;
            this.document.description = document.description;
            this.document.filePath = document.filePath;
            $('#modal-document-file').modal('show');
        },
        getDocument: function getDocument(document) {
            this.document.id = document.id;
            this.document.documentDefinitionId = document.documentDefinitionId;
            this.document.description = document.description;
            this.document.filePath = document.filePath;
            $('#modal-document').modal('show');
        },
        uploadFile: function uploadFile() {
            var fileName = document.getElementById("fileName").value;
            var idxDot = fileName.lastIndexOf(".") + 1;
            var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
            if (extFile == "zip" || extFile == "pdf" || extFile == "doc" || extFile == "docx" || extFile == "xls" || extFile == "xlsx" || extFile == "png" || extFile == "jpg" || extFile == "jpeg") {
                if (this.$refs.file.files[0].size > 29000000) {
                    //29 MB
                    alertify.warning(this.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
                    this.fileId = null;
                    this.$refs.file.value = "";
                    return;
                }
                this.selectedFile = this.$refs.file.files[0];
            } else {
                alertify.warning(this.$ml.get("alerts.pleaseCheckTheFileFormat"));
                return;
            }
        },
        submitFile: function submitFile() {
            var _this3 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var formData, responseFile;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this3.selectedFile) {
                                    _context.next = 9;
                                    break;
                                }

                                _this3.isLoading = true;
                                formData = new FormData();

                                formData.append("file", _this3.selectedFile);
                                _context.next = 6;
                                return _this3.$axios.patch("/Inventory/AddDocumentFile/" + _this3.document.id, formData, {
                                    headers: {
                                        "Content-Type": "multipart/form-data"
                                    }
                                }).then(function (response) {
                                    alertify.success(_this3.$ml.get("alerts.fileUploadSuccessfull"));
                                    _this3.getDocuments();
                                    $("#modal-document-file").modal("hide");
                                    _this3.isLoading = false;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this3.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this3.$ml.get('errors.connectionError'));
                                            _this3.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this3.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 6:
                                responseFile = _context.sent;
                                _context.next = 12;
                                break;

                            case 9:
                                _this3.isLoading = false;
                                alertify.warning(_this3.$ml.get("alerts.pleaseSelectFile"));
                                return _context.abrupt("return");

                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, _this3);
            }))();
        },
        deleteDocument: function deleteDocument(documentId) {
            var _this4 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var id, response;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;

                                _this4.isLoadingDetail = true;
                                id = documentId;
                                _context2.next = 5;
                                return _this4.$axios.delete("/Inventory/Document/" + id).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this4.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this4.$ml.get('errors.connectionError'));
                                            _this4.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this4.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context2.sent;

                                _this4.getDocuments();
                                alertify.success(_this4.$ml.get('alerts.deletedSuccessfully'));
                                _this4.isLoadingDetail = false;
                                _context2.next = 15;
                                break;

                            case 11:
                                _context2.prev = 11;
                                _context2.t0 = _context2["catch"](0);

                                alertify.error("Hata Oluştu : " + _context2.t0);
                                _this4.isLoadingDetail = false;

                            case 15:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4, [[0, 11]]);
            }))();
        },
        saveDocument: function saveDocument() {
            var _this5 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var document2, response, id, _document, _response;

                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                if (!(_this5.document.documentDefinitionId == null)) {
                                    _context3.next = 3;
                                    break;
                                }

                                alertify.warning(_this5.$ml.get('alerts.pleaseSelectADocumentDefinition'));
                                return _context3.abrupt("return");

                            case 3:
                                _this5.isLoadingDetail = true;

                                if (!(_this5.document.id == null)) {
                                    _context3.next = 23;
                                    break;
                                }

                                _context3.prev = 5;
                                document2 = _this5.document;
                                _context3.next = 9;
                                return _this5.$axios.post("/Inventory/Document", {
                                    inventoryId: _this5.inventory.id,
                                    documentDefinitionId: document2.documentDefinitionId,
                                    description: document2.description
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this5.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this5.$ml.get('errors.connectionError'));
                                            _this5.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this5.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 9:
                                response = _context3.sent;
                                id = response.data.id;

                                if (response.status == 200) {
                                    alertify.success(_this5.$ml.get('alerts.savedSuccessfully'));
                                } else {
                                    alertify.error(response.message);
                                }
                                _this5.getDocuments();
                                _this5.isLoadingDetail = false;
                                _context3.next = 21;
                                break;

                            case 16:
                                _context3.prev = 16;
                                _context3.t0 = _context3["catch"](5);

                                console.error(_context3.t0);
                                alertify.error(_context3.t0.message);
                                _this5.isLoadingDetail = false;

                            case 21:
                                _context3.next = 38;
                                break;

                            case 23:
                                _context3.prev = 23;
                                _document = _this5.document;
                                _context3.next = 27;
                                return _this5.$axios.put("/Inventory/Document/" + _document.id, {
                                    documentDefinitionId: _document.documentDefinitionId,
                                    description: _document.description
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this5.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this5.$ml.get('errors.connectionError'));
                                            _this5.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this5.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 27:
                                _response = _context3.sent;

                                if (_response.status == 200) {
                                    alertify.success(_this5.$ml.get('alerts.updatedSuccessfully'));
                                } else {
                                    alertify.error(_response.message);
                                }
                                _this5.getDocuments();
                                _this5.isLoadingDetail = false;
                                _context3.next = 38;
                                break;

                            case 33:
                                _context3.prev = 33;
                                _context3.t1 = _context3["catch"](23);

                                console.error(_context3.t1);
                                alertify.error(_context3.t1);
                                _this5.isLoadingDetail = false;

                            case 38:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this5, [[5, 16], [23, 33]]);
            }))();
        },
        getDocuments: function getDocuments() {
            var _this6 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var response;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;

                                _this6.isLoading = true;
                                _this6.documents = [];
                                _context4.next = 5;
                                return _this6.$axios.get("/Inventory/Documents/" + _this6.inventory.id).then(function (response) {
                                    _this6.documents = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this6.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this6.$ml.get('errors.connectionError'));
                                            _this6.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this6.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context4.sent;

                                _this6.isLoading = false;
                                _context4.next = 14;
                                break;

                            case 9:
                                _context4.prev = 9;
                                _context4.t0 = _context4["catch"](0);

                                console.error(_context4.t0);
                                alertify.error("Servis Hatası :" + _context4.t0.message);
                                _this6.isLoading = false;

                            case 14:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this6, [[0, 9]]);
            }))();
        },
        getDocumentDefinitions: function getDocumentDefinitions() {
            var _this7 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var response;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.prev = 0;

                                _this7.isLoading = true;
                                _this7.documentDefinitions = [];
                                _context5.next = 5;
                                return _this7.$axios.get("/DocumentDefinition/GetAll").then(function (response) {
                                    _this7.documentDefinitions = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this7.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this7.$ml.get('errors.connectionError'));
                                            _this7.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this7.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context5.sent;

                                _this7.isLoading = false;
                                _context5.next = 14;
                                break;

                            case 9:
                                _context5.prev = 9;
                                _context5.t0 = _context5["catch"](0);

                                console.error(_context5.t0);
                                alertify.error("Servis Hatası :" + _context5.t0.message);
                                _this7.isLoading = false;

                            case 14:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this7, [[0, 9]]);
            }))();
        },
        addField: function addField() {
            var _this8 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
                var response;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                if (!(_this8.newFieldId == 0 || _this8.newFieldId == null)) {
                                    _context6.next = 3;
                                    break;
                                }

                                alertify.warning(_this8.$ml.get('alerts.pleaseSelect'));
                                return _context6.abrupt("return");

                            case 3:
                                if (!(_this8.newFieldValue == null || _this8.newFieldValue == "")) {
                                    _context6.next = 6;
                                    break;
                                }

                                alertify.warning(_this8.$ml.get('alerts.pleaseEnterAValue'));
                                return _context6.abrupt("return");

                            case 6:
                                _this8.isLoadingDetail = true;
                                _context6.next = 9;
                                return _this8.$axios.post("/Inventory/AddFieldValue/" + _this8.inventory.id, {
                                    fieldId: _this8.newFieldId,
                                    value: _this8.newFieldValue
                                }).then(function (response) {
                                    if (response.status == 200) {
                                        alertify.success(_this8.$ml.get('alerts.savedSuccessfully'));
                                        _this8.getInventory(_this8.inventory.id);
                                        _this8.newFieldId = 0;
                                        _this8.newFieldValue = "";
                                    } else {
                                        alertify.error(response.message);
                                    }
                                    _this8.isLoadingDetail = false;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this8.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this8.$ml.get('errors.connectionError'));
                                            _this8.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this8.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 9:
                                response = _context6.sent;

                            case 10:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this8);
            }))();
        },
        deleteField: function deleteField(fieldId) {
            var _this9 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                var id, response;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                _context7.prev = 0;

                                _this9.isLoadingDetail = true;
                                id = fieldId;
                                _context7.next = 5;
                                return _this9.$axios.delete("/Inventory/RemoveFieldValue/" + _this9.inventory.id + "?inventoryFieldValueId=" + id).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this9.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this9.$ml.get('errors.connectionError'));
                                            _this9.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this9.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context7.sent;

                                _this9.getInventory(_this9.inventory.id);
                                alertify.success(_this9.$ml.get('alerts.deletedSuccessfully'));
                                _this9.isLoadingDetail = false;
                                _context7.next = 15;
                                break;

                            case 11:
                                _context7.prev = 11;
                                _context7.t0 = _context7["catch"](0);

                                alertify.error("Hata Oluştu : " + _context7.t0);
                                _this9.isLoadingDetail = false;

                            case 15:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, _this9, [[0, 11]]);
            }))();
        },
        newInventory: function newInventory() {
            this.isLoadingDetail = true;
            this.inventory.id = null;
            this.inventory.name = "";
            this.inventory.code = "";
            this.inventory.serialNo = "";
            this.inventory.categoryId = 0;
            this.inventory.defaultWarehouseId = 0;
            this.inventory.quantity = 0;
            this.inventory.photoUrl = null;
            this.documents = [];
            $("#temel-bilgiler").addClass("active");
            $("#temel-bilgiler-tab").addClass("active");
            $("#ozellikler").removeClass("active");
            $("#ozellikler-tab").removeClass("active");
            $("#belgeler").removeClass("active");
            $("#belgeler-tab").removeClass("active");
            $("#zimmetlenen-kisiler").removeClass("active");
            $("#zimmetlenen-kisiler-tab").removeClass("active");
            this.isLoadingDetail = false;
        },
        addPhoto: function addPhoto() {
            var _this10 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
                var fileName, idxDot, extFile, formData, responseImage;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                if (!(_this10.inventory.id == null)) {
                                    _context8.next = 5;
                                    break;
                                }

                                alertify.warning(_this10.$ml.get("alerts.pleaseSelect"));
                                return _context8.abrupt("return");

                            case 5:
                                fileName = document.getElementById("image").value;
                                idxDot = fileName.lastIndexOf(".") + 1;
                                extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

                                if (!(extFile == "png" || extFile == "jpg" || extFile == "jpeg" || extFile == "gif")) {
                                    _context8.next = 19;
                                    break;
                                }

                                if (!(_this10.$refs.imageFile.files[0].size > 29000000)) {
                                    _context8.next = 14;
                                    break;
                                }

                                //29 MB
                                alertify.warning(_this10.$ml.with("29 MB").get("alerts.fileSizeIsTooHigh"));
                                _this10.fileId = null;
                                _this10.$refs.imageFile.value = "";
                                return _context8.abrupt("return");

                            case 14:
                                formData = new FormData();

                                formData.append("file", _this10.$refs.imageFile.files[0]);
                                responseImage = _this10.$axios.patch("/Inventory/AddPhoto/" + _this10.inventory.id, formData).then(function (result2) {
                                    alertify.success(_this10.$ml.get("alerts.savedSuccessfully"));
                                    _this10.getInventory(_this10.inventory.id);
                                });
                                _context8.next = 21;
                                break;

                            case 19:
                                alertify.warning(_this10.$ml.get("alerts.pleaseCheckTheFileFormat"));
                                return _context8.abrupt("return");

                            case 21:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, _this10);
            }))();
        },
        removeImage: function removeImage() {
            var _this11 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
                var responseImage;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                if (!(_this11.inventory.id == null)) {
                                    _context9.next = 5;
                                    break;
                                }

                                alertify.warning(_this11.$ml.get("alerts.pleaseSelect"));
                                return _context9.abrupt("return");

                            case 5:
                                responseImage = _this11.$axios.delete("/Inventory/RemovePhoto/" + _this11.inventory.id).then(function (result) {
                                    _this11.inventory.photoUrl = null;
                                    alertify.success(_this11.$ml.get("alerts.updatedSuccessfully"));
                                });

                            case 6:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, _this11);
            }))();
        },
        deleteInventory: function deleteInventory() {
            var _this12 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                var id, response;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.prev = 0;

                                _this12.isLoadingDetail = true;
                                id = _this12.inventory.id;
                                _context10.next = 5;
                                return _this12.$axios.delete("/Inventory/" + id).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 400) {
                                            alertify.error("Silmek istenilen demirbaş kişi veya ziyaretçilere zimmet olarak tanımlı.");
                                        }
                                        if (error.response.status == 401) {
                                            _this12.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this12.$ml.get('errors.connectionError'));
                                            _this12.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this12.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context10.sent;

                                _this12.getInventories();
                                _this12.newInventory();
                                alertify.success(_this12.$ml.get('alerts.deletedSuccessfully'));
                                _this12.isLoadingDetail = false;
                                _context10.next = 16;
                                break;

                            case 12:
                                _context10.prev = 12;
                                _context10.t0 = _context10["catch"](0);

                                alertify.error("Hata Oluştu : " + _context10.t0);
                                _this12.isLoadingDetail = false;

                            case 16:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, _this12, [[0, 12]]);
            }))();
        },
        saveInventory: function saveInventory() {
            var _this13 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                var inventory2, response, id, _inventory, _response2;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                if (!(_this13.inventory.name == "")) {
                                    _context11.next = 3;
                                    break;
                                }

                                alertify.warning(_this13.$ml.get('alerts.pleaseEnterAName'));
                                return _context11.abrupt("return");

                            case 3:
                                _this13.isLoadingDetail = true;

                                if (!(_this13.inventory.id == null)) {
                                    _context11.next = 24;
                                    break;
                                }

                                _context11.prev = 5;
                                inventory2 = _this13.inventory;
                                _context11.next = 9;
                                return _this13.$axios.post("/Inventory", {
                                    name: inventory2.name,
                                    code: inventory2.code,
                                    serialNo: inventory2.serialNo,
                                    categoryId: inventory2.categoryId,
                                    defaultWarehouseId: inventory2.defaultWarehouseId,
                                    quantity: inventory2.quantity
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this13.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this13.$ml.get('errors.connectionError'));
                                            _this13.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this13.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 9:
                                response = _context11.sent;
                                id = response.data.id;

                                if (response.status == 200) {
                                    alertify.success(_this13.$ml.get("alerts.savedSuccessfully"));
                                } else {
                                    alertify.error(response.message);
                                }
                                _this13.getInventories();
                                _this13.getInventory(id);
                                _this13.isLoadingDetail = false;
                                _context11.next = 22;
                                break;

                            case 17:
                                _context11.prev = 17;
                                _context11.t0 = _context11["catch"](5);

                                console.error(_context11.t0);
                                alertify.error(_context11.t0.message);
                                _this13.isLoadingDetail = false;

                            case 22:
                                _context11.next = 39;
                                break;

                            case 24:
                                _context11.prev = 24;
                                _inventory = _this13.inventory;
                                _context11.next = 28;
                                return _this13.$axios.put("/Inventory/" + _inventory.id, {
                                    name: _inventory.name,
                                    code: _inventory.code,
                                    serialNo: _inventory.serialNo,
                                    categoryId: _inventory.categoryId,
                                    defaultWarehouseId: _inventory.defaultWarehouseId,
                                    quantity: _inventory.quantity
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this13.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this13.$ml.get('errors.connectionError'));
                                            _this13.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this13.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 28:
                                _response2 = _context11.sent;

                                if (_response2.status == 200) {
                                    alertify.success(_this13.$ml.get("alerts.updatedSuccessfully"));
                                } else {
                                    alertify.error(_response2.message);
                                }
                                _this13.getInventories();
                                _this13.isLoadingDetail = false;
                                _context11.next = 39;
                                break;

                            case 34:
                                _context11.prev = 34;
                                _context11.t1 = _context11["catch"](24);

                                console.error(_context11.t1);
                                alertify.error(_context11.t1);
                                _this13.isLoadingDetail = false;

                            case 39:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, _this13, [[5, 17], [24, 34]]);
            }))();
        },
        getInventory: function getInventory(id) {
            var _this14 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
                var response;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.prev = 0;

                                _this14.isLoadingDetail = true;
                                _context12.next = 4;
                                return _this14.$axios.get("/Inventory/" + id).then(function (response) {
                                    _this14.inventory.id = id;
                                    _this14.inventory.name = response.data.name;
                                    _this14.inventory.code = response.data.code;
                                    _this14.inventory.serialNo = response.data.serialNo;
                                    _this14.inventory.categoryId = response.data.categoryId;
                                    _this14.inventory.defaultWarehouseId = response.data.defaultWarehouseId;
                                    _this14.inventory.quantity = response.data.quantity;
                                    _this14.inventory.photoUrl = response.data.photoUrl;
                                    _this14.inventory.assignedCount = response.data.assignedCount;
                                    _this14.inventory.assignedUsers = response.data.assignedUsers;
                                    _this14.inventory.fields = response.data.fields;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this14.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this14.$ml.get('errors.connectionError'));
                                            _this14.isLoadingDetail = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this14.isLoadingDetail = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context12.sent;
                                _context12.next = 7;
                                return _this14.getDocuments();

                            case 7:
                                _this14.isLoadingDetail = false;
                                _context12.next = 15;
                                break;

                            case 10:
                                _context12.prev = 10;
                                _context12.t0 = _context12["catch"](0);

                                console.error(_context12.t0);
                                alertify.error(_context12.t0);
                                _this14.isLoadingDetail = false;

                            case 15:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, _this14, [[0, 10]]);
            }))();
        },
        getInventories: function getInventories() {
            var _this15 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
                var response;
                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.prev = 0;

                                _this15.isLoading = true;
                                _context13.next = 4;
                                return _this15.$axios.get("/Inventory/Inventories").then(function (response) {
                                    _this15.inventories = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this15.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this15.$ml.get('errors.connectionError'));
                                            _this15.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this15.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context13.sent;

                                _this15.isLoading = false;
                                _context13.next = 13;
                                break;

                            case 8:
                                _context13.prev = 8;
                                _context13.t0 = _context13["catch"](0);

                                console.error(_context13.t0);
                                alertify.error("Servis Hatası :" + _context13.t0.message);
                                _this15.isLoading = false;

                            case 13:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, _this15, [[0, 8]]);
            }))();
        },
        getInventoryWarehouses: function getInventoryWarehouses() {
            var _this16 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                var response;
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.prev = 0;

                                _this16.isLoading = true;
                                _context14.next = 4;
                                return _this16.$axios.get("/InventoryWarehouse/GetAll").then(function (response) {
                                    _this16.inventoryWarehouses = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this16.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this16.$ml.get('errors.connectionError'));
                                            _this16.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this16.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context14.sent;

                                _this16.isLoading = false;
                                _context14.next = 13;
                                break;

                            case 8:
                                _context14.prev = 8;
                                _context14.t0 = _context14["catch"](0);

                                console.error(_context14.t0);
                                alertify.error("Servis Hatası :" + _context14.t0.message);
                                _this16.isLoading = false;

                            case 13:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, _this16, [[0, 8]]);
            }))();
        },
        getInventoryCategories: function getInventoryCategories() {
            var _this17 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
                var response;
                return regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                        switch (_context15.prev = _context15.next) {
                            case 0:
                                _context15.prev = 0;

                                _this17.isLoading = true;
                                _context15.next = 4;
                                return _this17.$axios.get("/InventoryCategory/GetAll").then(function (response) {
                                    _this17.inventoryCategories = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this17.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this17.$ml.get('errors.connectionError'));
                                            _this17.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this17.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 4:
                                response = _context15.sent;

                                _this17.isLoading = false;
                                _context15.next = 13;
                                break;

                            case 8:
                                _context15.prev = 8;
                                _context15.t0 = _context15["catch"](0);

                                console.error(_context15.t0);
                                alertify.error("Servis Hatası :" + _context15.t0.message);
                                _this17.isLoading = false;

                            case 13:
                            case "end":
                                return _context15.stop();
                        }
                    }
                }, _callee15, _this17, [[0, 8]]);
            }))();
        },
        getInventoryFields: function getInventoryFields() {
            var _this18 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
                var fields, response;
                return regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                        switch (_context16.prev = _context16.next) {
                            case 0:
                                _context16.prev = 0;

                                _this18.isLoading = true;
                                fields = [];
                                _context16.next = 5;
                                return _this18.$axios.get("/InventoryField/InventoryFields").then(function (response) {
                                    fields = response.data;
                                }).catch(function (error) {
                                    if (error.response) {
                                        if (error.response.status == 401) {
                                            _this18.$store.dispatch("logout");
                                        }
                                    } else {
                                        if (error.message == "Network Error" || error.message == "Error: Network Error") {
                                            alertify.error(_this18.$ml.get('errors.connectionError'));
                                            _this18.isLoading = false;
                                            return;
                                        } else {
                                            console.error(error);
                                            alertify.error(error.message);
                                            _this18.isLoading = false;
                                            return;
                                        }
                                    }
                                });

                            case 5:
                                response = _context16.sent;

                                _this18.inventoryFields = fields;
                                _this18.isLoading = false;
                                _context16.next = 15;
                                break;

                            case 10:
                                _context16.prev = 10;
                                _context16.t0 = _context16["catch"](0);

                                console.error(_context16.t0);
                                alertify.error("Servis Hatası :" + _context16.t0.message);
                                _this18.isLoading = false;

                            case 15:
                            case "end":
                                return _context16.stop();
                        }
                    }
                }, _callee16, _this18, [[0, 10]]);
            }))();
        },
        getAuthControl: function getAuthControl() {
            var _this19 = this;

            return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
                return regeneratorRuntime.wrap(function _callee17$(_context17) {
                    while (1) {
                        switch (_context17.prev = _context17.next) {
                            case 0:
                                if (_this19.authControl == 1) {
                                    alertify.warning(_this19.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                                }

                            case 1:
                            case "end":
                                return _context17.stop();
                        }
                    }
                }, _callee17, _this19);
            }))();
        }
    },
    beforeDestroy: function beforeDestroy() {
        window.removeEventListener("resize", this.onResize);
    },
    created: function created() {
        var _this20 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
            return regeneratorRuntime.wrap(function _callee18$(_context18) {
                while (1) {
                    switch (_context18.prev = _context18.next) {
                        case 0:
                            _context18.next = 2;
                            return _this20.getAuthControl();

                        case 2:
                            _context18.next = 4;
                            return _this20.getInventories();

                        case 4:
                            _context18.next = 6;
                            return _this20.getInventoryFields();

                        case 6:
                            _context18.next = 8;
                            return _this20.getInventoryCategories();

                        case 8:
                            _context18.next = 10;
                            return _this20.getInventoryWarehouses();

                        case 10:
                            _context18.next = 12;
                            return _this20.getDocumentDefinitions();

                        case 12:
                        case "end":
                            return _context18.stop();
                    }
                }
            }, _callee18, _this20);
        }))();
    }
});

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingList: false,
      searchText: "",
      orderNameList: 0,
      cardDesigns: [],
      cardDesign: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      selectedItem: {
        id: null,
        title: "",
        type: 0, // 0=Text, 1=Value, 2=Image
        imageUrl: "/src/assets/default-user.png",
        width: 100,
        height: 20,
        top: 10,
        left: 10,
        text: "",
        value: 0,
        fontSize: 12,
        fontAlign: "left",
        fontWeight: "",
        fontItalic: "",
        fontColor: "#000000"
      },
      cardValues: [{
        id: 0,
        name: this.$ml.get("employees.registrationNumberInfo")
      }, {
        id: 1,
        name: this.$ml.get("employees.citizenshipNumber")
      }, {
        id: 2,
        name: this.$ml.get("employees.nameSurname")
      }, {
        id: 3,
        name: this.$ml.get("employees.department")
      }, {
        id: 4,
        name: this.$ml.get("employees.title")
      }, {
        id: 5,
        name: this.$ml.get("employees.dateofBirth")
      }, {
        id: 6,
        name: this.$ml.get("employees.dateOfStartWorkInfo")
      }, {
        id: 7,
        name: this.$ml.get("employees.status")
      }, {
        id: 8,
        name: this.$ml.get("employees.state")
      }, {
        id: 9,
        name: this.$ml.get("employees.stateNote")
      }, {
        id: 10,
        name: this.$ml.get("employees.deviceEmployeeNumber")
      }, {
        id: 11,
        name: this.$ml.get("employees.deviceStatus")
      }, {
        id: 12,
        name: this.$ml.get("employees.deviceCardNo")
      }, {
        id: 13,
        name: this.$ml.get("employees.plateNo")
      }, {
        id: 14,
        name: this.$ml.get("employees.hgsNo")
      }, {
        id: 15,
        name: this.$ml.get("employees.workPlan")
      }, {
        id: 16,
        name: this.$ml.get("employees.documentNo")
      }, {
        id: 17,
        name: this.$ml.get("employees.email")
      }, {
        id: 18,
        name: this.$ml.get("employees.address")
      }, {
        id: 19,
        name: this.$ml.get("employees.mobileNumber")
      }, {
        id: 20,
        name: this.$ml.get("employees.internal")
      }, {
        id: 21,
        name: this.$ml.get("employees.homePhone")
      }, {
        id: 22,
        name: this.$ml.get("employees.gender")
      }, {
        id: 23,
        name: this.$ml.get("employees.educationStatus")
      }, {
        id: 24,
        name: this.$ml.get("employees.militaryStatus")
      }, {
        id: 25,
        name: this.$ml.get("employees.maritalStatus")
      }, {
        id: 26,
        name: this.$ml.get("employees.drivingLicence")
      }, {
        id: 27,
        name: this.$ml.get("employees.foreignLanguage")
      }, {
        id: 28,
        name: this.$ml.get("employees.bloodType")
      }],
      imageData: null
    };
  },

  computed: {
    filtered: function filtered() {
      return this.cardDesigns;
    },
    cardDesignList: function cardDesignList() {
      return this.cardDesigns;
    },
    cardItems: function cardItems() {
      return this.cardDesign.template.items;
    },
    cardLabelItems: function cardLabelItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 0;
      });
    },
    cardValueItems: function cardValueItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 1;
      });
    },
    cardImageItems: function cardImageItems() {
      return this.cardDesign.template.items.filter(function (a) {
        return a.type == 2;
      });
    }
  },
  filters: {
    readMore: function readMore(str) {
      if (str) {
        if (str.length > 75) {
          return str.slice(0, 75) + " ...";
        } else {
          return str;
        }
      } else {
        return str;
      }
    }
  },
  methods: {
    onFilePicked: function onFilePicked(event) {
      var _this = this;

      this.isLoading = true;
      var files = event.target.files;
      var filename = files[0].name;
      this.imageData = files[0];
      var fileReader = new FileReader();
      fileReader.addEventListener("load", function () {
        _this.cardDesign.backgroundImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.isLoading = false;
    },
    changebackgroundColor: function changebackgroundColor(event) {
      this.cardDesign.backgroundColor = event.target.value;
    },
    changeFontColor: function changeFontColor(event) {
      this.selectedItem.fontColor = event.target.value;
    },
    changeType: function changeType(event) {
      this.selectedItem.type = event.target.value;
      if (this.selectedItem.type == 0) {
        this.selectedItem.height = 20;
      } else if (this.selectedItem.type == 1) {
        this.selectedItem.value = this.cardValues[0].id;
        this.selectedItem.height = 20;
      } else {
        this.selectedItem.height = 100;
      }
    },
    changeAlign: function changeAlign(align) {
      this.selectedItem.fontAlign = align;
    },
    changeFontWeight: function changeFontWeight(weight) {
      if (this.selectedItem.fontWeight == weight) {
        this.selectedItem.fontWeight = "";
      } else {
        this.selectedItem.fontWeight = weight;
      }
    },
    changeFontItalic: function changeFontItalic(italic) {
      if (this.selectedItem.fontItalic == italic) {
        this.selectedItem.fontItalic = "";
      } else {
        this.selectedItem.fontItalic = italic;
      }
    },
    changeCardValue: function changeCardValue(event) {
      this.selectedItem.value = event.target.value;
    },
    getValueTitle: function getValueTitle(valueId) {
      var val = this.cardValues.filter(function (v) {
        return v.id == valueId;
      });
      if (val[0]) {
        return "{" + val[0].name + "}";
      } else {
        return "";
      }
    },
    removeItem: function removeItem(index) {
      this.cardDesign.template.items.splice(index, 1);
    },
    newCardDesign: function newCardDesign() {
      this.cardDesign.id = null;
      this.cardDesign.name = "";
      this.cardDesign.backgroundImage = null;
      this.cardDesign.backgroundColor = "#ffffff";
      this.cardDesign.template = {
        items: []
      };
    },
    newItem: function newItem() {
      var a = {
        id: null,
        title: "",
        type: 0,
        imageUrl: "/src/assets/default-user.png",
        width: 100,
        height: 100,
        top: 10,
        left: 10,
        text: "",
        fontSize: 12,
        fontAlign: "left",
        fontWeight: "",
        fontItalic: "",
        fontColor: "#000000"
      };
      this.selectedItem = a;
    },
    selectItem: function selectItem(cardItem) {
      this.selectedItem = cardItem;
    },
    addItem: function addItem() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var index;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.selectedItem.type == 0)) {
                  _context.next = 7;
                  break;
                }

                if (!(_this2.selectedItem.text == "")) {
                  _context.next = 4;
                  break;
                }

                alertify.warning("Lütfen bir metin girin...");
                return _context.abrupt("return");

              case 4:
                _this2.selectedItem.title = _this2.selectedItem.text;
                _context.next = 14;
                break;

              case 7:
                if (!(_this2.selectedItem.type == 1)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 10;
                return _this2.getValueTitle(_this2.selectedItem.value);

              case 10:
                _this2.selectedItem.title = _context.sent;
                _context.next = 14;
                break;

              case 13:
                _this2.selectedItem.title = "Profil Fotoğrafı";

              case 14:
                index = 1;
                _context.next = 17;
                return _this2.cardDesign.template.items.forEach(function (a) {
                  if (a.id >= index) {
                    index = index + 1;
                  }
                });

              case 17:
                _this2.selectedItem.id = index;
                _this2.cardDesign.template.items.push(_this2.selectedItem);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    deleteCardDesign: function deleteCardDesign(id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (id) {
                  _context2.next = 4;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.pleaseSelect"));
                _context2.next = 19;
                break;

              case 4:
                _this3.isLoadingReader = true;
                _context2.prev = 5;
                _context2.next = 8;
                return _this3.$axios.delete("/CardDesign/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context2.sent;

                _this3.getCardDesigns();
                _this3.newCardDesign();
                alertify.success(_this3.$ml.get("alerts.deletedSuccessfully"));
                _this3.isLoadingReader = false;
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](5);

                alertify.error("Hata Oluştu : " + _context2.t0);
                _this3.isLoadingReader = false;

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 15]]);
      }))();
    },
    saveCard: function saveCard() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var image, response, id, formData, responseImage, _image, _response, _formData, _responseImage;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.cardDesign.name == "")) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning("Lütfen Şablon Adı Girin...");
                return _context3.abrupt("return");

              case 3:
                _this4.isLoading = true;

                if (_this4.cardDesign.id) {
                  _context3.next = 29;
                  break;
                }

                _context3.prev = 5;
                image = _this4.imageData;
                _context3.next = 9;
                return _this4.$axios.post("/CardDesign", {
                  name: _this4.cardDesign.name,
                  template: _this4.cardDesign.template,
                  backgroundColor: _this4.cardDesign.backgroundColor
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context3.sent;
                id = response.data.id;

                if (!_this4.imageData) {
                  _context3.next = 18;
                  break;
                }

                formData = new FormData();

                formData.append("file", image);

                if (!(_this4.imageData != null)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 17;
                return _this4.$axios.post("/CardDesign/AddImage/" + id, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 17:
                responseImage = _context3.sent;

              case 18:
                try {
                  if (response.status == 200) {
                    _this4.getCardDesigns();
                    _this4.getCardDesign(id);
                    alertify.success(_this4.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                } catch (error) {}
                _this4.isLoading = false;
                _context3.next = 27;
                break;

              case 22:
                _context3.prev = 22;
                _context3.t0 = _context3["catch"](5);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this4.isLoading = false;

              case 27:
                _context3.next = 50;
                break;

              case 29:
                _context3.prev = 29;
                _image = _this4.imageData;
                _context3.next = 33;
                return _this4.$axios.post("/CardDesign/" + _this4.cardDesign.id, {
                  name: _this4.cardDesign.name,
                  template: _this4.cardDesign.template,
                  backgroundColor: _this4.cardDesign.backgroundColor
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 33:
                _response = _context3.sent;

                if (!_this4.imageData) {
                  _context3.next = 41;
                  break;
                }

                _formData = new FormData();

                _formData.append("file", _image);

                if (!(_this4.imageData != null)) {
                  _context3.next = 41;
                  break;
                }

                _context3.next = 40;
                return _this4.$axios.post("/CardDesign/AddImage/" + _this4.cardDesign.id, _formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                });

              case 40:
                _responseImage = _context3.sent;

              case 41:
                try {
                  if (_response.status == 200) {
                    _this4.getCardDesigns();
                    alertify.success(_this4.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response.message);
                  }
                } catch (error) {}
                _this4.isLoading = false;
                _context3.next = 50;
                break;

              case 45:
                _context3.prev = 45;
                _context3.t1 = _context3["catch"](29);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this4.isLoading = false;

              case 50:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[5, 22], [29, 45]]);
      }))();
    },
    itemStyle: function itemStyle(item) {
      var selectedStyle = "";
      if (item.id == this.selectedItem.id) {
        if (item.type == 1) {
          selectedStyle = "border:1px dashed blue;font-weight:initial;";
        } else {
          selectedStyle = "border:1px dashed red;font-weight:initial;";
        }
      }
      return selectedStyle + "cursor:pointer;position:absolute;width:" + item.width + "px;height:" + item.height + "px;top:" + item.top + "px;left:" + item.left + "px;font-size:" + item.fontSize + "px;text-align:" + item.fontAlign + ";" + item.fontWeight + item.fontItalic + ";color:" + item.fontColor + ";";
    },
    imageItemStyle: function imageItemStyle(item) {
      var selectedStyle = "";
      if (item.id == this.selectedItem.id) {
        selectedStyle = "border:1px dashed red;";
      }
      return selectedStyle + "cursor:pointer;position:absolute;width:" + item.width + "px;height:" + item.height + "px;top:" + item.top + "px;left:" + item.left + "px;";
    },
    getCardDesign: function getCardDesign(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoadingReader = true;
                _context4.next = 4;
                return _this5.$axios.get("/CardDesign/" + id).then(function (response) {
                  _this5.cardDesign = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;
                _context4.next = 12;
                break;

              case 7:
                _context4.prev = 7;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0);
                _this5.isLoadingReader = false;

              case 12:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 7]]);
      }))();
    },
    getCardDesigns: function getCardDesigns() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var cardDesigns, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                cardDesigns = [];
                _context5.next = 4;
                return _this6.$axios.get("/CardDesign").then(function (response) {
                  response.data.forEach(function (doc) {
                    cardDesigns.push({
                      id: doc.id,
                      name: doc.name,
                      backgroundImage: doc.backgroundImage,
                      backgroundColor: doc.backgroundColor,
                      template: doc.template
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context5.sent;

                _this6.cardDesigns = cardDesigns;
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası :" + _context5.t0.message);

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 8]]);
      }))();
    }
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.getCardDesigns();

            case 2:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }
});

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      searchText: "",
      selectedExtraField: {
        id: null,
        name: ""
      },
      extraFields: [],
      isNewExtraField: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    extraFieldList: function extraFieldList() {
      var _this = this;

      if (this.searchText) {
        return this.extraFields.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.extraFields;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    selectExtraField: function selectExtraField(extraField) {
      this.isNewExtraField = false;
      this.selectedExtraField.id = extraField.id;
      this.selectedExtraField.name = extraField.name;
    },
    newExtraField: function newExtraField() {
      this.isNewExtraField = true;
      this.selectedExtraField.id = null;
      this.selectedExtraField.name = "";
    },
    saveExtraField: function saveExtraField() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var selectedExtraField2, _selectedExtraField, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.selectedExtraField.name == "")) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.pleaseEnterAName"));
                return _context.abrupt("return");

              case 3:
                _this3.isLoading = true;

                if (!_this3.isNewExtraField) {
                  _context.next = 19;
                  break;
                }

                _context.prev = 5;
                selectedExtraField2 = _this3.selectedExtraField;
                _context.next = 9;
                return _this3.$axios.post("/ExtraField", {
                  definition: selectedExtraField2.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this3.$ml.get("alerts.savedSuccessfully"));
                    _this3.getExtraFields();
                    _this3.newExtraField();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                _this3.isLoading = false;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this3.isLoading = false;

              case 17:
                _context.next = 32;
                break;

              case 19:
                _context.prev = 19;
                _selectedExtraField = _this3.selectedExtraField;
                _context.next = 23;
                return _this3.$axios.post("/ExtraField/" + _selectedExtraField.id, {
                  definition: _selectedExtraField.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this3.$ml.get("alerts.updatedSuccessfully"));
                    _this3.getExtraFields();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 23:
                response = _context.sent;

                _this3.isLoading = false;
                _context.next = 32;
                break;

              case 27:
                _context.prev = 27;
                _context.t1 = _context["catch"](19);

                console.error(_context.t1);
                alertify.error(_context.t1.message);
                _this3.isLoading = false;

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[5, 12], [19, 27]]);
      }))();
    },
    deleteExtraField: function deleteExtraField() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this4.isLoading = true;
                id = _this4.selectedExtraField.id;
                _context2.next = 5;
                return _this4.$axios.delete("/ExtraField/" + id).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get("alerts.deletedSuccessfully"));
                    _this4.getExtraFields();
                    _this4.newExtraField();
                  } else {
                    alertify.error(response.message);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this4.isLoading = false;
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoading = false;

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[0, 9]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var extraFields, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoading = true;
                extraFields = [];
                _context3.next = 5;
                return _this5.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extraFields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this5.extraFields = extraFields;
                _this5.isLoading = false;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this6.authControl == 1) {
                  alertify.warning(_this6.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.getAuthControl();

            case 2:
              _context5.next = 4;
              return _this7.getExtraFields();

            case 4:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this7);
    }))();
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      documentDefinition: {
        id: null,
        name: ""
      },
      documentDefinitions: [],
      isNewDocumentDefinition: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    documentDefinitionList: function documentDefinitionList() {
      var _this = this;

      if (this.searchText) {
        return this.documentDefinitions.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.documentDefinitions;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newDocumentDefinition: function newDocumentDefinition() {
      this.isLoadingDetail = true;
      this.isNewDocumentDefinition = true;
      this.documentDefinition.id = null;
      this.documentDefinition.name = "";
      this.isLoadingDetail = false;
    },
    deleteDocumentDefinition: function deleteDocumentDefinition() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.documentDefinition.id;
                _context.next = 5;
                return _this3.$axios.delete("/DocumentDefinition/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getDocumentDefinitions();
                _this3.newDocumentDefinition();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveDocumentDefinition: function saveDocumentDefinition() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var documentDefinition2, response, id, _documentDefinition, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.documentDefinition.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!_this4.isNewDocumentDefinition) {
                  _context2.next = 24;
                  break;
                }

                _context2.prev = 5;
                documentDefinition2 = _this4.documentDefinition;
                _context2.next = 9;
                return _this4.$axios.post("/DocumentDefinition", {
                  name: documentDefinition2.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getDocumentDefinitions();
                _this4.newDocumentDefinition();
                _this4.isLoadingDetail = false;
                _context2.next = 22;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 22:
                _context2.next = 39;
                break;

              case 24:
                _context2.prev = 24;
                _documentDefinition = _this4.documentDefinition;
                _context2.next = 28;
                return _this4.$axios.put("/DocumentDefinition/" + _documentDefinition.id, {
                  name: _documentDefinition.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 28:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getDocumentDefinitions();
                _this4.isLoadingDetail = false;
                _context2.next = 39;
                break;

              case 34:
                _context2.prev = 34;
                _context2.t1 = _context2["catch"](24);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 17], [24, 34]]);
      }))();
    },
    getDocumentDefinition: function getDocumentDefinition(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/DocumentDefinition/GetById/" + id).then(function (response) {
                  _this5.isNewDocumentDefinition = false;
                  _this5.documentDefinition.id = id;
                  _this5.documentDefinition.name = response.data.name;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getDocumentDefinitions: function getDocumentDefinitions() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var documentDefinitions, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                documentDefinitions = [];
                _context4.next = 5;
                return _this6.$axios.get("/DocumentDefinition/GetAll").then(function (response) {
                  response.data.forEach(function (doc) {
                    documentDefinitions.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this6.documentDefinitions = documentDefinitions;
                _this6.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this8.getDocumentDefinitions();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  }
});

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      department: {
        id: null,
        name: "",
        mainDepartmentId: null,
        isActive: true,
        locationTree: "",
        displayOnDashboard: false,
        authorizedUser1: 0,
        authorizedUser2: 0
      },
      users: [],
      departments: [],
      isNewDepartment: true
    };
  },

  computed: {
    activeUser: function activeUser() {
      return this.$store.getters.getUser;
    },
    userList: function userList() {
      var _this = this;

      return this.users.sort(function (a, b) {
        return _this.turkishToUpper(a.name).localeCompare(_this.turkishToUpper(b.name));
      });
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    getDepartmentList: function getDepartmentList() {
      return this.departments.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 240;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeAuthUser1: function changeAuthUser1(event) {
      this.department.authorizedUser1 = event.target.value;
    },
    changeAuthUser2: function changeAuthUser2(event) {
      this.department.authorizedUser2 = event.target.value;
    },
    changeMainDepartment: function changeMainDepartment(event) {
      this.department.mainDepartmentId = event.target.value;
    },
    newDepartment: function newDepartment() {
      this.isLoading = true;
      this.isNewDepartment = true;
      this.department.id = null;
      this.department.name = "";
      this.department.mainDepartmentId = null;
      this.department.displayOnDashboard = false;
      this.department.isActive = true;
      this.department.locationTree = "";
      this.department.authorizedUser1 = 0;
      this.department.authorizedUser2 = 0;
      this.isLoading = false;
    },
    selectNode: function selectNode() {
      this.isLoading = true;
      var node = document.getElementById("selectedNode").value;
      var selectedDepartment = this.getDepartmentFromName(node);
      if (selectedDepartment != null) {
        this.department.id = selectedDepartment.id;
        this.department.name = selectedDepartment.name;
        this.department.mainDepartmentId = selectedDepartment.mainDepartmentId;
        this.department.isActive = selectedDepartment.isActive;
        this.department.displayOnDashboard = selectedDepartment.displayOnDashboard;
        this.department.locationTree = selectedDepartment.locationTree;
        this.department.authorizedUser1 = selectedDepartment.authorizedUser1;
        this.department.authorizedUser2 = selectedDepartment.authorizedUser2;
        this.isNewDepartment = false;
      }
      this.isLoading = false;
    },
    selectDepartment: function selectDepartment(id) {
      var selectedDepartment = this.getDepartmentFromId(id);
      if (selectedDepartment != null) {
        this.department.id = selectedDepartment.id;
        this.department.name = selectedDepartment.name;
        this.department.mainDepartmentId = selectedDepartment.mainDepartmentId;
        this.department.isActive = selectedDepartment.isActive;
        this.department.displayOnDashboard = selectedDepartment.displayOnDashboard;
        this.department.locationTree = selectedDepartment.locationTree;
        this.department.authorizedUser1 = selectedDepartment.authorizedUser1;
        this.department.authorizedUser2 = selectedDepartment.authorizedUser2;
        this.isNewDepartment = false;
      }
    },
    getDepartmentFromId: function getDepartmentFromId(id) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.id == id;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    getDepartmentFromName: function getDepartmentFromName(name) {
      var aList = this.departments;
      var dep = aList.filter(function (department) {
        return department.name == name;
      });
      if (dep != "" && dep != null) {
        return dep[0];
      } else {
        return null;
      }
    },
    deleteDepartment: function deleteDepartment() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this3.isNewDepartment) {
                  _context.next = 4;
                  break;
                }

                alertify.warning(_this3.$ml.get("alerts.selectedDepartmentNotBlank"));
                _context.next = 20;
                break;

              case 4:
                _context.prev = 4;

                _this3.isLoadingDetail = true;
                id = _this3.department.id;
                _context.next = 9;
                return _this3.$axios.delete("/Department/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context.sent;

                _this3.getDepartments();
                _this3.newDepartment();
                alertify.success(_this3.$ml.get("alerts.deletedSuccessfully"));
                _this3.isLoadingDetail = false;
                _context.next = 20;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](4);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[4, 16]]);
      }))();
    },
    setLocationTree: function setLocationTree(mainDepId) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var aList, dep;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(mainDepId != null)) {
                  _context2.next = 10;
                  break;
                }

                aList = _this4.departments;
                dep = aList.filter(function (department) {
                  return department.id == mainDepId;
                });

                if (!(dep[0].locationTree != "" && dep[0].locationTree != null)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", dep[0].locationTree + mainDepId + "/");

              case 7:
                return _context2.abrupt("return", "/0/");

              case 8:
                _context2.next = 11;
                break;

              case 10:
                return _context2.abrupt("return", "/0/");

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    saveDepartment: function saveDepartment() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var department2, response, id, _department, _response;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this5.department.id == _this5.department.mainDepartmentId && _this5.department.id != null)) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.departmentAndMainDepartmentOverlap"));
                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return _this5.setLocationTree(_this5.department.mainDepartmentId);

              case 5:
                _this5.department.locationTree = _context3.sent;

                _this5.isLoadingDetail = true;

                if (!_this5.isNewDepartment) {
                  _context3.next = 28;
                  break;
                }

                _context3.prev = 8;
                department2 = _this5.department;
                _context3.next = 12;
                return _this5.$axios.post("/Department", {
                  name: department2.name,
                  mainDepartmentId: parseInt(department2.mainDepartmentId),
                  isActive: department2.isActive,
                  locationTree: department2.locationTree,
                  displayOnDashboard: department2.displayOnDashboard,
                  authorizedUser1: department2.authorizedUser1,
                  authorizedUser2: department2.authorizedUser2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 12:
                response = _context3.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this5.getDepartments();
                _this5.getDepartmentFromId(id);
                _this5.isNewDepartment = false;
                _this5.isLoadingDetail = false;
                _context3.next = 26;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3["catch"](8);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this5.isLoadingDetail = false;

              case 26:
                _context3.next = 43;
                break;

              case 28:
                _context3.prev = 28;
                _department = _this5.department;
                _context3.next = 32;
                return _this5.$axios.post("/Department/" + _department.id, {
                  name: _department.name,
                  mainDepartmentId: parseInt(_department.mainDepartmentId),
                  isActive: _department.isActive,
                  locationTree: _department.locationTree,
                  displayOnDashboard: _department.displayOnDashboard,
                  authorizedUser1: _department.authorizedUser1,
                  authorizedUser2: _department.authorizedUser2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context3.sent;

                if (_response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response.message);
                }
                _this5.getDepartments();
                _this5.isLoadingDetail = false;
                _context3.next = 43;
                break;

              case 38:
                _context3.prev = 38;
                _context3.t1 = _context3["catch"](28);

                console.error(_context3.t1);
                alertify.error(_context3.t1);
                _this5.isLoadingDetail = false;

              case 43:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[8, 21], [28, 38]]);
      }))();
    },
    setTree: function setTree() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var departments, root, tree;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                departments = _this6.departments;
                root = new TreeNode(_this6.activeUser.companyName + " ( " + _this6.$ml.get("shared.company") + " )");
                _context4.next = 4;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == null) {
                    var node = new TreeNode(doc.name);
                    root.addChild(node);
                    _this6.addChildDep(node, doc.id);
                  }
                });

              case 4:
                tree = new TreeView(root, "#treeview", {
                  leaf_icon: "<i class='fa fa-star'></i>",
                  parent_icon: "<i class='fa fa-sitemap'></i>",
                  open_icon: "<i class='fa fa-chevron-down'></i>",
                  close_icon: "<i class='fa fa-chevron-right'></i>"
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    addChildDep: function addChildDep(Tnode, mainDep) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var departments;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                departments = _this7.departments;
                _context5.next = 3;
                return departments.forEach(function (doc) {
                  if (doc.mainDepartmentId == mainDep) {
                    var node = new TreeNode(doc.name);
                    Tnode.addChild(node);
                    _this7.addChildDep(node, doc.id);
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var departmentList, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this8.isLoading = true;
                departmentList = [];
                _context6.prev = 2;
                _context6.next = 5;
                return _this8.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departmentList.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      displayOnDashboard: doc.displayOnDashboard,
                      userId: doc.userId,
                      authorizedUser1: doc.authorizedUser1,
                      authorizedUser2: doc.authorizedUser2
                    });
                  });
                  departmentList.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this8.departments = departmentList;
                _this8.setTree();
                _this8.isLoading = false;
                _context6.next = 16;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](2);

                console.error(_context6.t0);
                alertify.error(_context6.t0);
                _this8.isLoading = false;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[2, 11]]);
      }))();
    },
    getChildDep: function getChildDep(dep) {
      var DepartmentList = this.departments;
      return DepartmentList.filter(function (department) {
        return department.id == dep.mainDepartmentId;
      });
    },
    getMainFind: function getMainFind(id) {
      var DepartmentList = this.departments;
      var department = DepartmentList.filter(function (department) {
        return department.id == id;
      });
    },
    getUsers: function getUsers() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var users, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this9.isLoading = true;
                users = [];
                _context7.next = 5;
                return _this9.$axios.get("/User").then(function (response) {
                  response.data.forEach(function (doc) {
                    users.push({
                      id: doc.id,
                      name: doc.name,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this9.users = users;
                _this9.isLoading = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0.message);
                _this9.isLoading = false;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this10.authControl == 1) {
                  alertify.warning(_this10.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this11.getAuthControl();

            case 2:
              _context9.next = 4;
              return _this11.getUsers();

            case 4:
              _context9.next = 6;
              return _this11.getDepartments();

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this11);
    }))();
  }
});

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      selectedTemplate: 0,
      accessGroup: {
        id: null,
        name: "",
        isNewReaderAdd: true,
        selectedReaders: []
      },
      accessGroups: [],
      isNewAccessGroup: true,
      isCheck: false,
      readers: []
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthGecisYetkileri;
    },
    readerList: function readerList() {
      return this.readers;
    },
    accessGroupList: function accessGroupList() {
      var _this = this;

      if (this.searchText) {
        return this.accessGroups.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.accessGroups;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    checkReaders: function checkReaders() {
      var _this3 = this;

      this.isCheck = !this.isCheck;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this3.isCheck) {
          doc.check = _this3.isCheck;
        }
      });
    },
    checkFalseReaders: function checkFalseReaders() {
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == true) {
          doc.check = false;
        }
      });
    },
    checkReader: function checkReader(id) {
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.readerId == id) {
          doc.check = true;
        }
      });
    },
    changeTemplate: function changeTemplate(event) {
      this.selectedTemplate = event.target.value;
    },
    applyTemplate: function applyTemplate() {
      var _this4 = this;

      if (this.selectedTemplate != 0) {
        var ac = this.accessGroupList.filter(function (a) {
          return a.id == _this4.selectedTemplate;
        });
        this.readers.forEach(function (reader) {
          ac[0].selectedReaders.forEach(function (doc) {
            if (reader.readerId == doc.id) {
              reader.check = true;
            }
          });
        });
        this.selectedTemplate = 0;
      } else {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
        return;
      }
    },
    getCheckReaderList: function getCheckReaderList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var aList, selected;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                aList = _this5.readers;
                selected = "";
                _context.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    selected = selected + doc.readerId + ",";
                  }
                });

              case 4:
                return _context.abrupt("return", selected);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    selectAccessGroup: function selectAccessGroup(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var aList, aList2;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this6.isLoadingDetail = true;
                _context2.next = 3;
                return _this6.checkFalseReaders();

              case 3:
                _this6.isNewAccessGroup = false;
                aList = _this6.accessGroups;
                _context2.next = 7;
                return aList.forEach(function (doc) {
                  if (doc.id == id) {
                    _this6.accessGroup.id = doc.id;
                    _this6.accessGroup.name = doc.name;
                    _this6.accessGroup.isNewReaderAdd = doc.isNewReaderAdd;
                    _this6.accessGroup.selectedReaders = doc.selectedReaders;
                  }
                });

              case 7:
                aList2 = _this6.accessGroup.selectedReaders;

                aList2.forEach(function (doc) {
                  _this6.checkReader(doc.id);
                });
                _this6.isLoadingDetail = false;

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },
    newAccessGroup: function newAccessGroup() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this7.isLoadingDetail = true;
                _this7.isNewAccessGroup = true;
                _this7.accessGroup.id = null;
                _this7.accessGroup.name = "";
                _this7.accessGroup.isNewReaderAdd = true;
                _this7.accessGroup.selectedReaders = [];
                _this7.isCheck = false;
                _context3.next = 9;
                return _this7.checkFalseReaders();

              case 9:
                _this7.isLoadingDetail = false;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    deleteAccessGroup: function deleteAccessGroup() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this8.isNewAccessGroup) {
                  _context4.next = 4;
                  break;
                }

                alertify.warning(_this8.$ml.get("alerts.selectedAccessGroupNotBlank"));
                _context4.next = 20;
                break;

              case 4:
                _this8.isLoadingDetail = true;
                _context4.prev = 5;
                id = _this8.accessGroup.id;
                _context4.next = 9;
                return _this8.$axios.delete("/AccessGroups/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context4.sent;

                _this8.getAccessGroups();
                _this8.newAccessGroup();
                alertify.success(_this8.$ml.get("alerts.deletedSuccessfully"));
                _this8.isLoadingDetail = false;
                _context4.next = 20;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4["catch"](5);

                alertify.error("Hata Oluştu : " + _context4.t0);
                _this8.isLoadingDetail = false;

              case 20:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[5, 16]]);
      }))();
    },
    saveAccessGroup: function saveAccessGroup() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var readers2, accessGroup2, response, id, _accessGroup, _response;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this9.accessGroup.name == "")) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.accessGroupNameNotBlank"));
                return _context5.abrupt("return");

              case 3:
                _this9.isLoadingDetail = true;
                _context5.next = 6;
                return _this9.getCheckReaderList();

              case 6:
                readers2 = _context5.sent;

                if (!_this9.isNewAccessGroup) {
                  _context5.next = 28;
                  break;
                }

                _context5.prev = 8;
                accessGroup2 = _this9.accessGroup;
                _context5.next = 12;
                return _this9.$axios.post("/AccessGroups", {
                  name: accessGroup2.name,
                  isNewReaderAdd: accessGroup2.isNewReaderAdd,
                  readers: readers2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoading = false;
                      return;
                    }
                  }
                });

              case 12:
                response = _context5.sent;
                id = response.data.terminalYetkiGrubuId;

                if (response.status == 200) {
                  alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this9.getAccessGroups();
                _this9.selectAccessGroup(id);
                _this9.isNewAccessGroup = false;
                _this9.isLoadingDetail = false;
                _context5.next = 26;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](8);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);
                _this9.isLoadingDetail = false;

              case 26:
                _context5.next = 43;
                break;

              case 28:
                _context5.prev = 28;
                _accessGroup = _this9.accessGroup;
                _context5.next = 32;
                return _this9.$axios.post("/AccessGroups/" + _accessGroup.id, {
                  name: _accessGroup.name,
                  isNewReaderAdd: _accessGroup.isNewReaderAdd,
                  readers: readers2
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoading = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context5.sent;

                if (_response.status == 200) {
                  alertify.success(_this9.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response.message);
                }
                _this9.getAccessGroups();
                _this9.isLoadingDetail = false;
                _context5.next = 43;
                break;

              case 38:
                _context5.prev = 38;
                _context5.t1 = _context5["catch"](28);

                console.error(_context5.t1);
                alertify.error(_context5.t1);
                _this9.isLoadingDetail = false;

              case 43:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9, [[8, 21], [28, 38]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this10.isLoadingDetail = true;
                readers = [];
                _context6.next = 5;
                return _this10.$axios.get("/Terminal/GetReaders").then(function (response) {
                  response.data.forEach(function (doc) {
                    if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                      readers.push({
                        readerNo: doc.readerNo,
                        readerId: doc.readerId,
                        terminalId: doc.terminalId,
                        terminalNo: doc.terminalNo,
                        ipAddress: doc.ipAddress,
                        name: doc.name,
                        check: false
                      });
                    }
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this10.readers = readers;
                _this10.isLoadingDetail = false;
                _context6.next = 15;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);
                _this10.isLoadingDetail = false;

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this10, [[0, 10]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this11.isLoading = true;
                accessGroups = [];
                _context7.next = 5;
                return _this11.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this11.accessGroups = accessGroups;
                _this11.isLoading = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);
                _this11.isLoading = false;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this11, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this12.authControl == 1) {
                  alertify.warning(_this12.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this12);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this13 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this13.getAuthControl();

            case 2:
              _context9.next = 4;
              return _this13.getReaders();

            case 4:
              _context9.next = 6;
              return _this13.getAccessGroups();

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this13);
    }))();
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      workGroup: {
        model: 0,
        id: null,
        name: "",
        shortCode: "",
        isPeriod: false,
        periodStartDate: null,
        entryTime: "00:00",
        exitTime: "00:00",
        earlyEntryTime: "00:05",
        earlyExitTime: "00:05",
        lateEntryTime: "00:05",
        lateExitTime: "00:05",
        foodStartTime: "00:00",
        foodEndTime: "00:00",
        foodTotalTime: "00:00",
        totalWorkTime: "00:00",
        totalBreakTime: "",
        totalOverTime: "",
        firstEntryLastExit: false,
        dayOffHour: "00:00",
        solsticeHour: "00:00",
        discontinuityDayTime: "07:30",
        maxLimit: "00:00",
        minLimit: "00:15",
        acceptToEntryDay: false,
        accessDoorControl: false,
        oneOfAllLog: "00:05",
        deleteDifferentDoors: false,
        noDeleteOvertime: false,
        breakTolerances: [],
        extraWorks: [],
        periods: [],
        extraPayrolls: []
      },
      workGroups: [],
      payrolls: [],
      periodDetails: [],
      allowences: [],
      selectedPayrollStartTime: "00:00",
      selectedPayrollEndTime: "00:00",
      selectedPayrollId: null,
      selectedBreakHourlyWork: "00:00",
      selectedBreak: "00:00",
      selectedHakedis: false,
      selectedWorkGroup: null,
      selectedDay: 1,
      selectedPeriodisAllowence: false,
      selectedPeriodValue: null,
      isNewWorkGroup: true
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str, format) {
      if (str == "" || str == null) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        str = new Date(str);
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
          return saat + ":" + dakika + ":" + saniye;
        }
      } else if (format == "ss:dd") {
        if (str.length > 5) {
          str = new Date(str);
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        } else {
          str = new Date("1900-01-01 " + str.replace("Z", ""));
          var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
          var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
          return saat + ":" + dakika;
        }
      }
    },
    toDateFormatGetSTR: function toDateFormatGetSTR(str, format) {
      if (!str) {
        return "";
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = str.substr(8, 2);
        var ay = str.substr(5, 2);
        var yil = str.substr(0, 4);
        var saat = str.substr(11, 2);
        var dakika = str.substr(14, 2);
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = str.substr(8, 2);
        var ay = str.substr(5, 2);
        var yil = str.substr(0, 4);
        return gun + "." + ay + "." + yil;
      } else if (format == "ss:dd:ss") {
        var saat = str.substr(0, 2);
        var dakika = str.substr(3, 2);
        var saniye = str.substr(6, 2);
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.substr(0, 2);
        var dakika = str.substr(3, 2);
        return saat + ":" + dakika;
      }
    }
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    workGroupList: function workGroupList() {
      var _this = this;

      if (this.searchText) {
        return this.workGroups.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.workGroups;
      }
    },
    extraWorkGroupList: function extraWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.model == 1;
      });
    },
    extraWorkList: function extraWorkList() {
      return this.workGroup.extraWorks;
    },
    periodList: function periodList() {
      return this.workGroup.periods;
    },
    periodDetailList: function periodDetailList() {
      return this.periodDetails;
    },
    extraPayrollList: function extraPayrollList() {
      return this.workGroup.extraPayrolls;
    },
    breakToleranceList: function breakToleranceList() {
      return this.workGroup.breakTolerances;
    },
    payrollList: function payrollList() {
      return this.payrolls;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changePayrolls: function changePayrolls(event) {
      this.selectedPayrollId = event.target.value;
    },
    changeWorkGroups: function changeWorkGroups(event) {
      this.selectedWorkGroup = event.target.value;
    },
    changeWorkGroupModel: function changeWorkGroupModel(event) {
      this.workGroup.model = event.target.value;
    },
    changePeriodDetails: function changePeriodDetails(event) {
      var name = event.target.value;
      if (name.indexOf("true") == -1) {
        this.selectedPeriodisAllowence = false;
      } else {
        this.selectedPeriodisAllowence = true;
      }
      this.selectedPeriodValue = event.target.value.replace("-", "").replace("true", "").replace("false", "");
    },
    changePeriod: function changePeriod(event) {
      if (event.target.value == "true") {
        this.workGroup.isPeriod = true;
      } else {
        this.workGroup.isPeriod = false;
      }
    },
    payrollGetNameToId: function payrollGetNameToId(id) {
      var payroll = this.payrolls.filter(function (item) {
        return item.id == id;
      });
      if (payroll != "" && payroll != null) {
        return payroll[0].name;
      } else {
        return "";
      }
    },
    workGroupGetNameToId: function workGroupGetNameToId(id) {
      var workGroup = this.workGroups.filter(function (item) {
        return item.id == id;
      });
      if (workGroup != "" && workGroup != null) {
        return workGroup[0].shortCode + " - " + workGroup[0].name;
      } else {
        return "";
      }
    },
    periodDetailGetNameToId: function periodDetailGetNameToId(id, isAllowence) {
      if (isAllowence == true) {
        var allowence = this.allowences.filter(function (item) {
          return item.id == id;
        });
        if (allowence != "" && allowence != null) {
          return allowence[0].name;
        } else {
          return "";
        }
      } else {
        var workGroup = this.workGroups.filter(function (item) {
          return item.id == id;
        });
        if (workGroup != "" && workGroup != null) {
          return workGroup[0].shortCode + " - " + workGroup[0].name;
        } else {
          return "";
        }
      }
    },
    addBreakTolerance: function addBreakTolerance() {
      if (this.selectedBreakHourlyWork == "00:00" || this.selectedBreakHourlyWork == "" || this.selectedBreak == "00:00" || this.selectedBreak == "") {
        alertify.warning(this.$ml.get('alerts.pleaseCheckTimes'));
        return;
      }
      var hourlyWorkTime = this.toDateFormat(this.selectedBreakHourlyWork, "ss:dd");
      var breakTolerance = this.toDateFormat(this.selectedBreak, "ss:dd");
      var workGroupId = this.workGroup.id;
      this.workGroup.breakTolerances.push({
        id: null,
        hourlyWorkTime: hourlyWorkTime,
        breakTolerance: breakTolerance,
        workGroupId: workGroupId
      });
    },
    deleteBreakTolerance: function deleteBreakTolerance(index, id) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(id != null)) {
                  _context.next = 13;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this3.$axios.delete("/WorkGroups/DeleteBreakTolerance/" + id);

              case 4:
                response = _context.sent;

                if (response.status == 200) {
                  _this3.workGroup.breakTolerances.splice(index, 1);
                  alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                } else {
                  alertify.error(response.status + " - " + response.message);
                }
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                alertify.error("Hata Oluştu : " + _context.t0);

              case 11:
                _context.next = 14;
                break;

              case 13:
                _this3.workGroup.breakTolerances.splice(index, 1);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 8]]);
      }))();
    },
    addExtraPayroll: function addExtraPayroll() {
      if (this.selectedPayrollId == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      if (this.selectedPayrollStartTime == "" || this.selectedPayrollEndTime == "") {
        alertify.warning(this.$ml.get('alerts.pleaseCheckTimes'));
        return;
      }
      var payrollId = this.selectedPayrollId;
      var payroll = this.payrolls.filter(function (item) {
        return item.id == payrollId;
      });
      var payrollType = payroll[0].type;
      var hakedis = this.selectedHakedis;
      var startDate = this.toDateFormat(this.selectedPayrollStartTime, "ss:dd");
      var endDate = this.toDateFormat(this.selectedPayrollEndTime, "ss:dd");
      var workGroupId = this.workGroup.id;
      this.workGroup.extraPayrolls.push({
        id: null,
        startDate: startDate,
        endDate: endDate,
        payrollId: payrollId,
        payrollType: payrollType,
        hakedis: hakedis,
        workGroupId: workGroupId,
        holidayId: null
      });
    },
    deleteExtraPayroll: function deleteExtraPayroll(index, id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(id != null)) {
                  _context2.next = 13;
                  break;
                }

                _context2.prev = 1;
                _context2.next = 4;
                return _this4.$axios.delete("/WorkGroups/DeleteExtraPayroll/" + id);

              case 4:
                response = _context2.sent;

                if (response.status == 200) {
                  _this4.workGroup.extraPayrolls.splice(index, 1);
                  alertify.success(_this4.$ml.get('alerts.deletedSuccessfully'));
                } else {
                  alertify.error(response.status + " - " + response.message);
                }
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                alertify.error("Hata Oluştu : " + _context2.t0);

              case 11:
                _context2.next = 14;
                break;

              case 13:
                _this4.workGroup.extraPayrolls.splice(index, 1);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[1, 8]]);
      }))();
    },
    addExtraWork: function addExtraWork() {
      if (this.selectedWorkGroup == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      var subShiftId = this.selectedWorkGroup;
      var workGroupId = this.workGroup.id;
      this.workGroup.extraWorks.push({
        id: null,
        subShiftId: subShiftId,
        workGroupId: workGroupId
      });
    },
    deleteExtraWork: function deleteExtraWork(index, id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(id != null)) {
                  _context3.next = 13;
                  break;
                }

                _context3.prev = 1;
                _context3.next = 4;
                return _this5.$axios.delete("/WorkGroups/DeleteExtraWork/" + id);

              case 4:
                response = _context3.sent;

                if (response.status == 200) {
                  _this5.workGroup.extraWorks.splice(index, 1);
                  alertify.success(_this5.$ml.get('alerts.deletedSuccessfully'));
                } else {
                  alertify.error(response.status + " - " + response.message);
                }
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);

                alertify.error("Hata Oluştu : " + _context3.t0);

              case 11:
                _context3.next = 14;
                break;

              case 13:
                _this5.workGroup.extraWorks.splice(index, 1);

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[1, 8]]);
      }))();
    },
    addPeriod: function addPeriod() {
      if (this.selectedPeriodValue == null) {
        alertify.warning(this.$ml.get('alerts.pleaseSelect'));
        return;
      }
      var subShiftId = this.selectedPeriodValue;
      var day = this.selectedDay;
      var isAllowence = this.selectedPeriodisAllowence;
      var workGroupId = this.workGroup.id;
      var index = this.workGroup.periods.length + 1;
      this.workGroup.periods.push({
        id: null,
        index: index,
        subShiftId: subShiftId,
        day: day,
        workGroupId: workGroupId,
        isAllowence: isAllowence
      });
    },
    deletePeriod: function deletePeriod(index, id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(id != null)) {
                  _context4.next = 13;
                  break;
                }

                _context4.prev = 1;
                _context4.next = 4;
                return _this6.$axios.delete("/WorkGroups/DeletePeriod/" + id);

              case 4:
                response = _context4.sent;

                if (response.status == 200) {
                  _this6.workGroup.periods.splice(index, 1);
                  alertify.success(_this6.$ml.get('alerts.deletedSuccessfully'));
                } else {
                  alertify.error(response.status + " - " + response.message);
                }
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](1);

                alertify.error("Hata Oluştu : " + _context4.t0);

              case 11:
                _context4.next = 14;
                break;

              case 13:
                _this6.workGroup.periods.splice(index, 1);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[1, 8]]);
      }))();
    },
    newWorkGroup: function newWorkGroup() {
      this.isLoadingDetail = true;
      this.isNewWorkGroup = true;
      this.workGroup.model = 0;
      this.workGroup.shortCode = "";
      this.workGroup.name = "";
      this.workGroup.id = null;
      this.workGroup.isPeriod = false;
      this.workGroup.periodStartDate = null;
      this.workGroup.entryTime = "00:00";
      this.workGroup.exitTime = "00:00";
      this.workGroup.earlyEntryTime = "00:05";
      this.workGroup.earlyExitTime = "00:05";
      this.workGroup.lateEntryTime = "00:05";
      this.workGroup.lateExitTime = "00:05";
      this.workGroup.foodStartTime = "00:00";
      this.workGroup.foodEndTime = "00:00";
      this.workGroup.foodTotalTime = "00:00";
      this.workGroup.totalWorkTime = "00:00";
      this.workGroup.totalBreakTime = "";
      this.workGroup.totalOverTime = "";
      this.workGroup.firstEntryLastExit = false;
      this.workGroup.dayOffHour = "00:00";
      this.workGroup.solsticeHour = "00:00";
      this.workGroup.discontinuityDayTime = "07:30";
      this.workGroup.maxLimit = "17:00";
      this.workGroup.minLimit = "00:15";
      this.workGroup.acceptToEntryDay = false;
      this.workGroup.accessDoorControl = false;
      this.workGroup.oneOfAllLog = "00:05";
      this.workGroup.deleteDifferentDoors = false;
      this.workGroup.noDeleteOvertime = false;
      this.workGroup.breakTolerances = [];
      this.workGroup.extraWorks = [];
      this.workGroup.periods = [];
      this.workGroup.extraPayrolls = [];
      this.selectedPayrollStartTime = "00:00";
      this.selectedPayrollEndTime = "00:00";
      this.selectedPayrollId = null;
      this.selectedBreakHourlyWork = "00:00";
      this.selectedBreak = "00:00";
      this.selectedHakedis = false;
      this.selectedWorkGroup = null;
      this.selectedDay = 1;
      this.selectedPeriodisAllowence = false;
      this.selectedPeriodValue = null;
      this.isLoadingDetail = false;
    },
    getWorkGroup: function getWorkGroup(id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this7.isLoadingDetail = true;
                _context5.next = 4;
                return _this7.$axios.get("/WorkGroups/" + id);

              case 4:
                response = _context5.sent;

                _this7.isNewWorkGroup = false;
                _this7.workGroup.id = id;
                _this7.workGroup.model = response.data.model;
                _this7.workGroup.name = response.data.name;
                _this7.workGroup.shortCode = response.data.shortCode;
                _this7.workGroup.isPeriod = response.data.isPeriod;
                _this7.workGroup.periodStartDate = response.data.periodStartDate ? _this7.toDateFormat(response.data.periodStartDate, "gg.aa.yyyy") : "";
                _this7.workGroup.entryTime = response.data.entryTime ? _this7.toDateFormat(response.data.entryTime, "ss:dd") : "";
                _this7.workGroup.exitTime = response.data.exitTime ? _this7.toDateFormat(response.data.exitTime, "ss:dd") : "";
                _this7.workGroup.earlyEntryTime = response.data.earlyEntryTime ? _this7.toDateFormat(response.data.earlyEntryTime, "ss:dd") : "";
                _this7.workGroup.earlyExitTime = response.data.earlyExitTime ? _this7.toDateFormat(response.data.earlyExitTime, "ss:dd") : "";
                _this7.workGroup.lateEntryTime = response.data.lateEntryTime ? _this7.toDateFormat(response.data.lateEntryTime, "ss:dd") : "";
                _this7.workGroup.lateExitTime = response.data.lateExitTime ? _this7.toDateFormat(response.data.lateExitTime, "ss:dd") : "";
                _this7.workGroup.foodStartTime = response.data.foodStartTime ? _this7.toDateFormat(response.data.foodStartTime, "ss:dd") : "";
                _this7.workGroup.foodEndTime = response.data.foodEndTime ? _this7.toDateFormat(response.data.foodEndTime, "ss:dd") : "";
                _this7.workGroup.foodTotalTime = response.data.foodTotalTime ? _this7.toDateFormat(response.data.foodTotalTime, "ss:dd") : "";
                _this7.workGroup.totalWorkTime = response.data.totalWorkTime ? _this7.toDateFormat(response.data.totalWorkTime, "ss:dd") : "";
                _this7.workGroup.totalBreakTime = response.data.totalBreakTime ? _this7.toDateFormat(response.data.totalBreakTime, "ss:dd") : "";
                _this7.workGroup.totalOverTime = response.data.totalOverTime ? _this7.toDateFormat(response.data.totalOverTime, "ss:dd") : "";
                _this7.workGroup.firstEntryLastExit = response.data.firstEntryLastExit;
                _this7.workGroup.dayOffHour = response.data.dayOffHour ? _this7.toDateFormat(response.data.dayOffHour, "ss:dd") : "";
                _this7.workGroup.solsticeHour = response.data.solsticeHour ? _this7.toDateFormat(response.data.solsticeHour, "ss:dd") : "";
                _this7.workGroup.discontinuityDayTime = response.data.discontinuityDayTime ? _this7.toDateFormat(response.data.discontinuityDayTime, "ss:dd") : "";
                _this7.workGroup.maxLimit = response.data.maxLimit ? _this7.toDateFormat(response.data.maxLimit, "ss:dd") : "";
                _this7.workGroup.minLimit = response.data.minLimit ? _this7.toDateFormat(response.data.minLimit, "ss:dd") : "";
                _this7.workGroup.acceptToEntryDay = response.data.acceptToEntryDay;
                _this7.workGroup.accessDoorControl = response.data.accessDoorControl;
                _this7.workGroup.oneOfAllLog = response.data.oneOfAllLog ? _this7.toDateFormat(response.data.oneOfAllLog, "ss:dd") : "";
                _this7.workGroup.deleteDifferentDoors = response.data.deleteDifferentDoors;
                _this7.workGroup.noDeleteOvertime = response.data.noDeleteOvertime;
                _this7.workGroup.breakTolerances = response.data.breakTolerances;
                _this7.workGroup.extraWorks = response.data.extraWorks;
                _this7.workGroup.periods = response.data.periods;
                _this7.workGroup.extraPayrolls = response.data.extraPayrolls;
                _this7.isLoadingDetail = false;
                _context5.next = 47;
                break;

              case 42:
                _context5.prev = 42;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error(_context5.t0);
                _this7.isLoadingDetail = false;

              case 47:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 42]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this8.isLoading = true;
                workGroups = [];
                _context6.next = 5;
                return _this8.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      model: doc.model
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get('errors.connectionError'));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this8.workGroups = workGroups;
                _context6.next = 9;
                return _this8.getPeriodDetails();

              case 9:
                _this8.isLoading = false;
                _context6.next = 17;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);
                _this8.isLoading = false;

              case 17:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 12]]);
      }))();
    },
    getPeriodDetails: function getPeriodDetails() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var periodDetails, allowences, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this9.isLoadingDetail = true;
                periodDetails = [];
                allowences = [];
                _context7.next = 6;
                return _this9.workGroups.forEach(function (doc) {
                  periodDetails.push({
                    id: doc.id,
                    name: doc.shortCode + " - " + doc.name,
                    isAllowence: false
                  });
                });

              case 6:
                _context7.next = 8;
                return _this9.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    periodDetails.push({
                      id: doc.id,
                      name: doc.shortCode + " - " + doc.name,
                      isAllowence: true
                    });
                    allowences.push({
                      id: doc.id,
                      name: doc.shortCode + " - " + doc.name,
                      isAllowence: true
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get('errors.connectionError'));
                      _this9.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoading = false;
                      return;
                    }
                  }
                });

              case 8:
                response = _context7.sent;

                _this9.allowences = allowences;
                _this9.periodDetails = periodDetails;
                _this9.isLoadingDetail = false;
                _context7.next = 19;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);
                _this9.isLoadingDetail = false;

              case 19:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9, [[0, 14]]);
      }))();
    },
    getPayrolls: function getPayrolls() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var payrolls, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                payrolls = [];
                _context8.next = 4;
                return _this10.$axios.get("/Payroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    payrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      type: doc.type,
                      otherType: doc.otherPayrollTypes,
                      equalType: doc.equalPayroll,
                      maxLimit: doc.maxLimit,
                      monthlyPayrollId: doc.monthlyPayroll,
                      isApproved: doc.isApproved,
                      multiplier: doc.multiplier,
                      firstTolerance1: doc.firstTolerance1,
                      lastTolerance1: doc.lastTolerance1,
                      totalTolerance1: doc.totalTolerance1,
                      firstTolerance2: doc.firstTolerance2,
                      lastTolerance2: doc.lastTolerance2,
                      totalTolerance2: doc.totalTolerance2,
                      firstTolerance3: doc.firstTolerance3,
                      lastTolerance3: doc.lastTolerance3,
                      totalTolerance3: doc.totalTolerance3
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get('errors.connectionError'));
                      _this10.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context8.sent;

                _this10.payrolls = payrolls;
                _context8.next = 12;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this10, [[0, 8]]);
      }))();
    },
    deleteWorkGroup: function deleteWorkGroup() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                id = _this11.workGroup.id;

                if (id == null) {
                  alertify.warning(_this11.$ml.get('alerts.pleaseSelect'));
                }
                _context9.prev = 2;

                _this11.isLoadingDetail = true;
                _context9.next = 6;
                return _this11.$axios.delete("/WorkGroups/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get('errors.connectionError'));
                      _this11.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoading = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context9.sent;

                if (!(response.status == 200)) {
                  _context9.next = 16;
                  break;
                }

                alertify.success(_this11.$ml.get('alerts.deletedSuccessfully'));
                _context9.next = 11;
                return _this11.getWorkGroups();

              case 11:
                _context9.next = 13;
                return _this11.newWorkGroup();

              case 13:
                _this11.isLoadingDetail = false;
                _context9.next = 18;
                break;

              case 16:
                alertify.error(response.status + " - " + response.message);
                _this11.isLoadingDetail = false;

              case 18:
                _context9.next = 24;
                break;

              case 20:
                _context9.prev = 20;
                _context9.t0 = _context9["catch"](2);

                alertify.error("Hata Oluştu : " + _context9.t0);
                _this11.isLoadingDetail = false;

              case 24:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this11, [[2, 20]]);
      }))();
    },
    saveWorkGroup: function saveWorkGroup() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var workGroup2, response, id, _workGroup, _response;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (!(_this12.workGroup.isPeriod == true && _this12.workGroup.periodStartDate == "" && _this12.workGroup.periodStartDate == null)) {
                  _context10.next = 3;
                  break;
                }

                alertify.warning(_this12.$ml.get('alerts.pleaseEnterPeriodStartDate'));
                return _context10.abrupt("return");

              case 3:
                if (!(_this12.workGroup.shortCode == "" || _this12.workGroup.name == "")) {
                  _context10.next = 6;
                  break;
                }

                alertify.warning(_this12.$ml.get('alerts.pleaseEnterShortCodeAndName'));
                return _context10.abrupt("return");

              case 6:
                _this12.isLoadingDetail = true;

                if (!_this12.isNewWorkGroup) {
                  _context10.next = 28;
                  break;
                }

                _context10.prev = 8;
                workGroup2 = _this12.workGroup;
                _context10.next = 12;
                return _this12.$axios.post("/WorkGroups", {
                  model: workGroup2.model,
                  name: workGroup2.name,
                  shortCode: workGroup2.shortCode,
                  isPeriod: workGroup2.isPeriod,
                  periodStartDate: workGroup2.periodStartDate,
                  entryTime: workGroup2.entryTime,
                  exitTime: workGroup2.exitTime,
                  earlyEntryTime: workGroup2.earlyEntryTime,
                  earlyExitTime: workGroup2.earlyExitTime,
                  lateEntryTime: workGroup2.lateEntryTime,
                  lateExitTime: workGroup2.lateExitTime,
                  foodStartTime: workGroup2.foodStartTime,
                  foodEndTime: workGroup2.foodEndTime,
                  foodTotalTime: workGroup2.foodTotalTime,
                  totalWorkTime: workGroup2.totalWorkTime,
                  totalBreakTime: workGroup2.totalBreakTime,
                  totalOverTime: workGroup2.totalOverTime,
                  firstEntryLastExit: workGroup2.firstEntryLastExit,
                  dayOffHour: workGroup2.dayOffHour,
                  solsticeHour: workGroup2.solsticeHour,
                  discontinuityDayTime: workGroup2.discontinuityDayTime,
                  maxLimit: workGroup2.maxLimit,
                  minLimit: workGroup2.minLimit,
                  acceptToEntryDay: workGroup2.acceptToEntryDay,
                  accessDoorControl: workGroup2.accessDoorControl,
                  oneOfAllLog: workGroup2.oneOfAllLog,
                  deleteDifferentDoors: workGroup2.deleteDifferentDoors,
                  noDeleteOvertime: workGroup2.noDeleteOvertime,
                  breakTolerances: workGroup2.breakTolerances,
                  extraWorks: workGroup2.extraWorks,
                  periods: workGroup2.periods,
                  extraPayrolls: workGroup2.extraPayrolls
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get('errors.connectionError'));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 12:
                response = _context10.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this12.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this12.getWorkGroups();
                _this12.getWorkGroup(id);
                _this12.isNewWorkGroup = false;
                _this12.isLoadingDetail = false;
                _context10.next = 26;
                break;

              case 21:
                _context10.prev = 21;
                _context10.t0 = _context10["catch"](8);

                console.error(_context10.t0);
                alertify.error(_context10.t0.message);
                _this12.isLoadingDetail = false;

              case 26:
                _context10.next = 43;
                break;

              case 28:
                _context10.prev = 28;
                _workGroup = _this12.workGroup;
                _context10.next = 32;
                return _this12.$axios.post("/WorkGroups/" + _workGroup.id, {
                  model: _workGroup.model,
                  name: _workGroup.name,
                  shortCode: _workGroup.shortCode,
                  isPeriod: _workGroup.isPeriod,
                  periodStartDate: _workGroup.periodStartDate,
                  entryTime: _workGroup.entryTime,
                  exitTime: _workGroup.exitTime,
                  earlyEntryTime: _workGroup.earlyEntryTime,
                  earlyExitTime: _workGroup.earlyExitTime,
                  lateEntryTime: _workGroup.lateEntryTime,
                  lateExitTime: _workGroup.lateExitTime,
                  foodStartTime: _workGroup.foodStartTime,
                  foodEndTime: _workGroup.foodEndTime,
                  foodTotalTime: _workGroup.foodTotalTime,
                  totalWorkTime: _workGroup.totalWorkTime,
                  totalBreakTime: _workGroup.totalBreakTime,
                  totalOverTime: _workGroup.totalOverTime,
                  firstEntryLastExit: _workGroup.firstEntryLastExit,
                  dayOffHour: _workGroup.dayOffHour,
                  solsticeHour: _workGroup.solsticeHour,
                  discontinuityDayTime: _workGroup.discontinuityDayTime,
                  maxLimit: _workGroup.maxLimit,
                  minLimit: _workGroup.minLimit,
                  acceptToEntryDay: _workGroup.acceptToEntryDay,
                  accessDoorControl: _workGroup.accessDoorControl,
                  oneOfAllLog: _workGroup.oneOfAllLog,
                  deleteDifferentDoors: _workGroup.deleteDifferentDoors,
                  noDeleteOvertime: _workGroup.noDeleteOvertime,
                  breakTolerances: _workGroup.breakTolerances,
                  extraWorks: _workGroup.extraWorks,
                  periods: _workGroup.periods,
                  extraPayrolls: _workGroup.extraPayrolls
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get('errors.connectionError'));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 32:
                _response = _context10.sent;

                if (_response.status == 200) {
                  alertify.success(_this12.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this12.getWorkGroups();
                _this12.isLoadingDetail = false;
                _context10.next = 43;
                break;

              case 38:
                _context10.prev = 38;
                _context10.t1 = _context10["catch"](28);

                console.error(_context10.t1);
                alertify.error(_context10.t1);
                _this12.isLoadingDetail = false;

              case 43:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this12, [[8, 21], [28, 38]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (_this13.authControl == 1) {
                  alertify.warning(_this13.$ml.get('alerts.userIsNotAuthorizedToSeeData'));
                }

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this13);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this14 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this14.getAuthControl();

            case 2:
              _context12.next = 4;
              return _this14.getWorkGroups();

            case 4:
              _context12.next = 6;
              return _this14.getPayrolls();

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this14);
    }))();
  }
});

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoadingDescription: false,
      isLoadingPlace: false,
      overtimeDescription: {
        id: null,
        name: "",
        newName: ""
      },
      overtimePlace: {
        id: null,
        name: "",
        newName: ""
      },
      overtimeDescriptions: [],
      overtimePlaces: []
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    overtimeDescriptionList: function overtimeDescriptionList() {
      return this.overtimeDescriptions;
    },
    overtimePlaceList: function overtimePlaceList() {
      return this.overtimePlaces;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    selectOvertimePlace: function selectOvertimePlace(place) {
      this.overtimePlace.id = place.id;
      this.overtimePlace.name = place.name;
      this.overtimePlace.newName = place.name;
    },
    selectOvertimeDescription: function selectOvertimeDescription(description) {
      this.overtimeDescription.id = description.id;
      this.overtimeDescription.name = description.name;
      this.overtimeDescription.newName = description.name;
    },
    newOvertimePlace: function newOvertimePlace() {
      this.overtimePlace.id = null;
      this.overtimePlace.name = "";
      this.overtimePlace.newName = "";
    },
    newOvertimeDescription: function newOvertimeDescription() {
      this.overtimeDescription.id = null;
      this.overtimeDescription.name = "";
      this.overtimeDescription.newName = "";
    },
    deleteOvertimePlace: function deleteOvertimePlace() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.overtimePlace.id == null)) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this2.$ml.get('alerts.pleaseSelect'));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                _this2.isLoadingPlace = true;
                _context.next = 7;
                return _this2.$axios.delete("/OvertimePlaces/" + _this2.overtimePlace.id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingPlace = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingPlace = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context.sent;

                _this2.newOvertimePlace();
                _this2.getOvertimePlaces();
                alertify.success(_this2.$ml.get('alerts.deletedSuccessfully'));
                _this2.isLoadingPlace = false;
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this2.isLoadingPlace = false;

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 14]]);
      }))();
    },
    deleteOvertimeDescription: function deleteOvertimeDescription() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.overtimeDescription.id == null)) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get('alerts.pleaseSelect'));
                return _context2.abrupt("return");

              case 3:
                _context2.prev = 3;

                _this3.isLoadingDescription = true;
                _context2.next = 7;
                return _this3.$axios.delete("/OvertimeDescription/" + _this3.overtimeDescription.id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDescription = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDescription = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context2.sent;

                _this3.newOvertimeDescription();
                _this3.getOvertimeDescriptions();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDescription = false;
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](3);

                alertify.error("Hata Oluştu : " + _context2.t0);
                _this3.isLoadingDescription = false;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 14]]);
      }))();
    },
    saveOvertimePlace: function saveOvertimePlace() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.overtimePlace.name == "")) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                _this4.isLoadingPlace = true;
                _context3.next = 7;
                return _this4.$axios.post("/OvertimePlaces", {
                  name: _this4.overtimePlace.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                    _this4.isLoadingPlace = false;
                    _this4.getOvertimePlaces();
                  } else {
                    alertify.error(response.message);
                    _this4.isLoadingPlace = false;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingPlace = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingPlace = false;
                      return;
                    }
                  }
                });

              case 7:
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this4.isLoadingPlace = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 9]]);
      }))();
    },
    saveOvertimeDescription: function saveOvertimeDescription() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.overtimeDescription.name == "")) {
                  _context4.next = 3;
                  break;
                }

                alertify.warning(_this5.$ml.get('alerts.pleaseEnterAName'));
                return _context4.abrupt("return");

              case 3:
                _context4.prev = 3;

                _this5.isLoadingDescription = true;
                _context4.next = 7;
                return _this5.$axios.post("/OvertimeDescription", {
                  name: _this5.overtimeDescription.name
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get('alerts.savedSuccessfully'));
                    _this5.isLoadingDescription = false;
                    _this5.getOvertimeDescriptions();
                  } else {
                    alertify.error(response.message);
                    _this5.isLoadingDescription = false;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDescription = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDescription = false;
                      return;
                    }
                  }
                });

              case 7:
                _context4.next = 14;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4["catch"](3);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this5.isLoadingDescription = false;

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 9]]);
      }))();
    },
    updateOvertimePlace: function updateOvertimePlace() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(_this6.overtimePlace.newName == "")) {
                  _context5.next = 3;
                  break;
                }

                alertify.warning(_this6.$ml.get('alerts.pleaseEnterAName'));
                return _context5.abrupt("return");

              case 3:
                _context5.prev = 3;

                _this6.isLoadingPlace = true;
                _context5.next = 7;
                return _this6.$axios.post("/OvertimePlaces/" + _this6.overtimePlace.id, {
                  name: _this6.overtimePlace.newName
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this6.$ml.get('alerts.updatedSuccessfully'));
                    _this6.isLoadingPlace = false;
                    _this6.getOvertimePlaces();
                  } else {
                    alertify.error(response.message);
                    _this6.isLoadingPlace = false;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoadingPlace = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingPlace = false;
                      return;
                    }
                  }
                });

              case 7:
                _context5.next = 14;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](3);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);
                _this6.isLoadingPlace = false;

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 9]]);
      }))();
    },
    updateOvertimeDescription: function updateOvertimeDescription() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this7.overtimeDescription.newName == "")) {
                  _context6.next = 3;
                  break;
                }

                alertify.warning(_this7.$ml.get('alerts.pleaseEnterName'));
                return _context6.abrupt("return");

              case 3:
                _context6.prev = 3;

                _this7.isLoadingDescription = true;
                _context6.next = 7;
                return _this7.$axios.post("/OvertimeDescription/" + _this7.overtimeDescription.id, {
                  name: _this7.overtimeDescription.newName
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this7.$ml.get('alerts.updatedSuccessfully'));
                    _this7.isLoadingDescription = false;
                    _this7.getOvertimeDescriptions();
                  } else {
                    alertify.error(response.message);
                    _this7.isLoadingDescription = false;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get('errors.connectionError'));
                      _this7.isLoadingDescription = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingDescription = false;
                      return;
                    }
                  }
                });

              case 7:
                _context6.next = 14;
                break;

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](3);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this7.isLoadingDescription = false;

              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[3, 9]]);
      }))();
    },
    getOvertimeDescriptions: function getOvertimeDescriptions() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var overtimeDescriptions, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this8.isLoadingDescription = true;
                overtimeDescriptions = [];
                _context7.next = 5;
                return _this8.$axios.get("/OvertimeDescription").then(function (response) {
                  response.data.forEach(function (doc) {
                    overtimeDescriptions.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                  _this8.isLoadingDescription = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get('errors.connectionError'));
                      _this8.isLoadingDescription = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDescription = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this8.overtimeDescriptions = overtimeDescriptions;
                _context7.next = 14;
                break;

              case 9:
                _context7.prev = 9;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);
                _this8.isLoadingDescription = false;

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 9]]);
      }))();
    },
    getOvertimePlaces: function getOvertimePlaces() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var overtimePlaces, response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this9.isLoadingPlace = true;
                overtimePlaces = [];
                _context8.next = 5;
                return _this9.$axios.get("/OvertimePlaces").then(function (response) {
                  response.data.forEach(function (doc) {
                    overtimePlaces.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                  _this9.isLoadingPlace = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get('errors.connectionError'));
                      _this9.isLoadingPlace = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingPlace = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context8.sent;

                _this9.overtimePlaces = overtimePlaces;
                _context8.next = 14;
                break;

              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error("Servis Hatası :" + _context8.t0.message);
                _this9.isLoadingPlace = false;

              case 14:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9, [[0, 9]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (_this10.authControl == 1) {
                  alertify.warning(_this10.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this10);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this11.getOvertimeDescriptions();

            case 2:
              _context10.next = 4;
              return _this11.getOvertimePlaces();

            case 4:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10, _this11);
    }))();
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      allowence: {
        id: null,
        shortCode: "",
        name: "",
        monthlyPayrollId: null,
        dailyPayrollId: null,
        dayTime: "00:00",
        colorCode: "#ff4545",
        r: 0,
        g: 0,
        b: 0
      },
      allowences: [],
      monthlyPayrolls: [],
      dailyPayrolls: [],
      isNewAllowence: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    allowenceList: function allowenceList() {
      var _this = this;

      if (this.searchText) {
        return this.allowences.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.allowences;
      }
    },
    dailyPayrollList: function dailyPayrollList() {
      return this.dailyPayrolls;
    },
    monthlyPayrollList: function monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    changeColor: function changeColor(event) {
      var colorCode = event.target.value;
      this.allowence.r = parseInt(colorCode.substr(1, 2), 16);
      this.allowence.g = parseInt(colorCode.substr(3, 2), 16);
      this.allowence.b = parseInt(colorCode.substr(5, 2), 16);
      this.allowence.colorCode = colorCode;
    },
    rgbToHex: function rgbToHex(rgb) {
      var hex = Number(rgb).toString(16);
      if (hex.length < 2) {
        hex = "0" + hex;
      }
      return hex;
    },
    fullColorHex: function fullColorHex(r, g, b) {
      var red = this.rgbToHex(r);
      var green = this.rgbToHex(g);
      var blue = this.rgbToHex(b);
      return "#" + red + green + blue;
    },
    changeMonthlyPayrollType: function changeMonthlyPayrollType(event) {
      this.allowence.monthlyPayrollId = event.target.value;
    },
    changePayrollType: function changePayrollType(event) {
      this.allowence.dailyPayrollId = event.target.value;
    },
    newAllowence: function newAllowence() {
      this.isLoadingDetail = true;
      this.isNewAllowence = true;
      this.allowence.id = null;
      this.allowence.shortCode = "";
      this.allowence.name = "";
      this.allowence.monthlyPayrollId = null;
      this.allowence.dailyPayrollId = null;
      this.allowence.dayTime = "00:00";
      this.allowence.colorCode = "#ff4545";
      this.allowence.r = 0;
      this.allowence.g = 0;
      this.allowence.b = 0;
      this.isLoadingDetail = false;
    },
    deleteAllowence: function deleteAllowence() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.allowence.id;
                _context.next = 5;
                return _this3.$axios.delete("/Allowences/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getAllowences();
                _this3.newAllowence();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveAllowence: function saveAllowence() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var allowence2, response, id, _allowence, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.allowence.name == "" || _this4.allowence.shortCode == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterShortCodeAndName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!_this4.isNewAllowence) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 5;
                allowence2 = _this4.allowence;
                _context2.next = 9;
                return _this4.$axios.post("/Allowences", {
                  name: allowence2.name,
                  shortCode: allowence2.shortCode,
                  monthlyPayrollId: allowence2.monthlyPayrollId,
                  dailyPayrollId: allowence2.dailyPayrollId,
                  dayTime: allowence2.dayTime,
                  colorCode: allowence2.colorCode,
                  r: allowence2.r,
                  g: allowence2.g,
                  b: allowence2.b
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getAllowences();
                _this4.getAllowence(id);
                _this4.isNewAllowence = false;
                _this4.isLoadingDetail = false;
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 23:
                _context2.next = 40;
                break;

              case 25:
                _context2.prev = 25;
                _allowence = _this4.allowence;
                _context2.next = 29;
                return _this4.$axios.post("/Allowences/" + _allowence.id, {
                  name: _allowence.name,
                  shortCode: _allowence.shortCode,
                  monthlyPayrollId: _allowence.monthlyPayrollId,
                  dailyPayrollId: _allowence.dailyPayrollId,
                  dayTime: _allowence.dayTime,
                  colorCode: _allowence.colorCode,
                  r: _allowence.r,
                  g: _allowence.g,
                  b: _allowence.b
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 29:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getAllowences();
                _this4.isLoadingDetail = false;
                _context2.next = 40;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](25);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 18], [25, 35]]);
      }))();
    },
    getAllowence: function getAllowence(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/Allowences/" + id).then(function (response) {
                  _this5.isNewAllowence = false;
                  _this5.allowence.id = id;
                  _this5.allowence.shortCode = response.data.shortCode;
                  _this5.allowence.name = response.data.name;
                  _this5.allowence.monthlyPayrollId = response.data.monthlyPayrollId;
                  _this5.allowence.dailyPayrollId = response.data.dailyPayrollId;
                  _this5.allowence.dayTime = response.data.dayTime ? _this5.toDateFormat(response.data.dayTime, "ss:dd") : "";
                  _this5.allowence.r = response.data.r;
                  _this5.allowence.g = response.data.g;
                  _this5.allowence.b = response.data.b;
                  _this5.allowence.colorCode = _this5.fullColorHex(response.data.r, response.data.g, response.data.b);
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                allowences = [];
                _context4.next = 5;
                return _this6.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this6.allowences = allowences;
                _this6.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    },
    getDailyPayrolls: function getDailyPayrolls() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var dailyPayrolls, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this7.isLoadingDetail = true;
                dailyPayrolls = [];
                _context5.next = 5;
                return _this7.$axios.get("/Payroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    dailyPayrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      type: doc.type,
                      otherType: doc.otherPayrollTypes,
                      equalType: doc.equalPayroll,
                      maxLimit: doc.maxLimit,
                      monthlyPayrollId: doc.monthlyPayroll,
                      isApproved: doc.isApproved,
                      multiplier: doc.multiplier,
                      firstTolerance1: doc.firstTolerance1,
                      lastTolerance1: doc.lastTolerance1,
                      totalTolerance1: doc.totalTolerance1,
                      firstTolerance2: doc.firstTolerance2,
                      lastTolerance2: doc.lastTolerance2,
                      totalTolerance2: doc.totalTolerance2,
                      firstTolerance3: doc.firstTolerance3,
                      lastTolerance3: doc.lastTolerance3,
                      totalTolerance3: doc.totalTolerance3
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get('errors.connectionError'));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;

                _this7.dailyPayrolls = dailyPayrolls;
                _this7.isLoadingDetail = false;
                _context5.next = 15;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error("Servis Hatası :" + _context5.t0.message);
                _this7.isLoadingDetail = false;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7, [[0, 10]]);
      }))();
    },
    getMonthlyPayrolls: function getMonthlyPayrolls() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var monthlyPayrolls, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this8.isLoadingDetail = true;
                monthlyPayrolls = [];
                _context6.next = 5;
                return _this8.$axios.get("/MonthlyPayroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    monthlyPayrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      ssk: doc.ssk,
                      total: doc.total,
                      work: doc.work
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get('errors.connectionError'));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this8.monthlyPayrolls = monthlyPayrolls;
                _this8.isLoadingDetail = false;
                _context6.next = 15;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error("Servis Hatası :" + _context6.t0.message);
                _this8.isLoadingDetail = false;

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (_this9.authControl == 1) {
                  alertify.warning(_this9.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this9);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this10.getAuthControl();

            case 2:
              _context8.next = 4;
              return _this10.getAllowences();

            case 4:
              _context8.next = 6;
              return _this10.getMonthlyPayrolls();

            case 6:
              _context8.next = 8;
              return _this10.getDailyPayrolls();

            case 8:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, _this10);
    }))();
  }
});

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isNewAnnualPermit: true,
      annualPermits: [],
      start: 0,
      end: 0,
      claim: 0,
      annualPermit: {
        id: null,
        name: "",
        definitions: []
      }
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    annualPermitList: function annualPermitList() {
      return this.annualPermits;
    },
    aPDefinitionList: function aPDefinitionList() {
      return this.annualPermit.definitions;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    deleteAPDefinition: function deleteAPDefinition(index) {
      this.annualPermit.definitions.splice(index, 1);
    },
    addAPDefinition: function addAPDefinition() {
      if ($.isNumeric(this.start) == false || $.isNumeric(this.end) == false || $.isNumeric(this.claim) == false) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckEnteredValue'));
        return;
      } else if (this.start == 0 || this.end == 0 || this.claim == 0) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckEnteredValue'));
        return;
      } else {
        this.annualPermit.definitions.push({
          id: null,
          start: this.start,
          end: this.end,
          claim: this.claim
        });
      }
    },
    newAnnualPermit: function newAnnualPermit() {
      this.isNewAnnualPermit = true;
      this.start = 0;
      this.end = 0;
      this.claim = 0;
      this.annualPermit = { id: null, name: "", definitions: [] };
    },
    deleteAnnualPermit: function deleteAnnualPermit() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoadingDetail = true;
                id = _this2.annualPermit.id;
                _context.next = 5;
                return _this2.$axios.delete("/AnnualPermit/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this2.getAnnualPermits();
                _this2.newAnnualPermit();
                alertify.success(_this2.$ml.get('alerts.deletedSuccessfully'));
                _this2.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this2.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },
    saveAnnualPermit: function saveAnnualPermit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var annualPermit2, response, _annualPermit, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.annualPermit.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this3.isLoadingDetail = true;

                if (!_this3.isNewAnnualPermit) {
                  _context2.next = 23;
                  break;
                }

                _context2.prev = 5;
                annualPermit2 = _this3.annualPermit;
                _context2.next = 9;
                return _this3.$axios.post("/AnnualPermit", {
                  name: annualPermit2.name,
                  definitions: annualPermit2.definitions
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;

                if (response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this3.getAnnualPermits();
                _this3.newAnnualPermit();
                _this3.isLoadingDetail = false;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this3.isLoadingDetail = false;

              case 21:
                _context2.next = 38;
                break;

              case 23:
                _context2.prev = 23;
                _annualPermit = _this3.annualPermit;
                _context2.next = 27;
                return _this3.$axios.post("/AnnualPermit/" + _annualPermit.id, {
                  name: _annualPermit.name,
                  definitions: _annualPermit.definitions
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 27:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this3.getAnnualPermits();
                _this3.isLoadingDetail = false;
                _context2.next = 38;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t1 = _context2["catch"](23);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this3.isLoadingDetail = false;

              case 38:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 16], [23, 33]]);
      }))();
    },
    getAPDetail: function getAPDetail(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.isLoadingDetail = true;
                _this4.start = 0;
                _this4.end = 0;
                _this4.claim = 0;
                _context3.next = 7;
                return _this4.$axios.get("/AnnualPermit/" + id).then(function (response) {
                  _this4.isNewAnnualPermit = false;
                  _this4.annualPermit.id = id;
                  _this4.annualPermit.name = response.data.name;
                  _this4.annualPermit.definitions = response.data.definitions;
                  _this4.isLoadingDetail = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 7:
                response = _context3.sent;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this4.isLoadingDetail = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 10]]);
      }))();
    },
    getAnnualPermits: function getAnnualPermits() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var annualPermits, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoading = true;
                annualPermits = [];
                _context4.next = 5;
                return _this5.$axios.get("/AnnualPermit").then(function (response) {
                  response.data.forEach(function (doc) {
                    annualPermits.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                  _this5.annualPermits = annualPermits;
                  _this5.isLoading = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this5.isLoading = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.authControl == 1) {
                  alertify.warning(_this6.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this7.getAnnualPermits();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }
});

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      scenarios: []
    };
  },

  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 255;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    scenarioList: function scenarioList() {
      return this.scenarios;
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newScenario: function newScenario() {
      this.$router.push("/new-scenario");
    },
    goToDetails: function goToDetails(id) {
      this.$router.push({
        name: "scenario-details",
        params: { id: id }
      });
    },
    deleteScenario: function deleteScenario(id) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoading = true;
                _context.next = 4;
                return _this2.$axios.delete("/Scenario/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context.sent;

                _this2.getScenarios();
                alertify.success(_this2.$ml.get("alerts.deletedSuccessfully"));
                _this2.isLoading = false;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this2.isLoading = false;

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 10]]);
      }))();
    },
    getScenarios: function getScenarios() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.isLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this3.$axios.get("/Scenario").then(function (response) {
                  _this3.scenarios = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this3.isLoading = false;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);
                _this3.isLoading = false;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[1, 8]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.getScenarios();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }))();
  }
});

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      scenarios: [],
      scenario: {
        id: this.$route.params.id,
        name: "",
        type: 1,
        day: 0,
        days: [],
        time: null,
        command: 1,
        terminalList: []
      },
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }],
      devices: [],
      searchText: ""
    };
  },

  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    dayList: function dayList() {
      return this.days;
    },
    checkedDeviceList: function checkedDeviceList() {
      var checkedList = "";
      var list = this.devices.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    deviceList: function deviceList() {
      var _this = this;

      if (this.searchText != "") {
        return this.devices.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v) || item.ip.includes(v);
          });
        });
      } else {
        return this.devices.sort(function (a, b) {
          return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
        });
      }
    },
    scenarioList: function scenarioList() {
      return this.scenarios;
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    backToScenarioList: function backToScenarioList() {
      this.$router.push("/scenario-list");
    },
    changeDay: function changeDay(event) {
      this.scenario.day = event.target.value;
    },
    changeRepeat: function changeRepeat(event) {
      if (event.target.value == "1") {
        this.scenario.repeat = true;
      } else {
        this.scenario.repeat = false;
      }
    },
    checkSingleDevice: function checkSingleDevice(device) {
      this.deviceList.forEach(function (dev) {
        if (device.id == dev.id) {
          dev.check = true;
        } else {
          dev.check = false;
        }
      });
    },
    clearDevices: function clearDevices() {
      this.deviceList.forEach(function (dev) {
        dev.check = false;
      });
    },
    getCheckDeviceList: function getCheckDeviceList() {
      var _this3 = this;

      this.scenario.terminalList = [];
      this.devices.forEach(function (doc) {
        if (doc.check == true) {
          _this3.scenario.terminalList.push(doc.id);
        }
      });
    },
    checkDays: function checkDays() {
      var _this4 = this;

      this.scenario.days = [];
      this.dayList.forEach(function (item) {
        if (item.check == true) {
          _this4.scenario.days.push(item.value);
        }
      });
    },
    saveScenario: function saveScenario() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this5.getCheckDeviceList();

              case 2:
                if (!(_this5.scenario.name == "" || _this5.scenario.time == null || _this5.scenario.terminalList.length == 0)) {
                  _context.next = 5;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseCheckEmptyFields"));
                return _context.abrupt("return");

              case 5:
                if (!(_this5.scenario.id && _this5.scenario.day == 0)) {
                  _context.next = 8;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseCheckEmptyFields"));
                return _context.abrupt("return");

              case 8:
                if (_this5.scenario.id) {
                  _context.next = 29;
                  break;
                }

                _context.prev = 9;

                _this5.isLoading = true;
                _context.next = 13;
                return _this5.checkDays();

              case 13:
                if (!(_this5.scenario.days.length == 0)) {
                  _context.next = 16;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseCheckEmptyFields"));
                return _context.abrupt("return");

              case 16:
                _context.next = 18;
                return _this5.$axios.post("/Scenario", {
                  name: _this5.scenario.name,
                  type: _this5.scenario.type,
                  days: _this5.scenario.days,
                  time: _this5.scenario.time,
                  command: _this5.scenario.command,
                  terminalList: _this5.scenario.terminalList
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                    _this5.backToScenarioList();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 18:
                response = _context.sent;

                _this5.isLoading = false;
                _context.next = 27;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context["catch"](9);

                console.error(_context.t0);
                alertify.error("Servis Hatası :" + _context.t0.message);
                _this5.isLoading = false;

              case 27:
                _context.next = 42;
                break;

              case 29:
                _context.prev = 29;

                _this5.isLoading = true;
                _context.next = 33;
                return _this5.$axios.put("/Scenario", {
                  id: _this5.scenario.id,
                  name: _this5.scenario.name,
                  type: _this5.scenario.type,
                  day: _this5.scenario.day,
                  time: _this5.scenario.time,
                  command: _this5.scenario.command,
                  terminalList: _this5.scenario.terminalList
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                    _this5.backToScenarioList();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 33:
                _response = _context.sent;

                _this5.isLoading = false;
                _context.next = 42;
                break;

              case 37:
                _context.prev = 37;
                _context.t1 = _context["catch"](29);

                console.error(_context.t1);
                alertify.error("Servis Hatası :" + _context.t1.message);
                _this5.isLoading = false;

              case 42:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[9, 22], [29, 37]]);
      }))();
    },
    getDevices: function getDevices() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var devices, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this6.isLoading = true;
                devices = [];
                _context2.next = 5;
                return _this6.$axios.get("/Terminal").then(function (response) {
                  response.data.forEach(function (doc) {
                    devices.push({
                      id: doc.id,
                      no: doc.no,
                      name: doc.name,
                      ip: doc.ip,
                      lastConnectionTime: doc.lastConnectionTime,
                      lastConnectionStatus: doc.lastConnectionStatus,
                      check: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this6.devices = devices;
                _this6.isLoading = false;
                _context2.next = 15;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error("Servis Hatası :" + _context2.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[0, 10]]);
      }))();
    },
    getCheckDevices: function getCheckDevices() {
      var _this7 = this;

      this.deviceList.forEach(function (doc) {
        _this7.scenario.terminalList.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var response;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this8.getDevices();

            case 2:
              if (!_this8.scenario.id) {
                _context3.next = 16;
                break;
              }

              _this8.isLoading = true;
              _context3.prev = 4;
              _context3.next = 7;
              return _this8.$axios.get("/Scenario/" + _this8.scenario.id).then(function (response) {
                _this8.scenario.name = response.data.name;
                _this8.scenario.type = response.data.type;
                _this8.scenario.day = response.data.day;
                _this8.scenario.time = response.data.time ? _this8.toDateFormat(response.data.time, "ss:dd") : "";
                _this8.scenario.command = response.data.command;
                _this8.scenario.terminalList = response.data.terminalList;
                _this8.getCheckDevices();
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this8.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                    _this8.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this8.isLoading = false;
                    return;
                  }
                }
              });

            case 7:
              response = _context3.sent;

              _this8.isLoading = false;
              _context3.next = 16;
              break;

            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);

              console.error(_context3.t0);
              alertify.error("Servis Hatası :" + _context3.t0.message);
              _this8.isLoading = false;

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this8, [[4, 11]]);
    }))();
  }
});

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isNewTimeZone: true,
      timeZones: [],
      timeZone: {
        id: null,
        code: 1,
        name: ""
      }
    };
  },

  computed: {
    timeZoneList: function timeZoneList() {
      return this.timeZones;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 530;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    getTZDetail: function getTZDetail(id) {}
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
});

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_vue__ = __webpack_require__(83);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingReader: false,
      qrValue: "",
      qrSize: 200,
      qrTextStyle: "text-align:center;",
      orderDevice: 1,
      searchText: "",
      device: {
        id: null,
        deviceNo: null,
        name: "",
        seriNo: "",
        ipAddress: "",
        port: "",
        isActive: true,
        password: "",
        deviceGroupId: null,
        readers: [],
        brand: "",
        platform: "",
        isFingerDevice: false,
        isFaceDevice: false,
        isCardDevice: false,
        hasAntipassback: false,
        hasTimeZone: false,
        isOnlineDevice: false,
        isRealTime: false,
        isPanel: false
      },
      selectedReader: {
        id: null,
        name: "",
        inputName: "",
        isMainDoor: true,
        type: 0,
        statu: "0",
        readerNo: 1,
        positionX: 0,
        positionY: 0
      },
      devices: [],
      deviceGroups: [],
      brands: [],
      platforms: [],
      selectedBrand: {
        brand: "",
        platforms: []
      },
      isNewDevice: true,
      isNewReader: true
    };
  },

  components: {
    QrcodeVue: __WEBPACK_IMPORTED_MODULE_0_qrcode_vue__["a" /* default */]
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    deviceBrandList: function deviceBrandList() {
      return this.brands;
    },
    devicePlatformList: function devicePlatformList() {
      var _this = this;

      var brand = this.deviceBrandList.filter(function (item) {
        return item.brand == _this.device.brand;
      });
      if (brand.length > 0) {
        return brand[0].platforms;
      } else {
        return this.platforms;
      }
    },
    deviceList: function deviceList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.devices.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v) || item.ip.includes(v);
          });
        });
      } else {
        if (this.orderDevice == 1) {
          return this.devices.sort(function (a, b) {
            return a.ip.localeCompare(b.ip);
          });
        } else if (this.orderDevice == 2) {
          return this.devices.sort(function (a, b) {
            return b.ip.localeCompare(a.ip);
          });
        } else if (this.orderDevice == 3) {
          return this.devices.sort(function (a, b) {
            return _this2.turkishToUpper(a.name).localeCompare(_this2.turkishToUpper(b.name));
          });
        } else {
          return this.devices.sort(function (a, b) {
            return _this2.turkishToUpper(b.name).localeCompare(_this2.turkishToUpper(a.name));
          });
        }
      }
    },
    deviceGroupList: function deviceGroupList() {
      return this.deviceGroups;
    },
    deviceReaderList: function deviceReaderList() {
      return this.device.readers.sort(function (a, b) {
        if (a.readerNo < b.readerNo) return -1;
        if (a.readerNo > b.readerNo) return 0;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    print: function print() {
      this.$htmlToPaper("print");
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    setOrderDev: function setOrderDev(number) {
      if (number == 1) {
        if (this.orderDevice == 1) {
          this.orderDevice = 2;
        } else {
          this.orderDevice = 1;
        }
      } else {
        if (this.orderDevice == 3) {
          this.orderDevice = 4;
        } else {
          this.orderDevice = 3;
        }
      }
    },
    onCloseBoxDevice: function onCloseBoxDevice() {
      $("#deviceInfo").boxWidget("toggle");
    },
    changeDevicePlatform: function changeDevicePlatform(event) {
      this.device.platform = event.target.value;
    },
    changeDeviceBrand: function changeDeviceBrand(event) {
      this.device.brand = event.target.value;
      console.log(this.device.brand);
      if (this.device.brand == "ZkTeco" || this.device.brand == "ZKTeco") {
        this.device.port = 4370;
      } else if (this.device.brand == "Mavisoft Panel" || this.device.brand == "Mavisoft MW1010") {
        this.device.port = 5600;
      } else if (this.device.brand == "Mixa") {
        this.device.port = 5000;
      } else if (this.device.brand == "Anviz") {
        this.device.port = 8080;
      } else if (this.device.brand == "Hikvision") {
        this.device.port = 8000;
      } else if (this.device.brand == "Dahua") {
        this.device.port = 37777;
      } else if (this.device.brand == "Milesight") {
        this.device.port = 6000;
      } else if (this.device.brand == "Hanvon") {
        this.device.port = 8000;
      } else if (this.device.brand == "Soyal") {
        this.device.port = 6000;
      }
    },
    changeDeviceGroup: function changeDeviceGroup(event) {
      this.device.deviceGroupId = event.target.value;
    },
    changeReaderType: function changeReaderType(event) {
      this.selectedReader.type = event.target.value;
    },
    changeReaderStatu: function changeReaderStatu(event) {
      this.selectedReader.statu = event.target.value;
    },
    newDevice: function newDevice() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.isLoadingDetail = true;
                _this4.isNewDevice = true;
                _this4.device.id = null;
                _context.next = 5;
                return _this4.$axios.get("/Terminal/GetNewDeviceNo");

              case 5:
                response = _context.sent;

                _this4.device.deviceNo = response.data;
                _this4.device.seriNo = "";
                _this4.device.name = "";
                _this4.device.ipAddress = "";
                _this4.device.port = "";
                _this4.device.isActive = true;
                _this4.device.password = "";
                _this4.device.deviceGroupId = null;
                _this4.device.readers = [];
                _this4.device.brand = "";
                _this4.device.platform = "";
                _this4.device.isFingerDevice = false;
                _this4.device.isFaceDevice = false;
                _this4.device.isCardDevice = false;
                _this4.device.hasAntipassback = false;
                _this4.device.hasTimeZone = false;
                _this4.device.isOnlineDevice = false;
                _this4.device.isRealTime = false;
                _this4.device.isPanel = false;
                _this4.newReader();
                _this4.isLoadingDetail = false;

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    newReader: function newReader() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.isLoadingReader = true;
                _this5.isNewReader = true;
                _this5.selectedReader.id = null;
                _this5.selectedReader.name = "";
                _this5.selectedReader.inputName = "";
                _this5.selectedReader.isMainDoor = true;
                _this5.selectedReader.type = 0;
                _this5.selectedReader.statu = 0;
                _this5.selectedReader.positionX = 0;
                _this5.selectedReader.positionY = 0;
                _this5.qrValue = "";

                if (!_this5.device.id) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 14;
                return _this5.$axios.get("/Terminal/GetNewReaderNo?parentDeviceId=" + _this5.device.id);

              case 14:
                response = _context2.sent;

                _this5.selectedReader.readerNo = response.data;
                _context2.next = 19;
                break;

              case 18:
                _this5.selectedReader.readerNo = 1;

              case 19:
                _this5.isLoadingReader = false;

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    deleteReader: function deleteReader() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!_this6.isNewReader) {
                  _context3.next = 4;
                  break;
                }

                alertify.warning(_this6.$ml.get("alerts.pleaseSelectReader"));
                _context3.next = 20;
                break;

              case 4:
                _this6.isLoadingReader = true;
                _context3.prev = 5;
                id = _this6.selectedReader.id;
                _context3.next = 9;
                return _this6.$axios.delete("/Terminal/DeleteReader/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context3.sent;

                _this6.getDevice(_this6.device.id);
                _this6.newReader();
                alertify.success(_this6.$ml.get("alerts.deletedSuccessfully"));
                _this6.isLoadingReader = false;
                _context3.next = 20;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](5);

                alertify.error("Hata Oluştu : " + _context3.t0);
                _this6.isLoadingReader = false;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[5, 16]]);
      }))();
    },
    saveReader: function saveReader() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var reader2, deviceId, response, id, _reader, _deviceId, _response, _id;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this7.selectedReader.name == "")) {
                  _context4.next = 3;
                  break;
                }

                alertify.warning(_this7.$ml.get("alerts.pleaseEnterAReaderName"));
                return _context4.abrupt("return");

              case 3:
                if (!(_this7.selectedReader.readerNo == "")) {
                  _context4.next = 6;
                  break;
                }

                alertify.warning(_this7.$ml.get("alerts.pleaseReaderNoOrPressButtonNewReader"));
                return _context4.abrupt("return");

              case 6:
                _this7.isLoadingReader = true;

                if (!_this7.isNewReader) {
                  _context4.next = 29;
                  break;
                }

                _context4.prev = 8;
                reader2 = _this7.selectedReader;
                deviceId = _this7.device.id;
                _context4.next = 13;
                return _this7.$axios.post("/Terminal/AddReader", {
                  name: reader2.name,
                  inputName: reader2.inputName,
                  isMainDoor: reader2.isMainDoor,
                  parentDeviceId: parseInt(deviceId),
                  doorType: parseInt(reader2.type),
                  readerNo: parseInt(reader2.readerNo),
                  inOut: parseInt(reader2.statu),
                  positionX: parseFloat(reader2.positionX),
                  positionY: parseFloat(reader2.positionY)
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 13:
                response = _context4.sent;
                id = response.data.okuyucuId;

                if (response.status == 200) {
                  alertify.success(_this7.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this7.getDevice(deviceId);
                _this7.getDeviceReader(id);
                _this7.isNewReader = false;
                _this7.isLoadingReader = false;
                _context4.next = 27;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4["catch"](8);

                console.error(_context4.t0);
                alertify.error(_context4.t0);
                _this7.isLoadingReader = false;

              case 27:
                _context4.next = 47;
                break;

              case 29:
                _context4.prev = 29;
                _reader = _this7.selectedReader;
                _deviceId = _this7.device.id;
                _context4.next = 34;
                return _this7.$axios.post("/Terminal/UpdateReader/" + _reader.id, {
                  name: _reader.name,
                  inputName: _reader.inputName,
                  isMainDoor: _reader.isMainDoor,
                  parentDeviceId: parseInt(_deviceId),
                  doorType: parseInt(_reader.type),
                  readerNo: parseInt(_reader.readerNo),
                  inOut: parseInt(_reader.statu),
                  positionX: parseFloat(_reader.positionX),
                  positionY: parseFloat(_reader.positionY)
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 34:
                _response = _context4.sent;
                _id = _response.data.okuyucuId;

                if (_response.status == 200) {
                  alertify.success(_this7.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response.message);
                }
                _this7.getDevice(_deviceId);
                _this7.getDeviceReader(_id);
                _this7.isLoadingReader = false;
                _context4.next = 47;
                break;

              case 42:
                _context4.prev = 42;
                _context4.t1 = _context4["catch"](29);

                console.error(_context4.t1);
                alertify.error(_context4.t1);
                _this7.isLoadingReader = false;

              case 47:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[8, 22], [29, 42]]);
      }))();
    },
    deleteDevice: function deleteDevice() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this8.isLoadingDetail = true;
                id = _this8.device.id;
                _context5.next = 5;
                return _this8.$axios.delete("/Terminal/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get("errors.connectionError"));
                      _this8.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;

                _this8.getDevices();
                _this8.newDevice();
                alertify.success(_this8.$ml.get("alerts.deletedSuccessfully"));
                _this8.isLoadingDetail = false;
                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](0);

                alertify.error("Hata Oluştu : " + _context5.t0);
                _this8.isLoadingDetail = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 12]]);
      }))();
    },
    saveDevice: function saveDevice() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var device2, response, id, _device, _response2;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this9.device.deviceNo == "" || _this9.device.deviceNo == null)) {
                  _context6.next = 3;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.pleaseEnterADeviceNo"));
                return _context6.abrupt("return");

              case 3:
                if (!(_this9.device.name == "")) {
                  _context6.next = 6;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.pleaseEnterADeviceName"));
                return _context6.abrupt("return");

              case 6:
                if (!(_this9.device.ipAddress == "" || _this9.device.port == "")) {
                  _context6.next = 9;
                  break;
                }

                alertify.warning(_this9.$ml.get("alerts.pleaseEnterIpAddressAndPort"));
                return _context6.abrupt("return");

              case 9:
                _this9.isLoadingDetail = true;

                if (!_this9.isNewDevice) {
                  _context6.next = 35;
                  break;
                }

                if (!(_this9.deviceList.length >= _this9.modules.maxTerminalCount)) {
                  _context6.next = 15;
                  break;
                }

                _this9.isLoadingDetail = false;
                $("#maxTerminalLicence").modal("show");
                return _context6.abrupt("return");

              case 15:
                _context6.prev = 15;
                device2 = _this9.device;
                _context6.next = 19;
                return _this9.$axios.post("/Terminal", {
                  name: device2.name,
                  deviceNo: parseInt(device2.deviceNo),
                  seriNo: device2.seriNo,
                  ipAddress: device2.ipAddress,
                  port: device2.port,
                  isActive: device2.isActive,
                  password: device2.password,
                  deviceGroupId: parseInt(device2.deviceGroupId),
                  brand: device2.brand,
                  platform: device2.platform,
                  isFingerDevice: device2.isFingerDevice,
                  isCardDevice: device2.isCardDevice,
                  isFaceDevice: device2.isFaceDevice,
                  hasAntiPassback: device2.hasAntipassback,
                  hasTimeZone: device2.hasTimeZone,
                  isOnlineDevice: device2.isOnlineDevice,
                  isRealTime: device2.isRealTime,
                  isPanel: device2.isPanel
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 19:
                response = _context6.sent;
                id = response.data.terminalId;

                if (response.status == 200) {
                  alertify.success(_this9.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this9.getDevices();
                _this9.getDevice(id);
                _this9.isNewDevice = false;
                _this9.isLoadingDetail = false;
                _context6.next = 33;
                break;

              case 28:
                _context6.prev = 28;
                _context6.t0 = _context6["catch"](15);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this9.isLoadingDetail = false;

              case 33:
                _context6.next = 50;
                break;

              case 35:
                _context6.prev = 35;
                _device = _this9.device;
                _context6.next = 39;
                return _this9.$axios.post("/Terminal/" + _device.id, {
                  name: _device.name,
                  deviceNo: parseInt(_device.deviceNo),
                  seriNo: _device.seriNo,
                  ipAddress: _device.ipAddress,
                  port: _device.port,
                  isActive: _device.isActive,
                  password: _device.password,
                  deviceGroupId: _device.deviceGroupId,
                  brand: _device.brand,
                  platform: _device.platform,
                  isFingerDevice: _device.isFingerDevice,
                  isCardDevice: _device.isCardDevice,
                  isFaceDevice: _device.isFaceDevice,
                  hasAntiPassback: _device.hasAntipassback,
                  hasTimeZone: _device.hasTimeZone,
                  isOnlineDevice: _device.isOnlineDevice,
                  isRealTime: _device.isRealTime,
                  isPanel: _device.isPanel
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this9.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this9.$ml.get("errors.connectionError"));
                      _this9.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this9.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 39:
                _response2 = _context6.sent;

                if (_response2.status == 200) {
                  alertify.success(_this9.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response2.message);
                }
                _this9.getDevices();
                _this9.isLoadingDetail = false;
                _context6.next = 50;
                break;

              case 45:
                _context6.prev = 45;
                _context6.t1 = _context6["catch"](35);

                console.error(_context6.t1);
                alertify.error(_context6.t1);
                _this9.isLoadingDetail = false;

              case 50:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9, [[15, 28], [35, 45]]);
      }))();
    },
    getDevice: function getDevice(id) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response, dd;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this10.isLoadingDetail = true;
                _context7.next = 4;
                return _this10.$axios.get("/Terminal/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this10.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this10.$ml.get("errors.connectionError"));
                      _this10.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this10.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context7.sent;

                _this10.isNewDevice = false;
                _this10.device.id = id;
                _this10.device.deviceNo = response.data.deviceNo;
                _this10.device.seriNo = response.data.seriNo;
                _this10.device.name = response.data.name;
                _this10.device.ipAddress = response.data.ipAddress;
                _this10.device.port = response.data.port;
                _this10.device.isActive = response.data.isActive;
                _this10.device.password = response.data.password;
                _this10.device.deviceGroupId = response.data.deviceGroupId;
                _this10.device.readers = response.data.readers;
                _this10.device.brand = response.data.brand;
                if (response.data.brand == "Superpass") {
                  _this10.device.brand = "Mixa";
                }
                _this10.device.platform = response.data.platform;
                _this10.device.isFingerDevice = response.data.isFingerDevice;
                _this10.device.isFaceDevice = response.data.isFaceDevice;
                _this10.device.isCardDevice = response.data.isCardDevice;
                _this10.device.hasAntipassback = response.data.hasAntiPassback;
                _this10.device.hasTimeZone = response.data.hasTimeZone;
                _this10.device.isOnlineDevice = response.data.isOnlineDevice;
                _this10.device.isRealTime = response.data.isRealTime;
                _this10.device.isPanel = response.data.isPanel;
                if (_this10.device.readers.length != 0) {
                  dd = _this10.device.readers[0].id;

                  _this10.getDeviceReader(dd);
                } else {
                  _this10.newReader();
                }
                _this10.isLoadingDetail = false;
                _context7.next = 36;
                break;

              case 31:
                _context7.prev = 31;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error(_context7.t0);
                _this10.isLoadingDetail = false;

              case 36:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10, [[0, 31]]);
      }))();
    },
    getDeviceReader: function getDeviceReader(id) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var response;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;

                _this11.isLoadingReader = true;
                _context8.next = 4;
                return _this11.$axios.get("/Terminal/GetReader/" + id).then(function (response) {
                  _this11.isNewReader = false;
                  _this11.selectedReader.id = id;
                  _this11.selectedReader.readerNo = response.data.readerNo;
                  _this11.selectedReader.name = response.data.name;
                  _this11.selectedReader.inputName = response.data.inputName;
                  _this11.selectedReader.isMainDoor = response.data.isMainDoor;
                  _this11.selectedReader.type = response.data.doorType;
                  _this11.selectedReader.statu = response.data.inOut;
                  _this11.selectedReader.positionX = response.data.positionX;
                  _this11.selectedReader.positionY = response.data.positionY;
                  _this11.qrValue = "TCRP-" + id;
                  _this11.isLoadingReader = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this11.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this11.$ml.get("errors.connectionError"));
                      _this11.isLoadingReader = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this11.isLoadingReader = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context8.sent;
                _context8.next = 12;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);

                console.error(_context8.t0);
                alertify.error(_context8.t0);
                _this11.isLoadingReader = false;

              case 12:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11, [[0, 7]]);
      }))();
    },
    getDevices: function getDevices() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var devices, response;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this12.isLoading = true;
                devices = [];
                _context9.next = 5;
                return _this12.$axios.get("/Terminal").then(function (response) {
                  response.data.forEach(function (doc) {
                    devices.push({
                      id: doc.id,
                      no: doc.no,
                      name: doc.name,
                      ip: doc.ip
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this12.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this12.$ml.get("errors.connectionError"));
                      _this12.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this12.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context9.sent;

                _this12.devices = devices;
                _this12.isLoading = false;
                _context9.next = 15;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);

                console.error(_context9.t0);
                alertify.error("Servis Hatası :" + _context9.t0.message);
                _this12.isLoading = false;

              case 15:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12, [[0, 10]]);
      }))();
    },
    GetBrandsAndPlatforms: function GetBrandsAndPlatforms() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var response;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;

                _this13.isLoading = true;
                _context10.next = 4;
                return _this13.$axios.get("/Terminal/GetBrandsAndPlatforms").then(function (response) {
                  _this13.brands = response.data;
                  _this13.device.brand = _this13.brands[0].brand;
                  _this13.device.platform = _this13.brands[0].platforms[0];
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this13.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this13.$ml.get("errors.connectionError"));
                      _this13.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this13.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context10.sent;

                _this13.isLoading = false;
                _context10.next = 13;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);

                console.error(_context10.t0);
                alertify.error("Servis Hatası :" + _context10.t0.message);
                _this13.isLoading = false;

              case 13:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13, [[0, 8]]);
      }))();
    },
    getDeviceGroups: function getDeviceGroups() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var deviceGroups, response;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;

                _this14.isLoadingDetail = true;
                deviceGroups = [];
                _context11.next = 5;
                return _this14.$axios.get("/TerminalGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    deviceGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this14.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this14.$ml.get("errors.connectionError"));
                      _this14.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this14.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context11.sent;

                _this14.deviceGroups = deviceGroups;
                _this14.isLoadingDetail = false;
                _context11.next = 15;
                break;

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);

                console.error(_context11.t0);
                alertify.error("Servis Hatası :" + _context11.t0.message);
                _this14.isLoadingDetail = false;

              case 15:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_this15.authControl == 1) {
                  alertify.warning(_this15.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this16 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return _this16.getAuthControl();

            case 2:
              _context13.next = 4;
              return _this16.getDevices();

            case 4:
              _context13.next = 6;
              return _this16.getDeviceGroups();

            case 6:
              _context13.next = 8;
              return _this16.GetBrandsAndPlatforms();

            case 8:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this16);
    }))();
  }
});

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      readers: [],
      work: {
        date: null,
        isRepeated: false,
        day: 0,
        command: 0,
        terminalsAndReaders: []
      },
      selectedWork: {
        terminalWorkId: null,
        command: null,
        date: null,
        readerId: null
      },
      isCheck: false,
      works: []
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    readerList: function readerList() {
      var _this = this;

      if (this.searchText) {
        return this.readers.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.showName.toUpperCase().includes(v);
          });
        });
      } else {
        return this.readers.sort(function (a, b) {
          if (a.ipAddress < b.ipAddress) return -1;
          if (a.ipAddress > b.ipAddress) return 0;
        });
      }
    },
    workList: function workList() {
      return this.works.sort(function (a, b) {
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 0;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReaderHeightSize: function windowReaderHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 540;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      var saat = toDay.getHours() < 10 ? "0" + toDay.getHours() : toDay.getHours();
      var dakika = toDay.getMinutes() < 10 ? "0" + toDay.getMinutes() : toDay.getMinutes();
      if (this.work.date == null) {
        this.work.date = yil + "-" + ay + "-" + gun + "T" + saat + ":" + dakika;
      }
    },
    changeCommand: function changeCommand(event) {
      this.work.command = event.target.value;
    },
    checkReaders: function checkReaders() {
      var _this3 = this;

      this.isCheck = !this.isCheck;
      var aList = this.readers;
      aList.forEach(function (doc) {
        if (doc.check == !_this3.isCheck) {
          doc.check = _this3.isCheck;
        }
      });
    },
    getReader: function getReader(id) {
      var aList = this.readers;
      var reader = aList.filter(function (reader) {
        return reader.readerId == id;
      });
      if (reader.length > 0) {
        return reader[0].name;
      } else {
        return "";
      }
    },
    getCheckReaderList: function getCheckReaderList() {
      var _this4 = this;

      var aList = this.readers;
      this.work.terminalsAndReaders = [];
      aList.forEach(function (doc) {
        if (doc.check == true) {
          _this4.work.terminalsAndReaders.push({
            terminalId: doc.terminalId,
            readerId: doc.readerId
          });
        }
      });
    },
    selectWork: function selectWork(id) {
      var aList = this.works;
      var work3 = aList.filter(function (work4) {
        return work4.terminalWorkId == id;
      });
      this.selectedWork.terminalWorkId = work3[0].terminalWorkId;
      this.selectedWork.command = work3[0].command;
      this.selectedWork.date = work3[0].date;
      this.selectedWork.readerId = work3[0].readerId;
    },
    deleteWork: function deleteWork(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this5.isLoading = true;
                _context.next = 4;
                return _this5.$axios.delete("/TerminalService/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this5.$ml.get("errors.connectionError"));
                    _this5.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this5.isLoading = false;
                    return;
                  }
                });

              case 4:
                response = _context.sent;

                _this5.getWorkList();
                if (response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.deletedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this5.isLoading = false;
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error("Servis Hatası : " + _context.t0);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[0, 10]]);
      }))();
    },
    saveWork: function saveWork() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var work2, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this6.work.date == null)) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this6.$ml.get("deviceOperations.pleaseEnterADate"));
                return _context2.abrupt("return");

              case 3:
                _this6.isLoadingDetail = true;
                _context2.next = 6;
                return _this6.getCheckReaderList();

              case 6:
                _context2.prev = 6;
                work2 = _this6.work;
                _context2.next = 10;
                return _this6.$axios.post("/TerminalService", {
                  date: work2.date,
                  isRepeated: work2.isRepeated,
                  command: work2.command,
                  day: work2.day,
                  terminalsAndReaders: work2.terminalsAndReaders
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this6.$ml.get("errors.connectionError"));
                    _this6.isLoadingDetail = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this6.isLoadingDetail = false;
                    return;
                  }
                });

              case 10:
                response = _context2.sent;

                if (response.status == 200) {
                  alertify.success(_this6.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this6.getWorkList();
                _this6.isLoadingDetail = false;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2["catch"](6);

                console.error(_context2.t0);
                alertify.error("Servis Hatası : " + _context2.t0);
                _this6.isLoadingDetail = false;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[6, 16]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this7.isLoadingDetail = true;
                readers = [];
                _context3.next = 5;
                return _this7.$axios.get("/Terminal/GetReaders").then(function (response) {
                  response.data.forEach(function (doc) {
                    if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                      readers.push({
                        readerNo: doc.readerNo,
                        readerId: doc.readerId,
                        terminalId: doc.terminalId,
                        terminalNo: doc.terminalNo,
                        ipAddress: doc.ipAddress,
                        name: doc.name,
                        showName: doc.ipAddress + " | " + doc.readerNo + " - " + doc.name,
                        check: false
                      });
                    }
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this7.$ml.get("errors.connectionError"));
                    _this7.isLoadingDetail = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this7.isLoadingDetail = false;
                    return;
                  }
                });

              case 5:
                response = _context3.sent;

                _this7.readers = readers;
                _this7.isLoadingDetail = false;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Servis Hatası :" + _context3.t0.message);
                _this7.isLoadingDetail = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7, [[0, 10]]);
      }))();
    },
    getWorkList: function getWorkList() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var works, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this8.isLoading = true;
                works = [];
                _context4.next = 5;
                return _this8.$axios.get("/TerminalService").then(function (response) {
                  response.data.forEach(function (doc) {
                    works.push({
                      terminalWorkId: doc.terminalWorkId,
                      date: doc.date,
                      readerId: doc.readerId,
                      isRepeated: doc.isRepeated,
                      command: doc.command,
                      day: doc.day,
                      employeeName: doc.employeeName
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this8.$ml.get("errors.connectionError"));
                    _this8.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this8.isLoading = false;
                    return;
                  }
                });

              case 5:
                response = _context4.sent;

                _this8.works = works;
                _this8.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this8.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this9.authControl == 1) {
                  alertify.warning(_this9.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this9);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this10.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this10.getReaders();

            case 4:
              _context6.next = 6;
              return _this10.getWorkList();

            case 6:
              _context6.next = 8;
              return _this10.getDefaultDate();

            case 8:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this10);
    }))();
  }
});

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      workPlace: {
        id: null,
        name: ""
      },
      workPlaces: [],
      isNewWorkPlace: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    workPlaceList: function workPlaceList() {
      var _this = this;

      if (this.searchText) {
        return this.workPlaces.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.workPlaces;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    toDateFormat: function toDateFormat(str, format) {
      if (str.length > 9) {
        str = new Date(str);
      } else {
        str = new Date("1900-01-01 " + str.replace("Z", ""));
      }
      if (format == "gg.aa.yyyy ss:dd") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
      } else if (format == "gg.aa.yyyy") {
        var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
        var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
        var yil = str.getFullYear();
        return yil + "-" + ay + "-" + gun;
      } else if (format == "ss:dd:ss") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
        return saat + ":" + dakika + ":" + saniye;
      } else if (format == "ss:dd") {
        var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
        var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
        return saat + ":" + dakika;
      }
    },
    newWorkPlace: function newWorkPlace() {
      this.isLoadingDetail = true;
      this.isNewWorkPlace = true;
      this.workPlace.id = null;
      this.workPlace.name = "";
      this.isLoadingDetail = false;
    },
    deleteWorkPlace: function deleteWorkPlace() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.workPlace.id;
                _context.next = 5;
                return _this3.$axios.delete("/WorkPlaceDefinition/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.getWorkPlaces();
                _this3.newWorkPlace();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this3.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 12]]);
      }))();
    },
    saveWorkPlace: function saveWorkPlace() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var workPlace2, response, id, _workPlace, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this4.workPlace.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get('alerts.pleaseEnterAName'));
                return _context2.abrupt("return");

              case 3:
                _this4.isLoadingDetail = true;

                if (!_this4.isNewWorkPlace) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 5;
                workPlace2 = _this4.workPlace;
                _context2.next = 9;
                return _this4.$axios.post("/WorkPlaceDefinition", {
                  name: workPlace2.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this4.getWorkPlaces();
                _this4.getWorkPlace(id);
                _this4.isNewWorkPlace = false;
                _this4.isLoadingDetail = false;
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this4.isLoadingDetail = false;

              case 23:
                _context2.next = 40;
                break;

              case 25:
                _context2.prev = 25;
                _workPlace = _this4.workPlace;
                _context2.next = 29;
                return _this4.$axios.put("/WorkPlaceDefinition/" + _workPlace.id, {
                  name: _workPlace.name
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoading = false;
                      return;
                    }
                  }
                });

              case 29:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this4.getWorkPlaces();
                _this4.isLoadingDetail = false;
                _context2.next = 40;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](25);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this4.isLoadingDetail = false;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[5, 18], [25, 35]]);
      }))();
    },
    getWorkPlace: function getWorkPlace(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this5.isLoadingDetail = true;
                _context3.next = 4;
                return _this5.$axios.get("/WorkPlaceDefinition/GetById/" + id).then(function (response) {
                  _this5.isNewWorkPlace = false;
                  _this5.workPlace.id = id;
                  _this5.workPlace.name = response.data.name;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this5.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0);
                _this5.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this5, [[0, 8]]);
      }))();
    },
    getWorkPlaces: function getWorkPlaces() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var workPlaces, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this6.isLoading = true;
                workPlaces = [];
                _context4.next = 5;
                return _this6.$axios.get("/WorkPlaceDefinition/GetAll").then(function (response) {
                  response.data.forEach(function (doc) {
                    workPlaces.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this6.workPlaces = workPlaces;
                _this6.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error("Servis Hatası :" + _context4.t0.message);
                _this6.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this8.getWorkPlaces();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this8);
    }))();
  }
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingSetting: false,
      fields: [{ name: "sicilNo", label: this.$ml.get('employees.registrationNumberInfo'), isChecked: true, disabled: true }, { name: "name", label: this.$ml.get('employees.nameSurname'), isChecked: true, disabled: true }, { name: "title", label: this.$ml.get('employees.title'), isChecked: false, disabled: false }, { name: "departmentId", label: this.$ml.get('employees.department'), isChecked: true, disabled: true }, { name: "identityNo", label: this.$ml.get('employees.citizenshipNumber'), isChecked: false, disabled: false }, { name: "startDate", label: this.$ml.get('employees.dateOfStartWorkInfo'), isChecked: true, disabled: true }, { name: "endDate", label: this.$ml.get('employees.dateOfEndWork'), isChecked: false, disabled: false }, { name: "workGroupId", label: this.$ml.get('employees.workPlan'), isChecked: false, disabled: false }, { name: "stateId", label: this.$ml.get('employees.state'), isChecked: false, disabled: false }, { name: "stateNote", label: this.$ml.get('employees.stateNote'), isChecked: false, disabled: false }, { name: "terminalNo", label: this.$ml.get('employees.deviceEmployeeNumber'), isChecked: true, disabled: true }, { name: "statuId", label: this.$ml.get('employees.status'), isChecked: false, disabled: false }, { name: "cardNo", label: this.$ml.get('employees.deviceCardNo'), isChecked: false, disabled: false }, { name: "terminalStatu", label: this.$ml.get('employees.deviceStatus'), isChecked: false, disabled: false }, { name: "terminalPassword", label: this.$ml.get('employees.devicePassword'), isChecked: false, disabled: false }, { name: "tzCode", label: "Timezone", isChecked: false, disabled: false }, { name: "plateNo", label: this.$ml.get('employees.plateNo'), isChecked: false, disabled: false }, { name: "hgsNo", label: this.$ml.get('employees.hgsNo'), isChecked: false, disabled: false }, { name: "documentNo", label: this.$ml.get('employees.documentNo'), isChecked: false, disabled: false }],
      company: {
        id: null,
        name: "",
        logo: null,
        website: "",
        phoneNumber: "",
        address: "",
        title: "",
        setSicilNoToTerminalNo: false
      },
      ztkartBosYetki: null,
      ztkartYetki: null,
      isNewCompany: true,
      companies: [],
      accessGroups: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {}
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    companyList: function companyList() {
      return this.companies;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeZTKartYetki: function changeZTKartYetki(event) {
      this.ztkartYetki = event.target.value;
    },
    changeZTKartBosYetki: function changeZTKartBosYetki(event) {
      this.ztkartBosYetki = event.target.value;
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.company.logo = null;
    },
    newCompany: function newCompany() {
      this.isLoadingDetail = true;
      this.isNewCompany = true;
      this.company.id = null;
      this.company.name = "";
      this.company.logo = null;
      this.company.website = "";
      this.company.phoneNumber = "";
      this.company.address = "";
      this.company.title = "";
      this.company.setSicilNoToTerminalNo = false;
      this.imageData = null;
      this.tempUrl = null;
      this.isLoadingDetail = false;
    },
    deleteCompany: function deleteCompany() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoadingDetail = true;
                id = _this2.company.id;
                _context.next = 5;
                return _this2.$axios.delete("/CompanySettings/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this2.getCompanies();
                _this2.newCompany();
                alertify.success(_this2.$ml.get('alerts.deletedSuccessfully'));
                _this2.isLoadingDetail = false;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                alertify.error("Hata Oluştu : " + _context.t0);
                _this2.isLoadingDetail = false;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },
    saveCompany: function saveCompany() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var requiredFields, company2, image, response, id, formData, responseImage, _company, _image, _response, _id, _formData, _responseImage, _responseImage2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.company.name == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get('alerts.pleaseEnterACompanyName'));
                return _context2.abrupt("return");

              case 3:
                requiredFields = [];

                _this3.fields.forEach(function (field) {
                  if (field.isChecked) {
                    requiredFields.push(field.name);
                  }
                });

                if (!_this3.isNewCompany) {
                  _context2.next = 36;
                  break;
                }

                _this3.isLoadingDetail = true;
                _context2.prev = 7;
                company2 = _this3.company;
                image = _this3.imageData;
                _context2.next = 12;
                return _this3.$axios.post("/CompanySettings", {
                  name: company2.name,
                  website: company2.website,
                  phoneNumber: company2.phoneNumber,
                  address: company2.address,
                  title: company2.title,
                  setSicilNoToTerminalNo: company2.setSicilNoToTerminalNo,
                  requiredFields: requiredFields
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 12:
                response = _context2.sent;
                id = response.data.sirketId;

                if (!_this3.imageData) {
                  _context2.next = 22;
                  break;
                }

                formData = new FormData();

                formData.append("id", id);
                formData.append("file", image);

                if (!(_this3.imageData != null)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 21;
                return _this3.$axios.post("/CompanySettings/AddCompanyLogo/" + id, formData);

              case 21:
                responseImage = _context2.sent;

              case 22:
                if (response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this3.getCompanies();
                _this3.getCompany(id);
                _this3.isNewCompany = false;
                _this3.isLoadingDetail = false;
                _context2.next = 34;
                break;

              case 29:
                _context2.prev = 29;
                _context2.t0 = _context2["catch"](7);

                console.error(_context2.t0);
                alertify.error(_context2.t0);
                _this3.isLoadingDetail = false;

              case 34:
                _context2.next = 66;
                break;

              case 36:
                _context2.prev = 36;
                _company = _this3.company;
                _image = _this3.imageData;
                _context2.next = 41;
                return _this3.$axios.post("/CompanySettings/" + _company.id, {
                  name: _company.name,
                  website: _company.website,
                  phoneNumber: _company.phoneNumber,
                  address: _company.address,
                  title: _company.title,
                  setSicilNoToTerminalNo: _company.setSicilNoToTerminalNo,
                  requiredFields: requiredFields
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 41:
                _response = _context2.sent;
                _id = _company.id;

                if (!_this3.imageData) {
                  _context2.next = 52;
                  break;
                }

                _formData = new FormData();

                _formData.append("id", _id);
                _formData.append("file", _image);
                _context2.next = 49;
                return _this3.$axios.post("/CompanySettings/AddCompanyLogo/" + _id, _formData);

              case 49:
                _responseImage = _context2.sent;
                _context2.next = 56;
                break;

              case 52:
                if (!(_this3.company.logo == null)) {
                  _context2.next = 56;
                  break;
                }

                _context2.next = 55;
                return _this3.$axios.patch("/CompanySettings/RemoveLogo/" + _id);

              case 55:
                _responseImage2 = _context2.sent;

              case 56:
                if (_response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this3.getCompanies();
                _this3.isLoadingDetail = false;
                _context2.next = 66;
                break;

              case 61:
                _context2.prev = 61;
                _context2.t1 = _context2["catch"](36);

                console.error(_context2.t1);
                alertify.error(_context2.t1);
                _this3.isLoadingDetail = false;

              case 66:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[7, 29], [36, 61]]);
      }))();
    },
    setSetting: function setSetting() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var company2, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.isLoadingSetting = true;
                company2 = _this4.company;
                _context3.next = 5;
                return _this4.$axios.post("/CompanySettings/UpdateCompanyVisitorSettings", {
                  ztkartBosYetki: _this4.ztkartBosYetki,
                  ztkartYetki: _this4.ztkartYetki,
                  sirketId: company2.id
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this4.$ml.get('alerts.updatedSuccessfully'));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingSetting = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingSetting = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context3.sent;

                _this4.isLoadingSetting = false;
                _context3.next = 14;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error("Hata :" + _context3.t0.message);
                _this4.isLoadingSetting = false;

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 9]]);
      }))();
    },
    getSetting: function getSetting(id) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoadingSetting = true;
                _context4.next = 4;
                return _this5.$axios.get("CompanySettings/GetCompanyVisitorSettings?companyId=" + id).then(function (response) {
                  _this5.ztkartBosYetki = response.data.ztkartBosYetki;
                  _this5.ztkartYetki = response.data.ztkartYetki;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoadingSetting = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingSetting = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context4.sent;

                _this5.isLoadingSetting = false;
                _context4.next = 13;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0);
                _this5.isLoadingSetting = false;

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 8]]);
      }))();
    },
    getCompany: function getCompany(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this6.isLoadingDetail = true;
                _this6.newCompany();
                _context5.next = 5;
                return _this6.$axios.get("/CompanySettings/" + id).then(function (response) {
                  _this6.isNewCompany = false;
                  _this6.company.id = id;
                  _this6.company.name = response.data.name;
                  _this6.company.logo = response.data.logo;
                  _this6.company.website = response.data.website;
                  _this6.company.phoneNumber = response.data.phoneNumber;
                  _this6.company.address = response.data.address;
                  _this6.company.title = response.data.title;
                  _this6.company.setSicilNoToTerminalNo = response.data.setSicilNoToTerminalNo;
                  _this6.fields.forEach(function (field) {
                    if (response.data.requiredFields.includes(field.name)) {
                      field.isChecked = true;
                    } else {
                      field.isChecked = false;
                    }
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;
                _context5.next = 8;
                return _this6.getSetting(id);

              case 8:
                _this6.isLoadingDetail = false;
                _context5.next = 16;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error(_context5.t0);
                _this6.isLoadingDetail = false;

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 11]]);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var companies, response;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;

                _this7.isLoading = true;
                companies = [];
                _context6.next = 5;
                return _this7.$axios.get("/CompanySettings").then(function (response) {
                  response.data.forEach(function (doc) {
                    companies.push({
                      id: doc.id,
                      name: doc.name,
                      logo: doc.logo,
                      website: doc.website,
                      phoneNumber: doc.phoneNumber,
                      address: doc.address,
                      title: doc.title,
                      setSicilNoToTerminalNo: doc.setSicilNoToTerminalNo
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get('errors.connectionError'));
                      _this7.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context6.sent;

                _this7.companies = companies;
                if (companies.length > 0) {
                  _this7.getCompany(companies[0].id);
                  _this7.getSetting(companies[0].id);
                }
                _this7.isLoading = false;
                _context6.next = 16;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);

                console.error(_context6.t0);
                alertify.error(_context6.t0.message);
                _this7.isLoading = false;

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7, [[0, 11]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;

                _this8.isLoading = true;
                accessGroups = [];
                _context7.next = 5;
                return _this8.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this8.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this8.$ml.get('errors.connectionError'));
                      _this8.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this8.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context7.sent;

                _this8.accessGroups = accessGroups;
                _this8.isLoading = false;
                _context7.next = 15;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);

                console.error(_context7.t0);
                alertify.error("Servis Hatası :" + _context7.t0.message);
                _this8.isLoading = false;

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (_this9.authControl == 1) {
                  alertify.warning(_this9.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this10.getAuthControl();

            case 2:
              _context9.next = 4;
              return _this10.getCompanies();

            case 4:
              _context9.next = 6;
              return _this10.getAccessGroups();

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, _this10);
    }))();
  }
});

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      webshiftSettings: {
        id: 0,
        shiftMode: 0, //Aylık - Haftalık
        allowenceLimitPerWeek: 0, //Aynı haftaya maksimum girilebilir izin sayısı
        changeShiftDayLimit: 0, //Geriye dönük planlama sınırı
        isConfirmActive: true, //Onay gerekli mi?
        mailToFirstAuthorizedPerson: true, //Uyarı maili aktif
        mailToSecondAuthorizedPerson: true, //Uyarı tekrarı maili (ertesi gün)
        shiftConfirmStartDay: 0 //Onay başlangıç günü
      },
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: true }, { value: 2, name: this.$ml.get("general.tuesday"), check: true }, { value: 3, name: this.$ml.get("general.wednesday"), check: true }, { value: 4, name: this.$ml.get("general.thursday"), check: true }, { value: 5, name: this.$ml.get("general.friday"), check: true }, { value: 6, name: this.$ml.get("general.saturday"), check: true }, { value: 7, name: this.$ml.get("general.sunday"), check: true }]
    };
  },

  computed: {
    dayList: function dayList() {
      return this.days;
    },
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    changeShiftMode: function changeShiftMode(event) {
      this.webshiftSettings.shiftMode = event.target.value;
    },
    setSetting: function setSetting() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoading = true;
                _context.next = 4;
                return _this2.$axios.post("/WebshiftSettings", _this2.webshiftSettings).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this2.$ml.get("alerts.updatedSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context.sent;

                _this2.isLoading = false;
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error("Hata :" + _context.t0.message);
                _this2.isLoading = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    },
    getShiftSetting: function getShiftSetting() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.isLoading = true;
                _context2.next = 4;
                return _this3.$axios.get("WebshiftSettings").then(function (response) {
                  _this3.webshiftSettings = response.data;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this3.isLoading = false;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0);
                _this3.isLoading = false;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.authControl == 1) {
                  alertify.warning(_this4.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.getShiftSetting();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  }
});

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingCompanies: false,
      searchText: "",
      searchText2: "",
      user: {
        id: null,
        name: "",
        title: "",
        mail: "",
        authId: null,
        currentCompanyId: null,
        password: "",
        password2: "",
        photo: null,
        monitorGroupId: null,
        authCompanies: [],
        visitorCardGroup: "",
        phoneNumber: "",
        isSmsSend: false,
        isActive: true
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isNewUser: true,
      isNewRealTimeMonitor: true,
      selectedRealTimeMonitorId: null,
      selectedRealTimeMonitorDevices: [],
      selectedRealTimeMonitorName: "",
      isCheckDeps: false,
      users: [],
      companies: [],
      departments: [],
      sortableDepTrees: [],
      userAuhtGroups: [],
      monitorGroups: [],
      readers: [],
      visitorGroups: [],
      foodGroups: [],
      accessGroups: [],
      extrafields: [],
      states: [],
      status: [],
      titles: [],
      workGroups: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      activeReports: [],
      isCheckDep: false,
      isCheckReports: false,
      reports: [
      //max index:35, max id:36
      {
        id: 32,
        name: this.$ml.get("reports.reports.SaleReport"),
        endPoint: "SaleReport",
        isActive: false,
        index: 31,
        module: this.$store.getters.getModules.retailSale
      }, {
        id: 33,
        name: this.$ml.get("reports.reports.DetailedVisitorReport"),
        endPoint: "VisitorDetailedReport",
        isActive: false,
        index: 30,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 34,
        name: this.$ml.get("reports.reports.DepartmentBasedVisitorReport"),
        endPoint: "DepartmentBasedVisitorReport",
        isActive: false,
        index: 33,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 31,
        name: this.$ml.get("reports.reports.EntryExitSnapshotReport"),
        endPoint: "EntryExitSnapshotReport",
        isActive: false,
        index: 32,
        module: true
      }, {
        id: 1,
        name: this.$ml.get("reports.reports.LaterComersReport"),
        endPoint: "LaterComersReport",
        isActive: false,
        index: 2,
        module: true
      }, {
        id: 2,
        name: this.$ml.get("reports.reports.DetailedInOutReport"),
        endPoint: "DetailedInOutReport",
        isActive: false,
        index: 8,
        module: true
      }, {
        id: 3,
        name: this.$ml.get("reports.reports.FoodReport"),
        endPoint: "FoodReport",
        isActive: false,
        index: 22,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 4,
        name: this.$ml.get("reports.reports.FoodDebtReport"),
        endPoint: "FoodDebtReport",
        isActive: false,
        index: 23,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 5,
        name: this.$ml.get("reports.reports.EmployeesReport"),
        endPoint: "EmployeesReport",
        isActive: false,
        index: 0,
        module: true
      }, {
        id: 6,
        name: this.$ml.get("reports.reports.InsidesReport"),
        endPoint: "InsidesReport",
        isActive: false,
        index: 4,
        module: true
      }, {
        id: 7,
        name: this.$ml.get("reports.reports.OutsidesReport"),
        endPoint: "OutsidesReport",
        isActive: false,
        index: 5,
        module: true
      }, {
        id: 8,
        name: this.$ml.get("reports.reports.VisitorsReport"),
        endPoint: "VisitorsReport",
        isActive: false,
        index: 20,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 9,
        name: this.$ml.get("reports.reports.InsideVisitorsReport"),
        endPoint: "InsideVisitorsReport",
        isActive: false,
        index: 21,
        module: this.$store.getters.getModules.visitor
      }, {
        id: 10,
        name: this.$ml.get("reports.reports.TimeBasedWorkReport"),
        endPoint: "TimeBasedWorkReport",
        isActive: false,
        index: 10,
        module: true
      }, {
        id: 11,
        name: this.$ml.get("reports.reports.FirstInLastOutReport"),
        endPoint: "FirstInLastOutReport",
        isActive: false,
        index: 9,
        module: true
      }, {
        id: 12,
        name: this.$ml.get("reports.reports.AllowenceReport"),
        endPoint: "AllowenceReport",
        isActive: false,
        index: 3,
        module: true
      }, {
        id: 13,
        name: this.$ml.get("reports.reports.WorkSummaryReport"),
        endPoint: "WorkSummaryReport",
        isActive: false,
        index: 11,
        module: true
      }, {
        id: 14,
        name: this.$ml.get("reports.reports.CompanyEmployeesStatusReport"),
        endPoint: "CompanyEmployeesStatusReport",
        isActive: false,
        index: 12,
        module: true
      }, {
        id: 15,
        name: this.$ml.get("reports.reports.CustomCompanyEmployeesStatusReport"),
        endPoint: "CustomCompanyEmployeesStatusReport",
        isActive: false,
        index: 13,
        module: true
      }, {
        id: 16,
        name: this.$ml.get("reports.reports.PayrollReport"),
        endPoint: "PayrollReport",
        isActive: false,
        index: 14,
        module: true
      }, {
        id: 17,
        name: this.$ml.get("reports.reports.DetailedPayrollReport"),
        endPoint: "DetailedPayrollReport",
        isActive: false,
        index: 15,
        module: true
      }, {
        id: 29,
        name: this.$ml.get("reports.reports.WeeklyPayrollReport"),
        endPoint: "WeeklyPayrollReport",
        isActive: false,
        index: 15,
        module: true
      }, {
        id: 26,
        name: this.$ml.get("reports.reports.TemplatePayrollReport"),
        endPoint: "TemplatePayrollReport",
        isActive: false,
        index: 16,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 27,
        name: this.$ml.get("reports.reports.TemplateMonthlyPayrollReport"),
        endPoint: "TemplateMonthlyPayrollReport",
        isActive: false,
        index: 17,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 28,
        name: this.$ml.get("reports.reports.SalaryReport"),
        endPoint: "SalaryReport",
        isActive: false,
        index: 18,
        module: this.$store.getters.getModules.payroll
      }, {
        id: 30,
        name: this.$ml.get("reports.reports.DepartmentSummaryReport"),
        endPoint: "DepartmentSummaryReport",
        isActive: false,
        index: 19,
        module: true
      }, {
        id: 18,
        name: this.$ml.get("reports.reports.FoodCreditReport"),
        endPoint: "FoodCreditReport",
        isActive: false,
        index: 24,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 19,
        name: this.$ml.get("reports.reports.InOutReport"),
        endPoint: "InOutReport",
        isActive: false,
        index: 7,
        module: true
      }, {
        id: 20,
        name: this.$ml.get("reports.reports.DoorBasedLastMovementReport"),
        endPoint: "DoorBasedLastMovementReport",
        isActive: false,
        index: 6,
        module: true
      }, {
        id: 21,
        name: this.$ml.get("reports.reports.DoorsAuthorizationReport"),
        endPoint: "DoorsAuthorizationReport",
        isActive: false,
        index: 1,
        module: true
      }, {
        id: 22,
        name: this.$ml.get("reports.reports.DormitoryInformationReport"),
        endPoint: "DormitoryInformationReport",
        isActive: false,
        index: 26,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 23,
        name: this.$ml.get("reports.reports.DormitoryInsidesReport"),
        endPoint: "DormitoryInsidesReport",
        isActive: false,
        index: 27,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 24,
        name: this.$ml.get("reports.reports.DormitoryOutsidesReport"),
        endPoint: "DormitoryOutsidesReport",
        isActive: false,
        index: 28,
        module: this.$store.getters.getModules.dormitory
      }, {
        id: 25,
        name: this.$ml.get("reports.reports.FoodSummaryReport"),
        endPoint: "FoodSummaryReport",
        isActive: false,
        index: 29,
        module: this.$store.getters.getModules.diningHall
      }, {
        id: 35,
        name: this.$ml.get("reports.reports.ShiftReport"),
        endPoint: "ShiftReport",
        isActive: false,
        index: 34,
        module: true
      }, {
        id: 36,
        name: this.$ml.get("reports.reports.VerticalFirstInLastOutReport"),
        endPoint: "VerticalFirstInLastOutReport",
        isActive: false,
        index: 35,
        module: true
      }]
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    myUser: function myUser() {
      return this.$store.getters.getUser;
    },
    userList: function userList() {
      var _this = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.users.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.users;
      }
    },
    companyList: function companyList() {
      return this.companies;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.sortableDepTrees.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.sortableDepTrees;
      }
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    userAuhtGroupList: function userAuhtGroupList() {
      return this.userAuhtGroups.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    titleList: function titleList() {
      return this.titles;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    monitorGroupList: function monitorGroupList() {
      return this.monitorGroups;
    },
    visitorGroupList: function visitorGroupList() {
      return this.visitorGroups;
    },
    reportList: function reportList() {
      var list = this.reports.filter(function (item) {
        return item.module == true;
      });
      return list.sort(function (a, b) {
        if (a.index < b.index) return -1;
        if (a.index > b.index) return 0;
      });
    },
    readerList: function readerList() {
      return this.readers;
    },
    activeReaderList: function activeReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    },
    windowDepHeightSize: function windowDepHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 560;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReportHeightSize: function windowReportHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 130;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.filters.departments = [];
                _context.next = 3;
                return _this4.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.filters.accessGroup = [];
                _context2.next = 3;
                return _this5.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.filters.stateId = [];
                _context3.next = 3;
                return _this6.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.filters.statuId = [];
                _context4.next = 3;
                return _this7.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.filters.workGroupId = [];
                _context5.next = 3;
                return _this8.periodWorkGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.filters.foodGroup = [];
                _context6.next = 3;
                return _this9.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                aList = _this10.sortableDepartmentList;

                _this10.filters.departments = [];
                _context7.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this10.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this10.accessGroupList;

                _this10.filters.accessGroup = [];
                _context7.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this10.periodWorkGroupList;

                _this10.filters.workGroupId = [];
                _context7.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this10.foodGroupList;

                _this10.filters.foodGroup = [];
                _context7.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this10.statuList;

                _this10.filters.statuId = [];
                _context7.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this10.stateList;

                _this10.filters.stateId = [];
                _context7.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setFilter: function setFilter() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this11.getCheckDepartmentList();

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeUserAuthGroup: function changeUserAuthGroup(event) {
      this.user.authId = event.target.value;
    },
    changeMonitorGroup: function changeMonitorGroup(event) {
      this.user.monitorGroupId = event.target.value;
    },
    changeVisitorGroup: function changeVisitorGroup(event) {
      this.user.visitorCardGroup = event.target.value;
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.user.photo = null;
    },
    getCheckReports: function getCheckReports() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this12.activeReports = [];
                _context9.next = 3;
                return _this12.reports.forEach(function (doc) {
                  if (doc.isActive == true) {
                    _this12.activeReports.push(doc.id);
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getCheckReportAll: function getCheckReportAll(value) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.reports.forEach(function (dep) {
                  dep.isActive = value;
                });
                _this13.isCheckReports = !_this13.isCheckReports;

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    getCheckDepAll: function getCheckDepAll(value) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this14.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this14.isCheckDep = !_this14.isCheckDep;

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this15.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this15.isCheckDeps = !_this15.isCheckDeps;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                dep.check = checkValue;
                _this16.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this16.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this16);
      }))();
    },
    getCheckReaders: function getCheckReaders() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _this17.selectedRealTimeMonitorDevices = [];
                _context14.next = 3;
                return _this17.readers.forEach(function (doc) {
                  if (doc.check == true) {
                    _this17.selectedRealTimeMonitorDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    selectRealTimeMonitor: function selectRealTimeMonitor(id, name, devices) {
      var _this18 = this;

      this.isNewRealTimeMonitor = false;
      this.selectedRealTimeMonitorId = id;
      this.selectedRealTimeMonitorDevices = devices;
      this.selectedRealTimeMonitorName = name;
      this.readers.forEach(function (device) {
        device.check = false;
      });
      if (devices) {
        devices.forEach(function (item) {
          _this18.readers.forEach(function (device) {
            if (item == device.readerId) {
              device.check = true;
            }
          });
        });
      }
    },
    newRealTimeMonitor: function newRealTimeMonitor() {
      this.isNewRealTimeMonitor = true;
      this.readers.forEach(function (device) {
        device.check = false;
      });
      this.selectedRealTimeMonitorId = null;
      this.selectedRealTimeMonitorDevices = [];
      this.selectedRealTimeMonitorName = "";
    },
    saveRealTimeMonitor: function saveRealTimeMonitor() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var id, name, devices, response, _response;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (!(_this19.selectedRealTimeMonitorName == "")) {
                  _context15.next = 3;
                  break;
                }

                alertify.warning(_this19.$ml.get("alerts.pleaseEnterAName"));
                return _context15.abrupt("return");

              case 3:
                _context15.prev = 3;
                id = _this19.selectedRealTimeMonitorId;
                _context15.next = 7;
                return _this19.getCheckReaders();

              case 7:
                name = _this19.selectedRealTimeMonitorName;
                devices = _this19.selectedRealTimeMonitorDevices;

                if (!(_this19.isNewRealTimeMonitor == true)) {
                  _context15.next = 17;
                  break;
                }

                _context15.next = 12;
                return _this19.$axios.post("/RealTimeMonitor", {
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this19.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this19.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 12:
                response = _context15.sent;

                _this19.newRealTimeMonitor();
                _this19.getMonitorGroups();
                _context15.next = 22;
                break;

              case 17:
                _context15.next = 19;
                return _this19.$axios.post("/RealTimeMonitor/" + id, {
                  id: id,
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this19.$ml.get("alerts.updatedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this19.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 19:
                _response = _context15.sent;

                _this19.newRealTimeMonitor();
                _this19.getMonitorGroups();

              case 22:
                _context15.next = 28;
                break;

              case 24:
                _context15.prev = 24;
                _context15.t0 = _context15["catch"](3);

                console.error(_context15.t0);
                alertify.error(_context15.t0.message);

              case 28:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this19, [[3, 24]]);
      }))();
    },
    deleteRealTimeMonitor: function deleteRealTimeMonitor() {
      var _this20 = this;

      try {
        var id = this.selectedRealTimeMonitorId;
        if (id != null) {
          var response = this.$axios.delete("/RealTimeMonitor/" + id).then(function (response) {
            _this20.getMonitorGroups();
            _this20.newRealTimeMonitor();
            alertify.success(_this20.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this20.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this20.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    newUser: function newUser() {
      this.isLoadingDetail = true;
      this.isNewUser = true;
      this.user.id = null;
      this.user.name = "";
      this.user.title = "";
      this.user.mail = "";
      this.user.authId = null;
      this.user.currentCompanyId = 0;
      this.user.password = "";
      this.user.password2 = "";
      this.user.photo = null;
      this.user.monitorGroupId = 0;
      this.user.authCompanies = [];
      this.user.visitorCardGroup = "";
      this.user.phoneNumber = "";
      this.user.isSmsSend = false;
      this.user.isActive = true;
      this.imageData = null;
      this.tempUrl = null;
      this.companies.forEach(function (doc) {
        doc.check = true;
      });
      this.activeReports = [];
      this.reports.forEach(function (doc) {
        doc.isActive = false;
      });
      this.filtersClear();
      this.isLoadingDetail = false;
    },
    deleteUser: function deleteUser() {
      var _this21 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this21.isLoadingDetail = true;
                id = _this21.user.id;
                _context16.next = 5;
                return _this21.$axios.delete("/User/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this21.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this21.$ml.get("errors.connectionError"));
                      _this21.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this21.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context16.sent;

                _this21.getUsers();
                _this21.newUser();
                alertify.success(_this21.$ml.get("alerts.deletedSuccessfully"));
                _this21.isLoadingDetail = false;
                _context16.next = 17;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error(_context16.t0.message);
                _this21.isLoadingDetail = false;

              case 17:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this21, [[0, 12]]);
      }))();
    },
    getCheckAuthCompanyList: function getCheckAuthCompanyList() {
      var _this22 = this;

      var aList = this.companies;
      this.user.authCompanies = [];
      aList.forEach(function (doc) {
        if (doc.check == true) {
          _this22.user.authCompanies.push(doc.id);
        }
      });
    },
    saveUser: function saveUser() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var user2, image, response, id, formData, responseImage, _user, _image, _response2, _id, _formData, _responseImage, _responseImage2;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (_this23.user.name == "") {
                  alertify.warning(_this23.$ml.get("alerts.pleaseEnterAUserName"));
                }
                if (_this23.user.mail == "") {
                  alertify.warning(_this23.$ml.get("alerts.pleaseEnterAEmail"));
                }

                if (!(_this23.user.password == "" || _this23.user.password == " " || _this23.user.password == null)) {
                  _context17.next = 5;
                  break;
                }

                alertify.warning(_this23.$ml.get("alerts.pleaseEnterAPassword"));
                return _context17.abrupt("return");

              case 5:
                if (!(_this23.user.password != _this23.user.password2)) {
                  _context17.next = 8;
                  break;
                }

                alertify.warning(_this23.$ml.get("alerts.passwordsDoNotMatch"));
                return _context17.abrupt("return");

              case 8:
                if (_this23.user.authId) {
                  _context17.next = 11;
                  break;
                }

                alertify.warning(_this23.$ml.get("alerts.pleaseSelectAuthorityGroup"));
                return _context17.abrupt("return");

              case 11:
                _this23.isLoadingDetail = true;
                _context17.next = 14;
                return _this23.getCheckAuthCompanyList();

              case 14:
                _context17.next = 16;
                return _this23.getCheckReports();

              case 16:
                if (!_this23.isNewUser) {
                  _context17.next = 45;
                  break;
                }

                _context17.prev = 17;
                user2 = _this23.user;
                image = _this23.imageData;
                _context17.next = 22;
                return _this23.$axios.post("/User", {
                  name: user2.name,
                  title: user2.title,
                  mail: user2.mail,
                  authId: parseInt(user2.authId),
                  currentCompanyId: parseInt(user2.currentCompanyId),
                  password: user2.password,
                  monitorGroupId: parseInt(user2.monitorGroupId),
                  authCompanies: user2.authCompanies,
                  visitorCardGroup: user2.visitorCardGroup,
                  reports: _this23.activeReports,
                  phoneNumber: user2.phoneNumber,
                  isSmsSend: user2.isSmsSend,
                  isActive: user2.isActive,
                  filter: _this23.filters
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    } else if (error.response.status == 400) {
                      alertify.warning(error.response.data.message);
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 22:
                response = _context17.sent;
                id = response.data.kullaniciId;

                if (!_this23.imageData) {
                  _context17.next = 31;
                  break;
                }

                formData = new FormData();

                formData.append("file", image);

                if (!(_this23.imageData != null)) {
                  _context17.next = 31;
                  break;
                }

                _context17.next = 30;
                return _this23.$axios.post("/User/AddUserPhoto/" + id, formData);

              case 30:
                responseImage = _context17.sent;

              case 31:
                try {
                  if (response.status == 200) {
                    alertify.success(_this23.$ml.get("alerts.savedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                } catch (error) {}
                _this23.getUsers();
                _this23.getUser(id);
                _this23.isNewUser = false;
                _this23.isLoadingDetail = false;
                _context17.next = 43;
                break;

              case 38:
                _context17.prev = 38;
                _context17.t0 = _context17["catch"](17);

                console.error(_context17.t0);
                alertify.error(_context17.t0);
                _this23.isLoadingDetail = false;

              case 43:
                _context17.next = 75;
                break;

              case 45:
                _context17.prev = 45;
                _user = _this23.user;
                _image = _this23.imageData;
                _context17.next = 50;
                return _this23.$axios.post("/User/" + _user.id, {
                  name: _user.name,
                  title: _user.title,
                  mail: _user.mail,
                  authId: parseInt(_user.authId),
                  currentCompanyId: parseInt(_user.currentCompanyId),
                  password: _user.password,
                  monitorGroupId: parseInt(_user.monitorGroupId),
                  authCompanies: _user.authCompanies,
                  visitorCardGroup: _user.visitorCardGroup,
                  reports: _this23.activeReports,
                  phoneNumber: _user.phoneNumber,
                  isSmsSend: _user.isSmsSend,
                  isActive: _user.isActive,
                  filter: _this23.filters
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    } else if (error.response.status == 400) {
                      alertify.warning(error.response.data.message);
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 50:
                _response2 = _context17.sent;
                _id = _user.id;

                if (_this23.myUser.id == _id) {
                  localStorage.setItem("defaultFilters", JSON.stringify(_this23.filters));
                  _this23.$store.commit("setDefaultFilters", _this23.filters);
                }

                if (!_this23.imageData) {
                  _context17.next = 61;
                  break;
                }

                _formData = new FormData();

                _formData.append("file", _image);
                _context17.next = 58;
                return _this23.$axios.post("/User/AddUserPhoto/" + _id, _formData);

              case 58:
                _responseImage = _context17.sent;
                _context17.next = 65;
                break;

              case 61:
                if (!(_this23.user.photo == null)) {
                  _context17.next = 65;
                  break;
                }

                _context17.next = 64;
                return _this23.$axios.patch("/User/RemovePhoto/" + _id);

              case 64:
                _responseImage2 = _context17.sent;

              case 65:
                try {
                  if (_response2.status == 200) {
                    alertify.success(_this23.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(_response2.message);
                  }
                } catch (error) {}
                _this23.getUsers();
                _this23.isLoadingDetail = false;
                _context17.next = 75;
                break;

              case 70:
                _context17.prev = 70;
                _context17.t1 = _context17["catch"](45);

                console.error(_context17.t1);
                alertify.error(_context17.t1);
                _this23.isLoadingDetail = false;

              case 75:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this23, [[17, 38], [45, 70]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this24 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this24.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this24.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this24.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this24.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this24.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this24.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getUser: function getUser(id) {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this25.isLoadingDetail = true;
                _this25.newUser();
                _context18.next = 5;
                return _this25.$axios.get("/User/" + id).then(function (response) {
                  _this25.isNewUser = false;
                  _this25.user.id = id;
                  _this25.user.name = response.data.name;
                  _this25.user.title = response.data.title;
                  _this25.user.mail = response.data.mail;
                  _this25.user.authId = response.data.authId;
                  _this25.user.currentCompanyId = response.data.currentCompanyId;
                  _this25.user.password = response.data.password;
                  _this25.user.password2 = response.data.password;
                  _this25.user.monitorGroupId = response.data.monitorGroupId;
                  _this25.user.authCompanies = response.data.authCompanies;
                  _this25.user.visitorCardGroup = response.data.visitorCardGroup;
                  _this25.user.phoneNumber = response.data.phoneNumber;
                  _this25.user.isSmsSend = response.data.isSmsSend;
                  _this25.user.isActive = response.data.isActive;
                  _this25.activeReports = response.data.reports;
                  _this25.user.photo = response.data.photo;
                  _this25.companies.forEach(function (doc) {
                    _this25.user.authCompanies.forEach(function (doc2) {
                      if (doc.id == doc2) {
                        doc.check = true;
                      }
                    });
                  });
                  _this25.reports.forEach(function (doc) {
                    _this25.activeReports.forEach(function (rep) {
                      if (doc.id == rep) {
                        doc.isActive = true;
                      }
                    });
                  });
                  if (response.data.filter) {
                    _this25.setUserAuthorityFilter(response.data.filter);
                  } else {
                    _this25.filtersClear();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context18.sent;

                _this25.isLoadingDetail = false;
                _context18.next = 14;
                break;

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error(_context18.t0.message);
                _this25.isLoadingDetail = false;

              case 14:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this25, [[0, 9]]);
      }))();
    },
    getUsers: function getUsers() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var users, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this26.isLoading = true;
                users = [];
                _context19.next = 5;
                return _this26.$axios.get("/User").then(function (response) {
                  response.data.forEach(function (doc) {
                    users.push({
                      id: doc.id,
                      name: doc.name,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context19.sent;

                _this26.users = users;
                _this26.isLoading = false;
                _context19.next = 15;
                break;

              case 10:
                _context19.prev = 10;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error(_context19.t0.message);
                _this26.isLoading = false;

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this26, [[0, 10]]);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var companies, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;

                _this27.isLoadingCompanies = true;
                companies = [];
                _context20.next = 5;
                return _this27.$axios.get("/CompanySettings").then(function (response) {
                  response.data.forEach(function (doc) {
                    companies.push({
                      id: doc.id,
                      name: doc.name,
                      check: true,
                      logo: doc.logo,
                      website: doc.website,
                      phoneNumber: doc.phoneNumber,
                      address: doc.address,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context20.sent;

                _this27.companies = companies;
                _this27.isLoadingCompanies = false;
                _context20.next = 15;
                break;

              case 10:
                _context20.prev = 10;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error(_context20.t0.message);
                _this27.isLoadingCompanies = false;

              case 15:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this27, [[0, 10]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;

                _this28.isLoadingDetail = true;
                departments = [];
                _context21.next = 5;
                return _this28.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                    departments.sort(function (a, b) {
                      if (a.locationTree < b.locationTree) return -1;
                      if (a.locationTree > b.locationTree) return 0;
                    });
                  });
                  _this28.departments = departments;
                  _this28.sortableTrees();
                  _this28.isLoadingDetail = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context21.sent;
                _context21.next = 13;
                break;

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error(_context21.t0.message);
                _this28.isLoadingDetail = false;

              case 13:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this28, [[0, 8]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this29 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this29.sortableDepTrees.push(dep);
          _this29.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this30 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this30.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this30.subDepImport(doc2);
        });
      }
    },
    getUserAuthGroups: function getUserAuthGroups() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var userAuhtGroups, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this31.isLoadingDetail = true;
                userAuhtGroups = [];
                _context22.next = 5;
                return _this31.$axios.get("/User/UserAuthGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    userAuhtGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context22.sent;

                _this31.userAuhtGroups = userAuhtGroups;
                _this31.isLoadingDetail = false;
                _context22.next = 15;
                break;

              case 10:
                _context22.prev = 10;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error(_context22.t0.message);
                _this31.isLoadingDetail = false;

              case 15:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this31, [[0, 10]]);
      }))();
    },
    getMonitorGroups: function getMonitorGroups() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var monitorGroups, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;

                _this32.isLoadingDetail = true;
                monitorGroups = [];
                _context23.next = 5;
                return _this32.$axios.get("/RealTimeMonitor").then(function (response) {
                  response.data.forEach(function (doc) {
                    monitorGroups.push({
                      id: doc.id,
                      name: doc.name,
                      devices: doc.readers
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context23.sent;

                _this32.monitorGroups = monitorGroups;
                _this32.isLoadingDetail = false;
                _context23.next = 15;
                break;

              case 10:
                _context23.prev = 10;
                _context23.t0 = _context23["catch"](0);

                console.error(_context23.t0);
                alertify.error(_context23.t0.message);
                _this32.isLoadingDetail = false;

              case 15:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this32, [[0, 10]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                readers = [];
                _context24.next = 4;
                return _this33.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context24.sent;

                _this33.readers = readers;
                _context24.next = 12;
                break;

              case 8:
                _context24.prev = 8;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error("Servis Hatası : " + _context24.t0.message);

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this33, [[0, 8]]);
      }))();
    },
    getVisitorGroups: function getVisitorGroups() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var visitorGroups, response;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;

                _this34.isLoadingDetail = true;
                visitorGroups = [];
                _context25.next = 5;
                return _this34.$axios.get("/Visitors/GetVisitorsCardGroup?companyId=0").then(function (response) {
                  response.data.forEach(function (doc) {
                    visitorGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this34.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoadingDetail = false;
                      return;
                    } else {
                      r;
                      console.error(error);
                      alertify.error(error.message);
                      _this34.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context25.sent;

                _this34.visitorGroups = visitorGroups;
                _this34.isLoadingDetail = false;
                _context25.next = 15;
                break;

              case 10:
                _context25.prev = 10;
                _context25.t0 = _context25["catch"](0);

                console.error(_context25.t0);
                alertify.error(_context25.t0.message);
                _this34.isLoadingDetail = false;

              case 15:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this34, [[0, 10]]);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                foodGroups = [];
                _context26.next = 4;
                return _this35.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this35.foodGroups = foodGroups;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Servis Hatası :" + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this35, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;
                extrafields = [];
                _context27.next = 4;
                return _this36.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context27.sent;

                _this36.extrafields = extrafields;
                _context27.next = 12;
                break;

              case 8:
                _context27.prev = 8;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error("Servis Hatası :" + _context27.t0.message);

              case 12:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this36, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;
                status = [];
                _context28.next = 4;
                return _this37.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this37.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this37.$ml.get("errors.connectionError"));
                      _this37.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this37.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context28.sent;

                _this37.status = status;
                _context28.next = 12;
                break;

              case 8:
                _context28.prev = 8;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);

              case 12:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this37, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this38 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.prev = 0;
                states = [];
                _context29.next = 4;
                return _this38.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this38.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this38.$ml.get("errors.connectionError"));
                      _this38.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this38.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context29.sent;

                _this38.states = states;
                _context29.next = 12;
                break;

              case 8:
                _context29.prev = 8;
                _context29.t0 = _context29["catch"](0);

                console.error(_context29.t0);
                alertify.error("Servis Hatası :" + _context29.t0.message);

              case 12:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29, _this38, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this39 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.prev = 0;
                accessGroups = [];
                _context30.next = 4;
                return _this39.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this39.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this39.$ml.get("errors.connectionError"));
                      _this39.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this39.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context30.sent;

                _this39.accessGroups = accessGroups;
                _context30.next = 12;
                break;

              case 8:
                _context30.prev = 8;
                _context30.t0 = _context30["catch"](0);

                console.error(_context30.t0);
                alertify.error("Servis Hatası :" + _context30.t0.message);

              case 12:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, _this39, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this40 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee31() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.prev = 0;
                workGroups = [];
                _context31.next = 4;
                return _this40.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this40.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this40.$ml.get("errors.connectionError"));
                      _this40.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this40.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context31.sent;

                _this40.workGroups = workGroups;
                _context31.next = 12;
                break;

              case 8:
                _context31.prev = 8;
                _context31.t0 = _context31["catch"](0);

                console.error(_context31.t0);
                alertify.error("Servis Hatası :" + _context31.t0.message);

              case 12:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, _this40, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this41 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee32() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                titles = [];
                _context32.next = 4;
                return _this41.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this41.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this41.$ml.get("errors.connectionError"));
                      _this41.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this41.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context32.sent;

                _this41.titles = titles;
                _context32.next = 12;
                break;

              case 8:
                _context32.prev = 8;
                _context32.t0 = _context32["catch"](0);

                console.error(_context32.t0);
                alertify.error("Servis Hatası :" + _context32.t0.message);

              case 12:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, _this41, [[0, 8]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this42 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee33() {
        return regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                if (_this42.authControl == 1) {
                  alertify.warning(_this42.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, _this42);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this43 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee34() {
      return regeneratorRuntime.wrap(function _callee34$(_context34) {
        while (1) {
          switch (_context34.prev = _context34.next) {
            case 0:
              _context34.next = 2;
              return _this43.getAuthControl();

            case 2:
              _context34.next = 4;
              return _this43.getUsers();

            case 4:
              _context34.next = 6;
              return _this43.getCompanies();

            case 6:
              _context34.next = 8;
              return _this43.getDepartments();

            case 8:
              _context34.next = 10;
              return _this43.getUserAuthGroups();

            case 10:
              _context34.next = 12;
              return _this43.getMonitorGroups();

            case 12:
              _context34.next = 14;
              return _this43.getReaders();

            case 14:
              _context34.next = 16;
              return _this43.getVisitorGroups();

            case 16:
              _context34.next = 18;
              return _this43.getFoodGroups();

            case 18:
              _context34.next = 20;
              return _this43.getExtraFields();

            case 20:
              _context34.next = 22;
              return _this43.getAccessGroups();

            case 22:
              _context34.next = 24;
              return _this43.getStatus();

            case 24:
              _context34.next = 26;
              return _this43.getStates();

            case 26:
              _context34.next = 28;
              return _this43.getWorkGroups();

            case 28:
              _context34.next = 30;
              return _this43.getTitles();

            case 30:
            case "end":
              return _context34.stop();
          }
        }
      }, _callee34, _this43);
    }))();
  }
});

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__ = __webpack_require__(36);
var _data$components$comp;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = (_data$components$comp = {
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      isLoadingCompanies: false,
      searchText: "",
      searchText2: "",
      user: {
        id: null,
        name: "",
        title: "",
        mail: "",
        authId: null,
        currentCompanyId: null,
        password: "",
        password2: "",
        photo: null,
        monitorGroupId: null,
        authCompanies: [],
        visitorCardGroup: "",
        phoneNumber: "",
        isSmsSend: false,
        isActive: true
      },
      filters: {
        nameOrCardNumber: "",
        sicilOrTerminalNo: null,
        departments: [],
        accessGroup: [],
        identityNo: "",
        documentNoOrMail: "",
        foodGroup: [],
        workGroupId: [],
        title: "",
        stateId: [],
        statuId: [],
        plateNo: "",
        extraField1key: 0,
        extraField1value: "",
        extraField2key: 0,
        extraField2value: "",
        extraField3key: 0,
        extraField3value: "",
        extraField4key: 0,
        extraField4value: "",
        isVisitor: false,
        isActive: true
      },
      isNewUser: false,
      isNewRealTimeMonitor: true,
      selectedRealTimeMonitorId: null,
      selectedRealTimeMonitorDevices: [],
      selectedRealTimeMonitorName: "",
      isCheckDeps: false,
      users: [],
      companies: [],
      departments: [],
      sortableDepTrees: [],
      userAuhtGroups: [],
      monitorGroups: [],
      readers: [],
      visitorGroups: [],
      foodGroups: [],
      accessGroups: [],
      extrafields: [],
      states: [],
      status: [],
      titles: [],
      workGroups: [],
      uploadValue: 0,
      imageData: null,
      tempUrl: null,
      showImageDialog: false,
      params: {},
      headers: {},
      activeReports: [],
      isCheckDep: false,
      isCheckReports: false
    };
  },

  components: {
    "my-upload": __WEBPACK_IMPORTED_MODULE_0_vue_image_crop_upload__["a" /* default */]
  },
  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    myUser: function myUser() {
      return this.$store.getters.getUser;
    },
    userList: function userList() {
      var _this = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.users.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.users;
      }
    },
    companyList: function companyList() {
      return this.companies;
    },
    departmentList: function departmentList() {
      return this.departments;
    },
    sortableDepartmentList: function sortableDepartmentList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.sortableDepTrees.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.sortableDepTrees;
      }
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    userAuhtGroupList: function userAuhtGroupList() {
      return this.userAuhtGroups;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    titleList: function titleList() {
      return this.titles;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    monitorGroupList: function monitorGroupList() {
      return this.monitorGroups;
    },
    visitorGroupList: function visitorGroupList() {
      return this.visitorGroups;
    },
    readerList: function readerList() {
      return this.readers;
    },
    activeReaderList: function activeReaderList() {
      return this.readerList.filter(function (item) {
        return item.isActive == true;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowHeightTableSize: function windowHeightTableSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 420;
        return "max-height:" + height + "px;overflow:auto;color:black;";
      } else {
        return "max-height:370px;overflow:auto;color:black;";
      }
    },
    windowDepHeightSize: function windowDepHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 560;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReportHeightSize: function windowReportHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 270;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeFilterTitles: function changeFilterTitles(event) {
      this.filters.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.filters.extraField1key = event.target.value;
      if (!this.filters.extraField1key) {
        this.filters.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.filters.extraField2key = event.target.value;
      if (!this.filters.extraField2key) {
        this.filters.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.filters.extraField3key = event.target.value;
      if (!this.filters.extraField3key) {
        this.filters.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.filters.extraField4key = event.target.value;
      if (!this.filters.extraField4key) {
        this.filters.extraField4key = 0;
      }
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.filters.departments = [];
                _context.next = 3;
                return _this4.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.filters.accessGroup = [];
                _context2.next = 3;
                return _this5.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.filters.stateId = [];
                _context3.next = 3;
                return _this6.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.filters.statuId = [];
                _context4.next = 3;
                return _this7.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.filters.workGroupId = [];
                _context5.next = 3;
                return _this8.periodWorkGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.filters.foodGroup = [];
                _context6.next = 3;
                return _this9.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                aList = _this10.sortableDepartmentList;

                _this10.filters.departments = [];
                _context7.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this10.filters.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this10.accessGroupList;

                _this10.filters.accessGroup = [];
                _context7.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this10.periodWorkGroupList;

                _this10.filters.workGroupId = [];
                _context7.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this10.foodGroupList;

                _this10.filters.foodGroup = [];
                _context7.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this10.statuList;

                _this10.filters.statuId = [];
                _context7.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this10.stateList;

                _this10.filters.stateId = [];
                _context7.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.filters.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setFilter: function setFilter() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this11.getCheckDepartmentList();

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    filtersClear: function filtersClear() {
      this.filters.nameOrCardNumber = "";
      this.filters.sicilOrTerminalNo = null;
      this.filters.departments = [];
      this.filters.accessGroup = [];
      this.filters.identityNo = "";
      this.filters.documentNoOrMail = "";
      this.filters.foodGroup = [];
      this.filters.workGroupId = [];
      this.filters.title = "";
      this.filters.stateId = [];
      this.filters.statuId = [];
      this.filters.plateNo = "";
      this.filters.extraField1key = 0;
      this.filters.extraField1value = "";
      this.filters.extraField2key = 0;
      this.filters.extraField2value = "";
      this.filters.extraField3key = 0;
      this.filters.extraField3value = "";
      this.filters.extraField4key = 0;
      this.filters.extraField4value = "";
      this.filters.isVisitor = false;
      this.filters.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    changeUserAuthGroup: function changeUserAuthGroup(event) {
      this.user.authId = event.target.value;
    },
    changeMonitorGroup: function changeMonitorGroup(event) {
      this.user.monitorGroupId = event.target.value;
    },
    changeVisitorGroup: function changeVisitorGroup(event) {
      this.user.visitorCardGroup = event.target.value;
    },
    toggleShow: function toggleShow() {
      this.showImageDialog = !this.showImageDialog;
    },
    cropSuccess: function cropSuccess(imgDataUrl, imgData, mime, field) {
      this.imageData = imgData;
      this.tempUrl = imgDataUrl;
      this.showImageDialog = false;
    },
    removeImage: function removeImage() {
      this.imageData = null;
      this.tempUrl = null;
      this.user.photo = null;
    },
    getCheckDepAll: function getCheckDepAll(value) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this12.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this12.isCheckDep = !_this12.isCheckDep;

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this13.isCheckDeps = !_this13.isCheckDeps;

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                dep.check = checkValue;
                _this14.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this14.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    getCheckReaders: function getCheckReaders() {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this15.selectedRealTimeMonitorDevices = [];
                _context12.next = 3;
                return _this15.readers.forEach(function (doc) {
                  if (doc.check == true) {
                    _this15.selectedRealTimeMonitorDevices.push(doc.readerId);
                  }
                });

              case 3:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    selectRealTimeMonitor: function selectRealTimeMonitor(id, name, devices) {
      var _this16 = this;

      this.isNewRealTimeMonitor = false;
      this.selectedRealTimeMonitorId = id;
      this.selectedRealTimeMonitorDevices = devices;
      this.selectedRealTimeMonitorName = name;
      this.readers.forEach(function (device) {
        device.check = false;
      });
      if (devices) {
        devices.forEach(function (item) {
          _this16.readers.forEach(function (device) {
            if (item == device.readerId) {
              device.check = true;
            }
          });
        });
      }
    },
    newRealTimeMonitor: function newRealTimeMonitor() {
      this.isNewRealTimeMonitor = true;
      this.readers.forEach(function (device) {
        device.check = false;
      });
      this.selectedRealTimeMonitorId = null;
      this.selectedRealTimeMonitorDevices = [];
      this.selectedRealTimeMonitorName = "";
    },
    saveRealTimeMonitor: function saveRealTimeMonitor() {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var id, name, devices, response, _response;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                if (!(_this17.selectedRealTimeMonitorName == "")) {
                  _context13.next = 3;
                  break;
                }

                alertify.warning(_this17.$ml.get("alerts.pleaseEnterAName"));
                return _context13.abrupt("return");

              case 3:
                _context13.prev = 3;
                id = _this17.selectedRealTimeMonitorId;
                _context13.next = 7;
                return _this17.getCheckReaders();

              case 7:
                name = _this17.selectedRealTimeMonitorName;
                devices = _this17.selectedRealTimeMonitorDevices;

                if (!(_this17.isNewRealTimeMonitor == true)) {
                  _context13.next = 17;
                  break;
                }

                _context13.next = 12;
                return _this17.$axios.post("/RealTimeMonitor", {
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this17.$ml.get("alerts.savedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this17.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this17.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 12:
                response = _context13.sent;

                _this17.newRealTimeMonitor();
                _this17.getMonitorGroups();
                _context13.next = 22;
                break;

              case 17:
                _context13.next = 19;
                return _this17.$axios.post("/RealTimeMonitor/" + id, {
                  id: id,
                  name: name,
                  devices: devices
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this17.$ml.get("alerts.updatedSuccessfully"));
                  }
                }).catch(function (doc) {
                  if (doc.status == 401) {
                    _this17.$store.dispatch("logout");
                  } else if (doc.message == "Network Error") {
                    alertify.error(_this17.$ml.get("errors.connectionError"));
                  } else {
                    alertify.error(doc.message);
                  }
                });

              case 19:
                _response = _context13.sent;

                _this17.newRealTimeMonitor();
                _this17.getMonitorGroups();

              case 22:
                _context13.next = 28;
                break;

              case 24:
                _context13.prev = 24;
                _context13.t0 = _context13["catch"](3);

                console.error(_context13.t0);
                alertify.error(_context13.t0.message);

              case 28:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this17, [[3, 24]]);
      }))();
    },
    deleteRealTimeMonitor: function deleteRealTimeMonitor() {
      var _this18 = this;

      try {
        var id = this.selectedRealTimeMonitorId;
        if (id != null) {
          var response = this.$axios.delete("/RealTimeMonitor/" + id).then(function (response) {
            _this18.getMonitorGroups();
            _this18.newRealTimeMonitor();
            alertify.success(_this18.$ml.get("alerts.deletedSuccessfully"));
          }).catch(function (doc) {
            if (doc.status == 401) {
              _this18.$store.dispatch("logout");
            } else if (doc.message == "Network Error") {
              alertify.error(_this18.$ml.get("errors.connectionError"));
            } else {
              alertify.error(doc.message);
            }
          });
        }
      } catch (error) {
        alertify.error("Hata Oluştu : " + error);
      }
    },
    getCheckAuthCompanyList: function getCheckAuthCompanyList() {
      var _this19 = this;

      var aList = this.companies;
      this.user.authCompanies = [];
      aList.forEach(function (doc) {
        if (doc.check == true) {
          _this19.user.authCompanies.push(doc.id);
        }
      });
    },
    saveUser: function saveUser() {
      var _this20 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var user2, image, response, id, formData, responseImage, _responseImage;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                if (_this20.user.name == "") {
                  alertify.warning(_this20.$ml.get("alerts.pleaseEnterAUserName"));
                }
                if (_this20.user.mail == "") {
                  alertify.warning(_this20.$ml.get("alerts.pleaseEnterAEmail"));
                }

                if (!(_this20.user.password == "" || _this20.user.password == " " || _this20.user.password == null)) {
                  _context14.next = 5;
                  break;
                }

                alertify.warning(_this20.$ml.get("alerts.pleaseEnterAPassword"));
                return _context14.abrupt("return");

              case 5:
                if (!(_this20.user.password != _this20.user.password2)) {
                  _context14.next = 8;
                  break;
                }

                alertify.warning(_this20.$ml.get("alerts.passwordsDoNotMatch"));
                return _context14.abrupt("return");

              case 8:
                if (_this20.user.authId) {
                  _context14.next = 11;
                  break;
                }

                alertify.warning(_this20.$ml.get("alerts.pleaseSelectAuthorityGroup"));
                return _context14.abrupt("return");

              case 11:
                _this20.isLoadingDetail = true;
                _context14.next = 14;
                return _this20.getCheckAuthCompanyList();

              case 14:
                _context14.prev = 14;
                user2 = _this20.user;
                image = _this20.imageData;
                _context14.next = 19;
                return _this20.$axios.post("/User/" + user2.id, {
                  name: user2.name,
                  title: user2.title,
                  mail: user2.mail,
                  authId: parseInt(user2.authId),
                  currentCompanyId: parseInt(user2.currentCompanyId),
                  password: user2.password,
                  monitorGroupId: parseInt(user2.monitorGroupId),
                  authCompanies: user2.authCompanies,
                  visitorCardGroup: user2.visitorCardGroup,
                  reports: _this20.activeReports,
                  phoneNumber: user2.phoneNumber,
                  isSmsSend: user2.isSmsSend,
                  isActive: true,
                  filter: _this20.filters
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this20.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this20.$ml.get("errors.connectionError"));
                      _this20.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this20.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 19:
                response = _context14.sent;
                id = user2.id;

                if (_this20.myUser.id == id) {
                  localStorage.setItem("defaultFilters", JSON.stringify(_this20.filters));
                  _this20.$store.commit("setDefaultFilters", _this20.filters);
                  _this20.$store.commit("setMyUser", { userName: user2.name, title: user2.title, mail: user2.mail, profileUrl: _this20.tempUrl, defaultVisitorCardGroup: user2.visitorCardGroup });
                }

                if (!_this20.imageData) {
                  _context14.next = 30;
                  break;
                }

                formData = new FormData();

                formData.append("file", image);
                _context14.next = 27;
                return _this20.$axios.post("/User/AddUserPhoto/" + id, formData);

              case 27:
                responseImage = _context14.sent;
                _context14.next = 34;
                break;

              case 30:
                if (!(_this20.user.photo == null)) {
                  _context14.next = 34;
                  break;
                }

                _context14.next = 33;
                return _this20.$axios.patch("/User/RemovePhoto/" + id);

              case 33:
                _responseImage = _context14.sent;

              case 34:
                try {
                  if (response.status == 200) {
                    alertify.success(_this20.$ml.get("alerts.updatedSuccessfully"));
                  } else {
                    alertify.error(response.message);
                  }
                } catch (error) {}
                _this20.isLoadingDetail = false;
                _context14.next = 43;
                break;

              case 38:
                _context14.prev = 38;
                _context14.t0 = _context14["catch"](14);

                console.error(_context14.t0);
                alertify.error(_context14.t0);
                _this20.isLoadingDetail = false;

              case 43:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this20, [[14, 38]]);
      }))();
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      var _this21 = this;

      filter.accessGroup ? this.filters.accessGroup = filter.accessGroup : this.filters.accessGroup = [];
      filter.foodGroup ? this.filters.foodGroup = filter.foodGroup : this.filters.foodGroup = [];
      filter.workGroupId ? this.filters.workGroupId = filter.workGroupId : this.filters.workGroupId = [];
      filter.stateId ? this.filters.stateId = filter.stateId : this.filters.stateId = [];
      filter.statuId ? this.filters.statuId = filter.statuId : this.filters.statuId = [];
      this.filters.departments = filter.departments;
      this.filters.nameOrCardNumber = filter.nameOrCardNumber;
      this.filters.sicilOrTerminalNo = filter.sicilOrTerminalNo;
      this.filters.isActive = filter.isActive;
      this.filters.documentNoOrMail = filter.documentNoOrMail;
      this.filters.identityNo = filter.identityNo;
      this.filters.title = filter.title;
      this.filters.extraField1key = filter.extraField1key;
      this.filters.extraField1value = filter.extraField1value;
      this.filters.extraField2key = filter.extraField2key;
      this.filters.extraField2value = filter.extraField2value;
      this.filters.extraField3key = filter.extraField3key;
      this.filters.extraField3value = filter.extraField3value;
      this.filters.extraField4key = filter.extraField4key;
      this.filters.extraField4value = filter.extraField4value;
      this.filters.isVisitor = filter.isVisitor;
      this.filters.plateNo = filter.plateNo;
      //this.filters = filter;
      this.sortableDepartmentList.forEach(function (doc) {
        _this21.filters.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.periodWorkGroupList.forEach(function (doc) {
        _this21.filters.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.accessGroupList.forEach(function (doc) {
        _this21.filters.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.foodGroupList.forEach(function (doc) {
        _this21.filters.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.stateList.forEach(function (doc) {
        _this21.filters.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.statuList.forEach(function (doc) {
        _this21.filters.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    getUser: function getUser(id) {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var response;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;

                _this22.isLoadingDetail = true;
                _this22.user.password = "";
                _this22.user.password2 = "";
                _context15.next = 6;
                return _this22.$axios.get("/User/" + id).then(function (response) {
                  _this22.isNewUser = false;
                  _this22.user.id = id;
                  _this22.user.name = response.data.name;
                  _this22.user.title = response.data.title;
                  _this22.user.mail = response.data.mail;
                  _this22.user.authId = response.data.authId;
                  _this22.user.password = response.data.password;
                  _this22.user.password2 = response.data.password;
                  _this22.user.currentCompanyId = response.data.currentCompanyId;
                  _this22.user.monitorGroupId = response.data.monitorGroupId;
                  _this22.user.authCompanies = response.data.authCompanies;
                  _this22.user.visitorCardGroup = response.data.visitorCardGroup;
                  _this22.user.phoneNumber = response.data.phoneNumber;
                  _this22.user.isSmsSend = response.data.isSmsSend;
                  _this22.user.isActive = response.data.isActive;
                  _this22.activeReports = response.data.reports;
                  _this22.user.photo = response.data.photo;
                  _this22.companies.forEach(function (doc) {
                    _this22.user.authCompanies.forEach(function (doc2) {
                      if (doc.id == doc2) {
                        doc.check = true;
                      }
                    });
                  });
                  if (response.data.filter) {
                    _this22.setUserAuthorityFilter(response.data.filter);
                  } else {
                    _this22.filtersClear();
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context15.sent;

                _this22.isLoadingDetail = false;
                _context15.next = 15;
                break;

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](0);

                console.error(_context15.t0);
                alertify.error(_context15.t0.message);
                _this22.isLoadingDetail = false;

              case 15:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this22, [[0, 10]]);
      }))();
    },
    getCompanies: function getCompanies() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var companies, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this23.isLoadingCompanies = true;
                companies = [];
                _context16.next = 5;
                return _this23.$axios.get("/CompanySettings").then(function (response) {
                  response.data.forEach(function (doc) {
                    companies.push({
                      id: doc.id,
                      name: doc.name,
                      check: true,
                      logo: doc.logo,
                      website: doc.website,
                      phoneNumber: doc.phoneNumber,
                      address: doc.address,
                      title: doc.title
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context16.sent;

                _this23.companies = companies;
                _this23.isLoadingCompanies = false;
                _context16.next = 15;
                break;

              case 10:
                _context16.prev = 10;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error(_context16.t0.message);
                _this23.isLoadingCompanies = false;

              case 15:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this23, [[0, 10]]);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;

                _this24.isLoadingDetail = true;
                departments = [];
                _context17.next = 5;
                return _this24.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                    departments.sort(function (a, b) {
                      if (a.locationTree < b.locationTree) return -1;
                      if (a.locationTree > b.locationTree) return 0;
                    });
                  });
                  _this24.departments = departments;
                  _this24.sortableTrees();
                  _this24.isLoadingDetail = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context17.sent;
                _context17.next = 13;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error(_context17.t0.message);
                _this24.isLoadingDetail = false;

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this24, [[0, 8]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this25 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this25.sortableDepTrees.push(dep);
          _this25.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this26 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this26.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this26.subDepImport(doc2);
        });
      }
    },
    getUserAuthGroups: function getUserAuthGroups() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var userAuhtGroups, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;

                _this27.isLoadingDetail = true;
                userAuhtGroups = [];
                _context18.next = 5;
                return _this27.$axios.get("/User/UserAuthGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    userAuhtGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context18.sent;

                _this27.userAuhtGroups = userAuhtGroups;
                _this27.isLoadingDetail = false;
                _context18.next = 15;
                break;

              case 10:
                _context18.prev = 10;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error(_context18.t0.message);
                _this27.isLoadingDetail = false;

              case 15:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this27, [[0, 10]]);
      }))();
    },
    getMonitorGroups: function getMonitorGroups() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var monitorGroups, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;

                _this28.isLoadingDetail = true;
                monitorGroups = [];
                _context19.next = 5;
                return _this28.$axios.get("/RealTimeMonitor").then(function (response) {
                  response.data.forEach(function (doc) {
                    monitorGroups.push({
                      id: doc.id,
                      name: doc.name,
                      devices: doc.readers
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this28.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this28.$ml.get("errors.connectionError"));
                      _this28.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this28.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context19.sent;

                _this28.monitorGroups = monitorGroups;
                _this28.isLoadingDetail = false;
                _context19.next = 15;
                break;

              case 10:
                _context19.prev = 10;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error(_context19.t0.message);
                _this28.isLoadingDetail = false;

              case 15:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this28, [[0, 10]]);
      }))();
    },
    getReaders: function getReaders() {
      var _this29 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var readers, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                readers = [];
                _context20.next = 4;
                return _this29.$axios.get("/Terminal/GetReaders").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      if (doc.doorType == 0 || doc.doorType == 1 || doc.doorType == 2 || doc.doorType == 3 || doc.doorType == 5) {
                        readers.push({
                          readerNo: doc.readerNo,
                          readerId: doc.readerId,
                          terminalId: doc.terminalId,
                          terminalNo: doc.terminalNo,
                          ipAddress: doc.ipAddress,
                          isActive: doc.isActive,
                          doorType: doc.doorType,
                          name: doc.name,
                          check: false
                        });
                      }
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this29.$store.dispatch("logout");
                    }
                    if (error.response.status == 500) {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this29.$ml.get("errors.connectionError"));
                      _this29.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this29.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context20.sent;

                _this29.readers = readers;
                _context20.next = 12;
                break;

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error("Servis Hatası : " + _context20.t0.message);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this29, [[0, 8]]);
      }))();
    },
    getVisitorGroups: function getVisitorGroups() {
      var _this30 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var visitorGroups, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;

                _this30.isLoadingDetail = true;
                visitorGroups = [];
                _context21.next = 5;
                return _this30.$axios.get("/Visitors/GetVisitorsCardGroup?companyId=0").then(function (response) {
                  response.data.forEach(function (doc) {
                    visitorGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this30.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this30.$ml.get("errors.connectionError"));
                      _this30.isLoadingDetail = false;
                      return;
                    } else {
                      r;
                      console.error(error);
                      alertify.error(error.message);
                      _this30.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context21.sent;

                _this30.visitorGroups = visitorGroups;
                _this30.isLoadingDetail = false;
                _context21.next = 15;
                break;

              case 10:
                _context21.prev = 10;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error(_context21.t0.message);
                _this30.isLoadingDetail = false;

              case 15:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this30, [[0, 10]]);
      }))();
    },
    getFoodGroups: function getFoodGroups() {
      var _this31 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                foodGroups = [];
                _context22.next = 4;
                return _this31.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this31.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this31.$ml.get("errors.connectionError"));
                      _this31.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this31.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context22.sent;

                _this31.foodGroups = foodGroups;
                _context22.next = 12;
                break;

              case 8:
                _context22.prev = 8;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);

              case 12:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this31, [[0, 8]]);
      }))();
    },
    getExtraFields: function getExtraFields() {
      var _this32 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        var extrafields, response;
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                extrafields = [];
                _context23.next = 4;
                return _this32.$axios.get("/ExtraField").then(function (response) {
                  response.data.forEach(function (doc) {
                    extrafields.push({
                      id: doc.id,
                      name: doc.definition
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this32.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this32.$ml.get("errors.connectionError"));
                      _this32.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this32.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context23.sent;

                _this32.extrafields = extrafields;
                _context23.next = 12;
                break;

              case 8:
                _context23.prev = 8;
                _context23.t0 = _context23["catch"](0);

                console.error(_context23.t0);
                alertify.error("Servis Hatası :" + _context23.t0.message);

              case 12:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this32, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this33 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.prev = 0;
                status = [];
                _context24.next = 4;
                return _this33.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this33.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this33.$ml.get("errors.connectionError"));
                      _this33.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this33.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context24.sent;

                _this33.status = status;
                _context24.next = 12;
                break;

              case 8:
                _context24.prev = 8;
                _context24.t0 = _context24["catch"](0);

                console.error(_context24.t0);
                alertify.error("Servis Hatası :" + _context24.t0.message);

              case 12:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, _this33, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this34 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.prev = 0;
                states = [];
                _context25.next = 4;
                return _this34.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this34.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this34.$ml.get("errors.connectionError"));
                      _this34.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this34.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context25.sent;

                _this34.states = states;
                _context25.next = 12;
                break;

              case 8:
                _context25.prev = 8;
                _context25.t0 = _context25["catch"](0);

                console.error(_context25.t0);
                alertify.error("Servis Hatası :" + _context25.t0.message);

              case 12:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, _this34, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this35 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.prev = 0;
                accessGroups = [];
                _context26.next = 4;
                return _this35.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this35.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this35.$ml.get("errors.connectionError"));
                      _this35.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this35.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context26.sent;

                _this35.accessGroups = accessGroups;
                _context26.next = 12;
                break;

              case 8:
                _context26.prev = 8;
                _context26.t0 = _context26["catch"](0);

                console.error(_context26.t0);
                alertify.error("Servis Hatası :" + _context26.t0.message);

              case 12:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, _this35, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this36 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee27() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _context27.prev = 0;
                workGroups = [];
                _context27.next = 4;
                return _this36.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      isCheck: false
                    });
                    workGroups.sort(function (a, b) {
                      if (a.name < b.name) return -1;
                      if (a.name > b.name) return 0;
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this36.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this36.$ml.get("errors.connectionError"));
                      _this36.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this36.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context27.sent;

                _this36.workGroups = workGroups;
                _context27.next = 12;
                break;

              case 8:
                _context27.prev = 8;
                _context27.t0 = _context27["catch"](0);

                console.error(_context27.t0);
                alertify.error("Servis Hatası :" + _context27.t0.message);

              case 12:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, _this36, [[0, 8]]);
      }))();
    },
    getTitles: function getTitles() {
      var _this37 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee28() {
        var titles, response;
        return regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.prev = 0;
                titles = [];
                _context28.next = 4;
                return _this37.$axios.get("/Employees/getTitles").then(function (response) {
                  response.data.forEach(function (doc) {
                    titles.push({
                      name: doc
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this37.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this37.$ml.get("errors.connectionError"));
                      _this37.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this37.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context28.sent;

                _this37.titles = titles;
                _context28.next = 12;
                break;

              case 8:
                _context28.prev = 8;
                _context28.t0 = _context28["catch"](0);

                console.error(_context28.t0);
                alertify.error("Servis Hatası :" + _context28.t0.message);

              case 12:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28, _this37, [[0, 8]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
}, _defineProperty(_data$components$comp, "mounted", function mounted() {
  var _this38 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee29() {
    return regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.next = 2;
            return _this38.getUser(_this38.myUser.id);

          case 2:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29, _this38);
  }))();
}), _defineProperty(_data$components$comp, "created", function created() {
  var _this39 = this;

  return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee30() {
    return regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            _context30.next = 2;
            return _this39.getCompanies();

          case 2:
            _context30.next = 4;
            return _this39.getDepartments();

          case 4:
            _context30.next = 6;
            return _this39.getUserAuthGroups();

          case 6:
            _context30.next = 8;
            return _this39.getMonitorGroups();

          case 8:
            _context30.next = 10;
            return _this39.getReaders();

          case 10:
            _context30.next = 12;
            return _this39.getVisitorGroups();

          case 12:
            _context30.next = 14;
            return _this39.getFoodGroups();

          case 14:
            _context30.next = 16;
            return _this39.getExtraFields();

          case 16:
            _context30.next = 18;
            return _this39.getAccessGroups();

          case 18:
            _context30.next = 20;
            return _this39.getStatus();

          case 20:
            _context30.next = 22;
            return _this39.getStates();

          case 22:
            _context30.next = 24;
            return _this39.getWorkGroups();

          case 24:
            _context30.next = 26;
            return _this39.getTitles();

          case 26:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30, _this39);
  }))();
}), _data$components$comp);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      userAuthorityGroup: {
        id: null,
        name: "",
        description: "",
        state: 0,
        authUsers: 0,
        authAccessGroups: 0,
        authReports: 0,
        authSettings: 0,
        authDefinitions: 0,
        authRealTimeMonitor: 0,
        authFood: 0,
        authVisitor: 0,
        creditSale: 0,
        dashboard: 0,
        guardTour: 0,
        payrollManagement: 0,
        shiftManagement: 0,
        shiftSettings: {
          canPlan: true,
          canConfirmShift: true,
          canConfirmAllowence: true,
          canPlanAllowence: true,
          canSeeRealMovements: true,
          sendMailWhenUnconfirmedShifts: false,
          sendWarningMailOnSecondDay: false
        },
        filter: {
          departments: [],
          accessGroup: [],
          foodGroup: [],
          workGroupId: [],
          stateId: [],
          statuId: [],
          allowenceId: []
        }
      },
      isNewUserAuthorityGroup: true,
      userAuthorityGroups: [],
      searchText2: "",
      isCheckDeps: false,
      departments: [],
      sortableDepTrees: [],
      foodGroups: [],
      accessGroups: [],
      states: [],
      status: [],
      workGroups: [],
      allowences: []
    };
  },

  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    userAuthorityGroupList: function userAuthorityGroupList() {
      var _this = this;

      var search = this.turkishToUpper(this.searchText);
      if (search) {
        return this.userAuthorityGroups.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this.turkishToUpper(item.name).includes(v);
          });
        });
      } else {
        return this.userAuthorityGroups;
      }
    },
    departmentList: function departmentList() {
      return this.departments.filter(function (a) {
        return a.isActive == true;
      });
    },
    sortableDepartmentList: function sortableDepartmentList() {
      var _this2 = this;

      var search = this.turkishToUpper(this.searchText2);
      if (search) {
        return this.sortableDepTrees.filter(function (item) {
          return search.split(" ").every(function (v) {
            return _this2.turkishToUpper(item.name).includes(v) && item.isActive == true;
          });
        });
      } else {
        return this.sortableDepTrees.filter(function (a) {
          return a.isActive == true;
        });
      }
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      }).sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    allowenceList: function allowenceList() {
      return this.allowences.sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 0;
      });
    },
    checkedAllowenceList: function checkedAllowenceList() {
      var checkedList = "";
      var list = this.allowenceList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    turkishToUpper: function turkishToUpper(text) {
      var letters = { i: "İ", ş: "Ş", ğ: "Ğ", ü: "Ü", ö: "Ö", ç: "Ç", ı: "I" };
      text = text.replace(/(([iışğüçö]))/g, function (letter) {
        return letters[letter];
      });
      return text.toUpperCase();
    },
    changeUsersStatu: function changeUsersStatu(event) {
      this.userAuthorityGroup.authUsers = event.target.value;
    },
    changeDefinitionsStatu: function changeDefinitionsStatu(event) {
      this.userAuthorityGroup.authDefinitions = event.target.value;
    },
    changeAccessGroupsStatu: function changeAccessGroupsStatu(event) {
      this.userAuthorityGroup.authAccessGroups = event.target.value;
    },
    changeRealTimeMonitorStatu: function changeRealTimeMonitorStatu(event) {
      this.userAuthorityGroup.authRealTimeMonitor = event.target.value;
    },
    changeReportsStatu: function changeReportsStatu(event) {
      this.userAuthorityGroup.authReports = event.target.value;
    },
    changeSettingsStatu: function changeSettingsStatu(event) {
      this.userAuthorityGroup.authSettings = event.target.value;
    },
    changeFoodStatu: function changeFoodStatu(event) {
      this.userAuthorityGroup.authFood = event.target.value;
    },
    changeVisitorStatu: function changeVisitorStatu(event) {
      this.userAuthorityGroup.authVisitor = event.target.value;
    },
    changeDashboardStatu: function changeDashboardStatu(event) {
      this.userAuthorityGroup.dashboard = event.target.value;
    },
    changeCreditSaleStatu: function changeCreditSaleStatu(event) {
      this.userAuthorityGroup.creditSale = event.target.value;
    },
    changePayrollManagementStatu: function changePayrollManagementStatu(event) {
      this.userAuthorityGroup.payrollManagement = event.target.value;
    },
    changeGuardTourStatu: function changeGuardTourStatu(event) {
      this.userAuthorityGroup.guardTour = event.target.value;
    },
    changeShiftManagementStatu: function changeShiftManagementStatu(event) {
      this.userAuthorityGroup.shiftManagement = event.target.value;
    },
    filtersClear: function filtersClear() {
      this.searchText2 = "";
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
      this.allowenceList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    setUserAuthorityFilter: function setUserAuthorityFilter(filter) {
      this.userAuthorityGroup.filter.departments = filter.departments;
      this.sortableDepartmentList.forEach(function (doc) {
        filter.departments.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.check = true;
          }
        });
      });
      this.userAuthorityGroup.filter.workGroupId = filter.workGroupId;
      this.periodWorkGroupList.forEach(function (doc) {
        filter.workGroupId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.allowenceId = filter.allowenceId;
      this.allowenceList.forEach(function (doc) {
        filter.allowenceId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.accessGroup = filter.accessGroup;
      this.accessGroupList.forEach(function (doc) {
        filter.accessGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.foodGroup = filter.foodGroup;
      this.foodGroupList.forEach(function (doc) {
        filter.foodGroup.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.stateId = filter.stateId;
      this.stateList.forEach(function (doc) {
        filter.stateId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
      this.userAuthorityGroup.filter.statuId = filter.statuId;
      this.statuList.forEach(function (doc) {
        filter.statuId.forEach(function (doc2) {
          if (doc.id == doc2) {
            doc.isCheck = true;
          }
        });
      });
    },
    newUserAuthorityGroup: function newUserAuthorityGroup() {
      this.isLoadingDetail = true;
      this.isNewUserAuthorityGroup = true;
      this.userAuthorityGroup.id = null;
      this.userAuthorityGroup.name = "";
      this.userAuthorityGroup.description = "";
      this.userAuthorityGroup.state = 0;
      this.userAuthorityGroup.authUsers = 0;
      this.userAuthorityGroup.authAccessGroups = 0;
      this.userAuthorityGroup.authReports = 0;
      this.userAuthorityGroup.authSettings = 0;
      this.userAuthorityGroup.authDefinitions = 0;
      this.userAuthorityGroup.authRealTimeMonitor = 0;
      this.userAuthorityGroup.authFood = 0;
      this.userAuthorityGroup.authVisitor = 0;
      this.userAuthorityGroup.creditSale = 0;
      this.userAuthorityGroup.dashboard = 0;
      this.userAuthorityGroup.payrollManagement = 0;
      this.userAuthorityGroup.shiftManagement = 0;
      this.userAuthorityGroup.shiftSettings = {
        canPlan: true,
        canConfirmShift: true,
        canConfirmAllowence: true,
        canPlanAllowence: true,
        canSeeRealMovements: true,
        sendMailWhenUnconfirmedShifts: false,
        sendWarningMailOnSecondDay: false
      };
      this.userAuthorityGroup.filter = {
        departments: [],
        accessGroup: [],
        foodGroup: [],
        workGroupId: [],
        stateId: [],
        statuId: [],
        allowenceId: []
      };
      this.filtersClear();
      this.isLoadingDetail = false;
    },
    deleteUserAuthorityGroup: function deleteUserAuthorityGroup() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this4.isLoadingDetail = true;
                id = _this4.userAuthorityGroup.id;
                _context.next = 5;
                return _this4.$axios.delete("/UserAuthorityGroups/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this4.getUserAuthorityGroups();
                _this4.newUserAuthorityGroup();
                alertify.success(_this4.$ml.get("alerts.deletedSuccessfully"));
                _this4.isLoadingDetail = false;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this4.isLoadingDetail = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4, [[0, 12]]);
      }))();
    },
    saveUserAuthorityGroup: function saveUserAuthorityGroup() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var userAuthorityGroup2, response, id, _userAuthorityGroup, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this5.isNewUserAuthorityGroup) {
                  _context2.next = 27;
                  break;
                }

                if (!(_this5.userAuthorityGroup.name == "")) {
                  _context2.next = 4;
                  break;
                }

                alertify.warning(_this5.$ml.get("alerts.pleaseEnterAName"));
                return _context2.abrupt("return");

              case 4:
                _this5.isLoadingDetail = true;
                _context2.next = 7;
                return _this5.getCheckDepartmentList();

              case 7:
                _context2.prev = 7;
                userAuthorityGroup2 = _this5.userAuthorityGroup;
                _context2.next = 11;
                return _this5.$axios.post("/UserAuthorityGroups", {
                  name: userAuthorityGroup2.name,
                  description: userAuthorityGroup2.description,
                  state: userAuthorityGroup2.state,
                  authUsers: userAuthorityGroup2.authUsers,
                  authAccessGroups: userAuthorityGroup2.authAccessGroups,
                  authReports: userAuthorityGroup2.authReports,
                  authSettings: userAuthorityGroup2.authSettings,
                  authDefinitions: userAuthorityGroup2.authDefinitions,
                  authRealTimeMonitor: userAuthorityGroup2.authRealTimeMonitor,
                  authFood: userAuthorityGroup2.authFood,
                  authVisitor: userAuthorityGroup2.authVisitor,
                  creditSale: userAuthorityGroup2.creditSale,
                  dashboard: userAuthorityGroup2.dashboard,
                  payrollManagement: userAuthorityGroup2.payrollManagement,
                  guardTour: userAuthorityGroup2.guardTour,
                  shiftManagement: userAuthorityGroup2.shiftManagement,
                  shiftSettings: userAuthorityGroup2.shiftSettings,
                  filter: userAuthorityGroup2.filter
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 11:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.savedSuccessfully"));
                } else {
                  alertify.error(response.message);
                }
                _this5.getUserAuthorityGroups();
                _this5.getUserAuthorityGroup(id);
                _this5.isNewUserAuthorityGroup = false;
                _this5.isLoadingDetail = false;
                _context2.next = 25;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2["catch"](7);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this5.isLoadingDetail = false;

              case 25:
                _context2.next = 44;
                break;

              case 27:
                _context2.next = 29;
                return _this5.getCheckDepartmentList();

              case 29:
                _context2.prev = 29;
                _userAuthorityGroup = _this5.userAuthorityGroup;
                _context2.next = 33;
                return _this5.$axios.post("/UserAuthorityGroups/" + _userAuthorityGroup.id, {
                  name: _userAuthorityGroup.name,
                  description: _userAuthorityGroup.description,
                  state: _userAuthorityGroup.state,
                  authUsers: _userAuthorityGroup.authUsers,
                  authAccessGroups: _userAuthorityGroup.authAccessGroups,
                  authReports: _userAuthorityGroup.authReports,
                  authSettings: _userAuthorityGroup.authSettings,
                  authDefinitions: _userAuthorityGroup.authDefinitions,
                  authRealTimeMonitor: _userAuthorityGroup.authRealTimeMonitor,
                  authFood: _userAuthorityGroup.authFood,
                  authVisitor: _userAuthorityGroup.authVisitor,
                  creditSale: _userAuthorityGroup.creditSale,
                  dashboard: _userAuthorityGroup.dashboard,
                  payrollManagement: _userAuthorityGroup.payrollManagement,
                  guardTour: _userAuthorityGroup.guardTour,
                  shiftManagement: _userAuthorityGroup.shiftManagement,
                  shiftSettings: _userAuthorityGroup.shiftSettings,
                  filter: _userAuthorityGroup.filter
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get("errors.connectionError"));
                      _this5.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 33:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this5.$ml.get("alerts.updatedSuccessfully"));
                } else {
                  alertify.error(_response.message);
                }
                _this5.getUserAuthorityGroups();
                _this5.isLoadingDetail = false;
                _context2.next = 44;
                break;

              case 39:
                _context2.prev = 39;
                _context2.t1 = _context2["catch"](29);

                console.error(_context2.t1);
                alertify.error(_context2.t1.message);
                _this5.isLoadingDetail = false;

              case 44:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[7, 20], [29, 39]]);
      }))();
    },
    getUserAuthorityGroup: function getUserAuthorityGroup(id) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _this6.filtersClear();

              case 3:
                _this6.isLoadingDetail = true;
                _context3.next = 6;
                return _this6.$axios.get("/UserAuthorityGroups/" + id).then(function (response) {
                  _this6.isNewUserAuthorityGroup = false;
                  _this6.userAuthorityGroup.id = id;
                  _this6.userAuthorityGroup.name = response.data.name;
                  _this6.userAuthorityGroup.description = response.data.description;
                  _this6.userAuthorityGroup.state = response.data.state;
                  _this6.userAuthorityGroup.authUsers = response.data.authUsers;
                  _this6.userAuthorityGroup.authAccessGroups = response.data.authAccessGroups;
                  _this6.userAuthorityGroup.authReports = response.data.authReports;
                  _this6.userAuthorityGroup.authSettings = response.data.authSettings;
                  _this6.userAuthorityGroup.authDefinitions = response.data.authDefinitions;
                  _this6.userAuthorityGroup.authRealTimeMonitor = response.data.authRealTimeMonitor;
                  _this6.userAuthorityGroup.authFood = response.data.authFood;
                  _this6.userAuthorityGroup.authVisitor = response.data.authVisitor;
                  _this6.userAuthorityGroup.creditSale = response.data.creditSale;
                  _this6.userAuthorityGroup.dashboard = response.data.dashboard;
                  _this6.userAuthorityGroup.guardTour = response.data.guardTour ? response.data.guardTour : _this6.userAuthorityGroup.guardTour;
                  _this6.userAuthorityGroup.payrollManagement = response.data.payrollManagement;
                  _this6.userAuthorityGroup.shiftManagement = response.data.shiftManagement;
                  _this6.userAuthorityGroup.shiftSettings = response.data.shiftSettings ? response.data.shiftSettings : _this6.userAuthorityGroup.shiftSettings;
                  _this6.userAuthorityGroup.filter = response.data.filter;
                  if (response.data.filter) {
                    _this6.setUserAuthorityFilter(response.data.filter);
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get("errors.connectionError"));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 6:
                response = _context3.sent;

                _this6.isLoadingDetail = false;
                _context3.next = 15;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this6.isLoadingDetail = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 10]]);
      }))();
    },
    getUserAuthorityGroups: function getUserAuthorityGroups() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var userAuthorityGroups, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this7.isLoading = true;
                userAuthorityGroups = [];
                _context4.next = 5;
                return _this7.$axios.get("/UserAuthorityGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    userAuthorityGroups.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this7.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this7.$ml.get("errors.connectionError"));
                      _this7.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this7.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this7.userAuthorityGroups = userAuthorityGroups;
                _this7.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this7.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[0, 10]]);
      }))();
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.userAuthorityGroup.filter.departments = [];
                _context5.next = 3;
                return _this8.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.userAuthorityGroup.filter.accessGroup = [];
                _context6.next = 3;
                return _this9.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this10.userAuthorityGroup.filter.stateId = [];
                _context7.next = 3;
                return _this10.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this11.userAuthorityGroup.filter.statuId = [];
                _context8.next = 3;
                return _this11.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this12.userAuthorityGroup.filter.workGroupId = [];
                _context9.next = 3;
                return _this12.periodWorkGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    clearFilterAllowences: function clearFilterAllowences() {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.userAuthorityGroup.filter.allowenceId = [];
                _context10.next = 3;
                return _this13.allowenceList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this14.userAuthorityGroup.filter.foodGroup = [];
                _context11.next = 3;
                return _this14.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    },
    getCheckDepAll: function getCheckDepAll(value) {
      var _this15 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _this15.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this15.isCheckDep = !_this15.isCheckDep;

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, _this15);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _this16.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this16.isCheckDeps = !_this16.isCheckDeps;

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, _this16);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this17 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                dep.check = checkValue;
                _this17.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this17.changeFilterDep(doc, checkValue);
                  }
                  /*if (doc.id == dep.mainDepartmentId && checkValue) {
                    doc.check = true;
                  }*/
                });

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, _this17);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this18 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var aList, aList2, aList3, aList4, aList5, aList6, aList7;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                aList = _this18.sortableDepartmentList;

                _this18.userAuthorityGroup.filter.departments = [];
                _context15.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this18.userAuthorityGroup.filter.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this18.accessGroupList;

                _this18.userAuthorityGroup.filter.accessGroup = [];
                _context15.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this18.periodWorkGroupList;

                _this18.userAuthorityGroup.filter.workGroupId = [];
                _context15.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this18.foodGroupList;

                _this18.userAuthorityGroup.filter.foodGroup = [];
                _context15.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this18.statuList;

                _this18.userAuthorityGroup.filter.statuId = [];
                _context15.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this18.stateList;

                _this18.userAuthorityGroup.filter.stateId = [];
                _context15.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.stateId.push(doc.id);
                  }
                });

              case 24:
                aList7 = _this18.allowenceList;

                _this18.userAuthorityGroup.filter.allowenceId = [];
                _context15.next = 28;
                return aList7.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this18.userAuthorityGroup.filter.allowenceId.push(doc.id);
                  }
                });

              case 28:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, _this18);
      }))();
    },
    getDepartments: function getDepartments() {
      var _this19 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var departments, response;
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;

                _this19.isLoadingDetail = true;
                departments = [];
                _context16.next = 5;
                return _this19.$axios.get("/Department").then(function (response) {
                  response.data.forEach(function (doc) {
                    departments.push({
                      id: doc.id,
                      name: doc.name,
                      mainDepartmentId: doc.mainDepartmentId,
                      isActive: doc.isActive,
                      locationTree: doc.locationTree,
                      check: false
                    });
                    departments.sort(function (a, b) {
                      if (a.locationTree < b.locationTree) return -1;
                      if (a.locationTree > b.locationTree) return 0;
                    });
                  });
                  _this19.departments = departments;
                  _this19.sortableTrees();
                  _this19.isLoadingDetail = false;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this19.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this19.$ml.get("errors.connectionError"));
                      _this19.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this19.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context16.sent;
                _context16.next = 13;
                break;

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);

                console.error(_context16.t0);
                alertify.error(_context16.t0.message);
                _this19.isLoadingDetail = false;

              case 13:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, _this19, [[0, 8]]);
      }))();
    },
    sortableTrees: function sortableTrees() {
      var _this20 = this;

      this.sortableDepTrees = [];
      this.departments.forEach(function (dep) {
        if (dep.mainDepartmentId == null) {
          _this20.sortableDepTrees.push(dep);
          _this20.subDepImport(dep);
        }
      });
    },
    subDepImport: function subDepImport(dep) {
      var _this21 = this;

      var subDep = this.departments.filter(function (doc) {
        return doc.mainDepartmentId == dep.id;
      });
      if (subDep.length > 0) {
        var ekle = "";
        var ek = subDep[0].locationTree.split("/");
        for (var index = 0; index < ek.length - 3; index++) {
          ekle = "--/" + ekle;
        }
        subDep.forEach(function (doc2) {
          _this21.sortableDepTrees.push({
            id: doc2.id,
            name: ekle + " " + doc2.name,
            mainDepartmentId: doc2.mainDepartmentId,
            isActive: doc2.isActive,
            locationTree: doc2.locationTree,
            userId: doc2.userId,
            check: doc2.check
          });
          _this21.subDepImport(doc2);
        });
      }
    },
    getFoodGroups: function getFoodGroups() {
      var _this22 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var foodGroups, response;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                foodGroups = [];
                _context17.next = 4;
                return _this22.$axios.get("/FoodGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    foodGroups.push({
                      id: doc.id,
                      name: doc.name,
                      type: doc.type,
                      singleFoodEachMeal: doc.singleFoodEachMeal,
                      meals: doc.meals,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this22.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this22.$ml.get("errors.connectionError"));
                      _this22.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this22.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context17.sent;

                _this22.foodGroups = foodGroups;
                _context17.next = 12;
                break;

              case 8:
                _context17.prev = 8;
                _context17.t0 = _context17["catch"](0);

                console.error(_context17.t0);
                alertify.error("Servis Hatası :" + _context17.t0.message);

              case 12:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, _this22, [[0, 8]]);
      }))();
    },
    getStatus: function getStatus() {
      var _this23 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var status, response;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                status = [];
                _context18.next = 4;
                return _this23.$axios.get("/Employees/getStatus").then(function (response) {
                  response.data.forEach(function (doc) {
                    status.push({
                      id: doc.id,
                      name: doc.name,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this23.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this23.$ml.get("errors.connectionError"));
                      _this23.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this23.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context18.sent;

                _this23.status = status;
                _context18.next = 12;
                break;

              case 8:
                _context18.prev = 8;
                _context18.t0 = _context18["catch"](0);

                console.error(_context18.t0);
                alertify.error("Servis Hatası :" + _context18.t0.message);

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, _this23, [[0, 8]]);
      }))();
    },
    getStates: function getStates() {
      var _this24 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var states, response;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                states = [];
                _context19.next = 4;
                return _this24.$axios.get("/Employees/getStates").then(function (response) {
                  response.data.forEach(function (doc) {
                    states.push({
                      id: doc.id,
                      name: doc.name,
                      status: doc.status,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this24.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this24.$ml.get("errors.connectionError"));
                      _this24.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this24.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context19.sent;

                _this24.states = states;
                _context19.next = 12;
                break;

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);

                console.error(_context19.t0);
                alertify.error("Servis Hatası :" + _context19.t0.message);

              case 12:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, _this24, [[0, 8]]);
      }))();
    },
    getAccessGroups: function getAccessGroups() {
      var _this25 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        var accessGroups, response;
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                accessGroups = [];
                _context20.next = 4;
                return _this25.$axios.get("/AccessGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    accessGroups.push({
                      id: doc.id,
                      name: doc.name,
                      isNewReaderAdd: doc.isNewReaderAdd,
                      selectedReaders: doc.postReaders,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this25.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this25.$ml.get("errors.connectionError"));
                      _this25.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this25.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context20.sent;

                _this25.accessGroups = accessGroups;
                _context20.next = 12;
                break;

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);

                console.error(_context20.t0);
                alertify.error("Servis Hatası :" + _context20.t0.message);

              case 12:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, _this25, [[0, 8]]);
      }))();
    },
    getWorkGroups: function getWorkGroups() {
      var _this26 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var workGroups, response;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                workGroups = [];
                _context21.next = 4;
                return _this26.$axios.get("/WorkGroups").then(function (response) {
                  response.data.forEach(function (doc) {
                    workGroups.push({
                      id: doc.id,
                      name: doc.name,
                      shortCode: doc.shortCode,
                      isPeriod: doc.isPeriod,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this26.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this26.$ml.get("errors.connectionError"));
                      _this26.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this26.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context21.sent;

                _this26.workGroups = workGroups;
                _context21.next = 12;
                break;

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21["catch"](0);

                console.error(_context21.t0);
                alertify.error("Servis Hatası :" + _context21.t0.message);

              case 12:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, _this26, [[0, 8]]);
      }))();
    },
    getAllowences: function getAllowences() {
      var _this27 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var allowences, response;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;

                _this27.isLoading = true;
                allowences = [];
                _context22.next = 5;
                return _this27.$axios.get("/Allowences").then(function (response) {
                  response.data.forEach(function (doc) {
                    allowences.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      monthlyPayrollId: doc.monthlyPayrollId,
                      dailyPayrollId: doc.dailyPayrollId,
                      dayTime: doc.dayTime,
                      colorCode: doc.colorCode,
                      r: doc.r,
                      g: doc.g,
                      b: doc.b,
                      isCheck: false
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this27.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this27.$ml.get("errors.connectionError"));
                      _this27.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this27.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context22.sent;

                _this27.allowences = allowences;
                _this27.isLoading = false;
                _context22.next = 15;
                break;

              case 10:
                _context22.prev = 10;
                _context22.t0 = _context22["catch"](0);

                console.error(_context22.t0);
                alertify.error("Servis Hatası :" + _context22.t0.message);
                _this27.isLoading = false;

              case 15:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, _this27, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this28 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                if (_this28.authControl == 1) {
                  alertify.warning(_this28.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage"));
                }

              case 1:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, _this28);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this29 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return _this29.getAuthControl();

            case 2:
              _context24.next = 4;
              return _this29.getDepartments();

            case 4:
              _context24.next = 6;
              return _this29.getFoodGroups();

            case 6:
              _context24.next = 8;
              return _this29.getAccessGroups();

            case 8:
              _context24.next = 10;
              return _this29.getStatus();

            case 10:
              _context24.next = 12;
              return _this29.getStates();

            case 12:
              _context24.next = 14;
              return _this29.getWorkGroups();

            case 14:
              _context24.next = 16;
              return _this29.getAllowences();

            case 16:
              _context24.next = 18;
              return _this29.getUserAuthorityGroups();

            case 18:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, _this29);
    }))();
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _methods;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      mails: [],
      selectedReport: 0,
      selectedEmail: "",
      selectedMail: {
        id: 0,
        name: "",
        header: "",
        content: "",
        reports: [],
        emails: [],
        days: [],
        time: null,
        isActive: true,
        reportType: 0,
        filterType: 0,
        filter: {
          nameOrCardNumber: "",
          sicilOrTerminalNo: null,
          departments: [],
          isActive: true,
          documentNoOrMail: "",
          accessGroup: [],
          identityNo: "",
          foodGroup: [],
          workGroupId: [],
          title: "",
          stateId: [],
          statuId: [],
          extraField1key: 0,
          extraField1value: "",
          extraField2key: 0,
          extraField2value: "",
          extraField3key: 0,
          extraField3value: "",
          extraField4key: 0,
          extraField4value: "",
          isVisitor: false,
          plateNo: ""
        },
        authorizedUsers: [0]
      },
      searchText: "",
      allEmployees: [],
      departments: [],
      isCheckDeps: false,
      sortableDepTrees: [],
      foodGroups: [],
      accessGroups: [],
      extrafields: [],
      states: [],
      status: [],
      titles: [],
      workGroups: [],
      days: [{ value: 1, name: this.$ml.get("general.monday"), check: false }, { value: 2, name: this.$ml.get("general.tuesday"), check: false }, { value: 3, name: this.$ml.get("general.wednesday"), check: false }, { value: 4, name: this.$ml.get("general.thursday"), check: false }, { value: 5, name: this.$ml.get("general.friday"), check: false }, { value: 6, name: this.$ml.get("general.saturday"), check: false }, { value: 7, name: this.$ml.get("general.sunday"), check: false }],
      apiLink: "",
      baslik: "",
      apiKey: "",
      secretKey: "",
      kullaniciAdi: "",
      parola: "",
      aktifMi: true,
      icerik1: "",
      icerik2: "",
      icerik3: "",
      icerik4: "",
      gun1AktifMi: true,
      gun1SonGiris: null,
      gun2AktifMi: true,
      gun2SonGiris: null,
      gun3AktifMi: true,
      gun3SonGiris: null,
      gun4AktifMi: true,
      gun4SonGiris: null,
      gun5AktifMi: true,
      gun5SonGiris: null,
      gun6AktifMi: true,
      gun6SonGiris: null,
      gun7AktifMi: true,
      gun7SonGiris: null,
      reports: [{
        id: 1,
        name: this.$ml.get("reports.reports.LaterComersReport"),
        endPoint: "LaterComersReport",
        isActive: false,
        checked: false
      }, {
        id: 11,
        name: this.$ml.get("reports.reports.FirstInLastOutReport"),
        endPoint: "FirstInLastOutReport",
        isActive: false,
        checked: false
      }, {
        id: 3,
        name: this.$ml.get("reports.reports.FoodReport"),
        endPoint: "FoodReport",
        isActive: false,
        checked: false
      }]
    };
  },

  computed: {
    modules: function modules() {
      return this.$store.getters.getModules;
    },
    dayList: function dayList() {
      return this.days;
    },
    reportList: function reportList() {
      return this.reports;
    },
    checkedReportList: function checkedReportList() {
      return this.reports.filter(function (report) {
        return report.checked;
      });
    },
    mailList: function mailList() {
      return this.mails;
    },
    emailList: function emailList() {
      return this.selectedMail.emails;
    },
    selectedReportList: function selectedReportList() {
      return this.selectedMail.reports;
    },
    allEmployeeList: function allEmployeeList() {
      return this.allEmployees;
    },
    allEmployeeFilteredList: function allEmployeeFilteredList() {
      var _this = this;

      if (this.searchText) {
        return this.allEmployeeList.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.allEmployeeList;
      }
    },
    selectedAuthorizedEmployeeList: function selectedAuthorizedEmployeeList() {
      return this.allEmployeeList.filter(function (a) {
        return a.isCheck == true;
      });
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    sortableDepartmentList: function sortableDepartmentList() {
      var _this2 = this;

      if (this.searchText) {
        return this.sortableDepTrees.filter(function (item) {
          return _this2.searchText.toUpperCase().split(" ").every(function (v) {
            return item.name.toUpperCase().includes(v);
          });
        });
      } else {
        return this.sortableDepTrees;
      }
    },
    checkedDepartmentList: function checkedDepartmentList() {
      var checkedList = "";
      var list = this.sortableDepartmentList.forEach(function (a) {
        if (a.check == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    extraFieldList: function extraFieldList() {
      return this.extrafields;
    },
    foodGroupList: function foodGroupList() {
      return this.foodGroups;
    },
    checkedFoodGroupList: function checkedFoodGroupList() {
      var checkedList = "";
      var list = this.foodGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    accessGroupList: function accessGroupList() {
      return this.accessGroups;
    },
    checkedAccessGroupList: function checkedAccessGroupList() {
      var checkedList = "";
      var list = this.accessGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    stateList: function stateList() {
      return this.states;
    },
    checkedStateList: function checkedStateList() {
      var checkedList = "";
      var list = this.stateList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    statuList: function statuList() {
      return this.status;
    },
    checkedStatusList: function checkedStatusList() {
      var checkedList = "";
      var list = this.statuList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    },
    titleList: function titleList() {
      return this.titles;
    },
    periodWorkGroupList: function periodWorkGroupList() {
      return this.workGroups.filter(function (item) {
        return item.isPeriod == true || item.model == 4 || item.model == 3;
      });
    },
    checkedWorkGroupList: function checkedWorkGroupList() {
      var checkedList = "";
      var list = this.periodWorkGroupList.forEach(function (a) {
        if (a.isCheck == true) {
          if (checkedList != "") {
            checkedList += ", " + a.name;
          } else {
            checkedList += a.name;
          }
        }
      });
      return checkedList;
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this3.onResize);
    });
  },

  methods: (_methods = {
    //Filters
    changeFilterTitles: function changeFilterTitles(event) {
      this.selectedMail.filter.title = event.target.value;
    },
    changeFilterExtraField1: function changeFilterExtraField1(event) {
      this.selectedMail.filter.extraField1key = event.target.value;
      if (!this.selectedMail.filter.extraField1key) {
        this.selectedMail.filter.extraField1key = 0;
      }
    },
    changeFilterExtraField2: function changeFilterExtraField2(event) {
      this.selectedMail.filter.extraField2key = event.target.value;
      if (!this.selectedMail.filter.extraField2key) {
        this.selectedMail.filter.extraField2key = 0;
      }
    },
    changeFilterExtraField3: function changeFilterExtraField3(event) {
      this.selectedMail.filter.extraField3key = event.target.value;
      if (!this.selectedMail.filter.extraField3key) {
        this.selectedMail.filter.extraField3key = 0;
      }
    },
    changeFilterExtraField4: function changeFilterExtraField4(event) {
      this.selectedMail.filter.extraField4key = event.target.value;
      if (!this.selectedMail.filter.extraField4key) {
        this.selectedMail.filter.extraField4key = 0;
      }
    },
    clearFilterDepartments: function clearFilterDepartments() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.selectedMail.filter.departments = [];
                _context.next = 3;
                return _this4.sortableDepartmentList.forEach(function (doc) {
                  if (doc.check == true) {
                    doc.check = false;
                  }
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    clearFilterAccessGroup: function clearFilterAccessGroup() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.selectedMail.filter.accessGroup = [];
                _context2.next = 3;
                return _this5.accessGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    clearFilterStates: function clearFilterStates() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this6.selectedMail.filter.stateId = [];
                _context3.next = 3;
                return _this6.stateList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this6);
      }))();
    },
    clearFilterStatus: function clearFilterStatus() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this7.selectedMail.filter.statuId = [];
                _context4.next = 3;
                return _this7.statuList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this7);
      }))();
    },
    clearFilterWorkPlans: function clearFilterWorkPlans() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this8.selectedMail.filter.workGroupId = [];
                _context5.next = 3;
                return _this8.periodWorkGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    clearFilterFoodGroups: function clearFilterFoodGroups() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.selectedMail.filter.foodGroup = [];
                _context6.next = 3;
                return _this9.foodGroupList.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    doc.isCheck = false;
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }))();
    },
    getCheckDepartmentList: function getCheckDepartmentList() {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var aList, aList2, aList3, aList4, aList5, aList6;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                aList = _this10.sortableDepartmentList;

                _this10.selectedMail.filter.departments = [];
                _context7.next = 4;
                return aList.forEach(function (doc) {
                  if (doc.check == true) {
                    _this10.selectedMail.filter.departments.push(doc.id);
                  }
                });

              case 4:
                aList2 = _this10.accessGroupList;

                _this10.selectedMail.filter.accessGroup = [];
                _context7.next = 8;
                return aList2.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.selectedMail.filter.accessGroup.push(doc.id);
                  }
                });

              case 8:
                aList3 = _this10.periodWorkGroupList;

                _this10.selectedMail.filter.workGroupId = [];
                _context7.next = 12;
                return aList3.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.selectedMail.filter.workGroupId.push(doc.id);
                  }
                });

              case 12:
                aList4 = _this10.foodGroupList;

                _this10.selectedMail.filter.foodGroup = [];
                _context7.next = 16;
                return aList4.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.selectedMail.filter.foodGroup.push(doc.id);
                  }
                });

              case 16:
                aList5 = _this10.statuList;

                _this10.selectedMail.filter.statuId = [];
                _context7.next = 20;
                return aList5.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.selectedMail.filter.statuId.push(doc.id);
                  }
                });

              case 20:
                aList6 = _this10.stateList;

                _this10.selectedMail.filter.stateId = [];
                _context7.next = 24;
                return aList6.forEach(function (doc) {
                  if (doc.isCheck == true) {
                    _this10.selectedMail.filter.stateId.push(doc.id);
                  }
                });

              case 24:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, _this10);
      }))();
    },
    setFilter: function setFilter() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this11.getCheckDepartmentList();

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, _this11);
      }))();
    },
    filtersClear: function filtersClear() {
      this.selectedMail.filter.nameOrCardNumber = "";
      this.selectedMail.filter.sicilOrTerminalNo = null;
      this.selectedMail.filter.departments = [];
      this.selectedMail.filter.accessGroup = [];
      this.selectedMail.filter.identityNo = "";
      this.selectedMail.filter.documentNoOrMail = "";
      this.selectedMail.filter.foodGroup = [];
      this.selectedMail.filter.workGroupId = [];
      this.selectedMail.filter.title = "";
      this.selectedMail.filter.stateId = [];
      this.selectedMail.filter.statuId = [];
      this.selectedMail.filter.plateNo = "";
      this.selectedMail.filter.extraField1key = 0;
      this.selectedMail.filter.extraField1value = "";
      this.selectedMail.filter.extraField2key = 0;
      this.selectedMail.filter.extraField2value = "";
      this.selectedMail.filter.extraField3key = 0;
      this.selectedMail.filter.extraField3value = "";
      this.selectedMail.filter.extraField4key = 0;
      this.selectedMail.filter.extraField4value = "";
      this.selectedMail.filter.isVisitor = false;
      this.selectedMail.filter.isActive = true;
      this.accessGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.sortableDepartmentList.forEach(function (a) {
        a.check = false;
      });
      this.foodGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.periodWorkGroupList.forEach(function (a) {
        a.isCheck = false;
      });
      this.stateList.forEach(function (a) {
        a.isCheck = false;
      });
      this.statuList.forEach(function (a) {
        a.isCheck = false;
      });
    },
    getCheckDepAll: function getCheckDepAll(value) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this12.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this12.isCheckDep = !_this12.isCheckDep;

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, _this12);
      }))();
    },
    getCheckDepartmentAll: function getCheckDepartmentAll(value) {
      var _this13 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _this13.sortableDepartmentList.forEach(function (dep) {
                  dep.check = value;
                });
                _this13.isCheckDeps = !_this13.isCheckDeps;

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, _this13);
      }))();
    },
    changeFilterDep: function changeFilterDep(dep, checkValue) {
      var _this14 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                dep.check = checkValue;
                _this14.sortableDepartmentList.forEach(function (doc) {
                  if (doc.mainDepartmentId == dep.id) {
                    doc.check = checkValue;
                    _this14.changeFilterDep(doc, checkValue);
                  }
                });

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, _this14);
      }))();
    }
  }, _defineProperty(_methods, "getCheckDepartmentList", function getCheckDepartmentList() {
    var _this15 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      var aList;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              aList = _this15.sortableDepartmentList;

              _this15.selectedMail.filter.departments = [];
              _context12.next = 4;
              return aList.forEach(function (doc) {
                if (doc.check == true) {
                  _this15.selectedMail.filter.departments.push(doc.id);
                }
              });

            case 4:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12, _this15);
    }))();
  }), _defineProperty(_methods, "getDepartments", function getDepartments() {
    var _this16 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
      var departments, response;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;

              _this16.isLoadingDetail = true;
              departments = [];
              _context13.next = 5;
              return _this16.$axios.get("/Department").then(function (response) {
                response.data.forEach(function (doc) {
                  departments.push({
                    id: doc.id,
                    name: doc.name,
                    mainDepartmentId: doc.mainDepartmentId,
                    isActive: doc.isActive,
                    locationTree: doc.locationTree,
                    check: false
                  });
                  departments.sort(function (a, b) {
                    if (a.locationTree < b.locationTree) return -1;
                    if (a.locationTree > b.locationTree) return 0;
                  });
                });
                _this16.departments = departments;
                _this16.sortableTrees();
                _this16.isLoadingDetail = false;
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this16.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this16.$ml.get("errors.connectionError"));
                    _this16.isLoadingDetail = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this16.isLoadingDetail = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context13.sent;
              _context13.next = 13;
              break;

            case 8:
              _context13.prev = 8;
              _context13.t0 = _context13["catch"](0);

              console.error(_context13.t0);
              alertify.error(_context13.t0.message);
              _this16.isLoadingDetail = false;

            case 13:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13, _this16, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "sortableTrees", function sortableTrees() {
    var _this17 = this;

    this.sortableDepTrees = [];
    this.departments.forEach(function (dep) {
      if (dep.mainDepartmentId == null) {
        _this17.sortableDepTrees.push(dep);
        _this17.subDepImport(dep);
      }
    });
  }), _defineProperty(_methods, "subDepImport", function subDepImport(dep) {
    var _this18 = this;

    var subDep = this.departments.filter(function (doc) {
      return doc.mainDepartmentId == dep.id;
    });
    if (subDep.length > 0) {
      var ekle = "";
      var ek = subDep[0].locationTree.split("/");
      for (var index = 0; index < ek.length - 3; index++) {
        ekle = "--/" + ekle;
      }
      subDep.forEach(function (doc2) {
        _this18.sortableDepTrees.push({
          id: doc2.id,
          name: ekle + " " + doc2.name,
          mainDepartmentId: doc2.mainDepartmentId,
          isActive: doc2.isActive,
          locationTree: doc2.locationTree,
          userId: doc2.userId,
          check: doc2.check
        });
        _this18.subDepImport(doc2);
      });
    }
  }), _defineProperty(_methods, "getFoodGroups", function getFoodGroups() {
    var _this19 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
      var foodGroups, response;
      return regeneratorRuntime.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              foodGroups = [];
              _context14.next = 4;
              return _this19.$axios.get("/FoodGroups").then(function (response) {
                response.data.forEach(function (doc) {
                  foodGroups.push({
                    id: doc.id,
                    name: doc.name,
                    type: doc.type,
                    singleFoodEachMeal: doc.singleFoodEachMeal,
                    meals: doc.meals,
                    isCheck: false
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this19.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this19.$ml.get("errors.connectionError"));
                    _this19.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this19.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context14.sent;

              _this19.foodGroups = foodGroups;
              _context14.next = 12;
              break;

            case 8:
              _context14.prev = 8;
              _context14.t0 = _context14["catch"](0);

              console.error(_context14.t0);
              alertify.error("Servis Hatası :" + _context14.t0.message);

            case 12:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14, _this19, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getExtraFields", function getExtraFields() {
    var _this20 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
      var extrafields, response;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              extrafields = [];
              _context15.next = 4;
              return _this20.$axios.get("/ExtraField").then(function (response) {
                response.data.forEach(function (doc) {
                  extrafields.push({
                    id: doc.id,
                    name: doc.definition
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this20.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this20.$ml.get("errors.connectionError"));
                    _this20.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this20.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context15.sent;

              _this20.extrafields = extrafields;
              _context15.next = 12;
              break;

            case 8:
              _context15.prev = 8;
              _context15.t0 = _context15["catch"](0);

              console.error(_context15.t0);
              alertify.error("Servis Hatası :" + _context15.t0.message);

            case 12:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15, _this20, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getStatus", function getStatus() {
    var _this21 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
      var status, response;
      return regeneratorRuntime.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              _context16.prev = 0;
              status = [];
              _context16.next = 4;
              return _this21.$axios.get("/Employees/getStatus").then(function (response) {
                response.data.forEach(function (doc) {
                  status.push({
                    id: doc.id,
                    name: doc.name,
                    isCheck: false
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this21.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this21.$ml.get("errors.connectionError"));
                    _this21.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this21.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context16.sent;

              _this21.status = status;
              _context16.next = 12;
              break;

            case 8:
              _context16.prev = 8;
              _context16.t0 = _context16["catch"](0);

              console.error(_context16.t0);
              alertify.error("Servis Hatası :" + _context16.t0.message);

            case 12:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16, _this21, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getStates", function getStates() {
    var _this22 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
      var states, response;
      return regeneratorRuntime.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              _context17.prev = 0;
              states = [];
              _context17.next = 4;
              return _this22.$axios.get("/Employees/getStates").then(function (response) {
                response.data.forEach(function (doc) {
                  states.push({
                    id: doc.id,
                    name: doc.name,
                    status: doc.status,
                    isCheck: false
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this22.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this22.$ml.get("errors.connectionError"));
                    _this22.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this22.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context17.sent;

              _this22.states = states;
              _context17.next = 12;
              break;

            case 8:
              _context17.prev = 8;
              _context17.t0 = _context17["catch"](0);

              console.error(_context17.t0);
              alertify.error("Servis Hatası :" + _context17.t0.message);

            case 12:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17, _this22, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getAccessGroups", function getAccessGroups() {
    var _this23 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
      var accessGroups, response;
      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              accessGroups = [];
              _context18.next = 4;
              return _this23.$axios.get("/AccessGroups").then(function (response) {
                response.data.forEach(function (doc) {
                  accessGroups.push({
                    id: doc.id,
                    name: doc.name,
                    isNewReaderAdd: doc.isNewReaderAdd,
                    selectedReaders: doc.postReaders,
                    isCheck: false
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this23.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this23.$ml.get("errors.connectionError"));
                    _this23.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this23.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context18.sent;

              _this23.accessGroups = accessGroups;
              _context18.next = 12;
              break;

            case 8:
              _context18.prev = 8;
              _context18.t0 = _context18["catch"](0);

              console.error(_context18.t0);
              alertify.error("Servis Hatası :" + _context18.t0.message);

            case 12:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18, _this23, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getWorkGroups", function getWorkGroups() {
    var _this24 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
      var workGroups, response;
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.prev = 0;
              workGroups = [];
              _context19.next = 4;
              return _this24.$axios.get("/WorkGroups").then(function (response) {
                response.data.forEach(function (doc) {
                  workGroups.push({
                    id: doc.id,
                    name: doc.name,
                    shortCode: doc.shortCode,
                    isPeriod: doc.isPeriod,
                    isCheck: false
                  });
                  workGroups.sort(function (a, b) {
                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 0;
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this24.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this24.$ml.get("errors.connectionError"));
                    _this24.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this24.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context19.sent;

              _this24.workGroups = workGroups;
              _context19.next = 12;
              break;

            case 8:
              _context19.prev = 8;
              _context19.t0 = _context19["catch"](0);

              console.error(_context19.t0);
              alertify.error("Servis Hatası :" + _context19.t0.message);

            case 12:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19, _this24, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "getTitles", function getTitles() {
    var _this25 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var titles, response;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              titles = [];
              _context20.next = 4;
              return _this25.$axios.get("/Employees/getTitles").then(function (response) {
                response.data.forEach(function (doc) {
                  titles.push({
                    name: doc
                  });
                });
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this25.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this25.$ml.get("errors.connectionError"));
                    _this25.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this25.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context20.sent;

              _this25.titles = titles;
              _context20.next = 12;
              break;

            case 8:
              _context20.prev = 8;
              _context20.t0 = _context20["catch"](0);

              console.error(_context20.t0);
              alertify.error("Servis Hatası :" + _context20.t0.message);

            case 12:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20, _this25, [[0, 8]]);
    }))();
  }), _defineProperty(_methods, "onResize", function onResize() {
    this.windowHeight = window.innerHeight;
  }), _defineProperty(_methods, "toDateFormat", function toDateFormat(str, format) {
    if (str.length > 9) {
      str = new Date(str);
    } else {
      str = new Date("1900-01-01 " + str.replace("Z", ""));
    }
    if (format == "gg.aa.yyyy ss:dd") {
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    } else if (format == "gg.aa.yyyy") {
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      return yil + "-" + ay + "-" + gun;
    } else if (format == "ss:dd:ss") {
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      var saniye = str.getSeconds() < 10 ? "0" + str.getSeconds() : str.getSeconds();
      return saat + ":" + dakika + ":" + saniye;
    } else if (format == "ss:dd") {
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return saat + ":" + dakika;
    }
  }), _defineProperty(_methods, "getEmpNameFromId", function getEmpNameFromId(id) {
    var aList = this.allEmployees;
    var emp = aList.filter(function (emp) {
      return emp.id == id;
    });
    if (emp != "" && emp != null) {
      var title = "";
      if (emp[0].title != "") {
        title = " - " + emp[0].title;
      }
      return emp[0].name + title;
    } else {
      return null;
    }
  }), _defineProperty(_methods, "getConfig", function getConfig() {
    var _this26 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
      var response;
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _context21.next = 3;
              return _this26.$axios.get("/SmsConfig").then(function (response) {
                _this26.apiLink = response.data.apiLink;
                _this26.baslik = response.data.baslik;
                _this26.apiKey = response.data.apiKey;
                _this26.secretKey = response.data.secretKey;
                _this26.kullaniciAdi = response.data.kullaniciAdi;
                _this26.parola = response.data.parola;
                _this26.aktifMi = response.data.aktifMi;
                _this26.icerik1 = response.data.icerik1;
                _this26.icerik2 = response.data.icerik2;
                _this26.icerik3 = response.data.icerik3;
                _this26.icerik4 = response.data.icerik4;
                _this26.gun1AktifMi = response.data.gun1AktifMi;
                _this26.gun1SonGiris = response.data.gun1SonGiris ? _this26.toDateFormat(response.data.gun1SonGiris, "ss:dd") : "";
                _this26.gun2AktifMi = response.data.gun2AktifMi;
                _this26.gun2SonGiris = response.data.gun2SonGiris ? _this26.toDateFormat(response.data.gun2SonGiris, "ss:dd") : "";
                _this26.gun3AktifMi = response.data.gun3AktifMi;
                _this26.gun3SonGiris = response.data.gun3SonGiris ? _this26.toDateFormat(response.data.gun3SonGiris, "ss:dd") : "";
                _this26.gun4AktifMi = response.data.gun4AktifMi;
                _this26.gun4SonGiris = response.data.gun4SonGiris ? _this26.toDateFormat(response.data.gun4SonGiris, "ss:dd") : "";
                _this26.gun5AktifMi = response.data.gun5AktifMi;
                _this26.gun5SonGiris = response.data.gun5SonGiris ? _this26.toDateFormat(response.data.gun5SonGiris, "ss:dd") : "";
                _this26.gun6AktifMi = response.data.gun6AktifMi;
                _this26.gun6SonGiris = response.data.gun6SonGiris ? _this26.toDateFormat(response.data.gun6SonGiris, "ss:dd") : "";
                _this26.gun7AktifMi = response.data.gun7AktifMi;
                _this26.gun7SonGiris = response.data.gun7SonGiris ? _this26.toDateFormat(response.data.gun7SonGiris, "ss:dd") : "";
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this26.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this26.$ml.get("errors.connectionError"));
                    _this26.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this26.isLoading = false;
                    return;
                  }
                }
              });

            case 3:
              response = _context21.sent;
              _context21.next = 11;
              break;

            case 6:
              _context21.prev = 6;
              _context21.t0 = _context21["catch"](0);

              console.error(_context21.t0);
              alertify.error(_context21.t0.message);
              _this26.isLoading = false;

            case 11:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21, _this26, [[0, 6]]);
    }))();
  }), _defineProperty(_methods, "UpdateConfig", function UpdateConfig() {
    var _this27 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
      var response;
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return _this27.$axios.post("/SmsConfig", {
                apiLink: _this27.apiLink,
                baslik: _this27.baslik,
                apiKey: _this27.apiKey,
                secretKey: _this27.secretKey,
                kullaniciAdi: _this27.kullaniciAdi,
                parola: _this27.parola,
                aktifMi: _this27.aktifMi,
                icerik1: _this27.icerik1,
                icerik2: _this27.icerik2,
                icerik3: _this27.icerik3,
                icerik4: _this27.icerik4,
                gun1AktifMi: _this27.gun1AktifMi,
                gun1SonGiris: _this27.gun1SonGiris,
                gun2AktifMi: _this27.gun2AktifMi,
                gun2SonGiris: _this27.gun2SonGiris,
                gun3AktifMi: _this27.gun3AktifMi,
                gun3SonGiris: _this27.gun3SonGiris,
                gun4AktifMi: _this27.gun4AktifMi,
                gun4SonGiris: _this27.gun4SonGiris,
                gun5AktifMi: _this27.gun5AktifMi,
                gun5SonGiris: _this27.gun5SonGiris,
                gun6AktifMi: _this27.gun6AktifMi,
                gun6SonGiris: _this27.gun6SonGiris,
                gun7AktifMi: _this27.gun7AktifMi,
                gun7SonGiris: _this27.gun7SonGiris
              }).then(function (response) {
                if (response.status == 200) {
                  alertify.success(_this27.$ml.get("alerts.savedSuccessfully"));
                }
              }).catch(function (doc) {
                if (doc.status == 401) {
                  _this27.$store.dispatch("logout");
                } else if (doc.message == "Network Error") {
                  alertify.error(_this27.$ml.get("errors.connectionError"));
                } else {
                  alertify.error(doc.message);
                }
              });

            case 3:
              response = _context22.sent;
              _context22.next = 11;
              break;

            case 6:
              _context22.prev = 6;
              _context22.t0 = _context22["catch"](0);

              console.error(_context22.t0);
              alertify.error(_context22.t0.message);
              _this27.isLoading = false;

            case 11:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22, _this27, [[0, 6]]);
    }))();
  }), _defineProperty(_methods, "validateEmail", function validateEmail(email) {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      return false;
    }
  }), _defineProperty(_methods, "addEmail", function addEmail() {
    if (this.selectedEmail != "" && this.validateEmail(this.selectedEmail)) {
      this.selectedMail.emails.push(this.selectedEmail);
      this.selectedEmail = "";
    } else {
      alertify.warning(this.$ml.get("alerts.wrongEmail"));
    }
  }), _defineProperty(_methods, "removeEmail", function removeEmail(index) {
    this.emailList.splice(index, 1);
  }), _defineProperty(_methods, "deleteMail", function deleteMail() {
    var _this28 = this;

    try {
      var id = this.selectedMail.id;
      if (id != null && id != 0) {
        var response = this.$axios.delete("/Mail?id=" + id).then(function (response) {
          _this28.getMails();
          _this28.newMail();
          alertify.success(_this28.$ml.get("alerts.deletedSuccessfully"));
        }).catch(function (doc) {
          if (doc.status == 401) {
            _this28.$store.dispatch("logout");
          } else if (doc.message == "Network Error") {
            alertify.error(_this28.$ml.get("errors.connectionError"));
          } else {
            alertify.error(doc.message);
          }
        });
      }
    } catch (error) {
      alertify.error("Hata Oluştu : " + error);
    }
  }), _defineProperty(_methods, "saveMail", function saveMail() {
    var _this29 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
      var response, _response;

      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              if (!(_this29.selectedMail.name == "" || _this29.selectedMail.header == "" || _this29.selectedMail.content == "" || _this29.selectedMail.emails == [] || _this29.selectedMail.days == [] || _this29.selectedMail.time == null || _this29.checkedReportList.length == 0)) {
                _context23.next = 3;
                break;
              }

              alertify.warning(_this29.$ml.get("alerts.pleaseCheckEmptyFields"));
              return _context23.abrupt("return");

            case 3:
              _this29.selectedMail.reports = [];
              _this29.checkedReportList.forEach(function (doc) {
                _this29.selectedMail.reports.push(doc.id);
              });
              _this29.selectedMail.days = [];
              _this29.dayList.forEach(function (doc) {
                if (doc.check) {
                  _this29.selectedMail.days.push(doc.value);
                }
              });

              if (!(_this29.selectedMail.id == 0)) {
                _context23.next = 13;
                break;
              }

              _context23.next = 10;
              return _this29.$axios.post("/Mail", _this29.selectedMail).then(function (response) {
                if (response.status == 200) {
                  alertify.success(_this29.$ml.get("alerts.savedSuccessfully"));
                  _this29.newMail();
                  _this29.getMails();
                }
              }).catch(function (doc) {
                if (doc.status == 401) {
                  _this29.$store.dispatch("logout");
                } else if (doc.message == "Network Error") {
                  alertify.error(_this29.$ml.get("errors.connectionError"));
                } else {
                  alertify.error(doc.message);
                }
              });

            case 10:
              response = _context23.sent;
              _context23.next = 16;
              break;

            case 13:
              _context23.next = 15;
              return _this29.$axios.put("/Mail/", _this29.selectedMail).then(function (response) {
                if (response.status == 200) {
                  alertify.success(_this29.$ml.get("alerts.updatedSuccessfully"));
                  _this29.newMail();
                  _this29.getMails();
                }
              }).catch(function (doc) {
                if (doc.status == 401) {
                  _this29.$store.dispatch("logout");
                } else if (doc.message == "Network Error") {
                  alertify.error(_this29.$ml.get("errors.connectionError"));
                } else {
                  alertify.error(doc.message);
                }
              });

            case 15:
              _response = _context23.sent;

            case 16:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23, _this29);
    }))();
  }), _defineProperty(_methods, "newMail", function newMail() {
    this.selectedReport = 0;
    this.selectedMail.id = 0;
    this.selectedMail.name = "";
    this.selectedMail.header = "";
    this.selectedMail.content = "";
    this.selectedMail.reports = [];
    this.selectedMail.emails = [];
    this.selectedMail.days = [];
    this.selectedMail.time = null;
    this.selectedMail.isActive = true;
    this.selectedMail.reportType = 0;
    this.selectedMail.filterType = 0;
    this.selectedMail.filter.nameOrCardNumber = "";
    this.selectedMail.filter.sicilOrTerminalNo = null;
    this.selectedMail.filter.departments = [];
    this.selectedMail.filter.isActive = true;
    this.selectedMail.filter.documentNoOrMail = "";
    this.selectedMail.filter.accessGroup = [];
    this.selectedMail.filter.identityNo = "";
    this.selectedMail.filter.foodGroup = [];
    this.selectedMail.filter.workGroupId = [];
    this.selectedMail.filter.title = "";
    this.selectedMail.filter.stateId = [];
    this.selectedMail.filter.statuId = [];
    this.selectedMail.filter.extraField1key = 0;
    this.selectedMail.filter.extraField1value = "";
    this.selectedMail.filter.extraField2key = 0;
    this.selectedMail.filter.extraField2value = "";
    this.selectedMail.filter.extraField3key = 0;
    this.selectedMail.filter.extraField3value = "";
    this.selectedMail.filter.extraField4key = 0;
    this.selectedMail.filter.extraField4value = "";
    this.selectedMail.filter.isVisitor = false;
    this.selectedMail.filter.plateNo = "";
    this.selectedMail.authorizedUsers = [];
    this.dayList.forEach(function (doc) {
      doc.check = false;
    });
    this.reports.forEach(function (doc) {
      doc.checked = false;
    });
    this.filtersClear();
  }), _defineProperty(_methods, "getFilter", function getFilter(filter) {
    var _this30 = this;

    this.sortableDepartmentList.forEach(function (doc) {
      _this30.selectedMail.filter.departments.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.check = true;
        }
      });
    });
    this.periodWorkGroupList.forEach(function (doc) {
      _this30.selectedMail.filter.workGroupId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.accessGroupList.forEach(function (doc) {
      _this30.selectedMail.filter.accessGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.foodGroupList.forEach(function (doc) {
      _this30.selectedMail.filter.foodGroup.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.stateList.forEach(function (doc) {
      _this30.selectedMail.filter.stateId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
    this.statuList.forEach(function (doc) {
      _this30.selectedMail.filter.statuId.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.isCheck = true;
        }
      });
    });
  }), _defineProperty(_methods, "getMail", function getMail(mail) {
    var _this31 = this;

    this.selectedMail.id = mail.id;
    this.selectedMail.name = mail.name;
    this.selectedMail.header = mail.header;
    this.selectedMail.content = mail.content;
    this.selectedMail.reports = mail.reports;
    this.selectedMail.emails = mail.emails;
    this.selectedMail.days = mail.days;
    this.selectedMail.time = mail.time;
    this.selectedMail.isActive = mail.isActive;
    this.selectedMail.reportType = mail.reportType;
    this.selectedMail.filterType = mail.filterType;
    this.selectedMail.filter.nameOrCardNumber = mail.filter.nameOrCardNumber;
    this.selectedMail.filter.sicilOrTerminalNo = mail.filter.sicilOrTerminalNo;
    this.selectedMail.filter.departments = mail.filter.departments;
    this.selectedMail.filter.isActive = mail.filter.isActive;
    this.selectedMail.filter.documentNoOrMail = mail.filter.documentNoOrMail;
    this.selectedMail.filter.accessGroup = mail.filter.accessGroup;
    this.selectedMail.filter.identityNo = mail.filter.identityNo;
    this.selectedMail.filter.foodGroup = mail.filter.foodGroup;
    this.selectedMail.filter.workGroupId = mail.filter.workGroupId;
    this.selectedMail.filter.title = mail.filter.title;
    this.selectedMail.filter.stateId = mail.filter.stateId;
    this.selectedMail.filter.statuId = mail.filter.statuId;
    this.selectedMail.filter.extraField1key = mail.filter.extraField1key;
    this.selectedMail.filter.extraField1value = mail.filter.extraField1value;
    this.selectedMail.filter.extraField2key = mail.filter.extraField2key;
    this.selectedMail.filter.extraField2value = mail.filter.extraField2value;
    this.selectedMail.filter.extraField3key = mail.filter.extraField3key;
    this.selectedMail.filter.extraField3value = mail.filter.extraField3value;
    this.selectedMail.filter.extraField4key = mail.filter.extraField4key;
    this.selectedMail.filter.extraField4value = mail.filter.extraField4value;
    this.selectedMail.filter.isVisitor = mail.filter.isVisitor;
    this.selectedMail.filter.plateNo = mail.filter.plateNo;
    this.selectedMail.authorizedUsers = mail.authorizedUsers;
    this.getFilter(mail.filter);
    this.days.forEach(function (doc) {
      doc.check = false;
    });
    this.days.forEach(function (doc) {
      _this31.selectedMail.days.forEach(function (doc2) {
        if (doc.value == doc2) {
          doc.check = true;
        }
      });
    });
    this.reports.forEach(function (doc) {
      doc.checked = false;
    });
    this.reports.forEach(function (doc) {
      _this31.selectedMail.reports.forEach(function (doc2) {
        if (doc.id == doc2) {
          doc.checked = true;
        }
      });
    });
  }), _defineProperty(_methods, "getMails", function getMails() {
    var _this32 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
      var response;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;

              _this32.isLoading = true;
              _this32.mails = [];
              _context24.next = 5;
              return _this32.$axios.get("/Mail").then(function (response) {
                _this32.mails = response.data;
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this32.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this32.$ml.get("errors.connectionError"));
                    _this32.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this32.isLoading = false;
                    return;
                  }
                }
              });

            case 5:
              response = _context24.sent;

              _this32.isLoading = false;
              _context24.next = 14;
              break;

            case 9:
              _context24.prev = 9;
              _context24.t0 = _context24["catch"](0);

              console.error(_context24.t0);
              alertify.error(_context24.t0.message);
              _this32.isLoading = false;

            case 14:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24, _this32, [[0, 9]]);
    }))();
  }), _defineProperty(_methods, "getAllEmployees", function getAllEmployees() {
    var _this33 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25() {
      var allEmployees, response;
      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _context25.prev = 0;
              allEmployees = [];
              _context25.next = 4;
              return _this33.$axios.get("/Employees").then(function (response) {
                if (response.status == 200) {
                  response.data.forEach(function (doc) {
                    if (doc.isVisitor == false) {
                      allEmployees.push({
                        id: doc.id,
                        name: doc.name,
                        title: doc.title,
                        isVisitor: doc.isVisitor,
                        isCheck: false
                      });
                    }
                  });
                }
              }).catch(function (error) {
                if (error.response) {
                  if (error.response.status == 401) {
                    _this33.$store.dispatch("logout");
                  }
                } else {
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(_this33.$ml.get("errors.connectionError"));
                    _this33.isLoading = false;
                    return;
                  } else {
                    console.error(error);
                    alertify.error(error.message);
                    _this33.isLoading = false;
                    return;
                  }
                }
              });

            case 4:
              response = _context25.sent;

              _this33.allEmployees = allEmployees;
              _context25.next = 12;
              break;

            case 8:
              _context25.prev = 8;
              _context25.t0 = _context25["catch"](0);

              console.error(_context25.t0);
              alertify.error("Servis Hatası :" + _context25.t0.message);

            case 12:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25, _this33, [[0, 8]]);
    }))();
  }), _methods),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this34 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26() {
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return _this34.getConfig();

            case 2:
              _context26.next = 4;
              return _this34.getMails();

            case 4:
              _context26.next = 6;
              return _this34.getDepartments();

            case 6:
              _context26.next = 8;
              return _this34.getFoodGroups();

            case 8:
              _context26.next = 10;
              return _this34.getExtraFields();

            case 10:
              _context26.next = 12;
              return _this34.getAccessGroups();

            case 12:
              _context26.next = 14;
              return _this34.getStatus();

            case 14:
              _context26.next = 16;
              return _this34.getStates();

            case 16:
              _context26.next = 18;
              return _this34.getWorkGroups();

            case 18:
              _context26.next = 20;
              return _this34.getTitles();

            case 20:
              _context26.next = 22;
              return _this34.getAllEmployees();

            case 22:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26, _this34);
    }))();
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      selectedUserId: 0,
      startDate: null,
      endDate: null,
      users: [],
      logs: []
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    userList: function userList() {
      return this.users;
    },
    logList: function logList() {
      return this.logs;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    changeUser: function changeUser(event) {
      this.selectedUserId = event.target.value;
    },
    send: function send() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var logs, selectedUser, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.startDate == null | _this2.endDate == null)) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this2.$ml.get('alerts.pleaseCheckEnteredValue'));
                return _context.abrupt("return");

              case 3:
                _context.prev = 3;

                _this2.isLoading = true;
                logs = [];
                selectedUser = _this2.selectedUserId;
                startDate = _this2.startDate;
                endDate = _this2.endDate;
                _context.next = 11;
                return _this2.$axios.post("/UserLogs", {
                  userId: selectedUser,
                  startDate: startDate,
                  endDate: endDate
                }).then(function (response) {
                  response.data.forEach(function (doc) {
                    logs.push({
                      id: doc.id,
                      userName: doc.userName,
                      date: doc.date,
                      description: doc.description
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 11:
                response = _context.sent;

                _this2.logs = logs;
                _this2.isLoading = false;
                _context.next = 21;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](3);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this2.isLoading = false;

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[3, 16]]);
      }))();
    },
    getUsers: function getUsers() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var users, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.getDefaultDate();
                users = [];
                _context2.next = 5;
                return _this3.$axios.get("/UserLogs/GetUsers").then(function (response) {
                  response.data.forEach(function (doc) {
                    users.push({
                      id: doc.id,
                      name: doc.name
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this3.users = users;
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 9]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this4.authControl == 1) {
                  alertify.warning(_this4.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this5 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.getAuthControl();

            case 2:
              _context4.next = 4;
              return _this5.getUsers();

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this5);
    }))();
  }
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      selectedPayroll: {
        id: null,
        shortCode: "",
        name: "",
        type: 0,
        otherType: 0,
        equalType: 0,
        monthlyPayrollId: 0,
        maxLimit: 450,
        multiplier: 100,
        isApproved: false,
        firstTolerance1: 0,
        lastTolerance1: 0,
        totalTolerance1: 0,
        firstTolerance2: 0,
        lastTolerance2: 0,
        totalTolerance2: 0,
        firstTolerance3: 0,
        lastTolerance3: 0,
        totalTolerance3: 0
      },
      payrolls: [],
      monthlyPayrolls: [],
      isNewPayroll: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    payrollList: function payrollList() {
      return this.payrolls;
    },
    monthlyPayrollList: function monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    changePayrollType: function changePayrollType(event) {
      this.selectedPayroll.type = event.target.value;
    },
    changeOtherPayrollType: function changeOtherPayrollType(event) {
      this.selectedPayroll.otherType = event.target.value;
    },
    changeEqualPayrollType: function changeEqualPayrollType(event) {
      this.selectedPayroll.equalType = event.target.value;
    },
    changeMonthlyPayroll: function changeMonthlyPayroll(event) {
      this.selectedPayroll.monthlyPayrollId = event.target.value;
    },
    newPayroll: function newPayroll() {
      this.isLoadingDetail = true;
      this.isNewPayroll = true;
      this.selectedPayroll.id = null;
      this.selectedPayroll.shortCode = "";
      this.selectedPayroll.name = "";
      this.selectedPayroll.type = 0;
      this.selectedPayroll.otherType = 0;
      this.selectedPayroll.equalType = 0;
      this.selectedPayroll.monthlyPayrollId = 0;
      this.selectedPayroll.maxLimit = 450;
      this.selectedPayroll.multiplier = 100;
      this.selectedPayroll.isApproved = false;
      this.selectedPayroll.firstTolerance1 = 0;
      this.selectedPayroll.lastTolerance1 = 0;
      this.selectedPayroll.totalTolerance1 = 0;
      this.selectedPayroll.firstTolerance2 = 0;
      this.selectedPayroll.lastTolerance2 = 0;
      this.selectedPayroll.totalTolerance2 = 0;
      this.selectedPayroll.firstTolerance3 = 0;
      this.selectedPayroll.lastTolerance3 = 0;
      this.selectedPayroll.totalTolerance3 = 0;
      this.isLoadingDetail = false;
    },
    savePayroll: function savePayroll() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var selectedPayroll2, response, id, _selectedPayroll, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.selectedPayroll.name == "" || _this2.selectedPayroll.shortCode == "")) {
                  _context.next = 3;
                  break;
                }

                alertify.warning(_this2.$ml.get('alerts.pleaseEnterShortCodeAndName'));
                return _context.abrupt("return");

              case 3:
                _this2.isLoadingDetail = true;

                if (!_this2.isNewPayroll) {
                  _context.next = 25;
                  break;
                }

                _context.prev = 5;
                selectedPayroll2 = _this2.selectedPayroll;
                _context.next = 9;
                return _this2.$axios.post("/Payroll", {
                  shortCode: selectedPayroll2.shortCode,
                  name: selectedPayroll2.name,
                  type: selectedPayroll2.type,
                  otherPayrollTypes: parseInt(selectedPayroll2.otherType),
                  equalPayroll: parseInt(selectedPayroll2.equalType),
                  monthlyPayroll: parseInt(selectedPayroll2.monthlyPayrollId),
                  isApproved: selectedPayroll2.isApproved,
                  maxLimit: selectedPayroll2.maxLimit,
                  multiplier: selectedPayroll2.multiplier,
                  firstTolerance1: selectedPayroll2.firstTolerance1,
                  lastTolerance1: selectedPayroll2.lastTolerance1,
                  totalTolerance1: selectedPayroll2.totalTolerance1,
                  firstTolerance2: selectedPayroll2.firstTolerance2,
                  lastTolerance2: selectedPayroll2.lastTolerance2,
                  totalTolerance2: selectedPayroll2.totalTolerance2,
                  firstTolerance3: selectedPayroll2.firstTolerance3,
                  lastTolerance3: selectedPayroll2.lastTolerance3,
                  totalTolerance3: selectedPayroll2.totalTolerance3
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this2.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this2.getPayrolls();
                _this2.getPayroll(id);
                _this2.isNewDevice = false;
                _this2.isLoadingDetail = false;
                _context.next = 23;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](5);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this2.isLoadingDetail = false;

              case 23:
                _context.next = 40;
                break;

              case 25:
                _context.prev = 25;
                _selectedPayroll = _this2.selectedPayroll;
                _context.next = 29;
                return _this2.$axios.post("/Payroll/" + _selectedPayroll.id, {
                  shortCode: _selectedPayroll.shortCode,
                  name: _selectedPayroll.name,
                  type: _selectedPayroll.type,
                  otherPayrollTypes: parseInt(_selectedPayroll.otherType),
                  equalPayroll: parseInt(_selectedPayroll.equalType),
                  monthlyPayroll: parseInt(_selectedPayroll.monthlyPayrollId),
                  isApproved: _selectedPayroll.isApproved,
                  maxLimit: _selectedPayroll.maxLimit,
                  multiplier: _selectedPayroll.multiplier,
                  firstTolerance1: _selectedPayroll.firstTolerance1,
                  lastTolerance1: _selectedPayroll.lastTolerance1,
                  totalTolerance1: _selectedPayroll.totalTolerance1,
                  firstTolerance2: _selectedPayroll.firstTolerance2,
                  lastTolerance2: _selectedPayroll.lastTolerance2,
                  totalTolerance2: _selectedPayroll.totalTolerance2,
                  firstTolerance3: _selectedPayroll.firstTolerance3,
                  lastTolerance3: _selectedPayroll.lastTolerance3,
                  totalTolerance3: _selectedPayroll.totalTolerance3
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 29:
                _response = _context.sent;

                if (_response.status == 200) {
                  alertify.success(_this2.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this2.getPayrolls();
                _this2.isLoadingDetail = false;
                _context.next = 40;
                break;

              case 35:
                _context.prev = 35;
                _context.t1 = _context["catch"](25);

                console.error(_context.t1);
                alertify.error(_context.t1.message);
                _this2.isLoadingDetail = false;

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[5, 18], [25, 35]]);
      }))();
    },
    deletePayroll: function deletePayroll() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.isLoadingDetail = true;
                id = _this3.selectedPayroll.id;
                _context2.next = 5;
                return _this3.$axios.delete("/Payroll/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context2.sent;

                _this3.getPayrolls();
                _this3.newPayroll();
                alertify.success(_this3.$ml.get('alerts.deletedSuccessfully'));
                _this3.isLoadingDetail = false;
                _context2.next = 17;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this3.isLoadingDetail = false;

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 12]]);
      }))();
    },
    getPayroll: function getPayroll(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.isLoadingDetail = true;
                _context3.next = 4;
                return _this4.$axios.get("/Payroll/" + id).then(function (response) {
                  _this4.isNewPayroll = false;
                  _this4.selectedPayroll.id = id;
                  _this4.selectedPayroll.shortCode = response.data.shortCode;
                  _this4.selectedPayroll.name = response.data.name;
                  _this4.selectedPayroll.type = response.data.type;
                  _this4.selectedPayroll.otherType = response.data.otherPayrollTypes;
                  _this4.selectedPayroll.equalType = response.data.equalPayroll;
                  _this4.selectedPayroll.monthlyPayrollId = response.data.monthlyPayroll;
                  _this4.selectedPayroll.maxLimit = response.data.maxLimit;
                  _this4.selectedPayroll.multiplier = response.data.multiplier;
                  _this4.selectedPayroll.isApproved = response.data.isApproved;
                  _this4.selectedPayroll.firstTolerance1 = response.data.firstTolerance1;
                  _this4.selectedPayroll.lastTolerance1 = response.data.lastTolerance1;
                  _this4.selectedPayroll.totalTolerance1 = response.data.totalTolerance1;
                  _this4.selectedPayroll.firstTolerance2 = response.data.firstTolerance2;
                  _this4.selectedPayroll.lastTolerance2 = response.data.lastTolerance2;
                  _this4.selectedPayroll.totalTolerance2 = response.data.totalTolerance2;
                  _this4.selectedPayroll.firstTolerance3 = response.data.firstTolerance3;
                  _this4.selectedPayroll.lastTolerance3 = response.data.lastTolerance3;
                  _this4.selectedPayroll.totalTolerance3 = response.data.totalTolerance3;
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this4.isLoadingDetail = false;
                _context3.next = 13;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this4.isLoadingDetail = false;

              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 8]]);
      }))();
    },
    getPayrolls: function getPayrolls() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var payrolls, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoading = true;
                payrolls = [];
                _context4.next = 5;
                return _this5.$axios.get("/Payroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    payrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      type: doc.type,
                      otherType: doc.otherPayrollTypes,
                      equalType: doc.equalPayroll,
                      maxLimit: doc.maxLimit,
                      monthlyPayrollId: doc.monthlyPayroll,
                      isApproved: doc.isApproved,
                      multiplier: doc.multiplier,
                      firstTolerance1: doc.firstTolerance1,
                      lastTolerance1: doc.lastTolerance1,
                      totalTolerance1: doc.totalTolerance1,
                      firstTolerance2: doc.firstTolerance2,
                      lastTolerance2: doc.lastTolerance2,
                      totalTolerance2: doc.totalTolerance2,
                      firstTolerance3: doc.firstTolerance3,
                      lastTolerance3: doc.lastTolerance3,
                      totalTolerance3: doc.totalTolerance3
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this5.payrolls = payrolls;
                _this5.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    },
    getMonthlyPayrolls: function getMonthlyPayrolls() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var monthlyPayrolls, response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                _this6.isLoadingDetail = true;
                monthlyPayrolls = [];
                _context5.next = 5;
                return _this6.$axios.get("/MonthlyPayroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    monthlyPayrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      ssk: doc.ssk,
                      total: doc.total,
                      work: doc.work
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this6.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this6.$ml.get('errors.connectionError'));
                      _this6.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this6.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context5.sent;

                _this6.monthlyPayrolls = monthlyPayrolls;
                _this6.isLoadingDetail = false;
                _context5.next = 15;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);

                console.error(_context5.t0);
                alertify.error(_context5.t0.message);
                _this6.isLoadingDetail = false;

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (_this7.authControl == 1) {
                  alertify.warning(_this7.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return _this8.getAuthControl();

            case 2:
              _context7.next = 4;
              return _this8.getMonthlyPayrolls();

            case 4:
              _context7.next = 6;
              return _this8.getPayrolls();

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, _this8);
    }))();
  }
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      monthlyPayroll: {
        id: null,
        shortCode: "",
        name: "",
        ssk: true,
        total: true,
        work: true
      },
      monthlyPayrolls: [],
      isNewMonthlyPayroll: true
    };
  },

  computed: {
    authControl: function authControl() {
      return this.$store.getters.getAuthAyarlar;
    },
    monthlyPayrollList: function monthlyPayrollList() {
      return this.monthlyPayrolls;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    newMonthlyPayroll: function newMonthlyPayroll() {
      this.isLoadingDetail = true;
      this.isNewMonthlyPayroll = true;
      this.monthlyPayroll.id = null;
      this.monthlyPayroll.shortCode = "";
      this.monthlyPayroll.name = "";
      this.monthlyPayroll.ssk = true;
      this.monthlyPayroll.total = true;
      this.monthlyPayroll.work = true;
      this.monthlyPayroll.ipAddress = true;
      this.monthlyPayroll.port = true;
      this.isLoadingDetail = false;
    },
    deleteMonthlyPayroll: function deleteMonthlyPayroll() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoadingDetail = true;
                id = _this2.monthlyPayroll.id;
                _context.next = 5;
                return _this2.$axios.delete("/MonthlyPayroll/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get('errors.connectionError'));
                      _this2.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this2.getMonthlyPayrolls();
                _this2.newMonthlyPayroll();
                alertify.success(_this2.$ml.get('alerts.deletedSuccessfully'));
                _this2.isLoadingDetail = false;
                _context.next = 17;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this2.isLoadingDetail = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 12]]);
      }))();
    },
    saveMonthlyPayroll: function saveMonthlyPayroll() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var monthlyPayroll2, response, id, _monthlyPayroll, _response;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.monthlyPayroll.name == "" || _this3.monthlyPayroll.shortCode == "")) {
                  _context2.next = 3;
                  break;
                }

                alertify.warning(_this3.$ml.get('alerts.pleaseEnterShortCodeAndName'));
                return _context2.abrupt("return");

              case 3:
                _this3.isLoadingDetail = true;

                if (!_this3.isNewMonthlyPayroll) {
                  _context2.next = 25;
                  break;
                }

                _context2.prev = 5;
                monthlyPayroll2 = _this3.monthlyPayroll;
                _context2.next = 9;
                return _this3.$axios.post("/MonthlyPayroll", {
                  name: monthlyPayroll2.name,
                  shortCode: monthlyPayroll2.shortCode,
                  ssk: monthlyPayroll2.ssk,
                  total: monthlyPayroll2.total,
                  work: monthlyPayroll2.work
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 9:
                response = _context2.sent;
                id = response.data.id;

                if (response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.savedSuccessfully'));
                } else {
                  alertify.error(response.message);
                }
                _this3.getMonthlyPayrolls();
                _this3.getMonthlyPayroll(id);
                _this3.isNewMonthlyPayroll = false;
                _this3.isLoadingDetail = false;
                _context2.next = 23;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](5);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this3.isLoadingDetail = false;

              case 23:
                _context2.next = 40;
                break;

              case 25:
                _context2.prev = 25;
                _monthlyPayroll = _this3.monthlyPayroll;
                _context2.next = 29;
                return _this3.$axios.post("/MonthlyPayroll/" + _monthlyPayroll.id, {
                  name: _monthlyPayroll.name,
                  shortCode: _monthlyPayroll.shortCode,
                  ssk: _monthlyPayroll.ssk,
                  total: _monthlyPayroll.total,
                  work: _monthlyPayroll.work
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 29:
                _response = _context2.sent;

                if (_response.status == 200) {
                  alertify.success(_this3.$ml.get('alerts.updatedSuccessfully'));
                } else {
                  alertify.error(_response.message);
                }
                _this3.getMonthlyPayrolls();
                _this3.isLoadingDetail = false;
                _context2.next = 40;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t1 = _context2["catch"](25);

                console.error(_context2.t1);
                alertify.error(_context2.t1.message);
                _this3.isLoadingDetail = false;

              case 40:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[5, 18], [25, 35]]);
      }))();
    },
    getMonthlyPayroll: function getMonthlyPayroll(id) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                _this4.isLoadingDetail = true;
                _context3.next = 4;
                return _this4.$axios.get("/MonthlyPayroll/" + id).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get('errors.connectionError'));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context3.sent;

                _this4.isNewMonthlyPayroll = false;
                _this4.monthlyPayroll.id = id;
                _this4.monthlyPayroll.shortCode = response.data.shortCode;
                _this4.monthlyPayroll.name = response.data.name;
                _this4.monthlyPayroll.ssk = response.data.ssk;
                _this4.monthlyPayroll.total = response.data.total;
                _this4.monthlyPayroll.work = response.data.work;
                _this4.isLoadingDetail = false;
                _context3.next = 20;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](0);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this4.isLoadingDetail = false;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 15]]);
      }))();
    },
    getMonthlyPayrolls: function getMonthlyPayrolls() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var monthlyPayrolls, response;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;

                _this5.isLoading = true;
                monthlyPayrolls = [];
                _context4.next = 5;
                return _this5.$axios.get("/MonthlyPayroll").then(function (response) {
                  response.data.forEach(function (doc) {
                    monthlyPayrolls.push({
                      id: doc.id,
                      shortCode: doc.shortCode,
                      name: doc.name,
                      ssk: doc.ssk,
                      total: doc.total,
                      work: doc.work
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this5.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this5.$ml.get('errors.connectionError'));
                      _this5.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this5.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context4.sent;

                _this5.monthlyPayrolls = monthlyPayrolls;
                _this5.isLoading = false;
                _context4.next = 15;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);

                console.error(_context4.t0);
                alertify.error(_context4.t0.message);
                _this5.isLoading = false;

              case 15:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[0, 10]]);
      }))();
    },
    getAuthControl: function getAuthControl() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.authControl == 1) {
                  alertify.warning(_this6.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
                }

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this7 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this7.getAuthControl();

            case 2:
              _context6.next = 4;
              return _this7.getMonthlyPayrolls();

            case 4:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, _this7);
    }))();
  }
});

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      startDate: null,
      endDate: null,
      sonGuncellemeZamani: null,
      sonGuncellemeZamani2: null,
      sonGuncellemeZamani3: null,
      logs: []
    };
  },

  filters: {
    toDateFormatGet: function toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika = str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    baseUrl: function baseUrl() {
      return this.$store.getters.getBaseURL;
    },
    logList: function logList() {
      return this.logs;
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF: function exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    allTransferOperations: function allTransferOperations() {
      var url = this.baseUrl + "/hangfire";
      window.open(url, "_blank");
    },
    goToHangfire: function goToHangfire() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this2.isLoading = true;
                _context.next = 4;
                return _this2.$axios.post("/Integration", {
                  date1: _this2.sonGuncellemeZamani,
                  date2: _this2.sonGuncellemeZamani2,
                  date3: _this2.sonGuncellemeZamani3
                }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(_this2.$ml.get("alerts.transfersTriggeredSuccessfully"));
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this2.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this2.$ml.get("errors.connectionError"));
                      _this2.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this2.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context.sent;

                _this2.isLoading = false;
                _context.next = 13;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this2.isLoading = false;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 8]]);
      }))();
    },
    getSettings: function getSettings() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this3.isLoading = true;
                _context2.next = 4;
                return _this3.$axios.get("/Integration/Settings").then(function (response) {
                  if (response.status == 200) {
                    _this3.sonGuncellemeZamani = response.data.sonGuncellemeZamani;
                    _this3.sonGuncellemeZamani2 = response.data.sonGuncellemeZamani2;
                    _this3.sonGuncellemeZamani3 = response.data.sonGuncellemeZamani3;
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get("errors.connectionError"));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 4:
                response = _context2.sent;

                _this3.isLoading = false;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);

                console.error(_context2.t0);
                alertify.error(_context2.t0.message);
                _this3.isLoading = false;

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[0, 8]]);
      }))();
    },
    getDefaultDate: function getDefaultDate() {
      var toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    send: function send() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var logs, startDate, endDate, response;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(_this4.startDate == null | _this4.endDate == null)) {
                  _context3.next = 3;
                  break;
                }

                alertify.warning(_this4.$ml.get("alerts.pleaseCheckEnteredValue"));
                return _context3.abrupt("return");

              case 3:
                _context3.prev = 3;

                _this4.isLoadingDetail = true;
                logs = [];
                startDate = _this4.startDate;
                endDate = _this4.endDate;
                _context3.next = 10;
                return _this4.$axios.get("/Integration/Log?startDate=" + startDate + "&endDate=" + endDate).then(function (response) {
                  response.data.forEach(function (doc) {
                    logs.push({
                      id: doc.id,
                      zaman: doc.zaman,
                      olay: doc.olay
                    });
                  });
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this4.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this4.$ml.get("errors.connectionError"));
                      _this4.isLoadingDetail = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this4.isLoadingDetail = false;
                      return;
                    }
                  }
                });

              case 10:
                response = _context3.sent;

                _this4.logs = logs;
                _this4.isLoadingDetail = false;
                _context3.next = 20;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](3);

                console.error(_context3.t0);
                alertify.error(_context3.t0.message);
                _this4.isLoadingDetail = false;

              case 20:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 15]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    this.getSettings();
    this.getDefaultDate();
  }
});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      isLoadingDetail: false,
      windowHeight: window.innerHeight,
      list: [],
      selectedLink: "",
      selectedBaslik: "",
      searchText: ""
    };
  },

  computed: {
    helpList: function helpList() {
      return this.list;
    },
    filtered: function filtered() {
      var _this = this;

      if (this.searchText) {
        return this.helpList.filter(function (item) {
          return _this.searchText.toUpperCase().split(" ").every(function (v) {
            return item.etiketler.toUpperCase().includes(v);
          });
        });
      } else {
        return this.helpList;
      }
    },
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 360;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowVideoHeightSize: function windowVideoHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 360;
        return height;
      } else {
        return "400";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this2.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    },
    getHelp: function getHelp(link, anaBaslik, altBaslik) {
      this.isLoadingDetail = true;
      this.selectedBaslik = anaBaslik + " - " + altBaslik;
      this.selectedLink = link.replace("watch?v=", "embed/");
      this.isLoadingDetail = false;
    },
    getHelps: function getHelps() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var list, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;

                _this3.isLoading = true;
                list = [];
                _context.next = 5;
                return _this3.$axios.get("/Help").then(function (response) {
                  if (response.status == 200) {
                    response.data.forEach(function (doc) {
                      list.push({
                        anaBaslik: doc.anaBaslik,
                        altBaslik: doc.altBaslik,
                        link: doc.link,
                        etiketler: doc.etiketler
                      });
                    });
                  }
                }).catch(function (error) {
                  if (error.response) {
                    if (error.response.status == 401) {
                      _this3.$store.dispatch("logout");
                    }
                  } else {
                    if (error.message == "Network Error" || error.message == "Error: Network Error") {
                      alertify.error(_this3.$ml.get('errors.connectionError'));
                      _this3.isLoading = false;
                      return;
                    } else {
                      console.error(error);
                      alertify.error(error.message);
                      _this3.isLoading = false;
                      return;
                    }
                  }
                });

              case 5:
                response = _context.sent;

                _this3.list = list;
                _this3.isLoading = false;
                _context.next = 15;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);

                console.error(_context.t0);
                alertify.error(_context.t0.message);
                _this3.isLoading = false;

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 10]]);
      }))();
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  created: function created() {
    var _this4 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.getHelps();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      version: this.$store.state.version,
      windowHeight: window.innerHeight
    };
  },

  computed: {
    windowHeightSize: function windowHeightSize() {
      if (this.windowHeight) {
        var height = this.windowHeight - 240;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight: function windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
          //WEB
        }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      window.addEventListener("resize", _this.onResize);
    });
  },

  methods: {
    onResize: function onResize() {
      this.windowHeight = window.innerHeight;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  }
});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      user: {
        userName: "",
        password: ""
      },
      softwareKey: "",
      licenceKey: "",
      version: this.$store.state.version,
      flag: "",
      defaultLanguage: "",
      isLoading: false,
      errorDescription: "",
      errorStatu: false
    };
  },

  computed: {
    loginAlertMsgs: function loginAlertMsgs() {
      return new __WEBPACK_IMPORTED_MODULE_0_vue_multilanguage__["MLBuilder"]("msg").with("f", this.user.userName);
    }
  },
  methods: {
    changeLanguage: function changeLanguage(event) {
      this.defaultLanguage = event.target.value;
      localStorage.setItem("lang", this.defaultLanguage);
      if (event.target.value == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.$ml.change(event.target.value);
    },
    toLogin: function toLogin() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var vm, url, auth;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                vm = _this;

                if (!(_this.user.userName == null || _this.user.userName == "")) {
                  _context.next = 6;
                  break;
                }

                alertify.warning(vm.$ml.get("alerts.wrongEmailOrUsername"));
                return _context.abrupt("return");

              case 6:
                if (!(_this.user.password == null || _this.user.password == "")) {
                  _context.next = 11;
                  break;
                }

                alertify.warning(vm.$ml.get("alerts.wrongPassword"));
                return _context.abrupt("return");

              case 11:
                _this.isLoading = true;
                _context.next = 14;
                return _this.$store.getters.getBaseURL;

              case 14:
                url = _context.sent;
                auth = "Login?mail=" + _this.user.userName + "&" + "password=" + _this.user.password;
                _context.next = 18;
                return _this.$axios.post(url + "/api/" + auth).then(function (response) {
                  if (response.status == 200) {
                    var user = {
                      id: response.data.id,
                      mail: response.data.mail,
                      userName: response.data.userName,
                      companyName: response.data.companyName,
                      token: response.data.token,
                      title: response.data.title,
                      profileUrl: response.data.profileUrl,
                      defaultVisitorCardGroup: response.data.defaultVisitorCardGroup,
                      realtimeMonitorGroup: response.data.realtimeMonitorGroup,
                      authType: response.data.authType,
                      language: _this.defaultLanguage,
                      defaultFilters: response.data.filter
                    };
                    _this.$store.commit("setUser", user);
                    localStorage.setItem("id", user.id);
                    localStorage.setItem("userName", user.userName);
                    localStorage.setItem("email", user.mail);
                    localStorage.setItem("companyName", user.companyName);
                    localStorage.setItem("token", user.token);
                    localStorage.setItem("title", user.title);
                    localStorage.setItem("profileUrl", user.profileUrl);
                    localStorage.setItem("authType", user.authType);
                    localStorage.setItem("lang", _this.defaultLanguage);
                    localStorage.setItem("defaultFilters", JSON.stringify(user.defaultFilters));
                    if (user.defaultVisitorCardGroup) {
                      localStorage.setItem("defaultVisitorCardGroup", user.defaultVisitorCardGroup);
                    } else {
                      localStorage.setItem("defaultVisitorCardGroup", 0);
                    }
                    var currentUrl = window.location.origin;
                    window.location.href = currentUrl + "/dashboard";
                    //this.$router.push("/redirect");
                    //this.isLoading = false;
                  } else if (response.status == 210) {
                    $("#modal-licence").modal("show");
                    alertify.error(vm.$ml.get('shared.licenceError'));
                    _this.softwareKey = response.data.message;
                    _this.isLoading = false;
                    return;
                  } else {
                    alertify.warning(response.data.message);
                    console.log(response);
                    _this.isLoading = false;
                  }
                }).catch(function (error) {
                  console.log(error);
                  if (error.response) {
                    if (error.response.status == 401) {
                      alertify.error(vm.$ml.get("alerts.undefinedUser"));
                      _this.isLoading = false;
                    } else if (error.response.status == 404) {
                      alertify.error(vm.$ml.get("alerts.userNotFound"));
                      _this.isLoading = false;
                    } else {
                      console.error(error);
                      _this.isLoading = false;
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(vm.$ml.get("errors.connectionError"));
                    _this.isLoading = false;
                  } else {
                    alertify.error(error.response.status + " - " + error.message);
                    _this.isLoading = false;
                  }
                });

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    saveLicenceKey: function saveLicenceKey() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var vm, url, auth;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                vm = _this2;

                if (!(_this2.licenceKey == null || _this2.licenceKey == "")) {
                  _context2.next = 6;
                  break;
                }

                alertify.warning(vm.$ml.get("shared.wrongLicenceKey"));
                return _context2.abrupt("return");

              case 6:
                _this2.isLoading = true;
                _context2.next = 9;
                return _this2.$store.getters.getBaseURL;

              case 9:
                url = _context2.sent;
                auth = "SaveLicence";
                _context2.next = 13;
                return _this2.$axios.post(url + auth, { licenceKey: _this2.licenceKey }).then(function (response) {
                  if (response.status == 200) {
                    alertify.success(vm.$ml.get("shared.saveLicenceKeySuccessfully"));
                    _this2.isLoading = false;
                    return;
                  } else {
                    alertify.warning(response.data.message);
                    console.log(response);
                    _this2.isLoading = false;
                  }
                }).catch(function (error) {
                  console.log(error);
                  if (error.response) {
                    if (error.response.status == 401) {
                      alertify.error(vm.$ml.get("alerts.undefinedUser"));
                      _this2.isLoading = false;
                    } else if (error.response.status == 404) {
                      alertify.error(vm.$ml.get("alerts.userNotFound"));
                      _this2.isLoading = false;
                    } else {
                      console.error(error);
                      _this2.isLoading = false;
                    }
                  }
                  if (error.message == "Network Error" || error.message == "Error: Network Error") {
                    alertify.error(vm.$ml.get("errors.connectionError"));
                    _this2.isLoading = false;
                  } else {
                    alertify.error(error.response.status + " - " + error.message);
                    _this2.isLoading = false;
                  }
                });

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  },
  created: function created() {
    //document.body.style.backgroundColor = "#00a0f0";
    var language = localStorage.getItem("lang");
    if (language) {
      if (language != "English" && language != "Türkçe") {
        localStorage.setItem("lang", "Türkçe");
        this.defaultLanguage = "Türkçe";
        this.flag = "/src/assets/flags/TR.png";
      }
      this.defaultLanguage = language;
      if (language == "English") {
        this.flag = "/src/assets/flags/GB.png";
      } else {
        this.flag = "/src/assets/flags/TR.png";
      }
      this.$ml.change(language);
    } else {
      localStorage.setItem("lang", "Türkçe");
      this.defaultLanguage = "Türkçe";
      this.flag = "/src/assets/flags/TR.png";
    }
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(489);

__webpack_require__(686);

__webpack_require__(687);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(10) && !__webpack_require__(6)(function () {
  return Object.defineProperty(__webpack_require__(84)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(8);


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(18);
var toIObject = __webpack_require__(19);
var arrayIndexOf = __webpack_require__(65)(false);
var IE_PROTO = __webpack_require__(86)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11);
var anObject = __webpack_require__(2);
var getKeys = __webpack_require__(43);

module.exports = __webpack_require__(10) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(19);
var gOPN = __webpack_require__(46).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(10);
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(66);
var pIE = __webpack_require__(60);
var toObject = __webpack_require__(12);
var IObject = __webpack_require__(59);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(6)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(13);
var isObject = __webpack_require__(7);
var invoke = __webpack_require__(206);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 206 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(55).trim;
var ws = __webpack_require__(90);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(55).trim;

module.exports = 1 / $parseFloat(__webpack_require__(90) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(26);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(7);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 211 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(93);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(2);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(13);
var toObject = __webpack_require__(12);
var IObject = __webpack_require__(59);
var toLength = __webpack_require__(9);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(12);
var toAbsoluteIndex = __webpack_require__(44);
var toLength = __webpack_require__(9);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(105);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(10) && /./g.flags != 'g') __webpack_require__(11).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(61)
});


/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var newPromiseCapability = __webpack_require__(109);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(222);
var validate = __webpack_require__(51);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(74)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(11).f;
var create = __webpack_require__(45);
var redefineAll = __webpack_require__(50);
var ctx = __webpack_require__(25);
var anInstance = __webpack_require__(48);
var forOf = __webpack_require__(49);
var $iterDefine = __webpack_require__(95);
var step = __webpack_require__(216);
var setSpecies = __webpack_require__(47);
var DESCRIPTORS = __webpack_require__(10);
var fastKey = __webpack_require__(38).fastKey;
var validate = __webpack_require__(51);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(222);
var validate = __webpack_require__(51);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(74)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var each = __webpack_require__(32)(0);
var redefine = __webpack_require__(16);
var meta = __webpack_require__(38);
var assign = __webpack_require__(203);
var weak = __webpack_require__(225);
var isObject = __webpack_require__(7);
var validate = __webpack_require__(51);
var NATIVE_WEAK_MAP = __webpack_require__(51);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(74)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(50);
var getWeak = __webpack_require__(38).getWeak;
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var anInstance = __webpack_require__(48);
var forOf = __webpack_require__(49);
var createArrayMethod = __webpack_require__(32);
var $has = __webpack_require__(18);
var validate = __webpack_require__(51);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(27);
var toLength = __webpack_require__(9);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(46);
var gOPS = __webpack_require__(66);
var anObject = __webpack_require__(2);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(67);
var isObject = __webpack_require__(7);
var toLength = __webpack_require__(9);
var ctx = __webpack_require__(25);
var IS_CONCAT_SPREADABLE = __webpack_require__(8)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(9);
var repeat = __webpack_require__(92);
var defined = __webpack_require__(30);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(10);
var getKeys = __webpack_require__(43);
var toIObject = __webpack_require__(19);
var isEnum = __webpack_require__(60).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(54);
var from = __webpack_require__(232);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(49);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(235);
module.exports = __webpack_require__(197);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_html_to_paper__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_html_to_paper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_html_to_paper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ml__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_polyfill__);










var options = {
  name: '_blank',
  specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
  styles: ["./vendor/dist/css/customReport.css"]
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_html_to_paper___default.a, options);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

var config = window.APP_CONFIG; //config.js dosyasından gelen config bilgilerini alıyoruz

var axiosInstance = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: config.baseURL + "/api/"
});

__WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].commit("setConfig", config);

axiosInstance.interceptors.request.use(function (config) {
  config.headers["Authorization"] = "Bearer " + __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */].state.user.token;
  return config;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$axios = axiosInstance;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* router */],
  store: __WEBPACK_IMPORTED_MODULE_5__store_store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(237);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40), __webpack_require__(79)))

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e738ee0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(242);
function injectStyle (ssrContext) {
  __webpack_require__(239)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e738ee0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(240);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("b9716a82", content, true, {});

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var bind = __webpack_require__(114);
var Axios = __webpack_require__(244);
var mergeConfig = __webpack_require__(120);
var defaults = __webpack_require__(117);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(121);
axios.CancelToken = __webpack_require__(257);
axios.isCancel = __webpack_require__(116);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(258);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var buildURL = __webpack_require__(115);
var InterceptorManager = __webpack_require__(245);
var dispatchRequest = __webpack_require__(246);
var mergeConfig = __webpack_require__(120);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);
var transformData = __webpack_require__(247);
var isCancel = __webpack_require__(116);
var defaults = __webpack_require__(117);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(119);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(253);
var combineURLs = __webpack_require__(254);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(14);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(121);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isAuthenticated", function() { return isAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getToken", function() { return getToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBaseURL", function() { return getBaseURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVersion", function() { return getVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUser", function() { return getUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyURL", function() { return getCompanyURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCompanyName", function() { return getCompanyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRequiredFields", function() { return getRequiredFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthority", function() { return getAuthority; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthCanliIzleme", function() { return getAuthCanliIzleme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthKisiler", function() { return getAuthKisiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthGecisYetkileri", function() { return getAuthGecisYetkileri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthRaporlar", function() { return getAuthRaporlar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthAyarlar", function() { return getAuthAyarlar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthTanimlamalar", function() { return getAuthTanimlamalar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAuthBekciTur", function() { return getAuthBekciTur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModules", function() { return getModules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultFilters", function() { return getDefaultFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBuildings", function() { return getBuildings; });
var isAuthenticated = function isAuthenticated(state) {
    return state.user.token !== "";
};
var getToken = function getToken(state) {
    return state.user.token;
};

var getBaseURL = function getBaseURL(state) {
    return state.baseURL;
};

var getVersion = function getVersion(state) {
    return state.version;
};

var getUser = function getUser(state) {
    return state.user;
};

var getCompanyURL = function getCompanyURL(state) {
    return state.companyUrl;
};
var getCompanyName = function getCompanyName(state) {
    return state.companyName;
};

var getRequiredFields = function getRequiredFields(state) {
    return state.requiredFields;
};

var getAuthority = function getAuthority(state) {
    return state.authMap;
};

var getAuthCanliIzleme = function getAuthCanliIzleme(state) {
    return state.authMap.canliIzleme;
};

var getAuthKisiler = function getAuthKisiler(state) {
    return state.authMap.kisiler;
};

var getAuthGecisYetkileri = function getAuthGecisYetkileri(state) {
    return state.authMap.gecisYetkileri;
};

var getAuthRaporlar = function getAuthRaporlar(state) {
    return state.authMap.raporlar;
};

var getAuthAyarlar = function getAuthAyarlar(state) {
    return state.authMap.ayarlar;
};

var getAuthTanimlamalar = function getAuthTanimlamalar(state) {
    return state.authMap.tanimlamalar;
};
var getAuthBekciTur = function getAuthBekciTur(state) {
    return state.authMap.bekciTur;
};

var getModules = function getModules(state) {
    return state.modules;
};

var getDefaultFilters = function getDefaultFilters(state) {
    return state.defaultFilters;
};

var getBuildings = function getBuildings(state) {
    return state.buildings;
};

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearUser", function() { return clearUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return setUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAuthority", function() { return setAuthority; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setCompanyName", function() { return setCompanyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setMyUser", function() { return setMyUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultFilters", function() { return setDefaultFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRequiredFields", function() { return setRequiredFields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setConfig", function() { return setConfig; });
var clearUser = function clearUser(state) {
  state.user.id = "";
  state.user.userName = "";
  state.user.title = "";
  state.user.mail = "";
  state.user.companyName = "";
  state.user.profileUrl = null;
  state.user.token = "";
  state.user.defaultVisitorCardGroup = "";
  state.authMap.canliIzleme = 1;
  state.authMap.kisiler = 1;
  state.authMap.gecisYetkileri = 1;
  state.authMap.raporlar = 1;
  state.authMap.ayarlar = 1;
  state.authMap.tanimlamalar = 1;
  state.authMap.ziyaretciTakip = 1;
  state.authMap.yemekhane = 1;
  state.authMap.dashboard = 1;
  state.authMap.creditSale = 1;
  state.authMap.payrollManagement = 1;
  state.authMap.shiftManagement = 1;
  state.authMap.bekciTur = 1;
};

var setUser = function setUser(state, data) {
  state.user.id = data.id;
  state.user.userName = data.userName;
  state.user.title = data.title;
  state.user.mail = data.mail;
  state.user.companyName = data.companyName;
  state.user.profileUrl = data.profileUrl;
  state.user.token = data.token;
  state.user.defaultVisitorCardGroup = data.defaultVisitorCardGroup;
  state.user.language = data.language;
  state.user.authType = data.authType;
  state.defaultFilters = data.defaultFilters;
};

var setAuthority = function setAuthority(state, data) {
  state.authMap.canliIzleme = data.canliIzleme;
  state.authMap.kisiler = data.kisiler;
  state.authMap.gecisYetkileri = data.gecisYetkileri;
  state.authMap.raporlar = data.raporlar;
  state.authMap.ayarlar = data.ayarlar;
  state.authMap.tanimlamalar = data.tanimlamalar;
  state.authMap.ziyaretciTakip = data.ziyaretciTakip;
  state.authMap.yemekhane = data.yemekhane;
  state.authMap.dashboard = data.dashboard;
  state.authMap.creditSale = data.creditSale;
  state.authMap.puantajYonetimi = data.puantajYonetimi;
  state.authMap.shiftYonetimi = data.shiftYonetimi;
  state.authMap.shiftYetkileri = data.shiftYetkileri;
  state.authMap.bekciTur = data.bekciTur;
};

var setCompanyName = function setCompanyName(state, data) {
  state.user.companyName = data.companyName;
};

var setMyUser = function setMyUser(state, data) {
  state.user.userName = data.userName;
  state.user.title = data.title;
  state.user.mail = data.mail;
  state.user.profileUrl = data.profileUrl;
  state.user.defaultVisitorCardGroup = data.defaultVisitorCardGroup;
};

var setDefaultFilters = function setDefaultFilters(state, data) {
  state.defaultFilters = data;
};

var setRequiredFields = function setRequiredFields(state, data) {
  state.requiredFields = data;
};

var setConfig = function setConfig(state, data) {
  state.baseURL = data.baseURL;
  state.companyUrl = data.companyUrl;
  state.companyName = data.companyName;
  state.modules = data.modules;
};

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initAuth", function() { return initAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ml__ = __webpack_require__(124);





var logout = function logout(_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch,
      state = _ref.state;

  commit("clearUser");
  localStorage.removeItem("id");
  localStorage.removeItem("token");
  localStorage.removeItem("userName");
  localStorage.removeItem("email");
  localStorage.removeItem("companyName");
  localStorage.removeItem("profileUrl");
  localStorage.removeItem("title");
  localStorage.removeItem("defaultVisitorCardGroup");
  localStorage.removeItem("defaultFilters");
  localStorage.removeItem("authType");
  //localStorage.removeItem("lang")
  __WEBPACK_IMPORTED_MODULE_1__router__["a" /* router */].replace("/login");
};

var initAuth = function initAuth(_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  var id = localStorage.getItem("id");
  var token = localStorage.getItem("token");
  var userName = localStorage.getItem("userName");
  var eMail = localStorage.getItem("email");
  var companyName = localStorage.getItem("companyName");
  var title = localStorage.getItem("title");
  var profileUrl = localStorage.getItem("profileUrl");
  var defaultVisitorCardGroup = localStorage.getItem("defaultVisitorCardGroup");
  var language = localStorage.getItem("lang");
  var authType = localStorage.getItem("authType");
  var defaultFilters = JSON.parse(localStorage.getItem("defaultFilters"));
  commit("setUser", { id: id, userName: userName, mail: eMail, companyName: companyName, token: token, title: title, profileUrl: profileUrl, defaultVisitorCardGroup: defaultVisitorCardGroup, language: language, defaultFilters: defaultFilters, authType: authType });
  if (token) {
    //router.replace("/dashboard")
  } else {
    __WEBPACK_IMPORTED_MODULE_1__router__["a" /* router */].push("/login"); //BURA AUTH OLACAK
    return false;
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._install = undefined;

var _vue = __webpack_require__(35);

var _mixin = __webpack_require__(263);

var _gettingStrategy = __webpack_require__(126);

var _directive = __webpack_require__(264);

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {Object} VueMultiLanguageParams
 * @property {String} initial
 * @property {Array} languages
 * @property {Boolean} [save]
 * @property {Function} [middleware]
 */

/**
 * Function for install plugin with Vue.use
 * @function
 * @param {VueConstructor} _Vue
 * @param {VueMultiLanguageParams} options
 */
// @ts-check
var _install = exports._install = function _install(_Vue, options) {
  var initial = options.initial,
      languages = options.languages,
      save = options.save,
      middleware = options.middleware,
      gettingStrategy = options.gettingStrategy;


  var mixin = (0, _mixin.register)(initial, languages, save || false, middleware || function (self, path) {
    return path;
  }, gettingStrategy || _gettingStrategy.GettingStrategy.DEFAULT);

  // @ts-ignore
  if (mixin !== undefined) {
    // @ts-ignore
    _Vue.mixin(mixin);
    (0, _directive2.default)(_Vue, initial);
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // @ts-check


var _vue = __webpack_require__(35);

var _vue2 = _interopRequireDefault(_vue);

var _gettingStrategy = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventBus = new _vue2.default();

var currentGlobal = null;
/** @type {Array} */
var _with2 = null;
/**
 * Register all plugin actions
 *
 * @param {String} initial initial language
 * @param {Array} languages array with languages
 * @param {Boolean} save if save language in local storage
 * @param {Function} middleware function for handler get
 * @param {String} gettingStrategy translation getting strategy
 */
var register = exports.register = function register(initial, languages, save, middleware, gettingStrategy) {
  if (save) {
    var lang = window.localStorage.getItem('vueml-lang');
    if (lang === null) {
      window.localStorage.setItem('vueml-lang', initial);
    } else {
      initial = lang;
    }
  }

  if (initial === null) {
    return console.error('[vue-multilanguage] initial language is null, please set a value');
  }
  currentGlobal = initial;
  return {
    /**
     * Called before create component
     */
    beforeCreate: function beforeCreate() {
      var _this = this;

      var self = this;

      this.$ml = {
        /**
         * Change current language
         * @param {string} param new language
         */
        change: function change(param) {
          var current = languages.filter(function (l) {
            return l.name === param;
          });
          if (current.length === 0) {
            return console.error('[vue-multilanguage] \'' + param + '\' language not found');
          }

          if (currentGlobal !== param) {
            if (save) {
              window.localStorage.setItem('vueml-lang', param);
            }
            EventBus.$emit('vueml-language-changed', param);
          }
        },
        with: function _with(name) {
          var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

          if (value !== false) {
            if (_with2 === null) {
              _with2 = [];
            }
            _with2.push({ name: name, value: value });
          } else {
            _with2 = [name];
          }
          return this;
        },
        get: function get(path) {
          var initialPath = path;

          var current = languages.filter(function (l) {
            return l.name === currentGlobal;
          });
          if (current.length > 1) {
            return console.error('[vue-multilanguage] you define \'' + currentGlobal + '\' language two or more times');
          }
          var db = current[0].database;

          if ('ml' + path in self) {
            path = 'ml' + path;
            _with2 = self[path]._with;
            path = self[path].path;
          }

          path = middleware(self, path);

          /** @type {Array} */
          var splitedPath = path.split('.');

          splitedPath.forEach(function (ph) {
            if (ph in db) {
              db = db[ph];
            } else {
              if (gettingStrategy !== _gettingStrategy.GettingStrategy.RETURN_PATH_BY_DEFAULT_WITHOUT_ERROR) {
                console.error('[vue-multilanguage] path \'' + path + '\' unknown from \'' + ph + '\'');
              }
              if (gettingStrategy === _gettingStrategy.GettingStrategy.RETURN_PATH_BY_DEFAULT || gettingStrategy === _gettingStrategy.GettingStrategy.RETURN_PATH_BY_DEFAULT_WITHOUT_ERROR) {
                db = initialPath;
              } else {
                return db = false;
              }
            }
          });

          if (db !== false) {
            if (Array.isArray(_with2)) {
              _with2.forEach(function (w) {
                if ((typeof w === 'undefined' ? 'undefined' : _typeof(w)) !== 'object') {
                  db = db.replace(/\{0\}/g, _with2[0]);
                } else {
                  var replace = '{' + w.name + '}';
                  while (db.includes(replace)) {
                    db = db.replace(replace, w.value);
                  }
                }
              });
            }
            _with2 = null;

            return db;
          }
        },


        /**
         * get current permission
         */
        get current() {
          return currentGlobal;
        },

        /**
         * get event bus
         */
        get bus() {
          return EventBus;
        },

        /**
         * get languages list
         */
        get list() {
          return languages.map(function (l) {
            return l.name;
          });
        },

        /**
         * get languages database list
         */
        get db() {
          return languages.map(function (l) {
            return l.database;
          });
        }
      };

      EventBus.$on('vueml-language-changed', function (newLanguage) {
        currentGlobal = newLanguage;
        _this.$forceUpdate();
      });
    }
  };
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (Vue, initial) {
  Vue.directive('ml', {
    bind: function bind(el, binding, vnode) {
      var component = vnode.context;
      var changeTextBinding = function changeTextBinding(msg) {
        var variables = (msg.match(/\{(.*?)\}/gm) || []).map(function (v) {
          return v.replace('{', '').replace('}', '').trim();
        });
        if (variables.length <= 0) return msg;

        variables.forEach(function (variable) {
          var croped = variable.split('.');
          var instance = component;
          croped.forEach(function (part) {
            if (part in instance) {
              instance = instance[part];
            }
          });

          msg = msg.replace('{' + variable + '}', instance);
        });

        return msg;
      };

      el.setAttribute('data-ml-initial', el.innerText);
      el.innerText = changeTextBinding(el.getAttribute('data-ml-initial'));

      var actionToChange = function actionToChange() {
        var path = Object.keys(binding.modifiers).join('.');
        var current = component.$ml.current;
        var isInitial = current === initial;

        if (isInitial && el.innerText !== '') {
          el.innerText = changeTextBinding(el.getAttribute('data-ml-initial'));
          return;
        }

        Object.keys(binding.value || {}).forEach(function (name) {
          component.$ml.with(name, component[name]);
        });

        el.innerText = component.$ml.get(path);
        component.$forceUpdate();
      };

      component.$ml.bus.$on('vueml-language-changed', actionToChange);
      component.$ml.bus.$on('vueml-force-reload', actionToChange);
      el.removeEventListener('change', actionToChange);
      el.addEventListener('change', actionToChange);
    }
  });
};

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(127);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c776791e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(288);
function injectStyle (ssrContext) {
  __webpack_require__(266)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c776791e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(267);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("afa0caa6", content, true, {});

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85e554b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(283);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85e554b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var FetchHttpClient = /** @class */ (function (_super) {
    __extends(FetchHttpClient, _super);
    function FetchHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        if (typeof fetch === "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            var requireFunc =  true ? require : require;
            // Cookies aren't automatically handled in Node so we need to add a CookieJar to preserve cookies across requests
            _this.jar = new (requireFunc("tough-cookie")).CookieJar();
            _this.fetchType = requireFunc("node-fetch");
            // node-fetch doesn't have a nice API for getting and setting cookies
            // fetch-cookie will wrap a fetch implementation with a default CookieJar or a provided one
            _this.fetchType = requireFunc("fetch-cookie")(_this.fetchType, _this.jar);
            // Node needs EventListener methods on AbortController which our custom polyfill doesn't provide
            _this.abortControllerType = requireFunc("abort-controller");
        }
        else {
            _this.fetchType = fetch.bind(self);
            _this.abortControllerType = AbortController;
        }
        return _this;
    }
    /** @inheritDoc */
    FetchHttpClient.prototype.send = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var abortController, error, timeoutId, msTimeout, response, e_1, content, payload;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Check that abort was not signaled before calling send
                        if (request.abortSignal && request.abortSignal.aborted) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]();
                        }
                        if (!request.method) {
                            throw new Error("No method defined.");
                        }
                        if (!request.url) {
                            throw new Error("No url defined.");
                        }
                        abortController = new this.abortControllerType();
                        // Hook our abortSignal into the abort controller
                        if (request.abortSignal) {
                            request.abortSignal.onabort = function () {
                                abortController.abort();
                                error = new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]();
                            };
                        }
                        timeoutId = null;
                        if (request.timeout) {
                            msTimeout = request.timeout;
                            timeoutId = setTimeout(function () {
                                abortController.abort();
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Timeout from HTTP request.");
                                error = new __WEBPACK_IMPORTED_MODULE_0__Errors__["c" /* TimeoutError */]();
                            }, msTimeout);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.fetchType(request.url, {
                                body: request.content,
                                cache: "no-cache",
                                credentials: request.withCredentials === true ? "include" : "same-origin",
                                headers: __assign({ "Content-Type": "text/plain;charset=UTF-8", "X-Requested-With": "XMLHttpRequest" }, request.headers),
                                method: request.method,
                                mode: "cors",
                                redirect: "manual",
                                signal: abortController.signal,
                            })];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        if (error) {
                            throw error;
                        }
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Error from HTTP request. " + e_1 + ".");
                        throw e_1;
                    case 4:
                        if (timeoutId) {
                            clearTimeout(timeoutId);
                        }
                        if (request.abortSignal) {
                            request.abortSignal.onabort = null;
                        }
                        return [7 /*endfinally*/];
                    case 5:
                        if (!response.ok) {
                            throw new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](response.statusText, response.status);
                        }
                        content = deserializeContent(response, request.responseType);
                        return [4 /*yield*/, content];
                    case 6:
                        payload = _a.sent();
                        return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__HttpClient__["b" /* HttpResponse */](response.status, response.statusText, payload)];
                }
            });
        });
    };
    FetchHttpClient.prototype.getCookieString = function (url) {
        var cookies = "";
        if (__WEBPACK_IMPORTED_MODULE_3__Utils__["c" /* Platform */].isNode && this.jar) {
            // @ts-ignore: unused variable
            this.jar.getCookies(url, function (e, c) { return cookies = c.join("; "); });
        }
        return cookies;
    };
    return FetchHttpClient;
}(__WEBPACK_IMPORTED_MODULE_1__HttpClient__["a" /* HttpClient */]));

function deserializeContent(response, responseType) {
    var content;
    switch (responseType) {
        case "arraybuffer":
            content = response.arrayBuffer();
            break;
        case "text":
            content = response.text();
            break;
        case "blob":
        case "document":
        case "json":
            throw new Error(responseType + " is not supported.");
        default:
            content = response.text();
            break;
    }
    return content;
}
//# sourceMappingURL=FetchHttpClient.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XhrHttpClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Errors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpClient__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(22);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var XhrHttpClient = /** @class */ (function (_super) {
    __extends(XhrHttpClient, _super);
    function XhrHttpClient(logger) {
        var _this = _super.call(this) || this;
        _this.logger = logger;
        return _this;
    }
    /** @inheritDoc */
    XhrHttpClient.prototype.send = function (request) {
        var _this = this;
        // Check that abort was not signaled before calling send
        if (request.abortSignal && request.abortSignal.aborted) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
        }
        if (!request.method) {
            return Promise.reject(new Error("No method defined."));
        }
        if (!request.url) {
            return Promise.reject(new Error("No url defined."));
        }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open(request.method, request.url, true);
            xhr.withCredentials = request.withCredentials === undefined ? true : request.withCredentials;
            xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            // Explicitly setting the Content-Type header for React Native on Android platform.
            xhr.setRequestHeader("Content-Type", "text/plain;charset=UTF-8");
            var headers = request.headers;
            if (headers) {
                Object.keys(headers)
                    .forEach(function (header) {
                    xhr.setRequestHeader(header, headers[header]);
                });
            }
            if (request.responseType) {
                xhr.responseType = request.responseType;
            }
            if (request.abortSignal) {
                request.abortSignal.onabort = function () {
                    xhr.abort();
                    reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["a" /* AbortError */]());
                };
            }
            if (request.timeout) {
                xhr.timeout = request.timeout;
            }
            xhr.onload = function () {
                if (request.abortSignal) {
                    request.abortSignal.onabort = null;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(new __WEBPACK_IMPORTED_MODULE_1__HttpClient__["b" /* HttpResponse */](xhr.status, xhr.statusText, xhr.response || xhr.responseText));
                }
                else {
                    reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](xhr.statusText, xhr.status));
                }
            };
            xhr.onerror = function () {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Error from HTTP request. " + xhr.status + ": " + xhr.statusText + ".");
                reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["b" /* HttpError */](xhr.statusText, xhr.status));
            };
            xhr.ontimeout = function () {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Warning, "Timeout from HTTP request.");
                reject(new __WEBPACK_IMPORTED_MODULE_0__Errors__["c" /* TimeoutError */]());
            };
            xhr.send(request.content || "");
        });
    };
    return XhrHttpClient;
}(__WEBPACK_IMPORTED_MODULE_1__HttpClient__["a" /* HttpClient */]));

//# sourceMappingURL=XhrHttpClient.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandshakeProtocol; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.


/** @private */
var HandshakeProtocol = /** @class */ (function () {
    function HandshakeProtocol() {
    }
    // Handshake request is always JSON
    HandshakeProtocol.prototype.writeHandshakeRequest = function (handshakeRequest) {
        return __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].write(JSON.stringify(handshakeRequest));
    };
    HandshakeProtocol.prototype.parseHandshakeResponse = function (data) {
        var responseMessage;
        var messageData;
        var remainingData;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__Utils__["h" /* isArrayBuffer */])(data) || (typeof Buffer !== "undefined" && data instanceof Buffer)) {
            // Format is binary but still need to read JSON text from handshake response
            var binaryData = new Uint8Array(data);
            var separatorIndex = binaryData.indexOf(__WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].RecordSeparatorCode);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = String.fromCharCode.apply(null, binaryData.slice(0, responseLength));
            remainingData = (binaryData.byteLength > responseLength) ? binaryData.slice(responseLength).buffer : null;
        }
        else {
            var textData = data;
            var separatorIndex = textData.indexOf(__WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].RecordSeparator);
            if (separatorIndex === -1) {
                throw new Error("Message is incomplete.");
            }
            // content before separator is handshake response
            // optional content after is additional messages
            var responseLength = separatorIndex + 1;
            messageData = textData.substring(0, responseLength);
            remainingData = (textData.length > responseLength) ? textData.substring(responseLength) : null;
        }
        // At this point we should have just the single handshake message
        var messages = __WEBPACK_IMPORTED_MODULE_0__TextMessageFormat__["a" /* TextMessageFormat */].parse(messageData);
        var response = JSON.parse(messages[0]);
        if (response.type) {
            throw new Error("Expected a handshake response from the server.");
        }
        responseMessage = response;
        // multiple messages could have arrived with handshake
        // return additional data to be parsed as usual, or null if all parsed
        return [remainingData, responseMessage];
    };
    return HandshakeProtocol;
}());

//# sourceMappingURL=HandshakeProtocol.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(272).Buffer))

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(273)
var ieee754 = __webpack_require__(274)
var isArray = __webpack_require__(275)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 274 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 275 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HubConnectionBuilder; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HttpConnection__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HubConnection__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__JsonHubProtocol__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Loggers__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};







// tslint:disable:object-literal-sort-keys
var LogLevelNameMapping = {
    trace: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Trace,
    debug: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Debug,
    info: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Information,
    information: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Information,
    warn: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Warning,
    warning: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Warning,
    error: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Error,
    critical: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].Critical,
    none: __WEBPACK_IMPORTED_MODULE_3__ILogger__["a" /* LogLevel */].None,
};
function parseLogLevel(name) {
    // Case-insensitive matching via lower-casing
    // Yes, I know case-folding is a complicated problem in Unicode, but we only support
    // the ASCII strings defined in LogLevelNameMapping anyway, so it's fine -anurse.
    var mapping = LogLevelNameMapping[name.toLowerCase()];
    if (typeof mapping !== "undefined") {
        return mapping;
    }
    else {
        throw new Error("Unknown log level: " + name);
    }
}
/** A builder for configuring {@link @microsoft/signalr.HubConnection} instances. */
var HubConnectionBuilder = /** @class */ (function () {
    function HubConnectionBuilder() {
    }
    HubConnectionBuilder.prototype.configureLogging = function (logging) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(logging, "logging");
        if (isLogger(logging)) {
            this.logger = logging;
        }
        else if (typeof logging === "string") {
            var logLevel = parseLogLevel(logging);
            this.logger = new __WEBPACK_IMPORTED_MODULE_6__Utils__["b" /* ConsoleLogger */](logLevel);
        }
        else {
            this.logger = new __WEBPACK_IMPORTED_MODULE_6__Utils__["b" /* ConsoleLogger */](logging);
        }
        return this;
    };
    HubConnectionBuilder.prototype.withUrl = function (url, transportTypeOrOptions) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(url, "url");
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isNotEmpty(url, "url");
        this.url = url;
        // Flow-typing knows where it's at. Since HttpTransportType is a number and IHttpConnectionOptions is guaranteed
        // to be an object, we know (as does TypeScript) this comparison is all we need to figure out which overload was called.
        if (typeof transportTypeOrOptions === "object") {
            this.httpConnectionOptions = __assign({}, this.httpConnectionOptions, transportTypeOrOptions);
        }
        else {
            this.httpConnectionOptions = __assign({}, this.httpConnectionOptions, { transport: transportTypeOrOptions });
        }
        return this;
    };
    /** Configures the {@link @microsoft/signalr.HubConnection} to use the specified Hub Protocol.
     *
     * @param {IHubProtocol} protocol The {@link @microsoft/signalr.IHubProtocol} implementation to use.
     */
    HubConnectionBuilder.prototype.withHubProtocol = function (protocol) {
        __WEBPACK_IMPORTED_MODULE_6__Utils__["a" /* Arg */].isRequired(protocol, "protocol");
        this.protocol = protocol;
        return this;
    };
    HubConnectionBuilder.prototype.withAutomaticReconnect = function (retryDelaysOrReconnectPolicy) {
        if (this.reconnectPolicy) {
            throw new Error("A reconnectPolicy has already been set.");
        }
        if (!retryDelaysOrReconnectPolicy) {
            this.reconnectPolicy = new __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__["a" /* DefaultReconnectPolicy */]();
        }
        else if (Array.isArray(retryDelaysOrReconnectPolicy)) {
            this.reconnectPolicy = new __WEBPACK_IMPORTED_MODULE_0__DefaultReconnectPolicy__["a" /* DefaultReconnectPolicy */](retryDelaysOrReconnectPolicy);
        }
        else {
            this.reconnectPolicy = retryDelaysOrReconnectPolicy;
        }
        return this;
    };
    /** Creates a {@link @microsoft/signalr.HubConnection} from the configuration options specified in this builder.
     *
     * @returns {HubConnection} The configured {@link @microsoft/signalr.HubConnection}.
     */
    HubConnectionBuilder.prototype.build = function () {
        // If httpConnectionOptions has a logger, use it. Otherwise, override it with the one
        // provided to configureLogger
        var httpConnectionOptions = this.httpConnectionOptions || {};
        // If it's 'null', the user **explicitly** asked for null, don't mess with it.
        if (httpConnectionOptions.logger === undefined) {
            // If our logger is undefined or null, that's OK, the HttpConnection constructor will handle it.
            httpConnectionOptions.logger = this.logger;
        }
        // Now create the connection
        if (!this.url) {
            throw new Error("The 'HubConnectionBuilder.withUrl' method must be called before building the connection.");
        }
        var connection = new __WEBPACK_IMPORTED_MODULE_1__HttpConnection__["a" /* HttpConnection */](this.url, httpConnectionOptions);
        return __WEBPACK_IMPORTED_MODULE_2__HubConnection__["a" /* HubConnection */].create(connection, this.logger || __WEBPACK_IMPORTED_MODULE_5__Loggers__["a" /* NullLogger */].instance, this.protocol || new __WEBPACK_IMPORTED_MODULE_4__JsonHubProtocol__["a" /* JsonHubProtocol */](), this.reconnectPolicy);
    };
    return HubConnectionBuilder;
}());

function isLogger(logger) {
    return logger.log !== undefined;
}
//# sourceMappingURL=HubConnectionBuilder.js.map

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultReconnectPolicy; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// 0, 2, 10, 30 second delays before reconnect attempts.
var DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000, null];
/** @private */
var DefaultReconnectPolicy = /** @class */ (function () {
    function DefaultReconnectPolicy(retryDelays) {
        this.retryDelays = retryDelays !== undefined ? retryDelays.concat([null]) : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
    }
    DefaultReconnectPolicy.prototype.nextRetryDelayInMilliseconds = function (retryContext) {
        return this.retryDelays[retryContext.previousRetryCount];
    };
    return DefaultReconnectPolicy;
}());

//# sourceMappingURL=DefaultReconnectPolicy.js.map

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpConnection; });
/* unused harmony export TransportSendQueue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DefaultHttpClient__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ITransport__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ServerSentEventsTransport__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__WebSocketTransport__ = __webpack_require__(282);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};







var MAX_REDIRECTS = 100;
/** @private */
var HttpConnection = /** @class */ (function () {
    function HttpConnection(url, options) {
        if (options === void 0) { options = {}; }
        this.features = {};
        this.negotiateVersion = 1;
        __WEBPACK_IMPORTED_MODULE_5__Utils__["a" /* Arg */].isRequired(url, "url");
        this.logger = Object(__WEBPACK_IMPORTED_MODULE_5__Utils__["e" /* createLogger */])(options.logger);
        this.baseUrl = this.resolveUrl(url);
        options = options || {};
        options.logMessageContent = options.logMessageContent === undefined ? false : options.logMessageContent;
        if (typeof options.withCredentials === "boolean" || options.withCredentials === undefined) {
            options.withCredentials = options.withCredentials === undefined ? true : options.withCredentials;
        }
        else {
            throw new Error("withCredentials option was not a 'boolean' or 'undefined' value");
        }
        var webSocketModule = null;
        var eventSourceModule = null;
        if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && "function" !== "undefined") {
            // In order to ignore the dynamic require in webpack builds we need to do this magic
            // @ts-ignore: TS doesn't know about these names
            var requireFunc =  true ? require : require;
            webSocketModule = requireFunc("ws");
            eventSourceModule = requireFunc("eventsource");
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && typeof WebSocket !== "undefined" && !options.WebSocket) {
            options.WebSocket = WebSocket;
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && !options.WebSocket) {
            if (webSocketModule) {
                options.WebSocket = webSocketModule;
            }
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && typeof EventSource !== "undefined" && !options.EventSource) {
            options.EventSource = EventSource;
        }
        else if (__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isNode && !options.EventSource) {
            if (typeof eventSourceModule !== "undefined") {
                options.EventSource = eventSourceModule;
            }
        }
        this.httpClient = options.httpClient || new __WEBPACK_IMPORTED_MODULE_0__DefaultHttpClient__["a" /* DefaultHttpClient */](this.logger);
        this.connectionState = "Disconnected" /* Disconnected */;
        this.connectionStarted = false;
        this.options = options;
        this.onreceive = null;
        this.onclose = null;
    }
    HttpConnection.prototype.start = function (transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var message, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        transferFormat = transferFormat || __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */].Binary;
                        __WEBPACK_IMPORTED_MODULE_5__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Starting connection with transfer format '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][transferFormat] + "'.");
                        if (this.connectionState !== "Disconnected" /* Disconnected */) {
                            return [2 /*return*/, Promise.reject(new Error("Cannot start an HttpConnection that is not in the 'Disconnected' state."))];
                        }
                        this.connectionState = "Connecting" /* Connecting */;
                        this.startInternalPromise = this.startInternal(transferFormat);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 1:
                        _a.sent();
                        if (!(this.connectionState === "Disconnecting" /* Disconnecting */)) return [3 /*break*/, 3];
                        message = "Failed to start the HttpConnection before stop() was called.";
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, message);
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        // We cannot await stopPromise inside startInternal since stopInternal awaits the startInternalPromise.
                        _a.sent();
                        return [2 /*return*/, Promise.reject(new Error(message))];
                    case 3:
                        if (this.connectionState !== "Connected" /* Connected */) {
                            message = "HttpConnection.startInternal completed gracefully but didn't enter the connection into the connected state!";
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        _a.label = 4;
                    case 4:
                        this.connectionStarted = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.send = function (data) {
        if (this.connectionState !== "Connected" /* Connected */) {
            return Promise.reject(new Error("Cannot send data if the connection is not in the 'Connected' State."));
        }
        if (!this.sendQueue) {
            this.sendQueue = new TransportSendQueue(this.transport);
        }
        // Transport will not be null if state is connected
        return this.sendQueue.send(data);
    };
    HttpConnection.prototype.stop = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.connectionState === "Disconnected" /* Disconnected */) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnected state.");
                            return [2 /*return*/, Promise.resolve()];
                        }
                        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stop(" + error + ") ignored because the connection is already in the disconnecting state.");
                            return [2 /*return*/, this.stopPromise];
                        }
                        this.connectionState = "Disconnecting" /* Disconnecting */;
                        this.stopPromise = new Promise(function (resolve) {
                            // Don't complete stop() until stopConnection() completes.
                            _this.stopPromiseResolver = resolve;
                        });
                        // stopInternal should never throw so just observe it.
                        return [4 /*yield*/, this.stopInternal(error)];
                    case 1:
                        // stopInternal should never throw so just observe it.
                        _a.sent();
                        return [4 /*yield*/, this.stopPromise];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.stopInternal = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // Set error as soon as possible otherwise there is a race between
                        // the transport closing and providing an error and the error from a close message
                        // We would prefer the close message error.
                        this.stopError = error;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.startInternalPromise];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        return [3 /*break*/, 4];
                    case 4:
                        if (!this.transport) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.transport.stop()];
                    case 6:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "HttpConnection.transport.stop() threw error '" + e_2 + "'.");
                        this.stopConnection();
                        return [3 /*break*/, 8];
                    case 8:
                        this.transport = undefined;
                        return [3 /*break*/, 10];
                    case 9:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "HttpConnection.transport is undefined in HttpConnection.stop() because start() failed.");
                        this.stopConnection();
                        _a.label = 10;
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.startInternal = function (transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var url, negotiateResponse, redirects, _loop_1, this_1, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.baseUrl;
                        this.accessTokenFactory = this.options.accessTokenFactory;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 12, , 13]);
                        if (!this.options.skipNegotiation) return [3 /*break*/, 5];
                        if (!(this.options.transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets)) return [3 /*break*/, 3];
                        // No need to add a connection ID in this case
                        this.transport = this.constructTransport(__WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets);
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        return [4 /*yield*/, this.startTransport(url, transferFormat)];
                    case 2:
                        // We should just call connect directly in this case.
                        // No fallback or negotiate in this case.
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3: throw new Error("Negotiation can only be skipped when using the WebSocket transport directly.");
                    case 4: return [3 /*break*/, 11];
                    case 5:
                        negotiateResponse = null;
                        redirects = 0;
                        _loop_1 = function () {
                            var accessToken_1;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, this_1.getNegotiationResponse(url)];
                                    case 1:
                                        negotiateResponse = _a.sent();
                                        // the user tries to stop the connection when it is being started
                                        if (this_1.connectionState === "Disconnecting" /* Disconnecting */ || this_1.connectionState === "Disconnected" /* Disconnected */) {
                                            throw new Error("The connection was stopped during negotiation.");
                                        }
                                        if (negotiateResponse.error) {
                                            throw new Error(negotiateResponse.error);
                                        }
                                        if (negotiateResponse.ProtocolVersion) {
                                            throw new Error("Detected a connection attempt to an ASP.NET SignalR Server. This client only supports connecting to an ASP.NET Core SignalR Server. See https://aka.ms/signalr-core-differences for details.");
                                        }
                                        if (negotiateResponse.url) {
                                            url = negotiateResponse.url;
                                        }
                                        if (negotiateResponse.accessToken) {
                                            accessToken_1 = negotiateResponse.accessToken;
                                            this_1.accessTokenFactory = function () { return accessToken_1; };
                                        }
                                        redirects++;
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 6;
                    case 6: return [5 /*yield**/, _loop_1()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        if (negotiateResponse.url && redirects < MAX_REDIRECTS) return [3 /*break*/, 6];
                        _a.label = 9;
                    case 9:
                        if (redirects === MAX_REDIRECTS && negotiateResponse.url) {
                            throw new Error("Negotiate redirection limit exceeded.");
                        }
                        return [4 /*yield*/, this.createTransport(url, this.options.transport, negotiateResponse, transferFormat)];
                    case 10:
                        _a.sent();
                        _a.label = 11;
                    case 11:
                        if (this.transport instanceof __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__["a" /* LongPollingTransport */]) {
                            this.features.inherentKeepAlive = true;
                        }
                        if (this.connectionState === "Connecting" /* Connecting */) {
                            // Ensure the connection transitions to the connected state prior to completing this.startInternalPromise.
                            // start() will handle the case when stop was called and startInternal exits still in the disconnecting state.
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "The HttpConnection connected successfully.");
                            this.connectionState = "Connected" /* Connected */;
                        }
                        return [3 /*break*/, 13];
                    case 12:
                        e_3 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to start the connection: " + e_3);
                        this.connectionState = "Disconnected" /* Disconnected */;
                        this.transport = undefined;
                        return [2 /*return*/, Promise.reject(e_3)];
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.getNegotiationResponse = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, token, _a, name, value, negotiateUrl, response, negotiateResponse, e_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headers = {};
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _b.sent();
                        if (token) {
                            headers["Authorization"] = "Bearer " + token;
                        }
                        _b.label = 2;
                    case 2:
                        _a = Object(__WEBPACK_IMPORTED_MODULE_5__Utils__["g" /* getUserAgentHeader */])(), name = _a[0], value = _a[1];
                        headers[name] = value;
                        negotiateUrl = this.resolveNegotiateUrl(url);
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Sending negotiation request: " + negotiateUrl + ".");
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this.httpClient.post(negotiateUrl, {
                                content: "",
                                headers: __assign({}, headers, this.options.headers),
                                withCredentials: this.options.withCredentials,
                            })];
                    case 4:
                        response = _b.sent();
                        if (response.statusCode !== 200) {
                            return [2 /*return*/, Promise.reject(new Error("Unexpected status code returned from negotiate '" + response.statusCode + "'"))];
                        }
                        negotiateResponse = JSON.parse(response.content);
                        if (!negotiateResponse.negotiateVersion || negotiateResponse.negotiateVersion < 1) {
                            // Negotiate version 0 doesn't use connectionToken
                            // So we set it equal to connectionId so all our logic can use connectionToken without being aware of the negotiate version
                            negotiateResponse.connectionToken = negotiateResponse.connectionId;
                        }
                        return [2 /*return*/, negotiateResponse];
                    case 5:
                        e_4 = _b.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to complete negotiation with the server: " + e_4);
                        return [2 /*return*/, Promise.reject(e_4)];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    HttpConnection.prototype.createConnectUrl = function (url, connectionToken) {
        if (!connectionToken) {
            return url;
        }
        return url + (url.indexOf("?") === -1 ? "?" : "&") + ("id=" + connectionToken);
    };
    HttpConnection.prototype.createTransport = function (url, requestedTransport, negotiateResponse, requestedTransferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var connectUrl, transportExceptions, transports, negotiate, _i, transports_1, endpoint, transportOrError, ex_1, ex_2, message;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        connectUrl = this.createConnectUrl(url, negotiateResponse.connectionToken);
                        if (!this.isITransport(requestedTransport)) return [3 /*break*/, 2];
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Connection was provided an instance of ITransport, using that directly.");
                        this.transport = requestedTransport;
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 1:
                        _a.sent();
                        this.connectionId = negotiateResponse.connectionId;
                        return [2 /*return*/];
                    case 2:
                        transportExceptions = [];
                        transports = negotiateResponse.availableTransports || [];
                        negotiate = negotiateResponse;
                        _i = 0, transports_1 = transports;
                        _a.label = 3;
                    case 3:
                        if (!(_i < transports_1.length)) return [3 /*break*/, 13];
                        endpoint = transports_1[_i];
                        transportOrError = this.resolveTransportOrError(endpoint, requestedTransport, requestedTransferFormat);
                        if (!(transportOrError instanceof Error)) return [3 /*break*/, 4];
                        // Store the error and continue, we don't want to cause a re-negotiate in these cases
                        transportExceptions.push(endpoint.transport + " failed: " + transportOrError);
                        return [3 /*break*/, 12];
                    case 4:
                        if (!this.isITransport(transportOrError)) return [3 /*break*/, 12];
                        this.transport = transportOrError;
                        if (!!negotiate) return [3 /*break*/, 9];
                        _a.label = 5;
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.getNegotiationResponse(url)];
                    case 6:
                        negotiate = _a.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        ex_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_1)];
                    case 8:
                        connectUrl = this.createConnectUrl(url, negotiate.connectionToken);
                        _a.label = 9;
                    case 9:
                        _a.trys.push([9, 11, , 12]);
                        return [4 /*yield*/, this.startTransport(connectUrl, requestedTransferFormat)];
                    case 10:
                        _a.sent();
                        this.connectionId = negotiate.connectionId;
                        return [2 /*return*/];
                    case 11:
                        ex_2 = _a.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Failed to start the transport '" + endpoint.transport + "': " + ex_2);
                        negotiate = undefined;
                        transportExceptions.push(endpoint.transport + " failed: " + ex_2);
                        if (this.connectionState !== "Connecting" /* Connecting */) {
                            message = "Failed to select transport before stop() was called.";
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, message);
                            return [2 /*return*/, Promise.reject(new Error(message))];
                        }
                        return [3 /*break*/, 12];
                    case 12:
                        _i++;
                        return [3 /*break*/, 3];
                    case 13:
                        if (transportExceptions.length > 0) {
                            return [2 /*return*/, Promise.reject(new Error("Unable to connect to the server with any of the available transports. " + transportExceptions.join(" ")))];
                        }
                        return [2 /*return*/, Promise.reject(new Error("None of the transports supported by the client are supported by the server."))];
                }
            });
        });
    };
    HttpConnection.prototype.constructTransport = function (transport) {
        switch (transport) {
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets:
                if (!this.options.WebSocket) {
                    throw new Error("'WebSocket' is not supported in your environment.");
                }
                return new __WEBPACK_IMPORTED_MODULE_6__WebSocketTransport__["a" /* WebSocketTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.WebSocket, this.options.headers || {});
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].ServerSentEvents:
                if (!this.options.EventSource) {
                    throw new Error("'EventSource' is not supported in your environment.");
                }
                return new __WEBPACK_IMPORTED_MODULE_4__ServerSentEventsTransport__["a" /* ServerSentEventsTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.EventSource, this.options.withCredentials, this.options.headers || {});
            case __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].LongPolling:
                return new __WEBPACK_IMPORTED_MODULE_3__LongPollingTransport__["a" /* LongPollingTransport */](this.httpClient, this.accessTokenFactory, this.logger, this.options.logMessageContent || false, this.options.withCredentials, this.options.headers || {});
            default:
                throw new Error("Unknown transport: " + transport + ".");
        }
    };
    HttpConnection.prototype.startTransport = function (url, transferFormat) {
        var _this = this;
        this.transport.onreceive = this.onreceive;
        this.transport.onclose = function (e) { return _this.stopConnection(e); };
        return this.transport.connect(url, transferFormat);
    };
    HttpConnection.prototype.resolveTransportOrError = function (endpoint, requestedTransport, requestedTransferFormat) {
        var transport = __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][endpoint.transport];
        if (transport === null || transport === undefined) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
            return new Error("Skipping transport '" + endpoint.transport + "' because it is not supported by this client.");
        }
        else {
            if (transportMatches(requestedTransport, transport)) {
                var transferFormats = endpoint.transferFormats.map(function (s) { return __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][s]; });
                if (transferFormats.indexOf(requestedTransferFormat) >= 0) {
                    if ((transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].WebSockets && !this.options.WebSocket) ||
                        (transport === __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */].ServerSentEvents && !this.options.EventSource)) {
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it is not supported in your environment.'");
                        return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' is not supported in your environment.");
                    }
                    else {
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Selecting transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "'.");
                        try {
                            return this.constructTransport(transport);
                        }
                        catch (ex) {
                            return ex;
                        }
                    }
                }
                else {
                    this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it does not support the requested transfer format '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][requestedTransferFormat] + "'.");
                    return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' does not support " + __WEBPACK_IMPORTED_MODULE_2__ITransport__["b" /* TransferFormat */][requestedTransferFormat] + ".");
                }
            }
            else {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Skipping transport '" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' because it was disabled by the client.");
                return new Error("'" + __WEBPACK_IMPORTED_MODULE_2__ITransport__["a" /* HttpTransportType */][transport] + "' is disabled by the client.");
            }
        }
    };
    HttpConnection.prototype.isITransport = function (transport) {
        return transport && typeof (transport) === "object" && "connect" in transport;
    };
    HttpConnection.prototype.stopConnection = function (error) {
        var _this = this;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "HttpConnection.stopConnection(" + error + ") called while in state " + this.connectionState + ".");
        this.transport = undefined;
        // If we have a stopError, it takes precedence over the error from the transport
        error = this.stopError || error;
        this.stopError = undefined;
        if (this.connectionState === "Disconnected" /* Disconnected */) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Debug, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection is already in the disconnected state.");
            return;
        }
        if (this.connectionState === "Connecting" /* Connecting */) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Warning, "Call to HttpConnection.stopConnection(" + error + ") was ignored because the connection is still in the connecting state.");
            throw new Error("HttpConnection.stopConnection(" + error + ") was called while the connection is still in the connecting state.");
        }
        if (this.connectionState === "Disconnecting" /* Disconnecting */) {
            // A call to stop() induced this call to stopConnection and needs to be completed.
            // Any stop() awaiters will be scheduled to continue after the onclose callback fires.
            this.stopPromiseResolver();
        }
        if (error) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "Connection disconnected with error '" + error + "'.");
        }
        else {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Connection disconnected.");
        }
        if (this.sendQueue) {
            this.sendQueue.stop().catch(function (e) {
                _this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "TransportSendQueue.stop() threw error '" + e + "'.");
            });
            this.sendQueue = undefined;
        }
        this.connectionId = undefined;
        this.connectionState = "Disconnected" /* Disconnected */;
        if (this.connectionStarted) {
            this.connectionStarted = false;
            try {
                if (this.onclose) {
                    this.onclose(error);
                }
            }
            catch (e) {
                this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Error, "HttpConnection.onclose(" + error + ") threw error '" + e + "'.");
            }
        }
    };
    HttpConnection.prototype.resolveUrl = function (url) {
        // startsWith is not supported in IE
        if (url.lastIndexOf("https://", 0) === 0 || url.lastIndexOf("http://", 0) === 0) {
            return url;
        }
        if (!__WEBPACK_IMPORTED_MODULE_5__Utils__["c" /* Platform */].isBrowser || !window.document) {
            throw new Error("Cannot resolve '" + url + "'.");
        }
        // Setting the url to the href propery of an anchor tag handles normalization
        // for us. There are 3 main cases.
        // 1. Relative path normalization e.g "b" -> "http://localhost:5000/a/b"
        // 2. Absolute path normalization e.g "/a/b" -> "http://localhost:5000/a/b"
        // 3. Networkpath reference normalization e.g "//localhost:5000/a/b" -> "http://localhost:5000/a/b"
        var aTag = window.document.createElement("a");
        aTag.href = url;
        this.logger.log(__WEBPACK_IMPORTED_MODULE_1__ILogger__["a" /* LogLevel */].Information, "Normalizing '" + url + "' to '" + aTag.href + "'.");
        return aTag.href;
    };
    HttpConnection.prototype.resolveNegotiateUrl = function (url) {
        var index = url.indexOf("?");
        var negotiateUrl = url.substring(0, index === -1 ? url.length : index);
        if (negotiateUrl[negotiateUrl.length - 1] !== "/") {
            negotiateUrl += "/";
        }
        negotiateUrl += "negotiate";
        negotiateUrl += index === -1 ? "" : url.substring(index);
        if (negotiateUrl.indexOf("negotiateVersion") === -1) {
            negotiateUrl += index === -1 ? "?" : "&";
            negotiateUrl += "negotiateVersion=" + this.negotiateVersion;
        }
        return negotiateUrl;
    };
    return HttpConnection;
}());

function transportMatches(requestedTransport, actualTransport) {
    return !requestedTransport || ((actualTransport & requestedTransport) !== 0);
}
/** @private */
var TransportSendQueue = /** @class */ (function () {
    function TransportSendQueue(transport) {
        this.transport = transport;
        this.buffer = [];
        this.executing = true;
        this.sendBufferedData = new PromiseSource();
        this.transportResult = new PromiseSource();
        this.sendLoopPromise = this.sendLoop();
    }
    TransportSendQueue.prototype.send = function (data) {
        this.bufferData(data);
        if (!this.transportResult) {
            this.transportResult = new PromiseSource();
        }
        return this.transportResult.promise;
    };
    TransportSendQueue.prototype.stop = function () {
        this.executing = false;
        this.sendBufferedData.resolve();
        return this.sendLoopPromise;
    };
    TransportSendQueue.prototype.bufferData = function (data) {
        if (this.buffer.length && typeof (this.buffer[0]) !== typeof (data)) {
            throw new Error("Expected data to be of type " + typeof (this.buffer) + " but was of type " + typeof (data));
        }
        this.buffer.push(data);
        this.sendBufferedData.resolve();
    };
    TransportSendQueue.prototype.sendLoop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var transportResult, data, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (false) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.sendBufferedData.promise];
                    case 1:
                        _a.sent();
                        if (!this.executing) {
                            if (this.transportResult) {
                                this.transportResult.reject("Connection stopped.");
                            }
                            return [3 /*break*/, 6];
                        }
                        this.sendBufferedData = new PromiseSource();
                        transportResult = this.transportResult;
                        this.transportResult = undefined;
                        data = typeof (this.buffer[0]) === "string" ?
                            this.buffer.join("") :
                            TransportSendQueue.concatBuffers(this.buffer);
                        this.buffer.length = 0;
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.transport.send(data)];
                    case 3:
                        _a.sent();
                        transportResult.resolve();
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        transportResult.reject(error_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    TransportSendQueue.concatBuffers = function (arrayBuffers) {
        var totalLength = arrayBuffers.map(function (b) { return b.byteLength; }).reduce(function (a, b) { return a + b; });
        var result = new Uint8Array(totalLength);
        var offset = 0;
        for (var _i = 0, arrayBuffers_1 = arrayBuffers; _i < arrayBuffers_1.length; _i++) {
            var item = arrayBuffers_1[_i];
            result.set(new Uint8Array(item), offset);
            offset += item.byteLength;
        }
        return result.buffer;
    };
    return TransportSendQueue;
}());

var PromiseSource = /** @class */ (function () {
    function PromiseSource() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            var _a;
            return _a = [resolve, reject], _this.resolver = _a[0], _this.rejecter = _a[1], _a;
        });
    }
    PromiseSource.prototype.resolve = function () {
        this.resolver();
    };
    PromiseSource.prototype.reject = function (reason) {
        this.rejecter(reason);
    };
    return PromiseSource;
}());
//# sourceMappingURL=HttpConnection.js.map

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LongPollingTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AbortController__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Errors__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ITransport__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};





// Not exported from 'index', this type is internal.
/** @private */
var LongPollingTransport = /** @class */ (function () {
    function LongPollingTransport(httpClient, accessTokenFactory, logger, logMessageContent, withCredentials, headers) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.pollAbort = new __WEBPACK_IMPORTED_MODULE_0__AbortController__["a" /* AbortController */]();
        this.logMessageContent = logMessageContent;
        this.withCredentials = withCredentials;
        this.headers = headers;
        this.running = false;
        this.onreceive = null;
        this.onclose = null;
    }
    Object.defineProperty(LongPollingTransport.prototype, "pollAborted", {
        // This is an internal type, not exported from 'index' so this is really just internal.
        get: function () {
            return this.pollAbort.aborted;
        },
        enumerable: true,
        configurable: true
    });
    LongPollingTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, name, value, headers, pollOptions, token, pollUrl, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_4__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.url = url;
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Connecting.");
                        // Allow binary format on Node and Browsers that support binary content (indicated by the presence of responseType property)
                        if (transferFormat === __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */].Binary &&
                            (typeof XMLHttpRequest !== "undefined" && typeof new XMLHttpRequest().responseType !== "string")) {
                            throw new Error("Binary protocols over XmlHttpRequest not implementing advanced features are not supported.");
                        }
                        _b = Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["g" /* getUserAgentHeader */])(), name = _b[0], value = _b[1];
                        headers = __assign((_a = {}, _a[name] = value, _a), this.headers);
                        pollOptions = {
                            abortSignal: this.pollAbort.signal,
                            headers: headers,
                            timeout: 100000,
                            withCredentials: this.withCredentials,
                        };
                        if (transferFormat === __WEBPACK_IMPORTED_MODULE_3__ITransport__["b" /* TransferFormat */].Binary) {
                            pollOptions.responseType = "arraybuffer";
                        }
                        return [4 /*yield*/, this.getAccessToken()];
                    case 1:
                        token = _c.sent();
                        this.updateHeaderToken(pollOptions, token);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 2:
                        response = _c.sent();
                        if (response.statusCode !== 200) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Mark running as false so that the poll immediately ends and runs the close logic
                            this.closeError = new __WEBPACK_IMPORTED_MODULE_1__Errors__["b" /* HttpError */](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            this.running = true;
                        }
                        this.receiving = this.poll(this.url, pollOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.getAccessToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2: return [2 /*return*/, null];
                }
            });
        });
    };
    LongPollingTransport.prototype.updateHeaderToken = function (request, token) {
        if (!request.headers) {
            request.headers = {};
        }
        if (token) {
            // tslint:disable-next-line:no-string-literal
            request.headers["Authorization"] = "Bearer " + token;
            return;
        }
        // tslint:disable-next-line:no-string-literal
        if (request.headers["Authorization"]) {
            // tslint:disable-next-line:no-string-literal
            delete request.headers["Authorization"];
        }
    };
    LongPollingTransport.prototype.poll = function (url, pollOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var token, pollUrl, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, , 8, 9]);
                        _a.label = 1;
                    case 1:
                        if (!this.running) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.getAccessToken()];
                    case 2:
                        token = _a.sent();
                        this.updateHeaderToken(pollOptions, token);
                        _a.label = 3;
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        pollUrl = url + "&_=" + Date.now();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) polling: " + pollUrl + ".");
                        return [4 /*yield*/, this.httpClient.get(pollUrl, pollOptions)];
                    case 4:
                        response = _a.sent();
                        if (response.statusCode === 204) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Information, "(LongPolling transport) Poll terminated by server.");
                            this.running = false;
                        }
                        else if (response.statusCode !== 200) {
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Error, "(LongPolling transport) Unexpected response code: " + response.statusCode + ".");
                            // Unexpected status code
                            this.closeError = new __WEBPACK_IMPORTED_MODULE_1__Errors__["b" /* HttpError */](response.statusText || "", response.statusCode);
                            this.running = false;
                        }
                        else {
                            // Process the response
                            if (response.content) {
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["f" /* getDataDetail */])(response.content, this.logMessageContent) + ".");
                                if (this.onreceive) {
                                    this.onreceive(response.content);
                                }
                            }
                            else {
                                // This is another way timeout manifest.
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        if (!this.running) {
                            // Log but disregard errors that occur after stopping
                            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll errored after shutdown: " + e_1.message);
                        }
                        else {
                            if (e_1 instanceof __WEBPACK_IMPORTED_MODULE_1__Errors__["c" /* TimeoutError */]) {
                                // Ignore timeouts and reissue the poll.
                                this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Poll timed out, reissuing.");
                            }
                            else {
                                // Close the connection with the error as the result.
                                this.closeError = e_1;
                                this.running = false;
                            }
                        }
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Polling complete.");
                        // We will reach here with pollAborted==false when the server returned a response causing the transport to stop.
                        // If pollAborted==true then client initiated the stop and the stop method will raise the close event after DELETE is sent.
                        if (!this.pollAborted) {
                            this.raiseOnClose();
                        }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.running) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["i" /* sendMessage */])(this.logger, "LongPolling", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent, this.withCredentials, this.headers)];
            });
        });
    };
    LongPollingTransport.prototype.stop = function () {
        return __awaiter(this, void 0, void 0, function () {
            var headers, _a, name_1, value, deleteOptions, token;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Stopping polling.");
                        // Tell receiving loop to stop, abort any current request, and then wait for it to finish
                        this.running = false;
                        this.pollAbort.abort();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 5, 6]);
                        return [4 /*yield*/, this.receiving];
                    case 2:
                        _b.sent();
                        // Send DELETE to clean up long polling on the server
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) sending DELETE request to " + this.url + ".");
                        headers = {};
                        _a = Object(__WEBPACK_IMPORTED_MODULE_4__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                        headers[name_1] = value;
                        deleteOptions = {
                            headers: __assign({}, headers, this.headers),
                            withCredentials: this.withCredentials,
                        };
                        return [4 /*yield*/, this.getAccessToken()];
                    case 3:
                        token = _b.sent();
                        this.updateHeaderToken(deleteOptions, token);
                        return [4 /*yield*/, this.httpClient.delete(this.url, deleteOptions)];
                    case 4:
                        _b.sent();
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) DELETE request sent.");
                        return [3 /*break*/, 6];
                    case 5:
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, "(LongPolling transport) Stop finished.");
                        // Raise close event here instead of in polling
                        // It needs to happen after the DELETE request is sent
                        this.raiseOnClose();
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    LongPollingTransport.prototype.raiseOnClose = function () {
        if (this.onclose) {
            var logMessage = "(LongPolling transport) Firing onclose event.";
            if (this.closeError) {
                logMessage += " Error: " + this.closeError;
            }
            this.logger.log(__WEBPACK_IMPORTED_MODULE_2__ILogger__["a" /* LogLevel */].Trace, logMessage);
            this.onclose(this.closeError);
        }
    };
    return LongPollingTransport;
}());

//# sourceMappingURL=LongPollingTransport.js.map

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbortController; });
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
// Rough polyfill of https://developer.mozilla.org/en-US/docs/Web/API/AbortController
// We don't actually ever use the API being polyfilled, we always use the polyfill because
// it's a very new API right now.
// Not exported from index.
/** @private */
var AbortController = /** @class */ (function () {
    function AbortController() {
        this.isAborted = false;
        this.onabort = null;
    }
    AbortController.prototype.abort = function () {
        if (!this.isAborted) {
            this.isAborted = true;
            if (this.onabort) {
                this.onabort();
            }
        }
    };
    Object.defineProperty(AbortController.prototype, "signal", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbortController.prototype, "aborted", {
        get: function () {
            return this.isAborted;
        },
        enumerable: true,
        configurable: true
    });
    return AbortController;
}());

//# sourceMappingURL=AbortController.js.map

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServerSentEventsTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ITransport__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var ServerSentEventsTransport = /** @class */ (function () {
    function ServerSentEventsTransport(httpClient, accessTokenFactory, logger, logMessageContent, eventSourceConstructor, withCredentials, headers) {
        this.httpClient = httpClient;
        this.accessTokenFactory = accessTokenFactory;
        this.logger = logger;
        this.logMessageContent = logMessageContent;
        this.withCredentials = withCredentials;
        this.eventSourceConstructor = eventSourceConstructor;
        this.headers = headers;
        this.onreceive = null;
        this.onclose = null;
    }
    ServerSentEventsTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(SSE transport) Connecting.");
                        // set url before accessTokenFactory because this.url is only for send and we set the auth header instead of the query string for send
                        this.url = url;
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            var opened = false;
                            if (transferFormat !== __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */].Text) {
                                reject(new Error("The Server-Sent Events transport only supports the 'Text' transfer format"));
                                return;
                            }
                            var eventSource;
                            if (__WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isBrowser || __WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isWebWorker) {
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: _this.withCredentials });
                            }
                            else {
                                // Non-browser passes cookies via the dictionary
                                var cookies = _this.httpClient.getCookieString(url);
                                var headers = {};
                                headers.Cookie = cookies;
                                var _a = Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                                headers[name_1] = value;
                                eventSource = new _this.eventSourceConstructor(url, { withCredentials: _this.withCredentials, headers: __assign({}, headers, _this.headers) });
                            }
                            try {
                                eventSource.onmessage = function (e) {
                                    if (_this.onreceive) {
                                        try {
                                            _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(SSE transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(e.data, _this.logMessageContent) + ".");
                                            _this.onreceive(e.data);
                                        }
                                        catch (error) {
                                            _this.close(error);
                                            return;
                                        }
                                    }
                                };
                                eventSource.onerror = function (e) {
                                    var error = new Error(e.data || "Error occurred");
                                    if (opened) {
                                        _this.close(error);
                                    }
                                    else {
                                        reject(error);
                                    }
                                };
                                eventSource.onopen = function () {
                                    _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information, "SSE connected to " + _this.url);
                                    _this.eventSource = eventSource;
                                    opened = true;
                                    resolve();
                                };
                            }
                            catch (e) {
                                reject(e);
                                return;
                            }
                        })];
                }
            });
        });
    };
    ServerSentEventsTransport.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.eventSource) {
                    return [2 /*return*/, Promise.reject(new Error("Cannot send until the transport is connected"))];
                }
                return [2 /*return*/, Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["i" /* sendMessage */])(this.logger, "SSE", this.httpClient, this.url, this.accessTokenFactory, data, this.logMessageContent, this.withCredentials, this.headers)];
            });
        });
    };
    ServerSentEventsTransport.prototype.stop = function () {
        this.close();
        return Promise.resolve();
    };
    ServerSentEventsTransport.prototype.close = function (e) {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = undefined;
            if (this.onclose) {
                this.onclose(e);
            }
        }
    };
    return ServerSentEventsTransport;
}());

//# sourceMappingURL=ServerSentEventsTransport.js.map

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebSocketTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ILogger__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ITransport__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utils__ = __webpack_require__(23);
// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/** @private */
var WebSocketTransport = /** @class */ (function () {
    function WebSocketTransport(httpClient, accessTokenFactory, logger, logMessageContent, webSocketConstructor, headers) {
        this.logger = logger;
        this.accessTokenFactory = accessTokenFactory;
        this.logMessageContent = logMessageContent;
        this.webSocketConstructor = webSocketConstructor;
        this.httpClient = httpClient;
        this.onreceive = null;
        this.onclose = null;
        this.headers = headers;
    }
    WebSocketTransport.prototype.connect = function (url, transferFormat) {
        return __awaiter(this, void 0, void 0, function () {
            var token;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(url, "url");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isRequired(transferFormat, "transferFormat");
                        __WEBPACK_IMPORTED_MODULE_2__Utils__["a" /* Arg */].isIn(transferFormat, __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */], "transferFormat");
                        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) Connecting.");
                        if (!this.accessTokenFactory) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.accessTokenFactory()];
                    case 1:
                        token = _a.sent();
                        if (token) {
                            url += (url.indexOf("?") < 0 ? "?" : "&") + ("access_token=" + encodeURIComponent(token));
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                            url = url.replace(/^http/, "ws");
                            var webSocket;
                            var cookies = _this.httpClient.getCookieString(url);
                            var opened = false;
                            if (__WEBPACK_IMPORTED_MODULE_2__Utils__["c" /* Platform */].isNode) {
                                var headers = {};
                                var _a = Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["g" /* getUserAgentHeader */])(), name_1 = _a[0], value = _a[1];
                                headers[name_1] = value;
                                if (cookies) {
                                    headers["Cookie"] = "" + cookies;
                                }
                                // Only pass headers when in non-browser environments
                                webSocket = new _this.webSocketConstructor(url, undefined, {
                                    headers: __assign({}, headers, _this.headers),
                                });
                            }
                            if (!webSocket) {
                                // Chrome is not happy with passing 'undefined' as protocol
                                webSocket = new _this.webSocketConstructor(url);
                            }
                            if (transferFormat === __WEBPACK_IMPORTED_MODULE_1__ITransport__["b" /* TransferFormat */].Binary) {
                                webSocket.binaryType = "arraybuffer";
                            }
                            // tslint:disable-next-line:variable-name
                            webSocket.onopen = function (_event) {
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Information, "WebSocket connected to " + url + ".");
                                _this.webSocket = webSocket;
                                opened = true;
                                resolve();
                            };
                            webSocket.onerror = function (event) {
                                var error = null;
                                // ErrorEvent is a browser only type we need to check if the type exists before using it
                                if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                    error = event.error;
                                }
                                else {
                                    error = new Error("There was an error with the transport.");
                                }
                                reject(error);
                            };
                            webSocket.onmessage = function (message) {
                                _this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) data received. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(message.data, _this.logMessageContent) + ".");
                                if (_this.onreceive) {
                                    try {
                                        _this.onreceive(message.data);
                                    }
                                    catch (error) {
                                        _this.close(error);
                                        return;
                                    }
                                }
                            };
                            webSocket.onclose = function (event) {
                                // Don't call close handler if connection was never established
                                // We'll reject the connect call instead
                                if (opened) {
                                    _this.close(event);
                                }
                                else {
                                    var error = null;
                                    // ErrorEvent is a browser only type we need to check if the type exists before using it
                                    if (typeof ErrorEvent !== "undefined" && event instanceof ErrorEvent) {
                                        error = event.error;
                                    }
                                    else {
                                        error = new Error("There was an error with the transport.");
                                    }
                                    reject(error);
                                }
                            };
                        })];
                }
            });
        });
    };
    WebSocketTransport.prototype.send = function (data) {
        if (this.webSocket && this.webSocket.readyState === this.webSocketConstructor.OPEN) {
            this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) sending data. " + Object(__WEBPACK_IMPORTED_MODULE_2__Utils__["f" /* getDataDetail */])(data, this.logMessageContent) + ".");
            this.webSocket.send(data);
            return Promise.resolve();
        }
        return Promise.reject("WebSocket is not in the OPEN state");
    };
    WebSocketTransport.prototype.stop = function () {
        if (this.webSocket) {
            // Manually invoke onclose callback inline so we know the HttpConnection was closed properly before returning
            // This also solves an issue where websocket.onclose could take 18+ seconds to trigger during network disconnects
            this.close(undefined);
        }
        return Promise.resolve();
    };
    WebSocketTransport.prototype.close = function (event) {
        // webSocket will be null if the transport did not start successfully
        if (this.webSocket) {
            // Clear websocket handlers because we are considering the socket closed now
            this.webSocket.onclose = function () { };
            this.webSocket.onmessage = function () { };
            this.webSocket.onerror = function () { };
            this.webSocket.close();
            this.webSocket = undefined;
        }
        this.logger.log(__WEBPACK_IMPORTED_MODULE_0__ILogger__["a" /* LogLevel */].Trace, "(WebSockets transport) socket closed.");
        if (this.onclose) {
            if (this.isCloseEvent(event) && (event.wasClean === false || event.code !== 1000)) {
                this.onclose(new Error("WebSocket closed with status code: " + event.code + " (" + event.reason + ")."));
            }
            else if (event instanceof Error) {
                this.onclose(event);
            }
            else {
                this.onclose();
            }
        }
    };
    WebSocketTransport.prototype.isCloseEvent = function (event) {
        return event && typeof event.wasClean === "boolean" && typeof event.code === "number";
    };
    return WebSocketTransport;
}());

//# sourceMappingURL=WebSocketTransport.js.map

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',{staticClass:"main-header",attrs:{"id":"main-header","name":"main-header"}},[_c('router-link',{staticClass:"logo",attrs:{"tag":"a","to":"/dashboard"}},[_c('span',{staticClass:"logo-mini"},[_c('img',{staticStyle:{"padding":"5px"},attrs:{"src":"/icon.png","width":"50","height":"50"}})]),_vm._v(" "),_c('span',{staticClass:"logo-lg",staticStyle:{"font-family":"Source Sans Pro, HelveticaNeue Condensed, Arial, Sans-Serif"}},[_c('img',{staticStyle:{"width":"200px"},attrs:{"src":"/brand-logo-horizontal.png"}})])]),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCompanies),expression:"isCompanies"}],staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_vm._v("\n              "+_vm._s(_vm.$ml.get('shared.company'))+"   \n              "),_c('i',{staticClass:"fa fa-angle-down"})]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('li',{staticClass:"dropdown messages-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown"}},[_c('i',{staticClass:"fa fa-bell"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalNotify > 0),expression:"totalNotify > 0"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.totalNotify))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu",staticStyle:{"background-color":"#ECF0F5"}},[_c('li',{staticClass:"header"},[_vm._v(_vm._s(_vm.$ml.get('shared.notifications')))]),_vm._v(" "),_c('li',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.notificationList.length > 0),expression:"notificationList.length > 0"}],staticClass:"menu"},_vm._l((_vm.notificationList),function(notify){return _c('li',{key:notify.id},[_c('a',[(notify.type == 'success')?_c('div',{staticClass:"pull-left yesil"},[_c('i',{staticClass:"fa fa-check"})]):_vm._e(),_vm._v(" "),(notify.type == 'warning')?_c('div',{staticClass:"pull-left turuncu"},[_c('i',{staticClass:"fa fa-warning"})]):_vm._e(),_vm._v(" "),(notify.type == 'danger')?_c('div',{staticClass:"pull-left kirmizi"},[_c('i',{staticClass:"fa fa-ban"})]):_vm._e(),_vm._v(" "),(notify.type == 'primary')?_c('div',{staticClass:"pull-left mavi"},[_c('i',{staticClass:"fa fa-info-circle"})]):_vm._e(),_vm._v(" "),_c('h4',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('shared.deviceCommunication'))+"\n                        "),_c('small',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v("\n                          "+_vm._s(notify.time)+"\n                        ")])]),_vm._v(" "),_c('p',[_vm._v(_vm._s(notify.description))])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.notificationList.length == 0),expression:"notificationList.length == 0"}],staticClass:"text-center"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.notificationNotFound')))])])]),_vm._v(" "),_c('li',{staticClass:"footer"},[_c('a',[_vm._v(_vm._s(_vm.$ml.get('shared.notificationView'))+" "+_vm._s(_vm.totalNotify))])])])]),_vm._v(" "),_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('img',{staticClass:"user-image",attrs:{"src":_vm.user.profileUrl == null || _vm.user.profileUrl == '' || _vm.user.profileUrl == 'null' ? '/src/assets/user.png' : _vm.user.profileUrl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.user.userName))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"user-header"},[_c('img',{staticClass:"img-circle",attrs:{"src":_vm.user.profileUrl == null || _vm.user.profileUrl == '' || _vm.user.profileUrl == 'null' ? '/src/assets/user.png' : _vm.user.profileUrl}}),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.user.userName))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.user.title))])])]),_vm._v(" "),_c('li',{staticClass:"user-footer"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('button',{staticClass:"btn btn-success",staticStyle:{"display":"inline-block"},on:{"click":function($event){$event.preventDefault();return _vm.goToMyProfile()}}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('shared.myProfile'))+"\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger pull-right",staticStyle:{"display":"inline-block"},on:{"click":function($event){$event.preventDefault();return _vm.logOut($event)}}},[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('shared.logOut'))+"\n                  ")])])])])]),_vm._v(" "),_vm._m(4)])])])],1),_vm._v(" "),_c('aside',{staticClass:"main-sidebar"},[_c('section',{staticClass:"sidebar"},[_c('div',{staticClass:"user-panel"},[_c('div',{staticClass:"pull-left image"},[_c('img',{staticClass:"img-circle",attrs:{"src":_vm.user.profileUrl == null || _vm.user.profileUrl == '' || _vm.user.profileUrl == 'null' ? '/src/assets/user.png' : _vm.user.profileUrl}})]),_vm._v(" "),_c('div',{staticClass:"pull-left info",staticStyle:{"white-space":"normal"}},[_c('p',[_vm._v(_vm._s(_vm.user.userName))]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.user.title))])])]),_vm._v(" "),_c('ul',{staticClass:"sidebar-menu",attrs:{"data-widget":"tree"}},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authMap.dashboard != 2),expression:"authMap.dashboard != 2"}]},[_c('router-link',{attrs:{"to":"/dashboard","tag":"a"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.canliIzleme)),expression:"authControl(authMap.canliIzleme)"}]},[_c('router-link',{attrs:{"to":"/real-time-monitor","tag":"a"}},[_c('i',{staticClass:"fa fa-video-camera"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.realTimeMonitor')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authMap.kisiler != 2),expression:"authMap.kisiler != 2"}]},[_c('router-link',{attrs:{"to":"/employees","tag":"a"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.employees')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/operations","tag":"a"}},[_c('i',{staticClass:"fa fa-th-large"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.batchOperations')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.raporlar)),expression:"authControl(authMap.raporlar)"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.raporlar)),expression:"authControl(authMap.raporlar)"}]},[_c('router-link',{attrs:{"to":"/reports","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.puantajYonetimi) && _vm.modules.payrollManagement),expression:"authControl(authMap.puantajYonetimi) && modules.payrollManagement"}]},[_c('router-link',{attrs:{"to":"/shift-report","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.ShiftReport')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/vertical-first-in-last-out-report","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.VerticalFirstInLastOutReport')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.puantajYonetimi) && _vm.modules.payrollManagement),expression:"authControl(authMap.puantajYonetimi) && modules.payrollManagement"}]},[_c('router-link',{attrs:{"to":"/payroll-management","tag":"a"}},[_c('i',{staticClass:"fa fa-briefcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.shiftYonetimi) && _vm.modules.shiftManagement),expression:"authControl(authMap.shiftYonetimi) && modules.shiftManagement"}]},[_c('router-link',{attrs:{"to":"/shift-management","tag":"a"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftManagement')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payrollManagement && _vm.authControl(_vm.authMap.puantajYonetimi)),expression:"modules.payrollManagement && authControl(authMap.puantajYonetimi)"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryManagement')))]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/inventories","tag":"a"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventories')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/inventory-categories","tag":"a"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryCategories')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/inventory-warehouses","tag":"a"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryWarehouses')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/inventory-fields","tag":"a"}},[_c('i',{staticClass:"fa fa-archive"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryFields')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ziyaretciTakip) && _vm.modules.visitor),expression:"authControl(authMap.ziyaretciTakip) && modules.visitor"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))]),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ziyaretciTakip)),expression:"authControl(authMap.ziyaretciTakip)"}]},[_c('router-link',{attrs:{"to":"/visitors","tag":"a"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ziyaretciTakip)),expression:"authControl(authMap.ziyaretciTakip)"}]},[_c('router-link',{attrs:{"to":"/visitor-cards","tag":"a"}},[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitorCards')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ziyaretciTakip)),expression:"authControl(authMap.ziyaretciTakip)"}]},[_c('router-link',{attrs:{"to":"/visitor-reports","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitorReports')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.kisiler) && _vm.modules.plate),expression:"authControl(authMap.kisiler) && modules.plate"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licensePlateRecognition')))]),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/license-plate-recognition","tag":"a"}},[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licensePlateRecognition')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.studentTransactions')))]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}]},[_c('router-link',{attrs:{"to":"/build-definitions","tag":"a"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authMap.creditSale != 2 && _vm.modules.retailSale),expression:"authMap.creditSale != 2 && modules.retailSale"}]},[_c('router-link',{attrs:{"to":"/retail-sale","tag":"a"}},[_c('i',{staticClass:"fa fa-money"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.retailSale')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authMap.yemekhane != 2 && _vm.modules.diningHall),expression:"authMap.yemekhane != 2 && modules.diningHall"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHall')))]),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.yemekhane) && _vm.modules.diningHall),expression:"authControl(authMap.yemekhane) && modules.diningHall"}]},[_c('router-link',{attrs:{"to":"/food-group-operations","tag":"a"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.employeeOperations')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.yemekhane) && _vm.modules.diningHall),expression:"authControl(authMap.yemekhane) && modules.diningHall"}]},[_c('router-link',{attrs:{"to":"/food-groups","tag":"a"}},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.foodGroups')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.yemekhane) && _vm.modules.diningHall),expression:"authControl(authMap.yemekhane) && modules.diningHall"}]},[_c('router-link',{attrs:{"to":"/food-group-reports","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHallReports')))])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.guardTour && _vm.authControl(_vm.authMap.bekciTur)),expression:"modules.guardTour && authControl(authMap.bekciTur)"}],staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))]),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',[_c('router-link',{attrs:{"to":"/guards","tag":"a"}},[_c('i',{staticClass:"fa fa-user-secret"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guards')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guard-tour-area","tag":"a"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/control-points","tag":"a"}},[_c('i',{staticClass:"fa fa-thumb-tack"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.points')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guard-tours","tag":"a"}},[_c('i',{staticClass:"fa fa-flag-checkered"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.tours')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guard-tour-reports","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v("Tur Hareket Raporu")])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/guard-tour-incident-reports","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v("Tur Olay Raporları")])])],1)])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authMap.tanimlamalar != 2 && _vm.authMap.gecisYetkileri != 2),expression:"authMap.tanimlamalar != 2 && authMap.gecisYetkileri != 2"}],staticClass:"treeview",attrs:{"id":"m_tanimlamalar"}},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))]),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/card-designs","tag":"a"}},[_c('i',{staticClass:"fa fa-id-card-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.cardDesignTemplates')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/extra-fields","tag":"a"}},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.extraFields')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/document-definitions","tag":"a"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.documentDefinitions')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/departments","tag":"a"}},[_c('i',{staticClass:"fa fa-sitemap"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.departments')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/access-groups","tag":"a"}},[_c('i',{staticClass:"fa fa-key"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.accessGroups')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/shifts","tag":"a"}},[_c('i',{staticClass:"fa fa-briefcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlans')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar) && _vm.modules.payroll),expression:"authControl(authMap.tanimlamalar) && modules.payroll"}]},[_c('router-link',{attrs:{"to":"/overtime-settings","tag":"a"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.overtimeDefinitions')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/allowences","tag":"a"}},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.allowences')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/work-place-definitions","tag":"a"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlaceDefinitions')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar) && _vm.modules.annualPermit),expression:"authControl(authMap.tanimlamalar) && modules.annualPermit"}]},[_c('router-link',{attrs:{"to":"/annual-permits","tag":"a"}},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.annualPermitGroups')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar) && _vm.modules.scenario),expression:"authControl(authMap.tanimlamalar) && modules.scenario"}]},[_c('router-link',{attrs:{"to":"/scenario-list","tag":"a"}},[_c('i',{staticClass:"fa fa-bookmark"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.scenarioList')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar) && _vm.modules.timezone),expression:"authControl(authMap.tanimlamalar) && modules.timezone"}]},[_c('router-link',{attrs:{"to":"/timezones","tag":"a"}},[_c('i',{staticClass:"fa fa-exchange"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.timeZones')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/devices","tag":"a"}},[_c('i',{staticClass:"fa fa-microchip"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.devices')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.tanimlamalar)),expression:"authControl(authMap.tanimlamalar)"}]},[_c('router-link',{attrs:{"to":"/device-operations","tag":"a"}},[_c('i',{staticClass:"fa fa-random"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.deviceOperations')))])])],1)])]),_vm._v(" "),_c('li',{staticClass:"treeview",attrs:{"id":"m_ayarlar"}},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))]),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar)),expression:"authControl(authMap.ayarlar)"}]},[_c('router-link',{attrs:{"to":"/company-settings","tag":"a"}},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.companySettings')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar) && _vm.authControl(_vm.authMap.shiftYonetimi) && _vm.modules.shiftManagement),expression:"authControl(authMap.ayarlar) && authControl(authMap.shiftYonetimi) && modules.shiftManagement"}]},[_c('router-link',{attrs:{"to":"/shift-settings","tag":"a"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftSettings')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar)),expression:"authControl(authMap.ayarlar)"}]},[_c('router-link',{attrs:{"to":"/users","tag":"a"}},[_c('i',{staticClass:"fa fa-user-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.users')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar)),expression:"authControl(authMap.ayarlar)"}]},[_c('router-link',{attrs:{"to":"/user-authority-groups","tag":"a"}},[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userAuthorityGroups')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar) && _vm.modules.smsOrMail),expression:"authControl(authMap.ayarlar) && modules.smsOrMail"}]},[_c('router-link',{attrs:{"to":"/mail-sms-settings","tag":"a"}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.mailSmsSettings')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar)),expression:"authControl(authMap.ayarlar)"}]},[_c('router-link',{attrs:{"to":"/user-logs","tag":"a"}},[_c('i',{staticClass:"fa fa-tasks"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userLogs')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar) && _vm.modules.payroll),expression:"authControl(authMap.ayarlar) && modules.payroll"}]},[_c('router-link',{attrs:{"to":"/payroll-types","tag":"a"}},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollTypes')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar) && _vm.modules.payroll),expression:"authControl(authMap.ayarlar) && modules.payroll"}]},[_c('router-link',{attrs:{"to":"/monthly-payroll-tables","tag":"a"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.monthlyPayrollTables')))])])],1),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl(_vm.authMap.ayarlar) && _vm.modules.integration),expression:"authControl(authMap.ayarlar) && modules.integration"}]},[_c('router-link',{attrs:{"to":"/integration","tag":"a"}},[_c('i',{staticClass:"fa fa-code-fork"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.integration')))])])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/app-about","tag":"a"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.appAbout')))])])],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"#","data-toggle":"push-menu","role":"button"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"header"}),_vm._v(" "),_c('li',[_c('div',{staticClass:"table-responsive"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticStyle:{"display":"none"}},[_c('i',{staticClass:"fa fa-comments"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{staticStyle:{"display":"none"}},[_c('i',{staticClass:"fa fa-envelope"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#","data-toggle":"control-sidebar"}},[_c('i',{staticClass:"fa fa-cog"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(134);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16aa0650_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(285);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16aa0650_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v(_vm._s(_vm.$store.getters.getCompanyName))]),_vm._v("\n      v"+_vm._s(_vm.version)+"\n    ")]),_vm._v(" "),_c('strong',[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "+_vm._s(_vm.user.companyName)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(135);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065ebd7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(287);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_065ebd7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('aside',{staticClass:"control-sidebar control-sidebar-dark"},[_c('div',{staticStyle:{"margin-left":"15px","margin-right":"15px","margin-bottom":"15px"}},[_c('h3',{staticClass:"control-sidebar-heading"},[_c('i',{staticClass:"fa fa-globe"}),_vm._v("\n        "+_vm._s(_vm.$ml.get('shared.languageOptions'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('img',{attrs:{"src":_vm.flag}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag == ''),expression:"flag == ''"}],staticClass:"fa fa-globe"})]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeLanguage($event)}}},_vm._l((_vm.$ml.list),function(lang){return _c('option',{key:lang,domProps:{"value":lang,"selected":_vm.defaultLanguage == lang}},[_vm._v(_vm._s(lang))])}),0)]),_vm._v(" "),_c('h3',{staticClass:"control-sidebar-heading"},[_c('i',{staticClass:"fa fa-paint-brush"}),_vm._v("\n        "+_vm._s(_vm.$ml.get('shared.theme'))+"\n      ")]),_vm._v(" "),_c('ul',{staticClass:"list-unstyled clearfix"},[_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.blue')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.black')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(2),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.purple')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(3),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.green')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(4),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.red')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(5),_vm._v(" "),_c('p',{staticClass:"text-center no-margin"},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.yellow')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(6),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.blueLight')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(7),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.blackLight')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(8),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.purpleLight')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(9),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.greenLight')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(10),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.redLight')))])]),_vm._v(" "),_c('li',{staticStyle:{"float":"left","width":"33.33333%","padding":"5px"}},[_vm._m(11),_vm._v(" "),_c('p',{staticClass:"text-center no-margin",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.$ml.get('shared.themes.yellowLight')))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-blue"}},[_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"7px","background":"#367fa9"}}),_vm._v(" "),_c('span',{staticClass:"bg-light-blue",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222d32"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-black"}},[_c('div',{staticClass:"clearfix",staticStyle:{"box-shadow":"0 0 2px rgba(0,0,0,0.1)"}},[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"7px","background":"#fefefe"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"7px","background":"#fefefe"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-purple"}},[_c('div',[_c('span',{staticClass:"bg-purple-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-purple",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222d32"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-green"}},[_c('div',[_c('span',{staticClass:"bg-green-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-green",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222d32"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-red"}},[_c('div',[_c('span',{staticClass:"bg-red-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-red",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222d32"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-yellow"}},[_c('div',[_c('span',{staticClass:"bg-yellow-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-yellow",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#222d32"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-blue-light"}},[_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"7px","background":"#367fa9"}}),_vm._v(" "),_c('span',{staticClass:"bg-light-blue",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-black-light"}},[_c('div',{staticClass:"clearfix",staticStyle:{"box-shadow":"0 0 2px rgba(0,0,0,0.1)"}},[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"7px","background":"#fefefe"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"7px","background":"#fefefe"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-purple-light"}},[_c('div',[_c('span',{staticClass:"bg-purple-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-purple",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-green-light"}},[_c('div',[_c('span',{staticClass:"bg-green-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-green",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-red-light"}},[_c('div',[_c('span',{staticClass:"bg-red-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-red",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"clearfix full-opacity-hover",staticStyle:{"display":"block","box-shadow":"0 0 3px rgba(0,0,0,0.4)"},attrs:{"href":"javascript:void(0)","data-skin":"skin-yellow-light"}},[_c('div',[_c('span',{staticClass:"bg-yellow-active",staticStyle:{"display":"block","width":"20%","float":"left","height":"7px"}}),_vm._v(" "),_c('span',{staticClass:"bg-yellow",staticStyle:{"display":"block","width":"80%","float":"left","height":"7px"}})]),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"block","width":"20%","float":"left","height":"20px","background":"#f9fafc"}}),_vm._v(" "),_c('span',{staticStyle:{"display":"block","width":"80%","float":"left","height":"20px","background":"#f4f5f7"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('Sidebar')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ee0314_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(293);
function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ee0314_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(291);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("701bb140", content, true, {});

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * ApexCharts v3.35.5
 * (c) 2018-2022 ApexCharts
 * Released under the MIT License.
 */
function t(t,e){var i=Object.keys(t);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(t);e&&(a=a.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),i.push.apply(i,a)}return i}function e(e){for(var i=1;i<arguments.length;i++){var a=null!=arguments[i]?arguments[i]:{};i%2?t(Object(a),!0).forEach((function(t){o(e,t,a[t])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(a)):t(Object(a)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(a,t))}))}return e}function i(t){return(i="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function a(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){for(var i=0;i<e.length;i++){var a=e[i];a.enumerable=a.enumerable||!1,a.configurable=!0,"value"in a&&(a.writable=!0),Object.defineProperty(t,a.key,a)}}function r(t,e,i){return e&&s(t.prototype,e),i&&s(t,i),t}function o(t,e,i){return e in t?Object.defineProperty(t,e,{value:i,enumerable:!0,configurable:!0,writable:!0}):t[e]=i,t}function n(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&h(t,e)}function l(t){return(l=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function h(t,e){return(h=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function c(t,e){if(e&&("object"==typeof e||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined");return function(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}(t)}function d(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(t){return!1}}();return function(){var i,a=l(t);if(e){var s=l(this).constructor;i=Reflect.construct(a,arguments,s)}else i=a.apply(this,arguments);return c(this,i)}}function g(t,e){return function(t){if(Array.isArray(t))return t}(t)||function(t,e){var i=null==t?null:"undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(null==i)return;var a,s,r=[],o=!0,n=!1;try{for(i=i.call(t);!(o=(a=i.next()).done)&&(r.push(a.value),!e||r.length!==e);o=!0);}catch(t){n=!0,s=t}finally{try{o||null==i.return||i.return()}finally{if(n)throw s}}return r}(t,e)||p(t,e)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(t){return function(t){if(Array.isArray(t))return f(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||p(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function p(t,e){if(t){if("string"==typeof t)return f(t,e);var i=Object.prototype.toString.call(t).slice(8,-1);return"Object"===i&&t.constructor&&(i=t.constructor.name),"Map"===i||"Set"===i?Array.from(t):"Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)?f(t,e):void 0}}function f(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,a=new Array(e);i<e;i++)a[i]=t[i];return a}var x=function(){function t(){a(this,t)}return r(t,[{key:"shadeRGBColor",value:function(t,e){var i=e.split(","),a=t<0?0:255,s=t<0?-1*t:t,r=parseInt(i[0].slice(4),10),o=parseInt(i[1],10),n=parseInt(i[2],10);return"rgb("+(Math.round((a-r)*s)+r)+","+(Math.round((a-o)*s)+o)+","+(Math.round((a-n)*s)+n)+")"}},{key:"shadeHexColor",value:function(t,e){var i=parseInt(e.slice(1),16),a=t<0?0:255,s=t<0?-1*t:t,r=i>>16,o=i>>8&255,n=255&i;return"#"+(16777216+65536*(Math.round((a-r)*s)+r)+256*(Math.round((a-o)*s)+o)+(Math.round((a-n)*s)+n)).toString(16).slice(1)}},{key:"shadeColor",value:function(e,i){return t.isColorHex(i)?this.shadeHexColor(e,i):this.shadeRGBColor(e,i)}}],[{key:"bind",value:function(t,e){return function(){return t.apply(e,arguments)}}},{key:"isObject",value:function(t){return t&&"object"===i(t)&&!Array.isArray(t)&&null!=t}},{key:"is",value:function(t,e){return Object.prototype.toString.call(e)==="[object "+t+"]"}},{key:"listToArray",value:function(t){var e,i=[];for(e=0;e<t.length;e++)i[e]=t[e];return i}},{key:"extend",value:function(t,e){var i=this;"function"!=typeof Object.assign&&(Object.assign=function(t){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var e=Object(t),i=1;i<arguments.length;i++){var a=arguments[i];if(null!=a)for(var s in a)a.hasOwnProperty(s)&&(e[s]=a[s])}return e});var a=Object.assign({},t);return this.isObject(t)&&this.isObject(e)&&Object.keys(e).forEach((function(s){i.isObject(e[s])&&s in t?a[s]=i.extend(t[s],e[s]):Object.assign(a,o({},s,e[s]))})),a}},{key:"extendArray",value:function(e,i){var a=[];return e.map((function(e){a.push(t.extend(i,e))})),e=a}},{key:"monthMod",value:function(t){return t%12}},{key:"clone",value:function(e){if(t.is("Array",e)){for(var a=[],s=0;s<e.length;s++)a[s]=this.clone(e[s]);return a}if(t.is("Null",e))return null;if(t.is("Date",e))return e;if("object"===i(e)){var r={};for(var o in e)e.hasOwnProperty(o)&&(r[o]=this.clone(e[o]));return r}return e}},{key:"log10",value:function(t){return Math.log(t)/Math.LN10}},{key:"roundToBase10",value:function(t){return Math.pow(10,Math.floor(Math.log10(t)))}},{key:"roundToBase",value:function(t,e){return Math.pow(e,Math.floor(Math.log(t)/Math.log(e)))}},{key:"parseNumber",value:function(t){return null===t?t:parseFloat(t)}},{key:"randomId",value:function(){return(Math.random()+1).toString(36).substring(4)}},{key:"noExponents",value:function(t){var e=String(t).split(/[eE]/);if(1===e.length)return e[0];var i="",a=t<0?"-":"",s=e[0].replace(".",""),r=Number(e[1])+1;if(r<0){for(i=a+"0.";r++;)i+="0";return i+s.replace(/^-/,"")}for(r-=s.length;r--;)i+="0";return s+i}},{key:"getDimensions",value:function(t){var e=getComputedStyle(t,null),i=t.clientHeight,a=t.clientWidth;return i-=parseFloat(e.paddingTop)+parseFloat(e.paddingBottom),[a-=parseFloat(e.paddingLeft)+parseFloat(e.paddingRight),i]}},{key:"getBoundingClientRect",value:function(t){var e=t.getBoundingClientRect();return{top:e.top,right:e.right,bottom:e.bottom,left:e.left,width:t.clientWidth,height:t.clientHeight,x:e.left,y:e.top}}},{key:"getLargestStringFromArr",value:function(t){return t.reduce((function(t,e){return Array.isArray(e)&&(e=e.reduce((function(t,e){return t.length>e.length?t:e}))),t.length>e.length?t:e}),0)}},{key:"hexToRgba",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"#999999",e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:.6;"#"!==t.substring(0,1)&&(t="#999999");var i=t.replace("#","");i=i.match(new RegExp("(.{"+i.length/3+"})","g"));for(var a=0;a<i.length;a++)i[a]=parseInt(1===i[a].length?i[a]+i[a]:i[a],16);return void 0!==e&&i.push(e),"rgba("+i.join(",")+")"}},{key:"getOpacityFromRGBA",value:function(t){return parseFloat(t.replace(/^.*,(.+)\)/,"$1"))}},{key:"rgb2hex",value:function(t){return(t=t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i))&&4===t.length?"#"+("0"+parseInt(t[1],10).toString(16)).slice(-2)+("0"+parseInt(t[2],10).toString(16)).slice(-2)+("0"+parseInt(t[3],10).toString(16)).slice(-2):""}},{key:"isColorHex",value:function(t){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t)}},{key:"getPolygonPos",value:function(t,e){for(var i=[],a=2*Math.PI/e,s=0;s<e;s++){var r={};r.x=t*Math.sin(s*a),r.y=-t*Math.cos(s*a),i.push(r)}return i}},{key:"polarToCartesian",value:function(t,e,i,a){var s=(a-90)*Math.PI/180;return{x:t+i*Math.cos(s),y:e+i*Math.sin(s)}}},{key:"escapeString",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"x",i=t.toString().slice();return i=i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi,e)}},{key:"negToZero",value:function(t){return t<0?0:t}},{key:"moveIndexInArray",value:function(t,e,i){if(i>=t.length)for(var a=i-t.length+1;a--;)t.push(void 0);return t.splice(i,0,t.splice(e,1)[0]),t}},{key:"extractNumber",value:function(t){return parseFloat(t.replace(/[^\d.]*/g,""))}},{key:"findAncestor",value:function(t,e){for(;(t=t.parentElement)&&!t.classList.contains(e););return t}},{key:"setELstyles",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&(t.style.key=e[i])}},{key:"isNumber",value:function(t){return!isNaN(t)&&parseFloat(Number(t))===t&&!isNaN(parseInt(t,10))}},{key:"isFloat",value:function(t){return Number(t)===t&&t%1!=0}},{key:"isSafari",value:function(){return/^((?!chrome|android).)*safari/i.test(navigator.userAgent)}},{key:"isFirefox",value:function(){return navigator.userAgent.toLowerCase().indexOf("firefox")>-1}},{key:"isIE11",value:function(){if(-1!==window.navigator.userAgent.indexOf("MSIE")||window.navigator.appVersion.indexOf("Trident/")>-1)return!0}},{key:"isIE",value:function(){var t=window.navigator.userAgent,e=t.indexOf("MSIE ");if(e>0)return parseInt(t.substring(e+5,t.indexOf(".",e)),10);if(t.indexOf("Trident/")>0){var i=t.indexOf("rv:");return parseInt(t.substring(i+3,t.indexOf(".",i)),10)}var a=t.indexOf("Edge/");return a>0&&parseInt(t.substring(a+5,t.indexOf(".",a)),10)}}]),t}(),b=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.setEasingFunctions()}return r(t,[{key:"setEasingFunctions",value:function(){var t;if(!this.w.globals.easing){switch(this.w.config.chart.animations.easing){case"linear":t="-";break;case"easein":t="<";break;case"easeout":t=">";break;case"easeinout":t="<>";break;case"swing":t=function(t){var e=1.70158;return(t-=1)*t*((e+1)*t+e)+1};break;case"bounce":t=function(t){return t<1/2.75?7.5625*t*t:t<2/2.75?7.5625*(t-=1.5/2.75)*t+.75:t<2.5/2.75?7.5625*(t-=2.25/2.75)*t+.9375:7.5625*(t-=2.625/2.75)*t+.984375};break;case"elastic":t=function(t){return t===!!t?t:Math.pow(2,-10*t)*Math.sin((t-.075)*(2*Math.PI)/.3)+1};break;default:t="<>"}this.w.globals.easing=t}}},{key:"animateLine",value:function(t,e,i,a){t.attr(e).animate(a).attr(i)}},{key:"animateMarker",value:function(t,e,i,a,s,r){e||(e=0),t.attr({r:e,width:e,height:e}).animate(a,s).attr({r:i,width:i.width,height:i.height}).afterAll((function(){r()}))}},{key:"animateCircle",value:function(t,e,i,a,s){t.attr({r:e.r,cx:e.cx,cy:e.cy}).animate(a,s).attr({r:i.r,cx:i.cx,cy:i.cy})}},{key:"animateRect",value:function(t,e,i,a,s){t.attr(e).animate(a).attr(i).afterAll((function(){return s()}))}},{key:"animatePathsGradually",value:function(t){var e=t.el,i=t.realIndex,a=t.j,s=t.fill,r=t.pathFrom,o=t.pathTo,n=t.speed,l=t.delay,h=this.w,c=0;h.config.chart.animations.animateGradually.enabled&&(c=h.config.chart.animations.animateGradually.delay),h.config.chart.animations.dynamicAnimation.enabled&&h.globals.dataChanged&&"bar"!==h.config.chart.type&&(c=0),this.morphSVG(e,i,a,"line"!==h.config.chart.type||h.globals.comboCharts?s:"stroke",r,o,n,l*c)}},{key:"showDelayedElements",value:function(){this.w.globals.delayedElements.forEach((function(t){t.el.classList.remove("apexcharts-element-hidden")}))}},{key:"animationCompleted",value:function(t){var e=this.w;e.globals.animationEnded||(e.globals.animationEnded=!0,this.showDelayedElements(),"function"==typeof e.config.chart.events.animationEnd&&e.config.chart.events.animationEnd(this.ctx,{el:t,w:e}))}},{key:"morphSVG",value:function(t,e,i,a,s,r,o,n){var l=this,h=this.w;s||(s=t.attr("pathFrom")),r||(r=t.attr("pathTo"));var c=function(t){return"radar"===h.config.chart.type&&(o=1),"M 0 ".concat(h.globals.gridHeight)};(!s||s.indexOf("undefined")>-1||s.indexOf("NaN")>-1)&&(s=c()),(!r||r.indexOf("undefined")>-1||r.indexOf("NaN")>-1)&&(r=c()),h.globals.shouldAnimate||(o=1),t.plot(s).animate(1,h.globals.easing,n).plot(s).animate(o,h.globals.easing,n).plot(r).afterAll((function(){x.isNumber(i)?i===h.globals.series[h.globals.maxValsInArrayIndex].length-2&&h.globals.shouldAnimate&&l.animationCompleted(t):"none"!==a&&h.globals.shouldAnimate&&(!h.globals.comboCharts&&e===h.globals.series.length-1||h.globals.comboCharts)&&l.animationCompleted(t),l.showDelayedElements()}))}}]),t}(),v=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getDefaultFilter",value:function(t,e){var i=this.w;t.unfilter(!0),(new window.SVG.Filter).size("120%","180%","-5%","-40%"),"none"!==i.config.states.normal.filter?this.applyFilter(t,e,i.config.states.normal.filter.type,i.config.states.normal.filter.value):i.config.chart.dropShadow.enabled&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addNormalFilter",value:function(t,e){var i=this.w;i.config.chart.dropShadow.enabled&&!t.node.classList.contains("apexcharts-marker")&&this.dropShadow(t,i.config.chart.dropShadow,e)}},{key:"addLightenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:1.5,intercept:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"addDarkenFilter",value:function(t,e,i){var a=this,s=this.w,r=i.intensity;t.unfilter(!0);new window.SVG.Filter;t.filter((function(t){var i=s.config.chart.dropShadow;(i.enabled?a.addShadow(t,e,i):t).componentTransfer({rgb:{type:"linear",slope:r}})})),t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)}},{key:"applyFilter",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:.5;switch(i){case"none":this.addNormalFilter(t,e);break;case"lighten":this.addLightenFilter(t,e,{intensity:a});break;case"darken":this.addDarkenFilter(t,e,{intensity:a})}}},{key:"addShadow",value:function(t,e,i){var a=i.blur,s=i.top,r=i.left,o=i.color,n=i.opacity,l=t.flood(Array.isArray(o)?o[e]:o,n).composite(t.sourceAlpha,"in").offset(r,s).gaussianBlur(a).merge(t.source);return t.blend(t.source,l)}},{key:"dropShadow",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=e.top,s=e.left,r=e.blur,o=e.color,n=e.opacity,l=e.noUserSpaceOnUse,h=this.w;return t.unfilter(!0),x.isIE()&&"radialBar"===h.config.chart.type||(o=Array.isArray(o)?o[i]:o,t.filter((function(t){var e=null;e=x.isSafari()||x.isFirefox()||x.isIE()?t.flood(o,n).composite(t.sourceAlpha,"in").offset(s,a).gaussianBlur(r):t.flood(o,n).composite(t.sourceAlpha,"in").offset(s,a).gaussianBlur(r).merge(t.source),t.blend(t.source,e)})),l||t.filterer.node.setAttribute("filterUnits","userSpaceOnUse"),this._scaleFilterSize(t.filterer.node)),t}},{key:"setSelectionFilter",value:function(t,e,i){var a=this.w;if(void 0!==a.globals.selectedDataPoints[e]&&a.globals.selectedDataPoints[e].indexOf(i)>-1){t.node.setAttribute("selected",!0);var s=a.config.states.active.filter;"none"!==s&&this.applyFilter(t,e,s.type,s.value)}}},{key:"_scaleFilterSize",value:function(t){!function(e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}({width:"200%",height:"200%",x:"-50%",y:"-50%"})}}]),t}(),m=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawLine",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:"#a8a8a8",r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0,o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:"butt",l=this.w,h=l.globals.dom.Paper.line().attr({x1:t,y1:e,x2:i,y2:a,stroke:s,"stroke-dasharray":r,"stroke-width":o,"stroke-linecap":n});return h}},{key:"drawRect",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:0,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:0,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"#fefefe",o=arguments.length>6&&void 0!==arguments[6]?arguments[6]:1,n=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,l=arguments.length>8&&void 0!==arguments[8]?arguments[8]:null,h=arguments.length>9&&void 0!==arguments[9]?arguments[9]:0,c=this.w,d=c.globals.dom.Paper.rect();return d.attr({x:t,y:e,width:i>0?i:0,height:a>0?a:0,rx:s,ry:s,opacity:o,"stroke-width":null!==n?n:0,stroke:null!==l?l:"none","stroke-dasharray":h}),d.node.setAttribute("fill",r),d}},{key:"drawPolygon",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"#e1e1e1",i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:1,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"none",s=this.w,r=s.globals.dom.Paper.polygon(t).attr({fill:a,stroke:e,"stroke-width":i});return r}},{key:"drawCircle",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.w;t<0&&(t=0);var a=i.globals.dom.Paper.circle(2*t);return null!==e&&a.attr(e),a}},{key:"drawPath",value:function(t){var e=t.d,i=void 0===e?"":e,a=t.stroke,s=void 0===a?"#a8a8a8":a,r=t.strokeWidth,o=void 0===r?1:r,n=t.fill,l=t.fillOpacity,h=void 0===l?1:l,c=t.strokeOpacity,d=void 0===c?1:c,g=t.classes,u=t.strokeLinecap,p=void 0===u?null:u,f=t.strokeDashArray,x=void 0===f?0:f,b=this.w;return null===p&&(p=b.config.stroke.lineCap),(i.indexOf("undefined")>-1||i.indexOf("NaN")>-1)&&(i="M 0 ".concat(b.globals.gridHeight)),b.globals.dom.Paper.path(i).attr({fill:n,"fill-opacity":h,stroke:s,"stroke-opacity":d,"stroke-linecap":p,"stroke-width":o,"stroke-dasharray":x,class:g})}},{key:"group",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w,i=e.globals.dom.Paper.group();return null!==t&&i.attr(t),i}},{key:"move",value:function(t,e){var i=["M",t,e].join(" ");return i}},{key:"line",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=null;return null===i?a=["L",t,e].join(" "):"H"===i?a=["H",t].join(" "):"V"===i&&(a=["V",e].join(" ")),a}},{key:"curve",value:function(t,e,i,a,s,r){var o=["C",t,e,i,a,s,r].join(" ");return o}},{key:"quadraticCurve",value:function(t,e,i,a){return["Q",t,e,i,a].join(" ")}},{key:"arc",value:function(t,e,i,a,s,r,o){var n=arguments.length>7&&void 0!==arguments[7]&&arguments[7],l="A";n&&(l="a");var h=[l,t,e,i,a,s,r,o].join(" ");return h}},{key:"renderPaths",value:function(t){var i,a=t.j,s=t.realIndex,r=t.pathFrom,o=t.pathTo,n=t.stroke,l=t.strokeWidth,h=t.strokeLinecap,c=t.fill,d=t.animationDelay,g=t.initialSpeed,u=t.dataChangeSpeed,p=t.className,f=t.shouldClipToGrid,x=void 0===f||f,m=t.bindEventsOnPaths,y=void 0===m||m,w=t.drawShadow,k=void 0===w||w,A=this.w,S=new v(this.ctx),C=new b(this.ctx),L=this.w.config.chart.animations.enabled,P=L&&this.w.config.chart.animations.dynamicAnimation.enabled,M=!!(L&&!A.globals.resized||P&&A.globals.dataChanged&&A.globals.shouldAnimate);M?i=r:(i=o,A.globals.animationEnded=!0);var T=A.config.stroke.dashArray,I=0;I=Array.isArray(T)?T[s]:A.config.stroke.dashArray;var z=this.drawPath({d:i,stroke:n,strokeWidth:l,fill:c,fillOpacity:1,classes:p,strokeLinecap:h,strokeDashArray:I});if(z.attr("index",s),x&&z.attr({"clip-path":"url(#gridRectMask".concat(A.globals.cuid,")")}),"none"!==A.config.states.normal.filter.type)S.getDefaultFilter(z,s);else if(A.config.chart.dropShadow.enabled&&k&&(!A.config.chart.dropShadow.enabledOnSeries||A.config.chart.dropShadow.enabledOnSeries&&-1!==A.config.chart.dropShadow.enabledOnSeries.indexOf(s))){var X=A.config.chart.dropShadow;S.dropShadow(z,X,s)}y&&(z.node.addEventListener("mouseenter",this.pathMouseEnter.bind(this,z)),z.node.addEventListener("mouseleave",this.pathMouseLeave.bind(this,z)),z.node.addEventListener("mousedown",this.pathMouseDown.bind(this,z))),z.attr({pathTo:o,pathFrom:r});var E={el:z,j:a,realIndex:s,pathFrom:r,pathTo:o,fill:c,strokeWidth:l,delay:d};return!L||A.globals.resized||A.globals.dataChanged?!A.globals.resized&&A.globals.dataChanged||C.showDelayedElements():C.animatePathsGradually(e(e({},E),{},{speed:g})),A.globals.dataChanged&&P&&M&&C.animatePathsGradually(e(e({},E),{},{speed:u})),z}},{key:"drawPattern",value:function(t,e,i){var a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:"#a8a8a8",s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:0,r=this.w,o=r.globals.dom.Paper.pattern(e,i,(function(r){"horizontalLines"===t?r.line(0,0,i,0).stroke({color:a,width:s+1}):"verticalLines"===t?r.line(0,0,0,e).stroke({color:a,width:s+1}):"slantedLines"===t?r.line(0,0,e,i).stroke({color:a,width:s}):"squares"===t?r.rect(e,i).fill("none").stroke({color:a,width:s}):"circles"===t&&r.circle(e).fill("none").stroke({color:a,width:s})}));return o}},{key:"drawGradient",value:function(t,e,i,a,s){var r,o=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,n=arguments.length>6&&void 0!==arguments[6]?arguments[6]:null,l=arguments.length>7&&void 0!==arguments[7]?arguments[7]:null,h=arguments.length>8&&void 0!==arguments[8]?arguments[8]:0,c=this.w;e.length<9&&0===e.indexOf("#")&&(e=x.hexToRgba(e,a)),i.length<9&&0===i.indexOf("#")&&(i=x.hexToRgba(i,s));var d=0,g=1,u=1,p=null;null!==n&&(d=void 0!==n[0]?n[0]/100:0,g=void 0!==n[1]?n[1]/100:1,u=void 0!==n[2]?n[2]/100:1,p=void 0!==n[3]?n[3]/100:null);var f=!("donut"!==c.config.chart.type&&"pie"!==c.config.chart.type&&"polarArea"!==c.config.chart.type&&"bubble"!==c.config.chart.type);if(r=null===l||0===l.length?c.globals.dom.Paper.gradient(f?"radial":"linear",(function(t){t.at(d,e,a),t.at(g,i,s),t.at(u,i,s),null!==p&&t.at(p,e,a)})):c.globals.dom.Paper.gradient(f?"radial":"linear",(function(t){(Array.isArray(l[h])?l[h]:l).forEach((function(e){t.at(e.offset/100,e.color,e.opacity)}))})),f){var b=c.globals.gridWidth/2,v=c.globals.gridHeight/2;"bubble"!==c.config.chart.type?r.attr({gradientUnits:"userSpaceOnUse",cx:b,cy:v,r:o}):r.attr({cx:.5,cy:.5,r:.8,fx:.2,fy:.2})}else"vertical"===t?r.from(0,0).to(0,1):"diagonal"===t?r.from(0,0).to(1,1):"horizontal"===t?r.from(0,1).to(1,1):"diagonal2"===t&&r.from(1,0).to(0,1);return r}},{key:"getTextBasedOnMaxWidth",value:function(t){var e=t.text,i=t.maxWidth,a=t.fontSize,s=t.fontFamily,r=this.getTextRects(e,a,s),o=r.width/e.length,n=Math.floor(i/o);return i<r.width?e.slice(0,n-3)+"...":e}},{key:"drawText",value:function(t){var i=this,a=t.x,s=t.y,r=t.text,o=t.textAnchor,n=t.fontSize,l=t.fontFamily,h=t.fontWeight,c=t.foreColor,d=t.opacity,g=t.maxWidth,u=t.cssClass,p=void 0===u?"":u,f=t.isPlainText,x=void 0===f||f,b=this.w;void 0===r&&(r="");var v=r;o||(o="start"),c&&c.length||(c=b.config.chart.foreColor),l=l||b.config.chart.fontFamily,h=h||"regular";var m,y={maxWidth:g,fontSize:n=n||"11px",fontFamily:l};return Array.isArray(r)?m=b.globals.dom.Paper.text((function(t){for(var a=0;a<r.length;a++)v=r[a],g&&(v=i.getTextBasedOnMaxWidth(e({text:r[a]},y))),0===a?t.tspan(v):t.tspan(v).newLine()})):(g&&(v=this.getTextBasedOnMaxWidth(e({text:r},y))),m=x?b.globals.dom.Paper.plain(r):b.globals.dom.Paper.text((function(t){return t.tspan(v)}))),m.attr({x:a,y:s,"text-anchor":o,"dominant-baseline":"auto","font-size":n,"font-family":l,"font-weight":h,fill:c,class:"apexcharts-text "+p}),m.node.style.fontFamily=l,m.node.style.opacity=d,m}},{key:"drawMarker",value:function(t,e,i){t=t||0;var a=i.pSize||0,s=null;if("square"===i.shape||"rect"===i.shape){var r=void 0===i.pRadius?a/2:i.pRadius;null!==e&&a||(a=0,r=0);var o=1.2*a+r,n=this.drawRect(o,o,o,o,r);n.attr({x:t-o/2,y:e-o/2,cx:t,cy:e,class:i.class?i.class:"",fill:i.pointFillColor,"fill-opacity":i.pointFillOpacity?i.pointFillOpacity:1,stroke:i.pointStrokeColor,"stroke-width":i.pointStrokeWidth?i.pointStrokeWidth:0,"stroke-opacity":i.pointStrokeOpacity?i.pointStrokeOpacity:1}),s=n}else"circle"!==i.shape&&i.shape||(x.isNumber(e)||(a=0,e=0),s=this.drawCircle(a,{cx:t,cy:e,class:i.class?i.class:"",stroke:i.pointStrokeColor,fill:i.pointFillColor,"fill-opacity":i.pointFillOpacity?i.pointFillOpacity:1,"stroke-width":i.pointStrokeWidth?i.pointStrokeWidth:0,"stroke-opacity":i.pointStrokeOpacity?i.pointStrokeOpacity:1}));return s}},{key:"pathMouseEnter",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);if("function"==typeof i.config.chart.events.dataPointMouseEnter&&i.config.chart.events.dataPointMouseEnter(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseEnter",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),("none"===i.config.states.active.filter.type||"true"!==t.node.getAttribute("selected"))&&"none"!==i.config.states.hover.filter.type&&!i.globals.isTouchDevice){var o=i.config.states.hover.filter;a.applyFilter(t,s,o.type,o.value)}}},{key:"pathMouseLeave",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10);"function"==typeof i.config.chart.events.dataPointMouseLeave&&i.config.chart.events.dataPointMouseLeave(e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}),this.ctx.events.fireEvent("dataPointMouseLeave",[e,this.ctx,{seriesIndex:s,dataPointIndex:r,w:i}]),"none"!==i.config.states.active.filter.type&&"true"===t.node.getAttribute("selected")||"none"!==i.config.states.hover.filter.type&&a.getDefaultFilter(t,s)}},{key:"pathMouseDown",value:function(t,e){var i=this.w,a=new v(this.ctx),s=parseInt(t.node.getAttribute("index"),10),r=parseInt(t.node.getAttribute("j"),10),o="false";if("true"===t.node.getAttribute("selected")){if(t.node.setAttribute("selected","false"),i.globals.selectedDataPoints[s].indexOf(r)>-1){var n=i.globals.selectedDataPoints[s].indexOf(r);i.globals.selectedDataPoints[s].splice(n,1)}}else{if(!i.config.states.active.allowMultipleDataPointsSelection&&i.globals.selectedDataPoints.length>0){i.globals.selectedDataPoints=[];var l=i.globals.dom.Paper.select(".apexcharts-series path").members,h=i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members,c=function(t){Array.prototype.forEach.call(t,(function(t){t.node.setAttribute("selected","false"),a.getDefaultFilter(t,s)}))};c(l),c(h)}t.node.setAttribute("selected","true"),o="true",void 0===i.globals.selectedDataPoints[s]&&(i.globals.selectedDataPoints[s]=[]),i.globals.selectedDataPoints[s].push(r)}if("true"===o){var d=i.config.states.active.filter;if("none"!==d)a.applyFilter(t,s,d.type,d.value);else if("none"!==i.config.states.hover.filter&&!i.globals.isTouchDevice){var g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}}else if("none"!==i.config.states.active.filter.type)if("none"===i.config.states.hover.filter.type||i.globals.isTouchDevice)a.getDefaultFilter(t,s);else{g=i.config.states.hover.filter;a.applyFilter(t,s,g.type,g.value)}"function"==typeof i.config.chart.events.dataPointSelection&&i.config.chart.events.dataPointSelection(e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}),e&&this.ctx.events.fireEvent("dataPointSelection",[e,this.ctx,{selectedDataPoints:i.globals.selectedDataPoints,seriesIndex:s,dataPointIndex:r,w:i}])}},{key:"rotateAroundCenter",value:function(t){var e={};return t&&"function"==typeof t.getBBox&&(e=t.getBBox()),{x:e.x+e.width/2,y:e.y+e.height/2}}},{key:"getTextRects",value:function(t,e,i,a){var s=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],r=this.w,o=this.drawText({x:-200,y:-200,text:t,textAnchor:"start",fontSize:e,fontFamily:i,foreColor:"#fff",opacity:0});a&&o.attr("transform",a),r.globals.dom.Paper.add(o);var n=o.bbox();return s||(n=o.node.getBoundingClientRect()),o.remove(),{width:n.width,height:n.height}}},{key:"placeTextWithEllipsis",value:function(t,e,i){if("function"==typeof t.getComputedTextLength&&(t.textContent=e,e.length>0&&t.getComputedTextLength()>=i/1.1)){for(var a=e.length-3;a>0;a-=3)if(t.getSubStringLength(0,a)<=i/1.1)return void(t.textContent=e.substring(0,a)+"...");t.textContent="."}}}],[{key:"setAttrs",value:function(t,e){for(var i in e)e.hasOwnProperty(i)&&t.setAttribute(i,e[i])}}]),t}(),y=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getStackedSeriesTotals",value:function(){var t=this.w,e=[];if(0===t.globals.series.length)return e;for(var i=0;i<t.globals.series[t.globals.maxValsInArrayIndex].length;i++){for(var a=0,s=0;s<t.globals.series.length;s++)void 0!==t.globals.series[s][i]&&(a+=t.globals.series[s][i]);e.push(a)}return t.globals.stackedSeriesTotals=e,e}},{key:"getSeriesTotalByIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return null===t?this.w.config.series.reduce((function(t,e){return t+e}),0):this.w.globals.series[t].reduce((function(t,e){return t+e}),0)}},{key:"isSeriesNull",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null;return 0===(null===t?this.w.config.series.filter((function(t){return null!==t})):this.w.config.series[t].data.filter((function(t){return null!==t}))).length}},{key:"seriesHaveSameValues",value:function(t){return this.w.globals.series[t].every((function(t,e,i){return t===i[0]}))}},{key:"getCategoryLabels",value:function(t){var e=this.w,i=t.slice();return e.config.xaxis.convertedCatToNumeric&&(i=t.map((function(t,i){return e.config.xaxis.labels.formatter(t-e.globals.minX+1)}))),i}},{key:"getLargestSeries",value:function(){var t=this.w;t.globals.maxValsInArrayIndex=t.globals.series.map((function(t){return t.length})).indexOf(Math.max.apply(Math,t.globals.series.map((function(t){return t.length}))))}},{key:"getLargestMarkerSize",value:function(){var t=this.w,e=0;return t.globals.markers.size.forEach((function(t){e=Math.max(e,t)})),t.config.markers.discrete&&t.config.markers.discrete.length&&t.config.markers.discrete.forEach((function(t){e=Math.max(e,t.size)})),e>0&&(e+=t.config.markers.hover.sizeOffset+1),t.globals.markers.largestSize=e,e}},{key:"getSeriesTotals",value:function(){var t=this.w;t.globals.seriesTotals=t.globals.series.map((function(t,e){var i=0;if(Array.isArray(t))for(var a=0;a<t.length;a++)i+=t[a];else i+=t;return i}))}},{key:"getSeriesTotalsXRange",value:function(t,e){var i=this.w;return i.globals.series.map((function(a,s){for(var r=0,o=0;o<a.length;o++)i.globals.seriesX[s][o]>t&&i.globals.seriesX[s][o]<e&&(r+=a[o]);return r}))}},{key:"getPercentSeries",value:function(){var t=this.w;t.globals.seriesPercent=t.globals.series.map((function(e,i){var a=[];if(Array.isArray(e))for(var s=0;s<e.length;s++){var r=t.globals.stackedSeriesTotals[s],o=0;r&&(o=100*e[s]/r),a.push(o)}else{var n=100*e/t.globals.seriesTotals.reduce((function(t,e){return t+e}),0);a.push(n)}return a}))}},{key:"getCalculatedRatios",value:function(){var t,e,i,a,s=this.w.globals,r=[],o=0,n=[],l=.1,h=0;if(s.yRange=[],s.isMultipleYAxis)for(var c=0;c<s.minYArr.length;c++)s.yRange.push(Math.abs(s.minYArr[c]-s.maxYArr[c])),n.push(0);else s.yRange.push(Math.abs(s.minY-s.maxY));s.xRange=Math.abs(s.maxX-s.minX),s.zRange=Math.abs(s.maxZ-s.minZ);for(var d=0;d<s.yRange.length;d++)r.push(s.yRange[d]/s.gridHeight);if(e=s.xRange/s.gridWidth,i=Math.abs(s.initialMaxX-s.initialMinX)/s.gridWidth,t=s.yRange/s.gridWidth,a=s.xRange/s.gridHeight,(o=s.zRange/s.gridHeight*16)||(o=1),s.minY!==Number.MIN_VALUE&&0!==Math.abs(s.minY)&&(s.hasNegs=!0),s.isMultipleYAxis){n=[];for(var g=0;g<r.length;g++)n.push(-s.minYArr[g]/r[g])}else n.push(-s.minY/r[0]),s.minY!==Number.MIN_VALUE&&0!==Math.abs(s.minY)&&(l=-s.minY/t,h=s.minX/e);return{yRatio:r,invertedYRatio:t,zRatio:o,xRatio:e,initialXRatio:i,invertedXRatio:a,baseLineInvertedY:l,baseLineY:n,baseLineX:h}}},{key:"getLogSeries",value:function(t){var e=this,i=this.w;return i.globals.seriesLog=t.map((function(t,a){return i.config.yaxis[a]&&i.config.yaxis[a].logarithmic?t.map((function(t){return null===t?null:e.getLogVal(i.config.yaxis[a].logBase,t,a)})):t})),i.globals.invalidLogScale?t:i.globals.seriesLog}},{key:"getBaseLog",value:function(t,e){return Math.log(e)/Math.log(t)}},{key:"getLogVal",value:function(t,e,i){if(0===e)return 0;var a=this.w,s=0===a.globals.minYArr[i]?-1:this.getBaseLog(t,a.globals.minYArr[i]),r=(0===a.globals.maxYArr[i]?0:this.getBaseLog(t,a.globals.maxYArr[i]))-s;return e<1?e/r:(this.getBaseLog(t,e)-s)/r}},{key:"getLogYRatios",value:function(t){var e=this,i=this.w,a=this.w.globals;return a.yLogRatio=t.slice(),a.logYRange=a.yRange.map((function(t,s){if(i.config.yaxis[s]&&e.w.config.yaxis[s].logarithmic){var r,o=-Number.MAX_VALUE,n=Number.MIN_VALUE;return a.seriesLog.forEach((function(t,e){t.forEach((function(t){i.config.yaxis[e]&&i.config.yaxis[e].logarithmic&&(o=Math.max(t,o),n=Math.min(t,n))}))})),r=Math.pow(a.yRange[s],Math.abs(n-o)/a.yRange[s]),a.yLogRatio[s]=r/a.gridHeight,r}})),a.invalidLogScale?t.slice():a.yLogRatio}}],[{key:"checkComboSeries",value:function(t){var e=!1,i=0,a=0;return t.length&&void 0!==t[0].type&&t.forEach((function(t){"bar"!==t.type&&"column"!==t.type&&"candlestick"!==t.type&&"boxPlot"!==t.type||i++,void 0!==t.type&&a++})),a>0&&(e=!0),{comboBarCount:i,comboCharts:e}}},{key:"extendArrayProps",value:function(t,e,i){return e.yaxis&&(e=t.extendYAxis(e,i)),e.annotations&&(e.annotations.yaxis&&(e=t.extendYAxisAnnotations(e)),e.annotations.xaxis&&(e=t.extendXAxisAnnotations(e)),e.annotations.points&&(e=t.extendPointAnnotations(e))),e}}]),t}(),w=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e}return r(t,[{key:"setOrientations",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.w;if("vertical"===t.label.orientation){var a=null!==e?e:0,s=i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a,"']"));if(null!==s){var r=s.getBoundingClientRect();s.setAttribute("x",parseFloat(s.getAttribute("x"))-r.height+4),"top"===t.label.position?s.setAttribute("y",parseFloat(s.getAttribute("y"))+r.width):s.setAttribute("y",parseFloat(s.getAttribute("y"))-r.width);var o=this.annoCtx.graphics.rotateAroundCenter(s),n=o.x,l=o.y;s.setAttribute("transform","rotate(-90 ".concat(n," ").concat(l,")"))}}}},{key:"addBackgroundToAnno",value:function(t,e){var i=this.w;if(!t||void 0===e.label.text||void 0!==e.label.text&&!String(e.label.text).trim())return null;var a=i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(),s=t.getBoundingClientRect(),r=e.label.style.padding.left,o=e.label.style.padding.right,n=e.label.style.padding.top,l=e.label.style.padding.bottom;"vertical"===e.label.orientation&&(n=e.label.style.padding.left,l=e.label.style.padding.right,r=e.label.style.padding.top,o=e.label.style.padding.bottom);var h=s.left-a.left-r,c=s.top-a.top-n,d=this.annoCtx.graphics.drawRect(h-i.globals.barPadForNumericAxis,c,s.width+r+o,s.height+n+l,e.label.borderRadius,e.label.style.background,1,e.label.borderWidth,e.label.borderColor,0);return e.id&&d.node.classList.add(e.id),d}},{key:"annotationsBackground",value:function(){var t=this,e=this.w,i=function(i,a,s){var r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(a,"']"));if(r){var o=r.parentNode,n=t.addBackgroundToAnno(r,i);n&&(o.insertBefore(n.node,r),i.label.mouseEnter&&n.node.addEventListener("mouseenter",i.label.mouseEnter.bind(t,i)),i.label.mouseLeave&&n.node.addEventListener("mouseleave",i.label.mouseLeave.bind(t,i)),i.label.click&&n.node.addEventListener("click",i.label.click.bind(t,i)))}};e.config.annotations.xaxis.map((function(t,e){i(t,e,"xaxis")})),e.config.annotations.yaxis.map((function(t,e){i(t,e,"yaxis")})),e.config.annotations.points.map((function(t,e){i(t,e,"point")}))}},{key:"getY1Y2",value:function(t,e){var i,a="y1"===t?e.y:e.y2,s=this.w;if(this.annoCtx.invertAxis){var r=s.globals.labels.indexOf(a);s.config.xaxis.convertedCatToNumeric&&(r=s.globals.categoryLabels.indexOf(a));var o=s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child("+(r+1)+")");o&&(i=parseFloat(o.getAttribute("y")))}else{var n;if(s.config.yaxis[e.yAxisIndex].logarithmic)n=(a=new y(this.annoCtx.ctx).getLogVal(a,e.yAxisIndex))/s.globals.yLogRatio[e.yAxisIndex];else n=(a-s.globals.minYArr[e.yAxisIndex])/(s.globals.yRange[e.yAxisIndex]/s.globals.gridHeight);i=s.globals.gridHeight-n,!e.marker||void 0!==e.y&&null!==e.y||(i=0),s.config.yaxis[e.yAxisIndex]&&s.config.yaxis[e.yAxisIndex].reversed&&(i=n)}return i}},{key:"getX1X2",value:function(t,e){var i=this.w,a=this.annoCtx.invertAxis?i.globals.minY:i.globals.minX,s=this.annoCtx.invertAxis?i.globals.maxY:i.globals.maxX,r=this.annoCtx.invertAxis?i.globals.yRange[0]:i.globals.xRange,o=(e.x-a)/(r/i.globals.gridWidth);this.annoCtx.inversedReversedAxis&&(o=(s-e.x)/(r/i.globals.gridWidth)),"category"!==i.config.xaxis.type&&!i.config.xaxis.convertedCatToNumeric||this.annoCtx.invertAxis||i.globals.dataFormatXNumeric||(o=this.getStringX(e.x));var n=(e.x2-a)/(r/i.globals.gridWidth);return this.annoCtx.inversedReversedAxis&&(n=(s-e.x2)/(r/i.globals.gridWidth)),"category"!==i.config.xaxis.type&&!i.config.xaxis.convertedCatToNumeric||this.annoCtx.invertAxis||i.globals.dataFormatXNumeric||(n=this.getStringX(e.x2)),void 0!==e.x&&null!==e.x||!e.marker||(o=i.globals.gridWidth),"x1"===t?o:n}},{key:"getStringX",value:function(t){var e=this.w,i=t;e.config.xaxis.convertedCatToNumeric&&e.globals.categoryLabels.length&&(t=e.globals.categoryLabels.indexOf(t)+1);var a=e.globals.labels.indexOf(t),s=e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child("+(a+1)+")");return s&&(i=parseFloat(s.getAttribute("x"))),i}}]),t}(),k=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.invertAxis=this.annoCtx.invertAxis,this.helpers=new w(this.annoCtx)}return r(t,[{key:"addXaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=this.helpers.getX1X2("x1",t),o=t.label.text,n=t.strokeDashArray;if(x.isNumber(r)){if(null===t.x2||void 0===t.x2){var l=this.annoCtx.graphics.drawLine(r+t.offsetX,0+t.offsetY,r+t.offsetX,s.globals.gridHeight+t.offsetY,t.borderColor,n,t.borderWidth);e.appendChild(l.node),t.id&&l.node.classList.add(t.id)}else{if((a=this.helpers.getX1X2("x2",t))<r){var h=r;r=a,a=h}var c=this.annoCtx.graphics.drawRect(r+t.offsetX,0+t.offsetY,a-r,s.globals.gridHeight+t.offsetY,0,t.fillColor,t.opacity,1,t.borderColor,n);c.node.classList.add("apexcharts-annotation-rect"),c.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(c.node),t.id&&c.node.classList.add(t.id)}var d="top"===t.label.position?4:s.globals.gridHeight,g=this.annoCtx.graphics.getTextRects(o,parseFloat(t.label.style.fontSize)),u=this.annoCtx.graphics.drawText({x:r+t.label.offsetX,y:d+t.label.offsetY-("vertical"===t.label.orientation?"top"===t.label.position?g.width/2-12:-g.width/2:0),text:o,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});u.attr({rel:i}),e.appendChild(u.node),this.annoCtx.helpers.setOrientations(t,i)}}},{key:"drawXAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-xaxis-annotations"});return e.config.annotations.xaxis.map((function(e,a){t.addXaxisAnnotation(e,i.node,a)})),i}}]),t}(),A=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new w(this.annoCtx)}return r(t,[{key:"addYaxisAnnotation",value:function(t,e,i){var a,s=this.w,r=t.strokeDashArray,o=this.helpers.getY1Y2("y1",t),n=t.label.text;if(null===t.y2||void 0===t.y2){var l=this.annoCtx.graphics.drawLine(0+t.offsetX,o+t.offsetY,this._getYAxisAnnotationWidth(t),o+t.offsetY,t.borderColor,r,t.borderWidth);e.appendChild(l.node),t.id&&l.node.classList.add(t.id)}else{if((a=this.helpers.getY1Y2("y2",t))>o){var h=o;o=a,a=h}var c=this.annoCtx.graphics.drawRect(0+t.offsetX,a+t.offsetY,this._getYAxisAnnotationWidth(t),o-a,0,t.fillColor,t.opacity,1,t.borderColor,r);c.node.classList.add("apexcharts-annotation-rect"),c.attr("clip-path","url(#gridRectMask".concat(s.globals.cuid,")")),e.appendChild(c.node),t.id&&c.node.classList.add(t.id)}var d="right"===t.label.position?s.globals.gridWidth:0,g=this.annoCtx.graphics.drawText({x:d+t.label.offsetX,y:(null!=a?a:o)+t.label.offsetY-3,text:n,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});g.attr({rel:i}),e.appendChild(g.node)}},{key:"_getYAxisAnnotationWidth",value:function(t){var e=this.w;e.globals.gridWidth;return(t.width.indexOf("%")>-1?e.globals.gridWidth*parseInt(t.width,10)/100:parseInt(t.width,10))+t.offsetX}},{key:"drawYAxisAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-yaxis-annotations"});return e.config.annotations.yaxis.map((function(e,a){t.addYaxisAnnotation(e,i.node,a)})),i}}]),t}(),S=function(){function t(e){a(this,t),this.w=e.w,this.annoCtx=e,this.helpers=new w(this.annoCtx)}return r(t,[{key:"addPointAnnotation",value:function(t,e,i){this.w;var a=this.helpers.getX1X2("x1",t),s=this.helpers.getY1Y2("y1",t);if(x.isNumber(a)){var r={pSize:t.marker.size,pointStrokeWidth:t.marker.strokeWidth,pointFillColor:t.marker.fillColor,pointStrokeColor:t.marker.strokeColor,shape:t.marker.shape,pRadius:t.marker.radius,class:"apexcharts-point-annotation-marker ".concat(t.marker.cssClass," ").concat(t.id?t.id:"")},o=this.annoCtx.graphics.drawMarker(a+t.marker.offsetX,s+t.marker.offsetY,r);e.appendChild(o.node);var n=t.label.text?t.label.text:"",l=this.annoCtx.graphics.drawText({x:a+t.label.offsetX,y:s+t.label.offsetY-t.marker.size-parseFloat(t.label.style.fontSize)/1.6,text:n,textAnchor:t.label.textAnchor,fontSize:t.label.style.fontSize,fontFamily:t.label.style.fontFamily,fontWeight:t.label.style.fontWeight,foreColor:t.label.style.color,cssClass:"apexcharts-point-annotation-label ".concat(t.label.style.cssClass," ").concat(t.id?t.id:"")});if(l.attr({rel:i}),e.appendChild(l.node),t.customSVG.SVG){var h=this.annoCtx.graphics.group({class:"apexcharts-point-annotations-custom-svg "+t.customSVG.cssClass});h.attr({transform:"translate(".concat(a+t.customSVG.offsetX,", ").concat(s+t.customSVG.offsetY,")")}),h.node.innerHTML=t.customSVG.SVG,e.appendChild(h.node)}if(t.image.path){var c=t.image.width?t.image.width:20,d=t.image.height?t.image.height:20;o=this.annoCtx.addImage({x:a+t.image.offsetX-c/2,y:s+t.image.offsetY-d/2,width:c,height:d,path:t.image.path,appendTo:".apexcharts-point-annotations"})}t.mouseEnter&&o.node.addEventListener("mouseenter",t.mouseEnter.bind(this,t)),t.mouseLeave&&o.node.addEventListener("mouseleave",t.mouseLeave.bind(this,t)),t.click&&o.node.addEventListener("click",t.click.bind(this,t))}}},{key:"drawPointAnnotations",value:function(){var t=this,e=this.w,i=this.annoCtx.graphics.group({class:"apexcharts-point-annotations"});return e.config.annotations.points.map((function(e,a){t.addPointAnnotation(e,i.node,a)})),i}}]),t}();var C={name:"en",options:{months:["January","February","March","April","May","June","July","August","September","October","November","December"],shortMonths:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],days:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],shortDays:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],toolbar:{exportToSVG:"Download SVG",exportToPNG:"Download PNG",exportToCSV:"Download CSV",menu:"Menu",selection:"Selection",selectionZoom:"Selection Zoom",zoomIn:"Zoom In",zoomOut:"Zoom Out",pan:"Panning",reset:"Reset Zoom"}}},L=function(){function t(){a(this,t),this.yAxis={show:!0,showAlways:!1,showForNullSeries:!0,seriesName:void 0,opposite:!1,reversed:!1,logarithmic:!1,logBase:10,tickAmount:void 0,forceNiceScale:!1,max:void 0,min:void 0,floating:!1,decimalsInFloat:void 0,labels:{show:!0,minWidth:0,maxWidth:160,offsetX:0,offsetY:0,align:void 0,rotate:0,padding:20,style:{colors:[],fontSize:"11px",fontWeight:400,fontFamily:void 0,cssClass:""},formatter:void 0},axisBorder:{show:!1,color:"#e0e0e0",width:1,offsetX:0,offsetY:0},axisTicks:{show:!1,color:"#e0e0e0",width:6,offsetX:0,offsetY:0},title:{text:void 0,rotate:-90,offsetY:0,offsetX:0,style:{color:void 0,fontSize:"11px",fontWeight:900,fontFamily:void 0,cssClass:""}},tooltip:{enabled:!1,offsetX:0},crosshairs:{show:!0,position:"front",stroke:{color:"#b6b6b6",width:1,dashArray:0}}},this.pointAnnotation={id:void 0,x:0,y:null,yAxisIndex:0,seriesIndex:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,marker:{size:4,fillColor:"#fff",strokeWidth:2,strokeColor:"#333",shape:"circle",offsetX:0,offsetY:0,radius:2,cssClass:""},label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}},customSVG:{SVG:void 0,cssClass:void 0,offsetX:0,offsetY:0},image:{path:void 0,width:20,height:20,offsetX:0,offsetY:0}},this.yAxisAnnotation={id:void 0,y:0,y2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,width:"100%",yAxisIndex:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"end",position:"right",offsetX:0,offsetY:-3,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.xAxisAnnotation={id:void 0,x:0,x2:null,strokeDashArray:1,fillColor:"#c2c2c2",borderColor:"#c2c2c2",borderWidth:1,opacity:.3,offsetX:0,offsetY:0,label:{borderColor:"#c2c2c2",borderWidth:1,borderRadius:2,text:void 0,textAnchor:"middle",orientation:"vertical",position:"top",offsetX:0,offsetY:0,mouseEnter:void 0,mouseLeave:void 0,click:void 0,style:{background:"#fff",color:void 0,fontSize:"11px",fontFamily:void 0,fontWeight:400,cssClass:"",padding:{left:5,right:5,top:2,bottom:2}}}},this.text={x:0,y:0,text:"",textAnchor:"start",foreColor:void 0,fontSize:"13px",fontFamily:void 0,fontWeight:400,appendTo:".apexcharts-annotations",backgroundColor:"transparent",borderColor:"#c2c2c2",borderRadius:0,borderWidth:0,paddingLeft:4,paddingRight:4,paddingTop:2,paddingBottom:2}}return r(t,[{key:"init",value:function(){return{annotations:{position:"front",yaxis:[this.yAxisAnnotation],xaxis:[this.xAxisAnnotation],points:[this.pointAnnotation],texts:[],images:[],shapes:[]},chart:{animations:{enabled:!0,easing:"easeinout",speed:800,animateGradually:{delay:150,enabled:!0},dynamicAnimation:{enabled:!0,speed:350}},background:"transparent",locales:[C],defaultLocale:"en",dropShadow:{enabled:!1,enabledOnSeries:void 0,top:2,left:2,blur:4,color:"#000",opacity:.35},events:{animationEnd:void 0,beforeMount:void 0,mounted:void 0,updated:void 0,click:void 0,mouseMove:void 0,mouseLeave:void 0,legendClick:void 0,markerClick:void 0,selection:void 0,dataPointSelection:void 0,dataPointMouseEnter:void 0,dataPointMouseLeave:void 0,beforeZoom:void 0,beforeResetZoom:void 0,zoomed:void 0,scrolled:void 0,brushScrolled:void 0},foreColor:"#373d3f",fontFamily:"Helvetica, Arial, sans-serif",height:"auto",parentHeightOffset:15,redrawOnParentResize:!0,redrawOnWindowResize:!0,id:void 0,group:void 0,offsetX:0,offsetY:0,selection:{enabled:!1,type:"x",fill:{color:"#24292e",opacity:.1},stroke:{width:1,color:"#24292e",opacity:.4,dashArray:3},xaxis:{min:void 0,max:void 0},yaxis:{min:void 0,max:void 0}},sparkline:{enabled:!1},brush:{enabled:!1,autoScaleYaxis:!0,target:void 0},stacked:!1,stackType:"normal",toolbar:{show:!0,offsetX:0,offsetY:0,tools:{download:!0,selection:!0,zoom:!0,zoomin:!0,zoomout:!0,pan:!0,reset:!0,customIcons:[]},export:{csv:{filename:void 0,columnDelimiter:",",headerCategory:"category",headerValue:"value",dateFormatter:function(t){return new Date(t).toDateString()}},png:{filename:void 0},svg:{filename:void 0}},autoSelected:"zoom"},type:"line",width:"100%",zoom:{enabled:!0,type:"x",autoScaleYaxis:!1,zoomedArea:{fill:{color:"#90CAF9",opacity:.4},stroke:{color:"#0D47A1",opacity:.4,width:1}}}},plotOptions:{area:{fillTo:"origin"},bar:{horizontal:!1,columnWidth:"70%",barHeight:"70%",distributed:!1,borderRadius:0,rangeBarOverlap:!0,rangeBarGroupRows:!1,colors:{ranges:[],backgroundBarColors:[],backgroundBarOpacity:1,backgroundBarRadius:0},dataLabels:{position:"top",maxItems:100,hideOverflowingLabels:!0,orientation:"horizontal"}},bubble:{minBubbleRadius:void 0,maxBubbleRadius:void 0},candlestick:{colors:{upward:"#00B746",downward:"#EF403C"},wick:{useFillColor:!0}},boxPlot:{colors:{upper:"#00E396",lower:"#008FFB"}},heatmap:{radius:2,enableShades:!0,shadeIntensity:.5,reverseNegativeShade:!1,distributed:!1,useFillColorAsStroke:!1,colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},treemap:{enableShades:!0,shadeIntensity:.5,distributed:!1,reverseNegativeShade:!1,useFillColorAsStroke:!1,colorScale:{inverse:!1,ranges:[],min:void 0,max:void 0}},radialBar:{inverseOrder:!1,startAngle:0,endAngle:360,offsetX:0,offsetY:0,hollow:{margin:5,size:"50%",background:"transparent",image:void 0,imageWidth:150,imageHeight:150,imageOffsetX:0,imageOffsetY:0,imageClipped:!0,position:"front",dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},track:{show:!0,startAngle:void 0,endAngle:void 0,background:"#f2f2f2",strokeWidth:"97%",opacity:1,margin:5,dropShadow:{enabled:!1,top:0,left:0,blur:3,color:"#000",opacity:.5}},dataLabels:{show:!0,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:0,formatter:function(t){return t}},value:{show:!0,fontSize:"14px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:16,formatter:function(t){return t+"%"}},total:{show:!1,label:"Total",fontSize:"16px",fontWeight:600,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)/t.globals.series.length+"%"}}}},pie:{customScale:1,offsetX:0,offsetY:0,startAngle:0,endAngle:360,expandOnClick:!0,dataLabels:{offset:0,minAngleToShowLabel:10},donut:{size:"65%",background:"transparent",labels:{show:!1,name:{show:!0,fontSize:"16px",fontFamily:void 0,fontWeight:600,color:void 0,offsetY:-10,formatter:function(t){return t}},value:{show:!0,fontSize:"20px",fontFamily:void 0,fontWeight:400,color:void 0,offsetY:10,formatter:function(t){return t}},total:{show:!1,showAlways:!1,label:"Total",fontSize:"16px",fontWeight:400,fontFamily:void 0,color:void 0,formatter:function(t){return t.globals.seriesTotals.reduce((function(t,e){return t+e}),0)}}}}},polarArea:{rings:{strokeWidth:1,strokeColor:"#e8e8e8"},spokes:{strokeWidth:1,connectorColors:"#e8e8e8"}},radar:{size:void 0,offsetX:0,offsetY:0,polygons:{strokeWidth:1,strokeColors:"#e8e8e8",connectorColors:"#e8e8e8",fill:{colors:void 0}}}},colors:void 0,dataLabels:{enabled:!0,enabledOnSeries:void 0,formatter:function(t){return null!==t?t:""},textAnchor:"middle",distributed:!1,offsetX:0,offsetY:0,style:{fontSize:"12px",fontFamily:void 0,fontWeight:600,colors:void 0},background:{enabled:!0,foreColor:"#fff",borderRadius:2,padding:4,opacity:.9,borderWidth:1,borderColor:"#fff",dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},dropShadow:{enabled:!1,top:1,left:1,blur:1,color:"#000",opacity:.45}},fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]},image:{src:[],width:void 0,height:void 0},pattern:{style:"squares",width:6,height:6,strokeWidth:2}},forecastDataPoints:{count:0,fillOpacity:.5,strokeWidth:void 0,dashArray:4},grid:{show:!0,borderColor:"#e0e0e0",strokeDashArray:0,position:"back",xaxis:{lines:{show:!1}},yaxis:{lines:{show:!0}},row:{colors:void 0,opacity:.5},column:{colors:void 0,opacity:.5},padding:{top:0,right:10,bottom:0,left:12}},labels:[],legend:{show:!0,showForSingleSeries:!1,showForNullSeries:!0,showForZeroSeries:!0,floating:!1,position:"bottom",horizontalAlign:"center",inverseOrder:!1,fontSize:"12px",fontFamily:void 0,fontWeight:400,width:void 0,height:void 0,formatter:void 0,tooltipHoverFormatter:void 0,offsetX:-20,offsetY:4,customLegendItems:[],labels:{colors:void 0,useSeriesColors:!1},markers:{width:12,height:12,strokeWidth:0,fillColors:void 0,strokeColor:"#fff",radius:12,customHTML:void 0,offsetX:0,offsetY:0,onClick:void 0},itemMargin:{horizontal:5,vertical:2},onItemClick:{toggleDataSeries:!0},onItemHover:{highlightDataSeries:!0}},markers:{discrete:[],size:0,colors:void 0,strokeColors:"#fff",strokeWidth:2,strokeOpacity:.9,strokeDashArray:0,fillOpacity:1,shape:"circle",width:8,height:8,radius:2,offsetX:0,offsetY:0,onClick:void 0,onDblClick:void 0,showNullDataPoints:!0,hover:{size:void 0,sizeOffset:3}},noData:{text:void 0,align:"center",verticalAlign:"middle",offsetX:0,offsetY:0,style:{color:void 0,fontSize:"14px",fontFamily:void 0}},responsive:[],series:void 0,states:{normal:{filter:{type:"none",value:0}},hover:{filter:{type:"lighten",value:.1}},active:{allowMultipleDataPointsSelection:!1,filter:{type:"darken",value:.5}}},title:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:0,floating:!1,style:{fontSize:"14px",fontWeight:900,fontFamily:void 0,color:void 0}},subtitle:{text:void 0,align:"left",margin:5,offsetX:0,offsetY:30,floating:!1,style:{fontSize:"12px",fontWeight:400,fontFamily:void 0,color:void 0}},stroke:{show:!0,curve:"smooth",lineCap:"butt",width:2,colors:void 0,dashArray:0,fill:{type:"solid",colors:void 0,opacity:.85,gradient:{shade:"dark",type:"horizontal",shadeIntensity:.5,gradientToColors:void 0,inverseColors:!0,opacityFrom:1,opacityTo:1,stops:[0,50,100],colorStops:[]}}},tooltip:{enabled:!0,enabledOnSeries:void 0,shared:!0,followCursor:!1,intersect:!1,inverseOrder:!1,custom:void 0,fillSeriesColor:!1,theme:"light",cssClass:"",style:{fontSize:"12px",fontFamily:void 0},onDatasetHover:{highlightDataSeries:!1},x:{show:!0,format:"dd MMM",formatter:void 0},y:{formatter:void 0,title:{formatter:function(t){return t?t+": ":""}}},z:{formatter:void 0,title:"Size: "},marker:{show:!0,fillColors:void 0},items:{display:"flex"},fixed:{enabled:!1,position:"topRight",offsetX:0,offsetY:0}},xaxis:{type:"category",categories:[],convertedCatToNumeric:!1,offsetX:0,offsetY:0,overwriteCategories:void 0,labels:{show:!0,rotate:-45,rotateAlways:!1,hideOverlappingLabels:!0,trim:!1,minHeight:void 0,maxHeight:120,showDuplicates:!0,style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""},offsetX:0,offsetY:0,format:void 0,formatter:void 0,datetimeUTC:!0,datetimeFormatter:{year:"yyyy",month:"MMM 'yy",day:"dd MMM",hour:"HH:mm",minute:"HH:mm:ss",second:"HH:mm:ss"}},group:{groups:[],style:{colors:[],fontSize:"12px",fontWeight:400,fontFamily:void 0,cssClass:""}},axisBorder:{show:!0,color:"#e0e0e0",width:"100%",height:1,offsetX:0,offsetY:0},axisTicks:{show:!0,color:"#e0e0e0",height:6,offsetX:0,offsetY:0},tickAmount:void 0,tickPlacement:"on",min:void 0,max:void 0,range:void 0,floating:!1,decimalsInFloat:void 0,position:"bottom",title:{text:void 0,offsetX:0,offsetY:0,style:{color:void 0,fontSize:"12px",fontWeight:900,fontFamily:void 0,cssClass:""}},crosshairs:{show:!0,width:1,position:"back",opacity:.9,stroke:{color:"#b6b6b6",width:1,dashArray:3},fill:{type:"solid",color:"#B1B9C4",gradient:{colorFrom:"#D8E3F0",colorTo:"#BED1E6",stops:[0,100],opacityFrom:.4,opacityTo:.5}},dropShadow:{enabled:!1,left:0,top:0,blur:1,opacity:.4}},tooltip:{enabled:!0,offsetY:0,formatter:void 0,style:{fontSize:"12px",fontFamily:void 0}}},yaxis:this.yAxis,theme:{mode:"light",palette:"palette1",monochrome:{enabled:!1,color:"#008FFB",shadeTo:"light",shadeIntensity:.65}}}}}]),t}(),P=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.graphics=new m(this.ctx),this.w.globals.isBarHorizontal&&(this.invertAxis=!0),this.helpers=new w(this),this.xAxisAnnotations=new k(this),this.yAxisAnnotations=new A(this),this.pointsAnnotations=new S(this),this.w.globals.isBarHorizontal&&this.w.config.yaxis[0].reversed&&(this.inversedReversedAxis=!0),this.xDivision=this.w.globals.gridWidth/this.w.globals.dataPoints}return r(t,[{key:"drawAxesAnnotations",value:function(){var t=this.w;if(t.globals.axisCharts){for(var e=this.yAxisAnnotations.drawYAxisAnnotations(),i=this.xAxisAnnotations.drawXAxisAnnotations(),a=this.pointsAnnotations.drawPointAnnotations(),s=t.config.chart.animations.enabled,r=[e,i,a],o=[i.node,e.node,a.node],n=0;n<3;n++)t.globals.dom.elGraphical.add(r[n]),!s||t.globals.resized||t.globals.dataChanged||"scatter"!==t.config.chart.type&&"bubble"!==t.config.chart.type&&t.globals.dataPoints>1&&o[n].classList.add("apexcharts-element-hidden"),t.globals.delayedElements.push({el:o[n],index:0});this.helpers.annotationsBackground()}}},{key:"drawImageAnnos",value:function(){var t=this;this.w.config.annotations.images.map((function(e,i){t.addImage(e,i)}))}},{key:"drawTextAnnos",value:function(){var t=this;this.w.config.annotations.texts.map((function(e,i){t.addText(e,i)}))}},{key:"addXaxisAnnotation",value:function(t,e,i){this.xAxisAnnotations.addXaxisAnnotation(t,e,i)}},{key:"addYaxisAnnotation",value:function(t,e,i){this.yAxisAnnotations.addYaxisAnnotation(t,e,i)}},{key:"addPointAnnotation",value:function(t,e,i){this.pointsAnnotations.addPointAnnotation(t,e,i)}},{key:"addText",value:function(t,e){var i=t.x,a=t.y,s=t.text,r=t.textAnchor,o=t.foreColor,n=t.fontSize,l=t.fontFamily,h=t.fontWeight,c=t.cssClass,d=t.backgroundColor,g=t.borderWidth,u=t.strokeDashArray,p=t.borderRadius,f=t.borderColor,x=t.appendTo,b=void 0===x?".apexcharts-annotations":x,v=t.paddingLeft,m=void 0===v?4:v,y=t.paddingRight,w=void 0===y?4:y,k=t.paddingBottom,A=void 0===k?2:k,S=t.paddingTop,C=void 0===S?2:S,L=this.w,P=this.graphics.drawText({x:i,y:a,text:s,textAnchor:r||"start",fontSize:n||"12px",fontWeight:h||"regular",fontFamily:l||L.config.chart.fontFamily,foreColor:o||L.config.chart.foreColor,cssClass:c}),M=L.globals.dom.baseEl.querySelector(b);M&&M.appendChild(P.node);var T=P.bbox();if(s){var I=this.graphics.drawRect(T.x-m,T.y-C,T.width+m+w,T.height+A+C,p,d||"transparent",1,g,f,u);M.insertBefore(I.node,P.node)}}},{key:"addImage",value:function(t,e){var i=this.w,a=t.path,s=t.x,r=void 0===s?0:s,o=t.y,n=void 0===o?0:o,l=t.width,h=void 0===l?20:l,c=t.height,d=void 0===c?20:c,g=t.appendTo,u=void 0===g?".apexcharts-annotations":g,p=i.globals.dom.Paper.image(a);p.size(h,d).move(r,n);var f=i.globals.dom.baseEl.querySelector(u);return f&&f.appendChild(p.node),p}},{key:"addXaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"xaxis",contextMethod:i.addXaxisAnnotation}),i}},{key:"addYaxisAnnotationExternal",value:function(t,e,i){return this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"yaxis",contextMethod:i.addYaxisAnnotation}),i}},{key:"addPointAnnotationExternal",value:function(t,e,i){return void 0===this.invertAxis&&(this.invertAxis=i.w.globals.isBarHorizontal),this.addAnnotationExternal({params:t,pushToMemory:e,context:i,type:"point",contextMethod:i.addPointAnnotation}),i}},{key:"addAnnotationExternal",value:function(t){var e=t.params,i=t.pushToMemory,a=t.context,s=t.type,r=t.contextMethod,o=a,n=o.w,l=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations")),h=l.childNodes.length+1,c=new L,d=Object.assign({},"xaxis"===s?c.xAxisAnnotation:"yaxis"===s?c.yAxisAnnotation:c.pointAnnotation),g=x.extend(d,e);switch(s){case"xaxis":this.addXaxisAnnotation(g,l,h);break;case"yaxis":this.addYaxisAnnotation(g,l,h);break;case"point":this.addPointAnnotation(g,l,h)}var u=n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s,"-annotations .apexcharts-").concat(s,"-annotation-label[rel='").concat(h,"']")),p=this.helpers.addBackgroundToAnno(u,g);return p&&l.insertBefore(p.node,u),i&&n.globals.memory.methodsToExec.push({context:o,id:g.id?g.id:x.randomId(),method:r,label:"addAnnotation",params:e}),a}},{key:"clearAnnotations",value:function(t){var e=t.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");e.globals.memory.methodsToExec.map((function(t,i){"addText"!==t.label&&"addAnnotation"!==t.label||e.globals.memory.methodsToExec.splice(i,1)})),i=x.listToArray(i),Array.prototype.forEach.call(i,(function(t){for(;t.firstChild;)t.removeChild(t.firstChild)}))}},{key:"removeAnnotation",value:function(t,e){var i=t.w,a=i.globals.dom.baseEl.querySelectorAll(".".concat(e));a&&(i.globals.memory.methodsToExec.map((function(t,a){t.id===e&&i.globals.memory.methodsToExec.splice(a,1)})),Array.prototype.forEach.call(a,(function(t){t.parentElement.removeChild(t)})))}}]),t}(),M=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.opts=null,this.seriesIndex=0}return r(t,[{key:"clippedImgArea",value:function(t){var e=this.w,i=e.config,a=parseInt(e.globals.gridWidth,10),s=parseInt(e.globals.gridHeight,10),r=a>s?a:s,o=t.image,n=0,l=0;void 0===t.width&&void 0===t.height?void 0!==i.fill.image.width&&void 0!==i.fill.image.height?(n=i.fill.image.width+1,l=i.fill.image.height):(n=r+1,l=r):(n=t.width,l=t.height);var h=document.createElementNS(e.globals.SVGNS,"pattern");m.setAttrs(h,{id:t.patternID,patternUnits:t.patternUnits?t.patternUnits:"userSpaceOnUse",width:n+"px",height:l+"px"});var c=document.createElementNS(e.globals.SVGNS,"image");h.appendChild(c),c.setAttributeNS(window.SVG.xlink,"href",o),m.setAttrs(c,{x:0,y:0,preserveAspectRatio:"none",width:n+"px",height:l+"px"}),c.style.opacity=t.opacity,e.globals.dom.elDefs.node.appendChild(h)}},{key:"getSeriesIndex",value:function(t){var e=this.w;return("bar"===e.config.chart.type||"rangeBar"===e.config.chart.type)&&e.config.plotOptions.bar.distributed||"heatmap"===e.config.chart.type||"treemap"===e.config.chart.type?this.seriesIndex=t.seriesNumber:this.seriesIndex=t.seriesNumber%e.globals.series.length,this.seriesIndex}},{key:"fillPath",value:function(t){var e=this.w;this.opts=t;var i,a,s,r=this.w.config;this.seriesIndex=this.getSeriesIndex(t);var o=this.getFillColors()[this.seriesIndex];void 0!==e.globals.seriesColors[this.seriesIndex]&&(o=e.globals.seriesColors[this.seriesIndex]),"function"==typeof o&&(o=o({seriesIndex:this.seriesIndex,dataPointIndex:t.dataPointIndex,value:t.value,w:e}));var n=this.getFillType(this.seriesIndex),l=Array.isArray(r.fill.opacity)?r.fill.opacity[this.seriesIndex]:r.fill.opacity;t.color&&(o=t.color);var h=o;if(-1===o.indexOf("rgb")?o.length<9&&(h=x.hexToRgba(o,l)):o.indexOf("rgba")>-1&&(l=x.getOpacityFromRGBA(o)),t.opacity&&(l=t.opacity),"pattern"===n&&(a=this.handlePatternFill(a,o,l,h)),"gradient"===n&&(s=this.handleGradientFill(o,l,this.seriesIndex)),"image"===n){var c=r.fill.image.src,d=t.patternID?t.patternID:"";this.clippedImgArea({opacity:l,image:Array.isArray(c)?t.seriesNumber<c.length?c[t.seriesNumber]:c[0]:c,width:t.width?t.width:void 0,height:t.height?t.height:void 0,patternUnits:t.patternUnits,patternID:"pattern".concat(e.globals.cuid).concat(t.seriesNumber+1).concat(d)}),i="url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber+1).concat(d,")")}else i="gradient"===n?s:"pattern"===n?a:h;return t.solid&&(i=h),i}},{key:"getFillType",value:function(t){var e=this.w;return Array.isArray(e.config.fill.type)?e.config.fill.type[t]:e.config.fill.type}},{key:"getFillColors",value:function(){var t=this.w,e=t.config,i=this.opts,a=[];return t.globals.comboCharts?"line"===t.config.series[this.seriesIndex].type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors):"line"===e.chart.type?Array.isArray(t.globals.stroke.colors)?a=t.globals.stroke.colors:a.push(t.globals.stroke.colors):Array.isArray(t.globals.fill.colors)?a=t.globals.fill.colors:a.push(t.globals.fill.colors),void 0!==i.fillColors&&(a=[],Array.isArray(i.fillColors)?a=i.fillColors.slice():a.push(i.fillColors)),a}},{key:"handlePatternFill",value:function(t,e,i,a){var s=this.w.config,r=this.opts,o=new m(this.ctx),n=void 0===s.fill.pattern.strokeWidth?Array.isArray(s.stroke.width)?s.stroke.width[this.seriesIndex]:s.stroke.width:Array.isArray(s.fill.pattern.strokeWidth)?s.fill.pattern.strokeWidth[this.seriesIndex]:s.fill.pattern.strokeWidth,l=e;Array.isArray(s.fill.pattern.style)?t=void 0!==s.fill.pattern.style[r.seriesNumber]?o.drawPattern(s.fill.pattern.style[r.seriesNumber],s.fill.pattern.width,s.fill.pattern.height,l,n,i):a:t=o.drawPattern(s.fill.pattern.style,s.fill.pattern.width,s.fill.pattern.height,l,n,i);return t}},{key:"handleGradientFill",value:function(t,e,i){var a,s=this.w.config,r=this.opts,o=new m(this.ctx),n=new x,l=s.fill.gradient.type,h=t,c=void 0===s.fill.gradient.opacityFrom?e:Array.isArray(s.fill.gradient.opacityFrom)?s.fill.gradient.opacityFrom[i]:s.fill.gradient.opacityFrom;h.indexOf("rgba")>-1&&(c=x.getOpacityFromRGBA(h));var d=void 0===s.fill.gradient.opacityTo?e:Array.isArray(s.fill.gradient.opacityTo)?s.fill.gradient.opacityTo[i]:s.fill.gradient.opacityTo;if(void 0===s.fill.gradient.gradientToColors||0===s.fill.gradient.gradientToColors.length)a="dark"===s.fill.gradient.shade?n.shadeColor(-1*parseFloat(s.fill.gradient.shadeIntensity),t.indexOf("rgb")>-1?x.rgb2hex(t):t):n.shadeColor(parseFloat(s.fill.gradient.shadeIntensity),t.indexOf("rgb")>-1?x.rgb2hex(t):t);else if(s.fill.gradient.gradientToColors[r.seriesNumber]){var g=s.fill.gradient.gradientToColors[r.seriesNumber];a=g,g.indexOf("rgba")>-1&&(d=x.getOpacityFromRGBA(g))}else a=t;if(s.fill.gradient.inverseColors){var u=h;h=a,a=u}return h.indexOf("rgb")>-1&&(h=x.rgb2hex(h)),a.indexOf("rgb")>-1&&(a=x.rgb2hex(a)),o.drawGradient(l,h,a,c,d,r.size,s.fill.gradient.stops,s.fill.gradient.colorStops,i)}}]),t}(),T=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"setGlobalMarkerSize",value:function(){var t=this.w;if(t.globals.markers.size=Array.isArray(t.config.markers.size)?t.config.markers.size:[t.config.markers.size],t.globals.markers.size.length>0){if(t.globals.markers.size.length<t.globals.series.length+1)for(var e=0;e<=t.globals.series.length;e++)void 0===t.globals.markers.size[e]&&t.globals.markers.size.push(t.globals.markers.size[0])}else t.globals.markers.size=t.config.series.map((function(e){return t.config.markers.size}))}},{key:"plotChartMarkers",value:function(t,e,i,a){var s,r=arguments.length>4&&void 0!==arguments[4]&&arguments[4],o=this.w,n=e,l=t,h=null,c=new m(this.ctx),d=o.config.markers.discrete&&o.config.markers.discrete.length;if((o.globals.markers.size[e]>0||r||d)&&(h=c.group({class:r||d?"":"apexcharts-series-markers"})).attr("clip-path","url(#gridRectMarkerMask".concat(o.globals.cuid,")")),Array.isArray(l.x))for(var g=0;g<l.x.length;g++){var u=i;1===i&&0===g&&(u=0),1===i&&1===g&&(u=1);var p="apexcharts-marker";"line"!==o.config.chart.type&&"area"!==o.config.chart.type||o.globals.comboCharts||o.config.tooltip.intersect||(p+=" no-pointer-events");var f=Array.isArray(o.config.markers.size)?o.globals.markers.size[e]>0:o.config.markers.size>0;if(f||r||d){x.isNumber(l.y[g])?p+=" w".concat(x.randomId()):p="apexcharts-nullpoint";var b=this.getMarkerConfig({cssClass:p,seriesIndex:e,dataPointIndex:u});o.config.series[n].data[u]&&(o.config.series[n].data[u].fillColor&&(b.pointFillColor=o.config.series[n].data[u].fillColor),o.config.series[n].data[u].strokeColor&&(b.pointStrokeColor=o.config.series[n].data[u].strokeColor)),a&&(b.pSize=a),(s=c.drawMarker(l.x[g],l.y[g],b)).attr("rel",u),s.attr("j",u),s.attr("index",e),s.node.setAttribute("default-marker-size",b.pSize);var y=new v(this.ctx);y.setSelectionFilter(s,e,u),this.addEvents(s),h&&h.add(s)}else void 0===o.globals.pointsArray[e]&&(o.globals.pointsArray[e]=[]),o.globals.pointsArray[e].push([l.x[g],l.y[g]])}return h}},{key:"getMarkerConfig",value:function(t){var e=t.cssClass,i=t.seriesIndex,a=t.dataPointIndex,s=void 0===a?null:a,r=t.finishRadius,o=void 0===r?null:r,n=this.w,l=this.getMarkerStyle(i),h=n.globals.markers.size[i],c=n.config.markers;return null!==s&&c.discrete.length&&c.discrete.map((function(t){t.seriesIndex===i&&t.dataPointIndex===s&&(l.pointStrokeColor=t.strokeColor,l.pointFillColor=t.fillColor,h=t.size,l.pointShape=t.shape)})),{pSize:null===o?h:o,pRadius:c.radius,width:Array.isArray(c.width)?c.width[i]:c.width,height:Array.isArray(c.height)?c.height[i]:c.height,pointStrokeWidth:Array.isArray(c.strokeWidth)?c.strokeWidth[i]:c.strokeWidth,pointStrokeColor:l.pointStrokeColor,pointFillColor:l.pointFillColor,shape:l.pointShape||(Array.isArray(c.shape)?c.shape[i]:c.shape),class:e,pointStrokeOpacity:Array.isArray(c.strokeOpacity)?c.strokeOpacity[i]:c.strokeOpacity,pointStrokeDashArray:Array.isArray(c.strokeDashArray)?c.strokeDashArray[i]:c.strokeDashArray,pointFillOpacity:Array.isArray(c.fillOpacity)?c.fillOpacity[i]:c.fillOpacity,seriesIndex:i}}},{key:"addEvents",value:function(t){var e=this.w,i=new m(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this.ctx,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this.ctx,t)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this.ctx,t)),t.node.addEventListener("click",e.config.markers.onClick),t.node.addEventListener("dblclick",e.config.markers.onDblClick),t.node.addEventListener("touchstart",i.pathMouseDown.bind(this.ctx,t),{passive:!0})}},{key:"getMarkerStyle",value:function(t){var e=this.w,i=e.globals.markers.colors,a=e.config.markers.strokeColor||e.config.markers.strokeColors;return{pointStrokeColor:Array.isArray(a)?a[t]:a,pointFillColor:Array.isArray(i)?i[t]:i}}}]),t}(),I=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled}return r(t,[{key:"draw",value:function(t,e,i){var a=this.w,s=new m(this.ctx),r=i.realIndex,o=i.pointsPos,n=i.zRatio,l=i.elParent,h=s.group({class:"apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)});if(h.attr("clip-path","url(#gridRectMarkerMask".concat(a.globals.cuid,")")),Array.isArray(o.x))for(var c=0;c<o.x.length;c++){var d=e+1,g=!0;0===e&&0===c&&(d=0),0===e&&1===c&&(d=1);var u=0,p=a.globals.markers.size[r];if(n!==1/0){p=a.globals.seriesZ[r][d]/n;var f=a.config.plotOptions.bubble;f.minBubbleRadius&&p<f.minBubbleRadius&&(p=f.minBubbleRadius),f.maxBubbleRadius&&p>f.maxBubbleRadius&&(p=f.maxBubbleRadius)}a.config.chart.animations.enabled||(u=p);var x=o.x[c],b=o.y[c];if(u=u||0,null!==b&&void 0!==a.globals.series[r][d]||(g=!1),g){var v=this.drawPoint(x,b,u,p,r,d,e);h.add(v)}l.add(h)}}},{key:"drawPoint",value:function(t,e,i,a,s,r,o){var n=this.w,l=s,h=new b(this.ctx),c=new v(this.ctx),d=new M(this.ctx),g=new T(this.ctx),u=new m(this.ctx),p=g.getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:l,dataPointIndex:r,finishRadius:"bubble"===n.config.chart.type||n.globals.comboCharts&&n.config.series[s]&&"bubble"===n.config.series[s].type?a:null});a=p.pSize;var f,x=d.fillPath({seriesNumber:s,dataPointIndex:r,color:p.pointFillColor,patternUnits:"objectBoundingBox",value:n.globals.series[s][o]});if("circle"===p.shape?f=u.drawCircle(i):"square"!==p.shape&&"rect"!==p.shape||(f=u.drawRect(0,0,p.width-p.pointStrokeWidth/2,p.height-p.pointStrokeWidth/2,p.pRadius)),n.config.series[l].data[r]&&n.config.series[l].data[r].fillColor&&(x=n.config.series[l].data[r].fillColor),f.attr({x:t-p.width/2-p.pointStrokeWidth/2,y:e-p.height/2-p.pointStrokeWidth/2,cx:t,cy:e,fill:x,"fill-opacity":p.pointFillOpacity,stroke:p.pointStrokeColor,r:a,"stroke-width":p.pointStrokeWidth,"stroke-dasharray":p.pointStrokeDashArray,"stroke-opacity":p.pointStrokeOpacity}),n.config.chart.dropShadow.enabled){var y=n.config.chart.dropShadow;c.dropShadow(f,y,s)}if(!this.initialAnim||n.globals.dataChanged||n.globals.resized)n.globals.animationEnded=!0;else{var w=n.config.chart.animations.speed;h.animateMarker(f,0,"circle"===p.shape?a:{width:p.width,height:p.height},w,n.globals.easing,(function(){window.setTimeout((function(){h.animationCompleted(f)}),100)}))}if(n.globals.dataChanged&&"circle"===p.shape)if(this.dynamicAnim){var k,A,S,C,L=n.config.chart.animations.dynamicAnimation.speed;null!=(C=n.globals.previousPaths[s]&&n.globals.previousPaths[s][o])&&(k=C.x,A=C.y,S=void 0!==C.r?C.r:a);for(var P=0;P<n.globals.collapsedSeries.length;P++)n.globals.collapsedSeries[P].index===s&&(L=1,a=0);0===t&&0===e&&(a=0),h.animateCircle(f,{cx:k,cy:A,r:S},{cx:t,cy:e,r:a},L,n.globals.easing)}else f.attr({r:a});return f.attr({rel:r,j:r,index:s,"default-marker-size":a}),c.setSelectionFilter(f,s,r),g.addEvents(f),f.node.classList.add("apexcharts-marker"),f}},{key:"centerTextInBubble",value:function(t){var e=this.w;return{y:t+=parseInt(e.config.dataLabels.style.fontSize,10)/4}}}]),t}(),z=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"dataLabelsCorrection",value:function(t,e,i,a,s,r,o){var n=this.w,l=!1,h=new m(this.ctx).getTextRects(i,o),c=h.width,d=h.height;e<0&&(e=0),e>n.globals.gridHeight+d&&(e=n.globals.gridHeight+d/2),void 0===n.globals.dataLabelsRects[a]&&(n.globals.dataLabelsRects[a]=[]),n.globals.dataLabelsRects[a].push({x:t,y:e,width:c,height:d});var g=n.globals.dataLabelsRects[a].length-2,u=void 0!==n.globals.lastDrawnDataLabelsIndexes[a]?n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length-1]:0;if(void 0!==n.globals.dataLabelsRects[a][g]){var p=n.globals.dataLabelsRects[a][u];(t>p.x+p.width+2||e>p.y+p.height+2||t+c<p.x)&&(l=!0)}return(0===s||r)&&(l=!0),{x:t,y:e,textRects:h,drawnextLabel:l}}},{key:"drawDataLabel",value:function(t,e,i){var a=this,s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:2,r=this.w,o=new m(this.ctx),n=r.config.dataLabels,l=0,h=0,c=i,d=null;if(!n.enabled||!Array.isArray(t.x))return d;d=o.group({class:"apexcharts-data-labels"});for(var g=0;g<t.x.length;g++)if(l=t.x[g]+n.offsetX,h=t.y[g]+n.offsetY+s,!isNaN(l)){1===i&&0===g&&(c=0),1===i&&1===g&&(c=1);var u=r.globals.series[e][c],p="",f=function(t){return r.config.dataLabels.formatter(t,{ctx:a.ctx,seriesIndex:e,dataPointIndex:c,w:r})};if("bubble"===r.config.chart.type){p=f(u=r.globals.seriesZ[e][c]),h=t.y[g];var x=new I(this.ctx),b=x.centerTextInBubble(h,e,c);h=b.y}else void 0!==u&&(p=f(u));this.plotDataLabelsText({x:l,y:h,text:p,i:e,j:c,parent:d,offsetCorrection:!0,dataLabelsConfig:r.config.dataLabels})}return d}},{key:"plotDataLabelsText",value:function(t){var e=this.w,i=new m(this.ctx),a=t.x,s=t.y,r=t.i,o=t.j,n=t.text,l=t.textAnchor,h=t.fontSize,c=t.parent,d=t.dataLabelsConfig,g=t.color,u=t.alwaysDrawDataLabel,p=t.offsetCorrection;if(!(Array.isArray(e.config.dataLabels.enabledOnSeries)&&e.config.dataLabels.enabledOnSeries.indexOf(r)<0)){var f={x:a,y:s,drawnextLabel:!0,textRects:null};p&&(f=this.dataLabelsCorrection(a,s,n,r,o,u,parseInt(d.style.fontSize,10))),e.globals.zoomed||(a=f.x,s=f.y),f.textRects&&(a<-10-f.textRects.width||a>e.globals.gridWidth+f.textRects.width+10)&&(n="");var x=e.globals.dataLabels.style.colors[r];(("bar"===e.config.chart.type||"rangeBar"===e.config.chart.type)&&e.config.plotOptions.bar.distributed||e.config.dataLabels.distributed)&&(x=e.globals.dataLabels.style.colors[o]),"function"==typeof x&&(x=x({series:e.globals.series,seriesIndex:r,dataPointIndex:o,w:e})),g&&(x=g);var b=d.offsetX,y=d.offsetY;if("bar"!==e.config.chart.type&&"rangeBar"!==e.config.chart.type||(b=0,y=0),f.drawnextLabel){var w=i.drawText({width:100,height:parseInt(d.style.fontSize,10),x:a+b,y:s+y,foreColor:x,textAnchor:l||d.textAnchor,text:n,fontSize:h||d.style.fontSize,fontFamily:d.style.fontFamily,fontWeight:d.style.fontWeight||"normal"});if(w.attr({class:"apexcharts-datalabel",cx:a,cy:s}),d.dropShadow.enabled){var k=d.dropShadow;new v(this.ctx).dropShadow(w,k)}c.add(w),void 0===e.globals.lastDrawnDataLabelsIndexes[r]&&(e.globals.lastDrawnDataLabelsIndexes[r]=[]),e.globals.lastDrawnDataLabelsIndexes[r].push(o)}}}},{key:"addBackgroundToDataLabel",value:function(t,e){var i=this.w,a=i.config.dataLabels.background,s=a.padding,r=a.padding/2,o=e.width,n=e.height,l=new m(this.ctx).drawRect(e.x-s,e.y-r/2,o+2*s,n+r,a.borderRadius,"transparent"===i.config.chart.background?"#fff":i.config.chart.background,a.opacity,a.borderWidth,a.borderColor);a.dropShadow.enabled&&new v(this.ctx).dropShadow(l,a.dropShadow);return l}},{key:"dataLabelsBackground",value:function(){var t=this.w;if("bubble"!==t.config.chart.type)for(var e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"),i=0;i<e.length;i++){var a=e[i],s=a.getBBox(),r=null;if(s.width&&s.height&&(r=this.addBackgroundToDataLabel(a,s)),r){a.parentNode.insertBefore(r.node,a);var o=a.getAttribute("fill");t.config.chart.animations.enabled&&!t.globals.resized&&!t.globals.dataChanged?r.animate().attr({fill:o}):r.attr({fill:o}),a.setAttribute("fill",t.config.dataLabels.background.foreColor)}}}},{key:"bringForward",value:function(){for(var t=this.w,e=t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"),i=t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"),a=0;a<e.length;a++)i&&i.insertBefore(e[a],i.nextSibling)}}]),t}(),X=function(){function t(e){a(this,t),this.w=e.w,this.barCtx=e}return r(t,[{key:"handleBarDataLabels",value:function(t){var e=t.x,i=t.y,a=t.y1,s=t.y2,r=t.i,o=t.j,n=t.realIndex,l=t.series,h=t.barHeight,c=t.barWidth,d=t.barYPosition,g=t.visibleSeries,u=t.renderedPath,p=this.w,f=new m(this.barCtx.ctx),x=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[n]:this.barCtx.strokeWidth,b=e+parseFloat(c*g),v=i+parseFloat(h*g);p.globals.isXNumeric&&!p.globals.isBarHorizontal&&(b=e+parseFloat(c*(g+1)),v=i+parseFloat(h*(g+1))-x);var y=e,w=i,k={},A=p.config.dataLabels,S=this.barCtx.barOptions.dataLabels;void 0!==d&&this.barCtx.isRangeBar&&(v=d,w=d);var C=A.offsetX,L=A.offsetY,P={width:0,height:0};if(p.config.dataLabels.enabled){var M=this.barCtx.series[r][o];P=f.getTextRects(p.globals.yLabelFormatters[0](M),parseFloat(A.style.fontSize))}var T={x:e,y:i,i:r,j:o,renderedPath:u,bcx:b,bcy:v,barHeight:h,barWidth:c,textRects:P,strokeWidth:x,dataLabelsX:y,dataLabelsY:w,barDataLabelsConfig:S,offX:C,offY:L};return k=this.barCtx.isHorizontal?this.calculateBarsDataLabelsPosition(T):this.calculateColumnsDataLabelsPosition(T),u.attr({cy:k.bcy,cx:k.bcx,j:o,val:l[r][o],barHeight:h,barWidth:c}),this.drawCalculatedDataLabels({x:k.dataLabelsX,y:k.dataLabelsY,val:this.barCtx.isRangeBar?[a,s]:l[r][o],i:n,j:o,barWidth:c,barHeight:h,textRects:P,dataLabelsConfig:A})}},{key:"calculateColumnsDataLabelsPosition",value:function(t){var e,i=this.w,a=t.i,s=t.j,r=t.y,o=t.bcx,n=t.barWidth,l=t.barHeight,h=t.textRects,c=t.dataLabelsY,d=t.barDataLabelsConfig,g=t.strokeWidth,u=t.offX,p=t.offY;l=Math.abs(l);var f="vertical"===i.config.plotOptions.bar.dataLabels.orientation;o-=g/2;var x=i.globals.gridWidth/i.globals.dataPoints;if(e=i.globals.isXNumeric?o-n/2+u:o-x+n/2+u,f){e=e+h.height/2-g/2-2}var b=this.barCtx.series[a][s]<0,v=r;switch(this.barCtx.isReversed&&(v=r-l+(b?2*l:0),r-=l),d.position){case"center":c=f?b?v+l/2+p:v+l/2-p:b?v-l/2+h.height/2+p:v+l/2+h.height/2-p;break;case"bottom":c=f?b?v+l+p:v+l-p:b?v-l+h.height+g+p:v+l-h.height/2+g-p;break;case"top":c=f?b?v+p:v-p:b?v-h.height/2-p:v+h.height+p}return i.config.chart.stacked||(c<0?c=0+g:c+h.height/3>i.globals.gridHeight&&(c=i.globals.gridHeight-g)),{bcx:o,bcy:r,dataLabelsX:e,dataLabelsY:c}}},{key:"calculateBarsDataLabelsPosition",value:function(t){var e=this.w,i=t.x,a=t.i,s=t.j,r=t.bcy,o=t.barHeight,n=t.barWidth,l=t.textRects,h=t.dataLabelsX,c=t.strokeWidth,d=t.barDataLabelsConfig,g=t.offX,u=t.offY,p=e.globals.gridHeight/e.globals.dataPoints;n=Math.abs(n);var f=r-(this.barCtx.isRangeBar?0:p)+o/2+l.height/2+u-3,x=this.barCtx.series[a][s]<0,b=i;switch(this.barCtx.isReversed&&(b=i+n-(x?2*n:0),i=e.globals.gridWidth-n),d.position){case"center":h=x?b+n/2-g:Math.max(l.width/2,b-n/2)+g;break;case"bottom":h=x?b+n-c-Math.round(l.width/2)-g:b-n+c+Math.round(l.width/2)+g;break;case"top":h=x?b-c+Math.round(l.width/2)-g:b-c-Math.round(l.width/2)+g}return e.config.chart.stacked||(h<0?h=h+l.width+c:h+l.width/2>e.globals.gridWidth&&(h=e.globals.gridWidth-l.width-c)),{bcx:i,bcy:r,dataLabelsX:h,dataLabelsY:f}}},{key:"drawCalculatedDataLabels",value:function(t){var i=t.x,a=t.y,s=t.val,r=t.i,o=t.j,n=t.textRects,l=t.barHeight,h=t.barWidth,c=t.dataLabelsConfig,d=this.w,g="rotate(0)";"vertical"===d.config.plotOptions.bar.dataLabels.orientation&&(g="rotate(-90, ".concat(i,", ").concat(a,")"));var u=new z(this.barCtx.ctx),p=new m(this.barCtx.ctx),f=c.formatter,x=null,b=d.globals.collapsedSeriesIndices.indexOf(r)>-1;if(c.enabled&&!b){x=p.group({class:"apexcharts-data-labels",transform:g});var v="";void 0!==s&&(v=f(s,{seriesIndex:r,dataPointIndex:o,w:d}));var y=d.globals.series[r][o]<0,w=d.config.plotOptions.bar.dataLabels.position;if("vertical"===d.config.plotOptions.bar.dataLabels.orientation&&("top"===w&&(c.textAnchor=y?"end":"start"),"center"===w&&(c.textAnchor="middle"),"bottom"===w&&(c.textAnchor=y?"end":"start")),this.barCtx.isRangeBar&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels)h<p.getTextRects(v,parseFloat(c.style.fontSize)).width&&(v="");d.config.chart.stacked&&this.barCtx.barOptions.dataLabels.hideOverflowingLabels&&(this.barCtx.isHorizontal?n.width/1.6>Math.abs(h)&&(v=""):n.height/1.6>Math.abs(l)&&(v=""));var k=e({},c);this.barCtx.isHorizontal&&s<0&&("start"===c.textAnchor?k.textAnchor="end":"end"===c.textAnchor&&(k.textAnchor="start")),u.plotDataLabelsText({x:i,y:a,text:v,i:r,j:o,parent:x,dataLabelsConfig:k,alwaysDrawDataLabel:!0,offsetCorrection:!0})}return x}}]),t}(),E=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.legendInactiveClass="legend-mouseover-inactive"}return r(t,[{key:"getAllSeriesEls",value:function(){return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series")}},{key:"getSeriesByName",value:function(t){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat(x.escapeString(t),"']"))}},{key:"isSeriesHidden",value:function(t){var e=this.getSeriesByName(t),i=parseInt(e.getAttribute("data:realIndex"),10);return{isHidden:e.classList.contains("apexcharts-series-collapsed"),realIndex:i}}},{key:"addCollapsedClassToSeries",value:function(t,e){var i=this.w;function a(i){for(var a=0;a<i.length;a++)i[a].index===e&&t.node.classList.add("apexcharts-series-collapsed")}a(i.globals.collapsedSeries),a(i.globals.ancillaryCollapsedSeries)}},{key:"toggleSeries",value:function(t){var e=this.isSeriesHidden(t);return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,e.isHidden),e.isHidden}},{key:"showSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden&&this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!0)}},{key:"hideSeries",value:function(t){var e=this.isSeriesHidden(t);e.isHidden||this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex,!1)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w,s=x.clone(a.globals.initialSeries);a.globals.previousPaths=[],i?(a.globals.collapsedSeries=[],a.globals.ancillaryCollapsedSeries=[],a.globals.collapsedSeriesIndices=[],a.globals.ancillaryCollapsedSeriesIndices=[]):s=this.emptyCollapsedSeries(s),a.config.series=s,t&&(e&&(a.globals.zoomed=!1,this.ctx.updateHelpers.revertDefaultAxisMinMax()),this.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled))}},{key:"emptyCollapsedSeries",value:function(t){for(var e=this.w,i=0;i<t.length;i++)e.globals.collapsedSeriesIndices.indexOf(i)>-1&&(t[i].data=[]);return t}},{key:"toggleSeriesOnHover",value:function(t,e){var i=this.w;e||(e=t.target);var a=i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");if("mousemove"===t.type){var s=parseInt(e.getAttribute("rel"),10)-1,r=null,o=null;i.globals.axisCharts||"radialBar"===i.config.chart.type?i.globals.axisCharts?(r=i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s,"']")),o=i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s,"']"))):r=i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s+1,"']")):r=i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s+1,"'] path"));for(var n=0;n<a.length;n++)a[n].classList.add(this.legendInactiveClass);null!==r&&(i.globals.axisCharts||r.parentNode.classList.remove(this.legendInactiveClass),r.classList.remove(this.legendInactiveClass),null!==o&&o.classList.remove(this.legendInactiveClass))}else if("mouseout"===t.type)for(var l=0;l<a.length;l++)a[l].classList.remove(this.legendInactiveClass)}},{key:"highlightRangeInSeries",value:function(t,e){var i=this,a=this.w,s=a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"),r=function(t){for(var e=0;e<s.length;e++)s[e].classList[t](i.legendInactiveClass)};if("mousemove"===t.type){var o=parseInt(e.getAttribute("rel"),10)-1;r("add"),function(t){for(var e=0;e<s.length;e++){var a=parseInt(s[e].getAttribute("val"),10);a>=t.from&&a<=t.to&&s[e].classList.remove(i.legendInactiveClass)}}(a.config.plotOptions.heatmap.colorScale.ranges[o])}else"mouseout"===t.type&&r("remove")}},{key:"getActiveConfigSeriesIndex",value:function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"asc",i=this.w,a=0;if(i.config.series.length>1)for(var s=i.config.series.map((function(e,a){var s=!1;return t&&(s="bar"===i.config.series[a].type||"column"===i.config.series[a].type),e.data&&e.data.length>0&&!s?a:-1})),r="asc"===e?0:s.length-1;"asc"===e?r<s.length:r>=0;"asc"===e?r++:r--)if(-1!==s[r]){a=s[r];break}return a}},{key:"getPreviousPaths",value:function(){var t=this.w;function e(e,i,a){for(var s=e[i].childNodes,r={type:a,paths:[],realIndex:e[i].getAttribute("data:realIndex")},o=0;o<s.length;o++)if(s[o].hasAttribute("pathTo")){var n=s[o].getAttribute("pathTo");r.paths.push({d:n})}t.globals.previousPaths.push(r)}t.globals.previousPaths=[];["line","area","bar","rangebar","candlestick","radar"].forEach((function(i){for(var a,s=(a=i,t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a,"-series .apexcharts-series"))),r=0;r<s.length;r++)e(s,r,i)})),this.handlePrevBubbleScatterPaths("bubble"),this.handlePrevBubbleScatterPaths("scatter");var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series"));if(i.length>0)for(var a=function(e){for(var i=t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type," .apexcharts-series[data\\:realIndex='").concat(e,"'] rect")),a=[],s=function(t){var e=function(e){return i[t].getAttribute(e)},s={x:parseFloat(e("x")),y:parseFloat(e("y")),width:parseFloat(e("width")),height:parseFloat(e("height"))};a.push({rect:s,color:i[t].getAttribute("color")})},r=0;r<i.length;r++)s(r);t.globals.previousPaths.push(a)},s=0;s<i.length;s++)a(s);t.globals.axisCharts||(t.globals.previousPaths=t.globals.series)}},{key:"handlePrevBubbleScatterPaths",value:function(t){var e=this.w,i=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series"));if(i.length>0)for(var a=0;a<i.length;a++){for(var s=e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t,"-series .apexcharts-series[data\\:realIndex='").concat(a,"'] circle")),r=[],o=0;o<s.length;o++)r.push({x:s[o].getAttribute("cx"),y:s[o].getAttribute("cy"),r:s[o].getAttribute("r")});e.globals.previousPaths.push(r)}}},{key:"clearPreviousPaths",value:function(){var t=this.w;t.globals.previousPaths=[],t.globals.allSeriesCollapsed=!1}},{key:"handleNoData",value:function(){var t=this.w,e=t.config.noData,i=new m(this.ctx),a=t.globals.svgWidth/2,s=t.globals.svgHeight/2,r="middle";if(t.globals.noData=!0,t.globals.animationEnded=!0,"left"===e.align?(a=10,r="start"):"right"===e.align&&(a=t.globals.svgWidth-10,r="end"),"top"===e.verticalAlign?s=50:"bottom"===e.verticalAlign&&(s=t.globals.svgHeight-50),a+=e.offsetX,s=s+parseInt(e.style.fontSize,10)+2+e.offsetY,void 0!==e.text&&""!==e.text){var o=i.drawText({x:a,y:s,text:e.text,textAnchor:r,fontSize:e.style.fontSize,fontFamily:e.style.fontFamily,foreColor:e.style.color,opacity:1,class:"apexcharts-text-nodata"});t.globals.dom.Paper.add(o)}}},{key:"setNullSeriesToZeroValues",value:function(t){for(var e=this.w,i=0;i<t.length;i++)if(0===t[i].length)for(var a=0;a<t[e.globals.maxValsInArrayIndex].length;a++)t[i].push(0);return t}},{key:"hasAllSeriesEqualX",value:function(){for(var t=!0,e=this.w,i=this.filteredSeriesX(),a=0;a<i.length-1;a++)if(i[a][0]!==i[a+1][0]){t=!1;break}return e.globals.allSeriesHasEqualX=t,t}},{key:"filteredSeriesX",value:function(){var t=this.w.globals.seriesX.map((function(t){return t.length>0?t:[]}));return t}}]),t}(),Y=function(){function t(e){a(this,t),this.w=e.w,this.barCtx=e}return r(t,[{key:"initVariables",value:function(t){var e=this.w;this.barCtx.series=t,this.barCtx.totalItems=0,this.barCtx.seriesLen=0,this.barCtx.visibleI=-1,this.barCtx.visibleItems=1;for(var i=0;i<t.length;i++)if(t[i].length>0&&(this.barCtx.seriesLen=this.barCtx.seriesLen+1,this.barCtx.totalItems+=t[i].length),e.globals.isXNumeric)for(var a=0;a<t[i].length;a++)e.globals.seriesX[i][a]>e.globals.minX&&e.globals.seriesX[i][a]<e.globals.maxX&&this.barCtx.visibleItems++;else this.barCtx.visibleItems=e.globals.dataPoints;0===this.barCtx.seriesLen&&(this.barCtx.seriesLen=1),this.barCtx.zeroSerieses=[],this.barCtx.radiusOnSeriesNumber=t.length-1,e.globals.comboCharts||this.checkZeroSeries({series:t})}},{key:"initialPositions",value:function(){var t,e,i,a,s,r,o,n,l=this.w,h=l.globals.dataPoints;this.barCtx.isRangeBar&&(h=l.globals.labels.length);var c=this.barCtx.seriesLen;if(l.config.plotOptions.bar.rangeBarGroupRows&&(c=1),this.barCtx.isHorizontal)s=(i=l.globals.gridHeight/h)/c,l.globals.isXNumeric&&(s=(i=l.globals.gridHeight/this.barCtx.totalItems)/this.barCtx.seriesLen),s=s*parseInt(this.barCtx.barOptions.barHeight,10)/100,n=this.barCtx.baseLineInvertedY+l.globals.padHorizontal+(this.barCtx.isReversed?l.globals.gridWidth:0)-(this.barCtx.isReversed?2*this.barCtx.baseLineInvertedY:0),e=(i-s*this.barCtx.seriesLen)/2;else{if(a=l.globals.gridWidth/this.barCtx.visibleItems,l.config.xaxis.convertedCatToNumeric&&(a=l.globals.gridWidth/l.globals.dataPoints),r=a/this.barCtx.seriesLen*parseInt(this.barCtx.barOptions.columnWidth,10)/100,l.globals.isXNumeric){var d=this.barCtx.xRatio;l.config.xaxis.convertedCatToNumeric&&(d=this.barCtx.initialXRatio),l.globals.minXDiff&&.5!==l.globals.minXDiff&&l.globals.minXDiff/d>0&&(a=l.globals.minXDiff/d),(r=a/this.barCtx.seriesLen*parseInt(this.barCtx.barOptions.columnWidth,10)/100)<1&&(r=1)}o=l.globals.gridHeight-this.barCtx.baseLineY[this.barCtx.yaxisIndex]-(this.barCtx.isReversed?l.globals.gridHeight:0)+(this.barCtx.isReversed?2*this.barCtx.baseLineY[this.barCtx.yaxisIndex]:0),t=l.globals.padHorizontal+(a-r*this.barCtx.seriesLen)/2}return{x:t,y:e,yDivision:i,xDivision:a,barHeight:s,barWidth:r,zeroH:o,zeroW:n}}},{key:"getPathFillColor",value:function(t,e,i,a){var s=this.w,r=new M(this.barCtx.ctx),o=null,n=this.barCtx.barOptions.distributed?i:e;this.barCtx.barOptions.colors.ranges.length>0&&this.barCtx.barOptions.colors.ranges.map((function(a){t[e][i]>=a.from&&t[e][i]<=a.to&&(o=a.color)}));return s.config.series[e].data[i]&&s.config.series[e].data[i].fillColor&&(o=s.config.series[e].data[i].fillColor),r.fillPath({seriesNumber:this.barCtx.barOptions.distributed?n:a,dataPointIndex:i,color:o,value:t[e][i]})}},{key:"getStrokeWidth",value:function(t,e,i){var a=0,s=this.w;return void 0===this.barCtx.series[t][e]||null===this.barCtx.series[t][e]?this.barCtx.isNullValue=!0:this.barCtx.isNullValue=!1,s.config.stroke.show&&(this.barCtx.isNullValue||(a=Array.isArray(this.barCtx.strokeWidth)?this.barCtx.strokeWidth[i]:this.barCtx.strokeWidth)),a}},{key:"barBackground",value:function(t){var e=t.j,i=t.i,a=t.x1,s=t.x2,r=t.y1,o=t.y2,n=t.elSeries,l=this.w,h=new m(this.barCtx.ctx),c=new E(this.barCtx.ctx).getActiveConfigSeriesIndex();if(this.barCtx.barOptions.colors.backgroundBarColors.length>0&&c===i){e>=this.barCtx.barOptions.colors.backgroundBarColors.length&&(e%=this.barCtx.barOptions.colors.backgroundBarColors.length);var d=this.barCtx.barOptions.colors.backgroundBarColors[e],g=h.drawRect(void 0!==a?a:0,void 0!==r?r:0,void 0!==s?s:l.globals.gridWidth,void 0!==o?o:l.globals.gridHeight,this.barCtx.barOptions.colors.backgroundBarRadius,d,this.barCtx.barOptions.colors.backgroundBarOpacity);n.add(g),g.node.classList.add("apexcharts-backgroundBar")}}},{key:"getColumnPaths",value:function(t){var e=t.barWidth,i=t.barXPosition,a=t.yRatio,s=t.y1,r=t.y2,o=t.strokeWidth,n=t.series,l=t.realIndex,h=t.i,c=t.j,d=t.w,g=new m(this.barCtx.ctx);(o=Array.isArray(o)?o[l]:o)||(o=0);var u={barWidth:e,strokeWidth:o,yRatio:a,barXPosition:i,y1:s,y2:r},p=this.getRoundedBars(d,u,n,h,c),f=i,x=i+e,b=g.move(f,s),v=g.move(f,s),y=g.line(x-o,s);return d.globals.previousPaths.length>0&&(v=this.barCtx.getPreviousPath(l,c,!1)),b=b+g.line(f,p.y2)+p.pathWithRadius+g.line(x-o,p.y2)+y+y+"z",v=v+g.line(f,s)+y+y+y+y+y+g.line(f,s),d.config.chart.stacked&&(this.barCtx.yArrj.push(p.y2WithRadius),this.barCtx.yArrjF.push(Math.abs(s-p.y2WithRadius)),this.barCtx.yArrjVal.push(this.barCtx.series[h][c])),{pathTo:b,pathFrom:v}}},{key:"getBarpaths",value:function(t){var e=t.barYPosition,i=t.barHeight,a=t.x1,s=t.x2,r=t.strokeWidth,o=t.series,n=t.realIndex,l=t.i,h=t.j,c=t.w,d=new m(this.barCtx.ctx);(r=Array.isArray(r)?r[n]:r)||(r=0);var g={barHeight:i,strokeWidth:r,barYPosition:e,x2:s,x1:a},u=this.getRoundedBars(c,g,o,l,h),p=d.move(a,e),f=d.move(a,e);c.globals.previousPaths.length>0&&(f=this.barCtx.getPreviousPath(n,h,!1));var x=e,b=e+i,v=d.line(a,b-r);return p=p+d.line(u.x2,x)+u.pathWithRadius+d.line(u.x2,b-r)+v+v+"z",f=f+d.line(a,x)+v+v+v+v+v+d.line(a,x),c.config.chart.stacked&&(this.barCtx.xArrj.push(u.x2WithRadius),this.barCtx.xArrjF.push(Math.abs(a-u.x2WithRadius)),this.barCtx.xArrjVal.push(this.barCtx.series[l][h])),{pathTo:p,pathFrom:f}}},{key:"getRoundedBars",value:function(t,e,i,a,s){var r=new m(this.barCtx.ctx),o=0,n=t.config.plotOptions.bar.borderRadius,l=Array.isArray(n);l?o=n[a>n.length-1?n.length-1:a]:o=n;if(t.config.chart.stacked&&i.length>1&&a!==this.barCtx.radiusOnSeriesNumber&&!l&&(o=0),this.barCtx.isHorizontal){var h="",c=e.x2;if(Math.abs(e.x1-e.x2)<o&&(o=Math.abs(e.x1-e.x2)),void 0!==i[a][s]||null!==i[a][s]){var d=this.barCtx.isReversed?i[a][s]>0:i[a][s]<0;d&&(o*=-1),c-=o,h=r.quadraticCurve(c+o,e.barYPosition,c+o,e.barYPosition+(d?-1*o:o))+r.line(c+o,e.barYPosition+e.barHeight-e.strokeWidth-(d?-1*o:o))+r.quadraticCurve(c+o,e.barYPosition+e.barHeight-e.strokeWidth,c,e.barYPosition+e.barHeight-e.strokeWidth)}return{pathWithRadius:h,x2WithRadius:c+o,x2:c}}var g="",u=e.y2;if(Math.abs(e.y1-e.y2)<o&&(o=Math.abs(e.y1-e.y2)),void 0!==i[a][s]||null!==i[a][s]){var p=i[a][s]<0;p&&(o*=-1),u+=o,g=r.quadraticCurve(e.barXPosition,u-o,e.barXPosition+(p?-1*o:o),u-o)+r.line(e.barXPosition+e.barWidth-e.strokeWidth-(p?-1*o:o),u-o)+r.quadraticCurve(e.barXPosition+e.barWidth-e.strokeWidth,u-o,e.barXPosition+e.barWidth-e.strokeWidth,u)}return{pathWithRadius:g,y2WithRadius:u-o,y2:u}}},{key:"checkZeroSeries",value:function(t){for(var e=t.series,i=this.w,a=0;a<e.length;a++){for(var s=0,r=0;r<e[i.globals.maxValsInArrayIndex].length;r++)s+=e[a][r];0===s&&this.barCtx.zeroSerieses.push(a)}for(var o=e.length-1;o>=0;o--)this.barCtx.zeroSerieses.indexOf(o)>-1&&o===this.radiusOnSeriesNumber&&(this.barCtx.radiusOnSeriesNumber-=1);for(var n=e.length-1;n>=0;n--)i.globals.collapsedSeriesIndices.indexOf(this.barCtx.radiusOnSeriesNumber)>-1&&(this.barCtx.radiusOnSeriesNumber-=1)}},{key:"getXForValue",value:function(t,e){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=i?e:null;return null!=t&&(a=e+t/this.barCtx.invertedYRatio-2*(this.barCtx.isReversed?t/this.barCtx.invertedYRatio:0)),a}},{key:"getYForValue",value:function(t,e){var i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=i?e:null;return null!=t&&(a=e-t/this.barCtx.yRatio[this.barCtx.yaxisIndex]+2*(this.barCtx.isReversed?t/this.barCtx.yRatio[this.barCtx.yaxisIndex]:0)),a}},{key:"getGoalValues",value:function(t,e,i,a,s){var r=this,n=this.w,l=[];return n.globals.seriesGoals[a]&&n.globals.seriesGoals[a][s]&&Array.isArray(n.globals.seriesGoals[a][s])&&n.globals.seriesGoals[a][s].forEach((function(a){var s;l.push((o(s={},t,"x"===t?r.getXForValue(a.value,e,!1):r.getYForValue(a.value,i,!1)),o(s,"attrs",a),s))})),l}},{key:"drawGoalLine",value:function(t){var e=t.barXPosition,i=t.barYPosition,a=t.goalX,s=t.goalY,r=t.barWidth,o=t.barHeight,n=new m(this.barCtx.ctx),l=n.group({className:"apexcharts-bar-goals-groups"}),h=null;return this.barCtx.isHorizontal?Array.isArray(a)&&a.forEach((function(t){var e=void 0!==t.attrs.strokeHeight?t.attrs.strokeHeight:o/2,a=i+e+o/2;h=n.drawLine(t.x,a-2*e,t.x,a,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeWidth?t.attrs.strokeWidth:2,t.attrs.strokeLineCap),l.add(h)})):Array.isArray(s)&&s.forEach((function(t){var i=void 0!==t.attrs.strokeWidth?t.attrs.strokeWidth:r/2,a=e+i+r/2;h=n.drawLine(a-2*i,t.y,a,t.y,t.attrs.strokeColor?t.attrs.strokeColor:void 0,t.attrs.strokeDashArray,t.attrs.strokeHeight?t.attrs.strokeHeight:2,t.attrs.strokeLineCap),l.add(h)})),l}}]),t}(),F=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w;var s=this.w;this.barOptions=s.config.plotOptions.bar,this.isHorizontal=this.barOptions.horizontal,this.strokeWidth=s.config.stroke.width,this.isNullValue=!1,this.isRangeBar=s.globals.seriesRangeBar.length&&this.isHorizontal,this.xyRatios=i,null!==this.xyRatios&&(this.xRatio=i.xRatio,this.initialXRatio=i.initialXRatio,this.yRatio=i.yRatio,this.invertedXRatio=i.invertedXRatio,this.invertedYRatio=i.invertedYRatio,this.baseLineY=i.baseLineY,this.baseLineInvertedY=i.baseLineInvertedY),this.yaxisIndex=0,this.seriesLen=0,this.barHelpers=new Y(this)}return r(t,[{key:"draw",value:function(t,i){var a=this.w,s=new m(this.ctx),r=new y(this.ctx,a);t=r.getLogSeries(t),this.series=t,this.yRatio=r.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);var o=s.group({class:"apexcharts-bar-series apexcharts-plot-series"});a.config.dataLabels.enabled&&this.totalItems>this.barOptions.dataLabels.maxItems&&console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering.");for(var n=0,l=0;n<t.length;n++,l++){var h,c,d,g,u=void 0,p=void 0,f=[],b=[],v=a.globals.comboCharts?i[n]:n,w=s.group({class:"apexcharts-series",rel:n+1,seriesName:x.escapeString(a.globals.seriesNames[v]),"data:realIndex":v});this.ctx.series.addCollapsedClassToSeries(w,v),t[n].length>0&&(this.visibleI=this.visibleI+1);var k=0,A=0;this.yRatio.length>1&&(this.yaxisIndex=v),this.isReversed=a.config.yaxis[this.yaxisIndex]&&a.config.yaxis[this.yaxisIndex].reversed;var S=this.barHelpers.initialPositions();p=S.y,k=S.barHeight,c=S.yDivision,g=S.zeroW,u=S.x,A=S.barWidth,h=S.xDivision,d=S.zeroH,this.horizontal||b.push(u+A/2);for(var C=s.group({class:"apexcharts-datalabels","data:realIndex":v}),L=s.group({class:"apexcharts-bar-goals-markers",style:"pointer-events: none"}),P=0;P<a.globals.dataPoints;P++){var M=this.barHelpers.getStrokeWidth(n,P,v),T=null,I={indexes:{i:n,j:P,realIndex:v,bc:l},x:u,y:p,strokeWidth:M,elSeries:w};this.isHorizontal?(T=this.drawBarPaths(e(e({},I),{},{barHeight:k,zeroW:g,yDivision:c})),A=this.series[n][P]/this.invertedYRatio):(T=this.drawColumnPaths(e(e({},I),{},{xDivision:h,barWidth:A,zeroH:d})),k=this.series[n][P]/this.yRatio[this.yaxisIndex]);var z=this.barHelpers.drawGoalLine({barXPosition:T.barXPosition,barYPosition:T.barYPosition,goalX:T.goalX,goalY:T.goalY,barHeight:k,barWidth:A});z&&L.add(z),p=T.y,u=T.x,P>0&&b.push(u+A/2),f.push(p);var X=this.barHelpers.getPathFillColor(t,n,P,v);this.renderSeries({realIndex:v,pathFill:X,j:P,i:n,pathFrom:T.pathFrom,pathTo:T.pathTo,strokeWidth:M,elSeries:w,x:u,y:p,series:t,barHeight:k,barWidth:A,elDataLabelsWrap:C,elGoalsMarkers:L,visibleSeries:this.visibleI,type:"bar"})}a.globals.seriesXvalues[v]=b,a.globals.seriesYvalues[v]=f,o.add(w)}return o}},{key:"renderSeries",value:function(t){var e=t.realIndex,i=t.pathFill,a=t.lineFill,s=t.j,r=t.i,o=t.pathFrom,n=t.pathTo,l=t.strokeWidth,h=t.elSeries,c=t.x,d=t.y,g=t.y1,u=t.y2,p=t.series,f=t.barHeight,x=t.barWidth,b=t.barYPosition,y=t.elDataLabelsWrap,w=t.elGoalsMarkers,k=t.visibleSeries,A=t.type,S=this.w,C=new m(this.ctx);a||(a=this.barOptions.distributed?S.globals.stroke.colors[s]:S.globals.stroke.colors[e]),S.config.series[r].data[s]&&S.config.series[r].data[s].strokeColor&&(a=S.config.series[r].data[s].strokeColor),this.isNullValue&&(i="none");var L=s/S.config.chart.animations.animateGradually.delay*(S.config.chart.animations.speed/S.globals.dataPoints)/2.4,P=C.renderPaths({i:r,j:s,realIndex:e,pathFrom:o,pathTo:n,stroke:a,strokeWidth:l,strokeLineCap:S.config.stroke.lineCap,fill:i,animationDelay:L,initialSpeed:S.config.chart.animations.speed,dataChangeSpeed:S.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(A,"-area")});P.attr("clip-path","url(#gridRectMask".concat(S.globals.cuid,")"));var M=S.config.forecastDataPoints;M.count>0&&s>=S.globals.dataPoints-M.count&&(P.node.setAttribute("stroke-dasharray",M.dashArray),P.node.setAttribute("stroke-width",M.strokeWidth),P.node.setAttribute("fill-opacity",M.fillOpacity)),void 0!==g&&void 0!==u&&(P.attr("data-range-y1",g),P.attr("data-range-y2",u)),new v(this.ctx).setSelectionFilter(P,e,s),h.add(P);var T=new X(this).handleBarDataLabels({x:c,y:d,y1:g,y2:u,i:r,j:s,series:p,realIndex:e,barHeight:f,barWidth:x,barYPosition:b,renderedPath:P,visibleSeries:k});return null!==T&&y.add(T),h.add(y),w&&h.add(w),h}},{key:"drawBarPaths",value:function(t){var e=t.indexes,i=t.barHeight,a=t.strokeWidth,s=t.zeroW,r=t.x,o=t.y,n=t.yDivision,l=t.elSeries,h=this.w,c=e.i,d=e.j;h.globals.isXNumeric&&(o=(h.globals.seriesX[c][d]-h.globals.minX)/this.invertedXRatio-i);var g=o+i*this.visibleI;r=this.barHelpers.getXForValue(this.series[c][d],s);var u=this.barHelpers.getBarpaths({barYPosition:g,barHeight:i,x1:s,x2:r,strokeWidth:a,series:this.series,realIndex:e.realIndex,i:c,j:d,w:h});return h.globals.isXNumeric||(o+=n),this.barHelpers.barBackground({j:d,i:c,y1:g-i*this.visibleI,y2:i*this.seriesLen,elSeries:l}),{pathTo:u.pathTo,pathFrom:u.pathFrom,x:r,y:o,goalX:this.barHelpers.getGoalValues("x",s,null,c,d),barYPosition:g}}},{key:"drawColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.y,s=t.xDivision,r=t.barWidth,o=t.zeroH,n=t.strokeWidth,l=t.elSeries,h=this.w,c=e.realIndex,d=e.i,g=e.j,u=e.bc;if(h.globals.isXNumeric){var p=c;h.globals.seriesX[c].length||(p=h.globals.maxValsInArrayIndex),i=(h.globals.seriesX[p][g]-h.globals.minX)/this.xRatio-r*this.seriesLen/2}var f=i+r*this.visibleI;a=this.barHelpers.getYForValue(this.series[d][g],o);var x=this.barHelpers.getColumnPaths({barXPosition:f,barWidth:r,y1:o,y2:a,strokeWidth:n,series:this.series,realIndex:e.realIndex,i:d,j:g,w:h});return h.globals.isXNumeric||(i+=s),this.barHelpers.barBackground({bc:u,j:g,i:d,x1:f-n/2-r*this.visibleI,x2:r*this.seriesLen+n/2,elSeries:l}),{pathTo:x.pathTo,pathFrom:x.pathFrom,x:i,y:a,goalY:this.barHelpers.getGoalValues("y",null,o,d,g),barXPosition:f}}},{key:"getPreviousPath",value:function(t,e){for(var i,a=this.w,s=0;s<a.globals.previousPaths.length;s++){var r=a.globals.previousPaths[s];r.paths&&r.paths.length>0&&parseInt(r.realIndex,10)===parseInt(t,10)&&void 0!==a.globals.previousPaths[s].paths[e]&&(i=a.globals.previousPaths[s].paths[e].d)}return i}}]),t}(),R=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.months31=[1,3,5,7,8,10,12],this.months30=[2,4,6,9,11],this.daysCntOfYear=[0,31,59,90,120,151,181,212,243,273,304,334]}return r(t,[{key:"isValidDate",value:function(t){return!isNaN(this.parseDate(t))}},{key:"getTimeStamp",value:function(t){return Date.parse(t)?this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toISOString().substr(0,25)).getTime():new Date(t).getTime():t}},{key:"getDate",value:function(t){return this.w.config.xaxis.labels.datetimeUTC?new Date(new Date(t).toUTCString()):new Date(t)}},{key:"parseDate",value:function(t){var e=Date.parse(t);if(!isNaN(e))return this.getTimeStamp(t);var i=Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "));return i=this.getTimeStamp(i)}},{key:"parseDateWithTimezone",value:function(t){return Date.parse(t.replace(/-/g,"/").replace(/[a-z]+/gi," "))}},{key:"formatDate",value:function(t,e){var i=this.w.globals.locale,a=this.w.config.xaxis.labels.datetimeUTC,s=["\0"].concat(u(i.months)),r=["\x01"].concat(u(i.shortMonths)),o=["\x02"].concat(u(i.days)),n=["\x03"].concat(u(i.shortDays));function l(t,e){var i=t+"";for(e=e||2;i.length<e;)i="0"+i;return i}var h=a?t.getUTCFullYear():t.getFullYear();e=(e=(e=e.replace(/(^|[^\\])yyyy+/g,"$1"+h)).replace(/(^|[^\\])yy/g,"$1"+h.toString().substr(2,2))).replace(/(^|[^\\])y/g,"$1"+h);var c=(a?t.getUTCMonth():t.getMonth())+1;e=(e=(e=(e=e.replace(/(^|[^\\])MMMM+/g,"$1"+s[0])).replace(/(^|[^\\])MMM/g,"$1"+r[0])).replace(/(^|[^\\])MM/g,"$1"+l(c))).replace(/(^|[^\\])M/g,"$1"+c);var d=a?t.getUTCDate():t.getDate();e=(e=(e=(e=e.replace(/(^|[^\\])dddd+/g,"$1"+o[0])).replace(/(^|[^\\])ddd/g,"$1"+n[0])).replace(/(^|[^\\])dd/g,"$1"+l(d))).replace(/(^|[^\\])d/g,"$1"+d);var g=a?t.getUTCHours():t.getHours(),p=g>12?g-12:0===g?12:g;e=(e=(e=(e=e.replace(/(^|[^\\])HH+/g,"$1"+l(g))).replace(/(^|[^\\])H/g,"$1"+g)).replace(/(^|[^\\])hh+/g,"$1"+l(p))).replace(/(^|[^\\])h/g,"$1"+p);var f=a?t.getUTCMinutes():t.getMinutes();e=(e=e.replace(/(^|[^\\])mm+/g,"$1"+l(f))).replace(/(^|[^\\])m/g,"$1"+f);var x=a?t.getUTCSeconds():t.getSeconds();e=(e=e.replace(/(^|[^\\])ss+/g,"$1"+l(x))).replace(/(^|[^\\])s/g,"$1"+x);var b=a?t.getUTCMilliseconds():t.getMilliseconds();e=e.replace(/(^|[^\\])fff+/g,"$1"+l(b,3)),b=Math.round(b/10),e=e.replace(/(^|[^\\])ff/g,"$1"+l(b)),b=Math.round(b/10);var v=g<12?"AM":"PM";e=(e=(e=e.replace(/(^|[^\\])f/g,"$1"+b)).replace(/(^|[^\\])TT+/g,"$1"+v)).replace(/(^|[^\\])T/g,"$1"+v.charAt(0));var m=v.toLowerCase();e=(e=e.replace(/(^|[^\\])tt+/g,"$1"+m)).replace(/(^|[^\\])t/g,"$1"+m.charAt(0));var y=-t.getTimezoneOffset(),w=a||!y?"Z":y>0?"+":"-";if(!a){var k=(y=Math.abs(y))%60;w+=l(Math.floor(y/60))+":"+l(k)}e=e.replace(/(^|[^\\])K/g,"$1"+w);var A=(a?t.getUTCDay():t.getDay())+1;return e=(e=(e=(e=(e=e.replace(new RegExp(o[0],"g"),o[A])).replace(new RegExp(n[0],"g"),n[A])).replace(new RegExp(s[0],"g"),s[c])).replace(new RegExp(r[0],"g"),r[c])).replace(/\\(.)/g,"$1")}},{key:"getTimeUnitsfromTimestamp",value:function(t,e,i){var a=this.w;void 0!==a.config.xaxis.min&&(t=a.config.xaxis.min),void 0!==a.config.xaxis.max&&(e=a.config.xaxis.max);var s=this.getDate(t),r=this.getDate(e),o=this.formatDate(s,"yyyy MM dd HH mm ss fff").split(" "),n=this.formatDate(r,"yyyy MM dd HH mm ss fff").split(" ");return{minMillisecond:parseInt(o[6],10),maxMillisecond:parseInt(n[6],10),minSecond:parseInt(o[5],10),maxSecond:parseInt(n[5],10),minMinute:parseInt(o[4],10),maxMinute:parseInt(n[4],10),minHour:parseInt(o[3],10),maxHour:parseInt(n[3],10),minDate:parseInt(o[2],10),maxDate:parseInt(n[2],10),minMonth:parseInt(o[1],10)-1,maxMonth:parseInt(n[1],10)-1,minYear:parseInt(o[0],10),maxYear:parseInt(n[0],10)}}},{key:"isLeapYear",value:function(t){return t%4==0&&t%100!=0||t%400==0}},{key:"calculcateLastDaysOfMonth",value:function(t,e,i){return this.determineDaysOfMonths(t,e)-i}},{key:"determineDaysOfYear",value:function(t){var e=365;return this.isLeapYear(t)&&(e=366),e}},{key:"determineRemainingDaysOfYear",value:function(t,e,i){var a=this.daysCntOfYear[e]+i;return e>1&&this.isLeapYear()&&a++,a}},{key:"determineDaysOfMonths",value:function(t,e){var i=30;switch(t=x.monthMod(t),!0){case this.months30.indexOf(t)>-1:2===t&&(i=this.isLeapYear(e)?29:28);break;case this.months31.indexOf(t)>-1:default:i=31}return i}}]),t}(),H=function(t){n(s,F);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i){var a=this.w,s=new m(this.ctx);this.rangeBarOptions=this.w.config.plotOptions.rangeBar,this.series=t,this.seriesRangeStart=a.globals.seriesRangeStart,this.seriesRangeEnd=a.globals.seriesRangeEnd,this.barHelpers.initVariables(t);for(var r=s.group({class:"apexcharts-rangebar-series apexcharts-plot-series"}),o=0;o<t.length;o++){var n,l,h,c=void 0,d=void 0,g=void 0,u=a.globals.comboCharts?i[o]:o,p=s.group({class:"apexcharts-series",seriesName:x.escapeString(a.globals.seriesNames[u]),rel:o+1,"data:realIndex":u});this.ctx.series.addCollapsedClassToSeries(p,u),t[o].length>0&&(this.visibleI=this.visibleI+1);var f=0,b=0;this.yRatio.length>1&&(this.yaxisIndex=u);var v=this.barHelpers.initialPositions();d=v.y,h=v.zeroW,c=v.x,b=v.barWidth,n=v.xDivision,l=v.zeroH;for(var y=s.group({class:"apexcharts-datalabels","data:realIndex":u}),w=s.group({class:"apexcharts-rangebar-goals-markers",style:"pointer-events: none"}),k=0;k<a.globals.dataPoints;k++){var A=this.barHelpers.getStrokeWidth(o,k,u),S=this.seriesRangeStart[o][k],C=this.seriesRangeEnd[o][k],L=null,P=null,M={x:c,y:d,strokeWidth:A,elSeries:p};if(g=v.yDivision,f=v.barHeight,this.isHorizontal){P=d+f*this.visibleI;var T=this.seriesLen;a.config.plotOptions.bar.rangeBarGroupRows&&(T=1);var I=(g-f*T)/2;if(void 0===a.config.series[o].data[k])break;if(a.config.series[o].data[k].x){var z=this.detectOverlappingBars({i:o,j:k,barYPosition:P,srty:I,barHeight:f,yDivision:g,initPositions:v});f=z.barHeight,P=z.barYPosition}b=(L=this.drawRangeBarPaths(e({indexes:{i:o,j:k,realIndex:u},barHeight:f,barYPosition:P,zeroW:h,yDivision:g,y1:S,y2:C},M))).barWidth}else f=(L=this.drawRangeColumnPaths(e({indexes:{i:o,j:k,realIndex:u},zeroH:l,barWidth:b,xDivision:n},M))).barHeight;var X=this.barHelpers.drawGoalLine({barXPosition:L.barXPosition,barYPosition:P,goalX:L.goalX,goalY:L.goalY,barHeight:f,barWidth:b});X&&w.add(X),d=L.y,c=L.x;var E=this.barHelpers.getPathFillColor(t,o,k,u),Y=a.globals.stroke.colors[u];this.renderSeries({realIndex:u,pathFill:E,lineFill:Y,j:k,i:o,x:c,y:d,y1:S,y2:C,pathFrom:L.pathFrom,pathTo:L.pathTo,strokeWidth:A,elSeries:p,series:t,barHeight:f,barYPosition:P,barWidth:b,elDataLabelsWrap:y,elGoalsMarkers:w,visibleSeries:this.visibleI,type:"rangebar"})}r.add(p)}return r}},{key:"detectOverlappingBars",value:function(t){var e=t.i,i=t.j,a=t.barYPosition,s=t.srty,r=t.barHeight,o=t.yDivision,n=t.initPositions,l=this.w,h=[],c=l.config.series[e].data[i].rangeName,d=l.config.series[e].data[i].x,g=l.globals.labels.indexOf(d),u=l.globals.seriesRangeBar[e].findIndex((function(t){return t.x===d&&t.overlaps.length>0}));return a=l.config.plotOptions.bar.rangeBarGroupRows?s+o*g:s+r*this.visibleI+o*g,u>-1&&!l.config.plotOptions.bar.rangeBarOverlap&&(h=l.globals.seriesRangeBar[e][u].overlaps).indexOf(c)>-1&&(a=(r=n.barHeight/h.length)*this.visibleI+o*(100-parseInt(this.barOptions.barHeight,10))/100/2+r*(this.visibleI+h.indexOf(c))+o*g),{barYPosition:a,barHeight:r}}},{key:"drawRangeColumnPaths",value:function(t){var e=t.indexes,i=t.x;t.strokeWidth;var a=t.xDivision,s=t.barWidth,r=t.zeroH,o=this.w,n=e.i,l=e.j,h=this.yRatio[this.yaxisIndex],c=e.realIndex,d=this.getRangeValue(c,l),g=Math.min(d.start,d.end),u=Math.max(d.start,d.end);o.globals.isXNumeric&&(i=(o.globals.seriesX[n][l]-o.globals.minX)/this.xRatio-s/2);var p=i+s*this.visibleI;void 0===this.series[n][l]||null===this.series[n][l]?g=r:(g=r-g/h,u=r-u/h);var f=Math.abs(u-g),x=this.barHelpers.getColumnPaths({barXPosition:p,barWidth:s,y1:g,y2:u,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,realIndex:e.realIndex,i:c,j:l,w:o});return o.globals.isXNumeric||(i+=a),{pathTo:x.pathTo,pathFrom:x.pathFrom,barHeight:f,x:i,y:u,goalY:this.barHelpers.getGoalValues("y",null,r,n,l),barXPosition:p}}},{key:"drawRangeBarPaths",value:function(t){var e=t.indexes,i=t.y,a=t.y1,s=t.y2,r=t.yDivision,o=t.barHeight,n=t.barYPosition,l=t.zeroW,h=this.w,c=l+a/this.invertedYRatio,d=l+s/this.invertedYRatio,g=Math.abs(d-c),u=this.barHelpers.getBarpaths({barYPosition:n,barHeight:o,x1:c,x2:d,strokeWidth:this.strokeWidth,series:this.seriesRangeEnd,i:e.realIndex,realIndex:e.realIndex,j:e.j,w:h});return h.globals.isXNumeric||(i+=r),{pathTo:u.pathTo,pathFrom:u.pathFrom,barWidth:g,x:d,goalX:this.barHelpers.getGoalValues("x",l,null,e.realIndex,e.j),y:i}}},{key:"getRangeValue",value:function(t,e){var i=this.w;return{start:i.globals.seriesRangeStart[t][e],end:i.globals.seriesRangeEnd[t][e]}}},{key:"getTooltipValues",value:function(t){var e=t.ctx,i=t.seriesIndex,a=t.dataPointIndex,s=t.y1,r=t.y2,o=t.w,n=o.globals.seriesRangeStart[i][a],l=o.globals.seriesRangeEnd[i][a],h=o.globals.labels[a],c=o.config.series[i].name?o.config.series[i].name:"",d=o.config.tooltip.y.formatter,g=o.config.tooltip.y.title.formatter,u={w:o,seriesIndex:i,dataPointIndex:a,start:n,end:l};"function"==typeof g&&(c=g(c,u)),Number.isFinite(s)&&Number.isFinite(r)&&(n=s,l=r,o.config.series[i].data[a].x&&(h=o.config.series[i].data[a].x+":"),"function"==typeof d&&(h=d(h,u)));var p="",f="",x=o.globals.colors[i];if(void 0===o.config.tooltip.x.formatter)if("datetime"===o.config.xaxis.type){var b=new R(e);p=b.formatDate(b.getDate(n),o.config.tooltip.x.format),f=b.formatDate(b.getDate(l),o.config.tooltip.x.format)}else p=n,f=l;else p=o.config.tooltip.x.formatter(n),f=o.config.tooltip.x.formatter(l);return{start:n,end:l,startVal:p,endVal:f,ylabel:h,color:x,seriesName:c}}},{key:"buildCustomTooltipHTML",value:function(t){var e=t.color,i=t.seriesName;return'<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: '+e+'">'+(i||"")+'</span></div><div> <span class="category">'+t.ylabel+' </span> <span class="value start-value">'+t.start+'</span> <span class="separator">-</span> <span class="value end-value">'+t.end+"</span></div></div>"}}]),s}(),D=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"line",value:function(){return{chart:{animations:{easing:"swing"}},dataLabels:{enabled:!1},stroke:{width:5,curve:"straight"},markers:{size:0,hover:{sizeOffset:6}},xaxis:{crosshairs:{width:1}}}}},{key:"sparkline",value:function(t){this.opts.yaxis[0].show=!1,this.opts.yaxis[0].title.text="",this.opts.yaxis[0].axisBorder.show=!1,this.opts.yaxis[0].axisTicks.show=!1,this.opts.yaxis[0].floating=!0;return x.extend(t,{grid:{show:!1,padding:{left:0,right:0,top:0,bottom:0}},legend:{show:!1},xaxis:{labels:{show:!1},tooltip:{enabled:!1},axisBorder:{show:!1},axisTicks:{show:!1}},chart:{toolbar:{show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1}})}},{key:"bar",value:function(){return{chart:{stacked:!1,animations:{easing:"swing"}},plotOptions:{bar:{dataLabels:{position:"center"}}},dataLabels:{style:{colors:["#fff"]},background:{enabled:!1}},stroke:{width:0,lineCap:"round"},fill:{opacity:.85},legend:{markers:{shape:"square",radius:2,size:8}},tooltip:{shared:!1,intersect:!0},xaxis:{tooltip:{enabled:!1},tickPlacement:"between",crosshairs:{width:"barWidth",position:"back",fill:{type:"gradient"},dropShadow:{enabled:!1},stroke:{width:0}}}}}},{key:"candlestick",value:function(){var t=this;return{stroke:{width:1,colors:["#333"]},fill:{opacity:1},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Open","High","","Low","Close"],"candlestick")}},states:{active:{filter:{type:"none"}}},xaxis:{crosshairs:{width:1}}}}},{key:"boxPlot",value:function(){var t=this;return{chart:{animations:{dynamicAnimation:{enabled:!1}}},stroke:{width:1,colors:["#24292e"]},dataLabels:{enabled:!1},tooltip:{shared:!0,custom:function(e){var i=e.seriesIndex,a=e.dataPointIndex,s=e.w;return t._getBoxTooltip(s,i,a,["Minimum","Q1","Median","Q3","Maximum"],"boxPlot")}},markers:{size:5,strokeWidth:1,strokeColors:"#111"},xaxis:{crosshairs:{width:1}}}}},{key:"rangeBar",value:function(){return{stroke:{width:0,lineCap:"square"},plotOptions:{bar:{borderRadius:0,dataLabels:{position:"center"}}},dataLabels:{enabled:!1,formatter:function(t,e){e.ctx;var i=e.seriesIndex,a=e.dataPointIndex,s=e.w,r=s.globals.seriesRangeStart[i][a];return s.globals.seriesRangeEnd[i][a]-r},background:{enabled:!1},style:{colors:["#fff"]}},tooltip:{shared:!1,followCursor:!0,custom:function(t){return t.w.config.plotOptions&&t.w.config.plotOptions.bar&&t.w.config.plotOptions.bar.horizontal?function(t){var e=new H(t.ctx,null),i=e.getTooltipValues(t),a=i.color,s=i.seriesName,r=i.ylabel,o=i.startVal,n=i.endVal;return e.buildCustomTooltipHTML({color:a,seriesName:s,ylabel:r,start:o,end:n})}(t):function(t){var e=new H(t.ctx,null),i=e.getTooltipValues(t),a=i.color,s=i.seriesName,r=i.ylabel,o=i.start,n=i.end;return e.buildCustomTooltipHTML({color:a,seriesName:s,ylabel:r,start:o,end:n})}(t)}},xaxis:{tickPlacement:"between",tooltip:{enabled:!1},crosshairs:{stroke:{width:0}}}}}},{key:"area",value:function(){return{stroke:{width:4,fill:{type:"solid",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}}},fill:{type:"gradient",gradient:{inverseColors:!1,shade:"light",type:"vertical",opacityFrom:.65,opacityTo:.5,stops:[0,100,100]}},markers:{size:0,hover:{sizeOffset:6}},tooltip:{followCursor:!1}}}},{key:"brush",value:function(t){return x.extend(t,{chart:{toolbar:{autoSelected:"selection",show:!1},zoom:{enabled:!1}},dataLabels:{enabled:!1},stroke:{width:1},tooltip:{enabled:!1},xaxis:{tooltip:{enabled:!1}}})}},{key:"stacked100",value:function(t){t.dataLabels=t.dataLabels||{},t.dataLabels.formatter=t.dataLabels.formatter||void 0;var e=t.dataLabels.formatter;return t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})),"bar"===t.chart.type&&(t.dataLabels.formatter=e||function(t){return"number"==typeof t&&t?t.toFixed(0)+"%":t}),t}},{key:"convertCatToNumeric",value:function(t){return t.xaxis.convertedCatToNumeric=!0,t}},{key:"convertCatToNumericXaxis",value:function(t,e,i){t.xaxis.type="numeric",t.xaxis.labels=t.xaxis.labels||{},t.xaxis.labels.formatter=t.xaxis.labels.formatter||function(t){return x.isNumber(t)?Math.floor(t):t};var a=t.xaxis.labels.formatter,s=t.xaxis.categories&&t.xaxis.categories.length?t.xaxis.categories:t.labels;return i&&i.length&&(s=i.map((function(t){return Array.isArray(t)?t:String(t)}))),s&&s.length&&(t.xaxis.labels.formatter=function(t){return x.isNumber(t)?a(s[Math.floor(t)-1]):a(t)}),t.xaxis.categories=[],t.labels=[],t.xaxis.tickAmount=t.xaxis.tickAmount||"dataPoints",t}},{key:"bubble",value:function(){return{dataLabels:{style:{colors:["#fff"]}},tooltip:{shared:!1,intersect:!0},xaxis:{crosshairs:{width:0}},fill:{type:"solid",gradient:{shade:"light",inverse:!0,shadeIntensity:.55,opacityFrom:.4,opacityTo:.8}}}}},{key:"scatter",value:function(){return{dataLabels:{enabled:!1},tooltip:{shared:!1,intersect:!0},markers:{size:6,strokeWidth:1,hover:{sizeOffset:2}}}}},{key:"heatmap",value:function(){return{chart:{stacked:!1},fill:{opacity:1},dataLabels:{style:{colors:["#fff"]}},stroke:{colors:["#fff"]},tooltip:{followCursor:!0,marker:{show:!1},x:{show:!1}},legend:{position:"top",markers:{shape:"square",size:10,offsetY:2}},grid:{padding:{right:20}}}}},{key:"treemap",value:function(){return{chart:{zoom:{enabled:!1}},dataLabels:{style:{fontSize:14,fontWeight:600,colors:["#fff"]}},stroke:{show:!0,width:2,colors:["#fff"]},legend:{show:!1},fill:{gradient:{stops:[0,100]}},tooltip:{followCursor:!0,x:{show:!1}},grid:{padding:{left:0,right:0}},xaxis:{crosshairs:{show:!1},tooltip:{enabled:!1}}}}},{key:"pie",value:function(){return{chart:{toolbar:{show:!1}},plotOptions:{pie:{donut:{labels:{show:!1}}}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",stops:[0,100]}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"donut",value:function(){return{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},style:{colors:["#fff"]},background:{enabled:!1},dropShadow:{enabled:!0}},stroke:{colors:["#fff"]},fill:{opacity:1,gradient:{shade:"light",shadeIntensity:.35,stops:[80,100],opacityFrom:1,opacityTo:1}},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"polarArea",value:function(){return this.opts.yaxis[0].tickAmount=this.opts.yaxis[0].tickAmount?this.opts.yaxis[0].tickAmount:6,{chart:{toolbar:{show:!1}},dataLabels:{formatter:function(t){return t.toFixed(1)+"%"},enabled:!1},stroke:{show:!0,width:2},fill:{opacity:.7},tooltip:{theme:"dark",fillSeriesColor:!0},legend:{position:"right"}}}},{key:"radar",value:function(){return this.opts.yaxis[0].labels.offsetY=this.opts.yaxis[0].labels.offsetY?this.opts.yaxis[0].labels.offsetY:6,{dataLabels:{enabled:!1,style:{fontSize:"11px"}},stroke:{width:2},markers:{size:3,strokeWidth:1,strokeOpacity:1},fill:{opacity:.2},tooltip:{shared:!1,intersect:!0,followCursor:!0},grid:{show:!1},xaxis:{labels:{formatter:function(t){return t},style:{colors:["#a8a8a8"],fontSize:"11px"}},tooltip:{enabled:!1},crosshairs:{show:!1}}}}},{key:"radialBar",value:function(){return{chart:{animations:{dynamicAnimation:{enabled:!0,speed:800}},toolbar:{show:!1}},fill:{gradient:{shade:"dark",shadeIntensity:.4,inverseColors:!1,type:"diagonal2",opacityFrom:1,opacityTo:1,stops:[70,98,100]}},legend:{show:!1,position:"right"},tooltip:{enabled:!1,fillSeriesColor:!0}}}},{key:"_getBoxTooltip",value:function(t,e,i,a,s){var r=t.globals.seriesCandleO[e][i],o=t.globals.seriesCandleH[e][i],n=t.globals.seriesCandleM[e][i],l=t.globals.seriesCandleL[e][i],h=t.globals.seriesCandleC[e][i];return t.config.series[e].type&&t.config.series[e].type!==s?'<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name?t.config.series[e].name:"series-"+(e+1),": <strong>").concat(t.globals.series[e][i],"</strong>\n        </div>"):'<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type,'">')+"<div>".concat(a[0],': <span class="value">')+r+"</span></div>"+"<div>".concat(a[1],': <span class="value">')+o+"</span></div>"+(n?"<div>".concat(a[2],': <span class="value">')+n+"</span></div>":"")+"<div>".concat(a[3],': <span class="value">')+l+"</span></div>"+"<div>".concat(a[4],': <span class="value">')+h+"</span></div></div>"}}]),t}(),N=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"init",value:function(t){var e=t.responsiveOverride,a=this.opts,s=new L,r=new D(a);this.chartType=a.chart.type,"histogram"===this.chartType&&(a.chart.type="bar",a=x.extend({plotOptions:{bar:{columnWidth:"99.99%"}}},a)),a=this.extendYAxis(a),a=this.extendAnnotations(a);var o=s.init(),n={};if(a&&"object"===i(a)){var l={};l=-1!==["line","area","bar","candlestick","boxPlot","rangeBar","histogram","bubble","scatter","heatmap","treemap","pie","polarArea","donut","radar","radialBar"].indexOf(a.chart.type)?r[a.chart.type]():r.line(),a.chart.brush&&a.chart.brush.enabled&&(l=r.brush(l)),a.chart.stacked&&"100%"===a.chart.stackType&&(a=r.stacked100(a)),this.checkForDarkTheme(window.Apex),this.checkForDarkTheme(a),a.xaxis=a.xaxis||window.Apex.xaxis||{},e||(a.xaxis.convertedCatToNumeric=!1),((a=this.checkForCatToNumericXAxis(this.chartType,l,a)).chart.sparkline&&a.chart.sparkline.enabled||window.Apex.chart&&window.Apex.chart.sparkline&&window.Apex.chart.sparkline.enabled)&&(l=r.sparkline(l)),n=x.extend(o,l)}var h=x.extend(n,window.Apex);return o=x.extend(h,a),o=this.handleUserInputErrors(o)}},{key:"checkForCatToNumericXAxis",value:function(t,e,i){var a=new D(i),s=("bar"===t||"boxPlot"===t)&&i.plotOptions&&i.plotOptions.bar&&i.plotOptions.bar.horizontal,r="pie"===t||"polarArea"===t||"donut"===t||"radar"===t||"radialBar"===t||"heatmap"===t,o="datetime"!==i.xaxis.type&&"numeric"!==i.xaxis.type,n=i.xaxis.tickPlacement?i.xaxis.tickPlacement:e.xaxis&&e.xaxis.tickPlacement;return s||r||!o||"between"===n||(i=a.convertCatToNumeric(i)),i}},{key:"extendYAxis",value:function(t,e){var i=new L;(void 0===t.yaxis||!t.yaxis||Array.isArray(t.yaxis)&&0===t.yaxis.length)&&(t.yaxis={}),t.yaxis.constructor!==Array&&window.Apex.yaxis&&window.Apex.yaxis.constructor!==Array&&(t.yaxis=x.extend(t.yaxis,window.Apex.yaxis)),t.yaxis.constructor!==Array?t.yaxis=[x.extend(i.yAxis,t.yaxis)]:t.yaxis=x.extendArray(t.yaxis,i.yAxis);var a=!1;t.yaxis.forEach((function(t){t.logarithmic&&(a=!0)}));var s=t.series;return e&&!s&&(s=e.config.series),a&&s.length!==t.yaxis.length&&s.length&&(t.yaxis=s.map((function(e,a){if(e.name||(s[a].name="series-".concat(a+1)),t.yaxis[a])return t.yaxis[a].seriesName=s[a].name,t.yaxis[a];var r=x.extend(i.yAxis,t.yaxis[0]);return r.show=!1,r}))),a&&s.length>1&&s.length!==t.yaxis.length&&console.warn("A multi-series logarithmic chart should have equal number of series and y-axes. Please make sure to equalize both."),t}},{key:"extendAnnotations",value:function(t){return void 0===t.annotations&&(t.annotations={},t.annotations.yaxis=[],t.annotations.xaxis=[],t.annotations.points=[]),t=this.extendYAxisAnnotations(t),t=this.extendXAxisAnnotations(t),t=this.extendPointAnnotations(t)}},{key:"extendYAxisAnnotations",value:function(t){var e=new L;return t.annotations.yaxis=x.extendArray(void 0!==t.annotations.yaxis?t.annotations.yaxis:[],e.yAxisAnnotation),t}},{key:"extendXAxisAnnotations",value:function(t){var e=new L;return t.annotations.xaxis=x.extendArray(void 0!==t.annotations.xaxis?t.annotations.xaxis:[],e.xAxisAnnotation),t}},{key:"extendPointAnnotations",value:function(t){var e=new L;return t.annotations.points=x.extendArray(void 0!==t.annotations.points?t.annotations.points:[],e.pointAnnotation),t}},{key:"checkForDarkTheme",value:function(t){t.theme&&"dark"===t.theme.mode&&(t.tooltip||(t.tooltip={}),"light"!==t.tooltip.theme&&(t.tooltip.theme="dark"),t.chart.foreColor||(t.chart.foreColor="#f6f7f8"),t.chart.background||(t.chart.background="#424242"),t.theme.palette||(t.theme.palette="palette4"))}},{key:"handleUserInputErrors",value:function(t){var e=t;if(e.tooltip.shared&&e.tooltip.intersect)throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");if("bar"===e.chart.type&&e.plotOptions.bar.horizontal){if(e.yaxis.length>1)throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");e.yaxis[0].reversed&&(e.yaxis[0].opposite=!0),e.xaxis.tooltip.enabled=!1,e.yaxis[0].tooltip.enabled=!1,e.chart.zoom.enabled=!1}return"bar"!==e.chart.type&&"rangeBar"!==e.chart.type||e.tooltip.shared&&"barWidth"===e.xaxis.crosshairs.width&&e.series.length>1&&(e.xaxis.crosshairs.width="tickWidth"),"candlestick"!==e.chart.type&&"boxPlot"!==e.chart.type||e.yaxis[0].reversed&&(console.warn("Reversed y-axis in ".concat(e.chart.type," chart is not supported.")),e.yaxis[0].reversed=!1),e}}]),t}(),O=function(){function t(){a(this,t)}return r(t,[{key:"initGlobalVars",value:function(t){t.series=[],t.seriesCandleO=[],t.seriesCandleH=[],t.seriesCandleM=[],t.seriesCandleL=[],t.seriesCandleC=[],t.seriesRangeStart=[],t.seriesRangeEnd=[],t.seriesRangeBar=[],t.seriesPercent=[],t.seriesGoals=[],t.seriesX=[],t.seriesZ=[],t.seriesNames=[],t.seriesTotals=[],t.seriesLog=[],t.seriesColors=[],t.stackedSeriesTotals=[],t.seriesXvalues=[],t.seriesYvalues=[],t.labels=[],t.hasGroups=!1,t.groups=[],t.categoryLabels=[],t.timescaleLabels=[],t.noLabelsProvided=!1,t.resizeTimer=null,t.selectionResizeTimer=null,t.delayedElements=[],t.pointsArray=[],t.dataLabelsRects=[],t.isXNumeric=!1,t.xaxisLabelsCount=0,t.skipLastTimelinelabel=!1,t.skipFirstTimelinelabel=!1,t.isDataXYZ=!1,t.isMultiLineX=!1,t.isMultipleYAxis=!1,t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE,t.minYArr=[],t.maxYArr=[],t.maxX=-Number.MAX_VALUE,t.minX=Number.MAX_VALUE,t.initialMaxX=-Number.MAX_VALUE,t.initialMinX=Number.MAX_VALUE,t.maxDate=0,t.minDate=Number.MAX_VALUE,t.minZ=Number.MAX_VALUE,t.maxZ=-Number.MAX_VALUE,t.minXDiff=Number.MAX_VALUE,t.yAxisScale=[],t.xAxisScale=null,t.xAxisTicksPositions=[],t.yLabelsCoords=[],t.yTitleCoords=[],t.barPadForNumericAxis=0,t.padHorizontal=0,t.xRange=0,t.yRange=[],t.zRange=0,t.dataPoints=0,t.xTickAmount=0}},{key:"globalVars",value:function(t){return{chartID:null,cuid:null,events:{beforeMount:[],mounted:[],updated:[],clicked:[],selection:[],dataPointSelection:[],zoomed:[],scrolled:[]},colors:[],clientX:null,clientY:null,fill:{colors:[]},stroke:{colors:[]},dataLabels:{style:{colors:[]}},radarPolygons:{fill:{colors:[]}},markers:{colors:[],size:t.markers.size,largestSize:0},animationEnded:!1,isTouchDevice:"ontouchstart"in window||navigator.msMaxTouchPoints,isDirty:!1,isExecCalled:!1,initialConfig:null,initialSeries:[],lastXAxis:[],lastYAxis:[],columnSeries:null,labels:[],timescaleLabels:[],noLabelsProvided:!1,allSeriesCollapsed:!1,collapsedSeries:[],collapsedSeriesIndices:[],ancillaryCollapsedSeries:[],ancillaryCollapsedSeriesIndices:[],risingSeries:[],dataFormatXNumeric:!1,capturedSeriesIndex:-1,capturedDataPointIndex:-1,selectedDataPoints:[],goldenPadding:35,invalidLogScale:!1,ignoreYAxisIndexes:[],yAxisSameScaleIndices:[],maxValsInArrayIndex:0,radialSize:0,selection:void 0,zoomEnabled:"zoom"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.zoom&&t.chart.zoom.enabled,panEnabled:"pan"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.pan,selectionEnabled:"selection"===t.chart.toolbar.autoSelected&&t.chart.toolbar.tools.selection,yaxis:null,mousedown:!1,lastClientPosition:{},visibleXRange:void 0,yValueDecimal:0,total:0,SVGNS:"http://www.w3.org/2000/svg",svgWidth:0,svgHeight:0,noData:!1,locale:{},dom:{},memory:{methodsToExec:[]},shouldAnimate:!0,skipLastTimelinelabel:!1,skipFirstTimelinelabel:!1,delayedElements:[],axisCharts:!0,isDataXYZ:!1,resized:!1,resizeTimer:null,comboCharts:!1,dataChanged:!1,previousPaths:[],allSeriesHasEqualX:!0,pointsArray:[],dataLabelsRects:[],lastDrawnDataLabelsIndexes:[],hasNullValues:!1,easing:null,zoomed:!1,gridWidth:0,gridHeight:0,rotateXLabels:!1,defaultLabels:!1,xLabelFormatter:void 0,yLabelFormatters:[],xaxisTooltipFormatter:void 0,ttKeyFormatter:void 0,ttVal:void 0,ttZFormatter:void 0,LINE_HEIGHT_RATIO:1.618,xAxisLabelsHeight:0,xAxisGroupLabelsHeight:0,xAxisLabelsWidth:0,yAxisLabelsWidth:0,scaleX:1,scaleY:1,translateX:0,translateY:0,translateYAxisX:[],yAxisWidths:[],translateXAxisY:0,translateXAxisX:0,tooltip:null}}},{key:"init",value:function(t){var e=this.globalVars(t);return this.initGlobalVars(e),e.initialConfig=x.extend({},t),e.initialSeries=x.clone(t.series),e.lastXAxis=x.clone(e.initialConfig.xaxis),e.lastYAxis=x.clone(e.initialConfig.yaxis),e}}]),t}(),W=function(){function t(e){a(this,t),this.opts=e}return r(t,[{key:"init",value:function(){var t=new N(this.opts).init({responsiveOverride:!1});return{config:t,globals:(new O).init(t)}}}]),t}(),B=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.twoDSeries=[],this.threeDSeries=[],this.twoDSeriesX=[],this.seriesGoals=[],this.coreUtils=new y(this.ctx)}return r(t,[{key:"isMultiFormat",value:function(){return this.isFormatXY()||this.isFormat2DArray()}},{key:"isFormatXY",value:function(){var t=this.w.config.series.slice(),e=new E(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&null!==t[this.activeSeriesIndex].data[0]&&void 0!==t[this.activeSeriesIndex].data[0].x&&null!==t[this.activeSeriesIndex].data[0])return!0}},{key:"isFormat2DArray",value:function(){var t=this.w.config.series.slice(),e=new E(this.ctx);if(this.activeSeriesIndex=e.getActiveConfigSeriesIndex(),void 0!==t[this.activeSeriesIndex].data&&t[this.activeSeriesIndex].data.length>0&&void 0!==t[this.activeSeriesIndex].data[0]&&null!==t[this.activeSeriesIndex].data[0]&&t[this.activeSeriesIndex].data[0].constructor===Array)return!0}},{key:"handleFormat2DArray",value:function(t,e){for(var i=this.w.config,a=this.w.globals,s="boxPlot"===i.chart.type||"boxPlot"===i.series[e].type,r=0;r<t[e].data.length;r++)if(void 0!==t[e].data[r][1]&&(Array.isArray(t[e].data[r][1])&&4===t[e].data[r][1].length&&!s?this.twoDSeries.push(x.parseNumber(t[e].data[r][1][3])):t[e].data[r].length>=5?this.twoDSeries.push(x.parseNumber(t[e].data[r][4])):this.twoDSeries.push(x.parseNumber(t[e].data[r][1])),a.dataFormatXNumeric=!0),"datetime"===i.xaxis.type){var o=new Date(t[e].data[r][0]);o=new Date(o).getTime(),this.twoDSeriesX.push(o)}else this.twoDSeriesX.push(t[e].data[r][0]);for(var n=0;n<t[e].data.length;n++)void 0!==t[e].data[n][2]&&(this.threeDSeries.push(t[e].data[n][2]),a.isDataXYZ=!0)}},{key:"handleFormatXY",value:function(t,e){var i=this.w.config,a=this.w.globals,s=new R(this.ctx),r=e;a.collapsedSeriesIndices.indexOf(e)>-1&&(r=this.activeSeriesIndex);for(var o=0;o<t[e].data.length;o++)void 0!==t[e].data[o].y&&(Array.isArray(t[e].data[o].y)?this.twoDSeries.push(x.parseNumber(t[e].data[o].y[t[e].data[o].y.length-1])):this.twoDSeries.push(x.parseNumber(t[e].data[o].y))),void 0!==t[e].data[o].goals&&Array.isArray(t[e].data[o].goals)?(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(t[e].data[o].goals)):(void 0===this.seriesGoals[e]&&(this.seriesGoals[e]=[]),this.seriesGoals[e].push(null));for(var n=0;n<t[r].data.length;n++){var l="string"==typeof t[r].data[n].x,h=Array.isArray(t[r].data[n].x),c=!h&&!!s.isValidDate(t[r].data[n].x.toString());if(l||c)if(l||i.xaxis.convertedCatToNumeric){var d=a.isBarHorizontal&&a.isRangeData;"datetime"!==i.xaxis.type||d?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x)):this.twoDSeriesX.push(s.parseDate(t[r].data[n].x))}else"datetime"===i.xaxis.type?this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())):(a.dataFormatXNumeric=!0,a.isXNumeric=!0,this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));else h?(this.fallbackToCategory=!0,this.twoDSeriesX.push(t[r].data[n].x)):(a.isXNumeric=!0,a.dataFormatXNumeric=!0,this.twoDSeriesX.push(t[r].data[n].x))}if(t[e].data[0]&&void 0!==t[e].data[0].z){for(var g=0;g<t[e].data.length;g++)this.threeDSeries.push(t[e].data[g].z);a.isDataXYZ=!0}}},{key:"handleRangeData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleRangeDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleRangeDataFormat("xy",t,e)),i.seriesRangeStart.push(a.start),i.seriesRangeEnd.push(a.end),i.seriesRangeBar.push(a.rangeUniques),i.seriesRangeBar.forEach((function(t,e){t&&t.forEach((function(t,e){t.y.forEach((function(e,i){for(var a=0;a<t.y.length;a++)if(i!==a){var s=e.y1,r=e.y2,o=t.y[a].y1;s<=t.y[a].y2&&o<=r&&(t.overlaps.indexOf(e.rangeName)<0&&t.overlaps.push(e.rangeName),t.overlaps.indexOf(t.y[a].rangeName)<0&&t.overlaps.push(t.y[a].rangeName))}}))}))})),a}},{key:"handleCandleStickBoxData",value:function(t,e){var i=this.w.globals,a={};return this.isFormat2DArray()?a=this.handleCandleStickBoxDataFormat("array",t,e):this.isFormatXY()&&(a=this.handleCandleStickBoxDataFormat("xy",t,e)),i.seriesCandleO[e]=a.o,i.seriesCandleH[e]=a.h,i.seriesCandleM[e]=a.m,i.seriesCandleL[e]=a.l,i.seriesCandleC[e]=a.c,a}},{key:"handleRangeDataFormat",value:function(t,e,i){var a=[],s=[],r=e[i].data.filter((function(t,e,i){return e===i.findIndex((function(e){return e.x===t.x}))})).map((function(t,e){return{x:t.x,overlaps:[],y:[]}})),o="Please provide [Start, End] values in valid format. Read more https://apexcharts.com/docs/series/#rangecharts",n=new E(this.ctx).getActiveConfigSeriesIndex();if("array"===t){if(2!==e[n].data[0][1].length)throw new Error(o);for(var l=0;l<e[i].data.length;l++)a.push(e[i].data[l][1][0]),s.push(e[i].data[l][1][1])}else if("xy"===t){if(2!==e[n].data[0].y.length)throw new Error(o);for(var h=function(t){var o=x.randomId(),n=e[i].data[t].x,l={y1:e[i].data[t].y[0],y2:e[i].data[t].y[1],rangeName:o};e[i].data[t].rangeName=o;var h=r.findIndex((function(t){return t.x===n}));r[h].y.push(l),a.push(l.y1),s.push(l.y2)},c=0;c<e[i].data.length;c++)h(c)}return{start:a,end:s,rangeUniques:r}}},{key:"handleCandleStickBoxDataFormat",value:function(t,e,i){var a=this.w,s="boxPlot"===a.config.chart.type||"boxPlot"===a.config.series[i].type,r=[],o=[],n=[],l=[],h=[];if("array"===t)if(s&&6===e[i].data[0].length||!s&&5===e[i].data[0].length)for(var c=0;c<e[i].data.length;c++)r.push(e[i].data[c][1]),o.push(e[i].data[c][2]),s?(n.push(e[i].data[c][3]),l.push(e[i].data[c][4]),h.push(e[i].data[c][5])):(l.push(e[i].data[c][3]),h.push(e[i].data[c][4]));else for(var d=0;d<e[i].data.length;d++)Array.isArray(e[i].data[d][1])&&(r.push(e[i].data[d][1][0]),o.push(e[i].data[d][1][1]),s?(n.push(e[i].data[d][1][2]),l.push(e[i].data[d][1][3]),h.push(e[i].data[d][1][4])):(l.push(e[i].data[d][1][2]),h.push(e[i].data[d][1][3])));else if("xy"===t)for(var g=0;g<e[i].data.length;g++)Array.isArray(e[i].data[g].y)&&(r.push(e[i].data[g].y[0]),o.push(e[i].data[g].y[1]),s?(n.push(e[i].data[g].y[2]),l.push(e[i].data[g].y[3]),h.push(e[i].data[g].y[4])):(l.push(e[i].data[g].y[2]),h.push(e[i].data[g].y[3])));return{o:r,h:o,m:n,l:l,c:h}}},{key:"parseDataAxisCharts",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:this.ctx,a=this.w.config,s=this.w.globals,r=new R(i),o=a.labels.length>0?a.labels.slice():a.xaxis.categories.slice();s.isRangeBar="rangeBar"===a.chart.type&&s.isBarHorizontal,s.hasGroups="category"===a.xaxis.type&&a.xaxis.group.groups.length>0,s.hasGroups&&(s.groups=a.xaxis.group.groups);for(var n=function(){for(var t=0;t<o.length;t++)if("string"==typeof o[t]){if(!r.isValidDate(o[t]))throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");e.twoDSeriesX.push(r.parseDate(o[t]))}else e.twoDSeriesX.push(o[t])},l=0;l<t.length;l++){if(this.twoDSeries=[],this.twoDSeriesX=[],this.threeDSeries=[],void 0===t[l].data)return void console.error("It is a possibility that you may have not included 'data' property in series.");if("rangeBar"!==a.chart.type&&"rangeArea"!==a.chart.type&&"rangeBar"!==t[l].type&&"rangeArea"!==t[l].type||(s.isRangeData=!0,this.handleRangeData(t,l)),this.isMultiFormat())this.isFormat2DArray()?this.handleFormat2DArray(t,l):this.isFormatXY()&&this.handleFormatXY(t,l),"candlestick"!==a.chart.type&&"candlestick"!==t[l].type&&"boxPlot"!==a.chart.type&&"boxPlot"!==t[l].type||this.handleCandleStickBoxData(t,l),s.series.push(this.twoDSeries),s.labels.push(this.twoDSeriesX),s.seriesX.push(this.twoDSeriesX),s.seriesGoals=this.seriesGoals,l!==this.activeSeriesIndex||this.fallbackToCategory||(s.isXNumeric=!0);else{"datetime"===a.xaxis.type?(s.isXNumeric=!0,n(),s.seriesX.push(this.twoDSeriesX)):"numeric"===a.xaxis.type&&(s.isXNumeric=!0,o.length>0&&(this.twoDSeriesX=o,s.seriesX.push(this.twoDSeriesX))),s.labels.push(this.twoDSeriesX);var h=t[l].data.map((function(t){return x.parseNumber(t)}));s.series.push(h)}s.seriesZ.push(this.threeDSeries),void 0!==t[l].name?s.seriesNames.push(t[l].name):s.seriesNames.push("series-"+parseInt(l+1,10)),void 0!==t[l].color?s.seriesColors.push(t[l].color):s.seriesColors.push(void 0)}return this.w}},{key:"parseDataNonAxisCharts",value:function(t){var e=this.w.globals,i=this.w.config;e.series=t.slice(),e.seriesNames=i.labels.slice();for(var a=0;a<e.series.length;a++)void 0===e.seriesNames[a]&&e.seriesNames.push("series-"+(a+1));return this.w}},{key:"handleExternalLabelsData",value:function(t){var e=this.w.config,i=this.w.globals;if(e.xaxis.categories.length>0)i.labels=e.xaxis.categories;else if(e.labels.length>0)i.labels=e.labels.slice();else if(this.fallbackToCategory){if(i.labels=i.labels[0],i.seriesRangeBar.length&&(i.seriesRangeBar.map((function(t){t.forEach((function(t){i.labels.indexOf(t.x)<0&&t.x&&i.labels.push(t.x)}))})),i.labels=i.labels.filter((function(t,e,i){return i.indexOf(t)===e}))),e.xaxis.convertedCatToNumeric)new D(e).convertCatToNumericXaxis(e,this.ctx,i.seriesX[0]),this._generateExternalLabels(t)}else this._generateExternalLabels(t)}},{key:"_generateExternalLabels",value:function(t){var e=this.w.globals,i=this.w.config,a=[];if(e.axisCharts){if(e.series.length>0)if(this.isFormatXY())for(var s=i.series.map((function(t,e){return t.data.filter((function(t,e,i){return i.findIndex((function(e){return e.x===t.x}))===e}))})),r=s.reduce((function(t,e,i,a){return a[t].length>e.length?t:i}),0),o=0;o<s[r].length;o++)a.push(o+1);else for(var n=0;n<e.series[e.maxValsInArrayIndex].length;n++)a.push(n+1);e.seriesX=[];for(var l=0;l<t.length;l++)e.seriesX.push(a);e.isXNumeric=!0}if(0===a.length){a=e.axisCharts?[]:e.series.map((function(t,e){return e+1}));for(var h=0;h<t.length;h++)e.seriesX.push(a)}e.labels=a,i.xaxis.convertedCatToNumeric&&(e.categoryLabels=a.map((function(t){return i.xaxis.labels.formatter(t)}))),e.noLabelsProvided=!0}},{key:"parseData",value:function(t){var e=this.w,i=e.config,a=e.globals;if(this.excludeCollapsedSeriesInYAxis(),this.fallbackToCategory=!1,this.ctx.core.resetGlobals(),this.ctx.core.isMultipleY(),a.axisCharts?this.parseDataAxisCharts(t):this.parseDataNonAxisCharts(t),this.coreUtils.getLargestSeries(),"bar"===i.chart.type&&i.chart.stacked){var s=new E(this.ctx);a.series=s.setNullSeriesToZeroValues(a.series)}this.coreUtils.getSeriesTotals(),a.axisCharts&&this.coreUtils.getStackedSeriesTotals(),this.coreUtils.getPercentSeries(),a.dataFormatXNumeric||a.isXNumeric&&("numeric"!==i.xaxis.type||0!==i.labels.length||0!==i.xaxis.categories.length)||this.handleExternalLabelsData(t);for(var r=this.coreUtils.getCategoryLabels(a.labels),o=0;o<r.length;o++)if(Array.isArray(r[o])){a.isMultiLineX=!0;break}}},{key:"excludeCollapsedSeriesInYAxis",value:function(){var t=this,e=this.w;e.globals.ignoreYAxisIndexes=e.globals.collapsedSeries.map((function(i,a){if(t.w.globals.isMultipleYAxis&&!e.config.chart.stacked)return i.index}))}}]),t}(),V=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.tooltipKeyFormat="dd MMM"}return r(t,[{key:"xLabelFormat",value:function(t,e,i,a){var s=this.w;if("datetime"===s.config.xaxis.type&&void 0===s.config.xaxis.labels.formatter&&void 0===s.config.tooltip.x.formatter){var r=new R(this.ctx);return r.formatDate(r.getDate(e),s.config.tooltip.x.format)}return t(e,i,a)}},{key:"defaultGeneralFormatter",value:function(t){return Array.isArray(t)?t.map((function(t){return t})):t}},{key:"defaultYFormatter",value:function(t,e,i){var a=this.w;return x.isNumber(t)&&(t=0!==a.globals.yValueDecimal?t.toFixed(void 0!==e.decimalsInFloat?e.decimalsInFloat:a.globals.yValueDecimal):a.globals.maxYArr[i]-a.globals.minYArr[i]<5?t.toFixed(1):t.toFixed(0)),t}},{key:"setLabelFormatters",value:function(){var t=this,e=this.w;return e.globals.xaxisTooltipFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttKeyFormatter=function(e){return t.defaultGeneralFormatter(e)},e.globals.ttZFormatter=function(t){return t},e.globals.legendFormatter=function(e){return t.defaultGeneralFormatter(e)},void 0!==e.config.xaxis.labels.formatter?e.globals.xLabelFormatter=e.config.xaxis.labels.formatter:e.globals.xLabelFormatter=function(t){if(x.isNumber(t)){if(!e.config.xaxis.convertedCatToNumeric&&"numeric"===e.config.xaxis.type){if(x.isNumber(e.config.xaxis.decimalsInFloat))return t.toFixed(e.config.xaxis.decimalsInFloat);var i=e.globals.maxX-e.globals.minX;return i>0&&i<100?t.toFixed(1):t.toFixed(0)}if(e.globals.isBarHorizontal)if(e.globals.maxY-e.globals.minYArr<4)return t.toFixed(1);return t.toFixed(0)}return t},"function"==typeof e.config.tooltip.x.formatter?e.globals.ttKeyFormatter=e.config.tooltip.x.formatter:e.globals.ttKeyFormatter=e.globals.xLabelFormatter,"function"==typeof e.config.xaxis.tooltip.formatter&&(e.globals.xaxisTooltipFormatter=e.config.xaxis.tooltip.formatter),(Array.isArray(e.config.tooltip.y)||void 0!==e.config.tooltip.y.formatter)&&(e.globals.ttVal=e.config.tooltip.y),void 0!==e.config.tooltip.z.formatter&&(e.globals.ttZFormatter=e.config.tooltip.z.formatter),void 0!==e.config.legend.formatter&&(e.globals.legendFormatter=e.config.legend.formatter),e.config.yaxis.forEach((function(i,a){void 0!==i.labels.formatter?e.globals.yLabelFormatters[a]=i.labels.formatter:e.globals.yLabelFormatters[a]=function(s){return e.globals.xyCharts?Array.isArray(s)?s.map((function(e){return t.defaultYFormatter(e,i,a)})):t.defaultYFormatter(s,i,a):s}})),e.globals}},{key:"heatmapLabelFormatters",value:function(){var t=this.w;if("heatmap"===t.config.chart.type){t.globals.yAxisScale[0].result=t.globals.seriesNames.slice();var e=t.globals.seriesNames.reduce((function(t,e){return t.length>e.length?t:e}),0);t.globals.yAxisScale[0].niceMax=e,t.globals.yAxisScale[0].niceMin=e}}}]),t}(),G=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"getLabel",value:function(t,e,i,a){var s=arguments.length>4&&void 0!==arguments[4]?arguments[4]:[],r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"12px",o=!(arguments.length>6&&void 0!==arguments[6])||arguments[6],n=this.w,l=void 0===t[a]?"":t[a],h=l,c=n.globals.xLabelFormatter,d=n.config.xaxis.labels.formatter,g=!1,u=new V(this.ctx),p=l;o&&(h=u.xLabelFormat(c,l,p,{i:a,dateFormatter:new R(this.ctx).formatDate,w:n}),void 0!==d&&(h=d(l,t[a],{i:a,dateFormatter:new R(this.ctx).formatDate,w:n})));var f=function(t){var i=null;return e.forEach((function(t){"month"===t.unit?i="year":"day"===t.unit?i="month":"hour"===t.unit?i="day":"minute"===t.unit&&(i="hour")})),i===t};e.length>0?(g=f(e[a].unit),i=e[a].position,h=e[a].value):"datetime"===n.config.xaxis.type&&void 0===d&&(h=""),void 0===h&&(h=""),h=Array.isArray(h)?h:h.toString();var x=new m(this.ctx),b={};b=n.globals.rotateXLabels&&o?x.getTextRects(h,parseInt(r,10),null,"rotate(".concat(n.config.xaxis.labels.rotate," 0 0)"),!1):x.getTextRects(h,parseInt(r,10));var v=!n.config.xaxis.labels.showDuplicates&&this.ctx.timeScale;return!Array.isArray(h)&&(0===h.indexOf("NaN")||0===h.toLowerCase().indexOf("invalid")||h.toLowerCase().indexOf("infinity")>=0||s.indexOf(h)>=0&&v)&&(h=""),{x:i,text:h,textRect:b,isBold:g}}},{key:"checkLabelBasedOnTickamount",value:function(t,e,i){var a=this.w,s=a.config.xaxis.tickAmount;return"dataPoints"===s&&(s=Math.round(a.globals.gridWidth/120)),s>i||t%Math.round(i/(s+1))==0||(e.text=""),e}},{key:"checkForOverflowingLabels",value:function(t,e,i,a,s){var r=this.w;if(0===t&&r.globals.skipFirstTimelinelabel&&(e.text=""),t===i-1&&r.globals.skipLastTimelinelabel&&(e.text=""),r.config.xaxis.labels.hideOverlappingLabels&&a.length>0){var o=s[s.length-1];e.x<o.textRect.width/(r.globals.rotateXLabels?Math.abs(r.config.xaxis.labels.rotate)/12:1.01)+o.x&&(e.text="")}return e}},{key:"checkForReversedLabels",value:function(t,e){var i=this.w;return i.config.yaxis[t]&&i.config.yaxis[t].reversed&&e.reverse(),e}},{key:"isYAxisHidden",value:function(t){var e=this.w,i=new y(this.ctx);return!e.config.yaxis[t].show||!e.config.yaxis[t].showForNullSeries&&i.isSeriesNull(t)&&-1===e.globals.collapsedSeriesIndices.indexOf(t)}},{key:"getYAxisForeColor",value:function(t,e){var i=this.w;return Array.isArray(t)&&i.globals.yAxisScale[e]&&this.ctx.theme.pushExtraColors(t,i.globals.yAxisScale[e].result.length,!1),t}},{key:"drawYAxisTicks",value:function(t,e,i,a,s,r,o){var n=this.w,l=new m(this.ctx),h=n.globals.translateY;if(a.show&&e>0){!0===n.config.yaxis[s].opposite&&(t+=a.width);for(var c=e;c>=0;c--){var d=h+e/10+n.config.yaxis[s].labels.offsetY-1;n.globals.isBarHorizontal&&(d=r*c),"heatmap"===n.config.chart.type&&(d+=r/2);var g=l.drawLine(t+i.offsetX-a.width+a.offsetX,d+a.offsetY,t+i.offsetX+a.offsetX,d+a.offsetY,a.color);o.add(g),h+=r}}}}]),t}(),j=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"scaleSvgNode",value:function(t,e){var i=parseFloat(t.getAttributeNS(null,"width")),a=parseFloat(t.getAttributeNS(null,"height"));t.setAttributeNS(null,"width",i*e),t.setAttributeNS(null,"height",a*e),t.setAttributeNS(null,"viewBox","0 0 "+i+" "+a)}},{key:"fixSvgStringForIe11",value:function(t){if(!x.isIE11())return t.replace(/&nbsp;/g,"&#160;");var e=0,i=t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g,(function(t){return 2===++e?'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"':t}));return i=(i=i.replace(/xmlns:NS\d+=""/g,"")).replace(/NS\d+:(\w+:\w+=")/g,"$1")}},{key:"getSvgString",value:function(t){null==t&&(t=1);var e=this.w.globals.dom.Paper.svg();if(1!==t){var i=this.w.globals.dom.Paper.node.cloneNode(!0);this.scaleSvgNode(i,t),e=(new XMLSerializer).serializeToString(i)}return this.fixSvgStringForIe11(e)}},{key:"cleanup",value:function(){var t=this.w,e=t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"),i=t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");Array.prototype.forEach.call(a,(function(t){t.setAttribute("width",0)})),e&&e[0]&&(e[0].setAttribute("x",-500),e[0].setAttribute("x1",-500),e[0].setAttribute("x2",-500)),i&&i[0]&&(i[0].setAttribute("y",-100),i[0].setAttribute("y1",-100),i[0].setAttribute("y2",-100))}},{key:"svgUrl",value:function(){this.cleanup();var t=this.getSvgString(),e=new Blob([t],{type:"image/svg+xml;charset=utf-8"});return URL.createObjectURL(e)}},{key:"dataURI",value:function(t){var e=this;return new Promise((function(i){var a=e.w,s=t?t.scale||t.width/a.globals.svgWidth:1;e.cleanup();var r=document.createElement("canvas");r.width=a.globals.svgWidth*s,r.height=parseInt(a.globals.dom.elWrap.style.height,10)*s;var o="transparent"===a.config.chart.background?"#fff":a.config.chart.background,n=r.getContext("2d");n.fillStyle=o,n.fillRect(0,0,r.width*s,r.height*s);var l=e.getSvgString(s);if(window.canvg&&x.isIE11()){var h=window.canvg.Canvg.fromString(n,l,{ignoreClear:!0,ignoreDimensions:!0});h.start();var c=r.msToBlob();h.stop(),i({blob:c})}else{var d="data:image/svg+xml,"+encodeURIComponent(l),g=new Image;g.crossOrigin="anonymous",g.onload=function(){if(n.drawImage(g,0,0),r.msToBlob){var t=r.msToBlob();i({blob:t})}else{var e=r.toDataURL("image/png");i({imgURI:e})}},g.src=d}}))}},{key:"exportToSVG",value:function(){this.triggerDownload(this.svgUrl(),this.w.config.chart.toolbar.export.svg.filename,".svg")}},{key:"exportToPng",value:function(){var t=this;this.dataURI().then((function(e){var i=e.imgURI,a=e.blob;a?navigator.msSaveOrOpenBlob(a,t.w.globals.chartID+".png"):t.triggerDownload(i,t.w.config.chart.toolbar.export.png.filename,".png")}))}},{key:"exportToCSV",value:function(t){var e=this,i=t.series,a=t.fileName,s=t.columnDelimiter,r=void 0===s?",":s,o=t.lineDelimiter,n=void 0===o?"\n":o,l=this.w;i||(i=l.config.series);var h=[],c=[],d="",g=new B(this.ctx),u=new G(this.ctx),p=function(t){var i="";if(l.globals.axisCharts){if("category"===l.config.xaxis.type||l.config.xaxis.convertedCatToNumeric)if(l.globals.isBarHorizontal){var a=l.globals.yLabelFormatters[0],s=new E(e.ctx).getActiveConfigSeriesIndex();i=a(l.globals.labels[t],{seriesIndex:s,dataPointIndex:t,w:l})}else i=u.getLabel(l.globals.labels,l.globals.timescaleLabels,0,t).text;"datetime"===l.config.xaxis.type&&(l.config.xaxis.categories.length?i=l.config.xaxis.categories[t]:l.config.labels.length&&(i=l.config.labels[t]))}else i=l.config.labels[t];return Array.isArray(i)&&(i=i.join(" ")),x.isNumber(i)?i:i.split(r).join("")};h.push(l.config.chart.toolbar.export.csv.headerCategory),"boxPlot"===l.config.chart.type?(h.push("minimum"),h.push("q1"),h.push("median"),h.push("q3"),h.push("maximum")):"candlestick"===l.config.chart.type?(h.push("open"),h.push("high"),h.push("low"),h.push("close")):"rangeBar"===l.config.chart.type?(h.push("minimum"),h.push("maximum")):i.map((function(t,e){var i=t.name?t.name:"series-".concat(e);l.globals.axisCharts&&h.push(i.split(r).join("")?i.split(r).join(""):"series-".concat(e))})),l.globals.axisCharts||(h.push(l.config.chart.toolbar.export.csv.headerValue),c.push(h.join(r))),i.map((function(t,e){l.globals.axisCharts?function(t,e){if(h.length&&0===e&&c.push(h.join(r)),t.data&&t.data.length)for(var a=0;a<t.data.length;a++){h=[];var s=p(a);if(s||(g.isFormatXY()?s=i[e].data[a].x:g.isFormat2DArray()&&(s=i[e].data[a]?i[e].data[a][0]:"")),0===e){h.push((n=s,"datetime"===l.config.xaxis.type&&String(n).length>=10?l.config.chart.toolbar.export.csv.dateFormatter(s):x.isNumber(s)?s:s.split(r).join("")));for(var o=0;o<l.globals.series.length;o++)g.isFormatXY()?h.push(i[o].data[a].y):h.push(l.globals.series[o][a])}("candlestick"===l.config.chart.type||t.type&&"candlestick"===t.type)&&(h.pop(),h.push(l.globals.seriesCandleO[e][a]),h.push(l.globals.seriesCandleH[e][a]),h.push(l.globals.seriesCandleL[e][a]),h.push(l.globals.seriesCandleC[e][a])),("boxPlot"===l.config.chart.type||t.type&&"boxPlot"===t.type)&&(h.pop(),h.push(l.globals.seriesCandleO[e][a]),h.push(l.globals.seriesCandleH[e][a]),h.push(l.globals.seriesCandleM[e][a]),h.push(l.globals.seriesCandleL[e][a]),h.push(l.globals.seriesCandleC[e][a])),"rangeBar"===l.config.chart.type&&(h.pop(),h.push(l.globals.seriesRangeStart[e][a]),h.push(l.globals.seriesRangeEnd[e][a])),h.length&&c.push(h.join(r))}var n}(t,e):((h=[]).push(l.globals.labels[e].split(r).join("")),h.push(l.globals.series[e]),c.push(h.join(r)))})),d+=c.join(n),this.triggerDownload("data:text/csv; charset=utf-8,"+encodeURIComponent("\ufeff"+d),a||l.config.chart.toolbar.export.csv.filename,".csv")}},{key:"triggerDownload",value:function(t,e,i){var a=document.createElement("a");a.href=t,a.download=(e||this.w.globals.chartID)+i,document.body.appendChild(a),a.click(),document.body.removeChild(a)}}]),t}(),_=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.axesUtils=new G(e),this.xaxisLabels=i.globals.labels.slice(),i.globals.timescaleLabels.length>0&&!i.globals.isBarHorizontal&&(this.xaxisLabels=i.globals.timescaleLabels.slice()),i.config.xaxis.overwriteCategories&&(this.xaxisLabels=i.config.xaxis.overwriteCategories),this.drawnLabels=[],this.drawnLabelsRects=[],"top"===i.config.xaxis.position?this.offY=0:this.offY=i.globals.gridHeight+1,this.offY=this.offY+i.config.xaxis.axisBorder.offsetY,this.isCategoryBarHorizontal="bar"===i.config.chart.type&&i.config.plotOptions.bar.horizontal,this.xaxisFontSize=i.config.xaxis.labels.style.fontSize,this.xaxisFontFamily=i.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=i.config.xaxis.labels.style.colors,this.xaxisBorderWidth=i.config.xaxis.axisBorder.width,this.isCategoryBarHorizontal&&(this.xaxisBorderWidth=i.config.yaxis[0].axisBorder.width.toString()),this.xaxisBorderWidth.indexOf("%")>-1?this.xaxisBorderWidth=i.globals.gridWidth*parseInt(this.xaxisBorderWidth,10)/100:this.xaxisBorderWidth=parseInt(this.xaxisBorderWidth,10),this.xaxisBorderHeight=i.config.xaxis.axisBorder.height,this.yaxis=i.config.yaxis[0]}return r(t,[{key:"drawXaxis",value:function(){var t=this.w,e=new m(this.ctx),i=e.group({class:"apexcharts-xaxis",transform:"translate(".concat(t.config.xaxis.offsetX,", ").concat(t.config.xaxis.offsetY,")")}),a=e.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(t.globals.translateXAxisX,", ").concat(t.globals.translateXAxisY,")")});i.add(a);for(var s=[],r=0;r<this.xaxisLabels.length;r++)s.push(this.xaxisLabels[r]);if(this.drawXAxisLabelAndGroup(!0,e,a,s,t.globals.isXNumeric,(function(t,e){return e})),t.globals.hasGroups){var o=t.globals.groups;s=[];for(var n=0;n<o.length;n++)s.push(o[n].title);var l={};t.config.xaxis.group.style&&(l.xaxisFontSize=t.config.xaxis.group.style.fontSize,l.xaxisFontFamily=t.config.xaxis.group.style.fontFamily,l.xaxisForeColors=t.config.xaxis.group.style.colors,l.fontWeight=t.config.xaxis.group.style.fontWeight,l.cssClass=t.config.xaxis.group.style.cssClass),this.drawXAxisLabelAndGroup(!1,e,a,s,!1,(function(t,e){return o[t].cols*e}),l)}if(void 0!==t.config.xaxis.title.text){var h=e.group({class:"apexcharts-xaxis-title"}),c=e.drawText({x:t.globals.gridWidth/2+t.config.xaxis.title.offsetX,y:this.offY+parseFloat(this.xaxisFontSize)+t.globals.xAxisLabelsHeight+t.config.xaxis.title.offsetY,text:t.config.xaxis.title.text,textAnchor:"middle",fontSize:t.config.xaxis.title.style.fontSize,fontFamily:t.config.xaxis.title.style.fontFamily,fontWeight:t.config.xaxis.title.style.fontWeight,foreColor:t.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text "+t.config.xaxis.title.style.cssClass});h.add(c),i.add(h)}if(t.config.xaxis.axisBorder.show){var d=t.globals.barPadForNumericAxis,g=e.drawLine(t.globals.padHorizontal+t.config.xaxis.axisBorder.offsetX-d,this.offY,this.xaxisBorderWidth+d,this.offY,t.config.xaxis.axisBorder.color,0,this.xaxisBorderHeight);i.add(g)}return i}},{key:"drawXAxisLabelAndGroup",value:function(t,e,i,a,s,r){var o,n=this,l=arguments.length>6&&void 0!==arguments[6]?arguments[6]:{},h=[],c=[],d=this.w,g=l.xaxisFontSize||this.xaxisFontSize,u=l.xaxisFontFamily||this.xaxisFontFamily,p=l.xaxisForeColors||this.xaxisForeColors,f=l.fontWeight||d.config.xaxis.labels.style.fontWeight,x=l.cssClass||d.config.xaxis.labels.style.cssClass,b=d.globals.padHorizontal,v=a.length,m="category"===d.config.xaxis.type?d.globals.dataPoints:v;if(s){var y=m>1?m-1:m;o=d.globals.gridWidth/y,b=b+r(0,o)/2+d.config.xaxis.labels.offsetX}else o=d.globals.gridWidth/m,b=b+r(0,o)+d.config.xaxis.labels.offsetX;for(var w=function(s){var l=b-r(s,o)/2+d.config.xaxis.labels.offsetX;0===s&&1===v&&o/2===b&&1===m&&(l=d.globals.gridWidth/2);var y=n.axesUtils.getLabel(a,d.globals.timescaleLabels,l,s,h,g,t),w=28;d.globals.rotateXLabels&&t&&(w=22),t||(w=w+parseFloat(g)+(d.globals.xAxisLabelsHeight-d.globals.xAxisGroupLabelsHeight)+(d.globals.rotateXLabels?10:0)),y=void 0!==d.config.xaxis.tickAmount&&"dataPoints"!==d.config.xaxis.tickAmount&&"datetime"!==d.config.xaxis.type?n.axesUtils.checkLabelBasedOnTickamount(s,y,v):n.axesUtils.checkForOverflowingLabels(s,y,v,h,c);if(t&&y.text&&d.globals.xaxisLabelsCount++,d.config.xaxis.labels.show){var k=e.drawText({x:y.x,y:n.offY+d.config.xaxis.labels.offsetY+w-("top"===d.config.xaxis.position?d.globals.xAxisHeight+d.config.xaxis.axisTicks.height-2:0),text:y.text,textAnchor:"middle",fontWeight:y.isBold?600:f,fontSize:g,fontFamily:u,foreColor:Array.isArray(p)?t&&d.config.xaxis.convertedCatToNumeric?p[d.globals.minX+s-1]:p[s]:p,isPlainText:!1,cssClass:(t?"apexcharts-xaxis-label ":"apexcharts-xaxis-group-label ")+x});if(i.add(k),t){var A=document.createElementNS(d.globals.SVGNS,"title");A.textContent=Array.isArray(y.text)?y.text.join(" "):y.text,k.node.appendChild(A),""!==y.text&&(h.push(y.text),c.push(y))}}s<v-1&&(b+=r(s+1,o))},k=0;k<=v-1;k++)w(k)}},{key:"drawXaxisInversed",value:function(t){var e,i,a=this,s=this.w,r=new m(this.ctx),o=s.config.yaxis[0].opposite?s.globals.translateYAxisX[t]:0,n=r.group({class:"apexcharts-yaxis apexcharts-xaxis-inversed",rel:t}),l=r.group({class:"apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",transform:"translate("+o+", 0)"});n.add(l);var h=[];if(s.config.yaxis[t].show)for(var c=0;c<this.xaxisLabels.length;c++)h.push(this.xaxisLabels[c]);e=s.globals.gridHeight/h.length,i=-e/2.2;var d=s.globals.yLabelFormatters[0],g=s.config.yaxis[0].labels;if(g.show)for(var u=function(o){var n=void 0===h[o]?"":h[o];n=d(n,{seriesIndex:t,dataPointIndex:o,w:s});var c=a.axesUtils.getYAxisForeColor(g.style.colors,t),u=0;Array.isArray(n)&&(u=n.length/2*parseInt(g.style.fontSize,10));var p=r.drawText({x:g.offsetX-15,y:i+e+g.offsetY-u,text:n,textAnchor:a.yaxis.opposite?"start":"end",foreColor:Array.isArray(c)?c[o]:c,fontSize:g.style.fontSize,fontFamily:g.style.fontFamily,fontWeight:g.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-yaxis-label "+g.style.cssClass,maxWidth:g.maxWidth});l.add(p);var f=document.createElementNS(s.globals.SVGNS,"title");if(f.textContent=Array.isArray(n)?n.join(" "):n,p.node.appendChild(f),0!==s.config.yaxis[t].labels.rotate){var x=r.rotateAroundCenter(p.node);p.node.setAttribute("transform","rotate(".concat(s.config.yaxis[t].labels.rotate," 0 ").concat(x.y,")"))}i+=e},p=0;p<=h.length-1;p++)u(p);if(void 0!==s.config.yaxis[0].title.text){var f=r.group({class:"apexcharts-yaxis-title apexcharts-xaxis-title-inversed",transform:"translate("+o+", 0)"}),x=r.drawText({x:0,y:s.globals.gridHeight/2,text:s.config.yaxis[0].title.text,textAnchor:"middle",foreColor:s.config.yaxis[0].title.style.color,fontSize:s.config.yaxis[0].title.style.fontSize,fontWeight:s.config.yaxis[0].title.style.fontWeight,fontFamily:s.config.yaxis[0].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text "+s.config.yaxis[0].title.style.cssClass});f.add(x),n.add(f)}var b=0;this.isCategoryBarHorizontal&&s.config.yaxis[0].opposite&&(b=s.globals.gridWidth);var v=s.config.xaxis.axisBorder;if(v.show){var y=r.drawLine(s.globals.padHorizontal+v.offsetX+b,1+v.offsetY,s.globals.padHorizontal+v.offsetX+b,s.globals.gridHeight+v.offsetY,v.color,0);n.add(y)}return s.config.yaxis[0].axisTicks.show&&this.axesUtils.drawYAxisTicks(b,h.length,s.config.yaxis[0].axisBorder,s.config.yaxis[0].axisTicks,0,e,n),n}},{key:"drawXaxisTicks",value:function(t,e,i){var a=this.w,s=t;if(!(t<0||t-2>a.globals.gridWidth)){var r=this.offY+a.config.xaxis.axisTicks.offsetY;if(e=e+r+a.config.xaxis.axisTicks.height,"top"===a.config.xaxis.position&&(e=r-a.config.xaxis.axisTicks.height),a.config.xaxis.axisTicks.show){var o=new m(this.ctx).drawLine(t+a.config.xaxis.axisTicks.offsetX,r+a.config.xaxis.offsetY,s+a.config.xaxis.axisTicks.offsetX,e+a.config.xaxis.offsetY,a.config.xaxis.axisTicks.color);i.add(o),o.node.classList.add("apexcharts-xaxis-tick")}}}},{key:"getXAxisTicksPositions",value:function(){var t=this.w,e=[],i=this.xaxisLabels.length,a=t.globals.padHorizontal;if(t.globals.timescaleLabels.length>0)for(var s=0;s<i;s++)a=this.xaxisLabels[s].position,e.push(a);else for(var r=i,o=0;o<r;o++){var n=r;t.globals.isXNumeric&&"bar"!==t.config.chart.type&&(n-=1),a+=t.globals.gridWidth/n,e.push(a)}return e}},{key:"xAxisLabelCorrections",value:function(){var t=this.w,e=new m(this.ctx),i=t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"),s=t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"),r=t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");if(t.globals.rotateXLabels||t.config.xaxis.labels.rotateAlways)for(var o=0;o<a.length;o++){var n=e.rotateAroundCenter(a[o]);n.y=n.y-1,n.x=n.x+1,a[o].setAttribute("transform","rotate(".concat(t.config.xaxis.labels.rotate," ").concat(n.x," ").concat(n.y,")")),a[o].setAttribute("text-anchor","end");i.setAttribute("transform","translate(0, ".concat(-10,")"));var l=a[o].childNodes;t.config.xaxis.labels.trim&&Array.prototype.forEach.call(l,(function(i){e.placeTextWithEllipsis(i,i.textContent,t.globals.xAxisLabelsHeight-("bottom"===t.config.legend.position?20:10))}))}else!function(){for(var i=t.globals.gridWidth/(t.globals.labels.length+1),s=0;s<a.length;s++){var r=a[s].childNodes;t.config.xaxis.labels.trim&&"datetime"!==t.config.xaxis.type&&Array.prototype.forEach.call(r,(function(t){e.placeTextWithEllipsis(t,t.textContent,i)}))}}();if(s.length>0){var h=s[s.length-1].getBBox(),c=s[0].getBBox();h.x<-20&&s[s.length-1].parentNode.removeChild(s[s.length-1]),c.x+c.width>t.globals.gridWidth&&!t.globals.isBarHorizontal&&s[0].parentNode.removeChild(s[0]);for(var d=0;d<r.length;d++)e.placeTextWithEllipsis(r[d],r[d].textContent,t.config.yaxis[0].labels.maxWidth-(t.config.yaxis[0].title.text?2*parseFloat(t.config.yaxis[0].title.style.fontSize):0)-15)}}}]),t}(),U=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.xaxisLabels=i.globals.labels.slice(),this.axesUtils=new G(e),this.isRangeBar=i.globals.seriesRangeBar.length,i.globals.timescaleLabels.length>0&&(this.xaxisLabels=i.globals.timescaleLabels.slice())}return r(t,[{key:"drawGridArea",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,e=this.w,i=new m(this.ctx);null===t&&(t=i.group({class:"apexcharts-grid"}));var a=i.drawLine(e.globals.padHorizontal,1,e.globals.padHorizontal,e.globals.gridHeight,"transparent"),s=i.drawLine(e.globals.padHorizontal,e.globals.gridHeight,e.globals.gridWidth,e.globals.gridHeight,"transparent");return t.add(s),t.add(a),t}},{key:"drawGrid",value:function(){var t=null;return this.w.globals.axisCharts&&(t=this.renderGrid(),this.drawGridArea(t.el)),t}},{key:"createGridMask",value:function(){var t=this.w,e=t.globals,i=new m(this.ctx),a=Array.isArray(t.config.stroke.width)?0:t.config.stroke.width;if(Array.isArray(t.config.stroke.width)){var s=0;t.config.stroke.width.forEach((function(t){s=Math.max(s,t)})),a=s}e.dom.elGridRectMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elGridRectMask.setAttribute("id","gridRectMask".concat(e.cuid)),e.dom.elGridRectMarkerMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elGridRectMarkerMask.setAttribute("id","gridRectMarkerMask".concat(e.cuid)),e.dom.elForecastMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elForecastMask.setAttribute("id","forecastMask".concat(e.cuid)),e.dom.elNonForecastMask=document.createElementNS(e.SVGNS,"clipPath"),e.dom.elNonForecastMask.setAttribute("id","nonForecastMask".concat(e.cuid));var r=t.config.chart.type,o=0,n=0;("bar"===r||"rangeBar"===r||"candlestick"===r||"boxPlot"===r||t.globals.comboBarCount>0)&&t.globals.isXNumeric&&!t.globals.isBarHorizontal&&(o=t.config.grid.padding.left,n=t.config.grid.padding.right,e.barPadForNumericAxis>o&&(o=e.barPadForNumericAxis,n=e.barPadForNumericAxis)),e.dom.elGridRect=i.drawRect(-a/2-o-2,-a/2,e.gridWidth+a+n+o+4,e.gridHeight+a,0,"#fff");var l=t.globals.markers.largestSize+1;e.dom.elGridRectMarker=i.drawRect(2*-l,2*-l,e.gridWidth+4*l,e.gridHeight+4*l,0,"#fff"),e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node),e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);var h=e.dom.baseEl.querySelector("defs");h.appendChild(e.dom.elGridRectMask),h.appendChild(e.dom.elForecastMask),h.appendChild(e.dom.elNonForecastMask),h.appendChild(e.dom.elGridRectMarkerMask)}},{key:"_drawGridLines",value:function(t){var e=t.i,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.xCount,n=t.parent,l=this.w;if(!(0===e&&l.globals.skipFirstTimelinelabel||e===o-1&&l.globals.skipLastTimelinelabel&&!l.config.xaxis.labels.formatter||"radar"===l.config.chart.type)){l.config.grid.xaxis.lines.show&&this._drawGridLine({x1:i,y1:a,x2:s,y2:r,parent:n});var h=0;if(l.globals.hasGroups&&"between"===l.config.xaxis.tickPlacement){var c=l.globals.groups;if(c){for(var d=0,g=0;d<e&&g<c.length;g++)d+=c[g].cols;d===e&&(h=.6*l.globals.xAxisLabelsHeight)}}new _(this.ctx).drawXaxisTicks(i,h,this.elg)}}},{key:"_drawGridLine",value:function(t){var e=t.x1,i=t.y1,a=t.x2,s=t.y2,r=t.parent,o=this.w,n=r.node.classList.contains("apexcharts-gridlines-horizontal"),l=o.config.grid.strokeDashArray,h=o.globals.barPadForNumericAxis,c=new m(this).drawLine(e-(n?h:0),i,a+(n?h:0),s,o.config.grid.borderColor,l);c.node.classList.add("apexcharts-gridline"),r.add(c)}},{key:"_drawGridBandRect",value:function(t){var e=t.c,i=t.x1,a=t.y1,s=t.x2,r=t.y2,o=t.type,n=this.w,l=new m(this.ctx),h=n.globals.barPadForNumericAxis;if("column"!==o||"datetime"!==n.config.xaxis.type){var c=n.config.grid[o].colors[e],d=l.drawRect(i-("row"===o?h:0),a,s+("row"===o?2*h:0),r,0,c,n.config.grid[o].opacity);this.elg.add(d),d.attr("clip-path","url(#gridRectMask".concat(n.globals.cuid,")")),d.node.classList.add("apexcharts-grid-".concat(o))}}},{key:"_drawXYLines",value:function(t){var e=this,i=t.xCount,a=t.tickAmount,s=this.w;if(s.config.grid.xaxis.lines.show||s.config.xaxis.axisTicks.show){var r,o=s.globals.padHorizontal,n=s.globals.gridHeight;s.globals.timescaleLabels.length?function(t){for(var a=t.xC,s=t.x1,r=t.y1,o=t.x2,n=t.y2,l=0;l<a;l++)s=e.xaxisLabels[l].position,o=e.xaxisLabels[l].position,e._drawGridLines({i:l,x1:s,y1:r,x2:o,y2:n,xCount:i,parent:e.elgridLinesV})}({xC:i,x1:o,y1:0,x2:r,y2:n}):(s.globals.isXNumeric&&(i=s.globals.xAxisScale.result.length),s.config.xaxis.convertedCatToNumeric&&(i=s.globals.xaxisLabelsCount),function(t){var a=t.xC,r=t.x1,o=t.y1,n=t.x2,l=t.y2;if(void 0!==s.config.xaxis.tickAmount&&"dataPoints"!==s.config.xaxis.tickAmount&&"on"===s.config.xaxis.tickPlacement)s.globals.dom.baseEl.querySelectorAll(".apexcharts-text.apexcharts-xaxis-label tspan:not(:empty)").forEach((function(t,a){var s=t.getBBox();e._drawGridLines({i:a,x1:s.x+s.width/2,y1:o,x2:s.x+s.width/2,y2:l,xCount:i,parent:e.elgridLinesV})}));else for(var h=0;h<a+(s.globals.isXNumeric?0:1);h++)0===h&&1===a&&1===s.globals.dataPoints&&(n=r=s.globals.gridWidth/2),e._drawGridLines({i:h,x1:r,y1:o,x2:n,y2:l,xCount:i,parent:e.elgridLinesV}),n=r+=s.globals.gridWidth/(s.globals.isXNumeric?a-1:a)}({xC:i,x1:o,y1:0,x2:r,y2:n}))}if(s.config.grid.yaxis.lines.show){var l=0,h=0,c=s.globals.gridWidth,d=a+1;this.isRangeBar&&(d=s.globals.labels.length);for(var g=0;g<d+(this.isRangeBar?1:0);g++)this._drawGridLine({x1:0,y1:l,x2:c,y2:h,parent:this.elgridLinesH}),h=l+=s.globals.gridHeight/(this.isRangeBar?d:a)}}},{key:"_drawInvertedXYLines",value:function(t){var e=t.xCount,i=this.w;if(i.config.grid.xaxis.lines.show||i.config.xaxis.axisTicks.show)for(var a,s=i.globals.padHorizontal,r=i.globals.gridHeight,o=0;o<e+1;o++){i.config.grid.xaxis.lines.show&&this._drawGridLine({x1:s,y1:0,x2:a,y2:r,parent:this.elgridLinesV}),new _(this.ctx).drawXaxisTicks(s,0,this.elg),a=s=s+i.globals.gridWidth/e+.3}if(i.config.grid.yaxis.lines.show)for(var n=0,l=0,h=i.globals.gridWidth,c=0;c<i.globals.dataPoints+1;c++)this._drawGridLine({x1:0,y1:n,x2:h,y2:l,parent:this.elgridLinesH}),l=n+=i.globals.gridHeight/i.globals.dataPoints}},{key:"renderGrid",value:function(){var t=this.w,e=new m(this.ctx);this.elg=e.group({class:"apexcharts-grid"}),this.elgridLinesH=e.group({class:"apexcharts-gridlines-horizontal"}),this.elgridLinesV=e.group({class:"apexcharts-gridlines-vertical"}),this.elg.add(this.elgridLinesH),this.elg.add(this.elgridLinesV),t.config.grid.show||(this.elgridLinesV.hide(),this.elgridLinesH.hide());for(var i,a=t.globals.yAxisScale.length?t.globals.yAxisScale[0].result.length-1:5,s=0;s<t.globals.series.length&&(void 0!==t.globals.yAxisScale[s]&&(a=t.globals.yAxisScale[s].result.length-1),!(a>2));s++);return!t.globals.isBarHorizontal||this.isRangeBar?(i=this.xaxisLabels.length,this.isRangeBar&&(a=t.globals.labels.length,t.config.xaxis.tickAmount&&t.config.xaxis.labels.formatter&&(i=t.config.xaxis.tickAmount)),this._drawXYLines({xCount:i,tickAmount:a})):(i=a,a=t.globals.xTickAmount,this._drawInvertedXYLines({xCount:i,tickAmount:a})),this.drawGridBands(i,a),{el:this.elg,xAxisTickWidth:t.globals.gridWidth/i}}},{key:"drawGridBands",value:function(t,e){var i=this.w;if(void 0!==i.config.grid.row.colors&&i.config.grid.row.colors.length>0)for(var a=0,s=i.globals.gridHeight/e,r=i.globals.gridWidth,o=0,n=0;o<e;o++,n++)n>=i.config.grid.row.colors.length&&(n=0),this._drawGridBandRect({c:n,x1:0,y1:a,x2:r,y2:s,type:"row"}),a+=i.globals.gridHeight/e;if(void 0!==i.config.grid.column.colors&&i.config.grid.column.colors.length>0)for(var l=i.globals.isBarHorizontal||"category"!==i.config.xaxis.type&&!i.config.xaxis.convertedCatToNumeric?t:t-1,h=i.globals.padHorizontal,c=i.globals.padHorizontal+i.globals.gridWidth/l,d=i.globals.gridHeight,g=0,u=0;g<t;g++,u++)u>=i.config.grid.column.colors.length&&(u=0),this._drawGridBandRect({c:u,x1:h,y1:0,x2:c,y2:d,type:"column"}),h+=i.globals.gridWidth/l}}]),t}(),q=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"niceScale",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:0,s=arguments.length>4?arguments[4]:void 0,r=this.w,o=Math.abs(e-t);if("dataPoints"===(i=this._adjustTicksForSmallRange(i,a,o))&&(i=r.globals.dataPoints-1),t===Number.MIN_VALUE&&0===e||!x.isNumber(t)&&!x.isNumber(e)||t===Number.MIN_VALUE&&e===-Number.MAX_VALUE){t=0,e=i;var n=this.linearScale(t,e,i);return n}t>e?(console.warn("axis.min cannot be greater than axis.max"),e=t+.1):t===e&&(t=0===t?0:t-.5,e=0===e?2:e+.5);var l=[];o<1&&s&&("candlestick"===r.config.chart.type||"candlestick"===r.config.series[a].type||"boxPlot"===r.config.chart.type||"boxPlot"===r.config.series[a].type||r.globals.isRangeData)&&(e*=1.01);var h=i+1;h<2?h=2:h>2&&(h-=2);var c=o/h,d=Math.floor(x.log10(c)),g=Math.pow(10,d),u=Math.round(c/g);u<1&&(u=1);var p=u*g,f=p*Math.floor(t/p),b=p*Math.ceil(e/p),v=f;if(s&&o>2){for(;l.push(v),!((v+=p)>b););return{result:l,niceMin:l[0],niceMax:l[l.length-1]}}var m=t;(l=[]).push(m);for(var y=Math.abs(e-t)/i,w=0;w<=i;w++)m+=y,l.push(m);return l[l.length-2]>=e&&l.pop(),{result:l,niceMin:l[0],niceMax:l[l.length-1]}}},{key:"linearScale",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:10,a=arguments.length>3?arguments[3]:void 0,s=Math.abs(e-t);"dataPoints"===(i=this._adjustTicksForSmallRange(i,a,s))&&(i=this.w.globals.dataPoints-1);var r=s/i;i===Number.MAX_VALUE&&(i=10,r=1);for(var o=[],n=t;i>=0;)o.push(n),n+=r,i-=1;return{result:o,niceMin:o[0],niceMax:o[o.length-1]}}},{key:"logarithmicScaleNice",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.ceil(Math.log(e)/Math.log(i)+1),r=Math.floor(Math.log(t)/Math.log(i));r<s;r++)a.push(Math.pow(i,r));return{result:a,niceMin:a[0],niceMax:a[a.length-1]}}},{key:"logarithmicScale",value:function(t,e,i){e<=0&&(e=Math.max(t,i)),t<=0&&(t=Math.min(e,i));for(var a=[],s=Math.log(e)/Math.log(i),r=Math.log(t)/Math.log(i),o=s-r,n=Math.round(o),l=o/n,h=0,c=r;h<n;h++,c+=l)a.push(Math.pow(i,c));return a.push(Math.pow(i,s)),{result:a,niceMin:t,niceMax:e}}},{key:"_adjustTicksForSmallRange",value:function(t,e,i){var a=t;if(void 0!==e&&this.w.config.yaxis[e].labels.formatter&&void 0===this.w.config.yaxis[e].tickAmount){var s=this.w.config.yaxis[e].labels.formatter(1);x.isNumber(Number(s))&&!x.isFloat(s)&&(a=Math.ceil(i))}return a<t?a:t}},{key:"setYScaleForIndex",value:function(t,e,i){var a=this.w.globals,s=this.w.config,r=a.isBarHorizontal?s.xaxis:s.yaxis[t];void 0===a.yAxisScale[t]&&(a.yAxisScale[t]=[]);var o=Math.abs(i-e);if(r.logarithmic&&o<=5&&(a.invalidLogScale=!0),r.logarithmic&&o>5)a.allSeriesCollapsed=!1,a.yAxisScale[t]=this.logarithmicScale(e,i,r.logBase),a.yAxisScale[t]=r.forceNiceScale?this.logarithmicScaleNice(e,i,r.logBase):this.logarithmicScale(e,i,r.logBase);else if(i!==-Number.MAX_VALUE&&x.isNumber(i))if(a.allSeriesCollapsed=!1,void 0===r.min&&void 0===r.max||r.forceNiceScale){var n=void 0===s.yaxis[t].max&&void 0===s.yaxis[t].min||s.yaxis[t].forceNiceScale;a.yAxisScale[t]=this.niceScale(e,i,r.tickAmount?r.tickAmount:o<5&&o>1?o+1:5,t,n)}else a.yAxisScale[t]=this.linearScale(e,i,r.tickAmount,t);else a.yAxisScale[t]=this.linearScale(0,5,5)}},{key:"setXScale",value:function(t,e){var i=this.w,a=i.globals,s=i.config.xaxis,r=Math.abs(e-t);return e!==-Number.MAX_VALUE&&x.isNumber(e)?a.xAxisScale=this.linearScale(t,e,s.tickAmount?s.tickAmount:r<5&&r>1?r+1:5,0):a.xAxisScale=this.linearScale(0,5,5),a.xAxisScale}},{key:"setMultipleYScales",value:function(){var t=this,e=this.w.globals,i=this.w.config,a=e.minYArr.concat([]),s=e.maxYArr.concat([]),r=[];i.yaxis.forEach((function(e,o){var n=o;i.series.forEach((function(t,i){t.name===e.seriesName&&(n=i,o!==i?r.push({index:i,similarIndex:o,alreadyExists:!0}):r.push({index:i}))}));var l=a[n],h=s[n];t.setYScaleForIndex(o,l,h)})),this.sameScaleInMultipleAxes(a,s,r)}},{key:"sameScaleInMultipleAxes",value:function(t,e,i){var a=this,s=this.w.config,r=this.w.globals,o=[];i.forEach((function(t){t.alreadyExists&&(void 0===o[t.index]&&(o[t.index]=[]),o[t.index].push(t.index),o[t.index].push(t.similarIndex))})),r.yAxisSameScaleIndices=o,o.forEach((function(t,e){o.forEach((function(i,a){var s,r;e!==a&&(s=t,r=i,s.filter((function(t){return-1!==r.indexOf(t)}))).length>0&&(o[e]=o[e].concat(o[a]))}))}));var n=o.map((function(t){return t.filter((function(e,i){return t.indexOf(e)===i}))})).map((function(t){return t.sort()}));o=o.filter((function(t){return!!t}));var l=n.slice(),h=l.map((function(t){return JSON.stringify(t)}));l=l.filter((function(t,e){return h.indexOf(JSON.stringify(t))===e}));var c=[],d=[];t.forEach((function(t,i){l.forEach((function(a,s){a.indexOf(i)>-1&&(void 0===c[s]&&(c[s]=[],d[s]=[]),c[s].push({key:i,value:t}),d[s].push({key:i,value:e[i]}))}))}));var g=Array.apply(null,Array(l.length)).map(Number.prototype.valueOf,Number.MIN_VALUE),u=Array.apply(null,Array(l.length)).map(Number.prototype.valueOf,-Number.MAX_VALUE);c.forEach((function(t,e){t.forEach((function(t,i){g[e]=Math.min(t.value,g[e])}))})),d.forEach((function(t,e){t.forEach((function(t,i){u[e]=Math.max(t.value,u[e])}))})),t.forEach((function(t,e){d.forEach((function(t,i){var o=g[i],n=u[i];s.chart.stacked&&(n=0,t.forEach((function(t,e){t.value!==-Number.MAX_VALUE&&(n+=t.value),o!==Number.MIN_VALUE&&(o+=c[i][e].value)}))),t.forEach((function(i,l){t[l].key===e&&(void 0!==s.yaxis[e].min&&(o="function"==typeof s.yaxis[e].min?s.yaxis[e].min(r.minY):s.yaxis[e].min),void 0!==s.yaxis[e].max&&(n="function"==typeof s.yaxis[e].max?s.yaxis[e].max(r.maxY):s.yaxis[e].max),a.setYScaleForIndex(e,o,n))}))}))}))}},{key:"autoScaleY",value:function(t,e,i){t||(t=this);var a=t.w;if(a.globals.isMultipleYAxis||a.globals.collapsedSeries.length)return console.warn("autoScaleYaxis is not supported in a multi-yaxis chart."),e;var s=a.globals.seriesX[0],r=a.config.chart.stacked;return e.forEach((function(t,o){for(var n=0,l=0;l<s.length;l++)if(s[l]>=i.xaxis.min){n=l;break}var h,c,d=a.globals.minYArr[o],g=a.globals.maxYArr[o],u=a.globals.stackedSeriesTotals;a.globals.series.forEach((function(o,l){var p=o[n];r?(p=u[n],h=c=p,u.forEach((function(t,e){s[e]<=i.xaxis.max&&s[e]>=i.xaxis.min&&(t>c&&null!==t&&(c=t),o[e]<h&&null!==o[e]&&(h=o[e]))}))):(h=c=p,o.forEach((function(t,e){if(s[e]<=i.xaxis.max&&s[e]>=i.xaxis.min){var r=t,o=t;a.globals.series.forEach((function(i,a){null!==t&&(r=Math.min(i[e],r),o=Math.max(i[e],o))})),o>c&&null!==o&&(c=o),r<h&&null!==r&&(h=r)}}))),void 0===h&&void 0===c&&(h=d,c=g),c*=c<0?.9:1.1,0===(h*=h<0?1.1:.9)&&0===c&&(h=-1,c=1),c<0&&c<g&&(c=g),h<0&&h>d&&(h=d),e.length>1?(e[l].min=void 0===t.min?h:t.min,e[l].max=void 0===t.max?c:t.max):(e[0].min=void 0===t.min?h:t.min,e[0].max=void 0===t.max?c:t.max)}))})),e}}]),t}(),Z=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.scales=new q(e)}return r(t,[{key:"init",value:function(){this.setYRange(),this.setXRange(),this.setZRange()}},{key:"getMinYMaxY",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Number.MAX_VALUE,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:-Number.MAX_VALUE,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w.config,r=this.w.globals,o=-Number.MAX_VALUE,n=Number.MIN_VALUE;null===a&&(a=t+1);var l=r.series,h=l,c=l;"candlestick"===s.chart.type?(h=r.seriesCandleL,c=r.seriesCandleH):"boxPlot"===s.chart.type?(h=r.seriesCandleO,c=r.seriesCandleC):r.isRangeData&&(h=r.seriesRangeStart,c=r.seriesRangeEnd);for(var d=t;d<a;d++){r.dataPoints=Math.max(r.dataPoints,l[d].length),r.categoryLabels.length&&(r.dataPoints=r.categoryLabels.filter((function(t){return void 0!==t})).length);for(var g=0;g<r.series[d].length;g++){var u=l[d][g];null!==u&&x.isNumber(u)?(void 0!==c[d][g]&&(o=Math.max(o,c[d][g]),e=Math.min(e,c[d][g])),void 0!==h[d][g]&&(e=Math.min(e,h[d][g]),i=Math.max(i,h[d][g])),"candlestick"!==this.w.config.chart.type&&"boxPlot"!==this.w.config.chart.type||(void 0!==r.seriesCandleC[d][g]&&(o=Math.max(o,r.seriesCandleO[d][g]),o=Math.max(o,r.seriesCandleH[d][g]),o=Math.max(o,r.seriesCandleL[d][g]),o=Math.max(o,r.seriesCandleC[d][g]),"boxPlot"===this.w.config.chart.type&&(o=Math.max(o,r.seriesCandleM[d][g]))),!s.series[d].type||"candlestick"===s.series[d].type&&"boxPlot"===s.series[d].type||(o=Math.max(o,r.series[d][g]),e=Math.min(e,r.series[d][g])),i=o),r.seriesGoals[d]&&r.seriesGoals[d][g]&&Array.isArray(r.seriesGoals[d][g])&&r.seriesGoals[d][g].forEach((function(t){n!==Number.MIN_VALUE&&(n=Math.min(n,t.value),e=n),o=Math.max(o,t.value),i=o})),x.isFloat(u)&&(u=x.noExponents(u),r.yValueDecimal=Math.max(r.yValueDecimal,u.toString().split(".")[1].length)),n>h[d][g]&&h[d][g]<0&&(n=h[d][g])):r.hasNullValues=!0}}return"rangeBar"===s.chart.type&&r.seriesRangeStart.length&&r.isBarHorizontal&&(n=e),"bar"===s.chart.type&&(n<0&&o<0&&(o=0),n===Number.MIN_VALUE&&(n=0)),{minY:n,maxY:o,lowestY:e,highestY:i}}},{key:"setYRange",value:function(){var t=this.w.globals,e=this.w.config;t.maxY=-Number.MAX_VALUE,t.minY=Number.MIN_VALUE;var i=Number.MAX_VALUE;if(t.isMultipleYAxis)for(var a=0;a<t.series.length;a++){var s=this.getMinYMaxY(a,i,null,a+1);t.minYArr.push(s.minY),t.maxYArr.push(s.maxY),i=s.lowestY}var r=this.getMinYMaxY(0,i,null,t.series.length);if(t.minY=r.minY,t.maxY=r.maxY,i=r.lowestY,e.chart.stacked&&this._setStackedMinMax(),("line"===e.chart.type||"area"===e.chart.type||"candlestick"===e.chart.type||"boxPlot"===e.chart.type||"rangeBar"===e.chart.type&&!t.isBarHorizontal)&&t.minY===Number.MIN_VALUE&&i!==-Number.MAX_VALUE&&i!==t.maxY){var o=t.maxY-i;(i>=0&&i<=10||void 0!==e.yaxis[0].min||void 0!==e.yaxis[0].max)&&(o=0),t.minY=i-5*o/100,i>0&&t.minY<0&&(t.minY=0),t.maxY=t.maxY+5*o/100}if(e.yaxis.forEach((function(e,i){void 0!==e.max&&("number"==typeof e.max?t.maxYArr[i]=e.max:"function"==typeof e.max&&(t.maxYArr[i]=e.max(t.isMultipleYAxis?t.maxYArr[i]:t.maxY)),t.maxY=t.maxYArr[i]),void 0!==e.min&&("number"==typeof e.min?t.minYArr[i]=e.min:"function"==typeof e.min&&(t.minYArr[i]=e.min(t.isMultipleYAxis?t.minYArr[i]===Number.MIN_VALUE?0:t.minYArr[i]:t.minY)),t.minY=t.minYArr[i])})),t.isBarHorizontal){["min","max"].forEach((function(i){void 0!==e.xaxis[i]&&"number"==typeof e.xaxis[i]&&("min"===i?t.minY=e.xaxis[i]:t.maxY=e.xaxis[i])}))}return t.isMultipleYAxis?(this.scales.setMultipleYScales(),t.minY=i,t.yAxisScale.forEach((function(e,i){t.minYArr[i]=e.niceMin,t.maxYArr[i]=e.niceMax}))):(this.scales.setYScaleForIndex(0,t.minY,t.maxY),t.minY=t.yAxisScale[0].niceMin,t.maxY=t.yAxisScale[0].niceMax,t.minYArr[0]=t.yAxisScale[0].niceMin,t.maxYArr[0]=t.yAxisScale[0].niceMax),{minY:t.minY,maxY:t.maxY,minYArr:t.minYArr,maxYArr:t.maxYArr,yAxisScale:t.yAxisScale}}},{key:"setXRange",value:function(){var t=this.w.globals,e=this.w.config,i="numeric"===e.xaxis.type||"datetime"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided||t.noLabelsProvided||t.isXNumeric;if(t.isXNumeric&&function(){for(var e=0;e<t.series.length;e++)if(t.labels[e])for(var i=0;i<t.labels[e].length;i++)null!==t.labels[e][i]&&x.isNumber(t.labels[e][i])&&(t.maxX=Math.max(t.maxX,t.labels[e][i]),t.initialMaxX=Math.max(t.maxX,t.labels[e][i]),t.minX=Math.min(t.minX,t.labels[e][i]),t.initialMinX=Math.min(t.minX,t.labels[e][i]))}(),t.noLabelsProvided&&0===e.xaxis.categories.length&&(t.maxX=t.labels[t.labels.length-1],t.initialMaxX=t.labels[t.labels.length-1],t.minX=1,t.initialMinX=1),t.isXNumeric||t.noLabelsProvided||t.dataFormatXNumeric){var a;if(void 0===e.xaxis.tickAmount?(a=Math.round(t.svgWidth/150),"numeric"===e.xaxis.type&&t.dataPoints<30&&(a=t.dataPoints-1),a>t.dataPoints&&0!==t.dataPoints&&(a=t.dataPoints-1)):"dataPoints"===e.xaxis.tickAmount?(t.series.length>1&&(a=t.series[t.maxValsInArrayIndex].length-1),t.isXNumeric&&(a=t.maxX-t.minX-1)):a=e.xaxis.tickAmount,t.xTickAmount=a,void 0!==e.xaxis.max&&"number"==typeof e.xaxis.max&&(t.maxX=e.xaxis.max),void 0!==e.xaxis.min&&"number"==typeof e.xaxis.min&&(t.minX=e.xaxis.min),void 0!==e.xaxis.range&&(t.minX=t.maxX-e.xaxis.range),t.minX!==Number.MAX_VALUE&&t.maxX!==-Number.MAX_VALUE)if(e.xaxis.convertedCatToNumeric&&!t.dataFormatXNumeric){for(var s=[],r=t.minX-1;r<t.maxX;r++)s.push(r+1);t.xAxisScale={result:s,niceMin:s[0],niceMax:s[s.length-1]}}else t.xAxisScale=this.scales.setXScale(t.minX,t.maxX);else t.xAxisScale=this.scales.linearScale(1,a,a),t.noLabelsProvided&&t.labels.length>0&&(t.xAxisScale=this.scales.linearScale(1,t.labels.length,a-1),t.seriesX=t.labels.slice());i&&(t.labels=t.xAxisScale.result.slice())}return t.isBarHorizontal&&t.labels.length&&(t.xTickAmount=t.labels.length),this._handleSingleDataPoint(),this._getMinXDiff(),{minX:t.minX,maxX:t.maxX}}},{key:"setZRange",value:function(){var t=this.w.globals;if(t.isDataXYZ)for(var e=0;e<t.series.length;e++)if(void 0!==t.seriesZ[e])for(var i=0;i<t.seriesZ[e].length;i++)null!==t.seriesZ[e][i]&&x.isNumber(t.seriesZ[e][i])&&(t.maxZ=Math.max(t.maxZ,t.seriesZ[e][i]),t.minZ=Math.min(t.minZ,t.seriesZ[e][i]))}},{key:"_handleSingleDataPoint",value:function(){var t=this.w.globals,e=this.w.config;if(t.minX===t.maxX){var i=new R(this.ctx);if("datetime"===e.xaxis.type){var a=i.getDate(t.minX);e.xaxis.labels.datetimeUTC?a.setUTCDate(a.getUTCDate()-2):a.setDate(a.getDate()-2),t.minX=new Date(a).getTime();var s=i.getDate(t.maxX);e.xaxis.labels.datetimeUTC?s.setUTCDate(s.getUTCDate()+2):s.setDate(s.getDate()+2),t.maxX=new Date(s).getTime()}else("numeric"===e.xaxis.type||"category"===e.xaxis.type&&!t.noLabelsProvided)&&(t.minX=t.minX-2,t.initialMinX=t.minX,t.maxX=t.maxX+2,t.initialMaxX=t.maxX)}}},{key:"_getMinXDiff",value:function(){var t=this.w.globals;t.isXNumeric&&t.seriesX.forEach((function(e,i){1===e.length&&e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length-1]);var a=e.slice();a.sort((function(t,e){return t-e})),a.forEach((function(e,i){if(i>0){var s=e-a[i-1];s>0&&(t.minXDiff=Math.min(s,t.minXDiff))}})),1!==t.dataPoints&&t.minXDiff!==Number.MAX_VALUE||(t.minXDiff=.5)}))}},{key:"_setStackedMinMax",value:function(){var t=this.w.globals,e=[],i=[];if(t.series.length)for(var a=0;a<t.series[t.maxValsInArrayIndex].length;a++)for(var s=0,r=0,o=0;o<t.series.length;o++)null!==t.series[o][a]&&x.isNumber(t.series[o][a])&&(t.series[o][a]>0?s=s+parseFloat(t.series[o][a])+1e-4:r+=parseFloat(t.series[o][a])),o===t.series.length-1&&(e.push(s),i.push(r));for(var n=0;n<e.length;n++)t.maxY=Math.max(t.maxY,e[n]),t.minY=Math.min(t.minY,i[n])}}]),t}(),$=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.xaxisFontSize=i.config.xaxis.labels.style.fontSize,this.axisFontFamily=i.config.xaxis.labels.style.fontFamily,this.xaxisForeColors=i.config.xaxis.labels.style.colors,this.isCategoryBarHorizontal="bar"===i.config.chart.type&&i.config.plotOptions.bar.horizontal,this.xAxisoffX=0,"bottom"===i.config.xaxis.position&&(this.xAxisoffX=i.globals.gridHeight),this.drawnLabels=[],this.axesUtils=new G(e)}return r(t,[{key:"drawYaxis",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=i.config.yaxis[t].labels.style,r=s.fontSize,o=s.fontFamily,n=s.fontWeight,l=a.group({class:"apexcharts-yaxis",rel:t,transform:"translate("+i.globals.translateYAxisX[t]+", 0)"});if(this.axesUtils.isYAxisHidden(t))return l;var h=a.group({class:"apexcharts-yaxis-texts-g"});l.add(h);var c=i.globals.yAxisScale[t].result.length-1,d=i.globals.gridHeight/c,g=i.globals.translateY,u=i.globals.yLabelFormatters[t],p=i.globals.yAxisScale[t].result.slice();p=this.axesUtils.checkForReversedLabels(t,p);var f="";if(i.config.yaxis[t].labels.show)for(var x=function(l){var x=p[l];x=u(x,l,i);var b=i.config.yaxis[t].labels.padding;i.config.yaxis[t].opposite&&0!==i.config.yaxis.length&&(b*=-1);var v=e.axesUtils.getYAxisForeColor(s.colors,t),m=a.drawText({x:b,y:g+c/10+i.config.yaxis[t].labels.offsetY+1,text:x,textAnchor:i.config.yaxis[t].opposite?"start":"end",fontSize:r,fontFamily:o,fontWeight:n,maxWidth:i.config.yaxis[t].labels.maxWidth,foreColor:Array.isArray(v)?v[l]:v,isPlainText:!1,cssClass:"apexcharts-yaxis-label "+s.cssClass});l===c&&(f=m),h.add(m);var y=document.createElementNS(i.globals.SVGNS,"title");if(y.textContent=Array.isArray(x)?x.join(" "):x,m.node.appendChild(y),0!==i.config.yaxis[t].labels.rotate){var w=a.rotateAroundCenter(f.node),k=a.rotateAroundCenter(m.node);m.node.setAttribute("transform","rotate(".concat(i.config.yaxis[t].labels.rotate," ").concat(w.x," ").concat(k.y,")"))}g+=d},b=c;b>=0;b--)x(b);if(void 0!==i.config.yaxis[t].title.text){var v=a.group({class:"apexcharts-yaxis-title"}),y=0;i.config.yaxis[t].opposite&&(y=i.globals.translateYAxisX[t]);var w=a.drawText({x:y,y:i.globals.gridHeight/2+i.globals.translateY+i.config.yaxis[t].title.offsetY,text:i.config.yaxis[t].title.text,textAnchor:"end",foreColor:i.config.yaxis[t].title.style.color,fontSize:i.config.yaxis[t].title.style.fontSize,fontWeight:i.config.yaxis[t].title.style.fontWeight,fontFamily:i.config.yaxis[t].title.style.fontFamily,cssClass:"apexcharts-yaxis-title-text "+i.config.yaxis[t].title.style.cssClass});v.add(w),l.add(v)}var k=i.config.yaxis[t].axisBorder,A=31+k.offsetX;if(i.config.yaxis[t].opposite&&(A=-31-k.offsetX),k.show){var S=a.drawLine(A,i.globals.translateY+k.offsetY-2,A,i.globals.gridHeight+i.globals.translateY+k.offsetY+2,k.color,0,k.width);l.add(S)}return i.config.yaxis[t].axisTicks.show&&this.axesUtils.drawYAxisTicks(A,c,k,i.config.yaxis[t].axisTicks,t,d,l),l}},{key:"drawYaxisInversed",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-xaxis apexcharts-yaxis-inversed"}),s=i.group({class:"apexcharts-xaxis-texts-g",transform:"translate(".concat(e.globals.translateXAxisX,", ").concat(e.globals.translateXAxisY,")")});a.add(s);var r=e.globals.yAxisScale[t].result.length-1,o=e.globals.gridWidth/r+.1,n=o+e.config.xaxis.labels.offsetX,l=e.globals.xLabelFormatter,h=e.globals.yAxisScale[t].result.slice(),c=e.globals.timescaleLabels;c.length>0&&(this.xaxisLabels=c.slice(),r=(h=c.slice()).length),h=this.axesUtils.checkForReversedLabels(t,h);var d=c.length;if(e.config.xaxis.labels.show)for(var g=d?0:r;d?g<d:g>=0;d?g++:g--){var u=h[g];u=l(u,g,e);var p=e.globals.gridWidth+e.globals.padHorizontal-(n-o+e.config.xaxis.labels.offsetX);if(c.length){var f=this.axesUtils.getLabel(h,c,p,g,this.drawnLabels,this.xaxisFontSize);p=f.x,u=f.text,this.drawnLabels.push(f.text),0===g&&e.globals.skipFirstTimelinelabel&&(u=""),g===h.length-1&&e.globals.skipLastTimelinelabel&&(u="")}var x=i.drawText({x:p,y:this.xAxisoffX+e.config.xaxis.labels.offsetY+30-("top"===e.config.xaxis.position?e.globals.xAxisHeight+e.config.xaxis.axisTicks.height-2:0),text:u,textAnchor:"middle",foreColor:Array.isArray(this.xaxisForeColors)?this.xaxisForeColors[t]:this.xaxisForeColors,fontSize:this.xaxisFontSize,fontFamily:this.xaxisFontFamily,fontWeight:e.config.xaxis.labels.style.fontWeight,isPlainText:!1,cssClass:"apexcharts-xaxis-label "+e.config.xaxis.labels.style.cssClass});s.add(x),x.tspan(u);var b=document.createElementNS(e.globals.SVGNS,"title");b.textContent=u,x.node.appendChild(b),n+=o}return this.inversedYAxisTitleText(a),this.inversedYAxisBorder(a),a}},{key:"inversedYAxisBorder",value:function(t){var e=this.w,i=new m(this.ctx),a=e.config.xaxis.axisBorder;if(a.show){var s=0;"bar"===e.config.chart.type&&e.globals.isXNumeric&&(s-=15);var r=i.drawLine(e.globals.padHorizontal+s+a.offsetX,this.xAxisoffX,e.globals.gridWidth,this.xAxisoffX,a.color,0,a.height);t.add(r)}}},{key:"inversedYAxisTitleText",value:function(t){var e=this.w,i=new m(this.ctx);if(void 0!==e.config.xaxis.title.text){var a=i.group({class:"apexcharts-xaxis-title apexcharts-yaxis-title-inversed"}),s=i.drawText({x:e.globals.gridWidth/2+e.config.xaxis.title.offsetX,y:this.xAxisoffX+parseFloat(this.xaxisFontSize)+parseFloat(e.config.xaxis.title.style.fontSize)+e.config.xaxis.title.offsetY+20,text:e.config.xaxis.title.text,textAnchor:"middle",fontSize:e.config.xaxis.title.style.fontSize,fontFamily:e.config.xaxis.title.style.fontFamily,fontWeight:e.config.xaxis.title.style.fontWeight,foreColor:e.config.xaxis.title.style.color,cssClass:"apexcharts-xaxis-title-text "+e.config.xaxis.title.style.cssClass});a.add(s),t.add(a)}}},{key:"yAxisTitleRotate",value:function(t,e){var i=this.w,a=new m(this.ctx),s={width:0,height:0},r={width:0,height:0},o=i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-texts-g"));null!==o&&(s=o.getBoundingClientRect());var n=i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t,"'] .apexcharts-yaxis-title text"));if(null!==n&&(r=n.getBoundingClientRect()),null!==n){var l=this.xPaddingForYAxisTitle(t,s,r,e);n.setAttribute("x",l.xPos-(e?10:0))}if(null!==n){var h=a.rotateAroundCenter(n);n.setAttribute("transform","rotate(".concat(e?-1*i.config.yaxis[t].title.rotate:i.config.yaxis[t].title.rotate," ").concat(h.x," ").concat(h.y,")"))}}},{key:"xPaddingForYAxisTitle",value:function(t,e,i,a){var s=this.w,r=0,o=0,n=10;return void 0===s.config.yaxis[t].title.text||t<0?{xPos:o,padd:0}:(a?(o=e.width+s.config.yaxis[t].title.offsetX+i.width/2+n/2,0===(r+=1)&&(o-=n/2)):(o=-1*e.width+s.config.yaxis[t].title.offsetX+n/2+i.width/2,s.globals.isBarHorizontal&&(n=25,o=-1*e.width-s.config.yaxis[t].title.offsetX-n)),{xPos:o,padd:n})}},{key:"setYAxisXPosition",value:function(t,e){var i=this.w,a=0,s=0,r=18,o=1;i.config.yaxis.length>1&&(this.multipleYs=!0),i.config.yaxis.map((function(n,l){var h=i.globals.ignoreYAxisIndexes.indexOf(l)>-1||!n.show||n.floating||0===t[l].width,c=t[l].width+e[l].width;n.opposite?i.globals.isBarHorizontal?(s=i.globals.gridWidth+i.globals.translateX-1,i.globals.translateYAxisX[l]=s-n.labels.offsetX):(s=i.globals.gridWidth+i.globals.translateX+o,h||(o=o+c+20),i.globals.translateYAxisX[l]=s-n.labels.offsetX+20):(a=i.globals.translateX-r,h||(r=r+c+20),i.globals.translateYAxisX[l]=a+n.labels.offsetX)}))}},{key:"setYAxisTextAlignments",value:function(){var t=this.w,e=t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");(e=x.listToArray(e)).forEach((function(e,i){var a=t.config.yaxis[i];if(a&&void 0!==a.labels.align){var s=t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-texts-g")),r=t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i,"'] .apexcharts-yaxis-label"));r=x.listToArray(r);var o=s.getBoundingClientRect();"left"===a.labels.align?(r.forEach((function(t,e){t.setAttribute("text-anchor","start")})),a.opposite||s.setAttribute("transform","translate(-".concat(o.width,", 0)"))):"center"===a.labels.align?(r.forEach((function(t,e){t.setAttribute("text-anchor","middle")})),s.setAttribute("transform","translate(".concat(o.width/2*(a.opposite?1:-1),", 0)"))):"right"===a.labels.align&&(r.forEach((function(t,e){t.setAttribute("text-anchor","end")})),a.opposite&&s.setAttribute("transform","translate(".concat(o.width,", 0)")))}}))}}]),t}(),J=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.documentEvent=x.bind(this.documentEvent,this)}return r(t,[{key:"addEventListener",value:function(t,e){var i=this.w;i.globals.events.hasOwnProperty(t)?i.globals.events[t].push(e):i.globals.events[t]=[e]}},{key:"removeEventListener",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){var a=i.globals.events[t].indexOf(e);-1!==a&&i.globals.events[t].splice(a,1)}}},{key:"fireEvent",value:function(t,e){var i=this.w;if(i.globals.events.hasOwnProperty(t)){e&&e.length||(e=[]);for(var a=i.globals.events[t],s=a.length,r=0;r<s;r++)a[r].apply(null,e)}}},{key:"setupEventHandlers",value:function(){var t=this,e=this.w,i=this.ctx,a=e.globals.dom.baseEl.querySelector(e.globals.chartClass);this.ctx.eventList.forEach((function(t){a.addEventListener(t,(function(t){var a=Object.assign({},e,{seriesIndex:e.globals.capturedSeriesIndex,dataPointIndex:e.globals.capturedDataPointIndex});"mousemove"===t.type||"touchmove"===t.type?"function"==typeof e.config.chart.events.mouseMove&&e.config.chart.events.mouseMove(t,i,a):"mouseleave"===t.type||"touchleave"===t.type?"function"==typeof e.config.chart.events.mouseLeave&&e.config.chart.events.mouseLeave(t,i,a):("mouseup"===t.type&&1===t.which||"touchend"===t.type)&&("function"==typeof e.config.chart.events.click&&e.config.chart.events.click(t,i,a),i.ctx.events.fireEvent("click",[t,i,a]))}),{capture:!1,passive:!0})})),this.ctx.eventList.forEach((function(i){e.globals.dom.baseEl.addEventListener(i,t.documentEvent,{passive:!0})})),this.ctx.core.setupBrushHandler()}},{key:"documentEvent",value:function(t){var e=this.w,i=t.target.className;if("click"===t.type){var a=e.globals.dom.baseEl.querySelector(".apexcharts-menu");a&&a.classList.contains("apexcharts-menu-open")&&"apexcharts-menu-icon"!==i&&a.classList.remove("apexcharts-menu-open")}e.globals.clientX="touchmove"===t.type?t.touches[0].clientX:t.clientX,e.globals.clientY="touchmove"===t.type?t.touches[0].clientY:t.clientY}}]),t}(),Q=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"setCurrentLocaleValues",value:function(t){var e=this.w.config.chart.locales;window.Apex.chart&&window.Apex.chart.locales&&window.Apex.chart.locales.length>0&&(e=this.w.config.chart.locales.concat(window.Apex.chart.locales));var i=e.filter((function(e){return e.name===t}))[0];if(!i)throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");var a=x.extend(C,i);this.w.globals.locale=a.options}}]),t}(),K=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawAxis",value:function(t,e){var i,a,s=this.w.globals,r=this.w.config,o=new _(this.ctx),n=new $(this.ctx);s.axisCharts&&"radar"!==t&&(s.isBarHorizontal?(a=n.drawYaxisInversed(0),i=o.drawXaxisInversed(0),s.dom.elGraphical.add(i),s.dom.elGraphical.add(a)):(i=o.drawXaxis(),s.dom.elGraphical.add(i),r.yaxis.map((function(t,e){-1===s.ignoreYAxisIndexes.indexOf(e)&&(a=n.drawYaxis(e),s.dom.Paper.add(a))}))))}}]),t}(),tt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawXCrosshairs",value:function(){var t=this.w,e=new m(this.ctx),i=new v(this.ctx),a=t.config.xaxis.crosshairs.fill.gradient,s=t.config.xaxis.crosshairs.dropShadow,r=t.config.xaxis.crosshairs.fill.type,o=a.colorFrom,n=a.colorTo,l=a.opacityFrom,h=a.opacityTo,c=a.stops,d=s.enabled,g=s.left,u=s.top,p=s.blur,f=s.color,b=s.opacity,y=t.config.xaxis.crosshairs.fill.color;if(t.config.xaxis.crosshairs.show){"gradient"===r&&(y=e.drawGradient("vertical",o,n,l,h,null,c,null));var w=e.drawRect();1===t.config.xaxis.crosshairs.width&&(w=e.drawLine());var k=t.globals.gridHeight;(!x.isNumber(k)||k<0)&&(k=0);var A=t.config.xaxis.crosshairs.width;(!x.isNumber(A)||A<0)&&(A=0),w.attr({class:"apexcharts-xcrosshairs",x:0,y:0,y2:k,width:A,height:k,fill:y,filter:"none","fill-opacity":t.config.xaxis.crosshairs.opacity,stroke:t.config.xaxis.crosshairs.stroke.color,"stroke-width":t.config.xaxis.crosshairs.stroke.width,"stroke-dasharray":t.config.xaxis.crosshairs.stroke.dashArray}),d&&(w=i.dropShadow(w,{left:g,top:u,blur:p,color:f,opacity:b})),t.globals.dom.elGraphical.add(w)}}},{key:"drawYCrosshairs",value:function(){var t=this.w,e=new m(this.ctx),i=t.config.yaxis[0].crosshairs,a=t.globals.barPadForNumericAxis;if(t.config.yaxis[0].crosshairs.show){var s=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,i.stroke.dashArray,i.stroke.width);s.attr({class:"apexcharts-ycrosshairs"}),t.globals.dom.elGraphical.add(s)}var r=e.drawLine(-a,0,t.globals.gridWidth+a,0,i.stroke.color,0,0);r.attr({class:"apexcharts-ycrosshairs-hidden"}),t.globals.dom.elGraphical.add(r)}}]),t}(),et=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"checkResponsiveConfig",value:function(t){var e=this,i=this.w,a=i.config;if(0!==a.responsive.length){var s=a.responsive.slice();s.sort((function(t,e){return t.breakpoint>e.breakpoint?1:e.breakpoint>t.breakpoint?-1:0})).reverse();var r=new N({}),o=function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},a=s[0].breakpoint,o=window.innerWidth>0?window.innerWidth:screen.width;if(o>a){var n=y.extendArrayProps(r,i.globals.initialConfig,i);t=x.extend(n,t),t=x.extend(i.config,t),e.overrideResponsiveOptions(t)}else for(var l=0;l<s.length;l++)o<s[l].breakpoint&&(t=y.extendArrayProps(r,s[l].options,i),t=x.extend(i.config,t),e.overrideResponsiveOptions(t))};if(t){var n=y.extendArrayProps(r,t,i);n=x.extend(i.config,n),o(n=x.extend(n,t))}else o({})}}},{key:"overrideResponsiveOptions",value:function(t){var e=new N(t).init({responsiveOverride:!0});this.w.config=e}}]),t}(),it=function(){function t(e){a(this,t),this.ctx=e,this.colors=[],this.w=e.w;var i=this.w;this.isColorFn=!1,this.isHeatmapDistributed="treemap"===i.config.chart.type&&i.config.plotOptions.treemap.distributed||"heatmap"===i.config.chart.type&&i.config.plotOptions.heatmap.distributed,this.isBarDistributed=i.config.plotOptions.bar.distributed&&("bar"===i.config.chart.type||"rangeBar"===i.config.chart.type)}return r(t,[{key:"init",value:function(){this.setDefaultColors()}},{key:"setDefaultColors",value:function(){var t=this,e=this.w,i=new x;if(e.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(e.config.theme.mode)),void 0===e.config.colors?e.globals.colors=this.predefined():(e.globals.colors=e.config.colors,Array.isArray(e.config.colors)&&e.config.colors.length>0&&"function"==typeof e.config.colors[0]&&(e.globals.colors=e.config.series.map((function(i,a){var s=e.config.colors[a];return s||(s=e.config.colors[0]),"function"==typeof s?(t.isColorFn=!0,s({value:e.globals.axisCharts?e.globals.series[a][0]?e.globals.series[a][0]:0:e.globals.series[a],seriesIndex:a,dataPointIndex:a,w:e})):s})))),e.globals.seriesColors.map((function(t,i){t&&(e.globals.colors[i]=t)})),e.config.theme.monochrome.enabled){var a=[],s=e.globals.series.length;(this.isBarDistributed||this.isHeatmapDistributed)&&(s=e.globals.series[0].length*e.globals.series.length);for(var r=e.config.theme.monochrome.color,o=1/(s/e.config.theme.monochrome.shadeIntensity),n=e.config.theme.monochrome.shadeTo,l=0,h=0;h<s;h++){var c=void 0;"dark"===n?(c=i.shadeColor(-1*l,r),l+=o):(c=i.shadeColor(l,r),l+=o),a.push(c)}e.globals.colors=a.slice()}var d=e.globals.colors.slice();this.pushExtraColors(e.globals.colors);["fill","stroke"].forEach((function(i){void 0===e.config[i].colors?e.globals[i].colors=t.isColorFn?e.config.colors:d:e.globals[i].colors=e.config[i].colors.slice(),t.pushExtraColors(e.globals[i].colors)})),void 0===e.config.dataLabels.style.colors?e.globals.dataLabels.style.colors=d:e.globals.dataLabels.style.colors=e.config.dataLabels.style.colors.slice(),this.pushExtraColors(e.globals.dataLabels.style.colors,50),void 0===e.config.plotOptions.radar.polygons.fill.colors?e.globals.radarPolygons.fill.colors=["dark"===e.config.theme.mode?"#424242":"none"]:e.globals.radarPolygons.fill.colors=e.config.plotOptions.radar.polygons.fill.colors.slice(),this.pushExtraColors(e.globals.radarPolygons.fill.colors,20),void 0===e.config.markers.colors?e.globals.markers.colors=d:e.globals.markers.colors=e.config.markers.colors.slice(),this.pushExtraColors(e.globals.markers.colors)}},{key:"pushExtraColors",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=e||a.globals.series.length;if(null===i&&(i=this.isBarDistributed||this.isHeatmapDistributed||"heatmap"===a.config.chart.type&&a.config.plotOptions.heatmap.colorScale.inverse),i&&a.globals.series.length&&(s=a.globals.series[a.globals.maxValsInArrayIndex].length*a.globals.series.length),t.length<s)for(var r=s-t.length,o=0;o<r;o++)t.push(t[o])}},{key:"updateThemeOptions",value:function(t){t.chart=t.chart||{},t.tooltip=t.tooltip||{};var e=t.theme.mode||"light",i=t.theme.palette?t.theme.palette:"dark"===e?"palette4":"palette1",a=t.chart.foreColor?t.chart.foreColor:"dark"===e?"#f6f7f8":"#373d3f";return t.tooltip.theme=e,t.chart.foreColor=a,t.theme.palette=i,t}},{key:"predefined",value:function(){switch(this.w.config.theme.palette){case"palette1":this.colors=["#008FFB","#00E396","#FEB019","#FF4560","#775DD0"];break;case"palette2":this.colors=["#3f51b5","#03a9f4","#4caf50","#f9ce1d","#FF9800"];break;case"palette3":this.colors=["#33b2df","#546E7A","#d4526e","#13d8aa","#A5978B"];break;case"palette4":this.colors=["#4ecdc4","#c7f464","#81D4FA","#fd6a6a","#546E7A"];break;case"palette5":this.colors=["#2b908f","#f9a3a4","#90ee7e","#fa4443","#69d2e7"];break;case"palette6":this.colors=["#449DD1","#F86624","#EA3546","#662E9B","#C5D86D"];break;case"palette7":this.colors=["#D7263D","#1B998B","#2E294E","#F46036","#E2C044"];break;case"palette8":this.colors=["#662E9B","#F86624","#F9C80E","#EA3546","#43BCCD"];break;case"palette9":this.colors=["#5C4742","#A5978B","#8D5B4C","#5A2A27","#C4BBAF"];break;case"palette10":this.colors=["#A300D6","#7D02EB","#5653FE","#2983FF","#00B1F2"];break;default:this.colors=["#008FFB","#00E396","#FEB019","#FF4560","#775DD0"]}return this.colors}}]),t}(),at=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"draw",value:function(){this.drawTitleSubtitle("title"),this.drawTitleSubtitle("subtitle")}},{key:"drawTitleSubtitle",value:function(t){var e=this.w,i="title"===t?e.config.title:e.config.subtitle,a=e.globals.svgWidth/2,s=i.offsetY,r="middle";if("left"===i.align?(a=10,r="start"):"right"===i.align&&(a=e.globals.svgWidth-10,r="end"),a+=i.offsetX,s=s+parseInt(i.style.fontSize,10)+i.margin/2,void 0!==i.text){var o=new m(this.ctx).drawText({x:a,y:s,text:i.text,textAnchor:r,fontSize:i.style.fontSize,fontFamily:i.style.fontFamily,fontWeight:i.style.fontWeight,foreColor:i.style.color,opacity:1});o.node.setAttribute("class","apexcharts-".concat(t,"-text")),e.globals.dom.Paper.add(o)}}}]),t}(),st=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getTitleSubtitleCoords",value:function(t){var e=this.w,i=0,a=0,s="title"===t?e.config.title.floating:e.config.subtitle.floating,r=e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t,"-text"));if(null!==r&&!s){var o=r.getBoundingClientRect();i=o.width,a=e.globals.axisCharts?o.height+5:o.height}return{width:i,height:a}}},{key:"getLegendsRect",value:function(){var t=this.w,e=t.globals.dom.baseEl.querySelector(".apexcharts-legend");t.config.legend.height||"top"!==t.config.legend.position&&"bottom"!==t.config.legend.position||(e.style.maxHeight=t.globals.svgHeight/2+"px");var i=Object.assign({},x.getBoundingClientRect(e));return null!==e&&!t.config.legend.floating&&t.config.legend.show?this.dCtx.lgRect={x:i.x,y:i.y,height:i.height,width:0===i.height?0:i.width}:this.dCtx.lgRect={x:0,y:0,height:0,width:0},"left"!==t.config.legend.position&&"right"!==t.config.legend.position||1.5*this.dCtx.lgRect.width>t.globals.svgWidth&&(this.dCtx.lgRect.width=t.globals.svgWidth/1.5),this.dCtx.lgRect}},{key:"getLargestStringFromMultiArr",value:function(t,e){var i=t;if(this.w.globals.isMultiLineX){var a=e.map((function(t,e){return Array.isArray(t)?t.length:1})),s=Math.max.apply(Math,u(a));i=e[a.indexOf(s)]}return i}}]),t}(),rt=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getxAxisLabelsCoords",value:function(){var t,e=this.w,i=e.globals.labels.slice();if(e.config.xaxis.convertedCatToNumeric&&0===i.length&&(i=e.globals.categoryLabels),e.globals.timescaleLabels.length>0){var a=this.getxAxisTimeScaleLabelsCoords();t={width:a.width,height:a.height},e.globals.rotateXLabels=!1}else{this.dCtx.lgWidthForSideLegends="left"!==e.config.legend.position&&"right"!==e.config.legend.position||e.config.legend.floating?0:this.dCtx.lgRect.width;var s=e.globals.xLabelFormatter,r=x.getLargestStringFromArr(i),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,i);e.globals.isBarHorizontal&&(o=r=e.globals.yAxisScale[0].result.reduce((function(t,e){return t.length>e.length?t:e}),0));var n=new V(this.dCtx.ctx),l=r;r=n.xLabelFormat(s,r,l,{i:void 0,dateFormatter:new R(this.dCtx.ctx).formatDate,w:e}),o=n.xLabelFormat(s,o,l,{i:void 0,dateFormatter:new R(this.dCtx.ctx).formatDate,w:e}),(e.config.xaxis.convertedCatToNumeric&&void 0===r||""===String(r).trim())&&(o=r="1");var h=new m(this.dCtx.ctx),c=h.getTextRects(r,e.config.xaxis.labels.style.fontSize),d=c;if(r!==o&&(d=h.getTextRects(o,e.config.xaxis.labels.style.fontSize)),(t={width:c.width>=d.width?c.width:d.width,height:c.height>=d.height?c.height:d.height}).width*i.length>e.globals.svgWidth-this.dCtx.lgWidthForSideLegends-this.dCtx.yAxisWidth-this.dCtx.gridPad.left-this.dCtx.gridPad.right&&0!==e.config.xaxis.labels.rotate||e.config.xaxis.labels.rotateAlways){if(!e.globals.isBarHorizontal){e.globals.rotateXLabels=!0;var g=function(t){return h.getTextRects(t,e.config.xaxis.labels.style.fontSize,e.config.xaxis.labels.style.fontFamily,"rotate(".concat(e.config.xaxis.labels.rotate," 0 0)"),!1)};c=g(r),r!==o&&(d=g(o)),t.height=(c.height>d.height?c.height:d.height)/1.5,t.width=c.width>d.width?c.width:d.width}}else e.globals.rotateXLabels=!1}return e.config.xaxis.labels.show||(t={width:0,height:0}),{width:t.width,height:t.height}}},{key:"getxAxisGroupLabelsCoords",value:function(){var t,e=this.w;if(!e.globals.hasGroups)return{width:0,height:0};var i,a=(null===(t=e.config.xaxis.group.style)||void 0===t?void 0:t.fontSize)||e.config.xaxis.labels.style.fontSize,s=e.globals.groups.map((function(t){return t.title})),r=x.getLargestStringFromArr(s),o=this.dCtx.dimHelpers.getLargestStringFromMultiArr(r,s),n=new m(this.dCtx.ctx),l=n.getTextRects(r,a),h=l;return r!==o&&(h=n.getTextRects(o,a)),i={width:l.width>=h.width?l.width:h.width,height:l.height>=h.height?l.height:h.height},e.config.xaxis.labels.show||(i={width:0,height:0}),{width:i.width,height:i.height}}},{key:"getxAxisTitleCoords",value:function(){var t=this.w,e=0,i=0;if(void 0!==t.config.xaxis.title.text){var a=new m(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text,t.config.xaxis.title.style.fontSize);e=a.width,i=a.height}return{width:e,height:i}}},{key:"getxAxisTimeScaleLabelsCoords",value:function(){var t,e=this.w;this.dCtx.timescaleLabels=e.globals.timescaleLabels.slice();var i=this.dCtx.timescaleLabels.map((function(t){return t.value})),a=i.reduce((function(t,e){return void 0===t?(console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"),0):t.length>e.length?t:e}),0);return 1.05*(t=new m(this.dCtx.ctx).getTextRects(a,e.config.xaxis.labels.style.fontSize)).width*i.length>e.globals.gridWidth&&0!==e.config.xaxis.labels.rotate&&(e.globals.overlappingXLabels=!0),t}},{key:"additionalPaddingXLabels",value:function(t){var e=this,i=this.w,a=i.globals,s=i.config,r=s.xaxis.type,o=t.width;a.skipLastTimelinelabel=!1,a.skipFirstTimelinelabel=!1;var n=i.config.yaxis[0].opposite&&i.globals.isBarHorizontal,l=function(t,n){(function(t){return-1!==a.collapsedSeriesIndices.indexOf(t)})(n)||function(t){if(e.dCtx.timescaleLabels&&e.dCtx.timescaleLabels.length){var n=e.dCtx.timescaleLabels[0],l=e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length-1].position+o/1.75-e.dCtx.yAxisWidthRight,h=n.position-o/1.75+e.dCtx.yAxisWidthLeft,c="right"===i.config.legend.position&&e.dCtx.lgRect.width>0?e.dCtx.lgRect.width:0;l>a.svgWidth-a.translateX-c&&(a.skipLastTimelinelabel=!0),h<-(t.show&&!t.floating||"bar"!==s.chart.type&&"candlestick"!==s.chart.type&&"rangeBar"!==s.chart.type&&"boxPlot"!==s.chart.type?10:o/1.75)&&(a.skipFirstTimelinelabel=!0)}else"datetime"===r?e.dCtx.gridPad.right<o&&!a.rotateXLabels&&(a.skipLastTimelinelabel=!0):"datetime"!==r&&e.dCtx.gridPad.right<o/2-e.dCtx.yAxisWidthRight&&!a.rotateXLabels&&!i.config.xaxis.labels.trim&&("between"!==i.config.xaxis.tickPlacement||i.globals.isBarHorizontal)&&(e.dCtx.xPadRight=o/2+1)}(t)};s.yaxis.forEach((function(t,i){n?(e.dCtx.gridPad.left<o&&(e.dCtx.xPadLeft=o/2+1),e.dCtx.xPadRight=o/2+1):l(t,i)}))}}]),t}(),ot=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"getyAxisLabelsCoords",value:function(){var t=this,e=this.w,i=[],a=10,s=new G(this.dCtx.ctx);return e.config.yaxis.map((function(r,o){var n=e.globals.yAxisScale[o],l=0;if(!s.isYAxisHidden(o)&&r.labels.show&&void 0!==r.labels.minWidth&&(l=r.labels.minWidth),!s.isYAxisHidden(o)&&r.labels.show&&n.result.length){var h=e.globals.yLabelFormatters[o],c=n.niceMin===Number.MIN_VALUE?0:n.niceMin,d=String(c).length>String(n.niceMax).length?c:n.niceMax,g=h(d,{seriesIndex:o,dataPointIndex:-1,w:e}),u=g;if(void 0!==g&&0!==g.length||(g=d),e.globals.isBarHorizontal){a=0;var p=e.globals.labels.slice();g=h(g=x.getLargestStringFromArr(p),{seriesIndex:o,dataPointIndex:-1,w:e}),u=t.dCtx.dimHelpers.getLargestStringFromMultiArr(g,p)}var f=new m(t.dCtx.ctx),b="rotate(".concat(r.labels.rotate," 0 0)"),v=f.getTextRects(g,r.labels.style.fontSize,r.labels.style.fontFamily,b,!1),y=v;g!==u&&(y=f.getTextRects(u,r.labels.style.fontSize,r.labels.style.fontFamily,b,!1)),i.push({width:(l>y.width||l>v.width?l:y.width>v.width?y.width:v.width)+a,height:y.height>v.height?y.height:v.height})}else i.push({width:0,height:0})})),i}},{key:"getyAxisTitleCoords",value:function(){var t=this,e=this.w,i=[];return e.config.yaxis.map((function(e,a){if(e.show&&void 0!==e.title.text){var s=new m(t.dCtx.ctx),r="rotate(".concat(e.title.rotate," 0 0)"),o=s.getTextRects(e.title.text,e.title.style.fontSize,e.title.style.fontFamily,r,!1);i.push({width:o.width,height:o.height})}else i.push({width:0,height:0})})),i}},{key:"getTotalYAxisWidth",value:function(){var t=this.w,e=0,i=0,a=0,s=t.globals.yAxisScale.length>1?10:0,r=new G(this.dCtx.ctx),o=function(o,n){var l=t.config.yaxis[n].floating,h=0;o.width>0&&!l?(h=o.width+s,function(e){return t.globals.ignoreYAxisIndexes.indexOf(e)>-1}(n)&&(h=h-o.width-s)):h=l||r.isYAxisHidden(n)?0:5,t.config.yaxis[n].opposite?a+=h:i+=h,e+=h};return t.globals.yLabelsCoords.map((function(t,e){o(t,e)})),t.globals.yTitleCoords.map((function(t,e){o(t,e)})),t.globals.isBarHorizontal&&!t.config.yaxis[0].floating&&(e=t.globals.yLabelsCoords[0].width+t.globals.yTitleCoords[0].width+15),this.dCtx.yAxisWidthLeft=i,this.dCtx.yAxisWidthRight=a,e}}]),t}(),nt=function(){function t(e){a(this,t),this.w=e.w,this.dCtx=e}return r(t,[{key:"gridPadForColumnsInNumericAxis",value:function(t){var e=this.w;if(e.globals.noData||e.globals.allSeriesCollapsed)return 0;var i=function(t){return"bar"===t||"rangeBar"===t||"candlestick"===t||"boxPlot"===t},a=e.config.chart.type,s=0,r=i(a)?e.config.series.length:1;if(e.globals.comboBarCount>0&&(r=e.globals.comboBarCount),e.globals.collapsedSeries.forEach((function(t){i(t.type)&&(r-=1)})),e.config.chart.stacked&&(r=1),(i(a)||e.globals.comboBarCount>0)&&e.globals.isXNumeric&&!e.globals.isBarHorizontal&&r>0){var o,n,l=Math.abs(e.globals.initialMaxX-e.globals.initialMinX);l<=3&&(l=e.globals.dataPoints),o=l/t,e.globals.minXDiff&&e.globals.minXDiff/o>0&&(n=e.globals.minXDiff/o),n>t/2&&(n/=2),(s=n/r*parseInt(e.config.plotOptions.bar.columnWidth,10)/100)<1&&(s=1),s=s/(r>1?1:1.5)+5,e.globals.barPadForNumericAxis=s}return s}},{key:"gridPadFortitleSubtitle",value:function(){var t=this,e=this.w,i=e.globals,a=this.dCtx.isSparkline||!e.globals.axisCharts?0:10;["title","subtitle"].forEach((function(i){void 0!==e.config[i].text?a+=e.config[i].margin:a+=t.dCtx.isSparkline||!e.globals.axisCharts?0:5})),!e.config.legend.show||"bottom"!==e.config.legend.position||e.config.legend.floating||e.globals.axisCharts||(a+=10);var s=this.dCtx.dimHelpers.getTitleSubtitleCoords("title"),r=this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");i.gridHeight=i.gridHeight-s.height-r.height-a,i.translateY=i.translateY+s.height+r.height+a}},{key:"setGridXPosForDualYAxis",value:function(t,e){var i=this.w,a=new G(this.dCtx.ctx);i.config.yaxis.map((function(s,r){-1!==i.globals.ignoreYAxisIndexes.indexOf(r)||s.floating||a.isYAxisHidden(r)||(s.opposite&&(i.globals.translateX=i.globals.translateX-(e[r].width+t[r].width)-parseInt(i.config.yaxis[r].labels.style.fontSize,10)/1.2-12),i.globals.translateX<2&&(i.globals.translateX=2))}))}}]),t}(),lt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.lgRect={},this.yAxisWidth=0,this.yAxisWidthLeft=0,this.yAxisWidthRight=0,this.xAxisHeight=0,this.isSparkline=this.w.config.chart.sparkline.enabled,this.dimHelpers=new st(this),this.dimYAxis=new ot(this),this.dimXAxis=new rt(this),this.dimGrid=new nt(this),this.lgWidthForSideLegends=0,this.gridPad=this.w.config.grid.padding,this.xPadRight=0,this.xPadLeft=0}return r(t,[{key:"plotCoords",value:function(){var t=this,e=this.w,i=e.globals;this.lgRect=this.dimHelpers.getLegendsRect(),this.isSparkline&&(e.config.markers.discrete.length>0||e.config.markers.size>0)&&Object.entries(this.gridPad).forEach((function(e){var i=g(e,2),a=i[0],s=i[1];t.gridPad[a]=Math.max(s,t.w.globals.markers.largestSize/1.5)})),i.axisCharts?this.setDimensionsForAxisCharts():this.setDimensionsForNonAxisCharts(),this.dimGrid.gridPadFortitleSubtitle(),i.gridHeight=i.gridHeight-this.gridPad.top-this.gridPad.bottom,i.gridWidth=i.gridWidth-this.gridPad.left-this.gridPad.right-this.xPadRight-this.xPadLeft;var a=this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);i.gridWidth=i.gridWidth-2*a,i.translateX=i.translateX+this.gridPad.left+this.xPadLeft+(a>0?a+4:0),i.translateY=i.translateY+this.gridPad.top}},{key:"setDimensionsForAxisCharts",value:function(){var t=this,e=this.w,i=e.globals,a=this.dimYAxis.getyAxisLabelsCoords(),s=this.dimYAxis.getyAxisTitleCoords();e.globals.yLabelsCoords=[],e.globals.yTitleCoords=[],e.config.yaxis.map((function(t,i){e.globals.yLabelsCoords.push({width:a[i].width,index:i}),e.globals.yTitleCoords.push({width:s[i].width,index:i})})),this.yAxisWidth=this.dimYAxis.getTotalYAxisWidth();var r=this.dimXAxis.getxAxisLabelsCoords(),o=this.dimXAxis.getxAxisGroupLabelsCoords(),n=this.dimXAxis.getxAxisTitleCoords();this.conditionalChecksForAxisCoords(r,n,o),i.translateXAxisY=e.globals.rotateXLabels?this.xAxisHeight/8:-4,i.translateXAxisX=e.globals.rotateXLabels&&e.globals.isXNumeric&&e.config.xaxis.labels.rotate<=-45?-this.xAxisWidth/4:0,e.globals.isBarHorizontal&&(i.rotateXLabels=!1,i.translateXAxisY=parseInt(e.config.xaxis.labels.style.fontSize,10)/1.5*-1),i.translateXAxisY=i.translateXAxisY+e.config.xaxis.labels.offsetY,i.translateXAxisX=i.translateXAxisX+e.config.xaxis.labels.offsetX;var l=this.yAxisWidth,h=this.xAxisHeight;i.xAxisLabelsHeight=this.xAxisHeight-n.height,i.xAxisGroupLabelsHeight=i.xAxisLabelsHeight-r.height,i.xAxisLabelsWidth=this.xAxisWidth,i.xAxisHeight=this.xAxisHeight;var c=10;("radar"===e.config.chart.type||this.isSparkline)&&(l=0,h=i.goldenPadding),this.isSparkline&&(this.lgRect={height:0,width:0}),(this.isSparkline||"treemap"===e.config.chart.type)&&(l=0,h=0,c=0),this.isSparkline||this.dimXAxis.additionalPaddingXLabels(r);var d=function(){i.translateX=l,i.gridHeight=i.svgHeight-t.lgRect.height-h-(t.isSparkline||"treemap"===e.config.chart.type?0:e.globals.rotateXLabels?10:15),i.gridWidth=i.svgWidth-l};switch("top"===e.config.xaxis.position&&(c=i.xAxisHeight-e.config.xaxis.axisTicks.height-5),e.config.legend.position){case"bottom":i.translateY=c,d();break;case"top":i.translateY=this.lgRect.height+c,d();break;case"left":i.translateY=c,i.translateX=this.lgRect.width+l,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l;break;case"right":i.translateY=c,i.translateX=l,i.gridHeight=i.svgHeight-h-12,i.gridWidth=i.svgWidth-this.lgRect.width-l-5;break;default:throw new Error("Legend position not supported")}this.dimGrid.setGridXPosForDualYAxis(s,a),new $(this.ctx).setYAxisXPosition(a,s)}},{key:"setDimensionsForNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=t.config,a=0;t.config.legend.show&&!t.config.legend.floating&&(a=20);var s="pie"===i.chart.type||"polarArea"===i.chart.type||"donut"===i.chart.type?"pie":"radialBar",r=i.plotOptions[s].offsetY,o=i.plotOptions[s].offsetX;if(!i.legend.show||i.legend.floating)return e.gridHeight=e.svgHeight-i.grid.padding.left+i.grid.padding.right,e.gridWidth=e.gridHeight,e.translateY=r,void(e.translateX=o+(e.svgWidth-e.gridWidth)/2);switch(i.legend.position){case"bottom":e.gridHeight=e.svgHeight-this.lgRect.height-e.goldenPadding,e.gridWidth=e.svgWidth,e.translateY=r-10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"top":e.gridHeight=e.svgHeight-this.lgRect.height-e.goldenPadding,e.gridWidth=e.svgWidth,e.translateY=this.lgRect.height+r+10,e.translateX=o+(e.svgWidth-e.gridWidth)/2;break;case"left":e.gridWidth=e.svgWidth-this.lgRect.width-a,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+this.lgRect.width+a;break;case"right":e.gridWidth=e.svgWidth-this.lgRect.width-a-5,e.gridHeight="auto"!==i.chart.height?e.svgHeight:e.gridWidth,e.translateY=r,e.translateX=o+10;break;default:throw new Error("Legend position not supported")}}},{key:"conditionalChecksForAxisCoords",value:function(t,e,i){var a=this.w,s=a.globals.hasGroups?2:1,r=i.height+t.height+e.height,o=a.globals.isMultiLineX?1.2:a.globals.LINE_HEIGHT_RATIO,n=a.globals.rotateXLabels?22:10,l=a.globals.rotateXLabels&&"bottom"===a.config.legend.position?10:0;this.xAxisHeight=r*o+s*n+l,this.xAxisWidth=t.width,this.xAxisHeight-e.height>a.config.xaxis.labels.maxHeight&&(this.xAxisHeight=a.config.xaxis.labels.maxHeight),a.config.xaxis.labels.minHeight&&this.xAxisHeight<a.config.xaxis.labels.minHeight&&(this.xAxisHeight=a.config.xaxis.labels.minHeight),a.config.xaxis.floating&&(this.xAxisHeight=0);var h=0,c=0;a.config.yaxis.forEach((function(t){h+=t.labels.minWidth,c+=t.labels.maxWidth})),this.yAxisWidth<h&&(this.yAxisWidth=h),this.yAxisWidth>c&&(this.yAxisWidth=c)}}]),t}(),ht=function(){function t(e){a(this,t),this.w=e.w,this.lgCtx=e}return r(t,[{key:"getLegendStyles",value:function(){var t=document.createElement("style");t.setAttribute("type","text/css");var e=document.createTextNode("\t\n    \t\n      .apexcharts-legend {\t\n        display: flex;\t\n        overflow: auto;\t\n        padding: 0 10px;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\t\n        flex-wrap: wrap\t\n      }\t\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        flex-direction: column;\t\n        bottom: 0;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\t\n        justify-content: flex-start;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\t\n        justify-content: center;  \t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\t\n        justify-content: flex-end;\t\n      }\t\n      .apexcharts-legend-series {\t\n        cursor: pointer;\t\n        line-height: normal;\t\n      }\t\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{\t\n        display: flex;\t\n        align-items: center;\t\n      }\t\n      .apexcharts-legend-text {\t\n        position: relative;\t\n        font-size: 14px;\t\n      }\t\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\t\n        pointer-events: none;\t\n      }\t\n      .apexcharts-legend-marker {\t\n        position: relative;\t\n        display: inline-block;\t\n        cursor: pointer;\t\n        margin-right: 3px;\t\n        border-style: solid;\n      }\t\n      \t\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{\t\n        display: inline-block;\t\n      }\t\n      .apexcharts-legend-series.apexcharts-no-click {\t\n        cursor: auto;\t\n      }\t\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\t\n        display: none !important;\t\n      }\t\n      .apexcharts-inactive-legend {\t\n        opacity: 0.45;\t\n      }");return t.appendChild(e),t}},{key:"getLegendBBox",value:function(){var t=this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(),e=t.width;return{clwh:t.height,clww:e}}},{key:"appendToForeignObject",value:function(){var t=this.w.globals;t.dom.elLegendForeign=document.createElementNS(t.SVGNS,"foreignObject");var e=t.dom.elLegendForeign;e.setAttribute("x",0),e.setAttribute("y",0),e.setAttribute("width",t.svgWidth),e.setAttribute("height",t.svgHeight),t.dom.elLegendWrap.setAttribute("xmlns","http://www.w3.org/1999/xhtml"),e.appendChild(t.dom.elLegendWrap),e.appendChild(this.getLegendStyles()),t.dom.Paper.node.insertBefore(e,t.dom.elGraphical.node)}},{key:"toggleDataSeries",value:function(t,e){var i=this,a=this.w;if(a.globals.axisCharts||"radialBar"===a.config.chart.type){a.globals.resized=!0;var s=null,r=null;if(a.globals.risingSeries=[],a.globals.axisCharts?(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t,"']")),r=parseInt(s.getAttribute("data:realIndex"),10)):(s=a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t+1,"']")),r=parseInt(s.getAttribute("rel"),10)-1),e)[{cs:a.globals.collapsedSeries,csi:a.globals.collapsedSeriesIndices},{cs:a.globals.ancillaryCollapsedSeries,csi:a.globals.ancillaryCollapsedSeriesIndices}].forEach((function(t){i.riseCollapsedSeries(t.cs,t.csi,r)}));else this.hideSeries({seriesEl:s,realIndex:r})}else{var o=a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t+1,"'] path")),n=a.config.chart.type;if("pie"===n||"polarArea"===n||"donut"===n){var l=a.config.plotOptions.pie.donut.labels;new m(this.lgCtx.ctx).pathMouseDown(o.members[0],null),this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node,l)}o.fire("click")}}},{key:"hideSeries",value:function(t){var e=t.seriesEl,i=t.realIndex,a=this.w,s=x.clone(a.config.series);if(a.globals.axisCharts){var r=!1;if(a.config.yaxis[i]&&a.config.yaxis[i].show&&a.config.yaxis[i].showAlways&&(r=!0,a.globals.ancillaryCollapsedSeriesIndices.indexOf(i)<0&&(a.globals.ancillaryCollapsedSeries.push({index:i,data:s[i].data.slice(),type:e.parentNode.className.baseVal.split("-")[1]}),a.globals.ancillaryCollapsedSeriesIndices.push(i))),!r){a.globals.collapsedSeries.push({index:i,data:s[i].data.slice(),type:e.parentNode.className.baseVal.split("-")[1]}),a.globals.collapsedSeriesIndices.push(i);var o=a.globals.risingSeries.indexOf(i);a.globals.risingSeries.splice(o,1)}}else a.globals.collapsedSeries.push({index:i,data:s[i]}),a.globals.collapsedSeriesIndices.push(i);for(var n=e.childNodes,l=0;l<n.length;l++)n[l].classList.contains("apexcharts-series-markers-wrap")&&(n[l].classList.contains("apexcharts-hide")?n[l].classList.remove("apexcharts-hide"):n[l].classList.add("apexcharts-hide"));a.globals.allSeriesCollapsed=a.globals.collapsedSeries.length===a.config.series.length,s=this._getSeriesBasedOnCollapsedState(s),this.lgCtx.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled)}},{key:"riseCollapsedSeries",value:function(t,e,i){var a=this.w,s=x.clone(a.config.series);if(t.length>0){for(var r=0;r<t.length;r++)t[r].index===i&&(a.globals.axisCharts?(s[i].data=t[r].data.slice(),t.splice(r,1),e.splice(r,1),a.globals.risingSeries.push(i)):(s[i]=t[r].data,t.splice(r,1),e.splice(r,1),a.globals.risingSeries.push(i)));s=this._getSeriesBasedOnCollapsedState(s),this.lgCtx.ctx.updateHelpers._updateSeries(s,a.config.chart.animations.dynamicAnimation.enabled)}}},{key:"_getSeriesBasedOnCollapsedState",value:function(t){var e=this.w;return e.globals.axisCharts?t.forEach((function(i,a){e.globals.collapsedSeriesIndices.indexOf(a)>-1&&(t[a].data=[])})):t.forEach((function(i,a){e.globals.collapsedSeriesIndices.indexOf(a)>-1&&(t[a]=0)})),t}}]),t}(),ct=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w,this.onLegendClick=this.onLegendClick.bind(this),this.onLegendHovered=this.onLegendHovered.bind(this),this.isBarsDistributed="bar"===this.w.config.chart.type&&this.w.config.plotOptions.bar.distributed&&1===this.w.config.series.length,this.legendHelpers=new ht(this)}return r(t,[{key:"init",value:function(){var t=this.w,e=t.globals,i=t.config;if((i.legend.showForSingleSeries&&1===e.series.length||this.isBarsDistributed||e.series.length>1||!e.axisCharts)&&i.legend.show){for(;e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);this.drawLegends(),x.isIE11()?document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()):this.legendHelpers.appendToForeignObject(),"bottom"===i.legend.position||"top"===i.legend.position?this.legendAlignHorizontal():"right"!==i.legend.position&&"left"!==i.legend.position||this.legendAlignVertical()}}},{key:"drawLegends",value:function(){var t=this,e=this.w,i=e.config.legend.fontFamily,a=e.globals.seriesNames,s=e.globals.colors.slice();if("heatmap"===e.config.chart.type){var r=e.config.plotOptions.heatmap.colorScale.ranges;a=r.map((function(t){return t.name?t.name:t.from+" - "+t.to})),s=r.map((function(t){return t.color}))}else this.isBarsDistributed&&(a=e.globals.labels.slice());e.config.legend.customLegendItems.length&&(a=e.config.legend.customLegendItems);for(var o=e.globals.legendFormatter,n=e.config.legend.inverseOrder,l=n?a.length-1:0;n?l>=0:l<=a.length-1;n?l--:l++){var h=o(a[l],{seriesIndex:l,w:e}),c=!1,d=!1;if(e.globals.collapsedSeries.length>0)for(var g=0;g<e.globals.collapsedSeries.length;g++)e.globals.collapsedSeries[g].index===l&&(c=!0);if(e.globals.ancillaryCollapsedSeriesIndices.length>0)for(var u=0;u<e.globals.ancillaryCollapsedSeriesIndices.length;u++)e.globals.ancillaryCollapsedSeriesIndices[u]===l&&(d=!0);var p=document.createElement("span");p.classList.add("apexcharts-legend-marker");var f=e.config.legend.markers.offsetX,b=e.config.legend.markers.offsetY,v=e.config.legend.markers.height,w=e.config.legend.markers.width,k=e.config.legend.markers.strokeWidth,A=e.config.legend.markers.strokeColor,S=e.config.legend.markers.radius,C=p.style;C.background=s[l],C.color=s[l],C.setProperty("background",s[l],"important"),e.config.legend.markers.fillColors&&e.config.legend.markers.fillColors[l]&&(C.background=e.config.legend.markers.fillColors[l]),void 0!==e.globals.seriesColors[l]&&(C.background=e.globals.seriesColors[l],C.color=e.globals.seriesColors[l]),C.height=Array.isArray(v)?parseFloat(v[l])+"px":parseFloat(v)+"px",C.width=Array.isArray(w)?parseFloat(w[l])+"px":parseFloat(w)+"px",C.left=(Array.isArray(f)?parseFloat(f[l]):parseFloat(f))+"px",C.top=(Array.isArray(b)?parseFloat(b[l]):parseFloat(b))+"px",C.borderWidth=Array.isArray(k)?k[l]:k,C.borderColor=Array.isArray(A)?A[l]:A,C.borderRadius=Array.isArray(S)?parseFloat(S[l])+"px":parseFloat(S)+"px",e.config.legend.markers.customHTML&&(Array.isArray(e.config.legend.markers.customHTML)?e.config.legend.markers.customHTML[l]&&(p.innerHTML=e.config.legend.markers.customHTML[l]()):p.innerHTML=e.config.legend.markers.customHTML()),m.setAttrs(p,{rel:l+1,"data:collapsed":c||d}),(c||d)&&p.classList.add("apexcharts-inactive-legend");var L=document.createElement("div"),P=document.createElement("span");P.classList.add("apexcharts-legend-text"),P.innerHTML=Array.isArray(h)?h.join(" "):h;var M=e.config.legend.labels.useSeriesColors?e.globals.colors[l]:e.config.legend.labels.colors;M||(M=e.config.chart.foreColor),P.style.color=M,P.style.fontSize=parseFloat(e.config.legend.fontSize)+"px",P.style.fontWeight=e.config.legend.fontWeight,P.style.fontFamily=i||e.config.chart.fontFamily,m.setAttrs(P,{rel:l+1,i:l,"data:default-text":encodeURIComponent(h),"data:collapsed":c||d}),L.appendChild(p),L.appendChild(P);var T=new y(this.ctx);if(!e.config.legend.showForZeroSeries)0===T.getSeriesTotalByIndex(l)&&T.seriesHaveSameValues(l)&&!T.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&L.classList.add("apexcharts-hidden-zero-series");e.config.legend.showForNullSeries||T.isSeriesNull(l)&&-1===e.globals.collapsedSeriesIndices.indexOf(l)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(l)&&L.classList.add("apexcharts-hidden-null-series"),e.globals.dom.elLegendWrap.appendChild(L),e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)),e.globals.dom.elLegendWrap.classList.add("apx-legend-position-"+e.config.legend.position),L.classList.add("apexcharts-legend-series"),L.style.margin="".concat(e.config.legend.itemMargin.vertical,"px ").concat(e.config.legend.itemMargin.horizontal,"px"),e.globals.dom.elLegendWrap.style.width=e.config.legend.width?e.config.legend.width+"px":"",e.globals.dom.elLegendWrap.style.height=e.config.legend.height?e.config.legend.height+"px":"",m.setAttrs(L,{rel:l+1,seriesName:x.escapeString(a[l]),"data:collapsed":c||d}),(c||d)&&L.classList.add("apexcharts-inactive-legend"),e.config.legend.onItemClick.toggleDataSeries||L.classList.add("apexcharts-no-click")}e.globals.dom.elWrap.addEventListener("click",t.onLegendClick,!0),e.config.legend.onItemHover.highlightDataSeries&&0===e.config.legend.customLegendItems.length&&(e.globals.dom.elWrap.addEventListener("mousemove",t.onLegendHovered,!0),e.globals.dom.elWrap.addEventListener("mouseout",t.onLegendHovered,!0))}},{key:"setLegendWrapXY",value:function(t,e){var i=this.w,a=i.globals.dom.baseEl.querySelector(".apexcharts-legend"),s=a.getBoundingClientRect(),r=0,o=0;if("bottom"===i.config.legend.position)o+=i.globals.svgHeight-s.height/2;else if("top"===i.config.legend.position){var n=new lt(this.ctx),l=n.dimHelpers.getTitleSubtitleCoords("title").height,h=n.dimHelpers.getTitleSubtitleCoords("subtitle").height;o=o+(l>0?l-10:0)+(h>0?h-10:0)}a.style.position="absolute",r=r+t+i.config.legend.offsetX,o=o+e+i.config.legend.offsetY,a.style.left=r+"px",a.style.top=o+"px","bottom"===i.config.legend.position?(a.style.top="auto",a.style.bottom=5-i.config.legend.offsetY+"px"):"right"===i.config.legend.position&&(a.style.left="auto",a.style.right=25+i.config.legend.offsetX+"px");["width","height"].forEach((function(t){a.style[t]&&(a.style[t]=parseInt(i.config.legend[t],10)+"px")}))}},{key:"legendAlignHorizontal",value:function(){var t=this.w;t.globals.dom.baseEl.querySelector(".apexcharts-legend").style.right=0;var e=this.legendHelpers.getLegendBBox(),i=new lt(this.ctx),a=i.dimHelpers.getTitleSubtitleCoords("title"),s=i.dimHelpers.getTitleSubtitleCoords("subtitle"),r=0;"bottom"===t.config.legend.position?r=-e.clwh/1.8:"top"===t.config.legend.position&&(r=a.height+s.height+t.config.title.margin+t.config.subtitle.margin-10),this.setLegendWrapXY(20,r)}},{key:"legendAlignVertical",value:function(){var t=this.w,e=this.legendHelpers.getLegendBBox(),i=0;"left"===t.config.legend.position&&(i=20),"right"===t.config.legend.position&&(i=t.globals.svgWidth-e.clww-10),this.setLegendWrapXY(i,20)}},{key:"onLegendHovered",value:function(t){var e=this.w,i=t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker");if("heatmap"===e.config.chart.type||this.isBarsDistributed){if(i){var a=parseInt(t.target.getAttribute("rel"),10)-1;this.ctx.events.fireEvent("legendHover",[this.ctx,a,this.w]),new E(this.ctx).highlightRangeInSeries(t,t.target)}}else!t.target.classList.contains("apexcharts-inactive-legend")&&i&&new E(this.ctx).toggleSeriesOnHover(t,t.target)}},{key:"onLegendClick",value:function(t){var e=this.w;if(!e.config.legend.customLegendItems.length&&(t.target.classList.contains("apexcharts-legend-text")||t.target.classList.contains("apexcharts-legend-marker"))){var i=parseInt(t.target.getAttribute("rel"),10)-1,a="true"===t.target.getAttribute("data:collapsed"),s=this.w.config.chart.events.legendClick;"function"==typeof s&&s(this.ctx,i,this.w),this.ctx.events.fireEvent("legendClick",[this.ctx,i,this.w]);var r=this.w.config.legend.markers.onClick;"function"==typeof r&&t.target.classList.contains("apexcharts-legend-marker")&&(r(this.ctx,i,this.w),this.ctx.events.fireEvent("legendMarkerClick",[this.ctx,i,this.w])),"treemap"!==e.config.chart.type&&"heatmap"!==e.config.chart.type&&!this.isBarsDistributed&&e.config.legend.onItemClick.toggleDataSeries&&this.legendHelpers.toggleDataSeries(i,a)}}}]),t}(),dt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.ev=this.w.config.chart.events,this.selectedClass="apexcharts-selected",this.localeValues=this.w.globals.locale.toolbar,this.minX=i.globals.minX,this.maxX=i.globals.maxX}return r(t,[{key:"createToolbar",value:function(){var t=this,e=this.w,i=function(){return document.createElement("div")},a=i();if(a.setAttribute("class","apexcharts-toolbar"),a.style.top=e.config.chart.toolbar.offsetY+"px",a.style.right=3-e.config.chart.toolbar.offsetX+"px",e.globals.dom.elWrap.appendChild(a),this.elZoom=i(),this.elZoomIn=i(),this.elZoomOut=i(),this.elPan=i(),this.elSelection=i(),this.elZoomReset=i(),this.elMenuIcon=i(),this.elMenu=i(),this.elCustomIcons=[],this.t=e.config.chart.toolbar.tools,Array.isArray(this.t.customIcons))for(var s=0;s<this.t.customIcons.length;s++)this.elCustomIcons.push(i());var r=[],o=function(i,a,s){var o=i.toLowerCase();t.t[o]&&e.config.chart.zoom.enabled&&r.push({el:a,icon:"string"==typeof t.t[o]?t.t[o]:s,title:t.localeValues[i],class:"apexcharts-".concat(o,"-icon")})};o("zoomIn",this.elZoomIn,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'),o("zoomOut",this.elZoomOut,'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');var n=function(i){t.t[i]&&e.config.chart[i].enabled&&r.push({el:"zoom"===i?t.elZoom:t.elSelection,icon:"string"==typeof t.t[i]?t.t[i]:"zoom"===i?'<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>':'<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',title:t.localeValues["zoom"===i?"selectionZoom":"selection"],class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-".concat(i,"-icon")})};n("zoom"),n("selection"),this.t.pan&&e.config.chart.zoom.enabled&&r.push({el:this.elPan,icon:"string"==typeof this.t.pan?this.t.pan:'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',title:this.localeValues.pan,class:e.globals.isTouchDevice?"apexcharts-element-hidden":"apexcharts-pan-icon"}),o("reset",this.elZoomReset,'<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'),this.t.download&&r.push({el:this.elMenuIcon,icon:"string"==typeof this.t.download?this.t.download:'<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',title:this.localeValues.menu,class:"apexcharts-menu-icon"});for(var l=0;l<this.elCustomIcons.length;l++)r.push({el:this.elCustomIcons[l],icon:this.t.customIcons[l].icon,title:this.t.customIcons[l].title,index:this.t.customIcons[l].index,class:"apexcharts-toolbar-custom-icon "+this.t.customIcons[l].class});r.forEach((function(t,e){t.index&&x.moveIndexInArray(r,e,t.index)}));for(var h=0;h<r.length;h++)m.setAttrs(r[h].el,{class:r[h].class,title:r[h].title}),r[h].el.innerHTML=r[h].icon,a.appendChild(r[h].el);this._createHamburgerMenu(a),e.globals.zoomEnabled?this.elZoom.classList.add(this.selectedClass):e.globals.panEnabled?this.elPan.classList.add(this.selectedClass):e.globals.selectionEnabled&&this.elSelection.classList.add(this.selectedClass),this.addToolbarEventListeners()}},{key:"_createHamburgerMenu",value:function(t){this.elMenuItems=[],t.appendChild(this.elMenu),m.setAttrs(this.elMenu,{class:"apexcharts-menu"});var e=[{name:"exportSVG",title:this.localeValues.exportToSVG},{name:"exportPNG",title:this.localeValues.exportToPNG},{name:"exportCSV",title:this.localeValues.exportToCSV}];this.w.globals.allSeriesHasEqualX||e.splice(2,1);for(var i=0;i<e.length;i++)this.elMenuItems.push(document.createElement("div")),this.elMenuItems[i].innerHTML=e[i].title,m.setAttrs(this.elMenuItems[i],{class:"apexcharts-menu-item ".concat(e[i].name),title:e[i].title}),this.elMenu.appendChild(this.elMenuItems[i])}},{key:"addToolbarEventListeners",value:function(){var t=this;this.elZoomReset.addEventListener("click",this.handleZoomReset.bind(this)),this.elSelection.addEventListener("click",this.toggleZoomSelection.bind(this,"selection")),this.elZoom.addEventListener("click",this.toggleZoomSelection.bind(this,"zoom")),this.elZoomIn.addEventListener("click",this.handleZoomIn.bind(this)),this.elZoomOut.addEventListener("click",this.handleZoomOut.bind(this)),this.elPan.addEventListener("click",this.togglePanning.bind(this)),this.elMenuIcon.addEventListener("click",this.toggleMenu.bind(this)),this.elMenuItems.forEach((function(e){e.classList.contains("exportSVG")?e.addEventListener("click",t.handleDownload.bind(t,"svg")):e.classList.contains("exportPNG")?e.addEventListener("click",t.handleDownload.bind(t,"png")):e.classList.contains("exportCSV")&&e.addEventListener("click",t.handleDownload.bind(t,"csv"))}));for(var e=0;e<this.t.customIcons.length;e++)this.elCustomIcons[e].addEventListener("click",this.t.customIcons[e].click.bind(this,this.ctx,this.ctx.w))}},{key:"toggleZoomSelection",value:function(t){this.ctx.getSyncedCharts().forEach((function(e){e.ctx.toolbar.toggleOtherControls();var i="selection"===t?e.ctx.toolbar.elSelection:e.ctx.toolbar.elZoom,a="selection"===t?"selectionEnabled":"zoomEnabled";e.w.globals[a]=!e.w.globals[a],i.classList.contains(e.ctx.toolbar.selectedClass)?i.classList.remove(e.ctx.toolbar.selectedClass):i.classList.add(e.ctx.toolbar.selectedClass)}))}},{key:"getToolbarIconsReference",value:function(){var t=this.w;this.elZoom||(this.elZoom=t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")),this.elPan||(this.elPan=t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")),this.elSelection||(this.elSelection=t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"))}},{key:"enableZoomPanFromToolbar",value:function(t){this.toggleOtherControls(),"pan"===t?this.w.globals.panEnabled=!0:this.w.globals.zoomEnabled=!0;var e="pan"===t?this.elPan:this.elZoom,i="pan"===t?this.elZoom:this.elPan;e&&e.classList.add(this.selectedClass),i&&i.classList.remove(this.selectedClass)}},{key:"togglePanning",value:function(){this.ctx.getSyncedCharts().forEach((function(t){t.ctx.toolbar.toggleOtherControls(),t.w.globals.panEnabled=!t.w.globals.panEnabled,t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass)?t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass):t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass)}))}},{key:"toggleOtherControls",value:function(){var t=this,e=this.w;e.globals.panEnabled=!1,e.globals.zoomEnabled=!1,e.globals.selectionEnabled=!1,this.getToolbarIconsReference(),[this.elPan,this.elSelection,this.elZoom].forEach((function(e){e&&e.classList.remove(t.selectedClass)}))}},{key:"handleZoomIn",value:function(){var t=this.w;t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY);var e=(this.minX+this.maxX)/2,i=(this.minX+e)/2,a=(this.maxX+e)/2,s=this._getNewMinXMaxX(i,a);t.globals.disableZoomIn||this.zoomUpdateOptions(s.minX,s.maxX)}},{key:"handleZoomOut",value:function(){var t=this.w;if(t.globals.isRangeBar&&(this.minX=t.globals.minY,this.maxX=t.globals.maxY),!("datetime"===t.config.xaxis.type&&new Date(this.minX).getUTCFullYear()<1e3)){var e=(this.minX+this.maxX)/2,i=this.minX-(e-this.minX),a=this.maxX-(e-this.maxX),s=this._getNewMinXMaxX(i,a);t.globals.disableZoomOut||this.zoomUpdateOptions(s.minX,s.maxX)}}},{key:"_getNewMinXMaxX",value:function(t,e){var i=this.w.config.xaxis.convertedCatToNumeric;return{minX:i?Math.floor(t):t,maxX:i?Math.floor(e):e}}},{key:"zoomUpdateOptions",value:function(t,e){var i=this.w;if(void 0!==t||void 0!==e){if(!(i.config.xaxis.convertedCatToNumeric&&(t<1&&(t=1,e=i.globals.dataPoints),e-t<2))){var a={min:t,max:e},s=this.getBeforeZoomRange(a);s&&(a=s.xaxis);var r={xaxis:a},o=x.clone(i.globals.initialConfig.yaxis);if(i.config.chart.zoom.autoScaleYaxis)o=new q(this.ctx).autoScaleY(this.ctx,o,{xaxis:a});i.config.chart.group||(r.yaxis=o),this.w.globals.zoomed=!0,this.ctx.updateHelpers._updateOptions(r,!1,this.w.config.chart.animations.dynamicAnimation.enabled),this.zoomCallback(a,o)}}else this.handleZoomReset()}},{key:"zoomCallback",value:function(t,e){"function"==typeof this.ev.zoomed&&this.ev.zoomed(this.ctx,{xaxis:t,yaxis:e})}},{key:"getBeforeZoomRange",value:function(t,e){var i=null;return"function"==typeof this.ev.beforeZoom&&(i=this.ev.beforeZoom(this,{xaxis:t,yaxis:e})),i}},{key:"toggleMenu",value:function(){var t=this;window.setTimeout((function(){t.elMenu.classList.contains("apexcharts-menu-open")?t.elMenu.classList.remove("apexcharts-menu-open"):t.elMenu.classList.add("apexcharts-menu-open")}),0)}},{key:"handleDownload",value:function(t){var e=this.w,i=new j(this.ctx);switch(t){case"svg":i.exportToSVG(this.ctx);break;case"png":i.exportToPng(this.ctx);break;case"csv":i.exportToCSV({series:e.config.series,columnDelimiter:e.config.chart.toolbar.export.csv.columnDelimiter})}}},{key:"handleZoomReset",value:function(t){this.ctx.getSyncedCharts().forEach((function(t){var e=t.w;if(e.globals.lastXAxis.min=void 0,e.globals.lastXAxis.max=void 0,t.updateHelpers.revertDefaultAxisMinMax(),"function"==typeof e.config.chart.events.beforeResetZoom){var i=e.config.chart.events.beforeResetZoom(t,e);i&&t.updateHelpers.revertDefaultAxisMinMax(i)}"function"==typeof e.config.chart.events.zoomed&&t.ctx.toolbar.zoomCallback({min:e.config.xaxis.min,max:e.config.xaxis.max}),e.globals.zoomed=!1;var a=t.ctx.series.emptyCollapsedSeries(x.clone(e.globals.initialSeries));t.updateHelpers._updateSeries(a,e.config.chart.animations.dynamicAnimation.enabled)}))}},{key:"destroy",value:function(){this.elZoom=null,this.elZoomIn=null,this.elZoomOut=null,this.elPan=null,this.elSelection=null,this.elZoomReset=null,this.elMenuIcon=null}}]),t}(),gt=function(t){n(i,dt);var e=d(i);function i(t){var s;return a(this,i),(s=e.call(this,t)).ctx=t,s.w=t.w,s.dragged=!1,s.graphics=new m(s.ctx),s.eventList=["mousedown","mouseleave","mousemove","touchstart","touchmove","mouseup","touchend"],s.clientX=0,s.clientY=0,s.startX=0,s.endX=0,s.dragX=0,s.startY=0,s.endY=0,s.dragY=0,s.moveDirection="none",s}return r(i,[{key:"init",value:function(t){var e=this,i=t.xyRatios,a=this.w,s=this;this.xyRatios=i,this.zoomRect=this.graphics.drawRect(0,0,0,0),this.selectionRect=this.graphics.drawRect(0,0,0,0),this.gridRect=a.globals.dom.baseEl.querySelector(".apexcharts-grid"),this.zoomRect.node.classList.add("apexcharts-zoom-rect"),this.selectionRect.node.classList.add("apexcharts-selection-rect"),a.globals.dom.elGraphical.add(this.zoomRect),a.globals.dom.elGraphical.add(this.selectionRect),"x"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,minY:0,maxX:a.globals.gridWidth,maxY:a.globals.gridHeight}).on("dragmove",this.selectionDragging.bind(this,"dragging")):"y"===a.config.chart.selection.type?this.slDraggableRect=this.selectionRect.draggable({minX:0,maxX:a.globals.gridWidth}).on("dragmove",this.selectionDragging.bind(this,"dragging")):this.slDraggableRect=this.selectionRect.draggable().on("dragmove",this.selectionDragging.bind(this,"dragging")),this.preselectedSelection(),this.hoverArea=a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass," .apexcharts-svg")),this.hoverArea.classList.add("apexcharts-zoomable"),this.eventList.forEach((function(t){e.hoverArea.addEventListener(t,s.svgMouseEvents.bind(s,i),{capture:!1,passive:!0})}))}},{key:"destroy",value:function(){this.slDraggableRect&&(this.slDraggableRect.draggable(!1),this.slDraggableRect.off(),this.selectionRect.off()),this.selectionRect=null,this.zoomRect=null,this.gridRect=null}},{key:"svgMouseEvents",value:function(t,e){var i=this.w,a=this,s=this.ctx.toolbar,r=i.globals.zoomEnabled?i.config.chart.zoom.type:i.config.chart.selection.type,o=i.config.chart.toolbar.autoSelected;if(e.shiftKey?(this.shiftWasPressed=!0,s.enableZoomPanFromToolbar("pan"===o?"zoom":"pan")):this.shiftWasPressed&&(s.enableZoomPanFromToolbar(o),this.shiftWasPressed=!1),e.target){var n,l=e.target.classList;if(e.target.parentNode&&null!==e.target.parentNode&&(n=e.target.parentNode.classList),!(l.contains("apexcharts-selection-rect")||l.contains("apexcharts-legend-marker")||l.contains("apexcharts-legend-text")||n&&n.contains("apexcharts-toolbar"))){if(a.clientX="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientX:"touchend"===e.type?e.changedTouches[0].clientX:e.clientX,a.clientY="touchmove"===e.type||"touchstart"===e.type?e.touches[0].clientY:"touchend"===e.type?e.changedTouches[0].clientY:e.clientY,"mousedown"===e.type&&1===e.which){var h=a.gridRect.getBoundingClientRect();a.startX=a.clientX-h.left,a.startY=a.clientY-h.top,a.dragged=!1,a.w.globals.mousedown=!0}if(("mousemove"===e.type&&1===e.which||"touchmove"===e.type)&&(a.dragged=!0,i.globals.panEnabled?(i.globals.selection=null,a.w.globals.mousedown&&a.panDragging({context:a,zoomtype:r,xyRatios:t})):(a.w.globals.mousedown&&i.globals.zoomEnabled||a.w.globals.mousedown&&i.globals.selectionEnabled)&&(a.selection=a.selectionDrawing({context:a,zoomtype:r}))),"mouseup"===e.type||"touchend"===e.type||"mouseleave"===e.type){var c=a.gridRect.getBoundingClientRect();a.w.globals.mousedown&&(a.endX=a.clientX-c.left,a.endY=a.clientY-c.top,a.dragX=Math.abs(a.endX-a.startX),a.dragY=Math.abs(a.endY-a.startY),(i.globals.zoomEnabled||i.globals.selectionEnabled)&&a.selectionDrawn({context:a,zoomtype:r}),i.globals.panEnabled&&i.config.xaxis.convertedCatToNumeric&&a.delayedPanScrolled()),i.globals.zoomEnabled&&a.hideSelectionRect(this.selectionRect),a.dragged=!1,a.w.globals.mousedown=!1}this.makeSelectionRectDraggable()}}}},{key:"makeSelectionRectDraggable",value:function(){var t=this.w;if(this.selectionRect){var e=this.selectionRect.node.getBoundingClientRect();e.width>0&&e.height>0&&this.slDraggableRect.selectize({points:"l, r",pointSize:8,pointType:"rect"}).resize({constraint:{minX:0,minY:0,maxX:t.globals.gridWidth,maxY:t.globals.gridHeight}}).on("resizing",this.selectionDragging.bind(this,"resizing"))}}},{key:"preselectedSelection",value:function(){var t=this.w,e=this.xyRatios;if(!t.globals.zoomEnabled)if(void 0!==t.globals.selection&&null!==t.globals.selection)this.drawSelectionRect(t.globals.selection);else if(void 0!==t.config.chart.selection.xaxis.min&&void 0!==t.config.chart.selection.xaxis.max){var i=(t.config.chart.selection.xaxis.min-t.globals.minX)/e.xRatio,a={x:i,y:0,width:t.globals.gridWidth-(t.globals.maxX-t.config.chart.selection.xaxis.max)/e.xRatio-i,height:t.globals.gridHeight,translateX:0,translateY:0,selectionEnabled:!0};this.drawSelectionRect(a),this.makeSelectionRectDraggable(),"function"==typeof t.config.chart.events.selection&&t.config.chart.events.selection(this.ctx,{xaxis:{min:t.config.chart.selection.xaxis.min,max:t.config.chart.selection.xaxis.max},yaxis:{}})}}},{key:"drawSelectionRect",value:function(t){var e=t.x,i=t.y,a=t.width,s=t.height,r=t.translateX,o=void 0===r?0:r,n=t.translateY,l=void 0===n?0:n,h=this.w,c=this.zoomRect,d=this.selectionRect;if(this.dragged||null!==h.globals.selection){var g={transform:"translate("+o+", "+l+")"};h.globals.zoomEnabled&&this.dragged&&(a<0&&(a=1),c.attr({x:e,y:i,width:a,height:s,fill:h.config.chart.zoom.zoomedArea.fill.color,"fill-opacity":h.config.chart.zoom.zoomedArea.fill.opacity,stroke:h.config.chart.zoom.zoomedArea.stroke.color,"stroke-width":h.config.chart.zoom.zoomedArea.stroke.width,"stroke-opacity":h.config.chart.zoom.zoomedArea.stroke.opacity}),m.setAttrs(c.node,g)),h.globals.selectionEnabled&&(d.attr({x:e,y:i,width:a>0?a:0,height:s>0?s:0,fill:h.config.chart.selection.fill.color,"fill-opacity":h.config.chart.selection.fill.opacity,stroke:h.config.chart.selection.stroke.color,"stroke-width":h.config.chart.selection.stroke.width,"stroke-dasharray":h.config.chart.selection.stroke.dashArray,"stroke-opacity":h.config.chart.selection.stroke.opacity}),m.setAttrs(d.node,g))}}},{key:"hideSelectionRect",value:function(t){t&&t.attr({x:0,y:0,width:0,height:0})}},{key:"selectionDrawing",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.gridRect.getBoundingClientRect(),o=s.startX-1,n=s.startY,l=!1,h=!1,c=s.clientX-r.left-o,d=s.clientY-r.top-n,g={};return Math.abs(c+o)>a.globals.gridWidth?c=a.globals.gridWidth-o:s.clientX-r.left<0&&(c=o),o>s.clientX-r.left&&(l=!0,c=Math.abs(c)),n>s.clientY-r.top&&(h=!0,d=Math.abs(d)),g="x"===i?{x:l?o-c:o,y:0,width:c,height:a.globals.gridHeight}:"y"===i?{x:0,y:h?n-d:n,width:a.globals.gridWidth,height:d}:{x:l?o-c:o,y:h?n-d:n,width:c,height:d},s.drawSelectionRect(g),s.selectionDragging("resizing"),g}},{key:"selectionDragging",value:function(t,e){var i=this,a=this.w,s=this.xyRatios,r=this.selectionRect,o=0;"resizing"===t&&(o=30);var n=function(t){return parseFloat(r.node.getAttribute(t))},l={x:n("x"),y:n("y"),width:n("width"),height:n("height")};a.globals.selection=l,"function"==typeof a.config.chart.events.selection&&a.globals.selectionEnabled&&(clearTimeout(this.w.globals.selectionResizeTimer),this.w.globals.selectionResizeTimer=window.setTimeout((function(){var t=i.gridRect.getBoundingClientRect(),e=r.node.getBoundingClientRect(),o={xaxis:{min:a.globals.xAxisScale.niceMin+(e.left-t.left)*s.xRatio,max:a.globals.xAxisScale.niceMin+(e.right-t.left)*s.xRatio},yaxis:{min:a.globals.yAxisScale[0].niceMin+(t.bottom-e.bottom)*s.yRatio[0],max:a.globals.yAxisScale[0].niceMax-(e.top-t.top)*s.yRatio[0]}};a.config.chart.events.selection(i.ctx,o),a.config.chart.brush.enabled&&void 0!==a.config.chart.events.brushScrolled&&a.config.chart.events.brushScrolled(i.ctx,o)}),o))}},{key:"selectionDrawn",value:function(t){var e=t.context,i=t.zoomtype,a=this.w,s=e,r=this.xyRatios,o=this.ctx.toolbar;if(s.startX>s.endX){var n=s.startX;s.startX=s.endX,s.endX=n}if(s.startY>s.endY){var l=s.startY;s.startY=s.endY,s.endY=l}var h=void 0,c=void 0;a.globals.isRangeBar?(h=a.globals.yAxisScale[0].niceMin+s.startX*r.invertedYRatio,c=a.globals.yAxisScale[0].niceMin+s.endX*r.invertedYRatio):(h=a.globals.xAxisScale.niceMin+s.startX*r.xRatio,c=a.globals.xAxisScale.niceMin+s.endX*r.xRatio);var d=[],g=[];if(a.config.yaxis.forEach((function(t,e){d.push(a.globals.yAxisScale[e].niceMax-r.yRatio[e]*s.startY),g.push(a.globals.yAxisScale[e].niceMax-r.yRatio[e]*s.endY)})),s.dragged&&(s.dragX>10||s.dragY>10)&&h!==c)if(a.globals.zoomEnabled){var u=x.clone(a.globals.initialConfig.yaxis),p=x.clone(a.globals.initialConfig.xaxis);if(a.globals.zoomed=!0,a.config.xaxis.convertedCatToNumeric&&(h=Math.floor(h),c=Math.floor(c),h<1&&(h=1,c=a.globals.dataPoints),c-h<2&&(c=h+1)),"xy"!==i&&"x"!==i||(p={min:h,max:c}),"xy"!==i&&"y"!==i||u.forEach((function(t,e){u[e].min=g[e],u[e].max=d[e]})),a.config.chart.zoom.autoScaleYaxis){var f=new q(s.ctx);u=f.autoScaleY(s.ctx,u,{xaxis:p})}if(o){var b=o.getBeforeZoomRange(p,u);b&&(p=b.xaxis?b.xaxis:p,u=b.yaxis?b.yaxis:u)}var v={xaxis:p};a.config.chart.group||(v.yaxis=u),s.ctx.updateHelpers._updateOptions(v,!1,s.w.config.chart.animations.dynamicAnimation.enabled),"function"==typeof a.config.chart.events.zoomed&&o.zoomCallback(p,u)}else if(a.globals.selectionEnabled){var m,y=null;m={min:h,max:c},"xy"!==i&&"y"!==i||(y=x.clone(a.config.yaxis)).forEach((function(t,e){y[e].min=g[e],y[e].max=d[e]})),a.globals.selection=s.selection,"function"==typeof a.config.chart.events.selection&&a.config.chart.events.selection(s.ctx,{xaxis:m,yaxis:y})}}},{key:"panDragging",value:function(t){var e=t.context,i=this.w,a=e;if(void 0!==i.globals.lastClientPosition.x){var s=i.globals.lastClientPosition.x-a.clientX,r=i.globals.lastClientPosition.y-a.clientY;Math.abs(s)>Math.abs(r)&&s>0?this.moveDirection="left":Math.abs(s)>Math.abs(r)&&s<0?this.moveDirection="right":Math.abs(r)>Math.abs(s)&&r>0?this.moveDirection="up":Math.abs(r)>Math.abs(s)&&r<0&&(this.moveDirection="down")}i.globals.lastClientPosition={x:a.clientX,y:a.clientY};var o=i.globals.isRangeBar?i.globals.minY:i.globals.minX,n=i.globals.isRangeBar?i.globals.maxY:i.globals.maxX;i.config.xaxis.convertedCatToNumeric||a.panScrolled(o,n)}},{key:"delayedPanScrolled",value:function(){var t=this.w,e=t.globals.minX,i=t.globals.maxX,a=(t.globals.maxX-t.globals.minX)/2;"left"===this.moveDirection?(e=t.globals.minX+a,i=t.globals.maxX+a):"right"===this.moveDirection&&(e=t.globals.minX-a,i=t.globals.maxX-a),e=Math.floor(e),i=Math.floor(i),this.updateScrolledChart({xaxis:{min:e,max:i}},e,i)}},{key:"panScrolled",value:function(t,e){var i=this.w,a=this.xyRatios,s=x.clone(i.globals.initialConfig.yaxis),r=a.xRatio,o=i.globals.minX,n=i.globals.maxX;i.globals.isRangeBar&&(r=a.invertedYRatio,o=i.globals.minY,n=i.globals.maxY),"left"===this.moveDirection?(t=o+i.globals.gridWidth/15*r,e=n+i.globals.gridWidth/15*r):"right"===this.moveDirection&&(t=o-i.globals.gridWidth/15*r,e=n-i.globals.gridWidth/15*r),i.globals.isRangeBar||(t<i.globals.initialMinX||e>i.globals.initialMaxX)&&(t=o,e=n);var l={min:t,max:e};i.config.chart.zoom.autoScaleYaxis&&(s=new q(this.ctx).autoScaleY(this.ctx,s,{xaxis:l}));var h={xaxis:{min:t,max:e}};i.config.chart.group||(h.yaxis=s),this.updateScrolledChart(h,t,e)}},{key:"updateScrolledChart",value:function(t,e,i){var a=this.w;this.ctx.updateHelpers._updateOptions(t,!1,!1),"function"==typeof a.config.chart.events.scrolled&&a.config.chart.events.scrolled(this.ctx,{xaxis:{min:e,max:i}})}}]),i}(),ut=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx}return r(t,[{key:"getNearestValues",value:function(t){var e=t.hoverArea,i=t.elGrid,a=t.clientX,s=t.clientY,r=this.w,o=i.getBoundingClientRect(),n=o.width,l=o.height,h=n/(r.globals.dataPoints-1),c=l/r.globals.dataPoints,d=this.hasBars();!r.globals.comboCharts&&!d||r.config.xaxis.convertedCatToNumeric||(h=n/r.globals.dataPoints);var g=a-o.left-r.globals.barPadForNumericAxis,u=s-o.top;g<0||u<0||g>n||u>l?(e.classList.remove("hovering-zoom"),e.classList.remove("hovering-pan")):r.globals.zoomEnabled?(e.classList.remove("hovering-pan"),e.classList.add("hovering-zoom")):r.globals.panEnabled&&(e.classList.remove("hovering-zoom"),e.classList.add("hovering-pan"));var p=Math.round(g/h),f=Math.floor(u/c);d&&!r.config.xaxis.convertedCatToNumeric&&(p=Math.ceil(g/h),p-=1);var b=null,v=null,m=[],y=[];if(r.globals.seriesXvalues.forEach((function(t){m.push([t[0]+1e-6].concat(t))})),r.globals.seriesYvalues.forEach((function(t){y.push([t[0]+1e-6].concat(t))})),m=m.map((function(t){return t.filter((function(t){return x.isNumber(t)}))})),y=y.map((function(t){return t.filter((function(t){return x.isNumber(t)}))})),r.globals.isXNumeric){var w=this.ttCtx.getElGrid().getBoundingClientRect(),k=g*(w.width/n),A=u*(w.height/l);b=(v=this.closestInMultiArray(k,A,m,y)).index,p=v.j,null!==b&&(m=r.globals.seriesXvalues[b],p=(v=this.closestInArray(k,m)).index)}return r.globals.capturedSeriesIndex=null===b?-1:b,(!p||p<1)&&(p=0),r.globals.isBarHorizontal?r.globals.capturedDataPointIndex=f:r.globals.capturedDataPointIndex=p,{capturedSeries:b,j:r.globals.isBarHorizontal?f:p,hoverX:g,hoverY:u}}},{key:"closestInMultiArray",value:function(t,e,i,a){var s=this.w,r=0,o=null,n=-1;s.globals.series.length>1?r=this.getFirstActiveXArray(i):o=0;var l=i[r][0],h=Math.abs(t-l);if(i.forEach((function(e){e.forEach((function(e,i){var a=Math.abs(t-e);a<h&&(h=a,n=i)}))})),-1!==n){var c=a[r][n],d=Math.abs(e-c);o=r,a.forEach((function(t,i){var a=Math.abs(e-t[n]);a<d&&(d=a,o=i)}))}return{index:o,j:n}}},{key:"getFirstActiveXArray",value:function(t){for(var e=this.w,i=0,a=t.map((function(t,e){return t.length>0?e:-1})),s=0;s<a.length;s++)if(-1!==a[s]&&-1===e.globals.collapsedSeriesIndices.indexOf(s)&&-1===e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)){i=a[s];break}return i}},{key:"closestInArray",value:function(t,e){for(var i=e[0],a=null,s=Math.abs(t-i),r=0;r<e.length;r++){var o=Math.abs(t-e[r]);o<s&&(s=o,a=r)}return{index:a}}},{key:"isXoverlap",value:function(t){var e=[],i=this.w.globals.seriesX.filter((function(t){return void 0!==t[0]}));if(i.length>0)for(var a=0;a<i.length-1;a++)void 0!==i[a][t]&&void 0!==i[a+1][t]&&i[a][t]!==i[a+1][t]&&e.push("unEqual");return 0===e.length}},{key:"isInitialSeriesSameLen",value:function(){for(var t=!0,e=this.w.globals.initialSeries,i=0;i<e.length-1;i++)if(e[i].data.length!==e[i+1].data.length){t=!1;break}return t}},{key:"getBarsHeight",value:function(t){return u(t).reduce((function(t,e){return t+e.getBBox().height}),0)}},{key:"getElMarkers",value:function(){return this.w.globals.dom.baseEl.querySelectorAll(" .apexcharts-series-markers")}},{key:"getAllMarkers",value:function(){var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");(t=u(t)).sort((function(t,e){var i=Number(t.getAttribute("data:realIndex")),a=Number(e.getAttribute("data:realIndex"));return a<i?1:a>i?-1:0}));var e=[];return t.forEach((function(t){e.push(t.querySelector(".apexcharts-marker"))})),e}},{key:"hasMarkers",value:function(){return this.getElMarkers().length>0}},{key:"getElBars",value:function(){return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series")}},{key:"hasBars",value:function(){return this.getElBars().length>0}},{key:"getHoverMarkerSize",value:function(t){var e=this.w,i=e.config.markers.hover.size;return void 0===i&&(i=e.globals.markers.size[t]+e.config.markers.hover.sizeOffset),i}},{key:"toggleAllTooltipSeriesGroups",value:function(t){var e=this.w,i=this.ttCtx;0===i.allTooltipSeriesGroups.length&&(i.allTooltipSeriesGroups=e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));for(var a=i.allTooltipSeriesGroups,s=0;s<a.length;s++)"enable"===t?(a[s].classList.add("apexcharts-active"),a[s].style.display=e.config.tooltip.items.display):(a[s].classList.remove("apexcharts-active"),a[s].style.display="none")}}]),t}(),pt=function(){function t(e){a(this,t),this.w=e.w,this.ctx=e.ctx,this.ttCtx=e,this.tooltipUtil=new ut(e)}return r(t,[{key:"drawSeriesTexts",value:function(t){var e=t.shared,i=void 0===e||e,a=t.ttItems,s=t.i,r=void 0===s?0:s,o=t.j,n=void 0===o?null:o,l=t.y1,h=t.y2,c=t.e,d=this.w;void 0!==d.config.tooltip.custom?this.handleCustomTooltip({i:r,j:n,y1:l,y2:h,w:d}):this.toggleActiveInactiveSeries(i);var g=this.getValuesToPrint({i:r,j:n});this.printLabels({i:r,j:n,values:g,ttItems:a,shared:i,e:c});var u=this.ttCtx.getElTooltip();this.ttCtx.tooltipRect.ttWidth=u.getBoundingClientRect().width,this.ttCtx.tooltipRect.ttHeight=u.getBoundingClientRect().height}},{key:"printLabels",value:function(t){var i,a=this,s=t.i,r=t.j,o=t.values,n=t.ttItems,l=t.shared,h=t.e,c=this.w,d=[],g=function(t){return c.globals.seriesGoals[t]&&c.globals.seriesGoals[t][r]&&Array.isArray(c.globals.seriesGoals[t][r])},u=o.xVal,p=o.zVal,f=o.xAxisTTVal,x="",b=c.globals.colors[s];null!==r&&c.config.plotOptions.bar.distributed&&(b=c.globals.colors[r]);for(var v=function(t,o){var v=a.getFormatters(s);x=a.getSeriesName({fn:v.yLbTitleFormatter,index:s,seriesIndex:s,j:r}),"treemap"===c.config.chart.type&&(x=v.yLbTitleFormatter(String(c.config.series[s].data[r].x),{series:c.globals.series,seriesIndex:s,dataPointIndex:r,w:c}));var m=c.config.tooltip.inverseOrder?o:t;if(c.globals.axisCharts){var y=function(t){return v.yLbFormatter(c.globals.series[t][r],{series:c.globals.series,seriesIndex:t,dataPointIndex:r,w:c})};if(l)v=a.getFormatters(m),x=a.getSeriesName({fn:v.yLbTitleFormatter,index:m,seriesIndex:s,j:r}),b=c.globals.colors[m],i=y(m),g(m)&&(d=c.globals.seriesGoals[m][r].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:m,dataPointIndex:r,w:c})}})));else{var w,k=null==h||null===(w=h.target)||void 0===w?void 0:w.getAttribute("fill");k&&(b=-1!==k.indexOf("url")?document.querySelector(k.substr(4).slice(0,-1)).childNodes[0].getAttribute("stroke"):k),i=y(s),g(s)&&Array.isArray(c.globals.seriesGoals[s][r])&&(d=c.globals.seriesGoals[s][r].map((function(t){return{attrs:t,val:v.yLbFormatter(t.value,{seriesIndex:s,dataPointIndex:r,w:c})}})))}}null===r&&(i=v.yLbFormatter(c.globals.series[s],e(e({},c),{},{seriesIndex:s,dataPointIndex:s}))),a.DOMHandling({i:s,t:m,j:r,ttItems:n,values:{val:i,goalVals:d,xVal:u,xAxisTTVal:f,zVal:p},seriesName:x,shared:l,pColor:b})},m=0,y=c.globals.series.length-1;m<c.globals.series.length;m++,y--)v(m,y)}},{key:"getFormatters",value:function(t){var e,i=this.w,a=i.globals.yLabelFormatters[t];return void 0!==i.globals.ttVal?Array.isArray(i.globals.ttVal)?(a=i.globals.ttVal[t]&&i.globals.ttVal[t].formatter,e=i.globals.ttVal[t]&&i.globals.ttVal[t].title&&i.globals.ttVal[t].title.formatter):(a=i.globals.ttVal.formatter,"function"==typeof i.globals.ttVal.title.formatter&&(e=i.globals.ttVal.title.formatter)):e=i.config.tooltip.y.title.formatter,"function"!=typeof a&&(a=i.globals.yLabelFormatters[0]?i.globals.yLabelFormatters[0]:function(t){return t}),"function"!=typeof e&&(e=function(t){return t}),{yLbFormatter:a,yLbTitleFormatter:e}}},{key:"getSeriesName",value:function(t){var e=t.fn,i=t.index,a=t.seriesIndex,s=t.j,r=this.w;return e(String(r.globals.seriesNames[i]),{series:r.globals.series,seriesIndex:a,dataPointIndex:s,w:r})}},{key:"DOMHandling",value:function(t){t.i;var e=t.t,i=t.j,a=t.ttItems,s=t.values,r=t.seriesName,o=t.shared,n=t.pColor,l=this.w,h=this.ttCtx,c=s.val,d=s.goalVals,g=s.xVal,u=s.xAxisTTVal,p=s.zVal,f=null;f=a[e].children,l.config.tooltip.fillSeriesColor&&(a[e].style.backgroundColor=n,f[0].style.display="none"),h.showTooltipTitle&&(null===h.tooltipTitle&&(h.tooltipTitle=l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")),h.tooltipTitle.innerHTML=g),h.isXAxisTooltipEnabled&&(h.xaxisTooltipText.innerHTML=""!==u?u:g);var x=a[e].querySelector(".apexcharts-tooltip-text-y-label");x&&(x.innerHTML=r||"");var b=a[e].querySelector(".apexcharts-tooltip-text-y-value");b&&(b.innerHTML=void 0!==c?c:""),f[0]&&f[0].classList.contains("apexcharts-tooltip-marker")&&(l.config.tooltip.marker.fillColors&&Array.isArray(l.config.tooltip.marker.fillColors)&&(n=l.config.tooltip.marker.fillColors[e]),f[0].style.backgroundColor=n),l.config.tooltip.marker.show||(f[0].style.display="none");var v=a[e].querySelector(".apexcharts-tooltip-text-goals-label"),m=a[e].querySelector(".apexcharts-tooltip-text-goals-value");if(d.length&&l.globals.seriesGoals[e]){var y=function(){var t="<div >",e="<div>";d.forEach((function(i,a){t+=' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor,'; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name,"</div>"),e+="<div>".concat(i.val,"</div>")})),v.innerHTML=t+"</div>",m.innerHTML=e+"</div>"};o?l.globals.seriesGoals[e][i]&&Array.isArray(l.globals.seriesGoals[e][i])?y():(v.innerHTML="",m.innerHTML=""):y()}else v.innerHTML="",m.innerHTML="";null!==p&&(a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML=l.config.tooltip.z.title,a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML=void 0!==p?p:"");o&&f[0]&&(null==c||l.globals.ancillaryCollapsedSeriesIndices.indexOf(e)>-1||l.globals.collapsedSeriesIndices.indexOf(e)>-1?f[0].parentNode.style.display="none":f[0].parentNode.style.display=l.config.tooltip.items.display)}},{key:"toggleActiveInactiveSeries",value:function(t){var e=this.w;if(t)this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");else{this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");var i=e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");i&&(i.classList.add("apexcharts-active"),i.style.display=e.config.tooltip.items.display)}}},{key:"getValuesToPrint",value:function(t){var e=t.i,i=t.j,a=this.w,s=this.ctx.series.filteredSeriesX(),r="",o="",n=null,l=null,h={series:a.globals.series,seriesIndex:e,dataPointIndex:i,w:a},c=a.globals.ttZFormatter;null===i?l=a.globals.series[e]:a.globals.isXNumeric&&"treemap"!==a.config.chart.type?(r=s[e][i],0===s[e].length&&(r=s[this.tooltipUtil.getFirstActiveXArray(s)][i])):r=void 0!==a.globals.labels[i]?a.globals.labels[i]:"";var d=r;a.globals.isXNumeric&&"datetime"===a.config.xaxis.type?r=new V(this.ctx).xLabelFormat(a.globals.ttKeyFormatter,d,d,{i:void 0,dateFormatter:new R(this.ctx).formatDate,w:this.w}):r=a.globals.isBarHorizontal?a.globals.yLabelFormatters[0](d,h):a.globals.xLabelFormatter(d,h);return void 0!==a.config.tooltip.x.formatter&&(r=a.globals.ttKeyFormatter(d,h)),a.globals.seriesZ.length>0&&a.globals.seriesZ[e].length>0&&(n=c(a.globals.seriesZ[e][i],a)),o="function"==typeof a.config.xaxis.tooltip.formatter?a.globals.xaxisTooltipFormatter(d,h):r,{val:Array.isArray(l)?l.join(" "):l,xVal:Array.isArray(r)?r.join(" "):r,xAxisTTVal:Array.isArray(o)?o.join(" "):o,zVal:n}}},{key:"handleCustomTooltip",value:function(t){var e=t.i,i=t.j,a=t.y1,s=t.y2,r=t.w,o=this.ttCtx.getElTooltip(),n=r.config.tooltip.custom;Array.isArray(n)&&n[e]&&(n=n[e]),o.innerHTML=n({ctx:this.ctx,series:r.globals.series,seriesIndex:e,dataPointIndex:i,y1:a,y2:s,w:r})}}]),t}(),ft=function(){function t(e){a(this,t),this.ttCtx=e,this.ctx=e.ctx,this.w=e.w}return r(t,[{key:"moveXCrosshairs",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:null,i=this.ttCtx,a=this.w,s=i.getElXCrosshairs(),r=t-i.xcrosshairsWidth/2,o=a.globals.labels.slice().length;if(null!==e&&(r=a.globals.gridWidth/o*e),null===s||a.globals.isBarHorizontal||(s.setAttribute("x",r),s.setAttribute("x1",r),s.setAttribute("x2",r),s.setAttribute("y2",a.globals.gridHeight),s.classList.add("apexcharts-active")),r<0&&(r=0),r>a.globals.gridWidth&&(r=a.globals.gridWidth),i.isXAxisTooltipEnabled){var n=r;"tickWidth"!==a.config.xaxis.crosshairs.width&&"barWidth"!==a.config.xaxis.crosshairs.width||(n=r+i.xcrosshairsWidth/2),this.moveXAxisTooltip(n)}}},{key:"moveYCrosshairs",value:function(t){var e=this.ttCtx;null!==e.ycrosshairs&&m.setAttrs(e.ycrosshairs,{y1:t,y2:t}),null!==e.ycrosshairsHidden&&m.setAttrs(e.ycrosshairsHidden,{y1:t,y2:t})}},{key:"moveXAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;if(null!==i.xaxisTooltip&&0!==i.xcrosshairsWidth){i.xaxisTooltip.classList.add("apexcharts-active");var a=i.xaxisOffY+e.config.xaxis.tooltip.offsetY+e.globals.translateY+1+e.config.xaxis.offsetY;if(t-=i.xaxisTooltip.getBoundingClientRect().width/2,!isNaN(t)){t+=e.globals.translateX;var s;s=new m(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML),i.xaxisTooltipText.style.minWidth=s.width+"px",i.xaxisTooltip.style.left=t+"px",i.xaxisTooltip.style.top=a+"px"}}}},{key:"moveYAxisTooltip",value:function(t){var e=this.w,i=this.ttCtx;null===i.yaxisTTEls&&(i.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));var a=parseInt(i.ycrosshairsHidden.getAttribute("y1"),10),s=e.globals.translateY+a,r=i.yaxisTTEls[t].getBoundingClientRect().height,o=e.globals.translateYAxisX[t]-2;e.config.yaxis[t].opposite&&(o-=26),s-=r/2,-1===e.globals.ignoreYAxisIndexes.indexOf(t)?(i.yaxisTTEls[t].classList.add("apexcharts-active"),i.yaxisTTEls[t].style.top=s+"px",i.yaxisTTEls[t].style.left=o+e.config.yaxis[t].tooltip.offsetX+"px"):i.yaxisTTEls[t].classList.remove("apexcharts-active")}},{key:"moveTooltip",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=this.w,s=this.ttCtx,r=s.getElTooltip(),o=s.tooltipRect,n=null!==i?parseFloat(i):1,l=parseFloat(t)+n+5,h=parseFloat(e)+n/2;if(l>a.globals.gridWidth/2&&(l=l-o.ttWidth-n-10),l>a.globals.gridWidth-o.ttWidth-10&&(l=a.globals.gridWidth-o.ttWidth),l<-20&&(l=-20),a.config.tooltip.followCursor){var c=s.getElGrid(),d=c.getBoundingClientRect();h=s.e.clientY+a.globals.translateY-d.top-o.ttHeight/2}else a.globals.isBarHorizontal||(o.ttHeight/2+h>a.globals.gridHeight&&(h=a.globals.gridHeight-o.ttHeight+a.globals.translateY),h<0&&(h=0));isNaN(l)||(l+=a.globals.translateX,r.style.left=l+"px",r.style.top=h+"px")}},{key:"moveMarkers",value:function(t,e){var i=this.w,a=this.ttCtx;if(i.globals.markers.size[t]>0)for(var s=i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t,"'] .apexcharts-marker")),r=0;r<s.length;r++)parseInt(s[r].getAttribute("rel"),10)===e&&(a.marker.resetPointsSize(),a.marker.enlargeCurrentPoint(e,s[r]));else a.marker.resetPointsSize(),this.moveDynamicPointOnHover(e,t)}},{key:"moveDynamicPointOnHover",value:function(t,e){var i,a,s=this.w,r=this.ttCtx,o=s.globals.pointsArray,n=r.tooltipUtil.getHoverMarkerSize(e),l=s.config.series[e].type;if(!l||"column"!==l&&"candlestick"!==l&&"boxPlot"!==l){i=o[e][t][0],a=o[e][t][1]?o[e][t][1]:0;var h=s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e,"'] .apexcharts-series-markers circle"));h&&a<s.globals.gridHeight&&a>0&&(h.setAttribute("r",n),h.setAttribute("cx",i),h.setAttribute("cy",a)),this.moveXCrosshairs(i),r.fixedTooltip||this.moveTooltip(i,a,n)}}},{key:"moveDynamicPointsOnHover",value:function(t){var e,i=this.ttCtx,a=i.w,s=0,r=0,o=a.globals.pointsArray;e=new E(this.ctx).getActiveConfigSeriesIndex(!0);var n=i.tooltipUtil.getHoverMarkerSize(e);o[e]&&(s=o[e][t][0],r=o[e][t][1]);var l=i.tooltipUtil.getAllMarkers();if(null!==l)for(var h=0;h<a.globals.series.length;h++){var c=o[h];if(a.globals.comboCharts&&void 0===c&&l.splice(h,0,null),c&&c.length){var d=o[h][t][1];l[h].setAttribute("cx",s),null!==d&&!isNaN(d)&&d<a.globals.gridHeight+n&&d+n>0?(l[h]&&l[h].setAttribute("r",n),l[h]&&l[h].setAttribute("cy",d)):l[h]&&l[h].setAttribute("r",0)}}if(this.moveXCrosshairs(s),!i.fixedTooltip){var g=r||a.globals.gridHeight;this.moveTooltip(s,g,n)}}},{key:"moveStickyTooltipOverBars",value:function(t){var e=this.w,i=this.ttCtx,a=e.globals.columnSeries?e.globals.columnSeries.length:e.globals.series.length,s=a>=2&&a%2==0?Math.floor(a/2):Math.floor(a/2)+1;e.globals.isBarHorizontal&&(s=new E(this.ctx).getActiveConfigSeriesIndex(!1,"desc")+1);var r=e.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(s,"'] path[j='").concat(t,"'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(s,"'] path[j='").concat(t,"'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(s,"'] path[j='").concat(t,"'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(s,"'] path[j='").concat(t,"']")),o=r?parseFloat(r.getAttribute("cx")):0,n=r?parseFloat(r.getAttribute("cy")):0,l=r?parseFloat(r.getAttribute("barWidth")):0,h=r?parseFloat(r.getAttribute("barHeight")):0,c=i.getElGrid().getBoundingClientRect(),d=r.classList.contains("apexcharts-candlestick-area")||r.classList.contains("apexcharts-boxPlot-area");if(e.globals.isXNumeric?(r&&!d&&(o-=a%2!=0?l/2:0),r&&d&&e.globals.comboCharts&&(o-=l/2)):e.globals.isBarHorizontal||(o=i.xAxisTicksPositions[t-1]+i.dataPointsDividedWidth/2,isNaN(o)&&(o=i.xAxisTicksPositions[t]-i.dataPointsDividedWidth/2)),e.globals.isBarHorizontal?(n>e.globals.gridHeight/2&&(n-=i.tooltipRect.ttHeight),(n=n+e.config.grid.padding.top+h/3)+h>e.globals.gridHeight&&(n=e.globals.gridHeight-h)):e.config.tooltip.followCursor?n=i.e.clientY-c.top-i.tooltipRect.ttHeight/2:n+i.tooltipRect.ttHeight+15>e.globals.gridHeight&&(n=e.globals.gridHeight),n<-10&&(n=-10),e.globals.isBarHorizontal||this.moveXCrosshairs(o),!i.fixedTooltip){var g=n||e.globals.gridHeight;this.moveTooltip(o,g)}}}]),t}(),xt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e,this.ctx=e.ctx,this.tooltipPosition=new ft(e)}return r(t,[{key:"drawDynamicPoints",value:function(){var t=this.w,e=new m(this.ctx),i=new T(this.ctx),a=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");a=u(a),t.config.chart.stacked&&a.sort((function(t,e){return parseFloat(t.getAttribute("data:realIndex"))-parseFloat(e.getAttribute("data:realIndex"))}));for(var s=0;s<a.length;s++){var r=a[s].querySelector(".apexcharts-series-markers-wrap");if(null!==r){var o=void 0,n="apexcharts-marker w".concat((Math.random()+1).toString(36).substring(4));"line"!==t.config.chart.type&&"area"!==t.config.chart.type||t.globals.comboCharts||t.config.tooltip.intersect||(n+=" no-pointer-events");var l=i.getMarkerConfig({cssClass:n,seriesIndex:Number(r.getAttribute("data:realIndex"))});(o=e.drawMarker(0,0,l)).node.setAttribute("default-marker-size",0);var h=document.createElementNS(t.globals.SVGNS,"g");h.classList.add("apexcharts-series-markers"),h.appendChild(o.node),r.appendChild(h)}}}},{key:"enlargeCurrentPoint",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null,a=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,s=this.w;"bubble"!==s.config.chart.type&&this.newPointSize(t,e);var r=e.getAttribute("cx"),o=e.getAttribute("cy");if(null!==i&&null!==a&&(r=i,o=a),this.tooltipPosition.moveXCrosshairs(r),!this.fixedTooltip){if("radar"===s.config.chart.type){var n=this.ttCtx.getElGrid(),l=n.getBoundingClientRect();r=this.ttCtx.e.clientX-l.left}this.tooltipPosition.moveTooltip(r,o,s.config.markers.hover.size)}}},{key:"enlargePoints",value:function(t){for(var e=this.w,i=this,a=this.ttCtx,s=t,r=e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),o=e.config.markers.hover.size,n=0;n<r.length;n++){var l=r[n].getAttribute("rel"),h=r[n].getAttribute("index");if(void 0===o&&(o=e.globals.markers.size[h]+e.config.markers.hover.sizeOffset),s===parseInt(l,10)){i.newPointSize(s,r[n]);var c=r[n].getAttribute("cx"),d=r[n].getAttribute("cy");i.tooltipPosition.moveXCrosshairs(c),a.fixedTooltip||i.tooltipPosition.moveTooltip(c,d,o)}else i.oldPointSize(r[n])}}},{key:"newPointSize",value:function(t,e){var i=this.w,a=i.config.markers.hover.size,s=0===t?e.parentNode.firstChild:e.parentNode.lastChild;if("0"!==s.getAttribute("default-marker-size")){var r=parseInt(s.getAttribute("index"),10);void 0===a&&(a=i.globals.markers.size[r]+i.config.markers.hover.sizeOffset),a<0&&(a=0),s.setAttribute("r",a)}}},{key:"oldPointSize",value:function(t){var e=parseFloat(t.getAttribute("default-marker-size"));t.setAttribute("r",e)}},{key:"resetPointsSize",value:function(){for(var t=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"),e=0;e<t.length;e++){var i=parseFloat(t[e].getAttribute("default-marker-size"));x.isNumber(i)&&i>=0?t[e].setAttribute("r",i):t[e].setAttribute("r",0)}}}]),t}(),bt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e}return r(t,[{key:"getAttr",value:function(t,e){return parseFloat(t.target.getAttribute(e))}},{key:"handleHeatTreeTooltip",value:function(t){var e=t.e,i=t.opt,a=t.x,s=t.y,r=t.type,o=this.ttCtx,n=this.w;if(e.target.classList.contains("apexcharts-".concat(r,"-rect"))){var l=this.getAttr(e,"i"),h=this.getAttr(e,"j"),c=this.getAttr(e,"cx"),d=this.getAttr(e,"cy"),g=this.getAttr(e,"width"),u=this.getAttr(e,"height");if(o.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:l,j:h,shared:!1,e:e}),n.globals.capturedSeriesIndex=l,n.globals.capturedDataPointIndex=h,a=c+o.tooltipRect.ttWidth/2+g,s=d+o.tooltipRect.ttHeight/2-u/2,o.tooltipPosition.moveXCrosshairs(c+g/2),a>n.globals.gridWidth/2&&(a=c-o.tooltipRect.ttWidth/2+g),o.w.config.tooltip.followCursor){var p=n.globals.dom.elWrap.getBoundingClientRect();a=n.globals.clientX-p.left-(a>n.globals.gridWidth/2?o.tooltipRect.ttWidth:0),s=n.globals.clientY-p.top-(s>n.globals.gridHeight/2?o.tooltipRect.ttHeight:0)}}return{x:a,y:s}}},{key:"handleMarkerTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=t.x,o=t.y,n=this.w,l=this.ttCtx;if(a.target.classList.contains("apexcharts-marker")){var h=parseInt(s.paths.getAttribute("cx"),10),c=parseInt(s.paths.getAttribute("cy"),10),d=parseFloat(s.paths.getAttribute("val"));if(i=parseInt(s.paths.getAttribute("rel"),10),e=parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"),10)-1,l.intersect){var g=x.findAncestor(s.paths,"apexcharts-series");g&&(e=parseInt(g.getAttribute("data:realIndex"),10))}if(l.tooltipLabels.drawSeriesTexts({ttItems:s.ttItems,i:e,j:i,shared:!l.showOnIntersect&&n.config.tooltip.shared,e:a}),"mouseup"===a.type&&l.markerClick(a,e,i),n.globals.capturedSeriesIndex=e,n.globals.capturedDataPointIndex=i,r=h,o=c+n.globals.translateY-1.4*l.tooltipRect.ttHeight,l.w.config.tooltip.followCursor){var u=l.getElGrid().getBoundingClientRect();o=l.e.clientY+n.globals.translateY-u.top}d<0&&(o=c),l.marker.enlargeCurrentPoint(i,s.paths,r,o)}return{x:r,y:o}}},{key:"handleBarTooltip",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=this.ttCtx,n=o.getElTooltip(),l=0,h=0,c=0,d=this.getBarTooltipXY({e:a,opt:s});e=d.i;var g=d.barHeight,u=d.j;r.globals.capturedSeriesIndex=e,r.globals.capturedDataPointIndex=u,r.globals.isBarHorizontal&&o.tooltipUtil.hasBars()||!r.config.tooltip.shared?(h=d.x,c=d.y,i=Array.isArray(r.config.stroke.width)?r.config.stroke.width[e]:r.config.stroke.width,l=h):r.globals.comboCharts||r.config.tooltip.shared||(l/=2),isNaN(c)?c=r.globals.svgHeight-o.tooltipRect.ttHeight:c<0&&(c=0);var p=parseInt(s.paths.parentNode.getAttribute("data:realIndex"),10),f=r.globals.isMultipleYAxis?r.config.yaxis[p]&&r.config.yaxis[p].reversed:r.config.yaxis[0].reversed;if(h+o.tooltipRect.ttWidth>r.globals.gridWidth&&!f?h-=o.tooltipRect.ttWidth:h<0&&(h=0),o.w.config.tooltip.followCursor){var x=o.getElGrid().getBoundingClientRect();c=o.e.clientY-x.top}null===o.tooltip&&(o.tooltip=r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")),r.config.tooltip.shared||(r.globals.comboBarCount>0?o.tooltipPosition.moveXCrosshairs(l+i/2):o.tooltipPosition.moveXCrosshairs(l)),!o.fixedTooltip&&(!r.config.tooltip.shared||r.globals.isBarHorizontal&&o.tooltipUtil.hasBars())&&(f&&(h-=o.tooltipRect.ttWidth)<0&&(h=0),!f||r.globals.isBarHorizontal&&o.tooltipUtil.hasBars()||(c=c+g-2*(r.globals.series[e][u]<0?g:0)),o.tooltipRect.ttHeight+c>r.globals.gridHeight?c=r.globals.gridHeight-o.tooltipRect.ttHeight+r.globals.translateY:(c=c+r.globals.translateY-o.tooltipRect.ttHeight/2)<0&&(c=0),n.style.left=h+r.globals.translateX+"px",n.style.top=c+"px")}},{key:"getBarTooltipXY",value:function(t){var e=t.e,i=t.opt,a=this.w,s=null,r=this.ttCtx,o=0,n=0,l=0,h=0,c=0,d=e.target.classList;if(d.contains("apexcharts-bar-area")||d.contains("apexcharts-candlestick-area")||d.contains("apexcharts-boxPlot-area")||d.contains("apexcharts-rangebar-area")){var g=e.target,u=g.getBoundingClientRect(),p=i.elGrid.getBoundingClientRect(),f=u.height;c=u.height;var x=u.width,b=parseInt(g.getAttribute("cx"),10),v=parseInt(g.getAttribute("cy"),10);h=parseFloat(g.getAttribute("barWidth"));var m="touchmove"===e.type?e.touches[0].clientX:e.clientX;s=parseInt(g.getAttribute("j"),10),o=parseInt(g.parentNode.getAttribute("rel"),10)-1;var y=g.getAttribute("data-range-y1"),w=g.getAttribute("data-range-y2");a.globals.comboCharts&&(o=parseInt(g.parentNode.getAttribute("data:realIndex"),10)),r.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:o,j:s,y1:y?parseInt(y,10):null,y2:w?parseInt(w,10):null,shared:!r.showOnIntersect&&a.config.tooltip.shared,e:e}),a.config.tooltip.followCursor?a.globals.isBarHorizontal?(n=m-p.left+15,l=v-r.dataPointsDividedHeight+f/2-r.tooltipRect.ttHeight/2):(n=a.globals.isXNumeric?b-x/2:b-r.dataPointsDividedWidth+x/2,l=e.clientY-p.top-r.tooltipRect.ttHeight/2-15):a.globals.isBarHorizontal?((n=b)<r.xyRatios.baseLineInvertedY&&(n=b-r.tooltipRect.ttWidth),l=v-r.dataPointsDividedHeight+f/2-r.tooltipRect.ttHeight/2):(n=a.globals.isXNumeric?b-x/2:b-r.dataPointsDividedWidth+x/2,l=v)}return{x:n,y:l,barHeight:c,barWidth:h,i:o,j:s}}}]),t}(),vt=function(){function t(e){a(this,t),this.w=e.w,this.ttCtx=e}return r(t,[{key:"drawXaxisTooltip",value:function(){var t=this.w,e=this.ttCtx,i="bottom"===t.config.xaxis.position;e.xaxisOffY=i?t.globals.gridHeight+1:-t.globals.xAxisHeight-t.config.xaxis.axisTicks.height+3;var a=i?"apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom":"apexcharts-xaxistooltip apexcharts-xaxistooltip-top",s=t.globals.dom.elWrap;e.isXAxisTooltipEnabled&&(null===t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip")&&(e.xaxisTooltip=document.createElement("div"),e.xaxisTooltip.setAttribute("class",a+" apexcharts-theme-"+t.config.tooltip.theme),s.appendChild(e.xaxisTooltip),e.xaxisTooltipText=document.createElement("div"),e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"),e.xaxisTooltipText.style.fontFamily=t.config.xaxis.tooltip.style.fontFamily||t.config.chart.fontFamily,e.xaxisTooltipText.style.fontSize=t.config.xaxis.tooltip.style.fontSize,e.xaxisTooltip.appendChild(e.xaxisTooltipText)))}},{key:"drawYaxisTooltip",value:function(){for(var t=this.w,e=this.ttCtx,i=function(i){var a=t.config.yaxis[i].opposite||t.config.yaxis[i].crosshairs.opposite;e.yaxisOffX=a?t.globals.gridWidth+1:1;var s="apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i,a?" apexcharts-yaxistooltip-right":" apexcharts-yaxistooltip-left");t.globals.yAxisSameScaleIndices.map((function(e,a){e.map((function(e,a){a===i&&(s+=t.config.yaxis[a].show?" ":" apexcharts-yaxistooltip-hidden")}))}));var r=t.globals.dom.elWrap;null===t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i))&&(e.yaxisTooltip=document.createElement("div"),e.yaxisTooltip.setAttribute("class",s+" apexcharts-theme-"+t.config.tooltip.theme),r.appendChild(e.yaxisTooltip),0===i&&(e.yaxisTooltipText=[]),e.yaxisTooltipText[i]=document.createElement("div"),e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"),e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]))},a=0;a<t.config.yaxis.length;a++)i(a)}},{key:"setXCrosshairWidth",value:function(){var t=this.w,e=this.ttCtx,i=e.getElXCrosshairs();if(e.xcrosshairsWidth=parseInt(t.config.xaxis.crosshairs.width,10),t.globals.comboCharts){var a=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==a&&"barWidth"===t.config.xaxis.crosshairs.width){var s=parseFloat(a.getAttribute("barWidth"));e.xcrosshairsWidth=s}else if("tickWidth"===t.config.xaxis.crosshairs.width){var r=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/r}}else if("tickWidth"===t.config.xaxis.crosshairs.width){var o=t.globals.labels.length;e.xcrosshairsWidth=t.globals.gridWidth/o}else if("barWidth"===t.config.xaxis.crosshairs.width){var n=t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");if(null!==n){var l=parseFloat(n.getAttribute("barWidth"));e.xcrosshairsWidth=l}else e.xcrosshairsWidth=1}t.globals.isBarHorizontal&&(e.xcrosshairsWidth=0),null!==i&&e.xcrosshairsWidth>0&&i.setAttribute("width",e.xcrosshairsWidth)}},{key:"handleYCrosshair",value:function(){var t=this.w,e=this.ttCtx;e.ycrosshairs=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"),e.ycrosshairsHidden=t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden")}},{key:"drawYaxisTooltipText",value:function(t,e,i){var a=this.ttCtx,s=this.w,r=s.globals.yLabelFormatters[t];if(a.yaxisTooltips[t]){var o=a.getElGrid().getBoundingClientRect(),n=(e-o.top)*i.yRatio[t],l=s.globals.maxYArr[t]-s.globals.minYArr[t],h=s.globals.minYArr[t]+(l-n);a.tooltipPosition.moveYCrosshairs(e-o.top),a.yaxisTooltipText[t].innerHTML=r(h),a.tooltipPosition.moveYAxisTooltip(t)}}}]),t}(),mt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.tConfig=i.config.tooltip,this.tooltipUtil=new ut(this),this.tooltipLabels=new pt(this),this.tooltipPosition=new ft(this),this.marker=new xt(this),this.intersect=new bt(this),this.axesTooltip=new vt(this),this.showOnIntersect=this.tConfig.intersect,this.showTooltipTitle=this.tConfig.x.show,this.fixedTooltip=this.tConfig.fixed.enabled,this.xaxisTooltip=null,this.yaxisTTEls=null,this.isBarShared=!i.globals.isBarHorizontal&&this.tConfig.shared,this.lastHoverTime=Date.now()}return r(t,[{key:"getElTooltip",value:function(t){return t||(t=this),t.w.globals.dom.baseEl?t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip"):null}},{key:"getElXCrosshairs",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs")}},{key:"getElGrid",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid")}},{key:"drawTooltip",value:function(t){var e=this.w;this.xyRatios=t,this.isXAxisTooltipEnabled=e.config.xaxis.tooltip.enabled&&e.globals.axisCharts,this.yaxisTooltips=e.config.yaxis.map((function(t,i){return!!(t.show&&t.tooltip.enabled&&e.globals.axisCharts)})),this.allTooltipSeriesGroups=[],e.globals.axisCharts||(this.showTooltipTitle=!1);var i=document.createElement("div");if(i.classList.add("apexcharts-tooltip"),e.config.tooltip.cssClass&&i.classList.add(e.config.tooltip.cssClass),i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)),e.globals.dom.elWrap.appendChild(i),e.globals.axisCharts){this.axesTooltip.drawXaxisTooltip(),this.axesTooltip.drawYaxisTooltip(),this.axesTooltip.setXCrosshairWidth(),this.axesTooltip.handleYCrosshair();var a=new _(this.ctx);this.xAxisTicksPositions=a.getXAxisTicksPositions()}if(!e.globals.comboCharts&&!this.tConfig.intersect&&"rangeBar"!==e.config.chart.type||this.tConfig.shared||(this.showOnIntersect=!0),0!==e.config.markers.size&&0!==e.globals.markers.largestSize||this.marker.drawDynamicPoints(this),e.globals.collapsedSeries.length!==e.globals.series.length){this.dataPointsDividedHeight=e.globals.gridHeight/e.globals.dataPoints,this.dataPointsDividedWidth=e.globals.gridWidth/e.globals.dataPoints,this.showTooltipTitle&&(this.tooltipTitle=document.createElement("div"),this.tooltipTitle.classList.add("apexcharts-tooltip-title"),this.tooltipTitle.style.fontFamily=this.tConfig.style.fontFamily||e.config.chart.fontFamily,this.tooltipTitle.style.fontSize=this.tConfig.style.fontSize,i.appendChild(this.tooltipTitle));var s=e.globals.series.length;(e.globals.xyCharts||e.globals.comboCharts)&&this.tConfig.shared&&(s=this.showOnIntersect?1:e.globals.series.length),this.legendLabels=e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"),this.ttItems=this.createTTElements(s),this.addSVGEvents()}}},{key:"createTTElements",value:function(t){for(var e=this,i=this.w,a=[],s=this.getElTooltip(),r=function(r){var o=document.createElement("div");o.classList.add("apexcharts-tooltip-series-group"),o.style.order=i.config.tooltip.inverseOrder?t-r:r+1,e.tConfig.shared&&e.tConfig.enabledOnSeries&&Array.isArray(e.tConfig.enabledOnSeries)&&e.tConfig.enabledOnSeries.indexOf(r)<0&&o.classList.add("apexcharts-tooltip-series-group-hidden");var n=document.createElement("span");n.classList.add("apexcharts-tooltip-marker"),n.style.backgroundColor=i.globals.colors[r],o.appendChild(n);var l=document.createElement("div");l.classList.add("apexcharts-tooltip-text"),l.style.fontFamily=e.tConfig.style.fontFamily||i.config.chart.fontFamily,l.style.fontSize=e.tConfig.style.fontSize,["y","goals","z"].forEach((function(t){var e=document.createElement("div");e.classList.add("apexcharts-tooltip-".concat(t,"-group"));var i=document.createElement("span");i.classList.add("apexcharts-tooltip-text-".concat(t,"-label")),e.appendChild(i);var a=document.createElement("span");a.classList.add("apexcharts-tooltip-text-".concat(t,"-value")),e.appendChild(a),l.appendChild(e)})),o.appendChild(l),s.appendChild(o),a.push(o)},o=0;o<t;o++)r(o);return a}},{key:"addSVGEvents",value:function(){var t=this.w,e=t.config.chart.type,i=this.getElTooltip(),a=!("bar"!==e&&"candlestick"!==e&&"boxPlot"!==e&&"rangeBar"!==e),s="area"===e||"line"===e||"scatter"===e||"bubble"===e||"radar"===e,r=t.globals.dom.Paper.node,o=this.getElGrid();o&&(this.seriesBound=o.getBoundingClientRect());var n,l=[],h=[],c={hoverArea:r,elGrid:o,tooltipEl:i,tooltipY:l,tooltipX:h,ttItems:this.ttItems};if(t.globals.axisCharts&&(s?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker"):a?n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area"):"heatmap"!==e&&"treemap"!==e||(n=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")),n&&n.length))for(var d=0;d<n.length;d++)l.push(n[d].getAttribute("cy")),h.push(n[d].getAttribute("cx"));if(t.globals.xyCharts&&!this.showOnIntersect||t.globals.comboCharts&&!this.showOnIntersect||a&&this.tooltipUtil.hasBars()&&this.tConfig.shared)this.addPathsEventListeners([r],c);else if(a&&!t.globals.comboCharts||s&&this.showOnIntersect)this.addDatapointEventsListeners(c);else if(!t.globals.axisCharts||"heatmap"===e||"treemap"===e){var g=t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");this.addPathsEventListeners(g,c)}if(this.showOnIntersect){var u=t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");u.length>0&&this.addPathsEventListeners(u,c),this.tooltipUtil.hasBars()&&!this.tConfig.shared&&this.addDatapointEventsListeners(c)}}},{key:"drawFixedTooltipRect",value:function(){var t=this.w,e=this.getElTooltip(),i=e.getBoundingClientRect(),a=i.width+10,s=i.height+10,r=this.tConfig.fixed.offsetX,o=this.tConfig.fixed.offsetY,n=this.tConfig.fixed.position.toLowerCase();return n.indexOf("right")>-1&&(r=r+t.globals.svgWidth-a+10),n.indexOf("bottom")>-1&&(o=o+t.globals.svgHeight-s-10),e.style.left=r+"px",e.style.top=o+"px",{x:r,y:o,ttWidth:a,ttHeight:s}}},{key:"addDatapointEventsListeners",value:function(t){var e=this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");this.addPathsEventListeners(e,t)}},{key:"addPathsEventListeners",value:function(t,e){for(var i=this,a=function(a){var s={paths:t[a],tooltipEl:e.tooltipEl,tooltipY:e.tooltipY,tooltipX:e.tooltipX,elGrid:e.elGrid,hoverArea:e.hoverArea,ttItems:e.ttItems};["mousemove","mouseup","touchmove","mouseout","touchend"].map((function(e){return t[a].addEventListener(e,i.onSeriesHover.bind(i,s),{capture:!1,passive:!0})}))},s=0;s<t.length;s++)a(s)}},{key:"onSeriesHover",value:function(t,e){var i=this,a=Date.now()-this.lastHoverTime;a>=100?this.seriesHover(t,e):(clearTimeout(this.seriesHoverTimeout),this.seriesHoverTimeout=setTimeout((function(){i.seriesHover(t,e)}),100-a))}},{key:"seriesHover",value:function(t,e){var i=this;this.lastHoverTime=Date.now();var a=[],s=this.w;s.config.chart.group&&(a=this.ctx.getGroupedCharts()),s.globals.axisCharts&&(s.globals.minX===-1/0&&s.globals.maxX===1/0||0===s.globals.dataPoints)||(a.length?a.forEach((function(a){var s=i.getElTooltip(a),r={paths:t.paths,tooltipEl:s,tooltipY:t.tooltipY,tooltipX:t.tooltipX,elGrid:t.elGrid,hoverArea:t.hoverArea,ttItems:a.w.globals.tooltip.ttItems};a.w.globals.minX===i.w.globals.minX&&a.w.globals.maxX===i.w.globals.maxX&&a.w.globals.tooltip.seriesHoverByContext({chartCtx:a,ttCtx:a.w.globals.tooltip,opt:r,e:e})})):this.seriesHoverByContext({chartCtx:this.ctx,ttCtx:this.w.globals.tooltip,opt:t,e:e}))}},{key:"seriesHoverByContext",value:function(t){var e=t.chartCtx,i=t.ttCtx,a=t.opt,s=t.e,r=e.w,o=this.getElTooltip();if(o){if(i.tooltipRect={x:0,y:0,ttWidth:o.getBoundingClientRect().width,ttHeight:o.getBoundingClientRect().height},i.e=s,i.tooltipUtil.hasBars()&&!r.globals.comboCharts&&!i.isBarShared)if(this.tConfig.onDatasetHover.highlightDataSeries)new E(e).toggleSeriesOnHover(s,s.target.parentNode);i.fixedTooltip&&i.drawFixedTooltipRect(),r.globals.axisCharts?i.axisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect}):i.nonAxisChartsTooltips({e:s,opt:a,tooltipRect:i.tooltipRect})}}},{key:"axisChartsTooltips",value:function(t){var e,i,a=t.e,s=t.opt,r=this.w,o=s.elGrid.getBoundingClientRect(),n="touchmove"===a.type?a.touches[0].clientX:a.clientX,l="touchmove"===a.type?a.touches[0].clientY:a.clientY;if(this.clientY=l,this.clientX=n,r.globals.capturedSeriesIndex=-1,r.globals.capturedDataPointIndex=-1,l<o.top||l>o.top+o.height)this.handleMouseOut(s);else{if(Array.isArray(this.tConfig.enabledOnSeries)&&!r.config.tooltip.shared){var h=parseInt(s.paths.getAttribute("index"),10);if(this.tConfig.enabledOnSeries.indexOf(h)<0)return void this.handleMouseOut(s)}var c=this.getElTooltip(),d=this.getElXCrosshairs(),g=r.globals.xyCharts||"bar"===r.config.chart.type&&!r.globals.isBarHorizontal&&this.tooltipUtil.hasBars()&&this.tConfig.shared||r.globals.comboCharts&&this.tooltipUtil.hasBars();if("mousemove"===a.type||"touchmove"===a.type||"mouseup"===a.type){if(r.globals.collapsedSeries.length+r.globals.ancillaryCollapsedSeries.length===r.globals.series.length)return;null!==d&&d.classList.add("apexcharts-active");var u=this.yaxisTooltips.filter((function(t){return!0===t}));if(null!==this.ycrosshairs&&u.length&&this.ycrosshairs.classList.add("apexcharts-active"),g&&!this.showOnIntersect)this.handleStickyTooltip(a,n,l,s);else if("heatmap"===r.config.chart.type||"treemap"===r.config.chart.type){var p=this.intersect.handleHeatTreeTooltip({e:a,opt:s,x:e,y:i,type:r.config.chart.type});e=p.x,i=p.y,c.style.left=e+"px",c.style.top=i+"px"}else this.tooltipUtil.hasBars()&&this.intersect.handleBarTooltip({e:a,opt:s}),this.tooltipUtil.hasMarkers()&&this.intersect.handleMarkerTooltip({e:a,opt:s,x:e,y:i});if(this.yaxisTooltips.length)for(var f=0;f<r.config.yaxis.length;f++)this.axesTooltip.drawYaxisTooltipText(f,l,this.xyRatios);s.tooltipEl.classList.add("apexcharts-active")}else"mouseout"!==a.type&&"touchend"!==a.type||this.handleMouseOut(s)}}},{key:"nonAxisChartsTooltips",value:function(t){var e=t.e,i=t.opt,a=t.tooltipRect,s=this.w,r=i.paths.getAttribute("rel"),o=this.getElTooltip(),n=s.globals.dom.elWrap.getBoundingClientRect();if("mousemove"===e.type||"touchmove"===e.type){o.classList.add("apexcharts-active"),this.tooltipLabels.drawSeriesTexts({ttItems:i.ttItems,i:parseInt(r,10)-1,shared:!1});var l=s.globals.clientX-n.left-a.ttWidth/2,h=s.globals.clientY-n.top-a.ttHeight-10;if(o.style.left=l+"px",o.style.top=h+"px",s.config.legend.tooltipHoverFormatter){var c=r-1,d=(0,s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"),{seriesIndex:c,dataPointIndex:c,w:s});this.legendLabels[c].innerHTML=d}}else"mouseout"!==e.type&&"touchend"!==e.type||(o.classList.remove("apexcharts-active"),s.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)})))}},{key:"handleStickyTooltip",value:function(t,e,i,a){var s=this.w,r=this.tooltipUtil.getNearestValues({context:this,hoverArea:a.hoverArea,elGrid:a.elGrid,clientX:e,clientY:i}),o=r.j,n=r.capturedSeries,l=a.elGrid.getBoundingClientRect();r.hoverX<0||r.hoverX>l.width?this.handleMouseOut(a):null!==n?this.handleStickyCapturedSeries(t,n,a,o):(this.tooltipUtil.isXoverlap(o)||s.globals.isBarHorizontal)&&this.create(t,this,0,o,a.ttItems)}},{key:"handleStickyCapturedSeries",value:function(t,e,i,a){var s=this.w;if(!this.tConfig.shared&&null===s.globals.series[e][a])return void this.handleMouseOut(i);void 0!==s.globals.series[e][a]?this.tConfig.shared&&this.tooltipUtil.isXoverlap(a)&&this.tooltipUtil.isInitialSeriesSameLen()?this.create(t,this,e,a,i.ttItems):this.create(t,this,e,a,i.ttItems,!1):this.tooltipUtil.isXoverlap(a)&&this.create(t,this,0,a,i.ttItems)}},{key:"deactivateHoverFilter",value:function(){for(var t=this.w,e=new m(this.ctx),i=t.globals.dom.Paper.select(".apexcharts-bar-area"),a=0;a<i.length;a++)e.pathMouseLeave(i[a])}},{key:"handleMouseOut",value:function(t){var e=this.w,i=this.getElXCrosshairs();if(t.tooltipEl.classList.remove("apexcharts-active"),this.deactivateHoverFilter(),"bubble"!==e.config.chart.type&&this.marker.resetPointsSize(),null!==i&&i.classList.remove("apexcharts-active"),null!==this.ycrosshairs&&this.ycrosshairs.classList.remove("apexcharts-active"),this.isXAxisTooltipEnabled&&this.xaxisTooltip.classList.remove("apexcharts-active"),this.yaxisTooltips.length){null===this.yaxisTTEls&&(this.yaxisTTEls=e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));for(var a=0;a<this.yaxisTTEls.length;a++)this.yaxisTTEls[a].classList.remove("apexcharts-active")}e.config.legend.tooltipHoverFormatter&&this.legendLabels.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}))}},{key:"markerClick",value:function(t,e,i){var a=this.w;"function"==typeof a.config.chart.events.markerClick&&a.config.chart.events.markerClick(t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}),this.ctx.events.fireEvent("markerClick",[t,this.ctx,{seriesIndex:e,dataPointIndex:i,w:a}])}},{key:"create",value:function(t,e,i,a,s){var r=arguments.length>5&&void 0!==arguments[5]?arguments[5]:null,o=this.w,n=e;"mouseup"===t.type&&this.markerClick(t,i,a),null===r&&(r=this.tConfig.shared);var l=this.tooltipUtil.hasMarkers(),h=this.tooltipUtil.getElBars();if(o.config.legend.tooltipHoverFormatter){var c=o.config.legend.tooltipHoverFormatter,d=Array.from(this.legendLabels);d.forEach((function(t){var e=t.getAttribute("data:default-text");t.innerHTML=decodeURIComponent(e)}));for(var g=0;g<d.length;g++){var u=d[g],p=parseInt(u.getAttribute("i"),10),f=decodeURIComponent(u.getAttribute("data:default-text")),x=c(f,{seriesIndex:r?p:i,dataPointIndex:a,w:o});if(r)u.innerHTML=o.globals.collapsedSeriesIndices.indexOf(p)<0?x:f;else if(u.innerHTML=p===i?x:f,i===p)break}}if(r){if(n.tooltipLabels.drawSeriesTexts({ttItems:s,i:i,j:a,shared:!this.showOnIntersect&&this.tConfig.shared}),l&&(o.globals.markers.largestSize>0?n.marker.enlargePoints(a):n.tooltipPosition.moveDynamicPointsOnHover(a)),this.tooltipUtil.hasBars()&&(this.barSeriesHeight=this.tooltipUtil.getBarsHeight(h),this.barSeriesHeight>0)){var b=new m(this.ctx),v=o.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a,"']"));this.deactivateHoverFilter(),this.tooltipPosition.moveStickyTooltipOverBars(a);for(var y=0;y<v.length;y++)b.pathMouseEnter(v[y])}}else n.tooltipLabels.drawSeriesTexts({shared:!1,ttItems:s,i:i,j:a}),this.tooltipUtil.hasBars()&&n.tooltipPosition.moveStickyTooltipOverBars(a),l&&n.tooltipPosition.moveMarkers(i,a)}}]),t}(),yt=function(t){n(s,F);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i){var a=this,s=this.w;this.graphics=new m(this.ctx),this.bar=new F(this.ctx,this.xyRatios);var r=new y(this.ctx,s);t=r.getLogSeries(t),this.yRatio=r.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t),"100%"===s.config.chart.stackType&&(t=s.globals.seriesPercent.slice()),this.series=t,this.totalItems=0,this.prevY=[],this.prevX=[],this.prevYF=[],this.prevXF=[],this.prevYVal=[],this.prevXVal=[],this.xArrj=[],this.xArrjF=[],this.xArrjVal=[],this.yArrj=[],this.yArrjF=[],this.yArrjVal=[];for(var o=0;o<t.length;o++)t[o].length>0&&(this.totalItems+=t[o].length);for(var n=this.graphics.group({class:"apexcharts-bar-series apexcharts-plot-series"}),l=0,h=0,c=function(r,o){var c=void 0,d=void 0,g=void 0,u=void 0,p=[],f=[],b=s.globals.comboCharts?i[r]:r;a.yRatio.length>1&&(a.yaxisIndex=b),a.isReversed=s.config.yaxis[a.yaxisIndex]&&s.config.yaxis[a.yaxisIndex].reversed;var v=a.graphics.group({class:"apexcharts-series",seriesName:x.escapeString(s.globals.seriesNames[b]),rel:r+1,"data:realIndex":b});a.ctx.series.addCollapsedClassToSeries(v,b);var m=a.graphics.group({class:"apexcharts-datalabels","data:realIndex":b}),y=0,w=0,k=a.initialPositions(l,h,c,d,g,u);h=k.y,y=k.barHeight,d=k.yDivision,u=k.zeroW,l=k.x,w=k.barWidth,c=k.xDivision,g=k.zeroH,a.yArrj=[],a.yArrjF=[],a.yArrjVal=[],a.xArrj=[],a.xArrjF=[],a.xArrjVal=[],1===a.prevY.length&&a.prevY[0].every((function(t){return isNaN(t)}))&&(a.prevY[0]=a.prevY[0].map((function(t){return g})),a.prevYF[0]=a.prevYF[0].map((function(t){return 0})));for(var A=0;A<s.globals.dataPoints;A++){var S=a.barHelpers.getStrokeWidth(r,A,b),C={indexes:{i:r,j:A,realIndex:b,bc:o},strokeWidth:S,x:l,y:h,elSeries:v},L=null;a.isHorizontal?(L=a.drawStackedBarPaths(e(e({},C),{},{zeroW:u,barHeight:y,yDivision:d})),w=a.series[r][A]/a.invertedYRatio):(L=a.drawStackedColumnPaths(e(e({},C),{},{xDivision:c,barWidth:w,zeroH:g})),y=a.series[r][A]/a.yRatio[a.yaxisIndex]),h=L.y,l=L.x,p.push(l),f.push(h);var P=a.barHelpers.getPathFillColor(t,r,A,b);v=a.renderSeries({realIndex:b,pathFill:P,j:A,i:r,pathFrom:L.pathFrom,pathTo:L.pathTo,strokeWidth:S,elSeries:v,x:l,y:h,series:t,barHeight:y,barWidth:w,elDataLabelsWrap:m,type:"bar",visibleSeries:0})}s.globals.seriesXvalues[b]=p,s.globals.seriesYvalues[b]=f,a.prevY.push(a.yArrj),a.prevYF.push(a.yArrjF),a.prevYVal.push(a.yArrjVal),a.prevX.push(a.xArrj),a.prevXF.push(a.xArrjF),a.prevXVal.push(a.xArrjVal),n.add(v)},d=0,g=0;d<t.length;d++,g++)c(d,g);return n}},{key:"initialPositions",value:function(t,e,i,a,s,r){var o,n,l=this.w;return this.isHorizontal?(o=(o=a=l.globals.gridHeight/l.globals.dataPoints)*parseInt(l.config.plotOptions.bar.barHeight,10)/100,r=this.baseLineInvertedY+l.globals.padHorizontal+(this.isReversed?l.globals.gridWidth:0)-(this.isReversed?2*this.baseLineInvertedY:0),e=(a-o)/2):(n=i=l.globals.gridWidth/l.globals.dataPoints,n=l.globals.isXNumeric&&l.globals.dataPoints>1?(i=l.globals.minXDiff/this.xRatio)*parseInt(this.barOptions.columnWidth,10)/100:n*parseInt(l.config.plotOptions.bar.columnWidth,10)/100,s=this.baseLineY[this.yaxisIndex]+(this.isReversed?l.globals.gridHeight:0)-(this.isReversed?2*this.baseLineY[this.yaxisIndex]:0),t=l.globals.padHorizontal+(i-n)/2),{x:t,y:e,yDivision:a,xDivision:i,barHeight:o,barWidth:n,zeroH:s,zeroW:r}}},{key:"drawStackedBarPaths",value:function(t){for(var e,i=t.indexes,a=t.barHeight,s=t.strokeWidth,r=t.zeroW,o=t.x,n=t.y,l=t.yDivision,h=t.elSeries,c=this.w,d=n,g=i.i,u=i.j,p=0,f=0;f<this.prevXF.length;f++)p+=this.prevXF[f][u];if(g>0){var x=r;this.prevXVal[g-1][u]<0?x=this.series[g][u]>=0?this.prevX[g-1][u]+p-2*(this.isReversed?p:0):this.prevX[g-1][u]:this.prevXVal[g-1][u]>=0&&(x=this.series[g][u]>=0?this.prevX[g-1][u]:this.prevX[g-1][u]-p+2*(this.isReversed?p:0)),e=x}else e=r;o=null===this.series[g][u]?e:e+this.series[g][u]/this.invertedYRatio-2*(this.isReversed?this.series[g][u]/this.invertedYRatio:0);var b=this.barHelpers.getBarpaths({barYPosition:d,barHeight:a,x1:e,x2:o,strokeWidth:s,series:this.series,realIndex:i.realIndex,i:g,j:u,w:c});return this.barHelpers.barBackground({j:u,i:g,y1:d,y2:a,elSeries:h}),n+=l,{pathTo:b.pathTo,pathFrom:b.pathFrom,x:o,y:n}}},{key:"drawStackedColumnPaths",value:function(t){var e=t.indexes,i=t.x,a=t.y,s=t.xDivision,r=t.barWidth,o=t.zeroH;t.strokeWidth;var n=t.elSeries,l=this.w,h=e.i,c=e.j,d=e.bc;if(l.globals.isXNumeric){var g=l.globals.seriesX[h][c];g||(g=0),i=(g-l.globals.minX)/this.xRatio-r/2}for(var u,p=i,f=0,x=0;x<this.prevYF.length;x++)f+=isNaN(this.prevYF[x][c])?0:this.prevYF[x][c];if(h>0&&!l.globals.isXNumeric||h>0&&l.globals.isXNumeric&&l.globals.seriesX[h-1][c]===l.globals.seriesX[h][c]){var b,v,m=Math.min(this.yRatio.length+1,h+1);if(void 0!==this.prevY[h-1])for(var y=1;y<m;y++)if(!isNaN(this.prevY[h-y][c])){v=this.prevY[h-y][c];break}for(var w=1;w<m;w++){if(this.prevYVal[h-w][c]<0){b=this.series[h][c]>=0?v-f+2*(this.isReversed?f:0):v;break}if(this.prevYVal[h-w][c]>=0){b=this.series[h][c]>=0?v:v+f-2*(this.isReversed?f:0);break}}void 0===b&&(b=l.globals.gridHeight),u=this.prevYF[0].every((function(t){return 0===t}))&&this.prevYF.slice(1,h).every((function(t){return t.every((function(t){return isNaN(t)}))}))?l.globals.gridHeight-o:b}else u=l.globals.gridHeight-o;a=u-this.series[h][c]/this.yRatio[this.yaxisIndex]+2*(this.isReversed?this.series[h][c]/this.yRatio[this.yaxisIndex]:0);var k=this.barHelpers.getColumnPaths({barXPosition:p,barWidth:r,y1:u,y2:a,yRatio:this.yRatio[this.yaxisIndex],strokeWidth:this.strokeWidth,series:this.series,realIndex:e.realIndex,i:h,j:c,w:l});return this.barHelpers.barBackground({bc:d,j:c,i:h,x1:p,x2:r,elSeries:n}),i+=s,{pathTo:k.pathTo,pathFrom:k.pathFrom,x:l.globals.isXNumeric?i-s:i,y:a}}}]),s}(),wt=function(t){n(s,F);var i=d(s);function s(){return a(this,s),i.apply(this,arguments)}return r(s,[{key:"draw",value:function(t,i){var a=this,s=this.w,r=new m(this.ctx),o=new M(this.ctx);this.candlestickOptions=this.w.config.plotOptions.candlestick,this.boxOptions=this.w.config.plotOptions.boxPlot,this.isHorizontal=s.config.plotOptions.bar.horizontal;var n=new y(this.ctx,s);t=n.getLogSeries(t),this.series=t,this.yRatio=n.getLogYRatios(this.yRatio),this.barHelpers.initVariables(t);for(var l=r.group({class:"apexcharts-".concat(s.config.chart.type,"-series apexcharts-plot-series")}),h=function(n){a.isBoxPlot="boxPlot"===s.config.chart.type||"boxPlot"===s.config.series[n].type;var h,c,d,g,u=void 0,p=void 0,f=[],b=[],v=s.globals.comboCharts?i[n]:n,m=r.group({class:"apexcharts-series",seriesName:x.escapeString(s.globals.seriesNames[v]),rel:n+1,"data:realIndex":v});a.ctx.series.addCollapsedClassToSeries(m,v),t[n].length>0&&(a.visibleI=a.visibleI+1);var y,w;a.yRatio.length>1&&(a.yaxisIndex=v);var k=a.barHelpers.initialPositions();p=k.y,y=k.barHeight,c=k.yDivision,g=k.zeroW,u=k.x,w=k.barWidth,h=k.xDivision,d=k.zeroH,b.push(u+w/2);for(var A=r.group({class:"apexcharts-datalabels","data:realIndex":v}),S=function(i){var r=a.barHelpers.getStrokeWidth(n,i,v),l=null,x={indexes:{i:n,j:i,realIndex:v},x:u,y:p,strokeWidth:r,elSeries:m};l=a.isHorizontal?a.drawHorizontalBoxPaths(e(e({},x),{},{yDivision:c,barHeight:y,zeroW:g})):a.drawVerticalBoxPaths(e(e({},x),{},{xDivision:h,barWidth:w,zeroH:d})),p=l.y,u=l.x,i>0&&b.push(u+w/2),f.push(p),l.pathTo.forEach((function(e,h){var c=!a.isBoxPlot&&a.candlestickOptions.wick.useFillColor?l.color[h]:s.globals.stroke.colors[n],d=o.fillPath({seriesNumber:v,dataPointIndex:i,color:l.color[h],value:t[n][i]});a.renderSeries({realIndex:v,pathFill:d,lineFill:c,j:i,i:n,pathFrom:l.pathFrom,pathTo:e,strokeWidth:r,elSeries:m,x:u,y:p,series:t,barHeight:y,barWidth:w,elDataLabelsWrap:A,visibleSeries:a.visibleI,type:s.config.chart.type})}))},C=0;C<s.globals.dataPoints;C++)S(C);s.globals.seriesXvalues[v]=b,s.globals.seriesYvalues[v]=f,l.add(m)},c=0;c<t.length;c++)h(c);return l}},{key:"drawVerticalBoxPaths",value:function(t){var e=t.indexes,i=t.x;t.y;var a=t.xDivision,s=t.barWidth,r=t.zeroH,o=t.strokeWidth,n=this.w,l=new m(this.ctx),h=e.i,c=e.j,d=!0,g=n.config.plotOptions.candlestick.colors.upward,u=n.config.plotOptions.candlestick.colors.downward,p="";this.isBoxPlot&&(p=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var f=this.yRatio[this.yaxisIndex],x=e.realIndex,b=this.getOHLCValue(x,c),v=r,y=r;b.o>b.c&&(d=!1);var w=Math.min(b.o,b.c),k=Math.max(b.o,b.c),A=b.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[x][c]-n.globals.minX)/this.xRatio-s/2);var S=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(w=r,k=r):(w=r-w/f,k=r-k/f,v=r-b.h/f,y=r-b.l/f,A=r-b.m/f);var C=l.move(S,r),L=l.move(S+s/2,w);return n.globals.previousPaths.length>0&&(L=this.getPreviousPath(x,c,!0)),C=this.isBoxPlot?[l.move(S,w)+l.line(S+s/2,w)+l.line(S+s/2,v)+l.line(S+s/4,v)+l.line(S+s-s/4,v)+l.line(S+s/2,v)+l.line(S+s/2,w)+l.line(S+s,w)+l.line(S+s,A)+l.line(S,A)+l.line(S,w+o/2),l.move(S,A)+l.line(S+s,A)+l.line(S+s,k)+l.line(S+s/2,k)+l.line(S+s/2,y)+l.line(S+s-s/4,y)+l.line(S+s/4,y)+l.line(S+s/2,y)+l.line(S+s/2,k)+l.line(S,k)+l.line(S,A)+"z"]:[l.move(S,k)+l.line(S+s/2,k)+l.line(S+s/2,v)+l.line(S+s/2,k)+l.line(S+s,k)+l.line(S+s,w)+l.line(S+s/2,w)+l.line(S+s/2,y)+l.line(S+s/2,w)+l.line(S,w)+l.line(S,k-o/2)],L+=l.move(S,w),n.globals.isXNumeric||(i+=a),{pathTo:C,pathFrom:L,x:i,y:k,barXPosition:S,color:this.isBoxPlot?p:d?[g]:[u]}}},{key:"drawHorizontalBoxPaths",value:function(t){var e=t.indexes;t.x;var i=t.y,a=t.yDivision,s=t.barHeight,r=t.zeroW,o=t.strokeWidth,n=this.w,l=new m(this.ctx),h=e.i,c=e.j,d=this.boxOptions.colors.lower;this.isBoxPlot&&(d=[this.boxOptions.colors.lower,this.boxOptions.colors.upper]);var g=this.invertedYRatio,u=e.realIndex,p=this.getOHLCValue(u,c),f=r,x=r,b=Math.min(p.o,p.c),v=Math.max(p.o,p.c),y=p.m;n.globals.isXNumeric&&(i=(n.globals.seriesX[u][c]-n.globals.minX)/this.invertedXRatio-s/2);var w=i+s*this.visibleI;void 0===this.series[h][c]||null===this.series[h][c]?(b=r,v=r):(b=r+b/g,v=r+v/g,f=r+p.h/g,x=r+p.l/g,y=r+p.m/g);var k=l.move(r,w),A=l.move(b,w+s/2);return n.globals.previousPaths.length>0&&(A=this.getPreviousPath(u,c,!0)),k=[l.move(b,w)+l.line(b,w+s/2)+l.line(f,w+s/2)+l.line(f,w+s/2-s/4)+l.line(f,w+s/2+s/4)+l.line(f,w+s/2)+l.line(b,w+s/2)+l.line(b,w+s)+l.line(y,w+s)+l.line(y,w)+l.line(b+o/2,w),l.move(y,w)+l.line(y,w+s)+l.line(v,w+s)+l.line(v,w+s/2)+l.line(x,w+s/2)+l.line(x,w+s-s/4)+l.line(x,w+s/4)+l.line(x,w+s/2)+l.line(v,w+s/2)+l.line(v,w)+l.line(y,w)+"z"],A+=l.move(b,w),n.globals.isXNumeric||(i+=a),{pathTo:k,pathFrom:A,x:v,y:i,barYPosition:w,color:d}}},{key:"getOHLCValue",value:function(t,e){var i=this.w;return{o:this.isBoxPlot?i.globals.seriesCandleH[t][e]:i.globals.seriesCandleO[t][e],h:this.isBoxPlot?i.globals.seriesCandleO[t][e]:i.globals.seriesCandleH[t][e],m:i.globals.seriesCandleM[t][e],l:this.isBoxPlot?i.globals.seriesCandleC[t][e]:i.globals.seriesCandleL[t][e],c:this.isBoxPlot?i.globals.seriesCandleL[t][e]:i.globals.seriesCandleC[t][e]}}}]),s}(),kt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"checkColorRange",value:function(){var t=this.w,e=!1,i=t.config.plotOptions[t.config.chart.type];return i.colorScale.ranges.length>0&&i.colorScale.ranges.map((function(t,i){t.from<=0&&(e=!0)})),e}},{key:"getShadeColor",value:function(t,e,i,a){var s=this.w,r=1,o=s.config.plotOptions[t].shadeIntensity,n=this.determineColor(t,e,i);s.globals.hasNegs||a?r=s.config.plotOptions[t].reverseNegativeShade?n.percent<0?n.percent/100*(1.25*o):(1-n.percent/100)*(1.25*o):n.percent<=0?1-(1+n.percent/100)*o:(1-n.percent/100)*o:(r=1-n.percent/100,"treemap"===t&&(r=(1-n.percent/100)*(1.25*o)));var l=n.color,h=new x;return s.config.plotOptions[t].enableShades&&(l="dark"===this.w.config.theme.mode?x.hexToRgba(h.shadeColor(-1*r,n.color),s.config.fill.opacity):x.hexToRgba(h.shadeColor(r,n.color),s.config.fill.opacity)),{color:l,colorProps:n}}},{key:"determineColor",value:function(t,e,i){var a=this.w,s=a.globals.series[e][i],r=a.config.plotOptions[t],o=r.colorScale.inverse?i:e;r.distributed&&"treemap"===a.config.chart.type&&(o=i);var n=a.globals.colors[o],l=null,h=Math.min.apply(Math,u(a.globals.series[e])),c=Math.max.apply(Math,u(a.globals.series[e]));r.distributed||"heatmap"!==t||(h=a.globals.minY,c=a.globals.maxY),void 0!==r.colorScale.min&&(h=r.colorScale.min<a.globals.minY?r.colorScale.min:a.globals.minY,c=r.colorScale.max>a.globals.maxY?r.colorScale.max:a.globals.maxY);var d=Math.abs(c)+Math.abs(h),g=100*s/(0===d?d-1e-6:d);r.colorScale.ranges.length>0&&r.colorScale.ranges.map((function(t,e){if(s>=t.from&&s<=t.to){n=t.color,l=t.foreColor?t.foreColor:null,h=t.from,c=t.to;var i=Math.abs(c)+Math.abs(h);g=100*s/(0===i?i-1e-6:i)}}));return{color:n,foreColor:l,percent:g}}},{key:"calculateDataLabels",value:function(t){var e=t.text,i=t.x,a=t.y,s=t.i,r=t.j,o=t.colorProps,n=t.fontSize,l=this.w.config.dataLabels,h=new m(this.ctx),c=new z(this.ctx),d=null;if(l.enabled){d=h.group({class:"apexcharts-data-labels"});var g=l.offsetX,u=l.offsetY,p=i+g,f=a+parseFloat(l.style.fontSize)/3+u;c.plotDataLabelsText({x:p,y:f,text:e,i:s,j:r,color:o.foreColor,parent:d,fontSize:n,dataLabelsConfig:l})}return d}},{key:"addListeners",value:function(t){var e=new m(this.ctx);t.node.addEventListener("mouseenter",e.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",e.pathMouseLeave.bind(this,t)),t.node.addEventListener("mousedown",e.pathMouseDown.bind(this,t))}}]),t}(),At=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w,this.xRatio=i.xRatio,this.yRatio=i.yRatio,this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.helpers=new kt(e),this.rectRadius=this.w.config.plotOptions.heatmap.radius,this.strokeWidth=this.w.config.stroke.show?this.w.config.stroke.width:0}return r(t,[{key:"draw",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-heatmap"});a.attr("clip-path","url(#gridRectMask".concat(e.globals.cuid,")"));var s=e.globals.gridWidth/e.globals.dataPoints,r=e.globals.gridHeight/e.globals.series.length,o=0,n=!1;this.negRange=this.helpers.checkColorRange();var l=t.slice();e.config.yaxis[0].reversed&&(n=!0,l.reverse());for(var h=n?0:l.length-1;n?h<l.length:h>=0;n?h++:h--){var c=i.group({class:"apexcharts-series apexcharts-heatmap-series",seriesName:x.escapeString(e.globals.seriesNames[h]),rel:h+1,"data:realIndex":h});if(this.ctx.series.addCollapsedClassToSeries(c,h),e.config.chart.dropShadow.enabled){var d=e.config.chart.dropShadow;new v(this.ctx).dropShadow(c,d,h)}for(var g=0,u=e.config.plotOptions.heatmap.shadeIntensity,p=0;p<l[h].length;p++){var f=this.helpers.getShadeColor(e.config.chart.type,h,p,this.negRange),b=f.color,y=f.colorProps;if("image"===e.config.fill.type)b=new M(this.ctx).fillPath({seriesNumber:h,dataPointIndex:p,opacity:e.globals.hasNegs?y.percent<0?1-(1+y.percent/100):u+y.percent/100:y.percent/100,patternID:x.randomId(),width:e.config.fill.image.width?e.config.fill.image.width:s,height:e.config.fill.image.height?e.config.fill.image.height:r});var w=this.rectRadius,k=i.drawRect(g,o,s,r,w);if(k.attr({cx:g,cy:o}),k.node.classList.add("apexcharts-heatmap-rect"),c.add(k),k.attr({fill:b,i:h,index:h,j:p,val:l[h][p],"stroke-width":this.strokeWidth,stroke:e.config.plotOptions.heatmap.useFillColorAsStroke?b:e.globals.stroke.colors[0],color:b}),this.helpers.addListeners(k),e.config.chart.animations.enabled&&!e.globals.dataChanged){var A=1;e.globals.resized||(A=e.config.chart.animations.speed),this.animateHeatMap(k,g,o,s,r,A)}if(e.globals.dataChanged){var S=1;if(this.dynamicAnim.enabled&&e.globals.shouldAnimate){S=this.dynamicAnim.speed;var C=e.globals.previousPaths[h]&&e.globals.previousPaths[h][p]&&e.globals.previousPaths[h][p].color;C||(C="rgba(255, 255, 255, 0)"),this.animateHeatColor(k,x.isColorHex(C)?C:x.rgb2hex(C),x.isColorHex(b)?b:x.rgb2hex(b),S)}}var L=(0,e.config.dataLabels.formatter)(e.globals.series[h][p],{value:e.globals.series[h][p],seriesIndex:h,dataPointIndex:p,w:e}),P=this.helpers.calculateDataLabels({text:L,x:g+s/2,y:o+r/2,i:h,j:p,colorProps:y,series:l});null!==P&&c.add(P),g+=s}o+=r,a.add(c)}var T=e.globals.yAxisScale[0].result.slice();e.config.yaxis[0].reversed?T.unshift(""):T.push(""),e.globals.yAxisScale[0].result=T;var I=e.globals.gridHeight/e.globals.series.length;return e.config.yaxis[0].labels.offsetY=-I/2,a}},{key:"animateHeatMap",value:function(t,e,i,a,s,r){var o=new b(this.ctx);o.animateRect(t,{x:e+a/2,y:i+s/2,width:0,height:0},{x:e,y:i,width:a,height:s},r,(function(){o.animationCompleted(t)}))}},{key:"animateHeatColor",value:function(t,e,i,a){t.attr({fill:e}).animate(a).attr({fill:i})}}]),t}(),St=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"drawYAxisTexts",value:function(t,e,i,a){var s=this.w,r=s.config.yaxis[0],o=s.globals.yLabelFormatters[0];return new m(this.ctx).drawText({x:t+r.labels.offsetX,y:e+r.labels.offsetY,text:o(a,i),textAnchor:"middle",fontSize:r.labels.style.fontSize,fontFamily:r.labels.style.fontFamily,foreColor:Array.isArray(r.labels.style.colors)?r.labels.style.colors[i]:r.labels.style.colors})}}]),t}(),Ct=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w;var i=this.w;this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animBeginArr=[0],this.animDur=0,this.donutDataLabels=this.w.config.plotOptions.pie.donut.labels,this.lineColorArr=void 0!==i.globals.stroke.colors?i.globals.stroke.colors:i.globals.colors,this.defaultSize=Math.min(i.globals.gridWidth,i.globals.gridHeight),this.centerY=this.defaultSize/2,this.centerX=i.globals.gridWidth/2,"radialBar"===i.config.chart.type?this.fullAngle=360:this.fullAngle=Math.abs(i.config.plotOptions.pie.endAngle-i.config.plotOptions.pie.startAngle),this.initialAngle=i.config.plotOptions.pie.startAngle%this.fullAngle,i.globals.radialSize=this.defaultSize/2.05-i.config.stroke.width-(i.config.chart.sparkline.enabled?0:i.config.chart.dropShadow.blur),this.donutSize=i.globals.radialSize*parseInt(i.config.plotOptions.pie.donut.size,10)/100,this.maxY=0,this.sliceLabels=[],this.sliceSizes=[],this.prevSectorAngleArr=[]}return r(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new m(this.ctx);if(this.ret=a.group({class:"apexcharts-pie"}),i.globals.noData)return this.ret;for(var s=0,r=0;r<t.length;r++)s+=x.negToZero(t[r]);var o=[],n=a.group();0===s&&(s=1e-5),t.forEach((function(t){e.maxY=Math.max(e.maxY,t)})),i.config.yaxis[0].max&&(this.maxY=i.config.yaxis[0].max),"back"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(this.ret);for(var l=0;l<t.length;l++){var h=this.fullAngle*x.negToZero(t[l])/s;o.push(h),"polarArea"===this.chartType?(o[l]=this.fullAngle/t.length,this.sliceSizes.push(i.globals.radialSize*t[l]/this.maxY)):this.sliceSizes.push(i.globals.radialSize)}if(i.globals.dataChanged){for(var c,d=0,g=0;g<i.globals.previousPaths.length;g++)d+=x.negToZero(i.globals.previousPaths[g]);for(var u=0;u<i.globals.previousPaths.length;u++)c=this.fullAngle*x.negToZero(i.globals.previousPaths[u])/d,this.prevSectorAngleArr.push(c)}this.donutSize<0&&(this.donutSize=0);var p=i.config.plotOptions.pie.customScale,f=i.globals.gridWidth/2,b=i.globals.gridHeight/2,v=f-i.globals.gridWidth/2*p,y=b-i.globals.gridHeight/2*p;if("donut"===this.chartType){var w=a.drawCircle(this.donutSize);w.attr({cx:this.centerX,cy:this.centerY,fill:i.config.plotOptions.pie.donut.background?i.config.plotOptions.pie.donut.background:"transparent"}),n.add(w)}var k=this.drawArcs(o,t);if(this.sliceLabels.forEach((function(t){k.add(t)})),n.attr({transform:"translate(".concat(v,", ").concat(y,") scale(").concat(p,")")}),n.add(k),this.ret.add(n),this.donutDataLabels.show){var A=this.renderInnerDataLabels(this.donutDataLabels,{hollowSize:this.donutSize,centerX:this.centerX,centerY:this.centerY,opacity:this.donutDataLabels.show,translateX:v,translateY:y});this.ret.add(A)}return"front"===i.config.grid.position&&"polarArea"===this.chartType&&this.drawPolarElements(this.ret),this.ret}},{key:"drawArcs",value:function(t,e){var i=this.w,a=new v(this.ctx),s=new m(this.ctx),r=new M(this.ctx),o=s.group({class:"apexcharts-slices"}),n=this.initialAngle,l=this.initialAngle,h=this.initialAngle,c=this.initialAngle;this.strokeWidth=i.config.stroke.show?i.config.stroke.width:0;for(var d=0;d<t.length;d++){var g=s.group({class:"apexcharts-series apexcharts-pie-series",seriesName:x.escapeString(i.globals.seriesNames[d]),rel:d+1,"data:realIndex":d});o.add(g),l=c,h=(n=h)+t[d],c=l+this.prevSectorAngleArr[d];var u=h<n?this.fullAngle+h-n:h-n,p=r.fillPath({seriesNumber:d,size:this.sliceSizes[d],value:e[d]}),f=this.getChangedPath(l,c),b=s.drawPath({d:f,stroke:Array.isArray(this.lineColorArr)?this.lineColorArr[d]:this.lineColorArr,strokeWidth:0,fill:p,fillOpacity:i.config.fill.opacity,classes:"apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(),"-slice-").concat(d)});if(b.attr({index:0,j:d}),a.setSelectionFilter(b,0,d),i.config.chart.dropShadow.enabled){var y=i.config.chart.dropShadow;a.dropShadow(b,y,d)}this.addListeners(b,this.donutDataLabels),m.setAttrs(b.node,{"data:angle":u,"data:startAngle":n,"data:strokeWidth":this.strokeWidth,"data:value":e[d]});var w={x:0,y:0};"pie"===this.chartType||"polarArea"===this.chartType?w=x.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize/1.25+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle):"donut"===this.chartType&&(w=x.polarToCartesian(this.centerX,this.centerY,(i.globals.radialSize+this.donutSize)/2+i.config.plotOptions.pie.dataLabels.offset,(n+u/2)%this.fullAngle)),g.add(b);var k=0;if(!this.initialAnim||i.globals.resized||i.globals.dataChanged?this.animBeginArr.push(0):(0===(k=u/this.fullAngle*i.config.chart.animations.speed)&&(k=1),this.animDur=k+this.animDur,this.animBeginArr.push(this.animDur)),this.dynamicAnim&&i.globals.dataChanged?this.animatePaths(b,{size:this.sliceSizes[d],endAngle:h,startAngle:n,prevStartAngle:l,prevEndAngle:c,animateStartingPos:!0,i:d,animBeginArr:this.animBeginArr,shouldSetPrevPaths:!0,dur:i.config.chart.animations.dynamicAnimation.speed}):this.animatePaths(b,{size:this.sliceSizes[d],endAngle:h,startAngle:n,i:d,totalItems:t.length-1,animBeginArr:this.animBeginArr,dur:k}),i.config.plotOptions.pie.expandOnClick&&"polarArea"!==this.chartType&&b.click(this.pieClicked.bind(this,d)),void 0!==i.globals.selectedDataPoints[0]&&i.globals.selectedDataPoints[0].indexOf(d)>-1&&this.pieClicked(d),i.config.dataLabels.enabled){var A=w.x,S=w.y,C=100*u/this.fullAngle+"%";if(0!==u&&i.config.plotOptions.pie.dataLabels.minAngleToShowLabel<t[d]){var L=i.config.dataLabels.formatter;void 0!==L&&(C=L(i.globals.seriesPercent[d][0],{seriesIndex:d,w:i}));var P=i.globals.dataLabels.style.colors[d],T=s.group({class:"apexcharts-datalabels"}),I=s.drawText({x:A,y:S,text:C,textAnchor:"middle",fontSize:i.config.dataLabels.style.fontSize,fontFamily:i.config.dataLabels.style.fontFamily,fontWeight:i.config.dataLabels.style.fontWeight,foreColor:P});if(T.add(I),i.config.dataLabels.dropShadow.enabled){var z=i.config.dataLabels.dropShadow;a.dropShadow(I,z)}I.node.classList.add("apexcharts-pie-label"),i.config.chart.animations.animate&&!1===i.globals.resized&&(I.node.classList.add("apexcharts-pie-label-delay"),I.node.style.animationDelay=i.config.chart.animations.speed/940+"s"),this.sliceLabels.push(T)}}}return o}},{key:"addListeners",value:function(t,e){var i=new m(this.ctx);t.node.addEventListener("mouseenter",i.pathMouseEnter.bind(this,t)),t.node.addEventListener("mouseleave",i.pathMouseLeave.bind(this,t)),t.node.addEventListener("mouseleave",this.revertDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",i.pathMouseDown.bind(this,t)),this.donutDataLabels.total.showAlways||(t.node.addEventListener("mouseenter",this.printDataLabelsInner.bind(this,t.node,e)),t.node.addEventListener("mousedown",this.printDataLabelsInner.bind(this,t.node,e)))}},{key:"animatePaths",value:function(t,e){var i=this.w,a=e.endAngle<e.startAngle?this.fullAngle+e.endAngle-e.startAngle:e.endAngle-e.startAngle,s=a,r=e.startAngle,o=e.startAngle;void 0!==e.prevStartAngle&&void 0!==e.prevEndAngle&&(r=e.prevEndAngle,s=e.prevEndAngle<e.prevStartAngle?this.fullAngle+e.prevEndAngle-e.prevStartAngle:e.prevEndAngle-e.prevStartAngle),e.i===i.config.series.length-1&&(a+o>this.fullAngle?e.endAngle=e.endAngle-(a+o):a+o<this.fullAngle&&(e.endAngle=e.endAngle+(this.fullAngle-(a+o)))),a===this.fullAngle&&(a=this.fullAngle-.01),this.animateArc(t,r,o,a,s,e)}},{key:"animateArc",value:function(t,e,i,a,s,r){var o,n=this,l=this.w,h=new b(this.ctx),c=r.size;(isNaN(e)||isNaN(s))&&(e=i,s=a,r.dur=0);var d=a,g=i,u=e<i?this.fullAngle+e-i:e-i;l.globals.dataChanged&&r.shouldSetPrevPaths&&r.prevEndAngle&&(o=n.getPiePath({me:n,startAngle:r.prevStartAngle,angle:r.prevEndAngle<r.prevStartAngle?this.fullAngle+r.prevEndAngle-r.prevStartAngle:r.prevEndAngle-r.prevStartAngle,size:c}),t.attr({d:o})),0!==r.dur?t.animate(r.dur,l.globals.easing,r.animBeginArr[r.i]).afterAll((function(){"pie"!==n.chartType&&"donut"!==n.chartType&&"polarArea"!==n.chartType||this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({"stroke-width":n.strokeWidth}),r.i===l.config.series.length-1&&h.animationCompleted(t)})).during((function(l){d=u+(a-u)*l,r.animateStartingPos&&(d=s+(a-s)*l,g=e-s+(i-(e-s))*l),o=n.getPiePath({me:n,startAngle:g,angle:d,size:c}),t.node.setAttribute("data:pathOrig",o),t.attr({d:o})})):(o=n.getPiePath({me:n,startAngle:g,angle:a,size:c}),r.isTrack||(l.globals.animationEnded=!0),t.node.setAttribute("data:pathOrig",o),t.attr({d:o,"stroke-width":n.strokeWidth}))}},{key:"pieClicked",value:function(t){var e,i=this.w,a=this,s=a.sliceSizes[t]+(i.config.plotOptions.pie.expandOnClick?4:0),r=i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(),"-slice-").concat(t)).members[0];if("true"!==r.attr("data:pieClicked")){var o=i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");Array.prototype.forEach.call(o,(function(t){t.setAttribute("data:pieClicked","false");var e=t.getAttribute("data:pathOrig");t.setAttribute("d",e)})),r.attr("data:pieClicked","true");var n=parseInt(r.attr("data:startAngle"),10),l=parseInt(r.attr("data:angle"),10);e=a.getPiePath({me:a,startAngle:n,angle:l,size:s}),360!==l&&r.plot(e)}else{r.attr({"data:pieClicked":"false"}),this.revertDataLabelsInner(r.node,this.donutDataLabels);var h=r.attr("data:pathOrig");r.attr({d:h})}}},{key:"getChangedPath",value:function(t,e){var i="";return this.dynamicAnim&&this.w.globals.dataChanged&&(i=this.getPiePath({me:this,startAngle:t,angle:e-t,size:this.size})),i}},{key:"getPiePath",value:function(t){var e=t.me,i=t.startAngle,a=t.angle,s=t.size,r=i,o=Math.PI*(r-90)/180,n=a+i;Math.ceil(n)>=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle&&(n=this.fullAngle+this.w.config.plotOptions.pie.startAngle%this.fullAngle-.01),Math.ceil(n)>this.fullAngle&&(n-=this.fullAngle);var l=Math.PI*(n-90)/180,h=e.centerX+s*Math.cos(o),c=e.centerY+s*Math.sin(o),d=e.centerX+s*Math.cos(l),g=e.centerY+s*Math.sin(l),u=x.polarToCartesian(e.centerX,e.centerY,e.donutSize,n),p=x.polarToCartesian(e.centerX,e.centerY,e.donutSize,r),f=a>180?1:0,b=["M",h,c,"A",s,s,0,f,1,d,g];return"donut"===e.chartType?[].concat(b,["L",u.x,u.y,"A",e.donutSize,e.donutSize,0,f,0,p.x,p.y,"L",h,c,"z"]).join(" "):"pie"===e.chartType||"polarArea"===e.chartType?[].concat(b,["L",e.centerX,e.centerY,"L",h,c]).join(" "):[].concat(b).join(" ")}},{key:"drawPolarElements",value:function(t){var e=this.w,i=new q(this.ctx),a=new m(this.ctx),s=new St(this.ctx),r=a.group(),o=a.group(),n=i.niceScale(0,Math.ceil(this.maxY),e.config.yaxis[0].tickAmount,0,!0),l=n.result.reverse(),h=n.result.length;this.maxY=n.niceMax;for(var c=e.globals.radialSize,d=c/(h-1),g=0;g<h-1;g++){var u=a.drawCircle(c);if(u.attr({cx:this.centerX,cy:this.centerY,fill:"none","stroke-width":e.config.plotOptions.polarArea.rings.strokeWidth,stroke:e.config.plotOptions.polarArea.rings.strokeColor}),e.config.yaxis[0].show){var p=s.drawYAxisTexts(this.centerX,this.centerY-c+parseInt(e.config.yaxis[0].labels.style.fontSize,10)/2,g,l[g]);o.add(p)}r.add(u),c-=d}this.drawSpokes(t),t.add(r),t.add(o)}},{key:"renderInnerDataLabels",value:function(t,e){var i=this.w,a=new m(this.ctx),s=a.group({class:"apexcharts-datalabels-group",transform:"translate(".concat(e.translateX?e.translateX:0,", ").concat(e.translateY?e.translateY:0,") scale(").concat(i.config.plotOptions.pie.customScale,")")}),r=t.total.show;s.node.style.opacity=e.opacity;var o,n,l=e.centerX,h=e.centerY;o=void 0===t.name.color?i.globals.colors[0]:t.name.color;var c=t.name.fontSize,d=t.name.fontFamily,g=t.name.fontWeight;n=void 0===t.value.color?i.config.chart.foreColor:t.value.color;var u=t.value.formatter,p="",f="";if(r?(o=t.total.color,c=t.total.fontSize,d=t.total.fontFamily,g=t.total.fontWeight,f=t.total.label,p=t.total.formatter(i)):1===i.globals.series.length&&(p=u(i.globals.series[0],i),f=i.globals.seriesNames[0]),f&&(f=t.name.formatter(f,t.total.show,i)),t.name.show){var x=a.drawText({x:l,y:h+parseFloat(t.name.offsetY),text:f,textAnchor:"middle",foreColor:o,fontSize:c,fontWeight:g,fontFamily:d});x.node.classList.add("apexcharts-datalabel-label"),s.add(x)}if(t.value.show){var b=t.name.show?parseFloat(t.value.offsetY)+16:t.value.offsetY,v=a.drawText({x:l,y:h+b,text:p,textAnchor:"middle",foreColor:n,fontWeight:t.value.fontWeight,fontSize:t.value.fontSize,fontFamily:t.value.fontFamily});v.node.classList.add("apexcharts-datalabel-value"),s.add(v)}return s}},{key:"printInnerLabels",value:function(t,e,i,a){var s,r=this.w;a?s=void 0===t.name.color?r.globals.colors[parseInt(a.parentNode.getAttribute("rel"),10)-1]:t.name.color:r.globals.series.length>1&&t.total.show&&(s=t.total.color);var o=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"),n=r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");i=(0,t.value.formatter)(i,r),a||"function"!=typeof t.total.formatter||(i=t.total.formatter(r));var l=e===t.total.label;e=t.name.formatter(e,l,r),null!==o&&(o.textContent=e),null!==n&&(n.textContent=i),null!==o&&(o.style.fill=s)}},{key:"printDataLabelsInner",value:function(t,e){var i=this.w,a=t.getAttribute("data:value"),s=i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"),10)-1];i.globals.series.length>1&&this.printInnerLabels(e,s,a,t);var r=i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");null!==r&&(r.style.opacity=1)}},{key:"drawSpokes",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=i.config.plotOptions.polarArea.spokes;if(0!==s.strokeWidth){for(var r=[],o=360/i.globals.series.length,n=0;n<i.globals.series.length;n++)r.push(x.polarToCartesian(this.centerX,this.centerY,i.globals.radialSize,i.config.plotOptions.pie.startAngle+o*n));r.forEach((function(i,r){var o=a.drawLine(i.x,i.y,e.centerX,e.centerY,Array.isArray(s.connectorColors)?s.connectorColors[r]:s.connectorColors);t.add(o)}))}}},{key:"revertDataLabelsInner",value:function(t,e,i){var a=this,s=this.w,r=s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"),o=!1,n=s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"),l=function(t){var i=t.makeSliceOut,s=t.printLabel;Array.prototype.forEach.call(n,(function(t){"true"===t.getAttribute("data:pieClicked")&&(i&&(o=!0),s&&a.printDataLabelsInner(t,e))}))};if(l({makeSliceOut:!0,printLabel:!1}),e.total.show&&s.globals.series.length>1)o&&!e.total.showAlways?l({makeSliceOut:!1,printLabel:!0}):this.printInnerLabels(e,e.total.label,e.total.formatter(s));else if(l({makeSliceOut:!1,printLabel:!0}),!o)if(s.globals.selectedDataPoints.length&&s.globals.series.length>1)if(s.globals.selectedDataPoints[0].length>0){var h=s.globals.selectedDataPoints[0],c=s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(),"-slice-").concat(h));this.printDataLabelsInner(c,e)}else r&&s.globals.selectedDataPoints.length&&0===s.globals.selectedDataPoints[0].length&&(r.style.opacity=0);else r&&s.globals.series.length>1&&(r.style.opacity=0)}}]),t}(),Lt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.chartType=this.w.config.chart.type,this.initialAnim=this.w.config.chart.animations.enabled,this.dynamicAnim=this.initialAnim&&this.w.config.chart.animations.dynamicAnimation.enabled,this.animDur=0;var i=this.w;this.graphics=new m(this.ctx),this.lineColorArr=void 0!==i.globals.stroke.colors?i.globals.stroke.colors:i.globals.colors,this.defaultSize=i.globals.svgHeight<i.globals.svgWidth?i.globals.gridHeight+1.5*i.globals.goldenPadding:i.globals.gridWidth,this.isLog=i.config.yaxis[0].logarithmic,this.coreUtils=new y(this.ctx),this.maxValue=this.isLog?this.coreUtils.getLogVal(i.globals.maxY,0):i.globals.maxY,this.minValue=this.isLog?this.coreUtils.getLogVal(this.w.globals.minY,0):i.globals.minY,this.polygons=i.config.plotOptions.radar.polygons,this.strokeWidth=i.config.stroke.show?i.config.stroke.width:0,this.size=this.defaultSize/2.1-this.strokeWidth-i.config.chart.dropShadow.blur,i.config.xaxis.labels.show&&(this.size=this.size-i.globals.xAxisLabelsWidth/1.75),void 0!==i.config.plotOptions.radar.size&&(this.size=i.config.plotOptions.radar.size),this.dataRadiusOfPercent=[],this.dataRadius=[],this.angleArr=[],this.yaxisLabelsTextsPos=[]}return r(t,[{key:"draw",value:function(t){var i=this,a=this.w,s=new M(this.ctx),r=[],o=new z(this.ctx);t.length&&(this.dataPointsLen=t[a.globals.maxValsInArrayIndex].length),this.disAngle=2*Math.PI/this.dataPointsLen;var n=a.globals.gridWidth/2,l=a.globals.gridHeight/2,h=n+a.config.plotOptions.radar.offsetX,c=l+a.config.plotOptions.radar.offsetY,d=this.graphics.group({class:"apexcharts-radar-series apexcharts-plot-series",transform:"translate(".concat(h||0,", ").concat(c||0,")")}),g=[],u=null,p=null;if(this.yaxisLabels=this.graphics.group({class:"apexcharts-yaxis"}),t.forEach((function(t,n){var l=t.length===a.globals.dataPoints,h=i.graphics.group().attr({class:"apexcharts-series","data:longestSeries":l,seriesName:x.escapeString(a.globals.seriesNames[n]),rel:n+1,"data:realIndex":n});i.dataRadiusOfPercent[n]=[],i.dataRadius[n]=[],i.angleArr[n]=[],t.forEach((function(t,e){var a=Math.abs(i.maxValue-i.minValue);t+=Math.abs(i.minValue),i.isLog&&(t=i.coreUtils.getLogVal(t,0)),i.dataRadiusOfPercent[n][e]=t/a,i.dataRadius[n][e]=i.dataRadiusOfPercent[n][e]*i.size,i.angleArr[n][e]=e*i.disAngle})),g=i.getDataPointsPos(i.dataRadius[n],i.angleArr[n]);var c=i.createPaths(g,{x:0,y:0});u=i.graphics.group({class:"apexcharts-series-markers-wrap apexcharts-element-hidden"}),p=i.graphics.group({class:"apexcharts-datalabels","data:realIndex":n}),a.globals.delayedElements.push({el:u.node,index:n});var d={i:n,realIndex:n,animationDelay:n,initialSpeed:a.config.chart.animations.speed,dataChangeSpeed:a.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-radar",shouldClipToGrid:!1,bindEventsOnPaths:!1,stroke:a.globals.stroke.colors[n],strokeLineCap:a.config.stroke.lineCap},f=null;a.globals.previousPaths.length>0&&(f=i.getPreviousPath(n));for(var b=0;b<c.linePathsTo.length;b++){var m=i.graphics.renderPaths(e(e({},d),{},{pathFrom:null===f?c.linePathsFrom[b]:f,pathTo:c.linePathsTo[b],strokeWidth:Array.isArray(i.strokeWidth)?i.strokeWidth[n]:i.strokeWidth,fill:"none",drawShadow:!1}));h.add(m);var y=s.fillPath({seriesNumber:n}),w=i.graphics.renderPaths(e(e({},d),{},{pathFrom:null===f?c.areaPathsFrom[b]:f,pathTo:c.areaPathsTo[b],strokeWidth:0,fill:y,drawShadow:!1}));if(a.config.chart.dropShadow.enabled){var k=new v(i.ctx),A=a.config.chart.dropShadow;k.dropShadow(w,Object.assign({},A,{noUserSpaceOnUse:!0}),n)}h.add(w)}t.forEach((function(t,s){var r=new T(i.ctx).getMarkerConfig({cssClass:"apexcharts-marker",seriesIndex:n,dataPointIndex:s}),l=i.graphics.drawMarker(g[s].x,g[s].y,r);l.attr("rel",s),l.attr("j",s),l.attr("index",n),l.node.setAttribute("default-marker-size",r.pSize);var c=i.graphics.group({class:"apexcharts-series-markers"});c&&c.add(l),u.add(c),h.add(u);var d=a.config.dataLabels;if(d.enabled){var f=d.formatter(a.globals.series[n][s],{seriesIndex:n,dataPointIndex:s,w:a});o.plotDataLabelsText({x:g[s].x,y:g[s].y,text:f,textAnchor:"middle",i:n,j:n,parent:p,offsetCorrection:!1,dataLabelsConfig:e({},d)})}h.add(p)})),r.push(h)})),this.drawPolygons({parent:d}),a.config.xaxis.labels.show){var f=this.drawXAxisTexts();d.add(f)}return r.forEach((function(t){d.add(t)})),d.add(this.yaxisLabels),d}},{key:"drawPolygons",value:function(t){for(var e=this,i=this.w,a=t.parent,s=new St(this.ctx),r=i.globals.yAxisScale[0].result.reverse(),o=r.length,n=[],l=this.size/(o-1),h=0;h<o;h++)n[h]=l*h;n.reverse();var c=[],d=[];n.forEach((function(t,i){var a=x.getPolygonPos(t,e.dataPointsLen),s="";a.forEach((function(t,a){if(0===i){var r=e.graphics.drawLine(t.x,t.y,0,0,Array.isArray(e.polygons.connectorColors)?e.polygons.connectorColors[a]:e.polygons.connectorColors);d.push(r)}0===a&&e.yaxisLabelsTextsPos.push({x:t.x,y:t.y}),s+=t.x+","+t.y+" "})),c.push(s)})),c.forEach((function(t,s){var r=e.polygons.strokeColors,o=e.polygons.strokeWidth,n=e.graphics.drawPolygon(t,Array.isArray(r)?r[s]:r,Array.isArray(o)?o[s]:o,i.globals.radarPolygons.fill.colors[s]);a.add(n)})),d.forEach((function(t){a.add(t)})),i.config.yaxis[0].show&&this.yaxisLabelsTextsPos.forEach((function(t,i){var a=s.drawYAxisTexts(t.x,t.y,i,r[i]);e.yaxisLabels.add(a)}))}},{key:"drawXAxisTexts",value:function(){var t=this,i=this.w,a=i.config.xaxis.labels,s=this.graphics.group({class:"apexcharts-xaxis"}),r=x.getPolygonPos(this.size,this.dataPointsLen);return i.globals.labels.forEach((function(o,n){var l=i.config.xaxis.labels.formatter,h=new z(t.ctx);if(r[n]){var c=t.getTextPos(r[n],t.size),d=l(o,{seriesIndex:-1,dataPointIndex:n,w:i});h.plotDataLabelsText({x:c.newX,y:c.newY,text:d,textAnchor:c.textAnchor,i:n,j:n,parent:s,color:Array.isArray(a.style.colors)&&a.style.colors[n]?a.style.colors[n]:"#a8a8a8",dataLabelsConfig:e({textAnchor:c.textAnchor,dropShadow:{enabled:!1}},a),offsetCorrection:!1})}})),s}},{key:"createPaths",value:function(t,e){var i=this,a=[],s=[],r=[],o=[];if(t.length){s=[this.graphics.move(e.x,e.y)],o=[this.graphics.move(e.x,e.y)];var n=this.graphics.move(t[0].x,t[0].y),l=this.graphics.move(t[0].x,t[0].y);t.forEach((function(e,a){n+=i.graphics.line(e.x,e.y),l+=i.graphics.line(e.x,e.y),a===t.length-1&&(n+="Z",l+="Z")})),a.push(n),r.push(l)}return{linePathsFrom:s,linePathsTo:a,areaPathsFrom:o,areaPathsTo:r}}},{key:"getTextPos",value:function(t,e){var i="middle",a=t.x,s=t.y;return Math.abs(t.x)>=10?t.x>0?(i="start",a+=10):t.x<0&&(i="end",a-=10):i="middle",Math.abs(t.y)>=e-10&&(t.y<0?s-=10:t.y>0&&(s+=10)),{textAnchor:i,newX:a,newY:s}}},{key:"getPreviousPath",value:function(t){for(var e=this.w,i=null,a=0;a<e.globals.previousPaths.length;a++){var s=e.globals.previousPaths[a];s.paths.length>0&&parseInt(s.realIndex,10)===parseInt(t,10)&&void 0!==e.globals.previousPaths[a].paths[0]&&(i=e.globals.previousPaths[a].paths[0].d)}return i}},{key:"getDataPointsPos",value:function(t,e){var i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:this.dataPointsLen;t=t||[],e=e||[];for(var a=[],s=0;s<i;s++){var r={};r.x=t[s]*Math.sin(e[s]),r.y=-t[s]*Math.cos(e[s]),a.push(r)}return a}}]),t}(),Pt=function(t){n(i,Ct);var e=d(i);function i(t){var s;a(this,i),(s=e.call(this,t)).ctx=t,s.w=t.w,s.animBeginArr=[0],s.animDur=0;var r=s.w;return s.startAngle=r.config.plotOptions.radialBar.startAngle,s.endAngle=r.config.plotOptions.radialBar.endAngle,s.totalAngle=Math.abs(r.config.plotOptions.radialBar.endAngle-r.config.plotOptions.radialBar.startAngle),s.trackStartAngle=r.config.plotOptions.radialBar.track.startAngle,s.trackEndAngle=r.config.plotOptions.radialBar.track.endAngle,s.donutDataLabels=s.w.config.plotOptions.radialBar.dataLabels,s.radialDataLabels=s.donutDataLabels,s.trackStartAngle||(s.trackStartAngle=s.startAngle),s.trackEndAngle||(s.trackEndAngle=s.endAngle),360===s.endAngle&&(s.endAngle=359.99),s.margin=parseInt(r.config.plotOptions.radialBar.track.margin,10),s}return r(i,[{key:"draw",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-radialbar"});if(e.globals.noData)return a;var s=i.group(),r=this.defaultSize/2,o=e.globals.gridWidth/2,n=this.defaultSize/2.05;e.config.chart.sparkline.enabled||(n=n-e.config.stroke.width-e.config.chart.dropShadow.blur);var l=e.globals.fill.colors;if(e.config.plotOptions.radialBar.track.show){var h=this.drawTracks({size:n,centerX:o,centerY:r,colorArr:l,series:t});s.add(h)}var c=this.drawArcs({size:n,centerX:o,centerY:r,colorArr:l,series:t}),d=360;e.config.plotOptions.radialBar.startAngle<0&&(d=this.totalAngle);var g=(360-d)/360;if(e.globals.radialSize=n-n*g,this.radialDataLabels.value.show){var u=Math.max(this.radialDataLabels.value.offsetY,this.radialDataLabels.name.offsetY);e.globals.radialSize+=u*g}return s.add(c.g),"front"===e.config.plotOptions.radialBar.hollow.position&&(c.g.add(c.elHollow),c.dataLabels&&c.g.add(c.dataLabels)),a.add(s),a}},{key:"drawTracks",value:function(t){var e=this.w,i=new m(this.ctx),a=i.group({class:"apexcharts-tracks"}),s=new v(this.ctx),r=new M(this.ctx),o=this.getStrokeWidth(t);t.size=t.size-o/2;for(var n=0;n<t.series.length;n++){var l=i.group({class:"apexcharts-radialbar-track apexcharts-track"});a.add(l),l.attr({rel:n+1}),t.size=t.size-o-this.margin;var h=e.config.plotOptions.radialBar.track,c=r.fillPath({seriesNumber:0,size:t.size,fillColors:Array.isArray(h.background)?h.background[n]:h.background,solid:!0}),d=this.trackStartAngle,g=this.trackEndAngle;Math.abs(g)+Math.abs(d)>=360&&(g=360-Math.abs(this.startAngle)-.1);var u=i.drawPath({d:"",stroke:c,strokeWidth:o*parseInt(h.strokeWidth,10)/100,fill:"none",strokeOpacity:h.opacity,classes:"apexcharts-radialbar-area"});if(h.dropShadow.enabled){var p=h.dropShadow;s.dropShadow(u,p)}l.add(u),u.attr("id","apexcharts-radialbarTrack-"+n),this.animatePaths(u,{centerX:t.centerX,centerY:t.centerY,endAngle:g,startAngle:d,size:t.size,i:n,totalItems:2,animBeginArr:0,dur:0,isTrack:!0,easing:e.globals.easing})}return a}},{key:"drawArcs",value:function(t){var e=this.w,i=new m(this.ctx),a=new M(this.ctx),s=new v(this.ctx),r=i.group(),o=this.getStrokeWidth(t);t.size=t.size-o/2;var n=e.config.plotOptions.radialBar.hollow.background,l=t.size-o*t.series.length-this.margin*t.series.length-o*parseInt(e.config.plotOptions.radialBar.track.strokeWidth,10)/100/2,h=l-e.config.plotOptions.radialBar.hollow.margin;void 0!==e.config.plotOptions.radialBar.hollow.image&&(n=this.drawHollowImage(t,r,l,n));var c=this.drawHollow({size:h,centerX:t.centerX,centerY:t.centerY,fill:n||"transparent"});if(e.config.plotOptions.radialBar.hollow.dropShadow.enabled){var d=e.config.plotOptions.radialBar.hollow.dropShadow;s.dropShadow(c,d)}var g=1;!this.radialDataLabels.total.show&&e.globals.series.length>1&&(g=0);var u=null;this.radialDataLabels.show&&(u=this.renderInnerDataLabels(this.radialDataLabels,{hollowSize:l,centerX:t.centerX,centerY:t.centerY,opacity:g})),"back"===e.config.plotOptions.radialBar.hollow.position&&(r.add(c),u&&r.add(u));var p=!1;e.config.plotOptions.radialBar.inverseOrder&&(p=!0);for(var f=p?t.series.length-1:0;p?f>=0:f<t.series.length;p?f--:f++){var b=i.group({class:"apexcharts-series apexcharts-radial-series",seriesName:x.escapeString(e.globals.seriesNames[f])});r.add(b),b.attr({rel:f+1,"data:realIndex":f}),this.ctx.series.addCollapsedClassToSeries(b,f),t.size=t.size-o-this.margin;var y=a.fillPath({seriesNumber:f,size:t.size,value:t.series[f]}),w=this.startAngle,k=void 0,A=x.negToZero(t.series[f]>100?100:t.series[f])/100,S=Math.round(this.totalAngle*A)+this.startAngle,C=void 0;e.globals.dataChanged&&(k=this.startAngle,C=Math.round(this.totalAngle*x.negToZero(e.globals.previousPaths[f])/100)+k),Math.abs(S)+Math.abs(w)>=360&&(S-=.01),Math.abs(C)+Math.abs(k)>=360&&(C-=.01);var L=S-w,P=Array.isArray(e.config.stroke.dashArray)?e.config.stroke.dashArray[f]:e.config.stroke.dashArray,T=i.drawPath({d:"",stroke:y,strokeWidth:o,fill:"none",fillOpacity:e.config.fill.opacity,classes:"apexcharts-radialbar-area apexcharts-radialbar-slice-"+f,strokeDashArray:P});if(m.setAttrs(T.node,{"data:angle":L,"data:value":t.series[f]}),e.config.chart.dropShadow.enabled){var I=e.config.chart.dropShadow;s.dropShadow(T,I,f)}s.setSelectionFilter(T,0,f),this.addListeners(T,this.radialDataLabels),b.add(T),T.attr({index:0,j:f});var z=0;!this.initialAnim||e.globals.resized||e.globals.dataChanged||(z=e.config.chart.animations.speed),e.globals.dataChanged&&(z=e.config.chart.animations.dynamicAnimation.speed),this.animDur=z/(1.2*t.series.length)+this.animDur,this.animBeginArr.push(this.animDur),this.animatePaths(T,{centerX:t.centerX,centerY:t.centerY,endAngle:S,startAngle:w,prevEndAngle:C,prevStartAngle:k,size:t.size,i:f,totalItems:2,animBeginArr:this.animBeginArr,dur:z,shouldSetPrevPaths:!0,easing:e.globals.easing})}return{g:r,elHollow:c,dataLabels:u}}},{key:"drawHollow",value:function(t){var e=new m(this.ctx).drawCircle(2*t.size);return e.attr({class:"apexcharts-radialbar-hollow",cx:t.centerX,cy:t.centerY,r:t.size,fill:t.fill}),e}},{key:"drawHollowImage",value:function(t,e,i,a){var s=this.w,r=new M(this.ctx),o=x.randomId(),n=s.config.plotOptions.radialBar.hollow.image;if(s.config.plotOptions.radialBar.hollow.imageClipped)r.clippedImgArea({width:i,height:i,image:n,patternID:"pattern".concat(s.globals.cuid).concat(o)}),a="url(#pattern".concat(s.globals.cuid).concat(o,")");else{var l=s.config.plotOptions.radialBar.hollow.imageWidth,h=s.config.plotOptions.radialBar.hollow.imageHeight;if(void 0===l&&void 0===h){var c=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-e.width/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-e.height/2+s.config.plotOptions.radialBar.hollow.imageOffsetY)}));e.add(c)}else{var d=s.globals.dom.Paper.image(n).loaded((function(e){this.move(t.centerX-l/2+s.config.plotOptions.radialBar.hollow.imageOffsetX,t.centerY-h/2+s.config.plotOptions.radialBar.hollow.imageOffsetY),this.size(l,h)}));e.add(d)}}return a}},{key:"getStrokeWidth",value:function(t){var e=this.w;return t.size*(100-parseInt(e.config.plotOptions.radialBar.hollow.size,10))/100/(t.series.length+1)-this.margin}}]),i}(),Mt=function(){function t(e){a(this,t),this.w=e.w,this.lineCtx=e}return r(t,[{key:"sameValueSeriesFix",value:function(t,e){var i=this.w;if("line"===i.config.chart.type&&("gradient"===i.config.fill.type||"gradient"===i.config.fill.type[t])&&new y(this.lineCtx.ctx,i).seriesHaveSameValues(t)){var a=e[t].slice();a[a.length-1]=a[a.length-1]+1e-6,e[t]=a}return e}},{key:"calculatePoints",value:function(t){var e=t.series,i=t.realIndex,a=t.x,s=t.y,r=t.i,o=t.j,n=t.prevY,l=this.w,h=[],c=[];if(0===o){var d=this.lineCtx.categoryAxisCorrection+l.config.markers.offsetX;l.globals.isXNumeric&&(d=(l.globals.seriesX[i][0]-l.globals.minX)/this.lineCtx.xRatio+l.config.markers.offsetX),h.push(d),c.push(x.isNumber(e[r][0])?n+l.config.markers.offsetY:null),h.push(a+l.config.markers.offsetX),c.push(x.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null)}else h.push(a+l.config.markers.offsetX),c.push(x.isNumber(e[r][o+1])?s+l.config.markers.offsetY:null);return{x:h,y:c}}},{key:"checkPreviousPaths",value:function(t){for(var e=t.pathFromLine,i=t.pathFromArea,a=t.realIndex,s=this.w,r=0;r<s.globals.previousPaths.length;r++){var o=s.globals.previousPaths[r];("line"===o.type||"area"===o.type)&&o.paths.length>0&&parseInt(o.realIndex,10)===parseInt(a,10)&&("line"===o.type?(this.lineCtx.appendPathFrom=!1,e=s.globals.previousPaths[r].paths[0].d):"area"===o.type&&(this.lineCtx.appendPathFrom=!1,i=s.globals.previousPaths[r].paths[0].d,s.config.stroke.show&&s.globals.previousPaths[r].paths[1]&&(e=s.globals.previousPaths[r].paths[1].d)))}return{pathFromLine:e,pathFromArea:i}}},{key:"determineFirstPrevY",value:function(t){var e=t.i,i=t.series,a=t.prevY,s=t.lineYPosition,r=this.w;if(void 0!==i[e][0])a=(s=r.config.chart.stacked&&e>0?this.lineCtx.prevSeriesY[e-1][0]:this.lineCtx.zeroY)-i[e][0]/this.lineCtx.yRatio[this.lineCtx.yaxisIndex]+2*(this.lineCtx.isReversed?i[e][0]/this.lineCtx.yRatio[this.lineCtx.yaxisIndex]:0);else if(r.config.chart.stacked&&e>0&&void 0===i[e][0])for(var o=e-1;o>=0;o--)if(null!==i[o][0]&&void 0!==i[o][0]){a=s=this.lineCtx.prevSeriesY[o][0];break}return{prevY:a,lineYPosition:s}}}]),t}(),Tt=function(){function t(e,i,s){a(this,t),this.ctx=e,this.w=e.w,this.xyRatios=i,this.pointsChart=!("bubble"!==this.w.config.chart.type&&"scatter"!==this.w.config.chart.type)||s,this.scatter=new I(this.ctx),this.noNegatives=this.w.globals.minX===Number.MAX_VALUE,this.lineHelpers=new Mt(this),this.markers=new T(this.ctx),this.prevSeriesY=[],this.categoryAxisCorrection=0,this.yaxisIndex=0}return r(t,[{key:"draw",value:function(t,e,i){var a=this.w,s=new m(this.ctx),r=a.globals.comboCharts?e:a.config.chart.type,o=s.group({class:"apexcharts-".concat(r,"-series apexcharts-plot-series")}),n=new y(this.ctx,a);this.yRatio=this.xyRatios.yRatio,this.zRatio=this.xyRatios.zRatio,this.xRatio=this.xyRatios.xRatio,this.baseLineY=this.xyRatios.baseLineY,t=n.getLogSeries(t),this.yRatio=n.getLogYRatios(this.yRatio);for(var l=[],h=0;h<t.length;h++){t=this.lineHelpers.sameValueSeriesFix(h,t);var c=a.globals.comboCharts?i[h]:h;this._initSerieVariables(t,h,c);var d=[],g=[],u=a.globals.padHorizontal+this.categoryAxisCorrection;this.ctx.series.addCollapsedClassToSeries(this.elSeries,c),a.globals.isXNumeric&&a.globals.seriesX.length>0&&(u=(a.globals.seriesX[c][0]-a.globals.minX)/this.xRatio),g.push(u);var p,f=u,x=f,b=this.zeroY;b=this.lineHelpers.determineFirstPrevY({i:h,series:t,prevY:b,lineYPosition:0}).prevY,d.push(b),p=b;var v=this._calculatePathsFrom({series:t,i:h,realIndex:c,prevX:x,prevY:b}),w=this._iterateOverDataPoints({series:t,realIndex:c,i:h,x:u,y:1,pX:f,pY:p,pathsFrom:v,linePaths:[],areaPaths:[],seriesIndex:i,lineYPosition:0,xArrj:g,yArrj:d});this._handlePaths({type:r,realIndex:c,i:h,paths:w}),this.elSeries.add(this.elPointsMain),this.elSeries.add(this.elDataLabelsWrap),l.push(this.elSeries)}if(a.config.chart.stacked)for(var k=l.length;k>0;k--)o.add(l[k-1]);else for(var A=0;A<l.length;A++)o.add(l[A]);return o}},{key:"_initSerieVariables",value:function(t,e,i){var a=this.w,s=new m(this.ctx);this.xDivision=a.globals.gridWidth/(a.globals.dataPoints-("on"===a.config.xaxis.tickPlacement?1:0)),this.strokeWidth=Array.isArray(a.config.stroke.width)?a.config.stroke.width[i]:a.config.stroke.width,this.yRatio.length>1&&(this.yaxisIndex=i),this.isReversed=a.config.yaxis[this.yaxisIndex]&&a.config.yaxis[this.yaxisIndex].reversed,this.zeroY=a.globals.gridHeight-this.baseLineY[this.yaxisIndex]-(this.isReversed?a.globals.gridHeight:0)+(this.isReversed?2*this.baseLineY[this.yaxisIndex]:0),this.areaBottomY=this.zeroY,(this.zeroY>a.globals.gridHeight||"end"===a.config.plotOptions.area.fillTo)&&(this.areaBottomY=a.globals.gridHeight),this.categoryAxisCorrection=this.xDivision/2,this.elSeries=s.group({class:"apexcharts-series",seriesName:x.escapeString(a.globals.seriesNames[i])}),this.elPointsMain=s.group({class:"apexcharts-series-markers-wrap","data:realIndex":i}),this.elDataLabelsWrap=s.group({class:"apexcharts-datalabels","data:realIndex":i});var r=t[e].length===a.globals.dataPoints;this.elSeries.attr({"data:longestSeries":r,rel:e+1,"data:realIndex":i}),this.appendPathFrom=!0}},{key:"_calculatePathsFrom",value:function(t){var e,i,a,s,r=t.series,o=t.i,n=t.realIndex,l=t.prevX,h=t.prevY,c=this.w,d=new m(this.ctx);if(null===r[o][0]){for(var g=0;g<r[o].length;g++)if(null!==r[o][g]){l=this.xDivision*g,h=this.zeroY-r[o][g]/this.yRatio[this.yaxisIndex],e=d.move(l,h),i=d.move(l,this.areaBottomY);break}}else e=d.move(l,h),i=d.move(l,this.areaBottomY)+d.line(l,h);if(a=d.move(-1,this.zeroY)+d.line(-1,this.zeroY),s=d.move(-1,this.zeroY)+d.line(-1,this.zeroY),c.globals.previousPaths.length>0){var u=this.lineHelpers.checkPreviousPaths({pathFromLine:a,pathFromArea:s,realIndex:n});a=u.pathFromLine,s=u.pathFromArea}return{prevX:l,prevY:h,linePath:e,areaPath:i,pathFromLine:a,pathFromArea:s}}},{key:"_handlePaths",value:function(t){var i=t.type,a=t.realIndex,s=t.i,r=t.paths,o=this.w,n=new m(this.ctx),l=new M(this.ctx);this.prevSeriesY.push(r.yArrj),o.globals.seriesXvalues[a]=r.xArrj,o.globals.seriesYvalues[a]=r.yArrj;var h=o.config.forecastDataPoints;if(h.count>0){var c=o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length-h.count-1],d=n.drawRect(c,0,o.globals.gridWidth,o.globals.gridHeight,0);o.globals.dom.elForecastMask.appendChild(d.node);var g=n.drawRect(0,0,c,o.globals.gridHeight,0);o.globals.dom.elNonForecastMask.appendChild(g.node)}this.pointsChart||o.globals.delayedElements.push({el:this.elPointsMain.node,index:a});var u={i:s,realIndex:a,animationDelay:s,initialSpeed:o.config.chart.animations.speed,dataChangeSpeed:o.config.chart.animations.dynamicAnimation.speed,className:"apexcharts-".concat(i)};if("area"===i)for(var p=l.fillPath({seriesNumber:a}),f=0;f<r.areaPaths.length;f++){var x=n.renderPaths(e(e({},u),{},{pathFrom:r.pathFromArea,pathTo:r.areaPaths[f],stroke:"none",strokeWidth:0,strokeLineCap:null,fill:p}));this.elSeries.add(x)}if(o.config.stroke.show&&!this.pointsChart){var b=null;if("line"===i)b=l.fillPath({seriesNumber:a,i:s});else if("solid"===o.config.stroke.fill.type)b=o.globals.stroke.colors[a];else{var v=o.config.fill;o.config.fill=o.config.stroke.fill,b=l.fillPath({seriesNumber:a,i:s}),o.config.fill=v}for(var y=0;y<r.linePaths.length;y++){var w=e(e({},u),{},{pathFrom:r.pathFromLine,pathTo:r.linePaths[y],stroke:b,strokeWidth:this.strokeWidth,strokeLineCap:o.config.stroke.lineCap,fill:"none"}),k=n.renderPaths(w);if(this.elSeries.add(k),h.count>0){var A=n.renderPaths(w);A.node.setAttribute("stroke-dasharray",h.dashArray),h.strokeWidth&&A.node.setAttribute("stroke-width",h.strokeWidth),this.elSeries.add(A),A.attr("clip-path","url(#forecastMask".concat(o.globals.cuid,")")),k.attr("clip-path","url(#nonForecastMask".concat(o.globals.cuid,")"))}}}}},{key:"_iterateOverDataPoints",value:function(t){for(var e=t.series,i=t.realIndex,a=t.i,s=t.x,r=t.y,o=t.pX,n=t.pY,l=t.pathsFrom,h=t.linePaths,c=t.areaPaths,d=t.seriesIndex,g=t.lineYPosition,u=t.xArrj,p=t.yArrj,f=this.w,b=new m(this.ctx),v=this.yRatio,y=l.prevY,w=l.linePath,k=l.areaPath,A=l.pathFromLine,S=l.pathFromArea,C=x.isNumber(f.globals.minYArr[i])?f.globals.minYArr[i]:f.globals.minY,L=f.globals.dataPoints>1?f.globals.dataPoints-1:f.globals.dataPoints,P=0;P<L;P++){var M=void 0===e[a][P+1]||null===e[a][P+1];if(f.globals.isXNumeric){var T=f.globals.seriesX[i][P+1];void 0===f.globals.seriesX[i][P+1]&&(T=f.globals.seriesX[i][L-1]),s=(T-f.globals.minX)/this.xRatio}else s+=this.xDivision;if(f.config.chart.stacked)if(a>0&&f.globals.collapsedSeries.length<f.config.series.length-1){g=this.prevSeriesY[function(t){for(var e=t,i=0;i<f.globals.series.length;i++)if(f.globals.collapsedSeriesIndices.indexOf(t)>-1){e--;break}return e>=0?e:0}(a-1)][P+1]}else g=this.zeroY;else g=this.zeroY;r=M?g-C/v[this.yaxisIndex]+2*(this.isReversed?C/v[this.yaxisIndex]:0):g-e[a][P+1]/v[this.yaxisIndex]+2*(this.isReversed?e[a][P+1]/v[this.yaxisIndex]:0),u.push(s),p.push(r);var I=this.lineHelpers.calculatePoints({series:e,x:s,y:r,realIndex:i,i:a,j:P,prevY:y}),z=this._createPaths({series:e,i:a,realIndex:i,j:P,x:s,y:r,pX:o,pY:n,linePath:w,areaPath:k,linePaths:h,areaPaths:c,seriesIndex:d});c=z.areaPaths,h=z.linePaths,o=z.pX,n=z.pY,k=z.areaPath,w=z.linePath,this.appendPathFrom&&(A+=b.line(s,this.zeroY),S+=b.line(s,this.zeroY)),this.handleNullDataPoints(e,I,a,P,i),this._handleMarkersAndLabels({pointsPos:I,series:e,x:s,y:r,prevY:y,i:a,j:P,realIndex:i})}return{yArrj:p,xArrj:u,pathFromArea:S,areaPaths:c,pathFromLine:A,linePaths:h}}},{key:"_handleMarkersAndLabels",value:function(t){var e=t.pointsPos;t.series,t.x,t.y,t.prevY;var i=t.i,a=t.j,s=t.realIndex,r=this.w,o=new z(this.ctx);if(this.pointsChart)this.scatter.draw(this.elSeries,a,{realIndex:s,pointsPos:e,zRatio:this.zRatio,elParent:this.elPointsMain});else{r.globals.series[i].length>1&&this.elPointsMain.node.classList.add("apexcharts-element-hidden");var n=this.markers.plotChartMarkers(e,s,a+1);null!==n&&this.elPointsMain.add(n)}var l=o.drawDataLabel(e,s,a+1,null);null!==l&&this.elDataLabelsWrap.add(l)}},{key:"_createPaths",value:function(t){var e=t.series,i=t.i,a=t.realIndex,s=t.j,r=t.x,o=t.y,n=t.pX,l=t.pY,h=t.linePath,c=t.areaPath,d=t.linePaths,g=t.areaPaths,u=t.seriesIndex,p=this.w,f=new m(this.ctx),x=p.config.stroke.curve,b=this.areaBottomY;if(Array.isArray(p.config.stroke.curve)&&(x=Array.isArray(u)?p.config.stroke.curve[u[i]]:p.config.stroke.curve[i]),"smooth"===x){var v=.35*(r-n);p.globals.hasNullValues?(null!==e[i][s]&&(null!==e[i][s+1]?(h=f.move(n,l)+f.curve(n+v,l,r-v,o,r+1,o),c=f.move(n+1,l)+f.curve(n+v,l,r-v,o,r+1,o)+f.line(r,b)+f.line(n,b)+"z"):(h=f.move(n,l),c=f.move(n,l)+"z")),d.push(h),g.push(c)):(h+=f.curve(n+v,l,r-v,o,r,o),c+=f.curve(n+v,l,r-v,o,r,o)),n=r,l=o,s===e[i].length-2&&(c=c+f.curve(n,l,r,o,r,b)+f.move(r,o)+"z",p.globals.hasNullValues||(d.push(h),g.push(c)))}else{if(null===e[i][s+1]){h+=f.move(r,o);var y=p.globals.isXNumeric?(p.globals.seriesX[a][s]-p.globals.minX)/this.xRatio:r-this.xDivision;c=c+f.line(y,b)+f.move(r,o)+"z"}null===e[i][s]&&(h+=f.move(r,o),c+=f.move(r,b)),"stepline"===x?(h=h+f.line(r,null,"H")+f.line(null,o,"V"),c=c+f.line(r,null,"H")+f.line(null,o,"V")):"straight"===x&&(h+=f.line(r,o),c+=f.line(r,o)),s===e[i].length-2&&(c=c+f.line(r,b)+f.move(r,o)+"z",d.push(h),g.push(c))}return{linePaths:d,areaPaths:g,pX:n,pY:l,linePath:h,areaPath:c}}},{key:"handleNullDataPoints",value:function(t,e,i,a,s){var r=this.w;if(null===t[i][a]&&r.config.markers.showNullDataPoints||1===t[i].length){var o=this.markers.plotChartMarkers(e,s,a+1,this.strokeWidth-r.config.markers.strokeWidth/2,!0);null!==o&&this.elPointsMain.add(o)}}}]),t}();window.TreemapSquared={},window.TreemapSquared.generate=function(){function t(e,i,a,s){this.xoffset=e,this.yoffset=i,this.height=s,this.width=a,this.shortestEdge=function(){return Math.min(this.height,this.width)},this.getCoordinates=function(t){var e,i=[],a=this.xoffset,s=this.yoffset,o=r(t)/this.height,n=r(t)/this.width;if(this.width>=this.height)for(e=0;e<t.length;e++)i.push([a,s,a+o,s+t[e]/o]),s+=t[e]/o;else for(e=0;e<t.length;e++)i.push([a,s,a+t[e]/n,s+n]),a+=t[e]/n;return i},this.cutArea=function(e){var i;if(this.width>=this.height){var a=e/this.height,s=this.width-a;i=new t(this.xoffset+a,this.yoffset,s,this.height)}else{var r=e/this.width,o=this.height-r;i=new t(this.xoffset,this.yoffset+r,this.width,o)}return i}}function e(e,a,s,o,n){return o=void 0===o?0:o,n=void 0===n?0:n,function(t){var e,i,a=[];for(e=0;e<t.length;e++)for(i=0;i<t[e].length;i++)a.push(t[e][i]);return a}(i(function(t,e){var i,a=[],s=e/r(t);for(i=0;i<t.length;i++)a[i]=t[i]*s;return a}(e,a*s),[],new t(o,n,a,s),[]))}function i(t,e,s,o){var n,l,h;if(0!==t.length)return n=s.shortestEdge(),function(t,e,i){var s;if(0===t.length)return!0;(s=t.slice()).push(e);var r=a(t,i),o=a(s,i);return r>=o}(e,l=t[0],n)?(e.push(l),i(t.slice(1),e,s,o)):(h=s.cutArea(r(e),o),o.push(s.getCoordinates(e)),i(t,[],h,o)),o;o.push(s.getCoordinates(e))}function a(t,e){var i=Math.min.apply(Math,t),a=Math.max.apply(Math,t),s=r(t);return Math.max(Math.pow(e,2)*a/Math.pow(s,2),Math.pow(s,2)/(Math.pow(e,2)*i))}function s(t){return t&&t.constructor===Array}function r(t){var e,i=0;for(e=0;e<t.length;e++)i+=t[e];return i}function o(t){var e,i=0;if(s(t[0]))for(e=0;e<t.length;e++)i+=o(t[e]);else i=r(t);return i}return function t(i,a,r,n,l){n=void 0===n?0:n,l=void 0===l?0:l;var h,c,d=[],g=[];if(s(i[0])){for(c=0;c<i.length;c++)d[c]=o(i[c]);for(h=e(d,a,r,n,l),c=0;c<i.length;c++)g.push(t(i[c],h[c][2]-h[c][0],h[c][3]-h[c][1],h[c][0],h[c][1]))}else g=e(i,a,r,n,l);return g}}();var It,zt,Xt=function(){function t(e,i){a(this,t),this.ctx=e,this.w=e.w,this.strokeWidth=this.w.config.stroke.width,this.helpers=new kt(e),this.dynamicAnim=this.w.config.chart.animations.dynamicAnimation,this.labels=[]}return r(t,[{key:"draw",value:function(t){var e=this,i=this.w,a=new m(this.ctx),s=new M(this.ctx),r=a.group({class:"apexcharts-treemap"});if(i.globals.noData)return r;var o=[];return t.forEach((function(t){var e=t.map((function(t){return Math.abs(t)}));o.push(e)})),this.negRange=this.helpers.checkColorRange(),i.config.series.forEach((function(t,i){t.data.forEach((function(t){Array.isArray(e.labels[i])||(e.labels[i]=[]),e.labels[i].push(t.x)}))})),window.TreemapSquared.generate(o,i.globals.gridWidth,i.globals.gridHeight).forEach((function(o,n){var l=a.group({class:"apexcharts-series apexcharts-treemap-series",seriesName:x.escapeString(i.globals.seriesNames[n]),rel:n+1,"data:realIndex":n});if(i.config.chart.dropShadow.enabled){var h=i.config.chart.dropShadow;new v(e.ctx).dropShadow(r,h,n)}var c=a.group({class:"apexcharts-data-labels"});o.forEach((function(r,o){var h=r[0],c=r[1],d=r[2],g=r[3],u=a.drawRect(h,c,d-h,g-c,0,"#fff",1,e.strokeWidth,i.config.plotOptions.treemap.useFillColorAsStroke?f:i.globals.stroke.colors[n]);u.attr({cx:h,cy:c,index:n,i:n,j:o,width:d-h,height:g-c});var p=e.helpers.getShadeColor(i.config.chart.type,n,o,e.negRange),f=p.color;void 0!==i.config.series[n].data[o]&&i.config.series[n].data[o].fillColor&&(f=i.config.series[n].data[o].fillColor);var x=s.fillPath({color:f,seriesNumber:n,dataPointIndex:o});u.node.classList.add("apexcharts-treemap-rect"),u.attr({fill:x}),e.helpers.addListeners(u);var b={x:h+(d-h)/2,y:c+(g-c)/2,width:0,height:0},v={x:h,y:c,width:d-h,height:g-c};if(i.config.chart.animations.enabled&&!i.globals.dataChanged){var m=1;i.globals.resized||(m=i.config.chart.animations.speed),e.animateTreemap(u,b,v,m)}if(i.globals.dataChanged){var y=1;e.dynamicAnim.enabled&&i.globals.shouldAnimate&&(y=e.dynamicAnim.speed,i.globals.previousPaths[n]&&i.globals.previousPaths[n][o]&&i.globals.previousPaths[n][o].rect&&(b=i.globals.previousPaths[n][o].rect),e.animateTreemap(u,b,v,y))}var w=e.getFontSize(r),k=i.config.dataLabels.formatter(e.labels[n][o],{value:i.globals.series[n][o],seriesIndex:n,dataPointIndex:o,w:i}),A=e.helpers.calculateDataLabels({text:k,x:(h+d)/2,y:(c+g)/2+e.strokeWidth/2+w/3,i:n,j:o,colorProps:p,fontSize:w,series:t});i.config.dataLabels.enabled&&A&&e.rotateToFitLabel(A,w,k,h,c,d,g),l.add(u),null!==A&&l.add(A)})),l.add(c),r.add(l)})),r}},{key:"getFontSize",value:function(t){var e=this.w;var i,a,s,r,o=function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=e[i].length;return a}(this.labels)/function t(e){var i,a=0;if(Array.isArray(e[0]))for(i=0;i<e.length;i++)a+=t(e[i]);else for(i=0;i<e.length;i++)a+=1;return a}(this.labels);return i=t[2]-t[0],a=t[3]-t[1],s=i*a,r=Math.pow(s,.5),Math.min(r/o,parseInt(e.config.dataLabels.style.fontSize,10))}},{key:"rotateToFitLabel",value:function(t,e,i,a,s,r,o){var n=new m(this.ctx),l=n.getTextRects(i,e);if(l.width+this.w.config.stroke.width+5>r-a&&l.width<=o-s){var h=n.rotateAroundCenter(t.node);t.node.setAttribute("transform","rotate(-90 ".concat(h.x," ").concat(h.y,")"))}}},{key:"animateTreemap",value:function(t,e,i,a){var s=new b(this.ctx);s.animateRect(t,{x:e.x,y:e.y,width:e.width,height:e.height},{x:i.x,y:i.y,width:i.width,height:i.height},a,(function(){s.animationCompleted(t)}))}}]),t}(),Et=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w,this.timeScaleArray=[],this.utc=this.w.config.xaxis.labels.datetimeUTC}return r(t,[{key:"calculateTimeScaleTicks",value:function(t,i){var a=this,s=this.w;if(s.globals.allSeriesCollapsed)return s.globals.labels=[],s.globals.timescaleLabels=[],[];var r=new R(this.ctx),o=(i-t)/864e5;this.determineInterval(o),s.globals.disableZoomIn=!1,s.globals.disableZoomOut=!1,o<.00011574074074074075?s.globals.disableZoomIn=!0:o>5e4&&(s.globals.disableZoomOut=!0);var n=r.getTimeUnitsfromTimestamp(t,i,this.utc),l=s.globals.gridWidth/o,h=l/24,c=h/60,d=c/60,g=Math.floor(24*o),u=Math.floor(1440*o),p=Math.floor(86400*o),f=Math.floor(o),x=Math.floor(o/30),b=Math.floor(o/365),v={minMillisecond:n.minMillisecond,minSecond:n.minSecond,minMinute:n.minMinute,minHour:n.minHour,minDate:n.minDate,minMonth:n.minMonth,minYear:n.minYear},m={firstVal:v,currentMillisecond:v.minMillisecond,currentSecond:v.minSecond,currentMinute:v.minMinute,currentHour:v.minHour,currentMonthDate:v.minDate,currentDate:v.minDate,currentMonth:v.minMonth,currentYear:v.minYear,daysWidthOnXAxis:l,hoursWidthOnXAxis:h,minutesWidthOnXAxis:c,secondsWidthOnXAxis:d,numberOfSeconds:p,numberOfMinutes:u,numberOfHours:g,numberOfDays:f,numberOfMonths:x,numberOfYears:b};switch(this.tickInterval){case"years":this.generateYearScale(m);break;case"months":case"half_year":this.generateMonthScale(m);break;case"months_days":case"months_fortnight":case"days":case"week_days":this.generateDayScale(m);break;case"hours":this.generateHourScale(m);break;case"minutes_fives":case"minutes":this.generateMinuteScale(m);break;case"seconds_tens":case"seconds_fives":case"seconds":this.generateSecondScale(m)}var y=this.timeScaleArray.map((function(t){var i={position:t.position,unit:t.unit,year:t.year,day:t.day?t.day:1,hour:t.hour?t.hour:0,month:t.month+1};return"month"===t.unit?e(e({},i),{},{day:1,value:t.value+1}):"day"===t.unit||"hour"===t.unit?e(e({},i),{},{value:t.value}):"minute"===t.unit?e(e({},i),{},{value:t.value,minute:t.value}):"second"===t.unit?e(e({},i),{},{value:t.value,minute:t.minute,second:t.second}):t}));return y.filter((function(t){var e=1,i=Math.ceil(s.globals.gridWidth/120),r=t.value;void 0!==s.config.xaxis.tickAmount&&(i=s.config.xaxis.tickAmount),y.length>i&&(e=Math.floor(y.length/i));var o=!1,n=!1;switch(a.tickInterval){case"years":"year"===t.unit&&(o=!0);break;case"half_year":e=7,"year"===t.unit&&(o=!0);break;case"months":e=1,"year"===t.unit&&(o=!0);break;case"months_fortnight":e=15,"year"!==t.unit&&"month"!==t.unit||(o=!0),30===r&&(n=!0);break;case"months_days":e=10,"month"===t.unit&&(o=!0),30===r&&(n=!0);break;case"week_days":e=8,"month"===t.unit&&(o=!0);break;case"days":e=1,"month"===t.unit&&(o=!0);break;case"hours":"day"===t.unit&&(o=!0);break;case"minutes_fives":r%5!=0&&(n=!0);break;case"seconds_tens":r%10!=0&&(n=!0);break;case"seconds_fives":r%5!=0&&(n=!0)}if("hours"===a.tickInterval||"minutes_fives"===a.tickInterval||"seconds_tens"===a.tickInterval||"seconds_fives"===a.tickInterval){if(!n)return!0}else if((r%e==0||o)&&!n)return!0}))}},{key:"recalcDimensionsBasedOnFormat",value:function(t,e){var i=this.w,a=this.formatDates(t),s=this.removeOverlappingTS(a);i.globals.timescaleLabels=s.slice(),new lt(this.ctx).plotCoords()}},{key:"determineInterval",value:function(t){var e=24*t,i=60*e;switch(!0){case t/365>5:this.tickInterval="years";break;case t>800:this.tickInterval="half_year";break;case t>180:this.tickInterval="months";break;case t>90:this.tickInterval="months_fortnight";break;case t>60:this.tickInterval="months_days";break;case t>30:this.tickInterval="week_days";break;case t>2:this.tickInterval="days";break;case e>2.4:this.tickInterval="hours";break;case i>15:this.tickInterval="minutes_fives";break;case i>5:this.tickInterval="minutes";break;case i>1:this.tickInterval="seconds_tens";break;case 60*i>20:this.tickInterval="seconds_fives";break;default:this.tickInterval="seconds"}}},{key:"generateYearScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.daysWidthOnXAxis,r=t.numberOfYears,o=e.minYear,n=0,l=new R(this.ctx),h="year";if(e.minDate>1||e.minMonth>0){var c=l.determineRemainingDaysOfYear(e.minYear,e.minMonth,e.minDate);n=(l.determineDaysOfYear(e.minYear)-c+1)*s,o=e.minYear+1,this.timeScaleArray.push({position:n,value:o,unit:h,year:o,month:x.monthMod(i+1)})}else 1===e.minDate&&0===e.minMonth&&this.timeScaleArray.push({position:n,value:o,unit:h,year:a,month:x.monthMod(i+1)});for(var d=o,g=n,u=0;u<r;u++)d++,g=l.determineDaysOfYear(d-1)*s+g,this.timeScaleArray.push({position:g,value:d,unit:h,year:d,month:1})}},{key:"generateMonthScale",value:function(t){var e=t.firstVal,i=t.currentMonthDate,a=t.currentMonth,s=t.currentYear,r=t.daysWidthOnXAxis,o=t.numberOfMonths,n=a,l=0,h=new R(this.ctx),c="month",d=0;if(e.minDate>1){l=(h.determineDaysOfMonths(a+1,e.minYear)-i+1)*r,n=x.monthMod(a+1);var g=s+d,u=x.monthMod(n),p=n;0===n&&(c="year",p=g,u=1,g+=d+=1),this.timeScaleArray.push({position:l,value:p,unit:c,year:g,month:u})}else this.timeScaleArray.push({position:l,value:n,unit:c,year:s,month:x.monthMod(a)});for(var f=n+1,b=l,v=0,m=1;v<o;v++,m++){0===(f=x.monthMod(f))?(c="year",d+=1):c="month";var y=this._getYear(s,f,d);b=h.determineDaysOfMonths(f,y)*r+b;var w=0===f?y:f;this.timeScaleArray.push({position:b,value:w,unit:c,year:y,month:0===f?1:f}),f++}}},{key:"generateDayScale",value:function(t){var e=t.firstVal,i=t.currentMonth,a=t.currentYear,s=t.hoursWidthOnXAxis,r=t.numberOfDays,o=new R(this.ctx),n="day",l=e.minDate+1,h=l,c=function(t,e,i){return t>o.determineDaysOfMonths(e+1,i)?(h=1,n="month",g=e+=1,e):e},d=(24-e.minHour)*s,g=l,u=c(h,i,a);0===e.minHour&&1===e.minDate?(d=0,g=x.monthMod(e.minMonth),n="month",h=e.minDate,r++):1!==e.minDate&&0===e.minHour&&0===e.minMinute&&(d=0,l=e.minDate,g=l,u=c(h=l,i,a)),this.timeScaleArray.push({position:d,value:g,unit:n,year:this._getYear(a,u,0),month:x.monthMod(u),day:h});for(var p=d,f=0;f<r;f++){n="day",u=c(h+=1,u,this._getYear(a,u,0));var b=this._getYear(a,u,0);p=24*s+p;var v=1===h?x.monthMod(u):h;this.timeScaleArray.push({position:p,value:v,unit:n,year:b,month:x.monthMod(u),day:v})}}},{key:"generateHourScale",value:function(t){var e=t.firstVal,i=t.currentDate,a=t.currentMonth,s=t.currentYear,r=t.minutesWidthOnXAxis,o=t.numberOfHours,n=new R(this.ctx),l="hour",h=function(t,e){return t>n.determineDaysOfMonths(e+1,s)&&(f=1,e+=1),{month:e,date:f}},c=function(t,e){return t>n.determineDaysOfMonths(e+1,s)?e+=1:e},d=60-(e.minMinute+e.minSecond/60),g=d*r,u=e.minHour+1,p=u+1;60===d&&(g=0,p=(u=e.minHour)+1);var f=i,b=c(f,a);this.timeScaleArray.push({position:g,value:u,unit:l,day:f,hour:p,year:s,month:x.monthMod(b)});for(var v=g,m=0;m<o;m++){if(l="hour",p>=24)p=0,l="day",b=h(f+=1,b).month,b=c(f,b);var y=this._getYear(s,b,0);v=0===p&&0===m?d*r:60*r+v;var w=0===p?f:p;this.timeScaleArray.push({position:v,value:w,unit:l,hour:p,day:f,year:y,month:x.monthMod(b)}),p++}}},{key:"generateMinuteScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.minutesWidthOnXAxis,h=t.secondsWidthOnXAxis,c=t.numberOfMinutes,d=a+1,g=r,u=o,p=n,f=s,b=(60-i-e/1e3)*h,v=0;v<c;v++)d>=60&&(d=0,24===(f+=1)&&(f=0)),this.timeScaleArray.push({position:b,value:d,unit:"minute",hour:f,minute:d,day:g,year:this._getYear(p,u,0),month:x.monthMod(u)}),b+=l,d++}},{key:"generateSecondScale",value:function(t){for(var e=t.currentMillisecond,i=t.currentSecond,a=t.currentMinute,s=t.currentHour,r=t.currentDate,o=t.currentMonth,n=t.currentYear,l=t.secondsWidthOnXAxis,h=t.numberOfSeconds,c=i+1,d=a,g=r,u=o,p=n,f=s,b=(1e3-e)/1e3*l,v=0;v<h;v++)c>=60&&(c=0,++d>=60&&(d=0,24===++f&&(f=0))),this.timeScaleArray.push({position:b,value:c,unit:"second",hour:f,minute:d,second:c,day:g,year:this._getYear(p,u,0),month:x.monthMod(u)}),b+=l,c++}},{key:"createRawDateString",value:function(t,e){var i=t.year;return 0===t.month&&(t.month=1),i+="-"+("0"+t.month.toString()).slice(-2),"day"===t.unit?i+="day"===t.unit?"-"+("0"+e).slice(-2):"-01":i+="-"+("0"+(t.day?t.day:"1")).slice(-2),"hour"===t.unit?i+="hour"===t.unit?"T"+("0"+e).slice(-2):"T00":i+="T"+("0"+(t.hour?t.hour:"0")).slice(-2),"minute"===t.unit?i+=":"+("0"+e).slice(-2):i+=":"+(t.minute?("0"+t.minute).slice(-2):"00"),"second"===t.unit?i+=":"+("0"+e).slice(-2):i+=":00",this.utc&&(i+=".000Z"),i}},{key:"formatDates",value:function(t){var e=this,i=this.w;return t.map((function(t){var a=t.value.toString(),s=new R(e.ctx),r=e.createRawDateString(t,a),o=s.getDate(s.parseDate(r));if(e.utc||(o=s.getDate(s.parseDateWithTimezone(r))),void 0===i.config.xaxis.labels.format){var n="dd MMM",l=i.config.xaxis.labels.datetimeFormatter;"year"===t.unit&&(n=l.year),"month"===t.unit&&(n=l.month),"day"===t.unit&&(n=l.day),"hour"===t.unit&&(n=l.hour),"minute"===t.unit&&(n=l.minute),"second"===t.unit&&(n=l.second),a=s.formatDate(o,n)}else a=s.formatDate(o,i.config.xaxis.labels.format);return{dateString:r,position:t.position,value:a,unit:t.unit,year:t.year,month:t.month}}))}},{key:"removeOverlappingTS",value:function(t){var e,i=this,a=new m(this.ctx),s=!1;t.length>0&&t[0].value&&t.every((function(e){return e.value.length===t[0].value.length}))&&(s=!0,e=a.getTextRects(t[0].value).width);var r=0,o=t.map((function(o,n){if(n>0&&i.w.config.xaxis.labels.hideOverlappingLabels){var l=s?e:a.getTextRects(t[r].value).width,h=t[r].position;return o.position>h+l+10?(r=n,o):null}return o}));return o=o.filter((function(t){return null!==t}))}},{key:"_getYear",value:function(t,e,i){return t+Math.floor(e/12)+i}}]),t}(),Yt=function(){function t(e,i){a(this,t),this.ctx=i,this.w=i.w,this.el=e}return r(t,[{key:"setupElements",value:function(){var t=this.w.globals,e=this.w.config,i=e.chart.type;t.axisCharts=["line","area","bar","rangeBar","candlestick","boxPlot","scatter","bubble","radar","heatmap","treemap"].indexOf(i)>-1,t.xyCharts=["line","area","bar","rangeBar","candlestick","boxPlot","scatter","bubble"].indexOf(i)>-1,t.isBarHorizontal=("bar"===e.chart.type||"rangeBar"===e.chart.type||"boxPlot"===e.chart.type)&&e.plotOptions.bar.horizontal,t.chartClass=".apexcharts"+t.chartID,t.dom.baseEl=this.el,t.dom.elWrap=document.createElement("div"),m.setAttrs(t.dom.elWrap,{id:t.chartClass.substring(1),class:"apexcharts-canvas "+t.chartClass.substring(1)}),this.el.appendChild(t.dom.elWrap),t.dom.Paper=new window.SVG.Doc(t.dom.elWrap),t.dom.Paper.attr({class:"apexcharts-svg","xmlns:data":"ApexChartsNS",transform:"translate(".concat(e.chart.offsetX,", ").concat(e.chart.offsetY,")")}),t.dom.Paper.node.style.background=e.chart.background,this.setSVGDimensions(),t.dom.elGraphical=t.dom.Paper.group().attr({class:"apexcharts-inner apexcharts-graphical"}),t.dom.elAnnotations=t.dom.Paper.group().attr({class:"apexcharts-annotations"}),t.dom.elDefs=t.dom.Paper.defs(),t.dom.elLegendWrap=document.createElement("div"),t.dom.elLegendWrap.classList.add("apexcharts-legend"),t.dom.elWrap.appendChild(t.dom.elLegendWrap),t.dom.Paper.add(t.dom.elGraphical),t.dom.elGraphical.add(t.dom.elDefs)}},{key:"plotChartType",value:function(t,e){var i=this.w,a=i.config,s=i.globals,r={series:[],i:[]},o={series:[],i:[]},n={series:[],i:[]},l={series:[],i:[]},h={series:[],i:[]},c={series:[],i:[]},d={series:[],i:[]};s.series.map((function(e,g){var u=0;void 0!==t[g].type?("column"===t[g].type||"bar"===t[g].type?(s.series.length>1&&a.plotOptions.bar.horizontal&&console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"),h.series.push(e),h.i.push(g),u++,i.globals.columnSeries=h.series):"area"===t[g].type?(o.series.push(e),o.i.push(g),u++):"line"===t[g].type?(r.series.push(e),r.i.push(g),u++):"scatter"===t[g].type?(n.series.push(e),n.i.push(g)):"bubble"===t[g].type?(l.series.push(e),l.i.push(g),u++):"candlestick"===t[g].type?(c.series.push(e),c.i.push(g),u++):"boxPlot"===t[g].type?(d.series.push(e),d.i.push(g),u++):console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble"),u>1&&(s.comboCharts=!0)):(r.series.push(e),r.i.push(g))}));var g=new Tt(this.ctx,e),u=new wt(this.ctx,e);this.ctx.pie=new Ct(this.ctx);var p=new Pt(this.ctx);this.ctx.rangeBar=new H(this.ctx,e);var f=new Lt(this.ctx),x=[];if(s.comboCharts){if(o.series.length>0&&x.push(g.draw(o.series,"area",o.i)),h.series.length>0)if(i.config.chart.stacked){var b=new yt(this.ctx,e);x.push(b.draw(h.series,h.i))}else this.ctx.bar=new F(this.ctx,e),x.push(this.ctx.bar.draw(h.series,h.i));if(r.series.length>0&&x.push(g.draw(r.series,"line",r.i)),c.series.length>0&&x.push(u.draw(c.series,c.i)),d.series.length>0&&x.push(u.draw(d.series,d.i)),n.series.length>0){var v=new Tt(this.ctx,e,!0);x.push(v.draw(n.series,"scatter",n.i))}if(l.series.length>0){var m=new Tt(this.ctx,e,!0);x.push(m.draw(l.series,"bubble",l.i))}}else switch(a.chart.type){case"line":x=g.draw(s.series,"line");break;case"area":x=g.draw(s.series,"area");break;case"bar":if(a.chart.stacked)x=new yt(this.ctx,e).draw(s.series);else this.ctx.bar=new F(this.ctx,e),x=this.ctx.bar.draw(s.series);break;case"candlestick":x=new wt(this.ctx,e).draw(s.series);break;case"boxPlot":x=new wt(this.ctx,e).draw(s.series);break;case"rangeBar":x=this.ctx.rangeBar.draw(s.series);break;case"heatmap":x=new At(this.ctx,e).draw(s.series);break;case"treemap":x=new Xt(this.ctx,e).draw(s.series);break;case"pie":case"donut":case"polarArea":x=this.ctx.pie.draw(s.series);break;case"radialBar":x=p.draw(s.series);break;case"radar":x=f.draw(s.series);break;default:x=g.draw(s.series)}return x}},{key:"setSVGDimensions",value:function(){var t=this.w.globals,e=this.w.config;t.svgWidth=e.chart.width,t.svgHeight=e.chart.height;var i=x.getDimensions(this.el),a=e.chart.width.toString().split(/[0-9]+/g).pop();"%"===a?x.isNumber(i[0])&&(0===i[0].width&&(i=x.getDimensions(this.el.parentNode)),t.svgWidth=i[0]*parseInt(e.chart.width,10)/100):"px"!==a&&""!==a||(t.svgWidth=parseInt(e.chart.width,10));var s=e.chart.height.toString().split(/[0-9]+/g).pop();if("auto"!==t.svgHeight&&""!==t.svgHeight)if("%"===s){var r=x.getDimensions(this.el.parentNode);t.svgHeight=r[1]*parseInt(e.chart.height,10)/100}else t.svgHeight=parseInt(e.chart.height,10);else t.axisCharts?t.svgHeight=t.svgWidth/1.61:t.svgHeight=t.svgWidth/1.2;if(t.svgWidth<0&&(t.svgWidth=0),t.svgHeight<0&&(t.svgHeight=0),m.setAttrs(t.dom.Paper.node,{width:t.svgWidth,height:t.svgHeight}),"%"!==s){var o=e.chart.sparkline.enabled?0:t.axisCharts?e.chart.parentHeightOffset:0;t.dom.Paper.node.parentNode.parentNode.style.minHeight=t.svgHeight+o+"px"}t.dom.elWrap.style.width=t.svgWidth+"px",t.dom.elWrap.style.height=t.svgHeight+"px"}},{key:"shiftGraphPosition",value:function(){var t=this.w.globals,e=t.translateY,i={transform:"translate("+t.translateX+", "+e+")"};m.setAttrs(t.dom.elGraphical.node,i)}},{key:"resizeNonAxisCharts",value:function(){var t=this.w,e=t.globals,i=0,a=t.config.chart.sparkline.enabled?1:15;a+=t.config.grid.padding.bottom,"top"!==t.config.legend.position&&"bottom"!==t.config.legend.position||!t.config.legend.show||t.config.legend.floating||(i=new ct(this.ctx).legendHelpers.getLegendBBox().clwh+10);var s=t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"),r=2.05*t.globals.radialSize;if(s&&!t.config.chart.sparkline.enabled&&0!==t.config.plotOptions.radialBar.startAngle){var o=x.getBoundingClientRect(s);r=o.bottom;var n=o.bottom-o.top;r=Math.max(2.05*t.globals.radialSize,n)}var l=r+e.translateY+i+a;e.dom.elLegendForeign&&e.dom.elLegendForeign.setAttribute("height",l),t.config.chart.height&&String(t.config.chart.height).indexOf("%")>0||(e.dom.elWrap.style.height=l+"px",m.setAttrs(e.dom.Paper.node,{height:l}),e.dom.Paper.node.parentNode.parentNode.style.minHeight=l+"px")}},{key:"coreCalculations",value:function(){new Z(this.ctx).init()}},{key:"resetGlobals",value:function(){var t=this,e=function(){return t.w.config.series.map((function(t){return[]}))},i=new O,a=this.w.globals;i.initGlobalVars(a),a.seriesXvalues=e(),a.seriesYvalues=e()}},{key:"isMultipleY",value:function(){if(this.w.config.yaxis.constructor===Array&&this.w.config.yaxis.length>1)return this.w.globals.isMultipleYAxis=!0,!0}},{key:"xySettings",value:function(){var t=null,e=this.w;if(e.globals.axisCharts){if("back"===e.config.xaxis.crosshairs.position)new tt(this.ctx).drawXCrosshairs();if("back"===e.config.yaxis[0].crosshairs.position)new tt(this.ctx).drawYCrosshairs();if("datetime"===e.config.xaxis.type&&void 0===e.config.xaxis.labels.formatter){this.ctx.timeScale=new Et(this.ctx);var i=[];isFinite(e.globals.minX)&&isFinite(e.globals.maxX)&&!e.globals.isBarHorizontal?i=this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX,e.globals.maxX):e.globals.isBarHorizontal&&(i=this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY,e.globals.maxY)),this.ctx.timeScale.recalcDimensionsBasedOnFormat(i)}t=new y(this.ctx).getCalculatedRatios()}return t}},{key:"updateSourceChart",value:function(t){this.ctx.w.globals.selection=void 0,this.ctx.updateHelpers._updateOptions({chart:{selection:{xaxis:{min:t.w.globals.minX,max:t.w.globals.maxX}}}},!1,!1)}},{key:"setupBrushHandler",value:function(){var t=this,i=this.w;if(i.config.chart.brush.enabled&&"function"!=typeof i.config.chart.events.selection){var a=i.config.chart.brush.targets||[i.config.chart.brush.target];a.forEach((function(e){var i=ApexCharts.getChartByID(e);i.w.globals.brushSource=t.ctx,"function"!=typeof i.w.config.chart.events.zoomed&&(i.w.config.chart.events.zoomed=function(){t.updateSourceChart(i)}),"function"!=typeof i.w.config.chart.events.scrolled&&(i.w.config.chart.events.scrolled=function(){t.updateSourceChart(i)})})),i.config.chart.events.selection=function(t,s){a.forEach((function(t){var a=ApexCharts.getChartByID(t),r=x.clone(i.config.yaxis);if(i.config.chart.brush.autoScaleYaxis&&1===a.w.globals.series.length){var o=new q(a);r=o.autoScaleY(a,r,s)}var n=a.w.config.yaxis.reduce((function(t,i,s){return[].concat(u(t),[e(e({},a.w.config.yaxis[s]),{},{min:r[0].min,max:r[0].max})])}),[]);a.ctx.updateHelpers._updateOptions({xaxis:{min:s.xaxis.min,max:s.xaxis.max},yaxis:n},!1,!1,!1,!1)}))}}}}]),t}(),Ft=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"_updateOptions",value:function(t){var e=this,a=arguments.length>1&&void 0!==arguments[1]&&arguments[1],s=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],r=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],o=arguments.length>4&&void 0!==arguments[4]&&arguments[4];return new Promise((function(n){var l=[e.ctx];r&&(l=e.ctx.getSyncedCharts()),e.ctx.w.globals.isExecCalled&&(l=[e.ctx],e.ctx.w.globals.isExecCalled=!1),l.forEach((function(r,h){var c=r.w;if(c.globals.shouldAnimate=s,a||(c.globals.resized=!0,c.globals.dataChanged=!0,s&&r.series.getPreviousPaths()),t&&"object"===i(t)&&(r.config=new N(t),t=y.extendArrayProps(r.config,t,c),r.w.globals.chartID!==e.ctx.w.globals.chartID&&delete t.series,c.config=x.extend(c.config,t),o&&(c.globals.lastXAxis=t.xaxis?x.clone(t.xaxis):[],c.globals.lastYAxis=t.yaxis?x.clone(t.yaxis):[],c.globals.initialConfig=x.extend({},c.config),c.globals.initialSeries=x.clone(c.config.series),t.series))){for(var d=0;d<c.globals.collapsedSeriesIndices.length;d++){var g=c.config.series[c.globals.collapsedSeriesIndices[d]];c.globals.collapsedSeries[d].data=c.globals.axisCharts?g.data.slice():g}for(var u=0;u<c.globals.ancillaryCollapsedSeriesIndices.length;u++){var p=c.config.series[c.globals.ancillaryCollapsedSeriesIndices[u]];c.globals.ancillaryCollapsedSeries[u].data=c.globals.axisCharts?p.data.slice():p}r.series.emptyCollapsedSeries(c.config.series)}return r.update(t).then((function(){h===l.length-1&&n(r)}))}))}))}},{key:"_updateSeries",value:function(t,e){var i=this,a=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return new Promise((function(s){var r,o=i.w;return o.globals.shouldAnimate=e,o.globals.dataChanged=!0,e&&i.ctx.series.getPreviousPaths(),o.globals.axisCharts?(0===(r=t.map((function(t,e){return i._extendSeries(t,e)}))).length&&(r=[{data:[]}]),o.config.series=r):o.config.series=t.slice(),a&&(o.globals.initialConfig.series=x.clone(o.config.series),o.globals.initialSeries=x.clone(o.config.series)),i.ctx.update().then((function(){s(i.ctx)}))}))}},{key:"_extendSeries",value:function(t,i){var a=this.w,s=a.config.series[i];return e(e({},a.config.series[i]),{},{name:t.name?t.name:s&&s.name,color:t.color?t.color:s&&s.color,type:t.type?t.type:s&&s.type,data:t.data?t.data:s&&s.data})}},{key:"toggleDataPointSelection",value:function(t,e){var i=this.w,a=null,s=".apexcharts-series[data\\:realIndex='".concat(t,"']");return i.globals.axisCharts?a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(e,"'], ").concat(s," circle[j='").concat(e,"'], ").concat(s," rect[j='").concat(e,"']")).members[0]:void 0===e&&(a=i.globals.dom.Paper.select("".concat(s," path[j='").concat(t,"']")).members[0],"pie"!==i.config.chart.type&&"polarArea"!==i.config.chart.type&&"donut"!==i.config.chart.type||this.ctx.pie.pieClicked(t)),a?(new m(this.ctx).pathMouseDown(a,null),a.node?a.node:null):(console.warn("toggleDataPointSelection: Element not found"),null)}},{key:"forceXAxisUpdate",value:function(t){var e=this.w;if(["min","max"].forEach((function(i){void 0!==t.xaxis[i]&&(e.config.xaxis[i]=t.xaxis[i],e.globals.lastXAxis[i]=t.xaxis[i])})),t.xaxis.categories&&t.xaxis.categories.length&&(e.config.xaxis.categories=t.xaxis.categories),e.config.xaxis.convertedCatToNumeric){var i=new D(t);t=i.convertCatToNumericXaxis(t,this.ctx)}return t}},{key:"forceYAxisUpdate",value:function(t){return t.chart&&t.chart.stacked&&"100%"===t.chart.stackType&&(Array.isArray(t.yaxis)?t.yaxis.forEach((function(e,i){t.yaxis[i].min=0,t.yaxis[i].max=100})):(t.yaxis.min=0,t.yaxis.max=100)),t}},{key:"revertDefaultAxisMinMax",value:function(t){var e=this,i=this.w,a=i.globals.lastXAxis,s=i.globals.lastYAxis;t&&t.xaxis&&(a=t.xaxis),t&&t.yaxis&&(s=t.yaxis),i.config.xaxis.min=a.min,i.config.xaxis.max=a.max;var r=function(t){void 0!==s[t]&&(i.config.yaxis[t].min=s[t].min,i.config.yaxis[t].max=s[t].max)};i.config.yaxis.map((function(t,a){i.globals.zoomed||void 0!==s[a]?r(a):void 0!==e.ctx.opts.yaxis[a]&&(t.min=e.ctx.opts.yaxis[a].min,t.max=e.ctx.opts.yaxis[a].max)}))}}]),t}();It="undefined"!=typeof window?window:void 0,zt=function(t,e){var a=(void 0!==this?this:t).SVG=function(t){if(a.supported)return t=new a.Doc(t),a.parser.draw||a.prepare(),t};if(a.ns="http://www.w3.org/2000/svg",a.xmlns="http://www.w3.org/2000/xmlns/",a.xlink="http://www.w3.org/1999/xlink",a.svgjs="http://svgjs.dev",a.supported=!0,!a.supported)return!1;a.did=1e3,a.eid=function(t){return"Svgjs"+d(t)+a.did++},a.create=function(t){var i=e.createElementNS(this.ns,t);return i.setAttribute("id",this.eid(t)),i},a.extend=function(){var t,e;e=(t=[].slice.call(arguments)).pop();for(var i=t.length-1;i>=0;i--)if(t[i])for(var s in e)t[i].prototype[s]=e[s];a.Set&&a.Set.inherit&&a.Set.inherit()},a.invent=function(t){var e="function"==typeof t.create?t.create:function(){this.constructor.call(this,a.create(t.create))};return t.inherit&&(e.prototype=new t.inherit),t.extend&&a.extend(e,t.extend),t.construct&&a.extend(t.parent||a.Container,t.construct),e},a.adopt=function(e){return e?e.instance?e.instance:((i="svg"==e.nodeName?e.parentNode instanceof t.SVGElement?new a.Nested:new a.Doc:"linearGradient"==e.nodeName?new a.Gradient("linear"):"radialGradient"==e.nodeName?new a.Gradient("radial"):a[d(e.nodeName)]?new(a[d(e.nodeName)]):new a.Element(e)).type=e.nodeName,i.node=e,e.instance=i,i instanceof a.Doc&&i.namespace().defs(),i.setData(JSON.parse(e.getAttribute("svgjs:data"))||{}),i):null;var i},a.prepare=function(){var t=e.getElementsByTagName("body")[0],i=(t?new a.Doc(t):a.adopt(e.documentElement).nested()).size(2,0);a.parser={body:t||e.documentElement,draw:i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,poly:i.polyline().node,path:i.path().node,native:a.create("svg")}},a.parser={native:a.create("svg")},e.addEventListener("DOMContentLoaded",(function(){a.parser.draw||a.prepare()}),!1),a.regex={numberAndUnit:/^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,hex:/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,rgb:/rgb\((\d+),(\d+),(\d+)\)/,reference:/#([a-z0-9\-_]+)/i,transforms:/\)\s*,?\s*/,whitespace:/\s/g,isHex:/^#[a-f0-9]{3,6}$/i,isRgb:/^rgb\(/,isCss:/[^:]+:[^;]+;?/,isBlank:/^(\s+)?$/,isNumber:/^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,isPercent:/^-?[\d\.]+%$/,isImage:/\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,delimiter:/[\s,]+/,hyphen:/([^e])\-/gi,pathLetters:/[MLHVCSQTAZ]/gi,isPathLetter:/[MLHVCSQTAZ]/i,numbersWithDots:/((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,dots:/\./g},a.utils={map:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)a.push(e(t[s]));return a},filter:function(t,e){for(var i=t.length,a=[],s=0;s<i;s++)e(t[s])&&a.push(t[s]);return a},filterSVGElements:function(e){return this.filter(e,(function(e){return e instanceof t.SVGElement}))}},a.defaults={attrs:{"fill-opacity":1,"stroke-opacity":1,"stroke-width":0,"stroke-linejoin":"miter","stroke-linecap":"butt",fill:"#000000",stroke:"#000000",opacity:1,x:0,y:0,cx:0,cy:0,width:0,height:0,r:0,rx:0,ry:0,offset:0,"stop-opacity":1,"stop-color":"#000000","font-size":16,"font-family":"Helvetica, Arial, sans-serif","text-anchor":"start"}},a.Color=function(t){var e,s;this.r=0,this.g=0,this.b=0,t&&("string"==typeof t?a.regex.isRgb.test(t)?(e=a.regex.rgb.exec(t.replace(a.regex.whitespace,"")),this.r=parseInt(e[1]),this.g=parseInt(e[2]),this.b=parseInt(e[3])):a.regex.isHex.test(t)&&(e=a.regex.hex.exec(4==(s=t).length?["#",s.substring(1,2),s.substring(1,2),s.substring(2,3),s.substring(2,3),s.substring(3,4),s.substring(3,4)].join(""):s),this.r=parseInt(e[1],16),this.g=parseInt(e[2],16),this.b=parseInt(e[3],16)):"object"===i(t)&&(this.r=t.r,this.g=t.g,this.b=t.b))},a.extend(a.Color,{toString:function(){return this.toHex()},toHex:function(){return"#"+g(this.r)+g(this.g)+g(this.b)},toRgb:function(){return"rgb("+[this.r,this.g,this.b].join()+")"},brightness:function(){return this.r/255*.3+this.g/255*.59+this.b/255*.11},morph:function(t){return this.destination=new a.Color(t),this},at:function(t){return this.destination?(t=t<0?0:t>1?1:t,new a.Color({r:~~(this.r+(this.destination.r-this.r)*t),g:~~(this.g+(this.destination.g-this.g)*t),b:~~(this.b+(this.destination.b-this.b)*t)})):this}}),a.Color.test=function(t){return t+="",a.regex.isHex.test(t)||a.regex.isRgb.test(t)},a.Color.isRgb=function(t){return t&&"number"==typeof t.r&&"number"==typeof t.g&&"number"==typeof t.b},a.Color.isColor=function(t){return a.Color.isRgb(t)||a.Color.test(t)},a.Array=function(t,e){0==(t=(t||[]).valueOf()).length&&e&&(t=e.valueOf()),this.value=this.parse(t)},a.extend(a.Array,{toString:function(){return this.value.join(" ")},valueOf:function(){return this.value},parse:function(t){return t=t.valueOf(),Array.isArray(t)?t:this.split(t)}}),a.PointArray=function(t,e){a.Array.call(this,t,e||[[0,0]])},a.PointArray.prototype=new a.Array,a.PointArray.prototype.constructor=a.PointArray;for(var s={M:function(t,e,i){return e.x=i.x=t[0],e.y=i.y=t[1],["M",e.x,e.y]},L:function(t,e){return e.x=t[0],e.y=t[1],["L",t[0],t[1]]},H:function(t,e){return e.x=t[0],["H",t[0]]},V:function(t,e){return e.y=t[0],["V",t[0]]},C:function(t,e){return e.x=t[4],e.y=t[5],["C",t[0],t[1],t[2],t[3],t[4],t[5]]},Q:function(t,e){return e.x=t[2],e.y=t[3],["Q",t[0],t[1],t[2],t[3]]},Z:function(t,e,i){return e.x=i.x,e.y=i.y,["Z"]}},r="mlhvqtcsaz".split(""),o=0,n=r.length;o<n;++o)s[r[o]]=function(t){return function(e,i,a){if("H"==t)e[0]=e[0]+i.x;else if("V"==t)e[0]=e[0]+i.y;else if("A"==t)e[5]=e[5]+i.x,e[6]=e[6]+i.y;else for(var r=0,o=e.length;r<o;++r)e[r]=e[r]+(r%2?i.y:i.x);if(s&&"function"==typeof s[t])return s[t](e,i,a)}}(r[o].toUpperCase());a.PathArray=function(t,e){a.Array.call(this,t,e||[["M",0,0]])},a.PathArray.prototype=new a.Array,a.PathArray.prototype.constructor=a.PathArray,a.extend(a.PathArray,{toString:function(){return function(t){for(var e=0,i=t.length,a="";e<i;e++)a+=t[e][0],null!=t[e][1]&&(a+=t[e][1],null!=t[e][2]&&(a+=" ",a+=t[e][2],null!=t[e][3]&&(a+=" ",a+=t[e][3],a+=" ",a+=t[e][4],null!=t[e][5]&&(a+=" ",a+=t[e][5],a+=" ",a+=t[e][6],null!=t[e][7]&&(a+=" ",a+=t[e][7])))));return a+" "}(this.value)},move:function(t,e){var i=this.bbox();return i.x,i.y,this},at:function(t){if(!this.destination)return this;for(var e=this.value,i=this.destination.value,s=[],r=new a.PathArray,o=0,n=e.length;o<n;o++){s[o]=[e[o][0]];for(var l=1,h=e[o].length;l<h;l++)s[o][l]=e[o][l]+(i[o][l]-e[o][l])*t;"A"===s[o][0]&&(s[o][4]=+(0!=s[o][4]),s[o][5]=+(0!=s[o][5]))}return r.value=s,r},parse:function(t){if(t instanceof a.PathArray)return t.valueOf();var e,i={M:2,L:2,H:1,V:1,C:6,S:4,Q:4,T:2,A:7,Z:0};t="string"==typeof t?t.replace(a.regex.numbersWithDots,h).replace(a.regex.pathLetters," $& ").replace(a.regex.hyphen,"$1 -").trim().split(a.regex.delimiter):t.reduce((function(t,e){return[].concat.call(t,e)}),[]);var r=[],o=new a.Point,n=new a.Point,l=0,c=t.length;do{a.regex.isPathLetter.test(t[l])?(e=t[l],++l):"M"==e?e="L":"m"==e&&(e="l"),r.push(s[e].call(null,t.slice(l,l+=i[e.toUpperCase()]).map(parseFloat),o,n))}while(c>l);return r},bbox:function(){return a.parser.draw||a.prepare(),a.parser.path.setAttribute("d",this.toString()),a.parser.path.getBBox()}}),a.Number=a.invent({create:function(t,e){this.value=0,this.unit=e||"","number"==typeof t?this.value=isNaN(t)?0:isFinite(t)?t:t<0?-34e37:34e37:"string"==typeof t?(e=t.match(a.regex.numberAndUnit))&&(this.value=parseFloat(e[1]),"%"==e[5]?this.value/=100:"s"==e[5]&&(this.value*=1e3),this.unit=e[5]):t instanceof a.Number&&(this.value=t.valueOf(),this.unit=t.unit)},extend:{toString:function(){return("%"==this.unit?~~(1e8*this.value)/1e6:"s"==this.unit?this.value/1e3:this.value)+this.unit},toJSON:function(){return this.toString()},valueOf:function(){return this.value},plus:function(t){return t=new a.Number(t),new a.Number(this+t,this.unit||t.unit)},minus:function(t){return t=new a.Number(t),new a.Number(this-t,this.unit||t.unit)},times:function(t){return t=new a.Number(t),new a.Number(this*t,this.unit||t.unit)},divide:function(t){return t=new a.Number(t),new a.Number(this/t,this.unit||t.unit)},to:function(t){var e=new a.Number(this);return"string"==typeof t&&(e.unit=t),e},morph:function(t){return this.destination=new a.Number(t),t.relative&&(this.destination.value+=this.value),this},at:function(t){return this.destination?new a.Number(this.destination).minus(this).times(t).plus(this):this}}}),a.Element=a.invent({create:function(t){this._stroke=a.defaults.attrs.stroke,this._event=null,this.dom={},(this.node=t)&&(this.type=t.nodeName,this.node.instance=this,this._stroke=t.getAttribute("stroke")||this._stroke)},extend:{x:function(t){return this.attr("x",t)},y:function(t){return this.attr("y",t)},cx:function(t){return null==t?this.x()+this.width()/2:this.x(t-this.width()/2)},cy:function(t){return null==t?this.y()+this.height()/2:this.y(t-this.height()/2)},move:function(t,e){return this.x(t).y(e)},center:function(t,e){return this.cx(t).cy(e)},width:function(t){return this.attr("width",t)},height:function(t){return this.attr("height",t)},size:function(t,e){var i=u(this,t,e);return this.width(new a.Number(i.width)).height(new a.Number(i.height))},clone:function(t){this.writeDataToDom();var e=x(this.node.cloneNode(!0));return t?t.add(e):this.after(e),e},remove:function(){return this.parent()&&this.parent().removeElement(this),this},replace:function(t){return this.after(t).remove(),t},addTo:function(t){return t.put(this)},putIn:function(t){return t.add(this)},id:function(t){return this.attr("id",t)},show:function(){return this.style("display","")},hide:function(){return this.style("display","none")},visible:function(){return"none"!=this.style("display")},toString:function(){return this.attr("id")},classes:function(){var t=this.attr("class");return null==t?[]:t.trim().split(a.regex.delimiter)},hasClass:function(t){return-1!=this.classes().indexOf(t)},addClass:function(t){if(!this.hasClass(t)){var e=this.classes();e.push(t),this.attr("class",e.join(" "))}return this},removeClass:function(t){return this.hasClass(t)&&this.attr("class",this.classes().filter((function(e){return e!=t})).join(" ")),this},toggleClass:function(t){return this.hasClass(t)?this.removeClass(t):this.addClass(t)},reference:function(t){return a.get(this.attr(t))},parent:function(e){var i=this;if(!i.node.parentNode)return null;if(i=a.adopt(i.node.parentNode),!e)return i;for(;i&&i.node instanceof t.SVGElement;){if("string"==typeof e?i.matches(e):i instanceof e)return i;if(!i.node.parentNode||"#document"==i.node.parentNode.nodeName)return null;i=a.adopt(i.node.parentNode)}},doc:function(){return this instanceof a.Doc?this:this.parent(a.Doc)},parents:function(t){var e=[],i=this;do{if(!(i=i.parent(t))||!i.node)break;e.push(i)}while(i.parent);return e},matches:function(t){return function(t,e){return(t.matches||t.matchesSelector||t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||t.oMatchesSelector).call(t,e)}(this.node,t)},native:function(){return this.node},svg:function(t){var i=e.createElement("svg");if(!(t&&this instanceof a.Parent))return i.appendChild(t=e.createElement("svg")),this.writeDataToDom(),t.appendChild(this.node.cloneNode(!0)),i.innerHTML.replace(/^<svg>/,"").replace(/<\/svg>$/,"");i.innerHTML="<svg>"+t.replace(/\n/,"").replace(/<([\w:-]+)([^<]+?)\/>/g,"<$1$2></$1>")+"</svg>";for(var s=0,r=i.firstChild.childNodes.length;s<r;s++)this.node.appendChild(i.firstChild.firstChild);return this},writeDataToDom:function(){return(this.each||this.lines)&&(this.each?this:this.lines()).each((function(){this.writeDataToDom()})),this.node.removeAttribute("svgjs:data"),Object.keys(this.dom).length&&this.node.setAttribute("svgjs:data",JSON.stringify(this.dom)),this},setData:function(t){return this.dom=t,this},is:function(t){return function(t,e){return t instanceof e}(this,t)}}}),a.easing={"-":function(t){return t},"<>":function(t){return-Math.cos(t*Math.PI)/2+.5},">":function(t){return Math.sin(t*Math.PI/2)},"<":function(t){return 1-Math.cos(t*Math.PI/2)}},a.morph=function(t){return function(e,i){return new a.MorphObj(e,i).at(t)}},a.Situation=a.invent({create:function(t){this.init=!1,this.reversed=!1,this.reversing=!1,this.duration=new a.Number(t.duration).valueOf(),this.delay=new a.Number(t.delay).valueOf(),this.start=+new Date+this.delay,this.finish=this.start+this.duration,this.ease=t.ease,this.loop=0,this.loops=!1,this.animations={},this.attrs={},this.styles={},this.transforms=[],this.once={}}}),a.FX=a.invent({create:function(t){this._target=t,this.situations=[],this.active=!1,this.situation=null,this.paused=!1,this.lastPos=0,this.pos=0,this.absPos=0,this._speed=1},extend:{animate:function(t,e,s){"object"===i(t)&&(e=t.ease,s=t.delay,t=t.duration);var r=new a.Situation({duration:t||1e3,delay:s||0,ease:a.easing[e||"-"]||e});return this.queue(r),this},target:function(t){return t&&t instanceof a.Element?(this._target=t,this):this._target},timeToAbsPos:function(t){return(t-this.situation.start)/(this.situation.duration/this._speed)},absPosToTime:function(t){return this.situation.duration/this._speed*t+this.situation.start},startAnimFrame:function(){this.stopAnimFrame(),this.animationFrame=t.requestAnimationFrame(function(){this.step()}.bind(this))},stopAnimFrame:function(){t.cancelAnimationFrame(this.animationFrame)},start:function(){return!this.active&&this.situation&&(this.active=!0,this.startCurrent()),this},startCurrent:function(){return this.situation.start=+new Date+this.situation.delay/this._speed,this.situation.finish=this.situation.start+this.situation.duration/this._speed,this.initAnimations().step()},queue:function(t){return("function"==typeof t||t instanceof a.Situation)&&this.situations.push(t),this.situation||(this.situation=this.situations.shift()),this},dequeue:function(){return this.stop(),this.situation=this.situations.shift(),this.situation&&(this.situation instanceof a.Situation?this.start():this.situation.call(this)),this},initAnimations:function(){var t,e=this.situation;if(e.init)return this;for(var i in e.animations){t=this.target()[i](),Array.isArray(t)||(t=[t]),Array.isArray(e.animations[i])||(e.animations[i]=[e.animations[i]]);for(var s=t.length;s--;)e.animations[i][s]instanceof a.Number&&(t[s]=new a.Number(t[s])),e.animations[i][s]=t[s].morph(e.animations[i][s])}for(var i in e.attrs)e.attrs[i]=new a.MorphObj(this.target().attr(i),e.attrs[i]);for(var i in e.styles)e.styles[i]=new a.MorphObj(this.target().style(i),e.styles[i]);return e.initialTransformation=this.target().matrixify(),e.init=!0,this},clearQueue:function(){return this.situations=[],this},clearCurrent:function(){return this.situation=null,this},stop:function(t,e){var i=this.active;return this.active=!1,e&&this.clearQueue(),t&&this.situation&&(!i&&this.startCurrent(),this.atEnd()),this.stopAnimFrame(),this.clearCurrent()},after:function(t){var e=this.last();return this.target().on("finished.fx",(function i(a){a.detail.situation==e&&(t.call(this,e),this.off("finished.fx",i))})),this._callStart()},during:function(t){var e=this.last(),i=function(i){i.detail.situation==e&&t.call(this,i.detail.pos,a.morph(i.detail.pos),i.detail.eased,e)};return this.target().off("during.fx",i).on("during.fx",i),this.after((function(){this.off("during.fx",i)})),this._callStart()},afterAll:function(t){var e=function e(i){t.call(this),this.off("allfinished.fx",e)};return this.target().off("allfinished.fx",e).on("allfinished.fx",e),this._callStart()},last:function(){return this.situations.length?this.situations[this.situations.length-1]:this.situation},add:function(t,e,i){return this.last()[i||"animations"][t]=e,this._callStart()},step:function(t){var e,i,a;t||(this.absPos=this.timeToAbsPos(+new Date)),!1!==this.situation.loops?(e=Math.max(this.absPos,0),i=Math.floor(e),!0===this.situation.loops||i<this.situation.loops?(this.pos=e-i,a=this.situation.loop,this.situation.loop=i):(this.absPos=this.situation.loops,this.pos=1,a=this.situation.loop-1,this.situation.loop=this.situation.loops),this.situation.reversing&&(this.situation.reversed=this.situation.reversed!=Boolean((this.situation.loop-a)%2))):(this.absPos=Math.min(this.absPos,1),this.pos=this.absPos),this.pos<0&&(this.pos=0),this.situation.reversed&&(this.pos=1-this.pos);var s=this.situation.ease(this.pos);for(var r in this.situation.once)r>this.lastPos&&r<=s&&(this.situation.once[r].call(this.target(),this.pos,s),delete this.situation.once[r]);return this.active&&this.target().fire("during",{pos:this.pos,eased:s,fx:this,situation:this.situation}),this.situation?(this.eachAt(),1==this.pos&&!this.situation.reversed||this.situation.reversed&&0==this.pos?(this.stopAnimFrame(),this.target().fire("finished",{fx:this,situation:this.situation}),this.situations.length||(this.target().fire("allfinished"),this.situations.length||(this.target().off(".fx"),this.active=!1)),this.active?this.dequeue():this.clearCurrent()):!this.paused&&this.active&&this.startAnimFrame(),this.lastPos=s,this):this},eachAt:function(){var t,e=this,i=this.target(),s=this.situation;for(var r in s.animations)t=[].concat(s.animations[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i[r].apply(i,t);for(var r in s.attrs)t=[r].concat(s.attrs[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i.attr.apply(i,t);for(var r in s.styles)t=[r].concat(s.styles[r]).map((function(t){return"string"!=typeof t&&t.at?t.at(s.ease(e.pos),e.pos):t})),i.style.apply(i,t);if(s.transforms.length){t=s.initialTransformation,r=0;for(var o=s.transforms.length;r<o;r++){var n=s.transforms[r];n instanceof a.Matrix?t=n.relative?t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))):t.morph(n).at(s.ease(this.pos)):(n.relative||n.undo(t.extract()),t=t.multiply(n.at(s.ease(this.pos))))}i.matrix(t)}return this},once:function(t,e,i){var a=this.last();return i||(t=a.ease(t)),a.once[t]=e,this},_callStart:function(){return setTimeout(function(){this.start()}.bind(this),0),this}},parent:a.Element,construct:{animate:function(t,e,i){return(this.fx||(this.fx=new a.FX(this))).animate(t,e,i)},delay:function(t){return(this.fx||(this.fx=new a.FX(this))).delay(t)},stop:function(t,e){return this.fx&&this.fx.stop(t,e),this},finish:function(){return this.fx&&this.fx.finish(),this}}}),a.MorphObj=a.invent({create:function(t,e){return a.Color.isColor(e)?new a.Color(t).morph(e):a.regex.delimiter.test(t)?a.regex.pathLetters.test(t)?new a.PathArray(t).morph(e):new a.Array(t).morph(e):a.regex.numberAndUnit.test(e)?new a.Number(t).morph(e):(this.value=t,void(this.destination=e))},extend:{at:function(t,e){return e<1?this.value:this.destination},valueOf:function(){return this.value}}}),a.extend(a.FX,{attr:function(t,e,a){if("object"===i(t))for(var s in t)this.attr(s,t[s]);else this.add(t,e,"attrs");return this},plot:function(t,e,i,a){return 4==arguments.length?this.plot([t,e,i,a]):this.add("plot",new(this.target().morphArray)(t))}}),a.Box=a.invent({create:function(t,e,s,r){if(!("object"!==i(t)||t instanceof a.Element))return a.Box.call(this,null!=t.left?t.left:t.x,null!=t.top?t.top:t.y,t.width,t.height);4==arguments.length&&(this.x=t,this.y=e,this.width=s,this.height=r),b(this)}}),a.BBox=a.invent({create:function(t){if(a.Box.apply(this,[].slice.call(arguments)),t instanceof a.Element){var i;try{if(!e.documentElement.contains){for(var s=t.node;s.parentNode;)s=s.parentNode;if(s!=e)throw new Error("Element not in the dom")}i=t.node.getBBox()}catch(e){if(t instanceof a.Shape){a.parser.draw||a.prepare();var r=t.clone(a.parser.draw.instance).show();r&&r.node&&"function"==typeof r.node.getBBox&&(i=r.node.getBBox()),r&&"function"==typeof r.remove&&r.remove()}else i={x:t.node.clientLeft,y:t.node.clientTop,width:t.node.clientWidth,height:t.node.clientHeight}}a.Box.call(this,i)}},inherit:a.Box,parent:a.Element,construct:{bbox:function(){return new a.BBox(this)}}}),a.BBox.prototype.constructor=a.BBox,a.Matrix=a.invent({create:function(t){var e=f([1,0,0,1,0,0]);t=null===t?e:t instanceof a.Element?t.matrixify():"string"==typeof t?f(t.split(a.regex.delimiter).map(parseFloat)):6==arguments.length?f([].slice.call(arguments)):Array.isArray(t)?f(t):t&&"object"===i(t)?t:e;for(var s=m.length-1;s>=0;--s)this[m[s]]=null!=t[m[s]]?t[m[s]]:e[m[s]]},extend:{extract:function(){var t=p(this,0,1);p(this,1,0);var e=180/Math.PI*Math.atan2(t.y,t.x)-90;return{x:this.e,y:this.f,transformedX:(this.e*Math.cos(e*Math.PI/180)+this.f*Math.sin(e*Math.PI/180))/Math.sqrt(this.a*this.a+this.b*this.b),transformedY:(this.f*Math.cos(e*Math.PI/180)+this.e*Math.sin(-e*Math.PI/180))/Math.sqrt(this.c*this.c+this.d*this.d),rotation:e,a:this.a,b:this.b,c:this.c,d:this.d,e:this.e,f:this.f,matrix:new a.Matrix(this)}},clone:function(){return new a.Matrix(this)},morph:function(t){return this.destination=new a.Matrix(t),this},multiply:function(t){return new a.Matrix(this.native().multiply(function(t){return t instanceof a.Matrix||(t=new a.Matrix(t)),t}(t).native()))},inverse:function(){return new a.Matrix(this.native().inverse())},translate:function(t,e){return new a.Matrix(this.native().translate(t||0,e||0))},native:function(){for(var t=a.parser.native.createSVGMatrix(),e=m.length-1;e>=0;e--)t[m[e]]=this[m[e]];return t},toString:function(){return"matrix("+v(this.a)+","+v(this.b)+","+v(this.c)+","+v(this.d)+","+v(this.e)+","+v(this.f)+")"}},parent:a.Element,construct:{ctm:function(){return new a.Matrix(this.node.getCTM())},screenCTM:function(){if(this instanceof a.Nested){var t=this.rect(1,1),e=t.node.getScreenCTM();return t.remove(),new a.Matrix(e)}return new a.Matrix(this.node.getScreenCTM())}}}),a.Point=a.invent({create:function(t,e){var a;a=Array.isArray(t)?{x:t[0],y:t[1]}:"object"===i(t)?{x:t.x,y:t.y}:null!=t?{x:t,y:null!=e?e:t}:{x:0,y:0},this.x=a.x,this.y=a.y},extend:{clone:function(){return new a.Point(this)},morph:function(t,e){return this.destination=new a.Point(t,e),this}}}),a.extend(a.Element,{point:function(t,e){return new a.Point(t,e).transform(this.screenCTM().inverse())}}),a.extend(a.Element,{attr:function(t,e,s){if(null==t){for(t={},s=(e=this.node.attributes).length-1;s>=0;s--)t[e[s].nodeName]=a.regex.isNumber.test(e[s].nodeValue)?parseFloat(e[s].nodeValue):e[s].nodeValue;return t}if("object"===i(t))for(var r in t)this.attr(r,t[r]);else if(null===e)this.node.removeAttribute(t);else{if(null==e)return null==(e=this.node.getAttribute(t))?a.defaults.attrs[t]:a.regex.isNumber.test(e)?parseFloat(e):e;"stroke-width"==t?this.attr("stroke",parseFloat(e)>0?this._stroke:null):"stroke"==t&&(this._stroke=e),"fill"!=t&&"stroke"!=t||(a.regex.isImage.test(e)&&(e=this.doc().defs().image(e,0,0)),e instanceof a.Image&&(e=this.doc().defs().pattern(0,0,(function(){this.add(e)})))),"number"==typeof e?e=new a.Number(e):a.Color.isColor(e)?e=new a.Color(e):Array.isArray(e)&&(e=new a.Array(e)),"leading"==t?this.leading&&this.leading(e):"string"==typeof s?this.node.setAttributeNS(s,t,e.toString()):this.node.setAttribute(t,e.toString()),!this.rebuild||"font-size"!=t&&"x"!=t||this.rebuild(t,e)}return this}}),a.extend(a.Element,{transform:function(t,e){var s;return"object"!==i(t)?(s=new a.Matrix(this).extract(),"string"==typeof t?s[t]:s):(s=new a.Matrix(this),e=!!e||!!t.relative,null!=t.a&&(s=e?s.multiply(new a.Matrix(t)):new a.Matrix(t)),this.attr("transform",s))}}),a.extend(a.Element,{untransform:function(){return this.attr("transform",null)},matrixify:function(){return(this.attr("transform")||"").split(a.regex.transforms).slice(0,-1).map((function(t){var e=t.trim().split("(");return[e[0],e[1].split(a.regex.delimiter).map((function(t){return parseFloat(t)}))]})).reduce((function(t,e){return"matrix"==e[0]?t.multiply(f(e[1])):t[e[0]].apply(t,e[1])}),new a.Matrix)},toParent:function(t){if(this==t)return this;var e=this.screenCTM(),i=t.screenCTM().inverse();return this.addTo(t).untransform().transform(i.multiply(e)),this},toDoc:function(){return this.toParent(this.doc())}}),a.Transformation=a.invent({create:function(t,e){if(arguments.length>1&&"boolean"!=typeof e)return this.constructor.call(this,[].slice.call(arguments));if(Array.isArray(t))for(var a=0,s=this.arguments.length;a<s;++a)this[this.arguments[a]]=t[a];else if(t&&"object"===i(t))for(a=0,s=this.arguments.length;a<s;++a)this[this.arguments[a]]=t[this.arguments[a]];this.inversed=!1,!0===e&&(this.inversed=!0)}}),a.Translate=a.invent({parent:a.Matrix,inherit:a.Transformation,create:function(t,e){this.constructor.apply(this,[].slice.call(arguments))},extend:{arguments:["transformedX","transformedY"],method:"translate"}}),a.extend(a.Element,{style:function(t,e){if(0==arguments.length)return this.node.style.cssText||"";if(arguments.length<2)if("object"===i(t))for(var s in t)this.style(s,t[s]);else{if(!a.regex.isCss.test(t))return this.node.style[c(t)];for(t=t.split(/\s*;\s*/).filter((function(t){return!!t})).map((function(t){return t.split(/\s*:\s*/)}));e=t.pop();)this.style(e[0],e[1])}else this.node.style[c(t)]=null===e||a.regex.isBlank.test(e)?"":e;return this}}),a.Parent=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Element,extend:{children:function(){return a.utils.map(a.utils.filterSVGElements(this.node.childNodes),(function(t){return a.adopt(t)}))},add:function(t,e){return null==e?this.node.appendChild(t.node):t.node!=this.node.childNodes[e]&&this.node.insertBefore(t.node,this.node.childNodes[e]),this},put:function(t,e){return this.add(t,e),t},has:function(t){return this.index(t)>=0},index:function(t){return[].slice.call(this.node.childNodes).indexOf(t.node)},get:function(t){return a.adopt(this.node.childNodes[t])},first:function(){return this.get(0)},last:function(){return this.get(this.node.childNodes.length-1)},each:function(t,e){for(var i=this.children(),s=0,r=i.length;s<r;s++)i[s]instanceof a.Element&&t.apply(i[s],[s,i]),e&&i[s]instanceof a.Container&&i[s].each(t,e);return this},removeElement:function(t){return this.node.removeChild(t.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,this},defs:function(){return this.doc().defs()}}}),a.extend(a.Parent,{ungroup:function(t,e){return 0===e||this instanceof a.Defs||this.node==a.parser.draw||(t=t||(this instanceof a.Doc?this:this.parent(a.Parent)),e=e||1/0,this.each((function(){return this instanceof a.Defs?this:this instanceof a.Parent?this.ungroup(t,e-1):this.toParent(t)})),this.node.firstChild||this.remove()),this},flatten:function(t,e){return this.ungroup(t,e)}}),a.Container=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Parent}),a.ViewBox=a.invent({parent:a.Container,construct:{}}),["click","dblclick","mousedown","mouseup","mouseover","mouseout","mousemove","touchstart","touchmove","touchleave","touchend","touchcancel"].forEach((function(t){a.Element.prototype[t]=function(e){return a.on(this.node,t,e),this}})),a.listeners=[],a.handlerMap=[],a.listenerId=0,a.on=function(t,e,i,s,r){var o=i.bind(s||t.instance||t),n=(a.handlerMap.indexOf(t)+1||a.handlerMap.push(t))-1,l=e.split(".")[0],h=e.split(".")[1]||"*";a.listeners[n]=a.listeners[n]||{},a.listeners[n][l]=a.listeners[n][l]||{},a.listeners[n][l][h]=a.listeners[n][l][h]||{},i._svgjsListenerId||(i._svgjsListenerId=++a.listenerId),a.listeners[n][l][h][i._svgjsListenerId]=o,t.addEventListener(l,o,r||{passive:!0})},a.off=function(t,e,i){var s=a.handlerMap.indexOf(t),r=e&&e.split(".")[0],o=e&&e.split(".")[1],n="";if(-1!=s)if(i){if("function"==typeof i&&(i=i._svgjsListenerId),!i)return;a.listeners[s][r]&&a.listeners[s][r][o||"*"]&&(t.removeEventListener(r,a.listeners[s][r][o||"*"][i],!1),delete a.listeners[s][r][o||"*"][i])}else if(o&&r){if(a.listeners[s][r]&&a.listeners[s][r][o]){for(var l in a.listeners[s][r][o])a.off(t,[r,o].join("."),l);delete a.listeners[s][r][o]}}else if(o)for(var h in a.listeners[s])for(var n in a.listeners[s][h])o===n&&a.off(t,[h,o].join("."));else if(r){if(a.listeners[s][r]){for(var n in a.listeners[s][r])a.off(t,[r,n].join("."));delete a.listeners[s][r]}}else{for(var h in a.listeners[s])a.off(t,h);delete a.listeners[s],delete a.handlerMap[s]}},a.extend(a.Element,{on:function(t,e,i,s){return a.on(this.node,t,e,i,s),this},off:function(t,e){return a.off(this.node,t,e),this},fire:function(e,i){return e instanceof t.Event?this.node.dispatchEvent(e):this.node.dispatchEvent(e=new a.CustomEvent(e,{detail:i,cancelable:!0})),this._event=e,this},event:function(){return this._event}}),a.Defs=a.invent({create:"defs",inherit:a.Container}),a.G=a.invent({create:"g",inherit:a.Container,extend:{x:function(t){return null==t?this.transform("x"):this.transform({x:t-this.x()},!0)}},construct:{group:function(){return this.put(new a.G)}}}),a.Doc=a.invent({create:function(t){t&&("svg"==(t="string"==typeof t?e.getElementById(t):t).nodeName?this.constructor.call(this,t):(this.constructor.call(this,a.create("svg")),t.appendChild(this.node),this.size("100%","100%")),this.namespace().defs())},inherit:a.Container,extend:{namespace:function(){return this.attr({xmlns:a.ns,version:"1.1"}).attr("xmlns:xlink",a.xlink,a.xmlns).attr("xmlns:svgjs",a.svgjs,a.xmlns)},defs:function(){var t;return this._defs||((t=this.node.getElementsByTagName("defs")[0])?this._defs=a.adopt(t):this._defs=new a.Defs,this.node.appendChild(this._defs.node)),this._defs},parent:function(){return this.node.parentNode&&"#document"!=this.node.parentNode.nodeName?this.node.parentNode:null},remove:function(){return this.parent()&&this.parent().removeChild(this.node),this},clear:function(){for(;this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);return delete this._defs,a.parser.draw&&!a.parser.draw.parentNode&&this.node.appendChild(a.parser.draw),this},clone:function(t){this.writeDataToDom();var e=this.node,i=x(e.cloneNode(!0));return t?(t.node||t).appendChild(i.node):e.parentNode.insertBefore(i.node,e.nextSibling),i}}}),a.extend(a.Element,{}),a.Gradient=a.invent({create:function(t){this.constructor.call(this,a.create(t+"Gradient")),this.type=t},inherit:a.Container,extend:{at:function(t,e,i){return this.put(new a.Stop).update(t,e,i)},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},fill:function(){return"url(#"+this.id()+")"},toString:function(){return this.fill()},attr:function(t,e,i){return"transform"==t&&(t="gradientTransform"),a.Container.prototype.attr.call(this,t,e,i)}},construct:{gradient:function(t,e){return this.defs().gradient(t,e)}}}),a.extend(a.Gradient,a.FX,{from:function(t,e){return"radial"==(this._target||this).type?this.attr({fx:new a.Number(t),fy:new a.Number(e)}):this.attr({x1:new a.Number(t),y1:new a.Number(e)})},to:function(t,e){return"radial"==(this._target||this).type?this.attr({cx:new a.Number(t),cy:new a.Number(e)}):this.attr({x2:new a.Number(t),y2:new a.Number(e)})}}),a.extend(a.Defs,{gradient:function(t,e){return this.put(new a.Gradient(t)).update(e)}}),a.Stop=a.invent({create:"stop",inherit:a.Element,extend:{update:function(t){return("number"==typeof t||t instanceof a.Number)&&(t={offset:arguments[0],color:arguments[1],opacity:arguments[2]}),null!=t.opacity&&this.attr("stop-opacity",t.opacity),null!=t.color&&this.attr("stop-color",t.color),null!=t.offset&&this.attr("offset",new a.Number(t.offset)),this}}}),a.Pattern=a.invent({create:"pattern",inherit:a.Container,extend:{fill:function(){return"url(#"+this.id()+")"},update:function(t){return this.clear(),"function"==typeof t&&t.call(this,this),this},toString:function(){return this.fill()},attr:function(t,e,i){return"transform"==t&&(t="patternTransform"),a.Container.prototype.attr.call(this,t,e,i)}},construct:{pattern:function(t,e,i){return this.defs().pattern(t,e,i)}}}),a.extend(a.Defs,{pattern:function(t,e,i){return this.put(new a.Pattern).update(i).attr({x:0,y:0,width:t,height:e,patternUnits:"userSpaceOnUse"})}}),a.Shape=a.invent({create:function(t){this.constructor.call(this,t)},inherit:a.Element}),a.Symbol=a.invent({create:"symbol",inherit:a.Container,construct:{symbol:function(){return this.put(new a.Symbol)}}}),a.Use=a.invent({create:"use",inherit:a.Shape,extend:{element:function(t,e){return this.attr("href",(e||"")+"#"+t,a.xlink)}},construct:{use:function(t,e){return this.put(new a.Use).element(t,e)}}}),a.Rect=a.invent({create:"rect",inherit:a.Shape,construct:{rect:function(t,e){return this.put(new a.Rect).size(t,e)}}}),a.Circle=a.invent({create:"circle",inherit:a.Shape,construct:{circle:function(t){return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0,0)}}}),a.extend(a.Circle,a.FX,{rx:function(t){return this.attr("r",t)},ry:function(t){return this.rx(t)}}),a.Ellipse=a.invent({create:"ellipse",inherit:a.Shape,construct:{ellipse:function(t,e){return this.put(new a.Ellipse).size(t,e).move(0,0)}}}),a.extend(a.Ellipse,a.Rect,a.FX,{rx:function(t){return this.attr("rx",t)},ry:function(t){return this.attr("ry",t)}}),a.extend(a.Circle,a.Ellipse,{x:function(t){return null==t?this.cx()-this.rx():this.cx(t+this.rx())},y:function(t){return null==t?this.cy()-this.ry():this.cy(t+this.ry())},cx:function(t){return null==t?this.attr("cx"):this.attr("cx",t)},cy:function(t){return null==t?this.attr("cy"):this.attr("cy",t)},width:function(t){return null==t?2*this.rx():this.rx(new a.Number(t).divide(2))},height:function(t){return null==t?2*this.ry():this.ry(new a.Number(t).divide(2))},size:function(t,e){var i=u(this,t,e);return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2))}}),a.Line=a.invent({create:"line",inherit:a.Shape,extend:{array:function(){return new a.PointArray([[this.attr("x1"),this.attr("y1")],[this.attr("x2"),this.attr("y2")]])},plot:function(t,e,i,s){return null==t?this.array():(t=void 0!==e?{x1:t,y1:e,x2:i,y2:s}:new a.PointArray(t).toLine(),this.attr(t))},move:function(t,e){return this.attr(this.array().move(t,e).toLine())},size:function(t,e){var i=u(this,t,e);return this.attr(this.array().size(i.width,i.height).toLine())}},construct:{line:function(t,e,i,s){return a.Line.prototype.plot.apply(this.put(new a.Line),null!=t?[t,e,i,s]:[0,0,0,0])}}}),a.Polyline=a.invent({create:"polyline",inherit:a.Shape,construct:{polyline:function(t){return this.put(new a.Polyline).plot(t||new a.PointArray)}}}),a.Polygon=a.invent({create:"polygon",inherit:a.Shape,construct:{polygon:function(t){return this.put(new a.Polygon).plot(t||new a.PointArray)}}}),a.extend(a.Polyline,a.Polygon,{array:function(){return this._array||(this._array=new a.PointArray(this.attr("points")))},plot:function(t){return null==t?this.array():this.clear().attr("points","string"==typeof t?t:this._array=new a.PointArray(t))},clear:function(){return delete this._array,this},move:function(t,e){return this.attr("points",this.array().move(t,e))},size:function(t,e){var i=u(this,t,e);return this.attr("points",this.array().size(i.width,i.height))}}),a.extend(a.Line,a.Polyline,a.Polygon,{morphArray:a.PointArray,x:function(t){return null==t?this.bbox().x:this.move(t,this.bbox().y)},y:function(t){return null==t?this.bbox().y:this.move(this.bbox().x,t)},width:function(t){var e=this.bbox();return null==t?e.width:this.size(t,e.height)},height:function(t){var e=this.bbox();return null==t?e.height:this.size(e.width,t)}}),a.Path=a.invent({create:"path",inherit:a.Shape,extend:{morphArray:a.PathArray,array:function(){return this._array||(this._array=new a.PathArray(this.attr("d")))},plot:function(t){return null==t?this.array():this.clear().attr("d","string"==typeof t?t:this._array=new a.PathArray(t))},clear:function(){return delete this._array,this}},construct:{path:function(t){return this.put(new a.Path).plot(t||new a.PathArray)}}}),a.Image=a.invent({create:"image",inherit:a.Shape,extend:{load:function(e){if(!e)return this;var i=this,s=new t.Image;return a.on(s,"load",(function(){a.off(s);var t=i.parent(a.Pattern);null!==t&&(0==i.width()&&0==i.height()&&i.size(s.width,s.height),t&&0==t.width()&&0==t.height()&&t.size(i.width(),i.height()),"function"==typeof i._loaded&&i._loaded.call(i,{width:s.width,height:s.height,ratio:s.width/s.height,url:e}))})),a.on(s,"error",(function(t){a.off(s),"function"==typeof i._error&&i._error.call(i,t)})),this.attr("href",s.src=this.src=e,a.xlink)},loaded:function(t){return this._loaded=t,this},error:function(t){return this._error=t,this}},construct:{image:function(t,e,i){return this.put(new a.Image).load(t).size(e||0,i||e||0)}}}),a.Text=a.invent({create:function(){this.constructor.call(this,a.create("text")),this.dom.leading=new a.Number(1.3),this._rebuild=!0,this._build=!1,this.attr("font-family",a.defaults.attrs["font-family"])},inherit:a.Shape,extend:{x:function(t){return null==t?this.attr("x"):this.attr("x",t)},text:function(t){if(void 0===t){t="";for(var e=this.node.childNodes,i=0,s=e.length;i<s;++i)0!=i&&3!=e[i].nodeType&&1==a.adopt(e[i]).dom.newLined&&(t+="\n"),t+=e[i].textContent;return t}if(this.clear().build(!0),"function"==typeof t)t.call(this,this);else{i=0;for(var r=(t=t.split("\n")).length;i<r;i++)this.tspan(t[i]).newLine()}return this.build(!1).rebuild()},size:function(t){return this.attr("font-size",t).rebuild()},leading:function(t){return null==t?this.dom.leading:(this.dom.leading=new a.Number(t),this.rebuild())},lines:function(){var t=(this.textPath&&this.textPath()||this).node,e=a.utils.map(a.utils.filterSVGElements(t.childNodes),(function(t){return a.adopt(t)}));return new a.Set(e)},rebuild:function(t){if("boolean"==typeof t&&(this._rebuild=t),this._rebuild){var e=this,i=0,s=this.dom.leading*new a.Number(this.attr("font-size"));this.lines().each((function(){this.dom.newLined&&(e.textPath()||this.attr("x",e.attr("x")),"\n"==this.text()?i+=s:(this.attr("dy",s+i),i=0))})),this.fire("rebuild")}return this},build:function(t){return this._build=!!t,this},setData:function(t){return this.dom=t,this.dom.leading=new a.Number(t.leading||1.3),this}},construct:{text:function(t){return this.put(new a.Text).text(t)},plain:function(t){return this.put(new a.Text).plain(t)}}}),a.Tspan=a.invent({create:"tspan",inherit:a.Shape,extend:{text:function(t){return null==t?this.node.textContent+(this.dom.newLined?"\n":""):("function"==typeof t?t.call(this,this):this.plain(t),this)},dx:function(t){return this.attr("dx",t)},dy:function(t){return this.attr("dy",t)},newLine:function(){var t=this.parent(a.Text);return this.dom.newLined=!0,this.dy(t.dom.leading*t.attr("font-size")).attr("x",t.x())}}}),a.extend(a.Text,a.Tspan,{plain:function(t){return!1===this._build&&this.clear(),this.node.appendChild(e.createTextNode(t)),this},tspan:function(t){var e=(this.textPath&&this.textPath()||this).node,i=new a.Tspan;return!1===this._build&&this.clear(),e.appendChild(i.node),i.text(t)},clear:function(){for(var t=(this.textPath&&this.textPath()||this).node;t.hasChildNodes();)t.removeChild(t.lastChild);return this},length:function(){return this.node.getComputedTextLength()}}),a.TextPath=a.invent({create:"textPath",inherit:a.Parent,parent:a.Text,construct:{morphArray:a.PathArray,array:function(){var t=this.track();return t?t.array():null},plot:function(t){var e=this.track(),i=null;return e&&(i=e.plot(t)),null==t?i:this},track:function(){var t=this.textPath();if(t)return t.reference("href")},textPath:function(){if(this.node.firstChild&&"textPath"==this.node.firstChild.nodeName)return a.adopt(this.node.firstChild)}}}),a.Nested=a.invent({create:function(){this.constructor.call(this,a.create("svg")),this.style("overflow","visible")},inherit:a.Container,construct:{nested:function(){return this.put(new a.Nested)}}});var l={stroke:["color","width","opacity","linecap","linejoin","miterlimit","dasharray","dashoffset"],fill:["color","opacity","rule"],prefix:function(t,e){return"color"==e?t:t+"-"+e}};function h(t,e,i,s){return i+s.replace(a.regex.dots," .")}function c(t){return t.toLowerCase().replace(/-(.)/g,(function(t,e){return e.toUpperCase()}))}function d(t){return t.charAt(0).toUpperCase()+t.slice(1)}function g(t){var e=t.toString(16);return 1==e.length?"0"+e:e}function u(t,e,i){if(null==e||null==i){var a=t.bbox();null==e?e=a.width/a.height*i:null==i&&(i=a.height/a.width*e)}return{width:e,height:i}}function p(t,e,i){return{x:e*t.a+i*t.c+0,y:e*t.b+i*t.d+0}}function f(t){return{a:t[0],b:t[1],c:t[2],d:t[3],e:t[4],f:t[5]}}function x(e){for(var i=e.childNodes.length-1;i>=0;i--)e.childNodes[i]instanceof t.SVGElement&&x(e.childNodes[i]);return a.adopt(e).id(a.eid(e.nodeName))}function b(t){return null==t.x&&(t.x=0,t.y=0,t.width=0,t.height=0),t.w=t.width,t.h=t.height,t.x2=t.x+t.width,t.y2=t.y+t.height,t.cx=t.x+t.width/2,t.cy=t.y+t.height/2,t}function v(t){return Math.abs(t)>1e-37?t:0}["fill","stroke"].forEach((function(t){var e={};e[t]=function(e){if(void 0===e)return this;if("string"==typeof e||a.Color.isRgb(e)||e&&"function"==typeof e.fill)this.attr(t,e);else for(var i=l[t].length-1;i>=0;i--)null!=e[l[t][i]]&&this.attr(l.prefix(t,l[t][i]),e[l[t][i]]);return this},a.extend(a.Element,a.FX,e)})),a.extend(a.Element,a.FX,{translate:function(t,e){return this.transform({x:t,y:e})},matrix:function(t){return this.attr("transform",new a.Matrix(6==arguments.length?[].slice.call(arguments):t))},opacity:function(t){return this.attr("opacity",t)},dx:function(t){return this.x(new a.Number(t).plus(this instanceof a.FX?0:this.x()),!0)},dy:function(t){return this.y(new a.Number(t).plus(this instanceof a.FX?0:this.y()),!0)}}),a.extend(a.Path,{length:function(){return this.node.getTotalLength()},pointAt:function(t){return this.node.getPointAtLength(t)}}),a.Set=a.invent({create:function(t){Array.isArray(t)?this.members=t:this.clear()},extend:{add:function(){for(var t=[].slice.call(arguments),e=0,i=t.length;e<i;e++)this.members.push(t[e]);return this},remove:function(t){var e=this.index(t);return e>-1&&this.members.splice(e,1),this},each:function(t){for(var e=0,i=this.members.length;e<i;e++)t.apply(this.members[e],[e,this.members]);return this},clear:function(){return this.members=[],this},length:function(){return this.members.length},has:function(t){return this.index(t)>=0},index:function(t){return this.members.indexOf(t)},get:function(t){return this.members[t]},first:function(){return this.get(0)},last:function(){return this.get(this.members.length-1)},valueOf:function(){return this.members}},construct:{set:function(t){return new a.Set(t)}}}),a.FX.Set=a.invent({create:function(t){this.set=t}}),a.Set.inherit=function(){var t=[];for(var e in a.Shape.prototype)"function"==typeof a.Shape.prototype[e]&&"function"!=typeof a.Set.prototype[e]&&t.push(e);for(var e in t.forEach((function(t){a.Set.prototype[t]=function(){for(var e=0,i=this.members.length;e<i;e++)this.members[e]&&"function"==typeof this.members[e][t]&&this.members[e][t].apply(this.members[e],arguments);return"animate"==t?this.fx||(this.fx=new a.FX.Set(this)):this}})),t=[],a.FX.prototype)"function"==typeof a.FX.prototype[e]&&"function"!=typeof a.FX.Set.prototype[e]&&t.push(e);t.forEach((function(t){a.FX.Set.prototype[t]=function(){for(var e=0,i=this.set.members.length;e<i;e++)this.set.members[e].fx[t].apply(this.set.members[e].fx,arguments);return this}}))},a.extend(a.Element,{}),a.extend(a.Element,{remember:function(t,e){if("object"===i(arguments[0]))for(var a in t)this.remember(a,t[a]);else{if(1==arguments.length)return this.memory()[t];this.memory()[t]=e}return this},forget:function(){if(0==arguments.length)this._memory={};else for(var t=arguments.length-1;t>=0;t--)delete this.memory()[arguments[t]];return this},memory:function(){return this._memory||(this._memory={})}}),a.get=function(t){var i=e.getElementById(function(t){var e=(t||"").toString().match(a.regex.reference);if(e)return e[1]}(t)||t);return a.adopt(i)},a.select=function(t,i){return new a.Set(a.utils.map((i||e).querySelectorAll(t),(function(t){return a.adopt(t)})))},a.extend(a.Parent,{select:function(t){return a.select(t,this.node)}});var m="abcdef".split("");if("function"!=typeof t.CustomEvent){var y=function(t,i){i=i||{bubbles:!1,cancelable:!1,detail:void 0};var a=e.createEvent("CustomEvent");return a.initCustomEvent(t,i.bubbles,i.cancelable,i.detail),a};y.prototype=t.Event.prototype,a.CustomEvent=y}else a.CustomEvent=t.CustomEvent;return a}, true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return zt(It,It.document)}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===("undefined"==typeof exports?"undefined":i(exports))&&"undefined"!=typeof module?module.exports=It.document?zt(It,It.document):function(t){return zt(t,t.document)}:It.SVG=zt(It,It.document),
/*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */
function(){SVG.Filter=SVG.invent({create:"filter",inherit:SVG.Parent,extend:{source:"SourceGraphic",sourceAlpha:"SourceAlpha",background:"BackgroundImage",backgroundAlpha:"BackgroundAlpha",fill:"FillPaint",stroke:"StrokePaint",autoSetIn:!0,put:function(t,e){return this.add(t,e),!t.attr("in")&&this.autoSetIn&&t.attr("in",this.source),t.attr("result")||t.attr("result",t),t},blend:function(t,e,i){return this.put(new SVG.BlendEffect(t,e,i))},colorMatrix:function(t,e){return this.put(new SVG.ColorMatrixEffect(t,e))},convolveMatrix:function(t){return this.put(new SVG.ConvolveMatrixEffect(t))},componentTransfer:function(t){return this.put(new SVG.ComponentTransferEffect(t))},composite:function(t,e,i){return this.put(new SVG.CompositeEffect(t,e,i))},flood:function(t,e){return this.put(new SVG.FloodEffect(t,e))},offset:function(t,e){return this.put(new SVG.OffsetEffect(t,e))},image:function(t){return this.put(new SVG.ImageEffect(t))},merge:function(){var t=[void 0];for(var e in arguments)t.push(arguments[e]);return this.put(new(SVG.MergeEffect.bind.apply(SVG.MergeEffect,t)))},gaussianBlur:function(t,e){return this.put(new SVG.GaussianBlurEffect(t,e))},morphology:function(t,e){return this.put(new SVG.MorphologyEffect(t,e))},diffuseLighting:function(t,e,i){return this.put(new SVG.DiffuseLightingEffect(t,e,i))},displacementMap:function(t,e,i,a,s){return this.put(new SVG.DisplacementMapEffect(t,e,i,a,s))},specularLighting:function(t,e,i,a){return this.put(new SVG.SpecularLightingEffect(t,e,i,a))},tile:function(){return this.put(new SVG.TileEffect)},turbulence:function(t,e,i,a,s){return this.put(new SVG.TurbulenceEffect(t,e,i,a,s))},toString:function(){return"url(#"+this.attr("id")+")"}}}),SVG.extend(SVG.Defs,{filter:function(t){var e=this.put(new SVG.Filter);return"function"==typeof t&&t.call(e,e),e}}),SVG.extend(SVG.Container,{filter:function(t){return this.defs().filter(t)}}),SVG.extend(SVG.Element,SVG.G,SVG.Nested,{filter:function(t){return this.filterer=t instanceof SVG.Element?t:this.doc().filter(t),this.doc()&&this.filterer.doc()!==this.doc()&&this.doc().defs().add(this.filterer),this.attr("filter",this.filterer),this.filterer},unfilter:function(t){return this.filterer&&!0===t&&this.filterer.remove(),delete this.filterer,this.attr("filter",null)}}),SVG.Effect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}}),SVG.ParentEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Parent,extend:{in:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in")+'"]').get(0)||this.attr("in"):this.attr("in",t)},result:function(t){return null==t?this.attr("result"):this.attr("result",t)},toString:function(){return this.result()}}});var t={blend:function(t,e){return this.parent()&&this.parent().blend(this,t,e)},colorMatrix:function(t,e){return this.parent()&&this.parent().colorMatrix(t,e).in(this)},convolveMatrix:function(t){return this.parent()&&this.parent().convolveMatrix(t).in(this)},componentTransfer:function(t){return this.parent()&&this.parent().componentTransfer(t).in(this)},composite:function(t,e){return this.parent()&&this.parent().composite(this,t,e)},flood:function(t,e){return this.parent()&&this.parent().flood(t,e)},offset:function(t,e){return this.parent()&&this.parent().offset(t,e).in(this)},image:function(t){return this.parent()&&this.parent().image(t)},merge:function(){return this.parent()&&this.parent().merge.apply(this.parent(),[this].concat(arguments))},gaussianBlur:function(t,e){return this.parent()&&this.parent().gaussianBlur(t,e).in(this)},morphology:function(t,e){return this.parent()&&this.parent().morphology(t,e).in(this)},diffuseLighting:function(t,e,i){return this.parent()&&this.parent().diffuseLighting(t,e,i).in(this)},displacementMap:function(t,e,i,a){return this.parent()&&this.parent().displacementMap(this,t,e,i,a)},specularLighting:function(t,e,i,a){return this.parent()&&this.parent().specularLighting(t,e,i,a).in(this)},tile:function(){return this.parent()&&this.parent().tile().in(this)},turbulence:function(t,e,i,a,s){return this.parent()&&this.parent().turbulence(t,e,i,a,s).in(this)}};SVG.extend(SVG.Effect,t),SVG.extend(SVG.ParentEffect,t),SVG.ChildEffect=SVG.invent({create:function(){this.constructor.call(this)},inherit:SVG.Element,extend:{in:function(t){this.attr("in",t)}}});var e={blend:function(t,e,i){this.attr({in:t,in2:e,mode:i||"normal"})},colorMatrix:function(t,e){"matrix"==t&&(e=s(e)),this.attr({type:t,values:void 0===e?null:e})},convolveMatrix:function(t){t=s(t),this.attr({order:Math.sqrt(t.split(" ").length),kernelMatrix:t})},composite:function(t,e,i){this.attr({in:t,in2:e,operator:i})},flood:function(t,e){this.attr("flood-color",t),null!=e&&this.attr("flood-opacity",e)},offset:function(t,e){this.attr({dx:t,dy:e})},image:function(t){this.attr("href",t,SVG.xlink)},displacementMap:function(t,e,i,a,s){this.attr({in:t,in2:e,scale:i,xChannelSelector:a,yChannelSelector:s})},gaussianBlur:function(t,e){null!=t||null!=e?this.attr("stdDeviation",r(Array.prototype.slice.call(arguments))):this.attr("stdDeviation","0 0")},morphology:function(t,e){this.attr({operator:t,radius:e})},tile:function(){},turbulence:function(t,e,i,a,s){this.attr({numOctaves:e,seed:i,stitchTiles:a,baseFrequency:t,type:s})}},i={merge:function(){var t;if(arguments[0]instanceof SVG.Set){var e=this;arguments[0].each((function(t){this instanceof SVG.MergeNode?e.put(this):(this instanceof SVG.Effect||this instanceof SVG.ParentEffect)&&e.put(new SVG.MergeNode(this))}))}else{t=Array.isArray(arguments[0])?arguments[0]:arguments;for(var i=0;i<t.length;i++)t[i]instanceof SVG.MergeNode?this.put(t[i]):this.put(new SVG.MergeNode(t[i]))}},componentTransfer:function(t){if(this.rgb=new SVG.Set,["r","g","b","a"].forEach(function(t){this[t]=new(SVG["Func"+t.toUpperCase()])("identity"),this.rgb.add(this[t]),this.node.appendChild(this[t].node)}.bind(this)),t)for(var e in t.rgb&&(["r","g","b"].forEach(function(e){this[e].attr(t.rgb)}.bind(this)),delete t.rgb),t)this[e].attr(t[e])},diffuseLighting:function(t,e,i){this.attr({surfaceScale:t,diffuseConstant:e,kernelUnitLength:i})},specularLighting:function(t,e,i,a){this.attr({surfaceScale:t,diffuseConstant:e,specularExponent:i,kernelUnitLength:a})}},a={distantLight:function(t,e){this.attr({azimuth:t,elevation:e})},pointLight:function(t,e,i){this.attr({x:t,y:e,z:i})},spotLight:function(t,e,i,a,s,r){this.attr({x:t,y:e,z:i,pointsAtX:a,pointsAtY:s,pointsAtZ:r})},mergeNode:function(t){this.attr("in",t)}};function s(t){return Array.isArray(t)&&(t=new SVG.Array(t)),t.toString().replace(/^\s+/,"").replace(/\s+$/,"").replace(/\s+/g," ")}function r(t){if(!Array.isArray(t))return t;for(var e=0,i=t.length,a=[];e<i;e++)a.push(t[e]);return a.join(" ")}function o(){var t=function(){};for(var e in"function"==typeof arguments[arguments.length-1]&&(t=arguments[arguments.length-1],Array.prototype.splice.call(arguments,arguments.length-1,1)),arguments)for(var i in arguments[e])t(arguments[e][i],i,arguments[e])}["r","g","b","a"].forEach((function(t){a["Func"+t.toUpperCase()]=function(t){switch(this.attr("type",t),t){case"table":this.attr("tableValues",arguments[1]);break;case"linear":this.attr("slope",arguments[1]),this.attr("intercept",arguments[2]);break;case"gamma":this.attr("amplitude",arguments[1]),this.attr("exponent",arguments[2]),this.attr("offset",arguments[2])}}})),o(e,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.Effect,extend:{}})})),o(i,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i+"Effect"]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments),this.result(this.attr("id")+"Out")},inherit:SVG.ParentEffect,extend:{}})})),o(a,(function(t,e){var i=e.charAt(0).toUpperCase()+e.slice(1);SVG[i]=SVG.invent({create:function(){this.constructor.call(this,SVG.create("fe"+i)),t.apply(this,arguments)},inherit:SVG.ChildEffect,extend:{}})})),SVG.extend(SVG.MergeEffect,{in:function(t){return t instanceof SVG.MergeNode?this.add(t,0):this.add(new SVG.MergeNode(t),0),this}}),SVG.extend(SVG.CompositeEffect,SVG.BlendEffect,SVG.DisplacementMapEffect,{in2:function(t){return null==t?this.parent()&&this.parent().select('[result="'+this.attr("in2")+'"]').get(0)||this.attr("in2"):this.attr("in2",t)}}),SVG.filter={sepiatone:[.343,.669,.119,0,0,.249,.626,.13,0,0,.172,.334,.111,0,0,0,0,0,1,0]}}.call(void 0),function(){function t(t,s,r,o,n,l,h){for(var c=t.slice(s,r||h),d=o.slice(n,l||h),g=0,u={pos:[0,0],start:[0,0]},p={pos:[0,0],start:[0,0]};;){if(c[g]=e.call(u,c[g]),d[g]=e.call(p,d[g]),c[g][0]!=d[g][0]||"M"==c[g][0]||"A"==c[g][0]&&(c[g][4]!=d[g][4]||c[g][5]!=d[g][5])?(Array.prototype.splice.apply(c,[g,1].concat(a.call(u,c[g]))),Array.prototype.splice.apply(d,[g,1].concat(a.call(p,d[g])))):(c[g]=i.call(u,c[g]),d[g]=i.call(p,d[g])),++g==c.length&&g==d.length)break;g==c.length&&c.push(["C",u.pos[0],u.pos[1],u.pos[0],u.pos[1],u.pos[0],u.pos[1]]),g==d.length&&d.push(["C",p.pos[0],p.pos[1],p.pos[0],p.pos[1],p.pos[0],p.pos[1]])}return{start:c,dest:d}}function e(t){switch(t[0]){case"z":case"Z":t[0]="L",t[1]=this.start[0],t[2]=this.start[1];break;case"H":t[0]="L",t[2]=this.pos[1];break;case"V":t[0]="L",t[2]=t[1],t[1]=this.pos[0];break;case"T":t[0]="Q",t[3]=t[1],t[4]=t[2],t[1]=this.reflection[1],t[2]=this.reflection[0];break;case"S":t[0]="C",t[6]=t[4],t[5]=t[3],t[4]=t[2],t[3]=t[1],t[2]=this.reflection[1],t[1]=this.reflection[0]}return t}function i(t){var e=t.length;return this.pos=[t[e-2],t[e-1]],-1!="SCQT".indexOf(t[0])&&(this.reflection=[2*this.pos[0]-t[e-4],2*this.pos[1]-t[e-3]]),t}function a(t){var e=[t];switch(t[0]){case"M":return this.pos=this.start=[t[1],t[2]],e;case"L":t[5]=t[3]=t[1],t[6]=t[4]=t[2],t[1]=this.pos[0],t[2]=this.pos[1];break;case"Q":t[6]=t[4],t[5]=t[3],t[4]=1*t[4]/3+2*t[2]/3,t[3]=1*t[3]/3+2*t[1]/3,t[2]=1*this.pos[1]/3+2*t[2]/3,t[1]=1*this.pos[0]/3+2*t[1]/3;break;case"A":t=(e=function(t,e){var i,a,s,r,o,n,l,h,c,d,g,u,p,f,x,b,v,m,y,w,k,A,S,C,L,P,M=Math.abs(e[1]),T=Math.abs(e[2]),I=e[3]%360,z=e[4],X=e[5],E=e[6],Y=e[7],F=new SVG.Point(t),R=new SVG.Point(E,Y),H=[];if(0===M||0===T||F.x===R.x&&F.y===R.y)return[["C",F.x,F.y,R.x,R.y,R.x,R.y]];i=new SVG.Point((F.x-R.x)/2,(F.y-R.y)/2).transform((new SVG.Matrix).rotate(I)),(a=i.x*i.x/(M*M)+i.y*i.y/(T*T))>1&&(M*=a=Math.sqrt(a),T*=a);s=(new SVG.Matrix).rotate(I).scale(1/M,1/T).rotate(-I),F=F.transform(s),R=R.transform(s),r=[R.x-F.x,R.y-F.y],n=r[0]*r[0]+r[1]*r[1],o=Math.sqrt(n),r[0]/=o,r[1]/=o,l=n<4?Math.sqrt(1-n/4):0,z===X&&(l*=-1);h=new SVG.Point((R.x+F.x)/2+l*-r[1],(R.y+F.y)/2+l*r[0]),c=new SVG.Point(F.x-h.x,F.y-h.y),d=new SVG.Point(R.x-h.x,R.y-h.y),g=Math.acos(c.x/Math.sqrt(c.x*c.x+c.y*c.y)),c.y<0&&(g*=-1);u=Math.acos(d.x/Math.sqrt(d.x*d.x+d.y*d.y)),d.y<0&&(u*=-1);X&&g>u&&(u+=2*Math.PI);!X&&g<u&&(u-=2*Math.PI);for(f=Math.ceil(2*Math.abs(g-u)/Math.PI),b=[],v=g,p=(u-g)/f,x=4*Math.tan(p/4)/3,k=0;k<=f;k++)y=Math.cos(v),m=Math.sin(v),w=new SVG.Point(h.x+y,h.y+m),b[k]=[new SVG.Point(w.x+x*m,w.y-x*y),w,new SVG.Point(w.x-x*m,w.y+x*y)],v+=p;for(b[0][0]=b[0][1].clone(),b[b.length-1][2]=b[b.length-1][1].clone(),s=(new SVG.Matrix).rotate(I).scale(M,T).rotate(-I),k=0,A=b.length;k<A;k++)b[k][0]=b[k][0].transform(s),b[k][1]=b[k][1].transform(s),b[k][2]=b[k][2].transform(s);for(k=1,A=b.length;k<A;k++)S=(w=b[k-1][2]).x,C=w.y,L=(w=b[k][0]).x,P=w.y,E=(w=b[k][1]).x,Y=w.y,H.push(["C",S,C,L,P,E,Y]);return H}(this.pos,t))[0]}return t[0]="C",this.pos=[t[5],t[6]],this.reflection=[2*t[5]-t[3],2*t[6]-t[4]],e}function s(t,e){if(!1===e)return!1;for(var i=e,a=t.length;i<a;++i)if("M"==t[i][0])return i;return!1}SVG.extend(SVG.PathArray,{morph:function(e){for(var i=this.value,a=this.parse(e),r=0,o=0,n=!1,l=!1;!1!==r||!1!==o;){var h;n=s(i,!1!==r&&r+1),l=s(a,!1!==o&&o+1),!1===r&&(r=0==(h=new SVG.PathArray(c.start).bbox()).height||0==h.width?i.push(i[0])-1:i.push(["M",h.x+h.width/2,h.y+h.height/2])-1),!1===o&&(o=0==(h=new SVG.PathArray(c.dest).bbox()).height||0==h.width?a.push(a[0])-1:a.push(["M",h.x+h.width/2,h.y+h.height/2])-1);var c=t(i,r,n,a,o,l);i=i.slice(0,r).concat(c.start,!1===n?[]:i.slice(n)),a=a.slice(0,o).concat(c.dest,!1===l?[]:a.slice(l)),r=!1!==n&&r+c.start.length,o=!1!==l&&o+c.dest.length}return this.value=i,this.destination=new SVG.PathArray,this.destination.value=a,this}})}(),
/*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */
function(){function t(t){t.remember("_draggable",this),this.el=t}t.prototype.init=function(t,e){var i=this;this.constraint=t,this.value=e,this.el.on("mousedown.drag",(function(t){i.start(t)})),this.el.on("touchstart.drag",(function(t){i.start(t)}))},t.prototype.transformPoint=function(t,e){var i=(t=t||window.event).changedTouches&&t.changedTouches[0]||t;return this.p.x=i.clientX-(e||0),this.p.y=i.clientY,this.p.matrixTransform(this.m)},t.prototype.getBBox=function(){var t=this.el.bbox();return this.el instanceof SVG.Nested&&(t=this.el.rbox()),(this.el instanceof SVG.G||this.el instanceof SVG.Use||this.el instanceof SVG.Nested)&&(t.x=this.el.x(),t.y=this.el.y()),t},t.prototype.start=function(t){if("click"!=t.type&&"mousedown"!=t.type&&"mousemove"!=t.type||1==(t.which||t.buttons)){var e=this;if(this.el.fire("beforedrag",{event:t,handler:this}),!this.el.event().defaultPrevented){t.preventDefault(),t.stopPropagation(),this.parent=this.parent||this.el.parent(SVG.Nested)||this.el.parent(SVG.Doc),this.p=this.parent.node.createSVGPoint(),this.m=this.el.node.getScreenCTM().inverse();var i,a=this.getBBox();if(this.el instanceof SVG.Text)switch(i=this.el.node.getComputedTextLength(),this.el.attr("text-anchor")){case"middle":i/=2;break;case"start":i=0}this.startPoints={point:this.transformPoint(t,i),box:a,transform:this.el.transform()},SVG.on(window,"mousemove.drag",(function(t){e.drag(t)})),SVG.on(window,"touchmove.drag",(function(t){e.drag(t)})),SVG.on(window,"mouseup.drag",(function(t){e.end(t)})),SVG.on(window,"touchend.drag",(function(t){e.end(t)})),this.el.fire("dragstart",{event:t,p:this.startPoints.point,m:this.m,handler:this})}}},t.prototype.drag=function(t){var e=this.getBBox(),i=this.transformPoint(t),a=this.startPoints.box.x+i.x-this.startPoints.point.x,s=this.startPoints.box.y+i.y-this.startPoints.point.y,r=this.constraint,o=i.x-this.startPoints.point.x,n=i.y-this.startPoints.point.y;if(this.el.fire("dragmove",{event:t,p:i,m:this.m,handler:this}),this.el.event().defaultPrevented)return i;if("function"==typeof r){var l=r.call(this.el,a,s,this.m);"boolean"==typeof l&&(l={x:l,y:l}),!0===l.x?this.el.x(a):!1!==l.x&&this.el.x(l.x),!0===l.y?this.el.y(s):!1!==l.y&&this.el.y(l.y)}else"object"==typeof r&&(null!=r.minX&&a<r.minX?o=(a=r.minX)-this.startPoints.box.x:null!=r.maxX&&a>r.maxX-e.width&&(o=(a=r.maxX-e.width)-this.startPoints.box.x),null!=r.minY&&s<r.minY?n=(s=r.minY)-this.startPoints.box.y:null!=r.maxY&&s>r.maxY-e.height&&(n=(s=r.maxY-e.height)-this.startPoints.box.y),null!=r.snapToGrid&&(a-=a%r.snapToGrid,s-=s%r.snapToGrid,o-=o%r.snapToGrid,n-=n%r.snapToGrid),this.el instanceof SVG.G?this.el.matrix(this.startPoints.transform).transform({x:o,y:n},!0):this.el.move(a,s));return i},t.prototype.end=function(t){var e=this.drag(t);this.el.fire("dragend",{event:t,p:e,m:this.m,handler:this}),SVG.off(window,"mousemove.drag"),SVG.off(window,"touchmove.drag"),SVG.off(window,"mouseup.drag"),SVG.off(window,"touchend.drag")},SVG.extend(SVG.Element,{draggable:function(e,i){"function"!=typeof e&&"object"!=typeof e||(i=e,e=!0);var a=this.remember("_draggable")||new t(this);return(e=void 0===e||e)?a.init(i||{},e):(this.off("mousedown.drag"),this.off("touchstart.drag")),this}})}.call(void 0),function(){function t(t){this.el=t,t.remember("_selectHandler",this),this.pointSelection={isSelected:!1},this.rectSelection={isSelected:!1},this.pointsList={lt:[0,0],rt:["width",0],rb:["width","height"],lb:[0,"height"],t:["width",0],r:["width","height"],b:["width","height"],l:[0,"height"]},this.pointCoord=function(t,e,i){var a="string"!=typeof t?t:e[t];return i?a/2:a},this.pointCoords=function(t,e){var i=this.pointsList[t];return{x:this.pointCoord(i[0],e,"t"===t||"b"===t),y:this.pointCoord(i[1],e,"r"===t||"l"===t)}}}t.prototype.init=function(t,e){var i=this.el.bbox();this.options={};var a=this.el.selectize.defaults.points;for(var s in this.el.selectize.defaults)this.options[s]=this.el.selectize.defaults[s],void 0!==e[s]&&(this.options[s]=e[s]);var r=["points","pointsExclude"];for(var s in r){var o=this.options[r[s]];"string"==typeof o?o=o.length>0?o.split(/\s*,\s*/i):[]:"boolean"==typeof o&&"points"===r[s]&&(o=o?a:[]),this.options[r[s]]=o}this.options.points=[a,this.options.points].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)>-1}))})),this.options.points=[this.options.points,this.options.pointsExclude].reduce((function(t,e){return t.filter((function(t){return e.indexOf(t)<0}))})),this.parent=this.el.parent(),this.nested=this.nested||this.parent.group(),this.nested.matrix(new SVG.Matrix(this.el).translate(i.x,i.y)),this.options.deepSelect&&-1!==["line","polyline","polygon"].indexOf(this.el.type)?this.selectPoints(t):this.selectRect(t),this.observe(),this.cleanup()},t.prototype.selectPoints=function(t){return this.pointSelection.isSelected=t,this.pointSelection.set||(this.pointSelection.set=this.parent.set(),this.drawPoints()),this},t.prototype.getPointArray=function(){var t=this.el.bbox();return this.el.array().valueOf().map((function(e){return[e[0]-t.x,e[1]-t.y]}))},t.prototype.drawPoints=function(){for(var t=this,e=this.getPointArray(),i=0,a=e.length;i<a;++i){var s=function(e){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;t.el.fire("point",{x:a,y:s,i:e,event:i})}}(i),r=this.drawPoint(e[i][0],e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints+"_point").on("touchstart",s).on("mousedown",s);this.pointSelection.set.add(r)}},t.prototype.drawPoint=function(t,e){var i=this.options.pointType;switch(i){case"circle":return this.drawCircle(t,e);case"rect":return this.drawRect(t,e);default:if("function"==typeof i)return i.call(this,t,e);throw new Error("Unknown "+i+" point type!")}},t.prototype.drawCircle=function(t,e){return this.nested.circle(this.options.pointSize).center(t,e)},t.prototype.drawRect=function(t,e){return this.nested.rect(this.options.pointSize,this.options.pointSize).center(t,e)},t.prototype.updatePointSelection=function(){var t=this.getPointArray();this.pointSelection.set.each((function(e){this.cx()===t[e][0]&&this.cy()===t[e][1]||this.center(t[e][0],t[e][1])}))},t.prototype.updateRectSelection=function(){var t=this,e=this.el.bbox();if(this.rectSelection.set.get(0).attr({width:e.width,height:e.height}),this.options.points.length&&this.options.points.map((function(i,a){var s=t.pointCoords(i,e);t.rectSelection.set.get(a+1).center(s.x,s.y)})),this.options.rotationPoint){var i=this.rectSelection.set.length();this.rectSelection.set.get(i-1).center(e.width/2,20)}},t.prototype.selectRect=function(t){var e=this,i=this.el.bbox();function a(t){return function(i){(i=i||window.event).preventDefault?i.preventDefault():i.returnValue=!1,i.stopPropagation();var a=i.pageX||i.touches[0].pageX,s=i.pageY||i.touches[0].pageY;e.el.fire(t,{x:a,y:s,event:i})}}if(this.rectSelection.isSelected=t,this.rectSelection.set=this.rectSelection.set||this.parent.set(),this.rectSelection.set.get(0)||this.rectSelection.set.add(this.nested.rect(i.width,i.height).addClass(this.options.classRect)),this.options.points.length&&this.rectSelection.set.length()<2){this.options.points.map((function(t,s){var r=e.pointCoords(t,i),o=e.drawPoint(r.x,r.y).attr("class",e.options.classPoints+"_"+t).on("mousedown",a(t)).on("touchstart",a(t));e.rectSelection.set.add(o)})),this.rectSelection.set.each((function(){this.addClass(e.options.classPoints)}))}if(this.options.rotationPoint&&(this.options.points&&!this.rectSelection.set.get(9)||!this.options.points&&!this.rectSelection.set.get(1))){var s=function(t){(t=t||window.event).preventDefault?t.preventDefault():t.returnValue=!1,t.stopPropagation();var i=t.pageX||t.touches[0].pageX,a=t.pageY||t.touches[0].pageY;e.el.fire("rot",{x:i,y:a,event:t})},r=this.drawPoint(i.width/2,20).attr("class",this.options.classPoints+"_rot").on("touchstart",s).on("mousedown",s);this.rectSelection.set.add(r)}},t.prototype.handler=function(){var t=this.el.bbox();this.nested.matrix(new SVG.Matrix(this.el).translate(t.x,t.y)),this.rectSelection.isSelected&&this.updateRectSelection(),this.pointSelection.isSelected&&this.updatePointSelection()},t.prototype.observe=function(){var t=this;if(MutationObserver)if(this.rectSelection.isSelected||this.pointSelection.isSelected)this.observerInst=this.observerInst||new MutationObserver((function(){t.handler()})),this.observerInst.observe(this.el.node,{attributes:!0});else try{this.observerInst.disconnect(),delete this.observerInst}catch(t){}else this.el.off("DOMAttrModified.select"),(this.rectSelection.isSelected||this.pointSelection.isSelected)&&this.el.on("DOMAttrModified.select",(function(){t.handler()}))},t.prototype.cleanup=function(){!this.rectSelection.isSelected&&this.rectSelection.set&&(this.rectSelection.set.each((function(){this.remove()})),this.rectSelection.set.clear(),delete this.rectSelection.set),!this.pointSelection.isSelected&&this.pointSelection.set&&(this.pointSelection.set.each((function(){this.remove()})),this.pointSelection.set.clear(),delete this.pointSelection.set),this.pointSelection.isSelected||this.rectSelection.isSelected||(this.nested.remove(),delete this.nested)},SVG.extend(SVG.Element,{selectize:function(e,i){return"object"==typeof e&&(i=e,e=!0),(this.remember("_selectHandler")||new t(this)).init(void 0===e||e,i||{}),this}}),SVG.Element.prototype.selectize.defaults={points:["lt","rt","rb","lb","t","r","b","l"],pointsExclude:[],classRect:"svg_select_boundingRect",classPoints:"svg_select_points",pointSize:7,rotationPoint:!0,deepSelect:!1,pointType:"circle"}}(),function(){(function(){function t(t){t.remember("_resizeHandler",this),this.el=t,this.parameters={},this.lastUpdateCall=null,this.p=t.doc().node.createSVGPoint()}t.prototype.transformPoint=function(t,e,i){return this.p.x=t-(this.offset.x-window.pageXOffset),this.p.y=e-(this.offset.y-window.pageYOffset),this.p.matrixTransform(i||this.m)},t.prototype._extractPosition=function(t){return{x:null!=t.clientX?t.clientX:t.touches[0].clientX,y:null!=t.clientY?t.clientY:t.touches[0].clientY}},t.prototype.init=function(t){var e=this;if(this.stop(),"stop"!==t){for(var i in this.options={},this.el.resize.defaults)this.options[i]=this.el.resize.defaults[i],void 0!==t[i]&&(this.options[i]=t[i]);this.el.on("lt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rt.resize",(function(t){e.resize(t||window.event)})),this.el.on("rb.resize",(function(t){e.resize(t||window.event)})),this.el.on("lb.resize",(function(t){e.resize(t||window.event)})),this.el.on("t.resize",(function(t){e.resize(t||window.event)})),this.el.on("r.resize",(function(t){e.resize(t||window.event)})),this.el.on("b.resize",(function(t){e.resize(t||window.event)})),this.el.on("l.resize",(function(t){e.resize(t||window.event)})),this.el.on("rot.resize",(function(t){e.resize(t||window.event)})),this.el.on("point.resize",(function(t){e.resize(t||window.event)})),this.update()}},t.prototype.stop=function(){return this.el.off("lt.resize"),this.el.off("rt.resize"),this.el.off("rb.resize"),this.el.off("lb.resize"),this.el.off("t.resize"),this.el.off("r.resize"),this.el.off("b.resize"),this.el.off("l.resize"),this.el.off("rot.resize"),this.el.off("point.resize"),this},t.prototype.resize=function(t){var e=this;this.m=this.el.node.getScreenCTM().inverse(),this.offset={x:window.pageXOffset,y:window.pageYOffset};var i=this._extractPosition(t.detail.event);if(this.parameters={type:this.el.type,p:this.transformPoint(i.x,i.y),x:t.detail.x,y:t.detail.y,box:this.el.bbox(),rotation:this.el.transform().rotation},"text"===this.el.type&&(this.parameters.fontSize=this.el.attr()["font-size"]),void 0!==t.detail.i){var a=this.el.array().valueOf();this.parameters.i=t.detail.i,this.parameters.pointCoords=[a[t.detail.i][0],a[t.detail.i][1]]}switch(t.type){case"lt":this.calc=function(t,e){var i=this.snapToGrid(t,e);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y+i[1]).size(this.parameters.box.width-i[0],this.parameters.box.height-i[1])}};break;case"rt":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).size(this.parameters.box.width+i[0],this.parameters.box.height-i[1])}};break;case"rb":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x-i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize+i[0]);i=this.checkAspectRatio(i),this.el.move(this.parameters.box.x,this.parameters.box.y).size(this.parameters.box.width+i[0],this.parameters.box.height+i[1])}};break;case"lb":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0&&this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return this.el.move(this.parameters.box.x+i[0],this.parameters.box.y),void this.el.attr("font-size",this.parameters.fontSize-i[0]);i=this.checkAspectRatio(i,!0),this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).size(this.parameters.box.width-i[0],this.parameters.box.height+i[1])}};break;case"t":this.calc=function(t,e){var i=this.snapToGrid(t,e,2);if(this.parameters.box.height-i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y+i[1]).height(this.parameters.box.height-i[1])}};break;case"r":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.width+i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).width(this.parameters.box.width+i[0])}};break;case"b":this.calc=function(t,e){var i=this.snapToGrid(t,e,0);if(this.parameters.box.height+i[1]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x,this.parameters.box.y).height(this.parameters.box.height+i[1])}};break;case"l":this.calc=function(t,e){var i=this.snapToGrid(t,e,1);if(this.parameters.box.width-i[0]>0){if("text"===this.parameters.type)return;this.el.move(this.parameters.box.x+i[0],this.parameters.box.y).width(this.parameters.box.width-i[0])}};break;case"rot":this.calc=function(t,e){var i=t+this.parameters.p.x,a=e+this.parameters.p.y,s=Math.atan2(this.parameters.p.y-this.parameters.box.y-this.parameters.box.height/2,this.parameters.p.x-this.parameters.box.x-this.parameters.box.width/2),r=Math.atan2(a-this.parameters.box.y-this.parameters.box.height/2,i-this.parameters.box.x-this.parameters.box.width/2),o=this.parameters.rotation+180*(r-s)/Math.PI+this.options.snapToAngle/2;this.el.center(this.parameters.box.cx,this.parameters.box.cy).rotate(o-o%this.options.snapToAngle,this.parameters.box.cx,this.parameters.box.cy)};break;case"point":this.calc=function(t,e){var i=this.snapToGrid(t,e,this.parameters.pointCoords[0],this.parameters.pointCoords[1]),a=this.el.array().valueOf();a[this.parameters.i][0]=this.parameters.pointCoords[0]+i[0],a[this.parameters.i][1]=this.parameters.pointCoords[1]+i[1],this.el.plot(a)}}this.el.fire("resizestart",{dx:this.parameters.x,dy:this.parameters.y,event:t}),SVG.on(window,"touchmove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"touchend.resize",(function(){e.done()})),SVG.on(window,"mousemove.resize",(function(t){e.update(t||window.event)})),SVG.on(window,"mouseup.resize",(function(){e.done()}))},t.prototype.update=function(t){if(t){var e=this._extractPosition(t),i=this.transformPoint(e.x,e.y),a=i.x-this.parameters.p.x,s=i.y-this.parameters.p.y;this.lastUpdateCall=[a,s],this.calc(a,s),this.el.fire("resizing",{dx:a,dy:s,event:t})}else this.lastUpdateCall&&this.calc(this.lastUpdateCall[0],this.lastUpdateCall[1])},t.prototype.done=function(){this.lastUpdateCall=null,SVG.off(window,"mousemove.resize"),SVG.off(window,"mouseup.resize"),SVG.off(window,"touchmove.resize"),SVG.off(window,"touchend.resize"),this.el.fire("resizedone")},t.prototype.snapToGrid=function(t,e,i,a){var s;return void 0!==a?s=[(i+t)%this.options.snapToGrid,(a+e)%this.options.snapToGrid]:(i=null==i?3:i,s=[(this.parameters.box.x+t+(1&i?0:this.parameters.box.width))%this.options.snapToGrid,(this.parameters.box.y+e+(2&i?0:this.parameters.box.height))%this.options.snapToGrid]),t<0&&(s[0]-=this.options.snapToGrid),e<0&&(s[1]-=this.options.snapToGrid),t-=Math.abs(s[0])<this.options.snapToGrid/2?s[0]:s[0]-(t<0?-this.options.snapToGrid:this.options.snapToGrid),e-=Math.abs(s[1])<this.options.snapToGrid/2?s[1]:s[1]-(e<0?-this.options.snapToGrid:this.options.snapToGrid),this.constraintToBox(t,e,i,a)},t.prototype.constraintToBox=function(t,e,i,a){var s,r,o=this.options.constraint||{};return void 0!==a?(s=i,r=a):(s=this.parameters.box.x+(1&i?0:this.parameters.box.width),r=this.parameters.box.y+(2&i?0:this.parameters.box.height)),void 0!==o.minX&&s+t<o.minX&&(t=o.minX-s),void 0!==o.maxX&&s+t>o.maxX&&(t=o.maxX-s),void 0!==o.minY&&r+e<o.minY&&(e=o.minY-r),void 0!==o.maxY&&r+e>o.maxY&&(e=o.maxY-r),[t,e]},t.prototype.checkAspectRatio=function(t,e){if(!this.options.saveAspectRatio)return t;var i=t.slice(),a=this.parameters.box.width/this.parameters.box.height,s=this.parameters.box.width+t[0],r=this.parameters.box.height-t[1],o=s/r;return o<a?(i[1]=s/a-this.parameters.box.height,e&&(i[1]=-i[1])):o>a&&(i[0]=this.parameters.box.width-r*a,e&&(i[0]=-i[0])),i},SVG.extend(SVG.Element,{resize:function(e){return(this.remember("_resizeHandler")||new t(this)).init(e||{}),this}}),SVG.Element.prototype.resize.defaults={snapToAngle:.1,snapToGrid:1,constraint:{},saveAspectRatio:!1}}).call(this)}(),void 0===window.Apex&&(window.Apex={});var Rt=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"initModules",value:function(){this.ctx.publicMethods=["updateOptions","updateSeries","appendData","appendSeries","toggleSeries","showSeries","hideSeries","setLocale","resetSeries","zoomX","toggleDataPointSelection","dataURI","exportToCSV","addXaxisAnnotation","addYaxisAnnotation","addPointAnnotation","clearAnnotations","removeAnnotation","paper","destroy"],this.ctx.eventList=["click","mousedown","mousemove","mouseleave","touchstart","touchmove","touchleave","mouseup","touchend"],this.ctx.animations=new b(this.ctx),this.ctx.axes=new K(this.ctx),this.ctx.core=new Yt(this.ctx.el,this.ctx),this.ctx.config=new N({}),this.ctx.data=new B(this.ctx),this.ctx.grid=new U(this.ctx),this.ctx.graphics=new m(this.ctx),this.ctx.coreUtils=new y(this.ctx),this.ctx.crosshairs=new tt(this.ctx),this.ctx.events=new J(this.ctx),this.ctx.exports=new j(this.ctx),this.ctx.localization=new Q(this.ctx),this.ctx.options=new L,this.ctx.responsive=new et(this.ctx),this.ctx.series=new E(this.ctx),this.ctx.theme=new it(this.ctx),this.ctx.formatters=new V(this.ctx),this.ctx.titleSubtitle=new at(this.ctx),this.ctx.legend=new ct(this.ctx),this.ctx.toolbar=new dt(this.ctx),this.ctx.dimensions=new lt(this.ctx),this.ctx.updateHelpers=new Ft(this.ctx),this.ctx.zoomPanSelection=new gt(this.ctx),this.ctx.w.globals.tooltip=new mt(this.ctx)}}]),t}(),Ht=function(){function t(e){a(this,t),this.ctx=e,this.w=e.w}return r(t,[{key:"clear",value:function(t){var e=t.isUpdating;this.ctx.zoomPanSelection&&this.ctx.zoomPanSelection.destroy(),this.ctx.toolbar&&this.ctx.toolbar.destroy(),this.ctx.animations=null,this.ctx.axes=null,this.ctx.annotations=null,this.ctx.core=null,this.ctx.data=null,this.ctx.grid=null,this.ctx.series=null,this.ctx.responsive=null,this.ctx.theme=null,this.ctx.formatters=null,this.ctx.titleSubtitle=null,this.ctx.legend=null,this.ctx.dimensions=null,this.ctx.options=null,this.ctx.crosshairs=null,this.ctx.zoomPanSelection=null,this.ctx.updateHelpers=null,this.ctx.toolbar=null,this.ctx.localization=null,this.ctx.w.globals.tooltip=null,this.clearDomElements({isUpdating:e})}},{key:"killSVG",value:function(t){t.each((function(t,e){this.removeClass("*"),this.off(),this.stop()}),!0),t.ungroup(),t.clear()}},{key:"clearDomElements",value:function(t){var e=this,i=t.isUpdating,a=this.w.globals.dom.Paper.node;a.parentNode&&a.parentNode.parentNode&&!i&&(a.parentNode.parentNode.style.minHeight="unset");var s=this.w.globals.dom.baseEl;s&&this.ctx.eventList.forEach((function(t){s.removeEventListener(t,e.ctx.events.documentEvent)}));var r=this.w.globals.dom;if(null!==this.ctx.el)for(;this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);this.killSVG(r.Paper),r.Paper.remove(),r.elWrap=null,r.elGraphical=null,r.elAnnotations=null,r.elLegendWrap=null,r.baseEl=null,r.elGridRect=null,r.elGridRectMask=null,r.elGridRectMarkerMask=null,r.elForecastMask=null,r.elNonForecastMask=null,r.elDefs=null}}]),t}(),Dt=new WeakMap;var Nt=function(){function t(e,i){a(this,t),this.opts=i,this.ctx=this,this.w=new W(i).init(),this.el=e,this.w.globals.cuid=x.randomId(),this.w.globals.chartID=this.w.config.chart.id?x.escapeString(this.w.config.chart.id):this.w.globals.cuid,new Rt(this).initModules(),this.create=x.bind(this.create,this),this.windowResizeHandler=this._windowResizeHandler.bind(this),this.parentResizeHandler=this._parentResizeCallback.bind(this)}return r(t,[{key:"render",value:function(){var t=this;return new Promise((function(e,i){if(null!==t.el){void 0===Apex._chartInstances&&(Apex._chartInstances=[]),t.w.config.chart.id&&Apex._chartInstances.push({id:t.w.globals.chartID,group:t.w.config.chart.group,chart:t}),t.setLocale(t.w.config.chart.defaultLocale);var a=t.w.config.chart.events.beforeMount;if("function"==typeof a&&a(t,t.w),t.events.fireEvent("beforeMount",[t,t.w]),window.addEventListener("resize",t.windowResizeHandler),function(t,e){var i=!1;if(t.nodeType!==Node.DOCUMENT_FRAGMENT_NODE){var a=t.getBoundingClientRect();"none"!==t.style.display&&0!==a.width||(i=!0)}var s=new ResizeObserver((function(a){i&&e.call(t,a),i=!0}));t.nodeType===Node.DOCUMENT_FRAGMENT_NODE?Array.from(t.children).forEach((function(t){return s.observe(t)})):s.observe(t),Dt.set(e,s)}(t.el.parentNode,t.parentResizeHandler),!t.css){var s=t.el.getRootNode&&t.el.getRootNode(),r=x.is("ShadowRoot",s),o=t.el.ownerDocument,n=o.getElementById("apexcharts-css");!r&&n||(t.css=document.createElement("style"),t.css.id="apexcharts-css",t.css.textContent='.apexcharts-canvas {\n  position: relative;\n  user-select: none;\n  /* cannot give overflow: hidden as it will crop tooltips which overflow outside chart area */\n}\n\n\n/* scrollbar is not visible by default for legend, hence forcing the visibility */\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px;\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n\n.apexcharts-inner {\n  position: relative;\n}\n\n.apexcharts-text tspan {\n  font-family: inherit;\n}\n\n.legend-mouseover-inactive {\n  transition: 0.15s ease all;\n  opacity: 0.20;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0;\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, 0.8);\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit;\n}\n\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #ECEFF1;\n  border-bottom: 1px solid #ddd;\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, 0.7);\n  border-bottom: 1px solid #333;\n}\n\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  font-weight: 600;\n  margin-left: 5px;\n}\n\n.apexcharts-tooltip-title:empty,\n.apexcharts-tooltip-text-y-label:empty,\n.apexcharts-tooltip-text-y-value:empty,\n.apexcharts-tooltip-text-goals-label:empty,\n.apexcharts-tooltip-text-goals-value:empty,\n.apexcharts-tooltip-text-z-value:empty {\n  display: none;\n}\n\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-z-value {\n  font-weight: 600;\n}\n\n.apexcharts-tooltip-text-goals-label, \n.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-goals-group, \n.apexcharts-tooltip-text-goals-label, \n.apexcharts-tooltip-text-goals-value {\n  display: flex;\n}\n.apexcharts-tooltip-text-goals-label:not(:empty),\n.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px;\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px;\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0 !important;\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-box, .apexcharts-custom-tooltip {\n  padding: 4px 8px;\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0;\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: bold;\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px;\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777;\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: bold;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.apexcharts-xaxistooltip {\n  opacity: 0;\n  padding: 9px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-left: -6px;\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-left: -7px;\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%;\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%;\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #ECEFF1;\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #ECEFF1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  padding: 4px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-top: -6px;\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-top: -7px;\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%;\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%;\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1;\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none;\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0;\n}\n\n.apexcharts-selection-rect {\n  cursor: move;\n}\n\n.svg_select_boundingRect, .svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n}\n.apexcharts-selection-rect + g .svg_select_boundingRect,\n.apexcharts-selection-rect + g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.apexcharts-selection-rect + g .svg_select_points_l,\n.apexcharts-selection-rect + g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible;\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2;\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon,\n.apexcharts-reset-icon,\n.apexcharts-pan-icon,\n.apexcharts-selection-icon,\n.apexcharts-menu-icon,\n.apexcharts-toolbar-custom-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6E8192;\n  text-align: center;\n}\n\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-menu-icon svg {\n  fill: #6E8192;\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(0.76)\n}\n\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg {\n  fill: #f3f4f5;\n}\n\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg {\n  fill: #008FFB;\n}\n\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg {\n  fill: #333;\n}\n\n.apexcharts-selection-icon,\n.apexcharts-menu-icon {\n  position: relative;\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px;\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-reset-icon,\n.apexcharts-menu-icon {\n  transform: scale(0.85);\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(0.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px;\n}\n\n.apexcharts-pan-icon {\n  transform: scale(0.62);\n  position: relative;\n  left: 1px;\n  top: 0px;\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6E8192;\n  stroke-width: 2;\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008FFB;\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333;\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0px 6px 2px 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: 0.15s ease all;\n  pointer-events: none;\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee;\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n\n@media screen and (min-width: 768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1;\n  }\n}\n\n.apexcharts-datalabel.apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-pie-label,\n.apexcharts-datalabels,\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value {\n  cursor: default;\n  pointer-events: none;\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: 0.3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease;\n}\n\n.apexcharts-canvas .apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-gridline,\n.apexcharts-annotation-rect,\n.apexcharts-xaxis-annotation-label,\n.apexcharts-yaxis-annotation-label,\n.apexcharts-point-annotation-label,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-line,\n.apexcharts-zoom-rect,\n.apexcharts-toolbar svg,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-radar-series path,\n.apexcharts-radar-series polygon {\n  pointer-events: none;\n}\n\n\n/* markers */\n\n.apexcharts-marker {\n  transition: 0.15s ease all;\n}\n\n@keyframes opaque {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n\n/* Resize generated styles */\n\n@keyframes resizeanim {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.resize-triggers,\n.resize-triggers>div,\n.contract-trigger:before {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.resize-triggers>div {\n  background: #eee;\n  overflow: auto;\n}\n\n.contract-trigger:before {\n  width: 200%;\n  height: 200%;\n}',r?s.prepend(t.css):o.head.appendChild(t.css))}var l=t.create(t.w.config.series,{});if(!l)return e(t);t.mount(l).then((function(){"function"==typeof t.w.config.chart.events.mounted&&t.w.config.chart.events.mounted(t,t.w),t.events.fireEvent("mounted",[t,t.w]),e(l)})).catch((function(t){i(t)}))}else i(new Error("Element not found"))}))}},{key:"create",value:function(t,e){var i=this.w;new Rt(this).initModules();var a=this.w.globals;(a.noData=!1,a.animationEnded=!1,this.responsive.checkResponsiveConfig(e),i.config.xaxis.convertedCatToNumeric)&&new D(i.config).convertCatToNumericXaxis(i.config,this.ctx);if(null===this.el)return a.animationEnded=!0,null;if(this.core.setupElements(),"treemap"===i.config.chart.type&&(i.config.grid.show=!1,i.config.yaxis[0].show=!1),0===a.svgWidth)return a.animationEnded=!0,null;var s=y.checkComboSeries(t);a.comboCharts=s.comboCharts,a.comboBarCount=s.comboBarCount;var r=t.every((function(t){return t.data&&0===t.data.length}));(0===t.length||r)&&this.series.handleNoData(),this.events.setupEventHandlers(),this.data.parseData(t),this.theme.init(),new T(this).setGlobalMarkerSize(),this.formatters.setLabelFormatters(),this.titleSubtitle.draw(),a.noData&&a.collapsedSeries.length!==a.series.length&&!i.config.legend.showForSingleSeries||this.legend.init(),this.series.hasAllSeriesEqualX(),a.axisCharts&&(this.core.coreCalculations(),"category"!==i.config.xaxis.type&&this.formatters.setLabelFormatters(),this.ctx.toolbar.minX=i.globals.minX,this.ctx.toolbar.maxX=i.globals.maxX),this.formatters.heatmapLabelFormatters(),new y(this).getLargestMarkerSize(),this.dimensions.plotCoords();var o=this.core.xySettings();this.grid.createGridMask();var n=this.core.plotChartType(t,o),l=new z(this);l.bringForward(),i.config.dataLabels.background.enabled&&l.dataLabelsBackground(),this.core.shiftGraphPosition();var h={plot:{left:i.globals.translateX,top:i.globals.translateY,width:i.globals.gridWidth,height:i.globals.gridHeight}};return{elGraph:n,xyRatios:o,elInner:i.globals.dom.elGraphical,dimensions:h}}},{key:"mount",value:function(){var t=this,e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,i=this,a=i.w;return new Promise((function(s,r){if(null===i.el)return r(new Error("Not enough data to display or target element not found"));(null===e||a.globals.allSeriesCollapsed)&&i.series.handleNoData(),"treemap"!==a.config.chart.type&&i.axes.drawAxis(a.config.chart.type,e.xyRatios),i.grid=new U(i);var o=i.grid.drawGrid();i.annotations=new P(i),i.annotations.drawImageAnnos(),i.annotations.drawTextAnnos(),"back"===a.config.grid.position&&o&&a.globals.dom.elGraphical.add(o.el);var n=new _(t.ctx),l=new $(t.ctx);if(null!==o&&(n.xAxisLabelCorrections(o.xAxisTickWidth),l.setYAxisTextAlignments(),a.config.yaxis.map((function(t,e){-1===a.globals.ignoreYAxisIndexes.indexOf(e)&&l.yAxisTitleRotate(e,t.opposite)}))),"back"===a.config.annotations.position&&(a.globals.dom.Paper.add(a.globals.dom.elAnnotations),i.annotations.drawAxesAnnotations()),Array.isArray(e.elGraph))for(var h=0;h<e.elGraph.length;h++)a.globals.dom.elGraphical.add(e.elGraph[h]);else a.globals.dom.elGraphical.add(e.elGraph);if("front"===a.config.grid.position&&o&&a.globals.dom.elGraphical.add(o.el),"front"===a.config.xaxis.crosshairs.position&&i.crosshairs.drawXCrosshairs(),"front"===a.config.yaxis[0].crosshairs.position&&i.crosshairs.drawYCrosshairs(),"front"===a.config.annotations.position&&(a.globals.dom.Paper.add(a.globals.dom.elAnnotations),i.annotations.drawAxesAnnotations()),!a.globals.noData){if(a.config.tooltip.enabled&&!a.globals.noData&&i.w.globals.tooltip.drawTooltip(e.xyRatios),a.globals.axisCharts&&(a.globals.isXNumeric||a.config.xaxis.convertedCatToNumeric||a.globals.isRangeBar))(a.config.chart.zoom.enabled||a.config.chart.selection&&a.config.chart.selection.enabled||a.config.chart.pan&&a.config.chart.pan.enabled)&&i.zoomPanSelection.init({xyRatios:e.xyRatios});else{var c=a.config.chart.toolbar.tools;["zoom","zoomin","zoomout","selection","pan","reset"].forEach((function(t){c[t]=!1}))}a.config.chart.toolbar.show&&!a.globals.allSeriesCollapsed&&i.toolbar.createToolbar()}a.globals.memory.methodsToExec.length>0&&a.globals.memory.methodsToExec.forEach((function(t){t.method(t.params,!1,t.context)})),a.globals.axisCharts||a.globals.noData||i.core.resizeNonAxisCharts(),s(i)}))}},{key:"destroy",value:function(){var t,e;window.removeEventListener("resize",this.windowResizeHandler),this.el.parentNode,t=this.parentResizeHandler,(e=Dt.get(t))&&(e.disconnect(),Dt.delete(t));var i=this.w.config.chart.id;i&&Apex._chartInstances.forEach((function(t,e){t.id===x.escapeString(i)&&Apex._chartInstances.splice(e,1)})),new Ht(this.ctx).clear({isUpdating:!1})}},{key:"updateOptions",value:function(t){var e=this,i=arguments.length>1&&void 0!==arguments[1]&&arguments[1],a=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],s=!(arguments.length>3&&void 0!==arguments[3])||arguments[3],r=!(arguments.length>4&&void 0!==arguments[4])||arguments[4],o=this.w;return o.globals.selection=void 0,t.series&&(this.series.resetSeries(!1,!0,!1),t.series.length&&t.series[0].data&&(t.series=t.series.map((function(t,i){return e.updateHelpers._extendSeries(t,i)}))),this.updateHelpers.revertDefaultAxisMinMax()),t.xaxis&&(t=this.updateHelpers.forceXAxisUpdate(t)),t.yaxis&&(t=this.updateHelpers.forceYAxisUpdate(t)),o.globals.collapsedSeriesIndices.length>0&&this.series.clearPreviousPaths(),t.theme&&(t=this.theme.updateThemeOptions(t)),this.updateHelpers._updateOptions(t,i,a,s,r)}},{key:"updateSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2];return this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(t,e,i)}},{key:"appendSeries",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=!(arguments.length>2&&void 0!==arguments[2])||arguments[2],a=this.w.config.series.slice();return a.push(t),this.series.resetSeries(!1),this.updateHelpers.revertDefaultAxisMinMax(),this.updateHelpers._updateSeries(a,e,i)}},{key:"appendData",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=this;i.w.globals.dataChanged=!0,i.series.getPreviousPaths();for(var a=i.w.config.series.slice(),s=0;s<a.length;s++)if(null!==t[s]&&void 0!==t[s])for(var r=0;r<t[s].data.length;r++)a[s].data.push(t[s].data[r]);return i.w.config.series=a,e&&(i.w.globals.initialSeries=x.clone(i.w.config.series)),this.update()}},{key:"update",value:function(t){var e=this;return new Promise((function(i,a){new Ht(e.ctx).clear({isUpdating:!0});var s=e.create(e.w.config.series,t);if(!s)return i(e);e.mount(s).then((function(){"function"==typeof e.w.config.chart.events.updated&&e.w.config.chart.events.updated(e,e.w),e.events.fireEvent("updated",[e,e.w]),e.w.globals.isDirty=!0,i(e)})).catch((function(t){a(t)}))}))}},{key:"getSyncedCharts",value:function(){var t=this.getGroupedCharts(),e=[this];return t.length&&(e=[],t.forEach((function(t){e.push(t)}))),e}},{key:"getGroupedCharts",value:function(){var t=this;return Apex._chartInstances.filter((function(t){if(t.group)return!0})).map((function(e){return t.w.config.chart.group===e.group?e.chart:t}))}},{key:"toggleSeries",value:function(t){return this.series.toggleSeries(t)}},{key:"highlightSeriesOnLegendHover",value:function(t,e){return this.series.toggleSeriesOnHover(t,e)}},{key:"showSeries",value:function(t){this.series.showSeries(t)}},{key:"hideSeries",value:function(t){this.series.hideSeries(t)}},{key:"resetSeries",value:function(){var t=!(arguments.length>0&&void 0!==arguments[0])||arguments[0],e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];this.series.resetSeries(t,e)}},{key:"addEventListener",value:function(t,e){this.events.addEventListener(t,e)}},{key:"removeEventListener",value:function(t,e){this.events.removeEventListener(t,e)}},{key:"addXaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addXaxisAnnotationExternal(t,e,a)}},{key:"addYaxisAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addYaxisAnnotationExternal(t,e,a)}},{key:"addPointAnnotation",value:function(t){var e=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0,a=this;i&&(a=i),a.annotations.addPointAnnotationExternal(t,e,a)}},{key:"clearAnnotations",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:void 0,e=this;t&&(e=t),e.annotations.clearAnnotations(e)}},{key:"removeAnnotation",value:function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:void 0,i=this;e&&(i=e),i.annotations.removeAnnotation(i,t)}},{key:"getChartArea",value:function(){return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner")}},{key:"getSeriesTotalXRange",value:function(t,e){return this.coreUtils.getSeriesTotalsXRange(t,e)}},{key:"getHighestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=new Z(this.ctx);return e.getMinYMaxY(t).highestY}},{key:"getLowestValueInSeries",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,e=new Z(this.ctx);return e.getMinYMaxY(t).lowestY}},{key:"getSeriesTotal",value:function(){return this.w.globals.seriesTotals}},{key:"toggleDataPointSelection",value:function(t,e){return this.updateHelpers.toggleDataPointSelection(t,e)}},{key:"zoomX",value:function(t,e){this.ctx.toolbar.zoomUpdateOptions(t,e)}},{key:"setLocale",value:function(t){this.localization.setCurrentLocaleValues(t)}},{key:"dataURI",value:function(t){return new j(this.ctx).dataURI(t)}},{key:"exportToCSV",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},e=new j(this.ctx);return e.exportToCSV(t)}},{key:"paper",value:function(){return this.w.globals.dom.Paper}},{key:"_parentResizeCallback",value:function(){this.w.globals.animationEnded&&this.w.config.chart.redrawOnParentResize&&this._windowResize()}},{key:"_windowResize",value:function(){var t=this;clearTimeout(this.w.globals.resizeTimer),this.w.globals.resizeTimer=window.setTimeout((function(){t.w.globals.resized=!0,t.w.globals.dataChanged=!1,t.ctx.update()}),150)}},{key:"_windowResizeHandler",value:function(){var t=this.w.config.chart.redrawOnWindowResize;"function"==typeof t&&(t=t()),t&&this._windowResize()}}],[{key:"getChartByID",value:function(t){var e=x.escapeString(t),i=Apex._chartInstances.filter((function(t){return t.id===e}))[0];return i&&i.chart}},{key:"initOnLoad",value:function(){for(var e=document.querySelectorAll("[data-apexcharts]"),i=0;i<e.length;i++){new t(e[i],JSON.parse(e[i].getAttribute("data-options"))).render()}}},{key:"exec",value:function(t,e){var i=this.getChartByID(t);if(i){i.w.globals.isExecCalled=!0;var a=null;if(-1!==i.publicMethods.indexOf(e)){for(var s=arguments.length,r=new Array(s>2?s-2:0),o=2;o<s;o++)r[o-2]=arguments[o];a=i[e].apply(i,r)}return a}}},{key:"merge",value:function(t,e){return x.extend(t,e)}}]),t}();module.exports=Nt;


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])])])]),_vm._v(" "),(_vm.authMap.dashboard != 2)?_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.controlPanelStatistics),expression:"modules.controlPanelStatistics"}],staticClass:"col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleTodayStartOfWorks'), 0)}}},[_c('span',{staticClass:"info-box-icon bg-green"},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-checkmark",staticStyle:{"margin-top":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.startOfWorks')))])]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"text-align":"center","font-size":"25px"}},[_c('span',[_vm._v(_vm._s(_vm.startWorkEmployees))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.controlPanelStatistics),expression:"modules.controlPanelStatistics"}],staticClass:"col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleTodayAbsentees'), 1)}}},[_c('span',{staticClass:"info-box-icon bg-red"},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-close",staticStyle:{"margin-top":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.absentees')))])]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"text-align":"center","font-size":"25px"}},[_c('span',[_vm._v(_vm._s(_vm.discontinuity))])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix visible-sm-block"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.controlPanelStatistics),expression:"modules.controlPanelStatistics"}],staticClass:"col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleTodayLateComers'), 11)}}},[_c('span',{staticClass:"info-box-icon bg-yellow"},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-alarm",staticStyle:{"margin-top":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.lateComers')))])]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"text-align":"center","font-size":"25px"}},[_c('span',[_vm._v(_vm._s(_vm.lateComers))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.controlPanelStatistics),expression:"modules.controlPanelStatistics"}],staticClass:"col-md-3 col-sm-6 col-xs-12"},[_c('div',{staticClass:"info-box",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleTotalEmployees'), 2)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"background":"#3C8DBC","color":"#fff"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{staticClass:"ion ion-ios-contact-outline",staticStyle:{"margin-top":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.totalEmployee')))])]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"text-align":"center","font-size":"25px"}},[_c('span',[_vm._v(_vm._s(_vm.totalEmployees))])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('i',{staticClass:"fa fa-thumb-tack"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.deviceStatus')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastConnectionTime),expression:"lastConnectionTime"}],staticStyle:{"font-size":"12px"}},[_vm._v("("+_vm._s(_vm.$ml.get('dashboard.lastUpdate'))+" :\n                "+_vm._s(_vm._f("toDateFormatGet")(_vm.lastConnectionTime,"gg.aa.yyyy ss:dd"))+")")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList.length > 0),expression:"deviceList.length > 0"}],attrs:{"id":"infoDevices"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList.length == 0 && !_vm.isLoading),expression:"deviceList.length == 0 && !isLoading"}],staticClass:"fa fa-microchip",staticStyle:{"font-size":"60px","color":"#00A0F0","margin-top":"50px","text-align":"center","height":"150px","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"info-box bg-green",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){return _vm.openDeviceReport()}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"fa fa-microchip",staticStyle:{"font-size":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v("Bağlı")]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.connectedDevice))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.connectedDevice != null),expression:"connectedDevice != null"}],staticClass:"progress-bar",style:('width:' + this.connectedDevice * 100 / this.deviceList.length + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{staticClass:"info-box bg-red",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){return _vm.openDeviceReport()}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"fa fa-microchip",staticStyle:{"font-size":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v("Bağlantı Sorunu")]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.disconnectedDevice))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.disconnectedDevice != null),expression:"disconnectedDevice != null"}],staticClass:"progress-bar",style:('width:' + this.disconnectedDevice * 100 / this.deviceList.length + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{staticClass:"info-box bg-yellow",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){return _vm.openDeviceReport()}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"fa fa-microchip",staticStyle:{"font-size":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v("Bilinmeyen")]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.otherDeviceStatus))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.otherDeviceStatus != null),expression:"otherDeviceStatus != null"}],staticClass:"progress-bar",style:('width:' + this.otherDeviceStatus * 100 / this.deviceList.length + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall && _vm.authControl(_vm.authMap.yemekhane) && _vm.modules.controlPanelStatistics),expression:"modules.diningHall && authControl(authMap.yemekhane) && modules.controlPanelStatistics"}],staticClass:"info-box"},[_c('span',{staticClass:"info-box-icon bg-yellow"},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingFoodData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{staticClass:"ion ion-pizza",staticStyle:{"margin-top":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.todayTotalFood')))])]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"text-align":"center","font-size":"25px"}},[_c('span',[_vm._v(_vm._s(_vm.totalFoodCount))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor && _vm.authControl(_vm.authMap.ziyaretciTakip)),expression:"modules.visitor && authControl(authMap.ziyaretciTakip)"}],staticClass:"info-box",staticStyle:{"background":"#3C8DBC","color":"#fff","cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleInsideVisitors'), 6)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingVisitor}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingVisitor),expression:"!isLoadingVisitor"}],staticClass:"fa fa-address-card"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.insideVisitors')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.insideVisitors))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.insideVisitors != null),expression:"insideVisitors != null"}],staticClass:"progress-bar",style:('width:' + this.insideVisitors * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalEmployees > 0),expression:"totalEmployees > 0"}],attrs:{"id":"infoEmployees"}}),_vm._v(" "),_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px","height":"150px"},attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalEmployees == 0 && !_vm.isLoadingData),expression:"totalEmployees == 0 && !isLoadingData"}],staticClass:"fa fa-users",staticStyle:{"font-size":"60px","color":"#00A0F0","margin-top":"50px","text-align":"center","height":"150px","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"info-box bg-green",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleInsides'), 3)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingData),expression:"isLoadingData"}],staticClass:"fa fa-refresh fa-spin",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingData),expression:"!isLoadingData"}],staticClass:"ion ion-ios-people",staticStyle:{"font-size":"30px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.insides')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.insides))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.insides != null),expression:"insides != null"}],staticClass:"progress-bar",style:('width:' + this.insides * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{staticClass:"info-box bg-red",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleOutsides'), 4)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingData),expression:"isLoadingData"}],staticClass:"fa fa-refresh fa-spin",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingData),expression:"!isLoadingData"}],staticClass:"ion ion-ios-people-outline",staticStyle:{"font-size":"30px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.outsides')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.outsides))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.outsides != null),expression:"outsides != null"}],staticClass:"progress-bar",style:('width:' + this.outsides * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll),expression:"modules.payroll"}],staticClass:"info-box bg-yellow",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleTodayAllowence'), 5)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoadingData),expression:"isLoadingData"}],staticClass:"fa fa-refresh fa-spin",staticStyle:{"font-size":"20px"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingData),expression:"!isLoadingData"}],staticClass:"ion ion-ios-paperplane-outline",staticStyle:{"font-size":"30px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceEmployees')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.allowencedEmployees))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowencedEmployees != null),expression:"allowencedEmployees != null"}],staticClass:"progress-bar",style:('width:' + this.allowencedEmployees * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"box box-primary"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryTotalStudent > 0),expression:"dormitoryTotalStudent > 0"}],attrs:{"id":"infoStudents"}}),_vm._v(" "),_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px","height":"150px"},attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryTotalStudent == 0 && !_vm.isLoadingData),expression:"dormitoryTotalStudent == 0 && !isLoadingData"}],staticClass:"fa fa-graduation-cap",staticStyle:{"font-size":"60px","color":"#00A0F0","margin-top":"50px","text-align":"center","height":"150px","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"info-box",staticStyle:{"background":"#3C8DBC","color":"#fff","cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getDormitoryFastReport(_vm.$ml.get('dashboard.fastReportTitleActiveStudents'), 3)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px"},attrs:{"id":"load","hidden":!_vm.isLoadingDormitoryData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingDormitoryData),expression:"!isLoadingDormitoryData"}],staticClass:"fa fa-graduation-cap",staticStyle:{"font-size":"20px","vertical-align":"middle","margin-bottom":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.activeStudentsInDormitory')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.dormitoryTotalStudent))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryTotalStudent != null),expression:"dormitoryTotalStudent != null"}],staticClass:"progress-bar",style:('width:' + this.dormitoryTotalStudent * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"info-box bg-green",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getDormitoryFastReport(_vm.$ml.get('dashboard.fastReportTitleInsideStudents'), 0)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px"},attrs:{"id":"load","hidden":!_vm.isLoadingDormitoryData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingDormitoryData),expression:"!isLoadingDormitoryData"}],staticClass:"fa fa-building",staticStyle:{"font-size":"20px","vertical-align":"middle","margin-bottom":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.insideStudentsInDormitory')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.dormitoryInsideStudent))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryInsideStudent != null),expression:"dormitoryInsideStudent != null"}],staticClass:"progress-bar",style:('width:' + this.dormitoryInsideStudent * 100 / this.dormitoryTotalStudent + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"info-box bg-red",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getDormitoryFastReport(_vm.$ml.get('dashboard.fastReportTitleOutsideStudents'), 1)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px"},attrs:{"id":"load","hidden":!_vm.isLoadingDormitoryData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingDormitoryData),expression:"!isLoadingDormitoryData"}],staticClass:"fa fa-sign-out",staticStyle:{"font-size":"20px","vertical-align":"middle","margin-bottom":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.outsideStudentsInDormitory')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.dormitoryOutsideStudent))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryOutsideStudent != null),expression:"dormitoryOutsideStudent != null"}],staticClass:"progress-bar",style:('width:' + this.dormitoryOutsideStudent * 100 / this.dormitoryTotalStudent + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"info-box bg-yellow",staticStyle:{"cursor":"pointer","min-height":"60px"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getDormitoryFastReport(_vm.$ml.get('dashboard.fastReportTitleAllowencedStudents'), 2)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"width":"40px","height":"65px"}},[_c('div',{staticClass:"overlay",staticStyle:{"font-size":"30px"},attrs:{"id":"load","hidden":!_vm.isLoadingDormitoryData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingDormitoryData),expression:"!isLoadingDormitoryData"}],staticClass:"fa fa-calendar-check-o",staticStyle:{"font-size":"20px","vertical-align":"middle","margin-bottom":"20px"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"10px","text-align":"center"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"font-size":"12px","margin-left":"10px"}},[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowencedStudentsInDormitory')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.dormitoryAllowencedStudent))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dormitoryAllowencedStudent != null),expression:"dormitoryAllowencedStudent != null"}],staticClass:"progress-bar",style:('width:' + this.dormitoryAllowencedStudent * 100 / this.dormitoryTotalStudent + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"info-box bg-teal",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.totalCar')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleInsideCars'), 7)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingVehicle}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingVehicle),expression:"!isLoadingVehicle"}],staticClass:"fa fa-car"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.totalCar')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.totalCars))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.totalCars != null),expression:"totalCars != null"}],staticClass:"progress-bar",style:('width:' + this.totalCars * 100 / this.totalEmployees + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"info-box bg-purple",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.insideCar')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleInsideCars'), 7)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingVehicle}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingVehicle),expression:"!isLoadingVehicle"}],staticClass:"fa fa-car"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.insideCar')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.insideCars))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.insideCars != null),expression:"insideCars != null"}],staticClass:"progress-bar",style:('width:' + this.insideCars * 100 / this.totalCars + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"info-box bg-maroon",staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.insideCar')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleOutsideCars'), 7)}}},[_c('span',{staticClass:"info-box-icon",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingVehicle}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingVehicle),expression:"!isLoadingVehicle"}],staticClass:"fa fa-car"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.outsideCar')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.outsideCars))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.outsideCars != null),expression:"outsideCars != null"}],staticClass:"progress-bar",style:('width:' + this.outsideCars * 100 / this.totalCars + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.mobileApp),expression:"modules.mobileApp"}],staticClass:"info-box",staticStyle:{"background":"#fff","color":"#00A0F0","cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleMobileAppUsers'), 10)}}},[_c('span',{staticClass:"info-box-icon bg-purple",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingData),expression:"!isLoadingData"}],staticClass:"ion ion-person"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.registeredMobileAppUser')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.mobileUsers)+" / "+_vm._s(_vm.modules.maxMobileUsers))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mobileUsers != null),expression:"mobileUsers != null"}],staticClass:"progress-bar",style:('background-color:#00a0f0;width:' + this.mobileUsers * 100 / _vm.modules.maxMobileUsers + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.mobileApp),expression:"modules.mobileApp"}],staticClass:"info-box",staticStyle:{"background":"#fff","color":"#00A0F0","cursor":"pointer"},attrs:{"title":_vm.$ml.get('dashboard.fastReportView')},on:{"click":function($event){_vm.getFastReport(_vm.$ml.get('dashboard.fastReportTitleActiveMobileAppUsers'), 12)}}},[_c('span',{staticClass:"info-box-icon bg-purple",staticStyle:{"font-size":"30px"}},[_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingData}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoadingData),expression:"!isLoadingData"}],staticClass:"ion ion-ios-checkmark"})]),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.activeMobileAppUser')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v(_vm._s(_vm.activeMobileUsers)+" / "+_vm._s(_vm.mobileUsers))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeMobileUsers != null),expression:"activeMobileUsers != null"}],staticClass:"progress-bar",style:('background-color:#00a0f0;width:' + this.activeMobileUsers * 100 / this.mobileUsers + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.allowenceRequests),expression:"modules.allowenceRequests"}],staticClass:"box box-info"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceRequests'))+" : "+_vm._s(_vm.allowenceRequestCount))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceRequestList.length > 0),expression:"allowenceRequestList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"502px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{directives:[{name:"show",rawName:"v-show",value:(_vm.windowWidth >= 1339),expression:"windowWidth >= 1339"}]}),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceHeadNameAndDescription')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceHeadRequestedDates')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.allowenceRequestList),function(request){return _c('tr',{key:request.id,staticClass:"rows"},[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.windowWidth >= 1339),expression:"windowWidth >= 1339"}]},[_c('img',{staticStyle:{"border-radius":"50%","float":"left","width":"40px","height":"40px"},attrs:{"src":request.image ? request.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(request.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("readMore")(request.description)))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge label-primary",staticStyle:{"margin-bottom":"5px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(request.startDate,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(request.endDate,"gg.aa.yyyy ss:dd")))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-allowenceRequest"},on:{"click":function($event){return _vm.selectAllowencedRequest(request)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceRequestList.length == 0),expression:"allowenceRequestList.length == 0"}]},[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceRequestNotFound')))])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingAllowence}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-device-report"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcelDevices()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFDevices()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"margin-right":"10px","font-size":"20px"},attrs:{"hidden":!_vm.isLoadingReport}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.deviceStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchTextDevices),expression:"searchTextDevices"}],staticClass:"form-control mb-10",attrs:{"type":"text","placeholder":_vm.$ml.get('general.search')},domProps:{"value":(_vm.searchTextDevices)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchTextDevices=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.searchTextDevices = ''}}},[_c('i',{staticClass:"fa fa-times"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList != null),expression:"deviceList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize),attrs:{"id":"printReportDevices"}},[_c('div',{staticClass:"dep-baslik",staticStyle:{"padding-bottom":"10px","padding-top":"10px","text-align":"center"}},[_c('span',{staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.$ml.get('dashboard.deviceStatus'))),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.lastConnectionTime),expression:"lastConnectionTime"}]},[_vm._v(" - ("+_vm._s(_vm._f("toDateFormatGet")(_vm.lastConnectionTime,"gg.aa.yyyy ss:dd"))+")")])])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",attrs:{"id":"printExcelDevices"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('dashboard.device')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('dashboard.lastConnection')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('dashboard.status')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredDeviceList),function(device){return _c('tr',{key:device.id,staticClass:"rows"},[_c('td',[_c('span',[_vm._v(_vm._s(device.ip))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(device.name))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(device.lastConnectionTime))])]),_vm._v(" "),_c('td',[(device.lastConnectionStatus == 'Bağlı')?_c('span',{staticClass:"badge label-success"},[_vm._v(_vm._s(device.lastConnectionStatus))]):_vm._e(),_vm._v(" "),(device.lastConnectionStatus == 'Bağlantı Sorunu')?_c('span',{staticClass:"badge label-danger"},[_vm._v(_vm._s(device.lastConnectionStatus))]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredDeviceList.length == 0),expression:"filteredDeviceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('dashboard.deviceNotFound'))+"\n              ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-fast-report"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"margin-right":"10px","font-size":"20px"},attrs:{"hidden":!_vm.isLoadingReport}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.reportTitle))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control mb-10",attrs:{"type":"text","placeholder":_vm.$ml.get('general.search')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.searchText = ''}}},[_c('i',{staticClass:"fa fa-times"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fastReportList != null),expression:"fastReportList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize),attrs:{"id":"printReport"}},[_c('div',{staticClass:"dep-baslik",staticStyle:{"padding-bottom":"10px","padding-top":"10px","text-align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportTitle != ''),expression:"reportTitle != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.reportTitle)+" - ("+_vm._s(_vm._f("toDateFormatGet")(new Date(),"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',_vm._l((_vm.reportHeaderList),function(header,indexHead){return _c('th',{key:indexHead},[_vm._v(_vm._s(header))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((_vm.fastReportList),function(report,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(report.sicilNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.department))]),_vm._v(" "),(report.statu != null)?_c('td',[_vm._v(_vm._s(report.statu))]):_vm._e(),_vm._v(" "),(report.movement != null)?_c('td',[_vm._v(_vm._s(report.movement))]):_vm._e(),_vm._v(" "),(report.title != null)?_c('td',[_vm._v(_vm._s(report.title))]):_vm._e(),_vm._v(" "),(report.readerName != null)?_c('td',[_vm._v(_vm._s(report.readerName))]):_vm._e(),_vm._v(" "),(report.mobilePhone != null)?_c('td',[_vm._v(_vm._s(report.mobilePhone))]):_vm._e(),_vm._v(" "),(report.device != null)?_c('td',[_vm._v(_vm._s(report.device))]):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fastReportList == null || _vm.fastReportList == 0),expression:"fastReportList == null || fastReportList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('dashboard.fastReportNotRecord'))+"\n              ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-fast-report-dormitory"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel2()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF2()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"margin-right":"10px","font-size":"20px"},attrs:{"hidden":!_vm.isLoadingReport}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.reportTitle))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control mb-10",attrs:{"type":"text","placeholder":_vm.$ml.get('general.search')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.searchText = ''}}},[_c('i',{staticClass:"fa fa-times"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fastReportList != null),expression:"fastReportList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize),attrs:{"id":"printReportDormitory"}},[_c('div',{staticClass:"dep-baslik",staticStyle:{"padding-bottom":"10px","padding-top":"10px","text-align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportTitle != ''),expression:"reportTitle != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.reportTitle)+" - ("+_vm._s(_vm._f("toDateFormatGet")(new Date(),"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",attrs:{"id":"printExcelDormitory"}},[_c('tbody',_vm._l((_vm.fastReportList),function(report,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(report.sicilNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.allowence))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.exitDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.exitPoint))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.status))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.isSmsSend))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.motherName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.fatherName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.smsPhone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.validityDate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.areaName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.floorName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(report.roomName))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fastReportList == null || _vm.fastReportList == 0),expression:"fastReportList == null || fastReportList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('dashboard.fastReportNotRecord'))+"\n              ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-allowenceRequest"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceRequest')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('img',{staticStyle:{"width":"100%","margin-bottom":"10px"},attrs:{"src":_vm.allowenceRequest.image ? _vm.allowenceRequest.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kişi")]),_vm._v(" "),_c('label',{staticClass:"form-control",staticStyle:{"height":"auto"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceRequest.sicilNo != ''),expression:"allowenceRequest.sicilNo != ''"}]},[_vm._v(_vm._s(_vm.allowenceRequest.sicilNo)+" - ")]),_vm._v("\n                      "+_vm._s(_vm.allowenceRequest.name)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ünvan")]),_vm._v(" "),_c('label',{staticClass:"form-control",staticStyle:{"height":"auto"}},[_vm._v(_vm._s(_vm.allowenceRequest.title))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Departman")]),_vm._v(" "),_c('label',{staticClass:"form-control",staticStyle:{"height":"auto"}},[_vm._v(_vm._s(_vm.allowenceRequest.department))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İzinin Talep Edildiği Tarih")]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.allowenceRequest.createdDate,"gg.aa.yyyy ss:dd")))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Başlangıç Tarihi")]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.allowenceRequest.startDate,"gg.aa.yyyy ss:dd")))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bitiş Tarihi")]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.allowenceRequest.endDate,"gg.aa.yyyy ss:dd")))])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İzin Talebi Açıklaması")]),_vm._v(" "),_c('label',{staticClass:"form-control",staticStyle:{"height":"auto"}},[_vm._v(_vm._s(_vm.allowenceRequest.description))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.close')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.rejectAllowenceRequestModal()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" Reddet\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.successAllowenceRequestModal()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Onayla (İzine Dönüştür)\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-allowenceRequest-success"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceRequest'))+" Onayı")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('label',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceRequest.sicilNo != ''),expression:"allowenceRequest.sicilNo != ''"}]},[_vm._v("("+_vm._s(_vm.allowenceRequest.sicilNo)+")")]),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.name)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.title)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.department)+"\n                "),_c('br'),_vm._v("kişisi için izin oluştur\n              ")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"table-responsive",staticStyle:{"height":"350px","overflow":"auto"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('employees.validDays')))]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"15px"}},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check == true ? day.check = false : day.check = true}}}),_vm._v("\n                          "+_vm._s(day.name)+"\n                        ")])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typeAllowence')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowenceType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.allowence.allowenceType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.dailyAllowence'))+"\n                  ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.allowence.allowenceType == 1}},[_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.hourlyAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.startTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.startDate),expression:"allowence.startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.startDate)},on:{"change":function($event){return _vm.changeAllowenceStartTime()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.endTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.endDate),expression:"allowence.endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.allowence')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowence($event)}}},_vm._l((_vm.allowenceList),function(allowence3){return _c('option',{key:allowence3.id,domProps:{"selected":allowence3.id == _vm.allowence.allowenceId,"value":allowence3.id}},[_vm._v("\n                    "+_vm._s(allowence3.shortCode)+" - "+_vm._s(allowence3.name))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1),expression:"allowence.allowenceType == 1"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.totalTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.allowenceTime),expression:"allowence.allowenceTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.allowence.allowenceTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "allowenceTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1),expression:"allowence.allowenceType == 1"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.missingHourAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.missingTime),expression:"allowence.missingTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.allowence.missingTime)},on:{"change":function($event){return _vm.changeEqualMissingTime()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "missingTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1),expression:"allowence.allowenceType == 1"}],staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.isEqualTheMissingTime')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.allowence.equalTheMissingTime},on:{"change":function($event){return _vm.changeCheckEqualMissingTime()}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.equalTheMissingTime'))+"\n                  ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 0),expression:"allowence.allowenceType == 0"}],staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.doesApplyHolidays')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.allowence.holidayPass},on:{"change":function($event){_vm.allowence.holidayPass == true ? _vm.allowence.holidayPass = false : _vm.allowence.holidayPass = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.applyHolidays'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.descriptionAllowence')))]),_vm._v(" "),_c('textArea',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.allowence.description),callback:function ($$v) {_vm.$set(_vm.allowence, "description", $$v)},expression:"allowence.description"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.successAllowenceRequest()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Kaydet\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-allowenceRequest-reject"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('dashboard.allowenceRequest'))+" Onayı")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('label',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceRequest.sicilNo != ''),expression:"allowenceRequest.sicilNo != ''"}]},[_vm._v("("+_vm._s(_vm.allowenceRequest.sicilNo)+")")]),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.name)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.title)+"\n                "),_c('br'),_vm._v("\n                "+_vm._s(_vm.allowenceRequest.department)+"\n                "),_c('br'),_vm._v("kişisi için izin talebini reddet\n              ")]),_vm._v(" "),_c('hr')])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("Red Açıklaması")]),_vm._v(" "),_c('textArea',{staticClass:"form-control",attrs:{"type":"text"},model:{value:(_vm.allowenceRequestDescription),callback:function ($$v) {_vm.allowenceRequestDescription=$$v},expression:"allowenceRequestDescription"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.rejectAllowenceRequest()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Kaydet\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Kişi İstatistikleri\n            ")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" Yurt İstatistikleri\n            ")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RealTimeMonitor_vue__ = __webpack_require__(137);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f01860_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RealTimeMonitor_vue__ = __webpack_require__(297);
function injectStyle (ssrContext) {
  __webpack_require__(295)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26f01860"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RealTimeMonitor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f01860_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RealTimeMonitor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a335dc1c", content, true, {});

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ml-80[data-v-26f01860]{margin-left:60px}.box-w-70[data-v-26f01860]{width:60px;height:90px;border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:left;text-align:center;line-height:80px;background:rgba(0,0,0,.2)}.box-w-70 img[data-v-26f01860]{width:50px}.detail-box[data-v-26f01860]{display:block;min-height:90px;background:#fff;width:100%;box-shadow:0 1px 1px rgb(0 0 0/10%);border-radius:2px;margin-bottom:15px}", ""]);

// exports


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v("\n        "+_vm._s(_vm.$ml.get('shared.realTimeMonitor'))+"\n        "),_c('i',{staticClass:"fa fa-dot-circle-o",style:(_vm.connection == true ? 'color:green;' : 'color:red;')})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.foodMenuPopup),expression:"modules.foodMenuPopup"}],staticClass:"btn btn-success",staticStyle:{"margin-left":"10px"},on:{"click":function($event){return _vm.changeScreen()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreenStatus == 0),expression:"activeScreenStatus == 0"}]},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v("\n          "+_vm._s(_vm.$ml.get('realTimeMonitor.foodMenuAndView'))+"\n        ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreenStatus == 1),expression:"activeScreenStatus == 1"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n          "+_vm._s(_vm.$ml.get('realTimeMonitor.entryExitList'))+"\n        ")])])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.realTimeMonitor')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary collapsed-box",attrs:{"id":"deviceControlList"}},[_c('div',{staticClass:"box-header with-border",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onCloseBoxDevice()}}},[_c('i',{staticClass:"fa fa-sitemap"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.inputStatus')))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box-body"},_vm._l((_vm.readerList),function(reader){return _c('div',{key:reader.readerId,staticClass:"col-xl-2 col-lg-3 col-md-4 col-sm-6 col-xs-12",on:{"click":function($event){return _vm.openDoorModal(reader)}}},[_c('div',{staticClass:"detail-box",staticStyle:{"cursor":"pointer"}},[_c('span',{class:_vm.customColor(reader)},[_c('img',{attrs:{"title":_vm.getDoorStates(reader.doorStates) + ' - ' + _vm.getReaderStates(reader.connectionStatus),"src":_vm.getDoorImage(reader.doorStates)}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content ml-80"},[_c('strong',{staticClass:"no-wrap"},[_c('span',{staticStyle:{"font-size":"12px"},attrs:{"title":reader.inputName + ' (' + reader.name + ')'}},[_vm._v(_vm._s(reader.inputName))])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"}}),_vm._v(" "),_c('div',{staticClass:"no-wrap"},[_vm._m(1,true),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px"},attrs:{"title":reader.terminalName}},[_vm._v(_vm._s(reader.terminalName))])]),_vm._v(" "),_c('div',{staticClass:"no-wrap"},[_vm._m(2,true),_vm._v("\n                    "+_vm._s(reader.ipAddress)+"\n                  ")])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreenStatus == 0),expression:"activeScreenStatus == 0"}],staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-success"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-video-camera"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.lastEntry')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-rounded",staticStyle:{"width":"150px"},attrs:{"src":_vm.lastEntryRecord.image ? _vm.lastEntryRecord.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.lastEntryRecord.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.lastEntryRecord.title))])]),_vm._v(" "),_c('h4',[_c('span',[_vm._v(_vm._s(_vm.lastEntryRecord.readerName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted text-primary",staticStyle:{"font-size":"medium"}},[_vm._v(_vm._s(_vm.lastEntryRecord.terminalGroup))])]),_vm._v(" "),_c('h4',{staticClass:"text-success"},[_c('span',[_vm._v(_vm._s(_vm.lastEntryRecord.date))])])])])]),_vm._v(" "),_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-video-camera"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.lastExit')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-6"},[_c('img',{staticClass:"img-rounded",staticStyle:{"width":"150px"},attrs:{"src":_vm.lastExitRecord.image ? _vm.lastExitRecord.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.lastExitRecord.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.lastExitRecord.title))])]),_vm._v(" "),_c('h4',[_c('span',[_vm._v(_vm._s(_vm.lastExitRecord.readerName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted text-primary",staticStyle:{"font-size":"medium"}},[_vm._v(_vm._s(_vm.lastExitRecord.terminalGroup))])]),_vm._v(" "),_c('h4',{staticClass:"text-danger"},[_c('span',[_vm._v(_vm._s(_vm.lastExitRecord.date))])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreenStatus == 0),expression:"activeScreenStatus == 0"}],staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",attrs:{"align":"center"}},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.entryExitList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[(_vm.logList.length > 0)?_c('table',{staticClass:"table table-hover",staticStyle:{"max-height":"200px","owerflow":"auto","font-size":"16px"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.logList),function(log,index){return _c('tr',{key:index,class:_vm.bgAyar(log.isErrorLog, log.entryOrExit)},[_c('td',[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":log.image ? log.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.getCardName(log)))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(log.title))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(log.terminalGroup))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(log.readerName))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(log.date))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(log.entryOrExit == 1 && log.isErrorLog == false),expression:"log.entryOrExit == 1 && log.isErrorLog == false"}],staticClass:"text-success"},[_c('i',{staticClass:"fa fa-sign-in"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(log.entryOrExit == 2 && log.isErrorLog == false),expression:"log.entryOrExit == 2 && log.isErrorLog == false"}],staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-sign-out"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(log.isErrorLog == true),expression:"log.isErrorLog == true"}]},[_c('i',{staticClass:"fa fa-exclamation-triangle"})])]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm.logDescription(log.description)))])])}),0)]):_c('div',{staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('realTimeMonitor.logNotFoundInfo'))+"\n              ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreenStatus == 1),expression:"activeScreenStatus == 1"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',{staticStyle:{"font-size":"36px"}},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('realTimeMonitor.foodMenu'))+"\n              ")])]),_vm._v(" "),_c('h3',{staticClass:"box-title pull-right"},[_c('span',{staticStyle:{"font-size":"36px"}},[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.todayTotalFood'))+" : "+_vm._s(_vm.totalFoodCount))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body",style:(_vm.windowFoodHeightSize)},[_c('div',{staticClass:"table-responsive no-padding"},[_c('table',{staticClass:"table",staticStyle:{"max-height":"200px","owerflow":"auto","font-size":"42px","color":"black","text-align":"center","margin-top":"10px"}},[_c('tbody',[_c('tr',[_c('td',{staticStyle:{"vertical-align":"middle","border":"none"}},[_vm._v(_vm._s(_vm.foodMenus.yemek1))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"middle","border":"none"}},[_vm._v(_vm._s(_vm.foodMenus.yemek2))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"middle","border":"none"}},[_vm._v(_vm._s(_vm.foodMenus.yemek3))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"middle","border":"none"}},[_vm._v(_vm._s(_vm.foodMenus.yemek4))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"vertical-align":"middle","border":"none"}},[_vm._v(_vm._s(_vm.foodMenus.yemek5))])])])])])])])])]),_vm._v(" "),_c('div',{class:_vm.foodLog.isErrorLog ? 'modal modal-danger fade' : 'modal modal-success fade',staticStyle:{"display":"none"},attrs:{"id":"modal-food-log"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.entryOrExitLogInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"40px"}},[_c('div',{staticClass:"col-sm-5 text-center"},[_c('img',{staticClass:"img-rounded",staticStyle:{"width":"150px"},attrs:{"src":_vm.foodLog.image ? _vm.foodLog.image : '/src/assets/default-user.png'}}),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.foodLog.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.foodLog.title))])]),_vm._v(" "),_c('h4',[_c('span',[_vm._v(_vm._s(_vm.foodLog.readerName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"medium"}},[_vm._v(_vm._s(_vm.foodLog.terminalGroup))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.logTime')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(_vm.foodLog.date))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.logDescription')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(_vm.foodLog.description))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.mealPay')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(_vm.foodLog.foodPrice)+" TL")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.availableBalance')))]),_vm._v(" "),_c('h3',{staticStyle:{"margin-left":"30px"}},[_vm._v(_vm._s(_vm.foodLog.foodRemainPrice)+" TL")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-open-door"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.openDoor')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h4',[_vm._v(_vm._s(_vm.selectedDevice.inputName))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"relayTime"}},[_vm._v(_vm._s(_vm.$ml.get('realTimeMonitor.relayDelay')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relay),expression:"relay"}],staticClass:"form-control",attrs:{"type":"number","min":"1","id":"relayTime"},domProps:{"value":(_vm.relay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.relay=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary w-100",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendOpenDoorCommand()}}},[_c('i',{staticClass:"fa fa-bolt"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('realTimeMonitor.openDoor'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-microchip"}),_vm._v(" :\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-share-alt"}),_vm._v(" :\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Ad Soyad")]),_vm._v(" "),_c('th',[_vm._v("Ünvan")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Okuyucu")]),_vm._v(" "),_c('th',[_vm._v("Zaman")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Durum")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Employees_vue__ = __webpack_require__(138);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186be5f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Employees_vue__ = __webpack_require__(308);
function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-186be5f7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Employees_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_186be5f7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Employees_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(300);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2059f139", content, true, {});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".fp-kutu-kirmizi[data-v-186be5f7]{background-image:url(\"/src/assets/fingerprint-false.png\")}.fp-kutu-kirmizi[data-v-186be5f7],.fp-kutu-yesil[data-v-186be5f7]{width:50px;height:50px;position:absolute;cursor:pointer;text-align:center;font-size:18px;padding-top:10px;background-size:cover;z-index:999;color:#fff}.fp-kutu-yesil[data-v-186be5f7]{background-image:url(\"/src/assets/fingerprint-true.png\")}.customCard[data-v-186be5f7]{width:323px;height:204px;border-radius:10px;display:inline-block;border:2px solid #ccc;position:relative}.table>tbody>tr>td[data-v-186be5f7],.table>tbody>tr>th[data-v-186be5f7],.table>thead>tr>th[data-v-186be5f7]{align-content:center}", ""]);

// exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(302);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1864e2b4", content, true, {});

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "@-webkit-keyframes vicp_progress{0%{background-position-y:0}to{background-position-y:40px}}@keyframes vicp_progress{0%{background-position-y:0}to{background-position-y:40px}}@-webkit-keyframes vicp{0%{opacity:0;-webkit-transform:scale(0) translatey(-60px);transform:scale(0) translatey(-60px)}to{opacity:1;-webkit-transform:scale(1) translatey(0);transform:scale(1) translatey(0)}}@keyframes vicp{0%{opacity:0;-webkit-transform:scale(0) translatey(-60px);transform:scale(0) translatey(-60px)}to{opacity:1;-webkit-transform:scale(1) translatey(0);transform:scale(1) translatey(0)}}.vue-image-crop-upload{width:100%;height:100%;background-color:rgba(0,0,0,.65);-webkit-tap-highlight-color:transparent;-moz-tap-highlight-color:transparent}.vue-image-crop-upload,.vue-image-crop-upload .vicp-wrap{position:fixed;display:block;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:10000;top:0;bottom:0;left:0;right:0}.vue-image-crop-upload .vicp-wrap{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.23);box-shadow:0 1px 3px 0 rgba(0,0,0,.23);margin:auto;width:600px;height:330px;padding:25px;background-color:#fff;border-radius:2px;-webkit-animation:vicp .12s ease-in;animation:vicp .12s ease-in}.vue-image-crop-upload .vicp-wrap .vicp-close{position:absolute;right:-30px;top:-30px}.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4{position:relative;display:block;width:30px;height:30px;cursor:pointer;-webkit-transition:-webkit-transform .18s;transition:-webkit-transform .18s;transition:transform .18s;transition:transform .18s,-webkit-transform .18s;-webkit-transform:rotate(0);-ms-transform:rotate(0);transform:rotate(0)}.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:after,.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:before{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.23);box-shadow:0 1px 3px 0 rgba(0,0,0,.23);content:\"\";position:absolute;top:12px;left:4px;width:20px;height:3px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);background-color:#fff}.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:after{-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.vue-image-crop-upload .vicp-wrap .vicp-close .vicp-icon4:hover{-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;padding:35px;height:170px;background-color:rgba(0,0,0,.03);text-align:center;border:1px dashed rgba(0,0,0,.08);overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1{display:block;margin:0 auto 6px;width:42px;height:42px;overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-arrow{display:block;margin:0 auto;width:0;height:0;border-bottom:14.7px solid rgba(0,0,0,.3);border-left:14.7px solid transparent;border-right:14.7px solid transparent}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-body{display:block;width:12.6px;height:14.7px;margin:0 auto;background-color:rgba(0,0,0,.3)}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-icon1 .vicp-icon1-bottom{-webkit-box-sizing:border-box;box-sizing:border-box;display:block;height:12.6px;border:6px solid rgba(0,0,0,.3);border-top:none}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-hint{display:block;padding:15px;font-size:14px;color:#666;line-height:30px}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area .vicp-no-supported-hint{display:block;position:absolute;top:0;left:0;padding:30px;width:100%;height:60px;line-height:30px;background-color:#eee;text-align:center;color:#666;font-size:14px}.vue-image-crop-upload .vicp-wrap .vicp-step1 .vicp-drop-area:hover{cursor:pointer;border-color:rgba(0,0,0,.1);background-color:rgba(0,0,0,.05)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop{overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left{float:left}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container{position:relative;display:block;width:240px;height:180px;background-color:#e5e5e0;overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img{position:absolute;display:block;cursor:move;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.18);box-shadow:0 2px 6px 0 rgba(0,0,0,.18);position:absolute;background-color:hsla(210,8%,95%,.8)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-1{top:0;left:0}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-img-container .vicp-img-shade.vicp-img-shade-2{bottom:0;right:0}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate{position:relative;width:240px;height:18px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i{display:block;width:18px;height:18px;border-radius:100%;line-height:18px;text-align:center;font-size:12px;font-weight:700;background-color:rgba(0,0,0,.08);color:#fff;overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:hover{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.12);cursor:pointer;background-color:rgba(0,0,0,.14)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:first-child{float:left}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-rotate i:last-child{float:right}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range{position:relative;margin:30px 0 10px;width:240px;height:18px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5,.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6{position:absolute;top:0;width:18px;height:18px;border-radius:100%;background-color:rgba(0,0,0,.08)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5:hover,.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6:hover{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.12);cursor:pointer;background-color:rgba(0,0,0,.14)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5{left:0}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon5:before{position:absolute;content:\"\";display:block;left:3px;top:8px;width:12px;height:2px;background-color:#fff}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6{right:0}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6:before{position:absolute;content:\"\";display:block;left:3px;top:8px;width:12px;height:2px;background-color:#fff}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range .vicp-icon6:after{position:absolute;content:\"\";display:block;top:3px;left:8px;width:2px;height:12px;background-color:#fff}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]{display:block;padding-top:5px;margin:0 auto;width:180px;height:8px;vertical-align:top;background:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;cursor:pointer}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus{outline:none}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-thumb{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.18);box-shadow:0 2px 6px 0 rgba(0,0,0,.18);-webkit-appearance:none;appearance:none;margin-top:-3px;width:12px;height:12px;background-color:#61c091;border-radius:100%;border:none;-webkit-transition:.2s;transition:.2s}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-thumb{box-shadow:0 2px 6px 0 rgba(0,0,0,.18);-moz-appearance:none;appearance:none;width:12px;height:12px;background-color:#61c091;border-radius:100%;border:none;-webkit-transition:.2s;transition:.2s}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-thumb{box-shadow:0 2px 6px 0 rgba(0,0,0,.18);appearance:none;width:12px;height:12px;background-color:#61c091;border:none;border-radius:100%;-webkit-transition:.2s;transition:.2s}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-moz-range-thumb{box-shadow:0 1px 3px 0 rgba(0,0,0,.23);width:14px;height:14px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-ms-thumb{box-shadow:0 1px 3px 0 rgba(0,0,0,.23);width:14px;height:14px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:active::-webkit-slider-thumb{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.23);box-shadow:0 1px 3px 0 rgba(0,0,0,.23);margin-top:-4px;width:14px;height:14px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-webkit-slider-runnable-track{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.12);width:100%;height:6px;cursor:pointer;border-radius:2px;border:none;background-color:rgba(68,170,119,.3)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-moz-range-track{box-shadow:0 1px 3px 0 rgba(0,0,0,.12);width:100%;height:6px;cursor:pointer;border-radius:2px;border:none;background-color:rgba(68,170,119,.3)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-track{box-shadow:0 1px 3px 0 rgba(0,0,0,.12);width:100%;cursor:pointer;background:transparent;border-color:transparent;color:transparent;height:6px;border-radius:2px;border:none}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-lower{background-color:rgba(68,170,119,.3)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]::-ms-fill-upper{background-color:rgba(68,170,119,.15)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-webkit-slider-runnable-track{background-color:rgba(68,170,119,.5)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-moz-range-track{background-color:rgba(68,170,119,.5)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-lower{background-color:rgba(68,170,119,.45)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-left .vicp-range input[type=range]:focus::-ms-fill-upper{background-color:rgba(68,170,119,.25)}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right{float:right}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview{height:150px;overflow:hidden}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item{position:relative;padding:5px;width:100px;height:100px;float:left;margin-right:16px}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item span{position:absolute;bottom:-30px;width:100%;font-size:14px;color:#bbb;display:block;text-align:center}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item img{position:absolute;display:block;top:0;bottom:0;left:0;right:0;margin:auto;padding:3px;background-color:#fff;border:1px solid rgba(0,0,0,.15);overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle{margin-right:0}.vue-image-crop-upload .vicp-wrap .vicp-step2 .vicp-crop .vicp-crop-right .vicp-preview .vicp-preview-item.vicp-preview-item-circle img{border-radius:100%}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;padding:35px;height:170px;background-color:rgba(0,0,0,.03);text-align:center;border:1px dashed #ddd}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-loading{display:block;padding:15px;font-size:16px;color:#999;line-height:30px}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap{margin-top:12px;background-color:rgba(0,0,0,.08);border-radius:3px}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress{position:relative;display:block;height:5px;border-radius:3px;background-color:#4a7;-webkit-box-shadow:0 2px 6px 0 rgba(68,170,119,.3);box-shadow:0 2px 6px 0 rgba(68,170,119,.3);-webkit-transition:width .15s linear;transition:width .15s linear;background-image:-webkit-linear-gradient(135deg,hsla(0,0%,100%,.2) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.2) 0,hsla(0,0%,100%,.2) 75%,transparent 0,transparent);background-image:linear-gradient(-45deg,hsla(0,0%,100%,.2) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.2) 0,hsla(0,0%,100%,.2) 75%,transparent 0,transparent);background-size:40px 40px;-webkit-animation:vicp_progress .5s linear infinite;animation:vicp_progress .5s linear infinite}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-progress-wrap .vicp-progress:after{content:\"\";position:absolute;display:block;top:-3px;right:-3px;width:9px;height:9px;border:1px solid rgba(245,246,247,.7);-webkit-box-shadow:0 1px 4px 0 rgba(68,170,119,.7);box-shadow:0 1px 4px 0 rgba(68,170,119,.7);border-radius:100%;background-color:#4a7}.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-error,.vue-image-crop-upload .vicp-wrap .vicp-step3 .vicp-upload .vicp-success{height:100px;line-height:100px}.vue-image-crop-upload .vicp-wrap .vicp-operate{position:absolute;left:20px;bottom:20px}.vue-image-crop-upload .vicp-wrap .vicp-operate a{position:relative;float:left;display:block;margin-left:10px;width:100px;height:36px;line-height:36px;text-align:center;cursor:pointer;font-size:14px;color:#4a7;border-radius:2px;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vue-image-crop-upload .vicp-wrap .vicp-operate a:hover{background-color:rgba(0,0,0,.03)}.vue-image-crop-upload .vicp-wrap .vicp-error,.vue-image-crop-upload .vicp-wrap .vicp-success{display:block;font-size:14px;line-height:24px;height:24px;color:#d10;text-align:center;vertical-align:top}.vue-image-crop-upload .vicp-wrap .vicp-success{color:#4a7}.vue-image-crop-upload .vicp-wrap .vicp-icon3{position:relative;display:inline-block;width:20px;height:20px;top:4px}.vue-image-crop-upload .vicp-wrap .vicp-icon3:after{position:absolute;top:3px;left:6px;width:6px;height:10px;border-width:0 2px 2px 0;border-color:#4a7;border-style:solid;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);content:\"\"}.vue-image-crop-upload .vicp-wrap .vicp-icon2{position:relative;display:inline-block;width:20px;height:20px;top:4px}.vue-image-crop-upload .vicp-wrap .vicp-icon2:after,.vue-image-crop-upload .vicp-wrap .vicp-icon2:before{content:\"\";position:absolute;top:9px;left:4px;width:13px;height:2px;background-color:#d10;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.vue-image-crop-upload .vicp-wrap .vicp-icon2:after{-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.e-ripple{position:absolute;border-radius:100%;background-color:rgba(0,0,0,.15);background-clip:padding-box;pointer-events:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transform:scale(0);-ms-transform:scale(0);transform:scale(0);opacity:1}.e-ripple.z-active{opacity:0;-webkit-transform:scale(2);-ms-transform:scale(2);transform:scale(2);-webkit-transition:opacity 1.2s ease-out,-webkit-transform .6s ease-out;transition:opacity 1.2s ease-out,-webkit-transform .6s ease-out;transition:opacity 1.2s ease-out,transform .6s ease-out;transition:opacity 1.2s ease-out,transform .6s ease-out,-webkit-transform .6s ease-out}", ""]);

// exports


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	zh: {
		hint: '点击，或拖动图片至此处',
		loading: '正在上传……',
		noSupported: '浏览器不支持该功能，请使用IE10以上或其他现在浏览器！',
		success: '上传成功',
		fail: '图片上传失败',
		preview: '头像预览',
		btn: {
			off: '取消',
			close: '关闭',
			back: '上一步',
			save: '保存'
		},
		error: {
			onlyImg: '仅限图片格式',
			outOfSize: '单文件大小不能超过 ',
			lowestPx: '图片最低像素为（宽*高）：'
		}
	},
	'zh-tw': {
		hint: '點擊，或拖動圖片至此處',
		loading: '正在上傳……',
		noSupported: '瀏覽器不支持該功能，請使用IE10以上或其他現代瀏覽器！',
		success: '上傳成功',
		fail: '圖片上傳失敗',
		preview: '頭像預覽',
		btn: {
			off: '取消',
			close: '關閉',
			back: '上一步',
			save: '保存'
		},
		error: {
			onlyImg: '僅限圖片格式',
			outOfSize: '單文件大小不能超過 ',
			lowestPx: '圖片最低像素為（寬*高）：'
		}
	},
	en: {
		hint: 'Click or drag the file here to upload',
		loading: 'Uploading…',
		noSupported: 'Browser is not supported, please use IE10+ or other browsers',
		success: 'Upload success',
		fail: 'Upload failed',
		preview: 'Preview',
		btn: {
			off: 'Cancel',
			close: 'Close',
			back: 'Back',
			save: 'Select'
		},
		error: {
			onlyImg: 'Image only',
			outOfSize: 'Image exceeds size limit: ',
			lowestPx: 'Image\'s size is too low. Expected at least: '
		}
	},
	ro: {
		hint: 'Atinge sau trage fișierul aici',
		loading: 'Se încarcă',
		noSupported: 'Browser-ul tău nu suportă acest feature. Te rugăm încearcă cu alt browser.',
		success: 'S-a încărcat cu succes',
		fail: 'A apărut o problemă la încărcare',
		preview: 'Previzualizează',

		btn: {
			off: 'Anulează',
			close: 'Închide',
			back: 'Înapoi',
			save: 'Salvează'
		},

		error: {
			onlyImg: 'Doar imagini',
			outOfSize: 'Imaginea depășește limita de: ',
			loewstPx: 'Imaginea este prea mică; Minim: '
		}
	},
	ru: {
		hint: 'Нажмите, или перетащите файл в это окно',
		loading: 'Загружаю……',
		noSupported: 'Ваш браузер не поддерживается, пожалуйста, используйте IE10 + или другие браузеры',
		success: 'Загрузка выполнена успешно',
		fail: 'Ошибка загрузки',
		preview: 'Предпросмотр',
		btn: {
			off: 'Отменить',
			close: 'Закрыть',
			back: 'Назад',
			save: 'Сохранить'
		},
		error: {
			onlyImg: 'Только изображения',
			outOfSize: 'Изображение превышает предельный размер: ',
			lowestPx: 'Минимальный размер изображения: '
		}
	},
	'pt-br': {
		hint: 'Clique ou arraste o arquivo aqui para carregar',
		loading: 'Carregando…',
		noSupported: 'Browser não suportado, use o IE10+ ou outro browser',
		success: 'Sucesso ao carregar imagem',
		fail: 'Falha ao carregar imagem',
		preview: 'Pré-visualizar',
		btn: {
			off: 'Cancelar',
			close: 'Fechar',
			back: 'Voltar',
			save: 'Salvar'
		},
		error: {
			onlyImg: 'Apenas imagens',
			outOfSize: 'A imagem excede o limite de tamanho: ',
			lowestPx: 'O tamanho da imagem é muito pequeno. Tamanho mínimo: '
		}
	},
	fr: {
		hint: 'Cliquez ou glissez le fichier ici.',
		loading: 'Téléchargement…',
		noSupported: 'Votre navigateur n\'est pas supporté. Utilisez IE10 + ou un autre navigateur s\'il vous plaît.',
		success: 'Téléchargement réussit',
		fail: 'Téléchargement echoué',
		preview: 'Aperçu',
		btn: {
			off: 'Annuler',
			close: 'Fermer',
			back: 'Retour',
			save: 'Enregistrer'
		},
		error: {
			onlyImg: 'Image uniquement',
			outOfSize: 'L\'image sélectionnée dépasse la taille maximum: ',
			lowestPx: 'L\'image sélectionnée est trop petite. Dimensions attendues: '
		}
	},
	nl: {
		hint: 'Klik hier of sleep een afbeelding in dit vlak',
		loading: 'Uploaden…',
		noSupported: 'Je browser wordt helaas niet ondersteund. Gebruik IE10+ of een andere browser.',
		success: 'Upload succesvol',
		fail: 'Upload mislukt',
		preview: 'Voorbeeld',
		btn: {
			off: 'Annuleren',
			close: 'Sluiten',
			back: 'Terug',
			save: 'Opslaan'
		},
		error: {
			onlyImg: 'Alleen afbeeldingen',
			outOfSize: 'De afbeelding is groter dan: ',
			lowestPx: 'De afbeelding is te klein! Minimale afmetingen: '
		}
	},
	tr: {
		hint: 'Tıkla veya yüklemek istediğini buraya sürükle',
		loading: 'Yükleniyor…',
		noSupported: 'Tarayıcı desteklenmiyor, lütfen IE10+ veya farklı tarayıcı kullanın',
		success: 'Yükleme başarılı',
		fail: 'Yüklemede hata oluştu',
		preview: 'Önizle',
		btn: {
			off: 'İptal',
			close: 'Kapat',
			back: 'Geri',
			save: 'Seç'
		},
		error: {
			onlyImg: 'Sadece resim',
			outOfSize: 'Resim yükleme limitini aşıyor: ',
			lowestPx: 'Resmin boyutu çok küçük. En az olması gereken: '
		}
	},
	'es-MX': {
		hint: 'Selecciona o arrastra una imagen',
		loading: 'Subiendo...',
		noSupported: 'Tu navegador no es soportado, por favor usa IE10+ u otros navegadores más recientes',
		success: 'Subido exitosamente',
		fail: 'Sucedió un error',
		preview: 'Vista previa',
		btn: {
			off: 'Cancelar',
			close: 'Cerrar',
			back: 'Atrás',
			save: 'Guardar'
		},
		error: {
			onlyImg: 'Únicamente imágenes',
			outOfSize: 'La imagen excede el tamaño maximo:',
			lowestPx: 'La imagen es demasiado pequeña. Se espera por lo menos:'
		}
	},
	de: {
		hint: 'Klick hier oder zieh eine Datei hier rein zum Hochladen',
		loading: 'Hochladen…',
		noSupported: 'Browser wird nicht unterstützt, bitte verwende IE10+ oder andere Browser',
		success: 'Upload erfolgreich',
		fail: 'Upload fehlgeschlagen',
		preview: 'Vorschau',
		btn: {
			off: 'Abbrechen',
			close: 'Schließen',
			back: 'Zurück',
			save: 'Speichern'
		},
		error: {
			onlyImg: 'Nur Bilder',
			outOfSize: 'Das Bild ist zu groß: ',
			lowestPx: 'Das Bild ist zu klein. Mindestens: '
		}
	},
	ja: {
		hint: 'クリック・ドラッグしてファイルをアップロード',
		loading: 'アップロード中...',
		noSupported: 'このブラウザは対応されていません。IE10+かその他の主要ブラウザをお使いください。',
		success: 'アップロード成功',
		fail: 'アップロード失敗',
		preview: 'プレビュー',
		btn: {
			off: 'キャンセル',
			close: '閉じる',
			back: '戻る',
			save: '保存'
		},
		error: {
			onlyImg: '画像のみ',
			outOfSize: '画像サイズが上限を超えています。上限: ',
			lowestPx: '画像が小さすぎます。最小サイズ: '
		}
	},
	ua: {
		hint: 'Натисніть, або перетягніть файл в це вікно',
		loading: 'Завантажую……',
		noSupported: 'Ваш браузер не підтримується, будь ласка скористайтесь IE10 + або іншими браузерами',
		success: 'Завантаження виконано успішно',
		fail: 'Помилка завантаження',
		preview: 'Попередній перегляд',
		btn: {
			off: 'Відмінити',
			close: 'Закрити',
			back: 'Назад',
			save: 'Зберегти'
		},
		error: {
			onlyImg: 'Тільки зображення',
			outOfSize: 'Зображення перевищує граничний розмір: ',
			lowestPx: 'Мінімальний розмір зображення: '
		}
	},
	it: {
		hint: 'Clicca o trascina qui il file per caricarlo',
		loading: 'Caricamento del file…',
		noSupported: 'Browser non supportato, per favore usa IE10+ o un altro browser',
		success: 'Caricamento completato',
		fail: 'Caricamento fallito',
		preview: 'Anteprima',
		btn: {
			off: 'Annulla',
			close: 'Chiudi',
			back: 'Indietro',
			save: 'Salva'
		},
		error: {
			onlyImg: 'Sono accettate solo immagini',
			outOfSize: 'L\'immagine eccede i limiti di dimensione: ',
			lowestPx: 'L\'immagine è troppo piccola. Il requisito minimo è: '
		}
	},
	ar: {
		hint: 'اضغط أو اسحب الملف هنا للتحميل',
		loading: 'جاري التحميل...',
		noSupported: 'المتصفح غير مدعوم ، يرجى استخدام IE10 + أو متصفح أخر',
		success: 'تم التحميل بنجاح',
		fail: 'فشل التحميل',
		preview: 'معاينه',
		btn: {
			off: 'إلغاء',
			close: 'إغلاق',
			back: 'رجوع',
			save: 'حفظ'
		},
		error: {
			onlyImg: 'صور فقط',
			outOfSize: 'تتجاوز الصوره الحجم المحدد: ',
			lowestPx: 'حجم الصورة صغير جدا. من المتوقع على الأقل: '
		}
	},
	ug: {
		hint: 'مەزكۇر دائىرىنى چىكىپ رەسىم تاللاڭ ياكى رەسىمنى سۆرەپ ئەكىرىڭ',
		loading: 'يوللىنىۋاتىدۇ...',
		noSupported: 'تور كۆرگۈچ بۇ ئىقتىدارنى قوللىمايدۇ ، يۇقىرى نەشىردىكى تور كۆرگۈچنى ئىشلىتىڭ',
		success: 'غەلبىلىك بولدى',
		fail: 'مەغلۇب بولدى',
		preview: 'ئۈنۈم رەسىم',
		btn: {
			off: 'بولدى قىلىش',
			close: 'تاقاش',
			back: 'ئالدىنقى قەدەم',
			save: 'ساقلاش'
		},
		error: {
			onlyImg: 'پەقەت رەسىم فورماتىنىلا قوللايدۇ',
			outOfSize: 'رەسىم چوڭ - كىچىكلىكى چەكتىن ئىشىپ كەتتى',
			lowestPx: 'رەسىمنىڭ ئەڭ كىچىك ئۆلچىمى :'
		}
	},
	th: {
		hint: 'คลิ๊กหรือลากรูปมาที่นี่',
		loading: 'กำลังอัพโหลด…',
		noSupported: 'เบราเซอร์ไม่รองรับ, กรุณาใช้ IE เวอร์ชั่น 10 ขึ้นไป หรือใช้เบราเซอร์ตัวอื่น',
		success: 'อัพโหลดสำเร็จ',
		fail: 'อัพโหลดล้มเหลว',
		preview: 'ตัวอย่าง',
		btn: {
			off: 'ยกเลิก',
			close: 'ปิด',
			back: 'กลับ',
			save: 'บันทึก'
		},
		error: {
			onlyImg: 'ไฟล์ภาพเท่านั้น',
			outOfSize: 'ไฟล์ใหญ่เกินกำหนด: ',
			lowestPx: 'ไฟล์เล็กเกินไป. อย่างน้อยต้องมีขนาด: '
		}
	},
	mm: {
		hint: 'ဖိုင်ကို ဤနေရာတွင် နှိပ်၍ (သို့) ဆွဲထည့်၍ တင်ပါ',
		loading: 'တင်နေသည်…',
		noSupported: 'ဤဘရောက်ဇာကို အထောက်အပံ့ မပေးပါ၊ ကျေးဇူးပြု၍ IE10+ သို့မဟုတ် အခြား ဘရောက်ဇာ ကို အသုံးပြုပါ',
		success: 'ဖိုင်တင်နေမှု မပြီးမြောက်ပါ',
		fail: 'ဖိုင်တင်နေမှု မအောင်မြင်ပါ',
		preview: 'အစမ်းကြည့်',
		btn: {
			off: 'မလုပ်တော့ပါ',
			close: 'ပိတ်မည်',
			back: 'နောက်သို့',
			save: 'သိမ်းမည်'
		},
		error: {
			onlyImg: 'ဓာတ်ပုံ သီးသန့်သာ',
			outOfSize: 'ဓာတ်ပုံဆိုဒ် ကြီးလွန်းသည် ။ အများဆုံး ဆိုဒ် : ',
			lowestPx: 'ဓာတ်ပုံဆိုဒ် သေးလွန်းသည်။ အနည်းဆုံး ဆိုဒ် : '
		}
	},
	se: {
		hint: 'Klicka eller dra en fil hit för att ladda upp den',
		loading: 'Laddar upp…',
		noSupported: 'Din webbläsare stöds inte, vänligen använd IE10+ eller andra webbläsare',
		success: 'Uppladdning lyckades',
		fail: 'Uppladdning misslyckades',
		preview: 'Förhandsgranska',
		btn: {
			off: 'Avbryt',
			close: 'Stäng',
			back: 'Tillbaka',
			save: 'Spara'
		},
		error: {
			onlyImg: 'Endast bilder',
			outOfSize: 'Bilden är större än max-gränsen: ',
			lowestPx: 'Bilden är för liten. Minimum är: '
		}
	}
});


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'psd': 'image/photoshop'
});


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * database64文件格式转换为2进制
 *
 * @param  {[String]} data dataURL 的格式为 “data:image/png;base64,****”,逗号之前都是一些说明性的文字，我们只需要逗号之后的就行了
 * @param  {[String]} mime [description]
 * @return {[blob]}      [description]
 */
/* harmony default export */ __webpack_exports__["a"] = (function(data, mime) {
	data = data.split(',')[1];
	data = window.atob(data);
	var ia = new Uint8Array(data.length);
	for (var i = 0; i < data.length; i++) {
		ia[i] = data.charCodeAt(i);
	};
	// canvas.toDataURL 返回的默认格式就是 image/png
	return new Blob([ia], {
		type: mime
	});
});;


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 点击波纹效果
 *
 * @param  {[event]} e        [description]
 * @param  {[Object]} arg_opts [description]
 * @return {[bollean]}          [description]
 */
/* harmony default export */ __webpack_exports__["a"] = (function(e, arg_opts) {
	var opts = Object.assign({
			ele: e.target, // 波纹作用元素
			type: 'hit', // hit点击位置扩散　center中心点扩展
			bgc: 'rgba(0, 0, 0, 0.15)' // 波纹颜色
		}, arg_opts),
		target = opts.ele;
	if (target) {
		var rect = target.getBoundingClientRect(),
			ripple = target.querySelector('.e-ripple');
		if (!ripple) {
			ripple = document.createElement('span');
			ripple.className = 'e-ripple';
			ripple.style.height = ripple.style.width = Math.max(rect.width, rect.height) + 'px';
			target.appendChild(ripple);
		} else {
			ripple.className = 'e-ripple';
		}
		switch (opts.type) {
			case 'center':
				ripple.style.top = (rect.height / 2 - ripple.offsetHeight / 2) + 'px';
				ripple.style.left = (rect.width / 2 - ripple.offsetWidth / 2) + 'px';
				break;
			default:
				ripple.style.top = (e.pageY - rect.top - ripple.offsetHeight / 2 - document.body.scrollTop) + 'px';
				ripple.style.left = (e.pageX - rect.left - ripple.offsetWidth / 2 - document.body.scrollLeft) + 'px';
		}
		ripple.style.backgroundColor = opts.bgc;
		ripple.className = 'e-ripple z-active';
		return false;
	}
});;


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.value),expression:"value"}],staticClass:"vue-image-crop-upload"},[_c('div',{staticClass:"vicp-wrap"},[_c('div',{staticClass:"vicp-close",on:{"click":_vm.off}},[_c('i',{staticClass:"vicp-icon4"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.step == 1),expression:"step == 1"}],staticClass:"vicp-step1"},[_c('div',{staticClass:"vicp-drop-area",on:{"dragleave":_vm.preventDefault,"dragover":_vm.preventDefault,"dragenter":_vm.preventDefault,"click":_vm.handleClick,"drop":_vm.handleChange}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading != 1),expression:"loading != 1"}],staticClass:"vicp-icon1"},[_c('i',{staticClass:"vicp-icon1-arrow"}),_vm._v(" "),_c('i',{staticClass:"vicp-icon1-body"}),_vm._v(" "),_c('i',{staticClass:"vicp-icon1-bottom"})]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading !== 1),expression:"loading !== 1"}],staticClass:"vicp-hint"},[_vm._v(_vm._s(_vm.lang.hint))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSupported),expression:"!isSupported"}],staticClass:"vicp-no-supported-hint"},[_vm._v(_vm._s(_vm.lang.noSupported))]),_vm._v(" "),(_vm.step == 1)?_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"fileinput",attrs:{"type":"file"},on:{"change":_vm.handleChange}}):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"vicp-error"},[_c('i',{staticClass:"vicp-icon2"}),_vm._v(" "+_vm._s(_vm.errorMsg)+"\n\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":_vm.off,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.off))])])]),_vm._v(" "),(_vm.step == 2)?_c('div',{staticClass:"vicp-step2"},[_c('div',{staticClass:"vicp-crop"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"vicp-crop-left"},[_c('div',{staticClass:"vicp-img-container"},[_c('img',{ref:"img",staticClass:"vicp-img",style:(_vm.sourceImgStyle),attrs:{"src":_vm.sourceImgUrl,"draggable":"false"},on:{"drag":_vm.preventDefault,"dragstart":_vm.preventDefault,"dragend":_vm.preventDefault,"dragleave":_vm.preventDefault,"dragover":_vm.preventDefault,"dragenter":_vm.preventDefault,"drop":_vm.preventDefault,"touchstart":_vm.imgStartMove,"touchmove":_vm.imgMove,"touchend":_vm.createImg,"touchcancel":_vm.createImg,"mousedown":_vm.imgStartMove,"mousemove":_vm.imgMove,"mouseup":_vm.createImg,"mouseout":_vm.createImg}}),_vm._v(" "),_c('div',{staticClass:"vicp-img-shade vicp-img-shade-1",style:(_vm.sourceImgShadeStyle)}),_vm._v(" "),_c('div',{staticClass:"vicp-img-shade vicp-img-shade-2",style:(_vm.sourceImgShadeStyle)})]),_vm._v(" "),_c('div',{staticClass:"vicp-range"},[_c('input',{attrs:{"type":"range","step":"1","min":"0","max":"100"},domProps:{"value":_vm.scale.range},on:{"mousemove":_vm.zoomChange}}),_vm._v(" "),_c('i',{staticClass:"vicp-icon5",on:{"mousedown":_vm.startZoomSub,"mouseout":_vm.endZoomSub,"mouseup":_vm.endZoomSub}}),_vm._v(" "),_c('i',{staticClass:"vicp-icon6",on:{"mousedown":_vm.startZoomAdd,"mouseout":_vm.endZoomAdd,"mouseup":_vm.endZoomAdd}})]),_vm._v(" "),(!_vm.noRotate)?_c('div',{staticClass:"vicp-rotate"},[_c('i',{on:{"click":_vm.rotateImg}},[_vm._v("↻")])]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],staticClass:"vicp-crop-right"},[_c('div',{staticClass:"vicp-preview"},[(!_vm.noSquare)?_c('div',{staticClass:"vicp-preview-item"},[_c('img',{style:(_vm.previewStyle),attrs:{"src":_vm.createImgUrl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.preview))])]):_vm._e(),_vm._v(" "),(!_vm.noCircle)?_c('div',{staticClass:"vicp-preview-item vicp-preview-item-circle"},[_c('img',{style:(_vm.previewStyle),attrs:{"src":_vm.createImgUrl}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lang.preview))])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":function($event){return _vm.setStep(1)},"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.back))]),_vm._v(" "),_c('a',{staticClass:"vicp-operate-btn",on:{"click":_vm.prepareUpload,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.save))])])]):_vm._e(),_vm._v(" "),(_vm.step == 3)?_c('div',{staticClass:"vicp-step3"},[_c('div',{staticClass:"vicp-upload"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 1),expression:"loading === 1"}],staticClass:"vicp-loading"},[_vm._v(_vm._s(_vm.lang.loading))]),_vm._v(" "),_c('div',{staticClass:"vicp-progress-wrap"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 1),expression:"loading === 1"}],staticClass:"vicp-progress",style:(_vm.progressStyle)})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasError),expression:"hasError"}],staticClass:"vicp-error"},[_c('i',{staticClass:"vicp-icon2"}),_vm._v(" "+_vm._s(_vm.errorMsg)+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading === 2),expression:"loading === 2"}],staticClass:"vicp-success"},[_c('i',{staticClass:"vicp-icon3"}),_vm._v(" "+_vm._s(_vm.lang.success)+"\n\t\t\t\t")])]),_vm._v(" "),_c('div',{staticClass:"vicp-operate"},[_c('a',{on:{"click":function($event){return _vm.setStep(2)},"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.back))]),_vm._v(" "),_c('a',{on:{"click":_vm.off,"mousedown":_vm.ripple}},[_vm._v(_vm._s(_vm.lang.btn.close))])])]):_vm._e(),_vm._v(" "),_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"canvas",attrs:{"width":_vm.width,"height":_vm.height}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.employees")))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.dashboard")))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.employees")))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('employees.searchEmployeeInList'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployeesFromCardNoFast(_vm.searchText)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("employees.employeeList")))])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0),expression:"employeeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"945px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee1){return _c('tr',{key:employee1.id,class:_vm.employee.id == employee1.id ? 'bg-primary' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getEmployee(employee1.id)}}},[_c('td',[_vm._v(_vm._s(employee1.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("("+_vm._s(employee1.title)+")")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0),expression:"employeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get("employees.employeeSearchNotFound"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("employees.employeeInfo")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newEmployee()}}},[_c('i',{staticClass:"fa fa-user-plus"}),_vm._v("\n                "+_vm._s(_vm.$ml.get("employees.newEmployee"))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.saveEmployee'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"!isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.updateEmployee'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body box-profile"},[_c('img',{staticClass:"profile-user-img img-responsive",staticStyle:{"width":"100%"},attrs:{"src":(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.employee.image),expression:"this.tempUrl || this.employee.image"}],staticClass:"text-red mt-1",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.removePhoto'))+"\n                      ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":300,"height":300,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.selectPhoto'))+"\n                    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"profile-username text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.name != ''),expression:"employee.name != ''"}]},[_vm._v(_vm._s(_vm.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive == false),expression:"employee.isActive == false"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('employees.deletedRecord')))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.title != ''),expression:"employee.title != ''"}]},[_vm._v(_vm._s(_vm.employee.title))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null),expression:"employee.departmentId != null"}]},[_vm._v(_vm._s(_vm.getDepartmentFromId(_vm.employee.departmentId)))])]),_vm._v(" "),_c('hr',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null),expression:"employee.departmentId != null"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],staticClass:"row text-center",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.recordType')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('select',{staticClass:"form-control text-center",on:{"change":function($event){return _vm.changeRecordType($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":!_vm.employee.isStudent}},[_vm._v(_vm._s(_vm.$ml.get('employees.employee'))+"\n                          ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.isStudent}},[_vm._v(_vm._s(_vm.$ml.get('employees.student')))])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory && _vm.employee.isStudent),expression:"modules.dormitory && employee.isStudent"}],staticClass:"row text-center",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.employee.isStayInDormitory},on:{"change":function($event){_vm.employee.isStayInDormitory == true ? _vm.employee.isStayInDormitory = false : _vm.employee.isStayInDormitory = true}}}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.employee.isStayInDormitory ? _vm.$ml.get('employees.doesStayInTheDormitory') : _vm.$ml.get('employees.doesNotStayInTheDormitory'))}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"row text-center",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.employee.foodClaim},on:{"change":function($event){_vm.employee.foodClaim == true ? _vm.employee.foodClaim = false : _vm.employee.foodClaim = true}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("employees.foodClaim")))])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.registrationNumber')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('a',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo == ''),expression:"employee.sicilNo == ''"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo != ''),expression:"employee.sicilNo != ''"}]},[_vm._v(_vm._s(_vm.employee.sicilNo))])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('b',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isStudent),expression:"!employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.dateOfStartWork')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isStudent),expression:"employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.dateOfStart')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('a',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate == null),expression:"employee.startDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate != ''),expression:"employee.startDate != ''"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.startDate,"gg.aa.yyyy")))])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('b',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isStudent),expression:"!employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.dateOfEndWork')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isStudent),expression:"employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.dateOfEnd')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center"},[_c('a',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.endDate == null),expression:"employee.endDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.endDate != '' || _vm.employee.endDate != null),expression:"employee.endDate != '' || employee.endDate != null"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.endDate,"gg.aa.yyyy")))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory && _vm.employee.isStudent && _vm.employee.isStayInDormitory),expression:"modules.dormitory && employee.isStudent && employee.isStayInDormitory"}],staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.roomInformation')))])])]),_vm._v(" "),_c('div',{class:_vm.employee.roomId ? 'col-sm-12 text-center' : 'col-sm-12 text-center',staticStyle:{"margin-left":"10px"}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.roomId == 0 || _vm.employee.roomId == null),expression:"employee.roomId == 0 || employee.roomId == null"}]},[_vm._v("-")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.roomId != 0 && _vm.employee.roomId != null),expression:"employee.roomId != 0 && employee.roomId != null"}]},[_c('i',{staticClass:"fa fa-building"}),_vm._v("\n                          : "+_vm._s(_vm.employee.areaName)+"\n                          "),_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-th"}),_vm._v("\n                          : "+_vm._s(_vm.employee.floorName)+"\n                          "),_c('br'),_vm._v(" "),_c('i',{staticClass:"fa fa-home"}),_vm._v("\n                          : "+_vm._s(_vm.employee.roomName)+"\n                          "),_c('br')])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('div',{staticClass:"justify-between-content text-center"},[_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasPassword ? _vm.$ml.get('employees.passwordExist') : _vm.$ml.get('employees.passwordNotExist'),"src":_vm.employee.hasPassword ? '/src/assets/password-true.png' : '/src/assets/password-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasCard ? _vm.$ml.get('employees.cardNumberExist') : _vm.$ml.get('employees.cardNumberNotExist'),"src":_vm.employee.hasCard ? '/src/assets/card-true.png' : '/src/assets/card-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasFinger ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist'),"src":_vm.employee.hasFinger ? '/src/assets/fingerprint-true.png' : '/src/assets/fingerprint-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasFace ? _vm.$ml.get('employees.faceTemplateExist') : _vm.$ml.get('employees.faceTemplateNotExist'),"src":_vm.employee.hasFace ? '/src/assets/face-true.png' : '/src/assets/face-false.png'}})])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1},on:{"click":function($event){return _vm.selectGetFingerFromUsb()}}},[_c('i',{staticClass:"fa fa-hand-o-up"}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('employees.fingerPrintInformation'))+"\n                        ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-sm btn-danger",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-istencikis"}},[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('employees.setLeaveDate'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center",staticStyle:{"margin-top":"10px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.endDate != null),expression:"employee.endDate != null"}],staticClass:"btn btn-sm btn-warning",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button"},on:{"click":function($event){return _vm.removeLeaveEmployee()}}},[_c('i',{staticClass:"fa fa-sign-in"}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isStudent),expression:"!employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.backToWork')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isStudent),expression:"employee.isStudent"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.reActivate')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-center",staticStyle:{"margin-top":"10px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"!isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","value":"Sil","data-toggle":"modal","data-target":"#modal-sil"}},[_c('i',{staticClass:"fa fa-user-times"}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('employees.deleteEmployee'))+"\n                        ")])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#temel-bilgiler","data-toggle":"tab","aria-expanded":"true"}},[_c('span',{domProps:{"textContent":_vm._s(_vm.employee.isStudent ? _vm.$ml.get('employees.studentInformation') : _vm.$ml.get('employees.generalInformation'))}})])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#gruplamalar","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.extraFields')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#mobil-gecis","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.mobileApp')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}]},[_c('a',{attrs:{"href":"#diger-bilgileri","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.otherInformation')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#yetkiler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.accessAuthorities')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hareketler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.movements')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}]},[_c('a',{attrs:{"href":"#izinler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.allowences')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll && !_vm.employee.isVisitor),expression:"modules.payroll && !employee.isVisitor"}]},[_c('a',{attrs:{"href":"#puantaj","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.payroll')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.annualPermit && !_vm.employee.isVisitor),expression:"modules.annualPermit && !employee.isVisitor"}]},[_c('a',{attrs:{"href":"#yillik-izin","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.annualPermit')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor && !_vm.employee.isStudent),expression:"!employee.isVisitor && !employee.isStudent"}]},[_c('a',{attrs:{"href":"#salary","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.salary')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}]},[_c('a',{attrs:{"href":"#odemeler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.payments')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#gorev-yerleri","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaces')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#documents","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.documents')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#inventories","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.assignedInventory')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#islem-gecmisi","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.employeeLogs')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#kart-baski","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('employees.cardPrinting')))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"temel-bilgiler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.registrationNumberInfo')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.sicilNo),expression:"employee.sicilNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.sicilNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "sicilNo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getNewSicilveTerminalNo()}}},[_c('i',{staticClass:"fa fa-refresh"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.citizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.identityNo),expression:"employee.identityNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "identityNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isVisitor),expression:"employee.isVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.cardName')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.nameSurname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.name),expression:"employee.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.department')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null && _vm.employee.departmentId != 0),expression:"employee.departmentId != null && employee.departmentId != 0"}],staticClass:"form-control tdb-box",attrs:{"id":"selectedNode"},on:{"click":function($event){return _vm.selectNode()}}},[_vm._v(_vm._s(_vm.getDepartmentFromId(_vm.employee.departmentId)))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId == null || _vm.employee.departmentId == 0),expression:"employee.departmentId == null || employee.departmentId == 0"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null && _vm.employee.departmentId != ''),expression:"employee.departmentId != null && employee.departmentId != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){_vm.employee.departmentId = null}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.title),expression:"employee.title"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "title", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.dateofBirth')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.birthDayDate),expression:"employee.birthDayDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employee.birthDayDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "birthDayDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.status')))]),_vm._v(" "),_c('div',{class:_vm.authControl == 0 ? 'input-group' : 'form-group'},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeStatus($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.statuId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                                ")]),_vm._v(" "),_vm._l((_vm.statuList),function(statu){return _c('option',{key:statu.id,domProps:{"value":statu.id,"selected":statu.id == _vm.employee.statuId}},[_vm._v(_vm._s(statu.name))])})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"input-group-btn"},[_vm._m(3)])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.employee.isStudent ? _vm.$ml.get('employees.dateOfStart') : _vm.$ml.get('employees.dateOfStartWorkInfo'))}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.startDate),expression:"employee.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employee.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "startDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.state')))]),_vm._v(" "),_c('div',{class:_vm.authControl == 0 ? 'input-group' : 'form-group'},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeStates($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.stateId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                                ")]),_vm._v(" "),_vm._l((_vm.stateList),function(state){return _c('option',{key:state.id,domProps:{"value":state.id,"selected":state.id == _vm.employee.stateId}},[_vm._v(_vm._s(state.name))])})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"input-group-btn"},[_vm._m(4)])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.stateNote')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.stateNote),expression:"employee.stateNote"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.stateNote)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "stateNote", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.smsOrMail && _vm.employee.isStudent),expression:"modules.smsOrMail && employee.isStudent"}],staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.activateSmsSystem')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.employee.isSmsSend},on:{"change":function($event){_vm.employee.isSmsSend == true ? _vm.employee.isSmsSend = false : _vm.employee.isSmsSend = true}}}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('general.active'))+"\n                              ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.smsOrMail && _vm.employee.isStudent),expression:"modules.smsOrMail && employee.isStudent"}],staticClass:"col-sm-6 col-md-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.smsSendPhone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.parentPhone),expression:"employee.parentPhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.parentPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "parentPhone", $event.target.value)}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.deviceEmployeeNumber')))]),_vm._v(" "),(_vm.modules.isDisabledTerminalNo)?_c('label',{staticClass:"form-control",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.employee.terminalNo))]):_vm._e(),_vm._v(" "),(!_vm.modules.isDisabledTerminalNo)?_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.terminalNo),expression:"employee.terminalNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.employee.terminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "terminalNo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getNewSicilveTerminalNo()}}},[_c('i',{staticClass:"fa fa-refresh"})])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.deviceStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeTerminalStatu($event)}}},[_c('option',{domProps:{"selected":_vm.employee.terminalStatu == 0,"value":0}},[_vm._v("User")]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.employee.terminalStatu == 3,"value":3}},[_vm._v("Admin")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.devicePassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.terminalPassword),expression:"employee.terminalPassword"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.terminalPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "terminalPassword", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.deviceCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.cardNo),expression:"employee.cardNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.cardNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "cardNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.timezone),expression:"modules.timezone"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v("Timezone")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.tzCode),expression:"employee.tzCode"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.tzCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "tzCode", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition && _vm.modules.plate),expression:"modules.licencePlateRecognition && modules.plate"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.plateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.plateNo),expression:"employee.plateNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition && _vm.modules.hgs),expression:"modules.licencePlateRecognition && modules.hgs"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.hgsNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.hgsNo),expression:"employee.hgsNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.hgsNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "hgsNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.memberManagement),expression:"modules.memberManagement"}],staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.validityStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.validityStartDate),expression:"employee.validityStartDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employee.validityStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "validityStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.validityEndDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.validityEndDate),expression:"employee.validityEndDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employee.validityEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "validityEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isStudent),expression:"!employee.isStudent"}],class:!_vm.modules.diningHall ? 'col-sm-12' : 'col-sm-6'},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlan')))]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeWorkGroups($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.workGroupId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_vm._l((_vm.periodWorkGroupList),function(workGroup){return _c('option',{key:workGroup.id,domProps:{"value":workGroup.id,"selected":workGroup.id == _vm.employee.workGroupId}},[_vm._v("\n                                "+_vm._s(workGroup.name))])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.foodGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFoodGroup($event)}}},[_c('option',{domProps:{"selected":_vm.employee.foodGroupId == 0,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_vm._l((_vm.foodGroupList),function(foodGroup){return _c('option',{key:foodGroup.id,domProps:{"selected":_vm.employee.foodGroupId == foodGroup.id,"value":foodGroup.id}},[_vm._v("\n                                "+_vm._s(foodGroup.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.customFieldName == ''),expression:"modules.customFieldName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.documentNo')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.customFieldName != ''),expression:"modules.customFieldName != ''"}]},[_vm._v(_vm._s(_vm.modules.customFieldName))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.documentNo),expression:"employee.documentNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.documentNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "documentNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isStudent),expression:"!employee.isStudent"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimeStatus')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.employee.overWorkStatus},on:{"change":function($event){_vm.employee.overWorkStatus == true ? _vm.employee.overWorkStatus = false : _vm.employee.overWorkStatus = true}}}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.takesOvertime'))+"\n                              ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isStudent),expression:"employee.isStudent"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.motherName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.motherName),expression:"employee.motherName"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.motherName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "motherName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.motherPhone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.motherPhone),expression:"employee.motherPhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.motherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "motherPhone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.fatherName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.fatherName),expression:"employee.fatherName"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.fatherName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "fatherName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.fatherPhone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.fatherPhone),expression:"employee.fatherPhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.fatherPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "fatherPhone", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"gruplamalar"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.extraFields')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1},on:{"click":function($event){return _vm.newExtraField()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.createExtraField'))+"\n                              ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"color":"black"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('employees.keyExtraField')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeExtraFieldKey($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.extraFieldKey == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                                  ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(ef){return _c('option',{key:ef.id,domProps:{"value":ef.id,"selected":ef.id == _vm.extraFieldKey}},[_vm._v(_vm._s(ef.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('employees.valueExtraField')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.extraFieldValue),expression:"extraFieldValue"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.extraFieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.extraFieldValue=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3",staticStyle:{"margin-bottom":"10px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-success",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1},on:{"click":function($event){return _vm.saveExtraField()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.saveExtraField'))+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeExtraFieldList.length > 0),expression:"employeeExtraFieldList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.employeeExtraFieldList),function(employeeExtraField,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm.getExtraFieldNameFromKey(employeeExtraField.key)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employeeExtraField.value))]),_vm._v(" "),_c('td',{staticStyle:{"width":"40px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.selectExtraField(employeeExtraField.id, employeeExtraField.value, employeeExtraField.key)}}},[_c('i',{staticClass:"fa fa-search"})])]),_vm._v(" "),_c('td',{staticStyle:{"width":"40px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.deleteExtraField(employeeExtraField.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeExtraFieldList.length == 0),expression:"employeeExtraFieldList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.extraFieldNotRecord'))+"\n                              ")])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.mobileApp && !_vm.employee.isVisitor),expression:"modules.mobileApp && !employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"mobil-gecis"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.isMobileAppUser')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.employee.isMobileUser},on:{"change":function($event){_vm.employee.isMobileUser == true ? _vm.employee.isMobileUser = false : _vm.employee.isMobileUser = true}}}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.isMobileAppUser'))+"\n                              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderMode')))]),_vm._v(" "),_c('select',{staticClass:"form-control"},[_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeAll')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeOnlyQRCreate')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeOnlyQRRead')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeOnlyWithButton')))]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeQRCreateAndRead')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeQRReadAndButton')))]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v(_vm._s(_vm.$ml.get('employees.qrReaderModeQRCreateAndButton')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.mobileNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.mobilePhone),expression:"employee.mobilePhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "mobilePhone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.mobileAppPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.mobilePassword),expression:"employee.mobilePassword"}],staticClass:"form-control",attrs:{"disabled":!_vm.employee.isMobileUser,"type":"password","autocomplete":"off"},domProps:{"value":(_vm.employee.mobilePassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "mobilePassword", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.mobileBrand')))]),_vm._v(" "),(_vm.employee.mobileUuid)?_c('label',{staticClass:"form-control"},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.employee.mobileBrand ? _vm.employee.mobileBrand : _vm.$ml.get('employees.unknown'))}})]):_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('employees.notPaired')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[(_vm.authControl == 0)?_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%","margin-top":"20px"},attrs:{"disabled":!_vm.employee.isMobileUser || !_vm.employee.mobileUuid},on:{"click":function($event){return _vm.removePhonePair()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$ml.get('employees.resetPairing')))]):_vm._e()])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"diger-bilgileri"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.mail),expression:"employee.mail"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "mail", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.mobileNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.mobilePhone),expression:"employee.mobilePhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "mobilePhone", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.address')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.address),expression:"employee.address"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "address", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.internal')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.internalPhone),expression:"employee.internalPhone"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.internalPhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "internalPhone", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.homePhone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.homePhone),expression:"employee.homePhone"}],staticClass:"form-control",attrs:{"type":"tel","autocomplete":"off"},domProps:{"value":(_vm.employee.homePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "homePhone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.gender')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeGender($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.gender == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.employee.gender == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.male'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.gender == 2}},[_vm._v(_vm._s(_vm.$ml.get('employees.female'))+"\n                              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.educationStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeEducationStatus($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.educationStatus == 0}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.employee.educationStatus == 1}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.primarySchool')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.educationStatus == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.highSchool')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.employee.educationStatus == 3}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.associateDegree')))]),_vm._v(" "),_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.employee.educationStatus == 4}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.bachelorDegree')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"},domProps:{"selected":_vm.employee.educationStatus == 5}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.postGraduate')))]),_vm._v(" "),_c('option',{attrs:{"value":"6"},domProps:{"selected":_vm.employee.educationStatus == 6}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.doctorate')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.militaryStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMilitaryStatus($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.militaryStatus == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.employee.militaryStatus == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.done'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.militaryStatus == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.exempt')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.smokingStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeSmokeStatus($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.smokeStatus == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.employee.smokeStatus == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.smoking'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.smokeStatus == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.notSmoking')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.maritalStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMaritalStatus($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.maritalStatus == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.employee.maritalStatus == 1}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.single')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.maritalStatus == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.married')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.employee.maritalStatus == 3}},[_vm._v(_vm._s(_vm.$ml.get('employees.widow'))+"\n                              ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.drivingLicence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.drivingLicence),expression:"employee.drivingLicence"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.drivingLicence)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "drivingLicence", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.foreignLanguage')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.foreignLanguage),expression:"employee.foreignLanguage"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.foreignLanguage)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "foreignLanguage", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.bloodType')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.bloodType),expression:"employee.bloodType"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.bloodType)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "bloodType", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.height')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.height),expression:"employee.height"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "height", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.weight')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.weight),expression:"employee.weight"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.weight)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "weight", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.disabledPercent')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.disabledPercent),expression:"employee.disabledPercent"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.disabledPercent)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "disabledPercent", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.authorizedPerson1')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.getEmpNameFromId(_vm.employee.authorizedPerson1))}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-kisi-sec","type":"button"},on:{"click":function($event){_vm.selectAP = 1}}},[_c('i',{staticClass:"fa fa-search"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.authorizedPerson2')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.getEmpNameFromId(_vm.employee.authorizedPerson2))}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kisi-sec"},on:{"click":function($event){_vm.selectAP = 2}}},[_c('i',{staticClass:"fa fa-search"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.note1')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.note1),expression:"employee.note1"}],staticClass:"form-control",attrs:{"rows":"2","cols":"20","autocomplete":"off"},domProps:{"value":(_vm.employee.note1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "note1", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.note2')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.note2),expression:"employee.note2"}],staticClass:"form-control",attrs:{"rows":"2","cols":"20","autocomplete":"off"},domProps:{"value":(_vm.employee.note2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "note2", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"yetkiler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.accessAuthoritiesInfo')))]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeAccessGroups($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.accessGroupId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                              ")]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(acc){return _c('option',{key:acc.id,domProps:{"value":acc.id,"selected":acc.id == _vm.employee.accessGroupId}},[_vm._v(_vm._s(acc.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-sm btn-primary",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1},on:{"click":function($event){return _vm.sendUserToDevices()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('employees.sendPersontoDevices'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.deviceList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowACHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.activeReaderList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.readerNo)+" - "+_vm._s(reader.name))]),_vm._v(" "),_c('td',{staticClass:"checkbox"},[(_vm.employee.isActive != false && !_vm.isNewEmployee)?_c('div',{staticClass:"pull-right"},[_vm._m(5,true),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.sendUserToDevice(reader.readerId)}}},[_vm._v(_vm._s(_vm.$ml.get('employees.sendToReader')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.selectGetFingerFromTerminal(reader.readerId)}}},[_vm._v(_vm._s(_vm.$ml.get('employees.getFingerprint')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.SendGetFaceCommand(reader.readerId)}}},[_vm._v(_vm._s(_vm.$ml.get('employees.getFaceTemplate')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){return _vm.GetUserDataFromDevice(reader.readerId)}}},[_vm._v(_vm._s(_vm.$ml.get('employees.getUserData')))])])])]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('employees.deviceNotRecord'))+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"hareketler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.movements')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0 && _vm.authControl == 0),expression:"inOutList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFHareketler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),(_vm.employee.isActive != false && _vm.modules.saveMovementLog)?_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-hareket-ekle"},on:{"click":function($event){return _vm.newInOut()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.newMovement'))+"\n                                  ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_vm._m(6),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutListDoorType($event)}}},[_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.inOut.inOutListDoorType == 4}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.allDoors')))]),_vm._v(" "),_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut.inOutListDoorType == 0}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.access')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.inOut.inOutListDoorType == 1}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.pdks')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.inOut.inOutListDoorType == 2}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.diningHall')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.inOut.inOutListDoorType == 3}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.licencePlateRecognition')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"},domProps:{"selected":_vm.inOut.inOutListDoorType == 5}},[_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.dormitoryDevice')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center",staticStyle:{"margin-bottom":"5px"}},[_c('button',{class:_vm.inOut.inOutListType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(0)}}},[_c('i',{staticClass:"fa fa-square text-blue"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.all'))+"\n                                  ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(1)}}},[_c('i',{staticClass:"fa fa-square text-green"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.active'))+"\n                                  ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(2)}}},[_c('i',{staticClass:"fa fa-square text-red"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.passive'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.startDateMovements')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutStartDate),expression:"inOut.inOutStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.endDateMovements')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutEndDate),expression:"inOut.inOutEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isLoadingInOuts,"type":"button"},on:{"click":function($event){return _vm.getInOuts()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.searchMovements'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","owerflow":"auto"},attrs:{"id":"printHareketler"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+"\n                                      ("+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutStartDate,"gg.aa.yyyy ss:dd"))+" -\n                                      "+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.timeMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.deviceMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.statusMovement')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.inOutFiltered),function(inOut2){return _c('tr',{key:inOut2.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(inOut2.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId != 0),expression:"inOut2.readerId != 0"}]},[_vm._v(_vm._s(inOut2.readerName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId == 0),expression:"inOut2.readerId == 0"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.manuelMovement')))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut != 2),expression:"inOut2.inOrOut != 2"}],staticClass:"label btn-success"},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut == 2),expression:"inOut2.inOrOut == 2"}],staticClass:"label btn-danger"},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement')))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!inOut2.isActive),expression:"!inOut2.isActive"}],staticClass:"badge"},[_vm._v(_vm._s(_vm.$ml.get('employees.passive')))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0 && inOut2.positionX != '' && inOut2.positionY != '' && inOut2.positionX && inOut2.positionY),expression:"employee.isActive != false && authControl == 0 && inOut2.positionX != '' && inOut2.positionY != '' && inOut2.positionX && inOut2.positionY"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-konum"},on:{"click":function($event){return _vm.selectInOut(inOut2.id)}}},[_c('i',{staticClass:"fa fa-eye"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-hareket-ekle"},on:{"click":function($event){return _vm.selectInOut(inOut2.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteInOut(inOut2.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length == 0),expression:"inOutList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('employees.movementNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingInOuts}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"izinler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.allowences')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceForEmployeeList.length > 0 && _vm.authControl == 0),expression:"allowenceForEmployeeList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFIzinler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-danger btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-izin-sil"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.removeAllowence'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-izin-ekle"},on:{"click":function($event){return _vm.newAllowence()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.newAllowence'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.startDateAllowences')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.searchStartDate),expression:"allowence.searchStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.searchStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "searchStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.endDateAllowences')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.searchEndDate),expression:"allowence.searchEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.searchEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "searchEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"type":"button","disabled":_vm.isLoadingAllowence},on:{"click":function($event){return _vm.getAllowenceForEmployee()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.searchAllowences'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceForEmployeeList.length > 0),expression:"allowenceForEmployeeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printIzinler"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceForEmployeeList.length > 0),expression:"allowenceForEmployeeList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" -\n                                      "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(this.allowence.searchStartDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.allowence.searchEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.startAllowence')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.endAllowence')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"60px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.codeAllowence')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.nameAllowence')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.allowenceForEmployeeList),function(allowence2){return _c('tr',{key:allowence2.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(allowence2.startDate,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(allowence2.endDate,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"label btn-primary"},[_vm._v(_vm._s(allowence2.shortCode))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allowence2.name))]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-izin-ekle"},on:{"click":function($event){return _vm.selectAllowence(allowence2.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteAllowence(allowence2.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceForEmployeeList.length == 0),expression:"allowenceForEmployeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('employees.allowenceNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingAllowence}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"puantaj"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.payroll')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.EmpPayrollList.length > 0 && _vm.authControl == 0),expression:"EmpPayrollList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFPuantaj()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee,"type":"button"},on:{"click":function($event){return _vm.getCalculatePayrolls()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.recalculate'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.startDatePayrolls')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPayrollStartDate),expression:"searchPayrollStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.searchPayrollStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchPayrollStartDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.endDatePayrolls')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchPayrollEndDate),expression:"searchPayrollEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.searchPayrollEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchPayrollEndDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isLoadingPayrolls,"type":"button"},on:{"click":function($event){return _vm.getEmpPayrolls()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.searchPayrolls'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.EmpPayrollList.length > 0),expression:"EmpPayrollList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","owerflow":"auto"},attrs:{"id":"printPuantaj"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.EmpPayrollList.length > 0),expression:"EmpPayrollList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+"\n                                      ("+_vm._s(_vm._f("toDateFormatGet")(this.searchPayrollStartDate,"gg.aa.yyyy ss:dd"))+" -\n                                      "+_vm._s(_vm._f("toDateFormatGet")(this.searchPayrollEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"90px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.datePayroll')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlanPayroll')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px","text-align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('employees.firstEntry'))+"\n                                        ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"80px","text-align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('employees.lastExit'))+"\n                                        ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('employees.calculatedOvertime'))+"\n                                        ")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('employees.confirmedOvertime'))+"\n                                        ")]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.EmpPayrollList),function(empPayroll,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(empPayroll.date))]),_vm._v(" "),_c('td',[_c('a',{attrs:{"href":"","data-target":"#changePayroll","data-toggle":"modal"},on:{"click":function($event){return _vm.changePayroll(empPayroll)}}},[_vm._v(_vm._s(empPayroll.workPlan))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(empPayroll.firstEntry))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(empPayroll.lastOut))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(empPayroll.calculatedOverTime))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(empPayroll.confirmedOverTime))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right","white-space":"nowrap"}},[_c('button',{staticClass:"btn btn-xs btn-primary",attrs:{"data-toggle":"modal","data-target":"#puantaj-detay","type":"button"},on:{"click":function($event){return _vm.getDailyPayrollDetails(empPayroll.date, empPayroll.workPlan)}}},[_c('i',{staticClass:"fa fa-eye"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-xs btn-success",attrs:{"disabled":empPayroll.overTimeId == 0,"data-toggle":"modal","data-target":"#modal-confirm-overtime","title":_vm.$ml.get('employees.confirmTheCalculated'),"type":"button"},on:{"click":function($event){return _vm.getDailyPayrollDetails(empPayroll.date, empPayroll.workPlan)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"disabled":empPayroll.overTimeId == 0,"data-toggle":"tooltip","data-placement":"bottom","title":_vm.$ml.get('employees.deleteTheConfirmed'),"type":"button"},on:{"click":function($event){return _vm.deleteOverTime(empPayroll.overTimeId)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.EmpPayrollList.length == 0),expression:"EmpPayrollList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('employees.payrollNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingPayrolls}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"yillik-izin"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.annualPermitGroups')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeAnnualPermit($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.employee.annualPermitId == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.annualPermitList),function(annualPermit){return _c('option',{key:annualPermit.id,domProps:{"value":annualPermit.id,"selected":annualPermit.id == _vm.employee.annualPermitId}},[_vm._v("\n                              "+_vm._s(annualPermit.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.seniority')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.annualPermitSeniority),expression:"employee.annualPermitSeniority"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.employee.annualPermitSeniority)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "annualPermitSeniority", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.transfer')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.annualPermitTransfer),expression:"employee.annualPermitTransfer"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.employee.annualPermitTransfer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "annualPermitTransfer", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.remaining')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.employee.annualPermitRemain))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('employees.deservedAnnualPermits'))+" : "+_vm._s(_vm.employee.annualPermitClaim))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitClaimsDateList.length > 0),expression:"annualPermitClaimsDateList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.deservedDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.deservedDay')))])]),_vm._v(" "),_vm._l((_vm.annualPermitClaimsDateList),function(aPCD,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(aPCD.tarih2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(aPCD.yillikIzin))])])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitClaimsDateList.length == 0),expression:"annualPermitClaimsDateList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('employees.annualPermitNotRecord'))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('employees.usedAnnualPermits'))+" : "+_vm._s(_vm.employee.annualPermitUsed))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitDetailList.length > 0),expression:"annualPermitDetailList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.annualPermitDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.annualPermitName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.annualPermitDescription')))])]),_vm._v(" "),_vm._l((_vm.annualPermitDetailList),function(aPD,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(aPD.izinBaslangic))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(aPD.izinadi))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(aPD.aciklama))])])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitDetailList.length == 0),expression:"annualPermitDetailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('employees.usedAnnualPermitNotRecord'))+"\n                            ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor && !_vm.employee.isStudent),expression:"!employee.isVisitor && !employee.isStudent"}],staticClass:"tab-pane",attrs:{"id":"salary"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.salary')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length > 0 && _vm.authControl == 0),expression:"paymentForEmployeeList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFOdemeler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-salary"},on:{"click":function($event){return _vm.newSalary()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.newSalary'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.salaryForEmployeeList.length > 0),expression:"salaryForEmployeeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printSalary"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.salaryForEmployeeList.length > 0),expression:"salaryForEmployeeList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" -\n                                      "+_vm._s(_vm.employee.name))])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.salary')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.updateTime')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.salaryForEmployeeList),function(salary){return _c('tr',{key:salary.id},[_c('td',[_vm._v(_vm._s(_vm._f("toCurrency")(salary.salary)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(salary.updateTime,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-salary"},on:{"click":function($event){return _vm.selectSalary(salary)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteSalary(salary.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.salaryForEmployeeList.length == 0),expression:"salaryForEmployeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingSalary}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"odemeler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.payments')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-odemeler"}},[_c('i',{staticClass:"fa fa-money"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.paymentDefinitions'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length > 0 && _vm.authControl == 0),expression:"paymentForEmployeeList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFOdemeler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-odeme-ekle"},on:{"click":function($event){return _vm.newPayment()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.newPayment'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.startDatePayments')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.searchStartDate),expression:"payment.searchStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.payment.searchStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "searchStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.endDatePayments')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.searchEndDate),expression:"payment.searchEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.payment.searchEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "searchEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"type":"button","disabled":_vm.isLoadingPayment},on:{"click":function($event){return _vm.getPaymentForEmployee()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.searchPayments'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length > 0),expression:"paymentForEmployeeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printOdemeler"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length > 0),expression:"paymentForEmployeeList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" -\n                                      "+_vm._s(_vm.employee.name)+"\n                                      ("+_vm._s(_vm._f("toDateFormatGet")(this.payment.searchStartDate,"gg.aa.yyyy ss:dd"))+" -\n                                      "+_vm._s(_vm._f("toDateFormatGet")(this.payment.searchEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.timePayment')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.namePayment')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.amountPayment')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.statusPayment')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.paymentForEmployeeList),function(payment2){return _c('tr',{key:payment2.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(payment2.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(payment2.paymentName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toCurrency")(payment2.price)))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(payment2.status == 1),expression:"payment2.status == 1"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addedSalary')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(payment2.status == 2),expression:"payment2.status == 2"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.decreaseFromSalary')))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-odeme-ekle"},on:{"click":function($event){return _vm.selectPayment(payment2.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletePayment(payment2.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length == 0),expression:"paymentForEmployeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('employees.paymentNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingPayment}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.employee.isVisitor),expression:"!employee.isVisitor"}],staticClass:"tab-pane",attrs:{"id":"gorev-yerleri"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaces')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.authControl == 1,"tag":"button","to":"/work-place-definitions"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.workPlaceDefinitions'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentForEmployeeList.length > 0 && _vm.authControl == 0),expression:"paymentForEmployeeList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFWorkPlaces()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-work-place"},on:{"click":function($event){return _vm.newWorkPlace()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.newWorkPlace'))+"\n                                  ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workPlaceList.length > 0),expression:"workPlaceList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printWorkPlaces"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.workPlaceList.length > 0),expression:"workPlaceList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" -\n                                      "+_vm._s(_vm.employee.name))])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.workPlace')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceDescription')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceStartDate')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceEndDate')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.workPlaceList),function(workPlace){return _c('tr',{key:workPlace.id},[_c('td',[_vm._v(_vm._s(_vm.getWorkPlaceFromId(workPlace.workplaceId)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(workPlace.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(workPlace.startDate,"gg.aa.yyyy")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(workPlace.endDate,"gg.aa.yyyy")))]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-work-place"},on:{"click":function($event){return _vm.selectWorkPlace(workPlace)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteWorkPlace(workPlace.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workPlaceList.length == 0),expression:"workPlaceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingWorkPlace}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"inventories"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.assignedInventory')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventoryList.length > 0 && _vm.authControl == 0),expression:"employeeInventoryList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFInventory()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-inventory"},on:{"click":function($event){return _vm.newInventory()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.addInventory'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventoryList.length > 0),expression:"employeeInventoryList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printInventory"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventoryList.length > 0),expression:"employeeInventoryList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name))])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryQuantity')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryDescription')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.deliveryDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.takenDate')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((_vm.employeeInventoryList),function(employeeInventory){return _c('tr',{key:employeeInventory.id},[_c('td',[_vm._v(_vm._s(_vm.getInventoryFromId(employeeInventory.inventoryId).name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employeeInventory.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employeeInventory.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(employeeInventory.deliveryDate,"gg.aa.yyyy ss:dd"))+"\n                                        ")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(employeeInventory.takenDate == null),expression:"employeeInventory.takenDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employeeInventory.takenDate != null),expression:"employeeInventory.takenDate != null"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(employeeInventory.takenDate,"gg.aa.yyyy ss:dd")))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-primary",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-inventory-details"},on:{"click":function($event){return _vm.selectInventory(employeeInventory)}}},[_c('i',{staticClass:"fa fa-eye"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventoryList.length == 0),expression:"employeeInventoryList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingInventory}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"documents"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.documents')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('router-link',{staticClass:"btn btn-primary btn-sm",attrs:{"disabled":_vm.authControl == 1,"tag":"button","to":"/document-definitions"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('shared.documentDefinitions'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button"},on:{"click":function($event){return _vm.newDocument()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.addDocument'))+"\n                                  ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.documentType')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.documentDescription')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.validityStartDate')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.validityEndDate')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.documentList),function(document){return _c('tr',{key:document.id},[_c('td',[_vm._v(_vm._s(_vm.getDocumentDefinitionName(document.documentDefinitionId)))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(document.isISGDocument),expression:"document.isISGDocument"}],staticClass:"badge label-success"},[_c('i',{staticClass:"fa fa-check-circle"}),_vm._v(" İSG")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(document.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(document.starDate,'gg.aa.yyyy')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(document.endDate,'gg.aa.yyyy')))]),_vm._v(" "),_c('td',[(document.filePath)?_c('a',{staticClass:"btn btn-success btn-sm",attrs:{"href":document.filePath,"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Dosya\n                                            İndir\n                                          ")]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"90px"}},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getDocument(document)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.deleteDocument(document.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),(_vm.employee.id != null && _vm.documentList.length == 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.recordNotFound')))])])]):_vm._e(),_vm._v(" "),(_vm.employee.id == null)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.pleaseSelect')))])])]):_vm._e()],2)])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingInventory}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"islem-gecmisi"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.employeeLogs')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0 && _vm.authControl == 0),expression:"logList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFLogs()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.startDateLogs')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logStartDate),expression:"logStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.logStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logStartDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.endDateLogs')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logEndDate),expression:"logEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.logEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logEndDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isNewEmployee && _vm.isLoadingLogs,"type":"button"},on:{"click":function($event){return _vm.getLogs()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.searchLogs'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"550px","owerflow":"auto"},attrs:{"id":"printLogs"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+"\n                                      ("+_vm._s(_vm._f("toDateFormatGet")(this.logStartDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.logEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm.$ml.get('employees.timeLog')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.descriptionLog')))])]),_vm._v(" "),_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(log.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.description))])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('employees.logNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingLogs}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"kart-baski"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.cardPrinting')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFCard()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Baskı Tipi")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"btn-group text-center"},[_c('button',{class:!_vm.isDoubleSidedPrint ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){_vm.isDoubleSidedPrint = false}}},[_c('i',{staticClass:"fa fa-id-card-o"}),_vm._v(" Tek Yüze Baskı\n                                        ")]),_vm._v(" "),_c('button',{class:_vm.isDoubleSidedPrint ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){_vm.isDoubleSidedPrint = true}}},[_c('i',{staticClass:"fa fa-id-card"}),_vm._v(" Çift Yüze Baskı\n                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Ön Yüz - "+_vm._s(_vm.$ml.get('employees.selectTemplate')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCardDesign($event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.cardDesignList),function(cardDesign){return _c('option',{key:cardDesign.id,domProps:{"value":cardDesign.id}},[_vm._v(_vm._s(cardDesign.name))])})],2)]),_vm._v(" "),(_vm.isDoubleSidedPrint)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Arka Yüz - "+_vm._s(_vm.$ml.get('employees.selectTemplate')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCardDesign2($event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.cardDesignList),function(cardDesign){return _c('option',{key:cardDesign.id,domProps:{"value":cardDesign.id}},[_vm._v(_vm._s(cardDesign.name))])})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row text-center"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{attrs:{"id":"printCards"}},[_c('div',{attrs:{"id":"printCard"}},[_c('div',{style:('width: 347px;height: 221px;border-radius: 10px;display: inline-block;position: relative;background-color:' + _vm.cardDesign.backgroundColor + ';background-image:url(' + _vm.cardDesign.backgroundImage + ');background-size:cover;')},[_vm._l((_vm.cardImageItems),function(item1){return _c('img',{key:item1.id,style:(_vm.imageItemStyle(item1)),attrs:{"src":_vm.employee.image ? _vm.employee.image : '/src/assets/default-user.png'}})}),_vm._v(" "),_vm._l((_vm.cardLabelItems),function(item2){return _c('span',{key:item2.id,style:(_vm.itemStyle(item2))},[_vm._v(_vm._s(item2.text))])}),_vm._v(" "),_vm._l((_vm.cardValueItems),function(item3){return _c('span',{key:item3.id,style:(_vm.itemStyle(item3))},[_vm._v(_vm._s(_vm.getValueTitle(item3.value)))])})],2)]),_vm._v(" "),(_vm.isDoubleSidedPrint)?_c('div',{attrs:{"id":"printCard2"}},[_c('div',{style:('width: 347px;height: 221px;border-radius: 10px;display: inline-block;position: relative;background-color:' + _vm.cardDesign2.backgroundColor + ';background-image:url(' + _vm.cardDesign2.backgroundImage + ');background-size:cover;')},[_vm._l((_vm.cardImageItems2),function(item1){return _c('img',{key:item1.id,style:(_vm.imageItemStyle(item1)),attrs:{"src":_vm.employee.image ? _vm.employee.image : '/src/assets/default-user.png'}})}),_vm._v(" "),_vm._l((_vm.cardLabelItems2),function(item2){return _c('span',{key:item2.id,style:(_vm.itemStyle(item2))},[_vm._v(_vm._s(item2.text))])}),_vm._v(" "),_vm._l((_vm.cardValueItems2),function(item3){return _c('span',{key:item3.id,style:(_vm.itemStyle(item3))},[_vm._v(_vm._s(_vm.getValueTitle(item3.value)))])})],2)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.exportToPDFCard()}}},[_vm._v(_vm._s(_vm.$ml.get('general.print')))])])])])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingLogs}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.saveEmployee'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"!isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.updateEmployee'))+"\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-xl fade",attrs:{"id":"modal-kisi-sec"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.selectEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('employees.searchFromNameSurname')},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length > 0),expression:"allEmployeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.employeeList')))])]),_vm._v(" "),_vm._l((_vm.allEmployeeFilteredList),function(employee3){return _c('tr',{key:employee3.id},[_c('td',[_vm._v("\n                          "+_vm._s(employee3.name)+"\n                          "),(employee3.title != '')?_c('span',[_vm._v("- "+_vm._s(employee3.title))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.selectAuthorizedEmployee(employee3.id)}}},[_c('i',{staticClass:"fa fa-check"})])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length == 0),expression:"allEmployeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('employees.employeeSearchNotFound'))+"\n                ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.updateEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.isContinueUpdateEmployee')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveEmployee()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.updateEmployee')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.saveEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.isContinueSaveEmployee')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveEmployee()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.saveEmployee')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.deleteEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.isContinueDeleteEmployee')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteEmployee()}}},[_c('i',{staticClass:"fa fa-user-times"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.deleteEmployee')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-istencikis"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.setLeaveDate')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.setLeaveDateInfo')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.endDate),expression:"employee.endDate"}],staticClass:"form-control",staticStyle:{"color":"black"},attrs:{"type":"date"},domProps:{"value":(_vm.employee.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.setLeaveEmployee()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modalRemoveValidity"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.removeValidityDate')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.validityEndDate'))+" : "+_vm._s(_vm._f("toDateFormatGet")(this.employee.validityEndDate,"gg.aa.yyyy")))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.isContinueRemoveValidityDate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.validityDateRemove()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.remove')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-warning fade",attrs:{"id":"modalCreateValidity"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.createValidityDate')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('p',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.createValidityDateDescription')))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.validityEndDate),expression:"employee.validityEndDate"}],staticClass:"form-control",staticStyle:{"color":"black"},attrs:{"type":"date"},domProps:{"value":(_vm.employee.validityEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "validityEndDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.employee.validityEndDate = null;}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.validityDateCreate()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"changePayroll"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.updateWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6",staticStyle:{"color":"black","padding":"0px 10px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"450px","owerflow":"auto","background-color":"#fff"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allowenceList),function(allowence,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(allowence.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.setChangePayroll(allowence.id, true)}}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.updateAllowenceNotRecord'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"color":"black","padding":"0px 10px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length > 0),expression:"workGroupList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"450px","owerflow":"auto","background-color":"#fff"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.workGroupList),function(workGroup,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(workGroup.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.setChangePayroll(workGroup.id, false)}}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.updateWorkPlanNotRecord'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployeesFromCardNo()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(16),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.modules.customFieldName == '')?_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]):_c('span',[_vm._v(_vm._s(_vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.modules.customFieldName != '' ? _vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail') : _vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(17),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(18),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(19),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(20),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(21),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-hareket-ekle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(22),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut),expression:"isNewInOut"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewInOut),expression:"!isNewInOut"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.editMovement')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.timeMovement')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutAdd),expression:"inOut.inOutAdd"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutAdd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutAdd", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typeMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.inOut.inOutType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.inOut.inOutType == 2}},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.readerMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutDoor($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.activeMovementReaderList),function(door){return _c('option',{key:door.readerId,domProps:{"value":door.readerId,"selected":door.readerId == _vm.inOut.readerId}},[_vm._v(_vm._s(door.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll),expression:"modules.payroll"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.includePassivesMovement')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.includePassiveMovements},on:{"change":function($event){_vm.includePassiveMovements == true ? _vm.includePassiveMovements = false : _vm.includePassiveMovements = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.includePassivesMovement'))+"\n                  ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll),expression:"modules.payroll"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.confirmedOvertimeNotDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.doNotDeleteOvertimes},on:{"change":function($event){_vm.doNotDeleteOvertimes == true ? _vm.doNotDeleteOvertimes = false : _vm.doNotDeleteOvertimes = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.confirmedOvertimeNotDeleted'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut),expression:"isNewInOut"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.addInOut()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewInOut),expression:"!isNewInOut"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.updateInOut()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-salary"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(23),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.salary.id),expression:"!salary.id"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addSalary')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.salary.id),expression:"salary.id"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.editSalary')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.salary')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.salary.salary),expression:"salary.salary"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.salary.salary)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.salary, "salary", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.salary.id),expression:"!salary.id"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.addSalary()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.salary.id),expression:"salary.id"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateSalary()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-odeme-ekle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(24),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewPayment),expression:"isNewPayment"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addPayment')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPayment),expression:"!isNewPayment"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.editPayment')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.timePayment')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.date),expression:"payment.date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.payment.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.amountPayment')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.payment.price),expression:"payment.price"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.payment.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.payment, "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typePayment')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePaymentForEmployee($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.payment.salaryId == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.paymentDefinitionList),function(payment2){return _c('option',{key:payment2.id,domProps:{"value":payment2.id,"selected":payment2.id == _vm.payment.salaryId}},[_vm._v(_vm._s(payment2.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewPayment),expression:"isNewPayment"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.addPayment()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPayment),expression:"!isNewPayment"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.updatePayment()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-work-place"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(25),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewWorkPlace),expression:"isNewWorkPlace"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addWorkplace')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkPlace),expression:"!isNewWorkPlace"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.editWorkplace')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlace.startDate),expression:"workPlace.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.workPlace.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlace, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceEndDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlace.endDate),expression:"workPlace.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.workPlace.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlace, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.descriptionWorkPlace')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlace.description),expression:"workPlace.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.workPlace.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlace, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlace')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeWorkPlaceForEmployee($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.workPlace.workplaceId == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                  ")]),_vm._v(" "),_vm._l((_vm.workPlaceDefinitionList),function(workPlace2){return _c('option',{key:workPlace2.id,domProps:{"value":workPlace2.id,"selected":workPlace2.id == _vm.workPlace.workplaceId}},[_vm._v(_vm._s(workPlace2.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewWorkPlace),expression:"isNewWorkPlace"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.addWorkPlace()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkPlace),expression:"!isNewWorkPlace"}],staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateWorkPlace()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-document"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(26),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[(!_vm.document.id)?_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.addDocument')))]):_vm._e(),_vm._v(" "),(_vm.document.id)?_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.editDocument')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.documentType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.documentDefinitionId),expression:"document.documentDefinitionId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.document, "documentDefinitionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"selected":_vm.document.documentDefinitionId == null,"value":null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.documentDefinitionList),function(definition){return _c('option',{key:definition.id,domProps:{"selected":definition.id == _vm.document.documentDefinitionId,"value":definition.id}},[_vm._v(_vm._s(definition.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.documentDescription')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.description),expression:"document.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.document.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.document, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.document.id),expression:"!document.id"}],staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.documentFile')))]),_c('span',{staticClass:"text-muted",staticStyle:{"font-style":"italic","font-size":"12px","font-weight":"normal","margin-left":"10px"}},[_vm._v("(.zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg)")]),_vm._v(" "),_c('input',{ref:"file",staticClass:"form-control",attrs:{"type":"file","id":"fileName","accept":".zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.isgDocument')))]),_c('span',{staticClass:"text-muted",staticStyle:{"font-style":"italic","font-size":"12px","font-weight":"normal","margin-left":"10px"}},[_vm._v("İSG belgelerinde tarih alanları zorunludur.")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.document.isISGDocument},on:{"change":function($event){_vm.document.isISGDocument == true ? _vm.document.isISGDocument = false : _vm.document.isISGDocument = true}}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.isgDocument')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.validityStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.starDate),expression:"document.starDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.document.starDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.document, "starDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.validityEndDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.endDate),expression:"document.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.document.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.document, "endDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.saveDocument()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-izin-ekle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(27),_vm._v(" "),_c('div',{staticClass:"overlay",staticStyle:{"float":"right","font-size":"18px","margin-right":"15px"},attrs:{"id":"load","hidden":!_vm.isLoadingAllowenceModal}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAllowence),expression:"isNewAllowence"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.addAllowence')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAllowence),expression:"!isNewAllowence"}]},[_vm._v(_vm._s(_vm.$ml.get('employees.editAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAllowence),expression:"isNewAllowence"}],staticClass:"table-responsive",staticStyle:{"height":"350px","overflow":"auto"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('employees.validDays')))]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"background-color":"#fff","color":"black"}},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check == true ? day.check = false : day.check = true}}}),_vm._v("\n                            "+_vm._s(day.name)+"\n                          ")])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAllowence),expression:"isNewAllowence"}],staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typeAllowence')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowenceType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.allowence.allowenceType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.dailyAllowence'))+"\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.allowence.allowenceType == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.hourlyAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.startTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.startDate),expression:"allowence.startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.startDate)},on:{"change":function($event){return _vm.changeAllowenceStartTime()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.endTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.endDate),expression:"allowence.endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.allowence.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.allowence')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowence($event)}}},_vm._l((_vm.allowenceList),function(allowence3){return _c('option',{key:allowence3.id,domProps:{"selected":allowence3.id == _vm.allowence.allowenceId,"value":allowence3.id}},[_vm._v("\n                      "+_vm._s(allowence3.shortCode)+" - "+_vm._s(allowence3.name))])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1 && _vm.isNewAllowence),expression:"allowence.allowenceType == 1 && isNewAllowence"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.totalTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.allowenceTime),expression:"allowence.allowenceTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.allowence.allowenceTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "allowenceTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1 && _vm.isNewAllowence),expression:"allowence.allowenceType == 1 && isNewAllowence"}],staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.missingHourAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.missingTime),expression:"allowence.missingTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.allowence.missingTime)},on:{"change":function($event){return _vm.changeEqualMissingTime()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "missingTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 1 && _vm.isNewAllowence),expression:"allowence.allowenceType == 1 && isNewAllowence"}],staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.isEqualTheMissingTime')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.allowence.equalTheMissingTime},on:{"change":function($event){return _vm.changeCheckEqualMissingTime()}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.equalTheMissingTime'))+"\n                    ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowence.allowenceType == 0 && _vm.isNewAllowence),expression:"allowence.allowenceType == 0 && isNewAllowence"}],staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.doesApplyHolidays')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.allowence.holidayPass},on:{"change":function($event){_vm.allowence.holidayPass == true ? _vm.allowence.holidayPass = false : _vm.allowence.holidayPass = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.applyHolidays'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.descriptionAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.description),expression:"allowence.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.allowence.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "description", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAllowence),expression:"isNewAllowence"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.addAllowence()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAllowence),expression:"!isNewAllowence"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.updateAllowence()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",staticStyle:{"display":"none"},attrs:{"id":"modal-izin-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(28),_vm._v(" "),_c('div',{staticClass:"overlay",staticStyle:{"float":"right","font-size":"18px","margin-right":"15px"},attrs:{"id":"load","hidden":!_vm.isLoadingAllowenceModal}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.removeAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('employees.startDateAllowences')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDateRemoveAllowence),expression:"startDateRemoveAllowence"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDateRemoveAllowence)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDateRemoveAllowence=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('employees.endDateAllowences')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDateRemoveAllowence),expression:"endDateRemoveAllowence"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDateRemoveAllowence)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDateRemoveAllowence=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline",attrs:{"type":"button"},on:{"click":function($event){return _vm.batchDeleteAllowence()}}},[_vm._v(_vm._s(_vm.$ml.get('employees.removeAllowenceInSelectedDates')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-durum"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(29),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.states')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.stateList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newState()}}},[_vm._v(_vm._s(_vm.$ml.get('employees.newState')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length > 0),expression:"stateList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.stateList),function(state){return _c('tr',{key:state.id},[_c('td',[_vm._v(_vm._s(state.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectState(state.id, state.name, state.status)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.stateNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.stateName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStateName),expression:"selectedStateName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedStateName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedStateName=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.enableToLeaveDate')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selectedStateStatus},on:{"change":function($event){_vm.selectedStateStatus == true ? _vm.selectedStateStatus = false : _vm.selectedStateStatus = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.enableToLeaveDate'))+"\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewState),expression:"!isNewState"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteState()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveState()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewState),expression:"isNewState"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewState),expression:"!isNewState"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-statu"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(30),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.statusTitle')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.statusList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newStatu()}}},[_vm._v(_vm._s(_vm.$ml.get('employees.newStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length > 0),expression:"statuList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.statuList),function(statu){return _c('tr',{key:statu.id},[_c('td',[_vm._v(_vm._s(statu.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectStatu(statu.id, statu.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.statusNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.statusName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatuName),expression:"selectedStatuName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedStatuName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedStatuName=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewStatu),expression:"!isNewStatu"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteStatu()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveStatu()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewStatu),expression:"isNewStatu"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewStatu),expression:"!isNewStatu"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-odemeler"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(31),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.payments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('employees.paymentDefinitions')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newPaymentDefinition()}}},[_vm._v(_vm._s(_vm.$ml.get('employees.newPayment')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentDefinitionList.length > 0),expression:"paymentDefinitionList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.paymentDefinitionList),function(paymentDef){return _c('tr',{key:paymentDef.id},[_c('td',[_vm._v(_vm._s(paymentDef.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectPaymentDefinition(paymentDef.id, paymentDef.name, paymentDef.status)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paymentDefinitionList.length == 0),expression:"paymentDefinitionList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.paymentNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.namePayment')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.paymentDefinition.name),expression:"paymentDefinition.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.paymentDefinition.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.paymentDefinition, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.effectOnSalary')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePaymentDefinitionStatus($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.paymentDefinition.status == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.addedSalary'))+"\n                    ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.paymentDefinition.status == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.decreaseFromSalary')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPaymentDefinition),expression:"!isNewPaymentDefinition"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletePaymentDefinition()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.savePaymentDefinition()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewPaymentDefinition),expression:"isNewPaymentDefinition"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPaymentDefinition),expression:"!isNewPaymentDefinition"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"select-department"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(32),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.selectDepartment')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length > 0),expression:"departmentList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('div',{attrs:{"id":"treeview"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length == 0),expression:"departmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('employees.departmentNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"pull-left"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('employees.selectedDepartment'))+" :\n              "),_c('span',{domProps:{"textContent":_vm._s(_vm.employee.departmentId ? _vm.getDepartmentFromId(_vm.employee.departmentId) : ' - ')}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.confirm')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-confirm-overtime"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(33),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.confirmSelectedOvertime')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimePlace')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimePlace($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTPlaceId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.overtimePlaceList),function(place){return _c('option',{key:place.id,domProps:{"selected":place.id == _vm.selectedOTPlaceId,"value":place.id}},[_vm._v(_vm._s(place.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimeDescription')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimeDescription($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTDescriptionId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                ")]),_vm._v(" "),_vm._l((_vm.overtimeDescriptionList),function(description){return _c('option',{key:description.id,domProps:{"selected":description.id == _vm.selectedOTDescriptionId,"value":description.id}},[_vm._v("\n                  "+_vm._s(description.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.confirmOverTime()}}},[_vm._v(_vm._s(_vm.$ml.get('general.confirm')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"puantaj-detay"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(34),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.dailyPayrollDetail'))+" | "+_vm._s(this.selectedDailyPayrol.date))]),_vm._v(" "),_c('span',{staticClass:"pull-right",staticStyle:{"margin-right":"15px"}},[_vm._v(_vm._s(this.selectedDailyPayrol.workGroup))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.payrollDetail')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"color":"black"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyPayrollDetailList.length > 0),expression:"dailyPayrollDetailList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"height":"440px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.payrollTime')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.payroll')))])]),_vm._v(" "),_vm._l((_vm.dailyPayrollDetailList),function(payrollDetail,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(payrollDetail.time))]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(payrollDetail.payroll))])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyPayrollDetailList.length == 0),expression:"dailyPayrollDetailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.payrollNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.movementsOT')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"color":"black"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyInOutDetailList.length > 0),expression:"dailyInOutDetailList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"height":"440px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.movementOT')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.statusOT')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((_vm.dailyInOutDetailList),function(inOutDetail,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(inOutDetail.date))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOutDetail.status == 'Giriş'),expression:"inOutDetail.status == 'Giriş'"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOutDetail.status == 'Çıkış'),expression:"inOutDetail.status == 'Çıkış'"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement')))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-xs btn-primary",on:{"click":function($event){return _vm.selectInOut2(inOutDetail)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-danger",on:{"click":function($event){return _vm.deleteInOut2(inOutDetail.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyInOutDetailList.length == 0),expression:"dailyInOutDetailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('employees.movementNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.calculatedOvertimeLong')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.selectedDailyPayrol.calculatedOverTime))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.confirmedOvertimeLong')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDailyPayrol.confirmedOverTime),expression:"selectedDailyPayrol.confirmedOverTime"}],staticClass:"form-control",staticStyle:{"color":"black"},attrs:{"disabled":_vm.selectedDailyPayrol.overTimeId == null,"type":"time"},domProps:{"value":(_vm.selectedDailyPayrol.confirmedOverTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedDailyPayrol, "confirmedOverTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimePlace')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimePlace($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTPlaceId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.overtimePlaceList),function(place){return _c('option',{key:place.id,domProps:{"selected":place.id == _vm.selectedOTPlaceId,"value":place.id}},[_vm._v(_vm._s(place.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimeDescription')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimeDescription($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTDescriptionId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.overtimeDescriptionList),function(description){return _c('option',{key:description.id,domProps:{"selected":description.id == _vm.selectedOTDescriptionId,"value":description.id}},[_vm._v("\n                      "+_vm._s(description.name))])})],2)]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-sm",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.selectedDailyPayrol.overTimeId == null,"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.customConfirmOverTime()}}},[_vm._v(_vm._s(_vm.$ml.get('general.confirm')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"display":"flex"}},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.newInOut2()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.newMovement'))+"\n                  ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveInOut2 == true),expression:"isActiveInOut2 == true"}]},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.timeMovement')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut2.inOutAdd),expression:"inOut2.inOutAdd"}],staticClass:"form-control input-sm",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut2.inOutAdd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut2, "inOutAdd", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.readerMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",on:{"change":function($event){return _vm.changeInOutDoor2($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut2.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                      ")]),_vm._v(" "),_vm._l((_vm.activePDKSReaderList),function(door){return _c('option',{key:door.readerId,domProps:{"value":door.readerId,"selected":door.readerId == _vm.inOut2.readerId}},[_vm._v(_vm._s(door.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typeMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",on:{"change":function($event){return _vm.changeInOutType2($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut2.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                      ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.inOut2.inOutType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement'))+"\n                      ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.inOut2.inOutType == 2}},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.includePassiveMovements},on:{"change":function($event){_vm.includePassiveMovements == true ? _vm.includePassiveMovements = false : _vm.includePassiveMovements = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.includePassivesMovement'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.doNotDeleteOvertimes},on:{"change":function($event){_vm.doNotDeleteOvertimes == true ? _vm.doNotDeleteOvertimes = false : _vm.doNotDeleteOvertimes = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.confirmedOvertimeNotDeleted'))+"\n                      ")])])]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut2),expression:"isNewInOut2"}],staticClass:"btn btn-outline",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.addInOut2()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewInOut2),expression:"!isNewInOut2"}],staticClass:"btn btn-outline",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.updateInOut2()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.isActiveInOut2 = false}}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"fingerPrintModal"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(35),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.employee.name)+" - "+_vm._s(_vm.$ml.get('employees.fingerPrintInformation')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fpScreen == 0),expression:"fpScreen == 0"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('employees.fingerPrintDescription'))+"\n                ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fpScreen == 1),expression:"fpScreen == 1"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-success"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Seçilen parmak izi için kayıt başlasın mı?\n                  "),_c('button',{staticClass:"btn btn-outline",on:{"click":function($event){return _vm.getFP()}}},[_vm._v("Evet")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline",on:{"click":function($event){return _vm.clearFP()}}},[_vm._v("Hayır")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fpScreen == 2),expression:"fpScreen == 2"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-danger"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Seçilen parmak izi silinecektir. Devam edilsin mi?\n                  "),_c('button',{staticClass:"btn btn-outline",on:{"click":function($event){return _vm.deleteFP()}}},[_vm._v("Evet")]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline",on:{"click":function($event){return _vm.clearFP()}}},[_vm._v("Hayır")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{class:_vm.getFingerClass(1),staticStyle:{"top":"97px","left":"10px"},attrs:{"title":_vm.getHasFinger(1) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(1)}}},[_vm._v("\n                  1")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(2),staticStyle:{"top":"23px","left":"77px"},attrs:{"title":_vm.getHasFinger(2) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(2)}}},[_vm._v("\n                  2")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(3),staticStyle:{"top":"3px","left":"150px"},attrs:{"title":_vm.getHasFinger(3) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(3)}}},[_vm._v("\n                  3")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(4),staticStyle:{"top":"33px","left":"240px"},attrs:{"title":_vm.getHasFinger(4) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(4)}}},[_vm._v("\n                  4")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(5),staticStyle:{"top":"195px","left":"310px"},attrs:{"title":_vm.getHasFinger(5) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(5)}}},[_vm._v("\n                  5")]),_vm._v(" "),_c('img',{staticStyle:{"width":"350px"},attrs:{"src":"/src/assets/hand.jpg"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{class:_vm.getFingerClass(6),staticStyle:{"top":"195px","left":"20px"},attrs:{"title":_vm.getHasFinger(6) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(6)}}},[_vm._v("\n                  6")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(7),staticStyle:{"top":"33px","left":"90px"},attrs:{"title":_vm.getHasFinger(7) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(7)}}},[_vm._v("\n                  7")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(8),staticStyle:{"top":"3px","left":"180px"},attrs:{"title":_vm.getHasFinger(8) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(8)}}},[_vm._v("\n                  8")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(9),staticStyle:{"top":"23px","left":"250px"},attrs:{"title":_vm.getHasFinger(9) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(9)}}},[_vm._v("\n                  9")]),_vm._v(" "),_c('div',{class:_vm.getFingerClass(10),staticStyle:{"top":"97px","left":"320px"},attrs:{"title":_vm.getHasFinger(10) ? _vm.$ml.get('employees.fingerprintExist') : _vm.$ml.get('employees.fingerprintNotExist')},on:{"click":function($event){return _vm.GetOrDeleteFP(10)}}},[_vm._v("\n                  10")]),_vm._v(" "),_c('img',{staticStyle:{"width":"350px","transform":"scaleX(-1)","-webkit-transform":"scaleX(-1)"},attrs:{"src":"/src/assets/hand.jpg"}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.close')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getEmployee(_vm.employee.id)}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.refreshScreen'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(36),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length > 0),expression:"sortableDepartmentList.length > 0"}],staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(37),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(38),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(39),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(40),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(41),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-konum"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(42),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.location')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body text-center"},[_c('label',{staticClass:"form-control"},[_vm._v("Koordinatlar: "+_vm._s(_vm.inOut.positionX)+" - "+_vm._s(_vm.inOut.positionY))]),_vm._v(" "),_c('a',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"10px"},attrs:{"target":"_blank","href":'http://maps.google.com/maps?f=q&hl=en&q=' + _vm.inOut.positionX + '+N,+' + _vm.inOut.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + _vm.inOut.positionX + ',' + _vm.inOut.positionY + '&spn=0.003022,0.004989&t=k'}},[_c('i',{staticClass:"fa fa-map-marker"}),_vm._v(" Haritada Görüntüle\n            ")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-inventory"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(43),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.addInventory')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('h5',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryList')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchInventoryText),expression:"searchInventoryText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchInventoryText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchInventoryText=$event.target.value}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedInventoryCategory),expression:"selectedInventoryCategory"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedInventoryCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.allCategories')))]),_vm._v(" "),_vm._l((_vm.inventoryCategoryList),function(category){return _c('option',{key:category.id,domProps:{"value":category.id}},[_vm._v(_vm._s(category.name))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryList.length > 0),expression:"inventoryList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.inventoryList),function(inventory){return _c('tr',{key:inventory.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.employeeInventory.inventoryId = inventory.id}}},[_c('td',[_c('span',[_vm._v(_vm._s(inventory.name))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(inventory.code))])]),_vm._v(" "),_c('td',{staticStyle:{"align-content":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventory.inventoryId === inventory.id),expression:"employeeInventory.inventoryId === inventory.id"}],staticClass:"badge label-success"},[_vm._v(_vm._s(_vm.$ml.get('general.selected')))])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryList.length == 0),expression:"inventoryList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.selectedInventory')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventory.inventoryId == null),expression:"employeeInventory.inventoryId == null"}],staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).name)}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventory.inventoryId != null),expression:"employeeInventory.inventoryId != null"}],staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).name)}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeInventory.inventoryId != null),expression:"employeeInventory.inventoryId != null"}],staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.employeeInventory.inventoryId = null}}},[_c('i',{staticClass:"fa fa-trash"})])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryQuantity')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employeeInventory.quantity),expression:"employeeInventory.quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.employeeInventory.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employeeInventory, "quantity", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.deliveryDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employeeInventory.deliveryDate),expression:"employeeInventory.deliveryDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employeeInventory.deliveryDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employeeInventory, "deliveryDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.takenDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employeeInventory.takenDate),expression:"employeeInventory.takenDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employeeInventory.takenDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employeeInventory, "takenDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.employeeInventory.description),expression:"employeeInventory.description"}],staticClass:"form-control",domProps:{"value":(_vm.employeeInventory.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employeeInventory, "description", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveEmployeeInventory()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.save'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-inventory-details"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(44),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).name))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body box-profile"},[_c('img',{staticClass:"profile-user-img img-responsive",staticStyle:{"width":"100%"},attrs:{"src":_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).photoUrl == null ? '/src/assets/default-product.png' : _vm.getInventoryFromId(_vm.employeeInventory.inventoryId).photoUrl}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('span',{staticClass:"text-muted",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).code))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).name))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-style":"italic","font-size":"12px"}},[_vm._v(_vm._s(_vm.getInventoryCategoryName(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).categoryId)))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.selectedInventory')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getInventoryFromId(_vm.employeeInventory.inventoryId).name))])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryQuantity')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.employeeInventory.quantity))])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.deliveryDate')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employeeInventory.deliveryDate,"gg.aa.yyyy")))])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.takenDate')))]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.takenDate == null),expression:"employee.takenDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.takenDate != null),expression:"employee.takenDate != null"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employeeInventory.takenDate,"gg.aa.yyyy")))])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.inventoryDescription')))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.employeeInventory.description))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteEmployeeInventory()}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.delete'))+"\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.close'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-statu"}},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-durum"}},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link dropdown-toggle",attrs:{"type":"button","data-toggle":"dropdown","aria-expanded":"false"}},[_c('span',{staticClass:"fa fa-ellipsis-v"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-addon"},[_c('span',[_c('i',{staticClass:"fa fa-map-marker"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operations_vue__ = __webpack_require__(140);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f54156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operations_vue__ = __webpack_require__(312);
function injectStyle (ssrContext) {
  __webpack_require__(310)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Operations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9f54156_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Operations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(311);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("793e5319", content, true, {});

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.batchOperations')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.batchOperations')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",attrs:{"align":"center"}},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.filterTheEmployeesYouWantToSelect')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group col-sm-6",attrs:{"align":"center"}},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%"},attrs:{"data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6",attrs:{"align":"center"}},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"input-group col-sm-12",staticStyle:{"margin-bottom":"7px","margin-top":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('batchOperations.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(employee3.name)+"\n                      "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('batchOperations.employeeNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"box box-solid"},[_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n              "+_vm._s(_vm.$ml.get('batchOperations.chooseFromTheFollowingActions')))]),_vm._v(" "),_c('a',{staticClass:"btn btn-app",attrs:{"href":"#bilgi-guncelleme","data-toggle":"tab","title":_vm.$ml.get('batchOperations.informationUpdateOperations')}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.informationUpdate')))])]),_vm._v(" "),_c('a',{staticClass:"btn btn-app",attrs:{"href":"#izinler","data-toggle":"tab","title":_vm.$ml.get('batchOperations.allowenceOperations')}},[_c('i',{staticClass:"fa fa-plane"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.allowence')))])]),_vm._v(" "),_c('a',{staticClass:"btn btn-app",attrs:{"href":"#hareketler","data-toggle":"tab","title":_vm.$ml.get('batchOperations.movementOperations')}},[_c('i',{staticClass:"fa fa-exchange"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.movement')))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll),expression:"modules.payroll"}],staticClass:"btn btn-app",attrs:{"href":"#fazla-mesailer","data-toggle":"tab","title":_vm.$ml.get('batchOperations.overtimeOperations')}},[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.overtime')))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payroll),expression:"modules.payroll"}],staticClass:"btn btn-app",attrs:{"href":"#puantaj","data-toggle":"tab","title":_vm.$ml.get('batchOperations.payrollOperations')}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.payroll')))])]),_vm._v(" "),_c('a',{staticClass:"btn btn-app",attrs:{"href":"#calisma-gruplari","data-toggle":"tab","title":_vm.$ml.get('batchOperations.workPlanOperations')}},[_c('i',{staticClass:"fa fa-briefcase"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.workPlan')))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"btn btn-app",attrs:{"href":"#yemekhane","data-toggle":"tab","title":_vm.$ml.get('batchOperations.diningHall')}},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.diningHall')))])]),_vm._v(" "),_c('a',{staticClass:"btn btn-app",attrs:{"href":"#gorev-yeri","data-toggle":"tab","title":_vm.$ml.get('employees.workPlace')}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlace')))])])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"bilgi-guncelleme"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.informationUpdateOperations')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.department')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDepartment($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.departmentList),function(dep){return _c('option',{key:dep.id,domProps:{"value":dep.id}},[_vm._v(_vm._s(dep.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.status')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeStatu($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.statuList),function(statu){return _c('option',{key:statu.id,domProps:{"value":statu.id}},[_vm._v(_vm._s(statu.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.state')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeState($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.stateList),function(state){return _c('option',{key:state.id,domProps:{"value":state.id}},[_vm._v(_vm._s(state.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.foodGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeFoodGroup($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.foodGroupList),function(foodGroup){return _c('option',{key:foodGroup.id,domProps:{"value":foodGroup.id}},[_vm._v("\n                      "+_vm._s(foodGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.accessGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAccessGroup($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(accessGroup){return _c('option',{key:accessGroup.id,domProps:{"value":accessGroup.id}},[_vm._v("\n                      "+_vm._s(accessGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.validityStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchInfo.newValidityStartDate),expression:"batchInfo.newValidityStartDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchInfo.newValidityStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchInfo, "newValidityStartDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.validityEndDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchInfo.newValidityEndDate),expression:"batchInfo.newValidityEndDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchInfo.newValidityEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchInfo, "newValidityEndDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchInformation()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"izinler"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.allowenceOperations')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.startDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchAllowence.startDate),expression:"batchAllowence.startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.batchAllowence.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchAllowence, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.endDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchAllowence.endDate),expression:"batchAllowence.endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.batchAllowence.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchAllowence, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 table-responsive",staticStyle:{"height":"350px","overflow":"auto"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.validDays')))]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check == true ? day.check = false : day.check = true}}}),_vm._v("\n                            "+_vm._s(day.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.allowenceType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowenceType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.batchAllowence.allowenceType == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.dailyAllowence')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.batchAllowence.allowenceType == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.hourlyAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.allowence')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowence($event)}}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.allowenceList),function(allowence){return _c('option',{key:allowence.id,domProps:{"value":allowence.id}},[_vm._v("\n                      "+_vm._s(allowence.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.batchAllowence.allowenceType == 1),expression:"batchAllowence.allowenceType == 1"}],staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.totalTimeAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchAllowence.allowenceTime),expression:"batchAllowence.allowenceTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.batchAllowence.allowenceTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchAllowence, "allowenceTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.batchAllowence.allowenceType == 1),expression:"batchAllowence.allowenceType == 1"}],staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.missingHourAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchAllowence.missingTime),expression:"batchAllowence.missingTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.batchAllowence.missingTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchAllowence, "missingTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.batchAllowence.allowenceType == 1),expression:"batchAllowence.allowenceType == 1"}],staticClass:"form-group col-sm-8"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.isEqualTheMissingTime')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.batchAllowence.equalTheMissingTime},on:{"change":function($event){_vm.batchAllowence.equalTheMissingTime == true ? _vm.batchAllowence.equalTheMissingTime = false : _vm.batchAllowence.equalTheMissingTime = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.equalTheMissingTime'))+"\n                    ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.batchAllowence.allowenceType == 0),expression:"batchAllowence.allowenceType == 0"}],staticClass:"form-group col-sm-8"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.doesApplyHolidays')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.batchAllowence.holidayPass},on:{"change":function($event){_vm.batchAllowence.holidayPass == true ? _vm.batchAllowence.holidayPass = false : _vm.batchAllowence.holidayPass = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.applyHolidays'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.descriptionAllowence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchAllowence.description),expression:"batchAllowence.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.batchAllowence.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchAllowence, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchAllowence()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"hareketler"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.movementOperations')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.startDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchMovement.startDate),expression:"batchMovement.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchMovement.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchMovement, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.endDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchMovement.endDate),expression:"batchMovement.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchMovement.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchMovement, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 table-responsive",staticStyle:{"height":"350px","overflow":"auto"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.validDays')))]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check == true ? day.check = false : day.check = true}}}),_vm._v("\n                            "+_vm._s(day.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.movementDetails')))]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.movementTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchMovement.entryTime),expression:"batchMovement.entryTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.batchMovement.entryTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchMovement, "entryTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.reader')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeEntryDevice($event)}}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.readerList),function(entryReader){return _c('option',{key:entryReader.readerId,domProps:{"value":entryReader.readerId}},[_vm._v(_vm._s(entryReader.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.movementType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeEntryStatus($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.batchMovement.entryPointStatus == 1}},[_vm._v("\n                        "+_vm._s(_vm.$ml.get('batchOperations.entryMovement')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.batchMovement.entryPointStatus == 2}},[_vm._v("\n                        "+_vm._s(_vm.$ml.get('batchOperations.exitMovement')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.batchMovement.isTwoMovement},on:{"change":function($event){_vm.batchMovement.isTwoMovement == true ? _vm.batchMovement.isTwoMovement = false : _vm.batchMovement.isTwoMovement = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('batchOperations.createExitMovement'))+"\n                      ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.batchMovement.isTwoMovement),expression:"batchMovement.isTwoMovement"}]},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.secondMovementTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchMovement.exitTime),expression:"batchMovement.exitTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.batchMovement.exitTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchMovement, "exitTime", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.secondMovementReader')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeExitDevice($event)}}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.readerList),function(exitReader){return _c('option',{key:exitReader.readerId,domProps:{"value":exitReader.readerId}},[_vm._v(_vm._s(exitReader.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.secondMovementType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeExitStatus($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.batchMovement.exitPointStatus == 1}},[_vm._v("\n                          "+_vm._s(_vm.$ml.get('batchOperations.entryMovement')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.batchMovement.exitPointStatus == 2}},[_vm._v("\n                          "+_vm._s(_vm.$ml.get('batchOperations.exitMovement')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchMovement()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"fazla-mesailer"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.confirmOvertime')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.startDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchOvertime.startDate),expression:"batchOvertime.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchOvertime.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchOvertime, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.endDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchOvertime.endDate),expression:"batchOvertime.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.batchOvertime.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchOvertime, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%","margin-top":"25px"},on:{"click":function($event){return _vm.getBatchOvertimes()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('batchOperations.search'))+"\n                  ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-sm-12 table-responsive",style:(_vm.windowHeightConfirmOvertimeSize)},[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.overtimeWorks')))]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.nameSurname')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.date')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.workPlan')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.entryMovement')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.exitMovement')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.calculated')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.confirmed')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_c('button',{staticClass:"btn-link",on:{"click":function($event){return _vm.checkAllOvertime()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheckOvertime),expression:"!isCheckOvertime"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckOvertime),expression:"isCheckOvertime"}],staticClass:"text-danger"},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.batchOvertimeList),function(overtime){return _c('tr',{key:overtime.overTimeId},[_c('td',[_vm._v(_vm._s(overtime.sicilNo)+" - "+_vm._s(overtime.name))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(overtime.date,"gg.aa.yyyy")))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(overtime.workGroupName))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(overtime.entry))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(overtime.exit))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(overtime.calculated))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(overtime.confirmed),expression:"overtime.confirmed"}],style:(_vm.overtimeStyleControl(overtime.calculated, overtime.confirmed)),attrs:{"type":"time"},domProps:{"value":(overtime.confirmed)},on:{"change":function($event){return _vm.overtimeControl(overtime.calculated, overtime.confirmed, overtime.sicilNo + ' - ' + overtime.name, overtime.date)},"input":function($event){if($event.target.composing){ return; }_vm.$set(overtime, "confirmed", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":overtime.check},on:{"change":function($event){overtime.check == true ? overtime.check = false : overtime.check = true}}})])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchOvertime()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"puantaj"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.payrollOperations')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.startTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchPayrollStartDate),expression:"batchPayrollStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.batchPayrollStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.batchPayrollStartDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.includePassivesMovement')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.includePassiveMovements},on:{"change":function($event){_vm.includePassiveMovements == true ? _vm.includePassiveMovements = false : _vm.includePassiveMovements = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.includePassivesMovement'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.confirmedOvertimeNotDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.doNotDeleteOvertimes},on:{"change":function($event){_vm.doNotDeleteOvertimes == true ? _vm.doNotDeleteOvertimes = false : _vm.doNotDeleteOvertimes = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.confirmedOvertimeNotDeleted'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchPayroll()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"calisma-gruplari"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.workPlanOperations')))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.startTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchWorkGroup.startDate),expression:"batchWorkGroup.startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.batchWorkGroup.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchWorkGroup, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.endTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchWorkGroup.endDate),expression:"batchWorkGroup.endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.batchWorkGroup.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchWorkGroup, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.workPlan')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeWorkGroup($event)}}},[_c('option',{attrs:{"selected":""}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.workGroupList),function(workGroup){return _c('option',{key:workGroup.id,domProps:{"value":workGroup.id}},[_vm._v("\n                      "+_vm._s(workGroup.shortCode)+" - "+_vm._s(workGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.doesApplyHolidays')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.batchWorkGroup.holidayPass},on:{"change":function($event){_vm.batchWorkGroup.holidayPass == true ? _vm.batchWorkGroup.holidayPass = false : _vm.batchWorkGroup.holidayPass = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('batchOperations.applyHolidays'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('batchOperations.descriptionWorkPlan')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.batchWorkGroup.description),expression:"batchWorkGroup.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.batchWorkGroup.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.batchWorkGroup, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchWorkGroup()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"yemekhane"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('h4',{staticStyle:{"background-color":"#f7f7f7","font-size":"18px","text-align":"center","padding":"7px 10px","margin-top":"0"}},[_vm._v("\n                  "+_vm._s(_vm.$ml.get('batchOperations.diningHallOperations')))]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center",staticStyle:{"margin-top":"20px"}},[_c('button',{staticClass:"btn btn-primary btn-lg",on:{"click":function($event){return _vm.downloadExcelTemplate()}}},[_c('i',{staticClass:"fa fa-download"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('batchOperations.downloadTemplate')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"form-group"},[_c('input',{ref:"file",staticClass:"form-control",staticStyle:{"justify-self":"center","border":"1px solid grey","border-radius":"5px"},attrs:{"type":"file","accept":".xlsx","hidden":""}}),_vm._v(" "),_c('p',{staticClass:"help-block"},[_vm._v(_vm._s(_vm.$ml.get('batchOperations.uploadDescription')))])]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-primary btn-lg",on:{"click":_vm.uploadExcelTemplate}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('batchOperations.uploadFile')))])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"gorev-yeri"}},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlace')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeWorkPlace($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.notChanged')))]),_vm._v(" "),_vm._l((_vm.workPlaceDefinitionList),function(workPlace){return _c('option',{key:workPlace.id,domProps:{"value":workPlace.id}},[_vm._v(_vm._s(workPlace.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceDescription')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlaces.description),expression:"workPlaces.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.workPlaces.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlaces, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlaces.startDate),expression:"workPlaces.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.workPlaces.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlaces, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.workPlaceEndDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlaces.endDate),expression:"workPlaces.endDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.workPlaces.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlaces, "endDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"box-footer"},[_c('button',{staticClass:"btn btn-success  pull-right",on:{"click":function($event){return _vm.setBatchWorkPlace()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.apply'))+"\n                ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(7),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning ",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__(141);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c33d2afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__(316);
function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c33d2afa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c33d2afa_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(315);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("52ffb2fe", content, true, {});

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dep-baslik[data-v-c33d2afa]{font-weight:700;background-color:#3c8dbc;color:#fff}", ""]);

// exports


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.activeScreen == 1 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 1}}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('filters.filterEmployees'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 2 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.selectReport'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 3 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 3}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.report'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],class:_vm.activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title,index){return _c('option',{key:'title' + index,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterVisitorCards')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isVisitor},on:{"change":function($event){_vm.filters.isVisitor == true ? _vm.filters.isVisitor = false : _vm.filters.isVisitor = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterShow'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField1-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField2-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField3-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField4-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v("Seçilen Kişiler")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('filters.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:'employee' + employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(employee3.name)+"\n                              "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2),expression:"activeScreen == 2"}],class:_vm.activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportSettings')))]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.report'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeSelectedReport($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))]),_vm._v(" "),_vm._l((_vm.reportList),function(report){return _c('option',{key:'report' + report.id,domProps:{"value":report.id}},[_vm._v(_vm._s(report.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"width":"100%","margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 14 || _vm.selectedReportId != 15),expression:"selectedReportId != 14 || selectedReportId != 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.startDate'))+"\n                              :")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15),expression:"selectedReportId == 14 || selectedReportId == 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.date'))+"\n                              :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 6 && _vm.selectedReportId != 7 && _vm.selectedReportId != 14 && _vm.selectedReportId != 15),expression:"selectedReportId != 6 && selectedReportId != 7 && selectedReportId != 14 && selectedReportId != 15"}],staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.endDate'))+" :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 10 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 10 || selectedReportId == 11"}]},[_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportOptions')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 11"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showAllowed},on:{"change":function($event){_vm.reportOptions.showAllowed == true ? _vm.reportOptions.showAllowed = false : _vm.reportOptions.showAllowed = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showAllowences'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 11 || _vm.selectedReportId == 10),expression:"selectedReportId == 11 || selectedReportId == 10"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showNonComers},on:{"change":function($event){_vm.reportOptions.showNonComers == true ? _vm.reportOptions.showNonComers = false : _vm.reportOptions.showNonComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showMissing'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1),expression:"selectedReportId == 1"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showLateComers},on:{"change":function($event){_vm.reportOptions.showLateComers == true ? _vm.reportOptions.showLateComers = false : _vm.reportOptions.showLateComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showLatecomer'))+"\n                            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 10),expression:"selectedReportId == 10"}],staticClass:"input-group mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportOptions.time),expression:"reportOptions.time"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reportOptions.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reportOptions, "time", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.fromTheClock')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-lg",on:{"change":function($event){return _vm.changeIsUpperFromTime($event)}}},[_c('option',{attrs:{"value":"false"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == false}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.lessEmployees')))]),_vm._v(" "),_c('option',{attrs:{"value":"true"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == true}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.moreEmployees')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 8),expression:"selectedReportId == 8"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportVisitorCardGroups'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckVG ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllVisitorGroups()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length > 0),expression:"visitorGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.visitorGroupList),function(visitorGroup){return _c('tr',{key:visitorGroup.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){visitorGroup.check == true ? visitorGroup.check = false : visitorGroup.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(visitorGroup.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(visitorGroup.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length == 0),expression:"visitorGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.visitorCardGroupNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 2 || _vm.selectedReportId == 6 || _vm.selectedReportId == 7 || _vm.selectedReportId == 11 || _vm.selectedReportId == 19 || _vm.selectedReportId == 20 || _vm.selectedReportId == 21 || _vm.selectedReportId == 31),expression:"selectedReportId == 1 || selectedReportId == 2 || selectedReportId == 6 || selectedReportId == 7 || selectedReportId == 11 || selectedReportId == 19 || selectedReportId == 20 || selectedReportId == 21 || selectedReportId == 31"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDevices'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckReaders ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllReaders()}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.checkThisDevices'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutListDoorType($event)}}},[_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.selectedDoorType == 4}},[_vm._v(_vm._s(_vm.$ml.get('employees.allDoors'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedDoorType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.access'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedDoorType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.pdks'))+"\n                              ")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],attrs:{"value":"2"},domProps:{"selected":_vm.selectedDoorType == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.diningHall')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],attrs:{"value":"3"},domProps:{"selected":_vm.selectedDoorType == 3}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.licencePlateRecognition')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],attrs:{"value":"5"},domProps:{"selected":_vm.selectedDoorType == 5}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.dormitoryDevice')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:'reader' + reader.readerId,staticStyle:{"cursor":"pointer"},on:{"click":function($event){reader.check == true ? reader.check = false : reader.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.devicesNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 12),expression:"selectedReportId == 12"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportAllowences'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckAllowences ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllAllowence()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allowenceList),function(allowence){return _c('tr',{key:'allowence' + allowence.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){allowence.check == true ? allowence.check = false : allowence.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(allowence.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allowence.shortCode)+" - "+_vm._s(allowence.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.allowenceNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15 || _vm.selectedReportId == 25 || _vm.selectedReportId == 30),expression:"selectedReportId == 14 || selectedReportId == 15 || selectedReportId == 25 || selectedReportId == 30"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDepartments'))+"\n                            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckDeps),expression:"isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(false)}}},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheckDeps),expression:"!isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(true)}}},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length > 0),expression:"departmentList.length > 0"}],staticClass:"table-responsive no-padding text-black",style:('background-style:white; ' + _vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.sortableDepartmentList),function(dep){return _c('tr',{key:'department' + dep.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){dep.check == true ? _vm.changeFilterDep2(dep, false) : _vm.changeFilterDep2(dep, true)}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(dep.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dep.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length == 0),expression:"departmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.departmentNotFound'))+"\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getReportDetails()}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.viewReport'))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 3),expression:"activeScreen == 3"}],class:_vm.activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}]},[_vm._v(_vm._s(_vm.selectedReportName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName == ''),expression:"selectedReportName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.report')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0 && _vm.reportDataList != null),expression:"authControl == 0 && reportDataList != null"}],staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n                      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.selectedReportName)+"\n                          ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"12px"},attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',_vm._l((_vm.reportHeaderList),function(header,indexHead){return _c('th',{key:'head' + indexHead,staticClass:"dep-baslik"},[_vm._v("\n                              "+_vm._s(header))])}),0)]),_vm._v(" "),_vm._l((_vm.reportDataList),function(dep,index){return _c('tbody',{key:'body' + index},[_c('tr',[_c('td',{staticClass:"dep-baslik",attrs:{"colspan":_vm.selectedReportId == 1 ? 7 : 37}},[_c('strong',[_vm._v(_vm._s(dep.departmanAdi))])])]),_vm._v(" "),_vm._l((dep.veriler),function(data,index2){return _c('tr',{key:'data' + index2,class:index2 % 2 == 1 ? 'bg-secondary' : ''},[_vm._l((dep.keys),function(key1,indexKey){return _c('td',{key:'key' + indexKey,class:_vm.customReportStyle(key1, data[key1])},[(_vm.selectedReportId == 19 && indexKey == 4 && data.positionX)?_c('span',[(data.positionX)?_c('a',{staticStyle:{"margin-top":"10px"},attrs:{"target":"_blank","href":'http://maps.google.com/maps?f=q&hl=en&q=' + data.positionX + '+N,+' + data.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + data.positionX + ',' + data.positionY + '&spn=0.003022,0.004989&t=k'}},[_vm._v(_vm._s(data.positionX)+"\n                                  - "+_vm._s(data.positionY))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedReportId == 32 && indexKey != 5) || (_vm.selectedReportId != 31 && _vm.selectedReportId != 32) || (_vm.selectedReportId == 31 && indexKey != 6 && indexKey != 7)),expression:"(selectedReportId == 32 && indexKey != 5) || (selectedReportId != 31 && selectedReportId != 32) || (selectedReportId == 31 && indexKey != 6 && indexKey != 7)"}]},[_vm._v(_vm._s(data[key1]))]),_vm._v(" "),(_vm.selectedReportId == 32 && indexKey == 5 && data[key1])?_c('span',[_c('i',{staticClass:"fa fa-times-circle text-danger"}),_vm._v(" İade Edildi\n                              ")]):_vm._e(),_vm._v(" "),(_vm.selectedReportId == 31 && (indexKey == 6 || indexKey == 7))?_c('img',{staticStyle:{"width":"200px"},attrs:{"src":data[key1]}}):_vm._e()])}),_vm._v(" "),_vm._l((data.movements),function(movement,index){return _c('td',{key:'visitorKey' + index,staticClass:"no-wrap"},[_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]},[_vm._v("GİRİŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}],staticClass:"text-success"},[_vm._v(_vm._s(movement.entryTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "+_vm._s(movement.entryReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]},[_vm._v("ÇIKIŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}],staticClass:"text-danger"},[_vm._v(_vm._s(movement.exitTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "+_vm._s(movement.exitReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]},[_vm._v("FARK")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}],staticClass:"text-primary"},[_vm._v(_vm._s(movement.timeDifference))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]})])})],2)})],2)})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"margin-right":"70px","margin-bottom":"40px"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.noResults'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:'sortDep' + dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:'state' + state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:'status' + status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:'access' + acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:'workGroup' + work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:'foodGroup' + foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftReport_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4584fbcb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftReport_vue__ = __webpack_require__(320);
function injectStyle (ssrContext) {
  __webpack_require__(318)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4584fbcb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4584fbcb_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(319);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("83f5824e", content, true, {});

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dep-baslik[data-v-4584fbcb]{font-weight:700;background-color:#3c8dbc;color:#fff}", ""]);

// exports


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.ShiftReport')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.ShiftReport')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.activeScreen == 1 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 1}}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('filters.filterEmployees'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 2 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.reportSettings'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 3 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 3}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.report'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],class:_vm.activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title,index){return _c('option',{key:'title' + index,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField1-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField2-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField3-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField4-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v("Seçilen Kişiler")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('filters.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:'employee' + employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(employee3.name)+"\n                              "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2),expression:"activeScreen == 2"}],class:_vm.activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('reports.reportSettings')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group",staticStyle:{"width":"100%","margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.startDate'))+":")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.endDate'))+" :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isSignatureColumnAdded},on:{"change":function($event){_vm.isSignatureColumnAdded = !_vm.isSignatureColumnAdded}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get("reports.reports.ShiftReportHeaders.isSignatureColumnAdded"))+"\n                            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getReportDetails()}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.viewReport'))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 3),expression:"activeScreen == 3"}],class:_vm.activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}]},[_vm._v(_vm._s(_vm.selectedReportName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName == ''),expression:"selectedReportName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.report')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0 && _vm.reportDataList != null),expression:"authControl == 0 && reportDataList != null"}],staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n                      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.selectedReportName)+"\n                          ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"12px"},attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',_vm._l((_vm.reportHeaderList),function(header,indexHead){return _c('th',{key:'head' + indexHead,staticClass:"dep-baslik"},[_vm._v("\n                              "+_vm._s(header))])}),0)]),_vm._v(" "),_vm._l((_vm.reportDataList),function(dep,index){return _c('tbody',{key:'body' + index},[_c('tr',[_c('td',{staticClass:"dep-baslik",attrs:{"colspan":"37"}},[_c('strong',[_vm._v(_vm._s(dep.departmanAdi))])])]),_vm._v(" "),_vm._l((dep.veriler),function(data,index2){return _c('tr',{key:'data' + index2,class:index2 % 2 == 1 ? 'bg-secondary' : ''},[_c('td',[_vm._v(_vm._s(data.registerNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.title))]),_vm._v(" "),_vm._l((data.plans),function(plan,index){return _c('td',{key:'plan' + index,staticClass:"no-wrap"},[_vm._v("\n                              "+_vm._s(plan.name)+"\n                            ")])}),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.isSignatureColumnAdded),expression:"isSignatureColumnAdded"}],staticStyle:{"min-width":"150px"}})],2)})],2)})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"margin-right":"70px","margin-bottom":"40px"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.noResults'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:'sortDep' + dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:'state' + state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:'status' + status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:'access' + acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:'workGroup' + work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:'foodGroup' + foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalFirstInLastOutReport_vue__ = __webpack_require__(143);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c051233_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalFirstInLastOutReport_vue__ = __webpack_require__(324);
function injectStyle (ssrContext) {
  __webpack_require__(322)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c051233"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VerticalFirstInLastOutReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c051233_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VerticalFirstInLastOutReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(323);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("030edb52", content, true, {});

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dep-baslik[data-v-5c051233]{font-weight:700;background-color:#3c8dbc;color:#fff}", ""]);

// exports


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.VerticalFirstInLastOutReport')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.reports.VerticalFirstInLastOutReport')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.activeScreen == 1 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 1}}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('filters.filterEmployees'))+"\n                            ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 2 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.selectReport'))+"\n                            ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 3 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 3}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.report'))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],class:_vm.activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title,index){return _c('option',{key:'title' + index,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name)+"\n                                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                                                            "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                                                        ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterVisitorCards')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isVisitor},on:{"change":function($event){_vm.filters.isVisitor == true ? _vm.filters.isVisitor = false : _vm.filters.isVisitor = true}}}),_vm._v("\n                                                            "+_vm._s(_vm.$ml.get('filters.filterShow'))+"\n                                                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                                                        ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField1-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                                                        ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField2-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                                                        ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField3-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                                                        ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField4-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v("Seçilen Kişiler")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('filters.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                                                                "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                                                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                                                                "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                                                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:'employee' + employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                                                            "+_vm._s(employee3.name)+"\n                                                            "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                            "+_vm._s(_vm.$ml.get('filters.employeeNotRecord'))+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2),expression:"activeScreen == 2"}],class:_vm.activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('reports.reportSettings'))+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group",staticStyle:{"width":"100%","margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('reports.startDate'))+":")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.endDate'))+"\n                                                        :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',[_c('h4',[_vm._v("\n                                                        "+_vm._s(_vm.$ml.get('reports.displayInReportDevices'))+"\n                                                        "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckReaders ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllReaders()}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.checkThisDevices'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutListDoorType($event)}}},[_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.selectedDoorType == 4}},[_vm._v(_vm._s(_vm.$ml.get('employees.allDoors'))+"\n                                                            ")]),_vm._v(" "),_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedDoorType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.access'))+"\n                                                            ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedDoorType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.pdks'))+"\n                                                            ")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],attrs:{"value":"2"},domProps:{"selected":_vm.selectedDoorType == 2}},[_vm._v("\n                                                                "+_vm._s(_vm.$ml.get('employees.diningHall')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],attrs:{"value":"3"},domProps:{"selected":_vm.selectedDoorType == 3}},[_vm._v("\n                                                                "+_vm._s(_vm.$ml.get('employees.licencePlateRecognition'))+"\n                                                            ")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],attrs:{"value":"5"},domProps:{"selected":_vm.selectedDoorType == 5}},[_vm._v("\n                                                                "+_vm._s(_vm.$ml.get('employees.dormitoryDevice')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:'reader' + reader.readerId,staticStyle:{"cursor":"pointer"},on:{"click":function($event){reader.check == true ? reader.check = false : reader.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                                        "+_vm._s(_vm.$ml.get('reports.devicesNotFound'))+"\n                                                    ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getReportDetails()}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                                            "+_vm._s(_vm.$ml.get('reports.viewReport'))+"\n                                        ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 3),expression:"activeScreen == 3"}],class:_vm.activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}]},[_vm._v(_vm._s(_vm.selectedReportName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName == ''),expression:"selectedReportName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.report')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0 && _vm.reportDataList != null),expression:"authControl == 0 && reportDataList != null"}],staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                                "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n                                            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                                "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.selectedReportName)+"\n                                                    ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"12px"},attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',[_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.registrationNumber"))+"\n                                                        ")]),_vm._v(" "),_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.citizenshipNumber"))+"\n                                                        ")]),_vm._v(" "),_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.nameSurname"))+"\n                                                        ")]),_vm._v(" "),_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.status"))+"\n                                                        ")]),_vm._v(" "),_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.title"))+"\n                                                        ")]),_vm._v(" "),_c('th',{staticClass:"dep-baslik"},[_vm._v(_vm._s(_vm.$ml.get("reports.reports.VerticalFirstInLastOutReportHeaders.departmentName"))+"\n                                                        ")]),_vm._v(" "),_vm._l((_vm.reportHeaders),function(header){return _c('th',{key:header,staticClass:"dep-baslik",staticStyle:{"text-align":"center"},attrs:{"colspan":"2"}},[_vm._v("\n                                                            "+_vm._s(header)+"\n                                                        ")])})],2),_vm._v(" "),_c('tr',[_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_c('th',{staticClass:"dep-baslik"}),_vm._v(" "),_vm._l((_vm.reportHeaders.length * 2),function(a){return _c('th',{key:'f'+a,staticClass:"dep-baslik",staticStyle:{"text-align":"center"}},[_c('span',{domProps:{"textContent":_vm._s(a % 2 ? 'Giriş':'Çıkış')}})])})],2)]),_vm._v(" "),_vm._l((_vm.reportDataList),function(dep,index){return _c('tbody',{key:'body' + index},_vm._l((dep.veriler),function(data,index2){return _c('tr',{key:'data' + index2,class:index2 % 2 == 1 ? 'bg-secondary' : ''},[_c('td',[_vm._v(_vm._s(data.sicilNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.tcNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.adSoyad))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.statu))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.unvan))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(data.departman))]),_vm._v(" "),_vm._l((data.movements),function(movement,indexx){return _c('td',{key:'mv'+indexx,staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(movement.movement))])})],2)}),0)})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                            "+_vm._s(_vm.$ml.get('reports.noResults'))+"\n                                        ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:'sortDep' + dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                                    "+_vm._s(dep.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:'state' + state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(state.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:'status' + status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(status.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:'access' + acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(acc.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:'workGroup' + work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(work.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:'foodGroup' + foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(foodGroup.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollManagement_vue__ = __webpack_require__(144);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0784e696_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollManagement_vue__ = __webpack_require__(328);
function injectStyle (ssrContext) {
  __webpack_require__(326)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0784e696"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0784e696_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(327);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("524d103f", content, true, {});

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dep-baslik>th[data-v-0784e696]{font-weight:700;background-color:#3c8dbc;color:#fff}", ""]);

// exports


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12 col-lg-4",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"input-group",staticStyle:{"margin-top":"25px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('employees.searchEmployeeInList'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-2",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"input-group",staticStyle:{"width":"100%"}},[_c('label',[_vm._v("Başlangıç Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-2",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"input-group",staticStyle:{"width":"100%"}},[_c('label',[_vm._v("Bitiş Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-lg-4"},[_c('button',{staticClass:"btn btn-primary pull-right ",staticStyle:{"width":"100%","margin-top":"25px"},on:{"click":function($event){return _vm.getData()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n          Görüntüle\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success ",on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v(" Excele Aktar\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.payrollDataList.length > 0),expression:"payrollDataList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover",attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',{staticClass:"dep-baslik"},[_c('th'),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])]),_vm._v(" "),_c('th',[_vm._v("Çalışma Planı")]),_vm._v(" "),_c('th',[_vm._v("Mesai Tarihi")]),_vm._v(" "),_c('th',[_vm._v("İlk Giriş")]),_vm._v(" "),_c('th',[_vm._v("Son Çıkış")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('th',[_vm._v("İzin Açıklama")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_vm._l((_vm.filtered),function(employee1){return _c('tbody',{key:employee1.employeeId,class:_vm.employee.employeeId == employee1.employeeId ? 'bg-primary' : ''},[_c('tr',{staticClass:"text-bold"},[_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee1.registrationNumber))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("("+_vm._s(employee1.title)+")")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee1.workPlan))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(employee1.totalWorkTime))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(employee1.totalMissingHour))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(employee1.totalCalculatedOvertime))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(employee1.totalConfirmedOvertime))]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!employee1.isOpen),expression:"!employee1.isOpen"}],staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getPayrollDetail(employee1)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(employee1.isOpen),expression:"employee1.isOpen"}],staticClass:"btn btn-danger btn-sm",on:{"click":function($event){employee1.isOpen = false}}},[_c('i',{staticClass:"fa fa-times"})])])]),_vm._v(" "),_vm._l((employee1.payrollDetails),function(detail,index){return _c('tr',{directives:[{name:"show",rawName:"v-show",value:(employee1.payrollDetails.length > 0 && employee1.isOpen),expression:"employee1.payrollDetails.length > 0 && employee1.isOpen"}],key:detail.employeeId + '-' + index,staticStyle:{"background-color":"#f4f4f4"}},[_c('td',{staticStyle:{"cursor":"pointer"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":detail.check},on:{"click":function($event){return _vm.checkRow(detail)}}})]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.checkRow(detail)}}},[_vm._v(_vm._s(employee1.registrationNumber))]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.checkRow(detail)}}},[_vm._v("\n                      "+_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("("+_vm._s(employee1.title)+")")])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.changeWorkPlan(detail)}}},[_vm._v(_vm._s(detail.workPlan))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(detail.date))]),_vm._v(" "),_c('td',{staticClass:"text-center text-success",style:(detail.firstEntryModified ? 'text-decoration: underline;font-weight:bold;cursor:pointer;' : 'cursor:pointer;font-weight:bold;'),attrs:{"data-toggle":"tooltip","title":detail.firstEntryModified ? detail.firstEntry + ' (' + detail.firstEntryModifiedUserName + ')' : detail.firstEntry}},[_vm._v("\n                      "+_vm._s(_vm.toDateFormatGet(detail.firstEntry)))]),_vm._v(" "),_c('td',{staticClass:"text-center text-danger",style:(detail.lastExitModified ? 'text-decoration: underline;font-weight:bold;cursor:pointer;' : 'cursor:pointer;font-weight:bold;'),attrs:{"data-toggle":"tooltip","title":detail.lastExitModified ? detail.lastExit + ' (' + detail.lastExitModifiedUserName + ')' : detail.lastExit}},[_vm._v("\n                      "+_vm._s(_vm.toDateFormatGet(detail.lastExit)))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(detail.totalWorkTime))]),_vm._v(" "),_c('td',{class:detail.missingHour != '00:00' ? 'text-center text-danger' : 'text-center'},[_vm._v("\n                      "+_vm._s(detail.missingHour))]),_vm._v(" "),_c('td',{class:detail.calculatedOverTime != '00:00' ? 'text-center text-primary' : 'text-center'},[_vm._v("\n                      "+_vm._s(detail.calculatedOverTime))]),_vm._v(" "),_c('td',{class:detail.confirmedOverTime == '00:00' || detail.confirmedOverTime == detail.calculatedOverTime ? 'text-center' : 'text-center text-primary'},[_vm._v("\n                      "+_vm._s(detail.confirmedOverTime))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(detail.holidayDescription))]),_vm._v(" "),_c('td')])})],2)})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.payrollDataList.length == 0),expression:"payrollDataList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get("employees.employeeSearchNotFound"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckedRowList.length == 0),expression:"isCheckedRowList.length == 0"}],staticClass:"alert alert-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Lütfen bir seçim yapın...\n            ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckedRowList.length > 0),expression:"isCheckedRowList.length > 0"}],staticClass:"box-group",attrs:{"id":"titles"}},[_c('div',{staticClass:"panel box box-primary"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse in",attrs:{"id":"collapseOne","aria-expanded":"true"}},[_c('div',{staticClass:"box-body"},[_c('ul',{staticStyle:{"padding-inline-start":"10px"}},_vm._l((_vm.isCheckedRowList),function(al,index){return _c('li',{key:index,staticStyle:{"width":"100%","text-align":"left","font-size":"12px","margin-bottom":"10px"}},[_vm._v("\n                        "+_vm._s(al.registrationNumber)+" - "+_vm._s(al.name)+"\n                        "),_c('span',{staticClass:"label pull-right bg-blue",staticStyle:{"padding":"6px 5px","font-size":"12px","margin-bottom":"5px"}},[_vm._v(_vm._s(al.date))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"label bg-yellow",staticStyle:{"font-size":"12px","margin-top":"10px"}},[_vm._v(_vm._s(al.workPlan))])])}),0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckedRowList.length > 0),expression:"isCheckedRowList.length > 0"}],staticClass:"btn btn-danger",staticStyle:{"width":"100%"},attrs:{"data-toggle":"modal","data-target":"#changePayroll"}},[_vm._v("Çalışma Planı Güncelle")])])])]),_vm._v(" "),_c('div',{staticClass:"panel box box-danger"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",staticStyle:{"height":"0px"},attrs:{"id":"collapseTwo","aria-expanded":"false"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"accordion",attrs:{"id":"movements"}},_vm._l((_vm.selectedDateDetailList),function(dateDetail,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"mb-0",staticStyle:{"margin-top":"0px"}},[_c('button',{staticClass:"btn btn-secondary",staticStyle:{"width":"100%","text-align":"left","font-size":"12px"},attrs:{"type":"button","data-toggle":"collapse","data-target":'#movement' + index,"aria-expanded":"true","aria-controls":'movement' + index}},[_vm._v("\n                              "+_vm._s(dateDetail.registrationNumber)+" - "+_vm._s(dateDetail.employeeName)+"\n                              "),_c('span',{staticClass:"label pull-right bg-blue",staticStyle:{"padding":"6px 5px","font-size":"12px"}},[_vm._v(_vm._s(dateDetail.date))])])])]),_vm._v(" "),_c('div',{staticClass:"collapse in",attrs:{"id":'movement' + index,"data-parent":"#movements"}},[_c('div',{staticClass:"card-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut),expression:"isNewInOut"}]},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newInOut.date),expression:"newInOut.date"}],staticClass:"form-control text-center input-sm",attrs:{"type":"time"},domProps:{"value":(_vm.newInOut.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newInOut, "date", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"btn-group btn-group-toggle text-center",staticStyle:{"margin-top":"5px"}},[_c('button',{class:_vm.newInOut.inOrOut == 1 ? 'btn btn-success btn-sm' : 'btn btn-secondary btn-sm',on:{"click":function($event){_vm.newInOut.inOrOut = 1}}},[_vm._v("Giriş")]),_vm._v(" "),_c('button',{class:_vm.newInOut.inOrOut == 2 ? 'btn btn-danger btn-sm' : 'btn btn-secondary btn-sm',on:{"click":function($event){_vm.newInOut.inOrOut = 2}}},[_vm._v("Çıkış")])]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"margin-top":"5px","font-size":"12px"},on:{"change":function($event){return _vm.changeSelectedReader($event)}}},_vm._l((_vm.readerList),function(reader){return _c('option',{key:reader.id,domProps:{"selected":reader.id == _vm.newInOut.readerId,"value":reader.id}},[_vm._v(_vm._s(reader.name)+"\n                                ")])}),0),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"5px"}},[_c('button',{staticClass:"btn btn-success btn-sm",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.saveMovement(dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Kaydet\n                                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-secondary btn-sm",staticStyle:{"width":"100%"},on:{"click":function($event){_vm.isNewInOut = false}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v("İptal\n                                ")])])]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewInOut),expression:"!isNewInOut"}],staticClass:"btn btn-warning btn-sm",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.clearInOut()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Hareket\n                            ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"padding-inline-start":"0px"}},[_c('tbody',_vm._l((dateDetail.movements),function(movement){return _c('tr',{key:movement.id},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(movement.date),expression:"movement.date"}],staticClass:"form-control text-center input-sm",attrs:{"type":"time"},domProps:{"value":(movement.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(movement, "date", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"14px"}},[_c('span',{class:movement.inOrOut == 2 ? 'label bg-red' : 'label bg-green',staticStyle:{"cursor":"pointer","font-size":"10px","padding":"8px 5px"},domProps:{"textContent":_vm._s(movement.inOrOut == 2 ? 'Çıkış' : 'Giriş')},on:{"click":function($event){movement.inOrOut == 2 ? movement.inOrOut = 1 : movement.inOrOut = 2}}})]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-xs",attrs:{"title":"Güncelle"},on:{"click":function($event){return _vm.updateMovement(dateDetail.employeeId, dateDetail.employeeName, dateDetail.date, movement, dateDetail.registrationNumber)}}},[_c('i',{staticClass:"fa fa-refresh"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-xs",attrs:{"title":"Sil"},on:{"click":function($event){return _vm.deleteMovement(dateDetail.employeeId, dateDetail.employeeName, dateDetail.date, movement, dateDetail.registrationNumber)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"panel box box-success"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",staticStyle:{"height":"0px"},attrs:{"id":"collapseThree","aria-expanded":"false"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"accordion",attrs:{"id":"overtimes"}},_vm._l((_vm.selectedDateDetailList),function(dateDetail,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"mb-0",staticStyle:{"margin-top":"0px"}},[_c('button',{staticClass:"btn btn-secondary",staticStyle:{"width":"100%","text-align":"left","font-size":"12px"},attrs:{"type":"button","data-toggle":"collapse","data-target":'#overtime' + index,"aria-expanded":"true","aria-controls":'overtime' + index}},[_vm._v("\n                              "+_vm._s(dateDetail.registrationNumber)+" - "+_vm._s(dateDetail.employeeName)+"\n                              "),_c('span',{staticClass:"label pull-right bg-blue",staticStyle:{"padding":"6px 5px","font-size":"12px"}},[_vm._v(_vm._s(dateDetail.date))])])])]),_vm._v(" "),_c('div',{staticClass:"collapse in",attrs:{"id":'overtime' + index,"data-parent":"#overtimes"}},[_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-hover",staticStyle:{"padding-inline-start":"0px"}},[_vm._m(10,true),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',{staticClass:"text-center"},[_c('label',[_vm._v(_vm._s(dateDetail.overtimes.calculated))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('label',[_vm._v(_vm._s(dateDetail.overtimes.confirmed))])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('button',{staticClass:"btn btn-primary btn-xs",attrs:{"disabled":dateDetail.overtimes.calculated == '00:00' || dateDetail.overtimes.calculated == dateDetail.overtimes.confirmed,"title":"Onayla"},on:{"click":function($event){return _vm.confirmOverTime(dateDetail.overtimes.overTimeId, dateDetail.overtimes.confirmed, dateDetail.overtimes.calculated, dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)}}},[_c('i',{staticClass:"fa fa-check"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-xs",attrs:{"disabled":dateDetail.overtimes.confirmed == '00:00',"title":"Onaylananı Sil"},on:{"click":function($event){return _vm.deleteOverTime(dateDetail.overtimes.overTimeId, dateDetail.date, dateDetail.employeeId, dateDetail.employeeName, dateDetail.registrationNumber)}}},[_c('i',{staticClass:"fa fa-times"})])])])])])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"panel box box-success"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"panel-collapse collapse",staticStyle:{"height":"0px"},attrs:{"id":"collapseFour","aria-expanded":"false"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"accordion",attrs:{"id":"payrolls"}},_vm._l((_vm.selectedDateDetailList),function(dateDetail,index){return _c('div',{key:index,staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h2',{staticClass:"mb-0",staticStyle:{"margin-top":"0px"}},[_c('button',{staticClass:"btn btn-secondary",staticStyle:{"width":"100%","text-align":"left","font-size":"12px"},attrs:{"type":"button","data-toggle":"collapse","data-target":'#payroll' + index,"aria-expanded":"true","aria-controls":'payroll' + index}},[_vm._v("\n                              "+_vm._s(dateDetail.registrationNumber)+" - "+_vm._s(dateDetail.employeeName)+"\n                              "),_c('span',{staticClass:"label pull-right bg-blue",staticStyle:{"padding":"6px 5px","font-size":"12px"}},[_vm._v(_vm._s(dateDetail.date))])])])]),_vm._v(" "),_c('div',{staticClass:"collapse in",attrs:{"id":'payroll' + index,"data-parent":"#payrolls"}},[_c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table table-hover",staticStyle:{"padding-inline-start":"0px"}},[_c('tbody',_vm._l((dateDetail.payrolls),function(payroll){return _c('tr',{key:payroll.id},[_c('td',[_c('label',[_vm._v(_vm._s(payroll.time))])]),_vm._v(" "),_c('td',[_c('label',[_vm._v(_vm._s(payroll.payroll))])])])}),0)])])])])}),0)])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"changePayroll"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.updateWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6",staticStyle:{"color":"black","padding":"0px 10px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"450px","owerflow":"auto","background-color":"#fff"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allowenceList),function(allowence,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(allowence.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm ",staticStyle:{"width":"100%"},attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.setChangePayroll(allowence.id, true)}}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.updateAllowenceNotRecord'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"color":"black","padding":"0px 10px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length > 0),expression:"workGroupList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"450px","owerflow":"auto","background-color":"#fff"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.workGroupList),function(workGroup,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(workGroup.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm ",staticStyle:{"width":"100%"},attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.setChangePayroll(workGroup.id, false)}}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))])])])}),0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('employees.updateWorkPlanNotRecord'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(14),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.modules.customFieldName == '')?_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]):_c('span',[_vm._v(_vm._s(_vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.modules.customFieldName != '' ? _vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail') : _vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(15),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(16),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(17),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(18),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(19),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning ",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(20),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length > 0),expression:"sortableDepartmentList.length > 0"}],staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(21),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(22),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(23),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(24),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(25),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger ",staticStyle:{"width":"100%"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Kişileri Filtrele\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Puantaj Özeti")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                      Normal\n                      "),_c('br'),_vm._v("Çalışma\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                      Eksik\n                      "),_c('br'),_vm._v("Saat\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                      Hesaplanan\n                      "),_c('br'),_vm._v("F.M.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{staticClass:"text-center"},[_vm._v("\n                      Onaylanan\n                      "),_c('br'),_vm._v("F.M.\n                    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("İşlemler")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h4',{staticClass:"box-title"},[_c('a',{attrs:{"data-toggle":"collapse","data-parent":"#titles","href":"#collapseOne","aria-expanded":"true"}},[_c('i',{staticClass:"fa fa-briefcase"}),_vm._v(" Çalışma Planı\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h4',{staticClass:"box-title"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","data-parent":"#titles","href":"#collapseTwo","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-exchange"}),_vm._v(" Hareket\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h4',{staticClass:"box-title"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","data-parent":"#titles","href":"#collapseThree","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-calendar-check-o"}),_vm._v(" Fazla Mesai\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-center"},[_vm._v("Hesaplanan")]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v("Onaylanan")]),_vm._v(" "),_c('th',{staticClass:"text-center"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h4',{staticClass:"box-title"},[_c('a',{staticClass:"collapsed",attrs:{"data-toggle":"collapse","data-parent":"#titles","href":"#collapseFour","aria-expanded":"false"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Puantaj Detayı\n                    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollShiftManagement_vue__ = __webpack_require__(145);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7beda7d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollShiftManagement_vue__ = __webpack_require__(332);
function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7beda7d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollShiftManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7beda7d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollShiftManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2acc8ce8", content, true, {});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".default-label[data-v-7beda7d2]{background-color:#ecf0f5;color:#333}.selected-shift[data-v-7beda7d2],.selecting-hover[data-v-7beda7d2]:hover{background-color:#136edc;color:#fff}", ""]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12 col-md-5",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"input-group",staticStyle:{"margin-top":"25px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('employees.searchEmployeeInList'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.isLoading,"type":"button","data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Kişileri Filtrele\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Takvim")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWeek),expression:"selectedWeek"}],staticClass:"form-control",attrs:{"disabled":_vm.isLoading,"type":"week"},domProps:{"value":(_vm.selectedWeek)},on:{"change":function($event){return _vm.getDateOfIsOWeek()},"input":function($event){if($event.target.composing){ return; }_vm.selectedWeek=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4",staticStyle:{"padding-bottom":"5px","margin-top":"25px"}},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.getDateOfIsOWeek()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.view')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0 && _vm.shiftList.length > 0),expression:"employeeList.length > 0 && shiftList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printShiftPlan"}},[_c('table',{staticClass:"table table-hover table-bordered table-striped table-condensed"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('employees.nameSurname')))])]),_vm._v(" "),_vm._l((_vm.dayList),function(day,index){return _c('th',{key:index,staticClass:"text-center",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(day)),_c('br'),_vm._v(_vm._s(_vm._f("gunAdi")(day)))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.shiftList),function(employee1){return _c('tr',{key:employee1.empId},[_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm._f("fixedFive")(employee1.terminalNo)))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"text-weight":"bold"}},[_vm._v(_vm._s(employee1.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}],staticClass:"text-muted"},[_vm._v(_vm._s(employee1.title))])]),_vm._v(" "),_vm._l((employee1.shifts),function(shift,index){return _c('td',{key:employee1.empId + '-' + index,class:_vm.checkListControl(shift, employee1.empId) ? 'text-center selected-shift' : 'text-center',staticStyle:{"vertical-align":"middle","cursor":"pointer"},on:{"click":function($event){!_vm.selectedAllowence.id && !_vm.selectedWorkGroup.id ? _vm.selectShift(shift, employee1) : _vm.selectBatchShift(shift)}}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(shift.allowenceId == null && shift.workGroupId == 0),expression:"shift.allowenceId == null && shift.workGroupId == 0"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Planlanmadı\n                                            ")]),_vm._v(" "),_c('hr',{directives:[{name:"show",rawName:"v-show",value:((shift.allowenceId == null && shift.workGroupId == 0) && (shift.entry || shift.exit)),expression:"(shift.allowenceId == null && shift.workGroupId == 0) && (shift.entry || shift.exit)"}],staticStyle:{"margin-top":"5px","margin-bottom":"5px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.entry),expression:"shift.entry"}],class:_vm.bgColorShiftEntry(shift),staticStyle:{"padding":"10px","margin-bottom":"5px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(shift.entry,"ss:dd")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.exit),expression:"shift.exit"}],class:_vm.bgColorShiftExit(shift),staticStyle:{"padding":"10px","margin-bottom":"5px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(shift.exit,"ss:dd")))]),_vm._v(" "),_c('hr',{directives:[{name:"show",rawName:"v-show",value:((shift.entry || shift.exit) && (shift.allowenceId || shift.workGroupId)),expression:"(shift.entry || shift.exit) && (shift.allowenceId || shift.workGroupId)"}],staticStyle:{"margin-top":"5px","margin-bottom":"5px"}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.workGroupId),expression:"shift.workGroupId"}],staticStyle:{"padding":"5px 5px 0px 5px"}},[_vm._v("\n                                                "+_vm._s(shift.workGroupName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.allowenceId),expression:"shift.allowenceId"}],staticClass:"badge",style:(_vm.bgColorAllowence(shift.allowenceId) + 'padding:10px;')},[_vm._v(_vm._s(shift.allowenceName))])])})],2)}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0 || _vm.shiftList.length == 0),expression:"employeeList.length == 0 || shiftList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get("alerts.recordNotFound"))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWorkGroup.id || _vm.selectedAllowence.id),expression:"selectedWorkGroup.id || selectedAllowence.id"}],staticClass:"text-center text-bold"},[_c('span',[_vm._v(_vm._s(_vm.selectedWorkGroup.id ? _vm.selectedWorkGroup.name : _vm.selectedAllowence.name))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedBatchShiftList.length > 0),expression:"selectedBatchShiftList.length > 0"}],staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-success btn-block",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.saveBatchShift()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.update'))+"\n                        ")])]),_vm._v(" "),_c('div',{class:_vm.selectedBatchShiftList.length > 0 ? 'col-sm-6' : 'col-sm-12'},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWorkGroup.id || _vm.selectedAllowence.id),expression:"selectedWorkGroup.id || selectedAllowence.id"}],staticClass:"btn btn-danger btn-block",attrs:{"disabled":_vm.isLoading},on:{"click":function($event){return _vm.clearSelectedBatchShift()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.cancel'))+"\n                        ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedWorkGroup.id && !_vm.selectedAllowence.id),expression:"!selectedWorkGroup.id && !selectedAllowence.id"}],staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.workGroupIsActive = !_vm.workGroupIsActive}}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupIsActive),expression:"workGroupIsActive"}],staticClass:"box-body"},[_c('ul',_vm._l((_vm.workGroupList),function(workGroup){return _c('li',{key:workGroup.id},[_c('span',{class:_vm.selectedWorkGroup.id == workGroup.id ? 'text-primary text-bold' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectWorkGroup(workGroup)}}},[_vm._v(_vm._s(workGroup.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedWorkGroup.id && !_vm.selectedAllowence.id),expression:"!selectedWorkGroup.id && !selectedAllowence.id"}],staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.allowenceIsActive = !_vm.allowenceIsActive}}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceIsActive),expression:"allowenceIsActive"}],staticClass:"box-body"},[_c('ul',_vm._l((_vm.allowenceList),function(allowence){return _c('li',{key:allowence.id},[_c('span',{class:_vm.selectedAllowence.id == allowence.id ? 'text-primary text-bold' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectAllowence(allowence)}}},[_vm._v(_vm._s(allowence.name))])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                                        ")]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.modules.customFieldName == '')?_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]):_c('span',[_vm._v(_vm._s(_vm.modules.customFieldName + ' / ' +
                                        _vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.modules.customFieldName != '' ? _vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail') : _vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(7),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(8),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(9),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(10),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(11),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                                                "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                                            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v("\n                                            "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v("\n                                            "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v("\n                                            "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v("\n                                            "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length > 0),expression:"sortableDepartmentList.length > 0"}],staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                                    "+_vm._s(dep.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(state.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(status.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(acc.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(16),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(work.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(17),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(foodGroup.name)+"\n                                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-shift"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(18),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('span',[_vm._v(_vm._s(_vm.selectedEmployee.sicilNo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h4"},[_vm._v(_vm._s(_vm.selectedEmployee.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.selectedEmployee.title))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',[_vm._v("Tarih")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","font-size":"large"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.date,"gg.aa.yyyy"))+" "+_vm._s(_vm._f("gunAdi")(_vm.selectedShift.date)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("Çalışma Saatleri")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","font-size":"large"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.toleranceEntry,"ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.toleranceExit,"ss:dd")))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Çalışma Planı")]),_vm._v(" "),_c('select',{class:_vm.selectedShift.workGroupId == 0 || _vm.selectedShift.workGroupId == null ? 'form-control' : 'form-control label-success',on:{"change":function($event){return _vm.changeWorkGroup($event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.workGroupList),function(workGroup){return _c('option',{key:workGroup.id,domProps:{"value":workGroup.id,"selected":workGroup.id == _vm.selectedShift.workGroupId}},[_vm._v(_vm._s(workGroup.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İzin")]),_vm._v(" "),_c('select',{class:_vm.selectedShift.allowenceId == 0 || _vm.selectedShift.allowenceId == null ? 'form-control' : 'form-control label-success',on:{"change":function($event){return _vm.changeAllowence($event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.allowenceList),function(allowence){return _c('option',{key:allowence.id,domProps:{"value":allowence.id,"selected":allowence.id == _vm.selectedShift.allowenceId}},[_vm._v(_vm._s(allowence.name)+"\n                                        ")])})],2)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group text-center"},[_c('label',[_vm._v("İlk Giriş")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.entry),expression:"selectedShift.entry"}],staticStyle:{"font-size":"14px","padding":"7px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.entry,"gg.aa.yyyy")))]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.entry),expression:"selectedShift.entry"}],staticStyle:{"font-size":"14px","margin-top":"5px","padding":"7px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.entry,"ss:dd")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedShift.entry),expression:"!selectedShift.entry"}]},[_vm._v("-")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-xs-6"},[_c('div',{staticClass:"form-group text-center"},[_c('label',[_vm._v("Son Çıkış")]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.exit),expression:"selectedShift.exit"}],staticStyle:{"font-size":"14px","padding":"7px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.exit,"gg.aa.yyyy")))]),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.exit),expression:"selectedShift.exit"}],staticStyle:{"font-size":"14px","margin-top":"5px","padding":"7px"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.exit,"ss:dd")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedShift.exit),expression:"!selectedShift.exit"}]},[_vm._v("-")])])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Tüm Hareketler")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyInOutDetailList.length > 0),expression:"dailyInOutDetailList.length > 0"}],staticClass:"table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.movementOT')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.statusOT')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_vm._l((_vm.dailyInOutDetailList),function(inOutDetail,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(inOutDetail.date))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOutDetail.status == 'Giriş'),expression:"inOutDetail.status == 'Giriş'"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOutDetail.status == 'Çıkış'),expression:"inOutDetail.status == 'Çıkış'"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement')))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-xs btn-primary",on:{"click":function($event){return _vm.selectInOut2(inOutDetail)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-xs btn-danger",on:{"click":function($event){return _vm.deleteInOut2(inOutDetail.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyInOutDetailList.length == 0),expression:"dailyInOutDetailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.movementNotRecord'))+"\n                                ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveInOut2 == false && _vm.modules.saveMovementLog && _vm.authControl == 0),expression:"isActiveInOut2 == false && modules.saveMovementLog && authControl == 0"}],staticStyle:{"margin-top":"5px"}},[_c('button',{staticClass:"btn btn-sm btn-warning",staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.newInOut2()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                        "+_vm._s(_vm.$ml.get('employees.newMovement'))+"\n                                    ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActiveInOut2 == true),expression:"isActiveInOut2 == true"}],staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.timeMovement')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut2.inOutAdd),expression:"inOut2.inOutAdd"}],staticClass:"form-control input-sm",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut2.inOutAdd)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut2, "inOutAdd", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.readerMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",on:{"change":function($event){return _vm.changeInOutDoor2($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut2.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.activePDKSReaderList),function(door){return _c('option',{key:door.readerId,domProps:{"value":door.readerId,"selected":door.readerId == _vm.inOut2.readerId}},[_vm._v("\n                                                "+_vm._s(door.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.typeMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",on:{"change":function($event){return _vm.changeInOutType2($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut2.inOutType == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.inOut2.inOutType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.entryMovement'))+"\n                                            ")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.inOut2.inOutType == 2}},[_vm._v(_vm._s(_vm.$ml.get('employees.exitMovement'))+"\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.includePassiveMovements},on:{"change":function($event){_vm.includePassiveMovements == true ? _vm.includePassiveMovements = false : _vm.includePassiveMovements = true}}}),_vm._v("\n                                                "+_vm._s(_vm.$ml.get('employees.includePassivesMovement'))+"\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.doNotDeleteOvertimes},on:{"change":function($event){_vm.doNotDeleteOvertimes == true ? _vm.doNotDeleteOvertimes = false : _vm.doNotDeleteOvertimes = true}}}),_vm._v("\n                                                "+_vm._s(_vm.$ml.get('employees.confirmedOvertimeNotDeleted'))+"\n                                            ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut2 && _vm.authControl == 0),expression:"isNewInOut2 && authControl == 0"}],staticClass:"btn btn-success",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.addInOut2()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewInOut2 && _vm.authControl == 0),expression:"!isNewInOut2 && authControl == 0"}],staticClass:"btn btn-success",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.updateInOut2()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){_vm.isActiveInOut2 = false}}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('label',[_vm._v("Puantaj Detayı")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyPayrollDetailList.length > 0),expression:"dailyPayrollDetailList.length > 0"}],staticClass:"table-responsive no-padding"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.payrollTime')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.payroll')))])]),_vm._v(" "),_vm._l((_vm.dailyPayrollDetailList),function(payrollDetail,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(payrollDetail.time))]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(payrollDetail.payroll))])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.dailyPayrollDetailList.length == 0),expression:"dailyPayrollDetailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('employees.payrollNotRecord'))+"\n                                ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-6 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.calculatedOvertimeLong')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.selectedDailyPayrol.calculatedOverTime))])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12 col-md-6 text-center"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.confirmedOvertimeLong')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDailyPayrol.confirmedOverTime),expression:"selectedDailyPayrol.confirmedOverTime"}],staticClass:"form-control",staticStyle:{"color":"black"},attrs:{"disabled":_vm.selectedDailyPayrol.overTimeId == null,"type":"time"},domProps:{"value":(_vm.selectedDailyPayrol.confirmedOverTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedDailyPayrol, "confirmedOverTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDailyPayrol.overTimeId != null),expression:"selectedDailyPayrol.overTimeId != null"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimePlace')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimePlace($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTPlaceId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.overtimePlaceList),function(place){return _c('option',{key:place.id,domProps:{"selected":place.id == _vm.selectedOTPlaceId,"value":place.id}},[_vm._v(_vm._s(place.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDailyPayrol.overTimeId != null),expression:"selectedDailyPayrol.overTimeId != null"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.overtimeDescription')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOvertimeDescription($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedOTDescriptionId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                                        ")]),_vm._v(" "),_vm._l((_vm.overtimeDescriptionList),function(description){return _c('option',{key:description.id,domProps:{"selected":description.id == _vm.selectedOTDescriptionId,"value":description.id}},[_vm._v("\n                                            "+_vm._s(description.name))])})],2)]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedDailyPayrol.overTimeId != null),expression:"selectedDailyPayrol.overTimeId != null"}],staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.customConfirmOverTime()}}},[_vm._v(_vm._s(_vm.$ml.get('general.confirm')))])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveChangePayroll()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.update'))+"\n                        ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Çalışma Planı Takvimi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Çalışma Planları")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("İzinler")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Plan Detayı")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftManagement_vue__ = __webpack_require__(146);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1409ba58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftManagement_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(334)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1409ba58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1409ba58_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(335);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("0fc35353", content, true, {});

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".default-label[data-v-1409ba58]{background-color:#ecf0f5;color:#333}", ""]);

// exports


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftManagement')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftManagement')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12 col-md-5",staticStyle:{"padding-bottom":"10px"}},[_c('div',{staticClass:"input-group",staticStyle:{"margin-top":"25px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('employees.searchEmployeeInList'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.isLoading,"type":"button","data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Kişileri Filtrele\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-4",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Görüntüleme Tipi")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"disabled":_vm.isLoading},on:{"change":function($event){return _vm.changeScreen($event)}}},[_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.activeScreen == 2}},[_vm._v("Hafta Tatili Planı")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.getShiftAuthority.canSeeRealMovements),expression:"getShiftAuthority.canSeeRealMovements"}],attrs:{"value":"1"},domProps:{"selected":_vm.activeScreen == 1}},[_vm._v("Gerçekleşen Takvimi")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-3",staticStyle:{"padding-bottom":"5px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Takvim")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedWeek),expression:"selectedWeek"}],staticClass:"form-control",attrs:{"disabled":_vm.isLoading,"type":"week"},domProps:{"value":(_vm.selectedWeek)},on:{"change":function($event){return _vm.getDateOfIsOWeek()},"input":function($event){if($event.target.composing){ return; }_vm.selectedWeek=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[(_vm.activeScreen == 2)?_c('span',[_vm._v("Hafta Tatili Planı Takvimi")]):_vm._e(),_vm._v(" "),(_vm.activeScreen == 1)?_c('span',[_vm._v("Gerçekleşen Takvimi")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin && _vm.getShiftAuthority.canConfirmAllowence && _vm.activeScreen == 2),expression:"!isAdmin && getShiftAuthority.canConfirmAllowence && activeScreen == 2"}],staticClass:"badge label-info",staticStyle:{"padding":"10px"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                Onaylamak için planın üzerine tıklayın.\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isAdmin && _vm.getShiftAuthority.canPlanAllowence && _vm.activeScreen == 2),expression:"!isAdmin && getShiftAuthority.canPlanAllowence && activeScreen == 2"}],staticClass:"badge label-info",staticStyle:{"padding":"10px"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                Planlamak için günün üzerine tıklayın.\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin && !_vm.isConfirm && _vm.activeScreen == 2),expression:"isAdmin && !isConfirm && activeScreen == 2"}],staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.isConfirm = true}}},[_vm._v("Seçim Tipi: Planla")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isAdmin && _vm.isConfirm && _vm.activeScreen == 2),expression:"isAdmin && isConfirm && activeScreen == 2"}],staticClass:"btn btn-primary btn-sm",on:{"click":function($event){_vm.isConfirm = false}}},[_vm._v("Seçim Tipi: Onayla")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.shiftAuthStatus),expression:"!shiftAuthStatus"}],staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.shiftAuthControl()}}},[_c('i',{staticClass:"fa fa-lock"})])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0 && _vm.shiftList.length > 0),expression:"employeeList.length > 0 && shiftList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printShiftPlan"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.shiftList.length > 0),expression:"shiftList.length > 0"}]},[_vm._v("Gerçekleşen Takvimi")])]),_vm._v(" "),_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"min-width":"75px","vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('employees.deviceEmployeeNumber')))])]),_vm._v(" "),_c('th',{staticStyle:{"vertical-align":"middle"}},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('employees.nameSurname')))])]),_vm._v(" "),_vm._l((_vm.dayList),function(day,index){return _c('th',{key:index,staticClass:"text-center",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(day))])})],2)]),_vm._v(" "),_c('tbody',_vm._l((_vm.shiftList),function(employee1){return _c('tr',{key:employee1.empId},[_c('td',{staticClass:"text-center",staticStyle:{"vertical-align":"middle"}},[_vm._v(_vm._s(_vm._f("fixedFive")(employee1.terminalNo)))]),_vm._v(" "),_c('td',{staticStyle:{"vertical-align":"middle"}},[_c('span',{staticStyle:{"text-weight":"bold"}},[_vm._v(_vm._s(employee1.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}],staticClass:"text-muted"},[_vm._v(_vm._s(employee1.title))])]),_vm._v(" "),_vm._l((employee1.shifts),function(shift,index){return _c('td',{key:employee1.empId +'-'+ index,class:_vm.bgColor(shift.confirmStatus),staticStyle:{"vertical-align":"middle"},on:{"click":function($event){_vm.activeScreen == 2 ? _vm.selectAllowence(shift, employee1) : _vm.selectShift(shift, employee1)}}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2 && !shift.id && _vm.shiftDateAuth && shift.confirmStatus == 0),expression:"activeScreen == 2 && !shift.id && shiftDateAuth && shift.confirmStatus == 0"}],attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Planlanmadı\n                      ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.entry && !shift.allowenceId),expression:"shift.entry && !shift.allowenceId"}],class:_vm.bgColorShiftEntry(shift),staticStyle:{"padding":"10px","margin-bottom":"5px","cursor":"pointer"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(shift.entry,"ss:dd")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.exit && !shift.allowenceId),expression:"shift.exit && !shift.allowenceId"}],class:_vm.bgColorShiftExit(shift),staticStyle:{"padding":"10px","margin-bottom":"5px","cursor":"pointer"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(shift.exit,"ss:dd")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(shift.allowenceId),expression:"shift.allowenceId"}],staticClass:"badge label-info",staticStyle:{"padding":"10px","cursor":"pointer"}},[_vm._v(_vm._s(shift.allowenceName))])])})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.getShiftAuthority.canConfirmAllowence && _vm.monthOrWeekNumber != 0 && _vm.activeScreen == 2),expression:"getShiftAuthority.canConfirmAllowence && monthOrWeekNumber != 0 && activeScreen == 2"}],staticClass:"btn btn-success",on:{"click":function($event){return _vm.allConfirmShift()}}},[_vm._v("Tümünü Onayla")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0 || _vm.shiftList.length == 0),expression:"employeeList.length == 0 || shiftList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get("alerts.recordNotFound"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.modules.customFieldName == '')?_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]):_c('span',[_vm._v(_vm._s(_vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.modules.customFieldName != '' ? _vm.modules.customFieldName + ' / ' + _vm.$ml.get('filters.filterDocumentNoOrEmail') : _vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive==true ? _vm.filters.isActive=false : _vm.filters.isActive=true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length > 0),expression:"sortableDepartmentList.length > 0"}],staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck==true ? status.isCheck=false : status.isCheck=true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck==true ? acc.isCheck=false : acc.isCheck=true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck==true ? work.isCheck=false : work.isCheck=true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck==true ? foodGroup.isCheck=false : foodGroup.isCheck=true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-shift"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{domProps:{"textContent":_vm._s(!_vm.selectedShift.id || _vm.selectedShift.id == 0 ? 'Plan Oluştur' : 'Plan Güncelle')}})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.selectedEmployee.sicilNo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedEmployee.name))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.selectedEmployee.title))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',[_vm._v("Tarih")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-weight":"bold","font-size":"large"}},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.selectedShift.date,"gg.aa.yyyy")))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İzin")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAllowence($event)}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("İzin Yok")]),_vm._v(" "),_vm._l((_vm.allowenceList),function(allowence){return _c('option',{key:allowence.id,domProps:{"value":allowence.id,"selected":allowence.id == _vm.selectedShift.allowenceId}},[_vm._v(_vm._s(allowence.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Giriş Saati")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedShift.entry),expression:"selectedShift.entry"}],staticClass:"form-control",attrs:{"disabled":_vm.selectedShift.allowenceId && _vm.selectedShift.allowenceId != 0,"type":"datetime-local"},domProps:{"value":(_vm.selectedShift.entry)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedShift, "entry", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Çıkış Saati")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedShift.exit),expression:"selectedShift.exit"}],staticClass:"form-control",attrs:{"disabled":_vm.selectedShift.allowenceId && _vm.selectedShift.allowenceId != 0,"type":"datetime-local"},domProps:{"value":(_vm.selectedShift.exit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedShift, "exit", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.id || _vm.selectedShift.id != 0),expression:"selectedShift.id || selectedShift.id != 0"}],staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.delete'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedShift.id || _vm.selectedShift.id == 0),expression:"!selectedShift.id || selectedShift.id == 0"}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveShift()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.save'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedShift.id || _vm.selectedShift.id != 0),expression:"selectedShift.id || selectedShift.id != 0"}],staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveShift()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.update'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visitors_vue__ = __webpack_require__(147);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95565330_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visitors_vue__ = __webpack_require__(340);
function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-95565330"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Visitors_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95565330_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Visitors_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(339);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("522aaad3", content, true, {});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".overlay-wrapper .overlay>.fa[data-v-95565330],.tab-content .overlay>.fa[data-v-95565330]{position:absolute;top:50%;left:50%;margin-left:-15px;margin-top:-15px;color:#000;font-size:30px}.overlay-wrapper>.loading-img[data-v-95565330],.overlay-wrapper>.overlay[data-v-95565330],.tab-content>.loading-img[data-v-95565330],.tab-content>.overlay[data-v-95565330]{position:absolute;top:0;left:0;width:100%;height:100%}.tab-content .overlay[data-v-95565330]{z-index:50;background:hsla(0,0%,100%,.7);border-radius:3px}.nav-stacked>li>span[data-v-95565330]{border-radius:0;border-top:0;border-left:3px solid transparent;color:#444}.nav>li>span[data-v-95565330]{position:relative;display:block;padding:10px 15px}", ""]);

// exports


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v("\n        "+_vm._s(_vm.$ml.get('shared.visitors'))+"\n        "),_c('i',{staticClass:"fa fa-dot-circle-o",style:(_vm.connection == true ? 'color:green;' : 'color:red;')})])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#beklenenler","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 1}}},[_vm._v(_vm._s(_vm.$ml.get('visitors.waitingVisitors')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#karaListe","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 2}}},[_vm._v(_vm._s(_vm.$ml.get('visitors.blackList')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#gelisNedenleri","data-toggle":"tab"},on:{"click":function($event){_vm.activeTab = 3}}},[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))])]),_vm._v(" "),_c('li',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 1),expression:"activeTab == 1"}],staticClass:"btn btn-sm btn-warning ",attrs:{"data-toggle":"modal","data-target":"#modal-waitingVisitor"},on:{"click":function($event){return _vm.newWaitingVisitor()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.addNew'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 2),expression:"activeTab == 2"}],staticClass:"btn btn-sm btn-warning ",attrs:{"data-toggle":"modal","data-target":"#modal-blacklist"},on:{"click":function($event){return _vm.newBlacklistVisitor()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.addNew'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeTab == 3),expression:"activeTab == 3"}],staticClass:"btn btn-sm btn-warning ",attrs:{"data-toggle":"modal","data-target":"#modal-gelisNedenleri"},on:{"click":function($event){return _vm.newGelisNedeni()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.addNew'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"beklenenler"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.waitingVisitorList.length > 0),expression:"waitingVisitorList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.visitorName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.appointmentTime')))]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"140px"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.waitingVisitorList),function(waitingVisitor1){return _c('tr',{key:waitingVisitor1.id},[_c('td',[_vm._v(_vm._s(waitingVisitor1.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(waitingVisitor1.reason))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(waitingVisitor1.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-waitingVisitor","type":"button","title":"Düzenle"},on:{"click":function($event){return _vm.selectWaitingVisitor(waitingVisitor1.id, waitingVisitor1.identityNo, waitingVisitor1.name, waitingVisitor1.visitTo, waitingVisitor1.visitToSicil, waitingVisitor1.reason, waitingVisitor1.date, waitingVisitor1.description, waitingVisitor1.employeeId)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-hazir-kart","title":"Ziyaretçi Olarak Kaydet","type":"button"},on:{"click":function($event){return _vm.selectWaitingVisitor(waitingVisitor1.id, waitingVisitor1.identityNo, waitingVisitor1.name, waitingVisitor1.visitTo, waitingVisitor1.visitToSicil, waitingVisitor1.reason, waitingVisitor1.date, waitingVisitor1.description, waitingVisitor1.employeeId)}}},[_c('i',{staticClass:"fa fa-sign-out"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-delete-waitingVisitor","title":"Sil","type":"button"},on:{"click":function($event){return _vm.editWaitingVisitor(waitingVisitor1.id, waitingVisitor1.name)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.waitingVisitorList.length == 0),expression:"waitingVisitorList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('visitors.waitingVisitorNotRecord'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"karaListe"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.blacklistVisitorList.length > 0),expression:"blacklistVisitorList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.blackListName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.blackListDescription')))]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"140px"}})])]),_vm._v(" "),_c('tbody',_vm._l((_vm.blacklistVisitorList),function(blacklistVisitor1){return _c('tr',{key:blacklistVisitor1.id},[_c('td',[_vm._v(_vm._s(blacklistVisitor1.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(blacklistVisitor1.description))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-blacklist","type":"button"},on:{"click":function($event){return _vm.selectBlacklistVisitorDetail(blacklistVisitor1.id, blacklistVisitor1.name, blacklistVisitor1.identityNo, blacklistVisitor1.description)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-delete-blacklist","type":"button"},on:{"click":function($event){return _vm.editBlacklistVisitor(blacklistVisitor1.id, blacklistVisitor1.name)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.blacklistVisitorList.length == 0),expression:"blacklistVisitorList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('visitors.blackListNotRecord'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"gelisNedenleri"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gelisNedeniList.length > 0),expression:"gelisNedeniList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.gelisNedeniList),function(gelisNedeni1){return _c('tr',{key:gelisNedeni1.id},[_c('td',[_vm._v(_vm._s(gelisNedeni1.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-gelisNedenleri","type":"button"},on:{"click":function($event){return _vm.selectGelisNedeni(gelisNedeni1.id, gelisNedeni1.name)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-delete-reason","type":"button"},on:{"click":function($event){return _vm.editGelisNedeni(gelisNedeni1.id, gelisNedeni1.name)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.gelisNedeniList.length == 0),expression:"gelisNedeniList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('visitors.reasonForVisitNotRecord'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"dropdown active"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"data-toggle":"dropdown","href":"#"}},[_vm._v("\n                "+_vm._s(_vm.selectedGroupName)+"\n                "),_c('span',{staticClass:"caret"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._l((_vm.cardGroupList),function(cardGroup1){return _c('li',{key:cardGroup1.id,attrs:{"role":"presentation"}},[_c('a',{attrs:{"href":"#","role":"menuitem"},on:{"click":function($event){return _vm.getVisitorCards(cardGroup1.id, cardGroup1.name)}}},[_vm._v(_vm._s(cardGroup1.name))])])}),_vm._v(" "),_c('li',{staticClass:"divider",attrs:{"role":"presentation"}}),_vm._v(" "),_c('li',{attrs:{"role":"presentation"}},[_c('a',{attrs:{"role":"menuitem","href":"#"},on:{"click":function($event){_vm.getVisitorCards(0, _vm.$ml.get('general.all'))}}},[_vm._v(_vm._s(_vm.$ml.get('general.all')))])])],2)]),_vm._v(" "),_c('li',{staticClass:"pull-right"})]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_1"}},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('visitors.searchVisitorCardFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorCardFilteredList.length > 0),expression:"visitorCardFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowVisitorsHeightSize)},[_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.visitorCardFilteredList),function(visitorCard1){return _c('tr',{key:visitorCard1.id},[_c('td',[_vm._v(_vm._s(visitorCard1.cardName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(visitorCard1.lastPerson))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Kullanımda'),expression:"visitorCard1.status == 'Kullanımda'"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('visitors.inUse')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Hazır'),expression:"visitorCard1.status == 'Hazır'"}],staticClass:"badge label-success"},[_vm._v(_vm._s(_vm.$ml.get('visitors.ready')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Geçici Verildi'),expression:"visitorCard1.status == 'Geçici Verildi'"}],staticClass:"badge label-warning"},[_vm._v(_vm._s(_vm.$ml.get('visitors.givenTemporary')))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Kullanımda'),expression:"visitorCard1.status == 'Kullanımda'"}],staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-visitor"},on:{"click":function($event){return _vm.getVisitorCardDetails(visitorCard1.id)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Kullanımda' || visitorCard1.status == 'Geçici Verildi'),expression:"visitorCard1.status == 'Kullanımda' || visitorCard1.status == 'Geçici Verildi'"}],staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.exitVisitor(visitorCard1.id)}}},[_c('i',{staticClass:"fa fa-sign-out"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Hazır'),expression:"visitorCard1.status == 'Hazır'"}],staticClass:"btn btn-sm btn-success",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-visitor"},on:{"click":function($event){return _vm.selectVisitor(visitorCard1.id)}}},[_c('i',{staticClass:"fa fa-sign-out"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorCardFilteredList.length == 0),expression:"visitorCardFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('visitors.visitorCardNotRecord'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingVisitor}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitors.employeeStatus')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"İsim yazın ve enter tuşuna basın..."},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",attrs:{"type":"button"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0),expression:"employeeList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowEmployeesHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.employeeList),function(employee1){return _c('tr',{key:employee1.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getEmployeeDetail(employee1.id, 1)}}},[_c('td',[_vm._v(_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("\n                        ("+_vm._s(employee1.title)+")\n                      ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0),expression:"employeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('visitors.employeeNotRecord'))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"box box-widget widget-user",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"widget-user-header bg-primary"},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.name != ''),expression:"employee.name != ''"}],staticClass:"widget-user-username"},[_vm._v(_vm._s(_vm.employee.name))]),_vm._v(" "),_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.title != ''),expression:"employee.title != ''"}],staticClass:"widget-user-desc",staticStyle:{"font-style":"italic"}},[_vm._v("\n                  "+_vm._s(_vm.employee.title))]),_vm._v(" "),_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.status != '' || _vm.employee.state),expression:"employee.status != '' || employee.state"}],staticClass:"widget-user-desc",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(_vm.employee.status)+" "),_c('span',{class:_vm.employee.state == 'Aktif' ? 'badge label-success' : 'badge label-danger'},[_vm._v(_vm._s(_vm.employee.state))])]),_vm._v(" "),_c('h5',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.department != ''),expression:"employee.department != ''"}],staticClass:"widget-user-desc"},[_vm._v(_vm._s(_vm.employee.department))]),_vm._v(" "),_c('div',{staticClass:"widget-user-image"},[_c('img',{staticClass:"img-circle",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":this.employee.photo == null || this.employee.photo == '' ? '/src/assets/default-user.png' : this.employee.photo}})])]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('ul',{staticClass:"nav nav-stacked"},[_c('li',{staticClass:"align-content-center",staticStyle:{"display":"inline-flex","width":"100%","justify-content":"space-between","align-items":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.lastStatus == 1),expression:"employee.lastStatus == 1"}],staticClass:"pull-left badge label-success"},[_vm._v(_vm._s(_vm.$ml.get('visitors.in')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.lastStatus == 2),expression:"employee.lastStatus == 2"}],staticClass:"pull-left badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('visitors.out')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.lastStatus == null || _vm.employee.lastStatus == 0),expression:"employee.lastStatus == null || employee.lastStatus == 0"}],staticClass:"pull-right badge label-primary"},[_vm._v(_vm._s(_vm.$ml.get('visitors.noLatestStatusInformation')))]),_vm._v(" "),_c('span',{staticClass:"pull-right"},[_c('div',{staticClass:"text-right"},[_vm._v(_vm._s(_vm.employee.lastMovementPoint)),_c('br'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.lastMovementTime != null),expression:"employee.lastMovementTime != null"}],staticClass:"text-right text-bold"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.lastMovementTime,"gg.aa.yyyy ss:dd")))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-gelisNedenleri"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonsForVisit')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gelisNedeni.name),expression:"gelisNedeni.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.gelisNedeni.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gelisNedeni, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveGelisNedeni()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewGelisNedeni),expression:"isNewGelisNedeni"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGelisNedeni),expression:"!isNewGelisNedeni"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-blacklist"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.blackList')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.citizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.blacklistVisitor.identityNo),expression:"blacklistVisitor.identityNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.blacklistVisitor.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blacklistVisitor, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.blackListName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.blacklistVisitor.name),expression:"blacklistVisitor.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.blacklistVisitor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blacklistVisitor, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.blackListDescription')))]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.blacklistVisitor.description),expression:"blacklistVisitor.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.blacklistVisitor.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.blacklistVisitor, "description", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveBlacklist()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewBlacklist),expression:"isNewBlacklist"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewBlacklist),expression:"!isNewBlacklist"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-visitor"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.visitorInformation'))+" | "+_vm._s(_vm.visitorCard.cardName)+" |\n                "+_vm._s(_vm.visitor.entryDate))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitors.previousSimilarRecords')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.oldRecordList.length > 0),expression:"oldRecordList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.oldRecordList),function(oldRecord1){return _c('tr',{key:oldRecord1.id},[_c('td',[_vm._v(_vm._s(oldRecord1.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(oldRecord1.identityNo))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.getOldRecordDetail(oldRecord1.name, oldRecord1.identityNo, oldRecord1.reason, oldRecord1.toWho, oldRecord1.description, oldRecord1.mobilePhone, oldRecord1.employeeId)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.oldRecordList.length == 0),expression:"oldRecordList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.similarRecordNotFound'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingVisitor}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('h4',{staticClass:"box-title"},[_vm._v("Kişi ve Departmanlar")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"})]),_vm._v(" "),_c('div',{staticClass:"box-body",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"İsim yazın ve enter tuşuna basın..."},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchText2 == ''),expression:"searchText2 == ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchText2 != ''),expression:"searchText2 != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){_vm.searchText2 = ''}}},[_c('i',{staticClass:"fa fa-remove"})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0 || _vm.departmentList.length > 0),expression:"employeeList.length > 0 || departmentList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"300px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.employeeFilteredList),function(employee){return _c('tr',{key:'emp' + employee.id},[_c('td',{class:_vm.visitor.employeeId == employee.id ? 'bg-success' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getEmployeeDetail(employee.id, 2)}}},[_c('i',{staticClass:"fa fa-user"}),_vm._v("\n                              "+_vm._s(employee.name)+"\n                              "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee.title),expression:"employee.title"}]},[_vm._v("- "+_vm._s(employee.title))])])])}),_vm._v(" "),_vm._l((_vm.departmentFilteredList),function(department){return _c('tr',{key:'dep-' + department.id},[_c('td',{class:_vm.visitor.departmentId == department.id ? 'bg-success' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getDepartmentDetail(department.id)}}},[_c('i',{staticClass:"fa fa-building"}),_vm._v("\n                              "+_vm._s(department.name)+"\n                            ")])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0 && _vm.departmentFilteredList.length == 0),expression:"employeeFilteredList.length == 0 && departmentFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitorTemporaryCard == true),expression:"modules.visitorTemporaryCard == true"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{class:_vm.visitor.isTemporaryCard == false ? 'btn btn-success active' : 'btn btn-default',staticStyle:{"width":"100%"},on:{"click":function($event){_vm.visitor.isTemporaryCard = false}}},[_c('i',{staticClass:"fa fa-id-card-o"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.visitorCard'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{class:_vm.visitor.isTemporaryCard == true ? 'btn btn-success active' : 'btn btn-default',staticStyle:{"width":"100%"},on:{"click":function($event){_vm.visitor.isTemporaryCard = true}}},[_c('i',{staticClass:"fa fa-address-card"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.temporaryCardForEmployee'))+"\n                    ")])])]),_vm._v(" "),_c('hr',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitorTemporaryCard == true),expression:"modules.visitorTemporaryCard == true"}]}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.isTemporaryCard == false),expression:"visitor.isTemporaryCard == false"}]},[_c('div',{staticClass:"form-group col-sm-6",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOldRecords(_vm.visitor.name, _vm.visitor.identityNo)}}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.nameSurname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitor.name),expression:"visitor.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.visitor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitor, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getOldRecords(_vm.visitor.name, _vm.visitor.identityNo)}}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.citizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitor.identityNo),expression:"visitor.identityNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.visitor.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitor, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeNeden1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.visitor.reason == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.gelisNedeniList),function(neden){return _c('option',{key:neden.id,domProps:{"selected":_vm.visitor.reason == neden.name,"value":neden.name}},[_vm._v(_vm._s(neden.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.mobilePhone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitor.mobilePhone),expression:"visitor.mobilePhone"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.visitor.mobilePhone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitor, "mobilePhone", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.where')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeToWho($event)}}},[_c('option',{attrs:{"value":"Şahıs"},domProps:{"selected":_vm.visitor.toWho == 'Şahıs'}},[_vm._v(_vm._s(_vm.$ml.get('visitors.person'))+"\n                        ")]),_vm._v(" "),_c('option',{attrs:{"value":"Firma"},domProps:{"selected":_vm.visitor.toWho == 'Firma'}},[_vm._v(_vm._s(_vm.$ml.get('visitors.company'))+"\n                        ")]),_vm._v(" "),_c('option',{attrs:{"value":"Diğer"},domProps:{"selected":_vm.visitor.toWho == 'Diğer'}},[_vm._v(_vm._s(_vm.$ml.get('visitors.other'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.description')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.visitor.description),expression:"visitor.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.visitor.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.visitor, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("Ziyaret Edilen Departman")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.getDepartmentName(_vm.visitor.departmentId)))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.departmentId == null),expression:"visitor.departmentId == null"}],staticClass:"btn btn-danger",on:{"click":function($event){_vm.visitor.departmentId = null}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.departmentId != null && _vm.visitor.departmentId != ''),expression:"visitor.departmentId != null && visitor.departmentId != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){_vm.visitor.departmentId = null}}},[_c('i',{staticClass:"fa fa-remove"})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.isTemporaryCard == false),expression:"visitor.isTemporaryCard == false"}]},[_vm._v(_vm._s(_vm.$ml.get('visitors.visitedEmployeeInformation')))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.isTemporaryCard == true),expression:"visitor.isTemporaryCard == true"}]},[_vm._v(_vm._s(_vm.$ml.get('visitors.employeeInformation')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitor.employeeId),expression:"visitor.employeeId"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.cancelEmployee()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.remove'))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"box box-widget widget-user-2"},[_c('div',{staticClass:"widget-user-header bg-primary"},[_c('div',{staticClass:"widget-user-image"},[_c('img',{staticClass:"img-circle",staticStyle:{"width":"70px","height":"70px"},attrs:{"src":this.employeeVisitor.photo == null || this.employeeVisitor.photo == '' ? '/src/assets/default-user.png' : this.employeeVisitor.photo}})]),_vm._v(" "),_c('h3',{staticClass:"widget-user-username"},[_vm._v("\n                          "+_vm._s(_vm.employeeVisitor.name)+"\n                          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeVisitor.name == ''),expression:"employeeVisitor.name == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('visitors.selectEmployee')))])]),_vm._v(" "),_c('h5',{staticClass:"widget-user-desc"},[_vm._v("\n                          "+_vm._s(_vm.employeeVisitor.title)+"\n                          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeVisitor.title == ''),expression:"employeeVisitor.title == ''"}]},[_vm._v("-")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!(!_vm.isNewVisitor && _vm.visitor.isTemporaryCard == true)),expression:"!(!isNewVisitor && visitor.isTemporaryCard == true)"}],staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveVisitor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewVisitor),expression:"isNewVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewVisitor),expression:"!isNewVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-waitingVisitor"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.waitingVisitorInformation')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitors.employeeList')))]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('visitors.employeeSearch')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"600px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.employeeFilteredList),function(employee){return _c('tr',{key:employee.id},[_c('td',[_vm._v("\n                              "+_vm._s(employee.name)+"\n                              "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee.title),expression:"employee.title"}]},[_vm._v("- "+_vm._s(employee.title))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.getEmployeeDetail(employee.id, 3)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.citizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.waitingVisitor.identityNo),expression:"waitingVisitor.identityNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.waitingVisitor.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.waitingVisitor, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.nameSurname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.waitingVisitor.name),expression:"waitingVisitor.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.waitingVisitor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.waitingVisitor, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.appointmentTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.waitingVisitor.date),expression:"waitingVisitor.date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.waitingVisitor.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.waitingVisitor, "date", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.reasonForVisit')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeNeden2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.waitingVisitor.reason == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.gelisNedeniList),function(neden2){return _c('option',{key:neden2.id,domProps:{"selected":_vm.waitingVisitor.reason == neden2.name,"value":neden2.name}},[_vm._v(_vm._s(neden2.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.description')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.waitingVisitor.description),expression:"waitingVisitor.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.waitingVisitor.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.waitingVisitor, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitors.visitedEmployeeInformation')))]),_vm._v(" "),_c('div',{staticClass:"box box-widget widget-user-2"},[_c('div',{staticClass:"widget-user-header bg-primary"},[_c('div',{staticClass:"widget-user-image"},[_c('img',{staticClass:"img-circle",staticStyle:{"width":"70px","height":"70px"},attrs:{"src":this.employeeVisitor.photo == null || this.employeeVisitor.photo == '' ? '/src/assets/default-user.png' : this.employeeVisitor.photo}})]),_vm._v(" "),_c('h3',{staticClass:"widget-user-username"},[_vm._v("\n                        "+_vm._s(_vm.employeeVisitor.name)+"\n                        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeVisitor.name == ''),expression:"employeeVisitor.name == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('visitors.noContactInformation')))])]),_vm._v(" "),_c('h5',{staticClass:"widget-user-desc"},[_vm._v("\n                        "+_vm._s(_vm.employeeVisitor.title)+"\n                        "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeVisitor.title == ''),expression:"employeeVisitor.title == ''"}]},[_vm._v("-")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWaitingVisitor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewWaitingVisitor),expression:"isNewWaitingVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWaitingVisitor),expression:"!isNewWaitingVisitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-hazir-kart"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.selectVisitorCardToGive')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitors.visitorCards')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hazirCardFilteredList.length > 0),expression:"hazirCardFilteredList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"300px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.hazirCardFilteredList),function(visitorCard1){return _c('tr',{key:visitorCard1.id},[_c('td',[_vm._v(_vm._s(visitorCard1.cardName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(visitorCard1.lastPerson))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Kullanımda'),expression:"visitorCard1.status == 'Kullanımda'"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('visitors.inUse')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(visitorCard1.status == 'Hazır'),expression:"visitorCard1.status == 'Hazır'"}],staticClass:"badge label-success"},[_vm._v(_vm._s(_vm.$ml.get('visitors.ready')))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWaitingVisitorToCard(visitorCard1.id)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('general.select2'))+"\n                              ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.hazirCardFilteredList.length == 0),expression:"hazirCardFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitors.readyToUseVisitorCardNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-delete-waitingVisitor"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.selectedWaitingVisitorName))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.isContinueDeleteWaitingVisitor')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteWaitingVisitor(_vm.selectedWaitingVisitorId)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-delete-blacklist"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.selectedBlackListName))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.isContinueDeleteBlackList')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteBlacklistVisitor(_vm.selectedBlackListId)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-delete-reason"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.selectedReasonName))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitors.isContinueDeleteReason')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteGelisNedeni(_vm.selectedReasonId)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',{staticStyle:{"min-width":"90px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorCards_vue__ = __webpack_require__(148);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd58c3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorCards_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7cd58c3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorCards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cd58c3a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorCards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(343);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("c8fc3376", content, true, {});

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.visitorCards")))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.dashboard")))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.visitors")))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.visitorCards")))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('visitorCards.searchVisitorCardInList')},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployeesFromCardNoFast(_vm.searchText)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("visitorCards.visitorCardList")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0),expression:"employeeList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee1){return _c('tr',{key:employee1.id,class:_vm.employee.id == employee1.id ? 'bg-primary': '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getEmployee(employee1.id)}}},[_c('td',[_vm._v(_vm._s(employee1.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("("+_vm._s(employee1.title)+")")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0),expression:"employeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get("visitorCards.visitorCardSearchNotFound"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("visitorCards.visitorCardInfo")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newEmployee()}}},[_vm._v(_vm._s(_vm.$ml.get("visitorCards.newVisitorCard")))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body box-profile"},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.employee.image),expression:"this.tempUrl || this.employee.image"}],staticClass:"text-red",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('visitorCards.removePhoto'))+"\n                      ")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":100,"height":100,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitorCards.selectPhoto'))+"\n                    ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"profile-username text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.name != ''),expression:"employee.name != ''"}]},[_vm._v(_vm._s(_vm.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.isActive == false),expression:"this.employee.isActive == false"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deletedRecord')))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.title != ''),expression:"employee.title != ''"}]},[_vm._v(_vm._s(_vm.employee.title))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null),expression:"employee.departmentId != null"}]},[_vm._v(_vm._s(_vm.getDepartmentFromId(_vm.employee.departmentId)))])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-unbordered"},[_c('li',{staticClass:"list-group-item"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.registrationNumber')))]),_vm._v(" :\n                        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo == ''),expression:"employee.sicilNo == ''"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo != ''),expression:"employee.sicilNo != ''"}]},[_vm._v(_vm._s(_vm.employee.sicilNo))])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.dateOfCreate')))]),_vm._v(" :\n                        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate == null),expression:"employee.startDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate != ''),expression:"employee.startDate != ''"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.startDate,"gg.aa.yyyy")))])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('div',{staticClass:"justify-between-content text-center"},[_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasPassword ? _vm.$ml.get('visitorCards.passwordExist') : _vm.$ml.get('visitorCards.passwordNotExist'),"src":_vm.employee.hasPassword ? '/src/assets/password-true.png' : '/src/assets/password-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasCard ? _vm.$ml.get('visitorCards.cardNumberExist') : _vm.$ml.get('visitorCards.cardNumberNotExist'),"src":_vm.employee.hasCard ? '/src/assets/card-true.png' : '/src/assets/card-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasFinger ? _vm.$ml.get('visitorCards.fingerprintExist') : _vm.$ml.get('visitorCards.fingerprintNotExist'),"src":_vm.employee.hasFinger ? '/src/assets/fingerprint-true.png' : '/src/assets/fingerprint-false.png'}}),_vm._v(" "),_c('img',{staticStyle:{"width":"30px","margin":"5px"},attrs:{"title":_vm.employee.hasFace ? _vm.$ml.get('visitorCards.faceTemplateExist') : _vm.$ml.get('visitorCards.faceTemplateNotExist'),"src":_vm.employee.hasFace ? '/src/assets/face-true.png' : '/src/assets/face-false.png'}})])])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#temel-bilgiler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.generalInformation')))])]),_vm._v(" "),_c('li',[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitorAccessGroups),expression:"modules.visitorAccessGroups"}],attrs:{"href":"#yetkiler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.accessAuthorities')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hareketler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.movements')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#islem-gecmisi","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.employeeLogs')))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"temel-bilgiler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.registrationNumberInfo')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.sicilNo),expression:"employee.sicilNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.sicilNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "sicilNo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getNewSicilveTerminalNo()}}},[_c('i',{staticClass:"fa fa-refresh"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.visitorCardGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeVisitorCardGroup($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.visitorCardGroupId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.visitorCardGroupList),function(visitorCardGroup){return _c('option',{key:visitorCardGroup.id,domProps:{"value":visitorCardGroup.id,"selected":visitorCardGroup.id == _vm.employee.visitorCardGroupId}},[_vm._v(_vm._s(visitorCardGroup.name))])})],2),_vm._v(" "),_vm._m(1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.cardName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.name),expression:"employee.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.department')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null && _vm.employee.departmentId != 0),expression:"employee.departmentId != null && employee.departmentId != 0"}],staticClass:"form-control",attrs:{"id":"selectedNode"},on:{"click":function($event){return _vm.selectNode()}}},[_vm._v(_vm._s(_vm.getDepartmentFromId(_vm.employee.departmentId)))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId == null || _vm.employee.departmentId == 0),expression:"employee.departmentId == null || employee.departmentId == 0"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null && _vm.employee.departmentId != ''),expression:"employee.departmentId != null && employee.departmentId != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){_vm.employee.departmentId = null}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.dateOfCreateInfo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.startDate),expression:"employee.startDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.employee.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "startDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.status')))]),_vm._v(" "),_c('div',{class:_vm.authControl == 0 ? 'input-group' : 'form-group'},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeStatus($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.statuId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.statuList),function(statu){return _c('option',{key:statu.id,domProps:{"value":statu.id,"selected":statu.id == _vm.employee.statuId}},[_vm._v(_vm._s(statu.name))])})],2),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"input-group-btn"},[_vm._m(3)])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deviceEmployeeNumber')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.terminalNo),expression:"employee.terminalNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.employee.terminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "terminalNo", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getNewSicilveTerminalNo()}}},[_c('i',{staticClass:"fa fa-refresh"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deviceStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeTerminalStatu($event)}}},[_c('option',{domProps:{"selected":_vm.employee.terminalStatu == 0,"value":0}},[_vm._v("User")]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.employee.terminalStatu == 3,"value":3}},[_vm._v("Admin")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deviceCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.cardNo),expression:"employee.cardNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.cardNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "cardNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.devicePassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.employee.terminalPassword),expression:"employee.terminalPassword"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.employee.terminalPassword)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.employee, "terminalPassword", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitorAccessGroups),expression:"modules.visitorAccessGroups"}],staticClass:"tab-pane",attrs:{"id":"yetkiler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.accessAuthoritiesInfo')))]),_vm._v(" "),_c('select',{staticClass:"form-control",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeAccessGroups($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.employee.accessGroupId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(acc){return _c('option',{key:acc.id,domProps:{"value":acc.id,"selected":acc.id == _vm.employee.accessGroupId}},[_vm._v(_vm._s(acc.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-sm btn-primary",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1},on:{"click":function($event){return _vm.sendUserToDevices()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('visitorCards.sendPersontoDevices'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deviceList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.activeReaderList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.readerNo)+" - "+_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('visitorCards.deviceNotRecord'))+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"hareketler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.movements')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0 && _vm.authControl == 0),expression:"inOutList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFHareketler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"pull-left",staticStyle:{"margin-bottom":"5px"}},[_c('button',{class:_vm.inOut.inOutListDoorType == 3 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListDoorType(3)}}},[_c('i',{staticClass:"fa fa-thumb-tack text-blue"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.allDoors'))+"\n                                ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListDoorType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListDoorType(1)}}},[_c('i',{staticClass:"fa fa-hourglass-2 text-blue"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.pdks'))+"\n                                ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListDoorType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListDoorType(0)}}},[_c('i',{staticClass:"fa fa-id-card text-blue"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.access'))+"\n                                ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],class:_vm.inOut.inOutListDoorType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListDoorType(2)}}},[_c('i',{staticClass:"fa fa-cutlery text-blue"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.diningHall'))+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"margin-bottom":"5px"}},[_c('button',{class:_vm.inOut.inOutListType == 0 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(0)}}},[_c('i',{staticClass:"fa fa-square text-blue"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.all'))+"\n                                ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListType == 1 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(1)}}},[_c('i',{staticClass:"fa fa-square text-green"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.active'))+"\n                                ")]),_vm._v(" "),_c('button',{class:_vm.inOut.inOutListType == 2 ? 'btn btn-default btn-sm active' : 'btn btn-default btn-sm',attrs:{"type":"button"},on:{"click":function($event){return _vm.changeInOutListType(2)}}},[_c('i',{staticClass:"fa fa-square text-red"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.passive'))+"\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.startDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutStartDate),expression:"inOut.inOutStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.endDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutEndDate),expression:"inOut.inOutEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isLoadingInOuts,"type":"button"},on:{"click":function($event){return _vm.getInOuts()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('visitorCards.searchMovements'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"},attrs:{"id":"printHareketler"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutStartDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.timeMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deviceMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.statusMovement')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}})]),_vm._v(" "),_vm._l((_vm.inOutFiltered),function(inOut2){return _c('tr',{key:inOut2.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(inOut2.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId != 0),expression:"inOut2.readerId != 0"}]},[_vm._v(_vm._s(inOut2.readerName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId == 0),expression:"inOut2.readerId == 0"}]},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.manuelMovement')))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut != 2),expression:"inOut2.inOrOut != 2"}],staticClass:"label btn-success"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.entryMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut == 2),expression:"inOut2.inOrOut == 2"}],staticClass:"label btn-danger"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.exitMovement')))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!inOut2.isActive),expression:"!inOut2.isActive"}],staticClass:"badge"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.passive')))])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length == 0),expression:"inOutList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.movementNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingInOuts}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"islem-gecmisi"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.employeeLogs')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0 && _vm.authControl == 0),expression:"logList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFLogs()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.startDateLogs')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logStartDate),expression:"logStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.logStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logStartDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.endDateLogs')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.logEndDate),expression:"logEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.logEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.logEndDate=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isNewEmployee && _vm.isLoadingLogs,"type":"button"},on:{"click":function($event){return _vm.getLogs()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('visitorCards.searchLogs'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"},attrs:{"id":"printLogs"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(this.logStartDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.logEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.timeLog')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.descriptionLog')))])]),_vm._v(" "),_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(log.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(log.description))])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('visitorCards.logNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingLogs}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"!isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","value":"Sil","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewEmployee && _vm.employee.isActive != false && _vm.authControl == 0),expression:"!isNewEmployee && employee.isActive != false && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.updateVisitorCard')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.isContinueUpdateVisitorCard')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveEmployee()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.saveVisitorCard')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.isContinueSaveVisitorCard')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveEmployee()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.deleteVisitorCard')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.isContinueDeleteVisitorCard')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteEmployee()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-yemek"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 1),expression:"selectedFoodType == 1"}]},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.addCredit')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 2),expression:"selectedFoodType == 2"}]},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.addBalance')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 1),expression:"selectedFoodType == 1"}]},[_c('p',{staticClass:"margin"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.amountOfCredit')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.selectedFoodCount > 0 ? _vm.selectedFoodCount -= 1 : _vm.selectedFoodCount}}},[_c('i',{staticClass:"fa fa-minus"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFoodCount),expression:"selectedFoodCount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","value":"0"},domProps:{"value":(_vm.selectedFoodCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedFoodCount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.selectedFoodCount += 1}}},[_c('i',{staticClass:"fa fa-plus"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 2),expression:"selectedFoodType == 2"}],staticClass:"input-group"},[_c('p',{staticClass:"margin"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.amountOfBalance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFoodCount),expression:"selectedFoodCount"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedFoodCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedFoodCount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.updateFoodCredit()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-visitor-card-group"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.visitorCardGroups')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.cardGroupList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newVisitorCardGroup()}}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.newCardGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorCardGroupList.length > 0),expression:"visitorCardGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.visitorCardGroupList),function(visitorGroup){return _c('tr',{key:visitorGroup.id},[_c('td',[_vm._v(_vm._s(visitorGroup.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectVisitorCardGroup(visitorGroup.id, visitorGroup.name, visitorGroup.devices)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorCardGroupList.length == 0),expression:"visitorCardGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitorCards.visitorCardGroupNotFound'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.cardGroupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedVisitorCardGroupName),expression:"selectedVisitorCardGroupName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedVisitorCardGroupName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedVisitorCardGroupName=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover",staticStyle:{"background-color":"white"}},[_c('tbody',_vm._l((_vm.activeReaderList),function(reader){return _c('tr',{key:reader.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){reader.VCGcheck ? reader.VCGcheck = false : reader.VCGcheck = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.VCGcheck)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"10px"}},[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"10px"}},[_vm._v(_vm._s(reader.readerNo)+" - "+_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('visitorCards.readerNotFound'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewVisitorCardGroup),expression:"!isNewVisitorCardGroup"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteVisitorCardGroup()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveVisitorCardGroup()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewVisitorCardGroup),expression:"isNewVisitorCardGroup"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewVisitorCardGroup),expression:"!isNewVisitorCardGroup"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-statu"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.statusTitle')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.statusList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newStatu()}}},[_vm._v(_vm._s(_vm.$ml.get('visitorCards.newStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length > 0),expression:"statuList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.statuList),function(statu){return _c('tr',{key:statu.id},[_c('td',[_vm._v(_vm._s(statu.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectStatu(statu.id, statu.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('visitorCards.statusNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.statusName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedStatuName),expression:"selectedStatuName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedStatuName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedStatuName=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewStatu),expression:"!isNewStatu"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteStatu()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveStatu()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewStatu),expression:"isNewStatu"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewStatu),expression:"!isNewStatu"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"select-department"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('visitorCards.selectDepartment')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length > 0),expression:"departmentList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('div',{attrs:{"id":"treeview"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length == 0),expression:"departmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('visitorCards.departmentNotRecord'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-visitor-card-group"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-statu"}},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorReports_vue__ = __webpack_require__(149);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68584ec2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorReports_vue__ = __webpack_require__(348);
function injectStyle (ssrContext) {
  __webpack_require__(346)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68584ec2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VisitorReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68584ec2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VisitorReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(347);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("797d6a92", content, true, {});

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".dep-baslik[data-v-68584ec2]{font-weight:700;background-color:#3c8dbc;color:#fff}", ""]);

// exports


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitorReports')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-address-card"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.visitorReports')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.activeScreen == 1 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 1}}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('filters.filterEmployees'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 2 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.selectReport'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 3 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 3}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.report'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],class:_vm.activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title,index){return _c('option',{key:'title' + index,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterVisitorCards')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isVisitor},on:{"change":function($event){_vm.filters.isVisitor == true ? _vm.filters.isVisitor = false : _vm.filters.isVisitor = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterShow'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField1-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField2-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField3-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField4-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v("Seçilen Kişiler")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('filters.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:'employee' + employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(employee3.name)+"\n                              "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2),expression:"activeScreen == 2"}],class:_vm.activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportSettings')))]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.report'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeSelectedReport($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))]),_vm._v(" "),_vm._l((_vm.reportList),function(report){return _c('option',{key:'report' + report.id,domProps:{"value":report.id}},[_vm._v(_vm._s(report.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"width":"100%","margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 14 || _vm.selectedReportId != 15),expression:"selectedReportId != 14 || selectedReportId != 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.startDate'))+"\n                              :")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15),expression:"selectedReportId == 14 || selectedReportId == 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.date'))+"\n                              :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 6 && _vm.selectedReportId != 7 && _vm.selectedReportId != 14 && _vm.selectedReportId != 15),expression:"selectedReportId != 6 && selectedReportId != 7 && selectedReportId != 14 && selectedReportId != 15"}],staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.endDate'))+" :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 10 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 10 || selectedReportId == 11"}]},[_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportOptions')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 11"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showAllowed},on:{"change":function($event){_vm.reportOptions.showAllowed == true ? _vm.reportOptions.showAllowed = false : _vm.reportOptions.showAllowed = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showAllowences'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 11 || _vm.selectedReportId == 10),expression:"selectedReportId == 11 || selectedReportId == 10"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showNonComers},on:{"change":function($event){_vm.reportOptions.showNonComers == true ? _vm.reportOptions.showNonComers = false : _vm.reportOptions.showNonComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showMissing'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1),expression:"selectedReportId == 1"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showLateComers},on:{"change":function($event){_vm.reportOptions.showLateComers == true ? _vm.reportOptions.showLateComers = false : _vm.reportOptions.showLateComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showLatecomer'))+"\n                            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 10),expression:"selectedReportId == 10"}],staticClass:"input-group mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportOptions.time),expression:"reportOptions.time"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reportOptions.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reportOptions, "time", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.fromTheClock')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-lg",on:{"change":function($event){return _vm.changeIsUpperFromTime($event)}}},[_c('option',{attrs:{"value":"false"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == false}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.lessEmployees')))]),_vm._v(" "),_c('option',{attrs:{"value":"true"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == true}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.moreEmployees')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 8),expression:"selectedReportId == 8"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportVisitorCardGroups'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckVG ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllVisitorGroups()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length > 0),expression:"visitorGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.visitorGroupList),function(visitorGroup){return _c('tr',{key:visitorGroup.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){visitorGroup.check == true ? visitorGroup.check = false : visitorGroup.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(visitorGroup.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(visitorGroup.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length == 0),expression:"visitorGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.visitorCardGroupNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 2 || _vm.selectedReportId == 6 || _vm.selectedReportId == 7 || _vm.selectedReportId == 11 || _vm.selectedReportId == 19 || _vm.selectedReportId == 20 || _vm.selectedReportId == 21 || _vm.selectedReportId == 31),expression:"selectedReportId == 1 || selectedReportId == 2 || selectedReportId == 6 || selectedReportId == 7 || selectedReportId == 11 || selectedReportId == 19 || selectedReportId == 20 || selectedReportId == 21 || selectedReportId == 31"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDevices'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckReaders ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllReaders()}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.checkThisDevices'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutListDoorType($event)}}},[_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.selectedDoorType == 4}},[_vm._v(_vm._s(_vm.$ml.get('employees.allDoors'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedDoorType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.access'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedDoorType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.pdks'))+"\n                              ")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],attrs:{"value":"2"},domProps:{"selected":_vm.selectedDoorType == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.diningHall')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],attrs:{"value":"3"},domProps:{"selected":_vm.selectedDoorType == 3}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.licencePlateRecognition')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],attrs:{"value":"5"},domProps:{"selected":_vm.selectedDoorType == 5}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.dormitoryDevice')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:'reader' + reader.readerId,staticStyle:{"cursor":"pointer"},on:{"click":function($event){reader.check == true ? reader.check = false : reader.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.devicesNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 12),expression:"selectedReportId == 12"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportAllowences'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckAllowences ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllAllowence()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allowenceList),function(allowence){return _c('tr',{key:'allowence' + allowence.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){allowence.check == true ? allowence.check = false : allowence.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(allowence.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allowence.shortCode)+" - "+_vm._s(allowence.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.allowenceNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15 || _vm.selectedReportId == 25 || _vm.selectedReportId == 30),expression:"selectedReportId == 14 || selectedReportId == 15 || selectedReportId == 25 || selectedReportId == 30"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDepartments'))+"\n                            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckDeps),expression:"isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(false)}}},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheckDeps),expression:"!isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(true)}}},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length > 0),expression:"departmentList.length > 0"}],staticClass:"table-responsive no-padding text-black",style:('background-style:white; ' + _vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.sortableDepartmentList),function(dep){return _c('tr',{key:'department' + dep.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){dep.check == true ? _vm.changeFilterDep2(dep, false) : _vm.changeFilterDep2(dep, true)}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(dep.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dep.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length == 0),expression:"departmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.departmentNotFound'))+"\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getReportDetails()}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.viewReport'))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 3),expression:"activeScreen == 3"}],class:_vm.activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}]},[_vm._v(_vm._s(_vm.selectedReportName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName == ''),expression:"selectedReportName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.report')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0 && _vm.reportDataList != null),expression:"authControl == 0 && reportDataList != null"}],staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n                      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.selectedReportName)+"\n                          ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"12px"},attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',_vm._l((_vm.reportHeaderList),function(header,indexHead){return _c('th',{key:'head' + indexHead,staticClass:"dep-baslik"},[_vm._v("\n                              "+_vm._s(header))])}),0)]),_vm._v(" "),_vm._l((_vm.reportDataList),function(dep,index){return _c('tbody',{key:'body' + index},[_c('tr',[_c('td',{staticClass:"dep-baslik",attrs:{"colspan":_vm.selectedReportId == 1 ? 7 : 37}},[_c('strong',[_vm._v(_vm._s(dep.departmanAdi))])])]),_vm._v(" "),_vm._l((dep.veriler),function(data,index2){return _c('tr',{key:'data' + index2,class:index2 % 2 == 1 ? 'bg-secondary' : ''},[_vm._l((dep.keys),function(key1,indexKey){return _c('td',{key:'key' + indexKey,class:_vm.customReportStyle(key1, data[key1])},[(_vm.selectedReportId == 19 && indexKey == 4 && data.positionX)?_c('span',[(data.positionX)?_c('a',{staticStyle:{"margin-top":"10px"},attrs:{"target":"_blank","href":'http://maps.google.com/maps?f=q&hl=en&q=' + data.positionX + '+N,+' + data.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + data.positionX + ',' + data.positionY + '&spn=0.003022,0.004989&t=k'}},[_vm._v(_vm._s(data.positionX)+"\n                                  - "+_vm._s(data.positionY))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedReportId == 32 && indexKey != 5) || (_vm.selectedReportId != 31 && _vm.selectedReportId != 32) || (_vm.selectedReportId == 31 && indexKey != 6 && indexKey != 7)),expression:"(selectedReportId == 32 && indexKey != 5) || (selectedReportId != 31 && selectedReportId != 32) || (selectedReportId == 31 && indexKey != 6 && indexKey != 7)"}]},[_vm._v(_vm._s(data[key1]))]),_vm._v(" "),(_vm.selectedReportId == 32 && indexKey == 5 && data[key1])?_c('span',[_c('i',{staticClass:"fa fa-times-circle text-danger"}),_vm._v(" İade Edildi\n                              ")]):_vm._e(),_vm._v(" "),(_vm.selectedReportId == 31 && (indexKey == 6 || indexKey == 7))?_c('img',{staticStyle:{"width":"200px"},attrs:{"src":data[key1]}}):_vm._e()])}),_vm._v(" "),_vm._l((data.movements),function(movement,index){return _c('td',{key:'visitorKey' + index,staticClass:"no-wrap"},[_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]},[_vm._v("GİRİŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}],staticClass:"text-success"},[_vm._v(_vm._s(movement.entryTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "+_vm._s(movement.entryReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]},[_vm._v("ÇIKIŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}],staticClass:"text-danger"},[_vm._v(_vm._s(movement.exitTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "+_vm._s(movement.exitReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]},[_vm._v("FARK")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}],staticClass:"text-primary"},[_vm._v(_vm._s(movement.timeDifference))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]})])})],2)})],2)})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"margin-right":"70px","margin-bottom":"40px"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.noResults'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:'sortDep' + dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:'state' + state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:'status' + status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:'access' + acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:'workGroup' + work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:'foodGroup' + foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_licensePlateRecognition_vue__ = __webpack_require__(150);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a60f9cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_licensePlateRecognition_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_licensePlateRecognition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a60f9cd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_licensePlateRecognition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licensePlateRecognition')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-car"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licensePlateRecognition')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.licensePlateList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.plateList.length > 0),expression:"plateList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.plateList),function(plate){return _c('tr',{key:plate.id},[_c('td',[_vm._v(_vm._s(plate.plate))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectPlate(plate)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.plateList.length == 0),expression:"plateList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('licensePlateRecognition.plateNumberNotExist'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.licensePlateInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newPlate()}}},[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.newLicensePlate')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.plateNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPlate.plate),expression:"selectedPlate.plate"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedPlate.plate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPlate, "plate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.employee')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.getNameFromId(_vm.selectedPlate.employeeId))}}),_vm._v(" "),_vm._m(0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.deviceList')))]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table no-margin"},[_c('tbody',_vm._l((_vm.readers),function(reader){return _c('tr',{key:reader.readerId},[_c('th',{staticStyle:{"width":"50px"}},[_c('input',{staticStyle:{"margin-right":"5px"},attrs:{"type":"checkbox","id":'check' + reader.readerId},domProps:{"checked":reader.check},on:{"change":function($event){reader.check = !reader.check}}}),_vm._v(" "),_c('label',{staticClass:"input-text",attrs:{"for":'check' + reader.readerId}},[_vm._v(_vm._s(reader.name))])])])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPlate && _vm.authControl == 0),expression:"!isNewPlate && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewPlate && _vm.authControl == 0),expression:"isNewPlate && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPlate && _vm.authControl == 0),expression:"!isNewPlate && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedPlate.plate))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.isContinueUpdateLicensePlate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.savePlate()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.selectedPlate.plate))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.isContinueSaveLicensePlate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.savePlate()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedPlate.plate))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('licensePlateRecognition.isContinueDeleteLicensePlate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deletePlate()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-xl fade",attrs:{"id":"modal-kisi-sec"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.selectEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('employees.searchFromNameSurname')},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0),expression:"employeeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.employeeList')))])]),_vm._v(" "),_vm._l((_vm.employeeList),function(employee3){return _c('tr',{key:employee3.id},[_c('td',[_vm._v("\n                          "+_vm._s(employee3.name)+"\n                          "),(employee3.title != '')?_c('span',[_vm._v("- "+_vm._s(employee3.title))]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){_vm.selectedPlate.employeeId = employee3.id}}},[_c('i',{staticClass:"fa fa-check"})])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0),expression:"employeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('employees.employeeSearchNotFound'))+"\n                ")])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-kisi-sec","type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroups_vue__ = __webpack_require__(151);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3940b2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroups_vue__ = __webpack_require__(352);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3940b2c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.foodGroups")))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.dashboard")))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.diningHall")))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get("shared.foodGroups")))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.foodGroupList")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length > 0),expression:"foodGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.foodGroupList),function(foodGroup){return _c('tr',{key:foodGroup.id},[_c('td',[_vm._v(_vm._s(foodGroup.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getFoodGroup(foodGroup.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get("foodGroups.foodGroupNotRecord"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.foodGroupInformation")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newFoodGroup()}}},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.newFoodGroup")))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.groupName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foodGroup.name),expression:"foodGroup.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.foodGroup.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.foodGroup, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.groupType"))+"-"+_vm._s(_vm.foodGroup.type))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeGroupType($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.foodGroup.type == 1}},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.deserveType")))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.foodGroup.type == 2}},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.creditType")))]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.foodGroup.type == 3}},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.balanceType")))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.dailyMealEatingCount")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.foodGroup.singleFoodEachMeal),expression:"foodGroup.singleFoodEachMeal"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.foodGroup.singleFoodEachMeal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.foodGroup, "singleFoodEachMeal", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFoodGroup),expression:"!isNewFoodGroup"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get("general.delete")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewFoodGroup),expression:"isNewFoodGroup"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get("general.save")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFoodGroup),expression:"!isNewFoodGroup"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get("general.update")))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.meals")))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-primary ",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-mealName"}},[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "+_vm._s(_vm.$ml.get("foodGroups.mealDefinitions")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFoodGroup),expression:"!isNewFoodGroup"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-meal"},on:{"click":function($event){return _vm.newFoodMeal()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get("foodGroups.newMeal")))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mealList.length > 0),expression:"mealList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowMealHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.mealList),function(meal){return _c('tr',{key:meal.id},[_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 1),expression:"meal.day == 1"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get("general.monday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 2),expression:"meal.day == 2"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get("general.tuesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 3),expression:"meal.day == 3"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get("general.wednesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 4),expression:"meal.day == 4"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get("general.thursday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 5),expression:"meal.day == 5"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get("general.friday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 6),expression:"meal.day == 6"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get("general.saturday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(meal.day == 7),expression:"meal.day == 7"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get("general.sunday")))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getMealNameFromId(meal.mealNameId)))]),_vm._v(" "),_c('td',[_c('span',{staticClass:"badge label-success"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(meal.startDate,"ss:dd")))]),_vm._v(" -\n                      "),_c('span',{staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(meal.endDate,"ss:dd")))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm ",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-meal"},on:{"click":function($event){return _vm.getFoodMeal(meal.id)}}},[_c('i',{staticClass:"fa fa-edit"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteMeal(meal.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mealList.length == 0),expression:"mealList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get("foodGroups.mealNotFoundSelectedFoodGroups"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingMeals}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.update")))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.foodGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.foodGroupUpdateIsContinue")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.cancel")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveFoodGroup()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.update")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.save")))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.foodGroup.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.foodGroupSaveIsContinue")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.cancel")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveFoodGroup()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.save")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.delete")))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.foodGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.foodGroupDeleteIsContinue")))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.cancel")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteFoodGroup()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.delete")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-meal"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewMeal),expression:"isNewMeal"}]},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.addNewMeal")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewMeal),expression:"!isNewMeal"}]},[_vm._v("\n                  "+_vm._s(_vm.getMealNameFromId(_vm.selectedMeal.mealNameId))+" :\n                  "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 1),expression:"selectedMeal.day == 1"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get("general.monday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 2),expression:"selectedMeal.day == 2"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get("general.tuesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 3),expression:"selectedMeal.day == 3"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get("general.wednesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 4),expression:"selectedMeal.day == 4"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get("general.thursday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 5),expression:"selectedMeal.day == 5"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get("general.friday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 6),expression:"selectedMeal.day == 6"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get("general.saturday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMeal.day == 7),expression:"selectedMeal.day == 7"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get("general.sunday")))])])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","margin-right":"5px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewMeal),expression:"isNewMeal"}],staticClass:"col-sm-4 table-responsive",staticStyle:{"height":"350px","overflow":"auto"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.validDays")))]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check==true ? day.check=false : day.check=true}}}),_vm._v("\n                            "+_vm._s(day.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{class:_vm.isNewMeal ? 'col-sm-6' : 'col-sm-12'},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.mealName")))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMealName($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedMeal.mealNameId == null}},[_vm._v(_vm._s(_vm.$ml.get("general.select")))]),_vm._v(" "),_vm._l((_vm.mealNameList),function(mealName){return _c('option',{key:mealName.id,domProps:{"value":mealName.id,"selected":mealName.id == _vm.selectedMeal.mealNameId}},[_vm._v(_vm._s(mealName.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.startTime")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMeal.startDate),expression:"selectedMeal.startDate"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedMeal.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMeal, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.endTime")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMeal.endDate),expression:"selectedMeal.endDate"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedMeal.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMeal, "endDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.eatingCount")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMeal.foodClaim),expression:"selectedMeal.foodClaim"}],staticClass:"form-control",attrs:{"type":"number","min":"1","value":"1"},domProps:{"value":(_vm.selectedMeal.foodClaim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMeal, "foodClaim", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.price")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMeal.price),expression:"selectedMeal.price"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedMeal.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMeal, "price", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.guestPrice")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMeal.price2),expression:"selectedMeal.price2"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('foodGroups.guestPrice')},domProps:{"value":(_vm.selectedMeal.price2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMeal, "price2", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger ",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.cancel")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveMeal()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.save")))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-mealName"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.mealNameDefinitions")))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.mealNameList")))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning ",on:{"click":function($event){return _vm.newMealName()}}},[_vm._v(_vm._s(_vm.$ml.get("foodGroups.newMealName")))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mealNameList.length > 0),expression:"mealNameList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.mealNameList),function(mealName){return _c('tr',{key:mealName.id},[_c('td',[_vm._v(_vm._s(mealName.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectMealName(mealName.id, mealName.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mealNameList.length == 0),expression:"mealNameList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get("foodGroups.mealNameNotRecord"))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get("foodGroups.mealName")))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMealName),expression:"selectedMealName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedMealName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedMealName=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get("general.cancel")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewMealName),expression:"!isNewMealName"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteMealName()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("general.delete")))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveMealName()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewMealName),expression:"isNewMealName"}]},[_vm._v(_vm._s(_vm.$ml.get("general.save")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewMealName),expression:"!isNewMealName"}]},[_vm._v(_vm._s(_vm.$ml.get("general.update")))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroupOperations_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c34812a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroupOperations_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(354)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4c34812a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroupOperations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c34812a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroupOperations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(355);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4905c235", content, true, {});

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.employeeOperations')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHall')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.employeeOperations')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('foodGroupOperations.searchEmployeeInList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.employeeList')))])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length > 0),expression:"employeeList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee1){return _c('tr',{key:employee1.id,class:_vm.employee.id == employee1.id ? 'bg-primary': '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getEmployee(employee1.id)}}},[_c('td',[_vm._v(_vm._s(employee1.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(employee1.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("("+_vm._s(employee1.title)+")")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeList.length == 0),expression:"employeeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('foodGroupOperations.employeeSearchNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.employeeInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body box-profile"},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.employee.image == null && this.tempUrl == null) || (this.employee.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.employee.image || this.tempUrl}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticClass:"profile-username text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.name != ''),expression:"employee.name != ''"}]},[_vm._v(_vm._s(_vm.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.isActive == false),expression:"this.employee.isActive == false"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.deletedRecord')))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.title != ''),expression:"employee.title != ''"}]},[_vm._v(_vm._s(_vm.employee.title))])]),_vm._v(" "),_c('p',{staticClass:"text-muted text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.departmentId != null),expression:"employee.departmentId != null"}]},[_vm._v(_vm._s(_vm.getDepartmentFromId(_vm.employee.departmentId)))])]),_vm._v(" "),_c('ul',{staticClass:"list-group list-group-unbordered"},[_c('li',{staticClass:"list-group-item"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.registrationNumber')))]),_vm._v(" :\n                        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo == ''),expression:"employee.sicilNo == ''"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo != ''),expression:"employee.sicilNo != ''"}]},[_vm._v(_vm._s(_vm.employee.sicilNo))])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_vm._m(2),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{staticClass:"label label-primary",staticStyle:{"font-size":"small"}},[_vm._v(_vm._s(_vm.employee.remainder))])])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodGroupType == 2),expression:"selectedFoodGroupType == 2"}],staticClass:"list-group-item"},[_vm._m(3),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{staticClass:"label label-primary",staticStyle:{"font-size":"small"}},[_vm._v(_vm._s(_vm.employee.credit))])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.dateOfStartWork')))]),_vm._v(" :\n                        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate == null),expression:"employee.startDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.startDate != ''),expression:"employee.startDate != ''"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.startDate,"gg.aa.yyyy")))])])]),_vm._v(" "),_c('li',{staticClass:"list-group-item"},[_c('b',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.dateOfEndWork')))]),_vm._v(" :\n                        ")]),_vm._v(" "),_c('a',{staticClass:"pull-right"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.endDate == null),expression:"employee.endDate == null"}]},[_vm._v("-")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.endDate != ''),expression:"employee.endDate != ''"}]},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(_vm.employee.endDate,"gg.aa.yyyy")))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#yemek-grubu","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.foodGroup')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#hareketler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.movements')))])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#retail-sale-logs","data-toggle":"tab","aria-expanded":"true"}},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.retailSaleLogs')))])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"yemek-grubu"}},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-9"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeFoodGroup($event)}}},[_c('option',{domProps:{"selected":_vm.employee.foodGroupId == 0,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.foodGroupList),function(foodGroup){return _c('option',{key:foodGroup.id,domProps:{"selected":_vm.employee.foodGroupId == foodGroup.id,"value":foodGroup.id}},[_vm._v(_vm._s(foodGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"100%"},attrs:{"disabled":_vm.isNewEmployee && _vm.authControl == 0,"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodGroupType == 3 || _vm.modules.dormitory),expression:"selectedFoodGroupType == 3 || modules.dormitory"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.availableBalance')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.employee.remainder)}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-yemek"},on:{"click":function($event){return _vm.selectFoodType(2, _vm.employee.remainder)}}},[_c('i',{staticClass:"fa fa-plus"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodGroupType == 2),expression:"selectedFoodGroupType == 2"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.remainingCredits')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.employee.credit)}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-yemek"},on:{"click":function($event){return _vm.selectFoodType(1, _vm.employee.credit)}}},[_c('i',{staticClass:"fa fa-plus"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.foodBalanceLogs')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodBalanceLogList.length > 0 && _vm.authControl == 0),expression:"foodBalanceLogList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFBakiyeHareketleri()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodBalanceLogList.length > 0),expression:"foodBalanceLogList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"},attrs:{"id":"printBakiyeLoglari"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodBalanceLogList.length > 0),expression:"foodBalanceLogList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(new Date(),"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticClass:"text-center",staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.time')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.amount')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.type')))]),_vm._v(" "),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.status')))])]),_vm._v(" "),_vm._l((_vm.foodBalanceLogList),function(foodBalance){return _c('tr',{key:foodBalance.id},[_c('td',{staticClass:"text-center"},[_vm._v(_vm._s(_vm._f("toDateFormatGet")(foodBalance.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',{staticClass:"text-center text-bold"},[_vm._v(_vm._s(foodBalance.amount))]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{staticClass:"badge label-primary",domProps:{"textContent":_vm._s(foodBalance.type == 1 ? _vm.$ml.get('general.credit') : _vm.$ml.get('general.balance'))}})]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(foodBalance.isAdded),expression:"foodBalance.isAdded"}],staticClass:"badge label-success"},[_vm._v(_vm._s(_vm.$ml.get('general.added')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!foodBalance.isAdded),expression:"!foodBalance.isAdded"}],staticClass:"badge label-danger"},[_vm._v(_vm._s(_vm.$ml.get('general.removed')))])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodBalanceLogList.length == 0),expression:"foodBalanceLogList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('foodGroupOperations.foodBalanceLogNotRecord'))+"\n                              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"hareketler"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.movements')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0 && _vm.authControl == 0),expression:"inOutList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFHareketler()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false),expression:"employee.isActive != false"}],staticClass:"btn btn-warning btn-sm",attrs:{"disabled":_vm.isNewEmployee || _vm.authControl == 1,"type":"button","data-toggle":"modal","data-target":"#modal-hareket-ekle"},on:{"click":function($event){return _vm.newInOut()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('foodGroupOperations.newMovement'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.startDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutStartDate),expression:"inOut.inOutStartDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutStartDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.endDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutEndDate),expression:"inOut.inOutEndDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.inOut.inOutEndDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutEndDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isLoadingInOuts,"type":"button"},on:{"click":function($event){return _vm.getInOuts()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('foodGroupOperations.searchMovements'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"},attrs:{"id":"printHareketler"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length > 0),expression:"inOutList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutStartDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.inOut.inOutEndDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',{staticStyle:{"width":"130px"}},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.timeMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.deviceMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.statusMovement')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.price')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}}),_vm._v(" "),_c('th',{staticStyle:{"width":"100px"}})]),_vm._v(" "),_vm._l((_vm.inOutFiltered),function(inOut2){return _c('tr',{key:inOut2.id},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(inOut2.date,"gg.aa.yyyy ss:dd")))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId != 0),expression:"inOut2.readerId != 0"}]},[_vm._v(_vm._s(inOut2.readerName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.readerId == 0),expression:"inOut2.readerId == 0"}]},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.manuelMovement')))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut != 2),expression:"inOut2.inOrOut != 2"}],staticClass:"label btn-success"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.entryMovement')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.inOrOut == 2),expression:"inOut2.inOrOut == 2"}],staticClass:"label btn-danger"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.exitMovement')))])]),_vm._v(" "),_c('td',[_vm._v("\n                                          "+_vm._s(inOut2.price)+"\n                                          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(inOut2.price),expression:"inOut2.price"}]})]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!inOut2.isActive),expression:"!inOut2.isActive"}],staticClass:"badge"},[_vm._v(_vm._s(_vm.$ml.get('employees.passive')))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.isActive != false && _vm.authControl == 0),expression:"employee.isActive != false && authControl == 0"}],staticClass:"btn btn-xs btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteInOut(inOut2.id)}}},[_c('i',{staticClass:"fa fa-close"})])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inOutList.length == 0),expression:"inOutList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('foodGroupOperations.movementNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingInOuts}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"retail-sale-logs"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.retailSaleLogs')))]),_vm._v(" "),_c('div',{staticClass:"box-tools"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.retailSaleLogList.length > 0 && _vm.authControl == 0),expression:"retailSaleLogList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDFSaleLogs()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"5px"}},[_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.startDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.retailSaleLogs.startDate),expression:"retailSaleLogs.startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.retailSaleLogs.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.retailSaleLogs, "startDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-6 col-sm-12",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn",staticStyle:{"max-width":"120px"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.endDateMovements')))]),_vm._v(" :\n                                      ")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.retailSaleLogs.endDate),expression:"retailSaleLogs.endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.retailSaleLogs.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.retailSaleLogs, "endDate", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px","text-align":"center"}},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"90%"},attrs:{"disabled":_vm.isLoadingRetailSale,"type":"button"},on:{"click":function($event){return _vm.getRetailSaleLogs()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                                    "+_vm._s(_vm.$ml.get('foodGroupOperations.searchMovements'))+"\n                                  ")])])]),_vm._v(" "),_c('div',{staticClass:"row col-sm-12",staticStyle:{"margin":"0px 5px 10px 0px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.retailSaleLogList.length > 0),expression:"retailSaleLogList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"},attrs:{"id":"printSatisHareketleri"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.retailSaleLogList.length > 0),expression:"retailSaleLogList.length > 0"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+" ("+_vm._s(_vm._f("toDateFormatGet")(this.retailSaleLogs.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.retailSaleLogs.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._m(4),_vm._v(" "),_vm._l((_vm.retailSaleLogList),function(saleLog){return _c('tr',{key:saleLog.id},[_c('td',[_vm._v(_vm._s(saleLog.date))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(saleLog.isRefund),expression:"saleLog.isRefund"}]},[_c('i',{staticClass:"fa fa-times-circle text-danger"}),_vm._v(" İade Edildi\n                                          ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(saleLog.user))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(saleLog.price))])])}),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right","font-weight":"bold"}},[_vm._v("Toplam : ")]),_vm._v(" "),_c('td',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.retailSaleLogTotalPrice))])])],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.retailSaleLogList.length == 0),expression:"retailSaleLogList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('foodGroupOperations.movementNotRecord'))+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingRetailSale}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.employee.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(this.employee.title != ''),expression:"this.employee.title != ''"}]},[_vm._v("- "+_vm._s(this.employee.title))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.isContinueUpdateEmployeeFoodGroup')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveEmployee()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(7),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(8),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(9),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(10),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(11),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(12),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive==true ? _vm.filters.isActive=false : _vm.filters.isActive=true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-hareket-ekle"}},[_c('div',{staticClass:"modal-dialog modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.newMovement')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('foodGroupOperations.newMovementWarningInfo'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.dateMovement')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inOut.inOutAdd),expression:"inOut.inOutAdd"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.inOut.inOutAdd)},on:{"change":function($event){return _vm.getMeals(_vm.employee.foodGroupId, _vm.inOut.inOutAdd)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inOut, "inOutAdd", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.meal')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMeal($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedMealTime == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.mealList),function(meal,index){return _c('option',{key:index,domProps:{"value":meal.start,"selected":_vm.selectedMealTime == meal.start}},[_vm._v(_vm._s(meal.name)+" ("+_vm._s(meal.start)+" - "+_vm._s(meal.end)+")")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.readerMovement')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutDoor($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.inOut.readerId == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.activeReaderList),function(door){return _c('option',{key:door.readerId,domProps:{"value":door.readerId,"selected":door.readerId == _vm.inOut.readerId}},[_vm._v(_vm._s(door.name))])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewInOut),expression:"isNewInOut"}],staticClass:"btn btn-outline",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.addInOut()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-yemek"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-sm"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 1),expression:"selectedFoodType == 1"}]},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.addCredit')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 2),expression:"selectedFoodType == 2"}]},[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.addBalance')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 1),expression:"selectedFoodType == 1"}]},[_c('p',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.amountOfCredit')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.selectedFoodCount > 0 ? _vm.selectedFoodCount -= 1 : _vm.selectedFoodCount}}},[_c('i',{staticClass:"fa fa-minus"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFoodCount),expression:"selectedFoodCount"}],staticClass:"form-control",attrs:{"type":"number","min":"0","value":"0"},domProps:{"value":(_vm.selectedFoodCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedFoodCount=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.selectedFoodCount += 1}}},[_c('i',{staticClass:"fa fa-plus"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFoodType == 2),expression:"selectedFoodType == 2"}],staticClass:"input-group"},[_c('p',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.amountOfBalance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFoodCount),expression:"selectedFoodCount"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedFoodCount)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedFoodCount=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.updateFoodCredit()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(16),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck==true ? state.isCheck=false : state.isCheck=true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(17),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck==true ? status.isCheck=false : status.isCheck=true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(18),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck==true ? acc.isCheck=false : acc.isCheck=true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(19),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck==true ? work.isCheck=false : work.isCheck=true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(20),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck==true ? foodGroup.isCheck=false : foodGroup.isCheck=true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',[_vm._v("Güncel Bakiye")]),_vm._v(" :\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b',[_c('span',[_vm._v("Güncel Kredi")]),_vm._v(" :\n                        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',{staticClass:"text-left",staticStyle:{"width":"130px"}},[_vm._v("Tarih")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Durum")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("İşletme")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Tutar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroupReports_vue__ = __webpack_require__(153);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac43d25_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroupReports_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FoodGroupReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ac43d25_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FoodGroupReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(359);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("a5f12404", content, true, {});

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHallReports')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cutlery"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHall')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHallReports')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{class:_vm.activeScreen == 1 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 1}}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('filters.filterEmployees'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 2 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.selectReport'))+"\n              ")])]),_vm._v(" "),_c('li',{class:_vm.activeScreen == 3 ? 'active' : ''},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.activeScreen = 3}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('reports.report'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],class:_vm.activeScreen == 1 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-danger"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title,index){return _c('option',{key:'title' + index,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                            ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterVisitorCards')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isVisitor},on:{"change":function($event){_vm.filters.isVisitor == true ? _vm.filters.isVisitor = false : _vm.filters.isVisitor = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('filters.filterShow'))+"\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField1-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField2-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField3-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('select',{staticClass:"form-control input-sm text-center",staticStyle:{"margin-bottom":"5px","text-align":"center"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                            ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:'extraField4-' + extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterApply')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"display":"flex","justify-content":"space-between","align-items":"center"}},[_c('span',[_vm._v("Seçilen Kişiler")]),_vm._v(" "),_c('a',{staticStyle:{"cursor":"pointer","font-size":"15px"},on:{"click":function($event){return _vm.checkEmployees()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheck),expression:"!isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheck),expression:"isCheck"}]},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('filters.searchEmployeeFromList')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length > 0),expression:"employeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer","min-width":"75px"},on:{"click":function($event){return _vm.setOrderEmp(1)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.registrationNumberInfo'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 1),expression:"orderEmpList == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 2),expression:"orderEmpList == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderEmp(2)}}},[_c('strong',[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.nameSurname'))+"\n                                "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 3),expression:"orderEmpList == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderEmpList == 4),expression:"orderEmpList == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(employee3){return _c('tr',{key:'employee' + employee3.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){employee3.check == true ? employee3.check = false : employee3.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(employee3.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(employee3.sicilNo))]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(employee3.name)+"\n                              "),(employee3.title != '')?_c('span',[_vm._v("("+_vm._s(employee3.title)+")")]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.employeeFilteredList.length == 0),expression:"employeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.employeeNotRecord'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.activeScreen = 2}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 2),expression:"activeScreen == 2"}],class:_vm.activeScreen == 2 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportSettings')))]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.report'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeSelectedReport($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$ml.get('reports.selectReport')))]),_vm._v(" "),_vm._l((_vm.reportList),function(report){return _c('option',{key:'report' + report.id,domProps:{"value":report.id}},[_vm._v(_vm._s(report.name)+"\n                            ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"width":"100%","margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 14 || _vm.selectedReportId != 15),expression:"selectedReportId != 14 || selectedReportId != 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.startDate'))+"\n                              :")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15),expression:"selectedReportId == 14 || selectedReportId == 15"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.date'))+"\n                              :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId != 6 && _vm.selectedReportId != 7 && _vm.selectedReportId != 14 && _vm.selectedReportId != 15),expression:"selectedReportId != 6 && selectedReportId != 7 && selectedReportId != 14 && selectedReportId != 15"}],staticClass:"input-group",staticStyle:{"margin-bottom":"5px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.endDate'))+" :")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 10 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 10 || selectedReportId == 11"}]},[_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('reports.reportOptions')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 11),expression:"selectedReportId == 1 || selectedReportId == 11"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showAllowed},on:{"change":function($event){_vm.reportOptions.showAllowed == true ? _vm.reportOptions.showAllowed = false : _vm.reportOptions.showAllowed = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showAllowences'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 11 || _vm.selectedReportId == 10),expression:"selectedReportId == 11 || selectedReportId == 10"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showNonComers},on:{"change":function($event){_vm.reportOptions.showNonComers == true ? _vm.reportOptions.showNonComers = false : _vm.reportOptions.showNonComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showMissing'))+"\n                            ")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1),expression:"selectedReportId == 1"}],staticClass:"form-control checkbox mt-2 no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.reportOptions.showLateComers},on:{"change":function($event){_vm.reportOptions.showLateComers == true ? _vm.reportOptions.showLateComers = false : _vm.reportOptions.showLateComers = true}}}),_vm._v("\n                              "+_vm._s(_vm.$ml.get('reports.showLatecomer'))+"\n                            ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 10),expression:"selectedReportId == 10"}],staticClass:"input-group mt-2"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reportOptions.time),expression:"reportOptions.time"}],staticClass:"form-control input-lg",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.reportOptions.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.reportOptions, "time", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.fromTheClock')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-lg",on:{"change":function($event){return _vm.changeIsUpperFromTime($event)}}},[_c('option',{attrs:{"value":"false"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == false}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.lessEmployees')))]),_vm._v(" "),_c('option',{attrs:{"value":"true"},domProps:{"selected":_vm.reportOptions.isUpperFromTime == true}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('reports.moreEmployees')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 8),expression:"selectedReportId == 8"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportVisitorCardGroups'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckVG ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllVisitorGroups()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length > 0),expression:"visitorGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.visitorGroupList),function(visitorGroup){return _c('tr',{key:visitorGroup.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){visitorGroup.check == true ? visitorGroup.check = false : visitorGroup.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(visitorGroup.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(visitorGroup.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visitorGroupList.length == 0),expression:"visitorGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.visitorCardGroupNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 1 || _vm.selectedReportId == 2 || _vm.selectedReportId == 6 || _vm.selectedReportId == 7 || _vm.selectedReportId == 11 || _vm.selectedReportId == 19 || _vm.selectedReportId == 20 || _vm.selectedReportId == 21 || _vm.selectedReportId == 31),expression:"selectedReportId == 1 || selectedReportId == 2 || selectedReportId == 6 || selectedReportId == 7 || selectedReportId == 11 || selectedReportId == 19 || selectedReportId == 20 || selectedReportId == 21 || selectedReportId == 31"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDevices'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckReaders ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllReaders()}}})]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('reports.checkThisDevices'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeInOutListDoorType($event)}}},[_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.selectedDoorType == 4}},[_vm._v(_vm._s(_vm.$ml.get('employees.allDoors'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedDoorType == 0}},[_vm._v(_vm._s(_vm.$ml.get('employees.access'))+"\n                              ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedDoorType == 1}},[_vm._v(_vm._s(_vm.$ml.get('employees.pdks'))+"\n                              ")]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],attrs:{"value":"2"},domProps:{"selected":_vm.selectedDoorType == 2}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.diningHall')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],attrs:{"value":"3"},domProps:{"selected":_vm.selectedDoorType == 3}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.licencePlateRecognition')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],attrs:{"value":"5"},domProps:{"selected":_vm.selectedDoorType == 5}},[_vm._v("\n                                "+_vm._s(_vm.$ml.get('employees.dormitoryDevice')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:'reader' + reader.readerId,staticStyle:{"cursor":"pointer"},on:{"click":function($event){reader.check == true ? reader.check = false : reader.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(reader.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.ipAddress))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(reader.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.devicesNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 12),expression:"selectedReportId == 12"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportAllowences'))+"\n                            "),_c('span',{staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckAllowences ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))},on:{"click":function($event){return _vm.checkAllAllowence()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allowenceList),function(allowence){return _c('tr',{key:'allowence' + allowence.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){allowence.check == true ? allowence.check = false : allowence.check = true}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(allowence.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(allowence.shortCode)+" - "+_vm._s(allowence.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.allowenceNotFound'))+"\n                          ")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportId == 14 || _vm.selectedReportId == 15 || _vm.selectedReportId == 25 || _vm.selectedReportId == 30),expression:"selectedReportId == 14 || selectedReportId == 15 || selectedReportId == 25 || selectedReportId == 30"}]},[_c('h4',[_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.displayInReportDepartments'))+"\n                            "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCheckDeps),expression:"isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(false)}}},[_vm._v(_vm._s(_vm.$ml.get('general.removeAll')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isCheckDeps),expression:"!isCheckDeps"}],staticStyle:{"cursor":"pointer","color":"red","font-size":"15px"},on:{"click":function($event){return _vm.getCheckDepartmentAll(true)}}},[_vm._v(_vm._s(_vm.$ml.get('general.selectAll')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length > 0),expression:"departmentList.length > 0"}],staticClass:"table-responsive no-padding text-black",style:('background-style:white; ' + _vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.sortableDepartmentList),function(dep){return _c('tr',{key:'department' + dep.id,staticStyle:{"cursor":"pointer"},on:{"click":function($event){dep.check == true ? _vm.changeFilterDep2(dep, false) : _vm.changeFilterDep2(dep, true)}}},[_c('td',{staticStyle:{"font-size":"18px"}},[(dep.check)?_c('i',{staticClass:"fa fa-check-circle text-success"}):_c('i',{staticClass:"fa fa-times-circle text-danger"})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(dep.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.departmentList.length == 0),expression:"departmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('reports.departmentNotFound'))+"\n                          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.getReportDetails()}}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.viewReport'))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 3),expression:"activeScreen == 3"}],class:_vm.activeScreen == 3 ? 'row tab-pane active' : 'row tab-pane',staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title",attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}]},[_vm._v(_vm._s(_vm.selectedReportName))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName == ''),expression:"selectedReportName == ''"}]},[_vm._v(_vm._s(_vm.$ml.get('reports.report')))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0 && _vm.reportDataList != null),expression:"authControl == 0 && reportDataList != null"}],staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n                      ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReportName != ''),expression:"selectedReportName != ''"}],staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.selectedReportName)+"\n                          ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover",staticStyle:{"font-size":"12px"},attrs:{"id":"printExcel"}},[_c('thead',[_c('tr',_vm._l((_vm.reportHeaderList),function(header,indexHead){return _c('th',{key:'head' + indexHead,staticClass:"dep-baslik"},[_vm._v("\n                              "+_vm._s(header))])}),0)]),_vm._v(" "),_vm._l((_vm.reportDataList),function(dep,index){return _c('tbody',{key:'body' + index},[_c('tr',[_c('td',{staticClass:"dep-baslik",attrs:{"colspan":_vm.selectedReportId == 1 ? 7 : 37}},[_c('strong',[_vm._v(_vm._s(dep.departmanAdi))])])]),_vm._v(" "),_vm._l((dep.veriler),function(data,index2){return _c('tr',{key:'data' + index2,class:index2 % 2 == 1 ? 'bg-secondary' : ''},[_vm._l((dep.keys),function(key1,indexKey){return _c('td',{key:'key' + indexKey,class:_vm.customReportStyle(key1, data[key1])},[(_vm.selectedReportId == 19 && indexKey == 4 && data.positionX)?_c('span',[(data.positionX)?_c('a',{staticStyle:{"margin-top":"10px"},attrs:{"target":"_blank","href":'http://maps.google.com/maps?f=q&hl=en&q=' + data.positionX + '+N,+' + data.positionY + '+E&ie=UTF8&t=k&om=0&ll=' + data.positionX + ',' + data.positionY + '&spn=0.003022,0.004989&t=k'}},[_vm._v(_vm._s(data.positionX)+"\n                                  - "+_vm._s(data.positionY))]):_vm._e()]):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:((_vm.selectedReportId == 32 && indexKey != 5) || (_vm.selectedReportId != 31 && _vm.selectedReportId != 32) || (_vm.selectedReportId == 31 && indexKey != 6 && indexKey != 7)),expression:"(selectedReportId == 32 && indexKey != 5) || (selectedReportId != 31 && selectedReportId != 32) || (selectedReportId == 31 && indexKey != 6 && indexKey != 7)"}]},[_vm._v(_vm._s(data[key1]))]),_vm._v(" "),(_vm.selectedReportId == 32 && indexKey == 5 && data[key1])?_c('span',[_c('i',{staticClass:"fa fa-times-circle text-danger"}),_vm._v(" İade Edildi\n                              ")]):_vm._e(),_vm._v(" "),(_vm.selectedReportId == 31 && (indexKey == 6 || indexKey == 7))?_c('img',{staticStyle:{"width":"200px"},attrs:{"src":data[key1]}}):_vm._e()])}),_vm._v(" "),_vm._l((data.movements),function(movement,index){return _c('td',{key:'visitorKey' + index,staticClass:"no-wrap"},[_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]},[_vm._v("GİRİŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}],staticClass:"text-success"},[_vm._v(_vm._s(movement.entryTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.entryTime),expression:"movement.entryTime"}]}),_vm._v(" "+_vm._s(movement.entryReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]},[_vm._v("ÇIKIŞ")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}],staticClass:"text-danger"},[_vm._v(_vm._s(movement.exitTime))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.exitTime),expression:"movement.exitTime"}]}),_vm._v(" "+_vm._s(movement.exitReaderName)+" "),_c('br'),_vm._v(" "),_c('strong',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]},[_vm._v("FARK")]),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}],staticClass:"text-primary"},[_vm._v(_vm._s(movement.timeDifference))]),_vm._v(" "),_c('br',{directives:[{name:"show",rawName:"v-show",value:(movement.timeDifference),expression:"movement.timeDifference"}]})])})],2)})],2)})],2),_vm._v(" "),_c('div',{staticClass:"pull-right",staticStyle:{"margin-right":"70px","margin-bottom":"40px"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('reports.noResults'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:'sortDep' + dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:'state' + state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:'status' + status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:'access' + acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.workGroupList),function(work){return _c('span',{key:'workGroup' + work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:'foodGroup' + foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retailSale_vue__ = __webpack_require__(154);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd45cf2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_retailSale_vue__ = __webpack_require__(364);
function injectStyle (ssrContext) {
  __webpack_require__(362)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebd45cf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_retailSale_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebd45cf2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_retailSale_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("206ccfa9", content, true, {});

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".number-btn[data-v-ebd45cf2]{border-radius:30px;position:relative;padding:15px 5px;min-width:80px;text-align:center;color:#000;border:1px solid #ddd;background-color:#fff;font-weight:700;font-size:20px;width:100%;margin:0 0 10px;height:100px}.reportHeadInfo[data-v-ebd45cf2]{font-size:14px;text-align:center;width:100%;background:#00a0f0;color:#fff;padding:5px;margin-bottom:5px}", ""]);

// exports


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.retailSale')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.diningHall')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.retailSale')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4",on:{"click":function($event){return _vm.setCardFocus()}}},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardNumber),expression:"cardNumber"}],staticClass:"form-control input-lg",attrs:{"id":"searchCardNumber","type":"text"},domProps:{"value":(_vm.cardNumber)},on:{"change":function($event){return _vm.searchEmployee()},"input":function($event){if($event.target.composing){ return; }_vm.cardNumber=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get("employees.employeeInfo")))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(_vm.employee.image == null) ? '/src/assets/default-user.png' : _vm.employee.image}}),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.nameSurname')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.employee.sicilNo),expression:"employee.sicilNo"}]},[_vm._v(_vm._s(_vm.employee.sicilNo)+" -")]),_vm._v("\n                "+_vm._s(_vm.employee.name)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.department')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.employee.department))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.title')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.employee.title))])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('foodGroupOperations.availableBalance')))]),_vm._v(" "),_c('label',{staticClass:"form-control",domProps:{"textContent":_vm._s(_vm.employee.credit)}})]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row",staticStyle:{"margin":"10px 0 10px 0"}},[_c('div',{staticClass:"col-sm-6"},[_c('button',{class:_vm.activeScreen == 0 ? 'btn btn-primary btn-lg' : 'btn btn-danger btn-lg',staticStyle:{"width":"100%","height":"50px"},on:{"click":function($event){_vm.activeScreen = 0}}},[_vm._v("Satış")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{class:_vm.activeScreen == 1 ? 'btn btn-primary btn-lg' : 'btn btn-danger btn-lg',staticStyle:{"width":"100%","height":"50px"},on:{"click":function($event){_vm.activeScreen = 1}}},[_vm._v("Geçmiş Satışlar (Bu Ay)")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 0),expression:"activeScreen == 0"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"20px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.total),expression:"total"}],staticClass:"form-control input-lg text-center text-bold text-black",staticStyle:{"font-size":"20px","background-color":"#ffd110"},attrs:{"id":"totalPrice","type":"number","min":"0"},domProps:{"value":(_vm.total)},on:{"input":function($event){if($event.target.composing){ return; }_vm.total=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(1)}}},[_vm._v("1")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(2)}}},[_vm._v("2")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(3)}}},[_vm._v("3")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(4)}}},[_vm._v("4")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(5)}}},[_vm._v("5")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(6)}}},[_vm._v("6")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(7)}}},[_vm._v("7")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(8)}}},[_vm._v("8")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(9)}}},[_vm._v("9")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",staticStyle:{"font-size":"20px","background-color":"#ffd110"},on:{"click":function($event){return _vm.clearPaymentNumber()}}},[_c('i',{staticClass:"fa fa-arrow-left text-black"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber(0)}}},[_vm._v("0")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn number-btn",on:{"click":function($event){return _vm.setPaymentNumber('.0')}}},[_c('i',{staticClass:"fa fa-circle",staticStyle:{"font-size":"15px"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2"},[_c('button',{staticClass:"btn number-btn bg-red",staticStyle:{"font-size":"20px"},on:{"click":function($event){return _vm.setPaymentReset()}}},[_c('i',{staticClass:"fa fa-trash"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-primary btn-lg",staticStyle:{"width":"100%","height":"100px","margin-top":"10px"},on:{"click":function($event){return _vm.question()}}},[_vm._v("BAKİYEDEN DÜŞ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeScreen == 1),expression:"activeScreen == 1"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.saleList != null),expression:"saleList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize)},[_c('table',{staticClass:"table",staticStyle:{"font-size":"14px"},attrs:{"id":"printExcel"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.saleList),function(sale){return _c('tr',{key:sale.id},[_c('td',[_vm._v(_vm._s(sale.date))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(sale.price)+" TL")]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.selectSale(sale)}}},[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" İade Oluştur\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.saleList == null || _vm.saleList == 0),expression:"saleList == null || saleList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('dashboard.fastReportNotRecord'))+"\n                ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"report"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-success pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToExcel()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToExcel'))+"\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-sm btn-danger pull-right",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"pull-left",staticStyle:{"margin-right":"10px","font-size":"20px"},attrs:{"hidden":!_vm.isLoadingReport}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"5px"}},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Başlangıç Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bitiş Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"margin-top":"15px","width":"100%"},on:{"click":function($event){return _vm.getReport()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" Görüntüle\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null),expression:"reportDataList != null"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize),attrs:{"id":"printReport"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null && _vm.reportDataList != 0),expression:"reportDataList != null && reportDataList != 0"}],staticClass:"dep-baslik",staticStyle:{"padding-bottom":"10px","padding-top":"10px","text-align":"center"}},[_c('span',{staticClass:"mb-10 text-center"},[_vm._v(_vm._s(_vm.reportName))])]),_vm._v(" "),_c('table',{staticClass:"table",staticStyle:{"font-size":"14px"},attrs:{"id":"printExcel"}},[_vm._m(6),_vm._v(" "),_c('tbody',[_vm._l((_vm.reportDataList),function(report,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(report.date))]),_vm._v(" "),_c('td',{staticClass:"text-left"},[_vm._v(_vm._s(report.price)+" TL")])])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList != null && _vm.reportDataList != 0),expression:"reportDataList != null && reportDataList != 0"}]},[_c('td',{staticClass:"text-right text-bold"},[_vm._v("Toplam :")]),_vm._v(" "),_c('td',{staticClass:"text-bold text-left"},[_vm._v(_vm._s(_vm.reportDataTotal)+" TL")])])],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportDataList == null || _vm.reportDataList == 0),expression:"reportDataList == null || reportDataList == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('dashboard.fastReportNotRecord'))+"\n              ")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"question"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered"},[_c('div',{staticClass:"modal-content modal-primary"},[_vm._m(7),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center","padding":"10px","margin-bottom":"20px","font-size":"25px"}},[_c('span',[_vm._v("\n                "+_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+"\n                "),_c('br'),_vm._v(" "),_c('br'),_vm._v("kişinin bakiyesinden\n                "),_c('strong',[_vm._v(_vm._s(_vm.total)+" TL")]),_vm._v(" tutar düşülecektir.\n                "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Onaylıyor musunuz?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-success",staticStyle:{"padding":"20px","font-size":"30px","width":"100%"},on:{"click":function($event){return _vm.setPayment()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('br'),_vm._v("Evet\n              ")])]),_vm._v(" "),_vm._m(8)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"refund-confirm-modal"}},[_c('div',{staticClass:"modal-dialog modal-lg modal-dialog-centered"},[_c('div',{staticClass:"modal-content modal-primary"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"text-align":"center","padding":"10px","margin-bottom":"20px","font-size":"25px"}},[_c('span',[_vm._v("\n                "+_vm._s(_vm.employee.sicilNo)+" - "+_vm._s(_vm.employee.name)+"\n                "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                kişinin "+_vm._s(_vm.selectedSale.date)+" tarihli satışından\n                "),_c('strong',[_vm._v(_vm._s(_vm.selectedSale.price)+" TL")]),_vm._v(" tutar iade edilecektir.\n                "),_c('br'),_vm._v(" "),_c('br'),_vm._v("Onaylıyor musunuz?\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-success",staticStyle:{"padding":"20px","font-size":"30px","width":"100%"},on:{"click":function($event){return _vm.refund(_vm.selectedSale.id)}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('br'),_vm._v("Evet\n              ")])]),_vm._v(" "),_vm._m(10)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Kart Numarası")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary btn-lg",staticStyle:{"width":"100%"},attrs:{"data-toggle":"modal","data-target":"#report"}},[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" Rapor Görüntüle\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Satışlar")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("İşlem Zamanı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Tutar")]),_vm._v(" "),_c('th',{staticClass:"text-left"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Satış Raporu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("İşlem Zamanı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Tutar")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title text-center"},[_c('span',{staticStyle:{"font-size":"25px"}},[_vm._v("Onay")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"padding":"20px","font-size":"30px","width":"100%"},attrs:{"data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('br'),_vm._v("Hayır\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title text-center"},[_c('span',{staticStyle:{"font-size":"25px"}},[_vm._v("Onay")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"padding":"20px","font-size":"30px","width":"100%"},attrs:{"data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('br'),_vm._v("Hayır\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildDefinitions_vue__ = __webpack_require__(155);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660c853b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildDefinitions_vue__ = __webpack_require__(368);
function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-660c853b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildDefinitions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_660c853b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildDefinitions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(367);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("536988bc", content, true, {});

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ml-80[data-v-660c853b]{margin-left:60px}.box-w-70[data-v-660c853b]{width:60px}.detail-box[data-v-660c853b]{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:center;height:200px;width:100%;text-align:center;font-size:45px;line-height:80px}", ""]);

// exports


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.studentTransactions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon text-lg"},[_vm._v("Seçilen Bölge :")]),_vm._v(" "),_c('select',{staticClass:"form-control text-bold input-lg",on:{"change":function($event){return _vm.viewSelectArea($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.areaList),function(ar){return _c('option',{key:ar.id,domProps:{"selected":ar.id == _vm.viewSelectedArea.id,"value":ar.id}},[_vm._v(_vm._s(ar.name))])})],2)])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedViewFloorList.length == 0 && !_vm.isLoading),expression:"selectedViewFloorList.length == 0 && !isLoading"}],staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.viewSelectedArea.id ? 'Kayıtlı kat bulunamadı. Bölge tanımlarından kat kaydedebilirsiniz...' : 'Lütfen önce bölge seçin...')}})])]),_vm._v(" "),_vm._l((_vm.selectedViewFloorList),function(floor){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],key:floor.id,staticClass:"col-sm-12"},[_c('div',{staticClass:"box-header",staticStyle:{"margin-top":"20px"}},[_c('h3',{staticClass:"box-title",staticStyle:{"font-size":"24px","line-height":"1.1"}},[_vm._v(_vm._s(floor.name))]),_vm._v(" "),_c('div',{staticClass:"box-title pull-right"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newRoom(floor.id, _vm.viewSelectedArea.id)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Oda\n            ")])])]),_vm._v(" "),_c('hr',{staticStyle:{"border-top":"1px solid #000","margin-top":"10px"}}),_vm._v(" "),_c('div',{staticClass:"row"},_vm._l((floor.rooms),function(room){return _c('div',{key:room.id,staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-2"},[_c('div',{staticClass:"info-box room",staticStyle:{"cursor":"pointer"},attrs:{"name":room.id},on:{"click":function($event){return _vm.roomDetail(room)}}},[_c('span',{class:_vm.customColor(room)},[_c('img',{attrs:{"src":"/src/assets/room-white.png"}})]),_vm._v(" "),_c('div',{staticClass:"info-box-content ml-80"},[_c('strong',{staticClass:"h4"},[_vm._v(_vm._s(room.name))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"}}),_vm._v(" "),_vm._m(2,true),_vm._v("\n                "+_vm._s(room.capacity)+"\n                "),_c('br'),_vm._v(" "),_vm._m(3,true),_vm._v("\n                "+_vm._s(room.usesCount)+"\n              ")])])])}),0)])})],2),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;'+_vm.windowHeightSize),attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-area"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v("Bölge Listesi")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newArea()}}},[_vm._v("Yeni Bölge")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areaList.length > 0),expression:"areaList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.areaList),function(area){return _c('tr',{key:area.id},[_c('td',[_vm._v(_vm._s(area.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectArea(area.id, area.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areaList.length == 0),expression:"areaList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      Bölge kaydı bulunamadı.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bölge Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedArea.name),expression:"selectedArea.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedArea.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedArea, "name", $event.target.value)}}})]),_vm._v(" "),_c('label',[_vm._v("Katlar")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"callout callout-info"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kat Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFloor.name),expression:"selectedFloor.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedFloor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFloor, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sıra Numarası")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFloor.orderNo),expression:"selectedFloor.orderNo"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.selectedFloor.orderNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFloor, "orderNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}],staticClass:"btn btn-outline",on:{"click":function($event){return _vm.newFloor()}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" İptal\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deleteField(_vm.selectedFloor.id, 1)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Sil\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.saveFloor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewFloor),expression:"isNewFloor"}]},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Kat Ekle\n                        ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Güncelle\n                        ")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',_vm._l((_vm.selectedFloorList),function(floor){return _c('li',{key:floor.id,staticStyle:{"margin-bottom":"5px"}},[_vm._v("\n                        "+_vm._s(floor.name)+"\n                        "),_c('button',{staticClass:"btn btn-xs btn-primary",staticStyle:{"margin-left":"5px"},on:{"click":function($event){return _vm.selectFloor(floor.id, floor.name)}}},[_c('i',{staticClass:"fa fa-search"})])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFloorList.length == 0),expression:"selectedFloorList.length == 0"}],staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(!_vm.isNewArea ? 'Kat bulunamadı.' : 'Lütfen önce bölgeyi kaydedin.')}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteField(_vm.selectedArea.id, 0)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveArea()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewArea),expression:"isNewArea"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",staticStyle:{"display":"none"},attrs:{"id":"modal-room-types"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v("Daire Tipi Listesi")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newRoomType()}}},[_vm._v("Yeni Daire Tipi")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.roomTypeList.length > 0),expression:"roomTypeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.roomTypeList),function(roomType){return _c('tr',{key:roomType.id},[_c('td',[_vm._v(_vm._s(roomType.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectRoomType(roomType.id, roomType.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.roomTypeList.length == 0),expression:"roomTypeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      Daire tipi kaydı bulunamadı.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Daire Tipi Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoomType.name),expression:"selectedRoomType.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedRoomType.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedRoomType, "name", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoomType),expression:"!isNewRoomType"}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteRoomType(_vm.selectedRoomType.id)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveRoomType()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoomType),expression:"isNewRoomType"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoomType),expression:"!isNewRoomType"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"modal-room-detail"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('span',{class:_vm.customColor2},[_c('img',{staticStyle:{"height":"150px","margin-top":"20px"},attrs:{"src":"/src/assets/room-white-150.png"}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._m(7),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.name)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(8),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.capacity)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(9),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.usesCount)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(10),_vm._v("\n                  "+_vm._s(_vm.getRoomTypeName(_vm.viewSelectedRoom.roomTypeId))+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(11),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.orderNo)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"form-group text-center"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.editRoom()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Odayı Düzenle\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"font-size":"20px","line-height":"1.1"}},[_vm._v("Mevcut Kişiler")]),_vm._v(" "),_c('div',{staticClass:"box-title pull-right"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newEmployees()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Kişi Ekle\n                    ")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"10px"}}),_vm._v(" "),_c('ul',{staticClass:"products-list product-list-in-box"},_vm._l((_vm.viewSelectedRoom.usesEmployees),function(emp,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount > 0 && !_vm.isLoadingUsesEmployees),expression:"viewSelectedRoom.usesCount > 0 && !isLoadingUsesEmployees"}],key:emp.id,staticClass:"item"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-center"},[_c('img',{staticStyle:{"width":"70px"},attrs:{"src":emp.image ? emp.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center",staticStyle:{"margin-top":"10px"}},[_c('a',{staticClass:"product-title"},[_vm._v(_vm._s(emp.registrationNumber)+" - "+_vm._s(emp.name))]),_vm._v(" "),_c('span',{staticClass:"product-description"},[_vm._v(_vm._s(emp.title))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"margin":"10px"},on:{"click":function($event){return _vm.removeEmployee(emp, index)}}},[_c('i',{staticClass:"fa fa-times"})])])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount == 0),expression:"viewSelectedRoom.usesCount == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Kişi kaydı mevcut değil.\n                ")]),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;'+_vm.windowEmployeesHeightSize),attrs:{"id":"load","hidden":!_vm.isLoadingUsesEmployees}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"employees-modal"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Eklenecek Kişileri Seçin ("+_vm._s(_vm.viewSelectedRoom.capacity)+" / "+_vm._s(_vm.viewSelectedRoom.usesCount)+" kişi seçildi.)")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('visitors.searchEmployeeFromList')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length > 0 && !_vm.isLoadingEmployee),expression:"allEmployeeFilteredList.length > 0 && !isLoadingEmployee"}],staticClass:"table-responsive no-padding",style:(_vm.windowEmployeesHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allEmployeeFilteredList),function(employee1){return _c('tr',{key:employee1.id,on:{"click":function($event){employee1.isCheck = !employee1.isCheck}}},[_c('td',[_vm._v("\n                          "+_vm._s(employee1.sicilNo)+" - "+_vm._s(employee1.name)+"\n                          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("- "+_vm._s(employee1.title))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount < _vm.viewSelectedRoom.capacity || employee1.isCheck == true),expression:"viewSelectedRoom.usesCount < viewSelectedRoom.capacity || employee1.isCheck == true"}],class:employee1.isCheck ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm',attrs:{"disabled":employee1.isAtRoom,"type":"button"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!employee1.isCheck),expression:"!employee1.isCheck"}],staticClass:"fa fa-times"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(employee1.isCheck),expression:"employee1.isCheck"}],staticClass:"fa fa-check"})])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;'+_vm.windowEmployeesHeightSize),attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.addEmployee()}}},[_vm._m(13)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"room-modal"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoom),expression:"isNewRoom"}]},[_vm._v("Yeni Oda Oluştur")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}]},[_vm._v("Oda Düzenle")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('span',{class:_vm.isNewRoom ? 'detail-box bg-orange text-center' : 'detail-box bg-blue text-center'},[_c('img',{staticStyle:{"height":"150px","margin-top":"20px"},attrs:{"src":"/src/assets/room-white-150.png"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.name),expression:"viewSelectedRoom.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.viewSelectedRoom.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(16),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.capacity),expression:"viewSelectedRoom.capacity"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.viewSelectedRoom.capacity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "capacity", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(17),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.orderNo),expression:"viewSelectedRoom.orderNo"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.viewSelectedRoom.orderNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "orderNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(18),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeRoomType($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.roomTypeList),function(roomType){return _c('option',{key:roomType.id,domProps:{"value":roomType.id,"selected":_vm.viewSelectedRoom.roomTypeId == roomType.id}},[_vm._v(_vm._s(roomType.name))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}],staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.deleteField(_vm.viewSelectedRoom.id, 2)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveRoom()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoom),expression:"isNewRoom"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-lg btn-primary",staticStyle:{"width":"100%"},attrs:{"data-target":"#modal-area","data-toggle":"modal"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" Bölge Tanımları\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-lg btn-info",staticStyle:{"width":"100%"},attrs:{"data-target":"#modal-room-types","data-toggle":"modal"}},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipleri\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-bed"}),_vm._v(" :\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" :\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Bölge Tanımları")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Daire Tipleri")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Oda Detayı")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Oda Adı :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-bed"}),_vm._v(" Kapasite :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Mevcut Kişi :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipi :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-sort"}),_vm._v(" Sıra Numarası :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                Seçilenleri Odaya Ekle\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Oda Adı\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-bed"}),_vm._v(" Kapasite\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-sort"}),_vm._v(" Sıra Numarası\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipi\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildDefinitionsTest_vue__ = __webpack_require__(156);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55823685_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildDefinitionsTest_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55823685"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildDefinitionsTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55823685_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildDefinitionsTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(371);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("bb9b8f46", content, true, {});

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".ml-80[data-v-55823685]{margin-left:60px}.box-w-70[data-v-55823685]{width:60px}.detail-box[data-v-55823685]{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:center;height:200px;width:100%;text-align:center;font-size:45px;line-height:80px}", ""]);

// exports


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-graduation-cap"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.studentTransactions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon text-lg"},[_vm._v("Seçilen Bölge :")]),_vm._v(" "),_c('select',{staticClass:"form-control text-bold input-lg",on:{"change":function($event){return _vm.viewSelectArea($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.areaList),function(ar){return _c('option',{key:ar.id,domProps:{"selected":ar.id == _vm.viewSelectedArea.id,"value":ar.id}},[_vm._v("\n              "+_vm._s(ar.name))])})],2)])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedViewFloorList.length == 0 && !_vm.isLoading),expression:"selectedViewFloorList.length == 0 && !isLoading"}],staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.viewSelectedArea.id ? 'Kayıtlı kat bulunamadı. Bölge tanımlarından kat kaydedebilirsiniz...' : 'Lütfen önce bölge seçin...')}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_vm._m(2),_vm._v(" "),_c('hr',{staticStyle:{"border-top":"1px solid #000","margin-top":"10px"}}),_vm._v(" "),_c('div',{staticStyle:{"background":"url('/src/assets/zemin.png')","width":"100%","height":"100vh","background-repeat":"no-repeat","background-size":"contain"}},[_c('i',{staticClass:"fa fa-camera",staticStyle:{"color":"orange","cursor":"pointer","position":"relative","top":"200px","left":"200px","font-size":"25px"},on:{"click":function($event){return _vm.openDevice()}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + _vm.windowHeightSize),attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-area"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v("Bölge Listesi")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newArea()}}},[_vm._v("Yeni Bölge")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areaList.length > 0),expression:"areaList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.areaList),function(area){return _c('tr',{key:area.id},[_c('td',[_vm._v(_vm._s(area.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectArea(area.id, area.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.areaList.length == 0),expression:"areaList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      Bölge kaydı bulunamadı.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bölge Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedArea.name),expression:"selectedArea.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedArea.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedArea, "name", $event.target.value)}}})]),_vm._v(" "),_c('label',[_vm._v("Katlar")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"callout callout-info"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kat Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFloor.name),expression:"selectedFloor.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedFloor.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFloor, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Sıra Numarası")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedFloor.orderNo),expression:"selectedFloor.orderNo"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.selectedFloor.orderNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedFloor, "orderNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}],staticClass:"btn btn-outline",on:{"click":function($event){return _vm.newFloor()}}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" İptal\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.deleteField(_vm.selectedFloor.id, 1)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" Sil\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){return _vm.saveFloor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewFloor),expression:"isNewFloor"}]},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Kat Ekle\n                        ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewFloor),expression:"!isNewFloor"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" Güncelle\n                        ")])])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('ul',_vm._l((_vm.selectedFloorList),function(floor){return _c('li',{key:floor.id,staticStyle:{"margin-bottom":"5px"}},[_vm._v("\n                        "+_vm._s(floor.name)+"\n                        "),_c('button',{staticClass:"btn btn-xs btn-primary",staticStyle:{"margin-left":"5px"},on:{"click":function($event){return _vm.selectFloor(floor.id, floor.name)}}},[_c('i',{staticClass:"fa fa-search"})])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedFloorList.length == 0),expression:"selectedFloorList.length == 0"}],staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(!_vm.isNewArea ? 'Kat bulunamadı.' : 'Lütfen önce bölgeyi kaydedin.')}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteField(_vm.selectedArea.id, 0)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveArea()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewArea),expression:"isNewArea"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",staticStyle:{"display":"none"},attrs:{"id":"modal-room-types"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v("Daire Tipi Listesi")]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newRoomType()}}},[_vm._v("Yeni Daire Tipi")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.roomTypeList.length > 0),expression:"roomTypeList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto","color":"black"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.roomTypeList),function(roomType){return _c('tr',{key:roomType.id},[_c('td',[_vm._v(_vm._s(roomType.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectRoomType(roomType.id, roomType.name)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.roomTypeList.length == 0),expression:"roomTypeList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      Daire tipi kaydı bulunamadı.\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Daire Tipi Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRoomType.name),expression:"selectedRoomType.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedRoomType.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedRoomType, "name", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoomType),expression:"!isNewRoomType"}],staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteRoomType(_vm.selectedRoomType.id)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveRoomType()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoomType),expression:"isNewRoomType"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoomType),expression:"!isNewRoomType"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"modal-room-detail"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('span',{class:_vm.customColor2},[_c('img',{staticStyle:{"height":"150px","margin-top":"20px"},attrs:{"src":"/src/assets/room-white-150.png"}})]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._m(6),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.name)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(7),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.capacity)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(8),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.usesCount)+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(9),_vm._v("\n                  "+_vm._s(_vm.getRoomTypeName(_vm.viewSelectedRoom.roomTypeId))+"\n                ")]),_vm._v(" "),_c('h4',[_vm._m(10),_vm._v("\n                  "+_vm._s(_vm.viewSelectedRoom.orderNo)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"form-group text-center"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.editRoom()}}},[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" Odayı Düzenle\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title",staticStyle:{"font-size":"20px","line-height":"1.1"}},[_vm._v("Mevcut Kişiler")]),_vm._v(" "),_c('div',{staticClass:"box-title pull-right"},[_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newEmployees()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Kişi Ekle\n                    ")])])]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"10px"}}),_vm._v(" "),_c('ul',{staticClass:"products-list product-list-in-box"},_vm._l((_vm.viewSelectedRoom.usesEmployees),function(emp,index){return _c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount > 0 && !_vm.isLoadingUsesEmployees),expression:"viewSelectedRoom.usesCount > 0 && !isLoadingUsesEmployees"}],key:emp.id,staticClass:"item"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 text-center"},[_c('img',{staticStyle:{"width":"70px"},attrs:{"src":emp.image ? emp.image : '/src/assets/default-user.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center",staticStyle:{"margin-top":"10px"}},[_c('a',{staticClass:"product-title"},[_vm._v(_vm._s(emp.registrationNumber)+" - "+_vm._s(emp.name))]),_vm._v(" "),_c('span',{staticClass:"product-description"},[_vm._v(_vm._s(emp.title))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"margin":"10px"},on:{"click":function($event){return _vm.removeEmployee(emp, index)}}},[_c('i',{staticClass:"fa fa-times"})])])])])}),0),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount == 0),expression:"viewSelectedRoom.usesCount == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Kişi kaydı mevcut değil.\n                ")]),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + _vm.windowEmployeesHeightSize),attrs:{"id":"load","hidden":!_vm.isLoadingUsesEmployees}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"employees-modal"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Eklenecek Kişileri Seçin ("+_vm._s(_vm.viewSelectedRoom.capacity)+" / "+_vm._s(_vm.viewSelectedRoom.usesCount)+" kişi\n                seçildi.)")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.getEmployees()}}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('visitors.searchEmployeeFromList')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){return _vm.getEmployees()}}},[_c('i',{staticClass:"fa fa-search"})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length > 0 && !_vm.isLoadingEmployee),expression:"allEmployeeFilteredList.length > 0 && !isLoadingEmployee"}],staticClass:"table-responsive no-padding",style:(_vm.windowEmployeesHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.allEmployeeFilteredList),function(employee1){return _c('tr',{key:employee1.id,on:{"click":function($event){employee1.isCheck = !employee1.isCheck}}},[_c('td',[_vm._v("\n                          "+_vm._s(employee1.sicilNo)+" - "+_vm._s(employee1.name)+"\n                          "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(employee1.title),expression:"employee1.title"}]},[_vm._v("- "+_vm._s(employee1.title))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.viewSelectedRoom.usesCount < _vm.viewSelectedRoom.capacity || employee1.isCheck == true),expression:"viewSelectedRoom.usesCount < viewSelectedRoom.capacity || employee1.isCheck == true"}],class:employee1.isCheck ? 'btn btn-success btn-sm' : 'btn btn-danger btn-sm',attrs:{"disabled":employee1.isAtRoom,"type":"button"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(!employee1.isCheck),expression:"!employee1.isCheck"}],staticClass:"fa fa-times"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(employee1.isCheck),expression:"employee1.isCheck"}],staticClass:"fa fa-check"})])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"overlay",style:('font-size:30px;text-align:center;background-color:#fff;margin-top:10px;' + _vm.windowEmployeesHeightSize),attrs:{"id":"load","hidden":!_vm.isLoadingEmployee}},[_c('i',{staticClass:"fa fa-refresh fa-spin",staticStyle:{"margin":"150px"}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.addEmployee()}}},[_vm._m(12)])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",staticStyle:{"display":"none"},attrs:{"id":"room-modal"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoom),expression:"isNewRoom"}]},[_vm._v("Yeni Oda Oluştur")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}]},[_vm._v("Oda Düzenle")])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('span',{class:_vm.isNewRoom ? 'detail-box bg-orange text-center' : 'detail-box bg-blue text-center'},[_c('img',{staticStyle:{"height":"150px","margin-top":"20px"},attrs:{"src":"/src/assets/room-white-150.png"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_vm._m(14),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.name),expression:"viewSelectedRoom.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.viewSelectedRoom.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(15),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.capacity),expression:"viewSelectedRoom.capacity"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.viewSelectedRoom.capacity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "capacity", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(16),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.viewSelectedRoom.orderNo),expression:"viewSelectedRoom.orderNo"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.viewSelectedRoom.orderNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.viewSelectedRoom, "orderNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_vm._m(17),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeRoomType($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.roomTypeList),function(roomType){return _c('option',{key:roomType.id,domProps:{"value":roomType.id,"selected":_vm.viewSelectedRoom.roomTypeId == roomType.id}},[_vm._v(_vm._s(roomType.name))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}],staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal","type":"button"},on:{"click":function($event){return _vm.deleteField(_vm.viewSelectedRoom.id, 2)}}},[_c('span',[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.saveRoom()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRoom),expression:"isNewRoom"}]},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRoom),expression:"!isNewRoom"}]},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-lg btn-primary",staticStyle:{"width":"100%"},attrs:{"data-target":"#modal-area","data-toggle":"modal"}},[_c('i',{staticClass:"fa fa-building"}),_vm._v(" Bölge Tanımları\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 text-center"},[_c('button',{staticClass:"btn btn-lg btn-info",staticStyle:{"width":"100%"},attrs:{"data-target":"#modal-room-types","data-toggle":"modal"}},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipleri\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header",staticStyle:{"margin-top":"20px"}},[_c('h3',{staticClass:"box-title",staticStyle:{"font-size":"24px","line-height":"1.1"}},[_vm._v("1. Kat")]),_vm._v(" "),_c('div',{staticClass:"box-title pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Bölge Tanımları")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Daire Tipleri")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Oda Detayı")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Oda Adı :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-bed"}),_vm._v(" Kapasite :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Mevcut Kişi :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipi :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-sort"}),_vm._v(" Sıra Numarası :\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                Seçilenleri Odaya Ekle\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-home"}),_vm._v(" Oda Adı\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-bed"}),_vm._v(" Kapasite\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-sort"}),_vm._v(" Sıra Numarası\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{staticClass:"text-muted"},[_c('i',{staticClass:"fa fa-map-signs"}),_vm._v(" Daire Tipi\n                    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guards_vue__ = __webpack_require__(157);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea8f2ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guards_vue__ = __webpack_require__(374);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Guards_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ea8f2ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Guards_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guards')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guards')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('guardTour.guards')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newGuard()}}},[_vm._v(_vm._s(_vm.$ml.get('guardTour.newGuard')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length > 0),expression:"guardList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.guardList),function(guard){return _c('tr',{key:guard.id},[_c('td',[_vm._v("\n                      "+_vm._s(guard.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(guard.title != ''),expression:"guard.title != ''"}]},[_vm._v("("+_vm._s(guard.title)+")")])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getGuard(guard.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length == 0),expression:"guardList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('users.userNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('guardTour.guardInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4",attrs:{"align":"center"}},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.guard.image == null && this.tempUrl == null) || (this.guard.image == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.guard.image || this.tempUrl}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.guard.image),expression:"this.tempUrl || this.guard.image"}],staticClass:"text-red",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.remove'))+"\n                ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":300,"height":300,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('users.selectPhoto'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('guardTour.nameSurname')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.name),expression:"guard.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.guard.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('guardTour.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.title),expression:"guard.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.guard.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.mail),expression:"guard.mail"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"false","aria-autocomplete":"false"},domProps:{"value":(_vm.guard.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "mail", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.phoneNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.phone),expression:"guard.phone"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.guard.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "phone", $event.target.value)}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},attrs:{"data-toggle":"modal","data-target":"#modal-parola-guncelle"}},[_c('i',{staticClass:"fa fa-key"}),_vm._v(" "+_vm._s(_vm.$ml.get('guardTour.updatePassword'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('employees.mobileBrand')))]),_vm._v(" "),(_vm.guard.mobilUID)?_c('label',{staticClass:"form-control"},[_c('i',{staticClass:"fa fa-link"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.guard.mobileToken ? _vm.guard.mobileToken : _vm.$ml.get('employees.unknown'))}})]):_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('employees.notPaired')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%"},attrs:{"disabled":!_vm.guard.mobilUID},on:{"click":function($event){return _vm.removePhonePair()}}},[_c('i',{staticClass:"fa fa-ban"}),_vm._v(" "+_vm._s(_vm.$ml.get('employees.resetPairing')))])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('guardTour.responsibleUserForGuard')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-left":"20px"}},_vm._l((_vm.userList),function(user){return _c('div',{key:user.id,staticClass:"checkbox",staticStyle:{"margin":"5px"}},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.authorizedUserIds),expression:"guard.authorizedUserIds"}],attrs:{"type":"checkbox"},domProps:{"value":user.id,"checked":Array.isArray(_vm.guard.authorizedUserIds)?_vm._i(_vm.guard.authorizedUserIds,user.id)>-1:(_vm.guard.authorizedUserIds)},on:{"change":function($event){var $$a=_vm.guard.authorizedUserIds,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=user.id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.guard, "authorizedUserIds", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.guard, "authorizedUserIds", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.guard, "authorizedUserIds", $$c)}}}}),_vm._v("\n                              "+_vm._s(user.name)+"\n                            ")])])}),0)])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuard),expression:"!isNewGuard"}],staticClass:"btn btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewGuard),expression:"isNewGuard"}],staticClass:"btn btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuard),expression:"!isNewGuard"}],staticClass:"btn btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('guardTour.tourCalendar')))]),_vm._v(" "),_vm._l((_vm.dayList),function(day){return _c('div',{key:day.value,staticClass:"box box-primary collapsed-box",attrs:{"id":'day' + day.value}},[_c('div',{staticClass:"box-header with-border",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onCloseBoxDevice('day' + day.value)}}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(day.name))]),_vm._v(" "),_c('span',{staticClass:"badge label-primary"},[_vm._v(_vm._s(_vm.getCalendar(day.value).length))])]),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('ul',_vm._l((_vm.getCalendar(day.value)),function(cal){return _c('li',{key:cal.id},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectCalendar(cal)}}},[_vm._v(_vm._s(_vm.getGuardTourFromId(cal.tourId).name))]),_vm._v(" "),_c('button',{staticClass:"btn btn-xs btn-danger",on:{"click":function($event){return _vm.deleteCalendar(cal.id)}}},[_c('i',{staticClass:"fa fa-times"})])])}),0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuard),expression:"!isNewGuard"}],staticClass:"btn btn-xs btn-warning",staticStyle:{"width":"100%"},attrs:{"data-toggle":"modal","data-target":"#modal-tour"},on:{"click":function($event){return _vm.newCalendar(day.value)}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('guardTour.newCalendar'))+"\n            ")])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-parola-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.password),expression:"guard.password"}],staticClass:"form-control",attrs:{"type":"password","autocomplete":"false","aria-autocomplete":"false"},domProps:{"value":(_vm.guard.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.repeatPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guard.password2),expression:"guard.password2"}],staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":(_vm.guard.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guard, "password2", $event.target.value)}}})])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v("Parola güncellenecektir. Devam edilsin mi?")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.updatePassword()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.guard.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveGuard()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.guard.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveGuard()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.guard.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.deleteGuard()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-tour"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(6),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeTour($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.guardTourList),function(gt){return _c('option',{key:gt.id,domProps:{"value":gt.id,"selected":_vm.calendar.tourId == gt.id}},[_vm._v(_vm._s(gt.name))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTour),expression:"!isNewTour"}],staticClass:"btn btn-danger ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteCalendar(_vm.calendar.id)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTour),expression:"!isNewTour"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveCalendar()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewTour),expression:"isNewTour"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveCalendar()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Parola Güncelle")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Tur Takvimi")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-flag-checkered"}),_vm._v(" Tur\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Areas_vue__ = __webpack_require__(158);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14845f07_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Areas_vue__ = __webpack_require__(378);
function injectStyle (ssrContext) {
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14845f07"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Areas_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14845f07_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Areas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(377);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("756f3e94", content, true, {});

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".box[data-v-14845f07]{min-height:300px;height:300px;max-height:300px}", ""]);

// exports


/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.areas')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._l((_vm.areaList),function(area){return _c('div',{key:area.id,staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-2",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"modal","data-target":"#modal-area"},on:{"click":function($event){return _vm.selectArea(area)}}},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"box-header text-center"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(area.areaName))])]),_vm._v(" "),_c('div',{staticClass:"box-body text-center"},[_c('span',[_c('img',{staticStyle:{"width":"150px"},attrs:{"src":area.imagePath == '' || area.imagePath == null ? '/src/assets/buildings/office-building-19.png': '/src/assets/buildings/' + area.imagePath}})]),_vm._v(" "),_c('br')])])])}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-2",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"modal","data-target":"#modal-area"},on:{"click":function($event){return _vm.newArea()}}},[_vm._m(0)])],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-area"}},[_c('div',{class:_vm.newImg ? 'modal-dialog modal-lg' : 'modal-dialog'},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{domProps:{"textContent":_vm._s(_vm.area.areaName != '' ? _vm.area.areaName : 'Yeni Bölge')}})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.newImg ? 'col-sm-8' : 'col-sm-12'},[_c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"cursor":"pointer","width":"200px","height":"200px"},attrs:{"src":_vm.area.imagePath && _vm.area.imagePath != '' ? '/src/assets/buildings/' + _vm.area.imagePath : '/src/assets/buildings/office-building-19.png'},on:{"click":function($event){_vm.newImg = true}}}),_vm._v(" "),_c('h3',[_c('span',{domProps:{"textContent":_vm._s(_vm.area.areaName != '' ? _vm.area.areaName : 'Yeni Bölge')}})]),_vm._v(" "),_c('span',{staticClass:"text-muted"},[_vm._v("Görseli değiştirmek için üzerine tıklayın.")]),_vm._v(" "),_c('h4')]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.area.areaName),expression:"area.areaName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.area.areaName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.area, "areaName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.newImg),expression:"newImg"}],staticClass:"col-sm-4"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Arama yapın...","autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchText),expression:"searchText"}],staticClass:"btn btn-warning ",attrs:{"type":"button"},on:{"click":function($event){_vm.searchText = ''}}},[_c('i',{staticClass:"fa fa-trash"})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgList.length > 0),expression:"imgList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"height":"400px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.imgList),function(img,index){return _c('tr',{key:index,class:_vm.area.imagePath == img.target ? 'bg-primary' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){_vm.area.imagePath = img.target;}}},[_c('td',[_c('img',{staticStyle:{"width":"50px","height":"50px"},attrs:{"src":'/src/assets/buildings/' + img.target}})]),_vm._v(" "),_c('td',{staticStyle:{"padding-top":"25px"}},[_vm._v(_vm._s(img.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.imgList.length == 0),expression:"imgList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                Aramanıza uygun sonuç bulunamadı.\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"btn btn-danger ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteArea()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.delete'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewArea),expression:"!isNewArea"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveArea()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.update'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewArea),expression:"isNewArea"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveArea()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.save'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body text-center text-primary"},[_c('span',{staticStyle:{"font-size":"50px","padding-top":"70px","display":"inherit"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('h4',[_vm._v("Yeni Bölge Ekle")])]),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Bölge Adı\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-picture-o"}),_vm._v(" Bölge Görseli\n              ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary ",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPoints_vue__ = __webpack_require__(159);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57eaddee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPoints_vue__ = __webpack_require__(382);
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57eaddee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ControlPoints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57eaddee_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ControlPoints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(381);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("5e46ba91", content, true, {});

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".box[data-v-57eaddee]{min-height:300px;height:300px;max-height:300px}", ""]);

// exports


/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.points')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.points')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_vm._l((_vm.controlPointList),function(controlPoint){return _c('div',{key:controlPoint.id,staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-2",staticStyle:{"cursor":"pointer"}},[_c('div',{staticClass:"box"},[_c('div',{attrs:{"data-toggle":"modal","data-target":"#modal-control-point"},on:{"click":function($event){return _vm.selectControlPoint(controlPoint)}}},[_c('div',{staticClass:"box-body text-center"},[_c('span',[_c('img',{staticStyle:{"width":"100px"},attrs:{"src":_vm.getAreaImageFromId(controlPoint.areaId) == '' || _vm.getAreaImageFromId(controlPoint.areaId) == null ? '/src/assets/buildings/office-building-19.png' : '/src/assets/buildings/' + _vm.getAreaImageFromId(controlPoint.areaId)}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12px","font-weight":"bold"}},[_vm._v(_vm._s(controlPoint.name))])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-center"},[_c('p',{staticStyle:{"font-size":"12px"}},[_c('span',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.getAreaNameFromId(controlPoint.areaId)))])]),_vm._v(" "),_c('button',{staticClass:"btn",staticStyle:{"margin":"0px"},attrs:{"data-target":"#qr-code","data-toggle":"modal"},on:{"click":function($event){return _vm.selectControlPoint(controlPoint)}}},[_vm._v(_vm._s(_vm.$ml.get('general.viewQRCode'))+"\n            ")])])])])}),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 col-md-4 col-lg-2",staticStyle:{"cursor":"pointer"},attrs:{"data-toggle":"modal","data-target":"#modal-control-point"},on:{"click":function($event){return _vm.newControlPoint()}}},[_vm._m(0)])],2)]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-control-point"}},[_c('div',{class:_vm.newImg ? 'modal-dialog' : 'modal-dialog'},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',{domProps:{"textContent":_vm._s(_vm.controlPoint.name != '' ? _vm.controlPoint.name : 'Yeni Kontrol Noktası')}})])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"width":"200px","height":"200px"},attrs:{"src":_vm.getAreaImageFromId(_vm.controlPoint.areaId) && _vm.getAreaImageFromId(_vm.controlPoint.areaId) != '' ? '/src/assets/buildings/' + _vm.getAreaImageFromId(_vm.controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'}}),_vm._v(" "),_c('h3',[_c('span',{domProps:{"textContent":_vm._s(_vm.controlPoint.name != '' ? _vm.controlPoint.name : 'Yeni Kontrol Noktası')}})])]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.controlPoint.name),expression:"controlPoint.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.controlPoint.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.controlPoint, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(3),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeArea($event)}}},[_c('option',[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.areaList),function(area){return _c('option',{key:area.id,domProps:{"value":area.id,"selected":_vm.controlPoint.areaId == area.id}},[_vm._v(_vm._s(area.areaName))])})],2)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v("X Koordinatı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.controlPoint.positionX),expression:"controlPoint.positionX"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.controlPoint.positionX)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.controlPoint, "positionX", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v("Y Koordinatı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.controlPoint.positionY),expression:"controlPoint.positionY"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.controlPoint.positionY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.controlPoint, "positionY", $event.target.value)}}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewControlPoint),expression:"!isNewControlPoint"}],staticClass:"btn btn-danger ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteControlPoint()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.delete'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewControlPoint),expression:"!isNewControlPoint"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveControlPoint()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.update'))+"\n            ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewControlPoint),expression:"isNewControlPoint"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveControlPoint()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.save'))+"\n            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"qr-code","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_c('i',{staticClass:"fa fa-qrcode"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.qRCodeBarcodePrint'))+"\n          ")]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8",attrs:{"id":"print"}},[_c('div',{style:(_vm.qrTextStyle)},[_c('qrcode-vue',{attrs:{"renderAs":"svg","value":_vm.qrValue,"size":_vm.qrSize,"level":"H"}}),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"margin-bottom":"5px"}},[_c('strong',[_vm._v(_vm._s(_vm.controlPoint.name))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getAreaNameFromId(_vm.controlPoint.areaId)))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('general.qrSettings')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.qrSize')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrSize),expression:"qrSize"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.qrSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qrSize=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.qrTextStyle == 'text-align:left;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:left;'}}},[_c('i',{staticClass:"fa fa-align-left"})]),_vm._v(" "),_c('button',{class:_vm.qrTextStyle == 'text-align:center;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:center;'}}},[_c('i',{staticClass:"fa fa-align-center"})]),_vm._v(" "),_c('button',{class:_vm.qrTextStyle == 'text-align:right;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:right;'}}},[_c('i',{staticClass:"fa fa-align-right"})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.print()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.print'))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"box-body text-center text-primary"},[_c('span',{staticStyle:{"font-size":"50px","padding-top":"70px","display":"inherit"}},[_c('i',{staticClass:"fa fa-plus-circle"}),_vm._v(" "),_c('h4',[_vm._v("Yeni Kontrol Noktası Ekle")])]),_vm._v(" "),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" Kontrol Noktası Adı\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-building"}),_vm._v(" Bölge\n                ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardTours_vue__ = __webpack_require__(160);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e5d1f2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardTours_vue__ = __webpack_require__(385);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardTours_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e5d1f2e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardTours_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * alertifyjs 1.13.1 http://alertifyjs.com
 * AlertifyJS is a javascript framework for developing pretty browser dialogs and notifications.
 * Copyright 2019 Mohammad Younes <Mohammad@alertifyjs.com> (http://alertifyjs.com) 
 * Licensed under GPL 3 <https://opensource.org/licenses/gpl-3.0>*/
( function ( window ) {
    'use strict';
    var NOT_DISABLED_NOT_RESET = ':not(:disabled):not(.ajs-reset)';
    /**
     * Keys enum
     * @type {Object}
     */
    var keys = {
        ENTER: 13,
        ESC: 27,
        F1: 112,
        F12: 123,
        LEFT: 37,
        RIGHT: 39,
        TAB: 9
    };
    /**
     * Default options 
     * @type {Object}
     */
    var defaults = {
        autoReset:true,
        basic:false,
        closable:true,
        closableByDimmer:true,
        invokeOnCloseOff:false,
        frameless:false,
        defaultFocusOff:false,
        maintainFocus:true, //global default not per instance, applies to all dialogs
        maximizable:true,
        modal:true,
        movable:true,
        moveBounded:false,
        overflow:true,
        padding: true,
        pinnable:true,
        pinned:true,
        preventBodyShift:false, //global default not per instance, applies to all dialogs
        resizable:true,
        startMaximized:false,
        transition:'pulse',
        transitionOff:false,
        tabbable:['button', '[href]', 'input', 'select', 'textarea', '[tabindex]:not([tabindex^="-"])'+NOT_DISABLED_NOT_RESET].join(NOT_DISABLED_NOT_RESET+','),//global
        notifier:{
            delay:5,
            position:'bottom-right',
            closeButton:false,
            classes: {
                base: 'alertify-notifier',
                prefix:'ajs-',
                message: 'ajs-message',
                top: 'ajs-top',
                right: 'ajs-right',
                bottom: 'ajs-bottom',
                left: 'ajs-left',
                center: 'ajs-center',
                visible: 'ajs-visible',
                hidden: 'ajs-hidden',
                close: 'ajs-close'
            }
        },
        glossary:{
            title:'AlertifyJS',
            ok: 'OK',
            cancel: 'Cancel',
            acccpt: 'Accept',
            deny: 'Deny',
            confirm: 'Confirm',
            decline: 'Decline',
            close: 'Close',
            maximize: 'Maximize',
            restore: 'Restore',
        },
        theme:{
            input:'ajs-input',
            ok:'ajs-ok',
            cancel:'ajs-cancel',
        },
        hooks:{
            preinit:function(){},
            postinit:function(){}
        }
    };
    
    //holds open dialogs instances
    var openDialogs = [];

    /**
     * [Helper]  Adds the specified class(es) to the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be added to the class attribute of the element.
     * 
     * @return {undefined}
     */
    function addClass(element,classNames){
        element.className += ' ' + classNames;
    }
    
    /**
     * [Helper]  Removes the specified class(es) from the element.
     *
     * @element {node}      The element
     * @className {string}  One or more space-separated classes to be removed from the class attribute of the element.
     * 
     * @return {undefined}
     */
    function removeClass(element, classNames) {
        var original = element.className.split(' ');
        var toBeRemoved = classNames.split(' ');
        for (var x = 0; x < toBeRemoved.length; x += 1) {
            var index = original.indexOf(toBeRemoved[x]);
            if (index > -1){
                original.splice(index,1);
            }
        }
        element.className = original.join(' ');
    }

    /**
     * [Helper]  Checks if the document is RTL
     *
     * @return {Boolean} True if the document is RTL, false otherwise.
     */
    function isRightToLeft(){
        return window.getComputedStyle(document.body).direction === 'rtl';
    }
    /**
     * [Helper]  Get the document current scrollTop
     *
     * @return {Number} current document scrollTop value
     */
    function getScrollTop(){
        return ((document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop);
    }

    /**
     * [Helper]  Get the document current scrollLeft
     *
     * @return {Number} current document scrollLeft value
     */
    function getScrollLeft(){
        return ((document.documentElement && document.documentElement.scrollLeft) || document.body.scrollLeft);
    }

    /**
    * Helper: clear contents
    *
    */
    function clearContents(element){
        while (element.lastChild) {
            element.removeChild(element.lastChild);
        }
    }
    /**
     * Extends a given prototype by merging properties from base into sub.
     *
     * @sub {Object} sub The prototype being overwritten.
     * @base {Object} base The prototype being written.
     *
     * @return {Object} The extended prototype.
     */
    function copy(src) {
        if(null === src){
            return src;
        }
        var cpy;
        if(Array.isArray(src)){
            cpy = [];
            for(var x=0;x<src.length;x+=1){
                cpy.push(copy(src[x]));
            }
            return cpy;
        }
      
        if(src instanceof Date){
            return new Date(src.getTime());
        }
      
        if(src instanceof RegExp){
            cpy = new RegExp(src.source);
            cpy.global = src.global;
            cpy.ignoreCase = src.ignoreCase;
            cpy.multiline = src.multiline;
            cpy.lastIndex = src.lastIndex;
            return cpy;
        }
        
        if(typeof src === 'object'){
            cpy = {};
            // copy dialog pototype over definition.
            for (var prop in src) {
                if (src.hasOwnProperty(prop)) {
                    cpy[prop] = copy(src[prop]);
                }
            }
            return cpy;
        }
        return src;
    }
    /**
      * Helper: destruct the dialog
      *
      */
    function destruct(instance, initialize){
        if(instance.elements){
            //delete the dom and it's references.
            var root = instance.elements.root;
            root.parentNode.removeChild(root);
            delete instance.elements;
            //copy back initial settings.
            instance.settings = copy(instance.__settings);
            //re-reference init function.
            instance.__init = initialize;
            //delete __internal variable to allow re-initialization.
            delete instance.__internal;
        }
    }

    /**
     * Test to check if passive event listeners are supported.
     */
    var IsPassiveSupported = false;
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                IsPassiveSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {}

     /**
     * Removes an event listener
     *
     * @param {HTMLElement} el The EventTarget to register the listenr on.
     * @param {string} event The event type to listen for.
     * @param {Function} handler The function to handle the event.
     * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
     * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
     */
    var on = function (el, event, fn, useCapture, passive) {
        el.addEventListener(event, fn, IsPassiveSupported ? { capture: useCapture, passive: passive } : useCapture === true);
    };

    /**
     * Removes an event listener
     *
     * @param {HTMLElement} el The EventTarget to unregister the listenr from.
     * @param {string} event The event type to remove.
     * @param {Function} fn The event handler to remove.
     * @param {boolean} useCapture Specifices if the event to be dispatched to the registered listener before being dispatched to any EventTarget beneath it in the DOM tree.
     * @param {boolean} passive A Boolean which, if true, indicates that the function specified by listener will never call preventDefault().
     */
    var off = function (el, event, fn, useCapture, passive) {
        el.removeEventListener(event, fn, IsPassiveSupported ? { capture: useCapture, passive: passive } : useCapture === true);
    };

    /**
     * Prevent default event from firing
     *
     * @param  {Event} event Event object
     * @return {undefined}

    function prevent ( event ) {
        if ( event ) {
            if ( event.preventDefault ) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }
        }
    }
    */
    var transition = (function () {
        var t, type;
        var supported = false;
        var transitions = {
            'animation'        : 'animationend',
            'OAnimation'       : 'oAnimationEnd oanimationend',
            'msAnimation'      : 'MSAnimationEnd',
            'MozAnimation'     : 'animationend',
            'WebkitAnimation'  : 'webkitAnimationEnd'
        };

        for (t in transitions) {
            if (document.documentElement.style[t] !== undefined) {
                type = transitions[t];
                supported = true;
                break;
            }
        }

        return {
            type: type,
            supported: supported
        };
    }());

    /**
    * Creates event handler delegate that sends the instance as last argument.
    * 
    * @return {Function}    a function wrapper which sends the instance as last argument.
    */
    function delegate(context, method) {
        return function () {
            if (arguments.length > 0) {
                var args = [];
                for (var x = 0; x < arguments.length; x += 1) {
                    args.push(arguments[x]);
                }
                args.push(context);
                return method.apply(context, args);
            }
            return method.apply(context, [null, context]);
        };
    }
    /**
    * Helper for creating a dialog close event.
    * 
    * @return {object}
    */
    function createCloseEvent(index, button) {
        return {
            index: index,
            button: button,
            cancel: false
        };
    }
    /**
    * Helper for dispatching events.
    *
    * @param  {string} evenType The type of the event to disptach.
    * @param  {object} instance The dialog instance disptaching the event.
    *
    * @return   {any}   The result of the invoked function.
    */
    function dispatchEvent(eventType, instance) {
        if ( typeof instance.get(eventType) === 'function' ) {
            return instance.get(eventType).call(instance);
        }
    }


    /**
     * Super class for all dialogs
     *
     * @return {Object}		base dialog prototype
     */
    var dialog = (function () {
        var //holds the list of used keys.
            usedKeys = [],
            //dummy variable, used to trigger dom reflow.
            reflow = null,
            //holds body tab index in case it has any.
            tabindex = false,
            //condition for detecting safari
            isSafari = window.navigator.userAgent.indexOf('Safari') > -1 && window.navigator.userAgent.indexOf('Chrome') < 0,
            //dialog building blocks
            templates = {
                dimmer:'<div class="ajs-dimmer"></div>',
                /*tab index required to fire click event before body focus*/
                modal: '<div class="ajs-modal" tabindex="0"></div>',
                dialog: '<div class="ajs-dialog" tabindex="0"></div>',
                reset: '<button class="ajs-reset"></button>',
                commands: '<div class="ajs-commands"><button class="ajs-pin"></button><button class="ajs-maximize"></button><button class="ajs-close"></button></div>',
                header: '<div class="ajs-header"></div>',
                body: '<div class="ajs-body"></div>',
                content: '<div class="ajs-content"></div>',
                footer: '<div class="ajs-footer"></div>',
                buttons: { primary: '<div class="ajs-primary ajs-buttons"></div>', auxiliary: '<div class="ajs-auxiliary ajs-buttons"></div>' },
                button: '<button class="ajs-button"></button>',
                resizeHandle: '<div class="ajs-handle"></div>',
            },
            //common class names
            classes = {
                animationIn: 'ajs-in',
                animationOut: 'ajs-out',
                base: 'alertify',
                basic:'ajs-basic',
                capture: 'ajs-capture',
                closable:'ajs-closable',
                fixed: 'ajs-fixed',
                frameless:'ajs-frameless',
                hidden: 'ajs-hidden',
                maximize: 'ajs-maximize',
                maximized: 'ajs-maximized',
                maximizable:'ajs-maximizable',
                modeless: 'ajs-modeless',
                movable: 'ajs-movable',
                noSelection: 'ajs-no-selection',
                noOverflow: 'ajs-no-overflow',
                noPadding:'ajs-no-padding',
                pin:'ajs-pin',
                pinnable:'ajs-pinnable',
                prefix: 'ajs-',
                resizable: 'ajs-resizable',
                restore: 'ajs-restore',
                shake:'ajs-shake',
                unpinned:'ajs-unpinned',
                noTransition:'ajs-no-transition'
            };

        /**
         * Helper: initializes the dialog instance
         * 
         * @return	{Number}	The total count of currently open modals.
         */
        function initialize(instance){
            
            if(!instance.__internal){
                //invoke preinit global hook
                alertify.defaults.hooks.preinit(instance);
                //no need to expose init after this.
                delete instance.__init;
              
                //keep a copy of initial dialog settings
                if(!instance.__settings){
                    instance.__settings = copy(instance.settings);
                }
                
                //get dialog buttons/focus setup
                var setup;
                if(typeof instance.setup === 'function'){
                    setup = instance.setup();
                    setup.options = setup.options  || {};
                    setup.focus = setup.focus  || {};
                }else{
                    setup = {
                        buttons:[],
                        focus:{
                            element:null,
                            select:false
                        },
                        options:{
                        }
                    };
                }
                
                //initialize hooks object.
                if(typeof instance.hooks !== 'object'){
                    instance.hooks = {};
                }

                //copy buttons defintion
                var buttonsDefinition = [];
                if(Array.isArray(setup.buttons)){
                    for(var b=0;b<setup.buttons.length;b+=1){
                        var ref  = setup.buttons[b],
                            cpy = {};
                        for (var i in ref) {
                            if (ref.hasOwnProperty(i)) {
                                cpy[i] = ref[i];
                            }
                        }
                        buttonsDefinition.push(cpy);
                    }
                }

                var internal = instance.__internal = {
                    /**
                     * Flag holding the open state of the dialog
                     * 
                     * @type {Boolean}
                     */
                    isOpen:false,
                    /**
                     * Active element is the element that will receive focus after
                     * closing the dialog. It defaults as the body tag, but gets updated
                     * to the last focused element before the dialog was opened.
                     *
                     * @type {Node}
                     */
                    activeElement:document.body,
                    timerIn:undefined,
                    timerOut:undefined,
                    buttons: buttonsDefinition,
                    focus: setup.focus,
                    options: {
                        title: undefined,
                        modal: undefined,
                        basic:undefined,
                        frameless:undefined,
                        defaultFocusOff:undefined,
                        pinned: undefined,
                        movable: undefined,
                        moveBounded:undefined,
                        resizable: undefined,
                        autoReset: undefined,
                        closable: undefined,
                        closableByDimmer: undefined,
                        invokeOnCloseOff:undefined,
                        maximizable: undefined,
                        startMaximized: undefined,
                        pinnable: undefined,
                        transition: undefined,
                        transitionOff: undefined,
                        padding:undefined,
                        overflow:undefined,
                        onshow:undefined,
                        onclosing:undefined,
                        onclose:undefined,
                        onfocus:undefined,
                        onmove:undefined,
                        onmoved:undefined,
                        onresize:undefined,
                        onresized:undefined,
                        onmaximize:undefined,
                        onmaximized:undefined,
                        onrestore:undefined,
                        onrestored:undefined
                    },
                    resetHandler:undefined,
                    beginMoveHandler:undefined,
                    beginResizeHandler:undefined,
                    bringToFrontHandler:undefined,
                    modalClickHandler:undefined,
                    buttonsClickHandler:undefined,
                    commandsClickHandler:undefined,
                    transitionInHandler:undefined,
                    transitionOutHandler:undefined,
                    destroy:undefined
                };

                var elements = {};
                //root node
                elements.root = document.createElement('div');
                //prevent FOUC in case of async styles loading.
                elements.root.style.display = 'none';
                elements.root.className = classes.base + ' ' + classes.hidden + ' ';

                elements.root.innerHTML = templates.dimmer + templates.modal;
                
                //dimmer
                elements.dimmer = elements.root.firstChild;

                //dialog
                elements.modal = elements.root.lastChild;
                elements.modal.innerHTML = templates.dialog;
                elements.dialog = elements.modal.firstChild;
                elements.dialog.innerHTML = templates.reset + templates.commands + templates.header + templates.body + templates.footer + templates.resizeHandle + templates.reset;

                //reset links
                elements.reset = [];
                elements.reset.push(elements.dialog.firstChild);
                elements.reset.push(elements.dialog.lastChild);
                
                //commands
                elements.commands = {};
                elements.commands.container = elements.reset[0].nextSibling;
                elements.commands.pin = elements.commands.container.firstChild;
                elements.commands.maximize = elements.commands.pin.nextSibling;
                elements.commands.close = elements.commands.maximize.nextSibling;
                
                //header
                elements.header = elements.commands.container.nextSibling;

                //body
                elements.body = elements.header.nextSibling;
                elements.body.innerHTML = templates.content;
                elements.content = elements.body.firstChild;

                //footer
                elements.footer = elements.body.nextSibling;
                elements.footer.innerHTML = templates.buttons.auxiliary + templates.buttons.primary;
                
                //resize handle
                elements.resizeHandle = elements.footer.nextSibling;

                //buttons
                elements.buttons = {};
                elements.buttons.auxiliary = elements.footer.firstChild;
                elements.buttons.primary = elements.buttons.auxiliary.nextSibling;
                elements.buttons.primary.innerHTML = templates.button;
                elements.buttonTemplate = elements.buttons.primary.firstChild;
                //remove button template
                elements.buttons.primary.removeChild(elements.buttonTemplate);
                               
                for(var x=0; x < instance.__internal.buttons.length; x+=1) {
                    var button = instance.__internal.buttons[x];
                    
                    // add to the list of used keys.
                    if(usedKeys.indexOf(button.key) < 0){
                        usedKeys.push(button.key);
                    }

                    button.element = elements.buttonTemplate.cloneNode();
                    button.element.innerHTML = button.text;
                    if(typeof button.className === 'string' &&  button.className !== ''){
                        addClass(button.element, button.className);
                    }
                    for(var key in button.attrs){
                        if(key !== 'className' && button.attrs.hasOwnProperty(key)){
                            button.element.setAttribute(key, button.attrs[key]);
                        }
                    }
                    if(button.scope === 'auxiliary'){
                        elements.buttons.auxiliary.appendChild(button.element);
                    }else{
                        elements.buttons.primary.appendChild(button.element);
                    }
                }
                //make elements pubic
                instance.elements = elements;
                
                //save event handlers delegates
                internal.resetHandler = delegate(instance, onReset);
                internal.beginMoveHandler = delegate(instance, beginMove);
                internal.beginResizeHandler = delegate(instance, beginResize);
                internal.bringToFrontHandler = delegate(instance, bringToFront);
                internal.modalClickHandler = delegate(instance, modalClickHandler);
                internal.buttonsClickHandler = delegate(instance, buttonsClickHandler);
                internal.commandsClickHandler = delegate(instance, commandsClickHandler);
                internal.transitionInHandler = delegate(instance, handleTransitionInEvent);
                internal.transitionOutHandler = delegate(instance, handleTransitionOutEvent);

                //settings
                for(var opKey in internal.options){
                    if(setup.options[opKey] !== undefined){
                        // if found in user options
                        instance.set(opKey, setup.options[opKey]);
                    }else if(alertify.defaults.hasOwnProperty(opKey)) {
                        // else if found in defaults options
                        instance.set(opKey, alertify.defaults[opKey]);
                    }else if(opKey === 'title' ) {
                        // else if title key, use alertify.defaults.glossary
                        instance.set(opKey, alertify.defaults.glossary[opKey]);
                    }
                }

                // allow dom customization
                if(typeof instance.build === 'function'){
                    instance.build();
                }

                //invoke postinit global hook
                alertify.defaults.hooks.postinit(instance);
            }

            //add to the end of the DOM tree.
            document.body.appendChild(instance.elements.root);
        }

        /**
         * Helper: maintains scroll position
         *
         */
        var scrollX, scrollY;
        function saveScrollPosition(){
            scrollX = getScrollLeft();
            scrollY = getScrollTop();
        }
        function restoreScrollPosition(){
            window.scrollTo(scrollX, scrollY);
        }

        /**
         * Helper: adds/removes no-overflow class from body
         *
         */
        function ensureNoOverflow(){
            var requiresNoOverflow = 0;
            for(var x=0;x<openDialogs.length;x+=1){
                var instance = openDialogs[x];
                if(instance.isModal() || instance.isMaximized()){
                    requiresNoOverflow+=1;
                }
            }
            if(requiresNoOverflow === 0 && document.body.className.indexOf(classes.noOverflow) >= 0){
                //last open modal or last maximized one
                removeClass(document.body, classes.noOverflow);
                preventBodyShift(false);
            }else if(requiresNoOverflow > 0 && document.body.className.indexOf(classes.noOverflow) < 0){
                //first open modal or first maximized one
                preventBodyShift(true);
                addClass(document.body, classes.noOverflow);
            }
        }
        var top = '', topScroll = 0;
        /**
         * Helper: prevents body shift.
         *
         */
        function preventBodyShift(add){
            if(alertify.defaults.preventBodyShift){
                if(add && document.documentElement.scrollHeight > document.documentElement.clientHeight ){//&& openDialogs[openDialogs.length-1].elements.dialog.clientHeight <= document.documentElement.clientHeight){
                    topScroll = scrollY;
                    top = window.getComputedStyle(document.body).top;
                    addClass(document.body, classes.fixed);
                    document.body.style.top = -scrollY + 'px';
                } else if(!add) {
                    scrollY = topScroll;
                    document.body.style.top = top;
                    removeClass(document.body, classes.fixed);
                    restoreScrollPosition();
                }
            }
        }
		
        /**
         * Sets the name of the transition used to show/hide the dialog
         * 
         * @param {Object} instance The dilog instance.
         *
         */
        function updateTransition(instance, value, oldValue){
            if(typeof oldValue === 'string'){
                removeClass(instance.elements.root,classes.prefix +  oldValue);
            }
            addClass(instance.elements.root, classes.prefix + value);
            reflow = instance.elements.root.offsetWidth;
        }

        /**
         * Toggles the dialog no transition 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateTransitionOff(instance){
            if (instance.get('transitionOff')) {
                // add class
                addClass(instance.elements.root, classes.noTransition);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.noTransition);
            }
        }

        /**
         * Toggles the dialog display mode
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateDisplayMode(instance){
            if(instance.get('modal')){

                //make modal
                removeClass(instance.elements.root, classes.modeless);

                //only if open
                if(instance.isOpen()){
                    unbindModelessEvents(instance);

                    //in case a pinned modless dialog was made modal while open.
                    updateAbsPositionFix(instance);

                    ensureNoOverflow();
                }
            }else{
                //make modelss
                addClass(instance.elements.root, classes.modeless);

                //only if open
                if(instance.isOpen()){
                    bindModelessEvents(instance);

                    //in case pin/unpin was called while a modal is open
                    updateAbsPositionFix(instance);

                    ensureNoOverflow();
                }
            }
        }

        /**
         * Toggles the dialog basic view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateBasicMode(instance){
            if (instance.get('basic')) {
                // add class
                addClass(instance.elements.root, classes.basic);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.basic);
            }
        }

        /**
         * Toggles the dialog frameless view mode 
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function updateFramelessMode(instance){
            if (instance.get('frameless')) {
                // add class
                addClass(instance.elements.root, classes.frameless);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.frameless);
            }
        }
		
        /**
         * Helper: Brings the modeless dialog to front, attached to modeless dialogs.
         *
         * @param {Event} event Focus event
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bringToFront(event, instance){
            
            // Do not bring to front if preceeded by an open modal
            var index = openDialogs.indexOf(instance);
            for(var x=index+1;x<openDialogs.length;x+=1){
                if(openDialogs[x].isModal()){
                    return;
                }
            }
			
            // Bring to front by making it the last child.
            if(document.body.lastChild !== instance.elements.root){
                document.body.appendChild(instance.elements.root);
                //also make sure its at the end of the list
                openDialogs.splice(openDialogs.indexOf(instance),1);
                openDialogs.push(instance);
                setFocus(instance);
            }
			
            return false;
        }
		
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {String} option The updated option name.
         *
         * @return	{undefined}	
         */
        function optionUpdated(instance, option, oldValue, newValue){
            switch(option){
            case 'title':
                instance.setHeader(newValue);
                break;
            case 'modal':
                updateDisplayMode(instance);
                break;
            case 'basic':
                updateBasicMode(instance);
                break;
            case 'frameless':
                updateFramelessMode(instance);
                break;
            case 'pinned':
                updatePinned(instance);
                break;
            case 'closable':
                updateClosable(instance);
                break;
            case 'maximizable':
                updateMaximizable(instance);
                break;
            case 'pinnable':
                updatePinnable(instance);
                break;
            case 'movable':
                updateMovable(instance);
                break;
            case 'resizable':
                updateResizable(instance);
                break;
            case 'padding':
                if(newValue){
                    removeClass(instance.elements.root, classes.noPadding);
                }else if(instance.elements.root.className.indexOf(classes.noPadding) < 0){
                    addClass(instance.elements.root, classes.noPadding);
                }
                break;
            case 'overflow':
                if(newValue){
                    removeClass(instance.elements.root, classes.noOverflow);
                }else if(instance.elements.root.className.indexOf(classes.noOverflow) < 0){
                    addClass(instance.elements.root, classes.noOverflow);
                }
                break;
            case 'transition':
                updateTransition(instance,newValue, oldValue);
                break;
            case 'transitionOff':
                updateTransitionOff(instance);
                break;
            }

            // internal on option updated event
            if(typeof instance.hooks.onupdate === 'function'){
                instance.hooks.onupdate.call(instance, option, oldValue, newValue);
            }
        }
		
        /**
         * Helper: reflects dialogs options updates
         *
         * @param {Object} instance The dilog instance.
         * @param {Object} obj The object to set/get a value on/from.
         * @param {Function} callback The callback function to call if the key was found.
         * @param {String|Object} key A string specifying a propery name or a collection of key value pairs.
         * @param {Object} value Optional, the value associated with the key (in case it was a string).
         * @param {String} option The updated option name.
         *
         * @return	{Object} result object 
         *	The result objects has an 'op' property, indicating of this is a SET or GET operation.
         *		GET: 
         *		- found: a flag indicating if the key was found or not.
         *		- value: the property value.
         *		SET:
         *		- items: a list of key value pairs of the properties being set.
         *				each contains:
         *					- found: a flag indicating if the key was found or not.
         *					- key: the property key.
         *					- value: the property value.
         */
        function update(instance, obj, callback, key, value){
            var result = {op:undefined, items: [] };
            if(typeof value === 'undefined' && typeof key === 'string') {
                //get
                result.op = 'get';
                if(obj.hasOwnProperty(key)){
                    result.found = true;
                    result.value = obj[key];
                }else{
                    result.found = false;
                    result.value = undefined;
                }
            }
            else
            {
                var old;
                //set
                result.op = 'set';
                if(typeof key === 'object'){
                    //set multiple
                    var args = key;
                    for (var prop in args) {
                        if (obj.hasOwnProperty(prop)) {
                            if(obj[prop] !== args[prop]){
                                old = obj[prop];
                                obj[prop] = args[prop];
                                callback.call(instance,prop, old, args[prop]);
                            }
                            result.items.push({ 'key': prop, 'value': args[prop], 'found':true});
                        }else{
                            result.items.push({ 'key': prop, 'value': args[prop], 'found':false});
                        }
                    }
                } else if (typeof key === 'string'){
                    //set single
                    if (obj.hasOwnProperty(key)) {
                        if(obj[key] !== value){
                            old  = obj[key];
                            obj[key] = value;
                            callback.call(instance,key, old, value);
                        }
                        result.items.push({'key': key, 'value': value , 'found':true});

                    }else{
                        result.items.push({'key': key, 'value': value , 'found':false});
                    }
                } else {
                    //invalid params
                    throw new Error('args must be a string or object');
                }
            }
            return result;
        }


        /**
         * Triggers a close event.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function triggerClose(instance) {
            var found;
            triggerCallback(instance, function (button) {
                return found = instance.get('invokeOnCloseOff') !== true && (button.invokeOnClose === true);
            });
            //none of the buttons registered as onclose callback
            //close the dialog
            if (!found && instance.isOpen()) {
                instance.close();
            }
        }

        /**
         * Dialogs commands event handler, attached to the dialog commands element.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function commandsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            switch (target) {
            case instance.elements.commands.pin:
                if (!instance.isPinned()) {
                    pin(instance);
                } else {
                    unpin(instance);
                }
                break;
            case instance.elements.commands.maximize:
                if (!instance.isMaximized()) {
                    maximize(instance);
                } else {
                    restore(instance);
                }
                break;
            case instance.elements.commands.close:
                triggerClose(instance);
                break;
            }
            return false;
        }

        /**
         * Helper: pins the modeless dialog.
         *
         * @param {Object} instance	The dialog instance.
         * 
         * @return {undefined}
         */
        function pin(instance) {
            //pin the dialog
            instance.set('pinned', true);
        }

        /**
         * Helper: unpins the modeless dialog.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function unpin(instance) {
            //unpin the dialog 
            instance.set('pinned', false);
        }


        /**
         * Helper: enlarges the dialog to fill the entire screen.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function maximize(instance) {
            // allow custom `onmaximize` method
            dispatchEvent('onmaximize', instance);
            //maximize the dialog 
            addClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) {
                ensureNoOverflow();
            }
            // allow custom `onmaximized` method
            dispatchEvent('onmaximized', instance);
        }

        /**
         * Helper: returns the dialog to its former size.
         *
         * @param {Object} instance	The dilog instance.
         * 
         * @return {undefined}
         */
        function restore(instance) {
            // allow custom `onrestore` method
            dispatchEvent('onrestore', instance);
            //maximize the dialog 
            removeClass(instance.elements.root, classes.maximized);
            if (instance.isOpen()) {
                ensureNoOverflow();
            }
            // allow custom `onrestored` method
            dispatchEvent('onrestored', instance);
        }

        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updatePinnable(instance) {
            if (instance.get('pinnable')) {
                // add class
                addClass(instance.elements.root, classes.pinnable);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.pinnable);
            }
        }

        /**
         * Helper: Fixes the absolutly positioned modal div position.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function addAbsPositionFix(instance) {
            var scrollLeft = getScrollLeft();
            instance.elements.modal.style.marginTop = getScrollTop() + 'px';
            instance.elements.modal.style.marginLeft = scrollLeft + 'px';
            instance.elements.modal.style.marginRight = (-scrollLeft) + 'px';
        }

        /**
         * Helper: Removes the absolutly positioned modal div position fix.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function removeAbsPositionFix(instance) {
            var marginTop = parseInt(instance.elements.modal.style.marginTop, 10);
            var marginLeft = parseInt(instance.elements.modal.style.marginLeft, 10);
            instance.elements.modal.style.marginTop = '';
            instance.elements.modal.style.marginLeft = '';
            instance.elements.modal.style.marginRight = '';

            if (instance.isOpen()) {
                var top = 0,
                    left = 0
                ;
                if (instance.elements.dialog.style.top !== '') {
                    top = parseInt(instance.elements.dialog.style.top, 10);
                }
                instance.elements.dialog.style.top = (top + (marginTop - getScrollTop())) + 'px';

                if (instance.elements.dialog.style.left !== '') {
                    left = parseInt(instance.elements.dialog.style.left, 10);
                }
                instance.elements.dialog.style.left = (left + (marginLeft - getScrollLeft())) + 'px';
            }
        }
        /**
         * Helper: Adds/Removes the absolutly positioned modal div position fix based on its pinned setting.
         *
         * @param {Object} instance The dialog instance.
         *
         * @return {undefined}
         */
        function updateAbsPositionFix(instance) {
            // if modeless and unpinned add fix
            if (!instance.get('modal') && !instance.get('pinned')) {
                addAbsPositionFix(instance);
            } else {
                removeAbsPositionFix(instance);
            }
        }
        /**
         * Toggles the dialog position lock | modeless only.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to make it modal, false otherwise.
         *
         * @return {undefined}
         */
        function updatePinned(instance) {
            if (instance.get('pinned')) {
                removeClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen()) {
                    removeAbsPositionFix(instance);
                }
            } else {
                addClass(instance.elements.root, classes.unpinned);
                if (instance.isOpen() && !instance.isModal()) {
                    addAbsPositionFix(instance);
                }
            }
        }

        /**
         * Show or hide the maximize box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateMaximizable(instance) {
            if (instance.get('maximizable')) {
                // add class
                addClass(instance.elements.root, classes.maximizable);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.maximizable);
            }
        }

        /**
         * Show or hide the close box.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateClosable(instance) {
            if (instance.get('closable')) {
                // add class
                addClass(instance.elements.root, classes.closable);
                bindClosableEvents(instance);
            } else {
                // remove class
                removeClass(instance.elements.root, classes.closable);
                unbindClosableEvents(instance);
            }
        }

        
        var cancelClick = false,// flag to cancel click event if already handled by end resize event (the mousedown, mousemove, mouseup sequence fires a click event.).
            modalClickHandlerTS=0 // stores last click timestamp to prevent executing the handler twice on double click.
            ;

        /**
         * Helper: closes the modal dialog when clicking the modal
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function modalClickHandler(event, instance) {
            if(event.timeStamp - modalClickHandlerTS > 200 && (modalClickHandlerTS = event.timeStamp) && !cancelClick){
                var target = event.srcElement || event.target;
                if (instance.get('closableByDimmer') === true && target === instance.elements.modal) {
                    triggerClose(instance);
                }
            }
            cancelClick = false;
        }

        // stores last call timestamp to prevent triggering the callback twice.
        var callbackTS = 0;
        // flag to cancel keyup event if already handled by click event (pressing Enter on a focusted button).
        var cancelKeyup = false;
        /** 
         * Helper: triggers a button callback
         *
         * @param {Object}		The dilog instance.
         * @param {Function}	Callback to check which button triggered the event.
         *
         * @return {undefined}
         */
        function triggerCallback(instance, check) {
            if(Date.now() - callbackTS > 200 && (callbackTS = Date.now())){
                for (var idx = 0; idx < instance.__internal.buttons.length; idx += 1) {
                    var button = instance.__internal.buttons[idx];
                    if (!button.element.disabled && check(button)) {
                        var closeEvent = createCloseEvent(idx, button);
                        if (typeof instance.callback === 'function') {
                            instance.callback.apply(instance, [closeEvent]);
                        }
                        //close the dialog only if not canceled.
                        if (closeEvent.cancel === false) {
                            instance.close();
                        }
                        break;
                    }
                }
            }
        }

        /**
         * Clicks event handler, attached to the dialog footer.
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */
        function buttonsClickHandler(event, instance) {
            var target = event.srcElement || event.target;
            triggerCallback(instance, function (button) {
                // if this button caused the click, cancel keyup event
                return button.element === target && (cancelKeyup = true);
            });
        }

        /**
         * Keyup event handler, attached to the document.body
         *
         * @param {Event}		DOM event object.
         * @param {Object}		The dilog instance.
         * 
         * @return {undefined}
         */
        function keyupHandler(event) {
            //hitting enter while button has focus will trigger keyup too.
            //ignore if handled by clickHandler
            if (cancelKeyup) {
                cancelKeyup = false;
                return;
            }
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (instance.__internal.buttons.length === 0 && keyCode === keys.ESC && instance.get('closable') === true) {
                triggerClose(instance);
                return false;
            }else if (usedKeys.indexOf(keyCode) > -1) {
                triggerCallback(instance, function (button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }
        /**
        * Keydown event handler, attached to the document.body
        *
        * @param {Event}		DOM event object.
        * @param {Object}		The dilog instance.
        * 
        * @return {undefined}
        */
        function keydownHandler(event) {
            var instance = openDialogs[openDialogs.length - 1];
            var keyCode = event.keyCode;
            if (keyCode === keys.LEFT || keyCode === keys.RIGHT) {
                var buttons = instance.__internal.buttons;
                for (var x = 0; x < buttons.length; x += 1) {
                    if (document.activeElement === buttons[x].element) {
                        switch (keyCode) {
                        case keys.LEFT:
                            buttons[(x || buttons.length) - 1].element.focus();
                            return;
                        case keys.RIGHT:
                            buttons[(x + 1) % buttons.length].element.focus();
                            return;
                        }
                    }
                }
            }else if (keyCode < keys.F12 + 1 && keyCode > keys.F1 - 1 && usedKeys.indexOf(keyCode) > -1) {
                event.preventDefault();
                event.stopPropagation();
                triggerCallback(instance, function (button) {
                    return button.key === keyCode;
                });
                return false;
            }
        }


        /**
         * Sets focus to proper dialog element
         *
         * @param {Object} instance The dilog instance.
         * @param {Node} [resetTarget=undefined] DOM element to reset focus to.
         *
         * @return {undefined}
         */
        function setFocus(instance, resetTarget) {
            // reset target has already been determined.
            if (resetTarget) {
                resetTarget.focus();
            } else {
                // current instance focus settings
                var focus = instance.__internal.focus;
                // the focus element.
                var element = focus.element;

                switch (typeof focus.element) {
                // a number means a button index
                case 'number':
                    if (instance.__internal.buttons.length > focus.element) {
                        //in basic view, skip focusing the buttons.
                        if (instance.get('basic') === true) {
                            element = instance.elements.reset[0];
                        } else {
                            element = instance.__internal.buttons[focus.element].element;
                        }
                    }
                    break;
                // a string means querySelector to select from dialog body contents.
                case 'string':
                    element = instance.elements.body.querySelector(focus.element);
                    break;
                // a function should return the focus element.
                case 'function':
                    element = focus.element.call(instance);
                    break;
                }

                // if no focus element, default to first reset element.
                if (instance.get('defaultFocusOff') === true || ((typeof element === 'undefined' || element === null) && instance.__internal.buttons.length === 0)) {
                    element = instance.elements.reset[0];
                }
                // focus
                if (element && element.focus) {
                    element.focus();
                    // if selectable
                    if (focus.select && element.select) {
                        element.select();
                    }
                }
            }
        }

        /**
         * Focus event handler, attached to document.body and dialogs own reset links.
         * handles the focus for modal dialogs only.
         *
         * @param {Event} event DOM focus event object.
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function onReset(event, instance) {

            // should work on last modal if triggered from document.body 
            if (!instance) {
                for (var x = openDialogs.length - 1; x > -1; x -= 1) {
                    if (openDialogs[x].isModal()) {
                        instance = openDialogs[x];
                        break;
                    }
                }
            }

            if(instance) {
                // if modal
                if (instance.isModal()) {
                    // determine reset target to enable forward/backward tab cycle.
                    var firstReset = instance.elements.reset[0],
                        lastReset = instance.elements.reset[1],
                        lastFocusedElement = event.relatedTarget,
                        within = instance.elements.root.contains(lastFocusedElement),
                        target = event.srcElement || event.target,
                        resetTarget;

                    //if the previous focused element element was outside the modal do nthing
                    if(  /*first show */
                        (target === firstReset && !within) ||
                         /*focus cycle */
                        (target === lastReset && lastFocusedElement === firstReset)){
                        return;
                    }else if(target === lastReset || target === document.body){
                        resetTarget = firstReset;
                    }else if(target === firstReset && lastFocusedElement === lastReset){
                        resetTarget = findTabbable(instance);
                    }else if(target === firstReset && within){
                        resetTarget = findTabbable(instance, true);
                    }
                    // focus
                    setFocus(instance, resetTarget);
                }
            }
        }
        function findTabbable(instance, last){
            var tabbables = [].slice.call(instance.elements.dialog.querySelectorAll(defaults.tabbable));
            if(last){
                tabbables.reverse();
            }
            for(var x=0;x<tabbables.length;x+=1){
                var tabbable = tabbables[x];
                //check if visible
                if(!!(tabbable.offsetParent || tabbable.offsetWidth || tabbable.offsetHeight || tabbable.getClientRects().length)){
                    return tabbable;
                }
            }
        }
        function recycleTab(event) {
            var instance = openDialogs[openDialogs.length - 1];
            if (instance && event.shiftKey && event.keyCode === keys.TAB) {
                instance.elements.reset[1].focus();
            }
        }
        /**
         * Transition in transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */
        function handleTransitionInEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerIn);

            // once transition is complete, set focus
            setFocus(instance);

            // allow handling key up after transition ended.
            cancelKeyup = false;

            // allow custom `onfocus` method
            dispatchEvent('onfocus', instance);

            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

            removeClass(instance.elements.root, classes.animationIn);
        }

        /**
         * Transition out transitionend event handler. 
         *
         * @param {Event}		TransitionEnd event object.
         * @param {Object}		The dilog instance.
         *
         * @return {undefined}
         */
        function handleTransitionOutEvent(event, instance) {
            // clear the timer
            clearTimeout(instance.__internal.timerOut);
            // unbind the event
            off(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

            // reset move updates
            resetMove(instance);
            // reset resize updates
            resetResize(instance);

            // restore if maximized
            if (instance.isMaximized() && !instance.get('startMaximized')) {
                restore(instance);
            }

            //destory the instance
            if (typeof instance.__internal.destroy === 'function') {
                instance.__internal.destroy.apply(instance);
            }
        }
        /* Controls moving a dialog around */
        //holde the current moving instance
        var movable = null,
            //holds the current X offset when move starts
            offsetX = 0,
            //holds the current Y offset when move starts
            offsetY = 0,
            xProp = 'pageX',
            yProp = 'pageY',
            bounds = null,
            refreshTop = false,
            moveDelegate = null
        ;

        /**
         * Helper: sets the element top/left coordinates
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */
        function moveElement(event, element) {
            var left = (event[xProp] - offsetX),
                top  = (event[yProp] - offsetY);

            if(refreshTop){
                top -= document.body.scrollTop;
            }
           
            element.style.left = left + 'px';
            element.style.top = top + 'px';
           
        }
        /**
         * Helper: sets the element top/left coordinates within screen bounds
         *
         * @param {Event} event	DOM event object.
         * @param {Node} element The element being moved.
         * 
         * @return {undefined}
         */
        function moveElementBounded(event, element) {
            var left = (event[xProp] - offsetX),
                top  = (event[yProp] - offsetY);

            if(refreshTop){
                top -= document.body.scrollTop;
            }
            
            element.style.left = Math.min(bounds.maxLeft, Math.max(bounds.minLeft, left)) + 'px';
            if(refreshTop){
                element.style.top = Math.min(bounds.maxTop, Math.max(bounds.minTop, top)) + 'px';
            }else{
                element.style.top = Math.max(bounds.minTop, top) + 'px';
            }
        }
            

        /**
         * Triggers the start of a move event, attached to the header element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */
        function beginMove(event, instance) {
            if (resizable === null && !instance.isMaximized() && instance.get('movable')) {
                var eventSrc, left=0, top=0;
                if (event.type === 'touchstart') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                    xProp = 'clientX';
                    yProp = 'clientY';
                } else if (event.button === 0) {
                    eventSrc = event;
                }

                if (eventSrc) {

                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);

                    if (element.style.left) {
                        left = parseInt(element.style.left, 10);
                    }

                    if (element.style.top) {
                        top = parseInt(element.style.top, 10);
                    }
                    
                    offsetX = eventSrc[xProp] - left;
                    offsetY = eventSrc[yProp] - top;

                    if(instance.isModal()){
                        offsetY += instance.elements.modal.scrollTop;
                    }else if(instance.isPinned()){
                        offsetY -= document.body.scrollTop;
                    }
                    
                    if(instance.get('moveBounded')){
                        var current = element,
                            offsetLeft = -left,
                            offsetTop = -top;
                        
                        //calc offset
                        do {
                            offsetLeft += current.offsetLeft;
                            offsetTop += current.offsetTop;
                        } while (current = current.offsetParent);
                        
                        bounds = {
                            maxLeft : offsetLeft,
                            minLeft : -offsetLeft,
                            maxTop  : document.documentElement.clientHeight - element.clientHeight - offsetTop,
                            minTop  : -offsetTop
                        };
                        moveDelegate = moveElementBounded;
                    }else{
                        bounds = null;
                        moveDelegate = moveElement;
                    }
                    
                    // allow custom `onmove` method
                    dispatchEvent('onmove', instance);

                    refreshTop = !instance.isModal() && instance.isPinned();
                    movable = instance;
                    moveDelegate(eventSrc, element);
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }

        /**
         * The actual move handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */
        function move(event) {
            if (movable) {
                var eventSrc;
                if (event.type === 'touchmove') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    moveDelegate(eventSrc, movable.elements.dialog);
                }
            }
        }

        /**
         * Triggers the end of a move event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */
        function endMove() {
            if (movable) {
                var instance = movable;
                movable = bounds = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                // allow custom `onmoved` method
                dispatchEvent('onmoved', instance);
            }
        }

        /**
         * Resets any changes made by moving the element to its original state,
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function resetMove(instance) {
            movable = null;
            var element = instance.elements.dialog;
            element.style.left = element.style.top = '';
        }

        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateMovable(instance) {
            if (instance.get('movable')) {
                // add class
                addClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) {
                    bindMovableEvents(instance);
                }
            } else {

                //reset
                resetMove(instance);
                // remove class
                removeClass(instance.elements.root, classes.movable);
                if (instance.isOpen()) {
                    unbindMovableEvents(instance);
                }
            }
        }

        /* Controls moving a dialog around */
        //holde the current instance being resized		
        var resizable = null,
            //holds the staring left offset when resize starts.
            startingLeft = Number.Nan,
            //holds the staring width when resize starts.
            startingWidth = 0,
            //holds the initial width when resized for the first time.
            minWidth = 0,
            //holds the offset of the resize handle.
            handleOffset = 0
        ;

        /**
         * Helper: sets the element width/height and updates left coordinate if neccessary.
         *
         * @param {Event} event	DOM mousemove event object.
         * @param {Node} element The element being moved.
         * @param {Boolean} pinned A flag indicating if the element being resized is pinned to the screen.
         * 
         * @return {undefined}
         */
        function resizeElement(event, element, pageRelative) {

            //calculate offsets from 0,0
            var current = element;
            var offsetLeft = 0;
            var offsetTop = 0;
            do {
                offsetLeft += current.offsetLeft;
                offsetTop += current.offsetTop;
            } while (current = current.offsetParent);

            // determine X,Y coordinates.
            var X, Y;
            if (pageRelative === true) {
                X = event.pageX;
                Y = event.pageY;
            } else {
                X = event.clientX;
                Y = event.clientY;
            }
            // rtl handling
            var isRTL = isRightToLeft();
            if (isRTL) {
                // reverse X 
                X = document.body.offsetWidth - X;
                // if has a starting left, calculate offsetRight
                if (!isNaN(startingLeft)) {
                    offsetLeft = document.body.offsetWidth - offsetLeft - element.offsetWidth;
                }
            }

            // set width/height
            element.style.height = (Y - offsetTop + handleOffset) + 'px';
            element.style.width = (X - offsetLeft + handleOffset) + 'px';

            // if the element being resized has a starting left, maintain it.
            // the dialog is centered, divide by half the offset to maintain the margins.
            if (!isNaN(startingLeft)) {
                var diff = Math.abs(element.offsetWidth - startingWidth) * 0.5;
                if (isRTL) {
                    //negate the diff, why?
                    //when growing it should decrease left
                    //when shrinking it should increase left
                    diff *= -1;
                }
                if (element.offsetWidth > startingWidth) {
                    //growing
                    element.style.left = (startingLeft + diff) + 'px';
                } else if (element.offsetWidth >= minWidth) {
                    //shrinking
                    element.style.left = (startingLeft - diff) + 'px';
                }
            }
        }

        /**
         * Triggers the start of a resize event, attached to the resize handle element mouse down event.
         * Adds no-selection class to the body, disabling selection while moving.
         *
         * @param {Event} event	DOM event object.
         * @param {Object} instance The dilog instance.
         * 
         * @return {Boolean} false
         */
        function beginResize(event, instance) {
            if (!instance.isMaximized()) {
                var eventSrc;
                if (event.type === 'touchstart') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    // allow custom `onresize` method
                    dispatchEvent('onresize', instance);
                    
                    resizable = instance;
                    handleOffset = instance.elements.resizeHandle.offsetHeight / 2;
                    var element = instance.elements.dialog;
                    addClass(element, classes.capture);
                    startingLeft = parseInt(element.style.left, 10);
                    element.style.height = element.offsetHeight + 'px';
                    element.style.minHeight = instance.elements.header.offsetHeight + instance.elements.footer.offsetHeight + 'px';
                    element.style.width = (startingWidth = element.offsetWidth) + 'px';

                    if (element.style.maxWidth !== 'none') {
                        element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                    }
                    element.style.maxWidth = 'none';
                    addClass(document.body, classes.noSelection);
                    return false;
                }
            }
        }

        /**
         * The actual resize handler,  attached to document.body mousemove event.
         *
         * @param {Event} event	DOM event object.
         * 
         * @return {undefined}
         */
        function resize(event) {
            if (resizable) {
                var eventSrc;
                if (event.type === 'touchmove') {
                    event.preventDefault();
                    eventSrc = event.targetTouches[0];
                } else if (event.button === 0) {
                    eventSrc = event;
                }
                if (eventSrc) {
                    resizeElement(eventSrc, resizable.elements.dialog, !resizable.get('modal') && !resizable.get('pinned'));
                }
            }
        }

        /**
         * Triggers the end of a resize event,  attached to document.body mouseup event.
         * Removes no-selection class from document.body, allowing selection.
         *
         * @return {undefined}
         */
        function endResize() {
            if (resizable) {
                var instance = resizable;
                resizable = null;
                removeClass(document.body, classes.noSelection);
                removeClass(instance.elements.dialog, classes.capture);
                cancelClick = true;
                // allow custom `onresized` method
                dispatchEvent('onresized', instance);
            }
        }

        /**
         * Resets any changes made by resizing the element to its original state.
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function resetResize(instance) {
            resizable = null;
            var element = instance.elements.dialog;
            if (element.style.maxWidth === 'none') {
                //clear inline styles.
                element.style.maxWidth = element.style.minWidth = element.style.width = element.style.height = element.style.minHeight = element.style.left = '';
                //reset variables.
                startingLeft = Number.Nan;
                startingWidth = minWidth = handleOffset = 0;
            }
        }


        /**
         * Updates the dialog move behavior.
         *
         * @param {Object} instance The dilog instance.
         * @param {Boolean} on True to add the behavior, removes it otherwise.
         *
         * @return {undefined}
         */
        function updateResizable(instance) {
            if (instance.get('resizable')) {
                // add class
                addClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) {
                    bindResizableEvents(instance);
                }
            } else {
                //reset
                resetResize(instance);
                // remove class
                removeClass(instance.elements.root, classes.resizable);
                if (instance.isOpen()) {
                    unbindResizableEvents(instance);
                }
            }
        }

        /**
         * Reset move/resize on window resize.
         *
         * @param {Event} event	window resize event object.
         *
         * @return {undefined}
         */
        function windowResize(/*event*/) {
            for (var x = 0; x < openDialogs.length; x += 1) {
                var instance = openDialogs[x];
                if (instance.get('autoReset')) {
                    resetMove(instance);
                    resetResize(instance);
                }
            }
        }
        /**
         * Bind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindEvents(instance) {
            // if first dialog, hook global handlers
            if (openDialogs.length === 1) {
                //global
                on(window, 'resize', windowResize);
                on(document.body, 'keyup', keyupHandler);
                on(document.body, 'keydown', keydownHandler);
                on(document.body, 'focus', onReset);

                //move
                on(document.documentElement, 'mousemove', move);
                on(document.documentElement, 'touchmove', move, false, false);
                on(document.documentElement, 'mouseup', endMove);
                on(document.documentElement, 'touchend', endMove);
                //resize
                on(document.documentElement, 'mousemove', resize);
                on(document.documentElement, 'touchmove', resize, false, false);
                on(document.documentElement, 'mouseup', endResize);
                on(document.documentElement, 'touchend', endResize);
            }

            // common events
            on(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
            on(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
            on(instance.elements.reset[0], 'focusin', instance.__internal.resetHandler);
            on(instance.elements.reset[0], 'keydown', recycleTab);
            on(instance.elements.reset[1], 'focusin', instance.__internal.resetHandler);

            //prevent handling key up when dialog is being opened by a key stroke.
            cancelKeyup = true;
            // hook in transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionInHandler);

            // modelss only events
            if (!instance.get('modal')) {
                bindModelessEvents(instance);
            }

            // resizable
            if (instance.get('resizable')) {
                bindResizableEvents(instance);
            }

            // movable
            if (instance.get('movable')) {
                bindMovableEvents(instance);
            }
        }

        /**
         * Unbind dialogs events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindEvents(instance) {
            // if last dialog, remove global handlers
            if (openDialogs.length === 1) {
                //global
                off(window, 'resize', windowResize);
                off(document.body, 'keyup', keyupHandler);
                off(document.body, 'keydown', keydownHandler);
                off(document.body, 'focus', onReset);
                //move
                off(document.documentElement, 'mousemove', move);
                off(document.documentElement, 'mouseup', endMove);
                //resize
                off(document.documentElement, 'mousemove', resize);
                off(document.documentElement, 'mouseup', endResize);
            }

            // common events
            off(instance.elements.commands.container, 'click', instance.__internal.commandsClickHandler);
            off(instance.elements.footer, 'click', instance.__internal.buttonsClickHandler);
            off(instance.elements.reset[0], 'focusin', instance.__internal.resetHandler);
            off(instance.elements.reset[0], 'keydown', recycleTab);
            off(instance.elements.reset[1], 'focusin', instance.__internal.resetHandler);

            // hook out transition handler
            on(instance.elements.dialog, transition.type, instance.__internal.transitionOutHandler);

            // modelss only events
            if (!instance.get('modal')) {
                unbindModelessEvents(instance);
            }

            // movable
            if (instance.get('movable')) {
                unbindMovableEvents(instance);
            }

            // resizable
            if (instance.get('resizable')) {
                unbindResizableEvents(instance);
            }

        }

        /**
         * Bind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindModelessEvents(instance) {
            on(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
        }

        /**
         * Unbind modeless specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindModelessEvents(instance) {
            off(instance.elements.dialog, 'focus', instance.__internal.bringToFrontHandler, true);
        }



        /**
         * Bind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindMovableEvents(instance) {
            on(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
            on(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler, false, false);
        }

        /**
         * Unbind movable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindMovableEvents(instance) {
            off(instance.elements.header, 'mousedown', instance.__internal.beginMoveHandler);
            off(instance.elements.header, 'touchstart', instance.__internal.beginMoveHandler, false, false);
        }



        /**
         * Bind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindResizableEvents(instance) {
            on(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
            on(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler, false, false);
        }

        /**
         * Unbind resizable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindResizableEvents(instance) {
            off(instance.elements.resizeHandle, 'mousedown', instance.__internal.beginResizeHandler);
            off(instance.elements.resizeHandle, 'touchstart', instance.__internal.beginResizeHandler, false, false);
        }

        /**
         * Bind closable events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function bindClosableEvents(instance) {
            on(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
        }

        /**
         * Unbind closable specific events
         *
         * @param {Object} instance The dilog instance.
         *
         * @return {undefined}
         */
        function unbindClosableEvents(instance) {
            off(instance.elements.modal, 'click', instance.__internal.modalClickHandler);
        }
        // dialog API
        return {
            __init:initialize,
            /**
             * Check if dialog is currently open
             *
             * @return {Boolean}
             */
            isOpen: function () {
                return this.__internal.isOpen;
            },
            isModal: function (){
                return this.elements.root.className.indexOf(classes.modeless) < 0;
            },
            isMaximized:function(){
                return this.elements.root.className.indexOf(classes.maximized) > -1;
            },
            isPinned:function(){
                return this.elements.root.className.indexOf(classes.unpinned) < 0;
            },
            maximize:function(){
                if(!this.isMaximized()){
                    maximize(this);
                }
                return this;
            },
            restore:function(){
                if(this.isMaximized()){
                    restore(this);
                }
                return this;
            },
            pin:function(){
                if(!this.isPinned()){
                    pin(this);
                }
                return this;
            },
            unpin:function(){
                if(this.isPinned()){
                    unpin(this);
                }
                return this;
            },
            bringToFront:function(){
                bringToFront(null, this);
                return this;
            },
            /**
             * Move the dialog to a specific x/y coordinates
             *
             * @param {Number} x    The new dialog x coordinate in pixels.
             * @param {Number} y    The new dialog y coordinate in pixels.
             *
             * @return {Object} The dialog instance.
             */
            moveTo:function(x,y){
                if(!isNaN(x) && !isNaN(y)){
                    // allow custom `onmove` method
                    dispatchEvent('onmove', this);
                    
                    var element = this.elements.dialog,
                        current = element,
                        offsetLeft = 0,
                        offsetTop = 0;
                    
                    //subtract existing left,top
                    if (element.style.left) {
                        offsetLeft -= parseInt(element.style.left, 10);
                    }
                    if (element.style.top) {
                        offsetTop -= parseInt(element.style.top, 10);
                    }
                    //calc offset
                    do {
                        offsetLeft += current.offsetLeft;
                        offsetTop += current.offsetTop;
                    } while (current = current.offsetParent);

                    //calc left, top
                    var left = (x - offsetLeft);
                    var top  = (y - offsetTop);

                    //// rtl handling
                    if (isRightToLeft()) {
                        left *= -1;
                    }

                    element.style.left = left + 'px';
                    element.style.top = top + 'px';
                    
                    // allow custom `onmoved` method
                    dispatchEvent('onmoved', this);
                }
                return this;
            },
            /**
             * Resize the dialog to a specific width/height (the dialog must be 'resizable').
             * The dialog can be resized to:
             *  A minimum width equal to the initial display width
             *  A minimum height equal to the sum of header/footer heights.
             *
             *
             * @param {Number or String} width    The new dialog width in pixels or in percent.
             * @param {Number or String} height   The new dialog height in pixels or in percent.
             *
             * @return {Object} The dialog instance.
             */
            resizeTo:function(width,height){
                var w = parseFloat(width),
                    h = parseFloat(height),
                    regex = /(\d*\.\d+|\d+)%/
                ;

                if(!isNaN(w) && !isNaN(h) && this.get('resizable') === true){
                    
                    // allow custom `onresize` method
                    dispatchEvent('onresize', this);
                    
                    if(('' + width).match(regex)){
                        w = w / 100 * document.documentElement.clientWidth ;
                    }

                    if(('' + height).match(regex)){
                        h = h / 100 * document.documentElement.clientHeight;
                    }

                    var element = this.elements.dialog;
                    if (element.style.maxWidth !== 'none') {
                        element.style.minWidth = (minWidth = element.offsetWidth) + 'px';
                    }
                    element.style.maxWidth = 'none';
                    element.style.minHeight = this.elements.header.offsetHeight + this.elements.footer.offsetHeight + 'px';
                    element.style.width = w + 'px';
                    element.style.height = h + 'px';
                    
                    // allow custom `onresized` method
                    dispatchEvent('onresized', this);
                }
                return this;
            },
            /**
             * Gets or Sets dialog settings/options 
             *
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Object} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */
            setting : function (key, value) {
                var self = this;
                var result = update(this, this.__internal.options, function(k,o,n){ optionUpdated(self,k,o,n); }, key, value);
                if(result.op === 'get'){
                    if(result.found){
                        return result.value;
                    }else if(typeof this.settings !== 'undefined'){
                        return update(this, this.settings, this.settingUpdated || function(){}, key, value).value;
                    }else{
                        return undefined;
                    }
                }else if(result.op === 'set'){
                    if(result.items.length > 0){
                        var callback = this.settingUpdated || function(){};
                        for(var x=0;x<result.items.length;x+=1){
                            var item = result.items[x];
                            if(!item.found && typeof this.settings !== 'undefined'){
                                update(this, this.settings, callback, item.key, item.value);
                            }
                        }
                    }
                    return this;
                }
            },
            /**
             * [Alias] Sets dialog settings/options 
             */
            set:function(key, value){
                this.setting(key,value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options 
             */
            get:function(key){
                return this.setting(key);
            },
            /**
            * Sets dialog header
            * @content {string or element}
            *
            * @return {undefined}
            */
            setHeader:function(content){
                if(typeof content === 'string'){
                    clearContents(this.elements.header);
                    this.elements.header.innerHTML = content;
                }else if (content instanceof window.HTMLElement && this.elements.header.firstChild !== content){
                    clearContents(this.elements.header);
                    this.elements.header.appendChild(content);
                }
                return this;
            },
            /**
            * Sets dialog contents
            * @content {string or element}
            *
            * @return {undefined}
            */
            setContent:function(content){
                if(typeof content === 'string'){
                    clearContents(this.elements.content);
                    this.elements.content.innerHTML = content;
                }else if (content instanceof window.HTMLElement && this.elements.content.firstChild !== content){
                    clearContents(this.elements.content);
                    this.elements.content.appendChild(content);
                }
                return this;
            },
            /**
             * Show the dialog as modal
             *
             * @return {Object} the dialog instance.
             */
            showModal: function(className){
                return this.show(true, className);
            },
            /**
             * Show the dialog
             *
             * @return {Object} the dialog instance.
             */
            show: function (modal, className) {
                
                // ensure initialization
                initialize(this);

                if ( !this.__internal.isOpen ) {

                    // add to open dialogs
                    this.__internal.isOpen = true;
                    openDialogs.push(this);

                    // save last focused element
                    if(alertify.defaults.maintainFocus){
                        this.__internal.activeElement = document.activeElement;
                    }

                    // set tabindex attribute on body element this allows script to give it focusable
                    if(!document.body.hasAttribute('tabindex')) {
                        document.body.setAttribute( 'tabindex', tabindex = '0');
                    }

                    //allow custom dom manipulation updates before showing the dialog.
                    if(typeof this.prepare === 'function'){
                        this.prepare();
                    }

                    bindEvents(this);

                    if(modal !== undefined){
                        this.set('modal', modal);
                    }

                    //save scroll to prevent document jump
                    saveScrollPosition();

                    ensureNoOverflow();

                    // allow custom dialog class on show
                    if(typeof className === 'string' && className !== ''){
                        this.__internal.className = className;
                        addClass(this.elements.root, className);
                    }

                    // maximize if start maximized
                    if ( this.get('startMaximized')) {
                        this.maximize();
                    }else if(this.isMaximized()){
                        restore(this);
                    }

                    updateAbsPositionFix(this);
                    this.elements.root.removeAttribute('style');
                    removeClass(this.elements.root, classes.animationOut);
                    addClass(this.elements.root, classes.animationIn);

                    // set 1s fallback in case transition event doesn't fire
                    clearTimeout( this.__internal.timerIn);
                    this.__internal.timerIn = setTimeout( this.__internal.transitionInHandler, transition.supported ? 1000 : 100 );

                    if(isSafari){
                        // force desktop safari reflow
                        var root = this.elements.root;
                        root.style.display  = 'none';
                        setTimeout(function(){root.style.display  = 'block';}, 0);
                    }

                    //reflow
                    reflow = this.elements.root.offsetWidth;
                  
                    // show dialog
                    removeClass(this.elements.root, classes.hidden);

                    //restore scroll to prevent document jump
                    restoreScrollPosition();

                    // internal on show event
                    if(typeof this.hooks.onshow === 'function'){
                        this.hooks.onshow.call(this);
                    }

                    // allow custom `onshow` method
                    dispatchEvent('onshow', this);

                }else{
                    // reset move updates
                    resetMove(this);
                    // reset resize updates
                    resetResize(this);
                    // shake the dialog to indicate its already open
                    addClass(this.elements.dialog, classes.shake);
                    var self = this;
                    setTimeout(function(){
                        removeClass(self.elements.dialog, classes.shake);
                    },200);
                }
                return this;
            },
            /**
             * Close the dialog
             *
             * @return {Object} The dialog instance
             */
            close: function () {
                if (this.__internal.isOpen ) {
                    // custom `onclosing` event
                    if(dispatchEvent('onclosing', this) !== false){

                        unbindEvents(this);

                        removeClass(this.elements.root, classes.animationIn);
                        addClass(this.elements.root, classes.animationOut);

                        // set 1s fallback in case transition event doesn't fire
                        clearTimeout( this.__internal.timerOut );
                        this.__internal.timerOut = setTimeout( this.__internal.transitionOutHandler, transition.supported ? 1000 : 100 );
                        // hide dialog
                        addClass(this.elements.root, classes.hidden);
                        //reflow
                        reflow = this.elements.modal.offsetWidth;

                        // return focus to the last active element
                        if (alertify.defaults.maintainFocus && this.__internal.activeElement) {
                            this.__internal.activeElement.focus();
                            this.__internal.activeElement = null;
                        }

                        // remove custom dialog class on hide
                        if (typeof this.__internal.className !== 'undefined' && this.__internal.className !== '') {
                            removeClass(this.elements.root, this.__internal.className);
                        }

                        // internal on close event
                        if(typeof this.hooks.onclose === 'function'){
                            this.hooks.onclose.call(this);
                        }

                        // allow custom `onclose` method
                        dispatchEvent('onclose', this);

                        //remove from open dialogs
                        openDialogs.splice(openDialogs.indexOf(this),1);
                        this.__internal.isOpen = false;

                        ensureNoOverflow();
                    }

                }
                // last dialog and tab index was set by us, remove it.
                if(!openDialogs.length && tabindex === '0'){
                    document.body.removeAttribute('tabindex');
                }
                return this;
            },
            /**
             * Close all open dialogs except this.
             *
             * @return {undefined}
             */
            closeOthers:function(){
                alertify.closeAll(this);
                return this;
            },
            /**
             * Destroys this dialog instance
             *
             * @return {undefined}
             */
            destroy:function(){
                if(this.__internal) {
                    if (this.__internal.isOpen ) {
                        //mark dialog for destruction, this will be called on tranistionOut event.
                        this.__internal.destroy = function(){
                            destruct(this, initialize);
                        };
                        //close the dialog to unbind all events.
                        this.close();
                    }else if(!this.__internal.destroy){
                        destruct(this, initialize);
                    }
                }
                return this;
            },
        };
	} () );
    var notifier = (function () {
        var reflow,
            element,
            openInstances = [],
            classes = defaults.notifier.classes,
            baseClass = classes.base;
        /**
         * Helper: initializes the notifier instance
         *
         */
        function initialize(instance) {

            if (!instance.__internal) {
                instance.__internal = {
                    position: alertify.defaults.notifier.position,
                    delay: alertify.defaults.notifier.delay,
                };

                element = document.createElement('DIV');
                var transitionOff = 'transitionOff' in defaults.notifier ? defaults.notifier.transitionOff : defaults.transitionOff;
                if(transitionOff){
                    baseClass = classes.base + ' ajs-no-transition';
                }
                updatePosition(instance);
            }

            //add to DOM tree.
            if (element.parentNode !== document.body) {
                document.body.appendChild(element);
            }
        }

        function pushInstance(instance) {
            instance.__internal.pushed = true;
            openInstances.push(instance);
        }
        function popInstance(instance) {
            openInstances.splice(openInstances.indexOf(instance), 1);
            instance.__internal.pushed = false;
        }
        /**
         * Helper: update the notifier instance position
         *
         */
        function updatePosition(instance) {
            element.className = baseClass;
            switch (instance.__internal.position) {
            case 'top-right':
                addClass(element, classes.top + ' ' + classes.right);
                break;
            case 'top-left':
                addClass(element, classes.top + ' ' + classes.left);
                break;
            case 'top-center':
                addClass(element, classes.top + ' ' + classes.center);
                break;
            case 'bottom-left':
                addClass(element, classes.bottom + ' ' + classes.left);
                break;
            case 'bottom-center':
                addClass(element, classes.bottom + ' ' + classes.center);
                break;

            default:
            case 'bottom-right':
                addClass(element, classes.bottom + ' ' + classes.right);
                break;
            }
        }

        /**
        * creates a new notification message
        *
        * @param  {DOMElement} message	The notifier message element
        * @param  {Number} wait   Time (in ms) to wait before the message is dismissed, a value of 0 means keep open till clicked.
        * @param  {Function} callback A callback function to be invoked when the message is dismissed.
        *
        * @return {undefined}
        */
        function create(div, callback) {

            function clickDelegate(event, instance) {
                if(!instance.__internal.closeButton || event.target.getAttribute('data-close') === 'true'){
                    instance.dismiss(true);
                }
            }

            function transitionDone(event, instance) {
                // unbind event
                off(instance.element, transition.type, transitionDone);
                // remove the message
                element.removeChild(instance.element);
            }

            function initialize(instance) {
                if (!instance.__internal) {
                    instance.__internal = {
                        pushed: false,
                        delay : undefined,
                        timer: undefined,
                        clickHandler: undefined,
                        transitionEndHandler: undefined,
                        transitionTimeout: undefined
                    };
                    instance.__internal.clickHandler = delegate(instance, clickDelegate);
                    instance.__internal.transitionEndHandler = delegate(instance, transitionDone);
                }
                return instance;
            }
            function clearTimers(instance) {
                clearTimeout(instance.__internal.timer);
                clearTimeout(instance.__internal.transitionTimeout);
            }
            return initialize({
                /* notification DOM element*/
                element: div,
                /*
                 * Pushes a notification message
                 * @param {string or DOMElement} content The notification message content
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */
                push: function (_content, _wait) {
                    if (!this.__internal.pushed) {

                        pushInstance(this);
                        clearTimers(this);

                        var content, wait;
                        switch (arguments.length) {
                        case 0:
                            wait = this.__internal.delay;
                            break;
                        case 1:
                            if (typeof (_content) === 'number') {
                                wait = _content;
                            } else {
                                content = _content;
                                wait = this.__internal.delay;
                            }
                            break;
                        case 2:
                            content = _content;
                            wait = _wait;
                            break;
                        }
                        this.__internal.closeButton = alertify.defaults.notifier.closeButton;
                        // set contents
                        if (typeof content !== 'undefined') {
                            this.setContent(content);
                        }
                        // append or insert
                        if (notifier.__internal.position.indexOf('top') < 0) {
                            element.appendChild(this.element);
                        } else {
                            element.insertBefore(this.element, element.firstChild);
                        }
                        reflow = this.element.offsetWidth;
                        addClass(this.element, classes.visible);
                        // attach click event
                        on(this.element, 'click', this.__internal.clickHandler);
                        return this.delay(wait);
                    }
                    return this;
                },
                /*
                 * {Function} callback function to be invoked before dismissing the notification message.
                 * Remarks: A return value === 'false' will cancel the dismissal
                 *
                 */
                ondismiss: function () { },
                /*
                 * {Function} callback function to be invoked when the message is dismissed.
                 *
                 */
                callback: callback,
                /*
                 * Dismisses the notification message
                 * @param {Boolean} clicked A flag indicating if the dismissal was caused by a click.
                 *
                 */
                dismiss: function (clicked) {
                    if (this.__internal.pushed) {
                        clearTimers(this);
                        if (!(typeof this.ondismiss === 'function' && this.ondismiss.call(this) === false)) {
                            //detach click event
                            off(this.element, 'click', this.__internal.clickHandler);
                            // ensure element exists
                            if (typeof this.element !== 'undefined' && this.element.parentNode === element) {
                                //transition end or fallback
                                this.__internal.transitionTimeout = setTimeout(this.__internal.transitionEndHandler, transition.supported ? 1000 : 100);
                                removeClass(this.element, classes.visible);

                                // custom callback on dismiss
                                if (typeof this.callback === 'function') {
                                    this.callback.call(this, clicked);
                                }
                            }
                            popInstance(this);
                        }
                    }
                    return this;
                },
                /*
                 * Delays the notification message dismissal
                 * @param {Number} wait The time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
                 *
                 */
                delay: function (wait) {
                    clearTimers(this);
                    this.__internal.delay = typeof wait !== 'undefined' && !isNaN(+wait) ? +wait : notifier.__internal.delay;
                    if (this.__internal.delay > 0) {
                        var  self = this;
                        this.__internal.timer = setTimeout(function () { self.dismiss(); }, this.__internal.delay * 1000);
                    }
                    return this;
                },
                /*
                 * Sets the notification message contents
                 * @param {string or DOMElement} content The notification message content
                 *
                 */
                setContent: function (content) {
                    if (typeof content === 'string') {
                        clearContents(this.element);
                        this.element.innerHTML = content;
                    } else if (content instanceof window.HTMLElement && this.element.firstChild !== content) {
                        clearContents(this.element);
                        this.element.appendChild(content);
                    }
                    if(this.__internal.closeButton){
                        var close = document.createElement('span');
                        addClass(close, classes.close);
                        close.setAttribute('data-close', true);
                        this.element.appendChild(close);
                    }
                    return this;
                },
                /*
                 * Dismisses all open notifications except this.
                 *
                 */
                dismissOthers: function () {
                    notifier.dismissAll(this);
                    return this;
                }
            });
        }

        //notifier api
        return {
            /**
             * Gets or Sets notifier settings.
             *
             * @param {string} key The setting name
             * @param {Variant} value The setting value.
             *
             * @return {Object}	if the called as a setter, return the notifier instance.
             */
            setting: function (key, value) {
                //ensure init
                initialize(this);

                if (typeof value === 'undefined') {
                    //get
                    return this.__internal[key];
                } else {
                    //set
                    switch (key) {
                    case 'position':
                        this.__internal.position = value;
                        updatePosition(this);
                        break;
                    case 'delay':
                        this.__internal.delay = value;
                        break;
                    }
                }
                return this;
            },
            /**
             * [Alias] Sets dialog settings/options
             */
            set:function(key,value){
                this.setting(key,value);
                return this;
            },
            /**
             * [Alias] Gets dialog settings/options
             */
            get:function(key){
                return this.setting(key);
            },
            /**
             * Creates a new notification message
             *
             * @param {string} type The type of notification message (simply a CSS class name 'ajs-{type}' to be added).
             * @param {Function} callback  A callback function to be invoked when the message is dismissed.
             *
             * @return {undefined}
             */
            create: function (type, callback) {
                //ensure notifier init
                initialize(this);
                //create new notification message
                var div = document.createElement('div');
                div.className = classes.message + ((typeof type === 'string' && type !== '') ? ' ' + classes.prefix + type : '');
                return create(div, callback);
            },
            /**
             * Dismisses all open notifications.
             *
             * @param {Object} excpet [optional] The notification object to exclude from dismissal.
             *
             */
            dismissAll: function (except) {
                var clone = openInstances.slice(0);
                for (var x = 0; x < clone.length; x += 1) {
                    var  instance = clone[x];
                    if (except === undefined || except !== instance) {
                        instance.dismiss();
                    }
                }
            }
        };
    })();

    /**
     * Alertify public API
     * This contains everything that is exposed through the alertify object.
     *
     * @return {Object}
     */
    function Alertify() {

        // holds a references of created dialogs
        var dialogs = {};

        /**
         * Extends a given prototype by merging properties from base into sub.
         *
         * @sub {Object} sub The prototype being overwritten.
         * @base {Object} base The prototype being written.
         *
         * @return {Object} The extended prototype.
         */
        function extend(sub, base) {
            // copy dialog pototype over definition.
            for (var prop in base) {
                if (base.hasOwnProperty(prop)) {
                    sub[prop] = base[prop];
                }
            }
            return sub;
        }


        /**
        * Helper: returns a dialog instance from saved dialogs.
        * and initializes the dialog if its not already initialized.
        *
        * @name {String} name The dialog name.
        *
        * @return {Object} The dialog instance.
        */
        function get_dialog(name) {
            var dialog = dialogs[name].dialog;
            //initialize the dialog if its not already initialized.
            if (dialog && typeof dialog.__init === 'function') {
                dialog.__init(dialog);
            }
            return dialog;
        }

        /**
         * Helper:  registers a new dialog definition.
         *
         * @name {String} name The dialog name.
         * @Factory {Function} Factory a function resposible for creating dialog prototype.
         * @transient {Boolean} transient True to create a new dialog instance each time the dialog is invoked, false otherwise.
         * @base {String} base the name of another dialog to inherit from.
         *
         * @return {Object} The dialog definition.
         */
        function register(name, Factory, transient, base) {
            var definition = {
                dialog: null,
                factory: Factory
            };

            //if this is based on an existing dialog, create a new definition
            //by applying the new protoype over the existing one.
            if (base !== undefined) {
                definition.factory = function () {
                    return extend(new dialogs[base].factory(), new Factory());
                };
            }

            if (!transient) {
                //create a new definition based on dialog
                definition.dialog = extend(new definition.factory(), dialog);
            }
            return dialogs[name] = definition;
        }

        return {
            /**
             * Alertify defaults
             * 
             * @type {Object}
             */
            defaults: defaults,
            /**
             * Dialogs factory 
             *
             * @param {string}      Dialog name.
             * @param {Function}    A Dialog factory function.
             * @param {Boolean}     Indicates whether to create a singleton or transient dialog.
             * @param {String}      The name of the base type to inherit from.
             */
            dialog: function (name, Factory, transient, base) {

                // get request, create a new instance and return it.
                if (typeof Factory !== 'function') {
                    return get_dialog(name);
                }

                if (this.hasOwnProperty(name)) {
                    throw new Error('alertify.dialog: name already exists');
                }

                // register the dialog
                var definition = register(name, Factory, transient, base);

                if (transient) {

                    // make it public
                    this[name] = function () {
                        //if passed with no params, consider it a get request
                        if (arguments.length === 0) {
                            return definition.dialog;
                        } else {
                            var instance = extend(new definition.factory(), dialog);
                            //ensure init
                            if (instance && typeof instance.__init === 'function') {
                                instance.__init(instance);
                            }
                            instance['main'].apply(instance, arguments);
                            return instance['show'].apply(instance);
                        }
                    };
                } else {
                    // make it public
                    this[name] = function () {
                        //ensure init
                        if (definition.dialog && typeof definition.dialog.__init === 'function') {
                            definition.dialog.__init(definition.dialog);
                        }
                        //if passed with no params, consider it a get request
                        if (arguments.length === 0) {
                            return definition.dialog;
                        } else {
                            var dialog = definition.dialog;
                            dialog['main'].apply(definition.dialog, arguments);
                            return dialog['show'].apply(definition.dialog);
                        }
                    };
                }
            },
            /**
             * Close all open dialogs.
             *
             * @param {Object} excpet [optional] The dialog object to exclude from closing.
             *
             * @return {undefined}
             */
            closeAll: function (except) {
                var clone = openDialogs.slice(0);
                for (var x = 0; x < clone.length; x += 1) {
                    var instance = clone[x];
                    if (except === undefined || except !== instance) {
                        instance.close();
                    }
                }
            },
            /**
             * Gets or Sets dialog settings/options. if the dialog is transient, this call does nothing.
             *
             * @param {string} name The dialog name.
             * @param {String|Object} key A string specifying a propery name or a collection of key/value pairs.
             * @param {Variant} value Optional, the value associated with the key (in case it was a string).
             *
             * @return {undefined}
             */
            setting: function (name, key, value) {

                if (name === 'notifier') {
                    return notifier.setting(key, value);
                }

                var dialog = get_dialog(name);
                if (dialog) {
                    return dialog.setting(key, value);
                }
            },
            /**
             * [Alias] Sets dialog settings/options 
             */
            set: function(name,key,value){
                return this.setting(name, key,value);
            },
            /**
             * [Alias] Gets dialog settings/options 
             */
            get: function(name, key){
                return this.setting(name, key);
            },
            /**
             * Creates a new notification message.
             * If a type is passed, a class name "ajs-{type}" will be added.
             * This allows for custom look and feel for various types of notifications.
             *
             * @param  {String | DOMElement}    [message=undefined]		Message text
             * @param  {String}                 [type='']				Type of log message
             * @param  {String}                 [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}               [callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            notify: function (message, type, wait, callback) {
                return notifier.create(type, callback).push(message, wait);
            },
            /**
             * Creates a new notification message.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            message: function (message, wait, callback) {
                return notifier.create(null, callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'success'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            success: function (message, wait, callback) {
                return notifier.create('success', callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'error'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            error: function (message, wait, callback) {
                return notifier.create('error', callback).push(message, wait);
            },
            /**
             * Creates a new notification message of type 'warning'.
             *
             * @param  {String}		[message=undefined]		Message text
             * @param  {String}     [wait='']				Time (in seconds) to wait before auto-close
             * @param  {Function}	[callback=undefined]	A callback function to be invoked when the log is closed.
             *
             * @return {Object} Notification object.
             */
            warning: function (message, wait, callback) {
                return notifier.create('warning', callback).push(message, wait);
            },
            /**
             * Dismisses all open notifications
             *
             * @return {undefined}
             */
            dismissAll: function () {
                notifier.dismissAll();
            }
        };
    }
    var alertify = new Alertify();

    /**
    * Alert dialog definition
    *
    * invoked by:
    *	alertify.alert(message);
    *	alertify.alert(title, message);
    *	alertify.alert(message, onok);
    *	alertify.alert(title, message, onok);
     */
    alertify.dialog('alert', function () {
        return {
            main: function (_title, _message, _onok) {
                var title, message, onok;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    if (typeof _message === 'function') {
                        message = _title;
                        onok = _message;
                    } else {
                        title = _title;
                        message = _message;
                    }
                    break;
                case 3:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('onok', onok);
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.ok,
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                // nothing
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                this.setContent(message);
            },
            settings: {
                message: undefined,
                onok: undefined,
                label: undefined,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'label':
                    if (this.__internal.buttons[0].element) {
                        this.__internal.buttons[0].element.innerHTML = newValue;
                    }
                    break;
                }
            },
            callback: function (closeEvent) {
                if (typeof this.get('onok') === 'function') {
                    var returnValue = this.get('onok').call(this, closeEvent);
                    if (typeof returnValue !== 'undefined') {
                        closeEvent.cancel = !returnValue;
                    }
                }
            }
        };
    });
    /**
     * Confirm dialog object
     *
     *	alertify.confirm(message);
     *	alertify.confirm(message, onok);
     *	alertify.confirm(message, onok, oncancel);
     *	alertify.confirm(title, message, onok, oncancel);
     */
    alertify.dialog('confirm', function () {

        var autoConfirm = {
            timer: null,
            index: null,
            text: null,
            duration: null,
            task: function (event, self) {
                if (self.isOpen()) {
                    self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text + ' (&#8207;' + autoConfirm.duration + '&#8207;) ';
                    autoConfirm.duration -= 1;
                    if (autoConfirm.duration === -1) {
                        clearAutoConfirm(self);
                        var button = self.__internal.buttons[autoConfirm.index];
                        var closeEvent = createCloseEvent(autoConfirm.index, button);

                        if (typeof self.callback === 'function') {
                            self.callback.apply(self, [closeEvent]);
                        }
                        //close the dialog.
                        if (closeEvent.close !== false) {
                            self.close();
                        }
                    }
                } else {
                    clearAutoConfirm(self);
                }
            }
        };

        function clearAutoConfirm(self) {
            if (autoConfirm.timer !== null) {
                clearInterval(autoConfirm.timer);
                autoConfirm.timer = null;
                self.__internal.buttons[autoConfirm.index].element.innerHTML = autoConfirm.text;
            }
        }

        function startAutoConfirm(self, index, duration) {
            clearAutoConfirm(self);
            autoConfirm.duration = duration;
            autoConfirm.index = index;
            autoConfirm.text = self.__internal.buttons[index].element.innerHTML;
            autoConfirm.timer = setInterval(delegate(self, autoConfirm.task), 1000);
            autoConfirm.task(null, self);
        }


        return {
            main: function (_title, _message, _onok, _oncancel) {
                var title, message, onok, oncancel;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    onok = _message;
                    break;
                case 3:
                    message = _title;
                    onok = _message;
                    oncancel = _onok;
                    break;
                case 4:
                    title = _title;
                    message = _message;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('onok', onok);
                this.set('oncancel', oncancel);
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok,
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel,
                        }
                    ],
                    focus: {
                        element: 0,
                        select: false
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                //nothing
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                this.setContent(message);
            },
            settings: {
                message: null,
                labels: null,
                onok: null,
                oncancel: null,
                defaultFocus: null,
                reverseButtons: null,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'labels':
                    if ('ok' in newValue && this.__internal.buttons[0].element) {
                        this.__internal.buttons[0].text = newValue.ok;
                        this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    }
                    if ('cancel' in newValue && this.__internal.buttons[1].element) {
                        this.__internal.buttons[1].text = newValue.cancel;
                        this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    }
                    break;
                case 'reverseButtons':
                    if (newValue === true) {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    } else {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    }
                    break;
                case 'defaultFocus':
                    this.__internal.focus.element = newValue === 'ok' ? 0 : 1;
                    break;
                }
            },
            callback: function (closeEvent) {
                clearAutoConfirm(this);
                var returnValue;
                switch (closeEvent.index) {
                case 0:
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                }
            },
            autoOk: function (duration) {
                startAutoConfirm(this, 0, duration);
                return this;
            },
            autoCancel: function (duration) {
                startAutoConfirm(this, 1, duration);
                return this;
            }
        };
    });
    /**
     * Prompt dialog object
     *
     * invoked by:
     *	alertify.prompt(message);
     *	alertify.prompt(message, value);
     *	alertify.prompt(message, value, onok);
     *	alertify.prompt(message, value, onok, oncancel);
     *	alertify.prompt(title, message, value, onok, oncancel);
     */
    alertify.dialog('prompt', function () {
        var input = document.createElement('INPUT');
        var p = document.createElement('P');
        return {
            main: function (_title, _message, _value, _onok, _oncancel) {
                var title, message, value, onok, oncancel;
                switch (arguments.length) {
                case 1:
                    message = _title;
                    break;
                case 2:
                    message = _title;
                    value = _message;
                    break;
                case 3:
                    message = _title;
                    value = _message;
                    onok = _value;
                    break;
                case 4:
                    message = _title;
                    value = _message;
                    onok = _value;
                    oncancel = _onok;
                    break;
                case 5:
                    title = _title;
                    message = _message;
                    value = _value;
                    onok = _onok;
                    oncancel = _oncancel;
                    break;
                }
                this.set('title', title);
                this.set('message', message);
                this.set('value', value);
                this.set('onok', onok);
                this.set('oncancel', oncancel);
                return this;
            },
            setup: function () {
                return {
                    buttons: [
                        {
                            text: alertify.defaults.glossary.ok,
                            key: keys.ENTER,
                            className: alertify.defaults.theme.ok,
                        },
                        {
                            text: alertify.defaults.glossary.cancel,
                            key: keys.ESC,
                            invokeOnClose: true,
                            className: alertify.defaults.theme.cancel,
                        }
                    ],
                    focus: {
                        element: input,
                        select: true
                    },
                    options: {
                        maximizable: false,
                        resizable: false
                    }
                };
            },
            build: function () {
                input.className = alertify.defaults.theme.input;
                input.setAttribute('type', 'text');
                input.value = this.get('value');
                this.elements.content.appendChild(p);
                this.elements.content.appendChild(input);
            },
            prepare: function () {
                //nothing
            },
            setMessage: function (message) {
                if (typeof message === 'string') {
                    clearContents(p);
                    p.innerHTML = message;
                } else if (message instanceof window.HTMLElement && p.firstChild !== message) {
                    clearContents(p);
                    p.appendChild(message);
                }
            },
            settings: {
                message: undefined,
                labels: undefined,
                onok: undefined,
                oncancel: undefined,
                value: '',
                type:'text',
                reverseButtons: undefined,
            },
            settingUpdated: function (key, oldValue, newValue) {
                switch (key) {
                case 'message':
                    this.setMessage(newValue);
                    break;
                case 'value':
                    input.value = newValue;
                    break;
                case 'type':
                    switch (newValue) {
                    case 'text':
                    case 'color':
                    case 'date':
                    case 'datetime-local':
                    case 'email':
                    case 'month':
                    case 'number':
                    case 'password':
                    case 'search':
                    case 'tel':
                    case 'time':
                    case 'week':
                        input.type = newValue;
                        break;
                    default:
                        input.type = 'text';
                        break;
                    }
                    break;
                case 'labels':
                    if (newValue.ok && this.__internal.buttons[0].element) {
                        this.__internal.buttons[0].element.innerHTML = newValue.ok;
                    }
                    if (newValue.cancel && this.__internal.buttons[1].element) {
                        this.__internal.buttons[1].element.innerHTML = newValue.cancel;
                    }
                    break;
                case 'reverseButtons':
                    if (newValue === true) {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[0].element);
                    } else {
                        this.elements.buttons.primary.appendChild(this.__internal.buttons[1].element);
                    }
                    break;
                }
            },
            callback: function (closeEvent) {
                var returnValue;
                switch (closeEvent.index) {
                case 0:
                    this.settings.value = input.value;
                    if (typeof this.get('onok') === 'function') {
                        returnValue = this.get('onok').call(this, closeEvent, this.settings.value);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    break;
                case 1:
                    if (typeof this.get('oncancel') === 'function') {
                        returnValue = this.get('oncancel').call(this, closeEvent);
                        if (typeof returnValue !== 'undefined') {
                            closeEvent.cancel = !returnValue;
                        }
                    }
                    if(!closeEvent.cancel){
                        input.value = this.settings.value;
                    }
                    break;
                }
            }
        };
    });

    // CommonJS
    if ( typeof module === 'object' && typeof module.exports === 'object' ) {
        module.exports = alertify;
    // AMD
    } else if ( true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return alertify;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    // window
    } else if ( !window.alertify ) {
        window.alertify = alertify;
    }

} ( typeof window !== 'undefined' ? window : this ) );


/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.tours')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.tours')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.tours')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newGuardTour()}}},[_vm._v("Yeni Tur")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardTourList.length > 0),expression:"guardTourList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.guardTourList),function(tour){return _c('tr',{key:tour.id},[_c('td',[_vm._v(_vm._s(tour.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getGuardTour(tour.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardTourList.length == 0),expression:"guardTourList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('users.userNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Tur Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guardTour.name),expression:"guardTour.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.guardTour.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guardTour, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Başlangıç Zamanı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guardTour.startDate),expression:"guardTour.startDate"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.guardTour.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guardTour, "startDate", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Bitiş Zamanı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.guardTour.endDate),expression:"guardTour.endDate"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.guardTour.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.guardTour, "endDate", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuardTour),expression:"!isNewGuardTour"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewGuardTour),expression:"isNewGuardTour"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuardTour),expression:"!isNewGuardTour"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('ul',{staticClass:"products-list product-list-in-box",style:(_vm.windowHeightSize)},_vm._l((_vm.tourDetailList),function(detail){return _c('li',{key:detail.id,staticClass:"item",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.selectTourDetail(detail)}}},[_c('div',{staticClass:"product-img"},[_c('img',{attrs:{"src":_vm.getAreaImageFromId(detail.controlPoint.areaId) ? '/src/assets/buildings/' + _vm.getAreaImageFromId(detail.controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'}})]),_vm._v(" "),_c('div',{staticClass:"product-info"},[_c('span',{staticClass:"product-title"},[_vm._v("\n                    "+_vm._s(detail.controlPoint.name)+"\n                    "),_c('span',{staticClass:"label label-warning pull-right",staticStyle:{"font-size":"large"}},[_vm._v(_vm._s(detail.time))])]),_vm._v(" "),_c('span',{staticClass:"product-description"},[_vm._v(_vm._s(_vm.getAreaNameFromId(detail.controlPoint.areaId)))])])])}),0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewGuardTour),expression:"!isNewGuardTour"}],staticClass:"btn btn-warning btn-lg",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.newTourDetail()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Ekle\n            ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewGuardTour),expression:"isNewGuardTour"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Lütfen önce tur seçin veya tur kaydedin.\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.guardTour.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveGuardTour()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(_vm.guardTour.name))]),_vm._v(" "),_c('span',[_vm._v("Yeni tur kaydedilecektir. Devam edilsin mi?")])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveGuardTour()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.guardTour.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.deleteGuardTour()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-tour-detail"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(6),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tourDetail.time),expression:"tourDetail.time"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.tourDetail.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tourDetail, "time", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTourDetail),expression:"!isNewTourDetail"}],staticClass:"form-group",staticStyle:{"margin-top":"10px"}},[_vm._m(7),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeControlPoint($event)}}},[_c('option',{attrs:{"value":""}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.controlPointList),function(controlPoint){return _c('option',{key:controlPoint.id,domProps:{"value":controlPoint.id,"selected":_vm.tourDetail.guardControlPointId == controlPoint.id}},[_vm._v(_vm._s(controlPoint.name))])})],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewTourDetail),expression:"isNewTourDetail"}]},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"470px","owerflow":"auto"}},[_vm._l((_vm.controlPointList),function(controlPoint){return _c('span',{key:controlPoint.id,staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":controlPoint.isCheck},on:{"change":function($event){controlPoint.isCheck == true ? controlPoint.isCheck = false : controlPoint.isCheck = true}}}),_vm._v("\n                        "+_vm._s(controlPoint.name)+" ("+_vm._s(_vm.getAreaById(controlPoint.areaId))+")\n                      ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.controlPointList.length == 0),expression:"controlPointList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("Kontrol noktası\n                      bulunamadı...")])],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tourDetail.controlPoint.areaId && !_vm.isNewTourDetail),expression:"tourDetail.controlPoint.areaId && !isNewTourDetail"}],staticClass:"row"},[_c('div',{staticClass:"col-sm-2"},[_c('img',{staticStyle:{"width":"50px"},attrs:{"src":_vm.getAreaImageFromId(_vm.tourDetail.controlPoint.areaId) ? '/src/assets/buildings/' + _vm.getAreaImageFromId(_vm.tourDetail.controlPoint.areaId) : '/src/assets/buildings/office-building-19.png'}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-10"},[_c('h4',[_vm._v(_vm._s(_vm.getAreaNameFromId(_vm.tourDetail.controlPoint.areaId)))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTourDetail),expression:"!isNewTourDetail"}],staticClass:"btn btn-danger ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteTourDetail()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.delete'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTourDetail),expression:"!isNewTourDetail"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveTourDetail()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.update'))+"\n              ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewTourDetail),expression:"isNewTourDetail"}],staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveTourDetail()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.save'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Tur Bilgileri")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Tur Detayları")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Tur Kontrol Noktası Detayı")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Zaman\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-thumb-tack"}),_vm._v(" Kontrol Noktası\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('i',{staticClass:"fa fa-thumb-tack"}),_vm._v(" Kontrol Noktaları\n                  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardTourReports_vue__ = __webpack_require__(161);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1715a578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardTourReports_vue__ = __webpack_require__(387);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardTourReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1715a578_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardTourReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourReports')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourReports')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList != ''),expression:"checkedGuardList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedGuardList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList == ''),expression:"checkedGuardList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList != ''),expression:"checkedGuardList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearCheckedGuards()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.send()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.view'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-setting"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"btn btn-danger btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{staticClass:"text-center"},[_c('span',[_vm._v("Tur Hareket Raporu ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" -\n                  "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id,staticClass:"rows"},[_c('td',[_c('span',[_vm._v(_vm._s(log.name))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.controlPoint))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.date))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(log.isOnlineRead),expression:"log.isOnlineRead"}],staticClass:"badge label-success"},[_vm._v("Çevrim içi")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!log.isOnlineRead),expression:"!log.isOnlineRead"}],staticClass:"badge label-danger"},[_vm._v("Çevrim dışı")])]),_vm._v(" "),_c('td',[(log.location)?_c('a',{staticStyle:{"margin-top":"10px"},attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.openWindow(log)}}},[_vm._v(_vm._s(log.location.lat)+"\n                        - "+_vm._s(log.location.lon))]):_vm._e()])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-guard"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length > 0),expression:"guardList.length > 0"}],staticClass:"form-control checkbox no-border",staticStyle:{"background-color":"#f4f4f4","font-weight":"bold"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.checkedGuardCount == _vm.guardList.length},on:{"change":function($event){return _vm.guardList.forEach(function (guard) {
                      guard.isCheck = $event.target.checked;
                    });}}}),_vm._v("\n                  Tümünü Seç\n                ")])]),_vm._v(" "),_vm._l((_vm.guardList),function(guard){return _c('span',{key:guard.id,staticClass:"form-control checkbox no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":guard.isCheck},on:{"change":function($event){guard.isCheck == true ? guard.isCheck = false : guard.isCheck = true}}}),_vm._v("\n                  "+_vm._s(guard.name)+"\n                  "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(guard.title != ''),expression:"guard.title != ''"}]},[_vm._v("( "+_vm._s(guard.title)+" )")])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length == 0),expression:"guardList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("Görevli kaydı bulunamadı...")])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-select-guard"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Tur Hareket Raporu")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Adı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Kontrol Noktası")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Okutma Zamanı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Hareket Durumu")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Koordinat")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Görevli Seç")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardIncidentReport_vue__ = __webpack_require__(162);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b153cde6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardIncidentReport_vue__ = __webpack_require__(391);
function injectStyle (ssrContext) {
  __webpack_require__(389)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b153cde6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GuardIncidentReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b153cde6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuardIncidentReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("4d97a708", content, true, {});

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".guard-tour-incident-image[data-v-b153cde6]{width:50px;height:50px;margin-right:5px;border:1px solid #ccc;border-radius:10px;cursor:pointer}.guard-tour-incident-image[data-v-b153cde6]:hover{box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19);transition:.3s}", ""]);

// exports


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourReports')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-shield"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourReports')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList != ''),expression:"checkedGuardList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedGuardList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList == ''),expression:"checkedGuardList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedGuardList != ''),expression:"checkedGuardList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearCheckedGuards()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.send()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.view'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-setting"}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"btn btn-danger btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                                "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                            ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{staticClass:"text-center"},[_c('span',[_vm._v("Tur Olay Raporları ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+"\n                                    -\n                                    "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id,staticClass:"rows"},[_c('td',[_c('span',[_vm._v(_vm._s(log.name))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.date))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.description))])]),_vm._v(" "),_c('td',_vm._l((log.photos),function(photo,index){return _c('img',{key:index,staticClass:"guard-tour-incident-image",attrs:{"src":photo,"alt":"Olay Görseli"},on:{"click":function($event){return _vm.openImageModal(photo)}}})}),0)])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-guard"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length > 0),expression:"guardList.length > 0"}],staticClass:"form-control checkbox no-border",staticStyle:{"background-color":"#f4f4f4","font-weight":"bold"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.guardList.forEach(function (guard) {
                                            guard.isCheck = $event.target.checked;
                                        });}}}),_vm._v("\n                                    Tümünü Seç\n                                ")])]),_vm._v(" "),_vm._l((_vm.guardList),function(guard){return _c('span',{key:guard.id,staticClass:"form-control checkbox no-border"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":guard.isCheck},on:{"change":function($event){guard.isCheck == true ? guard.isCheck = false : guard.isCheck = true}}}),_vm._v("\n                                    "+_vm._s(guard.name)+"\n                                    "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(guard.title != ''),expression:"guard.title != ''"}]},[_vm._v("( "+_vm._s(guard.title)+" )")])])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.guardList.length == 0),expression:"guardList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("Görevli kaydı\n                                bulunamadı...")])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-image"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"text-center"},[_c('img',{staticStyle:{"max-width":"100%","max-height":"500px"},attrs:{"src":_vm.tempImage,"alt":"Olay Görseli"}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('general.done'))+"\n                        ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-select-guard"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Tur Olay Raporları")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',{staticClass:"text-left"},[_vm._v("Adı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Olay Zamanı")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Açıklama")]),_vm._v(" "),_c('th',{staticClass:"text-left"},[_vm._v("Görseller")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Görevli Seç")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("Görsel")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryCategories_vue__ = __webpack_require__(163);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d2d761_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryCategories_vue__ = __webpack_require__(395);
function injectStyle (ssrContext) {
  __webpack_require__(393)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryCategories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46d2d761_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryCategories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(394);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("71790d80", content, true, {});

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryCategories')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryManagement')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryCategories')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryCategoryList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryCategoryList.length > 0),expression:"inventoryCategoryList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.inventoryCategoryList),function(inventoryCategory){return _c('tr',{key:inventoryCategory.id},[_c('td',[_c('span',[_vm._v(_vm._s(inventoryCategory.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getInventoryCategory(inventoryCategory.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryCategoryList.length == 0),expression:"inventoryCategoryList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryCategoryInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newInventoryCategory()}}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.newInventoryCategory')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryCategoryName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventoryCategory.name),expression:"inventoryCategory.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventoryCategory.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventoryCategory, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryCategory.id && _vm.authControl == 0),expression:"inventoryCategory.id && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventoryCategory.id && _vm.authControl == 0),expression:"!inventoryCategory.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryCategory.id && _vm.authControl == 0),expression:"inventoryCategory.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryCategory.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryCategoryUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryCategory()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.inventoryCategory.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryCategorySave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryCategory()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryCategory.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryCategoryDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteInventoryCategory()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryWarehouse_vue__ = __webpack_require__(164);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2772a326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryWarehouse_vue__ = __webpack_require__(399);
function injectStyle (ssrContext) {
  __webpack_require__(397)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryWarehouse_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2772a326_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryWarehouse_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(398);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("1c6c0186", content, true, {});

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryWarehouses')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryManagement')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryWarehouses')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryWarehouseList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryWarehouseList.length > 0),expression:"inventoryWarehouseList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.inventoryWarehouseList),function(inventoryWarehouse){return _c('tr',{key:inventoryWarehouse.id},[_c('td',[_c('span',[_vm._v(_vm._s(inventoryWarehouse.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getInventoryWarehouse(inventoryWarehouse.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryWarehouseList.length == 0),expression:"inventoryWarehouseList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryWarehouseInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newInventoryWarehouse()}}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.newInventoryWarehouse')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryWarehouseName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventoryWarehouse.name),expression:"inventoryWarehouse.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventoryWarehouse.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventoryWarehouse, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryWarehouse.id && _vm.authControl == 0),expression:"inventoryWarehouse.id && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventoryWarehouse.id && _vm.authControl == 0),expression:"!inventoryWarehouse.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryWarehouse.id && _vm.authControl == 0),expression:"inventoryWarehouse.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryWarehouse.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryWarehouseUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryWarehouse()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.inventoryWarehouse.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryWarehouseSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryWarehouse()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryWarehouse.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryWarehouseDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteInventoryWarehouse()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryFields_vue__ = __webpack_require__(165);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acc4711_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryFields_vue__ = __webpack_require__(403);
function injectStyle (ssrContext) {
  __webpack_require__(401)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InventoryFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6acc4711_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InventoryFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("519ccdaa", content, true, {});

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryFields')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryManagement')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryFields')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryFieldList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryFieldList.length > 0),expression:"inventoryFieldList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.inventoryFieldList),function(inventoryField){return _c('tr',{key:inventoryField.id},[_c('td',[_c('span',[_vm._v(_vm._s(inventoryField.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getInventoryField(inventoryField.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryFieldList.length == 0),expression:"inventoryFieldList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryFieldInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newInventoryField()}}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.newInventoryField')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryFieldName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventoryField.name),expression:"inventoryField.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventoryField.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventoryField, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryField.id && _vm.authControl == 0),expression:"inventoryField.id && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventoryField.id && _vm.authControl == 0),expression:"!inventoryField.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryField.id && _vm.authControl == 0),expression:"inventoryField.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryField.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryFieldUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryField()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.inventoryField.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryFieldSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventoryField()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventoryField.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryFieldDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteInventoryField()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventories_vue__ = __webpack_require__(166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66211a97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventories_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inventories_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66211a97_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Inventories_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(406);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("526cfe95", content, true, {});

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventories')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventoryManagement')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-box"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.inventories')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedCategory),expression:"selectedCategory"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selectedCategory=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{domProps:{"value":0}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.allCategories')))]),_vm._v(" "),_vm._l((_vm.inventoryCategoryList),function(category){return _c('option',{key:category.id,domProps:{"value":category.id}},[_vm._v(_vm._s(category.name))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryList.length > 0),expression:"inventoryList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.inventoryList),function(inventory){return _c('tr',{key:inventory.id},[_c('td',[_c('span',[_vm._v(_vm._s(inventory.name))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(inventory.code))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getInventory(inventory.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventoryList.length == 0),expression:"inventoryList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                        ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newInventory()}}},[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.newInventory')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-body box-profile"},[_c('img',{staticClass:"profile-user-img img-responsive",staticStyle:{"width":"100%"},attrs:{"src":_vm.inventory.photoUrl == null ? '/src/assets/default-product.png' : _vm.inventory.photoUrl}}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('input',{ref:"imageFile",staticClass:"form-control",staticStyle:{"display":"none"},attrs:{"type":"file","id":"image","accept":".png, .jpg, .jpeg","hidden":""},on:{"change":_vm.addPhoto}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.photoUrl),expression:"inventory.photoUrl"}],staticClass:"btn btn-danger btn-sm",staticStyle:{"width":"100%","margin-bottom":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                                            "+_vm._s(_vm.$ml.get('inventoryManagement.removePhoto'))+"\n                                        ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.imageFile.click()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                                            "+_vm._s(_vm.$ml.get('inventoryManagement.selectPhoto'))+"\n                                        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('span',{staticClass:"text-muted",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.inventory.code))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.inventory.name))]),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-style":"italic","font-size":"12px"}},[_vm._v(_vm._s(_vm.getInventoryCategoryName(_vm.inventory.categoryId)))])])])])]),_vm._v(" "),_c('div',{class:_vm.inventory.id ? 'col-md-9' : 'col-md-12'},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active",attrs:{"id":"temel-bilgiler-tab"}},[_c('a',{attrs:{"href":"#temel-bilgiler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v("\n                                                "+_vm._s(_vm.$ml.get('employees.generalInformation'))+"\n                                            ")])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],attrs:{"id":"ozellikler-tab"}},[_c('a',{attrs:{"href":"#ozellikler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v("Özellikler")])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],attrs:{"id":"belgeler-tab"}},[_c('a',{attrs:{"href":"#belgeler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v("Belgeler")])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],attrs:{"id":"zimmetlenen-kisiler-tab"}},[_c('a',{attrs:{"href":"#zimmetlenen-kisiler","data-toggle":"tab","aria-expanded":"true"}},[_vm._v("Zimmetlenen Kişiler")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"temel-bilgiler"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryCode')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventory.code),expression:"inventory.code"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventory.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventory, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryName')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventory.name),expression:"inventory.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventory.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventory, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventorySerialNo')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventory.serialNo),expression:"inventory.serialNo"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.inventory.serialNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventory, "serialNo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryCategory')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCategory($event)}}},[_c('option',{domProps:{"selected":_vm.inventory.categoryId == 0,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.inventoryCategoryList),function(category){return _c('option',{key:category.id,domProps:{"selected":category.id == _vm.inventory.categoryId,"value":category.id}},[_vm._v(_vm._s(category.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.inventoryDefaultWarehouse')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDefaultWarehouse($event)}}},[_c('option',{domProps:{"selected":_vm.inventory.defaultWarehouseId == 0,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.inventoryWarehouseList),function(warehouse){return _c('option',{key:warehouse.id,domProps:{"selected":warehouse.id == _vm.inventory.defaultWarehouseId,"value":warehouse.id}},[_vm._v(_vm._s(warehouse.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.quantity')))]),_vm._v(" :\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inventory.quantity),expression:"inventory.quantity"}],staticClass:"form-control",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.inventory.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inventory, "quantity", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"row",staticStyle:{"margin-top":"10px"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary",staticStyle:{"min-height":"90px","margin-bottom":"15px"}},[_c('div',{staticClass:"box-body"},[_c('div',{staticStyle:{"text-align":"start"}},[_c('span',[_vm._v("Toplam: "),_c('strong',[_vm._v(_vm._s(_vm.inventory.quantity))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Zimmetlenen: "),_c('strong',[_vm._v(_vm._s(_vm.inventory.assignedCount))])]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Kalan: "),_c('strong',[_vm._v(_vm._s(_vm.inventory.quantity -
                                                                    _vm.inventory.assignedCount))])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"info-box bg-blue"},[_c('div',{staticClass:"info-box-content",staticStyle:{"margin-left":"0px"}},[_c('span',{staticClass:"info-box-text",staticStyle:{"text-transform":"none"}},[_vm._v("Zimmet Oranı")]),_vm._v(" "),_c('span',{staticClass:"info-box-number"},[_vm._v("%"+_vm._s((_vm.inventory.assignedCount * 100 / _vm.inventory.quantity)))]),_vm._v(" "),_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:('width:' + _vm.inventory.assignedCount * 100 / _vm.inventory.quantity + '%')})]),_vm._v(" "),_c('span',{staticClass:"progress-description"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"tab-pane",attrs:{"id":"ozellikler"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-4"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeField($event)}}},[_c('option',{domProps:{"selected":_vm.newFieldId == 0,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.inventoryFieldList),function(field){return _c('option',{key:field.id,domProps:{"value":field.id,"selected":_vm.newFieldId == field.id}},[_vm._v(_vm._s(field.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newFieldValue),expression:"newFieldValue"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Değer Giriniz"},domProps:{"value":(_vm.newFieldValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.newFieldValue=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.addField()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v("\n                                                        "+_vm._s(_vm.$ml.get('general.add'))+"\n                                                    ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-hover",staticStyle:{"margin-top":"10px"}},[_c('tbody',[_vm._l((_vm.inventory.fields),function(field,key){return _c('tr',{key:'field' + key},[_c('td',[_vm._v(_vm._s(field.fieldName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(field.fieldValue))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteField(field.fieldValueId)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),(_vm.inventory.id != null && _vm.inventory.fields.length == 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"3"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.recordNotFound')))])])]):_vm._e()],2)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"tab-pane",attrs:{"id":"belgeler"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.newDocument()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                                                        Yeni Belge Yükle\n                                                    ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-hover",staticStyle:{"margin-top":"10px"}},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.documentType')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.documentDescription')))]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.documentList),function(document){return _c('tr',{key:document.id},[_c('td',[_vm._v(_vm._s(_vm.getDocumentDefinitionName(document.documentDefinitionId)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(document.description))]),_vm._v(" "),_c('td',[(!document.filePath)?_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.uploadDocumentDialog(document)}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" Dosya Yükle\n                                                                    ")]):_vm._e(),_vm._v(" "),(document.filePath)?_c('a',{staticClass:"btn btn-success btn-sm",attrs:{"href":document.filePath,"target":"_blank"}},[_c('i',{staticClass:"fa fa-download"}),_vm._v(" Dosya\n                                                                        İndir\n                                                                    ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getDocument(document)}}},[_c('i',{staticClass:"fa fa-pencil"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.deleteDocument(document.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),(_vm.inventory.id != null && _vm.documentList.length == 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.recordNotFound')))])])]):_vm._e(),_vm._v(" "),(_vm.inventory.id == null)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"4"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.pleaseSelect')))])])]):_vm._e()],2)])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id),expression:"inventory.id"}],staticClass:"tab-pane",attrs:{"id":"zimmetlenen-kisiler"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-hover",staticStyle:{"margin-top":"10px"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_vm._l((_vm.inventory.assignedUsers),function(assignedPerson,key){return _c('tr',{key:key},[_c('td',[_vm._v(_vm._s(assignedPerson.name)),_c('span',{directives:[{name:"show",rawName:"v-show",value:(assignedPerson.isVisitor),expression:"assignedPerson.isVisitor"}]},[_vm._v("\n                                                                        (Ziyaretçi)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(assignedPerson.quantity))])])}),_vm._v(" "),(_vm.inventory.id != null && _vm.inventory.assignedCount == 0)?_c('tr',[_c('td',{staticClass:"text-center",attrs:{"colspan":"2"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('alerts.recordNotFound')))])])]):_vm._e()],2)])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id && _vm.authControl == 0),expression:"inventory.id && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.inventory.id && _vm.authControl == 0),expression:"!inventory.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.inventory.id && _vm.authControl == 0),expression:"inventory.id && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-document"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[(!_vm.document.id)?_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.newDocument')))]):_vm._e(),_vm._v(" "),(_vm.document.id)?_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.editDocument')))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.documentType')))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.documentDefinitionId),expression:"document.documentDefinitionId"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.document, "documentDefinitionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"selected":_vm.document.documentDefinitionId == null,"value":null}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.documentDefinitionList),function(definition){return _c('option',{key:definition.id,domProps:{"selected":definition.id == _vm.document.documentDefinitionId,"value":definition.id}},[_vm._v(_vm._s(definition.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.documentDescription')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.document.description),expression:"document.description"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.document.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.document, "description", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDocument()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"modal-document-file"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.addDocumentFile')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('input',{ref:"file",staticClass:"form-control",attrs:{"type":"file","id":"fileName","accept":".zip, .pdf, .doc, .docx, .xls, .xlsx, .png, .jpg, .jpeg"},on:{"change":_vm.uploadFile}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.submitFile()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.upload')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventory.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventory()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.inventory.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventorySave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveInventory()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.inventory.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('inventoryManagement.isContinueInventoryDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteInventory()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12"},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Kişi Bilgisi")]),_vm._v(" "),_c('th',[_vm._v("Adet")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDesign_vue__ = __webpack_require__(167);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9a987b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDesign_vue__ = __webpack_require__(411);
function injectStyle (ssrContext) {
  __webpack_require__(409)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f9a987b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardDesign_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f9a987b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CardDesign_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(410);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("16c81733", content, true, {});

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".customCard[data-v-7f9a987b]{width:347px;height:221px;border-radius:10px;display:inline-block;position:relative;border:1px dotted #ccc}", ""]);

// exports


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.cardDesignTemplates')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.cardDesignTemplates')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newCardDesign()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Kart Tasarımı\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardDesignList.length > 0),expression:"cardDesignList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"945px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderName()}}},[_c('strong',[_vm._v("\n                        Şablon Adı\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderNameList == 0),expression:"orderNameList == 0"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderNameList == 1),expression:"orderNameList == 1"}],staticClass:"fa fa-sort-alpha-desc"})])]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.filtered),function(cardDesign1){return _c('tr',{key:cardDesign1.id,class:_vm.cardDesign.id == cardDesign1.id ? 'bg-primary': '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getCardDesign(cardDesign1.id)}}},[_c('td',[_vm._v(_vm._s(cardDesign1.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-danger",on:{"click":function($event){return _vm.deleteCardDesign(cardDesign1.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cardDesignList.length == 0),expression:"cardDesignList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get("alerts.recordNotFound"))+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingList}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-success",on:{"click":function($event){return _vm.saveCard()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" Değişiklikleri Kaydet\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"text-center col-sm-6"},[_c('div',{staticClass:"customCard",style:('background-color:'+_vm.cardDesign.backgroundColor+';background-image:url('+_vm.cardDesign.backgroundImage+');background-size:cover;')},[_vm._l((_vm.cardImageItems),function(item1){return _c('img',{key:item1.id,style:(_vm.imageItemStyle(item1)),attrs:{"src":item1.imageUrl},on:{"click":function($event){return _vm.selectItem(item1)}}})}),_vm._v(" "),_vm._l((_vm.cardLabelItems),function(item2){return _c('span',{key:item2.id,style:(_vm.itemStyle(item2)),on:{"click":function($event){return _vm.selectItem(item2)}}},[_vm._v(_vm._s(item2.text))])}),_vm._v(" "),_vm._l((_vm.cardValueItems),function(item3){return _c('span',{key:item3.id,style:(_vm.itemStyle(item3)),on:{"click":function($event){return _vm.selectItem(item3)}}},[_vm._v(_vm._s(_vm.getValueTitle(item3.value)))])})],2),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v("Kullanılan Nesneler")]),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._l((_vm.cardItems),function(cardItem,index){return _c('div',{key:cardItem.id,staticClass:"input-group",staticStyle:{"margin-bottom":"5px","cursor":"pointer"},on:{"click":function($event){return _vm.selectItem(cardItem)}}},[_c('span',{staticClass:"input-group-addon",style:(_vm.selectedItem.id == cardItem.id ? 'background-color:#00a0f0;color:#ffffff;':'')},[(cardItem.type == 0)?_c('i',{staticClass:"fa fa-font"}):_vm._e(),_vm._v(" "),(cardItem.type == 1)?_c('i',{staticClass:"fa fa-lightbulb-o"}):_vm._e(),_vm._v(" "),(cardItem.type == 2)?_c('i',{staticClass:"fa fa-picture-o"}):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"form-control",style:(_vm.selectedItem.id == cardItem.id ? 'background-color:#00a0f0;color:#ffffff;cursor:pointer;':'cursor:pointer;')},[_vm._v(_vm._s(cardItem.title))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){return _vm.removeItem(index)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",staticStyle:{"width":"100%","margin-top":"5px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.newItem()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Nesne\n                ")])],2),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Şablon Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cardDesign.name),expression:"cardDesign.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.cardDesign.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.cardDesign, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Arkaplan Rengi")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"color"},domProps:{"value":_vm.cardDesign.backgroundColor},on:{"change":function($event){return _vm.changebackgroundColor($event)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Arkaplan Görseli")]),_vm._v(" "),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"accept":"image/*","type":"file"},on:{"change":function($event){return _vm.onFilePicked($event)}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.$refs.file.click()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('employees.selectPhoto'))+"\n                      ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',{staticClass:"text-center"},[_vm._v("Tasarım Ayarları")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Nesne Tipi")]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"type":"text"},on:{"change":function($event){return _vm.changeType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedItem.type == 0}},[_vm._v("Yazı")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedItem.type == 1}},[_vm._v("Değer (Bilgi Alanı)")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.selectedItem.type == 2}},[_vm._v("Profil Fotoğrafı")])])]),_vm._v(" "),(_vm.selectedItem.type == 1)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Değer (Bilgi Alanı)")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCardValue($event)}}},_vm._l((_vm.cardValues),function(cardValue){return _c('option',{key:cardValue.id,domProps:{"selected":cardValue.id == _vm.selectedItem.value,"value":cardValue.id}},[_vm._v(_vm._s(cardValue.name))])}),0)]):_vm._e(),_vm._v(" "),(_vm.selectedItem.type == 0)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Yazı Metni")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.text),expression:"selectedItem.text"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedItem.text)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "text", $event.target.value)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[(_vm.selectedItem.type != 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        Yazı Büyüklüğü :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.fontSize),expression:"selectedItem.fontSize"}],staticClass:"no-border text-center",attrs:{"type":"number","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.fontSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "fontSize", $event.target.value)}}}),_vm._v(" px\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.fontSize),expression:"selectedItem.fontSize"}],staticClass:"form-control",attrs:{"type":"range","max":"90","min":"3"},domProps:{"value":(_vm.selectedItem.fontSize)},on:{"__r":function($event){return _vm.$set(_vm.selectedItem, "fontSize", $event.target.value)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[(_vm.selectedItem.type != 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Hizalama")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.selectedItem.fontAlign == 'left' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeAlign('left')}}},[_c('i',{staticClass:"fa fa-align-left"})]),_vm._v(" "),_c('button',{class:_vm.selectedItem.fontAlign == 'center' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeAlign('center')}}},[_c('i',{staticClass:"fa fa-align-center"})]),_vm._v(" "),_c('button',{class:_vm.selectedItem.fontAlign == 'right' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeAlign('right')}}},[_c('i',{staticClass:"fa fa-align-right"})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-7"},[(_vm.selectedItem.type != 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Yazı Rengi")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"type":"color"},domProps:{"value":_vm.selectedItem.fontColor},on:{"change":function($event){return _vm.changeFontColor($event)}}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[(_vm.selectedItem.type != 2)?_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Yazı Tipi")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.selectedItem.fontWeight == 'font-weight:normal;' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeFontWeight('font-weight:normal;')}}},[_c('i',{staticClass:"fa fa-font"})]),_vm._v(" "),_c('button',{class:_vm.selectedItem.fontWeight == 'font-weight:bolder;' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeFontWeight('font-weight:bolder;')}}},[_c('i',{staticClass:"fa fa-bold"})]),_vm._v(" "),_c('button',{class:_vm.selectedItem.fontItalic == 'font-style:italic;' ? 'btn btn-primary' : 'btn btn-default',on:{"click":function($event){return _vm.changeFontItalic('font-style:italic;')}}},[_c('i',{staticClass:"fa fa-italic"})])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        Yükseklik :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.height),expression:"selectedItem.height"}],staticClass:"no-border text-center",attrs:{"type":"number","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.height)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "height", $event.target.value)}}}),_vm._v(" px\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.height),expression:"selectedItem.height"}],staticClass:"form-control",attrs:{"type":"range","max":"204","min":"5"},domProps:{"value":(_vm.selectedItem.height)},on:{"__r":function($event){return _vm.$set(_vm.selectedItem, "height", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        Genişlik :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.width),expression:"selectedItem.width"}],staticClass:"no-border text-center",attrs:{"type":"number","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.width)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "width", $event.target.value)}}}),_vm._v(" px\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.width),expression:"selectedItem.width"}],staticClass:"form-control",attrs:{"type":"range","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.width)},on:{"__r":function($event){return _vm.$set(_vm.selectedItem, "width", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        Üst Boşluk :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.top),expression:"selectedItem.top"}],staticClass:"no-border text-center",attrs:{"type":"number","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.top)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "top", $event.target.value)}}}),_vm._v(" px\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.top),expression:"selectedItem.top"}],staticClass:"form-control",attrs:{"type":"range","max":"190","min":"3"},domProps:{"value":(_vm.selectedItem.top)},on:{"__r":function($event){return _vm.$set(_vm.selectedItem, "top", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                        Sol Boşluk :\n                        "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.left),expression:"selectedItem.left"}],staticClass:"no-border text-center",attrs:{"type":"number","max":"323","min":"5"},domProps:{"value":(_vm.selectedItem.left)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedItem, "left", $event.target.value)}}}),_vm._v(" px\n                      ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedItem.left),expression:"selectedItem.left"}],staticClass:"form-control",attrs:{"type":"range","max":"300","min":"3"},domProps:{"value":(_vm.selectedItem.left)},on:{"__r":function($event){return _vm.$set(_vm.selectedItem, "left", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedItem.id),expression:"!selectedItem.id"}],staticClass:"btn btn-success",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.addItem()}}},[_vm._v("Nesneyi Ekle")])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Kart Şablon Listesi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Şablon Detayı")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraFields_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1050b432_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraFields_vue__ = __webpack_require__(413);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraFields_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1050b432_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraFields_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.extraFields')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.extraFields')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('extraFields.extraFieldList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraFieldList.length > 0),expression:"extraFieldList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.extraFieldList),function(extraField){return _c('tr',{key:extraField.id},[_c('td',[_vm._v(_vm._s(extraField.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectExtraField(extraField)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraFieldList.length == 0),expression:"extraFieldList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('extraFields.extraFieldNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('extraFields.extraFieldInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newExtraField()}}},[_vm._v(_vm._s(_vm.$ml.get('extraFields.newGroup')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('extraFields.groupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedExtraField.name),expression:"selectedExtraField.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedExtraField.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedExtraField, "name", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewExtraField && _vm.authControl == 0),expression:"!isNewExtraField && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewExtraField && _vm.authControl == 0),expression:"isNewExtraField && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewExtraField && _vm.authControl == 0),expression:"!isNewExtraField && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedExtraField.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('extraFields.isContinueUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveExtraField()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.selectedExtraField.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('extraFields.isContinueSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveExtraField()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedExtraField.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('extraFields.isContinueDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteExtraField()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documentDefinitions_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b2642e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_documentDefinitions_vue__ = __webpack_require__(417);
function injectStyle (ssrContext) {
  __webpack_require__(415)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documentDefinitions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01b2642e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_documentDefinitions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(416);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("06800148", content, true, {});

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.documentDefinitions')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.documentDefinitions')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.documentDefinitionList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.documentDefinitionList.length > 0),expression:"documentDefinitionList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.documentDefinitionList),function(documentDefinition){return _c('tr',{key:documentDefinition.id},[_c('td',[_c('span',[_vm._v(_vm._s(documentDefinition.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getDocumentDefinition(documentDefinition.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.documentDefinitionList.length == 0),expression:"documentDefinitionList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('documentDefinitions.documentDefinitionNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.documentDefinitionInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newDocumentDefinition()}}},[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.newDocumentDefinition')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.documentDefinitionName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.documentDefinition.name),expression:"documentDefinition.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.documentDefinition.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.documentDefinition, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDocumentDefinition && _vm.authControl == 0),expression:"!isNewDocumentDefinition && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewDocumentDefinition && _vm.authControl == 0),expression:"isNewDocumentDefinition && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDocumentDefinition && _vm.authControl == 0),expression:"!isNewDocumentDefinition && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.documentDefinition.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.isContinueDocumentDefinitionUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDocumentDefinition()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.documentDefinition.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.isContinueDocumentDefinitionSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDocumentDefinition()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.documentDefinition.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('documentDefinitions.isContinueDocumentDefinitionDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteDocumentDefinition()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Departments_vue__ = __webpack_require__(170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486740af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Departments_vue__ = __webpack_require__(421);
function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Departments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_486740af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Departments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(420);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("67576da8", content, true, {});

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.departments')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.departments')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('departments.departmentInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newDepartment()}}},[_vm._v(_vm._s(_vm.$ml.get('departments.newDepartment')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('departments.departmentName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.department.name),expression:"department.name"}],staticClass:"form-control",attrs:{"id":"selectedNode","type":"text"},domProps:{"value":(_vm.department.name)},on:{"click":function($event){return _vm.selectNode()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.department, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('departments.mainDepartment')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMainDepartment($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.department.mainDepartmentId == null}},[_vm._v(_vm._s(_vm.$ml.get('general.select'))+"\n                ")]),_vm._v(" "),_vm._l((_vm.getDepartmentList),function(mainDep){return _c('option',{key:mainDep.id,domProps:{"value":mainDep.id,"selected":mainDep.id == _vm.department.mainDepartmentId}},[_vm._v(_vm._s(mainDep.name))])})],2)]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.department.displayOnDashboard},on:{"change":function($event){_vm.department.displayOnDashboard = !_vm.department.displayOnDashboard}}}),_vm._v("\n                "+_vm._s(_vm.$ml.get('departments.displayOnDashboard'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("1.Sorumlu Kullanıcı")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAuthUser1($event)}}},[_c('option',{domProps:{"value":0}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.userList),function(user){return _c('option',{key:user.id,domProps:{"selected":user.id == _vm.department.authorizedUser1,"value":user.id}},[_vm._v(_vm._s(user.name)+" - "+_vm._s(user.title))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("2.Sorumlu Kullanıcı")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAuthUser2($event)}}},[_c('option',{domProps:{"value":0}},[_vm._v("Seçilmedi")]),_vm._v(" "),_vm._l((_vm.userList),function(user){return _c('option',{key:user.id,domProps:{"selected":user.id == _vm.department.authorizedUser2,"value":user.id}},[_vm._v(_vm._s(user.name)+" - "+_vm._s(user.title))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDepartment && _vm.authControl == 0),expression:"!isNewDepartment && authControl == 0"}],staticClass:"btn btn-sm btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewDepartment && _vm.authControl == 0),expression:"isNewDepartment && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDepartment && _vm.authControl == 0),expression:"!isNewDepartment && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('departments.departmentList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getDepartmentList.length > 0),expression:"getDepartmentList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('div',{attrs:{"id":"treeview"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.getDepartmentList.length == 0),expression:"getDepartmentList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('departments.departmentNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.department.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('departments.isContinueDepartmentUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDepartment()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.department.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('departments.isContinueDepartmentSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDepartment()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.department.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('departments.isContinueDepartmentDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteDepartment()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessGroups_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48308340_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessGroups_vue__ = __webpack_require__(425);
function injectStyle (ssrContext) {
  __webpack_require__(423)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AccessGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48308340_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AccessGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(424);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("ec990cc6", content, true, {});

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.accessGroups')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.accessGroups')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-setting"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length > 0),expression:"accessGroupList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead'),_vm._v(" "),_c('tbody',_vm._l((_vm.accessGroupList),function(accessG){return _c('tr',{key:accessG.id,staticClass:"rows"},[_c('td',[_vm._v(_vm._s(accessG.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.selectAccessGroup(accessG.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",on:{"click":function($event){return _vm.newAccessGroup()}}},[_vm._v(_vm._s(_vm.$ml.get('accessGroups.newAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","margin-right":"5px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.accessGroup.name),expression:"accessGroup.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.accessGroup.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.accessGroup, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.accessGroup.isNewReaderAdd}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('accessGroups.addNewDevicesAutomatically'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeTemplate($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedTemplate == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(accessGroup){return _c('option',{key:accessGroup.id,domProps:{"value":accessGroup.id,"selected":_vm.selectedTemplate == accessGroup.id}},[_vm._v(_vm._s(accessGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.applyTemplate()}}},[_c('i',{staticClass:"fa fa-copy"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('accessGroups.applyTemplate'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("\n                    "+_vm._s(_vm.$ml.get('accessGroups.authorizedDevices'))+"\n                    "),_c('span',{staticStyle:{"cursor":"pointer","color":"red"},domProps:{"textContent":_vm._s(!_vm.isCheck ? _vm.$ml.get('general.selectAll') : _vm.$ml.get('general.removeAll'))},on:{"click":function($event){return _vm.checkReaders()}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":reader.check},on:{"change":function($event){reader.check==true ? reader.check=false : reader.check=true}}}),_vm._v("\n                              "+_vm._s(reader.ipAddress)+" | "+_vm._s(reader.readerNo)+" - "+_vm._s(reader.name)+"\n                            ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('accessGroups.deviceNotRecord'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAccessGroup && _vm.authControl == 0),expression:"!isNewAccessGroup && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"data-toggle":"modal","data-target":"#modal-sil","type":"button"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAccessGroup && _vm.authControl == 0),expression:"isNewAccessGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"data-toggle":"modal","data-target":"#modal-kaydet","type":"button"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAccessGroup && _vm.authControl == 0),expression:"!isNewAccessGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"data-toggle":"modal","data-target":"#modal-guncelle","type":"button"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.accessGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.isContinueAccessGroupUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAccessGroup()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.accessGroup.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.isContinueAccessGroupSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAccessGroup()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.accessGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('accessGroups.isContinueAccessGroupDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteAccessGroup()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shifts_vue__ = __webpack_require__(172);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686b6bf7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shifts_vue__ = __webpack_require__(429);
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-686b6bf7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shifts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_686b6bf7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shifts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(428);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("6601526c", content, true, {});

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".step[data-v-686b6bf7]{width:70px;height:70px;line-height:70px;display:inline-block;border-radius:100px;z-index:2;left:0;text-align:center;font-size:25px;color:#fff;margin:0 10px;margin-bottom:30px}.step-primary[data-v-686b6bf7]{color:#3c8dbc;background-color:#fff;border-style:solid;border-color:#3c8dbc;line-height:65px}.step-danger[data-v-686b6bf7]{color:#d73925;background-color:#fff;border-style:solid;border-color:#d73925;line-height:65px}.step-warning[data-v-686b6bf7]{color:#f39c12;background-color:#fff;border-style:solid;border-color:#f39c12;line-height:65px}.step-success[data-v-686b6bf7]{color:#00a65a;background-color:#fff;border-style:solid;border-color:#00a65a;line-height:65px}", ""]);

// exports


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlans')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlans')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length > 0),expression:"workGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.workGroupList),function(workGroup2){return _c('tr',{key:workGroup2.id},[_c('td',[_vm._v(_vm._s(workGroup2.shortCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(workGroup2.name))]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(workGroup2.isPeriod),expression:"workGroup2.isPeriod"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.period')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!workGroup2.isPeriod),expression:"!workGroup2.isPeriod"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.singlePlan')))])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getWorkGroup(workGroup2.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroupList.length == 0),expression:"workGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary",attrs:{"id":"capavardiya"}},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanInfo')))])]),_vm._v(" "),_c('div',{staticClass:"pull-left"}),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",on:{"click":function($event){return _vm.newWorkGroup()}}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.newWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanModel')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeWorkGroupModel($event)}}},[_c('option',{domProps:{"selected":_vm.workGroup.model == 0 || _vm.workGroup.model == null,"value":0}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.workGroup.model == 1,"value":1}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.defaultWorkPlanModel')))]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.workGroup.model == 2,"value":2}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.workGroupModel')))]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.workGroup.model == 3,"value":3}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.hourBasedPlanningModel')))]),_vm._v(" "),_c('option',{domProps:{"selected":_vm.workGroup.model == 4,"value":4}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.freelanceModelWithHourlyInterval')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 1),expression:"workGroup.model == 1"}],staticClass:"info-box",staticStyle:{"background-color":"#3C8DBC","color":"#fff"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.defaultWorkPlanModel')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan1Title')))]),_vm._v(" "),_c('span',{staticClass:"progress-description",staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan1Description')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 2),expression:"workGroup.model == 2"}],staticClass:"info-box bg-red"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.workGroupModel')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan2Title')))]),_vm._v(" "),_c('span',{staticClass:"progress-description",staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan2Description')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 3),expression:"workGroup.model == 3"}],staticClass:"info-box bg-yellow"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.hourBasedPlanningModel')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan3Title')))]),_vm._v(" "),_c('span',{staticClass:"progress-description",staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan3Description')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 4),expression:"workGroup.model == 4"}],staticClass:"info-box bg-green"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"info-box-content"},[_c('span',{staticClass:"info-box-text"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.freelanceModelWithHourlyInterval')))]),_vm._v(" "),_c('span',{staticClass:"info-box-number",staticStyle:{"font-style":"italic"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan4Title')))]),_vm._v(" "),_c('span',{staticClass:"progress-description",staticStyle:{"padding-top":"5px"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan4Description')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model != 0),expression:"workGroup.model != 0"}],staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#tab_2","data-toggle":"tab","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.details')))])]),_vm._v(" "),_c('li',{},[_c('a',{attrs:{"href":"#tab_3","data-toggle":"tab","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.settings')))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model != 3 && _vm.workGroup.model != 4),expression:"workGroup.model != 3 && workGroup.model != 4"}]},[_c('a',{attrs:{"href":"#tab_4","data-toggle":"tab","aria-expanded":"false"}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.plan')))])]),_vm._v(" "),_c('li',{staticClass:"pull-right"})]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab_2"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model != 2),expression:"workGroup.model != 2"}],staticClass:"col-sm-12"},[_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.workGroup.firstEntryLastExit},on:{"change":function($event){_vm.workGroup.firstEntryLastExit==true ? _vm.workGroup.firstEntryLastExit=false : _vm.workGroup.firstEntryLastExit=true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('workPlans.calculateBasedOnFirstEntryAndLastExit'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.shortCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.shortCode),expression:"workGroup.shortCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.workGroup.shortCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "shortCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.name),expression:"workGroup.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.workGroup.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 1 || _vm.workGroup.model == 3),expression:"workGroup.model == 1 || workGroup.model == 3"}]},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.entryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.entryTime),expression:"workGroup.entryTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.entryTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "entryTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.exitTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.exitTime),expression:"workGroup.exitTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.exitTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "exitTime", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 1 || _vm.workGroup.model == 3),expression:"workGroup.model == 1 || workGroup.model == 3"}]},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('workPlans.tolerances')))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"5px"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.earlyEntryTolerance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.earlyEntryTime),expression:"workGroup.earlyEntryTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.earlyEntryTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "earlyEntryTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.earlyExitTolerance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.earlyExitTime),expression:"workGroup.earlyExitTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.earlyExitTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "earlyExitTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.lateEntryTolerance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.lateEntryTime),expression:"workGroup.lateEntryTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.lateEntryTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "lateEntryTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.lateExitTolerance')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.lateExitTime),expression:"workGroup.lateExitTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.lateExitTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "lateExitTime", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 1),expression:"workGroup.model == 1"}]},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('workPlans.mealBreakTime')))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"5px"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.mealStartTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.foodStartTime),expression:"workGroup.foodStartTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.foodStartTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "foodStartTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.mealEndTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.foodEndTime),expression:"workGroup.foodEndTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.foodEndTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "foodEndTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.totalMealTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.foodTotalTime),expression:"workGroup.foodTotalTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.foodTotalTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "foodTotalTime", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 4),expression:"workGroup.model == 4"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.totalWorkTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.totalWorkTime),expression:"workGroup.totalWorkTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.totalWorkTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "totalWorkTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 3 || _vm.workGroup.model == 4),expression:"workGroup.model == 3 || workGroup.model == 4"}]},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('workPlans.breakTolerances')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"alert alert-info alert-dismissible"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.createSettingsForDeservedBreaks'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedBreakHourlyWork),expression:"selectedBreakHourlyWork"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedBreakHourlyWork)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedBreakHourlyWork=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.forHourlyWork')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedBreak),expression:"selectedBreak"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedBreak)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedBreak=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.break')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-success  pull-right",staticStyle:{"width":"120px"},on:{"click":function($event){return _vm.addBreakTolerance()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.breakToleranceList.length > 0),expression:"breakToleranceList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.hourlyWork')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.breakTolerance')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.breakToleranceList),function(break2,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(break2.hourlyWorkTime,"ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(break2.breakTolerance,"ss:dd")))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteBreakTolerance(index, break2.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.breakToleranceList.length == 0),expression:"breakToleranceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.notRecord'))+"\n                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab_3"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 2),expression:"workGroup.model == 2"}]},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.durationOfAbsence')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.discontinuityDayTime),expression:"workGroup.discontinuityDayTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.discontinuityDayTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "discontinuityDayTime", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.skipTheDayTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.dayOffHour),expression:"workGroup.dayOffHour"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.dayOffHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "dayOffHour", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.solsticeTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.solsticeHour),expression:"workGroup.solsticeHour"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.solsticeHour)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "solsticeHour", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.maxLimit')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.maxLimit),expression:"workGroup.maxLimit"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.maxLimit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "maxLimit", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.minLimit')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.minLimit),expression:"workGroup.minLimit"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.minLimit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "minLimit", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.workGroup.acceptToEntryDay},on:{"change":function($event){_vm.workGroup.acceptToEntryDay==true ? _vm.workGroup.acceptToEntryDay=false : _vm.workGroup.acceptToEntryDay=true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('workPlans.basedOnEntryDay'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.workGroup.accessDoorControl},on:{"change":function($event){_vm.workGroup.accessDoorControl==true ? _vm.workGroup.accessDoorControl=false : _vm.workGroup.accessDoorControl=true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('workPlans.checkTheDoors'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.toleranceToReduceTheSameMovementsToOne')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.oneOfAllLog),expression:"workGroup.oneOfAllLog"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.workGroup.oneOfAllLog)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "oneOfAllLog", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.workGroup.deleteDifferentDoors},on:{"change":function($event){_vm.workGroup.deleteDifferentDoors==true ? _vm.workGroup.deleteDifferentDoors=false : _vm.workGroup.deleteDifferentDoors=true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('workPlans.includeDifferentDoorsInDeleting'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.workGroup.noDeleteOvertime},on:{"change":function($event){_vm.workGroup.noDeleteOvertime==true ? _vm.workGroup.noDeleteOvertime=false : _vm.workGroup.noDeleteOvertime=true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('workPlans.dontDeleteConfirmedOvertimes'))+"\n                        ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 2),expression:"workGroup.model == 2"}]},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"alert alert-info alert-dismissible"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"alert","aria-hidden":"true"}},[_vm._v("×")]),_vm._v(" "),_c('i',{staticClass:"icon fa fa-info"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.selectThePlansYouWantToIncludeInTheGroup'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeWorkGroups($event)}}},[_c('option',{domProps:{"selected":_vm.selectedWorkGroup == 0 || _vm.selectedWorkGroup == null,"value":null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.extraWorkGroupList),function(workGroup4){return _c('option',{key:workGroup4.id,domProps:{"value":workGroup4.id}},[_vm._v(_vm._s(workGroup4.shortCode)+" - "+_vm._s(workGroup4.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-success ",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.addExtraWork()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraWorkList.length > 0),expression:"extraWorkList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanName')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.extraWorkList),function(extraWork,index){return _c('tr',{key:index},[_c('td',[_c('span',{domProps:{"textContent":_vm._s(_vm.workGroupGetNameToId(extraWork.subShiftId))}})]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteExtraWork(index, extraWork.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraWorkList.length == 0),expression:"extraWorkList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.notRecord'))+"\n                        ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model == 1),expression:"workGroup.model == 1"}]},[_c('div',{staticClass:"col-sm-12"},[_c('h4',{},[_vm._v(_vm._s(_vm.$ml.get('workPlans.payrollDetails')))]),_vm._v(" "),_c('hr',{staticStyle:{"margin-top":"5px"}}),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayrollStartTime),expression:"selectedPayrollStartTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedPayrollStartTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedPayrollStartTime=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayrollEndTime),expression:"selectedPayrollEndTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedPayrollEndTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedPayrollEndTime=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.currentDefinitionBetweenSelectedHours'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePayrolls($event)}}},[_c('option',{domProps:{"selected":_vm.selectedPayrollId == null,"value":null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.payrollList),function(payroll){return _c('option',{key:payroll.id,domProps:{"value":payroll.id}},[_vm._v(_vm._s(payroll.shortCode)+" - "+_vm._s(payroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('span',{staticClass:"form-control checkbox",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selectedHakedis},on:{"change":function($event){_vm.selectedHakedis==true ? _vm.selectedHakedis=false : _vm.selectedHakedis=true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('workPlans.whenItDoesntComePerceiveItAsADeserved'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-success ",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.addExtraPayroll()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraPayrollList.length > 0),expression:"extraPayrollList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.start')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.end')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.payrollType')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.deserve')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.extraPayrollList),function(extraPayroll,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(extraPayroll.startDate,"ss:dd")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(extraPayroll.endDate,"ss:dd")))]),_vm._v(" "),_c('td',[_c('span',{domProps:{"textContent":_vm._s(_vm.payrollGetNameToId(extraPayroll.payrollId))}})]),_vm._v(" "),_c('td',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(extraPayroll.hakedis),expression:"extraPayroll.hakedis"}],staticClass:"fa fa-check"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!extraPayroll.hakedis),expression:"!extraPayroll.hakedis"}],staticClass:"fa fa-remove"})]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteExtraPayroll(index, extraPayroll.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.extraPayrollList.length == 0),expression:"extraPayrollList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.notRecord'))+"\n                      ")])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.model != 3 && _vm.workGroup.model != 4),expression:"workGroup.model != 3 && workGroup.model != 4"}],staticClass:"tab-pane",attrs:{"id":"tab_4"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.planType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePeriod($event)}}},[_c('option',{attrs:{"value":"false"},domProps:{"selected":_vm.workGroup.isPeriod == false}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.singlePlan')))]),_vm._v(" "),_c('option',{attrs:{"value":"true"},domProps:{"selected":_vm.workGroup.isPeriod == true}},[_vm._v(_vm._s(_vm.$ml.get('workPlans.period')))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workGroup.isPeriod == true),expression:"workGroup.isPeriod == true"}]},[_c('div',{staticClass:"col-sm-12"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('workPlans.periodDistribution')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('workPlans.periodStartDate')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workGroup.periodStartDate),expression:"workGroup.periodStartDate"}],staticClass:"form-control",attrs:{"type":"date"},domProps:{"value":(_vm.workGroup.periodStartDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workGroup, "periodStartDate", $event.target.value)}}})]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePeriodDetails($event)}}},[_c('option',{domProps:{"selected":_vm.selectedPeriodValue == null,"value":null}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.periodDetailList),function(periodDetail,index){return _c('option',{key:index,domProps:{"value":periodDetail.id + '-' +periodDetail.isAllowence}},[(periodDetail.isAllowence)?_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.allowence'))+" |")]):_vm._e(),_vm._v("\n                          "+_vm._s(periodDetail.name)+"\n                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedDay),expression:"selectedDay"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(_vm.selectedDay)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedDay=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.day')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-success ",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.addPeriod()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-top":"10px"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodList.length > 0),expression:"periodList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"250px","overflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.name')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('workPlans.dayCount')))]),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.periodList),function(period,index){return _c('tr',{key:index},[_c('td',[_c('span',{domProps:{"textContent":_vm._s(_vm.periodDetailGetNameToId(period.subShiftId, period.isAllowence))}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(period.day))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletePeriod(index, period.id)}}},[_c('i',{staticClass:"fa fa-remove"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodList.length == 0),expression:"periodList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlans.notRecord'))+"\n                      ")])])])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkGroup && _vm.authControl == 0),expression:"!isNewWorkGroup && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewWorkGroup && _vm.authControl == 0),expression:"isNewWorkGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkGroup && _vm.authControl == 0),expression:"!isNewWorkGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.workGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.isContinueWorkPlanUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWorkGroup()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.workGroup.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.isContinueWorkPlanSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWorkGroup()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.workGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlans.isContinueWorkPlanDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteWorkGroup()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info-box-icon"},[_c('a',{staticClass:"step step-primary"},[_c('i',{staticClass:"fa fa-check-circle"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info-box-icon"},[_c('a',{staticClass:"step step-danger"},[_c('i',{staticClass:"fa fa-check-circle"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info-box-icon"},[_c('a',{staticClass:"step step-warning"},[_c('i',{staticClass:"fa fa-check-circle"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"info-box-icon"},[_c('a',{staticClass:"step step-success"},[_c('i',{staticClass:"fa fa-check-circle"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12",attrs:{"align":"center"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":""}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OvertimeSettings_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4413d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OvertimeSettings_vue__ = __webpack_require__(431);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OvertimeSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a4413d8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OvertimeSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.overtimeDefinitions')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.overtimeDefinitions')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimePlaces')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning ",attrs:{"data-toggle":"modal","data-target":"#modal-yeni-yer"},on:{"click":function($event){return _vm.newOvertimePlace()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.addNew'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.overtimePlaceList.length > 0),expression:"overtimePlaceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.overtimePlaceList),function(place){return _c('tr',{key:place.id},[_c('td',[_c('span',[_vm._v(_vm._s(place.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-yer-guncelle"},on:{"click":function($event){return _vm.selectOvertimePlace(place)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-yer-sil"},on:{"click":function($event){return _vm.selectOvertimePlace(place)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.overtimePlaceList.length == 0),expression:"overtimePlaceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('overtimeDefinitions.overtimePlaceNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingPlace}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimeDescriptions')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-sm btn-warning ",attrs:{"data-toggle":"modal","data-target":"#modal-yeni-neden"},on:{"click":function($event){return _vm.newOvertimeDescription()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.addNew'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.overtimeDescriptionList.length > 0),expression:"overtimeDescriptionList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.overtimeDescriptionList),function(description){return _c('tr',{key:description.id},[_c('td',[_c('span',[_vm._v(_vm._s(description.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-neden-guncelle"},on:{"click":function($event){return _vm.selectOvertimeDescription(description)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-neden-sil"},on:{"click":function($event){return _vm.selectOvertimeDescription(description)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.overtimeDescriptionList.length == 0),expression:"overtimeDescriptionList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('overtimeDefinitions.overtimeDescriptionNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDescription}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-yeni-yer"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.newOvertimePlaceDefinition')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimePlaceName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overtimePlace.name),expression:"overtimePlace.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.overtimePlace.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.overtimePlace, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveOvertimePlace()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-yer-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimePlaceUpdate')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimePlaceName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overtimePlace.newName),expression:"overtimePlace.newName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.overtimePlace.newName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.overtimePlace, "newName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.updateOvertimePlace()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-yer-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.overtimePlace.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.isContinueOvertimePlaceDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteOvertimePlace()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-yeni-neden"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.newOvertimeDescriptionDefinition')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimeDescriptionName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overtimeDescription.name),expression:"overtimeDescription.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.overtimeDescription.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.overtimeDescription, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveOvertimeDescription()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-neden-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimeDescriptionUpdate')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.overtimeDescriptionName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.overtimeDescription.newName),expression:"overtimeDescription.newName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.overtimeDescription.newName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.overtimeDescription, "newName", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.updateOvertimeDescription()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-neden-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(_vm.overtimeDescription.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('overtimeDefinitions.isContinueOvertimeDescriptionDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteOvertimeDescription()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allowences_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04725c3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allowences_vue__ = __webpack_require__(435);
function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Allowences_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04725c3a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Allowences_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(434);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("255da327", content, true, {});

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.allowences')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.allowences')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.allowenceList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length > 0),expression:"allowenceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.allowenceList),function(allowence2){return _c('tr',{key:allowence2.id},[_c('td',[_c('span',[_vm._v(_vm._s(allowence2.name))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(allowence2.shortCode))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getAllowence(allowence2.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('allowences.allowenceNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.allowenceInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newAllowence()}}},[_vm._v(_vm._s(_vm.$ml.get('allowences.newAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.shortCode')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9",attrs:{"align":"center"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.shortCode),expression:"allowence.shortCode"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.allowence.shortCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "shortCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.allowenceName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.name),expression:"allowence.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.allowence.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.monthlyPayrollColumn')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMonthlyPayrollType($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.monthlyPayrollList),function(monthlyPayroll){return _c('option',{key:monthlyPayroll.id,domProps:{"value":monthlyPayroll.id,"selected":monthlyPayroll.id == _vm.allowence.monthlyPayrollId}},[_vm._v(_vm._s(monthlyPayroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.dailyPayrollColumn')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePayrollType($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.dailyPayrollList),function(payroll){return _c('option',{key:payroll.id,domProps:{"value":payroll.id,"selected":_vm.allowence.dailyPayrollId == payroll.id}},[_vm._v(_vm._s(payroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.fullWorkTimeInDay')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allowence.dayTime),expression:"allowence.dayTime"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.allowence.dayTime)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.allowence, "dayTime", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.color')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{staticClass:"form-control",attrs:{"type":"color"},domProps:{"value":this.allowence.colorCode},on:{"change":function($event){return _vm.changeColor($event)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAllowence && _vm.authControl == 0),expression:"!isNewAllowence && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAllowence && _vm.authControl == 0),expression:"isNewAllowence && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAllowence && _vm.authControl == 0),expression:"!isNewAllowence && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.allowence.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.isContinueAllowenceUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAllowence()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.allowence.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.isContinueAllowenceSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAllowence()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.allowence.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('allowences.isContinueAllowenceDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteAllowence()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnualPermits_vue__ = __webpack_require__(175);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b711664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnualPermits_vue__ = __webpack_require__(437);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnnualPermits_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b711664_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnnualPermits_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.annualPermitGroups')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.annualPermitGroups')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.annualPermitGroupList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitList.length > 0),expression:"annualPermitList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.annualPermitList),function(annualPermit){return _c('tr',{key:annualPermit.id},[_c('td',[_c('span',[_vm._v(_vm._s(annualPermit.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getAPDetail(annualPermit.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.annualPermitList.length == 0),expression:"annualPermitList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('annualPermitGroups.annualPermitGroupNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.annualPermitGroupInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newAnnualPermit()}}},[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.annualPermitGroupInfo')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.groupName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.annualPermit.name),expression:"annualPermit.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.annualPermit.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.annualPermit, "name", $event.target.value)}}})])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"form-group col-sm-3"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.start')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.start),expression:"start"}],staticClass:"form-control text-center",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.start)},on:{"input":function($event){if($event.target.composing){ return; }_vm.start=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.end')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.end),expression:"end"}],staticClass:"form-control text-center",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.end)},on:{"input":function($event){if($event.target.composing){ return; }_vm.end=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.deservedDay')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.claim),expression:"claim"}],staticClass:"form-control text-center",attrs:{"type":"number","min":"0"},domProps:{"value":(_vm.claim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.claim=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%","margin-top":"25px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.addAPDefinition()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                ")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.aPDefinitionList.length > 0),expression:"aPDefinitionList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"350px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover text-center"},[_c('thead',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.start')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.end')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.deservedDay')))]),_vm._v(" "),_c('th',{staticStyle:{"width":"20px"}})]),_vm._v(" "),_c('tbody',_vm._l((_vm.aPDefinitionList),function(aPDefinition,index){return _c('tr',{key:index},[_c('td',[_c('span',[_vm._v(_vm._s(aPDefinition.start))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(aPDefinition.end))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(aPDefinition.claim))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.deleteAPDefinition(index)}}},[_c('i',{staticClass:"fa fa-remove"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.aPDefinitionList.length == 0),expression:"aPDefinitionList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('annualPermitGroups.annualPermitGroupDetailNotRecord'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAnnualPermit && _vm.authControl == 0),expression:"!isNewAnnualPermit && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewAnnualPermit && _vm.authControl == 0),expression:"isNewAnnualPermit && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewAnnualPermit && _vm.authControl == 0),expression:"!isNewAnnualPermit && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.annualPermit.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.isContinueAnnualPermitGroupUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAnnualPermit()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.annualPermit.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.isContinueAnnualPermitGroupSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveAnnualPermit()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.annualPermit.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('annualPermitGroups.isContinueAnnualPermitGroupDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteAnnualPermit()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScenarioList_vue__ = __webpack_require__(176);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543d4cb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScenarioList_vue__ = __webpack_require__(439);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScenarioList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543d4cb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScenarioList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.scenarioList')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.scenarioList')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.scenarioList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-primary pull-right",on:{"click":function($event){return _vm.newScenario()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Yeni Senaryo Oluştur")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scenarioList.length > 0),expression:"scenarioList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.scenarioList),function(scenario){return _c('tr',{key:scenario.id},[_c('td',[_c('span',[_vm._v(_vm._s(scenario.name))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.type == 1),expression:"scenario.type == 1"}]},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Zaman Bazlı")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.type == 2),expression:"scenario.type == 2"}]},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Olay Bazlı")])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 1),expression:"scenario.day == 1"}]},[_vm._v(_vm._s(_vm.$ml.get("general.monday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 2),expression:"scenario.day == 2"}]},[_vm._v(_vm._s(_vm.$ml.get("general.tuesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 3),expression:"scenario.day == 3"}]},[_vm._v(_vm._s(_vm.$ml.get("general.wednesday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 4),expression:"scenario.day == 4"}]},[_vm._v(_vm._s(_vm.$ml.get("general.thursday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 5),expression:"scenario.day == 5"}]},[_vm._v(_vm._s(_vm.$ml.get("general.friday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 6),expression:"scenario.day == 6"}]},[_vm._v(_vm._s(_vm.$ml.get("general.saturday")))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.day == 7),expression:"scenario.day == 7"}]},[_vm._v(_vm._s(_vm.$ml.get("general.sunday")))])]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(_vm.toDateFormat(scenario.time, "ss:dd"))+"\n                    ")]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(scenario.command == 1),expression:"scenario.command == 1"}]},[_c('i',{staticClass:"fa fa-bell"}),_vm._v(" Alarm Tetikle")])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.goToDetails(scenario.id)}}},[_c('i',{staticClass:"fa fa-search"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-sm",on:{"click":function($event){return _vm.deleteScenario(scenario.id)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scenarioList.length == 0),expression:"scenarioList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get("alerts.recordNotFound"))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Senaryo Adı")]),_vm._v(" "),_c('th',[_vm._v("Senaryo Tipi")]),_vm._v(" "),_c('th',[_vm._v("Senaryo Gün")]),_vm._v(" "),_c('th',[_vm._v("Senaryo Zaman")]),_vm._v(" "),_c('th',[_vm._v("Komut")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScenarioDetails_vue__ = __webpack_require__(177);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24abce74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScenarioDetails_vue__ = __webpack_require__(441);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScenarioDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24abce74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScenarioDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',{domProps:{"textContent":_vm._s(_vm.scenario.id ? _vm.$ml.get('scenarios.scenarioDetails') : _vm.$ml.get('scenarios.newScenario'))}})]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-bookmark"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.scenarioList')))])]),_vm._v(" "),_c('li',[_c('span',{domProps:{"textContent":_vm._s(_vm.scenario.id ? _vm.$ml.get('scenarios.scenarioDetails') : _vm.$ml.get('scenarios.newScenario'))}})])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"}},[_c('button',{staticClass:"btn btn-primary pull-right",on:{"click":function($event){return _vm.backToScenarioList()}}},[_c('i',{staticClass:"fa fa-mail-reply"}),_vm._v("\n          "+_vm._s(_vm.$ml.get('scenarios.backToScenarios'))+"\n        ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('scenarios.scenarioDetails')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Senaryo Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scenario.name),expression:"scenario.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.scenario.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.scenario, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Senaryo Tipi")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.scenario.type == 1 ? 'btn btn-primary' : 'btn btn-default',attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" Zaman Bazlı\n                    ")]),_vm._v(" "),_c('button',{class:_vm.scenario.type == 2 ? 'btn btn-primary' : 'btn btn-default',attrs:{"disabled":"","type":"button"}},[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v(" Olay Bazlı\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.scenario.id),expression:"!scenario.id"}],staticClass:"form-group"},[_c('label',[_vm._v("Gün")]),_vm._v(" "),_c('br'),_vm._v(" "),_vm._l((_vm.dayList),function(day){return _c('div',{key:day.value,staticStyle:{"cursor":"pointer","margin-left":"20px"},on:{"click":function($event){day.check = !day.check}}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(day.check),expression:"day.check"}],staticClass:"fa fa-check-circle text-success",staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!day.check),expression:"!day.check"}],staticClass:"fa fa-times-circle text-danger",staticStyle:{"font-size":"18px"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(day.name))])])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scenario.id),expression:"scenario.id"}],staticClass:"form-group"},[_c('label',[_vm._v("Gün")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDay($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.scenario.day == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.dayList),function(day){return _c('option',{key:day.value,domProps:{"value":day.value,"selected":day.value == _vm.scenario.day}},[_vm._v(_vm._s(day.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Saat")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.scenario.time),expression:"scenario.time"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.scenario.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.scenario, "time", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İşlem Yapılacak Terminaller")]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDeviceList != ''),expression:"checkedDeviceList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDeviceList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDeviceList == ''),expression:"checkedDeviceList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDeviceList != ''),expression:"checkedDeviceList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearDevices()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Komut")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCommand($event)}}},[_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.scenario.command}},[_vm._v("Alarm Tetikle")])])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.saveScenario()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.save'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-device"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"500px","owerflow":"auto"}},[_vm._l((_vm.deviceList),function(device){return _c('span',{key:device.id,staticClass:"form-control",staticStyle:{"cursor":"pointer"},on:{"click":function($event){device.check==true ? device.check=false : device.check=true}}},[_c('span',{staticStyle:{"font-size":"15px"}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(device.check),expression:"device.check"}],staticClass:"fa fa-check-circle text-success"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(!device.check),expression:"!device.check"}],staticClass:"fa fa-times-circle text-danger"})]),_vm._v("\n              "+_vm._s(device.name)+" ("+_vm._s(device.ip)+")\n            ")])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList.length == 0),expression:"deviceList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('alerts.recordNotFound')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-select-device"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v("İşlem Yapılacak Terminal")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeZone_vue__ = __webpack_require__(178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249a60b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeZone_vue__ = __webpack_require__(443);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeZone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_249a60b3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeZone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.timeZones')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.timeZones')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.timeZoneList.length > 0),expression:"timeZoneList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.timeZoneList),function(timeZone){return _c('tr',{key:timeZone.id},[_c('td',[_c('span',[_vm._v(_vm._s(timeZone.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getTZDetail(timeZone.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.timeZoneList.length == 0),expression:"timeZoneList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" Geçiş parametreleri bulunamadı.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Parametre Kodu")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeZone.code),expression:"timeZone.code"}],staticClass:"form-control text-center",attrs:{"type":"number","max":"50"},domProps:{"value":(_vm.timeZone.code)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.timeZone, "code", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Parametre Adı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timeZone.name),expression:"timeZone.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.timeZone.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.timeZone, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.monday'))+" :")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.tuesday'))+" :")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.wednesday'))+" :")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.thursday'))+" :")]),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.friday'))+" :")]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.saturday'))+" :")]),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"},attrs:{"align":"center"}},[_c('div',{staticClass:"col-sm-3"},[_vm._v(_vm._s(_vm.$ml.get('general.sunday'))+" :")]),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15)])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTimeZone),expression:"!isNewTimeZone"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get("general.delete")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewTimeZone),expression:"isNewTimeZone"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get("general.save")))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewTimeZone),expression:"!isNewTimeZone"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get("general.update")))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Geçiş Parametreleri Listesi")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Geçiş Parametre Detayı")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3"},[_c('input',{staticClass:"form-control",attrs:{"type":"time"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__ = __webpack_require__(179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0fa9ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Devices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0fa9ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Devices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("2178ffc0", content, true, {});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.devices')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.devices')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.deviceList'))+" : "+_vm._s(_vm.deviceList.length))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newDevice()}}},[_vm._v(_vm._s(_vm.$ml.get('devices.newDevice')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList.length > 0),expression:"deviceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table"},[_c('thead',[_c('tr',[_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderDev(1)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('devices.ipAddress'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderDevice == 1),expression:"orderDevice == 1"}],staticClass:"fa fa-sort-numeric-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderDevice == 2),expression:"orderDevice == 2"}],staticClass:"fa fa-sort-numeric-desc"})])]),_vm._v(" "),_c('th',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.setOrderDev(2)}}},[_c('strong',[_vm._v("\n                        "+_vm._s(_vm.$ml.get('devices.deviceName'))+"\n                        "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderDevice == 3),expression:"orderDevice == 3"}],staticClass:"fa fa-sort-alpha-asc"}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderDevice == 4),expression:"orderDevice == 4"}],staticClass:"fa fa-sort-alpha-desc"})])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.deviceList),function(device1){return _c('tr',{key:device1.id,class:device1.id == _vm.device.id ? 'bg-primary' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getDevice(device1.id)}}},[_c('td',[_vm._v(_vm._s(device1.ip))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(device1.name))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceList.length == 0),expression:"deviceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('devices.deviceNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary",attrs:{"id":"deviceInfo"}},[_c('div',{staticClass:"box-header with-border",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.onCloseBoxDevice()}}},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.deviceInfo')))])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.deviceNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.deviceNo),expression:"device.deviceNo"}],staticClass:"form-control",attrs:{"type":"number","autocomplete":"off"},domProps:{"value":(_vm.device.deviceNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "deviceNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-9"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.deviceName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.name),expression:"device.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.device.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.brand')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDeviceBrand($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.device.brand == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.deviceBrandList),function(brand,index){return _c('option',{key:index,domProps:{"selected":_vm.device.brand == brand.brand,"value":brand.brand}},[_vm._v(_vm._s(brand.brand))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.serialNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.seriNo),expression:"device.seriNo"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.device.seriNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "seriNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.devicePlatformList.length > 0),expression:"devicePlatformList.length > 0"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.platform')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDevicePlatform($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.device.platform == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.devicePlatformList),function(platform,index){return _c('option',{key:index,domProps:{"selected":_vm.device.platform == platform,"value":platform}},[_vm._v(_vm._s(platform))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.ipAddress')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.ipAddress),expression:"device.ipAddress"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.device.ipAddress)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "ipAddress", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.port')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.port),expression:"device.port"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.device.port)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "port", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.device.brand == 'Hikvision'),expression:"device.brand == 'Hikvision'"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.adminPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.device.password),expression:"device.password"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.device.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.device, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.status')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isActive},on:{"change":function($event){_vm.device.isActive == true ? _vm.device.isActive = false : _vm.device.isActive = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.active'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6",staticStyle:{"margin-bottom":"20px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.feature')))]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isPanel},on:{"change":function($event){_vm.device.isPanel == true ? _vm.device.isPanel = false : _vm.device.isPanel = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.isPanel'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isCardDevice},on:{"change":function($event){_vm.device.isCardDevice == true ? _vm.device.isCardDevice = false : _vm.device.isCardDevice = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.card'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isFingerDevice},on:{"change":function($event){_vm.device.isFingerDevice == true ? _vm.device.isFingerDevice = false : _vm.device.isFingerDevice = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.fingerprint'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isFaceDevice},on:{"change":function($event){_vm.device.isFaceDevice == true ? _vm.device.isFaceDevice = false : _vm.device.isFaceDevice = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.faceRecognition'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isRealTime},on:{"change":function($event){_vm.device.isRealTime == true ? _vm.device.isRealTime = false : _vm.device.isRealTime = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.isRealTime'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.isOnlineDevice},on:{"change":function($event){_vm.device.isOnlineDevice == true ? _vm.device.isOnlineDevice = false : _vm.device.isOnlineDevice = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.isOnlineDevice'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.hasAntipassback},on:{"change":function($event){_vm.device.hasAntipassback == true ? _vm.device.hasAntipassback = false : _vm.device.hasAntipassback = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.hasAntipassback'))+"\n                  ")])]),_vm._v(" "),_c('span',{staticClass:"checkbox",staticStyle:{"margin-bottom":"5px","padding-left":"40px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.device.hasTimeZone},on:{"change":function($event){_vm.device.hasTimeZone == true ? _vm.device.hasTimeZone = false : _vm.device.hasTimeZone = true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('devices.hasTimeZone'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDevice && _vm.authControl == 0),expression:"!isNewDevice && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewDevice && _vm.authControl == 0),expression:"isNewDevice && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDevice && _vm.authControl == 0),expression:"!isNewDevice && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDevice),expression:"!isNewDevice"}],staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.readerList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceReaderList.length > 0),expression:"deviceReaderList.length > 0"}],staticClass:"table-responsive no-padding"},[_c('table',{staticClass:"table",staticStyle:{"max-height":"200px","owerflow":"auto"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.deviceReaderList),function(deviceReader){return _c('tr',{key:deviceReader.id,class:_vm.selectedReader.id == deviceReader.id ? 'bg-primary' : '',staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.getDeviceReader(deviceReader.id)}}},[_c('td',{staticStyle:{"width":"40px"}},[_vm._v(_vm._s(deviceReader.readerNo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(deviceReader.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(deviceReader.inputName))])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.deviceReaderList.length == 0),expression:"deviceReaderList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('devices.selectedDeviceReaderNotFound'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewDevice),expression:"!isNewDevice"}],staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.readerInformation')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newReader()}}},[_vm._v(_vm._s(_vm.$ml.get('devices.newReader')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.readerNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReader.readerNo),expression:"selectedReader.readerNo"}],staticClass:"form-control",attrs:{"type":"number","autocomplete":"off"},domProps:{"value":(_vm.selectedReader.readerNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedReader, "readerNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.readerStatus')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeReaderStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedReader.statu == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected'))+"\n                      ")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedReader.statu == 1}},[_vm._v(_vm._s(_vm.$ml.get('devices.entry')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.selectedReader.statu == 2}},[_vm._v(_vm._s(_vm.$ml.get('devices.exit')))])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.readerName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReader.name),expression:"selectedReader.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedReader.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedReader, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.inputName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReader.inputName),expression:"selectedReader.inputName"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedReader.inputName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedReader, "inputName", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.isMainDoor')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selectedReader.isMainDoor},on:{"change":function($event){_vm.selectedReader.isMainDoor == true ? _vm.selectedReader.isMainDoor = false : _vm.selectedReader.isMainDoor = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('devices.isMainDoor'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('devices.typeOfUse')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeReaderType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedReader.type == 0}},[_vm._v(_vm._s(_vm.$ml.get('devices.access')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedReader.type == 1}},[_vm._v(_vm._s(_vm.$ml.get('devices.pdks')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],attrs:{"value":"2"},domProps:{"selected":_vm.selectedReader.type == 2}},[_vm._v("\n                        "+_vm._s(_vm.$ml.get('devices.diningHall')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],attrs:{"value":"3"},domProps:{"selected":_vm.selectedReader.type == 3}},[_vm._v("\n                        "+_vm._s(_vm.$ml.get('devices.licencePlateRecognition')))]),_vm._v(" "),_c('option',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.dormitory),expression:"modules.dormitory"}],attrs:{"value":"5"},domProps:{"selected":_vm.selectedReader.type == 5}},[_vm._v("\n                        "+_vm._s(_vm.$ml.get('devices.dormitoryDevice')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("X Koordinatı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReader.positionX),expression:"selectedReader.positionX"}],staticClass:"form-control",attrs:{"type":"number","autocomplete":"off"},domProps:{"value":(_vm.selectedReader.positionX)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedReader, "positionX", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Y Koordinatı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedReader.positionY),expression:"selectedReader.positionY"}],staticClass:"form-control",attrs:{"type":"number","autocomplete":"off"},domProps:{"value":(_vm.selectedReader.positionY)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedReader, "positionY", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingReader}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-left"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedReader.id),expression:"selectedReader.id"}],staticClass:"btn btn-sm btn-primary",staticStyle:{"margin":"0px"},attrs:{"data-target":"#qr-code","data-toggle":"modal"}},[_c('i',{staticClass:"fa fa-qrcode"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.viewQRCode'))+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewReader && _vm.authControl == 0),expression:"!isNewReader && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-reader-sil"}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('general.delete'))+"\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewReader && _vm.authControl == 0),expression:"isNewReader && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-reader-kaydet"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('general.save'))+"\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewReader && _vm.authControl == 0),expression:"!isNewReader && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-reader-guncelle"}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('general.update'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewDevice),expression:"isNewDevice"}],staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('devices.readerInfo'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.device.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueDeviceUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDevice()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.device.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueDeviceSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveDevice()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.device.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueDeviceDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteDevice()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-reader-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedReader.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueReaderUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveReader()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-reader-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(6),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.selectedReader.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueReaderSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveReader()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-reader-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedReader.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('devices.isContinueReaderDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteReader()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"maxTerminalLicence"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceErrorTitle')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceAddTerminalMaxCount') + " : " + _vm.modules.maxTerminalCount))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceTerminalDescription')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.done')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"qr-code","role":"dialog"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_c('i',{staticClass:"fa fa-qrcode"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.qRCodeBarcodePrint'))+"\n            ")]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8",attrs:{"id":"print"}},[_c('div',{style:(_vm.qrTextStyle)},[_c('qrcode-vue',{attrs:{"renderAs":"svg","value":_vm.qrValue,"size":_vm.qrSize,"level":"H"}}),_vm._v(" "),_c('div',[_c('h2',{staticStyle:{"margin-bottom":"5px"}},[_c('strong',[_vm._v(_vm._s(_vm.selectedReader.name))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.device.name))])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('general.qrSettings')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.qrSize')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.qrSize),expression:"qrSize"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.qrSize)},on:{"input":function($event){if($event.target.composing){ return; }_vm.qrSize=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"btn-group"},[_c('button',{class:_vm.qrTextStyle == 'text-align:left;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:left;'}}},[_c('i',{staticClass:"fa fa-align-left"})]),_vm._v(" "),_c('button',{class:_vm.qrTextStyle == 'text-align:center;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:center;'}}},[_c('i',{staticClass:"fa fa-align-center"})]),_vm._v(" "),_c('button',{class:_vm.qrTextStyle == 'text-align:right;' ? 'btn btn-primary ' : 'btn btn-default ',attrs:{"type":"button"},on:{"click":function($event){_vm.qrTextStyle = 'text-align:right;'}}},[_c('i',{staticClass:"fa fa-align-right"})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-secondary",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.print()}}},[_c('i',{staticClass:"fa fa-print"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.print'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-box-tool",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("No")]),_vm._v(" "),_c('th',[_vm._v("Okuyucu")]),_vm._v(" "),_c('th',[_vm._v("Kapı")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceOperations_vue__ = __webpack_require__(180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e48b68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceOperations_vue__ = __webpack_require__(449);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeviceOperations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19e48b68_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeviceOperations_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.deviceOperations')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.deviceOperations')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.addTask')))]),_vm._v(" "),_c('a',{staticStyle:{"text-align":"right"},on:{"click":function($event){return _vm.checkReaders()}}},[_c('span',{staticStyle:{"font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheck == true ? this.$ml.get('general.removeAll') : this.$ml.get('general.selectAll'))}})])]),_vm._v(" "),_c('div',{staticClass:"pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px","margin-right":"5px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length > 0),expression:"readerList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowReaderHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.readerList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":reader.check},on:{"change":function($event){reader.check==true ? reader.check=false : reader.check=true}}}),_vm._v("\n                            "+_vm._s(reader.ipAddress)+" | "+_vm._s(reader.readerNo)+" - "+_vm._s(reader.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readerList.length == 0),expression:"readerList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('deviceOperations.deviceNotRecord'))+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.startTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.work.date),expression:"work.date"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.work.date)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.work, "date", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.selectTask')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCommand($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.work.command == 0}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.getMovementLogs')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.work.command == 1}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.personSetAndDelete')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.work.command == 3}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPersonData')))]),_vm._v(" "),_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.work.command == 4}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.updateTime')))]),_vm._v(" "),_c('option',{attrs:{"value":"7"},domProps:{"selected":_vm.work.command == 7}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.removeAllPerson')))]),_vm._v(" "),_c('option',{attrs:{"value":"8"},domProps:{"selected":_vm.work.command == 8}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendAuthorityGroups')))]),_vm._v(" "),_c('option',{attrs:{"value":"9"},domProps:{"selected":_vm.work.command == 9}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPlates')))]),_vm._v(" "),_c('option',{attrs:{"value":"10"},domProps:{"selected":_vm.work.command == 10}},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendPlate')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.repeatDaily')))]),_vm._v(" "),_c('div',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox","name":"isRepeated"},domProps:{"checked":_vm.work.isRepeated},on:{"click":function($event){_vm.work.isRepeated = !_vm.work.isRepeated}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('deviceOperations.applyRepeatDaily'))+"\n                    ")])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.work.isRepeated),expression:"work.isRepeated"}],staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.repetitionInterval')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.work.day),expression:"work.day"}],staticClass:"form-control text-center",attrs:{"type":"number","min":"0","max":"350"},domProps:{"value":(_vm.work.day)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.work, "day", $event.target.value)}}}),_vm._v(" "),_c('label',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.oneTimePerDay')))])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-primary ",staticStyle:{"display":"inline-block","width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.saveWork()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendCommand')))]),_vm._v(" "),_c('i',{staticClass:"fa fa-arrow-circle-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-random"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.activeTaskList'))+" : "+_vm._s(_vm.workList.length))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm ",on:{"click":function($event){return _vm.getWorkList()}}},[_vm._v(_vm._s(_vm.$ml.get('general.refreshScreen')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workList.length > 0),expression:"workList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v("#")]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.person')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.task')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.device')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.taskTime')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.repeatDay')))]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.workList),function(worke,index){return _c('tr',{key:worke.terminalWorkId,staticClass:"rows"},[_c('td',[_c('strong',[_vm._v(_vm._s(index + 1))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(worke.employeeName))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 0),expression:"worke.command == 0"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.getMovementLogs')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 1),expression:"worke.command == 1"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.personSetAndDelete')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 2),expression:"worke.command == 2"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.getPersons')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 3),expression:"worke.command == 3"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPersonData')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 4),expression:"worke.command == 4"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.updateTime')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 5),expression:"worke.command == 5"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.restart')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 6),expression:"worke.command == 6"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.removeAdminAuthorizes')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 7),expression:"worke.command == 7"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.removeAllPerson')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 8),expression:"worke.command == 8"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendAuthorityGroups')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 9),expression:"worke.command == 9"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPlates')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.command == 10),expression:"worke.command == 10"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendPlate')))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm.getReader(worke.readerId)))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(worke.date)))])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!worke.isRepeated),expression:"!worke.isRepeated"}]},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.noRepeat')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(worke.isRepeated),expression:"worke.isRepeated"}]},[_vm._v(_vm._s(worke.day))])]),_vm._v(" "),_c('td',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"data-toggle":"modal","data-target":"#modal-sil"},on:{"click":function($event){return _vm.selectWork(worke.terminalWorkId)}}},[_c('i',{staticClass:"fa fa-trash"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workList.length == 0),expression:"workList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('deviceOperations.activeTaskNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_vm._v("\n                "+_vm._s(_vm._f("toDateFormatGet")(_vm.selectedWork.date))+"\n                "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 0),expression:"selectedWork.command == 0"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.getMovementLogs')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 1),expression:"selectedWork.command == 1"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.personSetAndDelete')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 2),expression:"selectedWork.command == 2"}],staticClass:"label label-warning"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.getPersons')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 3),expression:"selectedWork.command == 3"}],staticClass:"label label-success"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPersonData')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 4),expression:"selectedWork.command == 4"}],staticClass:"label label-primary"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.updateTime')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 5),expression:"selectedWork.command == 5"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.restart')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 6),expression:"selectedWork.command == 6"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.removeAdminAuthorizes')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 7),expression:"selectedWork.command == 7"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.removeAllPerson')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 8),expression:"selectedWork.command == 8"}],staticClass:"label label-danger"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendAuthorityGroups')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 9),expression:"selectedWork.command == 9"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendBatchPlates')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedWork.command == 10),expression:"selectedWork.command == 10"}],staticClass:"label label-info"},[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.sendPlate')))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('deviceOperations.isContinueTaskDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteWork(_vm.selectedWork.terminalWorkId)}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workPlaceDefinitions_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3f74794_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workPlaceDefinitions_vue__ = __webpack_require__(453);
function injectStyle (ssrContext) {
  __webpack_require__(451)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_workPlaceDefinitions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3f74794_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_workPlaceDefinitions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(452);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("9f6cd4da", content, true, {});

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlaceDefinitions')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-book"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.workPlaceDefinitions')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.workPlaceList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workPlaceList.length > 0),expression:"workPlaceList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.workPlaceList),function(workPlace){return _c('tr',{key:workPlace.id},[_c('td',[_c('span',[_vm._v(_vm._s(workPlace.name))])]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getWorkPlace(workPlace.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),_vm._v(" "),_c('tr')],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.workPlaceList.length == 0),expression:"workPlaceList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('workPlaceDefinitions.workPlaceNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.workPlaceInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newWorkPlace()}}},[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.newWorkPlace')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-3"},[_c('h5',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.workPlaceName')))]),_vm._v(" :\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.workPlace.name),expression:"workPlace.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.workPlace.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.workPlace, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkPlace && _vm.authControl == 0),expression:"!isNewWorkPlace && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewWorkPlace && _vm.authControl == 0),expression:"isNewWorkPlace && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewWorkPlace && _vm.authControl == 0),expression:"!isNewWorkPlace && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.workPlace.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.isContinueWorkPlaceUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWorkPlace()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.workPlace.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.isContinueWorkPlaceSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveWorkPlace()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.workPlace.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('workPlaceDefinitions.isContinueWorkPlaceDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteWorkPlace()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanySettings_vue__ = __webpack_require__(182);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626e7b5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanySettings_vue__ = __webpack_require__(455);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CompanySettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_626e7b5e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CompanySettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.companySettings')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.companySettings')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.companies')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newCompany()}}},[_vm._v(_vm._s(_vm.$ml.get('companySettings.newCompany')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length > 0),expression:"companyList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.companyList),function(company2){return _c('tr',{key:company2.id},[_c('td',[_vm._v(_vm._s(company2.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getCompany(company2.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length == 0),expression:"companyList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('companySettings.companyNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.companyLogo')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body box-profile",attrs:{"align":"center"}},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.company.logo == null && this.tempUrl == null) || (this.company.logo == '' && this.tempUrl == null) ? '/src/assets/default-company.png' : this.company.logo || this.tempUrl}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.company.logo),expression:"this.tempUrl || this.company.logo"}],staticClass:"text-red",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.remove'))+"\n                ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":300,"height":300,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v(" "+_vm._s(_vm.$ml.get('companySettings.selectPhoto'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('companySettings.visitorSettings')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.cardIsNotUsedAccessGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeZTKartBosYetki($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.ztkartBosYetki == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(aG){return _c('option',{key:aG.id,domProps:{"value":aG.id,"selected":_vm.ztkartBosYetki == aG.id}},[_vm._v(_vm._s(aG.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.cardIsUsedAccessGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeZTKartYetki($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.ztkartYetki == 0}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.accessGroupList),function(aG){return _c('option',{key:aG.id,domProps:{"value":aG.id,"selected":_vm.ztkartYetki == aG.id}},[_vm._v(_vm._s(aG.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-success btn-sm ",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.setSetting()}}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingSetting}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"nav-tabs-custom"},[_c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"active"},[_c('a',{attrs:{"href":"#sirket-bilgileri","data-toggle":"tab","aria-expanded":"true"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.companyInformation')))])])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"sirket-bilgileri"}},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.companyName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.name),expression:"company.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.company.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.companyTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.title),expression:"company.title"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.company.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.phone')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.phoneNumber),expression:"company.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.company.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.webSite')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.website),expression:"company.website"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.company.website)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "website", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.address')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.company.address),expression:"company.address"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.company.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.company, "address", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('companySettings.syncRegistrationNoToDeviceNo')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.company.setSicilNoToTerminalNo},on:{"change":function($event){_vm.company.setSicilNoToTerminalNo == true ? _vm.company.setSicilNoToTerminalNo = false : _vm.company.setSicilNoToTerminalNo = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('companySettings.syncRegistrationNoToDeviceNo'))+"\n                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"zorunlu-alanlar"}},_vm._l((_vm.fields),function(field){return _c('span',{key:field.name,staticClass:"form-control checkbox",attrs:{"title":field.disabled ? 'Değiştirilemez' : ''}},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox","disabled":field.disabled},domProps:{"checked":field.isChecked},on:{"change":function($event){field.isChecked = !field.isChecked}}}),_vm._v("\n                      "+_vm._s(field.label)+" ("+_vm._s(field.name)+")\n                    ")])])}),0),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewCompany && _vm.authControl == 0),expression:"!isNewCompany && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewCompany && _vm.authControl == 0),expression:"isNewCompany && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewCompany && _vm.authControl == 0),expression:"!isNewCompany && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.company.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.isContinueCompanyUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveCompany()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.company.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.isContinueCompanySave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveCompany()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.company.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('companySettings.isContinueCompanyDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteCompany()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('a',{attrs:{"href":"#zorunlu-alanlar","data-toggle":"tab","aria-expanded":"true"}},[_vm._v("Zorunlu Alanlar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftSettings_vue__ = __webpack_require__(183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d55ed4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftSettings_vue__ = __webpack_require__(457);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShiftSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48d55ed4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShiftSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftSettings')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftSettings')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Çalışma Tipi")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeShiftMode($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.webshiftSettings.shiftMode == 0}},[_vm._v("Seçiniz")]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.webshiftSettings.shiftMode == 1}},[_vm._v("Haftalık")]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.webshiftSettings.shiftMode == 2}},[_vm._v("Aylık")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Onay başlangıç günü (Plan kilitleme günü)")]),_vm._v(" "),_c('select',{staticClass:"form-control"},_vm._l((_vm.dayList),function(day){return _c('option',{key:day.value,domProps:{"value":day.value,"selected":day.value == _vm.webshiftSettings.shiftConfirmStartDay}},[_vm._v(_vm._s(day.name))])}),0)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Aynı haftaya girilebilir maksimum izin sayısı")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.webshiftSettings.allowenceLimitPerWeek),expression:"webshiftSettings.allowenceLimitPerWeek"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.webshiftSettings.allowenceLimitPerWeek)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.webshiftSettings, "allowenceLimitPerWeek", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Geriye dönük planlama sınırı (Maksimum gün)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.webshiftSettings.changeShiftDayLimit),expression:"webshiftSettings.changeShiftDayLimit"}],staticClass:"form-control",attrs:{"type":"number"},domProps:{"value":(_vm.webshiftSettings.changeShiftDayLimit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.webshiftSettings, "changeShiftDayLimit", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Planlama Onay Durumu")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.webshiftSettings.isConfirmActive},on:{"change":function($event){_vm.webshiftSettings.isConfirmActive==true ? _vm.webshiftSettings.isConfirmActive=false : _vm.webshiftSettings.isConfirmActive=true}}}),_vm._v("\n                      Onay gerekli\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Onaylanmamış Plan Uyarısı")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.webshiftSettings.mailToFirstAuthorizedPerson},on:{"change":function($event){_vm.webshiftSettings.mailToFirstAuthorizedPerson==true ? _vm.webshiftSettings.mailToFirstAuthorizedPerson=false : _vm.webshiftSettings.mailToFirstAuthorizedPerson=true}}}),_vm._v("\n                      Onaylanmamış plan olduğunda uyarı e-postası gönderilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Onaylanmamış Plan Uyarı Tekrarı")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.webshiftSettings.mailToSecondAuthorizedPerson},on:{"change":function($event){_vm.webshiftSettings.mailToSecondAuthorizedPerson==true ? _vm.webshiftSettings.mailToSecondAuthorizedPerson=false : _vm.webshiftSettings.mailToSecondAuthorizedPerson=true}}}),_vm._v("\n                      Onaylanmamış plan tekrarı olduğunda uyarı e-postası gönderilsin\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button"},on:{"click":function($event){return _vm.setSetting()}}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Vardiya (Shift) Plan Ayarları")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__(184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099bcfe7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__(459);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_099bcfe7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.users')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.users')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.users')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newUser()}}},[_vm._v(_vm._s(_vm.$ml.get('users.newUser')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userList.length > 0),expression:"userList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.userList),function(user){return _c('tr',{key:user.id},[_c('td',[_vm._v("\n                      "+_vm._s(user.name)+"\n                      "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(user.title != ''),expression:"user.title != ''"}]},[_vm._v("("+_vm._s(user.title)+")")])]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getUser(user.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userList.length == 0),expression:"userList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('users.userNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.userPhoto')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body box-profile",attrs:{"align":"center"}},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.user.photo == null && this.tempUrl == null) || (this.user.photo == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.user.photo || this.tempUrl}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.user.photo),expression:"this.tempUrl || this.user.photo"}],staticClass:"text-red",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('general.remove'))+"\n                ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":200,"height":200,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('users.selectPhoto'))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('button',{class:_vm.filters.nameOrCardNumber != '' ? 'btn btn-success' : 'btn btn-warning',staticStyle:{"width":"100%","margin-bottom":"10px"},attrs:{"data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Varsayılan Filtre Grubu\n            ")]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('users.companyAuthorities')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length > 0),expression:"companyList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"200px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.companyList),function(company){return _c('tr',{key:company.id},[_c('td',[_c('div',{staticClass:"checkbox",staticStyle:{"margin-left":"20px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":company.check},on:{"change":function($event){company.check == true ? company.check = false : company.check = true}}}),_vm._v("\n                              "+_vm._s(company.name)+"\n                            ")])])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length == 0),expression:"companyList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('users.companyNotRecord'))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingCompanies}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.userInformation')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.userName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.userTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.title),expression:"user.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.mail),expression:"user.mail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "mail", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.authorityGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeUserAuthGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.userAuhtGroupList),function(userAuthGroup){return _c('option',{key:userAuthGroup.id,domProps:{"value":userAuthGroup.id,"selected":userAuthGroup.id == _vm.user.authId}},[_vm._v(_vm._s(userAuthGroup.name)+"\n                        ")])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.repeatPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password2),expression:"user.password2"}],staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.user.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password2", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.phoneNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.smsOrMail),expression:"modules.smsOrMail"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.activateSmsSystem')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.user.isSmsSend},on:{"change":function($event){_vm.user.isSmsSend == true ? _vm.user.isSmsSend = false : _vm.user.isSmsSend = true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('users.activateSmsSystem'))+"\n                        ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMonitorGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.monitorGroupList),function(monitorGroup){return _c('option',{key:monitorGroup.id,domProps:{"value":monitorGroup.id,"selected":monitorGroup.id == _vm.user.monitorGroupId}},[_vm._v("\n                            "+_vm._s(monitorGroup.name))])})],2),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.visitorCardGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeVisitorGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.visitorGroupList),function(visitorGroup){return _c('option',{key:visitorGroup.id,domProps:{"value":visitorGroup.id,"selected":visitorGroup.id == _vm.user.visitorCardGroup}},[_vm._v("\n                          "+_vm._s(visitorGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group",staticStyle:{"margin-bottom":"5px"}},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.isActive')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.user.isActive},on:{"change":function($event){_vm.user.isActive == true ? _vm.user.isActive = false : _vm.user.isActive = true}}}),_vm._v("\n                          "+_vm._s(_vm.$ml.get('general.active'))+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('h4',[_vm._v("\n                      "+_vm._s(_vm.$ml.get('users.reportAuthorities'))+"\n                      "),_c('a',{staticStyle:{"text-align":"right"},on:{"click":function($event){_vm.isCheckReports == true ? _vm.getCheckReportAll(false) : _vm.getCheckReportAll(true)}}},[_c('span',{staticStyle:{"font-size":"15px"},domProps:{"textContent":_vm._s(_vm.isCheckReports == true ? this.$ml.get('general.removeAll') : this.$ml.get('general.selectAll'))}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportList.length > 0),expression:"reportList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowReportHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.reportList),function(report){return _c('tr',{key:report.id},[_c('td',[_c('div',{staticClass:"checkbox",staticStyle:{"margin-left":"20px"}},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":report.isActive},on:{"change":function($event){report.isActive == true ? report.isActive = false : report.isActive = true}}}),_vm._v("\n                                  "+_vm._s(report.name)+"\n                                ")])])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.reportList.length == 0),expression:"reportList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('users.reportNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewUser && _vm.authControl == 0),expression:"!isNewUser && authControl == 0"}],staticClass:"btn btn-sm btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewUser && _vm.authControl == 0),expression:"isNewUser && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewUser && _vm.authControl == 0),expression:"!isNewUser && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.user.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUser()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.user.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUser()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.user.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.deleteUser()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-real-time-group"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroups')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroupList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning",on:{"click":function($event){return _vm.newRealTimeMonitor()}}},[_vm._v(_vm._s(_vm.$ml.get('users.newRealTimeMonitorGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monitorGroupList.length > 0),expression:"monitorGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.monitorGroupList),function(monitorGroup){return _c('tr',{key:monitorGroup.id},[_c('td',[_vm._v(_vm._s(monitorGroup.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectRealTimeMonitor(monitorGroup.id, monitorGroup.name, monitorGroup.devices)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monitorGroupList.length == 0),expression:"monitorGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('users.realTimeMonitorGroupNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.groupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRealTimeMonitorName),expression:"selectedRealTimeMonitorName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedRealTimeMonitorName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedRealTimeMonitorName=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeReaderList.length > 0),expression:"activeReaderList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover",staticStyle:{"background-color":"white"}},[_c('tbody',_vm._l((_vm.activeReaderList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px","color":"black"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":reader.check},on:{"change":function($event){reader.check == true ? reader.check = false : reader.check = true}}}),_vm._v("\n                            "+_vm._s(reader.ipAddress)+" | "+_vm._s(reader.readerNo)+" - "+_vm._s(reader.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeReaderList.length == 0),expression:"activeReaderList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('users.deviceNotRecord'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRealTimeMonitor),expression:"!isNewRealTimeMonitor"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteRealTimeMonitor()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveRealTimeMonitor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRealTimeMonitor),expression:"isNewRealTimeMonitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRealTimeMonitor),expression:"!isNewRealTimeMonitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(7),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(8),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(9),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(10),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(11),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive == true ? _vm.filters.isActive = false : _vm.filters.isActive = true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields'))+"\n                    ")]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.setFilter()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px","margin-top":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(16),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(17),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-real-time-group"}},[_c('i',{staticClass:"fa fa-plus"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyProfile_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5ab56aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyProfile_vue__ = __webpack_require__(461);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MyProfile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5ab56aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MyProfile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.myProfile')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.myProfile')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.userPhoto')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body box-profile",attrs:{"align":"center"}},[_c('img',{staticClass:"profile-user-img img-responsive img-circle",staticStyle:{"height":"150px","width":"150px"},attrs:{"src":(this.user.photo == null && this.tempUrl == null) || (this.user.photo == '' && this.tempUrl == null) ? '/src/assets/default-user.png' : this.user.photo || this.tempUrl}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(this.tempUrl || this.user.photo),expression:"this.tempUrl || this.user.photo"}],staticClass:"text-red",attrs:{"href":"#"},on:{"click":function($event){return _vm.removeImage()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.remove'))+"\n            ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('my-upload',{attrs:{"field":"img","langType":"tr","width":200,"height":200,"url":"/images","params":_vm.params,"headers":_vm.headers,"img-format":"png"},on:{"crop-success":_vm.cropSuccess},model:{value:(_vm.showImageDialog),callback:function ($$v) {_vm.showImageDialog=$$v},expression:"showImageDialog"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-sm",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleShow()}}},[_c('i',{staticClass:"fa fa-upload"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('users.selectPhoto'))+"\n            ")])],1),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])]),_vm._v(" "),_c('button',{class:_vm.filters.nameOrCardNumber != '' ? 'btn btn-success' : 'btn btn-warning',staticStyle:{"width":"100%","margin-bottom":"10px"},attrs:{"data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" Varsayılan Filtre Grubu\n        ")]),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('users.companyAuthorities')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length > 0),expression:"companyList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"200px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.companyList),function(company){return _c('tr',{key:company.id},[_c('td',[_c('div',{staticClass:"checkbox",staticStyle:{"margin-left":"20px"}},[_c('label',[_c('input',{attrs:{"disabled":_vm.authControl == 2,"type":"checkbox"},domProps:{"checked":company.check},on:{"change":function($event){company.check==true ? company.check=false : company.check=true}}}),_vm._v("\n                          "+_vm._s(company.name)+"\n                        ")])])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.companyList.length == 0),expression:"companyList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('users.companyNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingCompanies}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.userInformation')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.userName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.name),expression:"user.name"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.email')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.mail),expression:"user.mail"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.mail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "mail", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.authorityGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"disabled":_vm.authControl == 2},on:{"change":function($event){return _vm.changeUserAuthGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.userAuhtGroupList),function(userAuthGroup){return _c('option',{key:userAuthGroup.id,domProps:{"value":userAuthGroup.id,"selected":userAuthGroup.id == _vm.user.authId}},[_vm._v(_vm._s(userAuthGroup.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.repeatPassword')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password2),expression:"user.password2"}],staticClass:"form-control",attrs:{"type":"password","placeholder":""},domProps:{"value":(_vm.user.password2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.userTitle')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.title),expression:"user.title"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "title", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.phoneNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.phoneNumber),expression:"user.phoneNumber"}],staticClass:"form-control",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.user.phoneNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "phoneNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.smsOrMail),expression:"modules.smsOrMail"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.activateSmsSystem')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.user.isSmsSend},on:{"change":function($event){_vm.user.isSmsSend==true ? _vm.user.isSmsSend=false : _vm.user.isSmsSend=true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('users.activateSmsSystem'))+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroup')))]),_vm._v(" "),_c('div',{class:_vm.authControl == 2 ? '':'input-group'},[_c('select',{staticClass:"form-control",attrs:{"disabled":_vm.authControl == 2},on:{"change":function($event){return _vm.changeMonitorGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.monitorGroupList),function(monitorGroup){return _c('option',{key:monitorGroup.id,domProps:{"value":monitorGroup.id,"selected":monitorGroup.id == _vm.user.monitorGroupId}},[_vm._v(_vm._s(monitorGroup.name))])})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl != 2),expression:"authControl != 2"}],staticClass:"input-group-btn"},[_vm._m(0)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.visitorCardGroup')))]),_vm._v(" "),_c('select',{staticClass:"form-control",attrs:{"disabled":_vm.authControl == 2},on:{"change":function($event){return _vm.changeVisitorGroup($event)}}},[_c('option',{attrs:{"selected":"selected","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.visitorGroupList),function(visitorGroup){return _c('option',{key:visitorGroup.id,domProps:{"value":visitorGroup.id,"selected":visitorGroup.id == _vm.user.visitorCardGroup}},[_vm._v(_vm._s(visitorGroup.name))])})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.user.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUser()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.user.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUser()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(3),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.user.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.isContinueUserDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){$event.preventDefault();return _vm.deleteUser()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-real-time-group"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(4),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroups')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h4',{staticClass:"box-title"},[_vm._v(_vm._s(_vm.$ml.get('users.realTimeMonitorGroupList')))]),_vm._v(" "),_c('div',{staticClass:"pull-right box-tools"},[_c('button',{staticClass:"btn btn-sm btn-warning ",on:{"click":function($event){return _vm.newRealTimeMonitor()}}},[_vm._v(_vm._s(_vm.$ml.get('users.newRealTimeMonitorGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monitorGroupList.length > 0),expression:"monitorGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.monitorGroupList),function(monitorGroup){return _c('tr',{key:monitorGroup.id},[_c('td',[_vm._v(_vm._s(monitorGroup.name))]),_vm._v(" "),_c('td',[_c('button',{staticClass:"btn btn-sm btn-primary",on:{"click":function($event){return _vm.selectRealTimeMonitor(monitorGroup.id, monitorGroup.name, monitorGroup.devices)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monitorGroupList.length == 0),expression:"monitorGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('users.realTimeMonitorGroupNotRecord'))+"\n                    ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-7"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('users.groupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedRealTimeMonitorName),expression:"selectedRealTimeMonitorName"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedRealTimeMonitorName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.selectedRealTimeMonitorName=$event.target.value}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeReaderList.length > 0),expression:"activeReaderList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightTableSize)},[_c('table',{staticClass:"table table-hover",staticStyle:{"background-color":"white"}},[_c('tbody',_vm._l((_vm.activeReaderList),function(reader){return _c('tr',{key:reader.id},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px","color":"black"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":reader.check},on:{"change":function($event){reader.check==true ? reader.check=false : reader.check=true}}}),_vm._v("\n                            "+_vm._s(reader.ipAddress)+" | "+_vm._s(reader.readerNo)+" - "+_vm._s(reader.name)+"\n                          ")])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeReaderList.length == 0),expression:"activeReaderList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('users.deviceNotRecord'))+"\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-outline pull-left",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRealTimeMonitor),expression:"!isNewRealTimeMonitor"}],staticClass:"btn btn-outline btn-danger",attrs:{"type":"button"},on:{"click":function($event){return _vm.deleteRealTimeMonitor()}}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-outline btn-success",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveRealTimeMonitor()}}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewRealTimeMonitor),expression:"isNewRealTimeMonitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewRealTimeMonitor),expression:"!isNewRealTimeMonitor"}]},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(5),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.nameOrCardNumber),expression:"filters.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.filters.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.identityNo),expression:"filters.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.filters.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.sicilOrTerminalNo),expression:"filters.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.filters.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.documentNoOrMail),expression:"filters.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.filters.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.plateNo),expression:"filters.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.filters.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(7),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.filters.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(8),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(9),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(10),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(11),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.filters.isActive},on:{"change":function($event){_vm.filters.isActive==true ? _vm.filters.isActive=false : _vm.filters.isActive=true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField1key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField1value),expression:"filters.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField2key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField2value),expression:"filters.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField3key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField3value),expression:"filters.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.filters.extraField4key == 0}},[_vm._v(_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.filters.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filters.extraField4value),expression:"filters.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.filters.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filters, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning ",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.setFilter()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px","margin-top":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck==true ? state.isCheck=false : state.isCheck=true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck==true ? status.isCheck=false : status.isCheck=true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck==true ? acc.isCheck=false : acc.isCheck=true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(16),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck==true ? work.isCheck=false : work.isCheck=true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(17),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck==true ? foodGroup.isCheck=false : foodGroup.isCheck=true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v(_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"data-toggle":"modal","data-target":"#modal-real-time-group"}},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthorityGroups_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d65d904_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAuthorityGroups_vue__ = __webpack_require__(463);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserAuthorityGroups_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9d65d904_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserAuthorityGroups_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userAuthorityGroups')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userAuthorityGroups')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.userAuthorityGroupList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userAuthorityGroupList.length > 0),expression:"userAuthorityGroupList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.userAuthorityGroupList),function(userAuthority){return _c('tr',{key:userAuthority.id},[_c('td',[_vm._v(_vm._s(userAuthority.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getUserAuthorityGroup(userAuthority.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.userAuthorityGroupList.length == 0),expression:"userAuthorityGroupList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('userAuthorityGroups.userAuthorityGroupNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.userAuthorityGroupInformation')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning",attrs:{"type":"button"},on:{"click":function($event){return _vm.newUserAuthorityGroup()}}},[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.newAuthorityGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.authorityGroupName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAuthorityGroup.name),expression:"userAuthorityGroup.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.userAuthorityGroup.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userAuthorityGroup, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.description')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userAuthorityGroup.description),expression:"userAuthorityGroup.description"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.userAuthorityGroup.description)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.userAuthorityGroup, "description", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group form-control"},[_c('div',{staticClass:"radio",staticStyle:{"margin-left":"20px"}},[_c('label',[_c('input',{attrs:{"type":"radio","name":"optionsRadios","id":"optionsRadios1","value":"option1"},domProps:{"checked":_vm.userAuthorityGroup.state == 0},on:{"change":function($event){_vm.userAuthorityGroup.state = 0}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('userAuthorityGroups.admin'))+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group form-control"},[_c('div',{staticClass:"radio",staticStyle:{"margin-left":"20px"}},[_c('label',[_c('input',{attrs:{"type":"radio","name":"optionsRadios","id":"optionsRadios2","value":"option2"},domProps:{"checked":_vm.userAuthorityGroup.state == 1},on:{"change":function($event){_vm.userAuthorityGroup.state = 1}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('userAuthorityGroups.user'))+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-warning"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.filterAuthorities')))]),_vm._v(" "),_c('span',[_vm._v("*"+_vm._s(_vm.$ml.get('userAuthorityGroups.authorityInfo')))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(0),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAllowence')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAllowenceList != ''),expression:"checkedAllowenceList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAllowenceList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAllowenceList == ''),expression:"checkedAllowenceList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAllowenceList != ''),expression:"checkedAllowenceList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAllowences()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"callout callout-danger"},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.authorities')))])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDashboardStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.dashboard == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.dashboard == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.employees')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeUsersStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authUsers == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.userAuthorityGroup.authUsers == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.onlyView')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authUsers == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.definitions')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeDefinitionsStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authDefinitions == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.userAuthorityGroup.authDefinitions == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.onlyView')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authDefinitions == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.userAuthorityGroups')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeAccessGroupsStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authAccessGroups == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.userAuthorityGroup.authAccessGroups == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.onlyView')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authAccessGroups == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.realTimeMonitor')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeRealTimeMonitorStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authRealTimeMonitor == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authRealTimeMonitor == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.reports')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeReportsStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authReports == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.userAuthorityGroup.authReports == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.onlyView')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authReports == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeSettingsStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authSettings == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.userAuthorityGroup.authSettings == 1}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.onlyView')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authSettings == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.foodGroups')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeFoodStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authFood == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authFood == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.visitor),expression:"modules.visitor"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.visitors')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeVisitorStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.authVisitor == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.authVisitor == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.retailSale),expression:"modules.retailSale"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.retailSale')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeCreditSaleStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.creditSale == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.creditSale == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.payrollManagement),expression:"modules.payrollManagement"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollManagement')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePayrollManagementStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.payrollManagement == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.payrollManagement == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.guardTour),expression:"modules.guardTour"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.guardTourSystem')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeGuardTourStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.guardTour == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.guardTour == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.shiftManagement),expression:"modules.shiftManagement"}],staticClass:"col-sm-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('shared.shiftManagement')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeShiftManagementStatu($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.userAuthorityGroup.shiftManagement == 0}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.fullAuthority')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.userAuthorityGroup.shiftManagement == 2}},[_vm._v("\n                      "+_vm._s(_vm.$ml.get('userAuthorityGroups.cantUse')))])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.shiftManagement),expression:"modules.shiftManagement"}],staticClass:"col-sm-12"},[_vm._m(7),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-6 form-group"},[_c('label',[_vm._v("Shift Planlama")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.canPlan},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.canPlan == true ? _vm.userAuthorityGroup.shiftSettings.canPlan = false : _vm.userAuthorityGroup.shiftSettings.canPlan = true}}}),_vm._v("\n                      Shift planlayabilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 form-group"},[_c('label',[_vm._v("Shift Onaylama")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.canConfirmShift},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.canConfirmShift == true ? _vm.userAuthorityGroup.shiftSettings.canConfirmShift = false : _vm.userAuthorityGroup.shiftSettings.canConfirmShift = true}}}),_vm._v("\n                      Shift onaylayabilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 form-group"},[_c('label',[_vm._v("İzin Planlama")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.canPlanAllowence},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.canPlanAllowence == true ? _vm.userAuthorityGroup.shiftSettings.canPlanAllowence = false : _vm.userAuthorityGroup.shiftSettings.canPlanAllowence = true}}}),_vm._v("\n                      İzin planlayabilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-6 form-group"},[_c('label',[_vm._v("İzin Onaylama")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.canConfirmAllowence},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.canConfirmAllowence == true ? _vm.userAuthorityGroup.shiftSettings.canConfirmAllowence = false : _vm.userAuthorityGroup.shiftSettings.canConfirmAllowence = true}}}),_vm._v("\n                      İzin onaylayabilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 form-group"},[_c('label',[_vm._v("Gerçekleşen Takvimi")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.canSeeRealMovements},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.canSeeRealMovements == true ? _vm.userAuthorityGroup.shiftSettings.canSeeRealMovements = false : _vm.userAuthorityGroup.shiftSettings.canSeeRealMovements = true}}}),_vm._v("\n                      Gerçekleşen takvimi görüntüleyebilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 form-group"},[_c('label',[_vm._v("Onaylanmamış Plan Uyarısı")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts == true ? _vm.userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts = false : _vm.userAuthorityGroup.shiftSettings.sendMailWhenUnconfirmedShifts = true}}}),_vm._v("\n                      Onaylanmamış plan olduğunda uyarı e-postası gönderilsin\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 form-group"},[_c('label',[_vm._v("Onaylanmamış Plan Uyarı Tekrarı")]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"disabled":_vm.userAuthorityGroup.shiftManagement == 2,"type":"checkbox"},domProps:{"checked":_vm.userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay},on:{"change":function($event){_vm.userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay == true ? _vm.userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay = false : _vm.userAuthorityGroup.shiftSettings.sendWarningMailOnSecondDay = true}}}),_vm._v("\n                      Onaylanmamış plan tekrarı olduğunda uyarı e-postası gönderilsin\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewUserAuthorityGroup && _vm.authControl == 0),expression:"!isNewUserAuthorityGroup && authControl == 0"}],staticClass:"btn btn-sm btn-danger",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewUserAuthorityGroup && _vm.authControl == 0),expression:"isNewUserAuthorityGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewUserAuthorityGroup && _vm.authControl == 0),expression:"!isNewUserAuthorityGroup && authControl == 0"}],staticClass:"btn btn-sm btn-success",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.userAuthorityGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.isContinueUserAuthGroupUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUserAuthorityGroup()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.userAuthorityGroup.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.isContinueUserAuthGroupSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveUserAuthorityGroup()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.userAuthorityGroup.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('userAuthorityGroups.isContinueUserAuthGroupDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteUserAuthorityGroup()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText2),expression:"searchText2"}],staticClass:"form-control",staticStyle:{"margin-bottom":"10px","margin-top":"10px"},attrs:{"type":"text","placeholder":_vm.$ml.get('general.search'),"autocomplete":"false"},domProps:{"value":(_vm.searchText2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText2=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                  "+_vm._s(dep.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","M":"","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                  "+_vm._s(state.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                  "+_vm._s(status.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(14),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                  "+_vm._s(acc.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(15),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                  "+_vm._s(work.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(16),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                  "+_vm._s(foodGroup.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-allowence"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(17),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAllowence')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.allowenceList),function(allowence){return _c('span',{key:allowence.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":allowence.isCheck},on:{"change":function($event){allowence.isCheck == true ? allowence.isCheck = false : allowence.isCheck = true}}}),_vm._v("\n                  "+_vm._s(allowence.name)+"\n                ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allowenceList.length == 0),expression:"allowenceList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n                "+_vm._s(_vm.$ml.get('allowences.allowenceNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n              "+_vm._s(_vm.$ml.get('general.done'))+"\n            ")])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-allowence"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"callout callout-info"},[_c('h4',[_vm._v("Vardiya (Shift) Yönetimi Ayarları")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailSmsSettings_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d663af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailSmsSettings_vue__ = __webpack_require__(465);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MailSmsSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60d663af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MailSmsSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.mailSmsSettings')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.mailSmsSettings')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 text-center"},[_c('a',{staticClass:"btn btn-app",attrs:{"href":"#mail-ayarlari","data-toggle":"tab","title":_vm.$ml.get('mailSmsSettings.mailSettings')}},[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.mailSettings')))])]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.sms),expression:"modules.sms"}],staticClass:"btn btn-app",attrs:{"href":"#sms-ayarlari","data-toggle":"tab","title":_vm.$ml.get('mailSmsSettings.smsSettings')}},[_c('i',{staticClass:"fa fa-commenting"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.smsSettings')))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"mail-ayarlari"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('mailSmsSettings.automaticMailList'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"}),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mailList.length > 0),expression:"mailList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.mailList),function(mail){return _c('tr',{key:mail.id},[_c('td',[_vm._v(_vm._s(mail.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getMail(mail)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.mailList.length == 0),expression:"mailList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('alerts.recordNotFound'))+"\n                      ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_c('i',{staticClass:"fa fa-file-text"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('mailSmsSettings.mailDetails'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn  btn-sm btn-warning",on:{"click":function($event){return _vm.newMail()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.newMailDefinition'))+"\n                      ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-pencil"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.mailDefinitionName'))+"\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.name),expression:"selectedMail.name"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedMail.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-bookmark"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.mailHeader'))+"\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.header),expression:"selectedMail.header"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedMail.header)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail, "header", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-edit"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.mailContent'))+"\n                          ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.content),expression:"selectedMail.content"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.selectedMail.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail, "content", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.mailSendingTime'))+"\n                          ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.dayList),function(day){return _c('tr',{key:day.value,attrs:{"value":day.value}},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":day.check},on:{"change":function($event){day.check == true ? day.check = false : day.check = true}}}),_vm._v("\n                                    "+_vm._s(day.name)+"\n                                  ")])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.time'))+"\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.time),expression:"selectedMail.time"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.selectedMail.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail, "time", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-file-text"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.reportsToSubmit'))+"\n                          ")]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.reportList),function(report){return _c('tr',{key:report.id,attrs:{"value":report.id}},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"30px"}},[_c('input',{attrs:{"type":"checkbox","name":"check"},domProps:{"checked":report.checked},on:{"change":function($event){report.checked == true ? report.checked = false : report.checked = true}}}),_vm._v("\n                                    "+_vm._s(report.name)+"\n                                  ")])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('button',{staticClass:"btn btn-danger",staticStyle:{"width":"100%","margin-bottom":"10px"},attrs:{"disabled":_vm.selectedMail.filterType != 0,"data-toggle":"modal","data-target":"#modal-filtre"}},[_c('i',{staticClass:"fa fa-filter"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.filterGroup'))+"\n                        ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_c('i',{staticClass:"fa fa-envelope"}),_vm._v(" "+_vm._s(_vm.$ml.get('mailSmsSettings.emailAddressesToSend'))+"\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedEmail),expression:"selectedEmail"}],staticClass:"form-control",staticStyle:{"margin-bottom":"7px"},attrs:{"disabled":_vm.selectedMail.filterType != 0,"type":"text","placeholder":_vm.$ml.get('mailSmsSettings.enterAEmail'),"autocomplete":"false"},domProps:{"value":(_vm.selectedEmail)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addEmail()},"input":function($event){if($event.target.composing){ return; }_vm.selectedEmail=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%","margin-bottom":"10px"},attrs:{"disabled":_vm.selectedMail.filterType != 0,"type":"button"},on:{"click":function($event){return _vm.addEmail()}}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.add'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_vm._l((_vm.emailList),function(email,index){return _c('tr',{key:index},[_c('td',[_c('label',[_vm._v("\n                                  "+_vm._s(email)+"\n                                ")])]),_vm._v(" "),_c('td',{staticStyle:{"cursor":"pointer"}},[_c('a',{staticClass:"text-danger",attrs:{"disabled":_vm.selectedMail.filterType != 0},on:{"click":function($event){return _vm.removeEmail(index)}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.remove'))+"\n                                ")])])])}),_vm._v(" "),_c('tr',[_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.emailList.length == 0),expression:"emailList.length == 0"}],attrs:{"colspan":"2"}},[_c('div',{staticClass:"callout callout-warning"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                                  "+_vm._s(_vm.$ml.get('alerts.pleaseEnterAEmail'))+"\n                                ")])])])],2)])])])]),_vm._v(" "),_c('div',{staticClass:"box-footer text-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMail.id),expression:"selectedMail.id"}],staticClass:"btn  btn-danger",on:{"click":function($event){return _vm.deleteMail()}}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.delete'))+"\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedMail.id),expression:"selectedMail.id"}],staticClass:"btn  btn-success",on:{"click":function($event){return _vm.saveMail()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.update'))+"\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.selectedMail.id),expression:"!selectedMail.id"}],staticClass:"btn  btn-success",on:{"click":function($event){return _vm.saveMail()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.save'))+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.sms),expression:"modules.sms"}],staticClass:"tab-pane",attrs:{"id":"sms-ayarlari"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_c('i',{staticClass:"fa fa-bookmark"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('mailSmsSettings.smsAPIRecordInformation'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.requestSentLink')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiLink),expression:"apiLink"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.apiLink)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apiLink=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.title')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.baslik),expression:"baslik"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.baslik)},on:{"input":function($event){if($event.target.composing){ return; }_vm.baslik=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.apiKey')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.apiKey),expression:"apiKey"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.apiKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.apiKey=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.secretKey')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.secretKey),expression:"secretKey"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.secretKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.secretKey=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.userName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.kullaniciAdi),expression:"kullaniciAdi"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.kullaniciAdi)},on:{"input":function($event){if($event.target.composing){ return; }_vm.kullaniciAdi=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.password')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.parola),expression:"parola"}],staticClass:"form-control",attrs:{"type":"password"},domProps:{"value":(_vm.parola)},on:{"input":function($event){if($event.target.composing){ return; }_vm.parola=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.smsSystem')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.aktifMi},on:{"change":function($event){_vm.aktifMi == true ? _vm.aktifMi = false : _vm.aktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.sms && (_vm.modules.dormitory || _vm.modules.student)),expression:"modules.sms && (modules.dormitory || modules.student)"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_c('i',{staticClass:"fa fa-commenting"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('mailSmsSettings.dormitorySMSSettings'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("1."+_vm._s(_vm.$ml.get('mailSmsSettings.smsType'))+"\n                          ("+_vm._s(_vm.$ml.get('mailSmsSettings.smsContentDescription1'))+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.icerik1),expression:"icerik1"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.icerik1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icerik1=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.parameters'))+":")]),_vm._v("\n                          "+_vm._s(_vm.$ml.get('mailSmsSettings.studentName'))+"\n                          "),_c('strong',[_vm._v("[ADSOYAD]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.todaysDate'))+"\n                          "),_c('strong',[_vm._v("[TARIH]")])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("2."+_vm._s(_vm.$ml.get('mailSmsSettings.smsType'))+"\n                          ("+_vm._s(_vm.$ml.get('mailSmsSettings.smsContentDescription2'))+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.icerik2),expression:"icerik2"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.icerik2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icerik2=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.parameters'))+":")]),_vm._v("\n                          "+_vm._s(_vm.$ml.get('mailSmsSettings.studentName'))+"\n                          "),_c('strong',[_vm._v("[ADSOYAD]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.movementDate'))+"\n                          "),_c('strong',[_vm._v("[HAREKETTARIH]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.movementTime'))+"\n                          "),_c('strong',[_vm._v("[HAREKETSAAT]")])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("3."+_vm._s(_vm.$ml.get('mailSmsSettings.smsType'))+"\n                          ("+_vm._s(_vm.$ml.get('mailSmsSettings.smsContentDescription3'))+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.icerik3),expression:"icerik3"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.icerik3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icerik3=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.parameters'))+":")]),_vm._v("\n                          "+_vm._s(_vm.$ml.get('mailSmsSettings.studentName'))+"\n                          "),_c('strong',[_vm._v("[ADSOYAD]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.todaysDate'))+"\n                          "),_c('strong',[_vm._v("[TARIH]")])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-12"},[_c('label',[_vm._v("4."+_vm._s(_vm.$ml.get('mailSmsSettings.smsType'))+"\n                          ("+_vm._s(_vm.$ml.get('mailSmsSettings.smsContentDescription4'))+")")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.icerik4),expression:"icerik4"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.icerik4)},on:{"input":function($event){if($event.target.composing){ return; }_vm.icerik4=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.parameters'))+":")]),_vm._v("\n                          "+_vm._s(_vm.$ml.get('mailSmsSettings.studentName'))+"\n                          "),_c('strong',[_vm._v("[ADSOYAD]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.allowenceStartDate'))+"\n                          "),_c('strong',[_vm._v("[BASTARIH]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.allowenceEndDate'))+"\n                          "),_c('strong',[_vm._v("[BITTARIH]")]),_vm._v("\n                          , "+_vm._s(_vm.$ml.get('mailSmsSettings.allowenceName'))+"\n                          "),_c('strong',[_vm._v("[IZIN]")])]),_vm._v(" "),_c('hr')])])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.sms && (_vm.modules.dormitory || _vm.modules.student)),expression:"modules.sms && (modules.dormitory || modules.student)"}],staticClass:"col-sm-6"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_c('i',{staticClass:"fa fa-clock-o"}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('mailSmsSettings.dormitorySMSTimePlan'))+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.monday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun1AktifMi},on:{"change":function($event){_vm.gun1AktifMi == true ? _vm.gun1AktifMi = false : _vm.gun1AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun1SonGiris),expression:"gun1SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun1SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun1SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.tuesday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun2AktifMi},on:{"change":function($event){_vm.gun2AktifMi == true ? _vm.gun2AktifMi = false : _vm.gun2AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun2SonGiris),expression:"gun2SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun2SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun2SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.wednesday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun3AktifMi},on:{"change":function($event){_vm.gun3AktifMi == true ? _vm.gun3AktifMi = false : _vm.gun3AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun3SonGiris),expression:"gun3SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun3SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun3SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.thursday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun4AktifMi},on:{"change":function($event){_vm.gun4AktifMi == true ? _vm.gun4AktifMi = false : _vm.gun4AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun4SonGiris),expression:"gun4SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun4SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun4SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.friday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun5AktifMi},on:{"change":function($event){_vm.gun5AktifMi == true ? _vm.gun5AktifMi = false : _vm.gun5AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun5SonGiris),expression:"gun5SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun5SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun5SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.saturday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun6AktifMi},on:{"change":function($event){_vm.gun6AktifMi == true ? _vm.gun6AktifMi = false : _vm.gun6AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun6SonGiris),expression:"gun6SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun6SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun6SonGiris=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 text-center"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('general.sunday')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.gun7AktifMi},on:{"change":function($event){_vm.gun7AktifMi == true ? _vm.gun7AktifMi = false : _vm.gun7AktifMi = true}}}),_vm._v("\n                            "+_vm._s(_vm.$ml.get('mailSmsSettings.active'))+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('mailSmsSettings.lastEntryTime')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gun7SonGiris),expression:"gun7SonGiris"}],staticClass:"form-control",attrs:{"type":"time"},domProps:{"value":(_vm.gun7SonGiris)},on:{"input":function($event){if($event.target.composing){ return; }_vm.gun7SonGiris=$event.target.value}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 text-right"},[_c('button',{staticClass:"btn btn-success",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.UpdateConfig()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v("\n                  "+_vm._s(_vm.$ml.get('mailSmsSettings.updateInformation'))+"\n                ")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-primary fade",attrs:{"id":"modal-filtre"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterEmployees')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterNameSurnameOrCardNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.nameOrCardNumber),expression:"selectedMail.filter.nameOrCardNumber"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterNameSurnameOrCardNo')},domProps:{"value":(_vm.selectedMail.filter.nameOrCardNumber)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "nameOrCardNumber", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCitizenshipNumber')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.identityNo),expression:"selectedMail.filter.identityNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterCitizenshipNumber')},domProps:{"value":(_vm.selectedMail.filter.identityNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "identityNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterRegistrationOrDeviceNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.sicilOrTerminalNo),expression:"selectedMail.filter.sicilOrTerminalNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterRegistrationOrDeviceNo')},domProps:{"value":(_vm.selectedMail.filter.sicilOrTerminalNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "sicilOrTerminalNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDocumentNoOrEmail')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.documentNoOrMail),expression:"selectedMail.filter.documentNoOrMail"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterDocumentNoOrEmail')},domProps:{"value":(_vm.selectedMail.filter.documentNoOrMail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "documentNoOrMail", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.licencePlateRecognition),expression:"modules.licencePlateRecognition"}],staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterPlateNo')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.plateNo),expression:"selectedMail.filter.plateNo"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterPlateNo')},domProps:{"value":(_vm.selectedMail.filter.plateNo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "plateNo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStatusList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList == ''),expression:"checkedStatusList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(1),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStatusList != ''),expression:"checkedStatusList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStatus()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedStateList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList == ''),expression:"checkedStateList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedStateList != ''),expression:"checkedStateList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterStates()}}},[_c('i',{staticClass:"fa fa-remove"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('div',{staticClass:"form-group"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterTitle')))]),_vm._v(" "),_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterTitles($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedMail.filter.title == ''}},[_vm._v(_vm._s(_vm.$ml.get('general.select')))]),_vm._v(" "),_vm._l((_vm.titleList),function(title){return _c('option',{key:title.name,domProps:{"value":title.name,"selected":title.name == _vm.selectedMail.filter.title}},[_vm._v(_vm._s(title.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedDepartmentList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList == ''),expression:"checkedDepartmentList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(3),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedDepartmentList != ''),expression:"checkedDepartmentList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterDepartments()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedAccessGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList == ''),expression:"checkedAccessGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedAccessGroupList != ''),expression:"checkedAccessGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterAccessGroup()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedWorkGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList == ''),expression:"checkedWorkGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(5),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedWorkGroupList != ''),expression:"checkedWorkGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterWorkPlans()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modules.diningHall),expression:"modules.diningHall"}],staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('filters.filterFoodGroup')))]),_vm._v(" "),_c('div',{staticClass:"input-group"},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"form-control tdb-box"},[_vm._v(_vm._s(_vm.checkedFoodGroupList))]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList == ''),expression:"checkedFoodGroupList == ''"}],staticClass:"form-control"},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('div',{staticClass:"input-group-btn"},[_vm._m(6),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.checkedFoodGroupList != ''),expression:"checkedFoodGroupList != ''"}],staticClass:"btn btn-danger",on:{"click":function($event){return _vm.clearFilterFoodGroups()}}},[_c('i',{staticClass:"fa fa-remove"})])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDeleted')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selectedMail.filter.isActive},on:{"change":function($event){_vm.selectedMail.filter.isActive == true ? _vm.selectedMail.filter.isActive = false : _vm.selectedMail.filter.isActive = true}}}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('filters.filterNotShow'))+"\n                    ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"callout callout-info",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField1($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedMail.filter.extraField1key == 0}},[_vm._v("\n                    "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.selectedMail.filter.extraField1key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.extraField1value),expression:"selectedMail.filter.extraField1value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.selectedMail.filter.extraField1value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "extraField1value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField2($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedMail.filter.extraField2key == 0}},[_vm._v("\n                    "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.selectedMail.filter.extraField2key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.extraField2value),expression:"selectedMail.filter.extraField2value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.selectedMail.filter.extraField2value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "extraField2value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField3($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedMail.filter.extraField3key == 0}},[_vm._v("\n                    "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.selectedMail.filter.extraField3key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.extraField3value),expression:"selectedMail.filter.extraField3value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.selectedMail.filter.extraField3value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "extraField3value", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('select',{staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},on:{"change":function($event){return _vm.changeFilterExtraField4($event)}}},[_c('option',{attrs:{"value":""},domProps:{"selected":_vm.selectedMail.filter.extraField4key == 0}},[_vm._v("\n                    "+_vm._s(_vm.$ml.get('filters.filterSelectExtraFields')))]),_vm._v(" "),_vm._l((_vm.extraFieldList),function(extraField){return _c('option',{key:extraField.id,domProps:{"value":extraField.id,"selected":extraField.id == _vm.selectedMail.filter.extraField4key}},[_vm._v(_vm._s(extraField.name))])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-xs-6"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedMail.filter.extraField4value),expression:"selectedMail.filter.extraField4value"}],staticClass:"form-control input-sm",staticStyle:{"margin-bottom":"5px"},attrs:{"type":"text","placeholder":_vm.$ml.get('filters.filterValue')},domProps:{"value":(_vm.selectedMail.filter.extraField4value)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedMail.filter, "extraField4value", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterCancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-warning ",on:{"click":function($event){return _vm.filtersClear()}}},[_c('i',{staticClass:"fa fa-trash-o"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterClear')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.setFilter()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterComplete')))])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-department"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(7),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterDepartments')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('a',{on:{"click":function($event){_vm.isCheckDeps == true ? _vm.getCheckDepartmentAll(false) : _vm.getCheckDepartmentAll(true)}}},[_c('span',{domProps:{"textContent":_vm._s(_vm.isCheckDeps == true ? _vm.$ml.get('general.removeAll') : _vm.$ml.get('general.selectAll'))}})]),_vm._v(" "),_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.sortableDepartmentList),function(dep){return _c('span',{key:dep.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":dep.check},on:{"change":function($event){dep.check == true ? _vm.changeFilterDep(dep, false) : _vm.changeFilterDep(dep, true)}}}),_vm._v("\n                "+_vm._s(dep.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.sortableDepartmentList.length == 0),expression:"sortableDepartmentList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('employees.departmentNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-state"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(8),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterState')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.stateList),function(state){return _c('span',{key:state.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":state.isCheck},on:{"change":function($event){state.isCheck == true ? state.isCheck = false : state.isCheck = true}}}),_vm._v("\n                "+_vm._s(state.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.stateList.length == 0),expression:"stateList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('employees.stateNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-status"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(9),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterStatus')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.statuList),function(status){return _c('span',{key:status.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":status.isCheck},on:{"change":function($event){status.isCheck == true ? status.isCheck = false : status.isCheck = true}}}),_vm._v("\n                "+_vm._s(status.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.statuList.length == 0),expression:"statuList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('employees.statusNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-access"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(10),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterAccessGroup')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.accessGroupList),function(acc){return _c('span',{key:acc.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":acc.isCheck},on:{"change":function($event){acc.isCheck == true ? acc.isCheck = false : acc.isCheck = true}}}),_vm._v("\n                "+_vm._s(acc.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.accessGroupList.length == 0),expression:"accessGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('accessGroups.accessGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-workplan"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(11),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.periodWorkGroupList),function(work){return _c('span',{key:work.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":work.isCheck},on:{"change":function($event){work.isCheck == true ? work.isCheck = false : work.isCheck = true}}}),_vm._v("\n                "+_vm._s(work.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.periodWorkGroupList.length == 0),expression:"periodWorkGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('workPlans.workPlanNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-secondary fade",staticStyle:{"display":"none"},attrs:{"id":"modal-select-diningHall"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(12),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('filters.filterWorkPlan')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"table-responsive",staticStyle:{"max-height":"600px","owerflow":"auto"}},[_vm._l((_vm.foodGroupList),function(foodGroup){return _c('span',{key:foodGroup.id,staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":foodGroup.isCheck},on:{"change":function($event){foodGroup.isCheck == true ? foodGroup.isCheck = false : foodGroup.isCheck = true}}}),_vm._v("\n                "+_vm._s(foodGroup.name)+"\n              ")])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.foodGroupList.length == 0),expression:"foodGroupList.length == 0"}],staticClass:"callout callout-warning"},[_vm._v("\n              "+_vm._s(_vm.$ml.get('foodGroups.foodGroupNotRecord')))])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-check"}),_vm._v("\n            "+_vm._s(_vm.$ml.get('general.done'))+"\n          ")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-xl fade",attrs:{"id":"modal-kisi-sec"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(13),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('employees.selectEmployee')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control",attrs:{"placeholder":_vm.$ml.get('employees.searchFromNameSurname')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length > 0),expression:"allEmployeeFilteredList.length > 0"}],staticClass:"table-responsive no-padding",staticStyle:{"max-height":"500px","owerflow":"auto"}},[_c('table',{staticClass:"table table-hover"},[_c('tbody',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('employees.employeeList')))])]),_vm._v(" "),_vm._l((_vm.allEmployeeFilteredList),function(employee){return _c('tr',{key:employee.id},[_c('td',{staticClass:"checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":employee.isCheck},on:{"change":function($event){employee.isCheck == true ? employee.isCheck = false : employee.isCheck = true}}}),_vm._v("\n                          "+_vm._s(employee.name)+"\n                          "),(employee.title != '')?_c('span',[_vm._v("- "+_vm._s(employee.title))]):_vm._e()])])])})],2)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.allEmployeeFilteredList.length == 0),expression:"allEmployeeFilteredList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                "+_vm._s(_vm.$ml.get('employees.employeeSearchNotFound'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-status"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-state"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-department"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-access"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-workplan"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default",attrs:{"data-toggle":"modal","data-target":"#modal-select-diningHall"}},[_c('i',{staticClass:"fa fa-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLogs_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a702f8ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLogs_vue__ = __webpack_require__(467);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserLogs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a702f8ee_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserLogs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userLogs')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.userLogs')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_vm._v(_vm._s(_vm.$ml.get('userLogs.user'))+" :")]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeUser($event)}}},[_c('option',{attrs:{"selected":"","value":"0"}},[_vm._v(_vm._s(_vm.$ml.get('general.all')))]),_vm._v(" "),_vm._l((_vm.userList),function(user){return _c('option',{key:user.id,domProps:{"value":user.id,"selected":_vm.selectedUserId == user.id}},[_vm._v(_vm._s(user.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.send()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.view'))+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-setting"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('userLogs.userLogList')))])]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0 && _vm.authControl == 0),expression:"logList.length > 0 && authControl == 0"}],staticClass:"btn btn-danger btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v(" "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('userLogs.userLogs'))+" ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$ml.get('userLogs.userName')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('userLogs.logTime')))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.$ml.get('userLogs.logDescription')))])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id,staticClass:"rows"},[_c('td',[_c('span',[_vm._v(_vm._s(log.userName))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(log.date)))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.description))])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('userLogs.logNotRecord'))+"\n            ")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollTypes_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81b1fe40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollTypes_vue__ = __webpack_require__(469);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PayrollTypes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81b1fe40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PayrollTypes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollTypes')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.payrollTypes')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrollTypeList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.payrollList.length > 0),expression:"payrollList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.payrollList),function(payroll){return _c('tr',{key:payroll.id},[_c('td',[_vm._v(_vm._s(payroll.shortCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(payroll.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getPayroll(payroll.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.payrollList.length == 0),expression:"payrollList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('payrollTypes.payrollTypeNotRecord'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrollTypeInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newPayroll()}}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.newPayrollType')))])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.shortCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.shortCode),expression:"selectedPayroll.shortCode"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.shortCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "shortCode", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrollName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.name),expression:"selectedPayroll.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrollType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changePayrollType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedPayroll.type==0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_c('option',{attrs:{"value":"1"},domProps:{"selected":_vm.selectedPayroll.type==1}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.normalWork')))]),_vm._v(" "),_c('option',{attrs:{"value":"2"},domProps:{"selected":_vm.selectedPayroll.type==2}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.weekendHoliday')))]),_vm._v(" "),_c('option',{attrs:{"value":"3"},domProps:{"selected":_vm.selectedPayroll.type==3}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.publicHoliday')))]),_vm._v(" "),_c('option',{attrs:{"value":"4"},domProps:{"selected":_vm.selectedPayroll.type==4}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.annualPermit')))]),_vm._v(" "),_c('option',{attrs:{"value":"5"},domProps:{"selected":_vm.selectedPayroll.type==5}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.absenteeism')))]),_vm._v(" "),_c('option',{attrs:{"value":"6"},domProps:{"selected":_vm.selectedPayroll.type==6}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.missingHour')))]),_vm._v(" "),_c('option',{attrs:{"value":"7"},domProps:{"selected":_vm.selectedPayroll.type==7}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.allowence')))]),_vm._v(" "),_c('option',{attrs:{"value":"8"},domProps:{"selected":_vm.selectedPayroll.type==8}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.overtime')))]),_vm._v(" "),_c('option',{attrs:{"value":"9"},domProps:{"selected":_vm.selectedPayroll.type==9}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.break')))]),_vm._v(" "),_c('option',{attrs:{"value":"10"},domProps:{"selected":_vm.selectedPayroll.type==10}},[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.payrolls.nightOvertime')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.otherPayrollType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeOtherPayrollType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedPayroll.otherType==0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.payrollList),function(payroll){return _c('option',{key:payroll.id,domProps:{"value":payroll.id,"selected":_vm.selectedPayroll.otherType}},[_vm._v(_vm._s(payroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.equalPayrollType')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeEqualPayrollType($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedPayroll.equalType==0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.payrollList),function(payroll){return _c('option',{key:payroll.id,domProps:{"value":payroll.id,"selected":_vm.selectedPayroll.equalType == payroll.id}},[_vm._v(_vm._s(payroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.monthlyPayrollColumn')))]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeMonthlyPayroll($event)}}},[_c('option',{attrs:{"value":"0"},domProps:{"selected":_vm.selectedPayroll.monthlyPayrollId==0}},[_vm._v(_vm._s(_vm.$ml.get('general.notSelected')))]),_vm._v(" "),_vm._l((_vm.monthlyPayrollList),function(monthlyPayroll){return _c('option',{key:monthlyPayroll.id,domProps:{"value":monthlyPayroll.id,"selected":_vm.selectedPayroll.monthlyPayrollId == monthlyPayroll.id}},[_vm._v(_vm._s(monthlyPayroll.name))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.maxLimit')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.maxLimit),expression:"selectedPayroll.maxLimit"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.maxLimit)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "maxLimit", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.multiplier')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.multiplier),expression:"selectedPayroll.multiplier"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.multiplier)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "multiplier", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.confirmation')))]),_vm._v(" "),_c('span',{staticClass:"form-control checkbox"},[_c('label',{staticStyle:{"margin-left":"20px"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.selectedPayroll.isApproved},on:{"change":function($event){_vm.selectedPayroll.isApproved==true ? _vm.selectedPayroll.isApproved=false : _vm.selectedPayroll.isApproved=true}}}),_vm._v("\n                        "+_vm._s(_vm.$ml.get('payrollTypes.confirmationRequired'))+"\n                      ")])])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-sm-12",staticStyle:{"margin-bottom":"10px"},attrs:{"align":"center"}},[_c('h4',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.tolerances')))])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.firstTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.firstTolerance1),expression:"selectedPayroll.firstTolerance1"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.firstTolerance1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "firstTolerance1", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.lastTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.lastTolerance1),expression:"selectedPayroll.lastTolerance1"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.lastTolerance1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "lastTolerance1", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.totalTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.totalTolerance1),expression:"selectedPayroll.totalTolerance1"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.totalTolerance1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "totalTolerance1", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.firstTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.firstTolerance2),expression:"selectedPayroll.firstTolerance2"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.firstTolerance2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "firstTolerance2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.lastTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.lastTolerance2),expression:"selectedPayroll.lastTolerance2"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.lastTolerance2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "lastTolerance2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.totalTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.totalTolerance2),expression:"selectedPayroll.totalTolerance2"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.totalTolerance2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "totalTolerance2", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.firstTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.firstTolerance3),expression:"selectedPayroll.firstTolerance3"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.firstTolerance3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "firstTolerance3", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.lastTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.lastTolerance3),expression:"selectedPayroll.lastTolerance3"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.lastTolerance3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "lastTolerance3", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('label',{staticClass:"input-group-addon"},[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.totalTolerance'))+" :")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedPayroll.totalTolerance3),expression:"selectedPayroll.totalTolerance3"}],staticClass:"form-control",attrs:{"type":"number","min":"0","autocomplete":"off"},domProps:{"value":(_vm.selectedPayroll.totalTolerance3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.selectedPayroll, "totalTolerance3", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPayroll && _vm.authControl == 0),expression:"!isNewPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewPayroll && _vm.authControl == 0),expression:"isNewPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewPayroll && _vm.authControl == 0),expression:"!isNewPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedPayroll.shortCode)+" - "+_vm._s(this.selectedPayroll.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.isContinuePayrollTypeUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.savePayroll()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.selectedPayroll.shortCode)+" - "+_vm._s(this.selectedPayroll.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.isContinuePayrollTypeSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.savePayroll()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.selectedPayroll.shortCode)+" - "+_vm._s(this.selectedPayroll.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('payrollTypes.isContinuePayrollTypeDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deletePayroll()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyPayrollTables_vue__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8edbf7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyPayrollTables_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MonthlyPayrollTables_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c8edbf7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MonthlyPayrollTables_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.monthlyPayrollTables')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.monthlyPayrollTables')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.monthlyPayrolColumnlList')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monthlyPayrollList.length > 0),expression:"monthlyPayrollList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.monthlyPayrollList),function(monthlyPayroll){return _c('tr',{key:monthlyPayroll.id},[_c('td',[_vm._v(_vm._s(monthlyPayroll.shortCode))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(monthlyPayroll.name))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.getMonthlyPayroll(monthlyPayroll.id)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.monthlyPayrollList.length == 0),expression:"monthlyPayrollList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('monthlyPayrollTables.monthlyPayrollTableRecordNotFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.monthlyPayrollInfo')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.authControl == 0),expression:"authControl == 0"}],staticClass:"btn btn-sm btn-warning ",attrs:{"type":"button"},on:{"click":function($event){return _vm.newMonthlyPayroll()}}},[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.newMonthlyPayroll')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.shortCode')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.monthlyPayroll.shortCode),expression:"monthlyPayroll.shortCode"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.monthlyPayroll.shortCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.monthlyPayroll, "shortCode", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.payrollColumnName')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.monthlyPayroll.name),expression:"monthlyPayroll.name"}],staticClass:"form-control",attrs:{"type":"text","autocomplete":"off"},domProps:{"value":(_vm.monthlyPayroll.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.monthlyPayroll, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-bottom":"10px"},attrs:{"align":"center"}},[_c('span',{staticClass:"form-control checkbox"},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.monthlyPayroll.ssk},on:{"change":function($event){_vm.monthlyPayroll.ssk==true ? _vm.monthlyPayroll.ssk=false : _vm.monthlyPayroll.ssk=true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('monthlyPayrollTables.ssk'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-bottom":"10px"},attrs:{"align":"center"}},[_c('span',{staticClass:"form-control checkbox"},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.monthlyPayroll.total},on:{"change":function($event){_vm.monthlyPayroll.total==true ? _vm.monthlyPayroll.total=false : _vm.monthlyPayroll.total=true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('monthlyPayrollTables.total'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4",staticStyle:{"margin-bottom":"10px"},attrs:{"align":"center"}},[_c('span',{staticClass:"form-control checkbox"},[_c('label',[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.monthlyPayroll.work},on:{"change":function($event){_vm.monthlyPayroll.work==true ? _vm.monthlyPayroll.work=false : _vm.monthlyPayroll.work=true}}}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('monthlyPayrollTables.work'))+"\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"box-footer"},[_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewMonthlyPayroll && _vm.authControl == 0),expression:"!isNewMonthlyPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-danger ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-sil"}},[_vm._v(_vm._s(_vm.$ml.get('general.delete')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNewMonthlyPayroll && _vm.authControl == 0),expression:"isNewMonthlyPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-kaydet"}},[_vm._v(_vm._s(_vm.$ml.get('general.save')))]),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isNewMonthlyPayroll && _vm.authControl == 0),expression:"!isNewMonthlyPayroll && authControl == 0"}],staticClass:"btn btn-sm btn-success ",staticStyle:{"margin":"5px","width":"120px"},attrs:{"type":"button","data-toggle":"modal","data-target":"#modal-guncelle"}},[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-info fade",attrs:{"id":"modal-guncelle"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(0),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.monthlyPayroll.shortCode)+" - "+_vm._s(this.monthlyPayroll.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollUpdate')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-info",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveMonthlyPayroll()}}},[_c('i',{staticClass:"fa fa-refresh"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.update')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-success fade",attrs:{"id":"modal-kaydet"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('p',[_vm._v(_vm._s(this.monthlyPayroll.shortCode)+" - "+_vm._s(this.monthlyPayroll.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollSave')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.saveMonthlyPayroll()}}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.save')))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-sil"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(2),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',[_c('span',[_vm._v(_vm._s(this.monthlyPayroll.shortCode)+" - "+_vm._s(this.monthlyPayroll.name))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('monthlyPayrollTables.isContinueMonthlyPayrollDelete')))])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"data-dismiss":"modal"},on:{"click":function($event){return _vm.deleteMonthlyPayroll()}}},[_c('i',{staticClass:"fa fa-trash"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.delete')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Integration_vue__ = __webpack_require__(191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5aa4a5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Integration_vue__ = __webpack_require__(473);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Integration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5aa4a5c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Integration_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.integration')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.integration')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.integration')))])]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm",on:{"click":function($event){return _vm.getSettings()}}},[_c('i',{staticClass:"fa fa-refresh"})])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Kişiler Son Aktarım Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sonGuncellemeZamani),expression:"sonGuncellemeZamani"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.sonGuncellemeZamani)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sonGuncellemeZamani=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("Departmanlar Son Aktarım Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sonGuncellemeZamani2),expression:"sonGuncellemeZamani2"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.sonGuncellemeZamani2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sonGuncellemeZamani2=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('label',[_vm._v("İzinler Son Aktarım Tarihi")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sonGuncellemeZamani3),expression:"sonGuncellemeZamani3"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.sonGuncellemeZamani3)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sonGuncellemeZamani3=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},on:{"click":function($event){return _vm.goToHangfire()}}},[_vm._v(_vm._s(_vm.$ml.get('integration.triggerTransfers')))])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header"},[_c('i',{staticClass:"fa fa-setting"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.exportToPDF()}}},[_c('i',{staticClass:"fa fa-share"}),_vm._v("\n                    "+_vm._s(_vm.$ml.get('general.exportToPdfOrPrint'))+"\n                  ")])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"10px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.startDate),expression:"startDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.startDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.startDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon"},[_vm._v("-")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.endDate),expression:"endDate"}],staticClass:"form-control",attrs:{"type":"datetime-local"},domProps:{"value":(_vm.endDate)},on:{"input":function($event){if($event.target.composing){ return; }_vm.endDate=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary",staticStyle:{"width":"100%"},attrs:{"type":"button"},on:{"click":function($event){return _vm.send()}}},[_c('i',{staticClass:"fa fa-search"}),_vm._v("\n                      "+_vm._s(_vm.$ml.get('general.view'))+"\n                    ")])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length > 0),expression:"logList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize),attrs:{"id":"printReport"}},[_c('div',{attrs:{"align":"center"}},[_c('span',[_vm._v("Entegrasyon Olayları ("+_vm._s(_vm._f("toDateFormatGet")(this.startDate,"gg.aa.yyyy ss:dd"))+" - "+_vm._s(_vm._f("toDateFormatGet")(this.endDate,"gg.aa.yyyy ss:dd"))+")")])]),_vm._v(" "),_c('table',{staticClass:"table table-hover"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.logList),function(log){return _c('tr',{key:log.id,staticClass:"rows"},[_c('td',[_c('span',[_vm._v(_vm._s(log.id))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(_vm._f("toDateFormatGet")(log.zaman)))])]),_vm._v(" "),_c('td',[_c('span',[_vm._v(_vm._s(log.olay))])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logList.length == 0),expression:"logList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v("\n                  Olay kaydı bulunamadı.\n                ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"box-title"},[_c('span',[_vm._v("Entegrasyon Olayları")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',{staticStyle:{"text-align":"left"}},[_c('th',[_vm._v("İşlem Id")]),_vm._v(" "),_c('th',[_vm._v("Zaman")]),_vm._v(" "),_c('th',[_vm._v("Olay")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d39f07e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSettings_vue__ = __webpack_require__(475);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d39f07e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v("Uygulama Ayarları")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v("Kontrol Paneli")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Ayarlar")])]),_vm._v(" "),_c('li',[_c('span',[_vm._v("Uygulama Ayarları")])])])]),_vm._v(" "),_c('section',{staticClass:"content"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d38272a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d38272a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.support')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.support')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12",attrs:{"align":"center"}},[_c('h3',[_vm._v(_vm._s(_vm.$ml.get('support.whatWouldYouLikeSupportOn')))]),_vm._v(" "),_c('div',{staticClass:"input-group",staticStyle:{"margin-bottom":"7px","width":"70%"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"form-control text-center",attrs:{"type":"text","placeholder":_vm.$ml.get('support.subjectYouWantHelpWith')},domProps:{"value":(_vm.searchText)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('i',{staticClass:"fa fa-search"}),_vm._v(" "),_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('support.searchResults')))])])]),_vm._v(" "),_c('div',{staticClass:"box-body"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpList.length > 0),expression:"helpList.length > 0"}],staticClass:"table-responsive no-padding",style:(_vm.windowHeightSize)},[_c('table',{staticClass:"table table-hover"},[_c('tbody',_vm._l((_vm.filtered),function(help,index){return _c('tr',{key:index},[_c('td',[_vm._v(_vm._s(help.anaBaslik))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(help.altBaslik))]),_vm._v(" "),_c('td',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-primary btn-sm ",attrs:{"type":"button"},on:{"click":function($event){return _vm.getHelp(help.link, help.anaBaslik, help.altBaslik)}}},[_c('i',{staticClass:"fa fa-search"})])])])}),0)])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.helpList.length == 0),expression:"helpList.length == 0"}],staticClass:"callout callout-info"},[_c('i',{staticClass:"fa fa-info-circle"}),_vm._v(" "+_vm._s(_vm.$ml.get('support.noRecordFound'))+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border"},[_c('h3',{staticClass:"box-title"},[_c('span',[_vm._v(_vm._s(_vm.selectedBaslik))])])]),_vm._v(" "),_c('div',{staticClass:"box-body",attrs:{"align":"center"}},[_c('iframe',{attrs:{"width":"100%","height":_vm.windowVideoHeightSize,"src":_vm.selectedLink,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})]),_vm._v(" "),_c('div',{staticClass:"overlay",attrs:{"id":"load","hidden":!_vm.isLoadingDetail}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"input-group-btn"},[_c('button',{staticClass:"btn btn-primary ",attrs:{"type":"button"}},[_c('i',{staticClass:"fa fa-search"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAbout_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c96b60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAbout_vue__ = __webpack_require__(479);
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppAbout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47c96b60_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppAbout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[_c('h1',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.appAbout')))])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.dashboard')))])]),_vm._v(" "),_c('li',[_c('i',{staticClass:"fa fa-cogs"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.settings')))])]),_vm._v(" "),_c('li',[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.appAbout')))])])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-4 text-center"},[_c('div',{staticClass:"box box-primary"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"box-body",staticStyle:{"height":"200px"}},[_c('h3',[_vm._v(_vm._s(_vm.$store.getters.getCompanyName))]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000000","font-size":"18px"},attrs:{"href":_vm.$store.getters.getCompanyURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.$store.getters.getCompanyURL.replace("https://", "").replace("https://", "")))]),_vm._v(" "),_c('h4',[_c('strong',[_vm._v(_vm._s(_vm.$ml.get('shared.version')))]),_vm._v("\n              : "+_vm._s(_vm.version)+"\n            ")])])]),_vm._v(" "),_c('hr')]),_vm._v(" "),_c('div',{staticClass:"col-sm-8"},[_c('div',{staticClass:"box box-primary"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"box-body",style:(_vm.windowHeightSize)},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(28),_vm._v(" "),_vm._m(29),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(30),_vm._v(" "),_vm._m(31),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(32),_vm._v(" "),_vm._m(33),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(34),_vm._v(" "),_vm._m(35),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(36),_vm._v(" "),_vm._m(37),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(38),_vm._v(" "),_vm._m(39),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(40),_vm._v(" "),_vm._m(41),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(42),_vm._v(" "),_vm._m(43),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(44),_vm._v(" "),_vm._m(45),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(46),_vm._v(" "),_vm._m(47),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(48),_vm._v(" "),_vm._m(49),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(50),_vm._v(" "),_vm._m(51),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(52),_vm._v(" "),_vm._m(53),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(54),_vm._v(" "),_vm._m(55),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(56),_vm._v(" "),_vm._m(57),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(58),_vm._v(" "),_vm._m(59),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(60),_vm._v(" "),_vm._m(61),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(62),_vm._v(" "),_vm._m(63),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(64),_vm._v(" "),_vm._m(65),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(66),_vm._v(" "),_vm._m(67),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(68),_vm._v(" "),_vm._m(69),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(70),_vm._v(" "),_vm._m(71),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(72),_vm._v(" "),_vm._m(73),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(74),_vm._v(" "),_vm._m(75),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(76),_vm._v(" "),_vm._m(77),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(78),_vm._v(" "),_vm._m(79),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(80),_vm._v(" "),_vm._m(81),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(82),_vm._v(" "),_vm._m(83),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(84),_vm._v(" "),_vm._m(85),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(86),_vm._v(" "),_vm._m(87),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(88),_vm._v(" "),_vm._m(89),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(90),_vm._v(" "),_vm._m(91),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(92),_vm._v(" "),_vm._m(93),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(94),_vm._v(" "),_vm._m(95),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(96),_vm._v(" "),_vm._m(97),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(98),_vm._v(" "),_vm._m(99),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(100),_vm._v(" "),_vm._m(101)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-header"},[_c('h3',{staticClass:"box-title"},[_vm._v("Sürüm Notları")]),_vm._v(" "),_c('div',{staticClass:"box-tools pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.49\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("Demirbaş Modülü")]),_vm._v("ne fotoğraf, belge ekleme, kategoriler, depolar, özellikler ve belge tanımları gibi yeni özellikler eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Tanımlamalar menüsüne "),_c('strong',[_vm._v("Belge Tanımları")]),_vm._v(" sayfası eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına "),_c('strong',[_vm._v("zimmetler")]),_vm._v(" sekmesi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına "),_c('strong',[_vm._v("belgeler")]),_vm._v(" sekmesi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasındaki belge yükleme alanına İSG evrakları ve geçerlilik tarihi kontrolü özelliği geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Giriş çıkış raporlarına "),_c('strong',[_vm._v("görev yeri")]),_vm._v(" alanı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Toplu işlemler sayfasında kişilere "),_c('strong',[_vm._v("toplu geçerlilik başlangıç ve bitiş tarihi girme")]),_vm._v(" özelliği geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Toplu işlemler sayfasına "),_c('strong',[_vm._v("toplu görev yeri")]),_vm._v(" tanımlama özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişi bilgileri raporuna "),_c('strong',[_vm._v("geçerlilik tarihi")]),_vm._v(" alanları eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde terminal durumları listesi, istatistik widgetı olarak değiştirildi. Üstüne tıklandığında terminal durumları raporu açılacak şekilde geliştirildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.48\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("Demirbaş Modülü")]),_vm._v(" geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına "),_c('strong',[_vm._v("maaş")]),_vm._v(" sekmesi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına "),_c('strong',[_vm._v("başlangıç geçerlilik tarihi")]),_vm._v(" ve "),_c('strong',[_vm._v("bitiş geçerlilik tarihi")]),_vm._v(" eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Tanımlamalar menüsüne "),_c('strong',[_vm._v("Görev Yeri Tanımları")]),_vm._v(" sayfası eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına "),_c('strong',[_vm._v("Görev Yerleri")]),_vm._v(" sekmesi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Şirket ayarlarına "),_c('strong',[_vm._v("Zorunlu Alanlar")]),_vm._v(" sekmesi eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.47\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('strong',[_vm._v("Vardiya Raporu")]),_vm._v(" eklendi.")]),_vm._v(" "),_c('li',[_c('strong',[_vm._v("Dikey İlk Giriş Son Çıkış Raporu")]),_vm._v(" eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.46\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Ziyaretçi takip ekranına gelinen departman bilgisi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Ziyaretçi takip raporlarına \"Departman Bazlı Ziyaretçi Raporu\" eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.45\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Otomatik mail ayar sayfası iyileştirildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.44\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Ziyaretçi takip ekranındaki personel sorgulama ekranı iyileştirildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.43\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Kontrol panelindeki raporlara arama özelliği eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.42\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Kontrol paneline aktif mobil kullanıcılar widget'ı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde bulunan içeridekiler/dışarıdakiler raporlarına okuyucu adı sütunu eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.41\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Toplu işlemler sayfasına toplu geçiş grubu güncelleme özelliği eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.40\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Tema dosyalarında güncelleme yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol paneline geç gelenler widget'ı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Terminaller sayfasındaki okuyucu bilgilerine "),_c('strong',[_vm._v("ana kapı")]),_vm._v(" seçimi eklendi. Bu seçim kontrol panelinde yer alan içeridekiler/dışarıdakiler widget'larını etkileyecektir.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.39\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Otomatik mail ayarlarına yeni rapor eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Tema dosyalarında güncelleme yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Login tasarımı değiştirildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.38\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Puantaj Yönetimi sayfasında iyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.37\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Toplu İşlemler sayfasına Yemekhane işlemleri eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde ufak görsel düzenlemeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.36\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Puantaj Yönetimi sayfası iyileştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Terminaller sayfasındaki Seri No alanı tüm markalar için aktif hale getirildi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.35\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Puantaj Yönetimi sayfası yenilendi.")]),_vm._v(" "),_c('li',[_vm._v("Uygulamanın fontu değiştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde bulunan izin taleplerindeki görsel sorunu düzeltildi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.34\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Devriye Tur Kontrol modülü için görevli sayfasına eşleştirme kaldırma özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülü için görevli sayfasına telefon eşleştirme ve hesap kontrolü özelliği\n                eklendi. Eşleştirme kaldırma özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.33\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Devriye Tur Kontrol modülü için kullanıcı yetkileri eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülüne "),_c('strong',[_vm._v("Tur Hareket Raporu")]),_vm._v(" eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülüne "),_c('strong',[_vm._v("Tur Olay Raporu")]),_vm._v(" eklendi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.32\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Devriye Tur Kontrol modülü için görevlilere sorumlu kullanıcı alanları eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülü için tur tanımlarına saat kontrolü eklendi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.31\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Devriye Tur Kontrol modülüne kontrol noktaları için koordinat alanları eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülüne kontrol noktaları ekranı tasarımı iyileştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye Tur Kontrol modülüne kontrol noktaları ekranı tasarımı iyileştirildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.30\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Terminal okuyucularına koordinat alanları eklendi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.29\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Bazı hatalar giderildi.")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.28\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Devriye Tur Kontrol modülü yenilendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.27\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Yeni rapor eklendi: "),_c('strong',[_vm._v("Detaylı Ziyaretçi Hareket Raporu")]),_vm._v(".")]),_vm._v(" "),_c('li',[_vm._v("İyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.26\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Vardiya Shift Takvimi modülü üzerinde yeni geliştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("İlk Giriş Son Çıkış Raporunda iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Kart tasarım şablonları sayfası güncellendi.")]),_vm._v(" "),_c('li',[_vm._v("Çift taraflı kart baskısı özelliği eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.25\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Vardiya Shift Takvimi modülü üzerinde geliştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.24\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Kullanıcı yetki grupları geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Vardiya Shift Takvimi modülü geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Bakiyeli satış modülünde ek geliştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Güvenlik iyileştirmeleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Küçük hatalar giderildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.23\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Gerçekleşen hareketler takvimi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Hafta tatili takvimi eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Vardiya Shift Takvimi modülü geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde geliştirmeler yapıldı. İstatistiklere grafikler eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Küçük hatalar giderildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.22\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Yurt takip sistemi hızlandırıldı. Hatalar giderildi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Küçük hatalar giderildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.21\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Küçük hatalar giderildi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.20\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Esnek kart tasarımları için Kart Tasarım Şablonları ekranı hazırlandı.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler üzerinde istenilen şablon üzerinden kart basma özelliği geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol paneli üzerinde geliştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.19\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Bakiye düşme ekranı geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Logo ve görseller üzerinde değişiklikler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Yazı font tipi değiştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Görsel arayüz üzerinde geliştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Mixa Enroll Mobil uygulaması geliştirildi. Mobil uygulama ile entegrasyon geliştirmeleri yapıldı.\n              ")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Küçük hatalar giderildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.18\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Puantaj Yönetimi ekranı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Terminal işlemleri ekranında değişiklikler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.17\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Kontrol paneli istatistiklerinde iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Profilim alanı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kullanıcılar bölümüne Aktif Mi özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı güvenlik iyileştirmeleri yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.16\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Hızlandırmalar ve iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Yeni puantaj raporları eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.15\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Puantaj hesaplamalarında geliştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Terminal okuyucularına kapı adı alanı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kapı açık/kapalı bilgisini görüntülemek için canlı izleme sayfasına kapı durumları alanı eklendi.\n              ")]),_vm._v(" "),_c('li',[_vm._v("Esnek senaryoları desteklemek için senaryolar alt yapısı oluşturuldu. Zaman bazlı alarm çaldırabilme\n                komutları eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Yurt takip modülünde bölgeler sayfası iyileştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Kişiler sayfasına timezone alanı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Devriye tur kontrol modülü geliştirildi.")]),_vm._v(" "),_c('li',[_vm._v("Kişi listelerine sicil numarası alanı eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kişi listelerine sıralama özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Hızlandırmalar ve iyileştirmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.14\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Hızlandırmalar ve iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelinde bulunan istatistik alanları üzerinde düzeltmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Bazı raporlarda hızlandırma işlemleri yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Katı filtre özelliğindeki sorun düzeltildi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.13\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Hızlandırmalar ve iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Bazı raporlarda hızlandırma işlemleri yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.12\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Arayüzde iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Yazılımın arkaplanında iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Kullanıcı yetkilendirmelerinde yetki grupları güçlendirildi. Yazılım üzerinde tüm sayfalar\n                kullanıcının yetkisi olduğu departman, geçiş grubu, yemek grubu, çalışma grubu, statü ve durumu\n                alanlarına göre filtrelenip veriler getirilir hale gelmiştir. Yani yetkisiz departmanlar listelerde\n                gözükmeyecektir. Buna kontrol panelindeki istatistikler de dahil.")]),_vm._v(" "),_c('li',[_vm._v("Kullanıcılar sayfasındaki yetkili departmanlar alanı Kullanıcı Yetkileri sayfasına taşındı ve daha\n                detaylı hale getirildi.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Otomatik mail özelliği eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.11\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("İşlem kayıtlarında kullanıcı bazlı kayıtları görme sorunu düzeltildi.")]),_vm._v(" "),_c('li',[_vm._v("İki tarih arasındaki izin kayıtlarını toplu silme özelliği getirildi.")]),_vm._v(" "),_c('li',[_vm._v("Sil butonu İşten çıkış bildir butonu altına taşındı.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Kullanıcı bazlı varsayılan filtre yetki grubu özelliği eklendi. Kullanıcıların varsayılan filtresine\n                göre kişiler otomatik listenecektir. Detaylı filtre kullanılmak istenirse yeniden filtreleme\n                yapılabilecektir.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.10\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Her sayfaya arama özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.9\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("SMS modülü eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Öğrenciler için özel ekranlar oluşturuldu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.8\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Arayüzde iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Plaka tanıma modülü eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Araç takibi için kontrol paneli istatistik alanları oluşturuldu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.7\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("İyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.6\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Arayüzde değişiklikler ve iyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Geçerlilik tarihi özelliği ve üye takip modülü eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Bazı raporlarda düzeltmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.5\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Yeni marka terminaller ile haberleşme entegrasyonları oluşturuldu.")]),_vm._v(" "),_c('li',[_vm._v("Parmak izi alma ile ilgili arayüzde yeni ekranlar oluşturuldu.")]),_vm._v(" "),_c('li',[_vm._v("Bazı raporlarda düzeltmeler yapıldı.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.4\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("İyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Bazı kritik hatalar tespit edildi ve giderildi.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.3\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("İyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Yemekhane takip modülü oluşturuldu.")]),_vm._v(" "),_c('li',[_vm._v("Kontrol panelindeki istatistiklere tıklandığında açılan hızlı rapor özelliği eklendi.")]),_vm._v(" "),_c('li',[_vm._v("Yeni raporlar eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.2\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("İyileştirmeler yapıldı.")]),_vm._v(" "),_c('li',[_vm._v("Bazı hatalar giderildi.")]),_vm._v(" "),_c('li',[_vm._v("Yeni marka terminaller ile haberleşme entegrasyonları oluşturuldu.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.1\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Ziyaretçi takip modülü oluşturuldu.")]),_vm._v(" "),_c('li',[_vm._v("İngilizce dil seçeneği ve renk tema seçeneği eklendi.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h4',[_c('i',{staticClass:"fa fa-arrow-right"}),_vm._v(" 1.0.0\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Kararlı sürüm tamamlandı.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04762e49_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__ = __webpack_require__(483);
function injectStyle (ssrContext) {
  __webpack_require__(481)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-04762e49"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04762e49_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(482);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("68a62854", content, true, {});

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, ".carousel-caption[data-v-04762e49]{top:10%}.main-login-bg[data-v-04762e49]{background:#fff;height:100vh + 30px;width:100%}.icon-box[data-v-04762e49]{position:relative;margin-top:20px;padding:0 0 0 80px}.icon-left[data-v-04762e49]{display:block;position:absolute;width:64px;height:64px;top:0;left:0;text-align:center}", ""]);

// exports


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-login-bg"},[_c('div',{staticClass:"row",staticStyle:{"text-align":"center"}},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"hold-transition login-box",on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toLogin($event)}}},[_vm._m(0),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$ml.get('loginPage.welcome')))]),_vm._v(" "),_c('div',{staticClass:"login-box-body",staticStyle:{"border":"1px #000 solid"}},[_c('p',[_vm._v(_vm._s(_vm.$ml.get('loginPage.fullScreenInfo')))]),_vm._v(" "),_c('div',{staticClass:"overlay",staticStyle:{"font-size":"50px"},attrs:{"id":"load","hidden":!_vm.isLoading}},[_c('i',{staticClass:"fa fa-refresh fa-spin"})]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.userName),expression:"user.userName"}],staticClass:"form-control",attrs:{"type":"text","placeholder":_vm.$ml.get('loginPage.emailOrUsername')},domProps:{"value":(_vm.user.userName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "userName", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-user form-control-feedback",staticStyle:{"color":"#3C8DBC"}})]),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.user.password),expression:"user.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":_vm.$ml.get('loginPage.password')},domProps:{"value":(_vm.user.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.user, "password", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"fa fa-lock form-control-feedback",staticStyle:{"color":"#3C8DBC"}})]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-8"},[_c('div',{staticClass:"input-group"},[_c('span',{staticClass:"input-group-addon"},[_c('img',{attrs:{"src":_vm.flag}}),_vm._v(" "),_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.flag == ''),expression:"flag == ''"}],staticClass:"fa fa-globe"})]),_vm._v(" "),_c('select',{staticClass:"form-control",on:{"change":function($event){return _vm.changeLanguage($event)}}},_vm._l((_vm.$ml.list),function(lang){return _c('option',{key:lang,domProps:{"value":lang,"selected":_vm.defaultLanguage == lang}},[_vm._v("\n                    "+_vm._s(lang))])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"disabled":_vm.isLoading,"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.toLogin()}}},[_vm._v(_vm._s(_vm.$ml.get('loginPage.loginButton')))])])])]),_vm._v(" "),_c('div',{staticStyle:{"text-align":"center","margin-top":"20px"}},[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))]),_vm._v(" "),_c('strong',[_c('a',{attrs:{"href":_vm.$store.getters.getCompanyURL,"target":"_blank"}},[_vm._v(_vm._s(_vm.$store.getters.getCompanyName))])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.allRightsReserved')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.$ml.get('shared.version')))]),_vm._v("\n          "+_vm._s(_vm.version)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px","margin-bottom":"20px","text-align":"center"}},[_c('div',{staticClass:"col-sm-12"},[_c('a',{attrs:{"href":_vm.$store.getters.getCompanyURL,"target":"_blank"}},[_c('img',{attrs:{"src":"/company-logo.png","width":"200px"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal modal-danger fade",attrs:{"id":"modal-licence"}},[_c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-header"},[_vm._m(1),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceErrorTitle')))])])]),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('h3',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceError')))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('shared.softwareKey')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.softwareKeyDescription')))]),_vm._v(" "),_c('label',{staticClass:"form-control"},[_vm._v(_vm._s(this.softwareKey))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$ml.get('shared.enterLicenceKey')))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.licenceKeyDescription')))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.licenceKey),expression:"licenceKey"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.licenceKey)},on:{"input":function($event){if($event.target.composing){ return; }_vm.licenceKey=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger text-white",attrs:{"data-dismiss":"modal"}},[_c('i',{staticClass:"fa fa-remove"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('general.cancel')))])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success text-white",attrs:{"data-dismiss":"modal"},on:{"click":_vm.saveLicenceKey}},[_c('i',{staticClass:"fa fa-check"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$ml.get('shared.saveLicenceKey')))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-logo",staticStyle:{"margin-bottom":"30px"}},[_c('img',{staticStyle:{"width":"90%","max-width":"450px"},attrs:{"src":"/brand-logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18397699_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SignUp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18397699_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SignUp_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(486);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(4)("06df34c8", content, true, {});

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)(false);
// imports


// module
exports.push([module.i, "", ""]);

// exports


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#ffffff","background-image":"url('/src/assets/timecure-login.gif')"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports=function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=0)}([function(e,t,n){"use strict";function r(e,t){t.forEach(function(t){var n=e.document.createElement("link");n.setAttribute("rel","stylesheet"),n.setAttribute("type","text/css"),n.setAttribute("href",t),e.document.getElementsByTagName("head")[0].appendChild(n)})}Object.defineProperty(t,"__esModule",{value:!0}),t.default={install:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};e.prototype.$htmlToPaper=function(e,n){var o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:function(){return!0},l=["fullscreen=yes","titlebar=yes","scrollbars=yes"],u=[],i=t.name,s=void 0===i?"_blank":i,c=t.specs,a=void 0===c?l:c,d=t.replace,p=void 0===d||d,f=t.styles,m=void 0===f?u:f;n&&(n.name&&(s=n.name),n.specs&&(a=n.specs),n.replace&&(p=n.replace),n.styles&&(m=n.styles)),console.warn(m),a=a.length?a.join(","):"";var y=document.getElementById(e);if(!y)return void alert("Element to print #"+e+" not found!");var v=window.open("",s,a,p);return v.document.write("\n        <html>\n          <head>\n            <title>"+document.title+"</title>\n          </head>\n          <body>\n            "+y.innerHTML+"\n          </body>\n        </html>\n      "),r(v,m),setTimeout(function(){v.document.close(),v.focus(),v.print(),v.close(),o()},1e3),!0}}}}]);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(490);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(526);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(529);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(537);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(551);
__webpack_require__(552);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(104);
__webpack_require__(594);
__webpack_require__(217);
__webpack_require__(595);
__webpack_require__(218);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(221);
__webpack_require__(223);
__webpack_require__(224);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
__webpack_require__(643);
__webpack_require__(644);
__webpack_require__(645);
__webpack_require__(646);
__webpack_require__(647);
__webpack_require__(648);
__webpack_require__(649);
__webpack_require__(650);
__webpack_require__(651);
__webpack_require__(652);
__webpack_require__(653);
__webpack_require__(654);
__webpack_require__(655);
__webpack_require__(656);
__webpack_require__(657);
__webpack_require__(658);
__webpack_require__(659);
__webpack_require__(660);
__webpack_require__(661);
__webpack_require__(662);
__webpack_require__(663);
__webpack_require__(664);
__webpack_require__(665);
__webpack_require__(666);
__webpack_require__(667);
__webpack_require__(668);
__webpack_require__(669);
__webpack_require__(670);
__webpack_require__(671);
__webpack_require__(672);
__webpack_require__(673);
__webpack_require__(674);
__webpack_require__(675);
__webpack_require__(676);
__webpack_require__(677);
__webpack_require__(678);
__webpack_require__(679);
__webpack_require__(680);
__webpack_require__(681);
__webpack_require__(682);
__webpack_require__(683);
__webpack_require__(684);
__webpack_require__(685);
module.exports = __webpack_require__(24);


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(18);
var DESCRIPTORS = __webpack_require__(10);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(16);
var META = __webpack_require__(38).KEY;
var $fails = __webpack_require__(6);
var shared = __webpack_require__(58);
var setToStringTag = __webpack_require__(53);
var uid = __webpack_require__(42);
var wks = __webpack_require__(8);
var wksExt = __webpack_require__(199);
var wksDefine = __webpack_require__(85);
var enumKeys = __webpack_require__(492);
var isArray = __webpack_require__(67);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var toObject = __webpack_require__(12);
var toIObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(29);
var createDesc = __webpack_require__(41);
var _create = __webpack_require__(45);
var gOPNExt = __webpack_require__(202);
var $GOPD = __webpack_require__(20);
var $GOPS = __webpack_require__(66);
var $DP = __webpack_require__(11);
var $keys = __webpack_require__(43);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(46).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(60).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(37)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(15)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(58)('native-function-to-string', Function.toString);


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(43);
var gOPS = __webpack_require__(66);
var pIE = __webpack_require__(60);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(45) });


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(10), 'Object', { defineProperties: __webpack_require__(201) });


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(19);
var $getOwnPropertyDescriptor = __webpack_require__(20).f;

__webpack_require__(31)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(12);
var $getPrototypeOf = __webpack_require__(21);

__webpack_require__(31)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(12);
var $keys = __webpack_require__(43);

__webpack_require__(31)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(31)('getOwnPropertyNames', function () {
  return __webpack_require__(202).f;
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(38).onFreeze;

__webpack_require__(31)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(38).onFreeze;

__webpack_require__(31)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(7);
var meta = __webpack_require__(38).onFreeze;

__webpack_require__(31)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(7);

__webpack_require__(31)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(7);

__webpack_require__(31)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(7);

__webpack_require__(31)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(203) });


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(204) });


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(89).set });


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(54);
var test = {};
test[__webpack_require__(8)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(16)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(205) });


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(11).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(10) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(7);
var getPrototypeOf = __webpack_require__(21);
var HAS_INSTANCE = __webpack_require__(8)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(11).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(207);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(208);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(18);
var cof = __webpack_require__(26);
var inheritIfRequired = __webpack_require__(91);
var toPrimitive = __webpack_require__(29);
var fails = __webpack_require__(6);
var gOPN = __webpack_require__(46).f;
var gOPD = __webpack_require__(20).f;
var dP = __webpack_require__(11).f;
var $trim = __webpack_require__(55).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(45)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(10) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(16)(global, NUMBER, $Number);
}


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(27);
var aNumberValue = __webpack_require__(209);
var repeat = __webpack_require__(92);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(6)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(6);
var aNumberValue = __webpack_require__(209);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(210) });


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(210);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(208);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(207);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(211);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(93);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(94);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(212) });


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(211) });


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(93) });


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(94);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(6)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(94);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(44);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(19);
var toLength = __webpack_require__(9);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(55)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(68)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(95)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(68)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(97);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(98)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(97);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(98)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(92)
});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(9);
var context = __webpack_require__(97);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(98)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(17)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(17)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(17)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(17)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(17)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(17)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(17)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(17)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(17)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(17)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(17)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(17)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(17)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(29);

$export($export.P + $export.F * __webpack_require__(6)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(569);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(6);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(16)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(8)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(15)(proto, TO_PRIMITIVE, __webpack_require__(572));


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(67) });


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(25);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var call = __webpack_require__(213);
var isArrayIter = __webpack_require__(99);
var toLength = __webpack_require__(9);
var createProperty = __webpack_require__(100);
var getIterFn = __webpack_require__(101);

$export($export.S + $export.F * !__webpack_require__(70)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(100);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(6)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(19);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(59) != Object || !__webpack_require__(28)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(88);
var cof = __webpack_require__(26);
var toAbsoluteIndex = __webpack_require__(44);
var toLength = __webpack_require__(9);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(6)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var toObject = __webpack_require__(12);
var fails = __webpack_require__(6);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(28)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(32)(0);
var STRICT = __webpack_require__(28)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(7);
var isArray = __webpack_require__(67);
var SPECIES = __webpack_require__(8)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(32)(1);

$export($export.P + $export.F * !__webpack_require__(28)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(32)(2);

$export($export.P + $export.F * !__webpack_require__(28)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(32)(3);

$export($export.P + $export.F * !__webpack_require__(28)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(32)(4);

$export($export.P + $export.F * !__webpack_require__(28)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(28)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(214);

$export($export.P + $export.F * !__webpack_require__(28)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(65)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(19);
var toInteger = __webpack_require__(27);
var toLength = __webpack_require__(9);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(28)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(215) });

__webpack_require__(39)('copyWithin');


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(103) });

__webpack_require__(39)('fill');


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(32)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(39)(KEY);


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(32)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(39)(KEY);


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(47)('Array');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(91);
var dP = __webpack_require__(11).f;
var gOPN = __webpack_require__(46).f;
var isRegExp = __webpack_require__(69);
var $flags = __webpack_require__(61);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(10) && (!CORRECT_NEW || __webpack_require__(6)(function () {
  re2[__webpack_require__(8)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(16)(global, 'RegExp', $RegExp);
}

__webpack_require__(47)('RegExp');


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(218);
var anObject = __webpack_require__(2);
var $flags = __webpack_require__(61);
var DESCRIPTORS = __webpack_require__(10);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(16)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(6)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toLength = __webpack_require__(9);
var advanceStringIndex = __webpack_require__(106);
var regExpExec = __webpack_require__(71);

// @@match logic
__webpack_require__(72)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var toInteger = __webpack_require__(27);
var advanceStringIndex = __webpack_require__(106);
var regExpExec = __webpack_require__(71);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(72)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(2);
var sameValue = __webpack_require__(204);
var regExpExec = __webpack_require__(71);

// @@search logic
__webpack_require__(72)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(69);
var anObject = __webpack_require__(2);
var speciesConstructor = __webpack_require__(62);
var advanceStringIndex = __webpack_require__(106);
var toLength = __webpack_require__(9);
var callRegExpExec = __webpack_require__(71);
var regexpExec = __webpack_require__(105);
var fails = __webpack_require__(6);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(72)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(37);
var global = __webpack_require__(5);
var ctx = __webpack_require__(25);
var classof = __webpack_require__(54);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var aFunction = __webpack_require__(13);
var anInstance = __webpack_require__(48);
var forOf = __webpack_require__(49);
var speciesConstructor = __webpack_require__(62);
var task = __webpack_require__(107).set;
var microtask = __webpack_require__(108)();
var newPromiseCapabilityModule = __webpack_require__(109);
var perform = __webpack_require__(219);
var userAgent = __webpack_require__(73);
var promiseResolve = __webpack_require__(220);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(8)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(50)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(53)($Promise, PROMISE);
__webpack_require__(47)(PROMISE);
Wrapper = __webpack_require__(24)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(70)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(225);
var validate = __webpack_require__(51);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(74)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(75);
var buffer = __webpack_require__(110);
var anObject = __webpack_require__(2);
var toAbsoluteIndex = __webpack_require__(44);
var toLength = __webpack_require__(9);
var isObject = __webpack_require__(7);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(62);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(6)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(47)(ARRAY_BUFFER);


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(75).ABV, {
  DataView: __webpack_require__(110).DataView
});


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(2);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(6)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(45);
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);
var fails = __webpack_require__(6);
var bind = __webpack_require__(205);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(11);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var toPrimitive = __webpack_require__(29);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(6)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(20).f;
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(96)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(21);
var has = __webpack_require__(18);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(7);
var anObject = __webpack_require__(2);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(20);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(21);
var anObject = __webpack_require__(2);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(227) });


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(2);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(11);
var gOPD = __webpack_require__(20);
var getPrototypeOf = __webpack_require__(21);
var has = __webpack_require__(18);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(41);
var anObject = __webpack_require__(2);
var isObject = __webpack_require__(7);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(89);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(65)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(39)('includes');


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(228);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var aFunction = __webpack_require__(13);
var arraySpeciesCreate = __webpack_require__(102);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(39)('flatMap');


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(228);
var toObject = __webpack_require__(12);
var toLength = __webpack_require__(9);
var toInteger = __webpack_require__(27);
var arraySpeciesCreate = __webpack_require__(102);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(39)('flatten');


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(68)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(229);
var userAgent = __webpack_require__(73);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(229);
var userAgent = __webpack_require__(73);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(55)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(55)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(30);
var toLength = __webpack_require__(9);
var isRegExp = __webpack_require__(69);
var getFlags = __webpack_require__(61);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(96)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85)('asyncIterator');


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(85)('observable');


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(227);
var toIObject = __webpack_require__(19);
var gOPD = __webpack_require__(20);
var createProperty = __webpack_require__(100);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(230)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(230)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(11);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(10) && $export($export.P + __webpack_require__(76), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var aFunction = __webpack_require__(13);
var $defineProperty = __webpack_require__(11);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(10) && $export($export.P + __webpack_require__(76), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(21);
var getOwnPropertyDescriptor = __webpack_require__(20).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(10) && $export($export.P + __webpack_require__(76), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(12);
var toPrimitive = __webpack_require__(29);
var getPrototypeOf = __webpack_require__(21);
var getOwnPropertyDescriptor = __webpack_require__(20).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(10) && $export($export.P + __webpack_require__(76), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(231)('Map') });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(231)('Set') });


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(77)('Map');


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(77)('Set');


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(77)('WeakMap');


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(77)('WeakSet');


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(78)('Map');


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(78)('Set');


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(78)('WeakMap');


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(78)('WeakSet');


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(26);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(233);
var fround = __webpack_require__(212);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(233) });


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(24);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(62);
var promiseResolve = __webpack_require__(220);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(109);
var perform = __webpack_require__(219);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(21);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(223);
var from = __webpack_require__(232);
var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(21);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var getPrototypeOf = __webpack_require__(21);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(34);
var anObject = __webpack_require__(2);
var aFunction = __webpack_require__(13);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(108)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(26)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(24);
var microtask = __webpack_require__(108)();
var OBSERVABLE = __webpack_require__(8)('observable');
var aFunction = __webpack_require__(13);
var anObject = __webpack_require__(2);
var anInstance = __webpack_require__(48);
var redefineAll = __webpack_require__(50);
var hide = __webpack_require__(15);
var forOf = __webpack_require__(49);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(47)('Observable');


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(73);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(107);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(104);
var getKeys = __webpack_require__(43);
var redefine = __webpack_require__(16);
var global = __webpack_require__(5);
var hide = __webpack_require__(15);
var Iterators = __webpack_require__(56);
var wks = __webpack_require__(8);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(40)))

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(688);
module.exports = __webpack_require__(24).RegExp.escape;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(689)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 689 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js